var fF = Object.defineProperty;
var pF = (e, t, n) => t in e ? fF(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Al = (e, t, n) => pF(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as C, jsxs as ie, Fragment as mo } from "react/jsx-runtime";
import * as h from "react";
import en, { forwardRef as rs, useContext as Co, isValidElement as bo, cloneElement as Gr, Children as cu, createElement as js, useState as jt, useMemo as Ye, useRef as Ft, useEffect as Nt, useCallback as pt, useImperativeHandle as hF, useLayoutEffect as gF, createContext as Ki, memo as mF, useReducer as bF, Fragment as yF } from "react";
import * as IO from "react-dom";
import Zu, { unstable_batchedUpdates as Ju, createPortal as vF } from "react-dom";
const Ua = {
  black: "#000",
  white: "#fff"
}, pi = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, CF = {
  50: "#fce4ec",
  100: "#f8bbd0",
  200: "#f48fb1",
  300: "#f06292",
  400: "#ec407a",
  500: "#e91e63",
  600: "#d81b60",
  700: "#c2185b",
  800: "#ad1457",
  900: "#880e4f",
  A100: "#ff80ab",
  A200: "#ff4081",
  A400: "#f50057",
  A700: "#c51162"
}, hi = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, wF = {
  50: "#ede7f6",
  100: "#d1c4e9",
  200: "#b39ddb",
  300: "#9575cd",
  400: "#7e57c2",
  500: "#673ab7",
  600: "#5e35b1",
  700: "#512da8",
  800: "#4527a0",
  900: "#311b92",
  A100: "#b388ff",
  A200: "#7c4dff",
  A400: "#651fff",
  A700: "#6200ea"
}, SF = {
  50: "#e8eaf6",
  100: "#c5cae9",
  200: "#9fa8da",
  300: "#7986cb",
  400: "#5c6bc0",
  500: "#3f51b5",
  600: "#3949ab",
  700: "#303f9f",
  800: "#283593",
  900: "#1a237e",
  A100: "#8c9eff",
  A200: "#536dfe",
  A400: "#3d5afe",
  A700: "#304ffe"
}, gi = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, mi = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, xF = {
  50: "#e0f7fa",
  100: "#b2ebf2",
  200: "#80deea",
  300: "#4dd0e1",
  400: "#26c6da",
  500: "#00bcd4",
  600: "#00acc1",
  700: "#0097a7",
  800: "#00838f",
  900: "#006064",
  A100: "#84ffff",
  A200: "#18ffff",
  A400: "#00e5ff",
  A700: "#00b8d4"
}, TF = {
  50: "#e0f2f1",
  100: "#b2dfdb",
  200: "#80cbc4",
  300: "#4db6ac",
  400: "#26a69a",
  500: "#009688",
  600: "#00897b",
  700: "#00796b",
  800: "#00695c",
  900: "#004d40",
  A100: "#a7ffeb",
  A200: "#64ffda",
  A400: "#1de9b6",
  A700: "#00bfa5"
}, bi = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, RF = {
  50: "#f1f8e9",
  100: "#dcedc8",
  200: "#c5e1a5",
  300: "#aed581",
  400: "#9ccc65",
  500: "#8bc34a",
  600: "#7cb342",
  700: "#689f38",
  800: "#558b2f",
  900: "#33691e",
  A100: "#ccff90",
  A200: "#b2ff59",
  A400: "#76ff03",
  A700: "#64dd17"
}, EF = {
  50: "#f9fbe7",
  100: "#f0f4c3",
  200: "#e6ee9c",
  300: "#dce775",
  400: "#d4e157",
  500: "#cddc39",
  600: "#c0ca33",
  700: "#afb42b",
  800: "#9e9d24",
  900: "#827717",
  A100: "#f4ff81",
  A200: "#eeff41",
  A400: "#c6ff00",
  A700: "#aeea00"
}, IF = {
  50: "#fffde7",
  100: "#fff9c4",
  200: "#fff59d",
  300: "#fff176",
  400: "#ffee58",
  500: "#ffeb3b",
  600: "#fdd835",
  700: "#fbc02d",
  800: "#f9a825",
  900: "#f57f17",
  A100: "#ffff8d",
  A200: "#ffff00",
  A400: "#ffea00",
  A700: "#ffd600"
}, OF = {
  50: "#fff8e1",
  100: "#ffecb3",
  200: "#ffe082",
  300: "#ffd54f",
  400: "#ffca28",
  500: "#ffc107",
  600: "#ffb300",
  700: "#ffa000",
  800: "#ff8f00",
  900: "#ff6f00",
  A100: "#ffe57f",
  A200: "#ffd740",
  A400: "#ffc400",
  A700: "#ffab00"
}, Sa = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, PF = {
  50: "#fbe9e7",
  100: "#ffccbc",
  200: "#ffab91",
  300: "#ff8a65",
  400: "#ff7043",
  500: "#ff5722",
  600: "#f4511e",
  700: "#e64a19",
  800: "#d84315",
  900: "#bf360c",
  A100: "#ff9e80",
  A200: "#ff6e40",
  A400: "#ff3d00",
  A700: "#dd2c00"
}, MF = {
  50: "#efebe9",
  100: "#d7ccc8",
  200: "#bcaaa4",
  300: "#a1887f",
  400: "#8d6e63",
  500: "#795548",
  600: "#6d4c41",
  700: "#5d4037",
  800: "#4e342e",
  900: "#3e2723",
  A100: "#d7ccc8",
  A200: "#bcaaa4",
  A400: "#8d6e63",
  A700: "#5d4037"
}, OO = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, kF = {
  50: "#eceff1",
  100: "#cfd8dc",
  200: "#b0bec5",
  300: "#90a4ae",
  400: "#78909c",
  500: "#607d8b",
  600: "#546e7a",
  700: "#455a64",
  800: "#37474f",
  900: "#263238",
  A100: "#cfd8dc",
  A200: "#b0bec5",
  A400: "#78909c",
  A700: "#455a64"
}, Vbe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  amber: OF,
  blue: gi,
  blueGrey: kF,
  brown: MF,
  common: Ua,
  cyan: xF,
  deepOrange: PF,
  deepPurple: wF,
  green: bi,
  grey: OO,
  indigo: SF,
  lightBlue: mi,
  lightGreen: RF,
  lime: EF,
  orange: Sa,
  pink: CF,
  purple: hi,
  red: pi,
  teal: TF,
  yellow: IF
}, Symbol.toStringTag, { value: "Module" }));
function Zr(e, ...t) {
  const n = new URL(`https://mui.com/production-error/?code=${e}`);
  return t.forEach((o) => n.searchParams.append("args[]", o)), `Minified MUI error #${e}; visit ${n} for the full message.`;
}
const hr = "$$material";
function I() {
  return I = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n) ({}).hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, I.apply(null, arguments);
}
function DF(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function NF(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var PO = /* @__PURE__ */ function() {
  function e(n) {
    var o = this;
    this._insertTag = function(s) {
      var i;
      o.tags.length === 0 ? o.insertionPoint ? i = o.insertionPoint.nextSibling : o.prepend ? i = o.container.firstChild : i = o.before : i = o.tags[o.tags.length - 1].nextSibling, o.container.insertBefore(s, i), o.tags.push(s);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(o) {
    o.forEach(this._insertTag);
  }, t.insert = function(o) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(NF(this));
    var s = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var i = DF(s);
      try {
        i.insertRule(o, i.cssRules.length);
      } catch {
      }
    } else
      s.appendChild(document.createTextNode(o));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(o) {
      var s;
      return (s = o.parentNode) == null ? void 0 : s.removeChild(o);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), no = "-ms-", mf = "-moz-", Vt = "-webkit-", MO = "comm", pv = "rule", hv = "decl", $F = "@import", kO = "@keyframes", AF = "@layer", FF = Math.abs, ap = String.fromCharCode, LF = Object.assign;
function _F(e, t) {
  return Jn(e, 0) ^ 45 ? (((t << 2 ^ Jn(e, 0)) << 2 ^ Jn(e, 1)) << 2 ^ Jn(e, 2)) << 2 ^ Jn(e, 3) : 0;
}
function DO(e) {
  return e.trim();
}
function VF(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function zt(e, t, n) {
  return e.replace(t, n);
}
function jb(e, t) {
  return e.indexOf(t);
}
function Jn(e, t) {
  return e.charCodeAt(t) | 0;
}
function Ac(e, t, n) {
  return e.slice(t, n);
}
function Vr(e) {
  return e.length;
}
function gv(e) {
  return e.length;
}
function ed(e, t) {
  return t.push(e), e;
}
function BF(e, t) {
  return e.map(t).join("");
}
var lp = 1, Ka = 1, NO = 0, Do = 0, _n = 0, pl = "";
function cp(e, t, n, o, s, i, a) {
  return { value: e, root: t, parent: n, type: o, props: s, children: i, line: lp, column: Ka, length: a, return: "" };
}
function Fl(e, t) {
  return LF(cp("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function zF() {
  return _n;
}
function HF() {
  return _n = Do > 0 ? Jn(pl, --Do) : 0, Ka--, _n === 10 && (Ka = 1, lp--), _n;
}
function Go() {
  return _n = Do < NO ? Jn(pl, Do++) : 0, Ka++, _n === 10 && (Ka = 1, lp++), _n;
}
function qr() {
  return Jn(pl, Do);
}
function Ud() {
  return Do;
}
function uu(e, t) {
  return Ac(pl, e, t);
}
function Fc(e) {
  switch (e) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function $O(e) {
  return lp = Ka = 1, NO = Vr(pl = e), Do = 0, [];
}
function AO(e) {
  return pl = "", e;
}
function Kd(e) {
  return DO(uu(Do - 1, Gb(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function jF(e) {
  for (; (_n = qr()) && _n < 33; )
    Go();
  return Fc(e) > 2 || Fc(_n) > 3 ? "" : " ";
}
function GF(e, t) {
  for (; --t && Go() && !(_n < 48 || _n > 102 || _n > 57 && _n < 65 || _n > 70 && _n < 97); )
    ;
  return uu(e, Ud() + (t < 6 && qr() == 32 && Go() == 32));
}
function Gb(e) {
  for (; Go(); )
    switch (_n) {
      // ] ) " '
      case e:
        return Do;
      // " '
      case 34:
      case 39:
        e !== 34 && e !== 39 && Gb(_n);
        break;
      // (
      case 40:
        e === 41 && Gb(e);
        break;
      // \
      case 92:
        Go();
        break;
    }
  return Do;
}
function qF(e, t) {
  for (; Go() && e + _n !== 57; )
    if (e + _n === 84 && qr() === 47)
      break;
  return "/*" + uu(t, Do - 1) + "*" + ap(e === 47 ? e : Go());
}
function WF(e) {
  for (; !Fc(qr()); )
    Go();
  return uu(e, Do);
}
function UF(e) {
  return AO(Yd("", null, null, null, [""], e = $O(e), 0, [0], e));
}
function Yd(e, t, n, o, s, i, a, l, c) {
  for (var u = 0, d = 0, f = a, p = 0, m = 0, b = 0, v = 1, g = 1, y = 1, w = 0, x = "", S = s, T = i, E = o, O = x; g; )
    switch (b = w, w = Go()) {
      // (
      case 40:
        if (b != 108 && Jn(O, f - 1) == 58) {
          jb(O += zt(Kd(w), "&", "&\f"), "&\f") != -1 && (y = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        O += Kd(w);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        O += jF(b);
        break;
      // \
      case 92:
        O += GF(Ud() - 1, 7);
        continue;
      // /
      case 47:
        switch (qr()) {
          case 42:
          case 47:
            ed(KF(qF(Go(), Ud()), t, n), c);
            break;
          default:
            O += "/";
        }
        break;
      // {
      case 123 * v:
        l[u++] = Vr(O) * y;
      // } ; \0
      case 125 * v:
      case 59:
      case 0:
        switch (w) {
          // \0 }
          case 0:
          case 125:
            g = 0;
          // ;
          case 59 + d:
            y == -1 && (O = zt(O, /\f/g, "")), m > 0 && Vr(O) - f && ed(m > 32 ? hS(O + ";", o, n, f - 1) : hS(zt(O, " ", "") + ";", o, n, f - 2), c);
            break;
          // @ ;
          case 59:
            O += ";";
          // { rule/at-rule
          default:
            if (ed(E = pS(O, t, n, u, d, s, l, x, S = [], T = [], f), i), w === 123)
              if (d === 0)
                Yd(O, t, E, E, S, i, f, l, T);
              else
                switch (p === 99 && Jn(O, 3) === 110 ? 100 : p) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Yd(e, E, E, o && ed(pS(e, E, E, 0, 0, s, l, x, s, S = [], f), T), s, T, f, l, o ? S : T);
                    break;
                  default:
                    Yd(O, E, E, E, [""], T, 0, l, T);
                }
        }
        u = d = m = 0, v = y = 1, x = O = "", f = a;
        break;
      // :
      case 58:
        f = 1 + Vr(O), m = b;
      default:
        if (v < 1) {
          if (w == 123)
            --v;
          else if (w == 125 && v++ == 0 && HF() == 125)
            continue;
        }
        switch (O += ap(w), w * v) {
          // &
          case 38:
            y = d > 0 ? 1 : (O += "\f", -1);
            break;
          // ,
          case 44:
            l[u++] = (Vr(O) - 1) * y, y = 1;
            break;
          // @
          case 64:
            qr() === 45 && (O += Kd(Go())), p = qr(), d = f = Vr(x = O += WF(Ud())), w++;
            break;
          // -
          case 45:
            b === 45 && Vr(O) == 2 && (v = 0);
        }
    }
  return i;
}
function pS(e, t, n, o, s, i, a, l, c, u, d) {
  for (var f = s - 1, p = s === 0 ? i : [""], m = gv(p), b = 0, v = 0, g = 0; b < o; ++b)
    for (var y = 0, w = Ac(e, f + 1, f = FF(v = a[b])), x = e; y < m; ++y)
      (x = DO(v > 0 ? p[y] + " " + w : zt(w, /&\f/g, p[y]))) && (c[g++] = x);
  return cp(e, t, n, s === 0 ? pv : l, c, u, d);
}
function KF(e, t, n) {
  return cp(e, t, n, MO, ap(zF()), Ac(e, 2, -2), 0);
}
function hS(e, t, n, o) {
  return cp(e, t, n, hv, Ac(e, 0, o), Ac(e, o + 1, -1), o);
}
function Va(e, t) {
  for (var n = "", o = gv(e), s = 0; s < o; s++)
    n += t(e[s], s, e, t) || "";
  return n;
}
function YF(e, t, n, o) {
  switch (e.type) {
    case AF:
      if (e.children.length) break;
    case $F:
    case hv:
      return e.return = e.return || e.value;
    case MO:
      return "";
    case kO:
      return e.return = e.value + "{" + Va(e.children, o) + "}";
    case pv:
      e.value = e.props.join(",");
  }
  return Vr(n = Va(e.children, o)) ? e.return = e.value + "{" + n + "}" : "";
}
function XF(e) {
  var t = gv(e);
  return function(n, o, s, i) {
    for (var a = "", l = 0; l < t; l++)
      a += e[l](n, o, s, i) || "";
    return a;
  };
}
function QF(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function FO(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var ZF = function(t, n, o) {
  for (var s = 0, i = 0; s = i, i = qr(), s === 38 && i === 12 && (n[o] = 1), !Fc(i); )
    Go();
  return uu(t, Do);
}, JF = function(t, n) {
  var o = -1, s = 44;
  do
    switch (Fc(s)) {
      case 0:
        s === 38 && qr() === 12 && (n[o] = 1), t[o] += ZF(Do - 1, n, o);
        break;
      case 2:
        t[o] += Kd(s);
        break;
      case 4:
        if (s === 44) {
          t[++o] = qr() === 58 ? "&\f" : "", n[o] = t[o].length;
          break;
        }
      // fallthrough
      default:
        t[o] += ap(s);
    }
  while (s = Go());
  return t;
}, eL = function(t, n) {
  return AO(JF($O(t), n));
}, gS = /* @__PURE__ */ new WeakMap(), tL = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, o = t.parent, s = t.column === o.column && t.line === o.line; o.type !== "rule"; )
      if (o = o.parent, !o) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !gS.get(o)) && !s) {
      gS.set(t, !0);
      for (var i = [], a = eL(n, i), l = o.props, c = 0, u = 0; c < a.length; c++)
        for (var d = 0; d < l.length; d++, u++)
          t.props[u] = i[c] ? a[c].replace(/&\f/g, l[d]) : l[d] + " " + a[c];
    }
  }
}, nL = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function LO(e, t) {
  switch (_F(e, t)) {
    // color-adjust
    case 5103:
      return Vt + "print-" + e + e;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Vt + e + e;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Vt + e + mf + e + no + e + e;
    // flex, flex-direction
    case 6828:
    case 4268:
      return Vt + e + no + e + e;
    // order
    case 6165:
      return Vt + e + no + "flex-" + e + e;
    // align-items
    case 5187:
      return Vt + e + zt(e, /(\w+).+(:[^]+)/, Vt + "box-$1$2" + no + "flex-$1$2") + e;
    // align-self
    case 5443:
      return Vt + e + no + "flex-item-" + zt(e, /flex-|-self/, "") + e;
    // align-content
    case 4675:
      return Vt + e + no + "flex-line-pack" + zt(e, /align-content|flex-|-self/, "") + e;
    // flex-shrink
    case 5548:
      return Vt + e + no + zt(e, "shrink", "negative") + e;
    // flex-basis
    case 5292:
      return Vt + e + no + zt(e, "basis", "preferred-size") + e;
    // flex-grow
    case 6060:
      return Vt + "box-" + zt(e, "-grow", "") + Vt + e + no + zt(e, "grow", "positive") + e;
    // transition
    case 4554:
      return Vt + zt(e, /([^-])(transform)/g, "$1" + Vt + "$2") + e;
    // cursor
    case 6187:
      return zt(zt(zt(e, /(zoom-|grab)/, Vt + "$1"), /(image-set)/, Vt + "$1"), e, "") + e;
    // background, background-image
    case 5495:
    case 3959:
      return zt(e, /(image-set\([^]*)/, Vt + "$1$`$1");
    // justify-content
    case 4968:
      return zt(zt(e, /(.+:)(flex-)?(.*)/, Vt + "box-pack:$3" + no + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Vt + e + e;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return zt(e, /(.+)-inline(.+)/, Vt + "$1$2") + e;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Vr(e) - 1 - t > 6) switch (Jn(e, t + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (Jn(e, t + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return zt(e, /(.+:)(.+)-([^]+)/, "$1" + Vt + "$2-$3$1" + mf + (Jn(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        // (s)tretch
        case 115:
          return ~jb(e, "stretch") ? LO(zt(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    // position: sticky
    case 4949:
      if (Jn(e, t + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (Jn(e, Vr(e) - 3 - (~jb(e, "!important") && 10))) {
        // stic(k)y
        case 107:
          return zt(e, ":", ":" + Vt) + e;
        // (inline-)?fl(e)x
        case 101:
          return zt(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Vt + (Jn(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Vt + "$2$3$1" + no + "$2box$3") + e;
      }
      break;
    // writing-mode
    case 5936:
      switch (Jn(e, t + 11)) {
        // vertical-l(r)
        case 114:
          return Vt + e + no + zt(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        // vertical-r(l)
        case 108:
          return Vt + e + no + zt(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        // horizontal(-)tb
        case 45:
          return Vt + e + no + zt(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Vt + e + no + e + e;
  }
  return e;
}
var oL = function(t, n, o, s) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case hv:
      t.return = LO(t.value, t.length);
      break;
    case kO:
      return Va([Fl(t, {
        value: zt(t.value, "@", "@" + Vt)
      })], s);
    case pv:
      if (t.length) return BF(t.props, function(i) {
        switch (VF(i, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return Va([Fl(t, {
              props: [zt(i, /:(read-\w+)/, ":" + mf + "$1")]
            })], s);
          // :placeholder
          case "::placeholder":
            return Va([Fl(t, {
              props: [zt(i, /:(plac\w+)/, ":" + Vt + "input-$1")]
            }), Fl(t, {
              props: [zt(i, /:(plac\w+)/, ":" + mf + "$1")]
            }), Fl(t, {
              props: [zt(i, /:(plac\w+)/, no + "input-$1")]
            })], s);
        }
        return "";
      });
  }
}, rL = [oL], _O = function(t) {
  var n = t.key;
  if (n === "css") {
    var o = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(o, function(v) {
      var g = v.getAttribute("data-emotion");
      g.indexOf(" ") !== -1 && (document.head.appendChild(v), v.setAttribute("data-s", ""));
    });
  }
  var s = t.stylisPlugins || rL, i = {}, a, l = [];
  a = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(v) {
      for (var g = v.getAttribute("data-emotion").split(" "), y = 1; y < g.length; y++)
        i[g[y]] = !0;
      l.push(v);
    }
  );
  var c, u = [tL, nL];
  {
    var d, f = [YF, QF(function(v) {
      d.insert(v);
    })], p = XF(u.concat(s, f)), m = function(g) {
      return Va(UF(g), p);
    };
    c = function(g, y, w, x) {
      d = w, m(g ? g + "{" + y.styles + "}" : y.styles), x && (b.inserted[y.name] = !0);
    };
  }
  var b = {
    key: n,
    sheet: new PO({
      key: n,
      container: a,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: i,
    registered: {},
    insert: c
  };
  return b.sheet.hydrate(l), b;
}, td = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Zo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var nd = { exports: {} }, Kt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mS;
function sL() {
  if (mS) return Kt;
  mS = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
  function x(T) {
    if (typeof T == "object" && T !== null) {
      var E = T.$$typeof;
      switch (E) {
        case t:
          switch (T = T.type, T) {
            case c:
            case u:
            case o:
            case i:
            case s:
            case f:
              return T;
            default:
              switch (T = T && T.$$typeof, T) {
                case l:
                case d:
                case b:
                case m:
                case a:
                  return T;
                default:
                  return E;
              }
          }
        case n:
          return E;
      }
    }
  }
  function S(T) {
    return x(T) === u;
  }
  return Kt.AsyncMode = c, Kt.ConcurrentMode = u, Kt.ContextConsumer = l, Kt.ContextProvider = a, Kt.Element = t, Kt.ForwardRef = d, Kt.Fragment = o, Kt.Lazy = b, Kt.Memo = m, Kt.Portal = n, Kt.Profiler = i, Kt.StrictMode = s, Kt.Suspense = f, Kt.isAsyncMode = function(T) {
    return S(T) || x(T) === c;
  }, Kt.isConcurrentMode = S, Kt.isContextConsumer = function(T) {
    return x(T) === l;
  }, Kt.isContextProvider = function(T) {
    return x(T) === a;
  }, Kt.isElement = function(T) {
    return typeof T == "object" && T !== null && T.$$typeof === t;
  }, Kt.isForwardRef = function(T) {
    return x(T) === d;
  }, Kt.isFragment = function(T) {
    return x(T) === o;
  }, Kt.isLazy = function(T) {
    return x(T) === b;
  }, Kt.isMemo = function(T) {
    return x(T) === m;
  }, Kt.isPortal = function(T) {
    return x(T) === n;
  }, Kt.isProfiler = function(T) {
    return x(T) === i;
  }, Kt.isStrictMode = function(T) {
    return x(T) === s;
  }, Kt.isSuspense = function(T) {
    return x(T) === f;
  }, Kt.isValidElementType = function(T) {
    return typeof T == "string" || typeof T == "function" || T === o || T === u || T === i || T === s || T === f || T === p || typeof T == "object" && T !== null && (T.$$typeof === b || T.$$typeof === m || T.$$typeof === a || T.$$typeof === l || T.$$typeof === d || T.$$typeof === g || T.$$typeof === y || T.$$typeof === w || T.$$typeof === v);
  }, Kt.typeOf = x, Kt;
}
var Yt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bS;
function iL() {
  return bS || (bS = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, s = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, b = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, y = e ? Symbol.for("react.responder") : 60118, w = e ? Symbol.for("react.scope") : 60119;
    function x(H) {
      return typeof H == "string" || typeof H == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      H === o || H === u || H === i || H === s || H === f || H === p || typeof H == "object" && H !== null && (H.$$typeof === b || H.$$typeof === m || H.$$typeof === a || H.$$typeof === l || H.$$typeof === d || H.$$typeof === g || H.$$typeof === y || H.$$typeof === w || H.$$typeof === v);
    }
    function S(H) {
      if (typeof H == "object" && H !== null) {
        var U = H.$$typeof;
        switch (U) {
          case t:
            var X = H.type;
            switch (X) {
              case c:
              case u:
              case o:
              case i:
              case s:
              case f:
                return X;
              default:
                var re = X && X.$$typeof;
                switch (re) {
                  case l:
                  case d:
                  case b:
                  case m:
                  case a:
                    return re;
                  default:
                    return U;
                }
            }
          case n:
            return U;
        }
      }
    }
    var T = c, E = u, O = l, M = a, D = t, R = d, P = o, F = b, $ = m, N = n, A = i, k = s, L = f, B = !1;
    function V(H) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), _(H) || S(H) === c;
    }
    function _(H) {
      return S(H) === u;
    }
    function z(H) {
      return S(H) === l;
    }
    function j(H) {
      return S(H) === a;
    }
    function W(H) {
      return typeof H == "object" && H !== null && H.$$typeof === t;
    }
    function J(H) {
      return S(H) === d;
    }
    function G(H) {
      return S(H) === o;
    }
    function q(H) {
      return S(H) === b;
    }
    function Z(H) {
      return S(H) === m;
    }
    function Y(H) {
      return S(H) === n;
    }
    function Q(H) {
      return S(H) === i;
    }
    function ee(H) {
      return S(H) === s;
    }
    function ne(H) {
      return S(H) === f;
    }
    Yt.AsyncMode = T, Yt.ConcurrentMode = E, Yt.ContextConsumer = O, Yt.ContextProvider = M, Yt.Element = D, Yt.ForwardRef = R, Yt.Fragment = P, Yt.Lazy = F, Yt.Memo = $, Yt.Portal = N, Yt.Profiler = A, Yt.StrictMode = k, Yt.Suspense = L, Yt.isAsyncMode = V, Yt.isConcurrentMode = _, Yt.isContextConsumer = z, Yt.isContextProvider = j, Yt.isElement = W, Yt.isForwardRef = J, Yt.isFragment = G, Yt.isLazy = q, Yt.isMemo = Z, Yt.isPortal = Y, Yt.isProfiler = Q, Yt.isStrictMode = ee, Yt.isSuspense = ne, Yt.isValidElementType = x, Yt.typeOf = S;
  }()), Yt;
}
var yS;
function mv() {
  return yS || (yS = 1, process.env.NODE_ENV === "production" ? nd.exports = sL() : nd.exports = iL()), nd.exports;
}
var Eh, vS;
function aL() {
  if (vS) return Eh;
  vS = 1;
  var e = mv(), t = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, o = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, s = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[e.ForwardRef] = o, i[e.Memo] = s;
  function a(b) {
    return e.isMemo(b) ? s : i[b.$$typeof] || t;
  }
  var l = Object.defineProperty, c = Object.getOwnPropertyNames, u = Object.getOwnPropertySymbols, d = Object.getOwnPropertyDescriptor, f = Object.getPrototypeOf, p = Object.prototype;
  function m(b, v, g) {
    if (typeof v != "string") {
      if (p) {
        var y = f(v);
        y && y !== p && m(b, y, g);
      }
      var w = c(v);
      u && (w = w.concat(u(v)));
      for (var x = a(b), S = a(v), T = 0; T < w.length; ++T) {
        var E = w[T];
        if (!n[E] && !(g && g[E]) && !(S && S[E]) && !(x && x[E])) {
          var O = d(v, E);
          try {
            l(b, E, O);
          } catch {
          }
        }
      }
    }
    return b;
  }
  return Eh = m, Eh;
}
var lL = aL();
const VO = /* @__PURE__ */ Zo(lL);
var cL = !0;
function BO(e, t, n) {
  var o = "";
  return n.split(" ").forEach(function(s) {
    e[s] !== void 0 ? t.push(e[s] + ";") : s && (o += s + " ");
  }), o;
}
var bv = function(t, n, o) {
  var s = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (o === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  cL === !1) && t.registered[s] === void 0 && (t.registered[s] = n.styles);
}, yv = function(t, n, o) {
  bv(t, n, o);
  var s = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var i = n;
    do
      t.insert(n === i ? "." + s : "", i, t.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function uL(e) {
  for (var t = 0, n, o = 0, s = e.length; s >= 4; ++o, s -= 4)
    n = e.charCodeAt(o) & 255 | (e.charCodeAt(++o) & 255) << 8 | (e.charCodeAt(++o) & 255) << 16 | (e.charCodeAt(++o) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (s) {
    case 3:
      t ^= (e.charCodeAt(o + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(o + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(o) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var dL = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, fL = /[A-Z]|^ms/g, pL = /_EMO_([^_]+?)_([^]*?)_EMO_/g, zO = function(t) {
  return t.charCodeAt(1) === 45;
}, CS = function(t) {
  return t != null && typeof t != "boolean";
}, Ih = /* @__PURE__ */ FO(function(e) {
  return zO(e) ? e : e.replace(fL, "-$&").toLowerCase();
}), wS = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(pL, function(o, s, i) {
          return Br = {
            name: s,
            styles: i,
            next: Br
          }, s;
        });
  }
  return dL[t] !== 1 && !zO(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
function Lc(e, t, n) {
  if (n == null)
    return "";
  var o = n;
  if (o.__emotion_styles !== void 0)
    return o;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var s = n;
      if (s.anim === 1)
        return Br = {
          name: s.name,
          styles: s.styles,
          next: Br
        }, s.name;
      var i = n;
      if (i.styles !== void 0) {
        var a = i.next;
        if (a !== void 0)
          for (; a !== void 0; )
            Br = {
              name: a.name,
              styles: a.styles,
              next: Br
            }, a = a.next;
        var l = i.styles + ";";
        return l;
      }
      return hL(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var c = Br, u = n(e);
        return Br = c, Lc(e, t, u);
      }
      break;
    }
  }
  var d = n;
  if (t == null)
    return d;
  var f = t[d];
  return f !== void 0 ? f : d;
}
function hL(e, t, n) {
  var o = "";
  if (Array.isArray(n))
    for (var s = 0; s < n.length; s++)
      o += Lc(e, t, n[s]) + ";";
  else
    for (var i in n) {
      var a = n[i];
      if (typeof a != "object") {
        var l = a;
        t != null && t[l] !== void 0 ? o += i + "{" + t[l] + "}" : CS(l) && (o += Ih(i) + ":" + wS(i, l) + ";");
      } else if (Array.isArray(a) && typeof a[0] == "string" && (t == null || t[a[0]] === void 0))
        for (var c = 0; c < a.length; c++)
          CS(a[c]) && (o += Ih(i) + ":" + wS(i, a[c]) + ";");
      else {
        var u = Lc(e, t, a);
        switch (i) {
          case "animation":
          case "animationName": {
            o += Ih(i) + ":" + u + ";";
            break;
          }
          default:
            o += i + "{" + u + "}";
        }
      }
    }
  return o;
}
var SS = /label:\s*([^\s;{]+)\s*(;|$)/g, Br;
function du(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var o = !0, s = "";
  Br = void 0;
  var i = e[0];
  if (i == null || i.raw === void 0)
    o = !1, s += Lc(n, t, i);
  else {
    var a = i;
    s += a[0];
  }
  for (var l = 1; l < e.length; l++)
    if (s += Lc(n, t, e[l]), o) {
      var c = i;
      s += c[l];
    }
  SS.lastIndex = 0;
  for (var u = "", d; (d = SS.exec(s)) !== null; )
    u += "-" + d[1];
  var f = uL(s) + u;
  return {
    name: f,
    styles: s,
    next: Br
  };
}
var gL = function(t) {
  return t();
}, HO = h.useInsertionEffect ? h.useInsertionEffect : !1, jO = HO || gL, xS = HO || h.useLayoutEffect, GO = /* @__PURE__ */ h.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ _O({
    key: "css"
  }) : null
), mL = GO.Provider, vv = function(t) {
  return /* @__PURE__ */ rs(function(n, o) {
    var s = Co(GO);
    return t(n, s, o);
  });
}, fu = /* @__PURE__ */ h.createContext({}), Cv = {}.hasOwnProperty, qb = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", bL = function(t, n) {
  var o = {};
  for (var s in n)
    Cv.call(n, s) && (o[s] = n[s]);
  return o[qb] = t, o;
}, yL = function(t) {
  var n = t.cache, o = t.serialized, s = t.isStringTag;
  return bv(n, o, s), jO(function() {
    return yv(n, o, s);
  }), null;
}, vL = /* @__PURE__ */ vv(function(e, t, n) {
  var o = e.css;
  typeof o == "string" && t.registered[o] !== void 0 && (o = t.registered[o]);
  var s = e[qb], i = [o], a = "";
  typeof e.className == "string" ? a = BO(t.registered, i, e.className) : e.className != null && (a = e.className + " ");
  var l = du(i, void 0, h.useContext(fu));
  a += t.key + "-" + l.name;
  var c = {};
  for (var u in e)
    Cv.call(e, u) && u !== "css" && u !== qb && (c[u] = e[u]);
  return c.className = a, n && (c.ref = n), /* @__PURE__ */ h.createElement(h.Fragment, null, /* @__PURE__ */ h.createElement(yL, {
    cache: t,
    serialized: l,
    isStringTag: typeof s == "string"
  }), /* @__PURE__ */ h.createElement(s, c));
}), CL = vL, TS = function(t, n) {
  var o = arguments;
  if (n == null || !Cv.call(n, "css"))
    return h.createElement.apply(void 0, o);
  var s = o.length, i = new Array(s);
  i[0] = CL, i[1] = bL(t, n);
  for (var a = 2; a < s; a++)
    i[a] = o[a];
  return h.createElement.apply(null, i);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(TS || (TS = {}));
var wL = /* @__PURE__ */ vv(function(e, t) {
  var n = e.styles, o = du([n], void 0, h.useContext(fu)), s = h.useRef();
  return xS(function() {
    var i = t.key + "-global", a = new t.sheet.constructor({
      key: i,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), l = !1, c = document.querySelector('style[data-emotion="' + i + " " + o.name + '"]');
    return t.sheet.tags.length && (a.before = t.sheet.tags[0]), c !== null && (l = !0, c.setAttribute("data-emotion", i), a.hydrate([c])), s.current = [a, l], function() {
      a.flush();
    };
  }, [t]), xS(function() {
    var i = s.current, a = i[0], l = i[1];
    if (l) {
      i[1] = !1;
      return;
    }
    if (o.next !== void 0 && yv(t, o.next, !0), a.tags.length) {
      var c = a.tags[a.tags.length - 1].nextElementSibling;
      a.before = c, a.flush();
    }
    t.insert("", o, a, !1);
  }, [t, o.name]), null;
});
function Qs() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return du(t);
}
function ss() {
  var e = Qs.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var SL = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, xL = /* @__PURE__ */ FO(
  function(e) {
    return SL.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), TL = xL, RL = function(t) {
  return t !== "theme";
}, RS = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? TL : RL;
}, ES = function(t, n, o) {
  var s;
  if (n) {
    var i = n.shouldForwardProp;
    s = t.__emotion_forwardProp && i ? function(a) {
      return t.__emotion_forwardProp(a) && i(a);
    } : i;
  }
  return typeof s != "function" && o && (s = t.__emotion_forwardProp), s;
}, EL = function(t) {
  var n = t.cache, o = t.serialized, s = t.isStringTag;
  return bv(n, o, s), jO(function() {
    return yv(n, o, s);
  }), null;
}, IL = function e(t, n) {
  var o = t.__emotion_real === t, s = o && t.__emotion_base || t, i, a;
  n !== void 0 && (i = n.label, a = n.target);
  var l = ES(t, n, o), c = l || RS(s), u = !c("as");
  return function() {
    var d = arguments, f = o && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (i !== void 0 && f.push("label:" + i + ";"), d[0] == null || d[0].raw === void 0)
      f.push.apply(f, d);
    else {
      var p = d[0];
      f.push(p[0]);
      for (var m = d.length, b = 1; b < m; b++)
        f.push(d[b], p[b]);
    }
    var v = vv(function(g, y, w) {
      var x = u && g.as || s, S = "", T = [], E = g;
      if (g.theme == null) {
        E = {};
        for (var O in g)
          E[O] = g[O];
        E.theme = h.useContext(fu);
      }
      typeof g.className == "string" ? S = BO(y.registered, T, g.className) : g.className != null && (S = g.className + " ");
      var M = du(f.concat(T), y.registered, E);
      S += y.key + "-" + M.name, a !== void 0 && (S += " " + a);
      var D = u && l === void 0 ? RS(x) : c, R = {};
      for (var P in g)
        u && P === "as" || D(P) && (R[P] = g[P]);
      return R.className = S, w && (R.ref = w), /* @__PURE__ */ h.createElement(h.Fragment, null, /* @__PURE__ */ h.createElement(EL, {
        cache: y,
        serialized: M,
        isStringTag: typeof x == "string"
      }), /* @__PURE__ */ h.createElement(x, R));
    });
    return v.displayName = i !== void 0 ? i : "Styled(" + (typeof s == "string" ? s : s.displayName || s.name || "Component") + ")", v.defaultProps = t.defaultProps, v.__emotion_real = v, v.__emotion_base = s, v.__emotion_styles = f, v.__emotion_forwardProp = l, Object.defineProperty(v, "toString", {
      value: function() {
        return "." + a;
      }
    }), v.withComponent = function(g, y) {
      var w = e(g, I({}, n, y, {
        shouldForwardProp: ES(v, y, !0)
      }));
      return w.apply(void 0, f);
    }, v;
  };
}, OL = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], Wb = IL.bind(null);
OL.forEach(function(e) {
  Wb[e] = Wb(e);
});
var od = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Oh, IS;
function PL() {
  if (IS) return Oh;
  IS = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function o(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function s() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var a = {}, l = 0; l < 10; l++)
        a["_" + String.fromCharCode(l)] = l;
      var c = Object.getOwnPropertyNames(a).map(function(d) {
        return a[d];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        u[d] = d;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Oh = s() ? Object.assign : function(i, a) {
    for (var l, c = o(i), u, d = 1; d < arguments.length; d++) {
      l = Object(arguments[d]);
      for (var f in l)
        t.call(l, f) && (c[f] = l[f]);
      if (e) {
        u = e(l);
        for (var p = 0; p < u.length; p++)
          n.call(l, u[p]) && (c[u[p]] = l[u[p]]);
      }
    }
    return c;
  }, Oh;
}
var Ph, OS;
function wv() {
  if (OS) return Ph;
  OS = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ph = e, Ph;
}
var Mh, PS;
function qO() {
  return PS || (PS = 1, Mh = Function.call.bind(Object.prototype.hasOwnProperty)), Mh;
}
var kh, MS;
function ML() {
  if (MS) return kh;
  MS = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ wv(), n = {}, o = /* @__PURE__ */ qO();
    e = function(i) {
      var a = "Warning: " + i;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function s(i, a, l, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in i)
        if (o(i, d)) {
          var f;
          try {
            if (typeof i[d] != "function") {
              var p = Error(
                (c || "React class") + ": " + l + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = i[d](a, d, c, l, null, t);
          } catch (b) {
            f = b;
          }
          if (f && !(f instanceof Error) && e(
            (c || "React class") + ": type specification of " + l + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var m = u ? u() : "";
            e(
              "Failed " + l + " type: " + f.message + (m ?? "")
            );
          }
        }
    }
  }
  return s.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, kh = s, kh;
}
var Dh, kS;
function kL() {
  if (kS) return Dh;
  kS = 1;
  var e = mv(), t = PL(), n = /* @__PURE__ */ wv(), o = /* @__PURE__ */ qO(), s = /* @__PURE__ */ ML(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(l) {
    var c = "Warning: " + l;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Dh = function(l, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(_) {
      var z = _ && (u && _[u] || _[d]);
      if (typeof z == "function")
        return z;
    }
    var p = "<<anonymous>>", m = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: w(),
      arrayOf: x,
      element: S(),
      elementType: T(),
      instanceOf: E,
      node: R(),
      objectOf: M,
      oneOf: O,
      oneOfType: D,
      shape: F,
      exact: $
    };
    function b(_, z) {
      return _ === z ? _ !== 0 || 1 / _ === 1 / z : _ !== _ && z !== z;
    }
    function v(_, z) {
      this.message = _, this.data = z && typeof z == "object" ? z : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function g(_) {
      if (process.env.NODE_ENV !== "production")
        var z = {}, j = 0;
      function W(G, q, Z, Y, Q, ee, ne) {
        if (Y = Y || p, ee = ee || Z, ne !== n) {
          if (c) {
            var H = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw H.name = "Invariant Violation", H;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var U = Y + ":" + Z;
            !z[U] && // Avoid spamming the console because they are often not actionable except for lib authors
            j < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + ee + "` prop on `" + Y + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), z[U] = !0, j++);
          }
        }
        return q[Z] == null ? G ? q[Z] === null ? new v("The " + Q + " `" + ee + "` is marked as required " + ("in `" + Y + "`, but its value is `null`.")) : new v("The " + Q + " `" + ee + "` is marked as required in " + ("`" + Y + "`, but its value is `undefined`.")) : null : _(q, Z, Y, Q, ee);
      }
      var J = W.bind(null, !1);
      return J.isRequired = W.bind(null, !0), J;
    }
    function y(_) {
      function z(j, W, J, G, q, Z) {
        var Y = j[W], Q = k(Y);
        if (Q !== _) {
          var ee = L(Y);
          return new v(
            "Invalid " + G + " `" + q + "` of type " + ("`" + ee + "` supplied to `" + J + "`, expected ") + ("`" + _ + "`."),
            { expectedType: _ }
          );
        }
        return null;
      }
      return g(z);
    }
    function w() {
      return g(a);
    }
    function x(_) {
      function z(j, W, J, G, q) {
        if (typeof _ != "function")
          return new v("Property `" + q + "` of component `" + J + "` has invalid PropType notation inside arrayOf.");
        var Z = j[W];
        if (!Array.isArray(Z)) {
          var Y = k(Z);
          return new v("Invalid " + G + " `" + q + "` of type " + ("`" + Y + "` supplied to `" + J + "`, expected an array."));
        }
        for (var Q = 0; Q < Z.length; Q++) {
          var ee = _(Z, Q, J, G, q + "[" + Q + "]", n);
          if (ee instanceof Error)
            return ee;
        }
        return null;
      }
      return g(z);
    }
    function S() {
      function _(z, j, W, J, G) {
        var q = z[j];
        if (!l(q)) {
          var Z = k(q);
          return new v("Invalid " + J + " `" + G + "` of type " + ("`" + Z + "` supplied to `" + W + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(_);
    }
    function T() {
      function _(z, j, W, J, G) {
        var q = z[j];
        if (!e.isValidElementType(q)) {
          var Z = k(q);
          return new v("Invalid " + J + " `" + G + "` of type " + ("`" + Z + "` supplied to `" + W + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(_);
    }
    function E(_) {
      function z(j, W, J, G, q) {
        if (!(j[W] instanceof _)) {
          var Z = _.name || p, Y = V(j[W]);
          return new v("Invalid " + G + " `" + q + "` of type " + ("`" + Y + "` supplied to `" + J + "`, expected ") + ("instance of `" + Z + "`."));
        }
        return null;
      }
      return g(z);
    }
    function O(_) {
      if (!Array.isArray(_))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), a;
      function z(j, W, J, G, q) {
        for (var Z = j[W], Y = 0; Y < _.length; Y++)
          if (b(Z, _[Y]))
            return null;
        var Q = JSON.stringify(_, function(ne, H) {
          var U = L(H);
          return U === "symbol" ? String(H) : H;
        });
        return new v("Invalid " + G + " `" + q + "` of value `" + String(Z) + "` " + ("supplied to `" + J + "`, expected one of " + Q + "."));
      }
      return g(z);
    }
    function M(_) {
      function z(j, W, J, G, q) {
        if (typeof _ != "function")
          return new v("Property `" + q + "` of component `" + J + "` has invalid PropType notation inside objectOf.");
        var Z = j[W], Y = k(Z);
        if (Y !== "object")
          return new v("Invalid " + G + " `" + q + "` of type " + ("`" + Y + "` supplied to `" + J + "`, expected an object."));
        for (var Q in Z)
          if (o(Z, Q)) {
            var ee = _(Z, Q, J, G, q + "." + Q, n);
            if (ee instanceof Error)
              return ee;
          }
        return null;
      }
      return g(z);
    }
    function D(_) {
      if (!Array.isArray(_))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var z = 0; z < _.length; z++) {
        var j = _[z];
        if (typeof j != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + B(j) + " at index " + z + "."
          ), a;
      }
      function W(J, G, q, Z, Y) {
        for (var Q = [], ee = 0; ee < _.length; ee++) {
          var ne = _[ee], H = ne(J, G, q, Z, Y, n);
          if (H == null)
            return null;
          H.data && o(H.data, "expectedType") && Q.push(H.data.expectedType);
        }
        var U = Q.length > 0 ? ", expected one of type [" + Q.join(", ") + "]" : "";
        return new v("Invalid " + Z + " `" + Y + "` supplied to " + ("`" + q + "`" + U + "."));
      }
      return g(W);
    }
    function R() {
      function _(z, j, W, J, G) {
        return N(z[j]) ? null : new v("Invalid " + J + " `" + G + "` supplied to " + ("`" + W + "`, expected a ReactNode."));
      }
      return g(_);
    }
    function P(_, z, j, W, J) {
      return new v(
        (_ || "React class") + ": " + z + " type `" + j + "." + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + J + "`."
      );
    }
    function F(_) {
      function z(j, W, J, G, q) {
        var Z = j[W], Y = k(Z);
        if (Y !== "object")
          return new v("Invalid " + G + " `" + q + "` of type `" + Y + "` " + ("supplied to `" + J + "`, expected `object`."));
        for (var Q in _) {
          var ee = _[Q];
          if (typeof ee != "function")
            return P(J, G, q, Q, L(ee));
          var ne = ee(Z, Q, J, G, q + "." + Q, n);
          if (ne)
            return ne;
        }
        return null;
      }
      return g(z);
    }
    function $(_) {
      function z(j, W, J, G, q) {
        var Z = j[W], Y = k(Z);
        if (Y !== "object")
          return new v("Invalid " + G + " `" + q + "` of type `" + Y + "` " + ("supplied to `" + J + "`, expected `object`."));
        var Q = t({}, j[W], _);
        for (var ee in Q) {
          var ne = _[ee];
          if (o(_, ee) && typeof ne != "function")
            return P(J, G, q, ee, L(ne));
          if (!ne)
            return new v(
              "Invalid " + G + " `" + q + "` key `" + ee + "` supplied to `" + J + "`.\nBad object: " + JSON.stringify(j[W], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(_), null, "  ")
            );
          var H = ne(Z, ee, J, G, q + "." + ee, n);
          if (H)
            return H;
        }
        return null;
      }
      return g(z);
    }
    function N(_) {
      switch (typeof _) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !_;
        case "object":
          if (Array.isArray(_))
            return _.every(N);
          if (_ === null || l(_))
            return !0;
          var z = f(_);
          if (z) {
            var j = z.call(_), W;
            if (z !== _.entries) {
              for (; !(W = j.next()).done; )
                if (!N(W.value))
                  return !1;
            } else
              for (; !(W = j.next()).done; ) {
                var J = W.value;
                if (J && !N(J[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function A(_, z) {
      return _ === "symbol" ? !0 : z ? z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && z instanceof Symbol : !1;
    }
    function k(_) {
      var z = typeof _;
      return Array.isArray(_) ? "array" : _ instanceof RegExp ? "object" : A(z, _) ? "symbol" : z;
    }
    function L(_) {
      if (typeof _ > "u" || _ === null)
        return "" + _;
      var z = k(_);
      if (z === "object") {
        if (_ instanceof Date)
          return "date";
        if (_ instanceof RegExp)
          return "regexp";
      }
      return z;
    }
    function B(_) {
      var z = L(_);
      switch (z) {
        case "array":
        case "object":
          return "an " + z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + z;
        default:
          return z;
      }
    }
    function V(_) {
      return !_.constructor || !_.constructor.name ? p : _.constructor.name;
    }
    return m.checkPropTypes = s, m.resetWarningCache = s.resetWarningCache, m.PropTypes = m, m;
  }, Dh;
}
var Nh, DS;
function DL() {
  if (DS) return Nh;
  DS = 1;
  var e = /* @__PURE__ */ wv();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Nh = function() {
    function o(a, l, c, u, d, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    o.isRequired = o;
    function s() {
      return o;
    }
    var i = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: s,
      element: o,
      elementType: o,
      instanceOf: s,
      node: o,
      objectOf: s,
      oneOf: s,
      oneOfType: s,
      shape: s,
      exact: s,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Nh;
}
var NS;
function NL() {
  if (NS) return od.exports;
  if (NS = 1, process.env.NODE_ENV !== "production") {
    var e = mv(), t = !0;
    od.exports = /* @__PURE__ */ kL()(e.isElement, t);
  } else
    od.exports = /* @__PURE__ */ DL()();
  return od.exports;
}
var $L = /* @__PURE__ */ NL();
const r = /* @__PURE__ */ Zo($L), AL = (e) => {
  const t = _O(e);
  class n extends PO {
    constructor(s) {
      super(s), this.prepend = t.sheet.prepend;
    }
  }
  return t.sheet = new n({
    key: t.key,
    nonce: t.sheet.nonce,
    container: t.sheet.container,
    speedy: t.sheet.isSpeedy,
    prepend: t.sheet.prepend,
    insertionPoint: t.sheet.insertionPoint
  }), t;
};
let Ub;
typeof document == "object" && (Ub = AL({
  key: "css",
  prepend: !0
}));
function Sv(e) {
  const {
    injectFirst: t,
    children: n
  } = e;
  return t && Ub ? /* @__PURE__ */ C(mL, {
    value: Ub,
    children: n
  }) : n;
}
process.env.NODE_ENV !== "production" && (Sv.propTypes = {
  /**
   * Your component tree.
   */
  children: r.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: r.bool
});
function FL(e) {
  return e == null || Object.keys(e).length === 0;
}
function xv(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e;
  return /* @__PURE__ */ C(wL, {
    styles: typeof t == "function" ? (s) => t(FL(s) ? n : s) : t
  });
}
process.env.NODE_ENV !== "production" && (xv.propTypes = {
  defaultTheme: r.object,
  styles: r.oneOfType([r.array, r.string, r.object, r.func])
});
/**
 * @mui/styled-engine v6.1.10
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function WO(e, t) {
  const n = Wb(e, t);
  return process.env.NODE_ENV !== "production" ? (...o) => {
    const s = typeof e == "string" ? `"${e}"` : "component";
    return o.length === 0 ? console.error([`MUI: Seems like you called \`styled(${s})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : o.some((i) => i === void 0) && console.error(`MUI: the styled(${s})(...args) API requires all its args to be defined.`), n(...o);
  } : n;
}
function LL(e, t) {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}
const $S = [];
function AS(e) {
  return $S[0] = e, du($S);
}
function jr(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function UO(e) {
  if (/* @__PURE__ */ h.isValidElement(e) || !jr(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = UO(e[n]);
  }), t;
}
function Bn(e, t, n = {
  clone: !0
}) {
  const o = n.clone ? {
    ...e
  } : e;
  return jr(e) && jr(t) && Object.keys(t).forEach((s) => {
    /* @__PURE__ */ h.isValidElement(t[s]) ? o[s] = t[s] : jr(t[s]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, s) && jr(e[s]) ? o[s] = Bn(e[s], t[s], n) : n.clone ? o[s] = jr(t[s]) ? UO(t[s]) : t[s] : o[s] = t[s];
  }), o;
}
const _L = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, o) => n.val - o.val), t.reduce((n, o) => ({
    ...n,
    [o.key]: o.val
  }), {});
};
function VL(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: o = 5,
    ...s
  } = e, i = _L(t), a = Object.keys(i);
  function l(p) {
    return `@media (min-width:${typeof t[p] == "number" ? t[p] : p}${n})`;
  }
  function c(p) {
    return `@media (max-width:${(typeof t[p] == "number" ? t[p] : p) - o / 100}${n})`;
  }
  function u(p, m) {
    const b = a.indexOf(m);
    return `@media (min-width:${typeof t[p] == "number" ? t[p] : p}${n}) and (max-width:${(b !== -1 && typeof t[a[b]] == "number" ? t[a[b]] : m) - o / 100}${n})`;
  }
  function d(p) {
    return a.indexOf(p) + 1 < a.length ? u(p, a[a.indexOf(p) + 1]) : l(p);
  }
  function f(p) {
    const m = a.indexOf(p);
    return m === 0 ? l(a[1]) : m === a.length - 1 ? c(a[m]) : u(p, a[a.indexOf(p) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: a,
    values: i,
    up: l,
    down: c,
    between: u,
    only: d,
    not: f,
    unit: n,
    ...s
  };
}
function BL(e, t) {
  if (!e.containerQueries)
    return t;
  const n = Object.keys(t).filter((o) => o.startsWith("@container")).sort((o, s) => {
    var a, l;
    const i = /min-width:\s*([0-9.]+)/;
    return +(((a = o.match(i)) == null ? void 0 : a[1]) || 0) - +(((l = s.match(i)) == null ? void 0 : l[1]) || 0);
  });
  return n.length ? n.reduce((o, s) => {
    const i = t[s];
    return delete o[s], o[s] = i, o;
  }, {
    ...t
  }) : t;
}
function zL(e, t) {
  return t === "@" || t.startsWith("@") && (e.some((n) => t.startsWith(`@${n}`)) || !!t.match(/^@\d/));
}
function HL(e, t) {
  const n = t.match(/^@([^/]+)?\/?(.+)?$/);
  if (!n) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${t})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : Zr(18, `(${t})`));
    return null;
  }
  const [, o, s] = n, i = Number.isNaN(+o) ? o || 0 : +o;
  return e.containerQueries(s).up(i);
}
function jL(e) {
  const t = (i, a) => i.replace("@media", a ? `@container ${a}` : "@container");
  function n(i, a) {
    i.up = (...l) => t(e.breakpoints.up(...l), a), i.down = (...l) => t(e.breakpoints.down(...l), a), i.between = (...l) => t(e.breakpoints.between(...l), a), i.only = (...l) => t(e.breakpoints.only(...l), a), i.not = (...l) => {
      const c = t(e.breakpoints.not(...l), a);
      return c.includes("not all and") ? c.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : c;
    };
  }
  const o = {}, s = (i) => (n(o, i), o);
  return n(s), {
    ...e,
    containerQueries: s
  };
}
const GL = {
  borderRadius: 4
}, Zs = process.env.NODE_ENV !== "production" ? r.oneOfType([r.number, r.string, r.object, r.array]) : {};
function wc(e, t) {
  return t ? Bn(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const up = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, FS = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${up[e]}px)`
}, qL = {
  containerQueries: (e) => ({
    up: (t) => {
      let n = typeof t == "number" ? t : up[t] || t;
      return typeof n == "number" && (n = `${n}px`), e ? `@container ${e} (min-width:${n})` : `@container (min-width:${n})`;
    }
  })
};
function No(e, t, n) {
  const o = e.theme || {};
  if (Array.isArray(t)) {
    const i = o.breakpoints || FS;
    return t.reduce((a, l, c) => (a[i.up(i.keys[c])] = n(t[c]), a), {});
  }
  if (typeof t == "object") {
    const i = o.breakpoints || FS;
    return Object.keys(t).reduce((a, l) => {
      if (zL(i.keys, l)) {
        const c = HL(o.containerQueries ? o : qL, l);
        c && (a[c] = n(t[l], l));
      } else if (Object.keys(i.values || up).includes(l)) {
        const c = i.up(l);
        a[c] = n(t[l], l);
      } else {
        const c = l;
        a[c] = t[c];
      }
      return a;
    }, {});
  }
  return n(t);
}
function KO(e = {}) {
  var n;
  return ((n = e.keys) == null ? void 0 : n.reduce((o, s) => {
    const i = e.up(s);
    return o[i] = {}, o;
  }, {})) || {};
}
function YO(e, t) {
  return e.reduce((n, o) => {
    const s = n[o];
    return (!s || Object.keys(s).length === 0) && delete n[o], n;
  }, t);
}
function WL(e, ...t) {
  const n = KO(e), o = [n, ...t].reduce((s, i) => Bn(s, i), {});
  return YO(Object.keys(n), o);
}
function UL(e, t) {
  if (typeof e != "object")
    return {};
  const n = {}, o = Object.keys(t);
  return Array.isArray(e) ? o.forEach((s, i) => {
    i < e.length && (n[s] = !0);
  }) : o.forEach((s) => {
    e[s] != null && (n[s] = !0);
  }), n;
}
function Ii({
  values: e,
  breakpoints: t,
  base: n
}) {
  const o = n || UL(e, t), s = Object.keys(o);
  if (s.length === 0)
    return e;
  let i;
  return s.reduce((a, l, c) => (Array.isArray(e) ? (a[l] = e[c] != null ? e[c] : e[i], i = c) : typeof e == "object" ? (a[l] = e[l] != null ? e[l] : e[i], i = l) : a[l] = e, a), {});
}
function ce(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : Zr(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function dp(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const o = `vars.${t}`.split(".").reduce((s, i) => s && s[i] ? s[i] : null, e);
    if (o != null)
      return o;
  }
  return t.split(".").reduce((o, s) => o && o[s] != null ? o[s] : null, e);
}
function bf(e, t, n, o = n) {
  let s;
  return typeof e == "function" ? s = e(n) : Array.isArray(e) ? s = e[n] || o : s = dp(e, n) || o, t && (s = t(s, o, e)), s;
}
function An(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: o,
    transform: s
  } = e, i = (a) => {
    if (a[t] == null)
      return null;
    const l = a[t], c = a.theme, u = dp(c, o) || {};
    return No(a, l, (f) => {
      let p = bf(u, s, f);
      return f === p && typeof f == "string" && (p = bf(u, s, `${t}${f === "default" ? "" : ce(f)}`, f)), n === !1 ? p : {
        [n]: p
      };
    });
  };
  return i.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: Zs
  } : {}, i.filterProps = [t], i;
}
function KL(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const YL = {
  m: "margin",
  p: "padding"
}, XL = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, LS = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, QL = KL((e) => {
  if (e.length > 2)
    if (LS[e])
      e = LS[e];
    else
      return [e];
  const [t, n] = e.split(""), o = YL[t], s = XL[n] || "";
  return Array.isArray(s) ? s.map((i) => o + i) : [o + s];
}), fp = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], pp = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], ZL = [...fp, ...pp];
function pu(e, t, n, o) {
  const s = dp(e, t, !0) ?? n;
  return typeof s == "number" || typeof s == "string" ? (i) => typeof i == "string" ? i : (process.env.NODE_ENV !== "production" && typeof i != "number" && console.error(`MUI: Expected ${o} argument to be a number or a string, got ${i}.`), typeof s == "string" ? `calc(${i} * ${s})` : s * i) : Array.isArray(s) ? (i) => {
    if (typeof i == "string")
      return i;
    const a = Math.abs(i);
    process.env.NODE_ENV !== "production" && (Number.isInteger(a) ? a > s.length - 1 && console.error([`MUI: The value provided (${a}) overflows.`, `The supported values are: ${JSON.stringify(s)}.`, `${a} > ${s.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`)));
    const l = s[a];
    return i >= 0 ? l : typeof l == "number" ? -l : `-${l}`;
  } : typeof s == "function" ? s : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${s}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function hp(e) {
  return pu(e, "spacing", 8, "spacing");
}
function Ai(e, t) {
  return typeof t == "string" || t == null ? t : e(t);
}
function JL(e, t) {
  return (n) => e.reduce((o, s) => (o[s] = Ai(t, n), o), {});
}
function e_(e, t, n, o) {
  if (!t.includes(n))
    return null;
  const s = QL(n), i = JL(s, o), a = e[n];
  return No(e, a, i);
}
function XO(e, t) {
  const n = hp(e.theme);
  return Object.keys(e).map((o) => e_(e, t, o, n)).reduce(wc, {});
}
function En(e) {
  return XO(e, fp);
}
En.propTypes = process.env.NODE_ENV !== "production" ? fp.reduce((e, t) => (e[t] = Zs, e), {}) : {};
En.filterProps = fp;
function In(e) {
  return XO(e, pp);
}
In.propTypes = process.env.NODE_ENV !== "production" ? pp.reduce((e, t) => (e[t] = Zs, e), {}) : {};
In.filterProps = pp;
process.env.NODE_ENV !== "production" && ZL.reduce((e, t) => (e[t] = Zs, e), {});
function QO(e = 8, t = hp({
  spacing: e
})) {
  if (e.mui)
    return e;
  const n = (...o) => (process.env.NODE_ENV !== "production" && (o.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${o.length}`)), (o.length === 0 ? [1] : o).map((i) => {
    const a = t(i);
    return typeof a == "number" ? `${a}px` : a;
  }).join(" "));
  return n.mui = !0, n;
}
function gp(...e) {
  const t = e.reduce((o, s) => (s.filterProps.forEach((i) => {
    o[i] = s;
  }), o), {}), n = (o) => Object.keys(o).reduce((s, i) => t[i] ? wc(s, t[i](o)) : s, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((o, s) => Object.assign(o, s.propTypes), {}) : {}, n.filterProps = e.reduce((o, s) => o.concat(s.filterProps), []), n;
}
function cr(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function yr(e, t) {
  return An({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const t_ = yr("border", cr), n_ = yr("borderTop", cr), o_ = yr("borderRight", cr), r_ = yr("borderBottom", cr), s_ = yr("borderLeft", cr), i_ = yr("borderColor"), a_ = yr("borderTopColor"), l_ = yr("borderRightColor"), c_ = yr("borderBottomColor"), u_ = yr("borderLeftColor"), d_ = yr("outline", cr), f_ = yr("outlineColor"), mp = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = pu(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (o) => ({
      borderRadius: Ai(t, o)
    });
    return No(e, e.borderRadius, n);
  }
  return null;
};
mp.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Zs
} : {};
mp.filterProps = ["borderRadius"];
gp(t_, n_, o_, r_, s_, i_, a_, l_, c_, u_, mp, d_, f_);
const bp = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = pu(e.theme, "spacing", 8, "gap"), n = (o) => ({
      gap: Ai(t, o)
    });
    return No(e, e.gap, n);
  }
  return null;
};
bp.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Zs
} : {};
bp.filterProps = ["gap"];
const yp = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = pu(e.theme, "spacing", 8, "columnGap"), n = (o) => ({
      columnGap: Ai(t, o)
    });
    return No(e, e.columnGap, n);
  }
  return null;
};
yp.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Zs
} : {};
yp.filterProps = ["columnGap"];
const vp = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = pu(e.theme, "spacing", 8, "rowGap"), n = (o) => ({
      rowGap: Ai(t, o)
    });
    return No(e, e.rowGap, n);
  }
  return null;
};
vp.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Zs
} : {};
vp.filterProps = ["rowGap"];
const p_ = An({
  prop: "gridColumn"
}), h_ = An({
  prop: "gridRow"
}), g_ = An({
  prop: "gridAutoFlow"
}), m_ = An({
  prop: "gridAutoColumns"
}), b_ = An({
  prop: "gridAutoRows"
}), y_ = An({
  prop: "gridTemplateColumns"
}), v_ = An({
  prop: "gridTemplateRows"
}), C_ = An({
  prop: "gridTemplateAreas"
}), w_ = An({
  prop: "gridArea"
});
gp(bp, yp, vp, p_, h_, g_, m_, b_, y_, v_, C_, w_);
function Ba(e, t) {
  return t === "grey" ? t : e;
}
const S_ = An({
  prop: "color",
  themeKey: "palette",
  transform: Ba
}), x_ = An({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: Ba
}), T_ = An({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: Ba
});
gp(S_, x_, T_);
function zo(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const R_ = An({
  prop: "width",
  transform: zo
}), Tv = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var s, i, a, l, c;
      const o = ((a = (i = (s = e.theme) == null ? void 0 : s.breakpoints) == null ? void 0 : i.values) == null ? void 0 : a[n]) || up[n];
      return o ? ((c = (l = e.theme) == null ? void 0 : l.breakpoints) == null ? void 0 : c.unit) !== "px" ? {
        maxWidth: `${o}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: o
      } : {
        maxWidth: zo(n)
      };
    };
    return No(e, e.maxWidth, t);
  }
  return null;
};
Tv.filterProps = ["maxWidth"];
const E_ = An({
  prop: "minWidth",
  transform: zo
}), I_ = An({
  prop: "height",
  transform: zo
}), O_ = An({
  prop: "maxHeight",
  transform: zo
}), P_ = An({
  prop: "minHeight",
  transform: zo
});
An({
  prop: "size",
  cssProperty: "width",
  transform: zo
});
An({
  prop: "size",
  cssProperty: "height",
  transform: zo
});
const M_ = An({
  prop: "boxSizing"
});
gp(R_, Tv, E_, I_, O_, P_, M_);
const hu = {
  // borders
  border: {
    themeKey: "borders",
    transform: cr
  },
  borderTop: {
    themeKey: "borders",
    transform: cr
  },
  borderRight: {
    themeKey: "borders",
    transform: cr
  },
  borderBottom: {
    themeKey: "borders",
    transform: cr
  },
  borderLeft: {
    themeKey: "borders",
    transform: cr
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: cr
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: mp
  },
  // palette
  color: {
    themeKey: "palette",
    transform: Ba
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: Ba
  },
  backgroundColor: {
    themeKey: "palette",
    transform: Ba
  },
  // spacing
  p: {
    style: In
  },
  pt: {
    style: In
  },
  pr: {
    style: In
  },
  pb: {
    style: In
  },
  pl: {
    style: In
  },
  px: {
    style: In
  },
  py: {
    style: In
  },
  padding: {
    style: In
  },
  paddingTop: {
    style: In
  },
  paddingRight: {
    style: In
  },
  paddingBottom: {
    style: In
  },
  paddingLeft: {
    style: In
  },
  paddingX: {
    style: In
  },
  paddingY: {
    style: In
  },
  paddingInline: {
    style: In
  },
  paddingInlineStart: {
    style: In
  },
  paddingInlineEnd: {
    style: In
  },
  paddingBlock: {
    style: In
  },
  paddingBlockStart: {
    style: In
  },
  paddingBlockEnd: {
    style: In
  },
  m: {
    style: En
  },
  mt: {
    style: En
  },
  mr: {
    style: En
  },
  mb: {
    style: En
  },
  ml: {
    style: En
  },
  mx: {
    style: En
  },
  my: {
    style: En
  },
  margin: {
    style: En
  },
  marginTop: {
    style: En
  },
  marginRight: {
    style: En
  },
  marginBottom: {
    style: En
  },
  marginLeft: {
    style: En
  },
  marginX: {
    style: En
  },
  marginY: {
    style: En
  },
  marginInline: {
    style: En
  },
  marginInlineStart: {
    style: En
  },
  marginInlineEnd: {
    style: En
  },
  marginBlock: {
    style: En
  },
  marginBlockStart: {
    style: En
  },
  marginBlockEnd: {
    style: En
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: bp
  },
  rowGap: {
    style: vp
  },
  columnGap: {
    style: yp
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: zo
  },
  maxWidth: {
    style: Tv
  },
  minWidth: {
    transform: zo
  },
  height: {
    transform: zo
  },
  maxHeight: {
    transform: zo
  },
  minHeight: {
    transform: zo
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function k_(...e) {
  const t = e.reduce((o, s) => o.concat(Object.keys(s)), []), n = new Set(t);
  return e.every((o) => n.size === Object.keys(o).length);
}
function D_(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function N_() {
  function e(n, o, s, i) {
    const a = {
      [n]: o,
      theme: s
    }, l = i[n];
    if (!l)
      return {
        [n]: o
      };
    const {
      cssProperty: c = n,
      themeKey: u,
      transform: d,
      style: f
    } = l;
    if (o == null)
      return null;
    if (u === "typography" && o === "inherit")
      return {
        [n]: o
      };
    const p = dp(s, u) || {};
    return f ? f(a) : No(a, o, (b) => {
      let v = bf(p, d, b);
      return b === v && typeof b == "string" && (v = bf(p, d, `${n}${b === "default" ? "" : ce(b)}`, b)), c === !1 ? v : {
        [c]: v
      };
    });
  }
  function t(n) {
    const {
      sx: o,
      theme: s = {}
    } = n || {};
    if (!o)
      return null;
    const i = s.unstable_sxConfig ?? hu;
    function a(l) {
      let c = l;
      if (typeof l == "function")
        c = l(s);
      else if (typeof l != "object")
        return l;
      if (!c)
        return null;
      const u = KO(s.breakpoints), d = Object.keys(u);
      let f = u;
      return Object.keys(c).forEach((p) => {
        const m = D_(c[p], s);
        if (m != null)
          if (typeof m == "object")
            if (i[p])
              f = wc(f, e(p, m, s, i));
            else {
              const b = No({
                theme: s
              }, m, (v) => ({
                [p]: v
              }));
              k_(b, m) ? f[p] = t({
                sx: m,
                theme: s
              }) : f = wc(f, b);
            }
          else
            f = wc(f, e(p, m, s, i));
      }), BL(s, YO(d, f));
    }
    return Array.isArray(o) ? o.map(a) : a(o);
  }
  return t;
}
const qs = N_();
qs.filterProps = ["sx"];
function $_(e, t) {
  var o;
  const n = this;
  if (n.vars) {
    if (!((o = n.colorSchemes) != null && o[e]) || typeof n.getColorSchemeSelector != "function")
      return {};
    let s = n.getColorSchemeSelector(e);
    return s === "&" ? t : ((s.includes("data-") || s.includes(".")) && (s = `*:where(${s.replace(/\s*&$/, "")}) &`), {
      [s]: t
    });
  }
  return n.palette.mode === e ? t : {};
}
function Cp(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: o = {},
    spacing: s,
    shape: i = {},
    ...a
  } = e, l = VL(n), c = QO(s);
  let u = Bn({
    breakpoints: l,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...o
    },
    spacing: c,
    shape: {
      ...GL,
      ...i
    }
  }, a);
  return u = jL(u), u.applyStyles = $_, u = t.reduce((d, f) => Bn(d, f), u), u.unstable_sxConfig = {
    ...hu,
    ...a == null ? void 0 : a.unstable_sxConfig
  }, u.unstable_sx = function(f) {
    return qs({
      sx: f,
      theme: this
    });
  }, u;
}
function A_(e) {
  return Object.keys(e).length === 0;
}
function Rv(e = null) {
  const t = h.useContext(fu);
  return !t || A_(t) ? e : t;
}
const F_ = Cp();
function wp(e = F_) {
  return Rv(e);
}
function ZO({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const o = wp(n), s = typeof e == "function" ? e(t && o[t] || o) : e;
  return /* @__PURE__ */ C(xv, {
    styles: s
  });
}
process.env.NODE_ENV !== "production" && (ZO.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: r.object,
  /**
   * @ignore
   */
  styles: r.oneOfType([r.array, r.func, r.number, r.object, r.string, r.bool]),
  /**
   * @ignore
   */
  themeId: r.string
});
const L_ = (e) => {
  var o;
  const t = {
    systemProps: {},
    otherProps: {}
  }, n = ((o = e == null ? void 0 : e.theme) == null ? void 0 : o.unstable_sxConfig) ?? hu;
  return Object.keys(e).forEach((s) => {
    n[s] ? t.systemProps[s] = e[s] : t.otherProps[s] = e[s];
  }), t;
};
function Sp(e) {
  const {
    sx: t,
    ...n
  } = e, {
    systemProps: o,
    otherProps: s
  } = L_(n);
  let i;
  return Array.isArray(t) ? i = [o, ...t] : typeof t == "function" ? i = (...a) => {
    const l = t(...a);
    return jr(l) ? {
      ...o,
      ...l
    } : o;
  } : i = {
    ...o,
    ...t
  }, {
    ...s,
    sx: i
  };
}
const _S = (e) => e, __ = () => {
  let e = _S;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = _S;
    }
  };
}, JO = __();
function eP(e) {
  var t, n, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var s = e.length;
    for (t = 0; t < s; t++) e[t] && (n = eP(e[t])) && (o && (o += " "), o += n);
  } else for (n in e) e[n] && (o && (o += " "), o += n);
  return o;
}
function ae() {
  for (var e, t, n = 0, o = "", s = arguments.length; n < s; n++) (e = arguments[n]) && (t = eP(e)) && (o && (o += " "), o += t);
  return o;
}
function V_(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: o = "MuiBox-root",
    generateClassName: s
  } = e, i = WO("div", {
    shouldForwardProp: (l) => l !== "theme" && l !== "sx" && l !== "as"
  })(qs);
  return /* @__PURE__ */ h.forwardRef(function(c, u) {
    const d = wp(n), {
      className: f,
      component: p = "div",
      ...m
    } = Sp(c);
    return /* @__PURE__ */ C(i, {
      as: p,
      ref: u,
      className: ae(f, s ? s(o) : o),
      theme: t && d[t] || d,
      ...m
    });
  });
}
const B_ = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function De(e, t, n = "Mui") {
  const o = B_[t];
  return o ? `${n}-${o}` : `${JO.generate(e)}-${t}`;
}
function Ne(e, t, n = "Mui") {
  const o = {};
  return t.forEach((s) => {
    o[s] = De(e, s, n);
  }), o;
}
var rd = { exports: {} }, Xt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var VS;
function z_() {
  if (VS) return Xt;
  VS = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), b;
  b = Symbol.for("react.module.reference");
  function v(g) {
    if (typeof g == "object" && g !== null) {
      var y = g.$$typeof;
      switch (y) {
        case e:
          switch (g = g.type, g) {
            case n:
            case s:
            case o:
            case u:
            case d:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case l:
                case a:
                case c:
                case p:
                case f:
                case i:
                  return g;
                default:
                  return y;
              }
          }
        case t:
          return y;
      }
    }
  }
  return Xt.ContextConsumer = a, Xt.ContextProvider = i, Xt.Element = e, Xt.ForwardRef = c, Xt.Fragment = n, Xt.Lazy = p, Xt.Memo = f, Xt.Portal = t, Xt.Profiler = s, Xt.StrictMode = o, Xt.Suspense = u, Xt.SuspenseList = d, Xt.isAsyncMode = function() {
    return !1;
  }, Xt.isConcurrentMode = function() {
    return !1;
  }, Xt.isContextConsumer = function(g) {
    return v(g) === a;
  }, Xt.isContextProvider = function(g) {
    return v(g) === i;
  }, Xt.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, Xt.isForwardRef = function(g) {
    return v(g) === c;
  }, Xt.isFragment = function(g) {
    return v(g) === n;
  }, Xt.isLazy = function(g) {
    return v(g) === p;
  }, Xt.isMemo = function(g) {
    return v(g) === f;
  }, Xt.isPortal = function(g) {
    return v(g) === t;
  }, Xt.isProfiler = function(g) {
    return v(g) === s;
  }, Xt.isStrictMode = function(g) {
    return v(g) === o;
  }, Xt.isSuspense = function(g) {
    return v(g) === u;
  }, Xt.isSuspenseList = function(g) {
    return v(g) === d;
  }, Xt.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === s || g === o || g === u || g === d || g === m || typeof g == "object" && g !== null && (g.$$typeof === p || g.$$typeof === f || g.$$typeof === i || g.$$typeof === a || g.$$typeof === c || g.$$typeof === b || g.getModuleId !== void 0);
  }, Xt.typeOf = v, Xt;
}
var Qt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var BS;
function H_() {
  return BS || (BS = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), b = !1, v = !1, g = !1, y = !1, w = !1, x;
    x = Symbol.for("react.module.reference");
    function S(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === n || X === s || w || X === o || X === u || X === d || y || X === m || b || v || g || typeof X == "object" && X !== null && (X.$$typeof === p || X.$$typeof === f || X.$$typeof === i || X.$$typeof === a || X.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === x || X.getModuleId !== void 0));
    }
    function T(X) {
      if (typeof X == "object" && X !== null) {
        var re = X.$$typeof;
        switch (re) {
          case e:
            var oe = X.type;
            switch (oe) {
              case n:
              case s:
              case o:
              case u:
              case d:
                return oe;
              default:
                var le = oe && oe.$$typeof;
                switch (le) {
                  case l:
                  case a:
                  case c:
                  case p:
                  case f:
                  case i:
                    return le;
                  default:
                    return re;
                }
            }
          case t:
            return re;
        }
      }
    }
    var E = a, O = i, M = e, D = c, R = n, P = p, F = f, $ = t, N = s, A = o, k = u, L = d, B = !1, V = !1;
    function _(X) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function z(X) {
      return V || (V = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(X) {
      return T(X) === a;
    }
    function W(X) {
      return T(X) === i;
    }
    function J(X) {
      return typeof X == "object" && X !== null && X.$$typeof === e;
    }
    function G(X) {
      return T(X) === c;
    }
    function q(X) {
      return T(X) === n;
    }
    function Z(X) {
      return T(X) === p;
    }
    function Y(X) {
      return T(X) === f;
    }
    function Q(X) {
      return T(X) === t;
    }
    function ee(X) {
      return T(X) === s;
    }
    function ne(X) {
      return T(X) === o;
    }
    function H(X) {
      return T(X) === u;
    }
    function U(X) {
      return T(X) === d;
    }
    Qt.ContextConsumer = E, Qt.ContextProvider = O, Qt.Element = M, Qt.ForwardRef = D, Qt.Fragment = R, Qt.Lazy = P, Qt.Memo = F, Qt.Portal = $, Qt.Profiler = N, Qt.StrictMode = A, Qt.Suspense = k, Qt.SuspenseList = L, Qt.isAsyncMode = _, Qt.isConcurrentMode = z, Qt.isContextConsumer = j, Qt.isContextProvider = W, Qt.isElement = J, Qt.isForwardRef = G, Qt.isFragment = q, Qt.isLazy = Z, Qt.isMemo = Y, Qt.isPortal = Q, Qt.isProfiler = ee, Qt.isStrictMode = ne, Qt.isSuspense = H, Qt.isSuspenseList = U, Qt.isValidElementType = S, Qt.typeOf = T;
  }()), Qt;
}
var zS;
function j_() {
  return zS || (zS = 1, process.env.NODE_ENV === "production" ? rd.exports = z_() : rd.exports = H_()), rd.exports;
}
var HS = j_();
function tP(e, t = "") {
  return e.displayName || e.name || t;
}
function jS(e, t, n) {
  const o = tP(t);
  return e.displayName || (o !== "" ? `${n}(${o})` : n);
}
function Oi(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return tP(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case HS.ForwardRef:
          return jS(e, e.render, "ForwardRef");
        case HS.Memo:
          return jS(e, e.type, "memo");
        default:
          return;
      }
  }
}
function nP(e) {
  const {
    variants: t,
    ...n
  } = e, o = {
    variants: t,
    style: AS(n),
    isProcessed: !0
  };
  return o.style === n || t && t.forEach((s) => {
    typeof s.style != "function" && (s.style = AS(s.style));
  }), o;
}
const G_ = Cp();
function Xd(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function q_(e) {
  return e ? (t, n) => n[e] : null;
}
function W_(e, t, n) {
  e.theme = Y_(e.theme) ? n : e.theme[t] || e.theme;
}
function Qd(e, t) {
  const n = typeof t == "function" ? t(e) : t;
  if (Array.isArray(n))
    return n.flatMap((o) => Qd(e, o));
  if (Array.isArray(n == null ? void 0 : n.variants)) {
    let o;
    if (n.isProcessed)
      o = n.style;
    else {
      const {
        variants: s,
        ...i
      } = n;
      o = i;
    }
    return oP(e, n.variants, [o]);
  }
  return n != null && n.isProcessed ? n.style : n;
}
function oP(e, t, n = []) {
  var s;
  let o;
  e: for (let i = 0; i < t.length; i += 1) {
    const a = t[i];
    if (typeof a.props == "function") {
      if (o ?? (o = {
        ...e,
        ...e.ownerState,
        ownerState: e.ownerState
      }), !a.props(o))
        continue;
    } else
      for (const l in a.props)
        if (e[l] !== a.props[l] && ((s = e.ownerState) == null ? void 0 : s[l]) !== a.props[l])
          continue e;
    typeof a.style == "function" ? (o ?? (o = {
      ...e,
      ...e.ownerState,
      ownerState: e.ownerState
    }), n.push(a.style(o))) : n.push(a.style);
  }
  return n;
}
function rP(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = G_,
    rootShouldForwardProp: o = Xd,
    slotShouldForwardProp: s = Xd
  } = e;
  function i(l) {
    W_(l, t, n);
  }
  return (l, c = {}) => {
    LL(l, (T) => T.filter((E) => E !== qs));
    const {
      name: u,
      slot: d,
      skipVariantsResolver: f,
      skipSx: p,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: m = q_(sP(d)),
      ...b
    } = c, v = f !== void 0 ? f : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      d && d !== "Root" && d !== "root" || !1
    ), g = p || !1;
    let y = Xd;
    d === "Root" || d === "root" ? y = o : d ? y = s : X_(l) && (y = void 0);
    const w = WO(l, {
      shouldForwardProp: y,
      label: K_(u, d),
      ...b
    }), x = (T) => {
      if (typeof T == "function" && T.__emotion_real !== T)
        return function(O) {
          return Qd(O, T);
        };
      if (jr(T)) {
        const E = nP(T);
        return E.variants ? function(M) {
          return Qd(M, E);
        } : E.style;
      }
      return T;
    }, S = (...T) => {
      const E = [], O = T.map(x), M = [];
      if (E.push(i), u && m && M.push(function(F) {
        var k, L;
        const N = (L = (k = F.theme.components) == null ? void 0 : k[u]) == null ? void 0 : L.styleOverrides;
        if (!N)
          return null;
        const A = {};
        for (const B in N)
          A[B] = Qd(F, N[B]);
        return m(F, A);
      }), u && !v && M.push(function(F) {
        var A, k;
        const $ = F.theme, N = (k = (A = $ == null ? void 0 : $.components) == null ? void 0 : A[u]) == null ? void 0 : k.variants;
        return N ? oP(F, N) : null;
      }), g || M.push(qs), Array.isArray(O[0])) {
        const P = O.shift(), F = new Array(E.length).fill(""), $ = new Array(M.length).fill("");
        let N;
        N = [...F, ...P, ...$], N.raw = [...F, ...P.raw, ...$], E.unshift(N);
      }
      const D = [...E, ...O, ...M], R = w(...D);
      return l.muiName && (R.muiName = l.muiName), process.env.NODE_ENV !== "production" && (R.displayName = U_(u, d, l)), R;
    };
    return w.withConfig && (S.withConfig = w.withConfig), S;
  };
}
function U_(e, t, n) {
  return e ? `${e}${ce(t || "")}` : `Styled(${Oi(n)})`;
}
function K_(e, t) {
  let n;
  return process.env.NODE_ENV !== "production" && e && (n = `${e}-${sP(t || "Root")}`), n;
}
function Y_(e) {
  for (const t in e)
    return !1;
  return !0;
}
function X_(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function sP(e) {
  return e && e.charAt(0).toLowerCase() + e.slice(1);
}
const tn = rP();
function Fi(e, t) {
  const n = {
    ...t
  };
  for (const o in e)
    if (Object.prototype.hasOwnProperty.call(e, o)) {
      const s = o;
      if (s === "components" || s === "slots")
        n[s] = {
          ...e[s],
          ...n[s]
        };
      else if (s === "componentsProps" || s === "slotProps") {
        const i = e[s], a = t[s];
        if (!a)
          n[s] = i || {};
        else if (!i)
          n[s] = a;
        else {
          n[s] = {
            ...a
          };
          for (const l in i)
            if (Object.prototype.hasOwnProperty.call(i, l)) {
              const c = l;
              n[s][c] = Fi(i[c], a[c]);
            }
        }
      } else n[s] === void 0 && (n[s] = e[s]);
    }
  return n;
}
function iP(e) {
  const {
    theme: t,
    name: n,
    props: o
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? o : Fi(t.components[n].defaultProps, o);
}
function aP({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: o
}) {
  let s = wp(n);
  return o && (s = s[o] || s), iP({
    theme: s,
    name: t,
    props: e
  });
}
const yt = typeof window < "u" ? h.useLayoutEffect : h.useEffect;
function Q_(e, t, n, o, s) {
  const [i, a] = h.useState(() => s && n ? n(e).matches : o ? o(e).matches : t);
  return yt(() => {
    if (!n)
      return;
    const l = n(e), c = () => {
      a(l.matches);
    };
    return c(), l.addEventListener("change", c), () => {
      l.removeEventListener("change", c);
    };
  }, [e, n]), i;
}
const Z_ = {
  ...h
}, lP = Z_.useSyncExternalStore;
function J_(e, t, n, o, s) {
  const i = h.useCallback(() => t, [t]), a = h.useMemo(() => {
    if (s && n)
      return () => n(e).matches;
    if (o !== null) {
      const {
        matches: d
      } = o(e);
      return () => d;
    }
    return i;
  }, [i, e, o, s, n]), [l, c] = h.useMemo(() => {
    if (n === null)
      return [i, () => () => {
      }];
    const d = n(e);
    return [() => d.matches, (f) => (d.addEventListener("change", f), () => {
      d.removeEventListener("change", f);
    })];
  }, [i, n, e]);
  return lP(c, l, a);
}
function cP(e = {}) {
  const {
    themeId: t
  } = e;
  return function(o, s = {}) {
    let i = Rv();
    i && t && (i = i[t] || i);
    const a = typeof window < "u" && typeof window.matchMedia < "u", {
      defaultMatches: l = !1,
      matchMedia: c = a ? window.matchMedia : null,
      ssrMatchMedia: u = null,
      noSsr: d = !1
    } = iP({
      name: "MuiUseMediaQuery",
      props: s,
      theme: i
    });
    process.env.NODE_ENV !== "production" && typeof o == "function" && i === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
    let f = typeof o == "function" ? o(i) : o;
    f = f.replace(/^@media( ?)/m, "");
    const m = (lP !== void 0 ? J_ : Q_)(f, l, c, u, d);
    return process.env.NODE_ENV !== "production" && h.useDebugValue({
      query: f,
      match: m
    }), m;
  };
}
cP();
function Si(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
function Ev(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), Si(e, t, n);
}
function eV(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((o) => o + o)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((o, s) => s < 3 ? parseInt(o, 16) : Math.round(parseInt(o, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function tV(e) {
  const t = e.toString(16);
  return t.length === 1 ? `0${t}` : t;
}
function Mr(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Mr(eV(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(n))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : Zr(9, e));
  let o = e.substring(t + 1, e.length - 1), s;
  if (n === "color") {
    if (o = o.split(" "), s = o.shift(), o.length === 4 && o[3].charAt(0) === "/" && (o[3] = o[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(s))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${s}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : Zr(10, s));
  } else
    o = o.split(",");
  return o = o.map((i) => parseFloat(i)), {
    type: n,
    values: o,
    colorSpace: s
  };
}
const nV = (e) => {
  const t = Mr(e);
  return t.values.slice(0, 3).map((n, o) => t.type.includes("hsl") && o !== 0 ? `${n}%` : n).join(" ");
}, ic = (e, t) => {
  try {
    return nV(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
function gu(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: o
  } = e;
  return t.includes("rgb") ? o = o.map((s, i) => i < 3 ? parseInt(s, 10) : s) : t.includes("hsl") && (o[1] = `${o[1]}%`, o[2] = `${o[2]}%`), t.includes("color") ? o = `${n} ${o.join(" ")}` : o = `${o.join(", ")}`, `${t}(${o})`;
}
function Bbe(e) {
  if (e.startsWith("#"))
    return e;
  const {
    values: t
  } = Mr(e);
  return `#${t.map((n, o) => tV(o === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function uP(e) {
  e = Mr(e);
  const {
    values: t
  } = e, n = t[0], o = t[1] / 100, s = t[2] / 100, i = o * Math.min(s, 1 - s), a = (u, d = (u + n / 30) % 12) => s - i * Math.max(Math.min(d - 3, 9 - d, 1), -1);
  let l = "rgb";
  const c = [Math.round(a(0) * 255), Math.round(a(8) * 255), Math.round(a(4) * 255)];
  return e.type === "hsla" && (l += "a", c.push(t[3])), gu({
    type: l,
    values: c
  });
}
function yf(e) {
  e = Mr(e);
  let t = e.type === "hsl" || e.type === "hsla" ? Mr(uP(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function GS(e, t) {
  const n = yf(e), o = yf(t);
  return (Math.max(n, o) + 0.05) / (Math.min(n, o) + 0.05);
}
function he(e, t) {
  return e = Mr(e), t = Ev(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, gu(e);
}
function sd(e, t, n) {
  try {
    return he(e, t);
  } catch {
    return e;
  }
}
function $o(e, t) {
  if (e = Mr(e), t = Ev(t), e.type.includes("hsl"))
    e.values[2] *= 1 - t;
  else if (e.type.includes("rgb") || e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return gu(e);
}
function cn(e, t, n) {
  try {
    return $o(e, t);
  } catch {
    return e;
  }
}
function wo(e, t) {
  if (e = Mr(e), t = Ev(t), e.type.includes("hsl"))
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.includes("rgb"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.includes("color"))
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return gu(e);
}
function un(e, t, n) {
  try {
    return wo(e, t);
  } catch {
    return e;
  }
}
function vf(e, t = 0.15) {
  return yf(e) > 0.5 ? $o(e, t) : wo(e, t);
}
function id(e, t, n) {
  try {
    return vf(e, t);
  } catch {
    return e;
  }
}
function Gn(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...o) {
    return e(...o) || t(...o);
  };
}
function oV(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function dP(e, t, n, o, s) {
  const i = e[t], a = s || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  const c = i.type;
  return typeof c == "function" && !oV(c) && (l = "Did you accidentally use a plain function component for an element instead?"), l !== void 0 ? new Error(`Invalid ${o} \`${a}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const Ts = Gn(r.element, dP);
Ts.isRequired = Gn(r.element.isRequired, dP);
function rV(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function sV(e, t, n, o, s) {
  const i = e[t], a = s || t;
  if (i == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let l;
  return typeof i == "function" && !rV(i) && (l = "Did you accidentally provide a plain function component instead?"), l !== void 0 ? new Error(`Invalid ${o} \`${a}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${l} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const mu = Gn(r.elementType, sV), iV = "exact-prop: ​";
function hl(e) {
  return process.env.NODE_ENV === "production" ? e : {
    ...e,
    [iV]: (t) => {
      const n = Object.keys(t).filter((o) => !e.hasOwnProperty(o));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((o) => `\`${o}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function Ko(e, t, n, o, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = e[t], a = s || t;
  return i == null ? null : i && i.nodeType !== 1 ? new Error(`Invalid ${o} \`${a}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const Kb = typeof window < "u" && window.Math == Math ? window : typeof self < "u" && self.Math == Math ? self : Function("return this")(), Lt = r.oneOfType([r.func, r.object]);
function Yb(...e) {
  return e.reduce((t, n) => n == null ? t : function(...s) {
    t.apply(this, s), n.apply(this, s);
  }, () => {
  });
}
function Yi(e, t = 166) {
  let n;
  function o(...s) {
    const i = () => {
      e.apply(this, s);
    };
    clearTimeout(n), n = setTimeout(i, t);
  }
  return o.clear = () => {
    clearTimeout(n);
  }, o;
}
function Sc(e, t) {
  var n, o, s;
  return /* @__PURE__ */ h.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    e.type.muiName ?? ((s = (o = (n = e.type) == null ? void 0 : n._payload) == null ? void 0 : o.value) == null ? void 0 : s.muiName)
  ) !== -1;
}
function qt(e) {
  return e && e.ownerDocument || document;
}
function Ao(e) {
  return qt(e).defaultView || window;
}
function aV(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = t ? {
    ...t.propTypes
  } : null;
  return (s) => (i, a, l, c, u, ...d) => {
    const f = u || a, p = n == null ? void 0 : n[f];
    if (p) {
      const m = p(i, a, l, c, u, ...d);
      if (m)
        return m;
    }
    return typeof i[a] < "u" && !i[s] ? new Error(`The prop \`${f}\` of \`${e}\` can only be used together with the \`${s}\` prop.`) : null;
  };
}
function Cf(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let qS = 0;
function lV(e) {
  const [t, n] = h.useState(e), o = e || t;
  return h.useEffect(() => {
    t == null && (qS += 1, n(`mui-${qS}`));
  }, [t]), o;
}
const cV = {
  ...h
}, WS = cV.useId;
function gt(e) {
  if (WS !== void 0) {
    const t = WS();
    return e ?? t;
  }
  return lV(e);
}
function fP(e, t, n, o, s) {
  if (process.env.NODE_ENV === "production")
    return null;
  const i = s || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${i}\` is not supported. Please remove it.`) : null;
}
function jn({
  controlled: e,
  default: t,
  name: n,
  state: o = "value"
}) {
  const {
    current: s
  } = h.useRef(e !== void 0), [i, a] = h.useState(t), l = s ? e : i;
  if (process.env.NODE_ENV !== "production") {
    h.useEffect(() => {
      s !== (e !== void 0) && console.error([`MUI: A component is changing the ${s ? "" : "un"}controlled ${o} state of ${n} to be ${s ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, e]);
    const {
      current: u
    } = h.useRef(t);
    h.useEffect(() => {
      !s && !Object.is(u, t) && console.error([`MUI: A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const c = h.useCallback((u) => {
    s || a(u);
  }, []);
  return [l, c];
}
function xe(e) {
  const t = h.useRef(e);
  return yt(() => {
    t.current = e;
  }), h.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function tt(...e) {
  return h.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      Cf(n, t);
    });
  }, e);
}
const US = {};
function Jo(e, t) {
  const n = h.useRef(US);
  return n.current === US && (n.current = e(t)), n;
}
const uV = [];
function Iv(e) {
  h.useEffect(e, uV);
}
class xp {
  constructor() {
    Al(this, "currentId", null);
    Al(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    Al(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new xp();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function go() {
  const e = Jo(xp.create).current;
  return Iv(e.disposeEffect), e;
}
function Ws(e) {
  try {
    return e.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
function pP(e = window) {
  const t = e.document.documentElement.clientWidth;
  return e.innerWidth - t;
}
const Ov = (e) => {
  const t = h.useRef({});
  return h.useEffect(() => {
    t.current = e;
  }), t.current;
};
function dV(e) {
  return h.Children.toArray(e).filter((t) => /* @__PURE__ */ h.isValidElement(t));
}
const Pv = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function fV(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function hP(e, t, n, o) {
  const s = e[t];
  if (s == null || !Number.isInteger(s)) {
    const i = fV(s);
    return new RangeError(`Invalid ${o} \`${t}\` of type \`${i}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function gP(e, t, ...n) {
  return e[t] === void 0 ? null : hP(e, t, ...n);
}
function Xb() {
  return null;
}
gP.isRequired = hP;
Xb.isRequired = Xb;
const Wr = process.env.NODE_ENV === "production" ? Xb : gP;
function fe(e, t, n = void 0) {
  const o = {};
  for (const s in e) {
    const i = e[s];
    let a = "", l = !0;
    for (let c = 0; c < i.length; c += 1) {
      const u = i[c];
      u && (a += (l === !0 ? "" : " ") + t(u), l = !1, n && n[u] && (a += " " + n[u]));
    }
    o[s] = a;
  }
  return o;
}
function pV(e) {
  return typeof e == "string";
}
function mP(e, t, n) {
  return e === void 0 || pV(e) ? t : {
    ...t,
    ownerState: {
      ...t.ownerState,
      ...n
    }
  };
}
function Pi(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((o) => o.match(/^on[A-Z]/) && typeof e[o] == "function" && !t.includes(o)).forEach((o) => {
    n[o] = e[o];
  }), n;
}
function KS(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function bP(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: o,
    externalForwardedProps: s,
    className: i
  } = e;
  if (!t) {
    const m = ae(n == null ? void 0 : n.className, i, s == null ? void 0 : s.className, o == null ? void 0 : o.className), b = {
      ...n == null ? void 0 : n.style,
      ...s == null ? void 0 : s.style,
      ...o == null ? void 0 : o.style
    }, v = {
      ...n,
      ...s,
      ...o
    };
    return m.length > 0 && (v.className = m), Object.keys(b).length > 0 && (v.style = b), {
      props: v,
      internalRef: void 0
    };
  }
  const a = Pi({
    ...s,
    ...o
  }), l = KS(o), c = KS(s), u = t(a), d = ae(u == null ? void 0 : u.className, n == null ? void 0 : n.className, i, s == null ? void 0 : s.className, o == null ? void 0 : o.className), f = {
    ...u == null ? void 0 : u.style,
    ...n == null ? void 0 : n.style,
    ...s == null ? void 0 : s.style,
    ...o == null ? void 0 : o.style
  }, p = {
    ...u,
    ...n,
    ...c,
    ...l
  };
  return d.length > 0 && (p.className = d), Object.keys(f).length > 0 && (p.style = f), {
    props: p,
    internalRef: u.ref
  };
}
function Ur(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function et(e) {
  var f;
  const {
    elementType: t,
    externalSlotProps: n,
    ownerState: o,
    skipResolvingSlotProps: s = !1,
    ...i
  } = e, a = s ? {} : Ur(n, o), {
    props: l,
    internalRef: c
  } = bP({
    ...i,
    externalSlotProps: a
  }), u = tt(c, a == null ? void 0 : a.ref, (f = e.additionalProps) == null ? void 0 : f.ref);
  return mP(t, {
    ...l,
    ref: u
  }, o);
}
function Rs(e) {
  var t;
  return parseInt(h.version, 10) >= 19 ? ((t = e == null ? void 0 : e.props) == null ? void 0 : t.ref) || null : (e == null ? void 0 : e.ref) || null;
}
const Mv = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (Mv.displayName = "ThemeContext");
function Tp() {
  const e = h.useContext(Mv);
  return process.env.NODE_ENV !== "production" && h.useDebugValue(e), e;
}
const hV = typeof Symbol == "function" && Symbol.for, yP = hV ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function gV(e, t) {
  if (typeof t == "function") {
    const n = t(e);
    return process.env.NODE_ENV !== "production" && (n || console.error(["MUI: You should return an object from your theme function, i.e.", "<ThemeProvider theme={() => ({})} />"].join(`
`))), n;
  }
  return {
    ...e,
    ...t
  };
}
function wf(e) {
  const {
    children: t,
    theme: n
  } = e, o = Tp();
  process.env.NODE_ENV !== "production" && o === null && typeof n == "function" && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const s = h.useMemo(() => {
    const i = o === null ? {
      ...n
    } : gV(o, n);
    return i != null && (i[yP] = o !== null), i;
  }, [n, o]);
  return /* @__PURE__ */ C(Mv.Provider, {
    value: s,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (wf.propTypes = {
  /**
   * Your component tree.
   */
  children: r.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: r.oneOfType([r.object, r.func]).isRequired
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (wf.propTypes = hl(wf.propTypes));
const vP = /* @__PURE__ */ h.createContext();
function CP({
  value: e,
  ...t
}) {
  return /* @__PURE__ */ C(vP.Provider, {
    value: e ?? !0,
    ...t
  });
}
process.env.NODE_ENV !== "production" && (CP.propTypes = {
  children: r.node,
  value: r.bool
});
const _t = () => h.useContext(vP) ?? !1, wP = /* @__PURE__ */ h.createContext(void 0);
function SP({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ C(wP.Provider, {
    value: e,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (SP.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: r.node,
  /**
   * @ignore
   */
  value: r.object
});
function mV(e) {
  const {
    theme: t,
    name: n,
    props: o
  } = e;
  if (!t || !t.components || !t.components[n])
    return o;
  const s = t.components[n];
  return s.defaultProps ? Fi(s.defaultProps, o) : !s.styleOverrides && !s.variants ? Fi(s, o) : o;
}
function bV({
  props: e,
  name: t
}) {
  const n = h.useContext(wP);
  return mV({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const YS = {};
function XS(e, t, n, o = !1) {
  return h.useMemo(() => {
    const s = e && t[e] || t;
    if (typeof n == "function") {
      const i = n(s), a = e ? {
        ...t,
        [e]: i
      } : i;
      return o ? () => a : a;
    }
    return e ? {
      ...t,
      [e]: n
    } : {
      ...t,
      ...n
    };
  }, [e, t, n, o]);
}
function _c(e) {
  const {
    children: t,
    theme: n,
    themeId: o
  } = e, s = Rv(YS), i = Tp() || YS;
  process.env.NODE_ENV !== "production" && (s === null && typeof n == "function" || o && s && !s[o] && typeof n == "function") && console.error(["MUI: You are providing a theme function prop to the ThemeProvider component:", "<ThemeProvider theme={outerTheme => outerTheme} />", "", "However, no outer theme is present.", "Make sure a theme is already injected higher in the React tree or provide a theme object."].join(`
`));
  const a = XS(o, s, n), l = XS(o, i, n, !0), c = (o ? a[o] : a).direction === "rtl";
  return /* @__PURE__ */ C(wf, {
    theme: l,
    children: /* @__PURE__ */ C(fu.Provider, {
      value: a,
      children: /* @__PURE__ */ C(CP, {
        value: c,
        children: /* @__PURE__ */ C(SP, {
          value: o ? a[o].components : a.components,
          children: t
        })
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (_c.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Your component tree.
   */
  children: r.node,
  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: r.oneOfType([r.func, r.object]).isRequired,
  /**
   * The design system's unique id for getting the corresponded theme when there are multiple design systems.
   */
  themeId: r.string
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (_c.propTypes = hl(_c.propTypes));
const QS = {
  theme: void 0
};
function yV(e) {
  let t, n;
  return function(s) {
    let i = t;
    return (i === void 0 || s.theme !== n) && (QS.theme = s.theme, i = nP(e(QS)), t = i, n = s.theme), i;
  };
}
const kv = "mode", Dv = "color-scheme", vV = "data-color-scheme";
function CV(e) {
  const {
    defaultMode: t = "system",
    defaultLightColorScheme: n = "light",
    defaultDarkColorScheme: o = "dark",
    modeStorageKey: s = kv,
    colorSchemeStorageKey: i = Dv,
    attribute: a = vV,
    colorSchemeNode: l = "document.documentElement",
    nonce: c
  } = e || {};
  let u = "", d = a;
  if (a === "class" && (d = ".%s"), a === "data" && (d = "[data-%s]"), d.startsWith(".")) {
    const p = d.substring(1);
    u += `${l}.classList.remove('${p}'.replace('%s', light), '${p}'.replace('%s', dark));
      ${l}.classList.add('${p}'.replace('%s', colorScheme));`;
  }
  const f = d.match(/\[([^\]]+)\]/);
  if (f) {
    const [p, m] = f[1].split("=");
    m || (u += `${l}.removeAttribute('${p}'.replace('%s', light));
      ${l}.removeAttribute('${p}'.replace('%s', dark));`), u += `
      ${l}.setAttribute('${p}'.replace('%s', colorScheme), ${m ? `${m}.replace('%s', colorScheme)` : '""'});`;
  } else
    u += `${l}.setAttribute('${d}', colorScheme);`;
  return /* @__PURE__ */ C("script", {
    suppressHydrationWarning: !0,
    nonce: typeof window > "u" ? c : "",
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${s}') || '${t}';
  const dark = localStorage.getItem('${i}-dark') || '${o}';
  const light = localStorage.getItem('${i}-light') || '${n}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${u}
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function ZS(e) {
  if (typeof window < "u" && typeof window.matchMedia == "function" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function xP(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function wV(e) {
  return xP(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function $h(e, t) {
  if (typeof window > "u")
    return;
  let n;
  try {
    n = localStorage.getItem(e) || void 0, n || localStorage.setItem(e, t);
  } catch {
  }
  return n || t;
}
function SV(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: n,
    defaultDarkColorScheme: o,
    supportedColorSchemes: s = [],
    modeStorageKey: i = kv,
    colorSchemeStorageKey: a = Dv,
    storageWindow: l = typeof window > "u" ? void 0 : window,
    noSsr: c = !1
  } = e, u = s.join(","), d = s.length > 1, [f, p] = h.useState(() => {
    const S = $h(i, t), T = $h(`${a}-light`, n), E = $h(`${a}-dark`, o);
    return {
      mode: S,
      systemMode: ZS(S),
      lightColorScheme: T,
      darkColorScheme: E
    };
  }), [m, b] = h.useState(c || !d);
  h.useEffect(() => {
    b(!0);
  }, []);
  const v = wV(f), g = h.useCallback((S) => {
    p((T) => {
      if (S === T.mode)
        return T;
      const E = S ?? t;
      try {
        localStorage.setItem(i, E);
      } catch {
      }
      return {
        ...T,
        mode: E,
        systemMode: ZS(E)
      };
    });
  }, [i, t]), y = h.useCallback((S) => {
    S ? typeof S == "string" ? S && !u.includes(S) ? console.error(`\`${S}\` does not exist in \`theme.colorSchemes\`.`) : p((T) => {
      const E = {
        ...T
      };
      return xP(T, (O) => {
        try {
          localStorage.setItem(`${a}-${O}`, S);
        } catch {
        }
        O === "light" && (E.lightColorScheme = S), O === "dark" && (E.darkColorScheme = S);
      }), E;
    }) : p((T) => {
      const E = {
        ...T
      }, O = S.light === null ? n : S.light, M = S.dark === null ? o : S.dark;
      if (O)
        if (!u.includes(O))
          console.error(`\`${O}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          E.lightColorScheme = O;
          try {
            localStorage.setItem(`${a}-light`, O);
          } catch {
          }
        }
      if (M)
        if (!u.includes(M))
          console.error(`\`${M}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          E.darkColorScheme = M;
          try {
            localStorage.setItem(`${a}-dark`, M);
          } catch {
          }
        }
      return E;
    }) : p((T) => {
      try {
        localStorage.setItem(`${a}-light`, n), localStorage.setItem(`${a}-dark`, o);
      } catch {
      }
      return {
        ...T,
        lightColorScheme: n,
        darkColorScheme: o
      };
    });
  }, [u, a, n, o]), w = h.useCallback((S) => {
    f.mode === "system" && p((T) => {
      const E = S != null && S.matches ? "dark" : "light";
      return T.systemMode === E ? T : {
        ...T,
        systemMode: E
      };
    });
  }, [f.mode]), x = h.useRef(w);
  return x.current = w, h.useEffect(() => {
    if (typeof window.matchMedia != "function" || !d)
      return;
    const S = (...E) => x.current(...E), T = window.matchMedia("(prefers-color-scheme: dark)");
    return T.addListener(S), S(T), () => {
      T.removeListener(S);
    };
  }, [d]), h.useEffect(() => {
    if (l && d) {
      const S = (T) => {
        const E = T.newValue;
        typeof T.key == "string" && T.key.startsWith(a) && (!E || u.match(E)) && (T.key.endsWith("light") && y({
          light: E
        }), T.key.endsWith("dark") && y({
          dark: E
        })), T.key === i && (!E || ["light", "dark", "system"].includes(E)) && g(E || t);
      };
      return l.addEventListener("storage", S), () => {
        l.removeEventListener("storage", S);
      };
    }
  }, [y, g, i, a, u, t, l, d]), {
    ...f,
    mode: m ? f.mode : void 0,
    systemMode: m ? f.systemMode : void 0,
    colorScheme: m ? v : void 0,
    setMode: g,
    setColorScheme: y
  };
}
const xV = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function TV(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: n = {},
    modeStorageKey: o = kv,
    colorSchemeStorageKey: s = Dv,
    disableTransitionOnChange: i = !1,
    defaultColorScheme: a,
    resolveTheme: l
  } = e, c = {
    allColorSchemes: [],
    colorScheme: void 0,
    darkColorScheme: void 0,
    lightColorScheme: void 0,
    mode: void 0,
    setColorScheme: () => {
    },
    setMode: () => {
    },
    systemMode: void 0
  }, u = /* @__PURE__ */ h.createContext(void 0);
  process.env.NODE_ENV !== "production" && (u.displayName = "ColorSchemeContext");
  const d = () => h.useContext(u) || c, f = {}, p = {};
  function m(y) {
    var ue, de, Pe, ke;
    const {
      children: w,
      theme: x,
      modeStorageKey: S = o,
      colorSchemeStorageKey: T = s,
      disableTransitionOnChange: E = i,
      storageWindow: O = typeof window > "u" ? void 0 : window,
      documentNode: M = typeof document > "u" ? void 0 : document,
      colorSchemeNode: D = typeof document > "u" ? void 0 : document.documentElement,
      disableNestedContext: R = !1,
      disableStyleSheetGeneration: P = !1,
      defaultMode: F = "system",
      noSsr: $
    } = y, N = h.useRef(!1), A = Tp(), k = h.useContext(u), L = !!k && !R, B = h.useMemo(() => x || (typeof n == "function" ? n() : n), [x]), V = B[t], _ = V || B, {
      colorSchemes: z = f,
      components: j = p,
      cssVarPrefix: W
    } = _, J = Object.keys(z).filter((Me) => !!z[Me]).join(","), G = h.useMemo(() => J.split(","), [J]), q = typeof a == "string" ? a : a.light, Z = typeof a == "string" ? a : a.dark, Y = z[q] && z[Z] ? F : ((de = (ue = z[_.defaultColorScheme]) == null ? void 0 : ue.palette) == null ? void 0 : de.mode) || ((Pe = _.palette) == null ? void 0 : Pe.mode), {
      mode: Q,
      setMode: ee,
      systemMode: ne,
      lightColorScheme: H,
      darkColorScheme: U,
      colorScheme: X,
      setColorScheme: re
    } = SV({
      supportedColorSchemes: G,
      defaultLightColorScheme: q,
      defaultDarkColorScheme: Z,
      modeStorageKey: S,
      colorSchemeStorageKey: T,
      defaultMode: Y,
      storageWindow: O,
      noSsr: $
    });
    let oe = Q, le = X;
    L && (oe = k.mode, le = k.colorScheme);
    const se = h.useMemo(() => {
      var Ae;
      const Me = le || _.defaultColorScheme, be = ((Ae = _.generateThemeVars) == null ? void 0 : Ae.call(_)) || _.vars, me = {
        ..._,
        components: j,
        colorSchemes: z,
        cssVarPrefix: W,
        vars: be
      };
      if (typeof me.generateSpacing == "function" && (me.spacing = me.generateSpacing()), Me) {
        const ye = z[Me];
        ye && typeof ye == "object" && Object.keys(ye).forEach((We) => {
          ye[We] && typeof ye[We] == "object" ? me[We] = {
            ...me[We],
            ...ye[We]
          } : me[We] = ye[We];
        });
      }
      return l ? l(me) : me;
    }, [_, le, j, z, W]), Ce = _.colorSchemeSelector;
    h.useEffect(() => {
      if (le && D && Ce && Ce !== "media") {
        const Me = Ce;
        let be = Ce;
        if (Me === "class" && (be = ".%s"), Me === "data" && (be = "[data-%s]"), Me != null && Me.startsWith("data-") && !Me.includes("%s") && (be = `[${Me}="%s"]`), be.startsWith("."))
          D.classList.remove(...G.map((me) => be.substring(1).replace("%s", me))), D.classList.add(be.substring(1).replace("%s", le));
        else {
          const me = be.replace("%s", le).match(/\[([^\]]+)\]/);
          if (me) {
            const [Ae, ye] = me[1].split("=");
            ye || G.forEach((We) => {
              D.removeAttribute(Ae.replace(le, We));
            }), D.setAttribute(Ae, ye ? ye.replace(/"|'/g, "") : "");
          } else
            D.setAttribute(be, le);
        }
      }
    }, [le, Ce, D, G]), h.useEffect(() => {
      let Me;
      if (E && N.current && M) {
        const be = M.createElement("style");
        be.appendChild(M.createTextNode(xV)), M.head.appendChild(be), window.getComputedStyle(M.body), Me = setTimeout(() => {
          M.head.removeChild(be);
        }, 1);
      }
      return () => {
        clearTimeout(Me);
      };
    }, [le, E, M]), h.useEffect(() => (N.current = !0, () => {
      N.current = !1;
    }), []);
    const $e = h.useMemo(() => ({
      allColorSchemes: G,
      colorScheme: le,
      darkColorScheme: U,
      lightColorScheme: H,
      mode: oe,
      setColorScheme: re,
      setMode: process.env.NODE_ENV === "production" ? ee : (Me) => {
        se.colorSchemeSelector === "media" && console.error(["MUI: The `setMode` function has no effect if `colorSchemeSelector` is `media` (`media` is the default value).", "To toggle the mode manually, please configure `colorSchemeSelector` to use a class or data attribute.", "To learn more, visit https://mui.com/material-ui/customization/css-theme-variables/configuration/#toggling-dark-mode-manually"].join(`
`)), ee(Me);
      },
      systemMode: ne
    }), [G, le, U, H, oe, re, ee, ne, se.colorSchemeSelector]);
    let we = !0;
    (P || _.cssVariables === !1 || L && (A == null ? void 0 : A.cssVarPrefix) === W) && (we = !1);
    const Te = /* @__PURE__ */ ie(h.Fragment, {
      children: [/* @__PURE__ */ C(_c, {
        themeId: V ? t : void 0,
        theme: se,
        children: w
      }), we && /* @__PURE__ */ C(xv, {
        styles: ((ke = se.generateStyleSheets) == null ? void 0 : ke.call(se)) || []
      })]
    });
    return L ? Te : /* @__PURE__ */ C(u.Provider, {
      value: $e,
      children: Te
    });
  }
  process.env.NODE_ENV !== "production" && (m.propTypes = {
    /**
     * The component tree.
     */
    children: r.node,
    /**
     * The node used to attach the color-scheme attribute
     */
    colorSchemeNode: r.any,
    /**
     * localStorage key used to store `colorScheme`
     */
    colorSchemeStorageKey: r.string,
    /**
     * The default mode when the storage is empty,
     * require the theme to have `colorSchemes` with light and dark.
     */
    defaultMode: r.string,
    /**
     * If `true`, the provider creates its own context and generate stylesheet as if it is a root `CssVarsProvider`.
     */
    disableNestedContext: r.bool,
    /**
     * If `true`, the style sheet won't be generated.
     *
     * This is useful for controlling nested CssVarsProvider behavior.
     */
    disableStyleSheetGeneration: r.bool,
    /**
     * Disable CSS transitions when switching between modes or color schemes.
     */
    disableTransitionOnChange: r.bool,
    /**
     * The document to attach the attribute to.
     */
    documentNode: r.any,
    /**
     * The key in the local storage used to store current color scheme.
     */
    modeStorageKey: r.string,
    /**
     * If `true`, the mode will be the same value as the storage without an extra rerendering after the hydration.
     * You should use this option in conjuction with `InitColorSchemeScript` component.
     */
    noSsr: r.bool,
    /**
     * The window that attaches the 'storage' event listener.
     * @default window
     */
    storageWindow: r.any,
    /**
     * The calculated theme object that will be passed through context.
     */
    theme: r.object
  });
  const b = typeof a == "string" ? a : a.light, v = typeof a == "string" ? a : a.dark;
  return {
    CssVarsProvider: m,
    useColorScheme: d,
    getInitColorSchemeScript: (y) => CV({
      colorSchemeStorageKey: s,
      defaultLightColorScheme: b,
      defaultDarkColorScheme: v,
      modeStorageKey: o,
      ...y
    })
  };
}
function RV(e = "") {
  function t(...o) {
    if (!o.length)
      return "";
    const s = o[0];
    return typeof s == "string" && !s.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${s}${t(...o.slice(1))})` : `, ${s}`;
  }
  return (o, ...s) => `var(--${e ? `${e}-` : ""}${o}${t(...s)})`;
}
const JS = (e, t, n, o = []) => {
  let s = e;
  t.forEach((i, a) => {
    a === t.length - 1 ? Array.isArray(s) ? s[Number(i)] = n : s && typeof s == "object" && (s[i] = n) : s && typeof s == "object" && (s[i] || (s[i] = o.includes(i) ? [] : {}), s = s[i]);
  });
}, EV = (e, t, n) => {
  function o(s, i = [], a = []) {
    Object.entries(s).forEach(([l, c]) => {
      (!n || n && !n([...i, l])) && c != null && (typeof c == "object" && Object.keys(c).length > 0 ? o(c, [...i, l], Array.isArray(c) ? [...a, l] : a) : t([...i, l], c, a));
    });
  }
  o(e);
}, IV = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((o) => e.includes(o)) || e[e.length - 1].toLowerCase().includes("opacity") ? t : `${t}px` : t;
function Ah(e, t) {
  const {
    prefix: n,
    shouldSkipGeneratingVar: o
  } = t || {}, s = {}, i = {}, a = {};
  return EV(
    e,
    (l, c, u) => {
      if ((typeof c == "string" || typeof c == "number") && (!o || !o(l, c))) {
        const d = `--${n ? `${n}-` : ""}${l.join("-")}`, f = IV(l, c);
        Object.assign(s, {
          [d]: f
        }), JS(i, l, `var(${d})`, u), JS(a, l, `var(${d}, ${f})`, u);
      }
    },
    (l) => l[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: s,
    vars: i,
    varsWithDefaults: a
  };
}
function OV(e, t = {}) {
  const {
    getSelector: n = g,
    disableCssColorScheme: o,
    colorSchemeSelector: s
  } = t, {
    colorSchemes: i = {},
    components: a,
    defaultColorScheme: l = "light",
    ...c
  } = e, {
    vars: u,
    css: d,
    varsWithDefaults: f
  } = Ah(c, t);
  let p = f;
  const m = {}, {
    [l]: b,
    ...v
  } = i;
  if (Object.entries(v || {}).forEach(([x, S]) => {
    const {
      vars: T,
      css: E,
      varsWithDefaults: O
    } = Ah(S, t);
    p = Bn(p, O), m[x] = {
      css: E,
      vars: T
    };
  }), b) {
    const {
      css: x,
      vars: S,
      varsWithDefaults: T
    } = Ah(b, t);
    p = Bn(p, T), m[l] = {
      css: x,
      vars: S
    };
  }
  function g(x, S) {
    var E, O;
    let T = s;
    if (s === "class" && (T = ".%s"), s === "data" && (T = "[data-%s]"), s != null && s.startsWith("data-") && !s.includes("%s") && (T = `[${s}="%s"]`), x) {
      if (T === "media")
        return e.defaultColorScheme === x ? ":root" : {
          [`@media (prefers-color-scheme: ${((O = (E = i[x]) == null ? void 0 : E.palette) == null ? void 0 : O.mode) || x})`]: {
            ":root": S
          }
        };
      if (T)
        return e.defaultColorScheme === x ? `:root, ${T.replace("%s", String(x))}` : T.replace("%s", String(x));
    }
    return ":root";
  }
  return {
    vars: p,
    generateThemeVars: () => {
      let x = {
        ...u
      };
      return Object.entries(m).forEach(([, {
        vars: S
      }]) => {
        x = Bn(x, S);
      }), x;
    },
    generateStyleSheets: () => {
      var M, D;
      const x = [], S = e.defaultColorScheme || "light";
      function T(R, P) {
        Object.keys(P).length && x.push(typeof R == "string" ? {
          [R]: {
            ...P
          }
        } : R);
      }
      T(n(void 0, {
        ...d
      }), d);
      const {
        [S]: E,
        ...O
      } = m;
      if (E) {
        const {
          css: R
        } = E, P = (D = (M = i[S]) == null ? void 0 : M.palette) == null ? void 0 : D.mode, F = !o && P ? {
          colorScheme: P,
          ...R
        } : {
          ...R
        };
        T(n(S, {
          ...F
        }), F);
      }
      return Object.entries(O).forEach(([R, {
        css: P
      }]) => {
        var N, A;
        const F = (A = (N = i[R]) == null ? void 0 : N.palette) == null ? void 0 : A.mode, $ = !o && F ? {
          colorScheme: F,
          ...P
        } : {
          ...P
        };
        T(n(R, {
          ...$
        }), $);
      }), x;
    }
  };
}
function PV(e) {
  return function(n) {
    return e === "media" ? (process.env.NODE_ENV !== "production" && n !== "light" && n !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${n}'.`), `@media (prefers-color-scheme: ${n})`) : e ? e.startsWith("data-") && !e.includes("%s") ? `[${e}="${n}"] &` : e === "class" ? `.${n} &` : e === "data" ? `[data-${n}] &` : `${e.replace("%s", n)} &` : "&";
  };
}
const MV = Cp(), kV = tn("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function DV(e) {
  return aP({
    props: e,
    name: "MuiStack",
    defaultTheme: MV
  });
}
function NV(e, t) {
  const n = h.Children.toArray(e).filter(Boolean);
  return n.reduce((o, s, i) => (o.push(s), i < n.length - 1 && o.push(/* @__PURE__ */ h.cloneElement(t, {
    key: `separator-${i}`
  })), o), []);
}
const $V = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], AV = ({
  ownerState: e,
  theme: t
}) => {
  let n = {
    display: "flex",
    flexDirection: "column",
    ...No({
      theme: t
    }, Ii({
      values: e.direction,
      breakpoints: t.breakpoints.values
    }), (o) => ({
      flexDirection: o
    }))
  };
  if (e.spacing) {
    const o = hp(t), s = Object.keys(t.breakpoints.values).reduce((c, u) => ((typeof e.spacing == "object" && e.spacing[u] != null || typeof e.direction == "object" && e.direction[u] != null) && (c[u] = !0), c), {}), i = Ii({
      values: e.direction,
      base: s
    }), a = Ii({
      values: e.spacing,
      base: s
    });
    typeof i == "object" && Object.keys(i).forEach((c, u, d) => {
      if (!i[c]) {
        const p = u > 0 ? i[d[u - 1]] : "column";
        i[c] = p;
      }
    }), n = Bn(n, No({
      theme: t
    }, a, (c, u) => e.useFlexGap ? {
      gap: Ai(o, c)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${$V(u ? i[u] : e.direction)}`]: Ai(o, c)
      }
    }));
  }
  return n = WL(t.breakpoints, n), n;
};
function FV(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = kV,
    useThemeProps: n = DV,
    componentName: o = "MuiStack"
  } = e, s = () => fe({
    root: ["root"]
  }, (c) => De(o, c), {}), i = t(AV), a = /* @__PURE__ */ h.forwardRef(function(c, u) {
    const d = n(c), f = Sp(d), {
      component: p = "div",
      direction: m = "column",
      spacing: b = 0,
      divider: v,
      children: g,
      className: y,
      useFlexGap: w = !1,
      ...x
    } = f, S = {
      direction: m,
      spacing: b,
      useFlexGap: w
    }, T = s();
    return /* @__PURE__ */ C(i, {
      as: p,
      ownerState: S,
      ref: u,
      className: ae(T.root, y),
      ...x,
      children: v ? NV(g, v) : g
    });
  });
  return process.env.NODE_ENV !== "production" && (a.propTypes = {
    children: r.node,
    direction: r.oneOfType([r.oneOf(["column-reverse", "column", "row-reverse", "row"]), r.arrayOf(r.oneOf(["column-reverse", "column", "row-reverse", "row"])), r.object]),
    divider: r.node,
    spacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
    sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
  }), a;
}
function TP() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: Ua.white,
      default: Ua.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const LV = TP();
function RP() {
  return {
    text: {
      primary: Ua.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: Ua.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const ex = RP();
function tx(e, t, n, o) {
  const s = o.light || o, i = o.dark || o * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = wo(e.main, s) : t === "dark" && (e.dark = $o(e.main, i)));
}
function _V(e = "light") {
  return e === "dark" ? {
    main: gi[200],
    light: gi[50],
    dark: gi[400]
  } : {
    main: gi[700],
    light: gi[400],
    dark: gi[800]
  };
}
function VV(e = "light") {
  return e === "dark" ? {
    main: hi[200],
    light: hi[50],
    dark: hi[400]
  } : {
    main: hi[500],
    light: hi[300],
    dark: hi[700]
  };
}
function BV(e = "light") {
  return e === "dark" ? {
    main: pi[500],
    light: pi[300],
    dark: pi[700]
  } : {
    main: pi[700],
    light: pi[400],
    dark: pi[800]
  };
}
function zV(e = "light") {
  return e === "dark" ? {
    main: mi[400],
    light: mi[300],
    dark: mi[700]
  } : {
    main: mi[700],
    light: mi[500],
    dark: mi[900]
  };
}
function HV(e = "light") {
  return e === "dark" ? {
    main: bi[400],
    light: bi[300],
    dark: bi[700]
  } : {
    main: bi[800],
    light: bi[500],
    dark: bi[900]
  };
}
function jV(e = "light") {
  return e === "dark" ? {
    main: Sa[400],
    light: Sa[300],
    dark: Sa[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Sa[500],
    dark: Sa[900]
  };
}
function Nv(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: o = 0.2,
    ...s
  } = e, i = e.primary || _V(t), a = e.secondary || VV(t), l = e.error || BV(t), c = e.info || zV(t), u = e.success || HV(t), d = e.warning || jV(t);
  function f(v) {
    const g = GS(v, ex.text.primary) >= n ? ex.text.primary : LV.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const y = GS(v, g);
      y < 3 && console.error([`MUI: The contrast ratio of ${y}:1 for ${g} on ${v}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return g;
  }
  const p = ({
    color: v,
    name: g,
    mainShade: y = 500,
    lightShade: w = 300,
    darkShade: x = 700
  }) => {
    if (v = {
      ...v
    }, !v.main && v[y] && (v.main = v[y]), !v.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${g ? ` (${g})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${y}\` property.` : Zr(11, g ? ` (${g})` : "", y));
    if (typeof v.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${g ? ` (${g})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(v.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : Zr(12, g ? ` (${g})` : "", JSON.stringify(v.main)));
    return tx(v, "light", w, o), tx(v, "dark", x, o), v.contrastText || (v.contrastText = f(v.main)), v;
  };
  let m;
  return t === "light" ? m = TP() : t === "dark" && (m = RP()), process.env.NODE_ENV !== "production" && (m || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), Bn({
    // A collection of common colors.
    common: {
      ...Ua
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: p({
      color: i,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: p({
      color: a,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: p({
      color: l,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: p({
      color: d,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: p({
      color: c,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: p({
      color: u,
      name: "success"
    }),
    // The grey colors.
    grey: OO,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: p,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: o,
    // The light and dark mode object.
    ...m
  }, s);
}
function GV(e) {
  const t = {};
  return Object.entries(e).forEach((o) => {
    const [s, i] = o;
    typeof i == "object" && (t[s] = `${i.fontStyle ? `${i.fontStyle} ` : ""}${i.fontVariant ? `${i.fontVariant} ` : ""}${i.fontWeight ? `${i.fontWeight} ` : ""}${i.fontStretch ? `${i.fontStretch} ` : ""}${i.fontSize || ""}${i.lineHeight ? `/${i.lineHeight} ` : ""}${i.fontFamily || ""}`);
  }), t;
}
function qV(e, t) {
  return {
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    },
    ...t
  };
}
function WV(e) {
  return Math.round(e * 1e5) / 1e5;
}
const nx = {
  textTransform: "uppercase"
}, ox = '"Roboto", "Helvetica", "Arial", sans-serif';
function EP(e, t) {
  const {
    fontFamily: n = ox,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: s = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: a = 500,
    fontWeightBold: l = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: c = 16,
    // Apply the CSS properties to all the variants.
    allVariants: u,
    pxToRem: d,
    ...f
  } = typeof t == "function" ? t(e) : t;
  process.env.NODE_ENV !== "production" && (typeof o != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof c != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const p = o / 14, m = d || ((g) => `${g / c * p}rem`), b = (g, y, w, x, S) => ({
    fontFamily: n,
    fontWeight: g,
    fontSize: m(y),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: w,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...n === ox ? {
      letterSpacing: `${WV(x / y)}em`
    } : {},
    ...S,
    ...u
  }), v = {
    h1: b(s, 96, 1.167, -1.5),
    h2: b(s, 60, 1.2, -0.5),
    h3: b(i, 48, 1.167, 0),
    h4: b(i, 34, 1.235, 0.25),
    h5: b(i, 24, 1.334, 0),
    h6: b(a, 20, 1.6, 0.15),
    subtitle1: b(i, 16, 1.75, 0.15),
    subtitle2: b(a, 14, 1.57, 0.1),
    body1: b(i, 16, 1.5, 0.15),
    body2: b(i, 14, 1.43, 0.15),
    button: b(a, 14, 1.75, 0.4, nx),
    caption: b(i, 12, 1.66, 0.4),
    overline: b(i, 12, 2.66, 1, nx),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return Bn({
    htmlFontSize: c,
    pxToRem: m,
    fontFamily: n,
    fontSize: o,
    fontWeightLight: s,
    fontWeightRegular: i,
    fontWeightMedium: a,
    fontWeightBold: l,
    ...v
  }, f, {
    clone: !1
    // No need to clone deep
  });
}
const UV = 0.2, KV = 0.14, YV = 0.12;
function Cn(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${UV})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${KV})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${YV})`].join(",");
}
const XV = ["none", Cn(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Cn(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Cn(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Cn(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Cn(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Cn(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Cn(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Cn(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Cn(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Cn(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Cn(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Cn(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Cn(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Cn(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Cn(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Cn(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Cn(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Cn(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Cn(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Cn(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Cn(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Cn(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Cn(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Cn(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], QV = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, IP = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function rx(e) {
  return `${Math.round(e)}ms`;
}
function ZV(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.min(Math.round((4 + 15 * t ** 0.25 + t / 5) * 10), 3e3);
}
function JV(e) {
  const t = {
    ...QV,
    ...e.easing
  }, n = {
    ...IP,
    ...e.duration
  };
  return {
    getAutoHeightDuration: ZV,
    create: (s = ["all"], i = {}) => {
      const {
        duration: a = n.standard,
        easing: l = t.easeInOut,
        delay: c = 0,
        ...u
      } = i;
      if (process.env.NODE_ENV !== "production") {
        const d = (p) => typeof p == "string", f = (p) => !Number.isNaN(parseFloat(p));
        !d(s) && !Array.isArray(s) && console.error('MUI: Argument "props" must be a string or Array.'), !f(a) && !d(a) && console.error(`MUI: Argument "duration" must be a number or a string but found ${a}.`), d(l) || console.error('MUI: Argument "easing" must be a string.'), !f(c) && !d(c) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof i != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(u).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(u).join(",")}].`);
      }
      return (Array.isArray(s) ? s : [s]).map((d) => `${d} ${typeof a == "string" ? a : rx(a)} ${l} ${typeof c == "string" ? c : rx(c)}`).join(",");
    },
    ...e,
    easing: t,
    duration: n
  };
}
const e5 = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function t5(e) {
  return jr(e) || typeof e > "u" || typeof e == "string" || typeof e == "boolean" || typeof e == "number" || Array.isArray(e);
}
function OP(e = {}) {
  const t = {
    ...e
  };
  function n(o) {
    const s = Object.entries(o);
    for (let i = 0; i < s.length; i++) {
      const [a, l] = s[i];
      !t5(l) || a.startsWith("unstable_") ? delete o[a] : jr(l) && (o[a] = {
        ...l
      }, n(o[a]));
    }
  }
  return n(t), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(t, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function Qb(e = {}, ...t) {
  const {
    breakpoints: n,
    mixins: o = {},
    spacing: s,
    palette: i = {},
    transitions: a = {},
    typography: l = {},
    shape: c,
    ...u
  } = e;
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : Zr(20));
  const d = Nv(i), f = Cp(e);
  let p = Bn(f, {
    mixins: qV(f.breakpoints, o),
    palette: d,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: XV.slice(),
    typography: EP(d, l),
    transitions: JV(a),
    zIndex: {
      ...e5
    }
  });
  if (p = Bn(p, u), p = t.reduce((m, b) => Bn(m, b), p), process.env.NODE_ENV !== "production") {
    const m = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], b = (v, g) => {
      let y;
      for (y in v) {
        const w = v[y];
        if (m.includes(y) && Object.keys(w).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const x = De("", y);
            console.error([`MUI: The \`${g}\` component increases the CSS specificity of the \`${y}\` internal state.`, "You can not override it like this: ", JSON.stringify(v, null, 2), "", `Instead, you need to use the '&.${x}' syntax:`, JSON.stringify({
              root: {
                [`&.${x}`]: w
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          v[y] = {};
        }
      }
    };
    Object.keys(p.components).forEach((v) => {
      const g = p.components[v].styleOverrides;
      g && v.startsWith("Mui") && b(g, v);
    });
  }
  return p.unstable_sxConfig = {
    ...hu,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, p.unstable_sx = function(b) {
    return qs({
      sx: b,
      theme: this
    });
  }, p.toRuntimeSource = OP, p;
}
function Zb(e) {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, Math.round(t * 10) / 1e3;
}
const n5 = [...Array(25)].map((e, t) => {
  if (t === 0)
    return "none";
  const n = Zb(t);
  return `linear-gradient(rgba(255 255 255 / ${n}), rgba(255 255 255 / ${n}))`;
});
function PP(e) {
  return {
    inputPlaceholder: e === "dark" ? 0.5 : 0.42,
    inputUnderline: e === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: e === "dark" ? 0.2 : 0.12,
    switchTrack: e === "dark" ? 0.3 : 0.38
  };
}
function MP(e) {
  return e === "dark" ? n5 : [];
}
function o5(e) {
  const {
    palette: t = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: n,
    overlays: o,
    ...s
  } = e, i = Nv(t);
  return {
    palette: i,
    opacity: {
      ...PP(i.mode),
      ...n
    },
    overlays: o || MP(i.mode),
    ...s
  };
}
function r5(e) {
  var t;
  return !!e[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/(mode|contrastThreshold|tonalOffset)/));
}
const s5 = (e) => [...[...Array(25)].map((t, n) => `--${e ? `${e}-` : ""}overlays-${n}`), `--${e ? `${e}-` : ""}palette-AppBar-darkBg`, `--${e ? `${e}-` : ""}palette-AppBar-darkColor`], i5 = (e) => (t, n) => {
  const o = e.rootSelector || ":root", s = e.colorSchemeSelector;
  let i = s;
  if (s === "class" && (i = ".%s"), s === "data" && (i = "[data-%s]"), s != null && s.startsWith("data-") && !s.includes("%s") && (i = `[${s}="%s"]`), e.defaultColorScheme === t) {
    if (t === "dark") {
      const a = {};
      return s5(e.cssVarPrefix).forEach((l) => {
        a[l] = n[l], delete n[l];
      }), i === "media" ? {
        [o]: n,
        "@media (prefers-color-scheme: dark)": {
          [o]: a
        }
      } : i ? {
        [i.replace("%s", t)]: a,
        [`${o}, ${i.replace("%s", t)}`]: n
      } : {
        [o]: {
          ...n,
          ...a
        }
      };
    }
    if (i && i !== "media")
      return `${o}, ${i.replace("%s", String(t))}`;
  } else if (t) {
    if (i === "media")
      return {
        [`@media (prefers-color-scheme: ${String(t)})`]: {
          [o]: n
        }
      };
    if (i)
      return i.replace("%s", String(t));
  }
  return o;
};
function a5(e, t) {
  t.forEach((n) => {
    e[n] || (e[n] = {});
  });
}
function Ee(e, t, n) {
  !e[t] && n && (e[t] = n);
}
function ac(e) {
  return typeof e != "string" || !e.startsWith("hsl") ? e : uP(e);
}
function cs(e, t) {
  `${t}Channel` in e || (e[`${t}Channel`] = ic(ac(e[t]), `MUI: Can't create \`palette.${t}Channel\` because \`palette.${t}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${t}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function l5(e) {
  return typeof e == "number" ? `${e}px` : typeof e == "string" || typeof e == "function" || Array.isArray(e) ? e : "8px";
}
const Nr = (e) => {
  try {
    return e();
  } catch {
  }
}, c5 = (e = "mui") => RV(e);
function Fh(e, t, n, o) {
  if (!t)
    return;
  t = t === !0 ? {} : t;
  const s = o === "dark" ? "dark" : "light";
  if (!n) {
    e[o] = o5({
      ...t,
      palette: {
        mode: s,
        ...t == null ? void 0 : t.palette
      }
    });
    return;
  }
  const {
    palette: i,
    ...a
  } = Qb({
    ...n,
    palette: {
      mode: s,
      ...t == null ? void 0 : t.palette
    }
  });
  return e[o] = {
    ...t,
    palette: i,
    opacity: {
      ...PP(s),
      ...t == null ? void 0 : t.opacity
    },
    overlays: (t == null ? void 0 : t.overlays) || MP(s)
  }, a;
}
function u5(e = {}, ...t) {
  const {
    colorSchemes: n = {
      light: !0
    },
    defaultColorScheme: o,
    disableCssColorScheme: s = !1,
    cssVarPrefix: i = "mui",
    shouldSkipGeneratingVar: a = r5,
    colorSchemeSelector: l = n.light && n.dark ? "media" : void 0,
    rootSelector: c = ":root",
    ...u
  } = e, d = Object.keys(n)[0], f = o || (n.light && d !== "light" ? "light" : d), p = c5(i), {
    [f]: m,
    light: b,
    dark: v,
    ...g
  } = n, y = {
    ...g
  };
  let w = m;
  if ((f === "dark" && !("dark" in n) || f === "light" && !("light" in n)) && (w = !0), !w)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${f}\` option is either missing or invalid.` : Zr(21, f));
  const x = Fh(y, w, u, f);
  b && !y.light && Fh(y, b, void 0, "light"), v && !y.dark && Fh(y, v, void 0, "dark");
  let S = {
    defaultColorScheme: f,
    ...x,
    cssVarPrefix: i,
    colorSchemeSelector: l,
    rootSelector: c,
    getCssVar: p,
    colorSchemes: y,
    font: {
      ...GV(x.typography),
      ...x.font
    },
    spacing: l5(u.spacing)
  };
  Object.keys(S.colorSchemes).forEach((D) => {
    const R = S.colorSchemes[D].palette, P = (F) => {
      const $ = F.split("-"), N = $[1], A = $[2];
      return p(F, R[N][A]);
    };
    if (R.mode === "light" && (Ee(R.common, "background", "#fff"), Ee(R.common, "onBackground", "#000")), R.mode === "dark" && (Ee(R.common, "background", "#000"), Ee(R.common, "onBackground", "#fff")), a5(R, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), R.mode === "light") {
      Ee(R.Alert, "errorColor", cn(R.error.light, 0.6)), Ee(R.Alert, "infoColor", cn(R.info.light, 0.6)), Ee(R.Alert, "successColor", cn(R.success.light, 0.6)), Ee(R.Alert, "warningColor", cn(R.warning.light, 0.6)), Ee(R.Alert, "errorFilledBg", P("palette-error-main")), Ee(R.Alert, "infoFilledBg", P("palette-info-main")), Ee(R.Alert, "successFilledBg", P("palette-success-main")), Ee(R.Alert, "warningFilledBg", P("palette-warning-main")), Ee(R.Alert, "errorFilledColor", Nr(() => R.getContrastText(R.error.main))), Ee(R.Alert, "infoFilledColor", Nr(() => R.getContrastText(R.info.main))), Ee(R.Alert, "successFilledColor", Nr(() => R.getContrastText(R.success.main))), Ee(R.Alert, "warningFilledColor", Nr(() => R.getContrastText(R.warning.main))), Ee(R.Alert, "errorStandardBg", un(R.error.light, 0.9)), Ee(R.Alert, "infoStandardBg", un(R.info.light, 0.9)), Ee(R.Alert, "successStandardBg", un(R.success.light, 0.9)), Ee(R.Alert, "warningStandardBg", un(R.warning.light, 0.9)), Ee(R.Alert, "errorIconColor", P("palette-error-main")), Ee(R.Alert, "infoIconColor", P("palette-info-main")), Ee(R.Alert, "successIconColor", P("palette-success-main")), Ee(R.Alert, "warningIconColor", P("palette-warning-main")), Ee(R.AppBar, "defaultBg", P("palette-grey-100")), Ee(R.Avatar, "defaultBg", P("palette-grey-400")), Ee(R.Button, "inheritContainedBg", P("palette-grey-300")), Ee(R.Button, "inheritContainedHoverBg", P("palette-grey-A100")), Ee(R.Chip, "defaultBorder", P("palette-grey-400")), Ee(R.Chip, "defaultAvatarColor", P("palette-grey-700")), Ee(R.Chip, "defaultIconColor", P("palette-grey-700")), Ee(R.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), Ee(R.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), Ee(R.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), Ee(R.LinearProgress, "primaryBg", un(R.primary.main, 0.62)), Ee(R.LinearProgress, "secondaryBg", un(R.secondary.main, 0.62)), Ee(R.LinearProgress, "errorBg", un(R.error.main, 0.62)), Ee(R.LinearProgress, "infoBg", un(R.info.main, 0.62)), Ee(R.LinearProgress, "successBg", un(R.success.main, 0.62)), Ee(R.LinearProgress, "warningBg", un(R.warning.main, 0.62)), Ee(R.Skeleton, "bg", `rgba(${P("palette-text-primaryChannel")} / 0.11)`), Ee(R.Slider, "primaryTrack", un(R.primary.main, 0.62)), Ee(R.Slider, "secondaryTrack", un(R.secondary.main, 0.62)), Ee(R.Slider, "errorTrack", un(R.error.main, 0.62)), Ee(R.Slider, "infoTrack", un(R.info.main, 0.62)), Ee(R.Slider, "successTrack", un(R.success.main, 0.62)), Ee(R.Slider, "warningTrack", un(R.warning.main, 0.62));
      const F = id(R.background.default, 0.8);
      Ee(R.SnackbarContent, "bg", F), Ee(R.SnackbarContent, "color", Nr(() => R.getContrastText(F))), Ee(R.SpeedDialAction, "fabHoverBg", id(R.background.paper, 0.15)), Ee(R.StepConnector, "border", P("palette-grey-400")), Ee(R.StepContent, "border", P("palette-grey-400")), Ee(R.Switch, "defaultColor", P("palette-common-white")), Ee(R.Switch, "defaultDisabledColor", P("palette-grey-100")), Ee(R.Switch, "primaryDisabledColor", un(R.primary.main, 0.62)), Ee(R.Switch, "secondaryDisabledColor", un(R.secondary.main, 0.62)), Ee(R.Switch, "errorDisabledColor", un(R.error.main, 0.62)), Ee(R.Switch, "infoDisabledColor", un(R.info.main, 0.62)), Ee(R.Switch, "successDisabledColor", un(R.success.main, 0.62)), Ee(R.Switch, "warningDisabledColor", un(R.warning.main, 0.62)), Ee(R.TableCell, "border", un(sd(R.divider, 1), 0.88)), Ee(R.Tooltip, "bg", sd(R.grey[700], 0.92));
    }
    if (R.mode === "dark") {
      Ee(R.Alert, "errorColor", un(R.error.light, 0.6)), Ee(R.Alert, "infoColor", un(R.info.light, 0.6)), Ee(R.Alert, "successColor", un(R.success.light, 0.6)), Ee(R.Alert, "warningColor", un(R.warning.light, 0.6)), Ee(R.Alert, "errorFilledBg", P("palette-error-dark")), Ee(R.Alert, "infoFilledBg", P("palette-info-dark")), Ee(R.Alert, "successFilledBg", P("palette-success-dark")), Ee(R.Alert, "warningFilledBg", P("palette-warning-dark")), Ee(R.Alert, "errorFilledColor", Nr(() => R.getContrastText(R.error.dark))), Ee(R.Alert, "infoFilledColor", Nr(() => R.getContrastText(R.info.dark))), Ee(R.Alert, "successFilledColor", Nr(() => R.getContrastText(R.success.dark))), Ee(R.Alert, "warningFilledColor", Nr(() => R.getContrastText(R.warning.dark))), Ee(R.Alert, "errorStandardBg", cn(R.error.light, 0.9)), Ee(R.Alert, "infoStandardBg", cn(R.info.light, 0.9)), Ee(R.Alert, "successStandardBg", cn(R.success.light, 0.9)), Ee(R.Alert, "warningStandardBg", cn(R.warning.light, 0.9)), Ee(R.Alert, "errorIconColor", P("palette-error-main")), Ee(R.Alert, "infoIconColor", P("palette-info-main")), Ee(R.Alert, "successIconColor", P("palette-success-main")), Ee(R.Alert, "warningIconColor", P("palette-warning-main")), Ee(R.AppBar, "defaultBg", P("palette-grey-900")), Ee(R.AppBar, "darkBg", P("palette-background-paper")), Ee(R.AppBar, "darkColor", P("palette-text-primary")), Ee(R.Avatar, "defaultBg", P("palette-grey-600")), Ee(R.Button, "inheritContainedBg", P("palette-grey-800")), Ee(R.Button, "inheritContainedHoverBg", P("palette-grey-700")), Ee(R.Chip, "defaultBorder", P("palette-grey-700")), Ee(R.Chip, "defaultAvatarColor", P("palette-grey-300")), Ee(R.Chip, "defaultIconColor", P("palette-grey-300")), Ee(R.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), Ee(R.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), Ee(R.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), Ee(R.LinearProgress, "primaryBg", cn(R.primary.main, 0.5)), Ee(R.LinearProgress, "secondaryBg", cn(R.secondary.main, 0.5)), Ee(R.LinearProgress, "errorBg", cn(R.error.main, 0.5)), Ee(R.LinearProgress, "infoBg", cn(R.info.main, 0.5)), Ee(R.LinearProgress, "successBg", cn(R.success.main, 0.5)), Ee(R.LinearProgress, "warningBg", cn(R.warning.main, 0.5)), Ee(R.Skeleton, "bg", `rgba(${P("palette-text-primaryChannel")} / 0.13)`), Ee(R.Slider, "primaryTrack", cn(R.primary.main, 0.5)), Ee(R.Slider, "secondaryTrack", cn(R.secondary.main, 0.5)), Ee(R.Slider, "errorTrack", cn(R.error.main, 0.5)), Ee(R.Slider, "infoTrack", cn(R.info.main, 0.5)), Ee(R.Slider, "successTrack", cn(R.success.main, 0.5)), Ee(R.Slider, "warningTrack", cn(R.warning.main, 0.5));
      const F = id(R.background.default, 0.98);
      Ee(R.SnackbarContent, "bg", F), Ee(R.SnackbarContent, "color", Nr(() => R.getContrastText(F))), Ee(R.SpeedDialAction, "fabHoverBg", id(R.background.paper, 0.15)), Ee(R.StepConnector, "border", P("palette-grey-600")), Ee(R.StepContent, "border", P("palette-grey-600")), Ee(R.Switch, "defaultColor", P("palette-grey-300")), Ee(R.Switch, "defaultDisabledColor", P("palette-grey-600")), Ee(R.Switch, "primaryDisabledColor", cn(R.primary.main, 0.55)), Ee(R.Switch, "secondaryDisabledColor", cn(R.secondary.main, 0.55)), Ee(R.Switch, "errorDisabledColor", cn(R.error.main, 0.55)), Ee(R.Switch, "infoDisabledColor", cn(R.info.main, 0.55)), Ee(R.Switch, "successDisabledColor", cn(R.success.main, 0.55)), Ee(R.Switch, "warningDisabledColor", cn(R.warning.main, 0.55)), Ee(R.TableCell, "border", cn(sd(R.divider, 1), 0.68)), Ee(R.Tooltip, "bg", sd(R.grey[700], 0.92));
    }
    cs(R.background, "default"), cs(R.background, "paper"), cs(R.common, "background"), cs(R.common, "onBackground"), cs(R, "divider"), Object.keys(R).forEach((F) => {
      const $ = R[F];
      F !== "tonalOffset" && $ && typeof $ == "object" && ($.main && Ee(R[F], "mainChannel", ic(ac($.main))), $.light && Ee(R[F], "lightChannel", ic(ac($.light))), $.dark && Ee(R[F], "darkChannel", ic(ac($.dark))), $.contrastText && Ee(R[F], "contrastTextChannel", ic(ac($.contrastText))), F === "text" && (cs(R[F], "primary"), cs(R[F], "secondary")), F === "action" && ($.active && cs(R[F], "active"), $.selected && cs(R[F], "selected")));
    });
  }), S = t.reduce((D, R) => Bn(D, R), S);
  const T = {
    prefix: i,
    disableCssColorScheme: s,
    shouldSkipGeneratingVar: a,
    getSelector: i5(S)
  }, {
    vars: E,
    generateThemeVars: O,
    generateStyleSheets: M
  } = OV(S, T);
  return S.vars = E, Object.entries(S.colorSchemes[S.defaultColorScheme]).forEach(([D, R]) => {
    S[D] = R;
  }), S.generateThemeVars = O, S.generateStyleSheets = M, S.generateSpacing = function() {
    return QO(u.spacing, hp(this));
  }, S.getColorSchemeSelector = PV(l), S.spacing = S.generateSpacing(), S.shouldSkipGeneratingVar = a, S.unstable_sxConfig = {
    ...hu,
    ...u == null ? void 0 : u.unstable_sxConfig
  }, S.unstable_sx = function(R) {
    return qs({
      sx: R,
      theme: this
    });
  }, S.toRuntimeSource = OP, S;
}
function sx(e, t, n) {
  e.colorSchemes && n && (e.colorSchemes[t] = {
    ...n !== !0 && n,
    palette: Nv({
      ...n === !0 ? {} : n.palette,
      mode: t
    })
    // cast type to skip module augmentation test
  });
}
function gl(e = {}, ...t) {
  const {
    palette: n,
    cssVariables: o = !1,
    colorSchemes: s = n ? void 0 : {
      light: !0
    },
    defaultColorScheme: i = n == null ? void 0 : n.mode,
    ...a
  } = e, l = i || "light", c = s == null ? void 0 : s[l], u = {
    ...s,
    ...n ? {
      [l]: {
        ...typeof c != "boolean" && c,
        palette: n
      }
    } : void 0
  };
  if (o === !1) {
    if (!("colorSchemes" in e))
      return Qb(e, ...t);
    let d = n;
    "palette" in e || u[l] && (u[l] !== !0 ? d = u[l].palette : l === "dark" && (d = {
      mode: "dark"
    }));
    const f = Qb({
      ...e,
      palette: d
    }, ...t);
    return f.defaultColorScheme = l, f.colorSchemes = u, f.palette.mode === "light" && (f.colorSchemes.light = {
      ...u.light !== !0 && u.light,
      palette: f.palette
    }, sx(f, "dark", u.dark)), f.palette.mode === "dark" && (f.colorSchemes.dark = {
      ...u.dark !== !0 && u.dark,
      palette: f.palette
    }, sx(f, "light", u.light)), f;
  }
  return !n && !("light" in u) && l === "light" && (u.light = !0), u5({
    ...a,
    colorSchemes: u,
    defaultColorScheme: l,
    ...typeof o != "boolean" && o
  }, ...t);
}
function d5(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function f5(e) {
  return parseFloat(e);
}
const Rp = gl();
function sn() {
  const e = wp(Rp);
  return process.env.NODE_ENV !== "production" && h.useDebugValue(e), e[hr] || e;
}
function Et({
  props: e,
  name: t
}) {
  return aP({
    props: e,
    name: t,
    defaultTheme: Rp,
    themeId: hr
  });
}
function bu(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Xn = (e) => bu(e) && e !== "classes", te = rP({
  themeId: hr,
  defaultTheme: Rp,
  rootShouldForwardProp: Xn
});
function ix({
  theme: e,
  ...t
}) {
  const n = hr in e ? e[hr] : void 0;
  return /* @__PURE__ */ C(_c, {
    ...t,
    themeId: n ? hr : void 0,
    theme: n || e
  });
}
const ad = {
  colorSchemeStorageKey: "mui-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "mui-mode"
}, {
  CssVarsProvider: p5
} = TV({
  themeId: hr,
  // @ts-ignore ignore module augmentation tests
  theme: () => gl({
    cssVariables: !0
  }),
  colorSchemeStorageKey: ad.colorSchemeStorageKey,
  modeStorageKey: ad.modeStorageKey,
  defaultColorScheme: {
    light: ad.defaultLightColorScheme,
    dark: ad.defaultDarkColorScheme
  },
  resolveTheme: (e) => {
    const t = {
      ...e,
      typography: EP(e.palette, e.typography)
    };
    return t.unstable_sx = function(o) {
      return qs({
        sx: o,
        theme: this
      });
    }, t;
  }
}), h5 = p5;
function $v({
  theme: e,
  ...t
}) {
  return typeof e == "function" ? /* @__PURE__ */ C(ix, {
    theme: e,
    ...t
  }) : "colorSchemes" in (hr in e ? e[hr] : e) ? /* @__PURE__ */ C(h5, {
    theme: e,
    ...t
  }) : /* @__PURE__ */ C(ix, {
    theme: e,
    ...t
  });
}
function kP(e) {
  return /* @__PURE__ */ C(ZO, {
    ...e,
    defaultTheme: Rp,
    themeId: hr
  });
}
process.env.NODE_ENV !== "production" && (kP.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: r.oneOfType([r.array, r.func, r.number, r.object, r.string, r.bool])
});
function g5(e) {
  return function(n) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ C(kP, {
        styles: typeof e == "function" ? (o) => e({
          theme: o,
          ...n
        }) : e
      })
    );
  };
}
function m5() {
  return Sp;
}
const Fe = yV;
process.env.NODE_ENV !== "production" && (r.node, r.object.isRequired);
function Be(e) {
  return bV(e);
}
function b5(e) {
  return De("MuiSvgIcon", e);
}
Ne("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const y5 = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: o
  } = e, s = {
    root: ["root", t !== "inherit" && `color${ce(t)}`, `fontSize${ce(n)}`]
  };
  return fe(s, b5, o);
}, v5 = te("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${ce(n.color)}`], t[`fontSize${ce(n.fontSize)}`]];
  }
})(Fe(({
  theme: e
}) => {
  var t, n, o, s, i, a, l, c, u, d, f, p, m, b;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (s = (t = e.transitions) == null ? void 0 : t.create) == null ? void 0 : s.call(t, "fill", {
      duration: (o = (n = (e.vars ?? e).transitions) == null ? void 0 : n.duration) == null ? void 0 : o.shorter
    }),
    variants: [
      {
        props: (v) => !v.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((a = (i = e.typography) == null ? void 0 : i.pxToRem) == null ? void 0 : a.call(i, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((c = (l = e.typography) == null ? void 0 : l.pxToRem) == null ? void 0 : c.call(l, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((d = (u = e.typography) == null ? void 0 : u.pxToRem) == null ? void 0 : d.call(u, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((e.vars ?? e).palette).filter(([, v]) => v && v.main).map(([v]) => {
        var g, y;
        return {
          props: {
            color: v
          },
          style: {
            color: (y = (g = (e.vars ?? e).palette) == null ? void 0 : g[v]) == null ? void 0 : y.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (p = (f = (e.vars ?? e).palette) == null ? void 0 : f.action) == null ? void 0 : p.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (b = (m = (e.vars ?? e).palette) == null ? void 0 : m.action) == null ? void 0 : b.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), Vc = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: s,
    className: i,
    color: a = "inherit",
    component: l = "svg",
    fontSize: c = "medium",
    htmlColor: u,
    inheritViewBox: d = !1,
    titleAccess: f,
    viewBox: p = "0 0 24 24",
    ...m
  } = o, b = /* @__PURE__ */ h.isValidElement(s) && s.type === "svg", v = {
    ...o,
    color: a,
    component: l,
    fontSize: c,
    instanceFontSize: t.fontSize,
    inheritViewBox: d,
    viewBox: p,
    hasSvgAsChild: b
  }, g = {};
  d || (g.viewBox = p);
  const y = y5(v);
  return /* @__PURE__ */ ie(v5, {
    as: l,
    className: ae(y.root, i),
    focusable: "false",
    color: u,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: n,
    ...g,
    ...m,
    ...b && s.props,
    ownerState: v,
    children: [b ? s.props.children : s, f ? /* @__PURE__ */ C("title", {
      children: f
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (Vc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: r.oneOfType([r.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: r.oneOfType([r.oneOf(["inherit", "large", "medium", "small"]), r.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: r.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: r.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: r.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: r.string
});
Vc && (Vc.muiName = "SvgIcon");
function _e(e, t) {
  function n(o, s) {
    return /* @__PURE__ */ C(Vc, {
      "data-testid": `${t}Icon`,
      ref: s,
      ...o,
      children: e
    });
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = Vc.muiName, /* @__PURE__ */ h.memo(/* @__PURE__ */ h.forwardRef(n));
}
var ld = { exports: {} }, Zt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ax;
function C5() {
  if (ax) return Zt;
  ax = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), b;
  b = Symbol.for("react.module.reference");
  function v(g) {
    if (typeof g == "object" && g !== null) {
      var y = g.$$typeof;
      switch (y) {
        case e:
          switch (g = g.type, g) {
            case n:
            case s:
            case o:
            case u:
            case d:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case l:
                case a:
                case c:
                case p:
                case f:
                case i:
                  return g;
                default:
                  return y;
              }
          }
        case t:
          return y;
      }
    }
  }
  return Zt.ContextConsumer = a, Zt.ContextProvider = i, Zt.Element = e, Zt.ForwardRef = c, Zt.Fragment = n, Zt.Lazy = p, Zt.Memo = f, Zt.Portal = t, Zt.Profiler = s, Zt.StrictMode = o, Zt.Suspense = u, Zt.SuspenseList = d, Zt.isAsyncMode = function() {
    return !1;
  }, Zt.isConcurrentMode = function() {
    return !1;
  }, Zt.isContextConsumer = function(g) {
    return v(g) === a;
  }, Zt.isContextProvider = function(g) {
    return v(g) === i;
  }, Zt.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === e;
  }, Zt.isForwardRef = function(g) {
    return v(g) === c;
  }, Zt.isFragment = function(g) {
    return v(g) === n;
  }, Zt.isLazy = function(g) {
    return v(g) === p;
  }, Zt.isMemo = function(g) {
    return v(g) === f;
  }, Zt.isPortal = function(g) {
    return v(g) === t;
  }, Zt.isProfiler = function(g) {
    return v(g) === s;
  }, Zt.isStrictMode = function(g) {
    return v(g) === o;
  }, Zt.isSuspense = function(g) {
    return v(g) === u;
  }, Zt.isSuspenseList = function(g) {
    return v(g) === d;
  }, Zt.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === s || g === o || g === u || g === d || g === m || typeof g == "object" && g !== null && (g.$$typeof === p || g.$$typeof === f || g.$$typeof === i || g.$$typeof === a || g.$$typeof === c || g.$$typeof === b || g.getModuleId !== void 0);
  }, Zt.typeOf = v, Zt;
}
var Jt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lx;
function w5() {
  return lx || (lx = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), a = Symbol.for("react.context"), l = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), b = !1, v = !1, g = !1, y = !1, w = !1, x;
    x = Symbol.for("react.module.reference");
    function S(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === n || X === s || w || X === o || X === u || X === d || y || X === m || b || v || g || typeof X == "object" && X !== null && (X.$$typeof === p || X.$$typeof === f || X.$$typeof === i || X.$$typeof === a || X.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === x || X.getModuleId !== void 0));
    }
    function T(X) {
      if (typeof X == "object" && X !== null) {
        var re = X.$$typeof;
        switch (re) {
          case e:
            var oe = X.type;
            switch (oe) {
              case n:
              case s:
              case o:
              case u:
              case d:
                return oe;
              default:
                var le = oe && oe.$$typeof;
                switch (le) {
                  case l:
                  case a:
                  case c:
                  case p:
                  case f:
                  case i:
                    return le;
                  default:
                    return re;
                }
            }
          case t:
            return re;
        }
      }
    }
    var E = a, O = i, M = e, D = c, R = n, P = p, F = f, $ = t, N = s, A = o, k = u, L = d, B = !1, V = !1;
    function _(X) {
      return B || (B = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function z(X) {
      return V || (V = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(X) {
      return T(X) === a;
    }
    function W(X) {
      return T(X) === i;
    }
    function J(X) {
      return typeof X == "object" && X !== null && X.$$typeof === e;
    }
    function G(X) {
      return T(X) === c;
    }
    function q(X) {
      return T(X) === n;
    }
    function Z(X) {
      return T(X) === p;
    }
    function Y(X) {
      return T(X) === f;
    }
    function Q(X) {
      return T(X) === t;
    }
    function ee(X) {
      return T(X) === s;
    }
    function ne(X) {
      return T(X) === o;
    }
    function H(X) {
      return T(X) === u;
    }
    function U(X) {
      return T(X) === d;
    }
    Jt.ContextConsumer = E, Jt.ContextProvider = O, Jt.Element = M, Jt.ForwardRef = D, Jt.Fragment = R, Jt.Lazy = P, Jt.Memo = F, Jt.Portal = $, Jt.Profiler = N, Jt.StrictMode = A, Jt.Suspense = k, Jt.SuspenseList = L, Jt.isAsyncMode = _, Jt.isConcurrentMode = z, Jt.isContextConsumer = j, Jt.isContextProvider = W, Jt.isElement = J, Jt.isForwardRef = G, Jt.isFragment = q, Jt.isLazy = Z, Jt.isMemo = Y, Jt.isPortal = Q, Jt.isProfiler = ee, Jt.isStrictMode = ne, Jt.isSuspense = H, Jt.isSuspenseList = U, Jt.isValidElementType = S, Jt.typeOf = T;
  }()), Jt;
}
var cx;
function S5() {
  return cx || (cx = 1, process.env.NODE_ENV === "production" ? ld.exports = C5() : ld.exports = w5()), ld.exports;
}
var Js = S5();
function ve(e, t) {
  if (e == null) return {};
  var n = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.indexOf(o) !== -1) continue;
    n[o] = e[o];
  }
  return n;
}
function Jb(e, t) {
  return Jb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, Jb(e, t);
}
function yu(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Jb(e, t);
}
function x5(e, t) {
  return e.classList ? !!t && e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
function T5(e, t) {
  e.classList ? e.classList.add(t) : x5(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
function ux(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function R5(e, t) {
  e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = ux(e.className, t) : e.setAttribute("class", ux(e.className && e.className.baseVal || "", t));
}
const dx = {
  disabled: !1
};
var E5 = process.env.NODE_ENV !== "production" ? r.oneOfType([r.number, r.shape({
  enter: r.number,
  exit: r.number,
  appear: r.number
}).isRequired]) : null, I5 = process.env.NODE_ENV !== "production" ? r.oneOfType([r.string, r.shape({
  enter: r.string,
  exit: r.string,
  active: r.string
}), r.shape({
  enter: r.string,
  enterDone: r.string,
  enterActive: r.string,
  exit: r.string,
  exitDone: r.string,
  exitActive: r.string
})]) : null;
const Sf = en.createContext(null);
var DP = function(t) {
  return t.scrollTop;
}, lc = "unmounted", yi = "exited", vi = "entering", xa = "entered", ey = "exiting", So = /* @__PURE__ */ function(e) {
  yu(t, e);
  function t(o, s) {
    var i;
    i = e.call(this, o, s) || this;
    var a = s, l = a && !a.isMounting ? o.enter : o.appear, c;
    return i.appearStatus = null, o.in ? l ? (c = yi, i.appearStatus = vi) : c = xa : o.unmountOnExit || o.mountOnEnter ? c = lc : c = yi, i.state = {
      status: c
    }, i.nextCallback = null, i;
  }
  t.getDerivedStateFromProps = function(s, i) {
    var a = s.in;
    return a && i.status === lc ? {
      status: yi
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(s) {
    var i = null;
    if (s !== this.props) {
      var a = this.state.status;
      this.props.in ? a !== vi && a !== xa && (i = vi) : (a === vi || a === xa) && (i = ey);
    }
    this.updateStatus(!1, i);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var s = this.props.timeout, i, a, l;
    return i = a = l = s, s != null && typeof s != "number" && (i = s.exit, a = s.enter, l = s.appear !== void 0 ? s.appear : a), {
      exit: i,
      enter: a,
      appear: l
    };
  }, n.updateStatus = function(s, i) {
    if (s === void 0 && (s = !1), i !== null)
      if (this.cancelNextCallback(), i === vi) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var a = this.props.nodeRef ? this.props.nodeRef.current : Zu.findDOMNode(this);
          a && DP(a);
        }
        this.performEnter(s);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === yi && this.setState({
      status: lc
    });
  }, n.performEnter = function(s) {
    var i = this, a = this.props.enter, l = this.context ? this.context.isMounting : s, c = this.props.nodeRef ? [l] : [Zu.findDOMNode(this), l], u = c[0], d = c[1], f = this.getTimeouts(), p = l ? f.appear : f.enter;
    if (!s && !a || dx.disabled) {
      this.safeSetState({
        status: xa
      }, function() {
        i.props.onEntered(u);
      });
      return;
    }
    this.props.onEnter(u, d), this.safeSetState({
      status: vi
    }, function() {
      i.props.onEntering(u, d), i.onTransitionEnd(p, function() {
        i.safeSetState({
          status: xa
        }, function() {
          i.props.onEntered(u, d);
        });
      });
    });
  }, n.performExit = function() {
    var s = this, i = this.props.exit, a = this.getTimeouts(), l = this.props.nodeRef ? void 0 : Zu.findDOMNode(this);
    if (!i || dx.disabled) {
      this.safeSetState({
        status: yi
      }, function() {
        s.props.onExited(l);
      });
      return;
    }
    this.props.onExit(l), this.safeSetState({
      status: ey
    }, function() {
      s.props.onExiting(l), s.onTransitionEnd(a.exit, function() {
        s.safeSetState({
          status: yi
        }, function() {
          s.props.onExited(l);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(s, i) {
    i = this.setNextCallback(i), this.setState(s, i);
  }, n.setNextCallback = function(s) {
    var i = this, a = !0;
    return this.nextCallback = function(l) {
      a && (a = !1, i.nextCallback = null, s(l));
    }, this.nextCallback.cancel = function() {
      a = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(s, i) {
    this.setNextCallback(i);
    var a = this.props.nodeRef ? this.props.nodeRef.current : Zu.findDOMNode(this), l = s == null && !this.props.addEndListener;
    if (!a || l) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var c = this.props.nodeRef ? [this.nextCallback] : [a, this.nextCallback], u = c[0], d = c[1];
      this.props.addEndListener(u, d);
    }
    s != null && setTimeout(this.nextCallback, s);
  }, n.render = function() {
    var s = this.state.status;
    if (s === lc)
      return null;
    var i = this.props, a = i.children;
    i.in, i.mountOnEnter, i.unmountOnExit, i.appear, i.enter, i.exit, i.timeout, i.addEndListener, i.onEnter, i.onEntering, i.onEntered, i.onExit, i.onExiting, i.onExited, i.nodeRef;
    var l = ve(i, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ en.createElement(Sf.Provider, {
        value: null
      }, typeof a == "function" ? a(s, l) : en.cloneElement(en.Children.only(a), l))
    );
  }, t;
}(en.Component);
So.contextType = Sf;
So.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: r.shape({
    current: typeof Element > "u" ? r.any : function(e, t, n, o, s, i) {
      var a = e[t];
      return r.instanceOf(a && "ownerDocument" in a ? a.ownerDocument.defaultView.Element : Element)(e, t, n, o, s, i);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: r.oneOfType([r.func.isRequired, r.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: r.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: r.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: r.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: r.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: r.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: r.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = E5;
    t.addEndListener || (n = n.isRequired);
    for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
      s[i - 1] = arguments[i];
    return n.apply(void 0, [t].concat(s));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: r.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: r.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: r.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: r.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: r.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: r.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: r.func
} : {};
function la() {
}
So.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: la,
  onEntering: la,
  onEntered: la,
  onExit: la,
  onExiting: la,
  onExited: la
};
So.UNMOUNTED = lc;
So.EXITED = yi;
So.ENTERING = vi;
So.ENTERED = xa;
So.EXITING = ey;
var O5 = function(t, n) {
  return t && n && n.split(" ").forEach(function(o) {
    return T5(t, o);
  });
}, Lh = function(t, n) {
  return t && n && n.split(" ").forEach(function(o) {
    return R5(t, o);
  });
}, Av = /* @__PURE__ */ function(e) {
  yu(t, e);
  function t() {
    for (var o, s = arguments.length, i = new Array(s), a = 0; a < s; a++)
      i[a] = arguments[a];
    return o = e.call.apply(e, [this].concat(i)) || this, o.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, o.onEnter = function(l, c) {
      var u = o.resolveArguments(l, c), d = u[0], f = u[1];
      o.removeClasses(d, "exit"), o.addClass(d, f ? "appear" : "enter", "base"), o.props.onEnter && o.props.onEnter(l, c);
    }, o.onEntering = function(l, c) {
      var u = o.resolveArguments(l, c), d = u[0], f = u[1], p = f ? "appear" : "enter";
      o.addClass(d, p, "active"), o.props.onEntering && o.props.onEntering(l, c);
    }, o.onEntered = function(l, c) {
      var u = o.resolveArguments(l, c), d = u[0], f = u[1], p = f ? "appear" : "enter";
      o.removeClasses(d, p), o.addClass(d, p, "done"), o.props.onEntered && o.props.onEntered(l, c);
    }, o.onExit = function(l) {
      var c = o.resolveArguments(l), u = c[0];
      o.removeClasses(u, "appear"), o.removeClasses(u, "enter"), o.addClass(u, "exit", "base"), o.props.onExit && o.props.onExit(l);
    }, o.onExiting = function(l) {
      var c = o.resolveArguments(l), u = c[0];
      o.addClass(u, "exit", "active"), o.props.onExiting && o.props.onExiting(l);
    }, o.onExited = function(l) {
      var c = o.resolveArguments(l), u = c[0];
      o.removeClasses(u, "exit"), o.addClass(u, "exit", "done"), o.props.onExited && o.props.onExited(l);
    }, o.resolveArguments = function(l, c) {
      return o.props.nodeRef ? [o.props.nodeRef.current, l] : [l, c];
    }, o.getClassNames = function(l) {
      var c = o.props.classNames, u = typeof c == "string", d = u && c ? c + "-" : "", f = u ? "" + d + l : c[l], p = u ? f + "-active" : c[l + "Active"], m = u ? f + "-done" : c[l + "Done"];
      return {
        baseClassName: f,
        activeClassName: p,
        doneClassName: m
      };
    }, o;
  }
  var n = t.prototype;
  return n.addClass = function(s, i, a) {
    var l = this.getClassNames(i)[a + "ClassName"], c = this.getClassNames("enter"), u = c.doneClassName;
    i === "appear" && a === "done" && u && (l += " " + u), a === "active" && s && DP(s), l && (this.appliedClasses[i][a] = l, O5(s, l));
  }, n.removeClasses = function(s, i) {
    var a = this.appliedClasses[i], l = a.base, c = a.active, u = a.done;
    this.appliedClasses[i] = {}, l && Lh(s, l), c && Lh(s, c), u && Lh(s, u);
  }, n.render = function() {
    var s = this.props;
    s.classNames;
    var i = ve(s, ["classNames"]);
    return /* @__PURE__ */ en.createElement(So, I({}, i, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
}(en.Component);
Av.defaultProps = {
  classNames: ""
};
Av.propTypes = process.env.NODE_ENV !== "production" ? I({}, So.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: I5,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: r.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: r.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: r.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: r.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: r.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: r.func
}) : {};
function ty(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Fv(e, t) {
  var n = function(i) {
    return t && bo(i) ? t(i) : i;
  }, o = /* @__PURE__ */ Object.create(null);
  return e && cu.map(e, function(s) {
    return s;
  }).forEach(function(s) {
    o[s.key] = n(s);
  }), o;
}
function P5(e, t) {
  e = e || {}, t = t || {};
  function n(d) {
    return d in t ? t[d] : e[d];
  }
  var o = /* @__PURE__ */ Object.create(null), s = [];
  for (var i in e)
    i in t ? s.length && (o[i] = s, s = []) : s.push(i);
  var a, l = {};
  for (var c in t) {
    if (o[c])
      for (a = 0; a < o[c].length; a++) {
        var u = o[c][a];
        l[o[c][a]] = n(u);
      }
    l[c] = n(c);
  }
  for (a = 0; a < s.length; a++)
    l[s[a]] = n(s[a]);
  return l;
}
function Ti(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function M5(e, t) {
  return Fv(e.children, function(n) {
    return Gr(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: Ti(n, "appear", e),
      enter: Ti(n, "enter", e),
      exit: Ti(n, "exit", e)
    });
  });
}
function k5(e, t, n) {
  var o = Fv(e.children), s = P5(t, o);
  return Object.keys(s).forEach(function(i) {
    var a = s[i];
    if (bo(a)) {
      var l = i in t, c = i in o, u = t[i], d = bo(u) && !u.props.in;
      c && (!l || d) ? s[i] = Gr(a, {
        onExited: n.bind(null, a),
        in: !0,
        exit: Ti(a, "exit", e),
        enter: Ti(a, "enter", e)
      }) : !c && l && !d ? s[i] = Gr(a, {
        in: !1
      }) : c && l && bo(u) && (s[i] = Gr(a, {
        onExited: n.bind(null, a),
        in: u.props.in,
        exit: Ti(a, "exit", e),
        enter: Ti(a, "enter", e)
      }));
    }
  }), s;
}
var D5 = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, N5 = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, vu = /* @__PURE__ */ function(e) {
  yu(t, e);
  function t(o, s) {
    var i;
    i = e.call(this, o, s) || this;
    var a = i.handleExited.bind(ty(i));
    return i.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: a,
      firstRender: !0
    }, i;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(s, i) {
    var a = i.children, l = i.handleExited, c = i.firstRender;
    return {
      children: c ? M5(s, l) : k5(s, a, l),
      firstRender: !1
    };
  }, n.handleExited = function(s, i) {
    var a = Fv(this.props.children);
    s.key in a || (s.props.onExited && s.props.onExited(i), this.mounted && this.setState(function(l) {
      var c = I({}, l.children);
      return delete c[s.key], {
        children: c
      };
    }));
  }, n.render = function() {
    var s = this.props, i = s.component, a = s.childFactory, l = ve(s, ["component", "childFactory"]), c = this.state.contextValue, u = D5(this.state.children).map(a);
    return delete l.appear, delete l.enter, delete l.exit, i === null ? /* @__PURE__ */ en.createElement(Sf.Provider, {
      value: c
    }, u) : /* @__PURE__ */ en.createElement(Sf.Provider, {
      value: c
    }, /* @__PURE__ */ en.createElement(i, l, u));
  }, t;
}(en.Component);
vu.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: r.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: r.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: r.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: r.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: r.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: r.func
} : {};
vu.defaultProps = N5;
const Ep = (e) => e.scrollTop;
function Jr(e, t) {
  const {
    timeout: n,
    easing: o,
    style: s = {}
  } = e;
  return {
    duration: s.transitionDuration ?? (typeof n == "number" ? n : n[t.mode] || 0),
    easing: s.transitionTimingFunction ?? (typeof o == "object" ? o[t.mode] : o),
    delay: s.transitionDelay
  };
}
function $5(e) {
  return De("MuiCollapse", e);
}
Ne("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const A5 = (e) => {
  const {
    orientation: t,
    classes: n
  } = e, o = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return fe(o, $5, n);
}, F5 = te("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.state === "entered" && t.entered, n.state === "exited" && !n.in && n.collapsedSize === "0px" && t.hidden];
  }
})(Fe(({
  theme: e
}) => ({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height"),
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "auto",
      width: 0,
      transition: e.transitions.create("width")
    }
  }, {
    props: {
      state: "entered"
    },
    style: {
      height: "auto",
      overflow: "visible"
    }
  }, {
    props: {
      state: "entered",
      orientation: "horizontal"
    },
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.state === "exited" && !t.in && t.collapsedSize === "0px",
    style: {
      visibility: "hidden"
    }
  }]
}))), L5 = te("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), _5 = te("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})({
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), Ya = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: s,
    children: i,
    className: a,
    collapsedSize: l = "0px",
    component: c,
    easing: u,
    in: d,
    onEnter: f,
    onEntered: p,
    onEntering: m,
    onExit: b,
    onExited: v,
    onExiting: g,
    orientation: y = "vertical",
    style: w,
    timeout: x = IP.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: S = So,
    ...T
  } = o, E = {
    ...o,
    orientation: y,
    collapsedSize: l
  }, O = A5(E), M = sn(), D = go(), R = h.useRef(null), P = h.useRef(), F = typeof l == "number" ? `${l}px` : l, $ = y === "horizontal", N = $ ? "width" : "height", A = h.useRef(null), k = tt(n, A), L = (q) => (Z) => {
    if (q) {
      const Y = A.current;
      Z === void 0 ? q(Y) : q(Y, Z);
    }
  }, B = () => R.current ? R.current[$ ? "clientWidth" : "clientHeight"] : 0, V = L((q, Z) => {
    R.current && $ && (R.current.style.position = "absolute"), q.style[N] = F, f && f(q, Z);
  }), _ = L((q, Z) => {
    const Y = B();
    R.current && $ && (R.current.style.position = "");
    const {
      duration: Q,
      easing: ee
    } = Jr({
      style: w,
      timeout: x,
      easing: u
    }, {
      mode: "enter"
    });
    if (x === "auto") {
      const ne = M.transitions.getAutoHeightDuration(Y);
      q.style.transitionDuration = `${ne}ms`, P.current = ne;
    } else
      q.style.transitionDuration = typeof Q == "string" ? Q : `${Q}ms`;
    q.style[N] = `${Y}px`, q.style.transitionTimingFunction = ee, m && m(q, Z);
  }), z = L((q, Z) => {
    q.style[N] = "auto", p && p(q, Z);
  }), j = L((q) => {
    q.style[N] = `${B()}px`, b && b(q);
  }), W = L(v), J = L((q) => {
    const Z = B(), {
      duration: Y,
      easing: Q
    } = Jr({
      style: w,
      timeout: x,
      easing: u
    }, {
      mode: "exit"
    });
    if (x === "auto") {
      const ee = M.transitions.getAutoHeightDuration(Z);
      q.style.transitionDuration = `${ee}ms`, P.current = ee;
    } else
      q.style.transitionDuration = typeof Y == "string" ? Y : `${Y}ms`;
    q.style[N] = F, q.style.transitionTimingFunction = Q, g && g(q);
  });
  return /* @__PURE__ */ C(S, {
    in: d,
    onEnter: V,
    onEntered: z,
    onEntering: _,
    onExit: j,
    onExited: W,
    onExiting: J,
    addEndListener: (q) => {
      x === "auto" && D.start(P.current || 0, q), s && s(A.current, q);
    },
    nodeRef: A,
    timeout: x === "auto" ? null : x,
    ...T,
    children: (q, Z) => /* @__PURE__ */ C(F5, {
      as: c,
      className: ae(O.root, a, {
        entered: O.entered,
        exited: !d && F === "0px" && O.hidden
      }[q]),
      style: {
        [$ ? "minWidth" : "minHeight"]: F,
        ...w
      },
      ref: k,
      ...Z,
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: {
        ...E,
        state: q
      },
      children: /* @__PURE__ */ C(L5, {
        ownerState: {
          ...E,
          state: q
        },
        className: O.wrapper,
        ref: R,
        children: /* @__PURE__ */ C(_5, {
          ownerState: {
            ...E,
            state: q
          },
          className: O.wrapperInner,
          children: i
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Ya.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: r.func,
  /**
   * The content node to be collapsed.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: r.oneOfType([r.number, r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: mu,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: r.oneOfType([r.shape({
    enter: r.string,
    exit: r.string
  }), r.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: r.bool,
  /**
   * @ignore
   */
  onEnter: r.func,
  /**
   * @ignore
   */
  onEntered: r.func,
  /**
   * @ignore
   */
  onEntering: r.func,
  /**
   * @ignore
   */
  onExit: r.func,
  /**
   * @ignore
   */
  onExited: r.func,
  /**
   * @ignore
   */
  onExiting: r.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: r.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: r.oneOfType([r.oneOf(["auto"]), r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })])
});
Ya && (Ya.muiSupportAuto = !0);
function V5(e) {
  return De("MuiPaper", e);
}
Ne("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const B5 = (e) => {
  const {
    square: t,
    elevation: n,
    variant: o,
    classes: s
  } = e, i = {
    root: ["root", o, !t && "rounded", o === "elevation" && `elevation${n}`]
  };
  return fe(i, V5, s);
}, z5 = te("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(Fe(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  color: (e.vars || e).palette.text.primary,
  transition: e.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: t
    }) => !t.square,
    style: {
      borderRadius: e.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), ao = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var m;
  const o = Be({
    props: t,
    name: "MuiPaper"
  }), s = sn(), {
    className: i,
    component: a = "div",
    elevation: l = 1,
    square: c = !1,
    variant: u = "elevation",
    ...d
  } = o, f = {
    ...o,
    component: a,
    elevation: l,
    square: c,
    variant: u
  }, p = B5(f);
  return process.env.NODE_ENV !== "production" && s.shadows[l] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${l}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${l}]\` is defined.`].join(`
`)), /* @__PURE__ */ C(z5, {
    as: a,
    ownerState: f,
    className: ae(p.root, i),
    ref: n,
    ...d,
    style: {
      ...u === "elevation" && {
        "--Paper-shadow": (s.vars || s).shadows[l],
        ...s.vars && {
          "--Paper-overlay": (m = s.vars.overlays) == null ? void 0 : m[l]
        },
        ...!s.vars && s.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${he("#fff", Zb(l))}, ${he("#fff", Zb(l))})`
        }
      },
      ...d.style
    }
  });
});
process.env.NODE_ENV !== "production" && (ao.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: Gn(Wr, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: r.bool,
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: r.oneOfType([r.oneOf(["elevation", "outlined"]), r.string])
});
const Lv = /* @__PURE__ */ h.createContext({});
process.env.NODE_ENV !== "production" && (Lv.displayName = "AccordionContext");
function bn(e, t) {
  const {
    className: n,
    elementType: o,
    ownerState: s,
    externalForwardedProps: i,
    internalForwardedProps: a,
    ...l
  } = t, {
    component: c,
    slots: u = {
      [e]: void 0
    },
    slotProps: d = {
      [e]: void 0
    },
    ...f
  } = i, p = u[e] || o, m = Ur(d[e], s), {
    props: {
      component: b,
      ...v
    },
    internalRef: g
  } = bP({
    className: n,
    ...l,
    externalForwardedProps: e === "root" ? f : void 0,
    externalSlotProps: m
  }), y = tt(g, m == null ? void 0 : m.ref, t.ref), w = e === "root" ? b || c : b, x = mP(p, {
    ...e === "root" && !c && !u[e] && a,
    ...e !== "root" && !u[e] && a,
    ...v,
    ...w && {
      as: w
    },
    ref: y
  }, s);
  return [p, x];
}
function H5(e) {
  return De("MuiAccordion", e);
}
const cd = Ne("MuiAccordion", ["root", "heading", "rounded", "expanded", "disabled", "gutters", "region"]), j5 = (e) => {
  const {
    classes: t,
    square: n,
    expanded: o,
    disabled: s,
    disableGutters: i
  } = e;
  return fe({
    root: ["root", !n && "rounded", o && "expanded", s && "disabled", !i && "gutters"],
    heading: ["heading"],
    region: ["region"]
  }, H5, t);
}, G5 = te(ao, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${cd.region}`]: t.region
    }, t.root, !n.square && t.rounded, !n.disableGutters && t.gutters];
  }
})(Fe(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${cd.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${cd.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}), Fe(({
  theme: e
}) => ({
  variants: [{
    props: (t) => !t.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (e.vars || e).shape.borderRadius,
        borderTopRightRadius: (e.vars || e).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
        borderBottomRightRadius: (e.vars || e).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (t) => !t.disableGutters,
    style: {
      [`&.${cd.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
}))), q5 = te("h3", {
  name: "MuiAccordion",
  slot: "Heading",
  overridesResolver: (e, t) => t.heading
})({
  all: "unset"
}), _v = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiAccordion"
  }), {
    children: s,
    className: i,
    defaultExpanded: a = !1,
    disabled: l = !1,
    disableGutters: c = !1,
    expanded: u,
    onChange: d,
    square: f = !1,
    slots: p = {},
    slotProps: m = {},
    TransitionComponent: b,
    TransitionProps: v,
    ...g
  } = o, [y, w] = jn({
    controlled: u,
    default: a,
    name: "Accordion",
    state: "expanded"
  }), x = h.useCallback((k) => {
    w(!y), d && d(k, !y);
  }, [y, d, w]), [S, ...T] = h.Children.toArray(s), E = h.useMemo(() => ({
    expanded: y,
    disabled: l,
    disableGutters: c,
    toggle: x
  }), [y, l, c, x]), O = {
    ...o,
    square: f,
    disabled: l,
    disableGutters: c,
    expanded: y
  }, M = j5(O), D = {
    transition: b,
    ...p
  }, R = {
    transition: v,
    ...m
  }, P = {
    slots: D,
    slotProps: R
  }, [F, $] = bn("heading", {
    elementType: q5,
    externalForwardedProps: P,
    className: M.heading,
    ownerState: O
  }), [N, A] = bn("transition", {
    elementType: Ya,
    externalForwardedProps: P,
    ownerState: O
  });
  return /* @__PURE__ */ ie(G5, {
    className: ae(M.root, i),
    ref: n,
    ownerState: O,
    square: f,
    ...g,
    children: [/* @__PURE__ */ C(F, {
      ...$,
      children: /* @__PURE__ */ C(Lv.Provider, {
        value: E,
        children: S
      })
    }), /* @__PURE__ */ C(N, {
      in: y,
      timeout: "auto",
      ...A,
      children: /* @__PURE__ */ C("div", {
        "aria-labelledby": S.props.id,
        id: S.props["aria-controls"],
        role: "region",
        className: M.region,
        children: T
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (_v.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: Gn(r.node.isRequired, (e) => {
    const t = h.Children.toArray(e.children)[0];
    return Js.isFragment(t) ? new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.") : /* @__PURE__ */ h.isValidElement(t) ? null : new Error("MUI: Expected the first child of Accordion to be a valid element.");
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: r.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: r.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: r.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: r.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    heading: r.oneOfType([r.func, r.object]),
    transition: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    heading: r.elementType,
    transition: r.elementType
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: r.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionProps: r.object
});
function W5(e) {
  return De("MuiAccordionDetails", e);
}
Ne("MuiAccordionDetails", ["root"]);
const U5 = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, W5, t);
}, K5 = te("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(Fe(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
}))), Vv = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiAccordionDetails"
  }), {
    className: s,
    ...i
  } = o, a = o, l = U5(a);
  return /* @__PURE__ */ C(K5, {
    className: ae(l.root, s),
    ref: n,
    ownerState: a,
    ...i
  });
});
process.env.NODE_ENV !== "production" && (Vv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
class xf {
  constructor() {
    Al(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new xf();
  }
  static use() {
    const t = Jo(xf.create).current, [n, o] = h.useState(!1);
    return t.shouldMount = n, t.setShouldMount = o, h.useEffect(t.mountEffect, [n]), t;
  }
  mount() {
    return this.mounted || (this.mounted = X5(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.start(...t);
    });
  }
  stop(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.stop(...t);
    });
  }
  pulsate(...t) {
    this.mount().then(() => {
      var n;
      return (n = this.ref.current) == null ? void 0 : n.pulsate(...t);
    });
  }
}
function Y5() {
  return xf.use();
}
function X5() {
  let e, t;
  const n = new Promise((o, s) => {
    e = o, t = s;
  });
  return n.resolve = e, n.reject = t, n;
}
function NP(e) {
  const {
    className: t,
    classes: n,
    pulsate: o = !1,
    rippleX: s,
    rippleY: i,
    rippleSize: a,
    in: l,
    onExited: c,
    timeout: u
  } = e, [d, f] = h.useState(!1), p = ae(t, n.ripple, n.rippleVisible, o && n.ripplePulsate), m = {
    width: a,
    height: a,
    top: -(a / 2) + i,
    left: -(a / 2) + s
  }, b = ae(n.child, d && n.childLeaving, o && n.childPulsate);
  return !l && !d && f(!0), h.useEffect(() => {
    if (!l && c != null) {
      const v = setTimeout(c, u);
      return () => {
        clearTimeout(v);
      };
    }
  }, [c, l, u]), /* @__PURE__ */ C("span", {
    className: p,
    style: m,
    children: /* @__PURE__ */ C("span", {
      className: b
    })
  });
}
process.env.NODE_ENV !== "production" && (NP.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object.isRequired,
  className: r.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: r.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: r.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: r.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: r.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: r.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: r.number,
  /**
   * exit delay
   */
  timeout: r.number.isRequired
});
const ir = Ne("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), ny = 550, Q5 = 80, Z5 = ss`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, J5 = ss`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, eB = ss`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, tB = te("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), nB = te(NP, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${ir.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${Z5};
    animation-duration: ${ny}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  &.${ir.ripplePulsate} {
    animation-duration: ${({
  theme: e
}) => e.transitions.duration.shorter}ms;
  }

  & .${ir.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${ir.childLeaving} {
    opacity: 0;
    animation-name: ${J5};
    animation-duration: ${ny}ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
  }

  & .${ir.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${eB};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: e
}) => e.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, $P = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: s = !1,
    classes: i = {},
    className: a,
    ...l
  } = o, [c, u] = h.useState([]), d = h.useRef(0), f = h.useRef(null);
  h.useEffect(() => {
    f.current && (f.current(), f.current = null);
  }, [c]);
  const p = h.useRef(!1), m = go(), b = h.useRef(null), v = h.useRef(null), g = h.useCallback((S) => {
    const {
      pulsate: T,
      rippleX: E,
      rippleY: O,
      rippleSize: M,
      cb: D
    } = S;
    u((R) => [...R, /* @__PURE__ */ C(nB, {
      classes: {
        ripple: ae(i.ripple, ir.ripple),
        rippleVisible: ae(i.rippleVisible, ir.rippleVisible),
        ripplePulsate: ae(i.ripplePulsate, ir.ripplePulsate),
        child: ae(i.child, ir.child),
        childLeaving: ae(i.childLeaving, ir.childLeaving),
        childPulsate: ae(i.childPulsate, ir.childPulsate)
      },
      timeout: ny,
      pulsate: T,
      rippleX: E,
      rippleY: O,
      rippleSize: M
    }, d.current)]), d.current += 1, f.current = D;
  }, [i]), y = h.useCallback((S = {}, T = {}, E = () => {
  }) => {
    const {
      pulsate: O = !1,
      center: M = s || T.pulsate,
      fakeElement: D = !1
      // For test purposes
    } = T;
    if ((S == null ? void 0 : S.type) === "mousedown" && p.current) {
      p.current = !1;
      return;
    }
    (S == null ? void 0 : S.type) === "touchstart" && (p.current = !0);
    const R = D ? null : v.current, P = R ? R.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let F, $, N;
    if (M || S === void 0 || S.clientX === 0 && S.clientY === 0 || !S.clientX && !S.touches)
      F = Math.round(P.width / 2), $ = Math.round(P.height / 2);
    else {
      const {
        clientX: A,
        clientY: k
      } = S.touches && S.touches.length > 0 ? S.touches[0] : S;
      F = Math.round(A - P.left), $ = Math.round(k - P.top);
    }
    if (M)
      N = Math.sqrt((2 * P.width ** 2 + P.height ** 2) / 3), N % 2 === 0 && (N += 1);
    else {
      const A = Math.max(Math.abs((R ? R.clientWidth : 0) - F), F) * 2 + 2, k = Math.max(Math.abs((R ? R.clientHeight : 0) - $), $) * 2 + 2;
      N = Math.sqrt(A ** 2 + k ** 2);
    }
    S != null && S.touches ? b.current === null && (b.current = () => {
      g({
        pulsate: O,
        rippleX: F,
        rippleY: $,
        rippleSize: N,
        cb: E
      });
    }, m.start(Q5, () => {
      b.current && (b.current(), b.current = null);
    })) : g({
      pulsate: O,
      rippleX: F,
      rippleY: $,
      rippleSize: N,
      cb: E
    });
  }, [s, g, m]), w = h.useCallback(() => {
    y({}, {
      pulsate: !0
    });
  }, [y]), x = h.useCallback((S, T) => {
    if (m.clear(), (S == null ? void 0 : S.type) === "touchend" && b.current) {
      b.current(), b.current = null, m.start(0, () => {
        x(S, T);
      });
      return;
    }
    b.current = null, u((E) => E.length > 0 ? E.slice(1) : E), f.current = T;
  }, [m]);
  return h.useImperativeHandle(n, () => ({
    pulsate: w,
    start: y,
    stop: x
  }), [w, y, x]), /* @__PURE__ */ C(tB, {
    className: ae(ir.root, i.root, a),
    ref: v,
    ...l,
    children: /* @__PURE__ */ C(vu, {
      component: null,
      exit: !0,
      children: c
    })
  });
});
process.env.NODE_ENV !== "production" && ($P.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string
});
function oB(e) {
  return De("MuiButtonBase", e);
}
const rB = Ne("MuiButtonBase", ["root", "disabled", "focusVisible"]), sB = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: o,
    classes: s
  } = e, a = fe({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, oB, s);
  return n && o && (a.root += ` ${o}`), a;
}, iB = te("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${rB.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), Yn = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: s,
    centerRipple: i = !1,
    children: a,
    className: l,
    component: c = "button",
    disabled: u = !1,
    disableRipple: d = !1,
    disableTouchRipple: f = !1,
    focusRipple: p = !1,
    focusVisibleClassName: m,
    LinkComponent: b = "a",
    onBlur: v,
    onClick: g,
    onContextMenu: y,
    onDragLeave: w,
    onFocus: x,
    onFocusVisible: S,
    onKeyDown: T,
    onKeyUp: E,
    onMouseDown: O,
    onMouseLeave: M,
    onMouseUp: D,
    onTouchEnd: R,
    onTouchMove: P,
    onTouchStart: F,
    tabIndex: $ = 0,
    TouchRippleProps: N,
    touchRippleRef: A,
    type: k,
    ...L
  } = o, B = h.useRef(null), V = Y5(), _ = tt(V.ref, A), [z, j] = h.useState(!1);
  u && z && j(!1), h.useImperativeHandle(s, () => ({
    focusVisible: () => {
      j(!0), B.current.focus();
    }
  }), []);
  const W = V.shouldMount && !d && !u;
  h.useEffect(() => {
    z && p && !d && V.pulsate();
  }, [d, p, z, V]);
  const J = us(V, "start", O, f), G = us(V, "stop", y, f), q = us(V, "stop", w, f), Z = us(V, "stop", D, f), Y = us(V, "stop", (Te) => {
    z && Te.preventDefault(), M && M(Te);
  }, f), Q = us(V, "start", F, f), ee = us(V, "stop", R, f), ne = us(V, "stop", P, f), H = us(V, "stop", (Te) => {
    Ws(Te.target) || j(!1), v && v(Te);
  }, !1), U = xe((Te) => {
    B.current || (B.current = Te.currentTarget), Ws(Te.target) && (j(!0), S && S(Te)), x && x(Te);
  }), X = () => {
    const Te = B.current;
    return c && c !== "button" && !(Te.tagName === "A" && Te.href);
  }, re = xe((Te) => {
    p && !Te.repeat && z && Te.key === " " && V.stop(Te, () => {
      V.start(Te);
    }), Te.target === Te.currentTarget && X() && Te.key === " " && Te.preventDefault(), T && T(Te), Te.target === Te.currentTarget && X() && Te.key === "Enter" && !u && (Te.preventDefault(), g && g(Te));
  }), oe = xe((Te) => {
    p && Te.key === " " && z && !Te.defaultPrevented && V.stop(Te, () => {
      V.pulsate(Te);
    }), E && E(Te), g && Te.target === Te.currentTarget && X() && Te.key === " " && !Te.defaultPrevented && g(Te);
  });
  let le = c;
  le === "button" && (L.href || L.to) && (le = b);
  const se = {};
  le === "button" ? (se.type = k === void 0 ? "button" : k, se.disabled = u) : (!L.href && !L.to && (se.role = "button"), u && (se["aria-disabled"] = u));
  const Ce = tt(n, B), $e = {
    ...o,
    centerRipple: i,
    component: c,
    disabled: u,
    disableRipple: d,
    disableTouchRipple: f,
    focusRipple: p,
    tabIndex: $,
    focusVisible: z
  }, we = sB($e);
  return /* @__PURE__ */ ie(iB, {
    as: le,
    className: ae(we.root, l),
    ownerState: $e,
    onBlur: H,
    onClick: g,
    onContextMenu: G,
    onFocus: U,
    onKeyDown: re,
    onKeyUp: oe,
    onMouseDown: J,
    onMouseLeave: Y,
    onMouseUp: Z,
    onDragLeave: q,
    onTouchEnd: ee,
    onTouchMove: ne,
    onTouchStart: Q,
    ref: Ce,
    tabIndex: u ? -1 : $,
    type: k,
    ...se,
    ...L,
    children: [a, W ? /* @__PURE__ */ C($P, {
      ref: _,
      center: i,
      ...N
    }) : null]
  });
});
function us(e, t, n, o = !1) {
  return xe((s) => (n && n(s), o || e[t](s), !0));
}
process.env.NODE_ENV !== "production" && (Yn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: Lt,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: r.bool,
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: mu,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: r.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: r.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: r.string,
  /**
   * @ignore
   */
  href: r.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: r.elementType,
  /**
   * @ignore
   */
  onBlur: r.func,
  /**
   * @ignore
   */
  onClick: r.func,
  /**
   * @ignore
   */
  onContextMenu: r.func,
  /**
   * @ignore
   */
  onDragLeave: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: r.func,
  /**
   * @ignore
   */
  onKeyDown: r.func,
  /**
   * @ignore
   */
  onKeyUp: r.func,
  /**
   * @ignore
   */
  onMouseDown: r.func,
  /**
   * @ignore
   */
  onMouseLeave: r.func,
  /**
   * @ignore
   */
  onMouseUp: r.func,
  /**
   * @ignore
   */
  onTouchEnd: r.func,
  /**
   * @ignore
   */
  onTouchMove: r.func,
  /**
   * @ignore
   */
  onTouchStart: r.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * @default 0
   */
  tabIndex: r.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: r.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      pulsate: r.func.isRequired,
      start: r.func.isRequired,
      stop: r.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: r.oneOfType([r.oneOf(["button", "reset", "submit"]), r.string])
});
function aB(e) {
  return De("MuiAccordionSummary", e);
}
const Oa = Ne("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), lB = (e) => {
  const {
    classes: t,
    expanded: n,
    disabled: o,
    disableGutters: s
  } = e;
  return fe({
    root: ["root", n && "expanded", o && "disabled", !s && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", n && "expanded", !s && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", n && "expanded"]
  }, aB, t);
}, cB = te(Yn, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(Fe(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    display: "flex",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], t),
    [`&.${Oa.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${Oa.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${Oa.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (n) => !n.disableGutters,
      style: {
        [`&.${Oa.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
})), uB = te("div", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(Fe(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (t) => !t.disableGutters,
    style: {
      transition: e.transitions.create(["margin"], {
        duration: e.transitions.duration.shortest
      }),
      [`&.${Oa.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
}))), dB = te("div", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, t) => t.expandIconWrapper
})(Fe(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${Oa.expanded}`]: {
    transform: "rotate(180deg)"
  }
}))), Bv = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiAccordionSummary"
  }), {
    children: s,
    className: i,
    expandIcon: a,
    focusVisibleClassName: l,
    onClick: c,
    ...u
  } = o, {
    disabled: d = !1,
    disableGutters: f,
    expanded: p,
    toggle: m
  } = h.useContext(Lv), b = (y) => {
    m && m(y), c && c(y);
  }, v = {
    ...o,
    expanded: p,
    disabled: d,
    disableGutters: f
  }, g = lB(v);
  return /* @__PURE__ */ ie(cB, {
    focusRipple: !1,
    disableRipple: !0,
    disabled: d,
    component: "div",
    "aria-expanded": p,
    className: ae(g.root, i),
    focusVisibleClassName: ae(g.focusVisible, l),
    onClick: b,
    ref: n,
    ownerState: v,
    ...u,
    children: [/* @__PURE__ */ C(uB, {
      className: g.content,
      ownerState: v,
      children: s
    }), a && /* @__PURE__ */ C(dB, {
      className: g.expandIconWrapper,
      ownerState: v,
      children: a
    })]
  });
});
process.env.NODE_ENV !== "production" && (Bv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: r.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: r.string,
  /**
   * @ignore
   */
  onClick: r.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function fB(e) {
  return typeof e.main == "string";
}
function pB(e, t = []) {
  if (!fB(e))
    return !1;
  for (const n of t)
    if (!e.hasOwnProperty(n) || typeof e[n] != "string")
      return !1;
  return !0;
}
function $t(e = []) {
  return ([, t]) => t && pB(t, e);
}
function hB(e) {
  return De("MuiAlert", e);
}
const fx = Ne("MuiAlert", ["root", "action", "icon", "message", "filled", "colorSuccess", "colorInfo", "colorWarning", "colorError", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]);
function gB(e) {
  return De("MuiIconButton", e);
}
const mB = Ne("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), bB = (e) => {
  const {
    classes: t,
    disabled: n,
    color: o,
    edge: s,
    size: i
  } = e, a = {
    root: ["root", n && "disabled", o !== "default" && `color${ce(o)}`, s && `edge${ce(s)}`, `size${ce(i)}`]
  };
  return fe(a, gB, t);
}, yB = te(Yn, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${ce(n.color)}`], n.edge && t[`edge${ce(n.edge)}`], t[`size${ce(n.size)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette.action.active, e.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), Fe(({
  theme: e
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": e.vars ? `rgba(${(e.vars || e).palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : he((e.vars || e).palette[t].main, e.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: e.typography.pxToRem(28)
    }
  }],
  [`&.${mB.disabled}`]: {
    backgroundColor: "transparent",
    color: (e.vars || e).palette.action.disabled
  }
}))), Eo = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: s = !1,
    children: i,
    className: a,
    color: l = "default",
    disabled: c = !1,
    disableFocusRipple: u = !1,
    size: d = "medium",
    ...f
  } = o, p = {
    ...o,
    edge: s,
    color: l,
    disabled: c,
    disableFocusRipple: u,
    size: d
  }, m = bB(p);
  return /* @__PURE__ */ C(yB, {
    className: ae(m.root, a),
    centerRipple: !0,
    focusRipple: !u,
    disabled: c,
    ref: n,
    ...f,
    ownerState: p,
    children: i
  });
});
process.env.NODE_ENV !== "production" && (Eo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: Gn(r.node, (e) => h.Children.toArray(e.children).some((n) => /* @__PURE__ */ h.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: r.oneOfType([r.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: r.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["small", "medium", "large"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const vB = _e(/* @__PURE__ */ C("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), CB = _e(/* @__PURE__ */ C("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), wB = _e(/* @__PURE__ */ C("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), SB = _e(/* @__PURE__ */ C("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), AP = _e(/* @__PURE__ */ C("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), xB = (e) => {
  const {
    variant: t,
    color: n,
    severity: o,
    classes: s
  } = e, i = {
    root: ["root", `color${ce(n || o)}`, `${t}${ce(n || o)}`, `${t}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return fe(i, hB, s);
}, TB = te(ao, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${ce(n.color || n.severity)}`]];
  }
})(Fe(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? $o : wo, n = e.palette.mode === "light" ? wo : $o;
  return {
    ...e.typography.body2,
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px",
    variants: [...Object.entries(e.palette).filter($t(["light"])).map(([o]) => ({
      props: {
        colorSeverity: o,
        variant: "standard"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${o}Color`] : t(e.palette[o].light, 0.6),
        backgroundColor: e.vars ? e.vars.palette.Alert[`${o}StandardBg`] : n(e.palette[o].light, 0.9),
        [`& .${fx.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${o}IconColor`]
        } : {
          color: e.palette[o].main
        }
      }
    })), ...Object.entries(e.palette).filter($t(["light"])).map(([o]) => ({
      props: {
        colorSeverity: o,
        variant: "outlined"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${o}Color`] : t(e.palette[o].light, 0.6),
        border: `1px solid ${(e.vars || e).palette[o].light}`,
        [`& .${fx.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${o}IconColor`]
        } : {
          color: e.palette[o].main
        }
      }
    })), ...Object.entries(e.palette).filter($t(["dark"])).map(([o]) => ({
      props: {
        colorSeverity: o,
        variant: "filled"
      },
      style: {
        fontWeight: e.typography.fontWeightMedium,
        ...e.vars ? {
          color: e.vars.palette.Alert[`${o}FilledColor`],
          backgroundColor: e.vars.palette.Alert[`${o}FilledBg`]
        } : {
          backgroundColor: e.palette.mode === "dark" ? e.palette[o].dark : e.palette[o].main,
          color: e.palette.getContrastText(e.palette[o].main)
        }
      }
    }))]
  };
})), RB = te("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), EB = te("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), px = te("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), hx = {
  success: /* @__PURE__ */ C(vB, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ C(CB, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ C(wB, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ C(SB, {
    fontSize: "inherit"
  })
}, FP = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiAlert"
  }), {
    action: s,
    children: i,
    className: a,
    closeText: l = "Close",
    color: c,
    components: u = {},
    componentsProps: d = {},
    icon: f,
    iconMapping: p = hx,
    onClose: m,
    role: b = "alert",
    severity: v = "success",
    slotProps: g = {},
    slots: y = {},
    variant: w = "standard",
    ...x
  } = o, S = {
    ...o,
    color: c,
    severity: v,
    variant: w,
    colorSeverity: c || v
  }, T = xB(S), E = {
    slots: {
      closeButton: u.CloseButton,
      closeIcon: u.CloseIcon,
      ...y
    },
    slotProps: {
      ...d,
      ...g
    }
  }, [O, M] = bn("closeButton", {
    elementType: Eo,
    externalForwardedProps: E,
    ownerState: S
  }), [D, R] = bn("closeIcon", {
    elementType: AP,
    externalForwardedProps: E,
    ownerState: S
  });
  return /* @__PURE__ */ ie(TB, {
    role: b,
    elevation: 0,
    ownerState: S,
    className: ae(T.root, a),
    ref: n,
    ...x,
    children: [f !== !1 ? /* @__PURE__ */ C(RB, {
      ownerState: S,
      className: T.icon,
      children: f || p[v] || hx[v]
    }) : null, /* @__PURE__ */ C(EB, {
      ownerState: S,
      className: T.message,
      children: i
    }), s != null ? /* @__PURE__ */ C(px, {
      ownerState: S,
      className: T.action,
      children: s
    }) : null, s == null && m ? /* @__PURE__ */ C(px, {
      ownerState: S,
      className: T.action,
      children: /* @__PURE__ */ C(O, {
        size: "small",
        "aria-label": l,
        title: l,
        color: "inherit",
        onClick: m,
        ...M,
        children: /* @__PURE__ */ C(D, {
          fontSize: "small",
          ...R
        })
      })
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (FP.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: r.node,
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: r.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: r.oneOfType([r.oneOf(["error", "info", "success", "warning"]), r.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: r.shape({
    CloseButton: r.elementType,
    CloseIcon: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: r.shape({
    closeButton: r.object,
    closeIcon: r.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: r.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: r.shape({
    error: r.node,
    info: r.node,
    success: r.node,
    warning: r.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: r.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: r.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: r.oneOfType([r.oneOf(["error", "info", "success", "warning"]), r.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    closeButton: r.oneOfType([r.func, r.object]),
    closeIcon: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    closeButton: r.elementType,
    closeIcon: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: r.oneOfType([r.oneOf(["filled", "outlined", "standard"]), r.string])
});
function IB(e) {
  return De("MuiTypography", e);
}
const gx = Ne("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), OB = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, PB = m5(), MB = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: o,
    paragraph: s,
    variant: i,
    classes: a
  } = e, l = {
    root: ["root", i, e.align !== "inherit" && `align${ce(t)}`, n && "gutterBottom", o && "noWrap", s && "paragraph"]
  };
  return fe(l, IB, a);
}, kB = te("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${ce(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(Fe(({
  theme: e
}) => {
  var t;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(e.typography).filter(([n, o]) => n !== "inherit" && o && typeof o == "object").map(([n, o]) => ({
      props: {
        variant: n
      },
      style: o
    })), ...Object.entries(e.palette).filter($t()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main
      }
    })), ...Object.entries(((t = e.palette) == null ? void 0 : t.text) || {}).filter(([, n]) => typeof n == "string").map(([n]) => ({
      props: {
        color: `text${ce(n)}`
      },
      style: {
        color: (e.vars || e).palette.text[n]
      }
    })), {
      props: ({
        ownerState: n
      }) => n.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: n
      }) => n.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), mx = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, yn = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    color: o,
    ...s
  } = Be({
    props: t,
    name: "MuiTypography"
  }), i = !OB[o], a = PB({
    ...s,
    ...i && {
      color: o
    }
  }), {
    align: l = "inherit",
    className: c,
    component: u,
    gutterBottom: d = !1,
    noWrap: f = !1,
    paragraph: p = !1,
    variant: m = "body1",
    variantMapping: b = mx,
    ...v
  } = a, g = {
    ...a,
    align: l,
    color: o,
    className: c,
    component: u,
    gutterBottom: d,
    noWrap: f,
    paragraph: p,
    variant: m,
    variantMapping: b
  }, y = u || (p ? "p" : b[m] || mx[m]) || "span", w = MB(g);
  return /* @__PURE__ */ C(kB, {
    as: y,
    ref: n,
    className: ae(w.root, c),
    ...v,
    ownerState: g,
    style: {
      ...l !== "inherit" && {
        "--Typography-textAlign": l
      },
      ...v.style
    }
  });
});
process.env.NODE_ENV !== "production" && (yn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: r.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: r.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: r.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: r.bool,
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: r.oneOfType([r.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), r.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: r.object
});
function DB(e) {
  return De("MuiAppBar", e);
}
Ne("MuiAppBar", ["root", "positionFixed", "positionAbsolute", "positionSticky", "positionStatic", "positionRelative", "colorDefault", "colorPrimary", "colorSecondary", "colorInherit", "colorTransparent", "colorError", "colorInfo", "colorSuccess", "colorWarning"]);
const NB = (e) => {
  const {
    color: t,
    position: n,
    classes: o
  } = e, s = {
    root: ["root", `color${ce(t)}`, `position${ce(n)}`]
  };
  return fe(s, DB, o);
}, bx = (e, t) => e ? `${e == null ? void 0 : e.replace(")", "")}, ${t})` : t, $B = te(ao, {
  name: "MuiAppBar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`position${ce(n.position)}`], t[`color${ce(n.color)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  boxSizing: "border-box",
  // Prevent padding issue with the Modal and fixed positioned AppBar.
  flexShrink: 0,
  variants: [{
    props: {
      position: "fixed"
    },
    style: {
      position: "fixed",
      zIndex: (e.vars || e).zIndex.appBar,
      top: 0,
      left: "auto",
      right: 0,
      "@media print": {
        // Prevent the app bar to be visible on each printed page.
        position: "absolute"
      }
    }
  }, {
    props: {
      position: "absolute"
    },
    style: {
      position: "absolute",
      zIndex: (e.vars || e).zIndex.appBar,
      top: 0,
      left: "auto",
      right: 0
    }
  }, {
    props: {
      position: "sticky"
    },
    style: {
      position: "sticky",
      zIndex: (e.vars || e).zIndex.appBar,
      top: 0,
      left: "auto",
      right: 0
    }
  }, {
    props: {
      position: "static"
    },
    style: {
      position: "static"
    }
  }, {
    props: {
      position: "relative"
    },
    style: {
      position: "relative"
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      "--AppBar-color": "inherit"
    }
  }, {
    props: {
      color: "default"
    },
    style: {
      "--AppBar-background": e.vars ? e.vars.palette.AppBar.defaultBg : e.palette.grey[100],
      "--AppBar-color": e.vars ? e.vars.palette.text.primary : e.palette.getContrastText(e.palette.grey[100]),
      ...e.applyStyles("dark", {
        "--AppBar-background": e.vars ? e.vars.palette.AppBar.defaultBg : e.palette.grey[900],
        "--AppBar-color": e.vars ? e.vars.palette.text.primary : e.palette.getContrastText(e.palette.grey[900])
      })
    }
  }, ...Object.entries(e.palette).filter($t(["contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--AppBar-background": (e.vars ?? e).palette[t].main,
      "--AppBar-color": (e.vars ?? e).palette[t].contrastText
    }
  })), {
    props: (t) => t.enableColorOnDark === !0 && !["inherit", "transparent"].includes(t.color),
    style: {
      backgroundColor: "var(--AppBar-background)",
      color: "var(--AppBar-color)"
    }
  }, {
    props: (t) => t.enableColorOnDark === !1 && !["inherit", "transparent"].includes(t.color),
    style: {
      backgroundColor: "var(--AppBar-background)",
      color: "var(--AppBar-color)",
      ...e.applyStyles("dark", {
        backgroundColor: e.vars ? bx(e.vars.palette.AppBar.darkBg, "var(--AppBar-background)") : null,
        color: e.vars ? bx(e.vars.palette.AppBar.darkColor, "var(--AppBar-color)") : null
      })
    }
  }, {
    props: {
      color: "transparent"
    },
    style: {
      "--AppBar-background": "transparent",
      "--AppBar-color": "inherit",
      backgroundColor: "var(--AppBar-background)",
      color: "var(--AppBar-color)",
      ...e.applyStyles("dark", {
        backgroundImage: "none"
      })
    }
  }]
}))), LP = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiAppBar"
  }), {
    className: s,
    color: i = "primary",
    enableColorOnDark: a = !1,
    position: l = "fixed",
    ...c
  } = o, u = {
    ...o,
    color: i,
    position: l,
    enableColorOnDark: a
  }, d = NB(u);
  return /* @__PURE__ */ C($B, {
    square: !0,
    component: "header",
    ownerState: u,
    elevation: 4,
    className: ae(d.root, s, l === "fixed" && "mui-fixed"),
    ref: n,
    ...c
  });
});
process.env.NODE_ENV !== "production" && (LP.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["default", "inherit", "primary", "secondary", "transparent", "error", "info", "success", "warning"]), r.string]),
  /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */
  enableColorOnDark: r.bool,
  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */
  position: r.oneOf(["absolute", "fixed", "relative", "static", "sticky"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function yx(e) {
  return e.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function _P(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: n = !0,
    limit: o,
    matchFrom: s = "any",
    stringify: i,
    trim: a = !1
  } = e;
  return (l, {
    inputValue: c,
    getOptionLabel: u
  }) => {
    let d = a ? c.trim() : c;
    n && (d = d.toLowerCase()), t && (d = yx(d));
    const f = d ? l.filter((p) => {
      let m = (i || u)(p);
      return n && (m = m.toLowerCase()), t && (m = yx(m)), s === "start" ? m.startsWith(d) : m.includes(d);
    }) : l;
    return typeof o == "number" ? f.slice(0, o) : f;
  };
}
const AB = _P(), FB = 5, LB = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
}, _B = [];
function VB(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = LB,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: n = "Mui",
    autoComplete: o = !1,
    autoHighlight: s = !1,
    autoSelect: i = !1,
    blurOnSelect: a = !1,
    clearOnBlur: l = !e.freeSolo,
    clearOnEscape: c = !1,
    componentName: u = "useAutocomplete",
    defaultValue: d = e.multiple ? _B : null,
    disableClearable: f = !1,
    disableCloseOnSelect: p = !1,
    disabled: m,
    disabledItemsFocusable: b = !1,
    disableListWrap: v = !1,
    filterOptions: g = AB,
    filterSelectedOptions: y = !1,
    freeSolo: w = !1,
    getOptionDisabled: x,
    getOptionKey: S,
    getOptionLabel: T = (Ie) => Ie.label ?? Ie,
    groupBy: E,
    handleHomeEndKeys: O = !e.freeSolo,
    id: M,
    includeInputInList: D = !1,
    inputValue: R,
    isOptionEqualToValue: P = (Ie, Se) => Ie === Se,
    multiple: F = !1,
    onChange: $,
    onClose: N,
    onHighlightChange: A,
    onInputChange: k,
    onOpen: L,
    open: B,
    openOnFocus: V = !1,
    options: _,
    readOnly: z = !1,
    selectOnFocus: j = !e.freeSolo,
    value: W
  } = e, J = gt(M);
  let G = T;
  G = (Ie) => {
    const Se = T(Ie);
    if (typeof Se != "string") {
      if (process.env.NODE_ENV !== "production") {
        const je = Se === void 0 ? "undefined" : `${typeof Se} (${Se})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${u} returned ${je} instead of a string for ${JSON.stringify(Ie)}.`);
      }
      return String(Se);
    }
    return Se;
  };
  const q = h.useRef(!1), Z = h.useRef(!0), Y = h.useRef(null), Q = h.useRef(null), [ee, ne] = h.useState(null), [H, U] = h.useState(-1), X = s ? 0 : -1, re = h.useRef(X), [oe, le] = jn({
    controlled: W,
    default: d,
    name: u
  }), [se, Ce] = jn({
    controlled: R,
    default: "",
    name: u,
    state: "inputValue"
  }), [$e, we] = h.useState(!1), Te = h.useCallback((Ie, Se, je) => {
    if (!(F ? oe.length < Se.length : Se !== null) && !l)
      return;
    let at;
    if (F)
      at = "";
    else if (Se == null)
      at = "";
    else {
      const kt = G(Se);
      at = typeof kt == "string" ? kt : "";
    }
    se !== at && (Ce(at), k && k(Ie, at, je));
  }, [G, se, F, k, Ce, l, oe]), [ue, de] = jn({
    controlled: B,
    default: !1,
    name: u,
    state: "open"
  }), [Pe, ke] = h.useState(!0), Me = !F && oe != null && se === G(oe), be = ue && !z, me = be ? g(
    _.filter((Ie) => !(y && (F ? oe : [oe]).some((Se) => Se !== null && P(Ie, Se)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Me && Pe ? "" : se,
      getOptionLabel: G
    }
  ) : [], Ae = Ov({
    filteredOptions: me,
    value: oe,
    inputValue: se
  });
  h.useEffect(() => {
    const Ie = oe !== Ae.value;
    $e && !Ie || w && !Ie || Te(null, oe, "reset");
  }, [oe, Te, $e, Ae.value, w]);
  const ye = ue && me.length > 0 && !z, We = xe((Ie) => {
    Ie === -1 ? Y.current.focus() : ee.querySelector(`[data-tag-index="${Ie}"]`).focus();
  });
  h.useEffect(() => {
    F && H > oe.length - 1 && (U(-1), We(-1));
  }, [oe, F, H, We]);
  function He(Ie, Se) {
    if (!Q.current || Ie < 0 || Ie >= me.length)
      return -1;
    let je = Ie;
    for (; ; ) {
      const it = Q.current.querySelector(`[data-option-index="${je}"]`), at = b ? !1 : !it || it.disabled || it.getAttribute("aria-disabled") === "true";
      if (it && it.hasAttribute("tabindex") && !at)
        return je;
      if (Se === "next" ? je = (je + 1) % me.length : je = (je - 1 + me.length) % me.length, je === Ie)
        return -1;
    }
  }
  const ze = xe(({
    event: Ie,
    index: Se,
    reason: je = "auto"
  }) => {
    if (re.current = Se, Se === -1 ? Y.current.removeAttribute("aria-activedescendant") : Y.current.setAttribute("aria-activedescendant", `${J}-option-${Se}`), A && A(Ie, Se === -1 ? null : me[Se], je), !Q.current)
      return;
    const it = Q.current.querySelector(`[role="option"].${n}-focused`);
    it && (it.classList.remove(`${n}-focused`), it.classList.remove(`${n}-focusVisible`));
    let at = Q.current;
    if (Q.current.getAttribute("role") !== "listbox" && (at = Q.current.parentElement.querySelector('[role="listbox"]')), !at)
      return;
    if (Se === -1) {
      at.scrollTop = 0;
      return;
    }
    const kt = Q.current.querySelector(`[data-option-index="${Se}"]`);
    if (kt && (kt.classList.add(`${n}-focused`), je === "keyboard" && kt.classList.add(`${n}-focusVisible`), at.scrollHeight > at.clientHeight && je !== "mouse" && je !== "touch")) {
      const It = kt, Qn = at.clientHeight + at.scrollTop, ls = It.offsetTop + It.offsetHeight;
      ls > Qn ? at.scrollTop = ls - at.clientHeight : It.offsetTop - It.offsetHeight * (E ? 1.3 : 0) < at.scrollTop && (at.scrollTop = It.offsetTop - It.offsetHeight * (E ? 1.3 : 0));
    }
  }), pe = xe(({
    event: Ie,
    diff: Se,
    direction: je = "next",
    reason: it = "auto"
  }) => {
    if (!be)
      return;
    const kt = He((() => {
      const It = me.length - 1;
      if (Se === "reset")
        return X;
      if (Se === "start")
        return 0;
      if (Se === "end")
        return It;
      const Qn = re.current + Se;
      return Qn < 0 ? Qn === -1 && D ? -1 : v && re.current !== -1 || Math.abs(Se) > 1 ? 0 : It : Qn > It ? Qn === It + 1 && D ? -1 : v || Math.abs(Se) > 1 ? It : 0 : Qn;
    })(), je);
    if (ze({
      index: kt,
      reason: it,
      event: Ie
    }), o && Se !== "reset")
      if (kt === -1)
        Y.current.value = se;
      else {
        const It = G(me[kt]);
        Y.current.value = It, It.toLowerCase().indexOf(se.toLowerCase()) === 0 && se.length > 0 && Y.current.setSelectionRange(se.length, It.length);
      }
  }), Re = () => {
    const Ie = (Se, je) => {
      const it = Se ? G(Se) : "", at = je ? G(je) : "";
      return it === at;
    };
    if (re.current !== -1 && Ae.filteredOptions && Ae.filteredOptions.length !== me.length && Ae.inputValue === se && (F ? oe.length === Ae.value.length && Ae.value.every((Se, je) => G(oe[je]) === G(Se)) : Ie(Ae.value, oe))) {
      const Se = Ae.filteredOptions[re.current];
      if (Se)
        return me.findIndex((je) => G(je) === G(Se));
    }
    return -1;
  }, Ge = h.useCallback(() => {
    if (!be)
      return;
    const Ie = Re();
    if (Ie !== -1) {
      re.current = Ie;
      return;
    }
    const Se = F ? oe[0] : oe;
    if (me.length === 0 || Se == null) {
      pe({
        diff: "reset"
      });
      return;
    }
    if (Q.current) {
      if (Se != null) {
        const je = me[re.current];
        if (F && je && oe.findIndex((at) => P(je, at)) !== -1)
          return;
        const it = me.findIndex((at) => P(at, Se));
        it === -1 ? pe({
          diff: "reset"
        }) : ze({
          index: it
        });
        return;
      }
      if (re.current >= me.length - 1) {
        ze({
          index: me.length - 1
        });
        return;
      }
      ze({
        index: re.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    me.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    F ? !1 : oe,
    y,
    pe,
    ze,
    be,
    se,
    F
  ]), Qe = xe((Ie) => {
    Cf(Q, Ie), Ie && Ge();
  });
  process.env.NODE_ENV !== "production" && h.useEffect(() => {
    (!Y.current || Y.current.nodeName !== "INPUT") && (Y.current && Y.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${u} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${Y.current} while an HTMLInputElement was expected.`, `Instead, ${u} expects an input element.`, "", u === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [u]), h.useEffect(() => {
    Ge();
  }, [Ge]);
  const qe = (Ie) => {
    ue || (de(!0), ke(!0), L && L(Ie));
  }, st = (Ie, Se) => {
    ue && (de(!1), N && N(Ie, Se));
  }, wt = (Ie, Se, je, it) => {
    if (F) {
      if (oe.length === Se.length && oe.every((at, kt) => at === Se[kt]))
        return;
    } else if (oe === Se)
      return;
    $ && $(Ie, Se, je, it), le(Se);
  }, Ue = h.useRef(!1), nt = (Ie, Se, je = "selectOption", it = "options") => {
    let at = je, kt = Se;
    if (F) {
      if (kt = Array.isArray(oe) ? oe.slice() : [], process.env.NODE_ENV !== "production") {
        const Qn = kt.filter((ls) => P(Se, ls));
        Qn.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${u} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${Qn.length} matches.`].join(`
`));
      }
      const It = kt.findIndex((Qn) => P(Se, Qn));
      It === -1 ? kt.push(Se) : it !== "freeSolo" && (kt.splice(It, 1), at = "removeOption");
    }
    Te(Ie, kt, at), wt(Ie, kt, at, {
      option: Se
    }), !p && (!Ie || !Ie.ctrlKey && !Ie.metaKey) && st(Ie, at), (a === !0 || a === "touch" && Ue.current || a === "mouse" && !Ue.current) && Y.current.blur();
  };
  function ft(Ie, Se) {
    if (Ie === -1)
      return -1;
    let je = Ie;
    for (; ; ) {
      if (Se === "next" && je === oe.length || Se === "previous" && je === -1)
        return -1;
      const it = ee.querySelector(`[data-tag-index="${je}"]`);
      if (!it || !it.hasAttribute("tabindex") || it.disabled || it.getAttribute("aria-disabled") === "true")
        je += Se === "next" ? 1 : -1;
      else
        return je;
    }
  }
  const nn = (Ie, Se) => {
    if (!F)
      return;
    se === "" && st(Ie, "toggleInput");
    let je = H;
    H === -1 ? se === "" && Se === "previous" && (je = oe.length - 1) : (je += Se === "next" ? 1 : -1, je < 0 && (je = 0), je === oe.length && (je = -1)), je = ft(je, Se), U(je), We(je);
  }, St = (Ie) => {
    q.current = !0, Ce(""), k && k(Ie, "", "clear"), wt(Ie, F ? [] : null, "clear");
  }, Ke = (Ie) => (Se) => {
    if (Ie.onKeyDown && Ie.onKeyDown(Se), !Se.defaultMuiPrevented && (H !== -1 && !["ArrowLeft", "ArrowRight"].includes(Se.key) && (U(-1), We(-1)), Se.which !== 229))
      switch (Se.key) {
        case "Home":
          be && O && (Se.preventDefault(), pe({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: Se
          }));
          break;
        case "End":
          be && O && (Se.preventDefault(), pe({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: Se
          }));
          break;
        case "PageUp":
          Se.preventDefault(), pe({
            diff: -5,
            direction: "previous",
            reason: "keyboard",
            event: Se
          }), qe(Se);
          break;
        case "PageDown":
          Se.preventDefault(), pe({
            diff: FB,
            direction: "next",
            reason: "keyboard",
            event: Se
          }), qe(Se);
          break;
        case "ArrowDown":
          Se.preventDefault(), pe({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: Se
          }), qe(Se);
          break;
        case "ArrowUp":
          Se.preventDefault(), pe({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: Se
          }), qe(Se);
          break;
        case "ArrowLeft":
          nn(Se, "previous");
          break;
        case "ArrowRight":
          nn(Se, "next");
          break;
        case "Enter":
          if (re.current !== -1 && be) {
            const je = me[re.current], it = x ? x(je) : !1;
            if (Se.preventDefault(), it)
              return;
            nt(Se, je, "selectOption"), o && Y.current.setSelectionRange(Y.current.value.length, Y.current.value.length);
          } else w && se !== "" && Me === !1 && (F && Se.preventDefault(), nt(Se, se, "createOption", "freeSolo"));
          break;
        case "Escape":
          be ? (Se.preventDefault(), Se.stopPropagation(), st(Se, "escape")) : c && (se !== "" || F && oe.length > 0) && (Se.preventDefault(), Se.stopPropagation(), St(Se));
          break;
        case "Backspace":
          if (F && !z && se === "" && oe.length > 0) {
            const je = H === -1 ? oe.length - 1 : H, it = oe.slice();
            it.splice(je, 1), wt(Se, it, "removeOption", {
              option: oe[je]
            });
          }
          break;
        case "Delete":
          if (F && !z && se === "" && oe.length > 0 && H !== -1) {
            const je = H, it = oe.slice();
            it.splice(je, 1), wt(Se, it, "removeOption", {
              option: oe[je]
            });
          }
          break;
      }
  }, Ot = (Ie) => {
    we(!0), V && !q.current && qe(Ie);
  }, vn = (Ie) => {
    if (t(Q)) {
      Y.current.focus();
      return;
    }
    we(!1), Z.current = !0, q.current = !1, i && re.current !== -1 && be ? nt(Ie, me[re.current], "blur") : i && w && se !== "" ? nt(Ie, se, "blur", "freeSolo") : l && Te(Ie, oe, "blur"), st(Ie, "blur");
  }, on = (Ie) => {
    const Se = Ie.target.value;
    se !== Se && (Ce(Se), ke(!1), k && k(Ie, Se, "input")), Se === "" ? !f && !F && wt(Ie, null, "clear") : qe(Ie);
  }, Ze = (Ie) => {
    const Se = Number(Ie.currentTarget.getAttribute("data-option-index"));
    re.current !== Se && ze({
      event: Ie,
      index: Se,
      reason: "mouse"
    });
  }, ct = (Ie) => {
    ze({
      event: Ie,
      index: Number(Ie.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), Ue.current = !0;
  }, Ut = (Ie) => {
    const Se = Number(Ie.currentTarget.getAttribute("data-option-index"));
    nt(Ie, me[Se], "selectOption"), Ue.current = !1;
  }, xn = (Ie) => (Se) => {
    const je = oe.slice();
    je.splice(Ie, 1), wt(Se, je, "removeOption", {
      option: oe[Ie]
    });
  }, Fn = (Ie) => {
    ue ? st(Ie, "toggleInput") : qe(Ie);
  }, Rn = (Ie) => {
    Ie.currentTarget.contains(Ie.target) && Ie.target.getAttribute("id") !== J && Ie.preventDefault();
  }, Tn = (Ie) => {
    Ie.currentTarget.contains(Ie.target) && (Y.current.focus(), j && Z.current && Y.current.selectionEnd - Y.current.selectionStart === 0 && Y.current.select(), Z.current = !1);
  }, an = (Ie) => {
    !m && (se === "" || !ue) && Fn(Ie);
  };
  let hn = w && se.length > 0;
  hn = hn || (F ? oe.length > 0 : oe !== null);
  let tr = me;
  if (E) {
    const Ie = /* @__PURE__ */ new Map();
    let Se = !1;
    tr = me.reduce((je, it, at) => {
      const kt = E(it);
      return je.length > 0 && je[je.length - 1].group === kt ? je[je.length - 1].options.push(it) : (process.env.NODE_ENV !== "production" && (Ie.get(kt) && !Se && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${u} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), Se = !0), Ie.set(kt, !0)), je.push({
        key: at,
        index: at,
        group: kt,
        options: [it]
      })), je;
    }, []);
  }
  return m && $e && vn(), {
    getRootProps: (Ie = {}) => ({
      "aria-owns": ye ? `${J}-listbox` : null,
      ...Ie,
      onKeyDown: Ke(Ie),
      onMouseDown: Rn,
      onClick: Tn
    }),
    getInputLabelProps: () => ({
      id: `${J}-label`,
      htmlFor: J
    }),
    getInputProps: () => ({
      id: J,
      value: se,
      onBlur: vn,
      onFocus: Ot,
      onChange: on,
      onMouseDown: an,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": be ? "" : null,
      "aria-autocomplete": o ? "both" : "list",
      "aria-controls": ye ? `${J}-listbox` : void 0,
      "aria-expanded": ye,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: Y,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: m
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: St
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Fn
    }),
    getTagProps: ({
      index: Ie
    }) => ({
      key: Ie,
      "data-tag-index": Ie,
      tabIndex: -1,
      ...!z && {
        onDelete: xn(Ie)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${J}-listbox`,
      "aria-labelledby": `${J}-label`,
      ref: Qe,
      onMouseDown: (Ie) => {
        Ie.preventDefault();
      }
    }),
    getOptionProps: ({
      index: Ie,
      option: Se
    }) => {
      const je = (F ? oe : [oe]).some((at) => at != null && P(Se, at)), it = x ? x(Se) : !1;
      return {
        key: (S == null ? void 0 : S(Se)) ?? G(Se),
        tabIndex: -1,
        role: "option",
        id: `${J}-option-${Ie}`,
        onMouseMove: Ze,
        onClick: Ut,
        onTouchStart: ct,
        "data-option-index": Ie,
        "aria-disabled": it,
        "aria-selected": je
      };
    },
    id: J,
    inputValue: se,
    value: oe,
    dirty: hn,
    expanded: be && ee,
    popupOpen: be,
    focused: $e || H !== -1,
    anchorEl: ee,
    setAnchorEl: ne,
    focusedTag: H,
    groupedOptions: tr
  };
}
var Oo = "top", mr = "bottom", br = "right", Po = "left", zv = "auto", Cu = [Oo, mr, br, Po], Xa = "start", Bc = "end", BB = "clippingParents", VP = "viewport", Ll = "popper", zB = "reference", vx = /* @__PURE__ */ Cu.reduce(function(e, t) {
  return e.concat([t + "-" + Xa, t + "-" + Bc]);
}, []), BP = /* @__PURE__ */ [].concat(Cu, [zv]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Xa, t + "-" + Bc]);
}, []), HB = "beforeRead", jB = "read", GB = "afterRead", qB = "beforeMain", WB = "main", UB = "afterMain", KB = "beforeWrite", YB = "write", XB = "afterWrite", QB = [HB, jB, GB, qB, WB, UB, KB, YB, XB];
function es(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Yo(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Li(e) {
  var t = Yo(e).Element;
  return e instanceof t || e instanceof Element;
}
function gr(e) {
  var t = Yo(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Hv(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Yo(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function ZB(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var o = t.styles[n] || {}, s = t.attributes[n] || {}, i = t.elements[n];
    !gr(i) || !es(i) || (Object.assign(i.style, o), Object.keys(s).forEach(function(a) {
      var l = s[a];
      l === !1 ? i.removeAttribute(a) : i.setAttribute(a, l === !0 ? "" : l);
    }));
  });
}
function JB(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(o) {
      var s = t.elements[o], i = t.attributes[o] || {}, a = Object.keys(t.styles.hasOwnProperty(o) ? t.styles[o] : n[o]), l = a.reduce(function(c, u) {
        return c[u] = "", c;
      }, {});
      !gr(s) || !es(s) || (Object.assign(s.style, l), Object.keys(i).forEach(function(c) {
        s.removeAttribute(c);
      }));
    });
  };
}
const e4 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: ZB,
  effect: JB,
  requires: ["computeStyles"]
};
function Kr(e) {
  return e.split("-")[0];
}
var Mi = Math.max, Tf = Math.min, Qa = Math.round;
function oy() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function zP() {
  return !/^((?!chrome|android).)*safari/i.test(oy());
}
function Za(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var o = e.getBoundingClientRect(), s = 1, i = 1;
  t && gr(e) && (s = e.offsetWidth > 0 && Qa(o.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && Qa(o.height) / e.offsetHeight || 1);
  var a = Li(e) ? Yo(e) : window, l = a.visualViewport, c = !zP() && n, u = (o.left + (c && l ? l.offsetLeft : 0)) / s, d = (o.top + (c && l ? l.offsetTop : 0)) / i, f = o.width / s, p = o.height / i;
  return {
    width: f,
    height: p,
    top: d,
    right: u + f,
    bottom: d + p,
    left: u,
    x: u,
    y: d
  };
}
function jv(e) {
  var t = Za(e), n = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - o) <= 1 && (o = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: o
  };
}
function HP(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Hv(n)) {
    var o = t;
    do {
      if (o && e.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function ys(e) {
  return Yo(e).getComputedStyle(e);
}
function t4(e) {
  return ["table", "td", "th"].indexOf(es(e)) >= 0;
}
function ei(e) {
  return ((Li(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ip(e) {
  return es(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Hv(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ei(e)
  );
}
function Cx(e) {
  return !gr(e) || // https://github.com/popperjs/popper-core/issues/837
  ys(e).position === "fixed" ? null : e.offsetParent;
}
function n4(e) {
  var t = /firefox/i.test(oy()), n = /Trident/i.test(oy());
  if (n && gr(e)) {
    var o = ys(e);
    if (o.position === "fixed")
      return null;
  }
  var s = Ip(e);
  for (Hv(s) && (s = s.host); gr(s) && ["html", "body"].indexOf(es(s)) < 0; ) {
    var i = ys(s);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function wu(e) {
  for (var t = Yo(e), n = Cx(e); n && t4(n) && ys(n).position === "static"; )
    n = Cx(n);
  return n && (es(n) === "html" || es(n) === "body" && ys(n).position === "static") ? t : n || n4(e) || t;
}
function Gv(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function xc(e, t, n) {
  return Mi(e, Tf(t, n));
}
function o4(e, t, n) {
  var o = xc(e, t, n);
  return o > n ? n : o;
}
function jP() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function GP(e) {
  return Object.assign({}, jP(), e);
}
function qP(e, t) {
  return t.reduce(function(n, o) {
    return n[o] = e, n;
  }, {});
}
var r4 = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, GP(typeof t != "number" ? t : qP(t, Cu));
};
function s4(e) {
  var t, n = e.state, o = e.name, s = e.options, i = n.elements.arrow, a = n.modifiersData.popperOffsets, l = Kr(n.placement), c = Gv(l), u = [Po, br].indexOf(l) >= 0, d = u ? "height" : "width";
  if (!(!i || !a)) {
    var f = r4(s.padding, n), p = jv(i), m = c === "y" ? Oo : Po, b = c === "y" ? mr : br, v = n.rects.reference[d] + n.rects.reference[c] - a[c] - n.rects.popper[d], g = a[c] - n.rects.reference[c], y = wu(i), w = y ? c === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, x = v / 2 - g / 2, S = f[m], T = w - p[d] - f[b], E = w / 2 - p[d] / 2 + x, O = xc(S, E, T), M = c;
    n.modifiersData[o] = (t = {}, t[M] = O, t.centerOffset = O - E, t);
  }
}
function i4(e) {
  var t = e.state, n = e.options, o = n.element, s = o === void 0 ? "[data-popper-arrow]" : o;
  s != null && (typeof s == "string" && (s = t.elements.popper.querySelector(s), !s) || HP(t.elements.popper, s) && (t.elements.arrow = s));
}
const a4 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: s4,
  effect: i4,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ja(e) {
  return e.split("-")[1];
}
var l4 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function c4(e, t) {
  var n = e.x, o = e.y, s = t.devicePixelRatio || 1;
  return {
    x: Qa(n * s) / s || 0,
    y: Qa(o * s) / s || 0
  };
}
function wx(e) {
  var t, n = e.popper, o = e.popperRect, s = e.placement, i = e.variation, a = e.offsets, l = e.position, c = e.gpuAcceleration, u = e.adaptive, d = e.roundOffsets, f = e.isFixed, p = a.x, m = p === void 0 ? 0 : p, b = a.y, v = b === void 0 ? 0 : b, g = typeof d == "function" ? d({
    x: m,
    y: v
  }) : {
    x: m,
    y: v
  };
  m = g.x, v = g.y;
  var y = a.hasOwnProperty("x"), w = a.hasOwnProperty("y"), x = Po, S = Oo, T = window;
  if (u) {
    var E = wu(n), O = "clientHeight", M = "clientWidth";
    if (E === Yo(n) && (E = ei(n), ys(E).position !== "static" && l === "absolute" && (O = "scrollHeight", M = "scrollWidth")), E = E, s === Oo || (s === Po || s === br) && i === Bc) {
      S = mr;
      var D = f && E === T && T.visualViewport ? T.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        E[O]
      );
      v -= D - o.height, v *= c ? 1 : -1;
    }
    if (s === Po || (s === Oo || s === mr) && i === Bc) {
      x = br;
      var R = f && E === T && T.visualViewport ? T.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        E[M]
      );
      m -= R - o.width, m *= c ? 1 : -1;
    }
  }
  var P = Object.assign({
    position: l
  }, u && l4), F = d === !0 ? c4({
    x: m,
    y: v
  }, Yo(n)) : {
    x: m,
    y: v
  };
  if (m = F.x, v = F.y, c) {
    var $;
    return Object.assign({}, P, ($ = {}, $[S] = w ? "0" : "", $[x] = y ? "0" : "", $.transform = (T.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + v + "px)" : "translate3d(" + m + "px, " + v + "px, 0)", $));
  }
  return Object.assign({}, P, (t = {}, t[S] = w ? v + "px" : "", t[x] = y ? m + "px" : "", t.transform = "", t));
}
function u4(e) {
  var t = e.state, n = e.options, o = n.gpuAcceleration, s = o === void 0 ? !0 : o, i = n.adaptive, a = i === void 0 ? !0 : i, l = n.roundOffsets, c = l === void 0 ? !0 : l, u = {
    placement: Kr(t.placement),
    variation: Ja(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: s,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, wx(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: a,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, wx(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const d4 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: u4,
  data: {}
};
var ud = {
  passive: !0
};
function f4(e) {
  var t = e.state, n = e.instance, o = e.options, s = o.scroll, i = s === void 0 ? !0 : s, a = o.resize, l = a === void 0 ? !0 : a, c = Yo(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(d) {
    d.addEventListener("scroll", n.update, ud);
  }), l && c.addEventListener("resize", n.update, ud), function() {
    i && u.forEach(function(d) {
      d.removeEventListener("scroll", n.update, ud);
    }), l && c.removeEventListener("resize", n.update, ud);
  };
}
const p4 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: f4,
  data: {}
};
var h4 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Zd(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return h4[t];
  });
}
var g4 = {
  start: "end",
  end: "start"
};
function Sx(e) {
  return e.replace(/start|end/g, function(t) {
    return g4[t];
  });
}
function qv(e) {
  var t = Yo(e), n = t.pageXOffset, o = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: o
  };
}
function Wv(e) {
  return Za(ei(e)).left + qv(e).scrollLeft;
}
function m4(e, t) {
  var n = Yo(e), o = ei(e), s = n.visualViewport, i = o.clientWidth, a = o.clientHeight, l = 0, c = 0;
  if (s) {
    i = s.width, a = s.height;
    var u = zP();
    (u || !u && t === "fixed") && (l = s.offsetLeft, c = s.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: l + Wv(e),
    y: c
  };
}
function b4(e) {
  var t, n = ei(e), o = qv(e), s = (t = e.ownerDocument) == null ? void 0 : t.body, i = Mi(n.scrollWidth, n.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), a = Mi(n.scrollHeight, n.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), l = -o.scrollLeft + Wv(e), c = -o.scrollTop;
  return ys(s || n).direction === "rtl" && (l += Mi(n.clientWidth, s ? s.clientWidth : 0) - i), {
    width: i,
    height: a,
    x: l,
    y: c
  };
}
function Uv(e) {
  var t = ys(e), n = t.overflow, o = t.overflowX, s = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + s + o);
}
function WP(e) {
  return ["html", "body", "#document"].indexOf(es(e)) >= 0 ? e.ownerDocument.body : gr(e) && Uv(e) ? e : WP(Ip(e));
}
function Tc(e, t) {
  var n;
  t === void 0 && (t = []);
  var o = WP(e), s = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Yo(o), a = s ? [i].concat(i.visualViewport || [], Uv(o) ? o : []) : o, l = t.concat(a);
  return s ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(Tc(Ip(a)))
  );
}
function ry(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function y4(e, t) {
  var n = Za(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function xx(e, t, n) {
  return t === VP ? ry(m4(e, n)) : Li(t) ? y4(t, n) : ry(b4(ei(e)));
}
function v4(e) {
  var t = Tc(Ip(e)), n = ["absolute", "fixed"].indexOf(ys(e).position) >= 0, o = n && gr(e) ? wu(e) : e;
  return Li(o) ? t.filter(function(s) {
    return Li(s) && HP(s, o) && es(s) !== "body";
  }) : [];
}
function C4(e, t, n, o) {
  var s = t === "clippingParents" ? v4(e) : [].concat(t), i = [].concat(s, [n]), a = i[0], l = i.reduce(function(c, u) {
    var d = xx(e, u, o);
    return c.top = Mi(d.top, c.top), c.right = Tf(d.right, c.right), c.bottom = Tf(d.bottom, c.bottom), c.left = Mi(d.left, c.left), c;
  }, xx(e, a, o));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function UP(e) {
  var t = e.reference, n = e.element, o = e.placement, s = o ? Kr(o) : null, i = o ? Ja(o) : null, a = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, c;
  switch (s) {
    case Oo:
      c = {
        x: a,
        y: t.y - n.height
      };
      break;
    case mr:
      c = {
        x: a,
        y: t.y + t.height
      };
      break;
    case br:
      c = {
        x: t.x + t.width,
        y: l
      };
      break;
    case Po:
      c = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var u = s ? Gv(s) : null;
  if (u != null) {
    var d = u === "y" ? "height" : "width";
    switch (i) {
      case Xa:
        c[u] = c[u] - (t[d] / 2 - n[d] / 2);
        break;
      case Bc:
        c[u] = c[u] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return c;
}
function zc(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, s = o === void 0 ? e.placement : o, i = n.strategy, a = i === void 0 ? e.strategy : i, l = n.boundary, c = l === void 0 ? BB : l, u = n.rootBoundary, d = u === void 0 ? VP : u, f = n.elementContext, p = f === void 0 ? Ll : f, m = n.altBoundary, b = m === void 0 ? !1 : m, v = n.padding, g = v === void 0 ? 0 : v, y = GP(typeof g != "number" ? g : qP(g, Cu)), w = p === Ll ? zB : Ll, x = e.rects.popper, S = e.elements[b ? w : p], T = C4(Li(S) ? S : S.contextElement || ei(e.elements.popper), c, d, a), E = Za(e.elements.reference), O = UP({
    reference: E,
    element: x,
    placement: s
  }), M = ry(Object.assign({}, x, O)), D = p === Ll ? M : E, R = {
    top: T.top - D.top + y.top,
    bottom: D.bottom - T.bottom + y.bottom,
    left: T.left - D.left + y.left,
    right: D.right - T.right + y.right
  }, P = e.modifiersData.offset;
  if (p === Ll && P) {
    var F = P[s];
    Object.keys(R).forEach(function($) {
      var N = [br, mr].indexOf($) >= 0 ? 1 : -1, A = [Oo, mr].indexOf($) >= 0 ? "y" : "x";
      R[$] += F[A] * N;
    });
  }
  return R;
}
function w4(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, s = n.boundary, i = n.rootBoundary, a = n.padding, l = n.flipVariations, c = n.allowedAutoPlacements, u = c === void 0 ? BP : c, d = Ja(o), f = d ? l ? vx : vx.filter(function(b) {
    return Ja(b) === d;
  }) : Cu, p = f.filter(function(b) {
    return u.indexOf(b) >= 0;
  });
  p.length === 0 && (p = f);
  var m = p.reduce(function(b, v) {
    return b[v] = zc(e, {
      placement: v,
      boundary: s,
      rootBoundary: i,
      padding: a
    })[Kr(v)], b;
  }, {});
  return Object.keys(m).sort(function(b, v) {
    return m[b] - m[v];
  });
}
function S4(e) {
  if (Kr(e) === zv)
    return [];
  var t = Zd(e);
  return [Sx(e), t, Sx(t)];
}
function x4(e) {
  var t = e.state, n = e.options, o = e.name;
  if (!t.modifiersData[o]._skip) {
    for (var s = n.mainAxis, i = s === void 0 ? !0 : s, a = n.altAxis, l = a === void 0 ? !0 : a, c = n.fallbackPlacements, u = n.padding, d = n.boundary, f = n.rootBoundary, p = n.altBoundary, m = n.flipVariations, b = m === void 0 ? !0 : m, v = n.allowedAutoPlacements, g = t.options.placement, y = Kr(g), w = y === g, x = c || (w || !b ? [Zd(g)] : S4(g)), S = [g].concat(x).reduce(function(J, G) {
      return J.concat(Kr(G) === zv ? w4(t, {
        placement: G,
        boundary: d,
        rootBoundary: f,
        padding: u,
        flipVariations: b,
        allowedAutoPlacements: v
      }) : G);
    }, []), T = t.rects.reference, E = t.rects.popper, O = /* @__PURE__ */ new Map(), M = !0, D = S[0], R = 0; R < S.length; R++) {
      var P = S[R], F = Kr(P), $ = Ja(P) === Xa, N = [Oo, mr].indexOf(F) >= 0, A = N ? "width" : "height", k = zc(t, {
        placement: P,
        boundary: d,
        rootBoundary: f,
        altBoundary: p,
        padding: u
      }), L = N ? $ ? br : Po : $ ? mr : Oo;
      T[A] > E[A] && (L = Zd(L));
      var B = Zd(L), V = [];
      if (i && V.push(k[F] <= 0), l && V.push(k[L] <= 0, k[B] <= 0), V.every(function(J) {
        return J;
      })) {
        D = P, M = !1;
        break;
      }
      O.set(P, V);
    }
    if (M)
      for (var _ = b ? 3 : 1, z = function(G) {
        var q = S.find(function(Z) {
          var Y = O.get(Z);
          if (Y)
            return Y.slice(0, G).every(function(Q) {
              return Q;
            });
        });
        if (q)
          return D = q, "break";
      }, j = _; j > 0; j--) {
        var W = z(j);
        if (W === "break") break;
      }
    t.placement !== D && (t.modifiersData[o]._skip = !0, t.placement = D, t.reset = !0);
  }
}
const T4 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: x4,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Tx(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Rx(e) {
  return [Oo, br, mr, Po].some(function(t) {
    return e[t] >= 0;
  });
}
function R4(e) {
  var t = e.state, n = e.name, o = t.rects.reference, s = t.rects.popper, i = t.modifiersData.preventOverflow, a = zc(t, {
    elementContext: "reference"
  }), l = zc(t, {
    altBoundary: !0
  }), c = Tx(a, o), u = Tx(l, s, i), d = Rx(c), f = Rx(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: u,
    isReferenceHidden: d,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": f
  });
}
const E4 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: R4
};
function I4(e, t, n) {
  var o = Kr(e), s = [Po, Oo].indexOf(o) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, a = i[0], l = i[1];
  return a = a || 0, l = (l || 0) * s, [Po, br].indexOf(o) >= 0 ? {
    x: l,
    y: a
  } : {
    x: a,
    y: l
  };
}
function O4(e) {
  var t = e.state, n = e.options, o = e.name, s = n.offset, i = s === void 0 ? [0, 0] : s, a = BP.reduce(function(d, f) {
    return d[f] = I4(f, t.rects, i), d;
  }, {}), l = a[t.placement], c = l.x, u = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += u), t.modifiersData[o] = a;
}
const P4 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: O4
};
function M4(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = UP({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const k4 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: M4,
  data: {}
};
function D4(e) {
  return e === "x" ? "y" : "x";
}
function N4(e) {
  var t = e.state, n = e.options, o = e.name, s = n.mainAxis, i = s === void 0 ? !0 : s, a = n.altAxis, l = a === void 0 ? !1 : a, c = n.boundary, u = n.rootBoundary, d = n.altBoundary, f = n.padding, p = n.tether, m = p === void 0 ? !0 : p, b = n.tetherOffset, v = b === void 0 ? 0 : b, g = zc(t, {
    boundary: c,
    rootBoundary: u,
    padding: f,
    altBoundary: d
  }), y = Kr(t.placement), w = Ja(t.placement), x = !w, S = Gv(y), T = D4(S), E = t.modifiersData.popperOffsets, O = t.rects.reference, M = t.rects.popper, D = typeof v == "function" ? v(Object.assign({}, t.rects, {
    placement: t.placement
  })) : v, R = typeof D == "number" ? {
    mainAxis: D,
    altAxis: D
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, D), P = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, F = {
    x: 0,
    y: 0
  };
  if (E) {
    if (i) {
      var $, N = S === "y" ? Oo : Po, A = S === "y" ? mr : br, k = S === "y" ? "height" : "width", L = E[S], B = L + g[N], V = L - g[A], _ = m ? -M[k] / 2 : 0, z = w === Xa ? O[k] : M[k], j = w === Xa ? -M[k] : -O[k], W = t.elements.arrow, J = m && W ? jv(W) : {
        width: 0,
        height: 0
      }, G = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : jP(), q = G[N], Z = G[A], Y = xc(0, O[k], J[k]), Q = x ? O[k] / 2 - _ - Y - q - R.mainAxis : z - Y - q - R.mainAxis, ee = x ? -O[k] / 2 + _ + Y + Z + R.mainAxis : j + Y + Z + R.mainAxis, ne = t.elements.arrow && wu(t.elements.arrow), H = ne ? S === "y" ? ne.clientTop || 0 : ne.clientLeft || 0 : 0, U = ($ = P == null ? void 0 : P[S]) != null ? $ : 0, X = L + Q - U - H, re = L + ee - U, oe = xc(m ? Tf(B, X) : B, L, m ? Mi(V, re) : V);
      E[S] = oe, F[S] = oe - L;
    }
    if (l) {
      var le, se = S === "x" ? Oo : Po, Ce = S === "x" ? mr : br, $e = E[T], we = T === "y" ? "height" : "width", Te = $e + g[se], ue = $e - g[Ce], de = [Oo, Po].indexOf(y) !== -1, Pe = (le = P == null ? void 0 : P[T]) != null ? le : 0, ke = de ? Te : $e - O[we] - M[we] - Pe + R.altAxis, Me = de ? $e + O[we] + M[we] - Pe - R.altAxis : ue, be = m && de ? o4(ke, $e, Me) : xc(m ? ke : Te, $e, m ? Me : ue);
      E[T] = be, F[T] = be - $e;
    }
    t.modifiersData[o] = F;
  }
}
const $4 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: N4,
  requiresIfExists: ["offset"]
};
function A4(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function F4(e) {
  return e === Yo(e) || !gr(e) ? qv(e) : A4(e);
}
function L4(e) {
  var t = e.getBoundingClientRect(), n = Qa(t.width) / e.offsetWidth || 1, o = Qa(t.height) / e.offsetHeight || 1;
  return n !== 1 || o !== 1;
}
function _4(e, t, n) {
  n === void 0 && (n = !1);
  var o = gr(t), s = gr(t) && L4(t), i = ei(t), a = Za(e, s, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (o || !o && !n) && ((es(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Uv(i)) && (l = F4(t)), gr(t) ? (c = Za(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : i && (c.x = Wv(i))), {
    x: a.left + l.scrollLeft - c.x,
    y: a.top + l.scrollTop - c.y,
    width: a.width,
    height: a.height
  };
}
function V4(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function s(i) {
    n.add(i.name);
    var a = [].concat(i.requires || [], i.requiresIfExists || []);
    a.forEach(function(l) {
      if (!n.has(l)) {
        var c = t.get(l);
        c && s(c);
      }
    }), o.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || s(i);
  }), o;
}
function B4(e) {
  var t = V4(e);
  return QB.reduce(function(n, o) {
    return n.concat(t.filter(function(s) {
      return s.phase === o;
    }));
  }, []);
}
function z4(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function H4(e) {
  var t = e.reduce(function(n, o) {
    var s = n[o.name];
    return n[o.name] = s ? Object.assign({}, s, o, {
      options: Object.assign({}, s.options, o.options),
      data: Object.assign({}, s.data, o.data)
    }) : o, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Ex = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Ix() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function j4(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, o = n === void 0 ? [] : n, s = t.defaultOptions, i = s === void 0 ? Ex : s;
  return function(l, c, u) {
    u === void 0 && (u = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Ex, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: c
      },
      attributes: {},
      styles: {}
    }, f = [], p = !1, m = {
      state: d,
      setOptions: function(y) {
        var w = typeof y == "function" ? y(d.options) : y;
        v(), d.options = Object.assign({}, i, d.options, w), d.scrollParents = {
          reference: Li(l) ? Tc(l) : l.contextElement ? Tc(l.contextElement) : [],
          popper: Tc(c)
        };
        var x = B4(H4([].concat(o, d.options.modifiers)));
        return d.orderedModifiers = x.filter(function(S) {
          return S.enabled;
        }), b(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var y = d.elements, w = y.reference, x = y.popper;
          if (Ix(w, x)) {
            d.rects = {
              reference: _4(w, wu(x), d.options.strategy === "fixed"),
              popper: jv(x)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(R) {
              return d.modifiersData[R.name] = Object.assign({}, R.data);
            });
            for (var S = 0; S < d.orderedModifiers.length; S++) {
              if (d.reset === !0) {
                d.reset = !1, S = -1;
                continue;
              }
              var T = d.orderedModifiers[S], E = T.fn, O = T.options, M = O === void 0 ? {} : O, D = T.name;
              typeof E == "function" && (d = E({
                state: d,
                options: M,
                name: D,
                instance: m
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: z4(function() {
        return new Promise(function(g) {
          m.forceUpdate(), g(d);
        });
      }),
      destroy: function() {
        v(), p = !0;
      }
    };
    if (!Ix(l, c))
      return m;
    m.setOptions(u).then(function(g) {
      !p && u.onFirstUpdate && u.onFirstUpdate(g);
    });
    function b() {
      d.orderedModifiers.forEach(function(g) {
        var y = g.name, w = g.options, x = w === void 0 ? {} : w, S = g.effect;
        if (typeof S == "function") {
          var T = S({
            state: d,
            name: y,
            instance: m,
            options: x
          }), E = function() {
          };
          f.push(T || E);
        }
      });
    }
    function v() {
      f.forEach(function(g) {
        return g();
      }), f = [];
    }
    return m;
  };
}
var G4 = [p4, k4, d4, e4, P4, T4, $4, a4, E4], q4 = /* @__PURE__ */ j4({
  defaultModifiers: G4
});
function W4(e) {
  return typeof e == "function" ? e() : e;
}
const Hc = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    children: o,
    container: s,
    disablePortal: i = !1
  } = t, [a, l] = h.useState(null), c = tt(/* @__PURE__ */ h.isValidElement(o) ? Rs(o) : null, n);
  if (yt(() => {
    i || l(W4(s) || document.body);
  }, [s, i]), yt(() => {
    if (a && !i)
      return Cf(n, a), () => {
        Cf(n, null);
      };
  }, [n, a, i]), i) {
    if (/* @__PURE__ */ h.isValidElement(o)) {
      const u = {
        ref: c
      };
      return /* @__PURE__ */ h.cloneElement(o, u);
    }
    return o;
  }
  return a && /* @__PURE__ */ IO.createPortal(o, a);
});
process.env.NODE_ENV !== "production" && (Hc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: r.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: r.oneOfType([Ko, r.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: r.bool
});
process.env.NODE_ENV !== "production" && (Hc.propTypes = hl(Hc.propTypes));
function U4(e) {
  return De("MuiPopper", e);
}
Ne("MuiPopper", ["root"]);
function K4(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function Rf(e) {
  return typeof e == "function" ? e() : e;
}
function Op(e) {
  return e.nodeType !== void 0;
}
function Y4(e) {
  return !Op(e);
}
const X4 = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, U4, t);
}, Q4 = {}, Z4 = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    anchorEl: o,
    children: s,
    direction: i,
    disablePortal: a,
    modifiers: l,
    open: c,
    placement: u,
    popperOptions: d,
    popperRef: f,
    slotProps: p = {},
    slots: m = {},
    TransitionProps: b,
    // @ts-ignore internal logic
    ownerState: v,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...g
  } = t, y = h.useRef(null), w = tt(y, n), x = h.useRef(null), S = tt(x, f), T = h.useRef(S);
  yt(() => {
    T.current = S;
  }, [S]), h.useImperativeHandle(f, () => x.current, []);
  const E = K4(u, i), [O, M] = h.useState(E), [D, R] = h.useState(Rf(o));
  h.useEffect(() => {
    x.current && x.current.forceUpdate();
  }), h.useEffect(() => {
    o && R(Rf(o));
  }, [o]), yt(() => {
    if (!D || !c)
      return;
    const A = (B) => {
      M(B.placement);
    };
    if (process.env.NODE_ENV !== "production" && D && Op(D) && D.nodeType === 1) {
      const B = D.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && B.top === 0 && B.left === 0 && B.right === 0 && B.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let k = [{
      name: "preventOverflow",
      options: {
        altBoundary: a
      }
    }, {
      name: "flip",
      options: {
        altBoundary: a
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: B
      }) => {
        A(B);
      }
    }];
    l != null && (k = k.concat(l)), d && d.modifiers != null && (k = k.concat(d.modifiers));
    const L = q4(D, y.current, {
      placement: E,
      ...d,
      modifiers: k
    });
    return T.current(L), () => {
      L.destroy(), T.current(null);
    };
  }, [D, a, l, c, d, E]);
  const P = {
    placement: O
  };
  b !== null && (P.TransitionProps = b);
  const F = X4(t), $ = m.root ?? "div", N = et({
    elementType: $,
    externalSlotProps: p.root,
    externalForwardedProps: g,
    additionalProps: {
      role: "tooltip",
      ref: w
    },
    ownerState: t,
    className: F.root
  });
  return /* @__PURE__ */ C($, {
    ...N,
    children: typeof s == "function" ? s(P) : s
  });
}), KP = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    anchorEl: o,
    children: s,
    container: i,
    direction: a = "ltr",
    disablePortal: l = !1,
    keepMounted: c = !1,
    modifiers: u,
    open: d,
    placement: f = "bottom",
    popperOptions: p = Q4,
    popperRef: m,
    style: b,
    transition: v = !1,
    slotProps: g = {},
    slots: y = {},
    ...w
  } = t, [x, S] = h.useState(!0), T = () => {
    S(!1);
  }, E = () => {
    S(!0);
  };
  if (!c && !d && (!v || x))
    return null;
  let O;
  if (i)
    O = i;
  else if (o) {
    const R = Rf(o);
    O = R && Op(R) ? qt(R).body : qt(null).body;
  }
  const M = !d && c && (!v || x) ? "none" : void 0, D = v ? {
    in: d,
    onEnter: T,
    onExited: E
  } : void 0;
  return /* @__PURE__ */ C(Hc, {
    disablePortal: l,
    container: O,
    children: /* @__PURE__ */ C(Z4, {
      anchorEl: o,
      direction: a,
      disablePortal: l,
      modifiers: u,
      ref: n,
      open: v ? !x : d,
      placement: f,
      popperOptions: p,
      popperRef: m,
      slotProps: g,
      slots: y,
      ...w,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: M,
        ...b
      },
      TransitionProps: D,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && (KP.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: Gn(r.oneOfType([Ko, r.object, r.func]), (e) => {
    if (e.open) {
      const t = Rf(e.anchorEl);
      if (t && Op(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || Y4(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: r.oneOfType([r.node, r.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: r.oneOfType([Ko, r.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: r.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: r.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: r.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: r.arrayOf(r.shape({
    data: r.object,
    effect: r.func,
    enabled: r.bool,
    fn: r.func,
    name: r.any,
    options: r.object,
    phase: r.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: r.arrayOf(r.string),
    requiresIfExists: r.arrayOf(r.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: r.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: r.shape({
    modifiers: r.array,
    onFirstUpdate: r.func,
    placement: r.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: r.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Lt,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: r.shape({
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    root: r.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: r.bool
});
const J4 = te(KP, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), is = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = _t(), s = Be({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: i,
    component: a,
    components: l,
    componentsProps: c,
    container: u,
    disablePortal: d,
    keepMounted: f,
    modifiers: p,
    open: m,
    placement: b,
    popperOptions: v,
    popperRef: g,
    transition: y,
    slots: w,
    slotProps: x,
    ...S
  } = s, T = (w == null ? void 0 : w.root) ?? (l == null ? void 0 : l.Root), E = {
    anchorEl: i,
    container: u,
    disablePortal: d,
    keepMounted: f,
    modifiers: p,
    open: m,
    placement: b,
    popperOptions: v,
    popperRef: g,
    transition: y,
    ...S
  };
  return /* @__PURE__ */ C(J4, {
    as: a,
    direction: o ? "rtl" : "ltr",
    slots: {
      root: T
    },
    slotProps: x ?? c,
    ...E,
    ref: n
  });
});
process.env.NODE_ENV !== "production" && (is.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: r.oneOfType([Ko, r.object, r.func]),
  /**
   * Popper render function or node.
   */
  children: r.oneOfType([r.node, r.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: r.shape({
    Root: r.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: r.shape({
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: r.oneOfType([Ko, r.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: r.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: r.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: r.arrayOf(r.shape({
    data: r.object,
    effect: r.func,
    enabled: r.bool,
    fn: r.func,
    name: r.any,
    options: r.object,
    phase: r.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: r.arrayOf(r.string),
    requiresIfExists: r.arrayOf(r.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: r.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: r.shape({
    modifiers: r.array,
    onFirstUpdate: r.func,
    placement: r.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: r.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: Lt,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: r.shape({
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: r.bool
});
function ez(e) {
  return De("MuiListSubheader", e);
}
Ne("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const tz = (e) => {
  const {
    classes: t,
    color: n,
    disableGutters: o,
    inset: s,
    disableSticky: i
  } = e, a = {
    root: ["root", n !== "default" && `color${ce(n)}`, !o && "gutters", s && "inset", !i && "sticky"]
  };
  return fe(a, ez, t);
}, nz = te("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${ce(n.color)}`], !n.disableGutters && t.gutters, n.inset && t.inset, !n.disableSticky && t.sticky];
  }
})(Fe(({
  theme: e
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (e.vars || e).palette.background.paper
    }
  }]
}))), el = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: s,
    color: i = "default",
    component: a = "li",
    disableGutters: l = !1,
    disableSticky: c = !1,
    inset: u = !1,
    ...d
  } = o, f = {
    ...o,
    color: i,
    component: a,
    disableGutters: l,
    disableSticky: c,
    inset: u
  }, p = tz(f);
  return /* @__PURE__ */ C(nz, {
    as: a,
    className: ae(p.root, s),
    ref: n,
    ownerState: f,
    ...d
  });
});
el && (el.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (el.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: r.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: r.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: r.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const oz = _e(/* @__PURE__ */ C("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function rz(e) {
  return De("MuiChip", e);
}
const xt = Ne("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), sz = (e) => {
  const {
    classes: t,
    disabled: n,
    size: o,
    color: s,
    iconColor: i,
    onDelete: a,
    clickable: l,
    variant: c
  } = e, u = {
    root: ["root", c, n && "disabled", `size${ce(o)}`, `color${ce(s)}`, l && "clickable", l && `clickableColor${ce(s)}`, a && "deletable", a && `deletableColor${ce(s)}`, `${c}${ce(s)}`],
    label: ["label", `label${ce(o)}`],
    avatar: ["avatar", `avatar${ce(o)}`, `avatarColor${ce(s)}`],
    icon: ["icon", `icon${ce(o)}`, `iconColor${ce(i)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${ce(o)}`, `deleteIconColor${ce(s)}`, `deleteIcon${ce(c)}Color${ce(s)}`]
  };
  return fe(u, rz, t);
}, iz = te("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      color: o,
      iconColor: s,
      clickable: i,
      onDelete: a,
      size: l,
      variant: c
    } = n;
    return [{
      [`& .${xt.avatar}`]: t.avatar
    }, {
      [`& .${xt.avatar}`]: t[`avatar${ce(l)}`]
    }, {
      [`& .${xt.avatar}`]: t[`avatarColor${ce(o)}`]
    }, {
      [`& .${xt.icon}`]: t.icon
    }, {
      [`& .${xt.icon}`]: t[`icon${ce(l)}`]
    }, {
      [`& .${xt.icon}`]: t[`iconColor${ce(s)}`]
    }, {
      [`& .${xt.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${xt.deleteIcon}`]: t[`deleteIcon${ce(l)}`]
    }, {
      [`& .${xt.deleteIcon}`]: t[`deleteIconColor${ce(o)}`]
    }, {
      [`& .${xt.deleteIcon}`]: t[`deleteIcon${ce(c)}Color${ce(o)}`]
    }, t.root, t[`size${ce(l)}`], t[`color${ce(o)}`], i && t.clickable, i && o !== "default" && t[`clickableColor${ce(o)})`], a && t.deletable, a && o !== "default" && t[`deletableColor${ce(o)}`], t[c], t[`${c}${ce(o)}`]];
  }
})(Fe(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${xt.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${xt.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : t,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${xt.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${xt.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${xt.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${xt.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${xt.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : he(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : he(e.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${xt.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${xt.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(e.palette).filter($t(["contrastText"])).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        backgroundColor: (e.vars || e).palette[n].main,
        color: (e.vars || e).palette[n].contrastText,
        [`& .${xt.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].contrastTextChannel} / 0.7)` : he(e.palette[n].contrastText, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].contrastText
          }
        }
      }
    })), {
      props: (n) => n.iconColor === n.color,
      style: {
        [`& .${xt.icon}`]: {
          color: e.vars ? e.vars.palette.Chip.defaultIconColor : t
        }
      }
    }, {
      props: (n) => n.iconColor === n.color && n.color !== "default",
      style: {
        [`& .${xt.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${xt.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : he(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(e.palette).filter($t(["dark"])).map(([n]) => ({
      props: {
        color: n,
        onDelete: !0
      },
      style: {
        [`&.${xt.focusVisible}`]: {
          background: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : he(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
        },
        [`&.${xt.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : he(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[1]
        }
      }
    }, ...Object.entries(e.palette).filter($t(["dark"])).map(([n]) => ({
      props: {
        color: n,
        clickable: !0
      },
      style: {
        [`&:hover, &.${xt.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette[n].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
        [`&.${xt.clickable}:hover`]: {
          backgroundColor: (e.vars || e).palette.action.hover
        },
        [`&.${xt.focusVisible}`]: {
          backgroundColor: (e.vars || e).palette.action.focus
        },
        [`& .${xt.avatar}`]: {
          marginLeft: 4
        },
        [`& .${xt.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${xt.icon}`]: {
          marginLeft: 4
        },
        [`& .${xt.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${xt.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${xt.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(e.palette).filter($t()).map(([n]) => ({
      props: {
        variant: "outlined",
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main,
        border: `1px solid ${e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : he(e.palette[n].main, 0.7)}`,
        [`&.${xt.clickable}:hover`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette[n].main, e.palette.action.hoverOpacity)
        },
        [`&.${xt.focusVisible}`]: {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / ${e.vars.palette.action.focusOpacity})` : he(e.palette[n].main, e.palette.action.focusOpacity)
        },
        [`& .${xt.deleteIcon}`]: {
          color: e.vars ? `rgba(${e.vars.palette[n].mainChannel} / 0.7)` : he(e.palette[n].main, 0.7),
          "&:hover, &:active": {
            color: (e.vars || e).palette[n].main
          }
        }
      }
    }))]
  };
})), az = te("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      size: o
    } = n;
    return [t.label, t[`label${ce(o)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function Ox(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const Su = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiChip"
  }), {
    avatar: s,
    className: i,
    clickable: a,
    color: l = "default",
    component: c,
    deleteIcon: u,
    disabled: d = !1,
    icon: f,
    label: p,
    onClick: m,
    onDelete: b,
    onKeyDown: v,
    onKeyUp: g,
    size: y = "medium",
    variant: w = "filled",
    tabIndex: x,
    skipFocusWhenDisabled: S = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...T
  } = o, E = h.useRef(null), O = tt(E, n), M = (V) => {
    V.stopPropagation(), b && b(V);
  }, D = (V) => {
    V.currentTarget === V.target && Ox(V) && V.preventDefault(), v && v(V);
  }, R = (V) => {
    V.currentTarget === V.target && b && Ox(V) && b(V), g && g(V);
  }, P = a !== !1 && m ? !0 : a, F = P || b ? Yn : c || "div", $ = {
    ...o,
    component: F,
    disabled: d,
    size: y,
    color: l,
    iconColor: /* @__PURE__ */ h.isValidElement(f) && f.props.color || l,
    onDelete: !!b,
    clickable: P,
    variant: w
  }, N = sz($), A = F === Yn ? {
    component: c || "div",
    focusVisibleClassName: N.focusVisible,
    ...b && {
      disableRipple: !0
    }
  } : {};
  let k = null;
  b && (k = u && /* @__PURE__ */ h.isValidElement(u) ? /* @__PURE__ */ h.cloneElement(u, {
    className: ae(u.props.className, N.deleteIcon),
    onClick: M
  }) : /* @__PURE__ */ C(oz, {
    className: ae(N.deleteIcon),
    onClick: M
  }));
  let L = null;
  s && /* @__PURE__ */ h.isValidElement(s) && (L = /* @__PURE__ */ h.cloneElement(s, {
    className: ae(N.avatar, s.props.className)
  }));
  let B = null;
  return f && /* @__PURE__ */ h.isValidElement(f) && (B = /* @__PURE__ */ h.cloneElement(f, {
    className: ae(N.icon, f.props.className)
  })), process.env.NODE_ENV !== "production" && L && B && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ ie(iz, {
    as: F,
    className: ae(N.root, i),
    disabled: P && d ? !0 : void 0,
    onClick: m,
    onKeyDown: D,
    onKeyUp: R,
    ref: O,
    tabIndex: S && d ? -1 : x,
    ownerState: $,
    ...A,
    ...T,
    children: [L || B, /* @__PURE__ */ C(az, {
      className: ae(N.label),
      ownerState: $,
      children: p
    }), k]
  });
});
process.env.NODE_ENV !== "production" && (Su.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: r.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: fP,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: r.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: r.oneOfType([r.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: r.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * Icon element.
   */
  icon: r.element,
  /**
   * The content of the component.
   */
  label: r.node,
  /**
   * @ignore
   */
  onClick: r.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: r.func,
  /**
   * @ignore
   */
  onKeyDown: r.func,
  /**
   * @ignore
   */
  onKeyUp: r.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * @ignore
   */
  tabIndex: r.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: r.oneOfType([r.oneOf(["filled", "outlined"]), r.string])
});
function dd(e) {
  return parseInt(e, 10) || 0;
}
const lz = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function cz(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflowing;
}
const Kv = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    onChange: o,
    maxRows: s,
    minRows: i = 1,
    style: a,
    value: l,
    ...c
  } = t, {
    current: u
  } = h.useRef(l != null), d = h.useRef(null), f = tt(n, d), p = h.useRef(null), m = h.useRef(null), b = h.useCallback(() => {
    const y = d.current, x = Ao(y).getComputedStyle(y);
    if (x.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const S = m.current;
    S.style.width = x.width, S.value = y.value || t.placeholder || "x", S.value.slice(-1) === `
` && (S.value += " ");
    const T = x.boxSizing, E = dd(x.paddingBottom) + dd(x.paddingTop), O = dd(x.borderBottomWidth) + dd(x.borderTopWidth), M = S.scrollHeight;
    S.value = "x";
    const D = S.scrollHeight;
    let R = M;
    i && (R = Math.max(Number(i) * D, R)), s && (R = Math.min(Number(s) * D, R)), R = Math.max(R, D);
    const P = R + (T === "border-box" ? E + O : 0), F = Math.abs(R - M) <= 1;
    return {
      outerHeightStyle: P,
      overflowing: F
    };
  }, [s, i, t.placeholder]), v = h.useCallback(() => {
    const y = b();
    if (cz(y))
      return;
    const w = y.outerHeightStyle, x = d.current;
    p.current !== w && (p.current = w, x.style.height = `${w}px`), x.style.overflow = y.overflowing ? "hidden" : "";
  }, [b]);
  yt(() => {
    const y = () => {
      v();
    };
    let w;
    const x = () => {
      cancelAnimationFrame(w), w = requestAnimationFrame(() => {
        y();
      });
    }, S = Yi(y), T = d.current, E = Ao(T);
    E.addEventListener("resize", S);
    let O;
    return typeof ResizeObserver < "u" && (O = new ResizeObserver(process.env.NODE_ENV === "test" ? x : y), O.observe(T)), () => {
      S.clear(), cancelAnimationFrame(w), E.removeEventListener("resize", S), O && O.disconnect();
    };
  }, [b, v]), yt(() => {
    v();
  });
  const g = (y) => {
    u || v(), o && o(y);
  };
  return /* @__PURE__ */ ie(h.Fragment, {
    children: [/* @__PURE__ */ C("textarea", {
      value: l,
      onChange: g,
      ref: f,
      rows: i,
      style: a,
      ...c
    }), /* @__PURE__ */ C("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: m,
      tabIndex: -1,
      style: {
        ...lz.shadow,
        ...a,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
process.env.NODE_ENV !== "production" && (Kv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: r.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: r.oneOfType([r.number, r.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: r.oneOfType([r.number, r.string]),
  /**
   * @ignore
   */
  onChange: r.func,
  /**
   * @ignore
   */
  placeholder: r.string,
  /**
   * @ignore
   */
  style: r.object,
  /**
   * @ignore
   */
  value: r.oneOfType([r.arrayOf(r.string), r.number, r.string])
});
function Yr(e) {
  return typeof e == "string";
}
function Es({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((o, s) => (o[s] = e[s], n && typeof e[s] > "u" && (o[s] = n[s]), o), {});
}
const xu = /* @__PURE__ */ h.createContext(void 0);
process.env.NODE_ENV !== "production" && (xu.displayName = "FormControlContext");
function lo() {
  return h.useContext(xu);
}
function Px(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function Ef(e, t = !1) {
  return e && (Px(e.value) && e.value !== "" || t && Px(e.defaultValue) && e.defaultValue !== "");
}
function uz(e) {
  return e.startAdornment;
}
function dz(e) {
  return De("MuiInputBase", e);
}
const Un = Ne("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var Mx;
const Pp = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${ce(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, Mp = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, fz = (e) => {
  const {
    classes: t,
    color: n,
    disabled: o,
    error: s,
    endAdornment: i,
    focused: a,
    formControl: l,
    fullWidth: c,
    hiddenLabel: u,
    multiline: d,
    readOnly: f,
    size: p,
    startAdornment: m,
    type: b
  } = e, v = {
    root: ["root", `color${ce(n)}`, o && "disabled", s && "error", c && "fullWidth", a && "focused", l && "formControl", p && p !== "medium" && `size${ce(p)}`, d && "multiline", m && "adornedStart", i && "adornedEnd", u && "hiddenLabel", f && "readOnly"],
    input: ["input", o && "disabled", b === "search" && "inputTypeSearch", d && "inputMultiline", p === "small" && "inputSizeSmall", u && "inputHiddenLabel", m && "inputAdornedStart", i && "inputAdornedEnd", f && "readOnly"]
  };
  return fe(v, dz, t);
}, kp = te("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: Pp
})(Fe(({
  theme: e
}) => ({
  ...e.typography.body1,
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${Un.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: t,
      size: n
    }) => t.multiline && n === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), Dp = te("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: Mp
})(Fe(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = {
    color: "currentColor",
    ...e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: t ? 0.42 : 0.5
    },
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }, o = {
    opacity: "0 !important"
  }, s = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: t ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": n,
    "&::-moz-placeholder": n,
    // Firefox 19+
    "&::-ms-input-placeholder": n,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${Un.formControl} &`]: {
      "&::-webkit-input-placeholder": o,
      "&::-moz-placeholder": o,
      // Firefox 19+
      "&::-ms-input-placeholder": o,
      // Edge
      "&:focus::-webkit-input-placeholder": s,
      "&:focus::-moz-placeholder": s,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": s
      // Edge
    },
    [`&.${Un.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: i
      }) => !i.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: i
      }) => i.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), kx = g5({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), Xi = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": s,
    autoComplete: i,
    autoFocus: a,
    className: l,
    color: c,
    components: u = {},
    componentsProps: d = {},
    defaultValue: f,
    disabled: p,
    disableInjectingGlobalStyles: m,
    endAdornment: b,
    error: v,
    fullWidth: g = !1,
    id: y,
    inputComponent: w = "input",
    inputProps: x = {},
    inputRef: S,
    margin: T,
    maxRows: E,
    minRows: O,
    multiline: M = !1,
    name: D,
    onBlur: R,
    onChange: P,
    onClick: F,
    onFocus: $,
    onKeyDown: N,
    onKeyUp: A,
    placeholder: k,
    readOnly: L,
    renderSuffix: B,
    rows: V,
    size: _,
    slotProps: z = {},
    slots: j = {},
    startAdornment: W,
    type: J = "text",
    value: G,
    ...q
  } = o, Z = x.value != null ? x.value : G, {
    current: Y
  } = h.useRef(Z != null), Q = h.useRef(), ee = h.useCallback((ye) => {
    process.env.NODE_ENV !== "production" && ye && ye.nodeName !== "INPUT" && !ye.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), ne = tt(Q, S, x.ref, ee), [H, U] = h.useState(!1), X = lo();
  process.env.NODE_ENV !== "production" && h.useEffect(() => {
    if (X)
      return X.registerEffect();
  }, [X]);
  const re = Es({
    props: o,
    muiFormControl: X,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  re.focused = X ? X.focused : H, h.useEffect(() => {
    !X && p && H && (U(!1), R && R());
  }, [X, p, H, R]);
  const oe = X && X.onFilled, le = X && X.onEmpty, se = h.useCallback((ye) => {
    Ef(ye) ? oe && oe() : le && le();
  }, [oe, le]);
  yt(() => {
    Y && se({
      value: Z
    });
  }, [Z, se, Y]);
  const Ce = (ye) => {
    $ && $(ye), x.onFocus && x.onFocus(ye), X && X.onFocus ? X.onFocus(ye) : U(!0);
  }, $e = (ye) => {
    R && R(ye), x.onBlur && x.onBlur(ye), X && X.onBlur ? X.onBlur(ye) : U(!1);
  }, we = (ye, ...We) => {
    if (!Y) {
      const He = ye.target || Q.current;
      if (He == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : Zr(1));
      se({
        value: He.value
      });
    }
    x.onChange && x.onChange(ye, ...We), P && P(ye, ...We);
  };
  h.useEffect(() => {
    se(Q.current);
  }, []);
  const Te = (ye) => {
    Q.current && ye.currentTarget === ye.target && Q.current.focus(), F && F(ye);
  };
  let ue = w, de = x;
  M && ue === "input" && (V ? (process.env.NODE_ENV !== "production" && (O || E) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), de = {
    type: void 0,
    minRows: V,
    maxRows: V,
    ...de
  }) : de = {
    type: void 0,
    maxRows: E,
    minRows: O,
    ...de
  }, ue = Kv);
  const Pe = (ye) => {
    se(ye.animationName === "mui-auto-fill-cancel" ? Q.current : {
      value: "x"
    });
  };
  h.useEffect(() => {
    X && X.setAdornedStart(!!W);
  }, [X, W]);
  const ke = {
    ...o,
    color: re.color || "primary",
    disabled: re.disabled,
    endAdornment: b,
    error: re.error,
    focused: re.focused,
    formControl: X,
    fullWidth: g,
    hiddenLabel: re.hiddenLabel,
    multiline: M,
    size: re.size,
    startAdornment: W,
    type: J
  }, Me = fz(ke), be = j.root || u.Root || kp, me = z.root || d.root || {}, Ae = j.input || u.Input || Dp;
  return de = {
    ...de,
    ...z.input ?? d.input
  }, /* @__PURE__ */ ie(h.Fragment, {
    children: [!m && typeof kx == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (Mx || (Mx = /* @__PURE__ */ C(kx, {}))), /* @__PURE__ */ ie(be, {
      ...me,
      ref: n,
      onClick: Te,
      ...q,
      ...!Yr(be) && {
        ownerState: {
          ...ke,
          ...me.ownerState
        }
      },
      className: ae(Me.root, me.className, l, L && "MuiInputBase-readOnly"),
      children: [W, /* @__PURE__ */ C(xu.Provider, {
        value: null,
        children: /* @__PURE__ */ C(Ae, {
          "aria-invalid": re.error,
          "aria-describedby": s,
          autoComplete: i,
          autoFocus: a,
          defaultValue: f,
          disabled: re.disabled,
          id: y,
          onAnimationStart: Pe,
          name: D,
          placeholder: k,
          readOnly: L,
          required: re.required,
          rows: V,
          value: Z,
          onKeyDown: N,
          onKeyUp: A,
          type: J,
          ...de,
          ...!Yr(Ae) && {
            as: ue,
            ownerState: {
              ...ke,
              ...de.ownerState
            }
          },
          ref: ne,
          className: ae(Me.input, de.className, L && "MuiInputBase-readOnly"),
          onBlur: $e,
          onChange: we,
          onFocus: Ce
        })
      }), b, B ? B({
        ...re,
        startAdornment: W
      }) : null]
    })]
  });
});
process.env.NODE_ENV !== "production" && (Xi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": r.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: r.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: r.shape({
    Input: r.elementType,
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: r.shape({
    input: r.object,
    root: r.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: r.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: r.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: r.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: r.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: mu,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: r.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: r.oneOfType([r.number, r.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: r.oneOfType([r.number, r.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: r.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: r.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * @ignore
   */
  onClick: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: r.func,
  /**
   * @ignore
   */
  onKeyDown: r.func,
  /**
   * @ignore
   */
  onKeyUp: r.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: r.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: r.bool,
  /**
   * @ignore
   */
  renderSuffix: r.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: r.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: r.oneOfType([r.number, r.string]),
  /**
   * The size of the component.
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: r.shape({
    input: r.object,
    root: r.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: r.shape({
    input: r.elementType,
    root: r.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: r.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: r.any
});
function pz(e) {
  return De("MuiInput", e);
}
const zs = {
  ...Un,
  ...Ne("MuiInput", ["root", "underline", "input"])
};
function hz(e) {
  return De("MuiOutlinedInput", e);
}
const rr = {
  ...Un,
  ...Ne("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
function gz(e) {
  return De("MuiFilledInput", e);
}
const Vo = {
  ...Un,
  ...Ne("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, Yv = _e(/* @__PURE__ */ C("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function mz(e) {
  return De("MuiAutocomplete", e);
}
const mt = Ne("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var Dx, Nx;
const bz = (e) => {
  const {
    classes: t,
    disablePortal: n,
    expanded: o,
    focused: s,
    fullWidth: i,
    hasClearIcon: a,
    hasPopupIcon: l,
    inputFocused: c,
    popupOpen: u,
    size: d
  } = e, f = {
    root: ["root", o && "expanded", s && "focused", i && "fullWidth", a && "hasClearIcon", l && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", c && "inputFocused"],
    tag: ["tag", `tagSize${ce(d)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", u && "popupIndicatorOpen"],
    popper: ["popper", n && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return fe(f, mz, t);
}, yz = te("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      fullWidth: o,
      hasClearIcon: s,
      hasPopupIcon: i,
      inputFocused: a,
      size: l
    } = n;
    return [{
      [`& .${mt.tag}`]: t.tag
    }, {
      [`& .${mt.tag}`]: t[`tagSize${ce(l)}`]
    }, {
      [`& .${mt.inputRoot}`]: t.inputRoot
    }, {
      [`& .${mt.input}`]: t.input
    }, {
      [`& .${mt.input}`]: a && t.inputFocused
    }, t.root, o && t.fullWidth, i && t.hasPopupIcon, s && t.hasClearIcon];
  }
})({
  [`&.${mt.focused} .${mt.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${mt.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${mt.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${mt.inputRoot}`]: {
    [`.${mt.hasPopupIcon}&, .${mt.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${mt.hasPopupIcon}.${mt.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${mt.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${zs.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${zs.root}.${Un.sizeSmall}`]: {
    [`& .${zs.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${rr.root}`]: {
    padding: 9,
    [`.${mt.hasPopupIcon}&, .${mt.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${mt.hasPopupIcon}.${mt.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${mt.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${mt.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${rr.root}.${Un.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${mt.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${Vo.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${mt.hasPopupIcon}&, .${mt.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${mt.hasPopupIcon}.${mt.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Vo.input}`]: {
      padding: "7px 4px"
    },
    [`& .${mt.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Vo.root}.${Un.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${Vo.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${Un.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${Vo.root}.${Un.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${mt.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${Vo.root}.${Un.hiddenLabel}.${Un.sizeSmall}`]: {
    [`& .${mt.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${mt.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${mt.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${mt.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${mt.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), vz = te("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), Cz = te(Eo, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), wz = te(Eo, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: ({
    ownerState: e
  }, t) => ({
    ...t.popupIndicator,
    ...e.popupOpen && t.popupIndicatorOpen
  })
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), Sz = te(is, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${mt.option}`]: t.option
    }, t.popper, n.disablePortal && t.popperDisablePortal];
  }
})(Fe(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), xz = te(ao, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(Fe(({
  theme: e
}) => ({
  ...e.typography.body1,
  overflow: "auto"
}))), Tz = te("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(Fe(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), Rz = te("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(Fe(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
}))), Ez = te("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(Fe(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${mt.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${mt.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${mt.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : he(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${mt.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : he(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${mt.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : he(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
}))), Iz = te(el, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(Fe(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
}))), Oz = te("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${mt.option}`]: {
    paddingLeft: 24
  }
}), Np = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: s = !1,
    autoHighlight: i = !1,
    autoSelect: a = !1,
    blurOnSelect: l = !1,
    ChipProps: c,
    className: u,
    clearIcon: d = Dx || (Dx = /* @__PURE__ */ C(AP, {
      fontSize: "small"
    })),
    clearOnBlur: f = !o.freeSolo,
    clearOnEscape: p = !1,
    clearText: m = "Clear",
    closeText: b = "Close",
    componentsProps: v,
    defaultValue: g = o.multiple ? [] : null,
    disableClearable: y = !1,
    disableCloseOnSelect: w = !1,
    disabled: x = !1,
    disabledItemsFocusable: S = !1,
    disableListWrap: T = !1,
    disablePortal: E = !1,
    filterOptions: O,
    filterSelectedOptions: M = !1,
    forcePopupIcon: D = "auto",
    freeSolo: R = !1,
    fullWidth: P = !1,
    getLimitTagsText: F = (Rt) => `+${Rt}`,
    getOptionDisabled: $,
    getOptionKey: N,
    getOptionLabel: A,
    isOptionEqualToValue: k,
    groupBy: L,
    handleHomeEndKeys: B = !o.freeSolo,
    id: V,
    includeInputInList: _ = !1,
    inputValue: z,
    limitTags: j = -1,
    ListboxComponent: W,
    ListboxProps: J,
    loading: G = !1,
    loadingText: q = "Loading…",
    multiple: Z = !1,
    noOptionsText: Y = "No options",
    onChange: Q,
    onClose: ee,
    onHighlightChange: ne,
    onInputChange: H,
    onOpen: U,
    open: X,
    openOnFocus: re = !1,
    openText: oe = "Open",
    options: le,
    PaperComponent: se,
    PopperComponent: Ce,
    popupIcon: $e = Nx || (Nx = /* @__PURE__ */ C(Yv, {})),
    readOnly: we = !1,
    renderGroup: Te,
    renderInput: ue,
    renderOption: de,
    renderTags: Pe,
    selectOnFocus: ke = !o.freeSolo,
    size: Me = "medium",
    slots: be = {},
    slotProps: me = {},
    value: Ae,
    ...ye
  } = o, {
    getRootProps: We,
    getInputProps: He,
    getInputLabelProps: ze,
    getPopupIndicatorProps: pe,
    getClearProps: Re,
    getTagProps: Ge,
    getListboxProps: Qe,
    getOptionProps: qe,
    value: st,
    dirty: wt,
    expanded: Ue,
    id: nt,
    popupOpen: ft,
    focused: nn,
    focusedTag: St,
    anchorEl: Ke,
    setAnchorEl: Ot,
    inputValue: vn,
    groupedOptions: on
  } = VB({
    ...o,
    componentName: "Autocomplete"
  }), Ze = !y && !x && wt && !we, ct = (!R || D === !0) && D !== !1, {
    onMouseDown: Ut
  } = He(), {
    ref: xn,
    ...Fn
  } = Qe(), Tn = A || ((Rt) => Rt.label ?? Rt), an = {
    ...o,
    disablePortal: E,
    expanded: Ue,
    focused: nn,
    fullWidth: P,
    getOptionLabel: Tn,
    hasClearIcon: Ze,
    hasPopupIcon: ct,
    inputFocused: St === -1,
    popupOpen: ft,
    size: Me
  }, hn = bz(an), tr = {
    slots: {
      paper: se,
      popper: Ce,
      ...be
    },
    slotProps: {
      chip: c,
      listbox: J,
      ...v,
      ...me
    }
  }, [Ie, Se] = bn("listbox", {
    elementType: Ez,
    externalForwardedProps: tr,
    ownerState: an,
    className: hn.listbox,
    additionalProps: Fn,
    ref: xn
  }), [je, it] = bn("paper", {
    elementType: ao,
    externalForwardedProps: tr,
    ownerState: an,
    className: hn.paper
  }), [at, kt] = bn("popper", {
    elementType: is,
    externalForwardedProps: tr,
    ownerState: an,
    className: hn.popper,
    additionalProps: {
      disablePortal: E,
      style: {
        width: Ke ? Ke.clientWidth : null
      },
      role: "presentation",
      anchorEl: Ke,
      open: ft
    }
  });
  let It;
  if (Z && st.length > 0) {
    const Rt = (_o) => ({
      className: hn.tag,
      disabled: x,
      ...Ge(_o)
    });
    Pe ? It = Pe(st, Rt, an) : It = st.map((_o, wr) => {
      const {
        key: Ds,
        ...Qu
      } = Rt({
        index: wr
      });
      return /* @__PURE__ */ C(Su, {
        label: Tn(_o),
        size: Me,
        ...Qu,
        ...tr.slotProps.chip
      }, Ds);
    });
  }
  if (j > -1 && Array.isArray(It)) {
    const Rt = It.length - j;
    !nn && Rt > 0 && (It = It.splice(0, j), It.push(/* @__PURE__ */ C("span", {
      className: hn.tag,
      children: F(Rt)
    }, It.length)));
  }
  const ls = Te || ((Rt) => /* @__PURE__ */ ie("li", {
    children: [/* @__PURE__ */ C(Iz, {
      className: hn.groupLabel,
      ownerState: an,
      component: "div",
      children: Rt.group
    }), /* @__PURE__ */ C(Oz, {
      className: hn.groupUl,
      ownerState: an,
      children: Rt.children
    })]
  }, Rt.key)), Xu = de || ((Rt, _o) => {
    const {
      key: wr,
      ...Ds
    } = Rt;
    return /* @__PURE__ */ C("li", {
      ...Ds,
      children: Tn(_o)
    }, wr);
  }), $l = (Rt, _o) => {
    const wr = qe({
      option: Rt,
      index: _o
    });
    return Xu({
      ...wr,
      className: hn.option
    }, Rt, {
      selected: wr["aria-selected"],
      index: _o,
      inputValue: vn
    }, an);
  }, si = tr.slotProps.clearIndicator, ii = tr.slotProps.popupIndicator, aa = (Rt) => /* @__PURE__ */ C(Sz, {
    as: at,
    ...kt,
    children: /* @__PURE__ */ C(xz, {
      as: je,
      ...it,
      children: Rt
    })
  });
  let ai = null;
  return on.length > 0 ? ai = aa(
    // TODO v7: remove `as` prop and move ListboxComponentProp to externalForwardedProps or remove ListboxComponentProp entirely
    // https://github.com/mui/material-ui/pull/43994#issuecomment-2401945800
    /* @__PURE__ */ C(Ie, {
      as: W,
      ...Se,
      children: on.map((Rt, _o) => L ? ls({
        key: Rt.key,
        group: Rt.group,
        children: Rt.options.map((wr, Ds) => $l(wr, Rt.index + Ds))
      }) : $l(Rt, _o))
    })
  ) : G && on.length === 0 ? ai = aa(/* @__PURE__ */ C(Tz, {
    className: hn.loading,
    ownerState: an,
    children: q
  })) : on.length === 0 && !R && !G && (ai = aa(/* @__PURE__ */ C(Rz, {
    className: hn.noOptions,
    ownerState: an,
    role: "presentation",
    onMouseDown: (Rt) => {
      Rt.preventDefault();
    },
    children: Y
  }))), /* @__PURE__ */ ie(h.Fragment, {
    children: [/* @__PURE__ */ C(yz, {
      ref: n,
      className: ae(hn.root, u),
      ownerState: an,
      ...We(ye),
      children: ue({
        id: nt,
        disabled: x,
        fullWidth: !0,
        size: Me === "small" ? "small" : void 0,
        InputLabelProps: ze(),
        InputProps: {
          ref: Ot,
          className: hn.inputRoot,
          startAdornment: It,
          onMouseDown: (Rt) => {
            Rt.target === Rt.currentTarget && Ut(Rt);
          },
          ...(Ze || ct) && {
            endAdornment: /* @__PURE__ */ ie(vz, {
              className: hn.endAdornment,
              ownerState: an,
              children: [Ze ? /* @__PURE__ */ C(Cz, {
                ...Re(),
                "aria-label": m,
                title: m,
                ownerState: an,
                ...si,
                className: ae(hn.clearIndicator, si == null ? void 0 : si.className),
                children: d
              }) : null, ct ? /* @__PURE__ */ C(wz, {
                ...pe(),
                disabled: x,
                "aria-label": ft ? b : oe,
                title: ft ? b : oe,
                ownerState: an,
                ...ii,
                className: ae(hn.popupIndicator, ii == null ? void 0 : ii.className),
                children: $e
              }) : null]
            })
          }
        },
        inputProps: {
          className: hn.input,
          disabled: x,
          readOnly: we,
          ...He()
        }
      })
    }), Ke ? ai : null]
  });
});
process.env.NODE_ENV !== "production" && (Np.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: r.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: r.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: r.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: r.oneOfType([r.oneOf(["mouse", "touch"]), r.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: r.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: r.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: r.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: r.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: r.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: r.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: r.shape({
    clearIndicator: r.object,
    paper: r.object,
    popper: r.object,
    popupIndicator: r.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: Gn(r.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: r.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: r.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: r.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: r.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: r.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: r.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: r.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: r.oneOfType([r.oneOf(["auto"]), r.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: r.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: r.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: r.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: r.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: r.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */
  groupBy: r.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: r.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: r.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: r.bool,
  /**
   * The input value.
   */
  inputValue: r.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: r.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: Wr,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: r.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: r.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: r.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: r.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: r.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: r.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: r.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: r.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: r.func,
  /**
   * @ignore
   */
  onKeyDown: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: r.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: r.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: r.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: r.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: r.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: r.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: r.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: r.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: r.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: r.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: r.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: r.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["small", "medium"]), r.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    chip: r.oneOfType([r.func, r.object]),
    clearIndicator: r.oneOfType([r.func, r.object]),
    listbox: r.oneOfType([r.func, r.object]),
    paper: r.oneOfType([r.func, r.object]),
    popper: r.oneOfType([r.func, r.object]),
    popupIndicator: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    listbox: r.elementType,
    paper: r.elementType,
    popper: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: Gn(r.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const Pz = _e(/* @__PURE__ */ C("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function Mz(e) {
  return De("MuiAvatar", e);
}
const kz = Ne("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]), Dz = (e) => {
  const {
    classes: t,
    variant: n,
    colorDefault: o
  } = e;
  return fe({
    root: ["root", n, o && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, Mz, t);
}, Nz = te("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.colorDefault && t.colorDefault];
  }
})(Fe(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none",
  variants: [{
    props: {
      variant: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "square"
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: !0
    },
    style: {
      color: (e.vars || e).palette.background.default,
      ...e.vars ? {
        backgroundColor: e.vars.palette.Avatar.defaultBg
      } : {
        backgroundColor: e.palette.grey[400],
        ...e.applyStyles("dark", {
          backgroundColor: e.palette.grey[600]
        })
      }
    }
  }]
}))), $z = te("img", {
  name: "MuiAvatar",
  slot: "Img",
  overridesResolver: (e, t) => t.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), Az = te(Pz, {
  name: "MuiAvatar",
  slot: "Fallback",
  overridesResolver: (e, t) => t.fallback
})({
  width: "75%",
  height: "75%"
});
function Fz({
  crossOrigin: e,
  referrerPolicy: t,
  src: n,
  srcSet: o
}) {
  const [s, i] = h.useState(!1);
  return h.useEffect(() => {
    if (!n && !o)
      return;
    i(!1);
    let a = !0;
    const l = new Image();
    return l.onload = () => {
      a && i("loaded");
    }, l.onerror = () => {
      a && i("error");
    }, l.crossOrigin = e, l.referrerPolicy = t, l.src = n, o && (l.srcset = o), () => {
      a = !1;
    };
  }, [e, t, n, o]), s;
}
const Xv = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiAvatar"
  }), {
    alt: s,
    children: i,
    className: a,
    component: l = "div",
    slots: c = {},
    slotProps: u = {},
    imgProps: d,
    sizes: f,
    src: p,
    srcSet: m,
    variant: b = "circular",
    ...v
  } = o;
  let g = null;
  const y = {
    ...o,
    component: l,
    variant: b
  }, w = Fz({
    ...d,
    ...typeof u.img == "function" ? u.img(y) : u.img,
    src: p,
    srcSet: m
  }), x = p || m, S = x && w !== "error";
  y.colorDefault = !S, delete y.ownerState;
  const T = Dz(y), [E, O] = bn("img", {
    className: T.img,
    elementType: $z,
    externalForwardedProps: {
      slots: c,
      slotProps: {
        img: {
          ...d,
          ...u.img
        }
      }
    },
    additionalProps: {
      alt: s,
      src: p,
      srcSet: m,
      sizes: f
    },
    ownerState: y
  });
  return S ? g = /* @__PURE__ */ C(E, {
    ...O
  }) : i || i === 0 ? g = i : x && s ? g = s[0] : g = /* @__PURE__ */ C(Az, {
    ownerState: y,
    className: T.fallback
  }), /* @__PURE__ */ C(Nz, {
    as: l,
    className: ae(T.root, a),
    ref: n,
    ...v,
    ownerState: y,
    children: g
  });
});
process.env.NODE_ENV !== "production" && (Xv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: r.string,
  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   * @deprecated Use `slotProps.img` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  imgProps: r.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: r.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    img: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    img: r.elementType
  }),
  /**
   * The `src` attribute for the `img` element.
   */
  src: r.string,
  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The shape of the avatar.
   * @default 'circular'
   */
  variant: r.oneOfType([r.oneOf(["circular", "rounded", "square"]), r.string])
});
function Lz(e) {
  return De("MuiAvatarGroup", e);
}
const _z = Ne("MuiAvatarGroup", ["root", "avatar"]), $x = {
  small: -16,
  medium: -8
}, Vz = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    avatar: ["avatar"]
  }, Lz, t);
}, Bz = te("div", {
  name: "MuiAvatarGroup",
  slot: "Root",
  overridesResolver: (e, t) => ({
    [`& .${_z.avatar}`]: t.avatar,
    ...t.root
  })
})(Fe(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row-reverse",
  [`& .${kz.root}`]: {
    border: `2px solid ${(e.vars || e).palette.background.default}`,
    boxSizing: "content-box",
    marginLeft: "var(--AvatarGroup-spacing, -8px)",
    "&:last-child": {
      marginLeft: 0
    }
  }
}))), YP = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiAvatarGroup"
  }), {
    children: s,
    className: i,
    component: a = "div",
    componentsProps: l,
    max: c = 5,
    renderSurplus: u,
    slotProps: d = {},
    slots: f = {},
    spacing: p = "medium",
    total: m,
    variant: b = "circular",
    ...v
  } = o;
  let g = c < 2 ? 2 : c;
  const y = {
    ...o,
    max: c,
    spacing: p,
    component: a,
    variant: b
  }, w = Vz(y), x = h.Children.toArray(s).filter((F) => (process.env.NODE_ENV !== "production" && Js.isFragment(F) && console.error(["MUI: The AvatarGroup component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ h.isValidElement(F))), S = m || x.length;
  S === g && (g += 1), g = Math.min(S + 1, g);
  const T = Math.min(x.length, g - 1), E = Math.max(S - g, S - T, 0), O = u ? u(E) : `+${E}`, M = y.spacing && $x[y.spacing] !== void 0 ? $x[y.spacing] : -y.spacing || -8, D = {
    slots: f,
    slotProps: {
      surplus: d.additionalAvatar ?? (l == null ? void 0 : l.additionalAvatar),
      ...l,
      ...d
    }
  }, [R, P] = bn("surplus", {
    elementType: Xv,
    externalForwardedProps: D,
    className: w.avatar,
    ownerState: y,
    additionalProps: {
      variant: b
    }
  });
  return /* @__PURE__ */ ie(Bz, {
    as: a,
    ownerState: y,
    className: ae(w.root, i),
    ref: n,
    ...v,
    style: {
      "--AvatarGroup-spacing": M ? `${M}px` : void 0,
      ...v.style
    },
    children: [E ? /* @__PURE__ */ C(R, {
      ...P,
      children: O
    }) : null, x.slice(0, T).reverse().map((F) => /* @__PURE__ */ h.cloneElement(F, {
      className: ae(F.props.className, w.avatar),
      variant: F.props.variant || b
    }))]
  });
});
process.env.NODE_ENV !== "production" && (YP.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The avatars to stack.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: r.shape({
    additionalAvatar: r.object
  }),
  /**
   * Max avatars to show before +x.
   * @default 5
   */
  max: Gn(r.number, (e) => e.max < 2 ? new Error(["MUI: The prop `max` should be equal to 2 or above.", "A value below is clamped to 2."].join(`
`)) : null),
  /**
   * custom renderer of extraAvatars
   * @param {number} surplus number of extra avatars
   * @returns {React.ReactNode} custom element to display
   */
  renderSurplus: r.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    additionalAvatar: r.object,
    surplus: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    surplus: r.elementType
  }),
  /**
   * Spacing between avatars.
   * @default 'medium'
   */
  spacing: r.oneOfType([r.oneOf(["medium", "small"]), r.number]),
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The total number of avatars. Used for calculating the number of extra avatars.
   * @default children.length
   */
  total: r.number,
  /**
   * The variant to use.
   * @default 'circular'
   */
  variant: r.oneOfType([r.oneOf(["circular", "rounded", "square"]), r.string])
});
const zz = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, ti = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = sn(), s = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    addEndListener: i,
    appear: a = !0,
    children: l,
    easing: c,
    in: u,
    onEnter: d,
    onEntered: f,
    onEntering: p,
    onExit: m,
    onExited: b,
    onExiting: v,
    style: g,
    timeout: y = s,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: w = So,
    ...x
  } = t, S = h.useRef(null), T = tt(S, Rs(l), n), E = (N) => (A) => {
    if (N) {
      const k = S.current;
      A === void 0 ? N(k) : N(k, A);
    }
  }, O = E(p), M = E((N, A) => {
    Ep(N);
    const k = Jr({
      style: g,
      timeout: y,
      easing: c
    }, {
      mode: "enter"
    });
    N.style.webkitTransition = o.transitions.create("opacity", k), N.style.transition = o.transitions.create("opacity", k), d && d(N, A);
  }), D = E(f), R = E(v), P = E((N) => {
    const A = Jr({
      style: g,
      timeout: y,
      easing: c
    }, {
      mode: "exit"
    });
    N.style.webkitTransition = o.transitions.create("opacity", A), N.style.transition = o.transitions.create("opacity", A), m && m(N);
  }), F = E(b);
  return /* @__PURE__ */ C(w, {
    appear: a,
    in: u,
    nodeRef: S,
    onEnter: M,
    onEntered: D,
    onEntering: O,
    onExit: P,
    onExited: F,
    onExiting: R,
    addEndListener: (N) => {
      i && i(S.current, N);
    },
    timeout: y,
    ...x,
    children: (N, A) => /* @__PURE__ */ h.cloneElement(l, {
      style: {
        opacity: 0,
        visibility: N === "exited" && !u ? "hidden" : void 0,
        ...zz[N],
        ...g,
        ...l.props.style
      },
      ref: T,
      ...A
    })
  });
});
process.env.NODE_ENV !== "production" && (ti.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: r.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: r.bool,
  /**
   * A single child content element.
   */
  children: Ts.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: r.oneOfType([r.shape({
    enter: r.string,
    exit: r.string
  }), r.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: r.bool,
  /**
   * @ignore
   */
  onEnter: r.func,
  /**
   * @ignore
   */
  onEntered: r.func,
  /**
   * @ignore
   */
  onEntering: r.func,
  /**
   * @ignore
   */
  onExit: r.func,
  /**
   * @ignore
   */
  onExited: r.func,
  /**
   * @ignore
   */
  onExiting: r.func,
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: r.oneOfType([r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })])
});
function Hz(e) {
  return De("MuiBackdrop", e);
}
Ne("MuiBackdrop", ["root", "invisible"]);
const jz = (e) => {
  const {
    ownerState: t,
    ...n
  } = e;
  return n;
}, Gz = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return fe({
    root: ["root", n && "invisible"]
  }, Hz, t);
}, qz = te("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), $p = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: s,
    className: i,
    component: a = "div",
    invisible: l = !1,
    open: c,
    components: u = {},
    componentsProps: d = {},
    slotProps: f = {},
    slots: p = {},
    TransitionComponent: m,
    transitionDuration: b,
    ...v
  } = o, g = {
    ...o,
    component: a,
    invisible: l
  }, y = Gz(g), w = {
    transition: m,
    root: u.Root,
    ...p
  }, x = {
    ...d,
    ...f
  }, S = {
    slots: w,
    slotProps: x
  }, [T, E] = bn("root", {
    elementType: qz,
    externalForwardedProps: S,
    className: ae(y.root, i),
    ownerState: g
  }), [O, M] = bn("transition", {
    elementType: ti,
    externalForwardedProps: S,
    ownerState: g
  }), D = jz(M);
  return /* @__PURE__ */ C(O, {
    in: c,
    timeout: b,
    ...v,
    ...D,
    children: /* @__PURE__ */ C(T, {
      "aria-hidden": !0,
      ...E,
      classes: y,
      ref: n,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && ($p.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: r.shape({
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: r.shape({
    root: r.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: r.bool,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    root: r.oneOfType([r.func, r.object]),
    transition: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    root: r.elementType,
    transition: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: r.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: r.oneOfType([r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })])
});
function Wz(e) {
  const {
    badgeContent: t,
    invisible: n = !1,
    max: o = 99,
    showZero: s = !1
  } = e, i = Ov({
    badgeContent: t,
    max: o
  });
  let a = n;
  n === !1 && t === 0 && !s && (a = !0);
  const {
    badgeContent: l,
    max: c = o
  } = a ? i : e, u = l && Number(l) > c ? `${c}+` : l;
  return {
    badgeContent: l,
    invisible: a,
    max: c,
    displayValue: u
  };
}
function Uz(e) {
  return De("MuiBadge", e);
}
const Ns = Ne("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), _h = 10, Vh = 4, Kz = (e) => {
  const {
    color: t,
    anchorOrigin: n,
    invisible: o,
    overlap: s,
    variant: i,
    classes: a = {}
  } = e, l = {
    root: ["root"],
    badge: ["badge", i, o && "invisible", `anchorOrigin${ce(n.vertical)}${ce(n.horizontal)}`, `anchorOrigin${ce(n.vertical)}${ce(n.horizontal)}${ce(s)}`, `overlap${ce(s)}`, t !== "default" && `color${ce(t)}`]
  };
  return fe(l, Uz, a);
}, Yz = te("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), Xz = te("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.badge, t[n.variant], t[`anchorOrigin${ce(n.anchorOrigin.vertical)}${ce(n.anchorOrigin.horizontal)}${ce(n.overlap)}`], n.color !== "default" && t[`color${ce(n.color)}`], n.invisible && t.invisible];
  }
})(Fe(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  position: "absolute",
  boxSizing: "border-box",
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(12),
  minWidth: _h * 2,
  lineHeight: 1,
  padding: "0 6px",
  height: _h * 2,
  borderRadius: _h,
  zIndex: 1,
  // Render the badge on top of potential ripples.
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeInOut,
    duration: e.transitions.duration.enteringScreen
  }),
  variants: [...Object.entries(e.palette).filter($t(["contrastText"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: (e.vars || e).palette[t].main,
      color: (e.vars || e).palette[t].contrastText
    }
  })), {
    props: {
      variant: "dot"
    },
    style: {
      borderRadius: Vh,
      height: Vh * 2,
      minWidth: Vh * 2,
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      top: 0,
      right: 0,
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${Ns.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      right: 0,
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${Ns.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      top: 0,
      left: 0,
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${Ns.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "rectangular",
    style: {
      bottom: 0,
      left: 0,
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${Ns.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      top: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${Ns.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "right" && t.overlap === "circular",
    style: {
      bottom: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${Ns.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      top: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${Ns.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "bottom" && t.anchorOrigin.horizontal === "left" && t.overlap === "circular",
    style: {
      bottom: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${Ns.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: {
      invisible: !0
    },
    style: {
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeInOut,
        duration: e.transitions.duration.leavingScreen
      })
    }
  }]
})));
function Ax(e) {
  return {
    vertical: (e == null ? void 0 : e.vertical) ?? "top",
    horizontal: (e == null ? void 0 : e.horizontal) ?? "right"
  };
}
const Qv = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiBadge"
  }), {
    anchorOrigin: s,
    className: i,
    classes: a,
    component: l,
    components: c = {},
    componentsProps: u = {},
    children: d,
    overlap: f = "rectangular",
    color: p = "default",
    invisible: m = !1,
    max: b = 99,
    badgeContent: v,
    slots: g,
    slotProps: y,
    showZero: w = !1,
    variant: x = "standard",
    ...S
  } = o, {
    badgeContent: T,
    invisible: E,
    max: O,
    displayValue: M
  } = Wz({
    max: b,
    invisible: m,
    badgeContent: v,
    showZero: w
  }), D = Ov({
    anchorOrigin: Ax(s),
    color: p,
    overlap: f,
    variant: x,
    badgeContent: v
  }), R = E || T == null && x !== "dot", {
    color: P = p,
    overlap: F = f,
    anchorOrigin: $,
    variant: N = x
  } = R ? D : o, A = Ax($), k = N !== "dot" ? M : void 0, L = {
    ...o,
    badgeContent: T,
    invisible: R,
    max: O,
    displayValue: k,
    showZero: w,
    anchorOrigin: A,
    color: P,
    overlap: F,
    variant: N
  }, B = Kz(L), V = (g == null ? void 0 : g.root) ?? c.Root ?? Yz, _ = (g == null ? void 0 : g.badge) ?? c.Badge ?? Xz, z = (y == null ? void 0 : y.root) ?? u.root, j = (y == null ? void 0 : y.badge) ?? u.badge, W = et({
    elementType: V,
    externalSlotProps: z,
    externalForwardedProps: S,
    additionalProps: {
      ref: n,
      as: l
    },
    ownerState: L,
    className: ae(z == null ? void 0 : z.className, B.root, i)
  }), J = et({
    elementType: _,
    externalSlotProps: j,
    ownerState: L,
    className: ae(B.badge, j == null ? void 0 : j.className)
  });
  return /* @__PURE__ */ ie(V, {
    ...W,
    children: [d, /* @__PURE__ */ C(_, {
      ...J,
      children: k
    })]
  });
});
process.env.NODE_ENV !== "production" && (Qv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: r.shape({
    horizontal: r.oneOf(["left", "right"]),
    vertical: r.oneOf(["bottom", "top"])
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: r.node,
  /**
   * The badge will be added relative to this node.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: r.oneOfType([r.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: r.shape({
    Badge: r.elementType,
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: r.shape({
    badge: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: r.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: r.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: r.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: r.bool,
  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  slotProps: r.shape({
    badge: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    badge: r.elementType,
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: r.oneOfType([r.oneOf(["dot", "standard"]), r.string])
});
const Qz = Ne("MuiBox", ["root"]), Zz = gl(), vt = V_({
  themeId: hr,
  defaultTheme: Zz,
  defaultClassName: Qz.root,
  generateClassName: JO.generate
});
process.env.NODE_ENV !== "production" && (vt.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: r.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const Jz = _e(/* @__PURE__ */ C("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz"), eH = te(Yn)(Fe(({
  theme: e
}) => ({
  display: "flex",
  marginLeft: `calc(${e.spacing(1)} * 0.5)`,
  marginRight: `calc(${e.spacing(1)} * 0.5)`,
  ...e.palette.mode === "light" ? {
    backgroundColor: e.palette.grey[100],
    color: e.palette.grey[700]
  } : {
    backgroundColor: e.palette.grey[700],
    color: e.palette.grey[100]
  },
  borderRadius: 2,
  "&:hover, &:focus": {
    ...e.palette.mode === "light" ? {
      backgroundColor: e.palette.grey[200]
    } : {
      backgroundColor: e.palette.grey[600]
    }
  },
  "&:active": {
    boxShadow: e.shadows[0],
    ...e.palette.mode === "light" ? {
      backgroundColor: vf(e.palette.grey[200], 0.12)
    } : {
      backgroundColor: vf(e.palette.grey[600], 0.12)
    }
  }
}))), tH = te(Jz)({
  width: 24,
  height: 16
});
function XP(e) {
  const {
    slots: t = {},
    slotProps: n = {},
    ...o
  } = e, s = e;
  return /* @__PURE__ */ C("li", {
    children: /* @__PURE__ */ C(eH, {
      focusRipple: !0,
      ...o,
      ownerState: s,
      children: /* @__PURE__ */ C(tH, {
        as: t.CollapsedIcon,
        ownerState: s,
        ...n.collapsedIcon
      })
    })
  });
}
process.env.NODE_ENV !== "production" && (XP.propTypes = {
  /**
   * The props used for the CollapsedIcon slot.
   * @default {}
   */
  slotProps: r.shape({
    collapsedIcon: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside the BreadcumbCollapsed.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    CollapsedIcon: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.object
});
function nH(e) {
  return De("MuiBreadcrumbs", e);
}
const oH = Ne("MuiBreadcrumbs", ["root", "ol", "li", "separator"]), rH = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    li: ["li"],
    ol: ["ol"],
    separator: ["separator"]
  }, nH, t);
}, sH = te(yn, {
  name: "MuiBreadcrumbs",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`& .${oH.li}`]: t.li
  }, t.root]
})({}), iH = te("ol", {
  name: "MuiBreadcrumbs",
  slot: "Ol",
  overridesResolver: (e, t) => t.ol
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
}), aH = te("li", {
  name: "MuiBreadcrumbs",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  display: "flex",
  userSelect: "none",
  marginLeft: 8,
  marginRight: 8
});
function lH(e, t, n, o) {
  return e.reduce((s, i, a) => (a < e.length - 1 ? s = s.concat(i, /* @__PURE__ */ C(aH, {
    "aria-hidden": !0,
    className: t,
    ownerState: o,
    children: n
  }, `separator-${a}`)) : s.push(i), s), []);
}
const QP = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiBreadcrumbs"
  }), {
    children: s,
    className: i,
    component: a = "nav",
    slots: l = {},
    slotProps: c = {},
    expandText: u = "Show path",
    itemsAfterCollapse: d = 1,
    itemsBeforeCollapse: f = 1,
    maxItems: p = 8,
    separator: m = "/",
    ...b
  } = o, [v, g] = h.useState(!1), y = {
    ...o,
    component: a,
    expanded: v,
    expandText: u,
    itemsAfterCollapse: d,
    itemsBeforeCollapse: f,
    maxItems: p,
    separator: m
  }, w = rH(y), x = et({
    elementType: l.CollapsedIcon,
    externalSlotProps: c.collapsedIcon,
    ownerState: y
  }), S = h.useRef(null), T = (O) => {
    const M = () => {
      g(!0);
      const D = S.current.querySelector("a[href],button,[tabindex]");
      D && D.focus();
    };
    return f + d >= O.length ? (process.env.NODE_ENV !== "production" && console.error(["MUI: You have provided an invalid combination of props to the Breadcrumbs.", `itemsAfterCollapse={${d}} + itemsBeforeCollapse={${f}} >= maxItems={${p}}`].join(`
`)), O) : [...O.slice(0, f), /* @__PURE__ */ C(XP, {
      "aria-label": u,
      slots: {
        CollapsedIcon: l.CollapsedIcon
      },
      slotProps: {
        collapsedIcon: x
      },
      onClick: M
    }, "ellipsis"), ...O.slice(O.length - d, O.length)];
  }, E = h.Children.toArray(s).filter((O) => (process.env.NODE_ENV !== "production" && Js.isFragment(O) && console.error(["MUI: The Breadcrumbs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ h.isValidElement(O))).map((O, M) => /* @__PURE__ */ C("li", {
    className: w.li,
    children: O
  }, `child-${M}`));
  return /* @__PURE__ */ C(sH, {
    ref: n,
    component: a,
    color: "textSecondary",
    className: ae(w.root, i),
    ownerState: y,
    ...b,
    children: /* @__PURE__ */ C(iH, {
      className: w.ol,
      ref: S,
      ownerState: y,
      children: lH(v || p && E.length <= p ? E : T(E), w.separator, m, y)
    })
  });
});
process.env.NODE_ENV !== "production" && (QP.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Override the default label for the expand button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Show path'
   */
  expandText: r.string,
  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   * @default 1
   */
  itemsAfterCollapse: Wr,
  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   * @default 1
   */
  itemsBeforeCollapse: Wr,
  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   * @default 8
   */
  maxItems: Wr,
  /**
   * Custom separator node.
   * @default '/'
   */
  separator: r.node,
  /**
   * The props used for each slot inside the Breadcumb.
   * @default {}
   */
  slotProps: r.shape({
    collapsedIcon: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside the Breadcumb.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    CollapsedIcon: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function cH(e) {
  return De("MuiButton", e);
}
const ca = Ne("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), ZP = /* @__PURE__ */ h.createContext({});
process.env.NODE_ENV !== "production" && (ZP.displayName = "ButtonGroupContext");
const JP = /* @__PURE__ */ h.createContext(void 0);
process.env.NODE_ENV !== "production" && (JP.displayName = "ButtonGroupButtonContext");
const uH = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: o,
    size: s,
    variant: i,
    classes: a
  } = e, l = {
    root: ["root", i, `${i}${ce(t)}`, `size${ce(s)}`, `${i}Size${ce(s)}`, `color${ce(t)}`, n && "disableElevation", o && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${ce(s)}`],
    endIcon: ["icon", "endIcon", `iconSize${ce(s)}`]
  }, c = fe(l, cH, a);
  return {
    ...a,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...c
  };
}, eM = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], dH = te(Yn, {
  shouldForwardProp: (e) => Xn(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${ce(n.color)}`], t[`size${ce(n.size)}`], t[`${n.variant}Size${ce(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth];
  }
})(Fe(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], n = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return {
    ...e.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${ca.disabled}`]: {
      color: (e.vars || e).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (e.vars || e).shadows[2],
        "&:hover": {
          boxShadow: (e.vars || e).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (e.vars || e).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (e.vars || e).shadows[8]
        },
        [`&.${ca.focusVisible}`]: {
          boxShadow: (e.vars || e).shadows[6]
        },
        [`&.${ca.disabled}`]: {
          color: (e.vars || e).palette.action.disabled,
          boxShadow: (e.vars || e).shadows[0],
          backgroundColor: (e.vars || e).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${ca.disabled}`]: {
          border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(e.palette).filter($t()).map(([o]) => ({
      props: {
        color: o
      },
      style: {
        "--variant-textColor": (e.vars || e).palette[o].main,
        "--variant-outlinedColor": (e.vars || e).palette[o].main,
        "--variant-outlinedBorder": e.vars ? `rgba(${e.vars.palette[o].mainChannel} / 0.5)` : he(e.palette[o].main, 0.5),
        "--variant-containedColor": (e.vars || e).palette[o].contrastText,
        "--variant-containedBg": (e.vars || e).palette[o].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (e.vars || e).palette[o].dark,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette[o].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette[o].main, e.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (e.vars || e).palette[o].main,
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette[o].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette[o].main, e.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedBg : t,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": e.vars ? e.vars.palette.Button.inheritContainedHoverBg : n,
            "--variant-textBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette.text.primary, e.palette.action.hoverOpacity),
            "--variant-outlinedBg": e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette.text.primary, e.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: e.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: e.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${ca.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${ca.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }]
  };
})), fH = te("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, t[`iconSize${ce(n.size)}`]];
  }
})({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, ...eM]
}), pH = te("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, t[`iconSize${ce(n.size)}`]];
  }
})({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, ...eM]
}), Io = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = h.useContext(ZP), s = h.useContext(JP), i = Fi(o, t), a = Be({
    props: i,
    name: "MuiButton"
  }), {
    children: l,
    color: c = "primary",
    component: u = "button",
    className: d,
    disabled: f = !1,
    disableElevation: p = !1,
    disableFocusRipple: m = !1,
    endIcon: b,
    focusVisibleClassName: v,
    fullWidth: g = !1,
    size: y = "medium",
    startIcon: w,
    type: x,
    variant: S = "text",
    ...T
  } = a, E = {
    ...a,
    color: c,
    component: u,
    disabled: f,
    disableElevation: p,
    disableFocusRipple: m,
    fullWidth: g,
    size: y,
    type: x,
    variant: S
  }, O = uH(E), M = w && /* @__PURE__ */ C(fH, {
    className: O.startIcon,
    ownerState: E,
    children: w
  }), D = b && /* @__PURE__ */ C(pH, {
    className: O.endIcon,
    ownerState: E,
    children: b
  }), R = s || "";
  return /* @__PURE__ */ ie(dH, {
    ownerState: E,
    className: ae(o.className, O.root, d, R),
    component: u,
    disabled: f,
    focusRipple: !m,
    focusVisibleClassName: ae(O.focusVisible, v),
    ref: n,
    type: x,
    ...T,
    classes: O,
    children: [M, l, D]
  });
});
process.env.NODE_ENV !== "production" && (Io.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: r.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * Element placed after the children.
   */
  endIcon: r.node,
  /**
   * @ignore
   */
  focusVisibleClassName: r.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: r.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["small", "medium", "large"]), r.string]),
  /**
   * Element placed before the children.
   */
  startIcon: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * @ignore
   */
  type: r.oneOfType([r.oneOf(["button", "reset", "submit"]), r.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: r.oneOfType([r.oneOf(["contained", "outlined", "text"]), r.string])
});
function hH(e) {
  return De("MuiCard", e);
}
Ne("MuiCard", ["root"]);
const gH = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, hH, t);
}, mH = te(ao, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  overflow: "hidden"
}), tM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiCard"
  }), {
    className: s,
    raised: i = !1,
    ...a
  } = o, l = {
    ...o,
    raised: i
  }, c = gH(l);
  return /* @__PURE__ */ C(mH, {
    className: ae(c.root, s),
    elevation: i ? 8 : void 0,
    ref: n,
    ownerState: l,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (tM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: Gn(r.bool, (e) => e.raised && e.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function bH(e) {
  return De("MuiCardActionArea", e);
}
const Bh = Ne("MuiCardActionArea", ["root", "focusVisible", "focusHighlight"]), yH = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    focusHighlight: ["focusHighlight"]
  }, bH, t);
}, vH = te(Yn, {
  name: "MuiCardActionArea",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(Fe(({
  theme: e
}) => ({
  display: "block",
  textAlign: "inherit",
  borderRadius: "inherit",
  // for Safari to work https://github.com/mui/material-ui/issues/36285.
  width: "100%",
  [`&:hover .${Bh.focusHighlight}`]: {
    opacity: (e.vars || e).palette.action.hoverOpacity,
    "@media (hover: none)": {
      opacity: 0
    }
  },
  [`&.${Bh.focusVisible} .${Bh.focusHighlight}`]: {
    opacity: (e.vars || e).palette.action.focusOpacity
  }
}))), CH = te("span", {
  name: "MuiCardActionArea",
  slot: "FocusHighlight",
  overridesResolver: (e, t) => t.focusHighlight
})(Fe(({
  theme: e
}) => ({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit",
  opacity: 0,
  backgroundColor: "currentcolor",
  transition: e.transitions.create("opacity", {
    duration: e.transitions.duration.short
  })
}))), nM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiCardActionArea"
  }), {
    children: s,
    className: i,
    focusVisibleClassName: a,
    ...l
  } = o, c = o, u = yH(c);
  return /* @__PURE__ */ ie(vH, {
    className: ae(u.root, i),
    focusVisibleClassName: ae(a, u.focusVisible),
    ref: n,
    ownerState: c,
    ...l,
    children: [s, /* @__PURE__ */ C(CH, {
      className: u.focusHighlight,
      ownerState: c
    })]
  });
});
process.env.NODE_ENV !== "production" && (nM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * @ignore
   */
  focusVisibleClassName: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function wH(e) {
  return De("PrivateSwitchBase", e);
}
Ne("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const SH = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: o,
    edge: s
  } = e, i = {
    root: ["root", n && "checked", o && "disabled", s && `edge${ce(s)}`],
    input: ["input"]
  };
  return fe(i, wH, t);
}, xH = te(Yn)({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "start" && t.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: e,
      ownerState: t
    }) => e === "end" && t.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), TH = te("input", {
  shouldForwardProp: Xn
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), Ap = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    autoFocus: o,
    checked: s,
    checkedIcon: i,
    className: a,
    defaultChecked: l,
    disabled: c,
    disableFocusRipple: u = !1,
    edge: d = !1,
    icon: f,
    id: p,
    inputProps: m,
    inputRef: b,
    name: v,
    onBlur: g,
    onChange: y,
    onFocus: w,
    readOnly: x,
    required: S = !1,
    tabIndex: T,
    type: E,
    value: O,
    ...M
  } = t, [D, R] = jn({
    controlled: s,
    default: !!l,
    name: "SwitchBase",
    state: "checked"
  }), P = lo(), F = (V) => {
    w && w(V), P && P.onFocus && P.onFocus(V);
  }, $ = (V) => {
    g && g(V), P && P.onBlur && P.onBlur(V);
  }, N = (V) => {
    if (V.nativeEvent.defaultPrevented)
      return;
    const _ = V.target.checked;
    R(_), y && y(V, _);
  };
  let A = c;
  P && typeof A > "u" && (A = P.disabled);
  const k = E === "checkbox" || E === "radio", L = {
    ...t,
    checked: D,
    disabled: A,
    disableFocusRipple: u,
    edge: d
  }, B = SH(L);
  return /* @__PURE__ */ ie(xH, {
    component: "span",
    className: ae(B.root, a),
    centerRipple: !0,
    focusRipple: !u,
    disabled: A,
    tabIndex: null,
    role: void 0,
    onFocus: F,
    onBlur: $,
    ownerState: L,
    ref: n,
    ...M,
    children: [/* @__PURE__ */ C(TH, {
      autoFocus: o,
      checked: s,
      defaultChecked: l,
      className: B.input,
      disabled: A,
      id: k ? p : void 0,
      name: v,
      onChange: N,
      readOnly: x,
      ref: b,
      required: S,
      ownerState: L,
      tabIndex: T,
      type: E,
      ...E === "checkbox" && O === void 0 ? {} : {
        value: O
      },
      ...m
    }), D ? i : f]
  });
});
process.env.NODE_ENV !== "production" && (Ap.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: r.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: r.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: r.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * @ignore
   */
  defaultChecked: r.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: r.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: r.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: r.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /*
   * @ignore
   */
  name: r.string,
  /**
   * @ignore
   */
  onBlur: r.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: r.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.object,
  /**
   * @ignore
   */
  tabIndex: r.oneOfType([r.number, r.string]),
  /**
   * The input component prop `type`.
   */
  type: r.string.isRequired,
  /**
   * The value of the component.
   */
  value: r.any
});
const RH = _e(/* @__PURE__ */ C("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), EH = _e(/* @__PURE__ */ C("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), IH = _e(/* @__PURE__ */ C("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function OH(e) {
  return De("MuiCheckbox", e);
}
const zh = Ne("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), PH = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: o,
    size: s
  } = e, i = {
    root: ["root", n && "indeterminate", `color${ce(o)}`, `size${ce(s)}`]
  }, a = fe(i, OH, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...a
  };
}, MH = te(Ap, {
  shouldForwardProp: (e) => Xn(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${ce(n.size)}`], n.color !== "default" && t[`color${ce(n.color)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${zh.checked}, &.${zh.indeterminate}`]: {
        color: (e.vars || e).palette[t].main
      },
      [`&.${zh.disabled}`]: {
        color: (e.vars || e).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), kH = /* @__PURE__ */ C(EH, {}), DH = /* @__PURE__ */ C(RH, {}), NH = /* @__PURE__ */ C(IH, {}), ml = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: s = kH,
    color: i = "primary",
    icon: a = DH,
    indeterminate: l = !1,
    indeterminateIcon: c = NH,
    inputProps: u,
    size: d = "medium",
    disableRipple: f = !1,
    className: p,
    ...m
  } = o, b = l ? c : a, v = l ? c : s, g = {
    ...o,
    disableRipple: f,
    color: i,
    indeterminate: l,
    size: d
  }, y = PH(g);
  return /* @__PURE__ */ C(MH, {
    type: "checkbox",
    inputProps: {
      "data-indeterminate": l,
      ...u
    },
    icon: /* @__PURE__ */ h.cloneElement(b, {
      fontSize: b.props.fontSize ?? d
    }),
    checkedIcon: /* @__PURE__ */ h.cloneElement(v, {
      fontSize: v.props.fontSize ?? d
    }),
    ownerState: g,
    ref: n,
    className: ae(y.root, p),
    disableRipple: f,
    ...m,
    classes: y
  });
});
process.env.NODE_ENV !== "production" && (ml.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: r.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: r.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: r.node,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: r.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: r.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: r.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: r.any
});
function $H(e) {
  return De("MuiCircularProgress", e);
}
Ne("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const $s = 44, sy = ss`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, iy = ss`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`, AH = typeof sy != "string" ? Qs`
        animation: ${sy} 1.4s linear infinite;
      ` : null, FH = typeof iy != "string" ? Qs`
        animation: ${iy} 1.4s ease-in-out infinite;
      ` : null, LH = (e) => {
  const {
    classes: t,
    variant: n,
    color: o,
    disableShrink: s
  } = e, i = {
    root: ["root", n, `color${ce(o)}`],
    svg: ["svg"],
    circle: ["circle", `circle${ce(n)}`, s && "circleDisableShrink"]
  };
  return fe(i, $H, t);
}, _H = te("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`color${ce(n.color)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: AH || {
      animation: `${sy} 1.4s linear infinite`
    }
  }, ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), VH = te("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  display: "block"
  // Keeps the progress centered
}), BH = te("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.circle, t[`circle${ce(n.variant)}`], n.disableShrink && t.circleDisableShrink];
  }
})(Fe(({
  theme: e
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: e.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" && !t.disableShrink,
    style: FH || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${iy} 1.4s ease-in-out infinite`
    }
  }]
}))), Fp = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiCircularProgress"
  }), {
    className: s,
    color: i = "primary",
    disableShrink: a = !1,
    size: l = 40,
    style: c,
    thickness: u = 3.6,
    value: d = 0,
    variant: f = "indeterminate",
    ...p
  } = o, m = {
    ...o,
    color: i,
    disableShrink: a,
    size: l,
    thickness: u,
    value: d,
    variant: f
  }, b = LH(m), v = {}, g = {}, y = {};
  if (f === "determinate") {
    const w = 2 * Math.PI * (($s - u) / 2);
    v.strokeDasharray = w.toFixed(3), y["aria-valuenow"] = Math.round(d), v.strokeDashoffset = `${((100 - d) / 100 * w).toFixed(3)}px`, g.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ C(_H, {
    className: ae(b.root, s),
    style: {
      width: l,
      height: l,
      ...g,
      ...c
    },
    ownerState: m,
    ref: n,
    role: "progressbar",
    ...y,
    ...p,
    children: /* @__PURE__ */ C(VH, {
      className: b.svg,
      ownerState: m,
      viewBox: `${$s / 2} ${$s / 2} ${$s} ${$s}`,
      children: /* @__PURE__ */ C(BH, {
        className: b.circle,
        style: v,
        ownerState: m,
        cx: $s,
        cy: $s,
        r: ($s - u) / 2,
        fill: "none",
        strokeWidth: u
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Fp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: Gn(r.bool, (e) => e.disableShrink && e.variant && e.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: r.oneOfType([r.number, r.string]),
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: r.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: r.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: r.oneOf(["determinate", "indeterminate"])
});
function Fx(e) {
  return e.substring(2).toLowerCase();
}
function zH(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function tl(e) {
  const {
    children: t,
    disableReactTree: n = !1,
    mouseEvent: o = "onClick",
    onClickAway: s,
    touchEvent: i = "onTouchEnd"
  } = e, a = h.useRef(!1), l = h.useRef(null), c = h.useRef(!1), u = h.useRef(!1);
  h.useEffect(() => (setTimeout(() => {
    c.current = !0;
  }, 0), () => {
    c.current = !1;
  }), []);
  const d = tt(Rs(t), l), f = xe((b) => {
    const v = u.current;
    u.current = !1;
    const g = qt(l.current);
    if (!c.current || !l.current || "clientX" in b && zH(b, g))
      return;
    if (a.current) {
      a.current = !1;
      return;
    }
    let y;
    b.composedPath ? y = b.composedPath().includes(l.current) : y = !g.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      b.target
    ) || l.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      b.target
    ), !y && (n || !v) && s(b);
  }), p = (b) => (v) => {
    u.current = !0;
    const g = t.props[b];
    g && g(v);
  }, m = {
    ref: d
  };
  return i !== !1 && (m[i] = p(i)), h.useEffect(() => {
    if (i !== !1) {
      const b = Fx(i), v = qt(l.current), g = () => {
        a.current = !0;
      };
      return v.addEventListener(b, f), v.addEventListener("touchmove", g), () => {
        v.removeEventListener(b, f), v.removeEventListener("touchmove", g);
      };
    }
  }, [f, i]), o !== !1 && (m[o] = p(o)), h.useEffect(() => {
    if (o !== !1) {
      const b = Fx(o), v = qt(l.current);
      return v.addEventListener(b, f), () => {
        v.removeEventListener(b, f);
      };
    }
  }, [f, o]), /* @__PURE__ */ h.cloneElement(t, m);
}
process.env.NODE_ENV !== "production" && (tl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: Ts.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: r.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: r.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: r.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: r.oneOf(["onTouchEnd", "onTouchStart", !1])
});
process.env.NODE_ENV !== "production" && (tl.propTypes = hl(tl.propTypes));
const HH = (e, t) => ({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%",
  // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
  ...t
}), jH = (e) => ({
  color: (e.vars || e).palette.text.primary,
  ...e.typography.body1,
  backgroundColor: (e.vars || e).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (e.vars || e).palette.common.white
  }
});
process.env.NODE_ENV !== "production" && (r.node, r.bool);
function GH(e) {
  const t = qt(e);
  return t.body === e ? Ao(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function Rc(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function Lx(e) {
  return parseInt(Ao(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function qH(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(e.tagName), o = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || o;
}
function _x(e, t, n, o, s) {
  const i = [t, n, ...o];
  [].forEach.call(e.children, (a) => {
    const l = !i.includes(a), c = !qH(a);
    l && c && Rc(a, s);
  });
}
function Hh(e, t) {
  let n = -1;
  return e.some((o, s) => t(o) ? (n = s, !0) : !1), n;
}
function WH(e, t) {
  const n = [], o = e.container;
  if (!t.disableScrollLock) {
    if (GH(o)) {
      const a = pP(Ao(o));
      n.push({
        value: o.style.paddingRight,
        property: "padding-right",
        el: o
      }), o.style.paddingRight = `${Lx(o) + a}px`;
      const l = qt(o).querySelectorAll(".mui-fixed");
      [].forEach.call(l, (c) => {
        n.push({
          value: c.style.paddingRight,
          property: "padding-right",
          el: c
        }), c.style.paddingRight = `${Lx(c) + a}px`;
      });
    }
    let i;
    if (o.parentNode instanceof DocumentFragment)
      i = qt(o).body;
    else {
      const a = o.parentElement, l = Ao(o);
      i = (a == null ? void 0 : a.nodeName) === "HTML" && l.getComputedStyle(a).overflowY === "scroll" ? a : o;
    }
    n.push({
      value: i.style.overflow,
      property: "overflow",
      el: i
    }, {
      value: i.style.overflowX,
      property: "overflow-x",
      el: i
    }, {
      value: i.style.overflowY,
      property: "overflow-y",
      el: i
    }), i.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: i,
      el: a,
      property: l
    }) => {
      i ? a.style.setProperty(l, i) : a.style.removeProperty(l);
    });
  };
}
function UH(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class KH {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(t, n) {
    let o = this.modals.indexOf(t);
    if (o !== -1)
      return o;
    o = this.modals.length, this.modals.push(t), t.modalRef && Rc(t.modalRef, !1);
    const s = UH(n);
    _x(n, t.mount, t.modalRef, s, !0);
    const i = Hh(this.containers, (a) => a.container === n);
    return i !== -1 ? (this.containers[i].modals.push(t), o) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: s
    }), o);
  }
  mount(t, n) {
    const o = Hh(this.containers, (i) => i.modals.includes(t)), s = this.containers[o];
    s.restore || (s.restore = WH(s, n));
  }
  remove(t, n = !0) {
    const o = this.modals.indexOf(t);
    if (o === -1)
      return o;
    const s = Hh(this.containers, (a) => a.modals.includes(t)), i = this.containers[s];
    if (i.modals.splice(i.modals.indexOf(t), 1), this.modals.splice(o, 1), i.modals.length === 0)
      i.restore && i.restore(), t.modalRef && Rc(t.modalRef, n), _x(i.container, t.mount, t.modalRef, i.hiddenSiblings, !1), this.containers.splice(s, 1);
    else {
      const a = i.modals[i.modals.length - 1];
      a.modalRef && Rc(a.modalRef, !1);
    }
    return o;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const YH = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function XH(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function QH(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (o) => e.ownerDocument.querySelector(`input[type="radio"]${o}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function ZH(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || QH(e));
}
function JH(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(YH)).forEach((o, s) => {
    const i = XH(o);
    i === -1 || !ZH(o) || (i === 0 ? t.push(o) : n.push({
      documentOrder: s,
      tabIndex: i,
      node: o
    }));
  }), n.sort((o, s) => o.tabIndex === s.tabIndex ? o.documentOrder - s.documentOrder : o.tabIndex - s.tabIndex).map((o) => o.node).concat(t);
}
function ej() {
  return !0;
}
function nl(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: o = !1,
    disableRestoreFocus: s = !1,
    getTabbable: i = JH,
    isEnabled: a = ej,
    open: l
  } = e, c = h.useRef(!1), u = h.useRef(null), d = h.useRef(null), f = h.useRef(null), p = h.useRef(null), m = h.useRef(!1), b = h.useRef(null), v = tt(Rs(t), b), g = h.useRef(null);
  h.useEffect(() => {
    !l || !b.current || (m.current = !n);
  }, [n, l]), h.useEffect(() => {
    if (!l || !b.current)
      return;
    const x = qt(b.current);
    return b.current.contains(x.activeElement) || (b.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), b.current.setAttribute("tabIndex", "-1")), m.current && b.current.focus()), () => {
      s || (f.current && f.current.focus && (c.current = !0, f.current.focus()), f.current = null);
    };
  }, [l]), h.useEffect(() => {
    if (!l || !b.current)
      return;
    const x = qt(b.current), S = (O) => {
      g.current = O, !(o || !a() || O.key !== "Tab") && x.activeElement === b.current && O.shiftKey && (c.current = !0, d.current && d.current.focus());
    }, T = () => {
      var D, R;
      const O = b.current;
      if (O === null)
        return;
      if (!x.hasFocus() || !a() || c.current) {
        c.current = !1;
        return;
      }
      if (O.contains(x.activeElement) || o && x.activeElement !== u.current && x.activeElement !== d.current)
        return;
      if (x.activeElement !== p.current)
        p.current = null;
      else if (p.current !== null)
        return;
      if (!m.current)
        return;
      let M = [];
      if ((x.activeElement === u.current || x.activeElement === d.current) && (M = i(b.current)), M.length > 0) {
        const P = !!((D = g.current) != null && D.shiftKey && ((R = g.current) == null ? void 0 : R.key) === "Tab"), F = M[0], $ = M[M.length - 1];
        typeof F != "string" && typeof $ != "string" && (P ? $.focus() : F.focus());
      } else
        O.focus();
    };
    x.addEventListener("focusin", T), x.addEventListener("keydown", S, !0);
    const E = setInterval(() => {
      x.activeElement && x.activeElement.tagName === "BODY" && T();
    }, 50);
    return () => {
      clearInterval(E), x.removeEventListener("focusin", T), x.removeEventListener("keydown", S, !0);
    };
  }, [n, o, s, a, l, i]);
  const y = (x) => {
    f.current === null && (f.current = x.relatedTarget), m.current = !0, p.current = x.target;
    const S = t.props.onFocus;
    S && S(x);
  }, w = (x) => {
    f.current === null && (f.current = x.relatedTarget), m.current = !0;
  };
  return /* @__PURE__ */ ie(h.Fragment, {
    children: [/* @__PURE__ */ C("div", {
      tabIndex: l ? 0 : -1,
      onFocus: w,
      ref: u,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ h.cloneElement(t, {
      ref: v,
      onFocus: y
    }), /* @__PURE__ */ C("div", {
      tabIndex: l ? 0 : -1,
      onFocus: w,
      ref: d,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (nl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: Ts,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: r.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: r.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: r.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: r.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: r.func,
  /**
   * If `true`, focus is locked.
   */
  open: r.bool.isRequired
});
process.env.NODE_ENV !== "production" && (nl.propTypes = hl(nl.propTypes));
function tj(e) {
  return typeof e == "function" ? e() : e;
}
function nj(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const Vx = () => {
}, fd = new KH();
function oj(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: o = !1,
    closeAfterTransition: s = !1,
    onTransitionEnter: i,
    onTransitionExited: a,
    children: l,
    onClose: c,
    open: u,
    rootRef: d
  } = e, f = h.useRef({}), p = h.useRef(null), m = h.useRef(null), b = tt(m, d), [v, g] = h.useState(!u), y = nj(l);
  let w = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (w = !1);
  const x = () => qt(p.current), S = () => (f.current.modalRef = m.current, f.current.mount = p.current, f.current), T = () => {
    fd.mount(S(), {
      disableScrollLock: o
    }), m.current && (m.current.scrollTop = 0);
  }, E = xe(() => {
    const A = tj(t) || x().body;
    fd.add(S(), A), m.current && T();
  }), O = () => fd.isTopModal(S()), M = xe((A) => {
    p.current = A, A && (u && O() ? T() : m.current && Rc(m.current, w));
  }), D = h.useCallback(() => {
    fd.remove(S(), w);
  }, [w]);
  h.useEffect(() => () => {
    D();
  }, [D]), h.useEffect(() => {
    u ? E() : (!y || !s) && D();
  }, [u, D, y, s, E]);
  const R = (A) => (k) => {
    var L;
    (L = A.onKeyDown) == null || L.call(A, k), !(k.key !== "Escape" || k.which === 229 || // Wait until IME is settled.
    !O()) && (n || (k.stopPropagation(), c && c(k, "escapeKeyDown")));
  }, P = (A) => (k) => {
    var L;
    (L = A.onClick) == null || L.call(A, k), k.target === k.currentTarget && c && c(k, "backdropClick");
  };
  return {
    getRootProps: (A = {}) => {
      const k = Pi(e);
      delete k.onTransitionEnter, delete k.onTransitionExited;
      const L = {
        ...k,
        ...A
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...L,
        onKeyDown: R(L),
        ref: b
      };
    },
    getBackdropProps: (A = {}) => {
      const k = A;
      return {
        "aria-hidden": !0,
        ...k,
        onClick: P(k),
        open: u
      };
    },
    getTransitionProps: () => {
      const A = () => {
        g(!1), i && i();
      }, k = () => {
        g(!0), a && a(), s && D();
      };
      return {
        onEnter: Yb(A, (l == null ? void 0 : l.props.onEnter) ?? Vx),
        onExited: Yb(k, (l == null ? void 0 : l.props.onExited) ?? Vx)
      };
    },
    rootRef: b,
    portalRef: M,
    isTopModal: O,
    exited: v,
    hasTransition: y
  };
}
function rj(e) {
  return De("MuiModal", e);
}
Ne("MuiModal", ["root", "hidden", "backdrop"]);
const sj = (e) => {
  const {
    open: t,
    exited: n,
    classes: o
  } = e;
  return fe({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, rj, o);
}, ij = te("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(Fe(({
  theme: e
}) => ({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: t
    }) => !t.open && t.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), aj = te($p, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), Tu = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: s = aj,
    BackdropProps: i,
    classes: a,
    className: l,
    closeAfterTransition: c = !1,
    children: u,
    container: d,
    component: f,
    components: p = {},
    componentsProps: m = {},
    disableAutoFocus: b = !1,
    disableEnforceFocus: v = !1,
    disableEscapeKeyDown: g = !1,
    disablePortal: y = !1,
    disableRestoreFocus: w = !1,
    disableScrollLock: x = !1,
    hideBackdrop: S = !1,
    keepMounted: T = !1,
    onBackdropClick: E,
    onClose: O,
    onTransitionEnter: M,
    onTransitionExited: D,
    open: R,
    slotProps: P = {},
    slots: F = {},
    // eslint-disable-next-line react/prop-types
    theme: $,
    ...N
  } = o, A = {
    ...o,
    closeAfterTransition: c,
    disableAutoFocus: b,
    disableEnforceFocus: v,
    disableEscapeKeyDown: g,
    disablePortal: y,
    disableRestoreFocus: w,
    disableScrollLock: x,
    hideBackdrop: S,
    keepMounted: T
  }, {
    getRootProps: k,
    getBackdropProps: L,
    getTransitionProps: B,
    portalRef: V,
    isTopModal: _,
    exited: z,
    hasTransition: j
  } = oj({
    ...A,
    rootRef: n
  }), W = {
    ...A,
    exited: z
  }, J = sj(W), G = {};
  if (u.props.tabIndex === void 0 && (G.tabIndex = "-1"), j) {
    const {
      onEnter: H,
      onExited: U
    } = B();
    G.onEnter = H, G.onExited = U;
  }
  const q = {
    ...N,
    slots: {
      root: p.Root,
      backdrop: p.Backdrop,
      ...F
    },
    slotProps: {
      ...m,
      ...P
    }
  }, [Z, Y] = bn("root", {
    elementType: ij,
    externalForwardedProps: q,
    getSlotProps: k,
    additionalProps: {
      ref: n,
      as: f
    },
    ownerState: W,
    className: ae(l, J == null ? void 0 : J.root, !W.open && W.exited && (J == null ? void 0 : J.hidden))
  }), [Q, ee] = bn("backdrop", {
    elementType: s,
    externalForwardedProps: q,
    additionalProps: i,
    getSlotProps: (H) => L({
      ...H,
      onClick: (U) => {
        E && E(U), H != null && H.onClick && H.onClick(U);
      }
    }),
    className: ae(i == null ? void 0 : i.className, J == null ? void 0 : J.backdrop),
    ownerState: W
  }), ne = tt(i == null ? void 0 : i.ref, ee.ref);
  return !T && !R && (!j || z) ? null : /* @__PURE__ */ C(Hc, {
    ref: V,
    container: d,
    disablePortal: y,
    children: /* @__PURE__ */ ie(Z, {
      ...Y,
      children: [!S && s ? /* @__PURE__ */ C(Q, {
        ...ee,
        ref: ne
      }) : null, /* @__PURE__ */ C(nl, {
        disableEnforceFocus: v,
        disableAutoFocus: b,
        disableRestoreFocus: w,
        isEnabled: _,
        open: R,
        children: /* @__PURE__ */ h.cloneElement(u, G)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (Tu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: r.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: r.object,
  /**
   * A single child content element.
   */
  children: Ts.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: r.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: r.shape({
    Backdrop: r.elementType,
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: r.shape({
    backdrop: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: r.oneOfType([Ko, r.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: r.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: r.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: r.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: r.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: r.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: r.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: r.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: r.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: r.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: r.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: r.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: r.shape({
    backdrop: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    backdrop: r.elementType,
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function lj(e) {
  return De("MuiDialog", e);
}
const Ec = Ne("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), Zv = /* @__PURE__ */ h.createContext({});
process.env.NODE_ENV !== "production" && (Zv.displayName = "DialogContext");
const cj = te($p, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), uj = (e) => {
  const {
    classes: t,
    scroll: n,
    maxWidth: o,
    fullWidth: s,
    fullScreen: i
  } = e, a = {
    root: ["root"],
    container: ["container", `scroll${ce(n)}`],
    paper: ["paper", `paperScroll${ce(n)}`, `paperWidth${ce(String(o))}`, s && "paperFullWidth", i && "paperFullScreen"]
  };
  return fe(a, lj, t);
}, dj = te(Tu, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), fj = te("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.container, t[`scroll${ce(n.scroll)}`]];
  }
})({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&::after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    }
  }]
}), pj = te(ao, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`scrollPaper${ce(n.scroll)}`], t[`paperWidth${ce(String(n.maxWidth))}`], n.fullWidth && t.paperFullWidth, n.fullScreen && t.paperFullScreen];
  }
})(Fe(({
  theme: e
}) => ({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  },
  variants: [{
    props: {
      scroll: "paper"
    },
    style: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    }
  }, {
    props: {
      scroll: "body"
    },
    style: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "initial"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.maxWidth,
    style: {
      maxWidth: "calc(100% - 64px)"
    }
  }, {
    props: {
      maxWidth: "xs"
    },
    style: {
      maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
      [`&.${Ec.paperScrollBody}`]: {
        [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  }, ...Object.keys(e.breakpoints.values).filter((t) => t !== "xs").map((t) => ({
    props: {
      maxWidth: t
    },
    style: {
      maxWidth: `${e.breakpoints.values[t]}${e.breakpoints.unit}`,
      [`&.${Ec.paperScrollBody}`]: {
        [e.breakpoints.down(e.breakpoints.values[t] + 32 * 2)]: {
          maxWidth: "calc(100% - 64px)"
        }
      }
    }
  })), {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      width: "calc(100% - 64px)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullScreen,
    style: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      [`&.${Ec.paperScrollBody}`]: {
        margin: 0,
        maxWidth: "100%"
      }
    }
  }]
}))), Jv = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiDialog"
  }), s = sn(), i = {
    enter: s.transitions.duration.enteringScreen,
    exit: s.transitions.duration.leavingScreen
  }, {
    "aria-describedby": a,
    "aria-labelledby": l,
    "aria-modal": c = !0,
    BackdropComponent: u,
    BackdropProps: d,
    children: f,
    className: p,
    disableEscapeKeyDown: m = !1,
    fullScreen: b = !1,
    fullWidth: v = !1,
    maxWidth: g = "sm",
    onBackdropClick: y,
    onClick: w,
    onClose: x,
    open: S,
    PaperComponent: T = ao,
    PaperProps: E = {},
    scroll: O = "paper",
    TransitionComponent: M = ti,
    transitionDuration: D = i,
    TransitionProps: R,
    ...P
  } = o, F = {
    ...o,
    disableEscapeKeyDown: m,
    fullScreen: b,
    fullWidth: v,
    maxWidth: g,
    scroll: O
  }, $ = uj(F), N = h.useRef(), A = (V) => {
    N.current = V.target === V.currentTarget;
  }, k = (V) => {
    w && w(V), N.current && (N.current = null, y && y(V), x && x(V, "backdropClick"));
  }, L = gt(l), B = h.useMemo(() => ({
    titleId: L
  }), [L]);
  return /* @__PURE__ */ C(dj, {
    className: ae($.root, p),
    closeAfterTransition: !0,
    components: {
      Backdrop: cj
    },
    componentsProps: {
      backdrop: {
        transitionDuration: D,
        as: u,
        ...d
      }
    },
    disableEscapeKeyDown: m,
    onClose: x,
    open: S,
    ref: n,
    onClick: k,
    ownerState: F,
    ...P,
    children: /* @__PURE__ */ C(M, {
      appear: !0,
      in: S,
      timeout: D,
      role: "presentation",
      ...R,
      children: /* @__PURE__ */ C(fj, {
        className: ae($.container),
        onMouseDown: A,
        ownerState: F,
        children: /* @__PURE__ */ C(pj, {
          as: T,
          elevation: 24,
          role: "dialog",
          "aria-describedby": a,
          "aria-labelledby": L,
          "aria-modal": c,
          ...E,
          className: ae($.paper, E.className),
          ownerState: F,
          children: /* @__PURE__ */ C(Zv.Provider, {
            value: B,
            children: f
          })
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Jv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": r.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": r.string,
  /**
   * Informs assistive technologies that the element is modal.
   * It's added on the element with role="dialog".
   * @default true
   */
  "aria-modal": r.oneOfType([r.oneOf(["false", "true"]), r.bool]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: r.elementType,
  /**
   * @ignore
   */
  BackdropProps: r.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: r.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: r.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: r.oneOfType([r.oneOf(["xs", "sm", "md", "lg", "xl", !1]), r.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: r.func,
  /**
   * @ignore
   */
  onClick: r.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: r.elementType,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: r.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: r.oneOf(["body", "paper"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: r.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: r.oneOfType([r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: r.object
});
function hj(e) {
  return De("MuiDialogActions", e);
}
Ne("MuiDialogActions", ["root", "spacing"]);
const gj = (e) => {
  const {
    classes: t,
    disableSpacing: n
  } = e;
  return fe({
    root: ["root", !n && "spacing"]
  }, hj, t);
}, mj = te("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableSpacing && t.spacing];
  }
})({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disableSpacing,
    style: {
      "& > :not(style) ~ :not(style)": {
        marginLeft: 8
      }
    }
  }]
}), oM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: s,
    disableSpacing: i = !1,
    ...a
  } = o, l = {
    ...o,
    disableSpacing: i
  }, c = gj(l);
  return /* @__PURE__ */ C(mj, {
    className: ae(c.root, s),
    ownerState: l,
    ref: n,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (oM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function bj(e) {
  return De("MuiDialogContent", e);
}
Ne("MuiDialogContent", ["root", "dividers"]);
function yj(e) {
  return De("MuiDialogTitle", e);
}
const vj = Ne("MuiDialogTitle", ["root"]), Cj = (e) => {
  const {
    classes: t,
    dividers: n
  } = e;
  return fe({
    root: ["root", n && "dividers"]
  }, bj, t);
}, wj = te("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.dividers && t.dividers];
  }
})(Fe(({
  theme: e
}) => ({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px",
  variants: [{
    props: ({
      ownerState: t
    }) => t.dividers,
    style: {
      padding: "16px 24px",
      borderTop: `1px solid ${(e.vars || e).palette.divider}`,
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dividers,
    style: {
      [`.${vj.root} + &`]: {
        paddingTop: 0
      }
    }
  }]
}))), eC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: s,
    dividers: i = !1,
    ...a
  } = o, l = {
    ...o,
    dividers: i
  }, c = Cj(l);
  return /* @__PURE__ */ C(wj, {
    className: ae(c.root, s),
    ownerState: l,
    ref: n,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (eC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const Sj = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, yj, t);
}, xj = te(yn, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), rM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiDialogTitle"
  }), {
    className: s,
    id: i,
    ...a
  } = o, l = o, c = Sj(l), {
    titleId: u = i
  } = h.useContext(Zv);
  return /* @__PURE__ */ C(xj, {
    component: "h2",
    className: ae(c.root, s),
    ownerState: l,
    ref: n,
    variant: "h6",
    id: i ?? u,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (rM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * @ignore
   */
  id: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Tj(e) {
  return De("MuiDivider", e);
}
const Bx = Ne("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), Rj = (e) => {
  const {
    absolute: t,
    children: n,
    classes: o,
    flexItem: s,
    light: i,
    orientation: a,
    textAlign: l,
    variant: c
  } = e;
  return fe({
    root: ["root", t && "absolute", c, i && "light", a === "vertical" && "vertical", s && "flexItem", n && "withChildren", n && a === "vertical" && "withChildrenVertical", l === "right" && a !== "vertical" && "textAlignRight", l === "left" && a !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", a === "vertical" && "wrapperVertical"]
  }, Tj, o);
}, Ej = te("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.absolute && t.absolute, t[n.variant], n.light && t.light, n.orientation === "vertical" && t.vertical, n.flexItem && t.flexItem, n.children && t.withChildren, n.children && n.orientation === "vertical" && t.withChildrenVertical, n.textAlign === "right" && n.orientation !== "vertical" && t.textAlignRight, n.textAlign === "left" && n.orientation !== "vertical" && t.textAlignLeft];
  }
})(Fe(({
  theme: e
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : he(e.palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: e.spacing(2),
      marginRight: e.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: e.spacing(1),
      marginBottom: e.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.children && t.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(e.vars || e).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.orientation === "vertical" && t.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "right" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.textAlign === "left" && t.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), Ij = te("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.wrapper, n.orientation === "vertical" && t.wrapperVertical];
  }
})(Fe(({
  theme: e
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${e.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${e.spacing(1)} * 1.2)`
    }
  }]
}))), jc = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: s = !1,
    children: i,
    className: a,
    orientation: l = "horizontal",
    component: c = i || l === "vertical" ? "div" : "hr",
    flexItem: u = !1,
    light: d = !1,
    role: f = c !== "hr" ? "separator" : void 0,
    textAlign: p = "center",
    variant: m = "fullWidth",
    ...b
  } = o, v = {
    ...o,
    absolute: s,
    component: c,
    flexItem: u,
    light: d,
    orientation: l,
    role: f,
    textAlign: p,
    variant: m
  }, g = Rj(v);
  return /* @__PURE__ */ C(Ej, {
    as: c,
    className: ae(g.root, a),
    role: f,
    ref: n,
    ownerState: v,
    "aria-orientation": f === "separator" && (c !== "hr" || l === "vertical") ? l : void 0,
    ...b,
    children: i ? /* @__PURE__ */ C(Ij, {
      className: g.wrapper,
      ownerState: v,
      children: i
    }) : null
  });
});
jc && (jc.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (jc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: r.bool,
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: r.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: r.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: r.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: r.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: r.oneOfType([r.oneOf(["fullWidth", "inset", "middle"]), r.string])
});
function Oj(e, t, n) {
  const o = t.getBoundingClientRect(), s = n && n.getBoundingClientRect(), i = Ao(t);
  let a;
  if (t.fakeTransform)
    a = t.fakeTransform;
  else {
    const u = i.getComputedStyle(t);
    a = u.getPropertyValue("-webkit-transform") || u.getPropertyValue("transform");
  }
  let l = 0, c = 0;
  if (a && a !== "none" && typeof a == "string") {
    const u = a.split("(")[1].split(")")[0].split(",");
    l = parseInt(u[4], 10), c = parseInt(u[5], 10);
  }
  return e === "left" ? s ? `translateX(${s.right + l - o.left}px)` : `translateX(${i.innerWidth + l - o.left}px)` : e === "right" ? s ? `translateX(-${o.right - s.left - l}px)` : `translateX(-${o.left + o.width - l}px)` : e === "up" ? s ? `translateY(${s.bottom + c - o.top}px)` : `translateY(${i.innerHeight + c - o.top}px)` : s ? `translateY(-${o.top - s.top + o.height - c}px)` : `translateY(-${o.top + o.height - c}px)`;
}
function sM(e) {
  return typeof e == "function" ? e() : e;
}
function pd(e, t, n) {
  const o = sM(n), s = Oj(e, t, o);
  s && (t.style.webkitTransform = s, t.style.transform = s);
}
const Lp = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = sn(), s = {
    enter: o.transitions.easing.easeOut,
    exit: o.transitions.easing.sharp
  }, i = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    addEndListener: a,
    appear: l = !0,
    children: c,
    container: u,
    direction: d = "down",
    easing: f = s,
    in: p,
    onEnter: m,
    onEntered: b,
    onEntering: v,
    onExit: g,
    onExited: y,
    onExiting: w,
    style: x,
    timeout: S = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: T = So,
    ...E
  } = t, O = h.useRef(null), M = tt(Rs(c), O, n), D = (B) => (V) => {
    B && (V === void 0 ? B(O.current) : B(O.current, V));
  }, R = D((B, V) => {
    pd(d, B, u), Ep(B), m && m(B, V);
  }), P = D((B, V) => {
    const _ = Jr({
      timeout: S,
      style: x,
      easing: f
    }, {
      mode: "enter"
    });
    B.style.webkitTransition = o.transitions.create("-webkit-transform", {
      ..._
    }), B.style.transition = o.transitions.create("transform", {
      ..._
    }), B.style.webkitTransform = "none", B.style.transform = "none", v && v(B, V);
  }), F = D(b), $ = D(w), N = D((B) => {
    const V = Jr({
      timeout: S,
      style: x,
      easing: f
    }, {
      mode: "exit"
    });
    B.style.webkitTransition = o.transitions.create("-webkit-transform", V), B.style.transition = o.transitions.create("transform", V), pd(d, B, u), g && g(B);
  }), A = D((B) => {
    B.style.webkitTransition = "", B.style.transition = "", y && y(B);
  }), k = (B) => {
    a && a(O.current, B);
  }, L = h.useCallback(() => {
    O.current && pd(d, O.current, u);
  }, [d, u]);
  return h.useEffect(() => {
    if (p || d === "down" || d === "right")
      return;
    const B = Yi(() => {
      O.current && pd(d, O.current, u);
    }), V = Ao(O.current);
    return V.addEventListener("resize", B), () => {
      B.clear(), V.removeEventListener("resize", B);
    };
  }, [d, p, u]), h.useEffect(() => {
    p || L();
  }, [p, L]), /* @__PURE__ */ C(T, {
    nodeRef: O,
    onEnter: R,
    onEntered: F,
    onEntering: P,
    onExit: N,
    onExited: A,
    onExiting: $,
    addEndListener: k,
    appear: l,
    in: p,
    timeout: S,
    ...E,
    children: (B, V) => /* @__PURE__ */ h.cloneElement(c, {
      ref: M,
      style: {
        visibility: B === "exited" && !p ? "hidden" : void 0,
        ...x,
        ...c.props.style
      },
      ...V
    })
  });
});
process.env.NODE_ENV !== "production" && (Lp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: r.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: r.bool,
  /**
   * A single child content element.
   */
  children: Ts.isRequired,
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the container the Slide is transitioning from.
   */
  container: Gn(r.oneOfType([Ko, r.func]), (e) => {
    if (e.open) {
      const t = sM(e.container);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `container` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `container` prop provided to the component is invalid.", "It should be an HTML element instance."].join(`
`));
    }
    return null;
  }),
  /**
   * Direction the child node will enter from.
   * @default 'down'
   */
  direction: r.oneOf(["down", "left", "right", "up"]),
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   * @default {
   *   enter: theme.transitions.easing.easeOut,
   *   exit: theme.transitions.easing.sharp,
   * }
   */
  easing: r.oneOfType([r.shape({
    enter: r.string,
    exit: r.string
  }), r.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: r.bool,
  /**
   * @ignore
   */
  onEnter: r.func,
  /**
   * @ignore
   */
  onEntered: r.func,
  /**
   * @ignore
   */
  onEntering: r.func,
  /**
   * @ignore
   */
  onExit: r.func,
  /**
   * @ignore
   */
  onExited: r.func,
  /**
   * @ignore
   */
  onExiting: r.func,
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: r.oneOfType([r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })])
});
function Pj(e) {
  return De("MuiDrawer", e);
}
Ne("MuiDrawer", ["root", "docked", "paper", "paperAnchorLeft", "paperAnchorRight", "paperAnchorTop", "paperAnchorBottom", "paperAnchorDockedLeft", "paperAnchorDockedRight", "paperAnchorDockedTop", "paperAnchorDockedBottom", "modal"]);
const iM = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, (n.variant === "permanent" || n.variant === "persistent") && t.docked, t.modal];
}, Mj = (e) => {
  const {
    classes: t,
    anchor: n,
    variant: o
  } = e, s = {
    root: ["root"],
    docked: [(o === "permanent" || o === "persistent") && "docked"],
    modal: ["modal"],
    paper: ["paper", `paperAnchor${ce(n)}`, o !== "temporary" && `paperAnchorDocked${ce(n)}`]
  };
  return fe(s, Pj, t);
}, kj = te(Tu, {
  name: "MuiDrawer",
  slot: "Root",
  overridesResolver: iM
})(Fe(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.drawer
}))), zx = te("div", {
  shouldForwardProp: Xn,
  name: "MuiDrawer",
  slot: "Docked",
  skipVariantsResolver: !1,
  overridesResolver: iM
})({
  flex: "0 0 auto"
}), Dj = te(ao, {
  name: "MuiDrawer",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`paperAnchor${ce(n.anchor)}`], n.variant !== "temporary" && t[`paperAnchorDocked${ce(n.anchor)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  overflowY: "auto",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  flex: "1 0 auto",
  zIndex: (e.vars || e).zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  // temporary style
  position: "fixed",
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0,
  variants: [{
    props: {
      anchor: "left"
    },
    style: {
      left: 0
    }
  }, {
    props: {
      anchor: "top"
    },
    style: {
      top: 0,
      left: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: {
      anchor: "right"
    },
    style: {
      right: 0
    }
  }, {
    props: {
      anchor: "bottom"
    },
    style: {
      top: "auto",
      left: 0,
      bottom: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "left" && t.variant !== "temporary",
    style: {
      borderRight: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "top" && t.variant !== "temporary",
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "right" && t.variant !== "temporary",
    style: {
      borderLeft: `1px solid ${(e.vars || e).palette.divider}`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchor === "bottom" && t.variant !== "temporary",
    style: {
      borderTop: `1px solid ${(e.vars || e).palette.divider}`
    }
  }]
}))), aM = {
  left: "right",
  right: "left",
  top: "down",
  bottom: "up"
};
function Nj(e) {
  return ["left", "right"].includes(e);
}
function $j({
  direction: e
}, t) {
  return e === "rtl" && Nj(t) ? aM[t] : t;
}
const lM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiDrawer"
  }), s = sn(), i = _t(), a = {
    enter: s.transitions.duration.enteringScreen,
    exit: s.transitions.duration.leavingScreen
  }, {
    anchor: l = "left",
    BackdropProps: c,
    children: u,
    className: d,
    elevation: f = 16,
    hideBackdrop: p = !1,
    ModalProps: {
      BackdropProps: m,
      ...b
    } = {},
    onClose: v,
    open: g = !1,
    PaperProps: y = {},
    SlideProps: w,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: x = Lp,
    transitionDuration: S = a,
    variant: T = "temporary",
    ...E
  } = o, O = h.useRef(!1);
  h.useEffect(() => {
    O.current = !0;
  }, []);
  const M = $j({
    direction: i ? "rtl" : "ltr"
  }, l), R = {
    ...o,
    anchor: l,
    elevation: f,
    open: g,
    variant: T,
    ...E
  }, P = Mj(R), F = /* @__PURE__ */ C(Dj, {
    elevation: T === "temporary" ? f : 0,
    square: !0,
    ...y,
    className: ae(P.paper, y.className),
    ownerState: R,
    children: u
  });
  if (T === "permanent")
    return /* @__PURE__ */ C(zx, {
      className: ae(P.root, P.docked, d),
      ownerState: R,
      ref: n,
      ...E,
      children: F
    });
  const $ = /* @__PURE__ */ C(x, {
    in: g,
    direction: aM[M],
    timeout: S,
    appear: O.current,
    ...w,
    children: F
  });
  return T === "persistent" ? /* @__PURE__ */ C(zx, {
    className: ae(P.root, P.docked, d),
    ownerState: R,
    ref: n,
    ...E,
    children: $
  }) : /* @__PURE__ */ C(kj, {
    BackdropProps: {
      ...c,
      ...m,
      transitionDuration: S
    },
    className: ae(P.root, P.modal, d),
    open: g,
    ownerState: R,
    onClose: v,
    hideBackdrop: p,
    ref: n,
    ...E,
    ...b,
    children: $
  });
});
process.env.NODE_ENV !== "production" && (lM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Side from which the drawer will appear.
   * @default 'left'
   */
  anchor: r.oneOf(["bottom", "left", "right", "top"]),
  /**
   * @ignore
   */
  BackdropProps: r.object,
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The elevation of the drawer.
   * @default 16
   */
  elevation: Wr,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: r.bool,
  /**
   * Props applied to the [`Modal`](https://mui.com/material-ui/api/modal/) element.
   * @default {}
   */
  ModalProps: r.object,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: r.func,
  /**
   * If `true`, the component is shown.
   * @default false
   */
  open: r.bool,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: r.object,
  /**
   * Props applied to the [`Slide`](https://mui.com/material-ui/api/slide/) element.
   */
  SlideProps: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: r.oneOfType([r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })]),
  /**
   * The variant to use.
   * @default 'temporary'
   */
  variant: r.oneOf(["permanent", "persistent", "temporary"])
});
const Aj = (e) => {
  const {
    classes: t,
    disableUnderline: n,
    startAdornment: o,
    endAdornment: s,
    size: i,
    hiddenLabel: a,
    multiline: l
  } = e, c = {
    root: ["root", !n && "underline", o && "adornedStart", s && "adornedEnd", i === "small" && `size${ce(i)}`, a && "hiddenLabel", l && "multiline"],
    input: ["input"]
  }, u = fe(c, gz, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...u
  };
}, Fj = te(kp, {
  shouldForwardProp: (e) => Xn(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...Pp(e, t), !n.disableUnderline && t.underline];
  }
})(Fe(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", o = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", s = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", i = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : s,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o
      }
    },
    [`&.${Vo.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o
    },
    [`&.${Vo.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : i
    },
    variants: [{
      props: ({
        ownerState: a
      }) => !a.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${Vo.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${Vo.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${Vo.disabled}, .${Vo.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${Vo.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter($t()).map(([a]) => {
      var l;
      return {
        props: {
          disableUnderline: !1,
          color: a
        },
        style: {
          "&::after": {
            borderBottom: `2px solid ${(l = (e.vars || e).palette[a]) == null ? void 0 : l.main}`
          }
        }
      };
    }), {
      props: ({
        ownerState: a
      }) => a.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: a
      }) => a.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: a,
        size: l
      }) => a.multiline && l === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline && a.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: a
      }) => a.multiline && a.hiddenLabel && a.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), Lj = te(Dp, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: Mp
})(Fe(({
  theme: e
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hiddenLabel && t.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), Gc = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiFilledInput"
  }), {
    disableUnderline: s = !1,
    components: i = {},
    componentsProps: a,
    fullWidth: l = !1,
    hiddenLabel: c,
    // declare here to prevent spreading to DOM
    inputComponent: u = "input",
    multiline: d = !1,
    slotProps: f,
    slots: p = {},
    type: m = "text",
    ...b
  } = o, v = {
    ...o,
    disableUnderline: s,
    fullWidth: l,
    inputComponent: u,
    multiline: d,
    type: m
  }, g = Aj(o), y = {
    root: {
      ownerState: v
    },
    input: {
      ownerState: v
    }
  }, w = f ?? a ? Bn(y, f ?? a) : y, x = p.root ?? i.Root ?? Fj, S = p.input ?? i.Input ?? Lj;
  return /* @__PURE__ */ C(Xi, {
    slots: {
      root: x,
      input: S
    },
    slotProps: w,
    fullWidth: l,
    inputComponent: u,
    multiline: d,
    ref: n,
    type: m,
    ...b,
    classes: g
  });
});
process.env.NODE_ENV !== "production" && (Gc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: r.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary"]), r.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: r.shape({
    Input: r.elementType,
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: r.shape({
    input: r.object,
    root: r.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: r.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: r.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: r.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: r.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: r.bool,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: r.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: r.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: r.oneOfType([r.number, r.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: r.oneOfType([r.number, r.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: r.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: r.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: r.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: r.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: r.oneOfType([r.number, r.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: r.shape({
    input: r.object,
    root: r.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: r.shape({
    input: r.elementType,
    root: r.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: r.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: r.any
});
Gc && (Gc.muiName = "Input");
function _j(e) {
  return De("MuiFormControl", e);
}
Ne("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const Vj = (e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: o
  } = e, s = {
    root: ["root", n !== "none" && `margin${ce(n)}`, o && "fullWidth"]
  };
  return fe(s, _j, t);
}, Bj = te("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => ({
    ...t.root,
    ...t[`margin${ce(e.margin)}`],
    ...e.fullWidth && t.fullWidth
  })
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), bl = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiFormControl"
  }), {
    children: s,
    className: i,
    color: a = "primary",
    component: l = "div",
    disabled: c = !1,
    error: u = !1,
    focused: d,
    fullWidth: f = !1,
    hiddenLabel: p = !1,
    margin: m = "none",
    required: b = !1,
    size: v = "medium",
    variant: g = "outlined",
    ...y
  } = o, w = {
    ...o,
    color: a,
    component: l,
    disabled: c,
    error: u,
    fullWidth: f,
    hiddenLabel: p,
    margin: m,
    required: b,
    size: v,
    variant: g
  }, x = Vj(w), [S, T] = h.useState(() => {
    let N = !1;
    return s && h.Children.forEach(s, (A) => {
      if (!Sc(A, ["Input", "Select"]))
        return;
      const k = Sc(A, ["Select"]) ? A.props.input : A;
      k && uz(k.props) && (N = !0);
    }), N;
  }), [E, O] = h.useState(() => {
    let N = !1;
    return s && h.Children.forEach(s, (A) => {
      Sc(A, ["Input", "Select"]) && (Ef(A.props, !0) || Ef(A.props.inputProps, !0)) && (N = !0);
    }), N;
  }), [M, D] = h.useState(!1);
  c && M && D(!1);
  const R = d !== void 0 && !c ? d : M;
  let P;
  const F = h.useRef(!1);
  process.env.NODE_ENV !== "production" && (P = () => (F.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), F.current = !0, () => {
    F.current = !1;
  }));
  const $ = h.useMemo(() => ({
    adornedStart: S,
    setAdornedStart: T,
    color: a,
    disabled: c,
    error: u,
    filled: E,
    focused: R,
    fullWidth: f,
    hiddenLabel: p,
    size: v,
    onBlur: () => {
      D(!1);
    },
    onEmpty: () => {
      O(!1);
    },
    onFilled: () => {
      O(!0);
    },
    onFocus: () => {
      D(!0);
    },
    registerEffect: P,
    required: b,
    variant: g
  }), [S, a, c, u, E, R, f, p, P, b, v, g]);
  return /* @__PURE__ */ C(xu.Provider, {
    value: $,
    children: /* @__PURE__ */ C(Bj, {
      as: l,
      ownerState: w,
      className: ae(x.root, i),
      ref: n,
      ...y,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && (bl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: r.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: r.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: r.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: r.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: r.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
function zj(e) {
  return De("MuiFormControlLabel", e);
}
const cc = Ne("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), Hj = (e) => {
  const {
    classes: t,
    disabled: n,
    labelPlacement: o,
    error: s,
    required: i
  } = e, a = {
    root: ["root", n && "disabled", `labelPlacement${ce(o)}`, s && "error", i && "required"],
    label: ["label", n && "disabled"],
    asterisk: ["asterisk", s && "error"]
  };
  return fe(a, zj, t);
}, jj = te("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${cc.label}`]: t.label
    }, t.root, t[`labelPlacement${ce(n.labelPlacement)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${cc.disabled}`]: {
    cursor: "default"
  },
  [`& .${cc.label}`]: {
    [`&.${cc.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  },
  variants: [{
    props: {
      labelPlacement: "start"
    },
    style: {
      flexDirection: "row-reverse",
      marginRight: -11
    }
  }, {
    props: {
      labelPlacement: "top"
    },
    style: {
      flexDirection: "column-reverse"
    }
  }, {
    props: {
      labelPlacement: "bottom"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      labelPlacement: t
    }) => t === "start" || t === "top" || t === "bottom",
    style: {
      marginLeft: 16
      // used for row presentation of radio/checkbox
    }
  }]
}))), Gj = te("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(Fe(({
  theme: e
}) => ({
  [`&.${cc.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), qc = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    checked: s,
    className: i,
    componentsProps: a = {},
    control: l,
    disabled: c,
    disableTypography: u,
    inputRef: d,
    label: f,
    labelPlacement: p = "end",
    name: m,
    onChange: b,
    required: v,
    slots: g = {},
    slotProps: y = {},
    value: w,
    ...x
  } = o, S = lo(), T = c ?? l.props.disabled ?? (S == null ? void 0 : S.disabled), E = v ?? l.props.required, O = {
    disabled: T,
    required: E
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((A) => {
    typeof l.props[A] > "u" && typeof o[A] < "u" && (O[A] = o[A]);
  });
  const M = Es({
    props: o,
    muiFormControl: S,
    states: ["error"]
  }), D = {
    ...o,
    disabled: T,
    labelPlacement: p,
    required: E,
    error: M.error
  }, R = Hj(D), P = {
    slots: g,
    slotProps: {
      ...a,
      ...y
    }
  }, [F, $] = bn("typography", {
    elementType: yn,
    externalForwardedProps: P,
    ownerState: D
  });
  let N = f;
  return N != null && N.type !== yn && !u && (N = /* @__PURE__ */ C(F, {
    component: "span",
    ...$,
    className: ae(R.label, $ == null ? void 0 : $.className),
    children: N
  })), /* @__PURE__ */ ie(jj, {
    className: ae(R.root, i),
    ownerState: D,
    ref: n,
    ...x,
    children: [/* @__PURE__ */ h.cloneElement(l, O), E ? /* @__PURE__ */ ie("div", {
      children: [N, /* @__PURE__ */ ie(Gj, {
        ownerState: D,
        "aria-hidden": !0,
        className: R.asterisk,
        children: [" ", "*"]
      })]
    }) : N]
  });
});
process.env.NODE_ENV !== "production" && (qc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: r.shape({
    typography: r.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: r.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: r.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: r.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: r.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: r.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: r.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: r.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    typography: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    typography: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value of the component.
   */
  value: r.any
});
function qj(e) {
  return De("MuiFormGroup", e);
}
Ne("MuiFormGroup", ["root", "row", "error"]);
const Wj = (e) => {
  const {
    classes: t,
    row: n,
    error: o
  } = e;
  return fe({
    root: ["root", n && "row", o && "error"]
  }, qj, t);
}, Uj = te("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.row && t.row];
  }
})({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap",
  variants: [{
    props: {
      row: !0
    },
    style: {
      flexDirection: "row"
    }
  }]
}), tC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiFormGroup"
  }), {
    className: s,
    row: i = !1,
    ...a
  } = o, l = lo(), c = Es({
    props: o,
    muiFormControl: l,
    states: ["error"]
  }), u = {
    ...o,
    row: i,
    error: c.error
  }, d = Wj(u);
  return /* @__PURE__ */ C(Uj, {
    className: ae(d.root, s),
    ownerState: u,
    ref: n,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (tC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Kj(e) {
  return De("MuiFormHelperText", e);
}
const Hx = Ne("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var jx;
const Yj = (e) => {
  const {
    classes: t,
    contained: n,
    size: o,
    disabled: s,
    error: i,
    filled: a,
    focused: l,
    required: c
  } = e, u = {
    root: ["root", s && "disabled", i && "error", o && `size${ce(o)}`, n && "contained", l && "focused", a && "filled", c && "required"]
  };
  return fe(u, Kj, t);
}, Xj = te("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${ce(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }
})(Fe(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${Hx.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${Hx.error}`]: {
    color: (e.vars || e).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => t.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), _p = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: s,
    className: i,
    component: a = "p",
    disabled: l,
    error: c,
    filled: u,
    focused: d,
    margin: f,
    required: p,
    variant: m,
    ...b
  } = o, v = lo(), g = Es({
    props: o,
    muiFormControl: v,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), y = {
    ...o,
    component: a,
    contained: g.variant === "filled" || g.variant === "outlined",
    variant: g.variant,
    size: g.size,
    disabled: g.disabled,
    error: g.error,
    filled: g.filled,
    focused: g.focused,
    required: g.required
  };
  delete y.ownerState;
  const w = Yj(y);
  return /* @__PURE__ */ C(Xj, {
    as: a,
    className: ae(w.root, i),
    ref: n,
    ...b,
    ownerState: y,
    children: s === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      jx || (jx = /* @__PURE__ */ C("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      }))
    ) : s
  });
});
process.env.NODE_ENV !== "production" && (_p.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: r.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: r.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: r.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: r.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: r.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   */
  variant: r.oneOfType([r.oneOf(["filled", "outlined", "standard"]), r.string])
});
function Qj(e) {
  return De("MuiFormLabel", e);
}
const Ic = Ne("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), Zj = (e) => {
  const {
    classes: t,
    color: n,
    focused: o,
    disabled: s,
    error: i,
    filled: a,
    required: l
  } = e, c = {
    root: ["root", `color${ce(n)}`, s && "disabled", i && "error", a && "filled", o && "focused", l && "required"],
    asterisk: ["asterisk", i && "error"]
  };
  return fe(c, Qj, t);
}, Jj = te("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => ({
    ...t.root,
    ...e.color === "secondary" && t.colorSecondary,
    ...e.filled && t.filled
  })
})(Fe(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  ...e.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Ic.focused}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${Ic.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      },
      [`&.${Ic.error}`]: {
        color: (e.vars || e).palette.error.main
      }
    }
  }]
}))), e3 = te("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(Fe(({
  theme: e
}) => ({
  [`&.${Ic.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}))), cM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: s,
    className: i,
    color: a,
    component: l = "label",
    disabled: c,
    error: u,
    filled: d,
    focused: f,
    required: p,
    ...m
  } = o, b = lo(), v = Es({
    props: o,
    muiFormControl: b,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), g = {
    ...o,
    color: v.color || "primary",
    component: l,
    disabled: v.disabled,
    error: v.error,
    filled: v.filled,
    focused: v.focused,
    required: v.required
  }, y = Zj(g);
  return /* @__PURE__ */ ie(Jj, {
    as: l,
    ownerState: g,
    className: ae(y.root, i),
    ref: n,
    ...m,
    children: [s, v.required && /* @__PURE__ */ ie(e3, {
      ownerState: g,
      "aria-hidden": !0,
      className: y.asterisk,
      children: [" ", "*"]
    })]
  });
});
process.env.NODE_ENV !== "production" && (cM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: r.oneOfType([r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: r.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: r.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: r.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: r.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const ay = /* @__PURE__ */ h.createContext();
process.env.NODE_ENV !== "production" && (ay.displayName = "GridContext");
function t3(e) {
  return De("MuiGrid", e);
}
const n3 = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], o3 = ["column-reverse", "column", "row-reverse", "row"], r3 = ["nowrap", "wrap-reverse", "wrap"], _l = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], Wc = Ne("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...n3.map((e) => `spacing-xs-${e}`),
  // direction values
  ...o3.map((e) => `direction-xs-${e}`),
  // wrap values
  ...r3.map((e) => `wrap-xs-${e}`),
  // grid sizes for all breakpoints
  ..._l.map((e) => `grid-xs-${e}`),
  ..._l.map((e) => `grid-sm-${e}`),
  ..._l.map((e) => `grid-md-${e}`),
  ..._l.map((e) => `grid-lg-${e}`),
  ..._l.map((e) => `grid-xl-${e}`)
]);
function s3({
  theme: e,
  ownerState: t
}) {
  let n;
  return e.breakpoints.keys.reduce((o, s) => {
    let i = {};
    if (t[s] && (n = t[s]), !n)
      return o;
    if (n === !0)
      i = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    else if (n === "auto")
      i = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    else {
      const a = Ii({
        values: t.columns,
        breakpoints: e.breakpoints.values
      }), l = typeof a == "object" ? a[s] : a;
      if (l == null)
        return o;
      const c = `${Math.round(n / l * 1e8) / 1e6}%`;
      let u = {};
      if (t.container && t.item && t.columnSpacing !== 0) {
        const d = e.spacing(t.columnSpacing);
        if (d !== "0px") {
          const f = `calc(${c} + ${d})`;
          u = {
            flexBasis: f,
            maxWidth: f
          };
        }
      }
      i = {
        flexBasis: c,
        flexGrow: 0,
        maxWidth: c,
        ...u
      };
    }
    return e.breakpoints.values[s] === 0 ? Object.assign(o, i) : o[e.breakpoints.up(s)] = i, o;
  }, {});
}
function i3({
  theme: e,
  ownerState: t
}) {
  const n = Ii({
    values: t.direction,
    breakpoints: e.breakpoints.values
  });
  return No({
    theme: e
  }, n, (o) => {
    const s = {
      flexDirection: o
    };
    return o.startsWith("column") && (s[`& > .${Wc.item}`] = {
      maxWidth: "none"
    }), s;
  });
}
function uM({
  breakpoints: e,
  values: t
}) {
  let n = "";
  Object.keys(t).forEach((s) => {
    n === "" && t[s] !== 0 && (n = s);
  });
  const o = Object.keys(e).sort((s, i) => e[s] - e[i]);
  return o.slice(0, o.indexOf(n));
}
function a3({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    rowSpacing: o
  } = t;
  let s = {};
  if (n && o !== 0) {
    const i = Ii({
      values: o,
      breakpoints: e.breakpoints.values
    });
    let a;
    typeof i == "object" && (a = uM({
      breakpoints: e.breakpoints.values,
      values: i
    })), s = No({
      theme: e
    }, i, (l, c) => {
      const u = e.spacing(l);
      return u !== "0px" ? {
        marginTop: `-${u}`,
        [`& > .${Wc.item}`]: {
          paddingTop: u
        }
      } : a != null && a.includes(c) ? {} : {
        marginTop: 0,
        [`& > .${Wc.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return s;
}
function l3({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    columnSpacing: o
  } = t;
  let s = {};
  if (n && o !== 0) {
    const i = Ii({
      values: o,
      breakpoints: e.breakpoints.values
    });
    let a;
    typeof i == "object" && (a = uM({
      breakpoints: e.breakpoints.values,
      values: i
    })), s = No({
      theme: e
    }, i, (l, c) => {
      const u = e.spacing(l);
      if (u !== "0px") {
        const d = `-${u}`;
        return {
          width: `calc(100% + ${u})`,
          marginLeft: d,
          [`& > .${Wc.item}`]: {
            paddingLeft: u
          }
        };
      }
      return a != null && a.includes(c) ? {} : {
        width: "100%",
        marginLeft: 0,
        [`& > .${Wc.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return s;
}
function c3(e, t, n = {}) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [n[`spacing-xs-${String(e)}`]];
  const o = [];
  return t.forEach((s) => {
    const i = e[s];
    Number(i) > 0 && o.push(n[`spacing-${s}-${String(i)}`]);
  }), o;
}
const u3 = te("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      container: o,
      direction: s,
      item: i,
      spacing: a,
      wrap: l,
      zeroMinWidth: c,
      breakpoints: u
    } = n;
    let d = [];
    o && (d = c3(a, u, t));
    const f = [];
    return u.forEach((p) => {
      const m = n[p];
      m && f.push(t[`grid-${p}-${String(m)}`]);
    }), [t.root, o && t.container, i && t.item, c && t.zeroMinWidth, ...d, s !== "row" && t[`direction-xs-${String(s)}`], l !== "wrap" && t[`wrap-xs-${String(l)}`], ...f];
  }
})(
  // FIXME(romgrk): Can't use memoTheme here
  ({
    ownerState: e
  }) => ({
    boxSizing: "border-box",
    ...e.container && {
      display: "flex",
      flexWrap: "wrap",
      width: "100%"
    },
    ...e.item && {
      margin: 0
      // For instance, it's useful when used with a `figure` element.
    },
    ...e.zeroMinWidth && {
      minWidth: 0
    },
    ...e.wrap !== "wrap" && {
      flexWrap: e.wrap
    }
  }),
  i3,
  a3,
  l3,
  s3
);
function d3(e, t) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [`spacing-xs-${String(e)}`];
  const n = [];
  return t.forEach((o) => {
    const s = e[o];
    if (Number(s) > 0) {
      const i = `spacing-${o}-${String(s)}`;
      n.push(i);
    }
  }), n;
}
const f3 = (e) => {
  const {
    classes: t,
    container: n,
    direction: o,
    item: s,
    spacing: i,
    wrap: a,
    zeroMinWidth: l,
    breakpoints: c
  } = e;
  let u = [];
  n && (u = d3(i, c));
  const d = [];
  c.forEach((p) => {
    const m = e[p];
    m && d.push(`grid-${p}-${String(m)}`);
  });
  const f = {
    root: ["root", n && "container", s && "item", l && "zeroMinWidth", ...u, o !== "row" && `direction-xs-${String(o)}`, a !== "wrap" && `wrap-xs-${String(a)}`, ...d]
  };
  return fe(f, t3, t);
}, gs = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiGrid"
  }), {
    breakpoints: s
  } = sn(), i = Sp(o), {
    className: a,
    columns: l,
    columnSpacing: c,
    component: u = "div",
    container: d = !1,
    direction: f = "row",
    item: p = !1,
    rowSpacing: m,
    spacing: b = 0,
    wrap: v = "wrap",
    zeroMinWidth: g = !1,
    ...y
  } = i, w = m || b, x = c || b, S = h.useContext(ay), T = d ? l || 12 : S, E = {}, O = {
    ...y
  };
  s.keys.forEach((R) => {
    y[R] != null && (E[R] = y[R], delete O[R]);
  });
  const M = {
    ...i,
    columns: T,
    container: d,
    direction: f,
    item: p,
    rowSpacing: w,
    columnSpacing: x,
    wrap: v,
    zeroMinWidth: g,
    spacing: b,
    ...E,
    breakpoints: s.keys
  }, D = f3(M);
  return /* @__PURE__ */ C(ay.Provider, {
    value: T,
    children: /* @__PURE__ */ C(u3, {
      ownerState: M,
      className: ae(D.root, a),
      as: u,
      ref: n,
      ...O
    })
  });
});
process.env.NODE_ENV !== "production" && (gs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The number of columns.
   * @default 12
   */
  columns: r.oneOfType([r.arrayOf(r.number), r.number, r.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: r.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: r.oneOfType([r.oneOf(["column-reverse", "column", "row-reverse", "row"]), r.arrayOf(r.oneOf(["column-reverse", "column", "row-reverse", "row"])), r.object]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: r.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: r.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: r.oneOfType([r.oneOf(["auto"]), r.number, r.bool]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: r.bool
});
if (process.env.NODE_ENV !== "production") {
  const e = aV("Grid", gs);
  gs.propTypes = {
    // eslint-disable-next-line react/forbid-foreign-prop-types
    ...gs.propTypes,
    direction: e("container"),
    lg: e("item"),
    md: e("item"),
    sm: e("item"),
    spacing: e("container"),
    wrap: e("container"),
    xs: e("item"),
    zeroMinWidth: e("item")
  };
}
function ly(e) {
  return `scale(${e}, ${e ** 2})`;
}
const p3 = {
  entering: {
    opacity: 1,
    transform: ly(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, jh = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), vs = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    addEndListener: o,
    appear: s = !0,
    children: i,
    easing: a,
    in: l,
    onEnter: c,
    onEntered: u,
    onEntering: d,
    onExit: f,
    onExited: p,
    onExiting: m,
    style: b,
    timeout: v = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: g = So,
    ...y
  } = t, w = go(), x = h.useRef(), S = sn(), T = h.useRef(null), E = tt(T, Rs(i), n), O = (A) => (k) => {
    if (A) {
      const L = T.current;
      k === void 0 ? A(L) : A(L, k);
    }
  }, M = O(d), D = O((A, k) => {
    Ep(A);
    const {
      duration: L,
      delay: B,
      easing: V
    } = Jr({
      style: b,
      timeout: v,
      easing: a
    }, {
      mode: "enter"
    });
    let _;
    v === "auto" ? (_ = S.transitions.getAutoHeightDuration(A.clientHeight), x.current = _) : _ = L, A.style.transition = [S.transitions.create("opacity", {
      duration: _,
      delay: B
    }), S.transitions.create("transform", {
      duration: jh ? _ : _ * 0.666,
      delay: B,
      easing: V
    })].join(","), c && c(A, k);
  }), R = O(u), P = O(m), F = O((A) => {
    const {
      duration: k,
      delay: L,
      easing: B
    } = Jr({
      style: b,
      timeout: v,
      easing: a
    }, {
      mode: "exit"
    });
    let V;
    v === "auto" ? (V = S.transitions.getAutoHeightDuration(A.clientHeight), x.current = V) : V = k, A.style.transition = [S.transitions.create("opacity", {
      duration: V,
      delay: L
    }), S.transitions.create("transform", {
      duration: jh ? V : V * 0.666,
      delay: jh ? L : L || V * 0.333,
      easing: B
    })].join(","), A.style.opacity = 0, A.style.transform = ly(0.75), f && f(A);
  }), $ = O(p);
  return /* @__PURE__ */ C(g, {
    appear: s,
    in: l,
    nodeRef: T,
    onEnter: D,
    onEntered: R,
    onEntering: M,
    onExit: F,
    onExited: $,
    onExiting: P,
    addEndListener: (A) => {
      v === "auto" && w.start(x.current || 0, A), o && o(T.current, A);
    },
    timeout: v === "auto" ? null : v,
    ...y,
    children: (A, k) => /* @__PURE__ */ h.cloneElement(i, {
      style: {
        opacity: 0,
        transform: ly(0.75),
        visibility: A === "exited" && !l ? "hidden" : void 0,
        ...p3[A],
        ...b,
        ...i.props.style
      },
      ref: E,
      ...k
    })
  });
});
process.env.NODE_ENV !== "production" && (vs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: r.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: r.bool,
  /**
   * A single child content element.
   */
  children: Ts.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: r.oneOfType([r.shape({
    enter: r.string,
    exit: r.string
  }), r.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: r.bool,
  /**
   * @ignore
   */
  onEnter: r.func,
  /**
   * @ignore
   */
  onEntered: r.func,
  /**
   * @ignore
   */
  onEntering: r.func,
  /**
   * @ignore
   */
  onExit: r.func,
  /**
   * @ignore
   */
  onExited: r.func,
  /**
   * @ignore
   */
  onExiting: r.func,
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: r.oneOfType([r.oneOf(["auto"]), r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })])
});
vs && (vs.muiSupportAuto = !0);
const Qi = cP({
  themeId: hr
});
function h3(e) {
  return De("MuiIcon", e);
}
Ne("MuiIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const g3 = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: o
  } = e, s = {
    root: ["root", t !== "inherit" && `color${ce(t)}`, `fontSize${ce(n)}`]
  };
  return fe(s, h3, o);
}, m3 = te("span", {
  name: "MuiIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${ce(n.color)}`], t[`fontSize${ce(n.fontSize)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  userSelect: "none",
  width: "1em",
  height: "1em",
  // Chrome fix for https://issues.chromium.org/issues/41375697
  // To remove at some point.
  overflow: "hidden",
  display: "inline-block",
  // allow overflow hidden to take action
  textAlign: "center",
  // support non-square icon
  flexShrink: 0,
  variants: [{
    props: {
      fontSize: "inherit"
    },
    style: {
      fontSize: "inherit"
    }
  }, {
    props: {
      fontSize: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(20)
    }
  }, {
    props: {
      fontSize: "medium"
    },
    style: {
      fontSize: e.typography.pxToRem(24)
    }
  }, {
    props: {
      fontSize: "large"
    },
    style: {
      fontSize: e.typography.pxToRem(36)
    }
  }, {
    props: {
      color: "action"
    },
    style: {
      color: (e.vars || e).palette.action.active
    }
  }, {
    props: {
      color: "disabled"
    },
    style: {
      color: (e.vars || e).palette.action.disabled
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: void 0
    }
  }, ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  }))]
}))), yo = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiIcon"
  }), {
    baseClassName: s = "material-icons",
    className: i,
    color: a = "inherit",
    component: l = "span",
    fontSize: c = "medium",
    ...u
  } = o, d = {
    ...o,
    baseClassName: s,
    color: a,
    component: l,
    fontSize: c
  }, f = g3(d);
  return /* @__PURE__ */ C(m3, {
    as: l,
    className: ae(
      s,
      // Prevent the translation of the text content.
      // The font relies on the exact text content to render the icon.
      "notranslate",
      f.root,
      i
    ),
    ownerState: d,
    "aria-hidden": !0,
    ref: n,
    ...u
  });
});
process.env.NODE_ENV !== "production" && (yo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The base class applied to the icon. Defaults to 'material-icons', but can be changed to any
   * other base class that suits the icon font you're using (for example material-icons-rounded, fas, etc).
   * @default 'material-icons'
   */
  baseClassName: r.string,
  /**
   * The name of the icon font ligature.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'inherit'
   */
  color: r.oneOfType([r.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: r.oneOfType([r.oneOf(["inherit", "large", "medium", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
yo && (yo.muiName = "Icon");
const b3 = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, s = fe({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, pz, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...s
  };
}, y3 = te(kp, {
  shouldForwardProp: (e) => Xn(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...Pp(e, t), !n.disableUnderline && t.underline];
  }
})(Fe(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: o
      }) => o.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: o
      }) => !o.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${zs.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${zs.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${zs.disabled}, .${zs.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${zs.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(e.palette).filter($t()).map(([o]) => ({
      props: {
        color: o,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(e.vars || e).palette[o].main}`
        }
      }
    }))]
  };
})), v3 = te(Dp, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: Mp
})({}), _i = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: s = !1,
    components: i = {},
    componentsProps: a,
    fullWidth: l = !1,
    inputComponent: c = "input",
    multiline: u = !1,
    slotProps: d,
    slots: f = {},
    type: p = "text",
    ...m
  } = o, b = b3(o), g = {
    root: {
      ownerState: {
        disableUnderline: s
      }
    }
  }, y = d ?? a ? Bn(d ?? a, g) : g, w = f.root ?? i.Root ?? y3, x = f.input ?? i.Input ?? v3;
  return /* @__PURE__ */ C(Xi, {
    slots: {
      root: w,
      input: x
    },
    slotProps: y,
    fullWidth: l,
    inputComponent: c,
    multiline: u,
    ref: n,
    type: p,
    ...m,
    classes: b
  });
});
process.env.NODE_ENV !== "production" && (_i.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: r.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary"]), r.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: r.shape({
    Input: r.elementType,
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: r.shape({
    input: r.object,
    root: r.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: r.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: r.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: r.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: r.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: r.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: r.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: r.oneOfType([r.number, r.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: r.oneOfType([r.number, r.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: r.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: r.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: r.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: r.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: r.oneOfType([r.number, r.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: r.shape({
    input: r.object,
    root: r.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: r.shape({
    input: r.elementType,
    root: r.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: r.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: r.any
});
_i && (_i.muiName = "Input");
function C3(e) {
  return De("MuiInputAdornment", e);
}
const Gx = Ne("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var qx;
const w3 = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${ce(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, S3 = (e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: o,
    position: s,
    size: i,
    variant: a
  } = e, l = {
    root: ["root", n && "disablePointerEvents", s && `position${ce(s)}`, a, o && "hiddenLabel", i && `size${ce(i)}`]
  };
  return fe(l, C3, t);
}, x3 = te("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: w3
})(Fe(({
  theme: e
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${Gx.positionStart}&:not(.${Gx.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: !0
    },
    style: {
      pointerEvents: "none"
    }
  }]
}))), yl = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: s,
    className: i,
    component: a = "div",
    disablePointerEvents: l = !1,
    disableTypography: c = !1,
    position: u,
    variant: d,
    ...f
  } = o, p = lo() || {};
  let m = d;
  d && p.variant && process.env.NODE_ENV !== "production" && d === p.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), p && !m && (m = p.variant);
  const b = {
    ...o,
    hiddenLabel: p.hiddenLabel,
    size: p.size,
    disablePointerEvents: l,
    position: u,
    variant: m
  }, v = S3(b);
  return /* @__PURE__ */ C(xu.Provider, {
    value: null,
    children: /* @__PURE__ */ C(x3, {
      as: a,
      ownerState: b,
      className: ae(v.root, i),
      ref: n,
      ...f,
      children: typeof s == "string" && !c ? /* @__PURE__ */ C(yn, {
        color: "textSecondary",
        children: s
      }) : /* @__PURE__ */ ie(h.Fragment, {
        children: [u === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          qx || (qx = /* @__PURE__ */ C("span", {
            className: "notranslate",
            "aria-hidden": !0,
            children: "​"
          }))
        ) : null, s]
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (yl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: r.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: r.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: r.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
function T3(e) {
  return De("MuiInputLabel", e);
}
Ne("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const R3 = (e) => {
  const {
    classes: t,
    formControl: n,
    size: o,
    shrink: s,
    disableAnimation: i,
    variant: a,
    required: l
  } = e, c = {
    root: ["root", n && "formControl", !i && "animated", s && "shrink", o && o !== "normal" && `size${ce(o)}`, a],
    asterisk: [l && "asterisk"]
  }, u = fe(c, T3, t);
  return {
    ...t,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...u
  };
}, E3 = te(cM, {
  shouldForwardProp: (e) => Xn(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Ic.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }
})(Fe(({
  theme: e
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState: t
    }) => t.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableAnimation,
    style: {
      transition: e.transitions.create(["color", "transform", "max-width"], {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "filled" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n,
      size: o
    }) => t === "filled" && n.shrink && o === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant: t,
      ownerState: n
    }) => t === "outlined" && n.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), Ru = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: s = !1,
    margin: i,
    shrink: a,
    variant: l,
    className: c,
    ...u
  } = o, d = lo();
  let f = a;
  typeof f > "u" && d && (f = d.filled || d.focused || d.adornedStart);
  const p = Es({
    props: o,
    muiFormControl: d,
    states: ["size", "variant", "required", "focused"]
  }), m = {
    ...o,
    disableAnimation: s,
    formControl: d,
    shrink: f,
    size: p.size,
    variant: p.variant,
    required: p.required,
    focused: p.focused
  }, b = R3(m);
  return /* @__PURE__ */ C(E3, {
    "data-shrink": f,
    ref: n,
    className: ae(b.root, c),
    ...u,
    ownerState: m,
    classes: b
  });
});
process.env.NODE_ENV !== "production" && (Ru.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: r.oneOfType([r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), r.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: r.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: r.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: r.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: r.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: r.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: r.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: r.oneOfType([r.oneOf(["normal", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
function I3(e) {
  return De("MuiLinearProgress", e);
}
Ne("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
const cy = 4, uy = ss`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`, O3 = typeof uy != "string" ? Qs`
        animation: ${uy} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null, dy = ss`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`, P3 = typeof dy != "string" ? Qs`
        animation: ${dy} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null, fy = ss`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`, M3 = typeof fy != "string" ? Qs`
        animation: ${fy} 3s infinite linear;
      ` : null, k3 = (e) => {
  const {
    classes: t,
    variant: n,
    color: o
  } = e, s = {
    root: ["root", `color${ce(o)}`, n],
    dashed: ["dashed", `dashedColor${ce(o)}`],
    bar1: ["bar", `barColor${ce(o)}`, (n === "indeterminate" || n === "query") && "bar1Indeterminate", n === "determinate" && "bar1Determinate", n === "buffer" && "bar1Buffer"],
    bar2: ["bar", n !== "buffer" && `barColor${ce(o)}`, n === "buffer" && `color${ce(o)}`, (n === "indeterminate" || n === "query") && "bar2Indeterminate", n === "buffer" && "bar2Buffer"]
  };
  return fe(s, I3, t);
}, nC = (e, t) => e.vars ? e.vars.palette.LinearProgress[`${t}Bg`] : e.palette.mode === "light" ? wo(e.palette[t].main, 0.62) : $o(e.palette[t].main, 0.5), D3 = te("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${ce(n.color)}`], t[n.variant]];
  }
})(Fe(({
  theme: e
}) => ({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  // Fix Safari's bug during composition of different paint.
  zIndex: 0,
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: nC(e, t)
    }
  })), {
    props: ({
      ownerState: t
    }) => t.color === "inherit" && t.variant !== "buffer",
    style: {
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "currentColor",
        opacity: 0.3
      }
    }
  }, {
    props: {
      variant: "buffer"
    },
    style: {
      backgroundColor: "transparent"
    }
  }, {
    props: {
      variant: "query"
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}))), N3 = te("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.dashed, t[`dashedColor${ce(n.color)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  position: "absolute",
  marginTop: 0,
  height: "100%",
  width: "100%",
  backgroundSize: "10px 10px",
  backgroundPosition: "0 -23px",
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      opacity: 0.3,
      backgroundImage: "radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)"
    }
  }, ...Object.entries(e.palette).filter($t()).map(([t]) => {
    const n = nC(e, t);
    return {
      props: {
        color: t
      },
      style: {
        backgroundImage: `radial-gradient(${n} 0%, ${n} 16%, transparent 42%)`
      }
    };
  })]
})), M3 || {
  // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
  animation: `${fy} 3s infinite linear`
}), $3 = te("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.bar, t[`barColor${ce(n.color)}`], (n.variant === "indeterminate" || n.variant === "query") && t.bar1Indeterminate, n.variant === "determinate" && t.bar1Determinate, n.variant === "buffer" && t.bar1Buffer];
  }
})(Fe(({
  theme: e
}) => ({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      backgroundColor: "currentColor"
    }
  }, ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      backgroundColor: (e.vars || e).palette[t].main
    }
  })), {
    props: {
      variant: "determinate"
    },
    style: {
      transition: `transform .${cy}s linear`
    }
  }, {
    props: {
      variant: "buffer"
    },
    style: {
      zIndex: 1,
      transition: `transform .${cy}s linear`
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: O3 || {
      animation: `${uy} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
    }
  }]
}))), A3 = te("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.bar, t[`barColor${ce(n.color)}`], (n.variant === "indeterminate" || n.variant === "query") && t.bar2Indeterminate, n.variant === "buffer" && t.bar2Buffer];
  }
})(Fe(({
  theme: e
}) => ({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  variants: [...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--LinearProgressBar2-barColor": (e.vars || e).palette[t].main
    }
  })), {
    props: ({
      ownerState: t
    }) => t.variant !== "buffer" && t.color !== "inherit",
    style: {
      backgroundColor: "var(--LinearProgressBar2-barColor, currentColor)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant !== "buffer" && t.color === "inherit",
    style: {
      backgroundColor: "currentColor"
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      opacity: 0.3
    }
  }, ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t,
      variant: "buffer"
    },
    style: {
      backgroundColor: nC(e, t),
      transition: `transform .${cy}s linear`
    }
  })), {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.variant === "indeterminate" || t.variant === "query",
    style: P3 || {
      animation: `${dy} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
    }
  }]
}))), oC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiLinearProgress"
  }), {
    className: s,
    color: i = "primary",
    value: a,
    valueBuffer: l,
    variant: c = "indeterminate",
    ...u
  } = o, d = {
    ...o,
    color: i,
    variant: c
  }, f = k3(d), p = _t(), m = {}, b = {
    bar1: {},
    bar2: {}
  };
  if (c === "determinate" || c === "buffer")
    if (a !== void 0) {
      m["aria-valuenow"] = Math.round(a), m["aria-valuemin"] = 0, m["aria-valuemax"] = 100;
      let v = a - 100;
      p && (v = -v), b.bar1.transform = `translateX(${v}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (c === "buffer")
    if (l !== void 0) {
      let v = (l || 0) - 100;
      p && (v = -v), b.bar2.transform = `translateX(${v}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ ie(D3, {
    className: ae(f.root, s),
    ownerState: d,
    role: "progressbar",
    ...m,
    ref: n,
    ...u,
    children: [c === "buffer" ? /* @__PURE__ */ C(N3, {
      className: f.dashed,
      ownerState: d
    }) : null, /* @__PURE__ */ C($3, {
      className: f.bar1,
      ownerState: d,
      style: b.bar1
    }), c === "determinate" ? null : /* @__PURE__ */ C(A3, {
      className: f.bar2,
      ownerState: d,
      style: b.bar2
    })]
  });
});
process.env.NODE_ENV !== "production" && (oC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["inherit", "primary", "secondary"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: r.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: r.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: r.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
const qo = /* @__PURE__ */ h.createContext({});
process.env.NODE_ENV !== "production" && (qo.displayName = "ListContext");
function F3(e) {
  return De("MuiList", e);
}
Ne("MuiList", ["root", "padding", "dense", "subheader"]);
const L3 = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: o,
    subheader: s
  } = e;
  return fe({
    root: ["root", !n && "padding", o && "dense", s && "subheader"]
  }, F3, t);
}, _3 = te("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: e
    }) => !e.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: e
    }) => e.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), rC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiList"
  }), {
    children: s,
    className: i,
    component: a = "ul",
    dense: l = !1,
    disablePadding: c = !1,
    subheader: u,
    ...d
  } = o, f = h.useMemo(() => ({
    dense: l
  }), [l]), p = {
    ...o,
    component: a,
    dense: l,
    disablePadding: c
  }, m = L3(p);
  return /* @__PURE__ */ C(qo.Provider, {
    value: f,
    children: /* @__PURE__ */ ie(_3, {
      as: a,
      className: ae(m.root, i),
      ref: n,
      ownerState: p,
      ...d,
      children: [u, s]
    })
  });
});
process.env.NODE_ENV !== "production" && (rC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: r.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: r.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function V3(e) {
  return De("MuiListItem", e);
}
Ne("MuiListItem", ["root", "container", "dense", "alignItemsFlexStart", "divider", "gutters", "padding", "secondaryAction"]);
function B3(e) {
  return De("MuiListItemButton", e);
}
const Ta = Ne("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]), z3 = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters];
}, H3 = (e) => {
  const {
    alignItems: t,
    classes: n,
    dense: o,
    disabled: s,
    disableGutters: i,
    divider: a,
    selected: l
  } = e, u = fe({
    root: ["root", o && "dense", !i && "gutters", a && "divider", s && "disabled", t === "flex-start" && "alignItemsFlexStart", l && "selected"]
  }, B3, n);
  return {
    ...n,
    ...u
  };
}, j3 = te(Yn, {
  shouldForwardProp: (e) => Xn(e) || e === "classes",
  name: "MuiListItemButton",
  slot: "Root",
  overridesResolver: z3
})(Fe(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minWidth: 0,
  boxSizing: "border-box",
  textAlign: "left",
  paddingTop: 8,
  paddingBottom: 8,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Ta.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : he(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Ta.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : he(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Ta.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : he(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : he(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Ta.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Ta.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }]
}))), sC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiListItemButton"
  }), {
    alignItems: s = "center",
    autoFocus: i = !1,
    component: a = "div",
    children: l,
    dense: c = !1,
    disableGutters: u = !1,
    divider: d = !1,
    focusVisibleClassName: f,
    selected: p = !1,
    className: m,
    ...b
  } = o, v = h.useContext(qo), g = h.useMemo(() => ({
    dense: c || v.dense || !1,
    alignItems: s,
    disableGutters: u
  }), [s, v.dense, c, u]), y = h.useRef(null);
  yt(() => {
    i && (y.current ? y.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItemButton whose component has not been rendered."));
  }, [i]);
  const w = {
    ...o,
    alignItems: s,
    dense: g.dense,
    disableGutters: u,
    divider: d,
    selected: p
  }, x = H3(w), S = tt(y, n);
  return /* @__PURE__ */ C(qo.Provider, {
    value: g,
    children: /* @__PURE__ */ C(j3, {
      ref: S,
      href: b.href || b.to,
      component: (b.href || b.to) && a === "div" ? "button" : a,
      focusVisibleClassName: ae(x.focusVisible, f),
      ownerState: w,
      className: ae(x.root, m),
      ...b,
      classes: x,
      children: l
    })
  });
});
process.env.NODE_ENV !== "production" && (sC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: r.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: r.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: r.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: r.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: r.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: r.string,
  /**
   * @ignore
   */
  href: r.string,
  /**
   * Use to apply selected styling.
   * @default false
   */
  selected: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function G3(e) {
  return De("MuiListItemSecondaryAction", e);
}
Ne("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const q3 = (e) => {
  const {
    disableGutters: t,
    classes: n
  } = e;
  return fe({
    root: ["root", t && "disableGutters"]
  }, G3, n);
}, W3 = te("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.disableGutters && t.disableGutters];
  }
})({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  variants: [{
    props: ({
      ownerState: e
    }) => e.disableGutters,
    style: {
      right: 0
    }
  }]
}), iC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: s,
    ...i
  } = o, a = h.useContext(qo), l = {
    ...o,
    disableGutters: a.disableGutters
  }, c = q3(l);
  return /* @__PURE__ */ C(W3, {
    className: ae(c.root, s),
    ownerState: l,
    ref: n,
    ...i
  });
});
process.env.NODE_ENV !== "production" && (iC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
iC.muiName = "ListItemSecondaryAction";
const U3 = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters, !n.disablePadding && t.padding, n.hasSecondaryAction && t.secondaryAction];
}, K3 = (e) => {
  const {
    alignItems: t,
    classes: n,
    dense: o,
    disableGutters: s,
    disablePadding: i,
    divider: a,
    hasSecondaryAction: l
  } = e;
  return fe({
    root: ["root", o && "dense", !s && "gutters", !i && "padding", a && "divider", t === "flex-start" && "alignItemsFlexStart", l && "secondaryAction"],
    container: ["container"]
  }, V3, n);
}, Y3 = te("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: U3
})(Fe(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && t.dense,
    style: {
      paddingTop: 4,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.disablePadding && !!t.secondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.secondaryAction,
    style: {
      [`& > .${Ta.root}`]: {
        paddingRight: 48
      }
    }
  }, {
    props: {
      alignItems: "flex-start"
    },
    style: {
      alignItems: "flex-start"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.button,
    style: {
      transition: e.transitions.create("background-color", {
        duration: e.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.hasSecondaryAction,
    style: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    }
  }]
}))), X3 = te("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), aC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: s = "center",
    children: i,
    className: a,
    component: l,
    components: c = {},
    componentsProps: u = {},
    ContainerComponent: d = "li",
    ContainerProps: {
      className: f,
      ...p
    } = {},
    dense: m = !1,
    disableGutters: b = !1,
    disablePadding: v = !1,
    divider: g = !1,
    secondaryAction: y,
    slotProps: w = {},
    slots: x = {},
    ...S
  } = o, T = h.useContext(qo), E = h.useMemo(() => ({
    dense: m || T.dense || !1,
    alignItems: s,
    disableGutters: b
  }), [s, T.dense, m, b]), O = h.useRef(null), M = h.Children.toArray(i), D = M.length && Sc(M[M.length - 1], ["ListItemSecondaryAction"]), R = {
    ...o,
    alignItems: s,
    dense: E.dense,
    disableGutters: b,
    disablePadding: v,
    divider: g,
    hasSecondaryAction: D
  }, P = K3(R), F = tt(O, n), $ = x.root || c.Root || Y3, N = w.root || u.root || {}, A = {
    className: ae(P.root, N.className, a),
    ...S
  };
  let k = l || "li";
  return D ? (k = !A.component && !l ? "div" : k, d === "li" && (k === "li" ? k = "div" : A.component === "li" && (A.component = "div")), /* @__PURE__ */ C(qo.Provider, {
    value: E,
    children: /* @__PURE__ */ ie(X3, {
      as: d,
      className: ae(P.container, f),
      ref: F,
      ownerState: R,
      ...p,
      children: [/* @__PURE__ */ C($, {
        ...N,
        ...!Yr($) && {
          as: k,
          ownerState: {
            ...R,
            ...N.ownerState
          }
        },
        ...A,
        children: M
      }), M.pop()]
    })
  })) : /* @__PURE__ */ C(qo.Provider, {
    value: E,
    children: /* @__PURE__ */ ie($, {
      ...N,
      as: k,
      ref: F,
      ...!Yr($) && {
        ownerState: {
          ...R,
          ...N.ownerState
        }
      },
      ...A,
      children: [M, y && /* @__PURE__ */ C(iC, {
        children: y
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (aC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: r.oneOf(["center", "flex-start"]),
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: Gn(r.node, (e) => {
    const t = h.Children.toArray(e.children);
    let n = -1;
    for (let o = t.length - 1; o >= 0; o -= 1) {
      const s = t[o];
      if (Sc(s, ["ListItemSecondaryAction"])) {
        n = o;
        break;
      }
    }
    return n !== -1 && n !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  components: r.shape({
    Root: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  componentsProps: r.shape({
    root: r.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated Use the `component` or `slots.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerComponent: mu,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated Use the `slotProps.root` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ContainerProps: r.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: r.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: r.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: r.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: r.bool,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: r.node,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: r.shape({
    root: r.object
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: r.shape({
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Q3(e) {
  return De("MuiListItemAvatar", e);
}
Ne("MuiListItemAvatar", ["root", "alignItemsFlexStart"]);
const Z3 = (e) => {
  const {
    alignItems: t,
    classes: n
  } = e;
  return fe({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, Q3, n);
}, J3 = te("div", {
  name: "MuiListItemAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})({
  minWidth: 56,
  flexShrink: 0,
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
}), e6 = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiListItemAvatar"
  }), {
    className: s,
    ...i
  } = o, a = h.useContext(qo), l = {
    ...o,
    alignItems: a.alignItems
  }, c = Z3(l);
  return /* @__PURE__ */ C(J3, {
    className: ae(c.root, s),
    ownerState: l,
    ref: n,
    ...i
  });
});
process.env.NODE_ENV !== "production" && (e6.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `Avatar`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function t6(e) {
  return De("MuiListItemIcon", e);
}
const Wx = Ne("MuiListItemIcon", ["root", "alignItemsFlexStart"]), n6 = (e) => {
  const {
    alignItems: t,
    classes: n
  } = e;
  return fe({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, t6, n);
}, o6 = te("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(Fe(({
  theme: e
}) => ({
  minWidth: 56,
  color: (e.vars || e).palette.action.active,
  flexShrink: 0,
  display: "inline-flex",
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
}))), ur = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiListItemIcon"
  }), {
    className: s,
    ...i
  } = o, a = h.useContext(qo), l = {
    ...o,
    alignItems: a.alignItems
  }, c = n6(l);
  return /* @__PURE__ */ C(o6, {
    className: ae(c.root, s),
    ownerState: l,
    ref: n,
    ...i
  });
});
process.env.NODE_ENV !== "production" && (ur.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function r6(e) {
  return De("MuiListItemText", e);
}
const Pa = Ne("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), s6 = (e) => {
  const {
    classes: t,
    inset: n,
    primary: o,
    secondary: s,
    dense: i
  } = e;
  return fe({
    root: ["root", n && "inset", i && "dense", o && s && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, r6, t);
}, i6 = te("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Pa.primary}`]: t.primary
    }, {
      [`& .${Pa.secondary}`]: t.secondary
    }, t.root, n.inset && t.inset, n.primary && n.secondary && t.multiline, n.dense && t.dense];
  }
})({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4,
  [`.${gx.root}:where(& .${Pa.primary})`]: {
    display: "block"
  },
  [`.${gx.root}:where(& .${Pa.secondary})`]: {
    display: "block"
  },
  variants: [{
    props: ({
      ownerState: e
    }) => e.primary && e.secondary,
    style: {
      marginTop: 6,
      marginBottom: 6
    }
  }, {
    props: ({
      ownerState: e
    }) => e.inset,
    style: {
      paddingLeft: 56
    }
  }]
}), Ho = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiListItemText"
  }), {
    children: s,
    className: i,
    disableTypography: a = !1,
    inset: l = !1,
    primary: c,
    primaryTypographyProps: u,
    secondary: d,
    secondaryTypographyProps: f,
    ...p
  } = o, {
    dense: m
  } = h.useContext(qo);
  let b = c ?? s, v = d;
  const g = {
    ...o,
    disableTypography: a,
    inset: l,
    primary: !!b,
    secondary: !!v,
    dense: m
  }, y = s6(g);
  return b != null && b.type !== yn && !a && (b = /* @__PURE__ */ C(yn, {
    variant: m ? "body2" : "body1",
    className: y.primary,
    component: u != null && u.variant ? void 0 : "span",
    ...u,
    children: b
  })), v != null && v.type !== yn && !a && (v = /* @__PURE__ */ C(yn, {
    variant: "body2",
    className: y.secondary,
    color: "textSecondary",
    ...f,
    children: v
  })), /* @__PURE__ */ ie(i6, {
    className: ae(y.root, i),
    ownerState: g,
    ref: n,
    ...p,
    children: [b, v]
  });
});
process.env.NODE_ENV !== "production" && (Ho.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: r.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: r.bool,
  /**
   * The main content element.
   */
  primary: r.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: r.object,
  /**
   * The secondary content element.
   */
  secondary: r.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function Gh(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function Ux(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function dM(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.startsWith(t.keys.join(""));
}
function Vl(e, t, n, o, s, i) {
  let a = !1, l = s(e, t, t ? n : !1);
  for (; l; ) {
    if (l === e.firstChild) {
      if (a)
        return !1;
      a = !0;
    }
    const c = o ? !1 : l.disabled || l.getAttribute("aria-disabled") === "true";
    if (!l.hasAttribute("tabindex") || !dM(l, i) || c)
      l = s(e, l, n);
    else
      return l.focus(), !0;
  }
  return !1;
}
const Zi = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: o,
    autoFocus: s = !1,
    autoFocusItem: i = !1,
    children: a,
    className: l,
    disabledItemsFocusable: c = !1,
    disableListWrap: u = !1,
    onKeyDown: d,
    variant: f = "selectedMenu",
    ...p
  } = t, m = h.useRef(null), b = h.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  yt(() => {
    s && m.current.focus();
  }, [s]), h.useImperativeHandle(o, () => ({
    adjustStyleForScrollbar: (x, {
      direction: S
    }) => {
      const T = !m.current.style.width;
      if (x.clientHeight < m.current.clientHeight && T) {
        const E = `${pP(Ao(x))}px`;
        m.current.style[S === "rtl" ? "paddingLeft" : "paddingRight"] = E, m.current.style.width = `calc(100% + ${E})`;
      }
      return m.current;
    }
  }), []);
  const v = (x) => {
    const S = m.current, T = x.key;
    if (x.ctrlKey || x.metaKey || x.altKey) {
      d && d(x);
      return;
    }
    const O = qt(S).activeElement;
    if (T === "ArrowDown")
      x.preventDefault(), Vl(S, O, u, c, Gh);
    else if (T === "ArrowUp")
      x.preventDefault(), Vl(S, O, u, c, Ux);
    else if (T === "Home")
      x.preventDefault(), Vl(S, null, u, c, Gh);
    else if (T === "End")
      x.preventDefault(), Vl(S, null, u, c, Ux);
    else if (T.length === 1) {
      const M = b.current, D = T.toLowerCase(), R = performance.now();
      M.keys.length > 0 && (R - M.lastTime > 500 ? (M.keys = [], M.repeating = !0, M.previousKeyMatched = !0) : M.repeating && D !== M.keys[0] && (M.repeating = !1)), M.lastTime = R, M.keys.push(D);
      const P = O && !M.repeating && dM(O, M);
      M.previousKeyMatched && (P || Vl(S, O, !1, c, Gh, M)) ? x.preventDefault() : M.previousKeyMatched = !1;
    }
    d && d(x);
  }, g = tt(m, n);
  let y = -1;
  h.Children.forEach(a, (x, S) => {
    if (!/* @__PURE__ */ h.isValidElement(x)) {
      y === S && (y += 1, y >= a.length && (y = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && Js.isFragment(x) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), x.props.disabled || (f === "selectedMenu" && x.props.selected || y === -1) && (y = S), y === S && (x.props.disabled || x.props.muiSkipListHighlight || x.type.muiSkipListHighlight) && (y += 1, y >= a.length && (y = -1));
  });
  const w = h.Children.map(a, (x, S) => {
    if (S === y) {
      const T = {};
      return i && (T.autoFocus = !0), x.props.tabIndex === void 0 && f === "selectedMenu" && (T.tabIndex = 0), /* @__PURE__ */ h.cloneElement(x, T);
    }
    return x;
  });
  return /* @__PURE__ */ C(rC, {
    role: "menu",
    ref: g,
    className: l,
    onKeyDown: v,
    tabIndex: s ? 0 : -1,
    ...p,
    children: w
  });
});
process.env.NODE_ENV !== "production" && (Zi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: r.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: r.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: r.node,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: r.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: r.bool,
  /**
   * @ignore
   */
  onKeyDown: r.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: r.oneOf(["menu", "selectedMenu"])
});
function a6(e) {
  return De("MuiPopover", e);
}
Ne("MuiPopover", ["root", "paper"]);
function Kx(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function Yx(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function Xx(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function Jd(e) {
  return typeof e == "function" ? e() : e;
}
const l6 = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    paper: ["paper"]
  }, a6, t);
}, c6 = te(Tu, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), fM = te(ao, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), lC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiPopover"
  }), {
    action: s,
    anchorEl: i,
    anchorOrigin: a = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: l,
    anchorReference: c = "anchorEl",
    children: u,
    className: d,
    container: f,
    elevation: p = 8,
    marginThreshold: m = 16,
    open: b,
    PaperProps: v = {},
    slots: g = {},
    slotProps: y = {},
    transformOrigin: w = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: x = vs,
    transitionDuration: S = "auto",
    TransitionProps: {
      onEntering: T,
      ...E
    } = {},
    disableScrollLock: O = !1,
    ...M
  } = o, D = (y == null ? void 0 : y.paper) ?? v, R = h.useRef(), P = {
    ...o,
    anchorOrigin: a,
    anchorReference: c,
    elevation: p,
    marginThreshold: m,
    externalPaperSlotProps: D,
    transformOrigin: w,
    TransitionComponent: x,
    transitionDuration: S,
    TransitionProps: E
  }, F = l6(P), $ = h.useCallback(() => {
    if (c === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (l || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), l;
    const ee = Jd(i), ne = ee && ee.nodeType === 1 ? ee : qt(R.current).body, H = ne.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const U = ne.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && U.top === 0 && U.left === 0 && U.right === 0 && U.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: H.top + Kx(H, a.vertical),
      left: H.left + Yx(H, a.horizontal)
    };
  }, [i, a.horizontal, a.vertical, l, c]), N = h.useCallback((ee) => ({
    vertical: Kx(ee, w.vertical),
    horizontal: Yx(ee, w.horizontal)
  }), [w.horizontal, w.vertical]), A = h.useCallback((ee) => {
    const ne = {
      width: ee.offsetWidth,
      height: ee.offsetHeight
    }, H = N(ne);
    if (c === "none")
      return {
        top: null,
        left: null,
        transformOrigin: Xx(H)
      };
    const U = $();
    let X = U.top - H.vertical, re = U.left - H.horizontal;
    const oe = X + ne.height, le = re + ne.width, se = Ao(Jd(i)), Ce = se.innerHeight - m, $e = se.innerWidth - m;
    if (m !== null && X < m) {
      const we = X - m;
      X -= we, H.vertical += we;
    } else if (m !== null && oe > Ce) {
      const we = oe - Ce;
      X -= we, H.vertical += we;
    }
    if (process.env.NODE_ENV !== "production" && ne.height > Ce && ne.height && Ce && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${ne.height - Ce}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), m !== null && re < m) {
      const we = re - m;
      re -= we, H.horizontal += we;
    } else if (le > $e) {
      const we = le - $e;
      re -= we, H.horizontal += we;
    }
    return {
      top: `${Math.round(X)}px`,
      left: `${Math.round(re)}px`,
      transformOrigin: Xx(H)
    };
  }, [i, c, $, N, m]), [k, L] = h.useState(b), B = h.useCallback(() => {
    const ee = R.current;
    if (!ee)
      return;
    const ne = A(ee);
    ne.top !== null && ee.style.setProperty("top", ne.top), ne.left !== null && (ee.style.left = ne.left), ee.style.transformOrigin = ne.transformOrigin, L(!0);
  }, [A]);
  h.useEffect(() => (O && window.addEventListener("scroll", B), () => window.removeEventListener("scroll", B)), [i, O, B]);
  const V = (ee, ne) => {
    T && T(ee, ne), B();
  }, _ = () => {
    L(!1);
  };
  h.useEffect(() => {
    b && B();
  }), h.useImperativeHandle(s, () => b ? {
    updatePosition: () => {
      B();
    }
  } : null, [b, B]), h.useEffect(() => {
    if (!b)
      return;
    const ee = Yi(() => {
      B();
    }), ne = Ao(i);
    return ne.addEventListener("resize", ee), () => {
      ee.clear(), ne.removeEventListener("resize", ee);
    };
  }, [i, b, B]);
  let z = S;
  S === "auto" && !x.muiSupportAuto && (z = void 0);
  const j = f || (i ? qt(Jd(i)).body : void 0), W = {
    slots: g,
    slotProps: {
      ...y,
      paper: D
    }
  }, [J, G] = bn("paper", {
    elementType: fM,
    externalForwardedProps: W,
    additionalProps: {
      elevation: p,
      className: ae(F.paper, D == null ? void 0 : D.className),
      style: k ? D.style : {
        ...D.style,
        opacity: 0
      }
    },
    ownerState: P
  }), [q, {
    slotProps: Z,
    ...Y
  }] = bn("root", {
    elementType: c6,
    externalForwardedProps: W,
    additionalProps: {
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: j,
      open: b
    },
    ownerState: P,
    className: ae(F.root, d)
  }), Q = tt(R, G.ref);
  return /* @__PURE__ */ C(q, {
    ...Y,
    ...!Yr(q) && {
      slotProps: Z,
      disableScrollLock: O
    },
    ...M,
    ref: n,
    children: /* @__PURE__ */ C(x, {
      appear: !0,
      in: b,
      onEntering: V,
      onExited: _,
      timeout: z,
      ...E,
      children: /* @__PURE__ */ C(J, {
        ...G,
        ref: Q,
        children: u
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (lC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: Lt,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: Gn(r.oneOfType([Ko, r.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = Jd(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: r.shape({
    horizontal: r.oneOfType([r.oneOf(["center", "left", "right"]), r.number]).isRequired,
    vertical: r.oneOfType([r.oneOf(["bottom", "center", "top"]), r.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: r.shape({
    left: r.number.isRequired,
    top: r.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: r.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slotProps.root.slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slotProps.root.slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: r.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.root.slotProps.backdrop` instead.
   */
  BackdropProps: r.object,
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: r.oneOfType([Ko, r.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: r.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Wr,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: r.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: r.shape({
    component: mu
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    paper: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    paper: r.elementType,
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: r.shape({
    horizontal: r.oneOfType([r.oneOf(["center", "left", "right"]), r.number]).isRequired,
    vertical: r.oneOfType([r.oneOf(["bottom", "center", "top"]), r.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: r.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: r.oneOfType([r.oneOf(["auto"]), r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: r.object
});
function u6(e) {
  return De("MuiMenu", e);
}
Ne("MuiMenu", ["root", "paper", "list"]);
const d6 = {
  vertical: "top",
  horizontal: "right"
}, f6 = {
  vertical: "top",
  horizontal: "left"
}, p6 = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, u6, t);
}, h6 = te(lC, {
  shouldForwardProp: (e) => Xn(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), g6 = te(fM, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), m6 = te(Zi, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Eu = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: s = !0,
    children: i,
    className: a,
    disableAutoFocusItem: l = !1,
    MenuListProps: c = {},
    onClose: u,
    open: d,
    PaperProps: f = {},
    PopoverClasses: p,
    transitionDuration: m = "auto",
    TransitionProps: {
      onEntering: b,
      ...v
    } = {},
    variant: g = "selectedMenu",
    slots: y = {},
    slotProps: w = {},
    ...x
  } = o, S = _t(), T = {
    ...o,
    autoFocus: s,
    disableAutoFocusItem: l,
    MenuListProps: c,
    onEntering: b,
    PaperProps: f,
    transitionDuration: m,
    TransitionProps: v,
    variant: g
  }, E = p6(T), O = s && !l && d, M = h.useRef(null), D = (k, L) => {
    M.current && M.current.adjustStyleForScrollbar(k, {
      direction: S ? "rtl" : "ltr"
    }), b && b(k, L);
  }, R = (k) => {
    k.key === "Tab" && (k.preventDefault(), u && u(k, "tabKeyDown"));
  };
  let P = -1;
  h.Children.map(i, (k, L) => {
    /* @__PURE__ */ h.isValidElement(k) && (process.env.NODE_ENV !== "production" && Js.isFragment(k) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), k.props.disabled || (g === "selectedMenu" && k.props.selected || P === -1) && (P = L));
  });
  const F = y.paper ?? g6, $ = w.paper ?? f, N = et({
    elementType: y.root,
    externalSlotProps: w.root,
    ownerState: T,
    className: [E.root, a]
  }), A = et({
    elementType: F,
    externalSlotProps: $,
    ownerState: T,
    className: E.paper
  });
  return /* @__PURE__ */ C(h6, {
    onClose: u,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: S ? "right" : "left"
    },
    transformOrigin: S ? d6 : f6,
    slots: {
      paper: F,
      root: y.root
    },
    slotProps: {
      root: N,
      paper: A
    },
    open: d,
    ref: n,
    transitionDuration: m,
    TransitionProps: {
      onEntering: D,
      ...v
    },
    ownerState: T,
    ...x,
    classes: p,
    children: /* @__PURE__ */ C(m6, {
      onKeyDown: R,
      actions: M,
      autoFocus: s && (P === -1 || l),
      autoFocusItem: O,
      variant: g,
      ...c,
      className: ae(E.list, c.className),
      children: i
    })
  });
});
process.env.NODE_ENV !== "production" && (Eu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: r.oneOfType([Ko, r.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: r.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: r.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: r.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: r.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: r.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    paper: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    paper: r.elementType,
    root: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: r.oneOfType([r.oneOf(["auto"]), r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: r.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: r.oneOf(["menu", "selectedMenu"])
});
function b6(e) {
  return De("MuiMenuItem", e);
}
const Bl = Ne("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), y6 = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, v6 = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: o,
    disableGutters: s,
    selected: i,
    classes: a
  } = e, c = fe({
    root: ["root", n && "dense", t && "disabled", !s && "gutters", o && "divider", i && "selected"]
  }, b6, a);
  return {
    ...a,
    ...c
  };
}, C6 = te(Yn, {
  shouldForwardProp: (e) => Xn(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: y6
})(Fe(({
  theme: e
}) => ({
  ...e.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${Bl.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : he(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${Bl.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : he(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${Bl.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : he(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : he(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${Bl.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${Bl.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${Bx.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${Bx.inset}`]: {
    marginLeft: 52
  },
  [`& .${Pa.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${Pa.inset}`]: {
    paddingLeft: 36
  },
  [`& .${Wx.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: t
    }) => t.divider,
    style: {
      borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.dense,
    style: {
      [e.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...e.typography.body2,
      [`& .${Wx.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), Nn = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: s = !1,
    component: i = "li",
    dense: a = !1,
    divider: l = !1,
    disableGutters: c = !1,
    focusVisibleClassName: u,
    role: d = "menuitem",
    tabIndex: f,
    className: p,
    ...m
  } = o, b = h.useContext(qo), v = h.useMemo(() => ({
    dense: a || b.dense || !1,
    disableGutters: c
  }), [b.dense, a, c]), g = h.useRef(null);
  yt(() => {
    s && (g.current ? g.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [s]);
  const y = {
    ...o,
    dense: v.dense,
    divider: l,
    disableGutters: c
  }, w = v6(o), x = tt(g, n);
  let S;
  return o.disabled || (S = f !== void 0 ? f : -1), /* @__PURE__ */ C(qo.Provider, {
    value: v,
    children: /* @__PURE__ */ C(C6, {
      ref: x,
      role: d,
      tabIndex: S,
      component: i,
      focusVisibleClassName: ae(w.focusVisible, u),
      className: ae(w.root, p),
      ...m,
      ownerState: y,
      classes: w
    })
  });
});
process.env.NODE_ENV !== "production" && (Nn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: r.bool,
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: r.bool,
  /**
   * @ignore
   */
  disabled: r.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: r.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: r.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: r.string,
  /**
   * @ignore
   */
  role: r.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * @default 0
   */
  tabIndex: r.number
});
function pM(e) {
  return De("MuiNativeSelect", e);
}
const cC = Ne("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), w6 = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: o,
    multiple: s,
    open: i,
    error: a
  } = e, l = {
    select: ["select", n, o && "disabled", s && "multiple", a && "error"],
    icon: ["icon", `icon${ce(n)}`, i && "iconOpen", o && "disabled"]
  };
  return fe(l, pM, t);
}, hM = te("select")(({
  theme: e
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${cC.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.variant !== "filled" && t.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius,
      "&:focus": {
        borderRadius: (e.vars || e).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), S6 = te(hM, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: Xn,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${cC.multiple}`]: t.multiple
    }];
  }
})({}), gM = te("svg")(({
  theme: e
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (e.vars || e).palette.action.active,
  [`&.${cC.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), x6 = te(gM, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${ce(n.variant)}`], n.open && t.iconOpen];
  }
})({}), uC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    className: o,
    disabled: s,
    error: i,
    IconComponent: a,
    inputRef: l,
    variant: c = "standard",
    ...u
  } = t, d = {
    ...t,
    disabled: s,
    variant: c,
    error: i
  }, f = w6(d);
  return /* @__PURE__ */ ie(h.Fragment, {
    children: [/* @__PURE__ */ C(S6, {
      ownerState: d,
      className: ae(f.select, o),
      disabled: s,
      ref: l || n,
      ...u
    }), t.multiple ? null : /* @__PURE__ */ C(x6, {
      as: a,
      ownerState: d,
      className: f.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (uC.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * The CSS class name of the select element.
   */
  className: r.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: r.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: r.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: Lt,
  /**
   * @ignore
   */
  multiple: r.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: r.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * The input value.
   */
  value: r.any,
  /**
   * The variant to use.
   */
  variant: r.oneOf(["standard", "outlined", "filled"])
});
const T6 = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, pM, t);
}, R6 = /* @__PURE__ */ C(_i, {}), dC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    name: "MuiNativeSelect",
    props: t
  }), {
    className: s,
    children: i,
    classes: a = {},
    IconComponent: l = Yv,
    input: c = R6,
    inputProps: u,
    variant: d,
    ...f
  } = o, p = lo(), m = Es({
    props: o,
    muiFormControl: p,
    states: ["variant"]
  }), b = {
    ...o,
    classes: a
  }, v = T6(b), {
    root: g,
    ...y
  } = a;
  return /* @__PURE__ */ C(h.Fragment, {
    children: /* @__PURE__ */ h.cloneElement(c, {
      // Most of the logic is implemented in `NativeSelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: uC,
      inputProps: {
        children: i,
        classes: y,
        IconComponent: l,
        variant: m.variant,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        ...u,
        ...c ? c.props.inputProps : {}
      },
      ref: n,
      ...f,
      className: ae(v.root, c.props.className, s)
    })
  });
});
process.env.NODE_ENV !== "production" && (dC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: r.elementType,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   * @default <Input />
   */
  input: r.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/select#attributes) applied to the `select` element.
   */
  inputProps: r.object,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {React.ChangeEvent<HTMLSelectElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The `input` value. The DOM API casts this to a string.
   */
  value: r.any,
  /**
   * The variant to use.
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
dC.muiName = "Select";
var Qx;
const E6 = te("fieldset", {
  shouldForwardProp: Xn
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), I6 = te("legend", {
  shouldForwardProp: Xn
})(Fe(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: t
    }) => !t.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.withLabel && t.notched,
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function mM(e) {
  const {
    children: t,
    classes: n,
    className: o,
    label: s,
    notched: i,
    ...a
  } = e, l = s != null && s !== "", c = {
    ...e,
    notched: i,
    withLabel: l
  };
  return /* @__PURE__ */ C(E6, {
    "aria-hidden": !0,
    className: o,
    ownerState: c,
    ...a,
    children: /* @__PURE__ */ C(I6, {
      ownerState: c,
      children: l ? /* @__PURE__ */ C("span", {
        children: s
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        Qx || (Qx = /* @__PURE__ */ C("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
process.env.NODE_ENV !== "production" && (mM.propTypes = {
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The label.
   */
  label: r.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: r.bool.isRequired,
  /**
   * @ignore
   */
  style: r.object
});
const O6 = (e) => {
  const {
    classes: t
  } = e, o = fe({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, hz, t);
  return {
    ...t,
    // forward classes to the InputBase
    ...o
  };
}, P6 = te(kp, {
  shouldForwardProp: (e) => Xn(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: Pp
})(Fe(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${rr.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${rr.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${rr.focused} .${rr.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(e.palette).filter($t()).map(([n]) => ({
      props: {
        color: n
      },
      style: {
        [`&.${rr.focused} .${rr.notchedOutline}`]: {
          borderColor: (e.vars || e).palette[n].main
        }
      }
    })), {
      props: {},
      // to overide the above style
      style: {
        [`&.${rr.error} .${rr.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.error.main
        },
        [`&.${rr.disabled} .${rr.notchedOutline}`]: {
          borderColor: (e.vars || e).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: n
      }) => n.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: n,
        size: o
      }) => n.multiline && o === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), M6 = te(mM, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(Fe(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
})), k6 = te(Dp, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: Mp
})(Fe(({
  theme: e
}) => ({
  padding: "16.5px 14px",
  ...!e.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
      caretColor: e.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...e.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [e.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), ol = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var o;
  const s = Be({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: i = {},
    fullWidth: a = !1,
    inputComponent: l = "input",
    label: c,
    multiline: u = !1,
    notched: d,
    slots: f = {},
    type: p = "text",
    ...m
  } = s, b = O6(s), v = lo(), g = Es({
    props: s,
    muiFormControl: v,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), y = {
    ...s,
    color: g.color || "primary",
    disabled: g.disabled,
    error: g.error,
    focused: g.focused,
    formControl: v,
    fullWidth: a,
    hiddenLabel: g.hiddenLabel,
    multiline: u,
    size: g.size,
    type: p
  }, w = f.root ?? i.Root ?? P6, x = f.input ?? i.Input ?? k6;
  return /* @__PURE__ */ C(Xi, {
    slots: {
      root: w,
      input: x
    },
    renderSuffix: (S) => /* @__PURE__ */ C(M6, {
      ownerState: y,
      className: b.notchedOutline,
      label: c != null && c !== "" && g.required ? o || (o = /* @__PURE__ */ ie(h.Fragment, {
        children: [c, " ", "*"]
      })) : c,
      notched: typeof d < "u" ? d : !!(S.startAdornment || S.filled || S.focused)
    }),
    fullWidth: a,
    inputComponent: l,
    multiline: u,
    ref: n,
    type: p,
    ...m,
    classes: {
      ...b,
      notchedOutline: null
    }
  });
});
process.env.NODE_ENV !== "production" && (ol.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: r.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary"]), r.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: r.shape({
    Input: r.elementType,
    Root: r.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: r.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: r.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: r.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: r.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: r.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: r.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: r.oneOfType([r.number, r.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: r.oneOfType([r.number, r.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: r.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: r.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: r.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: r.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: r.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: r.oneOfType([r.number, r.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: r.shape({
    input: r.elementType,
    root: r.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: r.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: r.any
});
ol && (ol.muiName = "Input");
const D6 = _e(/* @__PURE__ */ C("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), N6 = _e(/* @__PURE__ */ C("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), $6 = _e(/* @__PURE__ */ C("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), A6 = _e(/* @__PURE__ */ C("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), F6 = te("span", {
  shouldForwardProp: Xn
})({
  position: "relative",
  display: "flex"
}), L6 = te($6)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), _6 = te(A6)(Fe(({
  theme: e
}) => ({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      checked: !0
    },
    style: {
      transform: "scale(1)",
      transition: e.transitions.create("transform", {
        easing: e.transitions.easing.easeOut,
        duration: e.transitions.duration.shortest
      })
    }
  }]
})));
function fC(e) {
  const {
    checked: t = !1,
    classes: n = {},
    fontSize: o
  } = e, s = {
    ...e,
    checked: t
  };
  return /* @__PURE__ */ ie(F6, {
    className: n.root,
    ownerState: s,
    children: [/* @__PURE__ */ C(L6, {
      fontSize: o,
      className: n.background,
      ownerState: s
    }), /* @__PURE__ */ C(_6, {
      fontSize: o,
      className: n.dot,
      ownerState: s
    })]
  });
}
process.env.NODE_ENV !== "production" && (fC.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: r.oneOf(["small", "medium"])
});
const pC = /* @__PURE__ */ h.createContext(void 0);
process.env.NODE_ENV !== "production" && (pC.displayName = "RadioGroupContext");
function V6() {
  return h.useContext(pC);
}
function B6(e) {
  return De("MuiRadio", e);
}
const Zx = Ne("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), z6 = (e) => {
  const {
    classes: t,
    color: n,
    size: o
  } = e, s = {
    root: ["root", `color${ce(n)}`, o !== "medium" && `size${ce(o)}`]
  };
  return {
    ...t,
    ...fe(s, B6, t)
  };
}, H6 = te(Ap, {
  shouldForwardProp: (e) => Xn(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size !== "medium" && t[`size${ce(n.size)}`], t[`color${ce(n.color)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  [`&.${Zx.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  },
  variants: [{
    props: {
      color: "default",
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette.action.active, e.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette[t].main, e.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t,
      disabled: !1
    },
    style: {
      [`&.${Zx.checked}`]: {
        color: (e.vars || e).palette[t].main
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
})));
function j6(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const Jx = /* @__PURE__ */ C(fC, {
  checked: !0
}), e1 = /* @__PURE__ */ C(fC, {}), hC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiRadio"
  }), {
    checked: s,
    checkedIcon: i = Jx,
    color: a = "primary",
    icon: l = e1,
    name: c,
    onChange: u,
    size: d = "medium",
    className: f,
    disabled: p,
    disableRipple: m = !1,
    ...b
  } = o, v = lo();
  let g = p;
  v && typeof g > "u" && (g = v.disabled), g ?? (g = !1);
  const y = {
    ...o,
    disabled: g,
    disableRipple: m,
    color: a,
    size: d
  }, w = z6(y), x = V6();
  let S = s;
  const T = Yb(u, x && x.onChange);
  let E = c;
  return x && (typeof S > "u" && (S = j6(x.value, o.value)), typeof E > "u" && (E = x.name)), /* @__PURE__ */ C(H6, {
    type: "radio",
    icon: /* @__PURE__ */ h.cloneElement(l, {
      fontSize: e1.props.fontSize ?? d
    }),
    checkedIcon: /* @__PURE__ */ h.cloneElement(i, {
      fontSize: Jx.props.fontSize ?? d
    }),
    disabled: g,
    ownerState: y,
    classes: w,
    name: E,
    checked: S,
    onChange: T,
    ref: n,
    className: ae(w.root, f),
    ...b
  });
});
process.env.NODE_ENV !== "production" && (hC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: r.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: r.node,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: r.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: r.any
});
function G6(e) {
  return De("MuiRadioGroup", e);
}
Ne("MuiRadioGroup", ["root", "row", "error"]);
const q6 = (e) => {
  const {
    classes: t,
    row: n,
    error: o
  } = e;
  return fe({
    root: ["root", n && "row", o && "error"]
  }, G6, t);
}, gC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: o,
    children: s,
    className: i,
    defaultValue: a,
    name: l,
    onChange: c,
    value: u,
    ...d
  } = t, f = h.useRef(null), p = q6(t), [m, b] = jn({
    controlled: u,
    default: a,
    name: "RadioGroup"
  });
  h.useImperativeHandle(o, () => ({
    focus: () => {
      let w = f.current.querySelector("input:not(:disabled):checked");
      w || (w = f.current.querySelector("input:not(:disabled)")), w && w.focus();
    }
  }), []);
  const v = tt(n, f), g = gt(l), y = h.useMemo(() => ({
    name: g,
    onChange(w) {
      b(w.target.value), c && c(w, w.target.value);
    },
    value: m
  }), [g, c, b, m]);
  return /* @__PURE__ */ C(pC.Provider, {
    value: y,
    children: /* @__PURE__ */ C(tC, {
      role: "radiogroup",
      ref: v,
      className: ae(p.root, i),
      ...d,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && (gC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: r.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: r.any
});
const W6 = _e(/* @__PURE__ */ C("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), "Star"), U6 = _e(/* @__PURE__ */ C("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), "StarBorder");
function K6(e) {
  return De("MuiRating", e);
}
const zl = Ne("MuiRating", ["root", "sizeSmall", "sizeMedium", "sizeLarge", "readOnly", "disabled", "focusVisible", "visuallyHidden", "pristine", "label", "labelEmptyValueActive", "icon", "iconEmpty", "iconFilled", "iconHover", "iconFocus", "iconActive", "decimal"]);
function Y6(e) {
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function qh(e, t) {
  if (e == null)
    return e;
  const n = Math.round(e / t) * t;
  return Number(n.toFixed(Y6(t)));
}
const X6 = (e) => {
  const {
    classes: t,
    size: n,
    readOnly: o,
    disabled: s,
    emptyValueFocused: i,
    focusVisible: a
  } = e, l = {
    root: ["root", `size${ce(n)}`, s && "disabled", a && "focusVisible", o && "readOnly"],
    label: ["label", "pristine"],
    labelEmptyValue: [i && "labelEmptyValueActive"],
    icon: ["icon"],
    iconEmpty: ["iconEmpty"],
    iconFilled: ["iconFilled"],
    iconHover: ["iconHover"],
    iconFocus: ["iconFocus"],
    iconActive: ["iconActive"],
    decimal: ["decimal"],
    visuallyHidden: ["visuallyHidden"]
  };
  return fe(l, K6, t);
}, Q6 = te("span", {
  name: "MuiRating",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${zl.visuallyHidden}`]: t.visuallyHidden
    }, t.root, t[`size${ce(n.size)}`], n.readOnly && t.readOnly];
  }
})(Fe(({
  theme: e
}) => ({
  display: "inline-flex",
  // Required to position the pristine input absolutely
  position: "relative",
  fontSize: e.typography.pxToRem(24),
  color: "#faaf00",
  cursor: "pointer",
  textAlign: "left",
  width: "min-content",
  WebkitTapHighlightColor: "transparent",
  [`&.${zl.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity,
    pointerEvents: "none"
  },
  [`&.${zl.focusVisible} .${zl.iconActive}`]: {
    outline: "1px solid #999"
  },
  [`& .${zl.visuallyHidden}`]: Pv,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      fontSize: e.typography.pxToRem(30)
    }
  }, {
    // TODO v6: use the .Mui-readOnly global state class
    props: ({
      ownerState: t
    }) => t.readOnly,
    style: {
      pointerEvents: "none"
    }
  }]
}))), bM = te("label", {
  name: "MuiRating",
  slot: "Label",
  overridesResolver: ({
    ownerState: e
  }, t) => [t.label, e.emptyValueFocused && t.labelEmptyValueActive]
})({
  cursor: "inherit",
  variants: [{
    props: ({
      ownerState: e
    }) => e.emptyValueFocused,
    style: {
      top: 0,
      bottom: 0,
      position: "absolute",
      outline: "1px solid #999",
      width: "100%"
    }
  }]
}), Z6 = te("span", {
  name: "MuiRating",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.iconEmpty && t.iconEmpty, n.iconFilled && t.iconFilled, n.iconHover && t.iconHover, n.iconFocus && t.iconFocus, n.iconActive && t.iconActive];
  }
})(Fe(({
  theme: e
}) => ({
  // Fit wrapper to actual icon size.
  display: "flex",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  // Fix mouseLeave issue.
  // https://github.com/facebook/react/issues/4492
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => t.iconActive,
    style: {
      transform: "scale(1.2)"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.iconEmpty,
    style: {
      color: (e.vars || e).palette.action.disabled
    }
  }]
}))), J6 = te("span", {
  name: "MuiRating",
  slot: "Decimal",
  shouldForwardProp: (e) => bu(e) && e !== "iconActive",
  overridesResolver: (e, t) => {
    const {
      iconActive: n
    } = e;
    return [t.decimal, n && t.iconActive];
  }
})({
  position: "relative",
  variants: [{
    props: ({
      iconActive: e
    }) => e,
    style: {
      transform: "scale(1.2)"
    }
  }]
});
function yM(e) {
  const {
    value: t,
    ...n
  } = e;
  return /* @__PURE__ */ C("span", {
    ...n
  });
}
process.env.NODE_ENV !== "production" && (yM.propTypes = {
  value: r.number.isRequired
});
function py(e) {
  const {
    classes: t,
    disabled: n,
    emptyIcon: o,
    focus: s,
    getLabelText: i,
    highlightSelectedOnly: a,
    hover: l,
    icon: c,
    IconContainerComponent: u,
    isActive: d,
    itemValue: f,
    labelProps: p,
    name: m,
    onBlur: b,
    onChange: v,
    onClick: g,
    onFocus: y,
    readOnly: w,
    ownerState: x,
    ratingValue: S,
    ratingValueRounded: T
  } = e, E = a ? f === S : f <= S, O = f <= l, M = f <= s, D = f === T, R = `${m}-${gt()}`, P = /* @__PURE__ */ C(Z6, {
    as: u,
    value: f,
    className: ae(t.icon, E ? t.iconFilled : t.iconEmpty, O && t.iconHover, M && t.iconFocus, d && t.iconActive),
    ownerState: {
      ...x,
      iconEmpty: !E,
      iconFilled: E,
      iconHover: O,
      iconFocus: M,
      iconActive: d
    },
    children: o && !E ? o : c
  });
  return w ? /* @__PURE__ */ C("span", {
    ...p,
    children: P
  }) : /* @__PURE__ */ ie(h.Fragment, {
    children: [/* @__PURE__ */ ie(bM, {
      ownerState: {
        ...x,
        emptyValueFocused: void 0
      },
      htmlFor: R,
      ...p,
      children: [P, /* @__PURE__ */ C("span", {
        className: t.visuallyHidden,
        children: i(f)
      })]
    }), /* @__PURE__ */ C("input", {
      className: t.visuallyHidden,
      onFocus: y,
      onBlur: b,
      onChange: v,
      onClick: g,
      disabled: n,
      value: f,
      id: R,
      type: "radio",
      name: m,
      checked: D
    })]
  });
}
process.env.NODE_ENV !== "production" && (py.propTypes = {
  classes: r.object.isRequired,
  disabled: r.bool.isRequired,
  emptyIcon: r.node,
  focus: r.number.isRequired,
  getLabelText: r.func.isRequired,
  highlightSelectedOnly: r.bool.isRequired,
  hover: r.number.isRequired,
  icon: r.node,
  IconContainerComponent: r.elementType.isRequired,
  isActive: r.bool.isRequired,
  itemValue: r.number.isRequired,
  labelProps: r.object,
  name: r.string,
  onBlur: r.func.isRequired,
  onChange: r.func.isRequired,
  onClick: r.func.isRequired,
  onFocus: r.func.isRequired,
  ownerState: r.object.isRequired,
  ratingValue: r.number,
  ratingValueRounded: r.number,
  readOnly: r.bool.isRequired
});
const eG = /* @__PURE__ */ C(W6, {
  fontSize: "inherit"
}), tG = /* @__PURE__ */ C(U6, {
  fontSize: "inherit"
});
function nG(e) {
  return `${e || "0"} Star${e !== 1 ? "s" : ""}`;
}
const vM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    name: "MuiRating",
    props: t
  }), {
    component: s = "span",
    className: i,
    defaultValue: a = null,
    disabled: l = !1,
    emptyIcon: c = tG,
    emptyLabelText: u = "Empty",
    getLabelText: d = nG,
    highlightSelectedOnly: f = !1,
    icon: p = eG,
    IconContainerComponent: m = yM,
    max: b = 5,
    name: v,
    onChange: g,
    onChangeActive: y,
    onMouseLeave: w,
    onMouseMove: x,
    precision: S = 1,
    readOnly: T = !1,
    size: E = "medium",
    value: O,
    ...M
  } = o, D = gt(v), [R, P] = jn({
    controlled: O,
    default: a,
    name: "Rating"
  }), F = qh(R, S), $ = _t(), [{
    hover: N,
    focus: A
  }, k] = h.useState({
    hover: -1,
    focus: -1
  });
  let L = F;
  N !== -1 && (L = N), A !== -1 && (L = A);
  const [B, V] = h.useState(!1), _ = h.useRef(), z = tt(_, n), j = (H) => {
    x && x(H);
    const U = _.current, {
      right: X,
      left: re,
      width: oe
    } = U.getBoundingClientRect();
    let le;
    $ ? le = (X - H.clientX) / oe : le = (H.clientX - re) / oe;
    let se = qh(b * le + S / 2, S);
    se = Si(se, S, b), k((Ce) => Ce.hover === se && Ce.focus === se ? Ce : {
      hover: se,
      focus: se
    }), V(!1), y && N !== se && y(H, se);
  }, W = (H) => {
    w && w(H);
    const U = -1;
    k({
      hover: U,
      focus: U
    }), y && N !== U && y(H, U);
  }, J = (H) => {
    let U = H.target.value === "" ? null : parseFloat(H.target.value);
    N !== -1 && (U = N), P(U), g && g(H, U);
  }, G = (H) => {
    H.clientX === 0 && H.clientY === 0 || (k({
      hover: -1,
      focus: -1
    }), P(null), g && parseFloat(H.target.value) === F && g(H, null));
  }, q = (H) => {
    Ws(H.target) && V(!0);
    const U = parseFloat(H.target.value);
    k((X) => ({
      hover: X.hover,
      focus: U
    }));
  }, Z = (H) => {
    if (N !== -1)
      return;
    Ws(H.target) || V(!1);
    const U = -1;
    k((X) => ({
      hover: X.hover,
      focus: U
    }));
  }, [Y, Q] = h.useState(!1), ee = {
    ...o,
    component: s,
    defaultValue: a,
    disabled: l,
    emptyIcon: c,
    emptyLabelText: u,
    emptyValueFocused: Y,
    focusVisible: B,
    getLabelText: d,
    icon: p,
    IconContainerComponent: m,
    max: b,
    precision: S,
    readOnly: T,
    size: E
  }, ne = X6(ee);
  return /* @__PURE__ */ ie(Q6, {
    as: s,
    ref: z,
    onMouseMove: j,
    onMouseLeave: W,
    className: ae(ne.root, i, T && "MuiRating-readOnly"),
    ownerState: ee,
    role: T ? "img" : null,
    "aria-label": T ? d(L) : null,
    ...M,
    children: [Array.from(new Array(b)).map((H, U) => {
      const X = U + 1, re = {
        classes: ne,
        disabled: l,
        emptyIcon: c,
        focus: A,
        getLabelText: d,
        highlightSelectedOnly: f,
        hover: N,
        icon: p,
        IconContainerComponent: m,
        name: D,
        onBlur: Z,
        onChange: J,
        onClick: G,
        onFocus: q,
        ratingValue: L,
        ratingValueRounded: F,
        readOnly: T,
        ownerState: ee
      }, oe = X === Math.ceil(L) && (N !== -1 || A !== -1);
      if (S < 1) {
        const le = Array.from(new Array(1 / S));
        return /* @__PURE__ */ C(J6, {
          className: ae(ne.decimal, oe && ne.iconActive),
          ownerState: ee,
          iconActive: oe,
          children: le.map((se, Ce) => {
            const $e = qh(X - 1 + (Ce + 1) * S, S);
            return /* @__PURE__ */ C(py, {
              ...re,
              // The icon is already displayed as active
              isActive: !1,
              itemValue: $e,
              labelProps: {
                style: le.length - 1 === Ce ? {} : {
                  width: $e === L ? `${(Ce + 1) * S * 100}%` : "0%",
                  overflow: "hidden",
                  position: "absolute"
                }
              }
            }, $e);
          })
        }, X);
      }
      return /* @__PURE__ */ C(py, {
        ...re,
        isActive: oe,
        itemValue: X
      }, X);
    }), !T && !l && /* @__PURE__ */ ie(bM, {
      className: ae(ne.label, ne.labelEmptyValue),
      ownerState: ee,
      children: [/* @__PURE__ */ C("input", {
        className: ne.visuallyHidden,
        value: "",
        id: `${D}-empty`,
        type: "radio",
        name: D,
        checked: F == null,
        onFocus: () => Q(!0),
        onBlur: () => Q(!1),
        onChange: J
      }), /* @__PURE__ */ C("span", {
        className: ne.visuallyHidden,
        children: u
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (vM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The default value. Use when the component is not controlled.
   * @default null
   */
  defaultValue: r.number,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * The icon to display when empty.
   * @default <StarBorder fontSize="inherit" />
   */
  emptyIcon: r.node,
  /**
   * The label read when the rating input is empty.
   * @default 'Empty'
   */
  emptyLabelText: r.node,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the rating.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {number} value The rating label's value to format.
   * @returns {string}
   * @default function defaultLabelText(value) {
   *   return `${value || '0'} Star${value !== 1 ? 's' : ''}`;
   * }
   */
  getLabelText: r.func,
  /**
   * If `true`, only the selected icon will be highlighted.
   * @default false
   */
  highlightSelectedOnly: r.bool,
  /**
   * The icon to display.
   * @default <Star fontSize="inherit" />
   */
  icon: r.node,
  /**
   * The component containing the icon.
   * @default function IconContainer(props) {
   *   const { value, ...other } = props;
   *   return <span {...other} />;
   * }
   */
  IconContainerComponent: r.elementType,
  /**
   * Maximum rating.
   * @default 5
   */
  max: r.number,
  /**
   * The name attribute of the radio `input` elements.
   * This input `name` should be unique within the page.
   * Being unique within a form is insufficient since the `name` is used to generate IDs.
   */
  name: r.string,
  /**
   * Callback fired when the value changes.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {number|null} value The new value.
   */
  onChange: r.func,
  /**
   * Callback function that is fired when the hover state changes.
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {number} value The new value.
   */
  onChangeActive: r.func,
  /**
   * @ignore
   */
  onMouseLeave: r.func,
  /**
   * @ignore
   */
  onMouseMove: r.func,
  /**
   * The minimum increment value change allowed.
   * @default 1
   */
  precision: Gn(r.number, (e) => e.precision < 0.1 ? new Error(["MUI: The prop `precision` should be above 0.1.", "A value below this limit has an imperceptible impact."].join(`
`)) : null),
  /**
   * Removes all hover effects and pointer events.
   * @default false
   */
  readOnly: r.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["small", "medium", "large"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The rating value.
   */
  value: r.number
});
function oG(e) {
  return De("MuiScopedCssBaseline", e);
}
Ne("MuiScopedCssBaseline", ["root"]);
const rG = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, oG, t);
}, sG = te("div", {
  name: "MuiScopedCssBaseline",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(Fe(({
  theme: e
}) => {
  const t = {};
  return e.colorSchemes && Object.entries(e.colorSchemes).forEach(([n, o]) => {
    var i, a;
    const s = e.getColorSchemeSelector(n);
    s.startsWith("@") ? t[s] = {
      colorScheme: (i = o.palette) == null ? void 0 : i.mode
    } : t[`&${s.replace(/\s*&/, "")}`] = {
      colorScheme: (a = o.palette) == null ? void 0 : a.mode
    };
  }), {
    ...HH(e, !1),
    ...jH(e),
    "& *, & *::before, & *::after": {
      boxSizing: "inherit"
    },
    "& strong, & b": {
      fontWeight: e.typography.fontWeightBold
    },
    variants: [{
      props: {
        enableColorScheme: !0
      },
      style: e.vars ? t : {
        colorScheme: e.palette.mode
      }
    }]
  };
})), CM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiScopedCssBaseline"
  }), {
    className: s,
    component: i = "div",
    enableColorScheme: a,
    ...l
  } = o, c = {
    ...o,
    component: i
  }, u = rG(c);
  return /* @__PURE__ */ C(sG, {
    as: i,
    className: ae(u.root, s),
    ref: n,
    ownerState: c,
    ...l
  });
});
process.env.NODE_ENV !== "production" && (CM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   */
  enableColorScheme: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function iG(e) {
  return De("MuiSelect", e);
}
const Hl = Ne("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var t1;
const aG = te(hM, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${Hl.select}`]: t.select
      },
      {
        [`&.${Hl.select}`]: t[n.variant]
      },
      {
        [`&.${Hl.error}`]: t.error
      },
      {
        [`&.${Hl.multiple}`]: t.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${Hl.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), lG = te(gM, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${ce(n.variant)}`], n.open && t.iconOpen];
  }
})({}), cG = te("input", {
  shouldForwardProp: (e) => bu(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function n1(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function uG(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const dG = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: o,
    multiple: s,
    open: i,
    error: a
  } = e, l = {
    select: ["select", n, o && "disabled", s && "multiple", a && "error"],
    icon: ["icon", `icon${ce(n)}`, i && "iconOpen", o && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return fe(l, iG, t);
}, wM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var ze;
  const {
    "aria-describedby": o,
    "aria-label": s,
    autoFocus: i,
    autoWidth: a,
    children: l,
    className: c,
    defaultOpen: u,
    defaultValue: d,
    disabled: f,
    displayEmpty: p,
    error: m = !1,
    IconComponent: b,
    inputRef: v,
    labelId: g,
    MenuProps: y = {},
    multiple: w,
    name: x,
    onBlur: S,
    onChange: T,
    onClose: E,
    onFocus: O,
    onOpen: M,
    open: D,
    readOnly: R,
    renderValue: P,
    SelectDisplayProps: F = {},
    tabIndex: $,
    // catching `type` from Input which makes no sense for SelectInput
    type: N,
    value: A,
    variant: k = "standard",
    ...L
  } = t, [B, V] = jn({
    controlled: A,
    default: d,
    name: "Select"
  }), [_, z] = jn({
    controlled: D,
    default: u,
    name: "Select"
  }), j = h.useRef(null), W = h.useRef(null), [J, G] = h.useState(null), {
    current: q
  } = h.useRef(D != null), [Z, Y] = h.useState(), Q = tt(n, v), ee = h.useCallback((pe) => {
    W.current = pe, pe && G(pe);
  }, []), ne = J == null ? void 0 : J.parentNode;
  h.useImperativeHandle(Q, () => ({
    focus: () => {
      W.current.focus();
    },
    node: j.current,
    value: B
  }), [B]), h.useEffect(() => {
    u && _ && J && !q && (Y(a ? null : ne.clientWidth), W.current.focus());
  }, [J, a]), h.useEffect(() => {
    i && W.current.focus();
  }, [i]), h.useEffect(() => {
    if (!g)
      return;
    const pe = qt(W.current).getElementById(g);
    if (pe) {
      const Re = () => {
        getSelection().isCollapsed && W.current.focus();
      };
      return pe.addEventListener("click", Re), () => {
        pe.removeEventListener("click", Re);
      };
    }
  }, [g]);
  const H = (pe, Re) => {
    pe ? M && M(Re) : E && E(Re), q || (Y(a ? null : ne.clientWidth), z(pe));
  }, U = (pe) => {
    pe.button === 0 && (pe.preventDefault(), W.current.focus(), H(!0, pe));
  }, X = (pe) => {
    H(!1, pe);
  }, re = h.Children.toArray(l), oe = (pe) => {
    const Re = re.find((Ge) => Ge.props.value === pe.target.value);
    Re !== void 0 && (V(Re.props.value), T && T(pe, Re));
  }, le = (pe) => (Re) => {
    let Ge;
    if (Re.currentTarget.hasAttribute("tabindex")) {
      if (w) {
        Ge = Array.isArray(B) ? B.slice() : [];
        const Qe = B.indexOf(pe.props.value);
        Qe === -1 ? Ge.push(pe.props.value) : Ge.splice(Qe, 1);
      } else
        Ge = pe.props.value;
      if (pe.props.onClick && pe.props.onClick(Re), B !== Ge && (V(Ge), T)) {
        const Qe = Re.nativeEvent || Re, qe = new Qe.constructor(Qe.type, Qe);
        Object.defineProperty(qe, "target", {
          writable: !0,
          value: {
            value: Ge,
            name: x
          }
        }), T(qe, pe);
      }
      w || H(!1, Re);
    }
  }, se = (pe) => {
    R || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(pe.key) && (pe.preventDefault(), H(!0, pe));
  }, Ce = J !== null && _, $e = (pe) => {
    !Ce && S && (Object.defineProperty(pe, "target", {
      writable: !0,
      value: {
        value: B,
        name: x
      }
    }), S(pe));
  };
  delete L["aria-invalid"];
  let we, Te;
  const ue = [];
  let de = !1, Pe = !1;
  (Ef({
    value: B
  }) || p) && (P ? we = P(B) : de = !0);
  const ke = re.map((pe) => {
    if (!/* @__PURE__ */ h.isValidElement(pe))
      return null;
    process.env.NODE_ENV !== "production" && Js.isFragment(pe) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let Re;
    if (w) {
      if (!Array.isArray(B))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : Zr(2));
      Re = B.some((Ge) => n1(Ge, pe.props.value)), Re && de && ue.push(pe.props.children);
    } else
      Re = n1(B, pe.props.value), Re && de && (Te = pe.props.children);
    return Re && (Pe = !0), /* @__PURE__ */ h.cloneElement(pe, {
      "aria-selected": Re ? "true" : "false",
      onClick: le(pe),
      onKeyUp: (Ge) => {
        Ge.key === " " && Ge.preventDefault(), pe.props.onKeyUp && pe.props.onKeyUp(Ge);
      },
      role: "option",
      selected: Re,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": pe.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && h.useEffect(() => {
    if (!Pe && !w && B !== "") {
      const pe = re.map((Re) => Re.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${B}\` for the select ${x ? `(name="${x}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${pe.filter((Re) => Re != null).map((Re) => `\`${Re}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Pe, re, w, x, B]), de && (w ? ue.length === 0 ? we = null : we = ue.reduce((pe, Re, Ge) => (pe.push(Re), Ge < ue.length - 1 && pe.push(", "), pe), []) : we = Te);
  let Me = Z;
  !a && q && J && (Me = ne.clientWidth);
  let be;
  typeof $ < "u" ? be = $ : be = f ? null : 0;
  const me = F.id || (x ? `mui-component-select-${x}` : void 0), Ae = {
    ...t,
    variant: k,
    value: B,
    open: Ce,
    error: m
  }, ye = dG(Ae), We = {
    ...y.PaperProps,
    ...(ze = y.slotProps) == null ? void 0 : ze.paper
  }, He = gt();
  return /* @__PURE__ */ ie(h.Fragment, {
    children: [/* @__PURE__ */ C(aG, {
      as: "div",
      ref: ee,
      tabIndex: be,
      role: "combobox",
      "aria-controls": He,
      "aria-disabled": f ? "true" : void 0,
      "aria-expanded": Ce ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": s,
      "aria-labelledby": [g, me].filter(Boolean).join(" ") || void 0,
      "aria-describedby": o,
      onKeyDown: se,
      onMouseDown: f || R ? null : U,
      onBlur: $e,
      onFocus: O,
      ...F,
      ownerState: Ae,
      className: ae(F.className, ye.select, c),
      id: me,
      children: uG(we) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        t1 || (t1 = /* @__PURE__ */ C("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : we
    }), /* @__PURE__ */ C(cG, {
      "aria-invalid": m,
      value: Array.isArray(B) ? B.join(",") : B,
      name: x,
      ref: j,
      "aria-hidden": !0,
      onChange: oe,
      tabIndex: -1,
      disabled: f,
      className: ye.nativeInput,
      autoFocus: i,
      ...L,
      ownerState: Ae
    }), /* @__PURE__ */ C(lG, {
      as: b,
      className: ye.icon,
      ownerState: Ae
    }), /* @__PURE__ */ C(Eu, {
      id: `menu-${x || ""}`,
      anchorEl: ne,
      open: Ce,
      onClose: X,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...y,
      MenuListProps: {
        "aria-labelledby": g,
        role: "listbox",
        "aria-multiselectable": w ? "true" : void 0,
        disableListWrap: !0,
        id: He,
        ...y.MenuListProps
      },
      slotProps: {
        ...y.slotProps,
        paper: {
          ...We,
          style: {
            minWidth: Me,
            ...We != null ? We.style : null
          }
        }
      },
      children: ke
    })]
  });
});
process.env.NODE_ENV !== "production" && (wM.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": r.string,
  /**
   * @ignore
   */
  "aria-label": r.string,
  /**
   * @ignore
   */
  autoFocus: r.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: r.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * The CSS class name of the select element.
   */
  className: r.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: r.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: r.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: r.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: r.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: Lt,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: r.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: r.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: r.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: r.string,
  /**
   * @ignore
   */
  onBlur: r.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: r.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool,
  /**
   * @ignore
   */
  readOnly: r.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: r.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: r.object,
  /**
   * @ignore
   */
  tabIndex: r.oneOfType([r.number, r.string]),
  /**
   * @ignore
   */
  type: r.any,
  /**
   * The input value.
   */
  value: r.any,
  /**
   * The variant to use.
   */
  variant: r.oneOf(["standard", "outlined", "filled"])
});
const fG = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, mC = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => Xn(e) && e !== "variant",
  slot: "Root"
}, pG = te(_i, mC)(""), hG = te(ol, mC)(""), gG = te(Gc, mC)(""), Ji = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: s = !1,
    children: i,
    classes: a = {},
    className: l,
    defaultOpen: c = !1,
    displayEmpty: u = !1,
    IconComponent: d = Yv,
    id: f,
    input: p,
    inputProps: m,
    label: b,
    labelId: v,
    MenuProps: g,
    multiple: y = !1,
    native: w = !1,
    onClose: x,
    onOpen: S,
    open: T,
    renderValue: E,
    SelectDisplayProps: O,
    variant: M = "outlined",
    ...D
  } = o, R = w ? uC : wM, P = lo(), F = Es({
    props: o,
    muiFormControl: P,
    states: ["variant", "error"]
  }), $ = F.variant || M, N = {
    ...o,
    variant: $,
    classes: a
  }, A = fG(N), {
    root: k,
    ...L
  } = A, B = p || {
    standard: /* @__PURE__ */ C(pG, {
      ownerState: N
    }),
    outlined: /* @__PURE__ */ C(hG, {
      label: b,
      ownerState: N
    }),
    filled: /* @__PURE__ */ C(gG, {
      ownerState: N
    })
  }[$], V = tt(n, Rs(B));
  return /* @__PURE__ */ C(h.Fragment, {
    children: /* @__PURE__ */ h.cloneElement(B, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: R,
      inputProps: {
        children: i,
        error: F.error,
        IconComponent: d,
        variant: $,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: y,
        ...w ? {
          id: f
        } : {
          autoWidth: s,
          defaultOpen: c,
          displayEmpty: u,
          labelId: v,
          MenuProps: g,
          onClose: x,
          onOpen: S,
          open: T,
          renderValue: E,
          SelectDisplayProps: {
            id: f,
            ...O
          }
        },
        ...m,
        classes: m ? Bn(L, m.classes) : L,
        ...p ? p.props.inputProps : {}
      },
      ...(y && w || u) && $ === "outlined" ? {
        notched: !0
      } : {},
      ref: V,
      className: ae(B.props.className, l, A.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!p && {
        variant: $
      },
      ...D
    })
  });
});
process.env.NODE_ENV !== "production" && (Ji.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: r.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: r.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: r.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: r.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: r.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: r.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: r.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: r.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: r.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: r.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: r.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: r.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: r.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: r.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: r.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: r.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: r.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: r.oneOfType([r.oneOf([""]), r.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
Ji.muiName = "Select";
function mG(e) {
  return De("MuiSkeleton", e);
}
Ne("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const bG = (e) => {
  const {
    classes: t,
    variant: n,
    animation: o,
    hasChildren: s,
    width: i,
    height: a
  } = e;
  return fe({
    root: ["root", n, o, s && "withChildren", s && !i && "fitContent", s && !a && "heightAuto"]
  }, mG, t);
}, hy = ss`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`, gy = ss`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`, yG = typeof hy != "string" ? Qs`
        animation: ${hy} 2s ease-in-out 0.5s infinite;
      ` : null, vG = typeof gy != "string" ? Qs`
        &::after {
          animation: ${gy} 2s linear 0.5s infinite;
        }
      ` : null, CG = te("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.animation !== !1 && t[n.animation], n.hasChildren && t.withChildren, n.hasChildren && !n.width && t.fitContent, n.hasChildren && !n.height && t.heightAuto];
  }
})(Fe(({
  theme: e
}) => {
  const t = d5(e.shape.borderRadius) || "px", n = f5(e.shape.borderRadius);
  return {
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: e.vars ? e.vars.palette.Skeleton.bg : he(e.palette.text.primary, e.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em",
    variants: [{
      props: {
        variant: "text"
      },
      style: {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${n}${t}/${Math.round(n / 0.6 * 10) / 10}${t}`,
        "&:empty:before": {
          content: '"\\00a0"'
        }
      }
    }, {
      props: {
        variant: "circular"
      },
      style: {
        borderRadius: "50%"
      }
    }, {
      props: {
        variant: "rounded"
      },
      style: {
        borderRadius: (e.vars || e).shape.borderRadius
      }
    }, {
      props: ({
        ownerState: o
      }) => o.hasChildren,
      style: {
        "& > *": {
          visibility: "hidden"
        }
      }
    }, {
      props: ({
        ownerState: o
      }) => o.hasChildren && !o.width,
      style: {
        maxWidth: "fit-content"
      }
    }, {
      props: ({
        ownerState: o
      }) => o.hasChildren && !o.height,
      style: {
        height: "auto"
      }
    }, {
      props: {
        animation: "pulse"
      },
      style: yG || {
        animation: `${hy} 2s ease-in-out 0.5s infinite`
      }
    }, {
      props: {
        animation: "wave"
      },
      style: {
        position: "relative",
        overflow: "hidden",
        /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
        WebkitMaskImage: "-webkit-radial-gradient(white, black)",
        "&::after": {
          background: `linear-gradient(
                90deg,
                transparent,
                ${(e.vars || e).palette.action.hover},
                transparent
              )`,
          content: '""',
          position: "absolute",
          transform: "translateX(-100%)",
          bottom: 0,
          left: 0,
          right: 0,
          top: 0
        }
      }
    }, {
      props: {
        animation: "wave"
      },
      style: vG || {
        "&::after": {
          animation: `${gy} 2s linear 0.5s infinite`
        }
      }
    }]
  };
})), bC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiSkeleton"
  }), {
    animation: s = "pulse",
    className: i,
    component: a = "span",
    height: l,
    style: c,
    variant: u = "text",
    width: d,
    ...f
  } = o, p = {
    ...o,
    animation: s,
    component: a,
    variant: u,
    hasChildren: !!f.children
  }, m = bG(p);
  return /* @__PURE__ */ C(CG, {
    as: a,
    ref: n,
    className: ae(m.root, i),
    ownerState: p,
    ...f,
    style: {
      width: d,
      height: l,
      ...c
    }
  });
});
process.env.NODE_ENV !== "production" && (bC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: r.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: r.oneOfType([r.number, r.string]),
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: r.oneOfType([r.oneOf(["circular", "rectangular", "rounded", "text"]), r.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: r.oneOfType([r.number, r.string])
});
function wG(e, t, n = (o, s) => o === s) {
  return e.length === t.length && e.every((o, s) => n(o, t[s]));
}
const SG = 2;
function SM(e, t) {
  return e - t;
}
function o1(e, t) {
  const {
    index: n
  } = e.reduce((o, s, i) => {
    const a = Math.abs(t - s);
    return o === null || a < o.distance || a === o.distance ? {
      distance: a,
      index: i
    } : o;
  }, null) ?? {};
  return n;
}
function hd(e, t) {
  if (t.current !== void 0 && e.changedTouches) {
    const n = e;
    for (let o = 0; o < n.changedTouches.length; o += 1) {
      const s = n.changedTouches[o];
      if (s.identifier === t.current)
        return {
          x: s.clientX,
          y: s.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function If(e, t, n) {
  return (e - t) * 100 / (n - t);
}
function xG(e, t, n) {
  return (n - t) * e + t;
}
function TG(e) {
  if (Math.abs(e) < 1) {
    const n = e.toExponential().split("e-"), o = n[0].split(".")[1];
    return (o ? o.length : 0) + parseInt(n[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function RG(e, t, n) {
  const o = Math.round((e - n) / t) * t + n;
  return Number(o.toFixed(TG(t)));
}
function r1({
  values: e,
  newValue: t,
  index: n
}) {
  const o = e.slice();
  return o[n] = t, o.sort(SM);
}
function gd({
  sliderRef: e,
  activeIndex: t,
  setActive: n
}) {
  var s, i, a;
  const o = qt(e.current);
  (!((s = e.current) != null && s.contains(o.activeElement)) || Number((i = o == null ? void 0 : o.activeElement) == null ? void 0 : i.getAttribute("data-index")) !== t) && ((a = e.current) == null || a.querySelector(`[type="range"][data-index="${t}"]`).focus()), n && n(t);
}
function md(e, t) {
  return typeof e == "number" && typeof t == "number" ? e === t : typeof e == "object" && typeof t == "object" ? wG(e, t) : !1;
}
const EG = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, IG = (e) => e;
let bd;
function s1() {
  return bd === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? bd = CSS.supports("touch-action", "none") : bd = !0), bd;
}
function OG(e) {
  const {
    "aria-labelledby": t,
    defaultValue: n,
    disabled: o = !1,
    disableSwap: s = !1,
    isRtl: i = !1,
    marks: a = !1,
    max: l = 100,
    min: c = 0,
    name: u,
    onChange: d,
    onChangeCommitted: f,
    orientation: p = "horizontal",
    rootRef: m,
    scale: b = IG,
    step: v = 1,
    shiftStep: g = 10,
    tabIndex: y,
    value: w
  } = e, x = h.useRef(void 0), [S, T] = h.useState(-1), [E, O] = h.useState(-1), [M, D] = h.useState(!1), R = h.useRef(0), [P, F] = jn({
    controlled: w,
    default: n ?? c,
    name: "Slider"
  }), $ = d && ((ue, de, Pe) => {
    const ke = ue.nativeEvent || ue, Me = new ke.constructor(ke.type, ke);
    Object.defineProperty(Me, "target", {
      writable: !0,
      value: {
        value: de,
        name: u
      }
    }), d(Me, de, Pe);
  }), N = Array.isArray(P);
  let A = N ? P.slice().sort(SM) : [P];
  A = A.map((ue) => ue == null ? c : Si(ue, c, l));
  const k = a === !0 && v !== null ? [...Array(Math.floor((l - c) / v) + 1)].map((ue, de) => ({
    value: c + v * de
  })) : a || [], L = k.map((ue) => ue.value), [B, V] = h.useState(-1), _ = h.useRef(null), z = tt(m, _), j = (ue) => (de) => {
    var ke;
    const Pe = Number(de.currentTarget.getAttribute("data-index"));
    Ws(de.target) && V(Pe), O(Pe), (ke = ue == null ? void 0 : ue.onFocus) == null || ke.call(ue, de);
  }, W = (ue) => (de) => {
    var Pe;
    Ws(de.target) || V(-1), O(-1), (Pe = ue == null ? void 0 : ue.onBlur) == null || Pe.call(ue, de);
  }, J = (ue, de) => {
    const Pe = Number(ue.currentTarget.getAttribute("data-index")), ke = A[Pe], Me = L.indexOf(ke);
    let be = de;
    if (k && v == null) {
      const me = L[L.length - 1];
      be > me ? be = me : be < L[0] ? be = L[0] : be = be < ke ? L[Me - 1] : L[Me + 1];
    }
    if (be = Si(be, c, l), N) {
      s && (be = Si(be, A[Pe - 1] || -1 / 0, A[Pe + 1] || 1 / 0));
      const me = be;
      be = r1({
        values: A,
        newValue: be,
        index: Pe
      });
      let Ae = Pe;
      s || (Ae = be.indexOf(me)), gd({
        sliderRef: _,
        activeIndex: Ae
      });
    }
    F(be), V(Pe), $ && !md(be, P) && $(ue, be, Pe), f && f(ue, be);
  }, G = (ue) => (de) => {
    var Pe;
    if (v !== null) {
      const ke = Number(de.currentTarget.getAttribute("data-index")), Me = A[ke];
      let be = null;
      (de.key === "ArrowLeft" || de.key === "ArrowDown") && de.shiftKey || de.key === "PageDown" ? be = Math.max(Me - g, c) : ((de.key === "ArrowRight" || de.key === "ArrowUp") && de.shiftKey || de.key === "PageUp") && (be = Math.min(Me + g, l)), be !== null && (J(de, be), de.preventDefault());
    }
    (Pe = ue == null ? void 0 : ue.onKeyDown) == null || Pe.call(ue, de);
  };
  yt(() => {
    var ue;
    o && _.current.contains(document.activeElement) && ((ue = document.activeElement) == null || ue.blur());
  }, [o]), o && S !== -1 && T(-1), o && B !== -1 && V(-1);
  const q = (ue) => (de) => {
    var Pe;
    (Pe = ue.onChange) == null || Pe.call(ue, de), J(de, de.target.valueAsNumber);
  }, Z = h.useRef(void 0);
  let Y = p;
  i && p === "horizontal" && (Y += "-reverse");
  const Q = ({
    finger: ue,
    move: de = !1
  }) => {
    const {
      current: Pe
    } = _, {
      width: ke,
      height: Me,
      bottom: be,
      left: me
    } = Pe.getBoundingClientRect();
    let Ae;
    Y.startsWith("vertical") ? Ae = (be - ue.y) / Me : Ae = (ue.x - me) / ke, Y.includes("-reverse") && (Ae = 1 - Ae);
    let ye;
    if (ye = xG(Ae, c, l), v)
      ye = RG(ye, v, c);
    else {
      const He = o1(L, ye);
      ye = L[He];
    }
    ye = Si(ye, c, l);
    let We = 0;
    if (N) {
      de ? We = Z.current : We = o1(A, ye), s && (ye = Si(ye, A[We - 1] || -1 / 0, A[We + 1] || 1 / 0));
      const He = ye;
      ye = r1({
        values: A,
        newValue: ye,
        index: We
      }), s && de || (We = ye.indexOf(He), Z.current = We);
    }
    return {
      newValue: ye,
      activeIndex: We
    };
  }, ee = xe((ue) => {
    const de = hd(ue, x);
    if (!de)
      return;
    if (R.current += 1, ue.type === "mousemove" && ue.buttons === 0) {
      ne(ue);
      return;
    }
    const {
      newValue: Pe,
      activeIndex: ke
    } = Q({
      finger: de,
      move: !0
    });
    gd({
      sliderRef: _,
      activeIndex: ke,
      setActive: T
    }), F(Pe), !M && R.current > SG && D(!0), $ && !md(Pe, P) && $(ue, Pe, ke);
  }), ne = xe((ue) => {
    const de = hd(ue, x);
    if (D(!1), !de)
      return;
    const {
      newValue: Pe
    } = Q({
      finger: de,
      move: !0
    });
    T(-1), ue.type === "touchend" && O(-1), f && f(ue, Pe), x.current = void 0, U();
  }), H = xe((ue) => {
    if (o)
      return;
    s1() || ue.preventDefault();
    const de = ue.changedTouches[0];
    de != null && (x.current = de.identifier);
    const Pe = hd(ue, x);
    if (Pe !== !1) {
      const {
        newValue: Me,
        activeIndex: be
      } = Q({
        finger: Pe
      });
      gd({
        sliderRef: _,
        activeIndex: be,
        setActive: T
      }), F(Me), $ && !md(Me, P) && $(ue, Me, be);
    }
    R.current = 0;
    const ke = qt(_.current);
    ke.addEventListener("touchmove", ee, {
      passive: !0
    }), ke.addEventListener("touchend", ne, {
      passive: !0
    });
  }), U = h.useCallback(() => {
    const ue = qt(_.current);
    ue.removeEventListener("mousemove", ee), ue.removeEventListener("mouseup", ne), ue.removeEventListener("touchmove", ee), ue.removeEventListener("touchend", ne);
  }, [ne, ee]);
  h.useEffect(() => {
    const {
      current: ue
    } = _;
    return ue.addEventListener("touchstart", H, {
      passive: s1()
    }), () => {
      ue.removeEventListener("touchstart", H), U();
    };
  }, [U, H]), h.useEffect(() => {
    o && U();
  }, [o, U]);
  const X = (ue) => (de) => {
    var Me;
    if ((Me = ue.onMouseDown) == null || Me.call(ue, de), o || de.defaultPrevented || de.button !== 0)
      return;
    de.preventDefault();
    const Pe = hd(de, x);
    if (Pe !== !1) {
      const {
        newValue: be,
        activeIndex: me
      } = Q({
        finger: Pe
      });
      gd({
        sliderRef: _,
        activeIndex: me,
        setActive: T
      }), F(be), $ && !md(be, P) && $(de, be, me);
    }
    R.current = 0;
    const ke = qt(_.current);
    ke.addEventListener("mousemove", ee, {
      passive: !0
    }), ke.addEventListener("mouseup", ne);
  }, re = If(N ? A[0] : c, c, l), oe = If(A[A.length - 1], c, l) - re, le = (ue = {}) => {
    const de = Pi(ue), Pe = {
      onMouseDown: X(de || {})
    }, ke = {
      ...de,
      ...Pe
    };
    return {
      ...ue,
      ref: z,
      ...ke
    };
  }, se = (ue) => (de) => {
    var ke;
    (ke = ue.onMouseOver) == null || ke.call(ue, de);
    const Pe = Number(de.currentTarget.getAttribute("data-index"));
    O(Pe);
  }, Ce = (ue) => (de) => {
    var Pe;
    (Pe = ue.onMouseLeave) == null || Pe.call(ue, de), O(-1);
  };
  return {
    active: S,
    axis: Y,
    axisProps: EG,
    dragging: M,
    focusedThumbIndex: B,
    getHiddenInputProps: (ue = {}) => {
      const de = Pi(ue), Pe = {
        onChange: q(de || {}),
        onFocus: j(de || {}),
        onBlur: W(de || {}),
        onKeyDown: G(de || {})
      }, ke = {
        ...de,
        ...Pe
      };
      return {
        tabIndex: y,
        "aria-labelledby": t,
        "aria-orientation": p,
        "aria-valuemax": b(l),
        "aria-valuemin": b(c),
        name: u,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : e.step ?? void 0,
        disabled: o,
        ...ue,
        ...ke,
        style: {
          ...Pv,
          direction: i ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%"
        }
      };
    },
    getRootProps: le,
    getThumbProps: (ue = {}) => {
      const de = Pi(ue), Pe = {
        onMouseOver: se(de || {}),
        onMouseLeave: Ce(de || {})
      };
      return {
        ...ue,
        ...de,
        ...Pe
      };
    },
    marks: k,
    open: E,
    range: N,
    rootRef: z,
    trackLeap: oe,
    trackOffset: re,
    values: A,
    getThumbStyle: (ue) => ({
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: S !== -1 && S !== ue ? "none" : void 0
    })
  };
}
const PG = (e) => !e || !Yr(e);
function MG(e) {
  return De("MuiSlider", e);
}
const dr = Ne("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), kG = (e) => {
  const {
    open: t
  } = e;
  return {
    offset: ae(t && dr.valueLabelOpen),
    circle: dr.valueLabelCircle,
    label: dr.valueLabelLabel
  };
};
function xM(e) {
  const {
    children: t,
    className: n,
    value: o
  } = e, s = kG(e);
  return t ? /* @__PURE__ */ h.cloneElement(t, {
    className: ae(t.props.className)
  }, /* @__PURE__ */ ie(h.Fragment, {
    children: [t.props.children, /* @__PURE__ */ C("span", {
      className: ae(s.offset, n),
      "aria-hidden": !0,
      children: /* @__PURE__ */ C("span", {
        className: s.circle,
        children: /* @__PURE__ */ C("span", {
          className: s.label,
          children: o
        })
      })
    })]
  })) : null;
}
process.env.NODE_ENV !== "production" && (xM.propTypes = {
  children: r.element.isRequired,
  className: r.string,
  value: r.node
});
function i1(e) {
  return e;
}
const DG = te("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${ce(n.color)}`], n.size !== "medium" && t[`size${ce(n.size)}`], n.marked && t.marked, n.orientation === "vertical" && t.vertical, n.track === "inverted" && t.trackInverted, n.track === !1 && t.trackFalse];
  }
})(Fe(({
  theme: e
}) => ({
  borderRadius: 12,
  boxSizing: "content-box",
  display: "inline-block",
  position: "relative",
  cursor: "pointer",
  touchAction: "none",
  WebkitTapHighlightColor: "transparent",
  "@media print": {
    colorAdjust: "exact"
  },
  [`&.${dr.disabled}`]: {
    pointerEvents: "none",
    cursor: "default",
    color: (e.vars || e).palette.grey[400]
  },
  [`&.${dr.dragging}`]: {
    [`& .${dr.thumb}, & .${dr.track}`]: {
      transition: "none"
    }
  },
  variants: [...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (e.vars || e).palette[t].main
    }
  })), {
    props: {
      orientation: "horizontal"
    },
    style: {
      height: 4,
      width: "100%",
      padding: "13px 0",
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "20px 0"
      }
    }
  }, {
    props: {
      orientation: "horizontal",
      size: "small"
    },
    style: {
      height: 2
    }
  }, {
    props: {
      orientation: "horizontal",
      marked: !0
    },
    style: {
      marginBottom: 20
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: 4,
      padding: "0 13px",
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "0 20px"
      }
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      width: 2
    }
  }, {
    props: {
      orientation: "vertical",
      marked: !0
    },
    style: {
      marginRight: 44
    }
  }]
}))), NG = te("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, t) => t.rail
})({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38,
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "100%",
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: "inverted"
    },
    style: {
      opacity: 1
    }
  }]
}), $G = te("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(Fe(({
  theme: e
}) => ({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  border: "1px solid currentColor",
  backgroundColor: "currentColor",
  transition: e.transitions.create(["left", "width", "bottom", "height"], {
    duration: e.transitions.duration.shortest
  }),
  variants: [{
    props: {
      size: "small"
    },
    style: {
      border: "none"
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: !1
    },
    style: {
      display: "none"
    }
  }, ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t,
      track: "inverted"
    },
    style: {
      ...e.vars ? {
        backgroundColor: e.vars.palette.Slider[`${t}Track`],
        borderColor: e.vars.palette.Slider[`${t}Track`]
      } : {
        backgroundColor: wo(e.palette[t].main, 0.62),
        borderColor: wo(e.palette[t].main, 0.62),
        ...e.applyStyles("dark", {
          backgroundColor: $o(e.palette[t].main, 0.5)
        }),
        ...e.applyStyles("dark", {
          borderColor: $o(e.palette[t].main, 0.5)
        })
      }
    }
  }))]
}))), AG = te("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.thumb, t[`thumbColor${ce(n.color)}`], n.size !== "medium" && t[`thumbSize${ce(n.size)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  position: "absolute",
  width: 20,
  height: 20,
  boxSizing: "border-box",
  borderRadius: "50%",
  outline: 0,
  backgroundColor: "currentColor",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: e.transitions.create(["box-shadow", "left", "bottom"], {
    duration: e.transitions.duration.shortest
  }),
  "&::before": {
    position: "absolute",
    content: '""',
    borderRadius: "inherit",
    width: "100%",
    height: "100%",
    boxShadow: (e.vars || e).shadows[2]
  },
  "&::after": {
    position: "absolute",
    content: '""',
    borderRadius: "50%",
    // 42px is the hit target
    width: 42,
    height: 42,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  },
  [`&.${dr.disabled}`]: {
    "&:hover": {
      boxShadow: "none"
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      width: 12,
      height: 12,
      "&::before": {
        boxShadow: "none"
      }
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-50%, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 50%)"
    }
  }, ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&:hover, &.${dr.focusVisible}`]: {
        ...e.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${e.vars.palette[t].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${he(e.palette[t].main, 0.16)}`
        },
        "@media (hover: none)": {
          boxShadow: "none"
        }
      },
      [`&.${dr.active}`]: {
        ...e.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${e.vars.palette[t].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 14px ${he(e.palette[t].main, 0.16)}`
        }
      }
    }
  }))]
}))), TM = te(xM, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, t) => t.valueLabel
})(Fe(({
  theme: e
}) => ({
  zIndex: 1,
  whiteSpace: "nowrap",
  ...e.typography.body2,
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      transform: "translateY(-100%) scale(0)",
      top: "-10px",
      transformOrigin: "bottom center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, 50%) rotate(45deg)",
        backgroundColor: "inherit",
        bottom: 0,
        left: "50%"
      },
      [`&.${dr.valueLabelOpen}`]: {
        transform: "translateY(-100%) scale(1)"
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      transform: "translateY(-50%) scale(0)",
      right: "30px",
      top: "50%",
      transformOrigin: "right center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, -50%) rotate(45deg)",
        backgroundColor: "inherit",
        right: -8,
        top: "50%"
      },
      [`&.${dr.valueLabelOpen}`]: {
        transform: "translateY(-50%) scale(1)"
      }
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(12),
      padding: "0.25rem 0.5rem"
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      right: "20px"
    }
  }]
})));
process.env.NODE_ENV !== "production" && (TM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: r.element.isRequired,
  /**
   * @ignore
   */
  index: r.number.isRequired,
  /**
   * @ignore
   */
  open: r.bool.isRequired,
  /**
   * @ignore
   */
  value: r.node
});
const FG = te("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => bu(e) && e !== "markActive",
  overridesResolver: (e, t) => {
    const {
      markActive: n
    } = e;
    return [t.mark, n && t.markActive];
  }
})(Fe(({
  theme: e
}) => ({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-1px, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 1px)"
    }
  }, {
    props: {
      markActive: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.background.paper,
      opacity: 0.8
    }
  }]
}))), LG = te("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => bu(e) && e !== "markLabelActive",
  overridesResolver: (e, t) => t.markLabel
})(Fe(({
  theme: e
}) => ({
  ...e.typography.body2,
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: 30,
      transform: "translateX(-50%)",
      "@media (pointer: coarse)": {
        top: 40
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: 36,
      transform: "translateY(50%)",
      "@media (pointer: coarse)": {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: !0
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }]
}))), _G = (e) => {
  const {
    disabled: t,
    dragging: n,
    marked: o,
    orientation: s,
    track: i,
    classes: a,
    color: l,
    size: c
  } = e, u = {
    root: ["root", t && "disabled", n && "dragging", o && "marked", s === "vertical" && "vertical", i === "inverted" && "trackInverted", i === !1 && "trackFalse", l && `color${ce(l)}`, c && `size${ce(c)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", t && "disabled", c && `thumbSize${ce(c)}`, l && `thumbColor${ce(l)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return fe(u, MG, a);
}, VG = ({
  children: e
}) => e, RM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiSlider"
  }), s = _t(), {
    "aria-label": i,
    "aria-valuetext": a,
    "aria-labelledby": l,
    // eslint-disable-next-line react/prop-types
    component: c = "span",
    components: u = {},
    componentsProps: d = {},
    color: f = "primary",
    classes: p,
    className: m,
    disableSwap: b = !1,
    disabled: v = !1,
    getAriaLabel: g,
    getAriaValueText: y,
    marks: w = !1,
    max: x = 100,
    min: S = 0,
    name: T,
    onChange: E,
    onChangeCommitted: O,
    orientation: M = "horizontal",
    shiftStep: D = 10,
    size: R = "medium",
    step: P = 1,
    scale: F = i1,
    slotProps: $,
    slots: N,
    tabIndex: A,
    track: k = "normal",
    value: L,
    valueLabelDisplay: B = "off",
    valueLabelFormat: V = i1,
    ..._
  } = o, z = {
    ...o,
    isRtl: s,
    max: x,
    min: S,
    classes: p,
    disabled: v,
    disableSwap: b,
    orientation: M,
    marks: w,
    color: f,
    size: R,
    step: P,
    shiftStep: D,
    scale: F,
    track: k,
    valueLabelDisplay: B,
    valueLabelFormat: V
  }, {
    axisProps: j,
    getRootProps: W,
    getHiddenInputProps: J,
    getThumbProps: G,
    open: q,
    active: Z,
    axis: Y,
    focusedThumbIndex: Q,
    range: ee,
    dragging: ne,
    marks: H,
    values: U,
    trackOffset: X,
    trackLeap: re,
    getThumbStyle: oe
  } = OG({
    ...z,
    rootRef: n
  });
  z.marked = H.length > 0 && H.some((Ue) => Ue.label), z.dragging = ne, z.focusedThumbIndex = Q;
  const le = _G(z), se = (N == null ? void 0 : N.root) ?? u.Root ?? DG, Ce = (N == null ? void 0 : N.rail) ?? u.Rail ?? NG, $e = (N == null ? void 0 : N.track) ?? u.Track ?? $G, we = (N == null ? void 0 : N.thumb) ?? u.Thumb ?? AG, Te = (N == null ? void 0 : N.valueLabel) ?? u.ValueLabel ?? TM, ue = (N == null ? void 0 : N.mark) ?? u.Mark ?? FG, de = (N == null ? void 0 : N.markLabel) ?? u.MarkLabel ?? LG, Pe = (N == null ? void 0 : N.input) ?? u.Input ?? "input", ke = ($ == null ? void 0 : $.root) ?? d.root, Me = ($ == null ? void 0 : $.rail) ?? d.rail, be = ($ == null ? void 0 : $.track) ?? d.track, me = ($ == null ? void 0 : $.thumb) ?? d.thumb, Ae = ($ == null ? void 0 : $.valueLabel) ?? d.valueLabel, ye = ($ == null ? void 0 : $.mark) ?? d.mark, We = ($ == null ? void 0 : $.markLabel) ?? d.markLabel, He = ($ == null ? void 0 : $.input) ?? d.input, ze = et({
    elementType: se,
    getSlotProps: W,
    externalSlotProps: ke,
    externalForwardedProps: _,
    additionalProps: {
      ...PG(se) && {
        as: c
      }
    },
    ownerState: {
      ...z,
      ...ke == null ? void 0 : ke.ownerState
    },
    className: [le.root, m]
  }), pe = et({
    elementType: Ce,
    externalSlotProps: Me,
    ownerState: z,
    className: le.rail
  }), Re = et({
    elementType: $e,
    externalSlotProps: be,
    additionalProps: {
      style: {
        ...j[Y].offset(X),
        ...j[Y].leap(re)
      }
    },
    ownerState: {
      ...z,
      ...be == null ? void 0 : be.ownerState
    },
    className: le.track
  }), Ge = et({
    elementType: we,
    getSlotProps: G,
    externalSlotProps: me,
    ownerState: {
      ...z,
      ...me == null ? void 0 : me.ownerState
    },
    className: le.thumb
  }), Qe = et({
    elementType: Te,
    externalSlotProps: Ae,
    ownerState: {
      ...z,
      ...Ae == null ? void 0 : Ae.ownerState
    },
    className: le.valueLabel
  }), qe = et({
    elementType: ue,
    externalSlotProps: ye,
    ownerState: z,
    className: le.mark
  }), st = et({
    elementType: de,
    externalSlotProps: We,
    ownerState: z,
    className: le.markLabel
  }), wt = et({
    elementType: Pe,
    getSlotProps: J,
    externalSlotProps: He,
    ownerState: z
  });
  return /* @__PURE__ */ ie(se, {
    ...ze,
    children: [/* @__PURE__ */ C(Ce, {
      ...pe
    }), /* @__PURE__ */ C($e, {
      ...Re
    }), H.filter((Ue) => Ue.value >= S && Ue.value <= x).map((Ue, nt) => {
      const ft = If(Ue.value, S, x), nn = j[Y].offset(ft);
      let St;
      return k === !1 ? St = U.includes(Ue.value) : St = k === "normal" && (ee ? Ue.value >= U[0] && Ue.value <= U[U.length - 1] : Ue.value <= U[0]) || k === "inverted" && (ee ? Ue.value <= U[0] || Ue.value >= U[U.length - 1] : Ue.value >= U[0]), /* @__PURE__ */ ie(h.Fragment, {
        children: [/* @__PURE__ */ C(ue, {
          "data-index": nt,
          ...qe,
          ...!Yr(ue) && {
            markActive: St
          },
          style: {
            ...nn,
            ...qe.style
          },
          className: ae(qe.className, St && le.markActive)
        }), Ue.label != null ? /* @__PURE__ */ C(de, {
          "aria-hidden": !0,
          "data-index": nt,
          ...st,
          ...!Yr(de) && {
            markLabelActive: St
          },
          style: {
            ...nn,
            ...st.style
          },
          className: ae(le.markLabel, st.className, St && le.markLabelActive),
          children: Ue.label
        }) : null]
      }, nt);
    }), U.map((Ue, nt) => {
      const ft = If(Ue, S, x), nn = j[Y].offset(ft), St = B === "off" ? VG : Te;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ C(St, {
          ...!Yr(St) && {
            valueLabelFormat: V,
            valueLabelDisplay: B,
            value: typeof V == "function" ? V(F(Ue), nt) : V,
            index: nt,
            open: q === nt || Z === nt || B === "on",
            disabled: v
          },
          ...Qe,
          children: /* @__PURE__ */ C(we, {
            "data-index": nt,
            ...Ge,
            className: ae(le.thumb, Ge.className, Z === nt && le.active, Q === nt && le.focusVisible),
            style: {
              ...nn,
              ...oe(nt),
              ...Ge.style
            },
            children: /* @__PURE__ */ C(Pe, {
              "data-index": nt,
              "aria-label": g ? g(nt) : i,
              "aria-valuenow": F(Ue),
              "aria-labelledby": l,
              "aria-valuetext": y ? y(F(Ue), nt) : a,
              value: U[nt],
              ...wt
            })
          })
        }, nt)
      );
    })]
  });
});
process.env.NODE_ENV !== "production" && (RM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The label of the slider.
   */
  "aria-label": Gn(r.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": r.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": Gn(r.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: r.shape({
    Input: r.elementType,
    Mark: r.elementType,
    MarkLabel: r.elementType,
    Rail: r.elementType,
    Root: r.elementType,
    Thumb: r.elementType,
    Track: r.elementType,
    ValueLabel: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: r.shape({
    input: r.oneOfType([r.func, r.object]),
    mark: r.oneOfType([r.func, r.object]),
    markLabel: r.oneOfType([r.func, r.object]),
    rail: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object]),
    thumb: r.oneOfType([r.func, r.object]),
    track: r.oneOfType([r.func, r.object]),
    valueLabel: r.oneOfType([r.func, r.shape({
      children: r.element,
      className: r.string,
      open: r.bool,
      style: r.object,
      value: r.node,
      valueLabelDisplay: r.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.oneOfType([r.arrayOf(r.number), r.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: r.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: r.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: r.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: r.oneOfType([r.arrayOf(r.shape({
    label: r.node,
    value: r.number.isRequired
  })), r.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: r.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: r.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: r.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: r.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: r.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: r.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: r.func,
  /**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */
  shiftStep: r.number,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["small", "medium"]), r.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: r.shape({
    input: r.oneOfType([r.func, r.object]),
    mark: r.oneOfType([r.func, r.object]),
    markLabel: r.oneOfType([r.func, r.object]),
    rail: r.oneOfType([r.func, r.object]),
    root: r.oneOfType([r.func, r.object]),
    thumb: r.oneOfType([r.func, r.object]),
    track: r.oneOfType([r.func, r.object]),
    valueLabel: r.oneOfType([r.func, r.shape({
      children: r.element,
      className: r.string,
      open: r.bool,
      style: r.object,
      value: r.node,
      valueLabelDisplay: r.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    input: r.elementType,
    mark: r.elementType,
    markLabel: r.elementType,
    rail: r.elementType,
    root: r.elementType,
    thumb: r.elementType,
    track: r.elementType,
    valueLabel: r.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: r.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: r.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: r.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: r.oneOfType([r.arrayOf(r.number), r.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: r.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: r.oneOfType([r.func, r.string])
});
function BG(e = {}) {
  const {
    autoHideDuration: t = null,
    disableWindowBlurListener: n = !1,
    onClose: o,
    open: s,
    resumeHideDuration: i
  } = e, a = go();
  h.useEffect(() => {
    if (!s)
      return;
    function y(w) {
      w.defaultPrevented || w.key === "Escape" && (o == null || o(w, "escapeKeyDown"));
    }
    return document.addEventListener("keydown", y), () => {
      document.removeEventListener("keydown", y);
    };
  }, [s, o]);
  const l = xe((y, w) => {
    o == null || o(y, w);
  }), c = xe((y) => {
    !o || y == null || a.start(y, () => {
      l(null, "timeout");
    });
  });
  h.useEffect(() => (s && c(t), a.clear), [s, t, c, a]);
  const u = (y) => {
    o == null || o(y, "clickaway");
  }, d = a.clear, f = h.useCallback(() => {
    t != null && c(i ?? t * 0.5);
  }, [t, i, c]), p = (y) => (w) => {
    const x = y.onBlur;
    x == null || x(w), f();
  }, m = (y) => (w) => {
    const x = y.onFocus;
    x == null || x(w), d();
  }, b = (y) => (w) => {
    const x = y.onMouseEnter;
    x == null || x(w), d();
  }, v = (y) => (w) => {
    const x = y.onMouseLeave;
    x == null || x(w), f();
  };
  return h.useEffect(() => {
    if (!n && s)
      return window.addEventListener("focus", f), window.addEventListener("blur", d), () => {
        window.removeEventListener("focus", f), window.removeEventListener("blur", d);
      };
  }, [n, s, f, d]), {
    getRootProps: (y = {}) => {
      const w = {
        ...Pi(e),
        ...Pi(y)
      };
      return {
        // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
        // See https://github.com/mui/material-ui/issues/29080
        role: "presentation",
        ...y,
        ...w,
        onBlur: p(w),
        onFocus: m(w),
        onMouseEnter: b(w),
        onMouseLeave: v(w)
      };
    },
    onClickAway: u
  };
}
function zG(e) {
  return De("MuiSnackbarContent", e);
}
Ne("MuiSnackbarContent", ["root", "message", "action"]);
const HG = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    action: ["action"],
    message: ["message"]
  }, zG, t);
}, jG = te(ao, {
  name: "MuiSnackbarContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(Fe(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? 0.8 : 0.98, n = vf(e.palette.background.default, t);
  return {
    ...e.typography.body2,
    color: e.vars ? e.vars.palette.SnackbarContent.color : e.palette.getContrastText(n),
    backgroundColor: e.vars ? e.vars.palette.SnackbarContent.bg : n,
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    flexGrow: 1,
    [e.breakpoints.up("sm")]: {
      flexGrow: "initial",
      minWidth: 288
    }
  };
})), GG = te("div", {
  name: "MuiSnackbarContent",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0"
}), qG = te("div", {
  name: "MuiSnackbarContent",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "center",
  marginLeft: "auto",
  paddingLeft: 16,
  marginRight: -8
}), EM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiSnackbarContent"
  }), {
    action: s,
    className: i,
    message: a,
    role: l = "alert",
    ...c
  } = o, u = o, d = HG(u);
  return /* @__PURE__ */ ie(jG, {
    role: l,
    square: !0,
    elevation: 6,
    className: ae(d.root, i),
    ownerState: u,
    ref: n,
    ...c,
    children: [/* @__PURE__ */ C(GG, {
      className: d.message,
      ownerState: u,
      children: a
    }), s ? /* @__PURE__ */ C(qG, {
      className: d.action,
      ownerState: u,
      children: s
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (EM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The message to display.
   */
  message: r.node,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: r.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function WG(e) {
  return De("MuiSnackbar", e);
}
Ne("MuiSnackbar", ["root", "anchorOriginTopCenter", "anchorOriginBottomCenter", "anchorOriginTopRight", "anchorOriginBottomRight", "anchorOriginTopLeft", "anchorOriginBottomLeft"]);
const UG = (e) => {
  const {
    classes: t,
    anchorOrigin: n
  } = e, o = {
    root: ["root", `anchorOrigin${ce(n.vertical)}${ce(n.horizontal)}`]
  };
  return fe(o, WG, t);
}, a1 = te("div", {
  name: "MuiSnackbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`anchorOrigin${ce(n.anchorOrigin.vertical)}${ce(n.anchorOrigin.horizontal)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.snackbar,
  position: "fixed",
  display: "flex",
  left: 8,
  right: 8,
  justifyContent: "center",
  alignItems: "center",
  variants: [{
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical === "top",
    style: {
      top: 8,
      [e.breakpoints.up("sm")]: {
        top: 24
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.vertical !== "top",
    style: {
      bottom: 8,
      [e.breakpoints.up("sm")]: {
        bottom: 24
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.horizontal === "left",
    style: {
      justifyContent: "flex-start",
      [e.breakpoints.up("sm")]: {
        left: 24,
        right: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.horizontal === "right",
    style: {
      justifyContent: "flex-end",
      [e.breakpoints.up("sm")]: {
        right: 24,
        left: "auto"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.anchorOrigin.horizontal === "center",
    style: {
      [e.breakpoints.up("sm")]: {
        left: "50%",
        right: "auto",
        transform: "translateX(-50%)"
      }
    }
  }]
}))), IM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiSnackbar"
  }), s = sn(), i = {
    enter: s.transitions.duration.enteringScreen,
    exit: s.transitions.duration.leavingScreen
  }, {
    action: a,
    anchorOrigin: {
      vertical: l,
      horizontal: c
    } = {
      vertical: "bottom",
      horizontal: "left"
    },
    autoHideDuration: u = null,
    children: d,
    className: f,
    ClickAwayListenerProps: p,
    ContentProps: m,
    disableWindowBlurListener: b = !1,
    message: v,
    onBlur: g,
    onClose: y,
    onFocus: w,
    onMouseEnter: x,
    onMouseLeave: S,
    open: T,
    resumeHideDuration: E,
    TransitionComponent: O = vs,
    transitionDuration: M = i,
    TransitionProps: {
      onEnter: D,
      onExited: R,
      ...P
    } = {},
    ...F
  } = o, $ = {
    ...o,
    anchorOrigin: {
      vertical: l,
      horizontal: c
    },
    autoHideDuration: u,
    disableWindowBlurListener: b,
    TransitionComponent: O,
    transitionDuration: M
  }, N = UG($), {
    getRootProps: A,
    onClickAway: k
  } = BG({
    ...$
  }), [L, B] = h.useState(!0), V = et({
    elementType: a1,
    getSlotProps: A,
    externalForwardedProps: F,
    ownerState: $,
    additionalProps: {
      ref: n
    },
    className: [N.root, f]
  }), _ = (j) => {
    B(!0), R && R(j);
  }, z = (j, W) => {
    B(!1), D && D(j, W);
  };
  return !T && L ? null : /* @__PURE__ */ C(tl, {
    onClickAway: k,
    ...p,
    children: /* @__PURE__ */ C(a1, {
      ...V,
      children: /* @__PURE__ */ C(O, {
        appear: !0,
        in: T,
        timeout: M,
        direction: l === "top" ? "down" : "up",
        onEnter: z,
        onExited: _,
        ...P,
        children: d || /* @__PURE__ */ C(EM, {
          message: v,
          action: a,
          ...m
        })
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (IM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the snackbar.
   */
  action: r.node,
  /**
   * The anchor of the `Snackbar`.
   * On smaller screens, the component grows to occupy all the available width,
   * the horizontal alignment is ignored.
   * @default { vertical: 'bottom', horizontal: 'left' }
   */
  anchorOrigin: r.shape({
    horizontal: r.oneOf(["center", "left", "right"]).isRequired,
    vertical: r.oneOf(["bottom", "top"]).isRequired
  }),
  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   * @default null
   */
  autoHideDuration: r.number,
  /**
   * Replace the `SnackbarContent` component.
   */
  children: r.element,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * Props applied to the `ClickAwayListener` element.
   */
  ClickAwayListenerProps: r.object,
  /**
   * Props applied to the [`SnackbarContent`](https://mui.com/material-ui/api/snackbar-content/) element.
   */
  ContentProps: r.object,
  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   * @default false
   */
  disableWindowBlurListener: r.bool,
  /**
   * When displaying multiple consecutive snackbars using a single parent-rendered
   * `<Snackbar/>`, add the `key` prop to ensure independent treatment of each message.
   * For instance, use `<Snackbar key={message} />`. Otherwise, messages might update
   * in place, and features like `autoHideDuration` could be affected.
   */
  key: () => null,
  /**
   * The message to display.
   */
  message: r.node,
  /**
   * @ignore
   */
  onBlur: r.func,
  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {React.SyntheticEvent<any> | Event} event The event source of the callback.
   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`, or `"escapeKeyDown"`.
   */
  onClose: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * @ignore
   */
  onMouseEnter: r.func,
  /**
   * @ignore
   */
  onMouseLeave: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool,
  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: r.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: r.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: r.oneOfType([r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: r.object
});
const KG = {
  entering: {
    transform: "none"
  },
  entered: {
    transform: "none"
  }
}, OM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = sn(), s = {
    enter: o.transitions.duration.enteringScreen,
    exit: o.transitions.duration.leavingScreen
  }, {
    addEndListener: i,
    appear: a = !0,
    children: l,
    easing: c,
    in: u,
    onEnter: d,
    onEntered: f,
    onEntering: p,
    onExit: m,
    onExited: b,
    onExiting: v,
    style: g,
    timeout: y = s,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: w = So,
    ...x
  } = t, S = h.useRef(null), T = tt(S, Rs(l), n), E = (N) => (A) => {
    if (N) {
      const k = S.current;
      A === void 0 ? N(k) : N(k, A);
    }
  }, O = E(p), M = E((N, A) => {
    Ep(N);
    const k = Jr({
      style: g,
      timeout: y,
      easing: c
    }, {
      mode: "enter"
    });
    N.style.webkitTransition = o.transitions.create("transform", k), N.style.transition = o.transitions.create("transform", k), d && d(N, A);
  }), D = E(f), R = E(v), P = E((N) => {
    const A = Jr({
      style: g,
      timeout: y,
      easing: c
    }, {
      mode: "exit"
    });
    N.style.webkitTransition = o.transitions.create("transform", A), N.style.transition = o.transitions.create("transform", A), m && m(N);
  }), F = E(b);
  return /* @__PURE__ */ C(w, {
    appear: a,
    in: u,
    nodeRef: S,
    onEnter: M,
    onEntered: D,
    onEntering: O,
    onExit: P,
    onExited: F,
    onExiting: R,
    addEndListener: (N) => {
      i && i(S.current, N);
    },
    timeout: y,
    ...x,
    children: (N, A) => /* @__PURE__ */ h.cloneElement(l, {
      style: {
        transform: "scale(0)",
        visibility: N === "exited" && !u ? "hidden" : void 0,
        ...KG[N],
        ...g,
        ...l.props.style
      },
      ref: T,
      ...A
    })
  });
});
process.env.NODE_ENV !== "production" && (OM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: r.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: r.bool,
  /**
   * A single child content element.
   */
  children: Ts.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: r.oneOfType([r.shape({
    enter: r.string,
    exit: r.string
  }), r.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: r.bool,
  /**
   * @ignore
   */
  onEnter: r.func,
  /**
   * @ignore
   */
  onEntered: r.func,
  /**
   * @ignore
   */
  onEntering: r.func,
  /**
   * @ignore
   */
  onExit: r.func,
  /**
   * @ignore
   */
  onExited: r.func,
  /**
   * @ignore
   */
  onExiting: r.func,
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: r.oneOfType([r.number, r.shape({
    appear: r.number,
    enter: r.number,
    exit: r.number
  })])
});
function YG(e) {
  return De("MuiTooltip", e);
}
const On = Ne("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
function XG(e) {
  return Math.round(e * 1e5) / 1e5;
}
const QG = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: o,
    touch: s,
    placement: i
  } = e, a = {
    popper: ["popper", !n && "popperInteractive", o && "popperArrow"],
    tooltip: ["tooltip", o && "tooltipArrow", s && "touch", `tooltipPlacement${ce(i.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return fe(a, YG, t);
}, ZG = te(is, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(Fe(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableInteractive,
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: ({
      open: t
    }) => !t,
    style: {
      pointerEvents: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      [`&[data-popper-placement*="bottom"] .${On.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${On.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${On.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${On.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${On.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${On.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${On.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.arrow && !!t.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${On.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
}))), JG = te("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${ce(n.placement.split("-")[0])}`]];
  }
})(Fe(({
  theme: e
}) => ({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : he(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium,
  [`.${On.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${On.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${On.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${On.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.arrow,
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      padding: "8px 16px",
      fontSize: e.typography.pxToRem(14),
      lineHeight: `${XG(16 / 14)}em`,
      fontWeight: e.typography.fontWeightRegular
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl,
    style: {
      [`.${On.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${On.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !t.isRtl && t.touch,
    style: {
      [`.${On.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${On.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl,
    style: {
      [`.${On.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${On.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => !!t.isRtl && t.touch,
    style: {
      [`.${On.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${On.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${On.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.touch,
    style: {
      [`.${On.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
}))), e9 = te("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(Fe(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : he(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let yd = !1;
const l1 = new xp();
let jl = {
  x: 0,
  y: 0
};
function vd(e, t) {
  return (n, ...o) => {
    t && t(n, ...o), e(n, ...o);
  };
}
const Vp = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: s = !1,
    children: i,
    classes: a,
    components: l = {},
    componentsProps: c = {},
    describeChild: u = !1,
    disableFocusListener: d = !1,
    disableHoverListener: f = !1,
    disableInteractive: p = !1,
    disableTouchListener: m = !1,
    enterDelay: b = 100,
    enterNextDelay: v = 0,
    enterTouchDelay: g = 700,
    followCursor: y = !1,
    id: w,
    leaveDelay: x = 0,
    leaveTouchDelay: S = 1500,
    onClose: T,
    onOpen: E,
    open: O,
    placement: M = "bottom",
    PopperComponent: D,
    PopperProps: R = {},
    slotProps: P = {},
    slots: F = {},
    title: $,
    TransitionComponent: N,
    TransitionProps: A,
    ...k
  } = o, L = /* @__PURE__ */ h.isValidElement(i) ? i : /* @__PURE__ */ C("span", {
    children: i
  }), B = sn(), V = _t(), [_, z] = h.useState(), [j, W] = h.useState(null), J = h.useRef(!1), G = p || y, q = go(), Z = go(), Y = go(), Q = go(), [ee, ne] = jn({
    controlled: O,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let H = ee;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: Ke
    } = h.useRef(O !== void 0);
    h.useEffect(() => {
      _ && _.disabled && !Ke && $ !== "" && _.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [$, _, Ke]);
  }
  const U = gt(w), X = h.useRef(), re = xe(() => {
    X.current !== void 0 && (document.body.style.WebkitUserSelect = X.current, X.current = void 0), Q.clear();
  });
  h.useEffect(() => re, [re]);
  const oe = (Ke) => {
    l1.clear(), yd = !0, ne(!0), E && !H && E(Ke);
  }, le = xe(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (Ke) => {
      l1.start(800 + x, () => {
        yd = !1;
      }), ne(!1), T && H && T(Ke), q.start(B.transitions.duration.shortest, () => {
        J.current = !1;
      });
    }
  ), se = (Ke) => {
    J.current && Ke.type !== "touchstart" || (_ && _.removeAttribute("title"), Z.clear(), Y.clear(), b || yd && v ? Z.start(yd ? v : b, () => {
      oe(Ke);
    }) : oe(Ke));
  }, Ce = (Ke) => {
    Z.clear(), Y.start(x, () => {
      le(Ke);
    });
  }, [, $e] = h.useState(!1), we = (Ke) => {
    Ws(Ke.target) || ($e(!1), Ce(Ke));
  }, Te = (Ke) => {
    _ || z(Ke.currentTarget), Ws(Ke.target) && ($e(!0), se(Ke));
  }, ue = (Ke) => {
    J.current = !0;
    const Ot = L.props;
    Ot.onTouchStart && Ot.onTouchStart(Ke);
  }, de = (Ke) => {
    ue(Ke), Y.clear(), q.clear(), re(), X.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Q.start(g, () => {
      document.body.style.WebkitUserSelect = X.current, se(Ke);
    });
  }, Pe = (Ke) => {
    L.props.onTouchEnd && L.props.onTouchEnd(Ke), re(), Y.start(S, () => {
      le(Ke);
    });
  };
  h.useEffect(() => {
    if (!H)
      return;
    function Ke(Ot) {
      Ot.key === "Escape" && le(Ot);
    }
    return document.addEventListener("keydown", Ke), () => {
      document.removeEventListener("keydown", Ke);
    };
  }, [le, H]);
  const ke = tt(Rs(L), z, n);
  !$ && $ !== 0 && (H = !1);
  const Me = h.useRef(), be = (Ke) => {
    const Ot = L.props;
    Ot.onMouseMove && Ot.onMouseMove(Ke), jl = {
      x: Ke.clientX,
      y: Ke.clientY
    }, Me.current && Me.current.update();
  }, me = {}, Ae = typeof $ == "string";
  u ? (me.title = !H && Ae && !f ? $ : null, me["aria-describedby"] = H ? U : null) : (me["aria-label"] = Ae ? $ : null, me["aria-labelledby"] = H && !Ae ? U : null);
  const ye = {
    ...me,
    ...k,
    ...L.props,
    className: ae(k.className, L.props.className),
    onTouchStart: ue,
    ref: ke,
    ...y ? {
      onMouseMove: be
    } : {}
  };
  process.env.NODE_ENV !== "production" && (ye["data-mui-internal-clone-element"] = !0, h.useEffect(() => {
    _ && !_.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [_]));
  const We = {};
  m || (ye.onTouchStart = de, ye.onTouchEnd = Pe), f || (ye.onMouseOver = vd(se, ye.onMouseOver), ye.onMouseLeave = vd(Ce, ye.onMouseLeave), G || (We.onMouseOver = se, We.onMouseLeave = Ce)), d || (ye.onFocus = vd(Te, ye.onFocus), ye.onBlur = vd(we, ye.onBlur), G || (We.onFocus = Te, We.onBlur = we)), process.env.NODE_ENV !== "production" && L.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${L.props.title}\` or the Tooltip component.`].join(`
`));
  const He = {
    ...o,
    isRtl: V,
    arrow: s,
    disableInteractive: G,
    placement: M,
    PopperComponentProp: D,
    touch: J.current
  }, ze = typeof P.popper == "function" ? P.popper(He) : P.popper, pe = h.useMemo(() => {
    var Ot, vn;
    let Ke = [{
      name: "arrow",
      enabled: !!j,
      options: {
        element: j,
        padding: 4
      }
    }];
    return (Ot = R.popperOptions) != null && Ot.modifiers && (Ke = Ke.concat(R.popperOptions.modifiers)), (vn = ze == null ? void 0 : ze.popperOptions) != null && vn.modifiers && (Ke = Ke.concat(ze.popperOptions.modifiers)), {
      ...R.popperOptions,
      ...ze == null ? void 0 : ze.popperOptions,
      modifiers: Ke
    };
  }, [j, R.popperOptions, ze == null ? void 0 : ze.popperOptions]), Re = QG(He), Ge = typeof P.transition == "function" ? P.transition(He) : P.transition, Qe = {
    slots: {
      popper: l.Popper,
      transition: l.Transition ?? N,
      tooltip: l.Tooltip,
      arrow: l.Arrow,
      ...F
    },
    slotProps: {
      arrow: P.arrow ?? c.arrow,
      popper: {
        ...R,
        ...ze ?? c.popper
      },
      // resolvedPopperProps can be spread because it's already an object
      tooltip: P.tooltip ?? c.tooltip,
      transition: {
        ...A,
        ...Ge ?? c.transition
      }
    }
  }, [qe, st] = bn("popper", {
    elementType: ZG,
    externalForwardedProps: Qe,
    ownerState: He,
    className: ae(Re.popper, R == null ? void 0 : R.className)
  }), [wt, Ue] = bn("transition", {
    elementType: vs,
    externalForwardedProps: Qe,
    ownerState: He
  }), [nt, ft] = bn("tooltip", {
    elementType: JG,
    className: Re.tooltip,
    externalForwardedProps: Qe,
    ownerState: He
  }), [nn, St] = bn("arrow", {
    elementType: e9,
    className: Re.arrow,
    externalForwardedProps: Qe,
    ownerState: He,
    ref: W
  });
  return /* @__PURE__ */ ie(h.Fragment, {
    children: [/* @__PURE__ */ h.cloneElement(L, ye), /* @__PURE__ */ C(qe, {
      as: D ?? is,
      placement: M,
      anchorEl: y ? {
        getBoundingClientRect: () => ({
          top: jl.y,
          left: jl.x,
          right: jl.x,
          bottom: jl.y,
          width: 0,
          height: 0
        })
      } : _,
      popperRef: Me,
      open: _ ? H : !1,
      id: U,
      transition: !0,
      ...We,
      ...st,
      popperOptions: pe,
      children: ({
        TransitionProps: Ke
      }) => /* @__PURE__ */ C(wt, {
        timeout: B.transitions.duration.shorter,
        ...Ke,
        ...Ue,
        children: /* @__PURE__ */ ie(nt, {
          ...ft,
          children: [$, s ? /* @__PURE__ */ C(nn, {
            ...St
          }) : null]
        })
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (Vp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: r.bool,
  /**
   * Tooltip reference element.
   */
  children: Ts.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: r.shape({
    Arrow: r.elementType,
    Popper: r.elementType,
    Tooltip: r.elementType,
    Transition: r.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: r.shape({
    arrow: r.object,
    popper: r.object,
    tooltip: r.object,
    transition: r.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: r.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: r.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: r.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: r.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: r.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: r.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: r.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: r.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: r.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: r.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: r.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: r.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: r.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: r.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: r.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: r.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    arrow: r.oneOfType([r.func, r.object]),
    popper: r.oneOfType([r.func, r.object]),
    tooltip: r.oneOfType([r.func, r.object]),
    transition: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    arrow: r.elementType,
    popper: r.elementType,
    tooltip: r.elementType,
    transition: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: r.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: r.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: r.object
});
const yC = FV({
  createStyledComponent: te("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => Be({
    props: e,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (yC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: r.oneOfType([r.oneOf(["column-reverse", "column", "row-reverse", "row"]), r.arrayOf(r.oneOf(["column-reverse", "column", "row-reverse", "row"])), r.object]),
  /**
   * Add an element between each child.
   */
  divider: r.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: r.bool
});
function t9(e) {
  return De("MuiSwitch", e);
}
const co = Ne("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), n9 = (e) => {
  const {
    classes: t,
    edge: n,
    size: o,
    color: s,
    checked: i,
    disabled: a
  } = e, l = {
    root: ["root", n && `edge${ce(n)}`, `size${ce(o)}`],
    switchBase: ["switchBase", `color${ce(s)}`, i && "checked", a && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, c = fe(l, t9, t);
  return {
    ...t,
    // forward the disabled and checked classes to the SwitchBase
    ...c
  };
}, o9 = te("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.edge && t[`edge${ce(n.edge)}`], t[`size${ce(n.size)}`]];
  }
})({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${co.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${co.switchBase}`]: {
        padding: 4,
        [`&.${co.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
}), r9 = te(Ap, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.switchBase, {
      [`& .${co.input}`]: t.input
    }, n.color !== "default" && t[`color${ce(n.color)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: e.vars ? e.vars.palette.Switch.defaultColor : `${e.palette.mode === "light" ? e.palette.common.white : e.palette.grey[300]}`,
  transition: e.transitions.create(["left", "transform"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${co.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${co.disabled}`]: {
    color: e.vars ? e.vars.palette.Switch.defaultDisabledColor : `${e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[600]}`
  },
  [`&.${co.checked} + .${co.track}`]: {
    opacity: 0.5
  },
  [`&.${co.disabled} + .${co.track}`]: {
    opacity: e.vars ? e.vars.opacity.switchTrackDisabled : `${e.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${co.input}`]: {
    left: "-100%",
    width: "300%"
  }
})), Fe(({
  theme: e
}) => ({
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(e.palette).filter($t(["light"])).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${co.checked}`]: {
        color: (e.vars || e).palette[t].main,
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette[t].main, e.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${co.disabled}`]: {
          color: e.vars ? e.vars.palette.Switch[`${t}DisabledColor`] : `${e.palette.mode === "light" ? wo(e.palette[t].main, 0.62) : $o(e.palette[t].main, 0.55)}`
        }
      },
      [`&.${co.checked} + .${co.track}`]: {
        backgroundColor: (e.vars || e).palette[t].main
      }
    }
  }))]
}))), s9 = te("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(Fe(({
  theme: e
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: e.transitions.create(["opacity", "background-color"], {
    duration: e.transitions.duration.shortest
  }),
  backgroundColor: e.vars ? e.vars.palette.common.onBackground : `${e.palette.mode === "light" ? e.palette.common.black : e.palette.common.white}`,
  opacity: e.vars ? e.vars.opacity.switchTrack : `${e.palette.mode === "light" ? 0.38 : 0.3}`
}))), i9 = te("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(Fe(({
  theme: e
}) => ({
  boxShadow: (e.vars || e).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
}))), vC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiSwitch"
  }), {
    className: s,
    color: i = "primary",
    edge: a = !1,
    size: l = "medium",
    sx: c,
    ...u
  } = o, d = {
    ...o,
    color: i,
    edge: a,
    size: l
  }, f = n9(d), p = /* @__PURE__ */ C(i9, {
    className: f.thumb,
    ownerState: d
  });
  return /* @__PURE__ */ ie(o9, {
    className: ae(f.root, s),
    sx: c,
    ownerState: d,
    children: [/* @__PURE__ */ C(r9, {
      type: "checkbox",
      icon: p,
      checkedIcon: p,
      ref: n,
      ownerState: d,
      ...u,
      classes: {
        ...f,
        root: f.switchBase
      }
    }), /* @__PURE__ */ C(s9, {
      className: f.track,
      ownerState: d
    })]
  });
});
process.env.NODE_ENV !== "production" && (vC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: r.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: r.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: r.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: r.node,
  /**
   * The id of the `input` element.
   */
  id: r.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: r.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: r.any
});
function a9(e) {
  return De("MuiTab", e);
}
const nr = Ne("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper", "icon"]), l9 = (e) => {
  const {
    classes: t,
    textColor: n,
    fullWidth: o,
    wrapped: s,
    icon: i,
    label: a,
    selected: l,
    disabled: c
  } = e, u = {
    root: ["root", i && a && "labelIcon", `textColor${ce(n)}`, o && "fullWidth", s && "wrapped", l && "selected", c && "disabled"],
    icon: ["iconWrapper", "icon"]
  };
  return fe(u, a9, t);
}, c9 = te(Yn, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.label && n.icon && t.labelIcon, t[`textColor${ce(n.textColor)}`], n.fullWidth && t.fullWidth, n.wrapped && t.wrapped, {
      [`& .${nr.iconWrapper}`]: t.iconWrapper
    }, {
      [`& .${nr.icon}`]: t.icon
    }];
  }
})(Fe(({
  theme: e
}) => ({
  ...e.typography.button,
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center",
  lineHeight: 1.25,
  variants: [{
    props: ({
      ownerState: t
    }) => t.label && (t.iconPosition === "top" || t.iconPosition === "bottom"),
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.label && t.iconPosition !== "top" && t.iconPosition !== "bottom",
    style: {
      flexDirection: "row"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.icon && t.label,
    style: {
      minHeight: 72,
      paddingTop: 9,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "top",
    style: {
      [`& > .${nr.icon}`]: {
        marginBottom: 6
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "bottom",
    style: {
      [`& > .${nr.icon}`]: {
        marginTop: 6
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "start",
    style: {
      [`& > .${nr.icon}`]: {
        marginRight: e.spacing(1)
      }
    }
  }, {
    props: ({
      ownerState: t,
      iconPosition: n
    }) => t.icon && t.label && n === "end",
    style: {
      [`& > .${nr.icon}`]: {
        marginLeft: e.spacing(1)
      }
    }
  }, {
    props: {
      textColor: "inherit"
    },
    style: {
      color: "inherit",
      opacity: 0.6,
      // same opacity as theme.palette.text.secondary
      [`&.${nr.selected}`]: {
        opacity: 1
      },
      [`&.${nr.disabled}`]: {
        opacity: (e.vars || e).palette.action.disabledOpacity
      }
    }
  }, {
    props: {
      textColor: "primary"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      [`&.${nr.selected}`]: {
        color: (e.vars || e).palette.primary.main
      },
      [`&.${nr.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      }
    }
  }, {
    props: {
      textColor: "secondary"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      [`&.${nr.selected}`]: {
        color: (e.vars || e).palette.secondary.main
      },
      [`&.${nr.disabled}`]: {
        color: (e.vars || e).palette.text.disabled
      }
    }
  }, {
    props: ({
      ownerState: t
    }) => t.fullWidth,
    style: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: "none"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.wrapped,
    style: {
      fontSize: e.typography.pxToRem(12)
    }
  }]
}))), CC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTab"
  }), {
    className: s,
    disabled: i = !1,
    disableFocusRipple: a = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: l,
    icon: c,
    iconPosition: u = "top",
    // eslint-disable-next-line react/prop-types
    indicator: d,
    label: f,
    onChange: p,
    onClick: m,
    onFocus: b,
    // eslint-disable-next-line react/prop-types
    selected: v,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: g,
    // eslint-disable-next-line react/prop-types
    textColor: y = "inherit",
    value: w,
    wrapped: x = !1,
    ...S
  } = o, T = {
    ...o,
    disabled: i,
    disableFocusRipple: a,
    selected: v,
    icon: !!c,
    iconPosition: u,
    label: !!f,
    fullWidth: l,
    textColor: y,
    wrapped: x
  }, E = l9(T), O = c && f && /* @__PURE__ */ h.isValidElement(c) ? /* @__PURE__ */ h.cloneElement(c, {
    className: ae(E.icon, c.props.className)
  }) : c, M = (R) => {
    !v && p && p(R, w), m && m(R);
  }, D = (R) => {
    g && !v && p && p(R, w), b && b(R);
  };
  return /* @__PURE__ */ ie(c9, {
    focusRipple: !a,
    className: ae(E.root, s),
    ref: n,
    role: "tab",
    "aria-selected": v,
    disabled: i,
    onClick: M,
    onFocus: D,
    ownerState: T,
    tabIndex: v ? 0 : -1,
    ...S,
    children: [u === "top" || u === "start" ? /* @__PURE__ */ ie(h.Fragment, {
      children: [O, f]
    }) : /* @__PURE__ */ ie(h.Fragment, {
      children: [f, O]
    }), d]
  });
});
process.env.NODE_ENV !== "production" && (CC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: fP,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * The icon to display.
   */
  icon: r.oneOfType([r.element, r.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: r.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: r.node,
  /**
   * @ignore
   */
  onChange: r.func,
  /**
   * @ignore
   */
  onClick: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: r.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: r.bool
});
const wC = /* @__PURE__ */ h.createContext();
process.env.NODE_ENV !== "production" && (wC.displayName = "TableContext");
function u9(e) {
  return De("MuiTable", e);
}
Ne("MuiTable", ["root", "stickyHeader"]);
const d9 = (e) => {
  const {
    classes: t,
    stickyHeader: n
  } = e;
  return fe({
    root: ["root", n && "stickyHeader"]
  }, u9, t);
}, f9 = te("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.stickyHeader && t.stickyHeader];
  }
})(Fe(({
  theme: e
}) => ({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": {
    ...e.typography.body2,
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  },
  variants: [{
    props: ({
      ownerState: t
    }) => t.stickyHeader,
    style: {
      borderCollapse: "separate"
    }
  }]
}))), c1 = "table", Iu = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTable"
  }), {
    className: s,
    component: i = c1,
    padding: a = "normal",
    size: l = "medium",
    stickyHeader: c = !1,
    ...u
  } = o, d = {
    ...o,
    component: i,
    padding: a,
    size: l,
    stickyHeader: c
  }, f = d9(d), p = h.useMemo(() => ({
    padding: a,
    size: l,
    stickyHeader: c
  }), [a, l, c]);
  return /* @__PURE__ */ C(wC.Provider, {
    value: p,
    children: /* @__PURE__ */ C(f9, {
      as: i,
      role: i === c1 ? null : "table",
      ref: n,
      className: ae(f.root, s),
      ownerState: d,
      ...u
    })
  });
});
process.env.NODE_ENV !== "production" && (Iu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: r.oneOf(["checkbox", "none", "normal"]),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * Set the header sticky.
   * @default false
   */
  stickyHeader: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const vl = /* @__PURE__ */ h.createContext();
process.env.NODE_ENV !== "production" && (vl.displayName = "Tablelvl2Context");
function p9(e) {
  return De("MuiTableBody", e);
}
Ne("MuiTableBody", ["root"]);
const h9 = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, p9, t);
}, g9 = te("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-row-group"
}), m9 = {
  variant: "body"
}, u1 = "tbody", rl = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTableBody"
  }), {
    className: s,
    component: i = u1,
    ...a
  } = o, l = {
    ...o,
    component: i
  }, c = h9(l);
  return /* @__PURE__ */ C(vl.Provider, {
    value: m9,
    children: /* @__PURE__ */ C(g9, {
      className: ae(c.root, s),
      as: i,
      ref: n,
      role: i === u1 ? null : "rowgroup",
      ownerState: l,
      ...a
    })
  });
});
process.env.NODE_ENV !== "production" && (rl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function b9(e) {
  return De("MuiTableCell", e);
}
const y9 = Ne("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), v9 = (e) => {
  const {
    classes: t,
    variant: n,
    align: o,
    padding: s,
    size: i,
    stickyHeader: a
  } = e, l = {
    root: ["root", n, a && "stickyHeader", o !== "inherit" && `align${ce(o)}`, s !== "normal" && `padding${ce(s)}`, `size${ce(i)}`]
  };
  return fe(l, b9, t);
}, C9 = te("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`size${ce(n.size)}`], n.padding !== "normal" && t[`padding${ce(n.padding)}`], n.align !== "inherit" && t[`align${ce(n.align)}`], n.stickyHeader && t.stickyHeader];
  }
})(Fe(({
  theme: e
}) => ({
  ...e.typography.body2,
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? wo(he(e.palette.divider, 1), 0.88) : $o(he(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16,
  variants: [{
    props: {
      variant: "head"
    },
    style: {
      color: (e.vars || e).palette.text.primary,
      lineHeight: e.typography.pxToRem(24),
      fontWeight: e.typography.fontWeightMedium
    }
  }, {
    props: {
      variant: "body"
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }, {
    props: {
      variant: "footer"
    },
    style: {
      color: (e.vars || e).palette.text.secondary,
      lineHeight: e.typography.pxToRem(21),
      fontSize: e.typography.pxToRem(12)
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      padding: "6px 16px",
      [`&.${y9.paddingCheckbox}`]: {
        width: 24,
        // prevent the checkbox column from growing
        padding: "0 12px 0 16px",
        "& > *": {
          padding: 0
        }
      }
    }
  }, {
    props: {
      padding: "checkbox"
    },
    style: {
      width: 48,
      // prevent the checkbox column from growing
      padding: "0 0 0 4px"
    }
  }, {
    props: {
      padding: "none"
    },
    style: {
      padding: 0
    }
  }, {
    props: {
      align: "left"
    },
    style: {
      textAlign: "left"
    }
  }, {
    props: {
      align: "center"
    },
    style: {
      textAlign: "center"
    }
  }, {
    props: {
      align: "right"
    },
    style: {
      textAlign: "right",
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      align: "justify"
    },
    style: {
      textAlign: "justify"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.stickyHeader,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 2,
      backgroundColor: (e.vars || e).palette.background.default
    }
  }]
}))), Wo = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTableCell"
  }), {
    align: s = "inherit",
    className: i,
    component: a,
    padding: l,
    scope: c,
    size: u,
    sortDirection: d,
    variant: f,
    ...p
  } = o, m = h.useContext(wC), b = h.useContext(vl), v = b && b.variant === "head";
  let g;
  a ? g = a : g = v ? "th" : "td";
  let y = c;
  g === "td" ? y = void 0 : !y && v && (y = "col");
  const w = f || b && b.variant, x = {
    ...o,
    align: s,
    component: g,
    padding: l || (m && m.padding ? m.padding : "normal"),
    size: u || (m && m.size ? m.size : "medium"),
    sortDirection: d,
    stickyHeader: w === "head" && m && m.stickyHeader,
    variant: w
  }, S = v9(x);
  let T = null;
  return d && (T = d === "asc" ? "ascending" : "descending"), /* @__PURE__ */ C(C9, {
    as: g,
    ref: n,
    className: ae(S.root, i),
    "aria-sort": T,
    scope: y,
    ownerState: x,
    ...p
  });
});
process.env.NODE_ENV !== "production" && (Wo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: r.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: r.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: r.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: r.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: r.oneOfType([r.oneOf(["body", "footer", "head"]), r.string])
});
function w9(e) {
  return De("MuiTableContainer", e);
}
Ne("MuiTableContainer", ["root"]);
const S9 = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, w9, t);
}, x9 = te("div", {
  name: "MuiTableContainer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  width: "100%",
  overflowX: "auto"
}), SC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTableContainer"
  }), {
    className: s,
    component: i = "div",
    ...a
  } = o, l = {
    ...o,
    component: i
  }, c = S9(l);
  return /* @__PURE__ */ C(x9, {
    ref: n,
    as: i,
    className: ae(c.root, s),
    ownerState: l,
    ...a
  });
});
process.env.NODE_ENV !== "production" && (SC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Table`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function T9(e) {
  return De("MuiTableFooter", e);
}
Ne("MuiTableFooter", ["root"]);
const R9 = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, T9, t);
}, E9 = te("tfoot", {
  name: "MuiTableFooter",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-footer-group"
}), I9 = {
  variant: "footer"
}, d1 = "tfoot", PM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTableFooter"
  }), {
    className: s,
    component: i = d1,
    ...a
  } = o, l = {
    ...o,
    component: i
  }, c = R9(l);
  return /* @__PURE__ */ C(vl.Provider, {
    value: I9,
    children: /* @__PURE__ */ C(E9, {
      as: i,
      className: ae(c.root, s),
      ref: n,
      role: i === d1 ? null : "rowgroup",
      ownerState: l,
      ...a
    })
  });
});
process.env.NODE_ENV !== "production" && (PM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function O9(e) {
  return De("MuiTableHead", e);
}
Ne("MuiTableHead", ["root"]);
const P9 = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, O9, t);
}, M9 = te("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-header-group"
}), k9 = {
  variant: "head"
}, f1 = "thead", Ou = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTableHead"
  }), {
    className: s,
    component: i = f1,
    ...a
  } = o, l = {
    ...o,
    component: i
  }, c = P9(l);
  return /* @__PURE__ */ C(vl.Provider, {
    value: k9,
    children: /* @__PURE__ */ C(M9, {
      as: i,
      className: ae(c.root, s),
      ref: n,
      role: i === f1 ? null : "rowgroup",
      ownerState: l,
      ...a
    })
  });
});
process.env.NODE_ENV !== "production" && (Ou.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function D9(e) {
  return De("MuiToolbar", e);
}
Ne("MuiToolbar", ["root", "gutters", "regular", "dense"]);
const N9 = (e) => {
  const {
    classes: t,
    disableGutters: n,
    variant: o
  } = e;
  return fe({
    root: ["root", !n && "gutters", o]
  }, D9, t);
}, $9 = te("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableGutters && t.gutters, t[n.variant]];
  }
})(Fe(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  variants: [{
    props: ({
      ownerState: t
    }) => !t.disableGutters,
    style: {
      paddingLeft: e.spacing(2),
      paddingRight: e.spacing(2),
      [e.breakpoints.up("sm")]: {
        paddingLeft: e.spacing(3),
        paddingRight: e.spacing(3)
      }
    }
  }, {
    props: {
      variant: "dense"
    },
    style: {
      minHeight: 48
    }
  }, {
    props: {
      variant: "regular"
    },
    style: e.mixins.toolbar
  }]
}))), Bp = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiToolbar"
  }), {
    className: s,
    component: i = "div",
    disableGutters: a = !1,
    variant: l = "regular",
    ...c
  } = o, u = {
    ...o,
    component: i,
    disableGutters: a,
    variant: l
  }, d = N9(u);
  return /* @__PURE__ */ C($9, {
    as: i,
    className: ae(d.root, s),
    ref: n,
    ownerState: u,
    ...c
  });
});
process.env.NODE_ENV !== "production" && (Bp.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: r.oneOfType([r.oneOf(["dense", "regular"]), r.string])
});
const MM = _e(/* @__PURE__ */ C("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), kM = _e(/* @__PURE__ */ C("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight"), DM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    backIconButtonProps: o,
    count: s,
    disabled: i = !1,
    getItemAriaLabel: a,
    nextIconButtonProps: l,
    onPageChange: c,
    page: u,
    rowsPerPage: d,
    showFirstButton: f,
    showLastButton: p,
    slots: m = {},
    slotProps: b = {},
    ...v
  } = t, g = _t(), y = (z) => {
    c(z, 0);
  }, w = (z) => {
    c(z, u - 1);
  }, x = (z) => {
    c(z, u + 1);
  }, S = (z) => {
    c(z, Math.max(0, Math.ceil(s / d) - 1));
  }, T = m.firstButton ?? Eo, E = m.lastButton ?? Eo, O = m.nextButton ?? Eo, M = m.previousButton ?? Eo, D = m.firstButtonIcon ?? D6, R = m.lastButtonIcon ?? N6, P = m.nextButtonIcon ?? kM, F = m.previousButtonIcon ?? MM, $ = g ? E : T, N = g ? O : M, A = g ? M : O, k = g ? T : E, L = g ? b.lastButton : b.firstButton, B = g ? b.nextButton : b.previousButton, V = g ? b.previousButton : b.nextButton, _ = g ? b.firstButton : b.lastButton;
  return /* @__PURE__ */ ie("div", {
    ref: n,
    ...v,
    children: [f && /* @__PURE__ */ C($, {
      onClick: y,
      disabled: i || u === 0,
      "aria-label": a("first", u),
      title: a("first", u),
      ...L,
      children: g ? /* @__PURE__ */ C(R, {
        ...b.lastButtonIcon
      }) : /* @__PURE__ */ C(D, {
        ...b.firstButtonIcon
      })
    }), /* @__PURE__ */ C(N, {
      onClick: w,
      disabled: i || u === 0,
      color: "inherit",
      "aria-label": a("previous", u),
      title: a("previous", u),
      ...B ?? o,
      children: g ? /* @__PURE__ */ C(P, {
        ...b.nextButtonIcon
      }) : /* @__PURE__ */ C(F, {
        ...b.previousButtonIcon
      })
    }), /* @__PURE__ */ C(A, {
      onClick: x,
      disabled: i || (s !== -1 ? u >= Math.ceil(s / d) - 1 : !1),
      color: "inherit",
      "aria-label": a("next", u),
      title: a("next", u),
      ...V ?? l,
      children: g ? /* @__PURE__ */ C(F, {
        ...b.previousButtonIcon
      }) : /* @__PURE__ */ C(P, {
        ...b.nextButtonIcon
      })
    }), p && /* @__PURE__ */ C(k, {
      onClick: S,
      disabled: i || u >= Math.ceil(s / d) - 1,
      "aria-label": a("last", u),
      title: a("last", u),
      ..._,
      children: g ? /* @__PURE__ */ C(D, {
        ...b.firstButtonIcon
      }) : /* @__PURE__ */ C(R, {
        ...b.lastButtonIcon
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (DM.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  backIconButtonProps: r.object,
  /**
   * The total number of rows.
   */
  count: r.number.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @returns {string}
   */
  getItemAriaLabel: r.func.isRequired,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  nextIconButtonProps: r.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: r.func.isRequired,
  /**
   * The zero-based index of the current page.
   */
  page: r.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: r.number.isRequired,
  /**
   * If `true`, show the first-page button.
   */
  showFirstButton: r.bool.isRequired,
  /**
   * If `true`, show the last-page button.
   */
  showLastButton: r.bool.isRequired,
  /**
   * The props used for each slot inside the TablePaginationActions.
   * @default {}
   */
  slotProps: r.shape({
    firstButton: r.object,
    firstButtonIcon: r.object,
    lastButton: r.object,
    lastButtonIcon: r.object,
    nextButton: r.object,
    nextButtonIcon: r.object,
    previousButton: r.object,
    previousButtonIcon: r.object
  }),
  /**
   * The components used for each slot inside the TablePaginationActions.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    firstButton: r.elementType,
    firstButtonIcon: r.elementType,
    lastButton: r.elementType,
    lastButtonIcon: r.elementType,
    nextButton: r.elementType,
    nextButtonIcon: r.elementType,
    previousButton: r.elementType,
    previousButtonIcon: r.elementType
  })
});
function A9(e) {
  return De("MuiTablePagination", e);
}
const ki = Ne("MuiTablePagination", ["root", "toolbar", "spacer", "selectLabel", "selectRoot", "select", "selectIcon", "input", "menuItem", "displayedRows", "actions"]);
var p1;
const F9 = te(Wo, {
  name: "MuiTablePagination",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(Fe(({
  theme: e
}) => ({
  overflow: "auto",
  color: (e.vars || e).palette.text.primary,
  fontSize: e.typography.pxToRem(14),
  // Increase the specificity to override TableCell.
  "&:last-child": {
    padding: 0
  }
}))), L9 = te(Bp, {
  name: "MuiTablePagination",
  slot: "Toolbar",
  overridesResolver: (e, t) => ({
    [`& .${ki.actions}`]: t.actions,
    ...t.toolbar
  })
})(Fe(({
  theme: e
}) => ({
  minHeight: 52,
  paddingRight: 2,
  [`${e.breakpoints.up("xs")} and (orientation: landscape)`]: {
    minHeight: 52
  },
  [e.breakpoints.up("sm")]: {
    minHeight: 52,
    paddingRight: 2
  },
  [`& .${ki.actions}`]: {
    flexShrink: 0,
    marginLeft: 20
  }
}))), _9 = te("div", {
  name: "MuiTablePagination",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})({
  flex: "1 1 100%"
}), V9 = te("p", {
  name: "MuiTablePagination",
  slot: "SelectLabel",
  overridesResolver: (e, t) => t.selectLabel
})(Fe(({
  theme: e
}) => ({
  ...e.typography.body2,
  flexShrink: 0
}))), B9 = te(Ji, {
  name: "MuiTablePagination",
  slot: "Select",
  overridesResolver: (e, t) => ({
    [`& .${ki.selectIcon}`]: t.selectIcon,
    [`& .${ki.select}`]: t.select,
    ...t.input,
    ...t.selectRoot
  })
})({
  color: "inherit",
  fontSize: "inherit",
  flexShrink: 0,
  marginRight: 32,
  marginLeft: 8,
  [`& .${ki.select}`]: {
    paddingLeft: 8,
    paddingRight: 24,
    textAlign: "right",
    textAlignLast: "right"
    // Align <select> on Chrome.
  }
}), z9 = te(Nn, {
  name: "MuiTablePagination",
  slot: "MenuItem",
  overridesResolver: (e, t) => t.menuItem
})({}), H9 = te("p", {
  name: "MuiTablePagination",
  slot: "DisplayedRows",
  overridesResolver: (e, t) => t.displayedRows
})(Fe(({
  theme: e
}) => ({
  ...e.typography.body2,
  flexShrink: 0
})));
function j9({
  from: e,
  to: t,
  count: n
}) {
  return `${e}–${t} of ${n !== -1 ? n : `more than ${t}`}`;
}
function G9(e) {
  return `Go to ${e} page`;
}
const q9 = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    toolbar: ["toolbar"],
    spacer: ["spacer"],
    selectLabel: ["selectLabel"],
    select: ["select"],
    input: ["input"],
    selectIcon: ["selectIcon"],
    menuItem: ["menuItem"],
    displayedRows: ["displayedRows"],
    actions: ["actions"]
  }, A9, t);
}, NM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTablePagination"
  }), {
    ActionsComponent: s = DM,
    backIconButtonProps: i,
    className: a,
    colSpan: l,
    component: c = Wo,
    count: u,
    disabled: d = !1,
    getItemAriaLabel: f = G9,
    labelDisplayedRows: p = j9,
    labelRowsPerPage: m = "Rows per page:",
    nextIconButtonProps: b,
    onPageChange: v,
    onRowsPerPageChange: g,
    page: y,
    rowsPerPage: w,
    rowsPerPageOptions: x = [10, 25, 50, 100],
    SelectProps: S = {},
    showFirstButton: T = !1,
    showLastButton: E = !1,
    slotProps: O = {},
    slots: M = {},
    ...D
  } = o, R = o, P = q9(R), F = (O == null ? void 0 : O.select) ?? S, $ = F.native ? "option" : z9;
  let N;
  (c === Wo || c === "td") && (N = l || 1e3);
  const A = gt(F.id), k = gt(F.labelId), L = () => u === -1 ? (y + 1) * w : w === -1 ? u : Math.min(u, (y + 1) * w);
  return /* @__PURE__ */ C(F9, {
    colSpan: N,
    ref: n,
    as: c,
    ownerState: R,
    className: ae(P.root, a),
    ...D,
    children: /* @__PURE__ */ ie(L9, {
      className: P.toolbar,
      children: [/* @__PURE__ */ C(_9, {
        className: P.spacer
      }), x.length > 1 && /* @__PURE__ */ C(V9, {
        className: P.selectLabel,
        id: k,
        children: m
      }), x.length > 1 && /* @__PURE__ */ C(B9, {
        variant: "standard",
        ...!F.variant && {
          input: p1 || (p1 = /* @__PURE__ */ C(Xi, {}))
        },
        value: w,
        onChange: g,
        id: A,
        labelId: k,
        ...F,
        classes: {
          ...F.classes,
          // TODO v5 remove `classes.input`
          root: ae(P.input, P.selectRoot, (F.classes || {}).root),
          select: ae(P.select, (F.classes || {}).select),
          // TODO v5 remove `selectIcon`
          icon: ae(P.selectIcon, (F.classes || {}).icon)
        },
        disabled: d,
        children: x.map((B) => /* @__PURE__ */ js($, {
          ...!Yr($) && {
            ownerState: R
          },
          className: P.menuItem,
          key: B.label ? B.label : B,
          value: B.value ? B.value : B
        }, B.label ? B.label : B))
      }), /* @__PURE__ */ C(H9, {
        className: P.displayedRows,
        children: p({
          from: u === 0 ? 0 : y * w + 1,
          to: L(),
          count: u === -1 ? -1 : u,
          page: y
        })
      }), /* @__PURE__ */ C(s, {
        className: P.actions,
        backIconButtonProps: i,
        count: u,
        nextIconButtonProps: b,
        onPageChange: v,
        page: y,
        rowsPerPage: w,
        showFirstButton: T,
        showLastButton: E,
        slotProps: O.actions,
        slots: M.actions,
        getItemAriaLabel: f,
        disabled: d
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (NM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */
  ActionsComponent: r.elementType,
  /**
   * Props applied to the back arrow [`IconButton`](https://mui.com/material-ui/api/icon-button/) component.
   *
   * This prop is an alias for `slotProps.actions.previousButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.previousButton` instead.
   */
  backIconButtonProps: r.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * @ignore
   */
  colSpan: r.number,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: Wr.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */
  getItemAriaLabel: r.func,
  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */
  labelDisplayedRows: r.func,
  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */
  labelRowsPerPage: r.node,
  /**
   * Props applied to the next arrow [`IconButton`](https://mui.com/material-ui/api/icon-button/) element.
   *
   * This prop is an alias for `slotProps.actions.nextButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.nextButton` instead.
   */
  nextIconButtonProps: r.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: r.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */
  onRowsPerPageChange: r.func,
  /**
   * The zero-based index of the current page.
   */
  page: Gn(Wr.isRequired, (e) => {
    const {
      count: t,
      page: n,
      rowsPerPage: o
    } = e;
    if (t === -1)
      return null;
    const s = Math.max(0, Math.ceil(t / o) - 1);
    return n < 0 || n > s ? new Error(`MUI: The page prop of a TablePagination is out of range (0 to ${s}, but page is ${n}).`) : null;
  }),
  /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */
  rowsPerPage: Wr.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */
  rowsPerPageOptions: r.arrayOf(r.oneOfType([r.number, r.shape({
    label: r.string.isRequired,
    value: r.number.isRequired
  })]).isRequired),
  /**
   * Props applied to the rows per page [`Select`](https://mui.com/material-ui/api/select/) element.
   *
   * This prop is an alias for `slotProps.select` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.select` instead.
   *
   * @default {}
   */
  SelectProps: r.object,
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: r.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: r.bool,
  /**
   * The props used for each slot inside the TablePagination.
   * @default {}
   */
  slotProps: r.shape({
    actions: r.shape({
      firstButton: r.object,
      firstButtonIcon: r.object,
      lastButton: r.object,
      lastButtonIcon: r.object,
      nextButton: r.object,
      nextButtonIcon: r.object,
      previousButton: r.object,
      previousButtonIcon: r.object
    }),
    select: r.object
  }),
  /**
   * The components used for each slot inside the TablePagination.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: r.shape({
    actions: r.shape({
      firstButton: r.elementType,
      firstButtonIcon: r.elementType,
      lastButton: r.elementType,
      lastButtonIcon: r.elementType,
      nextButton: r.elementType,
      nextButtonIcon: r.elementType,
      previousButton: r.elementType,
      previousButtonIcon: r.elementType
    })
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function W9(e) {
  return De("MuiTableRow", e);
}
const h1 = Ne("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), U9 = (e) => {
  const {
    classes: t,
    selected: n,
    hover: o,
    head: s,
    footer: i
  } = e;
  return fe({
    root: ["root", n && "selected", o && "hover", s && "head", i && "footer"]
  }, W9, t);
}, K9 = te("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.head && t.head, n.footer && t.footer];
  }
})(Fe(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${h1.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${h1.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : he(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : he(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
}))), g1 = "tr", Us = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTableRow"
  }), {
    className: s,
    component: i = g1,
    hover: a = !1,
    selected: l = !1,
    ...c
  } = o, u = h.useContext(vl), d = {
    ...o,
    component: i,
    hover: a,
    selected: l,
    head: u && u.variant === "head",
    footer: u && u.variant === "footer"
  }, f = U9(d);
  return /* @__PURE__ */ C(K9, {
    as: i,
    ref: n,
    className: ae(f.root, s),
    role: i === g1 ? null : "row",
    ownerState: d,
    ...c
  });
});
process.env.NODE_ENV !== "production" && (Us.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: r.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const Y9 = _e(/* @__PURE__ */ C("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward");
function X9(e) {
  return De("MuiTableSortLabel", e);
}
const Wh = Ne("MuiTableSortLabel", ["root", "active", "icon", "iconDirectionDesc", "iconDirectionAsc", "directionDesc", "directionAsc"]), Q9 = (e) => {
  const {
    classes: t,
    direction: n,
    active: o
  } = e, s = {
    root: ["root", o && "active", `direction${ce(n)}`],
    icon: ["icon", `iconDirection${ce(n)}`]
  };
  return fe(s, X9, t);
}, Z9 = te(Yn, {
  name: "MuiTableSortLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.active && t.active];
  }
})(Fe(({
  theme: e
}) => ({
  cursor: "pointer",
  display: "inline-flex",
  justifyContent: "flex-start",
  flexDirection: "inherit",
  alignItems: "center",
  "&:focus": {
    color: (e.vars || e).palette.text.secondary
  },
  "&:hover": {
    color: (e.vars || e).palette.text.secondary,
    [`& .${Wh.icon}`]: {
      opacity: 0.5
    }
  },
  [`&.${Wh.active}`]: {
    color: (e.vars || e).palette.text.primary,
    [`& .${Wh.icon}`]: {
      opacity: 1,
      color: (e.vars || e).palette.text.secondary
    }
  }
}))), J9 = te("span", {
  name: "MuiTableSortLabel",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, t[`iconDirection${ce(n.direction)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  fontSize: 18,
  marginRight: 4,
  marginLeft: 4,
  opacity: 0,
  transition: e.transitions.create(["opacity", "transform"], {
    duration: e.transitions.duration.shorter
  }),
  userSelect: "none",
  variants: [{
    props: {
      direction: "desc"
    },
    style: {
      transform: "rotate(0deg)"
    }
  }, {
    props: {
      direction: "asc"
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}))), $M = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTableSortLabel"
  }), {
    active: s = !1,
    children: i,
    className: a,
    direction: l = "asc",
    hideSortIcon: c = !1,
    IconComponent: u = Y9,
    ...d
  } = o, f = {
    ...o,
    active: s,
    direction: l,
    hideSortIcon: c,
    IconComponent: u
  }, p = Q9(f);
  return /* @__PURE__ */ ie(Z9, {
    className: ae(p.root, a),
    component: "span",
    disableRipple: !0,
    ownerState: f,
    ref: n,
    ...d,
    children: [i, c && !s ? null : /* @__PURE__ */ C(J9, {
      as: u,
      className: ae(p.icon),
      ownerState: f
    })]
  });
});
process.env.NODE_ENV !== "production" && ($M.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   * @default false
   */
  active: r.bool,
  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The current sort direction.
   * @default 'asc'
   */
  direction: r.oneOf(["asc", "desc"]),
  /**
   * Hide sort icon when active is false.
   * @default false
   */
  hideSortIcon: r.bool,
  /**
   * Sort icon to use.
   * @default ArrowDownwardIcon
   */
  IconComponent: r.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function e8(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
function t8(e, t, n, o = {}, s = () => {
}) {
  const {
    ease: i = e8,
    duration: a = 300
    // standard
  } = o;
  let l = null;
  const c = t[e];
  let u = !1;
  const d = () => {
    u = !0;
  }, f = (p) => {
    if (u) {
      s(new Error("Animation cancelled"));
      return;
    }
    l === null && (l = p);
    const m = Math.min(1, (p - l) / a);
    if (t[e] = i(m) * (n - c) + c, m >= 1) {
      requestAnimationFrame(() => {
        s(null);
      });
      return;
    }
    requestAnimationFrame(f);
  };
  return c === n ? (s(new Error("Element already at target position")), d) : (requestAnimationFrame(f), d);
}
const n8 = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function AM(e) {
  const {
    onChange: t,
    ...n
  } = e, o = h.useRef(), s = h.useRef(null), i = () => {
    o.current = s.current.offsetHeight - s.current.clientHeight;
  };
  return yt(() => {
    const a = Yi(() => {
      const c = o.current;
      i(), c !== o.current && t(o.current);
    }), l = Ao(s.current);
    return l.addEventListener("resize", a), () => {
      a.clear(), l.removeEventListener("resize", a);
    };
  }, [t]), h.useEffect(() => {
    i(), t(o.current);
  }, [t]), /* @__PURE__ */ C("div", {
    style: n8,
    ...n,
    ref: s
  });
}
process.env.NODE_ENV !== "production" && (AM.propTypes = {
  onChange: r.func.isRequired
});
function o8(e) {
  return De("MuiTabScrollButton", e);
}
const r8 = Ne("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), s8 = (e) => {
  const {
    classes: t,
    orientation: n,
    disabled: o
  } = e;
  return fe({
    root: ["root", n, o && "disabled"]
  }, o8, t);
}, i8 = te(Yn, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.orientation && t[n.orientation]];
  }
})({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${r8.disabled}`]: {
    opacity: 0
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      width: "100%",
      height: 40,
      "& svg": {
        transform: "var(--TabScrollButton-svgRotate)"
      }
    }
  }]
}), FM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTabScrollButton"
  }), {
    className: s,
    slots: i = {},
    slotProps: a = {},
    direction: l,
    orientation: c,
    disabled: u,
    ...d
  } = o, f = _t(), p = {
    isRtl: f,
    ...o
  }, m = s8(p), b = i.StartScrollButtonIcon ?? MM, v = i.EndScrollButtonIcon ?? kM, g = et({
    elementType: b,
    externalSlotProps: a.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: p
  }), y = et({
    elementType: v,
    externalSlotProps: a.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: p
  });
  return /* @__PURE__ */ C(i8, {
    component: "div",
    className: ae(m.root, s),
    ref: n,
    role: null,
    ownerState: p,
    tabIndex: null,
    ...d,
    style: {
      ...d.style,
      ...c === "vertical" && {
        "--TabScrollButton-svgRotate": `rotate(${f ? -90 : 90}deg)`
      }
    },
    children: l === "left" ? /* @__PURE__ */ C(b, {
      ...g
    }) : /* @__PURE__ */ C(v, {
      ...y
    })
  });
});
process.env.NODE_ENV !== "production" && (FM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The direction the button should indicate.
   */
  direction: r.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: r.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: r.shape({
    endScrollButtonIcon: r.oneOfType([r.func, r.object]),
    startScrollButtonIcon: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    EndScrollButtonIcon: r.elementType,
    StartScrollButtonIcon: r.elementType
  }),
  /**
   * @ignore
   */
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function a8(e) {
  return De("MuiTabs", e);
}
const Uh = Ne("MuiTabs", ["root", "vertical", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), m1 = (e, t) => e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild, b1 = (e, t) => e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild, Cd = (e, t, n) => {
  let o = !1, s = n(e, t);
  for (; s; ) {
    if (s === e.firstChild) {
      if (o)
        return;
      o = !0;
    }
    const i = s.disabled || s.getAttribute("aria-disabled") === "true";
    if (!s.hasAttribute("tabindex") || i)
      s = n(e, s);
    else {
      s.focus();
      return;
    }
  }
}, l8 = (e) => {
  const {
    vertical: t,
    fixed: n,
    hideScrollbar: o,
    scrollableX: s,
    scrollableY: i,
    centered: a,
    scrollButtonsHideMobile: l,
    classes: c
  } = e;
  return fe({
    root: ["root", t && "vertical"],
    scroller: ["scroller", n && "fixed", o && "hideScrollbar", s && "scrollableX", i && "scrollableY"],
    flexContainer: ["flexContainer", t && "flexContainerVertical", a && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", l && "scrollButtonsHideMobile"],
    scrollableX: [s && "scrollableX"],
    hideScrollbar: [o && "hideScrollbar"]
  }, a8, c);
}, c8 = te("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Uh.scrollButtons}`]: t.scrollButtons
    }, {
      [`& .${Uh.scrollButtons}`]: n.scrollButtonsHideMobile && t.scrollButtonsHideMobile
    }, t.root, n.vertical && t.vertical];
  }
})(Fe(({
  theme: e
}) => ({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex",
  variants: [{
    props: ({
      ownerState: t
    }) => t.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: t
    }) => t.scrollButtonsHideMobile,
    style: {
      [`& .${Uh.scrollButtons}`]: {
        [e.breakpoints.down("sm")]: {
          display: "none"
        }
      }
    }
  }]
}))), u8 = te("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.scroller, n.fixed && t.fixed, n.hideScrollbar && t.hideScrollbar, n.scrollableX && t.scrollableX, n.scrollableY && t.scrollableY];
  }
})({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap",
  variants: [{
    props: ({
      ownerState: e
    }) => e.fixed,
    style: {
      overflowX: "hidden",
      width: "100%"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.hideScrollbar,
    style: {
      // Hide dimensionless scrollbar on macOS
      scrollbarWidth: "none",
      // Firefox
      "&::-webkit-scrollbar": {
        display: "none"
        // Safari + Chrome
      }
    }
  }, {
    props: ({
      ownerState: e
    }) => e.scrollableX,
    style: {
      overflowX: "auto",
      overflowY: "hidden"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.scrollableY,
    style: {
      overflowY: "auto",
      overflowX: "hidden"
    }
  }]
}), d8 = te("div", {
  name: "MuiTabs",
  slot: "FlexContainer",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.flexContainer, n.vertical && t.flexContainerVertical, n.centered && t.centered];
  }
})({
  display: "flex",
  variants: [{
    props: ({
      ownerState: e
    }) => e.vertical,
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      ownerState: e
    }) => e.centered,
    style: {
      justifyContent: "center"
    }
  }]
}), f8 = te("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (e, t) => t.indicator
})(Fe(({
  theme: e
}) => ({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: e.transitions.create(),
  variants: [{
    props: {
      indicatorColor: "primary"
    },
    style: {
      backgroundColor: (e.vars || e).palette.primary.main
    }
  }, {
    props: {
      indicatorColor: "secondary"
    },
    style: {
      backgroundColor: (e.vars || e).palette.secondary.main
    }
  }, {
    props: ({
      ownerState: t
    }) => t.vertical,
    style: {
      height: "100%",
      width: 2,
      right: 0
    }
  }]
}))), p8 = te(AM)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), y1 = {};
let v1 = !1;
const xC = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTabs"
  }), s = sn(), i = _t(), {
    "aria-label": a,
    "aria-labelledby": l,
    action: c,
    centered: u = !1,
    children: d,
    className: f,
    component: p = "div",
    allowScrollButtonsMobile: m = !1,
    indicatorColor: b = "primary",
    onChange: v,
    orientation: g = "horizontal",
    ScrollButtonComponent: y = FM,
    scrollButtons: w = "auto",
    selectionFollowsFocus: x,
    slots: S = {},
    slotProps: T = {},
    TabIndicatorProps: E = {},
    TabScrollButtonProps: O = {},
    textColor: M = "primary",
    value: D,
    variant: R = "standard",
    visibleScrollbar: P = !1,
    ...F
  } = o, $ = R === "scrollable", N = g === "vertical", A = N ? "scrollTop" : "scrollLeft", k = N ? "top" : "left", L = N ? "bottom" : "right", B = N ? "clientHeight" : "clientWidth", V = N ? "height" : "width", _ = {
    ...o,
    component: p,
    allowScrollButtonsMobile: m,
    indicatorColor: b,
    orientation: g,
    vertical: N,
    scrollButtons: w,
    textColor: M,
    variant: R,
    visibleScrollbar: P,
    fixed: !$,
    hideScrollbar: $ && !P,
    scrollableX: $ && !N,
    scrollableY: $ && N,
    centered: u && !$,
    scrollButtonsHideMobile: !m
  }, z = l8(_), j = et({
    elementType: S.StartScrollButtonIcon,
    externalSlotProps: T.startScrollButtonIcon,
    ownerState: _
  }), W = et({
    elementType: S.EndScrollButtonIcon,
    externalSlotProps: T.endScrollButtonIcon,
    ownerState: _
  });
  process.env.NODE_ENV !== "production" && u && $ && console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
  const [J, G] = h.useState(!1), [q, Z] = h.useState(y1), [Y, Q] = h.useState(!1), [ee, ne] = h.useState(!1), [H, U] = h.useState(!1), [X, re] = h.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), oe = /* @__PURE__ */ new Map(), le = h.useRef(null), se = h.useRef(null), Ce = () => {
    const pe = le.current;
    let Re;
    if (pe) {
      const Qe = pe.getBoundingClientRect();
      Re = {
        clientWidth: pe.clientWidth,
        scrollLeft: pe.scrollLeft,
        scrollTop: pe.scrollTop,
        scrollWidth: pe.scrollWidth,
        top: Qe.top,
        bottom: Qe.bottom,
        left: Qe.left,
        right: Qe.right
      };
    }
    let Ge;
    if (pe && D !== !1) {
      const Qe = se.current.children;
      if (Qe.length > 0) {
        const qe = Qe[oe.get(D)];
        process.env.NODE_ENV !== "production" && (qe || console.error(["MUI: The `value` provided to the Tabs component is invalid.", `None of the Tabs' children match with "${D}".`, oe.keys ? `You can provide one of the following values: ${Array.from(oe.keys()).join(", ")}.` : null].join(`
`))), Ge = qe ? qe.getBoundingClientRect() : null, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && !v1 && Ge && Ge.width === 0 && Ge.height === 0 && // if the whole Tabs component is hidden, don't warn
        Re.clientWidth !== 0 && (Re = null, console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${D}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join(`
`)), v1 = !0);
      }
    }
    return {
      tabsMeta: Re,
      tabMeta: Ge
    };
  }, $e = xe(() => {
    const {
      tabsMeta: pe,
      tabMeta: Re
    } = Ce();
    let Ge = 0, Qe;
    N ? (Qe = "top", Re && pe && (Ge = Re.top - pe.top + pe.scrollTop)) : (Qe = i ? "right" : "left", Re && pe && (Ge = (i ? -1 : 1) * (Re[Qe] - pe[Qe] + pe.scrollLeft)));
    const qe = {
      [Qe]: Ge,
      // May be wrong until the font is loaded.
      [V]: Re ? Re[V] : 0
    };
    if (typeof q[Qe] != "number" || typeof q[V] != "number")
      Z(qe);
    else {
      const st = Math.abs(q[Qe] - qe[Qe]), wt = Math.abs(q[V] - qe[V]);
      (st >= 1 || wt >= 1) && Z(qe);
    }
  }), we = (pe, {
    animation: Re = !0
  } = {}) => {
    Re ? t8(A, le.current, pe, {
      duration: s.transitions.duration.standard
    }) : le.current[A] = pe;
  }, Te = (pe) => {
    let Re = le.current[A];
    N ? Re += pe : Re += pe * (i ? -1 : 1), we(Re);
  }, ue = () => {
    const pe = le.current[B];
    let Re = 0;
    const Ge = Array.from(se.current.children);
    for (let Qe = 0; Qe < Ge.length; Qe += 1) {
      const qe = Ge[Qe];
      if (Re + qe[B] > pe) {
        Qe === 0 && (Re = pe);
        break;
      }
      Re += qe[B];
    }
    return Re;
  }, de = () => {
    Te(-1 * ue());
  }, Pe = () => {
    Te(ue());
  }, ke = h.useCallback((pe) => {
    re({
      overflow: null,
      scrollbarWidth: pe
    });
  }, []), Me = () => {
    const pe = {};
    pe.scrollbarSizeListener = $ ? /* @__PURE__ */ C(p8, {
      onChange: ke,
      className: ae(z.scrollableX, z.hideScrollbar)
    }) : null;
    const Ge = $ && (w === "auto" && (Y || ee) || w === !0);
    return pe.scrollButtonStart = Ge ? /* @__PURE__ */ C(y, {
      slots: {
        StartScrollButtonIcon: S.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: j
      },
      orientation: g,
      direction: i ? "right" : "left",
      onClick: de,
      disabled: !Y,
      ...O,
      className: ae(z.scrollButtons, O.className)
    }) : null, pe.scrollButtonEnd = Ge ? /* @__PURE__ */ C(y, {
      slots: {
        EndScrollButtonIcon: S.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: W
      },
      orientation: g,
      direction: i ? "left" : "right",
      onClick: Pe,
      disabled: !ee,
      ...O,
      className: ae(z.scrollButtons, O.className)
    }) : null, pe;
  }, be = xe((pe) => {
    const {
      tabsMeta: Re,
      tabMeta: Ge
    } = Ce();
    if (!(!Ge || !Re)) {
      if (Ge[k] < Re[k]) {
        const Qe = Re[A] + (Ge[k] - Re[k]);
        we(Qe, {
          animation: pe
        });
      } else if (Ge[L] > Re[L]) {
        const Qe = Re[A] + (Ge[L] - Re[L]);
        we(Qe, {
          animation: pe
        });
      }
    }
  }), me = xe(() => {
    $ && w !== !1 && U(!H);
  });
  h.useEffect(() => {
    const pe = Yi(() => {
      le.current && $e();
    });
    let Re;
    const Ge = (st) => {
      st.forEach((wt) => {
        wt.removedNodes.forEach((Ue) => {
          Re == null || Re.unobserve(Ue);
        }), wt.addedNodes.forEach((Ue) => {
          Re == null || Re.observe(Ue);
        });
      }), pe(), me();
    }, Qe = Ao(le.current);
    Qe.addEventListener("resize", pe);
    let qe;
    return typeof ResizeObserver < "u" && (Re = new ResizeObserver(pe), Array.from(se.current.children).forEach((st) => {
      Re.observe(st);
    })), typeof MutationObserver < "u" && (qe = new MutationObserver(Ge), qe.observe(se.current, {
      childList: !0
    })), () => {
      pe.clear(), Qe.removeEventListener("resize", pe), qe == null || qe.disconnect(), Re == null || Re.disconnect();
    };
  }, [$e, me]), h.useEffect(() => {
    const pe = Array.from(se.current.children), Re = pe.length;
    if (typeof IntersectionObserver < "u" && Re > 0 && $ && w !== !1) {
      const Ge = pe[0], Qe = pe[Re - 1], qe = {
        root: le.current,
        threshold: 0.99
      }, st = (ft) => {
        Q(!ft[0].isIntersecting);
      }, wt = new IntersectionObserver(st, qe);
      wt.observe(Ge);
      const Ue = (ft) => {
        ne(!ft[0].isIntersecting);
      }, nt = new IntersectionObserver(Ue, qe);
      return nt.observe(Qe), () => {
        wt.disconnect(), nt.disconnect();
      };
    }
  }, [$, w, H, d == null ? void 0 : d.length]), h.useEffect(() => {
    G(!0);
  }, []), h.useEffect(() => {
    $e();
  }), h.useEffect(() => {
    be(y1 !== q);
  }, [be, q]), h.useImperativeHandle(c, () => ({
    updateIndicator: $e,
    updateScrollButtons: me
  }), [$e, me]);
  const Ae = /* @__PURE__ */ C(f8, {
    ...E,
    className: ae(z.indicator, E.className),
    ownerState: _,
    style: {
      ...q,
      ...E.style
    }
  });
  let ye = 0;
  const We = h.Children.map(d, (pe) => {
    if (!/* @__PURE__ */ h.isValidElement(pe))
      return null;
    process.env.NODE_ENV !== "production" && Js.isFragment(pe) && console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    const Re = pe.props.value === void 0 ? ye : pe.props.value;
    oe.set(Re, ye);
    const Ge = Re === D;
    return ye += 1, /* @__PURE__ */ h.cloneElement(pe, {
      fullWidth: R === "fullWidth",
      indicator: Ge && !J && Ae,
      selected: Ge,
      selectionFollowsFocus: x,
      onChange: v,
      textColor: M,
      value: Re,
      ...ye === 1 && D === !1 && !pe.props.tabIndex ? {
        tabIndex: 0
      } : {}
    });
  }), He = (pe) => {
    const Re = se.current, Ge = qt(Re).activeElement;
    if (Ge.getAttribute("role") !== "tab")
      return;
    let qe = g === "horizontal" ? "ArrowLeft" : "ArrowUp", st = g === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (g === "horizontal" && i && (qe = "ArrowRight", st = "ArrowLeft"), pe.key) {
      case qe:
        pe.preventDefault(), Cd(Re, Ge, b1);
        break;
      case st:
        pe.preventDefault(), Cd(Re, Ge, m1);
        break;
      case "Home":
        pe.preventDefault(), Cd(Re, null, m1);
        break;
      case "End":
        pe.preventDefault(), Cd(Re, null, b1);
        break;
    }
  }, ze = Me();
  return /* @__PURE__ */ ie(c8, {
    className: ae(z.root, f),
    ownerState: _,
    ref: n,
    as: p,
    ...F,
    children: [ze.scrollButtonStart, ze.scrollbarSizeListener, /* @__PURE__ */ ie(u8, {
      className: z.scroller,
      ownerState: _,
      style: {
        overflow: X.overflow,
        [N ? `margin${i ? "Left" : "Right"}` : "marginBottom"]: P ? void 0 : -X.scrollbarWidth
      },
      ref: le,
      children: [/* @__PURE__ */ C(d8, {
        "aria-label": a,
        "aria-labelledby": l,
        "aria-orientation": g === "vertical" ? "vertical" : null,
        className: z.flexContainer,
        ownerState: _,
        onKeyDown: He,
        ref: se,
        role: "tablist",
        children: We
      }), J && Ae]
    }), ze.scrollButtonEnd]
  });
});
process.env.NODE_ENV !== "production" && (xC.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: Lt,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: r.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": r.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": r.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: r.bool,
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: r.oneOfType([r.oneOf(["primary", "secondary"]), r.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: r.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: r.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */
  ScrollButtonComponent: r.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: r.oneOf(["auto", !1, !0]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: r.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: r.shape({
    endScrollButtonIcon: r.oneOfType([r.func, r.object]),
    startScrollButtonIcon: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    EndScrollButtonIcon: r.elementType,
    StartScrollButtonIcon: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Props applied to the tab indicator element.
   * @default  {}
   */
  TabIndicatorProps: r.object,
  /**
   * Props applied to the [`TabScrollButton`](https://mui.com/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */
  TabScrollButtonProps: r.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: r.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: r.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: r.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: r.bool
});
function h8(e) {
  return De("MuiTextField", e);
}
Ne("MuiTextField", ["root"]);
const g8 = {
  standard: _i,
  filled: Gc,
  outlined: ol
}, m8 = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, h8, t);
}, b8 = te(bl, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Is = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: s,
    autoFocus: i = !1,
    children: a,
    className: l,
    color: c = "primary",
    defaultValue: u,
    disabled: d = !1,
    error: f = !1,
    FormHelperTextProps: p,
    fullWidth: m = !1,
    helperText: b,
    id: v,
    InputLabelProps: g,
    inputProps: y,
    InputProps: w,
    inputRef: x,
    label: S,
    maxRows: T,
    minRows: E,
    multiline: O = !1,
    name: M,
    onBlur: D,
    onChange: R,
    onFocus: P,
    placeholder: F,
    required: $ = !1,
    rows: N,
    select: A = !1,
    SelectProps: k,
    slots: L = {},
    slotProps: B = {},
    type: V,
    value: _,
    variant: z = "outlined",
    ...j
  } = o, W = {
    ...o,
    autoFocus: i,
    color: c,
    disabled: d,
    error: f,
    fullWidth: m,
    multiline: O,
    required: $,
    select: A,
    variant: z
  }, J = m8(W);
  process.env.NODE_ENV !== "production" && A && !a && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const G = gt(v), q = b && G ? `${G}-helper-text` : void 0, Z = S && G ? `${G}-label` : void 0, Y = g8[z], Q = {
    slots: L,
    slotProps: {
      input: w,
      inputLabel: g,
      htmlInput: y,
      formHelperText: p,
      select: k,
      ...B
    }
  }, ee = {}, ne = Q.slotProps.inputLabel;
  z === "outlined" && (ne && typeof ne.shrink < "u" && (ee.notched = ne.shrink), ee.label = S), A && ((!k || !k.native) && (ee.id = void 0), ee["aria-describedby"] = void 0);
  const [H, U] = bn("input", {
    elementType: Y,
    externalForwardedProps: Q,
    additionalProps: ee,
    ownerState: W
  }), [X, re] = bn("inputLabel", {
    elementType: Ru,
    externalForwardedProps: Q,
    ownerState: W
  }), [oe, le] = bn("htmlInput", {
    elementType: "input",
    externalForwardedProps: Q,
    ownerState: W
  }), [se, Ce] = bn("formHelperText", {
    elementType: _p,
    externalForwardedProps: Q,
    ownerState: W
  }), [$e, we] = bn("select", {
    elementType: Ji,
    externalForwardedProps: Q,
    ownerState: W
  }), Te = /* @__PURE__ */ C(H, {
    "aria-describedby": q,
    autoComplete: s,
    autoFocus: i,
    defaultValue: u,
    fullWidth: m,
    multiline: O,
    name: M,
    rows: N,
    maxRows: T,
    minRows: E,
    type: V,
    value: _,
    id: G,
    inputRef: x,
    onBlur: D,
    onChange: R,
    onFocus: P,
    placeholder: F,
    inputProps: le,
    slots: {
      input: L.htmlInput ? oe : void 0
    },
    ...U
  });
  return /* @__PURE__ */ ie(b8, {
    className: ae(J.root, l),
    disabled: d,
    error: f,
    fullWidth: m,
    ref: n,
    required: $,
    color: c,
    variant: z,
    ownerState: W,
    ...j,
    children: [S != null && S !== "" && /* @__PURE__ */ C(X, {
      htmlFor: G,
      id: Z,
      ...re,
      children: S
    }), A ? /* @__PURE__ */ C($e, {
      "aria-describedby": q,
      id: G,
      labelId: Z,
      value: _,
      input: Te,
      ...we,
      children: a
    }) : Te, b && /* @__PURE__ */ C(se, {
      id: q,
      ...Ce,
      children: b
    })]
  });
});
process.env.NODE_ENV !== "production" && (Is.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: r.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: r.bool,
  /**
   * @ignore
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOfType([r.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: r.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: r.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The helper text content.
   */
  helperText: r.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: r.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: r.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: r.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: r.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: r.oneOfType([r.number, r.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: r.oneOfType([r.number, r.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: r.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  /**
   * @ignore
   */
  onBlur: r.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: r.func,
  /**
   * @ignore
   */
  onFocus: r.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: r.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: r.oneOfType([r.number, r.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: r.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: r.object,
  /**
   * The size of the component.
   */
  size: r.oneOfType([r.oneOf(["medium", "small"]), r.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.shape({
    formHelperText: r.oneOfType([r.func, r.object]),
    htmlInput: r.oneOfType([r.func, r.object]),
    input: r.oneOfType([r.func, r.object]),
    inputLabel: r.oneOfType([r.func, r.object]),
    select: r.oneOfType([r.func, r.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: r.shape({
    formHelperText: r.elementType,
    htmlInput: r.elementType,
    input: r.elementType,
    inputLabel: r.elementType,
    select: r.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: r.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: r.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
function y8(e) {
  return De("MuiToggleButton", e);
}
const Ri = Ne("MuiToggleButton", ["root", "disabled", "selected", "standard", "primary", "secondary", "sizeSmall", "sizeMedium", "sizeLarge", "fullWidth"]), TC = /* @__PURE__ */ h.createContext({});
process.env.NODE_ENV !== "production" && (TC.displayName = "ToggleButtonGroupContext");
const RC = /* @__PURE__ */ h.createContext(void 0);
process.env.NODE_ENV !== "production" && (RC.displayName = "ToggleButtonGroupButtonContext");
function v8(e, t) {
  return t === void 0 || e === void 0 ? !1 : Array.isArray(t) ? t.includes(e) : e === t;
}
const C8 = (e) => {
  const {
    classes: t,
    fullWidth: n,
    selected: o,
    disabled: s,
    size: i,
    color: a
  } = e, l = {
    root: ["root", o && "selected", s && "disabled", n && "fullWidth", `size${ce(i)}`, a]
  };
  return fe(l, y8, t);
}, w8 = te(Yn, {
  name: "MuiToggleButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`size${ce(n.size)}`]];
  }
})(Fe(({
  theme: e
}) => ({
  ...e.typography.button,
  borderRadius: (e.vars || e).shape.borderRadius,
  padding: 11,
  border: `1px solid ${(e.vars || e).palette.divider}`,
  color: (e.vars || e).palette.action.active,
  [`&.${Ri.disabled}`]: {
    color: (e.vars || e).palette.action.disabled,
    border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
  },
  "&:hover": {
    textDecoration: "none",
    // Reset on mouse devices
    backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette.text.primary, e.palette.action.hoverOpacity),
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [{
    props: {
      color: "standard"
    },
    style: {
      [`&.${Ri.selected}`]: {
        color: (e.vars || e).palette.text.primary,
        backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.selectedOpacity})` : he(e.palette.text.primary, e.palette.action.selectedOpacity),
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : he(e.palette.text.primary, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.selectedOpacity})` : he(e.palette.text.primary, e.palette.action.selectedOpacity)
          }
        }
      }
    }
  }, ...Object.entries(e.palette).filter($t()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Ri.selected}`]: {
        color: (e.vars || e).palette[t].main,
        backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.selectedOpacity})` : he(e.palette[t].main, e.palette.action.selectedOpacity),
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : he(e.palette[t].main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.selectedOpacity})` : he(e.palette[t].main, e.palette.action.selectedOpacity)
          }
        }
      }
    }
  })), {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      padding: 7,
      fontSize: e.typography.pxToRem(13)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 15,
      fontSize: e.typography.pxToRem(15)
    }
  }]
}))), LM = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    value: o,
    ...s
  } = h.useContext(TC), i = h.useContext(RC), a = Fi({
    ...s,
    selected: v8(t.value, o)
  }, t), l = Be({
    props: a,
    name: "MuiToggleButton"
  }), {
    children: c,
    className: u,
    color: d = "standard",
    disabled: f = !1,
    disableFocusRipple: p = !1,
    fullWidth: m = !1,
    onChange: b,
    onClick: v,
    selected: g,
    size: y = "medium",
    value: w,
    ...x
  } = l, S = {
    ...l,
    color: d,
    disabled: f,
    disableFocusRipple: p,
    fullWidth: m,
    size: y
  }, T = C8(S), E = (M) => {
    v && (v(M, w), M.defaultPrevented) || b && b(M, w);
  }, O = i || "";
  return /* @__PURE__ */ C(w8, {
    className: ae(s.className, T.root, u, O),
    disabled: f,
    focusRipple: !p,
    ref: n,
    onClick: E,
    onChange: b,
    value: w,
    ownerState: S,
    "aria-pressed": g,
    ...x,
    children: c
  });
});
process.env.NODE_ENV !== "production" && (LM.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the button when it is in an active state.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: r.oneOfType([r.oneOf(["standard", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * Callback fired when the state changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onChange: r.func,
  /**
   * Callback fired when the button is clicked.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected button.
   */
  onClick: r.func,
  /**
   * If `true`, the button is rendered in an active state.
   */
  selected: r.bool,
  /**
   * The size of the component.
   * The prop defaults to the value inherited from the parent ToggleButtonGroup component.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["small", "medium", "large"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The value to associate with the button when selected in a
   * ToggleButtonGroup.
   */
  value: r.any.isRequired
});
function S8(e) {
  return De("MuiToggleButtonGroup", e);
}
const gn = Ne("MuiToggleButtonGroup", ["root", "selected", "horizontal", "vertical", "disabled", "grouped", "groupedHorizontal", "groupedVertical", "fullWidth", "firstButton", "lastButton", "middleButton"]), x8 = (e) => {
  const {
    classes: t,
    orientation: n,
    fullWidth: o,
    disabled: s
  } = e, i = {
    root: ["root", n, o && "fullWidth"],
    grouped: ["grouped", `grouped${ce(n)}`, s && "disabled"],
    firstButton: ["firstButton"],
    lastButton: ["lastButton"],
    middleButton: ["middleButton"]
  };
  return fe(i, S8, t);
}, T8 = te("div", {
  name: "MuiToggleButtonGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${gn.grouped}`]: t.grouped
    }, {
      [`& .${gn.grouped}`]: t[`grouped${ce(n.orientation)}`]
    }, {
      [`& .${gn.firstButton}`]: t.firstButton
    }, {
      [`& .${gn.lastButton}`]: t.lastButton
    }, {
      [`& .${gn.middleButton}`]: t.middleButton
    }, t.root, n.orientation === "vertical" && t.vertical, n.fullWidth && t.fullWidth];
  }
})(Fe(({
  theme: e
}) => ({
  display: "inline-flex",
  borderRadius: (e.vars || e).shape.borderRadius,
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column",
      [`& .${gn.grouped}`]: {
        [`&.${gn.selected} + .${gn.grouped}.${gn.selected}`]: {
          borderTop: 0,
          marginTop: 0
        }
      },
      [`& .${gn.firstButton},& .${gn.middleButton}`]: {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0
      },
      [`& .${gn.lastButton},& .${gn.middleButton}`]: {
        marginTop: -1,
        borderTop: "1px solid transparent",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
      },
      [`& .${gn.lastButton}.${Ri.disabled},& .${gn.middleButton}.${Ri.disabled}`]: {
        borderTop: "1px solid transparent"
      }
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      orientation: "horizontal"
    },
    style: {
      [`& .${gn.grouped}`]: {
        [`&.${gn.selected} + .${gn.grouped}.${gn.selected}`]: {
          borderLeft: 0,
          marginLeft: 0
        }
      },
      [`& .${gn.firstButton},& .${gn.middleButton}`]: {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      },
      [`& .${gn.lastButton},& .${gn.middleButton}`]: {
        marginLeft: -1,
        borderLeft: "1px solid transparent",
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      [`& .${gn.lastButton}.${Ri.disabled},& .${gn.middleButton}.${Ri.disabled}`]: {
        borderLeft: "1px solid transparent"
      }
    }
  }]
}))), _M = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Be({
    props: t,
    name: "MuiToggleButtonGroup"
  }), {
    children: s,
    className: i,
    color: a = "standard",
    disabled: l = !1,
    exclusive: c = !1,
    fullWidth: u = !1,
    onChange: d,
    orientation: f = "horizontal",
    size: p = "medium",
    value: m,
    ...b
  } = o, v = {
    ...o,
    disabled: l,
    fullWidth: u,
    orientation: f,
    size: p
  }, g = x8(v), y = h.useCallback((O, M) => {
    if (!d)
      return;
    const D = m && m.indexOf(M);
    let R;
    m && D >= 0 ? (R = m.slice(), R.splice(D, 1)) : R = m ? m.concat(M) : [M], d(O, R);
  }, [d, m]), w = h.useCallback((O, M) => {
    d && d(O, m === M ? null : M);
  }, [d, m]), x = h.useMemo(() => ({
    className: g.grouped,
    onChange: c ? w : y,
    value: m,
    size: p,
    fullWidth: u,
    color: a,
    disabled: l
  }), [g.grouped, c, w, y, m, p, u, a, l]), S = dV(s), T = S.length, E = (O) => {
    const M = O === 0, D = O === T - 1;
    return M && D ? "" : M ? g.firstButton : D ? g.lastButton : g.middleButton;
  };
  return /* @__PURE__ */ C(T8, {
    role: "group",
    className: ae(g.root, i),
    ref: n,
    ownerState: v,
    ...b,
    children: /* @__PURE__ */ C(TC.Provider, {
      value: x,
      children: S.map((O, M) => (process.env.NODE_ENV !== "production" && Js.isFragment(O) && console.error(["MUI: The ToggleButtonGroup component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), /* @__PURE__ */ C(RC.Provider, {
        value: E(M),
        children: O
      }, M)))
    })
  });
});
process.env.NODE_ENV !== "production" && (_M.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * @ignore
   */
  className: r.string,
  /**
   * The color of the button when it is selected.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: r.oneOfType([r.oneOf(["standard", "primary", "secondary", "error", "info", "success", "warning"]), r.string]),
  /**
   * If `true`, the component is disabled. This implies that all ToggleButton children will be disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, only allow one of the child ToggleButton values to be selected.
   * @default false
   */
  exclusive: r.bool,
  /**
   * If `true`, the button group will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.MouseEvent<HTMLElement>} event The event source of the callback.
   * @param {any} value of the selected buttons. When `exclusive` is true
   * this is a single value; when false an array of selected values. If no value
   * is selected and `exclusive` is true the value is null; when false an empty array.
   */
  onChange: r.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: r.oneOf(["horizontal", "vertical"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: r.oneOfType([r.oneOf(["small", "medium", "large"]), r.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The currently selected value within the group or an array of selected
   * values when `exclusive` is false.
   *
   * The value must have reference equality with the option in order to be selected.
   */
  value: r.any
});
const Gt = rs((e, t) => /* @__PURE__ */ C(vt, { ...e, ref: t })), Ve = ({
  children: e,
  iconFamily: t = "material",
  rotate: n,
  ...o
}) => {
  const s = n ? { ...o, style: { transform: `rotate(${n}deg)` } } : o;
  return typeof e == "string" ? t === "material" ? /* @__PURE__ */ C(yo, { ...s, children: e }) : null : Gr(
    e,
    {
      ...s
    }
  );
}, zbe = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "assistant" }), Hbe = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "live_help" }), jbe = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "check_box_outline_blank" }), Gbe = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "cloud_download" }), qbe = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "send" }), Wbe = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "more_vert" }), Ube = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "fiber_new" }), Kbe = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "trending_up" }), Ybe = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "group_work" }), Xbe = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "account_balance_wallet" }), Qbe = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "extension" }), Zbe = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "error" }), Jbe = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "warning" }), eye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "support_agent" }), tye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "location_on" }), nye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "access_time" }), oye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "directions_car" }), rye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "attach_money" }), sye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "event" }), iye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "accessibility" }), aye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "child_friendly" }), lye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "local_bar" }), cye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "chat_bubble" }), uye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "person" }), dye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "announcement" }), fye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "person_add" }), pye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "alarm_on" }), hye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "block" }), gye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "create" }), mye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "message" }), bye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "star" }), yye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "insert_chart" }), vye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "settings" }), Cye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "people" }), wye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "extension" }), Sye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "attach_file" }), xye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "photo" }), Tye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "live_help" }), R8 = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "cloud_upload" }), E8 = (e) => (
  // @ts-expect-error FIXME: No overload matches this call.
  /* @__PURE__ */ C(Ve, { sx: { transform: "rotate(-90deg)" }, ...e, children: "note" })
), Rye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "rate_review" }), Eye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "update" }), Iye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "swap_horiz" }), Oye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "language" }), Pye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "help" }), Mye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "reply_all" }), kye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "perm_phone_msg" }), Dye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "question_answer" }), I8 = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "expand_more" }), Nye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "expand_less" }), $ye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "local_library" }), Aye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "chevron_left" }), Fye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "chevron_right" }), Lye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "check_circle" }), _ye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "all_inclusive" }), Vye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "sentiment_very_satisfied" }), Bye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "call_missed" }), zye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "watch" }), Hye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "insert_chart" }), jye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "delegate" }), Gye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "device_hub" }), qye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "local_offer" }), Wye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "sms_failed" }), Uye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "remove_circle_outline" }), Kye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "add_circle_outline" }), Yye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "radio_button_unchecked" }), Xye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "radio_button_checked" }), Qye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "check_box" }), Zye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "check_box_outline_blank" }), Jye = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "check" }), eve = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "delete" }), tve = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "edit" }), nve = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "error" }), ove = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "event" }), rve = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "link" }), sve = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "thumb_down" }), ive = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "thumb_up" }), ave = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "contact_phone" }), lve = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "stars" }), cve = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "email" }), uve = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "arrow_back" }), dve = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "face" }), fve = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "phone_callback" }), pve = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "phone" }), O8 = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "search" }), hve = (e) => /* @__PURE__ */ C(Ve, { ...e, children: "refresh" }), gve = ({
  summary: e,
  children: t,
  smallIcon: n,
  hideDivider: o,
  ...s
}) => {
  const i = `${s.id}-content`;
  return /* @__PURE__ */ ie(
    _v,
    {
      "aria-controls": i,
      sx: {
        width: "100%",
        backgroundColor: "transparent",
        ...o && {
          "&:before": {
            display: "none"
          }
        }
      },
      disableGutters: !0,
      ...s,
      children: [
        /* @__PURE__ */ C(
          Bv,
          {
            sx: {
              background: "transparent",
              alignItems: n ? "flex-start" : void 0,
              "& .MuiAccordionSummary-expandIconWrapper": {
                top: n ? 10 : void 0
              },
              ...o && {
                "&:before": {
                  display: "none"
                }
              }
            },
            expandIcon: /* @__PURE__ */ C(I8, { fontSize: n ? "small" : "medium" }),
            children: e
          }
        ),
        /* @__PURE__ */ C(Vv, { sx: { padding: 0 }, children: /* @__PURE__ */ C(Gt, { id: i, children: t }) })
      ]
    }
  );
}, mve = ({ children: e, ...t }) => /* @__PURE__ */ C(FP, { ...t, children: e }), my = ({
  children: e,
  ...t
}) => /* @__PURE__ */ C(Fp, { ...t, children: e }), P8 = ({
  children: e,
  ...t
}) => /* @__PURE__ */ C(Ya, { ...t, children: e }), M8 = ({ children: e, ...t }) => /* @__PURE__ */ C(ti, { ...t, children: e }), k8 = ({
  children: e,
  from: t,
  ...n
}) => /* @__PURE__ */ C(vs, { style: { transformOrigin: t }, ...n, children: e }), D8 = ({ value: e, variant: t }) => /* @__PURE__ */ C(oC, { value: e, variant: t }), bve = ({
  children: e,
  variant: t,
  width: n,
  height: o
}) => /* @__PURE__ */ C(bC, { variant: t, width: n, height: o, children: e }), N8 = ({ children: e, ...t }) => /* @__PURE__ */ C(Lp, { ...t, children: e }), yve = ({ position: e, color: t, children: n }) => /* @__PURE__ */ C(LP, { color: t, position: e, children: /* @__PURE__ */ C(Bp, { disableGutters: !0, children: n }) }), vve = Np, Cve = ({ children: e, ...t }) => /* @__PURE__ */ C(Xv, { ...t, children: e }), wve = ({ children: e, ...t }) => /* @__PURE__ */ C(YP, { ...t, children: e }), Sve = ({ children: e, ...t }) => /* @__PURE__ */ C($p, { ...t, children: e }), xve = ({ children: e, ...t }) => /* @__PURE__ */ C(Qv, { variant: "dot", ...t, children: e }), $8 = (e) => {
  switch (e) {
    case "small":
      return "caption.fontSize";
    case "medium":
      return "body2.fontSize";
    default:
      return "inherit";
  }
}, Kh = {
  small: {
    paddingX: 1.5,
    paddingY: 1
  },
  medium: {
    paddingX: 2,
    paddingY: 1
  },
  large: {
    paddingX: 2,
    paddingY: 1.5
  },
  inherit: {
    paddingX: 2,
    paddingY: 1
  }
}, Tve = ({
  children: e,
  color: t = "primary",
  size: n = "inherit",
  visible: o = !0,
  animated: s = !0,
  variant: i = "default",
  justifyContent: a = "center",
  iconName: l = "info_outline",
  sticky: c,
  includeIcon: u,
  onClose: d,
  ...f
}) => {
  if (!e) return null;
  const p = /* @__PURE__ */ ie(
    vt,
    {
      sx: (m) => ({
        display: "flex",
        gap: 1,
        justifyContent: a,
        alignItems: "center",
        color: i === "default" ? m.palette[t].contrastText : m.palette.text.primary,
        backgroundColor: i === "default" ? m.palette[t].main : m.palette[t].background,
        paddingX: Kh[n].paddingX,
        paddingY: Kh[n].paddingY,
        fontSize: $8(n),
        zIndex: 1,
        top: 0,
        left: 0,
        right: 0,
        position: c ? "sticky" : "static",
        overflowY: "hidden",
        overflowX: "auto",
        "& a": {
          color: "inherit"
        }
      }),
      ...f,
      children: [
        u && /* @__PURE__ */ C(yo, { children: l }),
        e,
        /* @__PURE__ */ C(
          vt,
          {
            sx: {
              position: "absolute",
              right: (m) => m.spacing(Kh[n].paddingX),
              height: "100%",
              display: "flex",
              alignItems: "center"
            },
            children: d && /* @__PURE__ */ C(yo, { onClick: d, children: "close" })
          }
        )
      ]
    }
  );
  return s ? /* @__PURE__ */ C(Ya, { in: o, children: p }) : p;
}, VM = ({ children: e, ...t }) => /* @__PURE__ */ C(Vp, { ...t, children: e }), BM = ({
  children: e,
  spacing: t = 1,
  fullWidth: n = !1,
  color: o,
  justifyContent: s = "flex-start",
  sx: i,
  ...a
}) => /* @__PURE__ */ C(
  vt,
  {
    gap: t,
    display: "flex",
    flexDirection: "row",
    sx: {
      color: o ? `${o}.main` : void 0,
      backgroundColor: o ? `${o}.background` : void 0,
      "& > *": n ? { flex: 1 } : void 0,
      ...i
    },
    justifyContent: s,
    ...a,
    children: e
  }
), Of = ({
  variant: e,
  disabled: t,
  children: n,
  tooltip: o,
  color: s = "secondary",
  isPrimary: i = !1,
  inProgress: a = !1,
  type: l = "button",
  whiteSpace: c = "normal",
  ...u
}) => /* @__PURE__ */ C(
  Io,
  {
    disabled: a || t,
    type: i ? "submit" : l,
    variant: i ? "contained" : e,
    color: s,
    sx: {
      whiteSpace: c
    },
    ...u,
    children: /* @__PURE__ */ C(VM, { title: o, children: /* @__PURE__ */ ie(BM, { alignItems: "center", children: [
      a && /* @__PURE__ */ C(my, { color: s, size: "0.8rem" }),
      n
    ] }) })
  }
), Rve = rs(
  ({ children: e, ...t }, n) => /* @__PURE__ */ C(Yn, { ...t, ref: n, children: e })
), Eve = ({
  children: e,
  withoutSeparator: t,
  withGap: n,
  align: o = "left"
}) => {
  const s = sn();
  let i = "flex-start";
  switch (o) {
    case "left":
      i = "flex-start";
      break;
    case "right":
      i = "flex-end";
      break;
  }
  return /* @__PURE__ */ C(
    vt,
    {
      sx: {
        display: "flex",
        borderRight: t ? "none" : "1px solid",
        borderColor: s.palette.divider,
        paddingRight: t ? 0 : 5,
        gap: n ? 1 : 0,
        justifyContent: i,
        "&:last-child": {
          borderRight: "none",
          paddingRight: 0
        },
        "& .MuiButton-root:not(:last-child)": {
          borderRight: n ? void 0 : "none"
        },
        ...n ? {} : {
          "& .MuiButton-root:not(:last-child):not(:first-child)": {
            borderRadius: 0
          },
          "& .MuiButton-root:first-child": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0
          },
          "& .MuiButton-root:last-child": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0
          }
        }
      },
      children: e
    }
  );
}, zp = ({
  icon: e,
  iconProps: t,
  color: n = "secondary",
  tooltip: o,
  iconOnly: s,
  tooltipPlacement: i,
  withBorder: a,
  ...l
}) => /* @__PURE__ */ C(Vp, { title: o, placement: i, children: /* @__PURE__ */ C(
  Eo,
  {
    color: n,
    ...l,
    sx: {
      border: a ? 1 : 0,
      padding: s ? 0 : void 0
    },
    children: /* @__PURE__ */ C(Ve, { ...t, children: e })
  }
) });
var Yh, C1;
function zM() {
  if (C1) return Yh;
  C1 = 1;
  var e = typeof td == "object" && td && td.Object === Object && td;
  return Yh = e, Yh;
}
var Xh, w1;
function ea() {
  if (w1) return Xh;
  w1 = 1;
  var e = zM(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return Xh = n, Xh;
}
var Qh, S1;
function HM() {
  if (S1) return Qh;
  S1 = 1;
  var e = ea(), t = e.Symbol;
  return Qh = t, Qh;
}
var Zh, x1;
function A8() {
  if (x1) return Zh;
  x1 = 1;
  var e = HM(), t = Object.prototype, n = t.hasOwnProperty, o = t.toString, s = e ? e.toStringTag : void 0;
  function i(a) {
    var l = n.call(a, s), c = a[s];
    try {
      a[s] = void 0;
      var u = !0;
    } catch {
    }
    var d = o.call(a);
    return u && (l ? a[s] = c : delete a[s]), d;
  }
  return Zh = i, Zh;
}
var Jh, T1;
function F8() {
  if (T1) return Jh;
  T1 = 1;
  var e = Object.prototype, t = e.toString;
  function n(o) {
    return t.call(o);
  }
  return Jh = n, Jh;
}
var eg, R1;
function Cl() {
  if (R1) return eg;
  R1 = 1;
  var e = HM(), t = A8(), n = F8(), o = "[object Null]", s = "[object Undefined]", i = e ? e.toStringTag : void 0;
  function a(l) {
    return l == null ? l === void 0 ? s : o : i && i in Object(l) ? t(l) : n(l);
  }
  return eg = a, eg;
}
var tg, E1;
function EC() {
  if (E1) return tg;
  E1 = 1;
  var e = Array.isArray;
  return tg = e, tg;
}
var ng, I1;
function ta() {
  if (I1) return ng;
  I1 = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return ng = e, ng;
}
var og, O1;
function L8() {
  if (O1) return og;
  O1 = 1;
  var e = Cl(), t = EC(), n = ta(), o = "[object String]";
  function s(i) {
    return typeof i == "string" || !t(i) && n(i) && e(i) == o;
  }
  return og = s, og;
}
var _8 = L8();
const Pf = /* @__PURE__ */ Zo(_8), V8 = ({
  toCopy: e,
  children: t,
  ...n
}) => /* @__PURE__ */ C(mo, { children: /* @__PURE__ */ C(
  zp,
  {
    disabled: !Pf(e),
    tooltip: "Copy",
    icon: "content_copy",
    onClick: () => B8(e),
    ...n
  }
) }), B8 = (e) => {
  if (navigator.clipboard)
    navigator.clipboard.writeText(e);
  else {
    const t = document.createElement("input");
    t.value = e, document.body.appendChild(t), t.select(), t.setSelectionRange(0, 99999), document.execCommand("copy"), document.body.removeChild(t);
  }
}, z8 = ({ border: e, borderLeft: t, borderRight: n, borderTop: o, borderBottom: s }, i = "divider", a = "1px", l = "solid") => !e && !t && !n && !o && !s ? {} : {
  border: e ? `${a} ${l}` : void 0,
  borderLeft: t ? `${a} ${l}` : void 0,
  borderRight: n ? `${a} ${l}` : void 0,
  borderTop: o ? `${a} ${l}` : void 0,
  borderBottom: s ? `${a} ${l}` : void 0,
  borderColor: i
}, H8 = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function j8(e = {}) {
  const {
    disableGlobal: t = !1,
    productionPrefix: n = "jss",
    seed: o = ""
  } = e, s = o === "" ? "" : `${o}-`;
  let i = 0;
  const a = () => (i += 1, process.env.NODE_ENV !== "production" && i >= 1e10 && console.warn(["MUI: You might have a memory leak.", "The ruleCounter is not supposed to grow that much."].join("")), i);
  return (l, c) => {
    const u = c.options.name;
    if (u && u.startsWith("Mui") && !c.options.link && !t) {
      if (H8.includes(l.key))
        return `Mui-${l.key}`;
      const f = `${s}${u}-${l.key}`;
      return !c.options.theme[yP] || o !== "" ? f : `${f}-${a()}`;
    }
    if (process.env.NODE_ENV === "production")
      return `${s}${n}${a()}`;
    const d = `${l.key}-${a()}`;
    return c.options.classNamePrefix ? `${s}${c.options.classNamePrefix}-${d}` : `${s}${d}`;
  };
}
function G8(e) {
  const {
    theme: t,
    name: n,
    props: o
  } = e;
  if (!t || !t.components || !t.components[n] || !t.components[n].defaultProps)
    return o;
  const s = {
    ...o
  }, i = t.components[n].defaultProps;
  let a;
  for (a in i)
    s[a] === void 0 && (s[a] = i[a]);
  return s;
}
var q8 = process.env.NODE_ENV === "production";
function vr(e, t) {
  if (!q8) {
    var n = "Warning: " + t;
    typeof console < "u" && console.warn(n);
    try {
      throw Error(n);
    } catch {
    }
  }
}
var P1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
  return typeof e;
} : function(e) {
  return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, Pu = (typeof window > "u" ? "undefined" : P1(window)) === "object" && (typeof document > "u" ? "undefined" : P1(document)) === "object" && document.nodeType === 9;
function Uc(e) {
  "@babel/helpers - typeof";
  return Uc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Uc(e);
}
function W8(e, t) {
  if (Uc(e) != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (Uc(o) != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function sl(e) {
  var t = W8(e, "string");
  return Uc(t) == "symbol" ? t : t + "";
}
function U8(e, t) {
  for (var n = 0; n < t.length; n++) {
    var o = t[n];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, sl(o.key), o);
  }
}
function jM(e, t, n) {
  return t && U8(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
var K8 = {}.constructor;
function by(e) {
  if (e == null || typeof e != "object") return e;
  if (Array.isArray(e)) return e.map(by);
  if (e.constructor !== K8) return e;
  var t = {};
  for (var n in e)
    t[n] = by(e[n]);
  return t;
}
function IC(e, t, n) {
  e === void 0 && (e = "unnamed");
  var o = n.jss, s = by(t), i = o.plugins.onCreateRule(e, s, n);
  return i || (e[0] === "@" && process.env.NODE_ENV !== "production" && vr(!1, "[JSS] Unknown rule " + e), null);
}
var M1 = function(t, n) {
  for (var o = "", s = 0; s < t.length && t[s] !== "!important"; s++)
    o && (o += n), o += t[s];
  return o;
}, Di = function(t) {
  if (!Array.isArray(t)) return t;
  var n = "";
  if (Array.isArray(t[0]))
    for (var o = 0; o < t.length && t[o] !== "!important"; o++)
      n && (n += ", "), n += M1(t[o], " ");
  else n = M1(t, ", ");
  return t[t.length - 1] === "!important" && (n += " !important"), n;
};
function wl(e) {
  return e && e.format === !1 ? {
    linebreak: "",
    space: ""
  } : {
    linebreak: `
`,
    space: " "
  };
}
function Gl(e, t) {
  for (var n = "", o = 0; o < t; o++)
    n += "  ";
  return n + e;
}
function Kc(e, t, n) {
  n === void 0 && (n = {});
  var o = "";
  if (!t) return o;
  var s = n, i = s.indent, a = i === void 0 ? 0 : i, l = t.fallbacks;
  n.format === !1 && (a = -1 / 0);
  var c = wl(n), u = c.linebreak, d = c.space;
  if (e && a++, l)
    if (Array.isArray(l))
      for (var f = 0; f < l.length; f++) {
        var p = l[f];
        for (var m in p) {
          var b = p[m];
          b != null && (o && (o += u), o += Gl(m + ":" + d + Di(b) + ";", a));
        }
      }
    else
      for (var v in l) {
        var g = l[v];
        g != null && (o && (o += u), o += Gl(v + ":" + d + Di(g) + ";", a));
      }
  for (var y in t) {
    var w = t[y];
    w != null && y !== "fallbacks" && (o && (o += u), o += Gl(y + ":" + d + Di(w) + ";", a));
  }
  return !o && !n.allowEmpty || !e ? o : (a--, o && (o = "" + u + o + u), Gl("" + e + d + "{" + o, a) + Gl("}", a));
}
var Y8 = /([[\].#*$><+~=|^:(),"'`\s])/g, k1 = typeof CSS < "u" && CSS.escape, OC = function(e) {
  return k1 ? k1(e) : e.replace(Y8, "\\$1");
}, GM = /* @__PURE__ */ function() {
  function e(n, o, s) {
    this.type = "style", this.isProcessed = !1;
    var i = s.sheet, a = s.Renderer;
    this.key = n, this.options = s, this.style = o, i ? this.renderer = i.renderer : a && (this.renderer = new a());
  }
  var t = e.prototype;
  return t.prop = function(o, s, i) {
    if (s === void 0) return this.style[o];
    var a = i ? i.force : !1;
    if (!a && this.style[o] === s) return this;
    var l = s;
    (!i || i.process !== !1) && (l = this.options.jss.plugins.onChangeValue(s, o, this));
    var c = l == null || l === !1, u = o in this.style;
    if (c && !u && !a) return this;
    var d = c && u;
    if (d ? delete this.style[o] : this.style[o] = l, this.renderable && this.renderer)
      return d ? this.renderer.removeProperty(this.renderable, o) : this.renderer.setProperty(this.renderable, o, l), this;
    var f = this.options.sheet;
    return f && f.attached && process.env.NODE_ENV !== "production" && vr(!1, '[JSS] Rule is not linked. Missing sheet option "link: true".'), this;
  }, e;
}(), yy = /* @__PURE__ */ function(e) {
  yu(t, e);
  function t(o, s, i) {
    var a;
    a = e.call(this, o, s, i) || this;
    var l = i.selector, c = i.scoped, u = i.sheet, d = i.generateId;
    return l ? a.selectorText = l : c !== !1 && (a.id = d(ty(ty(a)), u), a.selectorText = "." + OC(a.id)), a;
  }
  var n = t.prototype;
  return n.applyTo = function(s) {
    var i = this.renderer;
    if (i) {
      var a = this.toJSON();
      for (var l in a)
        i.setProperty(s, l, a[l]);
    }
    return this;
  }, n.toJSON = function() {
    var s = {};
    for (var i in this.style) {
      var a = this.style[i];
      typeof a != "object" ? s[i] = a : Array.isArray(a) && (s[i] = Di(a));
    }
    return s;
  }, n.toString = function(s) {
    var i = this.options.sheet, a = i ? i.options.link : !1, l = a ? I({}, s, {
      allowEmpty: !0
    }) : s;
    return Kc(this.selectorText, this.style, l);
  }, jM(t, [{
    key: "selector",
    set: function(s) {
      if (s !== this.selectorText) {
        this.selectorText = s;
        var i = this.renderer, a = this.renderable;
        if (!(!a || !i)) {
          var l = i.setSelector(a, s);
          l || i.replaceRule(a, this);
        }
      }
    },
    get: function() {
      return this.selectorText;
    }
  }]), t;
}(GM), X8 = {
  onCreateRule: function(t, n, o) {
    return t[0] === "@" || o.parent && o.parent.type === "keyframes" ? null : new yy(t, n, o);
  }
}, rg = {
  indent: 1,
  children: !0
}, Q8 = /@([\w-]+)/, Z8 = /* @__PURE__ */ function() {
  function e(n, o, s) {
    this.type = "conditional", this.isProcessed = !1, this.key = n;
    var i = n.match(Q8);
    this.at = i ? i[1] : "unknown", this.query = s.name || "@" + this.at, this.options = s, this.rules = new Hp(I({}, s, {
      parent: this
    }));
    for (var a in o)
      this.rules.add(a, o[a]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.getRule = function(o) {
    return this.rules.get(o);
  }, t.indexOf = function(o) {
    return this.rules.indexOf(o);
  }, t.addRule = function(o, s, i) {
    var a = this.rules.add(o, s, i);
    return a ? (this.options.jss.plugins.onProcessRule(a), a) : null;
  }, t.replaceRule = function(o, s, i) {
    var a = this.rules.replace(o, s, i);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, t.toString = function(o) {
    o === void 0 && (o = rg);
    var s = wl(o), i = s.linebreak;
    if (o.indent == null && (o.indent = rg.indent), o.children == null && (o.children = rg.children), o.children === !1)
      return this.query + " {}";
    var a = this.rules.toString(o);
    return a ? this.query + " {" + i + a + i + "}" : "";
  }, e;
}(), J8 = /@container|@media|@supports\s+/, eq = {
  onCreateRule: function(t, n, o) {
    return J8.test(t) ? new Z8(t, n, o) : null;
  }
}, sg = {
  indent: 1,
  children: !0
}, tq = /@keyframes\s+([\w-]+)/, vy = /* @__PURE__ */ function() {
  function e(n, o, s) {
    this.type = "keyframes", this.at = "@keyframes", this.isProcessed = !1;
    var i = n.match(tq);
    i && i[1] ? this.name = i[1] : (this.name = "noname", process.env.NODE_ENV !== "production" && vr(!1, "[JSS] Bad keyframes name " + n)), this.key = this.type + "-" + this.name, this.options = s;
    var a = s.scoped, l = s.sheet, c = s.generateId;
    this.id = a === !1 ? this.name : OC(c(this, l)), this.rules = new Hp(I({}, s, {
      parent: this
    }));
    for (var u in o)
      this.rules.add(u, o[u], I({}, s, {
        parent: this
      }));
    this.rules.process();
  }
  var t = e.prototype;
  return t.toString = function(o) {
    o === void 0 && (o = sg);
    var s = wl(o), i = s.linebreak;
    if (o.indent == null && (o.indent = sg.indent), o.children == null && (o.children = sg.children), o.children === !1)
      return this.at + " " + this.id + " {}";
    var a = this.rules.toString(o);
    return a && (a = "" + i + a + i), this.at + " " + this.id + " {" + a + "}";
  }, e;
}(), nq = /@keyframes\s+/, oq = /\$([\w-]+)/g, Cy = function(t, n) {
  return typeof t == "string" ? t.replace(oq, function(o, s) {
    return s in n ? n[s] : (process.env.NODE_ENV !== "production" && vr(!1, '[JSS] Referenced keyframes rule "' + s + '" is not defined.'), o);
  }) : t;
}, D1 = function(t, n, o) {
  var s = t[n], i = Cy(s, o);
  i !== s && (t[n] = i);
}, rq = {
  onCreateRule: function(t, n, o) {
    return typeof t == "string" && nq.test(t) ? new vy(t, n, o) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function(t, n, o) {
    return n.type !== "style" || !o || ("animation-name" in t && D1(t, "animation-name", o.keyframes), "animation" in t && D1(t, "animation", o.keyframes)), t;
  },
  onChangeValue: function(t, n, o) {
    var s = o.options.sheet;
    if (!s)
      return t;
    switch (n) {
      case "animation":
        return Cy(t, s.keyframes);
      case "animation-name":
        return Cy(t, s.keyframes);
      default:
        return t;
    }
  }
}, sq = /* @__PURE__ */ function(e) {
  yu(t, e);
  function t() {
    return e.apply(this, arguments) || this;
  }
  var n = t.prototype;
  return n.toString = function(s) {
    var i = this.options.sheet, a = i ? i.options.link : !1, l = a ? I({}, s, {
      allowEmpty: !0
    }) : s;
    return Kc(this.key, this.style, l);
  }, t;
}(GM), iq = {
  onCreateRule: function(t, n, o) {
    return o.parent && o.parent.type === "keyframes" ? new sq(t, n, o) : null;
  }
}, aq = /* @__PURE__ */ function() {
  function e(n, o, s) {
    this.type = "font-face", this.at = "@font-face", this.isProcessed = !1, this.key = n, this.style = o, this.options = s;
  }
  var t = e.prototype;
  return t.toString = function(o) {
    var s = wl(o), i = s.linebreak;
    if (Array.isArray(this.style)) {
      for (var a = "", l = 0; l < this.style.length; l++)
        a += Kc(this.at, this.style[l]), this.style[l + 1] && (a += i);
      return a;
    }
    return Kc(this.at, this.style, o);
  }, e;
}(), lq = /@font-face/, cq = {
  onCreateRule: function(t, n, o) {
    return lq.test(t) ? new aq(t, n, o) : null;
  }
}, uq = /* @__PURE__ */ function() {
  function e(n, o, s) {
    this.type = "viewport", this.at = "@viewport", this.isProcessed = !1, this.key = n, this.style = o, this.options = s;
  }
  var t = e.prototype;
  return t.toString = function(o) {
    return Kc(this.key, this.style, o);
  }, e;
}(), dq = {
  onCreateRule: function(t, n, o) {
    return t === "@viewport" || t === "@-ms-viewport" ? new uq(t, n, o) : null;
  }
}, fq = /* @__PURE__ */ function() {
  function e(n, o, s) {
    this.type = "simple", this.isProcessed = !1, this.key = n, this.value = o, this.options = s;
  }
  var t = e.prototype;
  return t.toString = function(o) {
    if (Array.isArray(this.value)) {
      for (var s = "", i = 0; i < this.value.length; i++)
        s += this.key + " " + this.value[i] + ";", this.value[i + 1] && (s += `
`);
      return s;
    }
    return this.key + " " + this.value + ";";
  }, e;
}(), pq = {
  "@charset": !0,
  "@import": !0,
  "@namespace": !0
}, hq = {
  onCreateRule: function(t, n, o) {
    return t in pq ? new fq(t, n, o) : null;
  }
}, N1 = [X8, eq, rq, iq, cq, dq, hq], gq = {
  process: !0
}, $1 = {
  force: !0,
  process: !0
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
}, Hp = /* @__PURE__ */ function() {
  function e(n) {
    this.map = {}, this.raw = {}, this.index = [], this.counter = 0, this.options = n, this.classes = n.classes, this.keyframes = n.keyframes;
  }
  var t = e.prototype;
  return t.add = function(o, s, i) {
    var a = this.options, l = a.parent, c = a.sheet, u = a.jss, d = a.Renderer, f = a.generateId, p = a.scoped, m = I({
      classes: this.classes,
      parent: l,
      sheet: c,
      jss: u,
      Renderer: d,
      generateId: f,
      scoped: p,
      name: o,
      keyframes: this.keyframes,
      selector: void 0
    }, i), b = o;
    o in this.raw && (b = o + "-d" + this.counter++), this.raw[b] = s, b in this.classes && (m.selector = "." + OC(this.classes[b]));
    var v = IC(b, s, m);
    if (!v) return null;
    this.register(v);
    var g = m.index === void 0 ? this.index.length : m.index;
    return this.index.splice(g, 0, v), v;
  }, t.replace = function(o, s, i) {
    var a = this.get(o), l = this.index.indexOf(a);
    a && this.remove(a);
    var c = i;
    return l !== -1 && (c = I({}, i, {
      index: l
    })), this.add(o, s, c);
  }, t.get = function(o) {
    return this.map[o];
  }, t.remove = function(o) {
    this.unregister(o), delete this.raw[o.key], this.index.splice(this.index.indexOf(o), 1);
  }, t.indexOf = function(o) {
    return this.index.indexOf(o);
  }, t.process = function() {
    var o = this.options.jss.plugins;
    this.index.slice(0).forEach(o.onProcessRule, o);
  }, t.register = function(o) {
    this.map[o.key] = o, o instanceof yy ? (this.map[o.selector] = o, o.id && (this.classes[o.key] = o.id)) : o instanceof vy && this.keyframes && (this.keyframes[o.name] = o.id);
  }, t.unregister = function(o) {
    delete this.map[o.key], o instanceof yy ? (delete this.map[o.selector], delete this.classes[o.key]) : o instanceof vy && delete this.keyframes[o.name];
  }, t.update = function() {
    var o, s, i;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) == "string" ? (o = arguments.length <= 0 ? void 0 : arguments[0], s = arguments.length <= 1 ? void 0 : arguments[1], i = arguments.length <= 2 ? void 0 : arguments[2]) : (s = arguments.length <= 0 ? void 0 : arguments[0], i = arguments.length <= 1 ? void 0 : arguments[1], o = null), o)
      this.updateOne(this.get(o), s, i);
    else
      for (var a = 0; a < this.index.length; a++)
        this.updateOne(this.index[a], s, i);
  }, t.updateOne = function(o, s, i) {
    i === void 0 && (i = gq);
    var a = this.options, l = a.jss.plugins, c = a.sheet;
    if (o.rules instanceof e) {
      o.rules.update(s, i);
      return;
    }
    var u = o.style;
    if (l.onUpdate(s, o, c, i), i.process && u && u !== o.style) {
      l.onProcessStyle(o.style, o, c);
      for (var d in o.style) {
        var f = o.style[d], p = u[d];
        f !== p && o.prop(d, f, $1);
      }
      for (var m in u) {
        var b = o.style[m], v = u[m];
        b == null && b !== v && o.prop(m, null, $1);
      }
    }
  }, t.toString = function(o) {
    for (var s = "", i = this.options.sheet, a = i ? i.options.link : !1, l = wl(o), c = l.linebreak, u = 0; u < this.index.length; u++) {
      var d = this.index[u], f = d.toString(o);
      !f && !a || (s && (s += c), s += f);
    }
    return s;
  }, e;
}(), qM = /* @__PURE__ */ function() {
  function e(n, o) {
    this.attached = !1, this.deployed = !1, this.classes = {}, this.keyframes = {}, this.options = I({}, o, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    }), o.Renderer && (this.renderer = new o.Renderer(this)), this.rules = new Hp(this.options);
    for (var s in n)
      this.rules.add(s, n[s]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.attach = function() {
    return this.attached ? this : (this.renderer && this.renderer.attach(), this.attached = !0, this.deployed || this.deploy(), this);
  }, t.detach = function() {
    return this.attached ? (this.renderer && this.renderer.detach(), this.attached = !1, this) : this;
  }, t.addRule = function(o, s, i) {
    var a = this.queue;
    this.attached && !a && (this.queue = []);
    var l = this.rules.add(o, s, i);
    return l ? (this.options.jss.plugins.onProcessRule(l), this.attached ? (this.deployed && (a ? a.push(l) : (this.insertRule(l), this.queue && (this.queue.forEach(this.insertRule, this), this.queue = void 0))), l) : (this.deployed = !1, l)) : null;
  }, t.replaceRule = function(o, s, i) {
    var a = this.rules.get(o);
    if (!a) return this.addRule(o, s, i);
    var l = this.rules.replace(o, s, i);
    return l && this.options.jss.plugins.onProcessRule(l), this.attached ? (this.deployed && this.renderer && (l ? a.renderable && this.renderer.replaceRule(a.renderable, l) : this.renderer.deleteRule(a)), l) : (this.deployed = !1, l);
  }, t.insertRule = function(o) {
    this.renderer && this.renderer.insertRule(o);
  }, t.addRules = function(o, s) {
    var i = [];
    for (var a in o) {
      var l = this.addRule(a, o[a], s);
      l && i.push(l);
    }
    return i;
  }, t.getRule = function(o) {
    return this.rules.get(o);
  }, t.deleteRule = function(o) {
    var s = typeof o == "object" ? o : this.rules.get(o);
    return !s || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !s.renderable ? !1 : (this.rules.remove(s), this.attached && s.renderable && this.renderer ? this.renderer.deleteRule(s.renderable) : !0);
  }, t.indexOf = function(o) {
    return this.rules.indexOf(o);
  }, t.deploy = function() {
    return this.renderer && this.renderer.deploy(), this.deployed = !0, this;
  }, t.update = function() {
    var o;
    return (o = this.rules).update.apply(o, arguments), this;
  }, t.updateOne = function(o, s, i) {
    return this.rules.updateOne(o, s, i), this;
  }, t.toString = function(o) {
    return this.rules.toString(o);
  }, e;
}(), mq = /* @__PURE__ */ function() {
  function e() {
    this.plugins = {
      internal: [],
      external: []
    }, this.registry = {};
  }
  var t = e.prototype;
  return t.onCreateRule = function(o, s, i) {
    for (var a = 0; a < this.registry.onCreateRule.length; a++) {
      var l = this.registry.onCreateRule[a](o, s, i);
      if (l) return l;
    }
    return null;
  }, t.onProcessRule = function(o) {
    if (!o.isProcessed) {
      for (var s = o.options.sheet, i = 0; i < this.registry.onProcessRule.length; i++)
        this.registry.onProcessRule[i](o, s);
      o.style && this.onProcessStyle(o.style, o, s), o.isProcessed = !0;
    }
  }, t.onProcessStyle = function(o, s, i) {
    for (var a = 0; a < this.registry.onProcessStyle.length; a++)
      s.style = this.registry.onProcessStyle[a](s.style, s, i);
  }, t.onProcessSheet = function(o) {
    for (var s = 0; s < this.registry.onProcessSheet.length; s++)
      this.registry.onProcessSheet[s](o);
  }, t.onUpdate = function(o, s, i, a) {
    for (var l = 0; l < this.registry.onUpdate.length; l++)
      this.registry.onUpdate[l](o, s, i, a);
  }, t.onChangeValue = function(o, s, i) {
    for (var a = o, l = 0; l < this.registry.onChangeValue.length; l++)
      a = this.registry.onChangeValue[l](a, s, i);
    return a;
  }, t.use = function(o, s) {
    s === void 0 && (s = {
      queue: "external"
    });
    var i = this.plugins[s.queue];
    i.indexOf(o) === -1 && (i.push(o), this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(a, l) {
      for (var c in l)
        c in a ? a[c].push(l[c]) : process.env.NODE_ENV !== "production" && vr(!1, '[JSS] Unknown hook "' + c + '".');
      return a;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    }));
  }, e;
}(), bq = /* @__PURE__ */ function() {
  function e() {
    this.registry = [];
  }
  var t = e.prototype;
  return t.add = function(o) {
    var s = this.registry, i = o.options.index;
    if (s.indexOf(o) === -1) {
      if (s.length === 0 || i >= this.index) {
        s.push(o);
        return;
      }
      for (var a = 0; a < s.length; a++)
        if (s[a].options.index > i) {
          s.splice(a, 0, o);
          return;
        }
    }
  }, t.reset = function() {
    this.registry = [];
  }, t.remove = function(o) {
    var s = this.registry.indexOf(o);
    this.registry.splice(s, 1);
  }, t.toString = function(o) {
    for (var s = o === void 0 ? {} : o, i = s.attached, a = ve(s, ["attached"]), l = wl(a), c = l.linebreak, u = "", d = 0; d < this.registry.length; d++) {
      var f = this.registry[d];
      i != null && f.attached !== i || (u && (u += c), u += f.toString(a));
    }
    return u;
  }, jM(e, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]), e;
}(), Oc = new bq(), wy = typeof globalThis < "u" ? globalThis : typeof window < "u" && window.Math === Math ? window : typeof self < "u" && self.Math === Math ? self : Function("return this")(), Sy = "2f1acc6c3a606b082e5eef5e54414ffb";
wy[Sy] == null && (wy[Sy] = 0);
var A1 = wy[Sy]++, yq = 1e10, F1 = function(t) {
  t === void 0 && (t = {});
  var n = 0, o = function(i, a) {
    n += 1, n > yq && process.env.NODE_ENV !== "production" && vr(!1, "[JSS] You might have a memory leak. Rule counter is at " + n + ".");
    var l = "", c = "";
    return a && (a.options.classNamePrefix && (c = a.options.classNamePrefix), a.options.jss.id != null && (l = String(a.options.jss.id))), t.minify ? "" + (c || "c") + A1 + l + n : c + i.key + "-" + A1 + (l ? "-" + l : "") + "-" + n;
  };
  return o;
}, WM = function(t) {
  var n;
  return function() {
    return n || (n = t()), n;
  };
}, vq = function(t, n) {
  try {
    return t.attributeStyleMap ? t.attributeStyleMap.get(n) : t.style.getPropertyValue(n);
  } catch {
    return "";
  }
}, Cq = function(t, n, o) {
  try {
    var s = o;
    if (Array.isArray(o) && (s = Di(o)), t.attributeStyleMap)
      t.attributeStyleMap.set(n, s);
    else {
      var i = s ? s.indexOf("!important") : -1, a = i > -1 ? s.substr(0, i - 1) : s;
      t.style.setProperty(n, a, i > -1 ? "important" : "");
    }
  } catch {
    return !1;
  }
  return !0;
}, wq = function(t, n) {
  try {
    t.attributeStyleMap ? t.attributeStyleMap.delete(n) : t.style.removeProperty(n);
  } catch (o) {
    process.env.NODE_ENV !== "production" && vr(!1, '[JSS] DOMException "' + o.message + '" was thrown. Tried to remove property "' + n + '".');
  }
}, Sq = function(t, n) {
  return t.selectorText = n, t.selectorText === n;
}, UM = WM(function() {
  return document.querySelector("head");
});
function xq(e, t) {
  for (var n = 0; n < e.length; n++) {
    var o = e[n];
    if (o.attached && o.options.index > t.index && o.options.insertionPoint === t.insertionPoint)
      return o;
  }
  return null;
}
function Tq(e, t) {
  for (var n = e.length - 1; n >= 0; n--) {
    var o = e[n];
    if (o.attached && o.options.insertionPoint === t.insertionPoint)
      return o;
  }
  return null;
}
function Rq(e) {
  for (var t = UM(), n = 0; n < t.childNodes.length; n++) {
    var o = t.childNodes[n];
    if (o.nodeType === 8 && o.nodeValue.trim() === e)
      return o;
  }
  return null;
}
function Eq(e) {
  var t = Oc.registry;
  if (t.length > 0) {
    var n = xq(t, e);
    if (n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element
      };
    if (n = Tq(t, e), n && n.renderer)
      return {
        parent: n.renderer.element.parentNode,
        node: n.renderer.element.nextSibling
      };
  }
  var o = e.insertionPoint;
  if (o && typeof o == "string") {
    var s = Rq(o);
    if (s)
      return {
        parent: s.parentNode,
        node: s.nextSibling
      };
    process.env.NODE_ENV !== "production" && vr(!1, '[JSS] Insertion point "' + o + '" not found.');
  }
  return !1;
}
function Iq(e, t) {
  var n = t.insertionPoint, o = Eq(t);
  if (o !== !1 && o.parent) {
    o.parent.insertBefore(e, o.node);
    return;
  }
  if (n && typeof n.nodeType == "number") {
    var s = n, i = s.parentNode;
    i ? i.insertBefore(e, s.nextSibling) : process.env.NODE_ENV !== "production" && vr(!1, "[JSS] Insertion point is not in the DOM.");
    return;
  }
  UM().appendChild(e);
}
var Oq = WM(function() {
  var e = document.querySelector('meta[property="csp-nonce"]');
  return e ? e.getAttribute("content") : null;
}), L1 = function(t, n, o) {
  try {
    "insertRule" in t ? t.insertRule(n, o) : "appendRule" in t && t.appendRule(n);
  } catch (s) {
    return process.env.NODE_ENV !== "production" && vr(!1, "[JSS] " + s.message), !1;
  }
  return t.cssRules[o];
}, _1 = function(t, n) {
  var o = t.cssRules.length;
  return n === void 0 || n > o ? o : n;
}, Pq = function() {
  var t = document.createElement("style");
  return t.textContent = `
`, t;
}, Mq = /* @__PURE__ */ function() {
  function e(n) {
    this.getPropertyValue = vq, this.setProperty = Cq, this.removeProperty = wq, this.setSelector = Sq, this.hasInsertedRules = !1, this.cssRules = [], n && Oc.add(n), this.sheet = n;
    var o = this.sheet ? this.sheet.options : {}, s = o.media, i = o.meta, a = o.element;
    this.element = a || Pq(), this.element.setAttribute("data-jss", ""), s && this.element.setAttribute("media", s), i && this.element.setAttribute("data-meta", i);
    var l = Oq();
    l && this.element.setAttribute("nonce", l);
  }
  var t = e.prototype;
  return t.attach = function() {
    if (!(this.element.parentNode || !this.sheet)) {
      Iq(this.element, this.sheet.options);
      var o = !!(this.sheet && this.sheet.deployed);
      this.hasInsertedRules && o && (this.hasInsertedRules = !1, this.deploy());
    }
  }, t.detach = function() {
    if (this.sheet) {
      var o = this.element.parentNode;
      o && o.removeChild(this.element), this.sheet.options.link && (this.cssRules = [], this.element.textContent = `
`);
    }
  }, t.deploy = function() {
    var o = this.sheet;
    if (o) {
      if (o.options.link) {
        this.insertRules(o.rules);
        return;
      }
      this.element.textContent = `
` + o.toString() + `
`;
    }
  }, t.insertRules = function(o, s) {
    for (var i = 0; i < o.index.length; i++)
      this.insertRule(o.index[i], i, s);
  }, t.insertRule = function(o, s, i) {
    if (i === void 0 && (i = this.element.sheet), o.rules) {
      var a = o, l = i;
      if (o.type === "conditional" || o.type === "keyframes") {
        var c = _1(i, s);
        if (l = L1(i, a.toString({
          children: !1
        }), c), l === !1)
          return !1;
        this.refCssRule(o, c, l);
      }
      return this.insertRules(a.rules, l), l;
    }
    var u = o.toString();
    if (!u) return !1;
    var d = _1(i, s), f = L1(i, u, d);
    return f === !1 ? !1 : (this.hasInsertedRules = !0, this.refCssRule(o, d, f), f);
  }, t.refCssRule = function(o, s, i) {
    o.renderable = i, o.options.parent instanceof qM && this.cssRules.splice(s, 0, i);
  }, t.deleteRule = function(o) {
    var s = this.element.sheet, i = this.indexOf(o);
    return i === -1 ? !1 : (s.deleteRule(i), this.cssRules.splice(i, 1), !0);
  }, t.indexOf = function(o) {
    return this.cssRules.indexOf(o);
  }, t.replaceRule = function(o, s) {
    var i = this.indexOf(o);
    return i === -1 ? !1 : (this.element.sheet.deleteRule(i), this.cssRules.splice(i, 1), this.insertRule(s, i));
  }, t.getRules = function() {
    return this.element.sheet.cssRules;
  }, e;
}(), kq = 0, Dq = /* @__PURE__ */ function() {
  function e(n) {
    this.id = kq++, this.version = "10.10.0", this.plugins = new mq(), this.options = {
      id: {
        minify: !1
      },
      createGenerateId: F1,
      Renderer: Pu ? Mq : null,
      plugins: []
    }, this.generateId = F1({
      minify: !1
    });
    for (var o = 0; o < N1.length; o++)
      this.plugins.use(N1[o], {
        queue: "internal"
      });
    this.setup(n);
  }
  var t = e.prototype;
  return t.setup = function(o) {
    return o === void 0 && (o = {}), o.createGenerateId && (this.options.createGenerateId = o.createGenerateId), o.id && (this.options.id = I({}, this.options.id, o.id)), (o.createGenerateId || o.id) && (this.generateId = this.options.createGenerateId(this.options.id)), o.insertionPoint != null && (this.options.insertionPoint = o.insertionPoint), "Renderer" in o && (this.options.Renderer = o.Renderer), o.plugins && this.use.apply(this, o.plugins), this;
  }, t.createStyleSheet = function(o, s) {
    s === void 0 && (s = {});
    var i = s, a = i.index;
    typeof a != "number" && (a = Oc.index === 0 ? 0 : Oc.index + 1);
    var l = new qM(o, I({}, s, {
      jss: this,
      generateId: s.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: a
    }));
    return this.plugins.onProcessSheet(l), l;
  }, t.removeStyleSheet = function(o) {
    return o.detach(), Oc.remove(o), this;
  }, t.createRule = function(o, s, i) {
    if (s === void 0 && (s = {}), i === void 0 && (i = {}), typeof o == "object")
      return this.createRule(void 0, o, s);
    var a = I({}, i, {
      name: o,
      jss: this,
      Renderer: this.options.Renderer
    });
    a.generateId || (a.generateId = this.generateId), a.classes || (a.classes = {}), a.keyframes || (a.keyframes = {});
    var l = IC(o, s, a);
    return l && this.plugins.onProcessRule(l), l;
  }, t.use = function() {
    for (var o = this, s = arguments.length, i = new Array(s), a = 0; a < s; a++)
      i[a] = arguments[a];
    return i.forEach(function(l) {
      o.plugins.use(l);
    }), this;
  }, e;
}(), PC = function(t) {
  return new Dq(t);
}, MC = typeof CSS == "object" && CSS != null && "number" in CSS;
function KM(e) {
  var t = null;
  for (var n in e) {
    var o = e[n], s = typeof o;
    if (s === "function")
      t || (t = {}), t[n] = o;
    else if (s === "object" && o !== null && !Array.isArray(o)) {
      var i = KM(o);
      i && (t || (t = {}), t[n] = i);
    }
  }
  return t;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
PC();
var YM = Date.now(), ig = "fnValues" + YM, ag = "fnStyle" + ++YM, Nq = function() {
  return {
    onCreateRule: function(n, o, s) {
      if (typeof o != "function") return null;
      var i = IC(n, {}, s);
      return i[ag] = o, i;
    },
    onProcessStyle: function(n, o) {
      if (ig in o || ag in o) return n;
      var s = {};
      for (var i in n) {
        var a = n[i];
        typeof a == "function" && (delete n[i], s[i] = a);
      }
      return o[ig] = s, n;
    },
    onUpdate: function(n, o, s, i) {
      var a = o, l = a[ag];
      if (l && (a.style = l(n) || {}, process.env.NODE_ENV === "development")) {
        for (var c in a.style)
          if (typeof a.style[c] == "function") {
            process.env.NODE_ENV !== "production" && vr(!1, "[JSS] Function values inside function rules are not supported.");
            break;
          }
      }
      var u = a[ig];
      if (u)
        for (var d in u)
          a.prop(d, u[d](n), i);
    }
  };
}, Gs = "@global", xy = "@global ", $q = /* @__PURE__ */ function() {
  function e(n, o, s) {
    this.type = "global", this.at = Gs, this.isProcessed = !1, this.key = n, this.options = s, this.rules = new Hp(I({}, s, {
      parent: this
    }));
    for (var i in o)
      this.rules.add(i, o[i]);
    this.rules.process();
  }
  var t = e.prototype;
  return t.getRule = function(o) {
    return this.rules.get(o);
  }, t.addRule = function(o, s, i) {
    var a = this.rules.add(o, s, i);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, t.replaceRule = function(o, s, i) {
    var a = this.rules.replace(o, s, i);
    return a && this.options.jss.plugins.onProcessRule(a), a;
  }, t.indexOf = function(o) {
    return this.rules.indexOf(o);
  }, t.toString = function(o) {
    return this.rules.toString(o);
  }, e;
}(), Aq = /* @__PURE__ */ function() {
  function e(n, o, s) {
    this.type = "global", this.at = Gs, this.isProcessed = !1, this.key = n, this.options = s;
    var i = n.substr(xy.length);
    this.rule = s.jss.createRule(i, o, I({}, s, {
      parent: this
    }));
  }
  var t = e.prototype;
  return t.toString = function(o) {
    return this.rule ? this.rule.toString(o) : "";
  }, e;
}(), Fq = /\s*,\s*/g;
function XM(e, t) {
  for (var n = e.split(Fq), o = "", s = 0; s < n.length; s++)
    o += t + " " + n[s].trim(), n[s + 1] && (o += ", ");
  return o;
}
function Lq(e, t) {
  var n = e.options, o = e.style, s = o ? o[Gs] : null;
  if (s) {
    for (var i in s)
      t.addRule(i, s[i], I({}, n, {
        selector: XM(i, e.selector)
      }));
    delete o[Gs];
  }
}
function _q(e, t) {
  var n = e.options, o = e.style;
  for (var s in o)
    if (!(s[0] !== "@" || s.substr(0, Gs.length) !== Gs)) {
      var i = XM(s.substr(Gs.length), e.selector);
      t.addRule(i, o[s], I({}, n, {
        selector: i
      })), delete o[s];
    }
}
function Vq() {
  function e(n, o, s) {
    if (!n) return null;
    if (n === Gs)
      return new $q(n, o, s);
    if (n[0] === "@" && n.substr(0, xy.length) === xy)
      return new Aq(n, o, s);
    var i = s.parent;
    return i && (i.type === "global" || i.options.parent && i.options.parent.type === "global") && (s.scoped = !1), !s.selector && s.scoped === !1 && (s.selector = n), null;
  }
  function t(n, o) {
    n.type !== "style" || !o || (Lq(n, o), _q(n, o));
  }
  return {
    onCreateRule: e,
    onProcessRule: t
  };
}
var V1 = /\s*,\s*/g, Bq = /&/g, zq = /\$([\w-]+)/g;
function Hq() {
  function e(s, i) {
    return function(a, l) {
      var c = s.getRule(l) || i && i.getRule(l);
      return c ? c.selector : (process.env.NODE_ENV !== "production" && vr(!1, '[JSS] Could not find the referenced rule "' + l + '" in "' + (s.options.meta || s.toString()) + '".'), l);
    };
  }
  function t(s, i) {
    for (var a = i.split(V1), l = s.split(V1), c = "", u = 0; u < a.length; u++)
      for (var d = a[u], f = 0; f < l.length; f++) {
        var p = l[f];
        c && (c += ", "), c += p.indexOf("&") !== -1 ? p.replace(Bq, d) : d + " " + p;
      }
    return c;
  }
  function n(s, i, a) {
    if (a) return I({}, a, {
      index: a.index + 1
    });
    var l = s.options.nestingLevel;
    l = l === void 0 ? 1 : l + 1;
    var c = I({}, s.options, {
      nestingLevel: l,
      index: i.indexOf(s) + 1
      // We don't need the parent name to be set options for chlid.
    });
    return delete c.name, c;
  }
  function o(s, i, a) {
    if (i.type !== "style") return s;
    var l = i, c = l.options.parent, u, d;
    for (var f in s) {
      var p = f.indexOf("&") !== -1, m = f[0] === "@";
      if (!(!p && !m)) {
        if (u = n(l, c, u), p) {
          var b = t(f, l.selector);
          d || (d = e(c, a)), b = b.replace(zq, d);
          var v = l.key + "-" + f;
          "replaceRule" in c ? c.replaceRule(v, s[f], I({}, u, {
            selector: b
          })) : c.addRule(v, s[f], I({}, u, {
            selector: b
          }));
        } else m && c.addRule(f, {}, u).addRule(l.key, s[f], {
          selector: l.selector
        });
        delete s[f];
      }
    }
    return s;
  }
  return {
    onProcessStyle: o
  };
}
var jq = /[A-Z]/g, Gq = /^ms-/, lg = {};
function qq(e) {
  return "-" + e.toLowerCase();
}
function QM(e) {
  if (lg.hasOwnProperty(e))
    return lg[e];
  var t = e.replace(jq, qq);
  return lg[e] = Gq.test(t) ? "-" + t : t;
}
function Mf(e) {
  var t = {};
  for (var n in e) {
    var o = n.indexOf("--") === 0 ? n : QM(n);
    t[o] = e[n];
  }
  return e.fallbacks && (Array.isArray(e.fallbacks) ? t.fallbacks = e.fallbacks.map(Mf) : t.fallbacks = Mf(e.fallbacks)), t;
}
function Wq() {
  function e(n) {
    if (Array.isArray(n)) {
      for (var o = 0; o < n.length; o++)
        n[o] = Mf(n[o]);
      return n;
    }
    return Mf(n);
  }
  function t(n, o, s) {
    if (o.indexOf("--") === 0)
      return n;
    var i = QM(o);
    return o === i ? n : (s.prop(i, n), null);
  }
  return {
    onProcessStyle: e,
    onChangeValue: t
  };
}
var Oe = MC && CSS ? CSS.px : "px", wd = MC && CSS ? CSS.ms : "ms", ua = MC && CSS ? CSS.percent : "%", Uq = {
  // Animation properties
  "animation-delay": wd,
  "animation-duration": wd,
  // Background properties
  "background-position": Oe,
  "background-position-x": Oe,
  "background-position-y": Oe,
  "background-size": Oe,
  // Border Properties
  border: Oe,
  "border-bottom": Oe,
  "border-bottom-left-radius": Oe,
  "border-bottom-right-radius": Oe,
  "border-bottom-width": Oe,
  "border-left": Oe,
  "border-left-width": Oe,
  "border-radius": Oe,
  "border-right": Oe,
  "border-right-width": Oe,
  "border-top": Oe,
  "border-top-left-radius": Oe,
  "border-top-right-radius": Oe,
  "border-top-width": Oe,
  "border-width": Oe,
  "border-block": Oe,
  "border-block-end": Oe,
  "border-block-end-width": Oe,
  "border-block-start": Oe,
  "border-block-start-width": Oe,
  "border-block-width": Oe,
  "border-inline": Oe,
  "border-inline-end": Oe,
  "border-inline-end-width": Oe,
  "border-inline-start": Oe,
  "border-inline-start-width": Oe,
  "border-inline-width": Oe,
  "border-start-start-radius": Oe,
  "border-start-end-radius": Oe,
  "border-end-start-radius": Oe,
  "border-end-end-radius": Oe,
  // Margin properties
  margin: Oe,
  "margin-bottom": Oe,
  "margin-left": Oe,
  "margin-right": Oe,
  "margin-top": Oe,
  "margin-block": Oe,
  "margin-block-end": Oe,
  "margin-block-start": Oe,
  "margin-inline": Oe,
  "margin-inline-end": Oe,
  "margin-inline-start": Oe,
  // Padding properties
  padding: Oe,
  "padding-bottom": Oe,
  "padding-left": Oe,
  "padding-right": Oe,
  "padding-top": Oe,
  "padding-block": Oe,
  "padding-block-end": Oe,
  "padding-block-start": Oe,
  "padding-inline": Oe,
  "padding-inline-end": Oe,
  "padding-inline-start": Oe,
  // Mask properties
  "mask-position-x": Oe,
  "mask-position-y": Oe,
  "mask-size": Oe,
  // Width and height properties
  height: Oe,
  width: Oe,
  "min-height": Oe,
  "max-height": Oe,
  "min-width": Oe,
  "max-width": Oe,
  // Position properties
  bottom: Oe,
  left: Oe,
  top: Oe,
  right: Oe,
  inset: Oe,
  "inset-block": Oe,
  "inset-block-end": Oe,
  "inset-block-start": Oe,
  "inset-inline": Oe,
  "inset-inline-end": Oe,
  "inset-inline-start": Oe,
  // Shadow properties
  "box-shadow": Oe,
  "text-shadow": Oe,
  // Column properties
  "column-gap": Oe,
  "column-rule": Oe,
  "column-rule-width": Oe,
  "column-width": Oe,
  // Font and text properties
  "font-size": Oe,
  "font-size-delta": Oe,
  "letter-spacing": Oe,
  "text-decoration-thickness": Oe,
  "text-indent": Oe,
  "text-stroke": Oe,
  "text-stroke-width": Oe,
  "word-spacing": Oe,
  // Motion properties
  motion: Oe,
  "motion-offset": Oe,
  // Outline properties
  outline: Oe,
  "outline-offset": Oe,
  "outline-width": Oe,
  // Perspective properties
  perspective: Oe,
  "perspective-origin-x": ua,
  "perspective-origin-y": ua,
  // Transform properties
  "transform-origin": ua,
  "transform-origin-x": ua,
  "transform-origin-y": ua,
  "transform-origin-z": ua,
  // Transition properties
  "transition-delay": wd,
  "transition-duration": wd,
  // Alignment properties
  "vertical-align": Oe,
  "flex-basis": Oe,
  // Some random properties
  "shape-margin": Oe,
  size: Oe,
  gap: Oe,
  // Grid properties
  grid: Oe,
  "grid-gap": Oe,
  "row-gap": Oe,
  "grid-row-gap": Oe,
  "grid-column-gap": Oe,
  "grid-template-rows": Oe,
  "grid-template-columns": Oe,
  "grid-auto-rows": Oe,
  "grid-auto-columns": Oe,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": Oe,
  "box-shadow-y": Oe,
  "box-shadow-blur": Oe,
  "box-shadow-spread": Oe,
  "font-line-height": Oe,
  "text-shadow-x": Oe,
  "text-shadow-y": Oe,
  "text-shadow-blur": Oe
};
function ZM(e) {
  var t = /(-[a-z])/g, n = function(a) {
    return a[1].toUpperCase();
  }, o = {};
  for (var s in e)
    o[s] = e[s], o[s.replace(t, n)] = e[s];
  return o;
}
var Kq = ZM(Uq);
function Pc(e, t, n) {
  if (t == null) return t;
  if (Array.isArray(t))
    for (var o = 0; o < t.length; o++)
      t[o] = Pc(e, t[o], n);
  else if (typeof t == "object")
    if (e === "fallbacks")
      for (var s in t)
        t[s] = Pc(s, t[s], n);
    else
      for (var i in t)
        t[i] = Pc(e + "-" + i, t[i], n);
  else if (typeof t == "number" && isNaN(t) === !1) {
    var a = n[e] || Kq[e];
    return a && !(t === 0 && a === Oe) ? typeof a == "function" ? a(t).toString() : "" + t + a : t.toString();
  }
  return t;
}
function Yq(e) {
  e === void 0 && (e = {});
  var t = ZM(e);
  function n(s, i) {
    if (i.type !== "style") return s;
    for (var a in s)
      s[a] = Pc(a, s[a], t);
    return s;
  }
  function o(s, i) {
    return Pc(i, s, t);
  }
  return {
    onProcessStyle: n,
    onChangeValue: o
  };
}
function Ty(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
  return o;
}
function Xq(e) {
  if (Array.isArray(e)) return Ty(e);
}
function Qq(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Zq(e, t) {
  if (e) {
    if (typeof e == "string") return Ty(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ty(e, t) : void 0;
  }
}
function Jq() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function e7(e) {
  return Xq(e) || Qq(e) || Zq(e) || Jq();
}
var uc = "", Ry = "", JM = "", ek = "", t7 = Pu && "ontouchstart" in document.documentElement;
if (Pu) {
  var cg = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  }, n7 = document.createElement("p"), ug = n7.style, o7 = "Transform";
  for (var dg in cg)
    if (dg + o7 in ug) {
      uc = dg, Ry = cg[dg];
      break;
    }
  uc === "Webkit" && "msHyphens" in ug && (uc = "ms", Ry = cg.ms, ek = "edge"), uc === "Webkit" && "-apple-trailing-word" in ug && (JM = "apple");
}
var ht = {
  js: uc,
  css: Ry,
  vendor: JM,
  browser: ek,
  isTouch: t7
};
function r7(e) {
  return e[1] === "-" || ht.js === "ms" ? e : "@" + ht.css + "keyframes" + e.substr(10);
}
var s7 = {
  noPrefill: ["appearance"],
  supportedProperty: function(t) {
    return t !== "appearance" ? !1 : ht.js === "ms" ? "-webkit-" + t : ht.css + t;
  }
}, i7 = {
  noPrefill: ["color-adjust"],
  supportedProperty: function(t) {
    return t !== "color-adjust" ? !1 : ht.js === "Webkit" ? ht.css + "print-" + t : t;
  }
}, a7 = /[-\s]+(.)?/g;
function l7(e, t) {
  return t ? t.toUpperCase() : "";
}
function kC(e) {
  return e.replace(a7, l7);
}
function Ks(e) {
  return kC("-" + e);
}
var c7 = {
  noPrefill: ["mask"],
  supportedProperty: function(t, n) {
    if (!/^mask/.test(t)) return !1;
    if (ht.js === "Webkit") {
      var o = "mask-image";
      if (kC(o) in n)
        return t;
      if (ht.js + Ks(o) in n)
        return ht.css + t;
    }
    return t;
  }
}, u7 = {
  noPrefill: ["text-orientation"],
  supportedProperty: function(t) {
    return t !== "text-orientation" ? !1 : ht.vendor === "apple" && !ht.isTouch ? ht.css + t : t;
  }
}, d7 = {
  noPrefill: ["transform"],
  supportedProperty: function(t, n, o) {
    return t !== "transform" ? !1 : o.transform ? t : ht.css + t;
  }
}, f7 = {
  noPrefill: ["transition"],
  supportedProperty: function(t, n, o) {
    return t !== "transition" ? !1 : o.transition ? t : ht.css + t;
  }
}, p7 = {
  noPrefill: ["writing-mode"],
  supportedProperty: function(t) {
    return t !== "writing-mode" ? !1 : ht.js === "Webkit" || ht.js === "ms" && ht.browser !== "edge" ? ht.css + t : t;
  }
}, h7 = {
  noPrefill: ["user-select"],
  supportedProperty: function(t) {
    return t !== "user-select" ? !1 : ht.js === "Moz" || ht.js === "ms" || ht.vendor === "apple" ? ht.css + t : t;
  }
}, g7 = {
  supportedProperty: function(t, n) {
    if (!/^break-/.test(t)) return !1;
    if (ht.js === "Webkit") {
      var o = "WebkitColumn" + Ks(t);
      return o in n ? ht.css + "column-" + t : !1;
    }
    if (ht.js === "Moz") {
      var s = "page" + Ks(t);
      return s in n ? "page-" + t : !1;
    }
    return !1;
  }
}, m7 = {
  supportedProperty: function(t, n) {
    if (!/^(border|margin|padding)-inline/.test(t)) return !1;
    if (ht.js === "Moz") return t;
    var o = t.replace("-inline", "");
    return ht.js + Ks(o) in n ? ht.css + o : !1;
  }
}, b7 = {
  supportedProperty: function(t, n) {
    return kC(t) in n ? t : !1;
  }
}, y7 = {
  supportedProperty: function(t, n) {
    var o = Ks(t);
    return t[0] === "-" || t[0] === "-" && t[1] === "-" ? t : ht.js + o in n ? ht.css + t : ht.js !== "Webkit" && "Webkit" + o in n ? "-webkit-" + t : !1;
  }
}, v7 = {
  supportedProperty: function(t) {
    return t.substring(0, 11) !== "scroll-snap" ? !1 : ht.js === "ms" ? "" + ht.css + t : t;
  }
}, C7 = {
  supportedProperty: function(t) {
    return t !== "overscroll-behavior" ? !1 : ht.js === "ms" ? ht.css + "scroll-chaining" : t;
  }
}, w7 = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
}, S7 = {
  supportedProperty: function(t, n) {
    var o = w7[t];
    return o && ht.js + Ks(o) in n ? ht.css + o : !1;
  }
}, tk = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
}, x7 = Object.keys(tk), T7 = function(t) {
  return ht.css + t;
}, R7 = {
  supportedProperty: function(t, n, o) {
    var s = o.multiple;
    if (x7.indexOf(t) > -1) {
      var i = tk[t];
      if (!Array.isArray(i))
        return ht.js + Ks(i) in n ? ht.css + i : !1;
      if (!s) return !1;
      for (var a = 0; a < i.length; a++)
        if (!(ht.js + Ks(i[0]) in n))
          return !1;
      return i.map(T7);
    }
    return !1;
  }
}, nk = [s7, i7, c7, u7, d7, f7, p7, h7, g7, m7, b7, y7, v7, C7, S7, R7], B1 = nk.filter(function(e) {
  return e.supportedProperty;
}).map(function(e) {
  return e.supportedProperty;
}), E7 = nk.filter(function(e) {
  return e.noPrefill;
}).reduce(function(e, t) {
  return e.push.apply(e, e7(t.noPrefill)), e;
}, []), dc, xi = {};
if (Pu) {
  dc = document.createElement("p");
  var fg = window.getComputedStyle(document.documentElement, "");
  for (var pg in fg)
    isNaN(pg) || (xi[fg[pg]] = fg[pg]);
  E7.forEach(function(e) {
    return delete xi[e];
  });
}
function Ey(e, t) {
  if (t === void 0 && (t = {}), !dc) return e;
  if (process.env.NODE_ENV !== "benchmark" && xi[e] != null)
    return xi[e];
  (e === "transition" || e === "transform") && (t[e] = e in dc.style);
  for (var n = 0; n < B1.length && (xi[e] = B1[n](e, dc.style, t), !xi[e]); n++)
    ;
  try {
    dc.style[e] = "";
  } catch {
    return !1;
  }
  return xi[e];
}
var da = {}, I7 = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
}, O7 = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g, Fs;
function P7(e, t, n) {
  if (t === "var") return "var";
  if (t === "all") return "all";
  if (n === "all") return ", all";
  var o = t ? Ey(t) : ", " + Ey(n);
  return o || t || n;
}
Pu && (Fs = document.createElement("p"));
function z1(e, t) {
  var n = t;
  if (!Fs || e === "content") return t;
  if (typeof n != "string" || !isNaN(parseInt(n, 10)))
    return n;
  var o = e + n;
  if (process.env.NODE_ENV !== "benchmark" && da[o] != null)
    return da[o];
  try {
    Fs.style[e] = n;
  } catch {
    return da[o] = !1, !1;
  }
  if (I7[e])
    n = n.replace(O7, P7);
  else if (Fs.style[e] === "" && (n = ht.css + n, n === "-ms-flex" && (Fs.style[e] = "-ms-flexbox"), Fs.style[e] = n, Fs.style[e] === ""))
    return da[o] = !1, !1;
  return Fs.style[e] = "", da[o] = n, da[o];
}
function M7() {
  function e(s) {
    if (s.type === "keyframes") {
      var i = s;
      i.at = r7(i.at);
    }
  }
  function t(s) {
    for (var i in s) {
      var a = s[i];
      if (i === "fallbacks" && Array.isArray(a)) {
        s[i] = a.map(t);
        continue;
      }
      var l = !1, c = Ey(i);
      c && c !== i && (l = !0);
      var u = !1, d = z1(c, Di(a));
      d && d !== a && (u = !0), (l || u) && (l && delete s[i], s[c || i] = d || a);
    }
    return s;
  }
  function n(s, i) {
    return i.type !== "style" ? s : t(s);
  }
  function o(s, i) {
    return z1(i, Di(s)) || s;
  }
  return {
    onProcessRule: e,
    onProcessStyle: n,
    onChangeValue: o
  };
}
function k7() {
  var e = function(n, o) {
    return n.length === o.length ? n > o ? 1 : -1 : n.length - o.length;
  };
  return {
    onProcessStyle: function(n, o) {
      if (o.type !== "style") return n;
      for (var s = {}, i = Object.keys(n).sort(e), a = 0; a < i.length; a++)
        s[i[a]] = n[i[a]];
      return s;
    }
  };
}
function ok() {
  return {
    plugins: [
      Nq(),
      Vq(),
      Hq(),
      Wq(),
      Yq(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window > "u" ? null : M7(),
      k7()
    ]
  };
}
function rk(e = {}) {
  const {
    baseClasses: t,
    newClasses: n,
    Component: o
  } = e;
  if (!n)
    return t;
  const s = {
    ...t
  };
  return process.env.NODE_ENV !== "production" && typeof n == "string" ? (console.error([`MUI: The value \`${n}\` provided to the classes prop of ${Oi(o)} is incorrect.`, "You might want to use the className prop instead."].join(`
`)), t) : (Object.keys(n).forEach((i) => {
    process.env.NODE_ENV !== "production" && (!t[i] && n[i] && console.error([`MUI: The key \`${i}\` provided to the classes prop is not implemented in ${Oi(o)}.`, `You can only override one of the following: ${Object.keys(t).join(",")}.`].join(`
`)), n[i] && typeof n[i] != "string" && console.error([`MUI: The key \`${i}\` provided to the classes prop is not valid for ${Oi(o)}.`, `You need to provide a non empty string instead of: ${n[i]}.`].join(`
`))), n[i] && (s[i] = `${t[i]} ${n[i]}`);
  }), s);
}
const Ma = {
  set: (e, t, n, o) => {
    let s = e.get(t);
    s || (s = /* @__PURE__ */ new Map(), e.set(t, s)), s.set(n, o);
  },
  get: (e, t, n) => {
    const o = e.get(t);
    return o ? o.get(n) : void 0;
  },
  delete: (e, t, n) => {
    e.get(t).delete(n);
  }
};
function DC() {
  const e = Tp();
  return (e == null ? void 0 : e.$$material) ?? e;
}
const D7 = PC(ok()), N7 = j8(), $7 = /* @__PURE__ */ new Map(), A7 = {
  disableGeneration: !1,
  generateClassName: N7,
  jss: D7,
  sheetsCache: null,
  sheetsManager: $7,
  sheetsRegistry: null
}, kf = /* @__PURE__ */ h.createContext(A7);
process.env.NODE_ENV !== "production" && (kf.displayName = "StylesContext");
let Sd;
function Iy(e) {
  const {
    children: t,
    injectFirst: n = !1,
    disableGeneration: o = !1,
    ...s
  } = e, i = h.useContext(kf), {
    generateClassName: a,
    jss: l,
    serverGenerateClassName: c,
    sheetsCache: u,
    sheetsManager: d,
    sheetsRegistry: f
  } = {
    ...i,
    ...s
  };
  process.env.NODE_ENV !== "production" && n && s.jss && console.error("MUI: You cannot use the jss and injectFirst props at the same time.");
  const p = h.useMemo(() => {
    const m = {
      disableGeneration: o,
      generateClassName: a,
      jss: l,
      serverGenerateClassName: c,
      sheetsCache: u,
      sheetsManager: d,
      sheetsRegistry: f
    };
    if (process.env.NODE_ENV !== "production" && typeof window > "u" && !m.sheetsManager && console.error("MUI: You need to use the ServerStyleSheets API when rendering on the server."), process.env.NODE_ENV !== "production" && m.jss.options.insertionPoint && n && console.error("MUI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time."), !m.jss.options.insertionPoint && n && typeof window < "u") {
      if (!Sd) {
        const b = document.head;
        Sd = document.createComment("mui-inject-first"), b.insertBefore(Sd, b.firstChild);
      }
      m.jss = PC({
        plugins: ok().plugins,
        insertionPoint: Sd
      });
    }
    return m;
  }, [n, o, a, l, c, u, d, f]);
  return /* @__PURE__ */ C(kf.Provider, {
    value: p,
    children: t
  });
}
process.env.NODE_ENV !== "production" && (Iy.propTypes = {
  /**
   * Your component tree.
   */
  children: r.node,
  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: r.bool,
  /**
   * JSS's class name generator.
   */
  generateClassName: r.func,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: r.bool,
  /**
   * JSS's instance.
   */
  jss: r.object,
  /**
   * @ignore
   */
  serverGenerateClassName: r.func,
  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: r.object,
  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: r.object,
  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: r.object
});
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && (Iy.propTypes = hl(Iy.propTypes));
let hg = -1e9;
function F7() {
  return hg += 1, process.env.NODE_ENV !== "production" && hg >= 0 && console.warn(["MUI: You might have a memory leak.", "The indexCounter is not supposed to grow that much."].join(`
`)), hg;
}
function H1(e) {
  return e.length === 0;
}
function L7(e) {
  const {
    variant: t,
    ...n
  } = e;
  let o = t || "";
  return Object.keys(n).sort().forEach((s) => {
    s === "color" ? o += H1(o) ? e[s] : ce(e[s]) : o += `${H1(o) ? s : ce(s)}${ce(e[s].toString())}`;
  }), o;
}
const sk = {};
function _7(e) {
  const t = typeof e == "function";
  return process.env.NODE_ENV !== "production" && typeof e != "object" && !t && console.error(["MUI: The `styles` argument provided is invalid.", "You need to provide a function generating the styles or a styles object."].join(`
`)), {
    create: (n, o) => {
      let s;
      try {
        s = t ? e(n) : e;
      } catch (c) {
        throw process.env.NODE_ENV !== "production" && t === !0 && n === sk && console.error(["MUI: The `styles` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`)), c;
      }
      if (!o || !n.components || !n.components[o] || !n.components[o].styleOverrides && !n.components[o].variants)
        return s;
      const i = n.components[o].styleOverrides || {}, a = n.components[o].variants || [], l = {
        ...s
      };
      return Object.keys(i).forEach((c) => {
        process.env.NODE_ENV !== "production" && (l[c] || console.warn(["MUI: You are trying to override a style that does not exist.", `Fix the \`${c}\` key of \`theme.components.${o}.styleOverrides\`.`, "", `If you intentionally wanted to add a new key, please use the theme.components[${o}].variants option.`].join(`
`))), l[c] = Bn(l[c] || {}, i[c]);
      }), a.forEach((c) => {
        const u = L7(c.props);
        l[u] = Bn(l[u] || {}, c.style);
      }), l;
    },
    options: {}
  };
}
function V7({
  state: e,
  stylesOptions: t
}, n, o) {
  if (t.disableGeneration)
    return n || {};
  e.cacheClasses || (e.cacheClasses = {
    // Cache for the finalized classes value.
    value: null,
    // Cache for the last used classes prop pointer.
    lastProp: null,
    // Cache for the last used rendered classes pointer.
    lastJSS: {}
  });
  let s = !1;
  return e.classes !== e.cacheClasses.lastJSS && (e.cacheClasses.lastJSS = e.classes, s = !0), n !== e.cacheClasses.lastProp && (e.cacheClasses.lastProp = n, s = !0), s && (e.cacheClasses.value = rk({
    baseClasses: e.cacheClasses.lastJSS,
    newClasses: n,
    Component: o
  })), e.cacheClasses.value;
}
function B7({
  state: e,
  theme: t,
  stylesOptions: n,
  stylesCreator: o,
  name: s
}, i) {
  if (n.disableGeneration)
    return;
  let a = Ma.get(n.sheetsManager, o, t);
  a || (a = {
    refs: 0,
    staticSheet: null,
    dynamicStyles: null
  }, Ma.set(n.sheetsManager, o, t, a));
  const l = {
    ...o.options,
    ...n,
    theme: t,
    flip: typeof n.flip == "boolean" ? n.flip : t.direction === "rtl"
  };
  l.generateId = l.serverGenerateClassName || l.generateClassName;
  const c = n.sheetsRegistry;
  if (a.refs === 0) {
    let u;
    n.sheetsCache && (u = Ma.get(n.sheetsCache, o, t));
    const d = o.create(t, s);
    u || (u = n.jss.createStyleSheet(d, {
      link: !1,
      ...l
    }), u.attach(), n.sheetsCache && Ma.set(n.sheetsCache, o, t, u)), c && c.add(u), a.staticSheet = u, a.dynamicStyles = KM(d);
  }
  if (a.dynamicStyles) {
    const u = n.jss.createStyleSheet(a.dynamicStyles, {
      link: !0,
      ...l
    });
    u.update(i), u.attach(), e.dynamicSheet = u, e.classes = rk({
      baseClasses: a.staticSheet.classes,
      newClasses: u.classes
    }), c && c.add(u);
  } else
    e.classes = a.staticSheet.classes;
  a.refs += 1;
}
function z7({
  state: e
}, t) {
  e.dynamicSheet && e.dynamicSheet.update(t);
}
function H7({
  state: e,
  theme: t,
  stylesOptions: n,
  stylesCreator: o
}) {
  if (n.disableGeneration)
    return;
  const s = Ma.get(n.sheetsManager, o, t);
  s.refs -= 1;
  const i = n.sheetsRegistry;
  s.refs === 0 && (Ma.delete(n.sheetsManager, o, t), n.jss.removeStyleSheet(s.staticSheet), i && i.remove(s.staticSheet)), e.dynamicSheet && (n.jss.removeStyleSheet(e.dynamicSheet), i && i.remove(e.dynamicSheet));
}
function j7(e, t) {
  const n = h.useRef([]);
  let o;
  const s = h.useMemo(() => ({}), t);
  n.current !== s && (n.current = s, o = e()), h.useEffect(
    () => () => {
      o && o();
    },
    [s]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function jp(e, t = {}) {
  const {
    // alias for classNamePrefix, if provided will listen to theme (required for theme.components[name].styleOverrides)
    name: n,
    // Help with debuggability.
    classNamePrefix: o,
    Component: s,
    defaultTheme: i = sk,
    ...a
  } = t, l = _7(e), c = n || o || "makeStyles";
  return l.options = {
    index: F7(),
    name: n,
    meta: c,
    classNamePrefix: c
  }, (d = {}) => {
    const f = DC() || i, p = {
      ...h.useContext(kf),
      ...a
    }, m = h.useRef(), b = h.useRef();
    j7(() => {
      const g = {
        name: n,
        state: {},
        stylesCreator: l,
        stylesOptions: p,
        theme: f
      };
      return B7(g, d), b.current = !1, m.current = g, () => {
        H7(g);
      };
    }, [f, l]), h.useEffect(() => {
      b.current && z7(m.current, d), b.current = !0;
    });
    const v = V7(m.current, d.classes, s);
    return process.env.NODE_ENV !== "production" && h.useDebugValue(v), process.env.NODE_ENV !== "production" && n && ["MuiAvatar", "MuiBadge", "MuiButton", "MuiButtonGroup", "MuiChip", "MuiDivider", "MuiFab", "MuiPaper", "MuiToolbar", "MuiTypography", "MuiAlert", "MuiPagination", "MuiPaginationItem", "MuiSkeleton", "MuiTimelineDot"].includes(n) && d.variant && !v[d.variant] && console.error([`MUI: You are using a variant value \`${d.variant}\` for which you didn't define styles.`, "Please create a new variant matcher in your theme for this variant. To learn more about matchers visit https://mui.com/r/custom-component-variants."].join(`
`)), v;
  };
}
const Ive = (e, t = {}) => (n) => {
  const {
    defaultTheme: o,
    withTheme: s = !1,
    name: i,
    ...a
  } = t;
  if (process.env.NODE_ENV !== "production" && n === void 0)
    throw new Error(["You are calling withStyles(styles)(Component) with an undefined component.", "You may have forgotten to import it."].join(`
`));
  let l = i;
  if (process.env.NODE_ENV !== "production" && !i) {
    const d = Oi(n);
    d !== void 0 && (l = d);
  }
  const c = jp(e, {
    defaultTheme: o,
    Component: n,
    name: i || n.displayName,
    classNamePrefix: l,
    ...a
  }), u = /* @__PURE__ */ h.forwardRef(function(f, p) {
    const {
      classes: m,
      ...b
    } = f, v = c({
      ...n.defaultProps,
      ...f
    });
    let g, y = b;
    return (typeof i == "string" || s) && (g = DC() || o, i && (y = G8({
      theme: g,
      name: i,
      props: b
    })), s && !y.theme && (y.theme = g)), /* @__PURE__ */ C(n, {
      ref: p,
      classes: v,
      ...y
    });
  });
  return process.env.NODE_ENV !== "production" && (u.propTypes = {
    /**
     * Override or extend the styles applied to the component.
     */
    classes: r.object
  }), process.env.NODE_ENV !== "production" && (u.displayName = `WithStyles(${Oi(n)})`), VO(u, n), process.env.NODE_ENV !== "production" && (u.Naked = n, u.options = t, u.useStyles = c), u;
};
function G7(e = {}) {
  const {
    defaultTheme: t
  } = e;
  return (o) => {
    if (process.env.NODE_ENV !== "production" && o === void 0)
      throw new Error(["You are calling withTheme(Component) with an undefined component.", "You may have forgotten to import it."].join(`
`));
    const s = /* @__PURE__ */ h.forwardRef(function(a, l) {
      const c = DC() || t;
      return /* @__PURE__ */ C(o, {
        theme: c,
        ref: l,
        ...a
      });
    });
    return process.env.NODE_ENV !== "production" && (s.displayName = `WithTheme(${Oi(o)})`), VO(s, o), process.env.NODE_ENV !== "production" && (s.Naked = o), s;
  };
}
const Ove = G7(), NC = () => {
  const e = sn();
  return Qi(e.breakpoints.down("md"));
}, q7 = (e) => {
  const t = sn();
  return Qi(t.breakpoints.down(e));
}, W7 = ({ children: e, ...t }) => /* @__PURE__ */ C(OM, { ...t, children: e }), U7 = (e) => {
  switch (e) {
    case "slide":
      return N8;
    case "zoom":
      return W7;
    case "collapse":
      return P8;
    case "fade":
      return M8;
    case "grow":
      return k8;
    default:
      return;
  }
}, K7 = ({
  children: e,
  color: t,
  spacing: n = 1,
  sx: o,
  ...s
}) => /* @__PURE__ */ C(
  vt,
  {
    gap: n,
    display: "flex",
    flexDirection: "column",
    sx: {
      color: t ? `${t}.main` : void 0,
      backgroundColor: t ? `${t}.background` : void 0,
      ...o
    },
    ...s,
    children: e
  }
), Y7 = ({
  title: e,
  onClose: t,
  children: n,
  transition: o = "grow",
  open: s = !1,
  noPadding: i = !1,
  responsive: a = !0,
  fullScreen: l = !1,
  fixedWidth: c = !1,
  hideCloseButton: u = !1,
  maxWidth: d = "sm",
  footer: f
}) => {
  const p = NC(), m = c ? { width: "50vw", height: "80vh", maxHeight: 720 } : {}, b = t && !u, v = e || b;
  return /* @__PURE__ */ ie(
    Jv,
    {
      open: s,
      onClose: t,
      TransitionComponent: U7(o),
      fullScreen: l || a && p,
      maxWidth: c ? "xl" : d,
      children: [
        v && /* @__PURE__ */ ie(
          rM,
          {
            sx: {
              display: "flex",
              justifyContent: "space-between"
            },
            children: [
              /* @__PURE__ */ C(Gt, { sx: { width: "100%" }, "data-testid": "dialog-title", children: e }),
              b && /* @__PURE__ */ C(
                zp,
                {
                  iconOnly: !0,
                  onClick: t,
                  icon: "close",
                  color: "inherit",
                  "data-testid": "dialog-close"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ C(
          eC,
          {
            sx: {
              // passing `undefined` let's the component use the "default" sizes
              padding: i ? 0 : void 0,
              margin: i ? 0 : void 0,
              ...m
            },
            children: /* @__PURE__ */ C(K7, { sx: { height: "100%" }, spacing: 2, children: n })
          }
        ),
        f
      ]
    }
  );
}, Pve = ({
  children: e,
  icon: t,
  onClick: n,
  open: o = !1,
  ...s
}) => {
  const [i, a] = jt(o);
  return /* @__PURE__ */ ie(mo, { children: [
    /* @__PURE__ */ C(
      zp,
      {
        onClick: (l) => {
          a(!0), n && n(l);
        },
        icon: t,
        ...s
      }
    ),
    bo(e) && Gr(e, {
      open: i,
      setOpen: a,
      onClose: () => a(!1)
    })
  ] });
}, X7 = te(Io)(() => ({
  minWidth: "unset"
})), $C = ({
  label: e,
  value: t,
  icon: n,
  items: o,
  menuWidth: s,
  handleChange: i,
  hideIndicator: a,
  noPadding: l,
  ...c
}) => {
  const { "data-cy": u, ...d } = c, [f, p] = jt(null), m = !!f, b = (y) => {
    p(y.currentTarget);
  }, v = () => {
    p(null);
  }, g = (y) => i && i(y);
  return /* @__PURE__ */ ie(mo, { children: [
    /* @__PURE__ */ C(
      X7,
      {
        ...d,
        "data-cy": u,
        startIcon: Pf(n) ? /* @__PURE__ */ C(yo, { children: n }) : n,
        endIcon: !a && /* @__PURE__ */ C(yo, { children: "arrow_drop_down" }),
        onClick: b,
        sx: {
          padding: l ? 0 : "undefined"
        },
        children: e
      }
    ),
    /* @__PURE__ */ C(
      Eu,
      {
        "data-cy": `${u}-menu`,
        open: m,
        anchorEl: f,
        onClick: v,
        onClose: v,
        slotProps: { paper: { style: { width: s } } },
        children: o.map((y) => {
          const {
            value: w,
            label: x,
            icon: S,
            description: T,
            ...E
          } = y;
          return /* @__PURE__ */ ie(
            Nn,
            {
              "data-cy": `${u}-menuItem-${w}`,
              selected: w === t,
              onClick: () => {
                g(w), v();
              },
              ...E,
              children: [
                S && /* @__PURE__ */ C(ur, { children: Pf(S) ? /* @__PURE__ */ C(yo, { children: S }) : S }),
                /* @__PURE__ */ C(
                  Ho,
                  {
                    primaryTypographyProps: {
                      // bold the title only if there's a description
                      fontWeight: T ? "bold" : void 0
                    },
                    secondary: T,
                    secondaryTypographyProps: {
                      sx: { textWrap: "wrap" },
                      color: "primary"
                    },
                    children: x
                  }
                )
              ]
            },
            w
          );
        })
      }
    )
  ] });
}, Mve = ({
  orientiation: e = "vertical",
  ...t
}) => /* @__PURE__ */ C(
  $C,
  {
    ...t,
    variant: "text",
    noPadding: !0,
    hideIndicator: !0,
    label: /* @__PURE__ */ C(Ve, { children: e === "vertical" ? "more_vert" : "more_horiz" })
  }
), Q7 = ({ children: e, ...t }) => /* @__PURE__ */ C(lC, { ...t, children: e }), kve = ({
  actions: e,
  buttonLabel: t,
  ...n
}) => {
  const [o, s] = jt(null), i = !!o, a = (u) => {
    s(u.currentTarget);
  }, l = () => {
    s(null);
  }, c = (u) => {
    u(), l();
  };
  return /* @__PURE__ */ ie(mo, { children: [
    /* @__PURE__ */ C(
      Of,
      {
        ...n,
        onClick: a,
        endIcon: /* @__PURE__ */ C(yo, { children: "arrow_drop_down" }),
        children: t
      }
    ),
    /* @__PURE__ */ C(
      Q7,
      {
        open: i,
        anchorEl: o,
        onClose: l,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        children: e.map(({ value: u, label: d, onClick: f }) => /* @__PURE__ */ C(Nn, { onClick: () => c(f), children: d }, u))
      }
    )
  ] });
}, Z7 = ({
  tooltip: e,
  size: t = "small",
  ...n
}) => /* @__PURE__ */ C(VM, { title: e, children: /* @__PURE__ */ C(LM, { size: t, ...n }) }), Dve = ({
  toggles: e,
  exclusive: t,
  ...n
}) => {
  const o = e.filter((i) => i.selected).map((i) => i.value), s = t ? o[0] : o;
  return /* @__PURE__ */ C(_M, { exclusive: t, value: s, ...n, children: e.map(({ selected: i, ...a }) => /* @__PURE__ */ C(Z7, { ...a }, a.value.toString())) });
}, AC = (e, t, n) => {
  const o = t && !["inherit", "default", "standard"].includes(t) ? t : "primary";
  return e.palette[o][n];
}, Df = (e, t) => AC(e, t, "main"), ik = (e, t) => AC(e, t, "contrastText"), ak = (e, t) => AC(e, t, "background"), J7 = {
  defaultProps: {
    variant: "text",
    disableElevation: !0
  },
  styleOverrides: {
    root: ({ theme: e, ownerState: t }) => ({
      width: "max-content",
      textTransform: "inherit",
      fontSize: t.size === "large" ? e.typography.body1.fontSize : e.typography.body2.fontSize,
      padding: `${e.spacing(1)} ${e.spacing(5)}`
    }),
    contained: ({ theme: e, ownerState: t }) => ({
      color: Df(e, t.color),
      backgroundColor: ak(e, t.color),
      "&:hover": {
        backgroundColor: ik(e, t.color)
      }
    })
  }
}, eW = {
  defaultProps: {
    size: "small",
    fullWidth: !0
  },
  styleOverrides: {}
}, lk = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme: e, ownerState: t }) => ({
      textTransform: "none",
      fontSize: e.typography.body2.fontSize,
      minWidth: "max-content",
      textWrap: "nowrap",
      "&.Mui-selected": {
        color: e.palette.text.primary,
        backgroundColor: ak(e, t.color)
      }
    })
  }
}, tW = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme: e }) => ({
      ...lk.styleOverrides.root({ theme: e }),
      padding: e.spacing(0, 4)
    })
  }
}, nW = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme: e }) => ({
      gap: e.spacing(2.5),
      alignItems: "center"
    })
  }
}, oW = {
  MuiButton: J7,
  MuiToolbar: nW,
  MuiToggleButton: tW,
  MuiFormControl: eW
}, rW = (e) => gl({
  palette: e.palette,
  typography: e.typography,
  shape: e.shape,
  breakpoints: e.breakpoints,
  transitions: e.transitions,
  shadows: e.shadows,
  zIndex: e.zIndex,
  spacing: 2,
  components: {
    ...e.components,
    ...oW
  }
}), sW = ({ children: e }) => {
  const t = sn(), n = Ye(() => rW(t), [t]);
  return /* @__PURE__ */ C(Sv, { injectFirst: !0, children: /* @__PURE__ */ C($v, { theme: n, children: e }) });
}, Nve = ({ children: e, noGap: t = !1 }) => /* @__PURE__ */ C(sW, { children: /* @__PURE__ */ C(
  Bp,
  {
    disableGutters: !0,
    sx: {
      gap: t ? 0 : void 0
    },
    children: e
  }
) });
var gg = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var j1;
function iW() {
  return j1 || (j1 = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var i = "", a = 0; a < arguments.length; a++) {
          var l = arguments[a];
          l && (i = s(i, o(l)));
        }
        return i;
      }
      function o(i) {
        if (typeof i == "string" || typeof i == "number")
          return i;
        if (typeof i != "object")
          return "";
        if (Array.isArray(i))
          return n.apply(null, i);
        if (i.toString !== Object.prototype.toString && !i.toString.toString().includes("[native code]"))
          return i.toString();
        var a = "";
        for (var l in i)
          t.call(i, l) && i[l] && (a = s(a, l));
        return a;
      }
      function s(i, a) {
        return a ? i ? i + " " + a : i + a : i;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(gg)), gg.exports;
}
var aW = iW();
const lW = /* @__PURE__ */ Zo(aW), cW = jp(() => ({
  fileInput: {
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1
  },
  actionButtonLabel: {
    display: "block",
    textTransform: "none",
    marginLeft: "10px",
    fontStyle: "italic"
  },
  actionButtonBigLabel: {
    fontWeight: "bold",
    fontStyle: "normal"
  },
  fileName: {
    fontStyle: "italic",
    fontWeight: "normal",
    textAlign: "start"
  },
  fileIcon: {
    transform: "rotate(-90deg)"
  }
})), $ve = ({
  onFileChange: e,
  fileName: t,
  bigger: n,
  ...o
}) => {
  const s = cW(), i = Ft(null);
  return /* @__PURE__ */ ie(
    Io,
    {
      onClick: () => {
        i.current && i.current.click();
      },
      startIcon: t ? /* @__PURE__ */ C(E8, {}) : /* @__PURE__ */ C(R8, {}),
      size: n ? "large" : "medium",
      ...o,
      children: [
        /* @__PURE__ */ C(
          "input",
          {
            className: s.fileInput,
            type: "file",
            ref: i,
            onChange: e
          }
        ),
        /* @__PURE__ */ C(
          "div",
          {
            className: lW(s.actionButtonLabel, {
              [s.actionButtonBigLabel]: n
            }),
            children: t ? /* @__PURE__ */ ie(mo, { children: [
              "File attachment",
              /* @__PURE__ */ C("div", { className: s.fileName, children: t })
            ] }) : "Choose a file"
          }
        )
      ]
    }
  );
}, Cs = ({ children: e, ...t }) => /* @__PURE__ */ C(yn, { ...t, children: e }), uW = ({ title: e, subtitle: t }) => /* @__PURE__ */ ie(
  Gt,
  {
    sx: {
      display: "flex",
      flexDirection: "column",
      gap: 0.25
    },
    children: [
      e && /* @__PURE__ */ C(
        Gt,
        {
          sx: (n) => ({
            color: n.palette.text.primary,
            fontSize: n.typography.body1.fontSize
          }),
          children: bo(e) ? e : /* @__PURE__ */ C(Cs, { variant: "body1", sx: { fontWeight: "bold" }, children: e })
        }
      ),
      t && /* @__PURE__ */ C(
        Gt,
        {
          sx: (n) => ({
            color: n.palette.text.secondary,
            fontSize: n.typography.body2.fontSize
          }),
          children: bo(t) ? t : /* @__PURE__ */ C(Cs, { variant: "body2", children: t })
        }
      )
    ]
  }
), Ave = ({
  children: e,
  variant: t = "basic",
  fullWidth: n = !1,
  title: o,
  subtitle: s,
  noPadding: i = !1,
  "data-testid": a,
  ...l
}) => /* @__PURE__ */ C(
  Gt,
  {
    sx: {
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
      width: n ? "100%" : "auto"
    },
    children: /* @__PURE__ */ ie(
      tM,
      {
        "data-testid": a,
        sx: {
          backgroundColor: "transparent",
          padding: 0
        },
        ...l,
        children: [
          !!(o || s) && /* @__PURE__ */ C(
            Gt,
            {
              sx: (u) => ({
                paddingX: 2,
                paddingY: 1.5,
                paddingBottom: t === "outlined" ? 1.5 : 0,
                borderBottom: t === "outlined" ? "1px solid" : "none",
                borderColor: "divider",
                backgroundColor: t === "outlined" ? u.palette.primary.background : "transparent"
              }),
              children: /* @__PURE__ */ C(uW, { title: o, subtitle: s })
            }
          ),
          /* @__PURE__ */ C(Gt, { sx: { padding: i ? 0 : 2 }, children: e })
        ]
      }
    )
  }
), dW = (e) => yf(e) > 0.5 ? $o(e, 0.75) : wo(e, 0.9), fW = ({
  variant: e = "filled",
  size: t = "medium",
  color: n = "primary",
  label: o,
  icon: s,
  colorOverride: i,
  ...a
}) => {
  const l = sn(), c = {
    color: i || `${n}.main`,
    backgroundColor: i ? dW(i) : `${n}.background`,
    borderColor: i || `${n}.main`
  };
  if (e === "contrast")
    c.color = l.palette[n].contrastText, c.backgroundColor = l.palette[n].main;
  else if (e === "text")
    return /* @__PURE__ */ C(vt, { component: "span", color: l.palette[n].main, children: o });
  return /* @__PURE__ */ C(
    Su,
    {
      label: o,
      variant: e === "outlined" ? "outlined" : "filled",
      size: t,
      sx: c,
      icon: s,
      ...a
    }
  );
}, ck = [];
let Ei = 0;
for (; Ei < 64; )
  ck[Ei] = 0 | Math.sin(++Ei % Math.PI) * 4294967296;
function pW(e) {
  const t = [];
  let n, o, s, i = unescape(encodeURI(e)) + "", a = i.length;
  const l = [n = 1732584193, o = 4023233417, ~n, ~o];
  for (e = --a / 4 + 2 | 15, t[--e] = a * 8; ~a; )
    t[a >> 2] |= i.charCodeAt(a) << 8 * a--;
  for (Ei = i = 0; Ei < e; Ei += 16) {
    for (a = l; i < 64; a = [s = a[3], n + ((s = a[0] + [n & o | ~n & s, s & n | ~s & o, n ^ o ^ s, o ^ (n | ~s)][a = i >> 4] + ck[i] + ~~t[Ei | [i, 5 * i + 1, 3 * i + 5, 7 * i][a] & 15]) << (a = [7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21][4 * a + i++ % 4]) | s >>> -a), n, o])
      n = a[1] | 0, o = a[2];
    for (i = 4; i; ) l[--i] += a[i];
  }
  for (e = ""; i < 32; )
    e += (l[i >> 3] >> (1 ^ i++) * 4 & 15).toString(16);
  return e;
}
const xd = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", uk = (e) => {
  let t = "", n, o, s, i, a, l, c, u = 0;
  for (e = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""); u < e.length; )
    i = xd.indexOf(e.charAt(u++)), a = xd.indexOf(e.charAt(u++)), l = xd.indexOf(e.charAt(u++)), c = xd.indexOf(e.charAt(u++)), n = i << 2 | a >> 4, o = (a & 15) << 4 | l >> 2, s = (l & 3) << 6 | c, t = t + String.fromCharCode(n), l != 64 && (t = t + String.fromCharCode(o)), c != 64 && (t = t + String.fromCharCode(s));
  return t;
}, hW = ["pro", "premium"], gW = [
  /**
   * A license is outdated if the current version of the software was released after the expiry date of the license.
   * But the license can be used indefinitely with an older version of the software.
   */
  "perpetual",
  /**
   * On development, a license is outdated if the expiry date has been reached
   * On production, a license is outdated if the current version of the software was released after the expiry date of the license (see "perpetual")
   */
  "annual",
  /**
   * Legacy. The previous name for 'annual'.
   * Can be removed once old license keys generated with 'subscription' are no longer supported.
   * To support for a while. We need more years of backward support and we sell multi year licenses.
   */
  "subscription"
], mW = typeof window < "u" && window.location.hostname.endsWith(".csb.app");
function Sl(e) {
  (mW ? console.log : console.error)(["*************************************************************", "", ...e, "", "*************************************************************"].join(`
`));
}
function bW() {
  Sl(["MUI X: Invalid license key.", "", "Your MUI X license key format isn't valid. It could be because the license key is missing a character or has a typo.", "", "To solve the issue, you need to double check that `setLicenseKey()` is called with the right argument", "Please check the license key installation https://mui.com/r/x-license-key-installation."]);
}
function yW() {
  Sl(["MUI X: License key plan mismatch.", "", "Your use of MUI X is not compatible with the plan of your license key. The feature you are trying to use is not included in the plan of your license key. This happens if you try to use Data Grid Premium with a license key for the Pro plan.", "", "To solve the issue, you can upgrade your plan from Pro to Premium at https://mui.com/r/x-get-license?scope=premium.", "Of if you didn't intend to use Premium features, you can replace the import of `@mui/x-data-grid-premium` with `@mui/x-data-grid-pro`."]);
}
function vW() {
  Sl(["MUI X: Component not included in your license.", "", "The component you are trying to use is not included in the Pro Plan you purchased.", "", "Your license is from an old version of the Pro Plan that is only compatible with the `@mui/x-data-grid-pro` and `@mui/x-date-pickers-pro` commercial packages.", "", "To start using another Pro package, please consider reaching to our sales team to upgrade your license or visit https://mui.com/r/x-get-license to get a new license key."]);
}
function CW({
  plan: e,
  packageName: t
}) {
  Sl(["MUI X: Missing license key.", "", `The license key is missing. You might not be allowed to use \`${t}\` which is part of MUI X ${e}.`, "", "To solve the issue, you can check the free trial conditions: https://mui.com/r/x-license-trial.", "If you are eligible no actions are required. If you are not eligible to the free trial, you need to purchase a license https://mui.com/r/x-get-license or stop using the software immediately."]);
}
function wW({
  packageName: e
}) {
  Sl(["MUI X: Expired package version.", "", `You have installed a version of \`${e}\` that is outside of the maintenance plan of your license key. By default, commercial licenses provide access to new versions released during the first year after the purchase.`, "", "To solve the issue, you can renew your license https://mui.com/r/x-get-license or install an older version of the npm package that is compatible with your license key."]);
}
function SW({
  plan: e,
  licenseKey: t,
  expiryTimestamp: n
}) {
  Sl(["MUI X: Expired license key.", "", `Your annual license key to use MUI X ${e} in non-production environments has expired. If you are seeing this development console message, you might be close to breach the license terms by making direct or indirect changes to the frontend of an app that render a MUI X ${e} component (more details in https://mui.com/r/x-license-annual).`, "", "To solve the problem you can either:", "", "- Renew your license https://mui.com/r/x-get-license and use the new key", `- Stop making changes to code depending directly or indirectly on MUI X ${e}'s APIs`, "", "Note that your license is perpetual in production environments with any version released before your license term ends.", "", `- License key expiry timestamp: ${new Date(n)}`, `- Installed license key: ${t}`, ""]);
}
function xW({
  plan: e,
  licenseKey: t,
  expiryTimestamp: n
}) {
  throw new Error(["MUI X: Expired license key.", "", `Your annual license key to use MUI X ${e} in non-production environments has expired. If you are seeing this development console message, you might be close to breach the license terms by making direct or indirect changes to the frontend of an app that render a MUI X ${e} component (more details in https://mui.com/r/x-license-annual).`, "", "To solve the problem you can either:", "", "- Renew your license https://mui.com/r/x-get-license and use the new key", `- Stop making changes to code depending directly or indirectly on MUI X ${e}'s APIs`, "", "Note that your license is perpetual in production environments with any version released before your license term ends.", "", `- License key expiry timestamp: ${new Date(n)}`, `- Installed license key: ${t}`, ""].join(`
`));
}
Kb.__MUI_LICENSE_INFO__ = Kb.__MUI_LICENSE_INFO__ || {
  key: void 0
};
class Nf {
  static getLicenseInfo() {
    return Kb.__MUI_LICENSE_INFO__;
  }
  static getLicenseKey() {
    return Nf.getLicenseInfo().key;
  }
  static setLicenseKey(t) {
    const n = Nf.getLicenseInfo();
    n.key = t;
  }
}
let ln = /* @__PURE__ */ function(e) {
  return e.NotFound = "NotFound", e.Invalid = "Invalid", e.ExpiredAnnual = "ExpiredAnnual", e.ExpiredAnnualGrace = "ExpiredAnnualGrace", e.ExpiredVersion = "ExpiredVersion", e.Valid = "Valid", e.OutOfScope = "OutOfScope", e.NotAvailableInInitialProPlan = "NotAvailableInInitialProPlan", e;
}({});
function TW(e, t) {
  let n;
  return e.includes("-pro") ? n = ["pro", "premium"] : e.includes("-premium") ? n = ["premium"] : n = [], n.includes(t);
}
const RW = /^.*EXPIRY=([0-9]+),.*$/, EW = ["x-data-grid-pro", "x-date-pickers-pro"], IW = (e) => {
  let t;
  try {
    t = parseInt(e.match(RW)[1], 10), (!t || Number.isNaN(t)) && (t = null);
  } catch {
    t = null;
  }
  return {
    planScope: "pro",
    licenseModel: "perpetual",
    expiryTimestamp: t,
    planVersion: "initial"
  };
}, OW = (e) => {
  const t = {
    planScope: null,
    licenseModel: null,
    expiryTimestamp: null,
    planVersion: "initial"
  };
  return e.split(",").map((n) => n.split("=")).filter((n) => n.length === 2).forEach(([n, o]) => {
    if (n === "S" && (t.planScope = o), n === "LM" && (t.licenseModel = o), n === "E") {
      const s = parseInt(o, 10);
      s && !Number.isNaN(s) && (t.expiryTimestamp = s);
    }
    n === "PV" && (t.planVersion = o);
  }), t;
}, PW = (e) => {
  const t = uk(e);
  return t.includes("KEYVERSION=1") ? IW(t) : t.includes("KV=2") ? OW(t) : null;
};
function MW({
  releaseInfo: e,
  licenseKey: t,
  packageName: n
}) {
  if (!e)
    throw new Error("MUI X: The release information is missing. Not able to validate license.");
  if (!t)
    return {
      status: ln.NotFound
    };
  const o = t.substr(0, 32), s = t.substr(32);
  if (o !== pW(s))
    return {
      status: ln.Invalid
    };
  const i = PW(s);
  if (i == null)
    return console.error("MUI X: Error checking license. Key version not found!"), {
      status: ln.Invalid
    };
  if (i.licenseModel == null || !gW.includes(i.licenseModel))
    return console.error("MUI X: Error checking license. Licensing model not found or invalid!"), {
      status: ln.Invalid
    };
  if (i.expiryTimestamp == null)
    return console.error("MUI X: Error checking license. Expiry timestamp not found or invalid!"), {
      status: ln.Invalid
    };
  if (i.licenseModel === "perpetual" || process.env.NODE_ENV === "production") {
    const a = parseInt(uk(e), 10);
    if (Number.isNaN(a))
      throw new Error("MUI X: The release information is invalid. Not able to validate license.");
    if (i.expiryTimestamp < a)
      return {
        status: ln.ExpiredVersion
      };
  } else if ((i.licenseModel === "subscription" || i.licenseModel === "annual") && (/* @__PURE__ */ new Date()).getTime() > i.expiryTimestamp)
    return (
      // 30 days grace
      (/* @__PURE__ */ new Date()).getTime() < i.expiryTimestamp + 1e3 * 3600 * 24 * 30 || process.env.NODE_ENV !== "development" ? {
        status: ln.ExpiredAnnualGrace,
        meta: {
          expiryTimestamp: i.expiryTimestamp,
          licenseKey: t
        }
      } : {
        status: ln.ExpiredAnnual,
        meta: {
          expiryTimestamp: i.expiryTimestamp,
          licenseKey: t
        }
      }
    );
  return i.planScope == null || !hW.includes(i.planScope) ? (console.error("MUI X: Error checking license. planScope not found or invalid!"), {
    status: ln.Invalid
  }) : TW(n, i.planScope) ? i.planVersion === "initial" && i.planScope === "pro" && !EW.includes(n) ? {
    status: ln.NotAvailableInInitialProPlan
  } : {
    status: ln.Valid
  } : {
    status: ln.OutOfScope
  };
}
const dk = /* @__PURE__ */ h.createContext({
  key: void 0
});
process.env.NODE_ENV !== "production" && (dk.displayName = "MuiLicenseInfoContext");
const Td = {};
function Mu(e, t) {
  const {
    key: n
  } = h.useContext(dk);
  return h.useMemo(() => {
    const o = n ?? Nf.getLicenseKey();
    if (Td[e] && Td[e].key === o)
      return Td[e].licenseVerifier;
    const s = e.includes("premium") ? "Premium" : "Pro", i = MW({
      releaseInfo: t,
      licenseKey: o,
      packageName: e
    }), a = `@mui/${e}`;
    if (i.status !== ln.Valid) {
      if (i.status === ln.Invalid)
        bW();
      else if (i.status === ln.NotAvailableInInitialProPlan)
        vW();
      else if (i.status === ln.OutOfScope)
        yW();
      else if (i.status === ln.NotFound)
        CW({
          plan: s,
          packageName: a
        });
      else if (i.status === ln.ExpiredAnnualGrace)
        SW(I({
          plan: s
        }, i.meta));
      else if (i.status === ln.ExpiredAnnual)
        xW(I({
          plan: s
        }, i.meta));
      else if (i.status === ln.ExpiredVersion)
        wW({
          packageName: a
        });
      else if (process.env.NODE_ENV !== "production")
        throw new Error("missing status handler");
    }
    return Td[e] = {
      key: o,
      licenseVerifier: i
    }, i;
  }, [e, t, n]);
}
const kW = Object.is;
function fk(e, t) {
  if (e === t)
    return !0;
  if (!(e instanceof Object) || !(t instanceof Object))
    return !1;
  let n = 0, o = 0;
  for (const s in e)
    if (n += 1, !kW(e[s], t[s]) || !(s in t))
      return !1;
  for (const s in t)
    o += 1;
  return n === o;
}
function Dr(e) {
  return /* @__PURE__ */ h.memo(e, fk);
}
function DW(e) {
  switch (e) {
    case ln.ExpiredAnnualGrace:
    case ln.ExpiredAnnual:
      return "MUI X Expired license key";
    case ln.ExpiredVersion:
      return "MUI X Expired package version";
    case ln.Invalid:
      return "MUI X Invalid license key";
    case ln.OutOfScope:
      return "MUI X License key plan mismatch";
    case ln.NotAvailableInInitialProPlan:
      return "MUI X Product not covered by plan";
    case ln.NotFound:
      return "MUI X Missing license key";
    default:
      throw new Error("Unhandled MUI X license status.");
  }
}
function NW(e) {
  const {
    packageName: t,
    releaseInfo: n
  } = e, o = Mu(t, n);
  return o.status === ln.Valid ? null : /* @__PURE__ */ C("div", {
    style: {
      position: "absolute",
      pointerEvents: "none",
      color: "#8282829e",
      zIndex: 1e5,
      width: "100%",
      textAlign: "center",
      bottom: "50%",
      right: 0,
      letterSpacing: 5,
      fontSize: 24
    },
    children: DW(o.status)
  });
}
const pk = Dr(NW);
var $W = (e, t, n) => {
  if (t.length === 1 && t[0] === n) {
    let o = !1;
    try {
      const s = {};
      e(s) === s && (o = !0);
    } catch {
    }
    if (o) {
      let s;
      try {
        throw new Error();
      } catch (i) {
        ({ stack: s } = i);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: s }
      );
    }
  }
}, AW = (e, t, n) => {
  const { memoize: o, memoizeOptions: s } = t, { inputSelectorResults: i, inputSelectorResultsCopy: a } = e, l = o(() => ({}), ...s);
  if (!(l.apply(null, i) === l.apply(null, a))) {
    let u;
    try {
      throw new Error();
    } catch (d) {
      ({ stack: u } = d);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: i,
        secondInputs: a,
        stack: u
      }
    );
  }
}, FW = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, $f = /* @__PURE__ */ Symbol("NOT_FOUND");
function LW(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function _W(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function VW(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((n) => typeof n == "function")) {
    const n = e.map(
      (o) => typeof o == "function" ? `function ${o.name || "unnamed"}()` : typeof o
    ).join(", ");
    throw new TypeError(`${t}[${n}]`);
  }
}
var G1 = (e) => Array.isArray(e) ? e : [e];
function BW(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return VW(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function q1(e, t) {
  const n = [], { length: o } = e;
  for (let s = 0; s < o; s++)
    n.push(e[s].apply(null, t));
  return n;
}
var zW = (e, t) => {
  const { identityFunctionCheck: n, inputStabilityCheck: o } = {
    ...FW,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: $W
    },
    inputStabilityCheck: {
      shouldRun: o === "always" || o === "once" && e,
      run: AW
    }
  };
};
function HW(e) {
  let t;
  return {
    get(n) {
      return t && e(t.key, n) ? t.value : $f;
    },
    put(n, o) {
      t = { key: n, value: o };
    },
    getEntries() {
      return t ? [t] : [];
    },
    clear() {
      t = void 0;
    }
  };
}
function jW(e, t) {
  let n = [];
  function o(l) {
    const c = n.findIndex((u) => t(l, u.key));
    if (c > -1) {
      const u = n[c];
      return c > 0 && (n.splice(c, 1), n.unshift(u)), u.value;
    }
    return $f;
  }
  function s(l, c) {
    o(l) === $f && (n.unshift({ key: l, value: c }), n.length > e && n.pop());
  }
  function i() {
    return n;
  }
  function a() {
    n = [];
  }
  return { get: o, put: s, getEntries: i, clear: a };
}
var GW = (e, t) => e === t;
function qW(e) {
  return function(n, o) {
    if (n === null || o === null || n.length !== o.length)
      return !1;
    const { length: s } = n;
    for (let i = 0; i < s; i++)
      if (!e(n[i], o[i]))
        return !1;
    return !0;
  };
}
function hk(e, t) {
  const n = typeof t == "object" ? t : { equalityCheck: t }, {
    equalityCheck: o = GW,
    maxSize: s = 1,
    resultEqualityCheck: i
  } = n, a = qW(o);
  let l = 0;
  const c = s <= 1 ? HW(a) : jW(s, a);
  function u() {
    let d = c.get(arguments);
    if (d === $f) {
      if (d = e.apply(null, arguments), l++, i) {
        const p = c.getEntries().find(
          (m) => i(m.value, d)
        );
        p && (d = p.value, l !== 0 && l--);
      }
      c.put(arguments, d);
    }
    return d;
  }
  return u.clearCache = () => {
    c.clear(), u.resetResultsCount();
  }, u.resultsCount = () => l, u.resetResultsCount = () => {
    l = 0;
  }, u;
}
var WW = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, UW = typeof WeakRef < "u" ? WeakRef : WW, KW = 0, W1 = 1;
function Rd() {
  return {
    s: KW,
    v: void 0,
    o: null,
    p: null
  };
}
function gk(e, t = {}) {
  let n = Rd();
  const { resultEqualityCheck: o } = t;
  let s, i = 0;
  function a() {
    var f;
    let l = n;
    const { length: c } = arguments;
    for (let p = 0, m = c; p < m; p++) {
      const b = arguments[p];
      if (typeof b == "function" || typeof b == "object" && b !== null) {
        let v = l.o;
        v === null && (l.o = v = /* @__PURE__ */ new WeakMap());
        const g = v.get(b);
        g === void 0 ? (l = Rd(), v.set(b, l)) : l = g;
      } else {
        let v = l.p;
        v === null && (l.p = v = /* @__PURE__ */ new Map());
        const g = v.get(b);
        g === void 0 ? (l = Rd(), v.set(b, l)) : l = g;
      }
    }
    const u = l;
    let d;
    if (l.s === W1)
      d = l.v;
    else if (d = e.apply(null, arguments), i++, o) {
      const p = ((f = s == null ? void 0 : s.deref) == null ? void 0 : f.call(s)) ?? s;
      p != null && o(p, d) && (d = p, i !== 0 && i--), s = typeof d == "object" && d !== null || typeof d == "function" ? new UW(d) : d;
    }
    return u.s = W1, u.v = d, d;
  }
  return a.clearCache = () => {
    n = Rd(), a.resetResultsCount();
  }, a.resultsCount = () => i, a.resetResultsCount = () => {
    i = 0;
  }, a;
}
function mk(e, ...t) {
  const n = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, o = (...s) => {
    let i = 0, a = 0, l, c = {}, u = s.pop();
    typeof u == "object" && (c = u, u = s.pop()), LW(
      u,
      `createSelector expects an output function after the inputs, but received: [${typeof u}]`
    );
    const d = {
      ...n,
      ...c
    }, {
      memoize: f,
      memoizeOptions: p = [],
      argsMemoize: m = gk,
      argsMemoizeOptions: b = [],
      devModeChecks: v = {}
    } = d, g = G1(p), y = G1(b), w = BW(s), x = f(function() {
      return i++, u.apply(
        null,
        arguments
      );
    }, ...g);
    let S = !0;
    const T = m(function() {
      a++;
      const O = q1(
        w,
        arguments
      );
      if (l = x.apply(null, O), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: M, inputStabilityCheck: D } = zW(S, v);
        if (M.shouldRun && M.run(
          u,
          O,
          l
        ), D.shouldRun) {
          const R = q1(
            w,
            arguments
          );
          D.run(
            { inputSelectorResults: O, inputSelectorResultsCopy: R },
            { memoize: f, memoizeOptions: g },
            arguments
          );
        }
        S && (S = !1);
      }
      return l;
    }, ...y);
    return Object.assign(T, {
      resultFunc: u,
      memoizedResultFunc: x,
      dependencies: w,
      dependencyRecomputations: () => a,
      resetDependencyRecomputations: () => {
        a = 0;
      },
      lastResult: () => l,
      recomputations: () => i,
      resetRecomputations: () => {
        i = 0;
      },
      memoize: f,
      argsMemoize: m
    });
  };
  return Object.assign(o, {
    withTypes: () => o
  }), o;
}
var bk = /* @__PURE__ */ mk(gk), YW = Object.assign(
  (e, t = bk) => {
    _W(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const n = Object.keys(e), o = n.map(
      (i) => e[i]
    );
    return t(
      o,
      (...i) => i.reduce((a, l, c) => (a[n[c]] = l, a), {})
    );
  },
  { withTypes: () => YW }
);
const U1 = /* @__PURE__ */ new Set();
function vo(e, t = "warning") {
  if (process.env.NODE_ENV === "production")
    return;
  const n = Array.isArray(e) ? e.join(`
`) : e;
  U1.has(n) || (U1.add(n), t === "error" ? console.error(n) : console.warn(n));
}
var Ed = { exports: {} }, mg = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var K1;
function XW() {
  if (K1) return mg;
  K1 = 1;
  var e = en;
  function t(f, p) {
    return f === p && (f !== 0 || 1 / f === 1 / p) || f !== f && p !== p;
  }
  var n = typeof Object.is == "function" ? Object.is : t, o = e.useState, s = e.useEffect, i = e.useLayoutEffect, a = e.useDebugValue;
  function l(f, p) {
    var m = p(), b = o({ inst: { value: m, getSnapshot: p } }), v = b[0].inst, g = b[1];
    return i(
      function() {
        v.value = m, v.getSnapshot = p, c(v) && g({ inst: v });
      },
      [f, m, p]
    ), s(
      function() {
        return c(v) && g({ inst: v }), f(function() {
          c(v) && g({ inst: v });
        });
      },
      [f]
    ), a(m), m;
  }
  function c(f) {
    var p = f.getSnapshot;
    f = f.value;
    try {
      var m = p();
      return !n(f, m);
    } catch {
      return !0;
    }
  }
  function u(f, p) {
    return p();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : l;
  return mg.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : d, mg;
}
var bg = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Y1;
function QW() {
  return Y1 || (Y1 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(m, b) {
      return m === b && (m !== 0 || 1 / m === 1 / b) || m !== m && b !== b;
    }
    function t(m, b) {
      d || s.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var v = b();
      if (!f) {
        var g = b();
        i(v, g) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      g = a({
        inst: { value: v, getSnapshot: b }
      });
      var y = g[0].inst, w = g[1];
      return c(
        function() {
          y.value = v, y.getSnapshot = b, n(y) && w({ inst: y });
        },
        [m, v, b]
      ), l(
        function() {
          return n(y) && w({ inst: y }), m(function() {
            n(y) && w({ inst: y });
          });
        },
        [m]
      ), u(v), v;
    }
    function n(m) {
      var b = m.getSnapshot;
      m = m.value;
      try {
        var v = b();
        return !i(m, v);
      } catch {
        return !0;
      }
    }
    function o(m, b) {
      return b();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var s = en, i = typeof Object.is == "function" ? Object.is : e, a = s.useState, l = s.useEffect, c = s.useLayoutEffect, u = s.useDebugValue, d = !1, f = !1, p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? o : t;
    bg.useSyncExternalStore = s.useSyncExternalStore !== void 0 ? s.useSyncExternalStore : p, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), bg;
}
var X1;
function ZW() {
  return X1 || (X1 = 1, process.env.NODE_ENV === "production" ? Ed.exports = XW() : Ed.exports = QW()), Ed.exports;
}
var FC = ZW();
function yk(e) {
  return e.acceptsApiRef;
}
function Q1(e, t) {
  return yk(t) ? t(e) : t(e.current.state);
}
function yg(e, t, n, o) {
  return yk(t) ? t(e, n) : t(e.current.state, o);
}
const vk = Object.is, LC = fk, JW = (e, t) => e === t ? !0 : e.length === t.length && e.every((n, o) => n === t[o]), eU = (e, t) => {
  let n = Object.is;
  return t instanceof Array ? n = JW : t instanceof Object && (n = LC), n(e, t);
}, Ck = () => ({
  state: null,
  equals: null,
  selector: null,
  args: void 0
}), Af = [], wk = () => null, ge = (e, t, n = vk) => {
  process.env.NODE_ENV !== "production" && (e.current.state || vo(["MUI X: `useGridSelector` has been called before the initialization of the state.", "This hook can only be used inside the context of the grid."]));
  const o = Jo(Ck), s = o.current.selector !== null, [i, a] = h.useState(
    // We don't use an initialization function to avoid allocations
    s ? null : Q1(e, t)
  );
  o.current.state = i, o.current.equals = n, o.current.selector = t;
  const l = h.useCallback(
    () => (o.current.subscription || (o.current.subscription = e.current.store.subscribe(() => {
      const u = Q1(e, o.current.selector);
      o.current.equals(o.current.state, u) || (o.current.state = u, a(u));
    })), null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Af
  ), c = h.useCallback(() => () => {
    o.current.subscription && (o.current.subscription(), o.current.subscription = void 0);
  }, Af);
  return FC.useSyncExternalStore(c, l, wk), i;
}, Ys = (e, t, n = void 0, o = vk) => {
  process.env.NODE_ENV !== "production" && (e.current.state || vo(["MUI X: `useGridSelector` has been called before the initialization of the state.", "This hook can only be used inside the context of the grid."]));
  const s = Jo(Ck), i = s.current.selector !== null, [a, l] = h.useState(
    // We don't use an initialization function to avoid allocations
    i ? null : yg(e, t, n, e.current.instanceId)
  );
  s.current.state = a, s.current.equals = o, s.current.selector = t;
  const c = s.current.args;
  if (s.current.args = n, i && !eU(c, n)) {
    const f = yg(e, s.current.selector, s.current.args, e.current.instanceId);
    s.current.equals(s.current.state, f) || (s.current.state = f, l(f));
  }
  const u = h.useCallback(
    () => (s.current.subscription || (s.current.subscription = e.current.store.subscribe(() => {
      const f = yg(e, s.current.selector, s.current.args, e.current.instanceId);
      s.current.equals(s.current.state, f) || (s.current.state = f, l(f));
    })), null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    Af
  ), d = h.useCallback(() => () => {
    s.current.subscription && (s.current.subscription(), s.current.subscription = void 0);
  }, Af);
  return FC.useSyncExternalStore(d, u, wk), a;
}, tU = mk({
  memoize: hk,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
}), Z1 = /* @__PURE__ */ new WeakMap();
function Er(e) {
  return "current" in e && "instanceId" in e.current;
}
const Ir = {
  id: "default"
}, Je = (e, t, n, o, s, i, ...a) => {
  if (a.length > 0)
    throw new Error("Unsupported number of selectors");
  let l;
  if (e && t && n && o && s && i)
    l = (c, u) => {
      const d = Er(c), f = u ?? (d ? c.current.instanceId : Ir), p = d ? c.current.state : c, m = e(p, f), b = t(p, f), v = n(p, f), g = o(p, f), y = s(p, f);
      return i(m, b, v, g, y);
    };
  else if (e && t && n && o && s)
    l = (c, u) => {
      const d = Er(c), f = u ?? (d ? c.current.instanceId : Ir), p = d ? c.current.state : c, m = e(p, f), b = t(p, f), v = n(p, f), g = o(p, f);
      return s(m, b, v, g);
    };
  else if (e && t && n && o)
    l = (c, u) => {
      const d = Er(c), f = u ?? (d ? c.current.instanceId : Ir), p = d ? c.current.state : c, m = e(p, f), b = t(p, f), v = n(p, f);
      return o(m, b, v);
    };
  else if (e && t && n)
    l = (c, u) => {
      const d = Er(c), f = u ?? (d ? c.current.instanceId : Ir), p = d ? c.current.state : c, m = e(p, f), b = t(p, f);
      return n(m, b);
    };
  else if (e && t)
    l = (c, u) => {
      const d = Er(c), f = u ?? (d ? c.current.instanceId : Ir), p = d ? c.current.state : c, m = e(p, f);
      return t(m);
    };
  else
    throw new Error("Missing arguments");
  return l.acceptsApiRef = !0, l;
}, ni = (e, t, n, o, s, i, ...a) => {
  if (a.length > 0)
    throw new Error("Unsupported number of selectors");
  let l;
  if (e && t && n && o && s && i)
    l = (c, u, d) => {
      const f = Er(c), p = d ?? (f ? c.current.instanceId : Ir), m = f ? c.current.state : c, b = e(m, u, p), v = t(m, u, p), g = n(m, u, p), y = o(m, u, p), w = s(m, u, p);
      return i(b, v, g, y, w, u);
    };
  else if (e && t && n && o && s)
    l = (c, u, d) => {
      const f = Er(c), p = d ?? (f ? c.current.instanceId : Ir), m = f ? c.current.state : c, b = e(m, u, p), v = t(m, u, p), g = n(m, u, p), y = o(m, u, p);
      return s(b, v, g, y, u);
    };
  else if (e && t && n && o)
    l = (c, u, d) => {
      const f = Er(c), p = d ?? (f ? c.current.instanceId : Ir), m = f ? c.current.state : c, b = e(m, u, p), v = t(m, u, p), g = n(m, u, p);
      return o(b, v, g, u);
    };
  else if (e && t && n)
    l = (c, u, d) => {
      const f = Er(c), p = d ?? (f ? c.current.instanceId : Ir), m = f ? c.current.state : c, b = e(m, u, p), v = t(m, u, p);
      return n(b, v, u);
    };
  else if (e && t)
    l = (c, u, d) => {
      const f = Er(c), p = d ?? (f ? c.current.instanceId : Ir), m = f ? c.current.state : c, b = e(m, u, p);
      return t(b, u);
    };
  else
    throw new Error("Missing arguments");
  return l.acceptsApiRef = !0, l;
}, Mt = (...e) => {
  const t = (n, o) => {
    const s = Er(n), i = s ? n.current.instanceId : o ?? Ir, a = s ? n.current.state : n;
    process.env.NODE_ENV !== "production" && i.id === "default" && vo(["MUI X: A selector was called without passing the instance ID, which may impact the performance of the grid.", "To fix, call it with `apiRef`, for example `mySelector(apiRef)`, or pass the instance ID explicitly, for example `mySelector(state, apiRef.current.instanceId)`."]);
    const l = Z1.get(i), c = l ?? /* @__PURE__ */ new Map(), u = c == null ? void 0 : c.get(e);
    if (c && u)
      return u(a, i);
    const d = tU(...e);
    return l || Z1.set(i, c), c.set(e, d), d(a, i);
  };
  return t.acceptsApiRef = !0, t;
}, Kn = (e) => e.dimensions, xl = Je(Kn, (e) => e.columnsTotalWidth), _C = (e) => e.dimensions.rowHeight, nU = (e) => e.dimensions.contentSize.height, oU = (e) => e.dimensions.hasScrollX, rU = (e) => e.dimensions.hasScrollY, VC = (e) => e.dimensions.columnsTotalWidth < e.dimensions.viewportOuterSize.width, sU = (e) => e.dimensions.headerHeight, iU = (e) => e.dimensions.groupHeaderHeight, aU = (e) => e.dimensions.headerFilterHeight, BC = (e) => e.dimensions.hasScrollY ? e.dimensions.scrollbarSize : 0, lU = (e) => e.dimensions.hasScrollX ? e.dimensions.scrollbarSize : 0, cU = (e) => {
  const t = e.dimensions.hasScrollX ? e.dimensions.scrollbarSize : 0, n = e.dimensions.viewportOuterSize.height - e.dimensions.minimumSize.height > 0;
  return !(t === 0 && !n);
}, zC = /* @__PURE__ */ h.createContext(void 0);
process.env.NODE_ENV !== "production" && (zC.displayName = "GridRootPropsContext");
const Xe = () => {
  const e = h.useContext(zC);
  if (!e)
    throw new Error("MUI X: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.");
  return e;
}, uU = {
  // Root
  noRowsLabel: "No rows",
  noResultsOverlayLabel: "No results found.",
  // Density selector toolbar button text
  toolbarDensity: "Density",
  toolbarDensityLabel: "Density",
  toolbarDensityCompact: "Compact",
  toolbarDensityStandard: "Standard",
  toolbarDensityComfortable: "Comfortable",
  // Columns selector toolbar button text
  toolbarColumns: "Columns",
  toolbarColumnsLabel: "Select columns",
  // Filters toolbar button text
  toolbarFilters: "Filters",
  toolbarFiltersLabel: "Show filters",
  toolbarFiltersTooltipHide: "Hide filters",
  toolbarFiltersTooltipShow: "Show filters",
  toolbarFiltersTooltipActive: (e) => e !== 1 ? `${e} active filters` : `${e} active filter`,
  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: "Search…",
  toolbarQuickFilterLabel: "Search",
  toolbarQuickFilterDeleteIconLabel: "Clear",
  // Export selector toolbar button text
  toolbarExport: "Export",
  toolbarExportLabel: "Export",
  toolbarExportCSV: "Download as CSV",
  toolbarExportPrint: "Print",
  toolbarExportExcel: "Download as Excel",
  // Columns management text
  columnsManagementSearchTitle: "Search",
  columnsManagementNoColumns: "No columns",
  columnsManagementShowHideAllText: "Show/Hide All",
  columnsManagementReset: "Reset",
  columnsManagementDeleteIconLabel: "Clear",
  // Filter panel text
  filterPanelAddFilter: "Add filter",
  filterPanelRemoveAll: "Remove all",
  filterPanelDeleteIconLabel: "Delete",
  filterPanelLogicOperator: "Logic operator",
  filterPanelOperator: "Operator",
  filterPanelOperatorAnd: "And",
  filterPanelOperatorOr: "Or",
  filterPanelColumns: "Columns",
  filterPanelInputLabel: "Value",
  filterPanelInputPlaceholder: "Filter value",
  // Filter operators text
  filterOperatorContains: "contains",
  filterOperatorDoesNotContain: "does not contain",
  filterOperatorEquals: "equals",
  filterOperatorDoesNotEqual: "does not equal",
  filterOperatorStartsWith: "starts with",
  filterOperatorEndsWith: "ends with",
  filterOperatorIs: "is",
  filterOperatorNot: "is not",
  filterOperatorAfter: "is after",
  filterOperatorOnOrAfter: "is on or after",
  filterOperatorBefore: "is before",
  filterOperatorOnOrBefore: "is on or before",
  filterOperatorIsEmpty: "is empty",
  filterOperatorIsNotEmpty: "is not empty",
  filterOperatorIsAnyOf: "is any of",
  "filterOperator=": "=",
  "filterOperator!=": "!=",
  "filterOperator>": ">",
  "filterOperator>=": ">=",
  "filterOperator<": "<",
  "filterOperator<=": "<=",
  // Header filter operators text
  headerFilterOperatorContains: "Contains",
  headerFilterOperatorDoesNotContain: "Does not contain",
  headerFilterOperatorEquals: "Equals",
  headerFilterOperatorDoesNotEqual: "Does not equal",
  headerFilterOperatorStartsWith: "Starts with",
  headerFilterOperatorEndsWith: "Ends with",
  headerFilterOperatorIs: "Is",
  headerFilterOperatorNot: "Is not",
  headerFilterOperatorAfter: "Is after",
  headerFilterOperatorOnOrAfter: "Is on or after",
  headerFilterOperatorBefore: "Is before",
  headerFilterOperatorOnOrBefore: "Is on or before",
  headerFilterOperatorIsEmpty: "Is empty",
  headerFilterOperatorIsNotEmpty: "Is not empty",
  headerFilterOperatorIsAnyOf: "Is any of",
  "headerFilterOperator=": "Equals",
  "headerFilterOperator!=": "Not equals",
  "headerFilterOperator>": "Greater than",
  "headerFilterOperator>=": "Greater than or equal to",
  "headerFilterOperator<": "Less than",
  "headerFilterOperator<=": "Less than or equal to",
  // Filter values text
  filterValueAny: "any",
  filterValueTrue: "true",
  filterValueFalse: "false",
  // Column menu text
  columnMenuLabel: "Menu",
  columnMenuShowColumns: "Show columns",
  columnMenuManageColumns: "Manage columns",
  columnMenuFilter: "Filter",
  columnMenuHideColumn: "Hide column",
  columnMenuUnsort: "Unsort",
  columnMenuSortAsc: "Sort by ASC",
  columnMenuSortDesc: "Sort by DESC",
  // Column header text
  columnHeaderFiltersTooltipActive: (e) => e !== 1 ? `${e} active filters` : `${e} active filter`,
  columnHeaderFiltersLabel: "Show filters",
  columnHeaderSortIconLabel: "Sort",
  // Rows selected footer text
  footerRowSelected: (e) => e !== 1 ? `${e.toLocaleString()} rows selected` : `${e.toLocaleString()} row selected`,
  // Total row amount footer text
  footerTotalRows: "Total Rows:",
  // Total visible row amount footer text
  footerTotalVisibleRows: (e, t) => `${e.toLocaleString()} of ${t.toLocaleString()}`,
  // Checkbox selection text
  checkboxSelectionHeaderName: "Checkbox selection",
  checkboxSelectionSelectAllRows: "Select all rows",
  checkboxSelectionUnselectAllRows: "Unselect all rows",
  checkboxSelectionSelectRow: "Select row",
  checkboxSelectionUnselectRow: "Unselect row",
  // Boolean cell text
  booleanCellTrueLabel: "yes",
  booleanCellFalseLabel: "no",
  // Actions cell more text
  actionsCellMore: "more",
  // Column pinning text
  pinToLeft: "Pin to left",
  pinToRight: "Pin to right",
  unpin: "Unpin",
  // Tree Data
  treeDataGroupingHeaderName: "Group",
  treeDataExpand: "see children",
  treeDataCollapse: "hide children",
  // Grouping columns
  groupingColumnHeaderName: "Group",
  groupColumn: (e) => `Group by ${e}`,
  unGroupColumn: (e) => `Stop grouping by ${e}`,
  // Master/detail
  detailPanelToggle: "Detail panel toggle",
  expandDetailPanel: "Expand",
  collapseDetailPanel: "Collapse",
  // Used core components translation keys
  MuiTablePagination: {},
  // Row reordering text
  rowReorderingHeaderName: "Row reordering",
  // Aggregation
  aggregationMenuItemHeader: "Aggregation",
  aggregationFunctionLabelSum: "sum",
  aggregationFunctionLabelAvg: "avg",
  aggregationFunctionLabelMin: "min",
  aggregationFunctionLabelMax: "max",
  aggregationFunctionLabelSize: "size"
};
function rt(e) {
  return De("MuiDataGrid", e);
}
const K = Ne("MuiDataGrid", ["actionsCell", "aggregationColumnHeader", "aggregationColumnHeader--alignLeft", "aggregationColumnHeader--alignCenter", "aggregationColumnHeader--alignRight", "aggregationColumnHeaderLabel", "autoHeight", "autosizing", "booleanCell", "cell--editable", "cell--editing", "cell--flex", "cell--textCenter", "cell--textLeft", "cell--textRight", "cell--rangeTop", "cell--rangeBottom", "cell--rangeLeft", "cell--rangeRight", "cell--pinnedLeft", "cell--pinnedRight", "cell--selectionMode", "cell", "cellCheckbox", "cellEmpty", "cellSkeleton", "cellOffsetLeft", "checkboxInput", "columnHeader", "columnHeader--alignCenter", "columnHeader--alignLeft", "columnHeader--alignRight", "columnHeader--dragging", "columnHeader--moving", "columnHeader--numeric", "columnHeader--sortable", "columnHeader--sorted", "columnHeader--filtered", "columnHeader--pinnedLeft", "columnHeader--pinnedRight", "columnHeader--last", "columnHeader--lastUnpinned", "columnHeader--siblingFocused", "columnHeaderCheckbox", "columnHeaderDraggableContainer", "columnHeaderTitle", "columnHeaderTitleContainer", "columnHeaderTitleContainerContent", "columnHeader--filledGroup", "columnHeader--emptyGroup", "columnHeaders", "columnSeparator--resizable", "columnSeparator--resizing", "columnSeparator--sideLeft", "columnSeparator--sideRight", "columnSeparator", "columnsManagement", "columnsManagementRow", "columnsManagementHeader", "columnsManagementSearchInput", "columnsManagementFooter", "container--top", "container--bottom", "detailPanel", "detailPanels", "detailPanelToggleCell", "detailPanelToggleCell--expanded", "footerCell", "panel", "panelHeader", "panelWrapper", "panelContent", "panelFooter", "paper", "editBooleanCell", "editInputCell", "filler", "filler--borderBottom", "filler--pinnedLeft", "filler--pinnedRight", "filterForm", "filterFormDeleteIcon", "filterFormLogicOperatorInput", "filterFormColumnInput", "filterFormOperatorInput", "filterFormValueInput", "filterIcon", "footerContainer", "headerFilterRow", "iconButtonContainer", "iconSeparator", "main", "main--hasPinnedRight", "main--hasSkeletonLoadingOverlay", "menu", "menuIcon", "menuIconButton", "menuOpen", "menuList", "overlay", "overlayWrapper", "overlayWrapperInner", "root", "root--densityStandard", "root--densityComfortable", "root--densityCompact", "root--disableUserSelection", "root--noToolbar", "row", "row--editable", "row--editing", "row--firstVisible", "row--lastVisible", "row--dragging", "row--dynamicHeight", "row--detailPanelExpanded", "row--borderBottom", "rowReorderCellPlaceholder", "rowCount", "rowReorderCellContainer", "rowReorderCell", "rowReorderCell--draggable", "rowSkeleton", "scrollArea--left", "scrollArea--right", "scrollArea", "scrollbar", "scrollbar--vertical", "scrollbar--horizontal", "scrollbarFiller", "scrollbarFiller--header", "scrollbarFiller--borderTop", "scrollbarFiller--borderBottom", "scrollbarFiller--pinnedRight", "selectedRowCount", "sortIcon", "toolbarContainer", "toolbarFilterList", "virtualScroller", "virtualScroller--hasScrollX", "virtualScrollerContent", "virtualScrollerContent--overflowed", "virtualScrollerRenderZone", "pinnedColumns", "withVerticalBorder", "withBorderColor", "cell--withRightBorder", "cell--withLeftBorder", "columnHeader--withRightBorder", "columnHeader--withLeftBorder", "treeDataGroupingCell", "treeDataGroupingCellToggle", "treeDataGroupingCellLoadingContainer", "groupingCriteriaCell", "groupingCriteriaCellToggle", "groupingCriteriaCellLoadingContainer", "pinnedRows", "pinnedRows--top", "pinnedRows--bottom", "pinnedRowsRenderZone"]), HC = /* @__PURE__ */ h.createContext(void 0);
process.env.NODE_ENV !== "production" && (HC.displayName = "GridApiContext");
function lt() {
  const e = h.useContext(HC);
  if (e === void 0)
    throw new Error(["MUI X: Could not find the Data Grid context.", "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.", "This can also happen if you are bundling multiple versions of the Data Grid."].join(`
`));
  return e;
}
const J1 = 1e3;
class dU {
  constructor(t = J1) {
    this.timeouts = /* @__PURE__ */ new Map(), this.cleanupTimeout = J1, this.cleanupTimeout = t;
  }
  register(t, n, o) {
    this.timeouts || (this.timeouts = /* @__PURE__ */ new Map());
    const s = setTimeout(() => {
      typeof n == "function" && n(), this.timeouts.delete(o.cleanupToken);
    }, this.cleanupTimeout);
    this.timeouts.set(o.cleanupToken, s);
  }
  unregister(t) {
    const n = this.timeouts.get(t.cleanupToken);
    n && (this.timeouts.delete(t.cleanupToken), clearTimeout(n));
  }
  reset() {
    this.timeouts && (this.timeouts.forEach((t, n) => {
      this.unregister({
        cleanupToken: n
      });
    }), this.timeouts = void 0);
  }
}
class fU {
  constructor() {
    this.registry = new FinalizationRegistry((t) => {
      typeof t == "function" && t();
    });
  }
  register(t, n, o) {
    this.registry.register(t, n, o);
  }
  unregister(t) {
    this.registry.unregister(t);
  }
  // eslint-disable-next-line class-methods-use-this
  reset() {
  }
}
var Mo = /* @__PURE__ */ function(e) {
  return e.DataGrid = "DataGrid", e.DataGridPro = "DataGridPro", e.DataGridPremium = "DataGridPremium", e;
}(Mo || {});
class pU {
}
function hU(e) {
  let t = 0;
  return function(o, s, i, a) {
    e.registry === null && (e.registry = typeof FinalizationRegistry < "u" ? new fU() : new dU());
    const [l] = h.useState(new pU()), c = h.useRef(null), u = h.useRef(null);
    u.current = i;
    const d = h.useRef(null);
    if (!c.current && u.current) {
      const f = (p, m, b) => {
        var v;
        m.defaultMuiPrevented || (v = u.current) == null || v.call(u, p, m, b);
      };
      c.current = o.current.subscribeEvent(s, f, a), t += 1, d.current = {
        cleanupToken: t
      }, e.registry.register(
        l,
        // The callback below will be called once this reference stops being retained
        () => {
          var p;
          (p = c.current) == null || p.call(c), c.current = null, d.current = null;
        },
        d.current
      );
    } else !u.current && c.current && (c.current(), c.current = null, d.current && (e.registry.unregister(d.current), d.current = null));
    h.useEffect(() => {
      if (!c.current && u.current) {
        const f = (p, m, b) => {
          var v;
          m.defaultMuiPrevented || (v = u.current) == null || v.call(u, p, m, b);
        };
        c.current = o.current.subscribeEvent(s, f, a);
      }
      return d.current && e.registry && (e.registry.unregister(d.current), d.current = null), () => {
        var f;
        (f = c.current) == null || f.call(c), c.current = null;
      };
    }, [o, s, a]);
  };
}
const gU = {
  registry: null
}, Le = hU(gU), mU = {
  isFirst: !0
};
function Pt(e, t, n) {
  Le(e, t, n, mU);
}
const bU = 0.7, yU = 1.3, vU = {
  compact: bU,
  comfortable: yU,
  standard: 1
}, ka = (e) => e.density, Tl = Je(ka, (e) => vU[e]), CU = parseInt(h.version, 10), Ct = (e) => {
  if (CU >= 19) {
    const t = (n) => e(n, n.ref ?? null);
    return t.displayName = e.displayName ?? e.name, t;
  }
  return /* @__PURE__ */ h.forwardRef(e);
}, wU = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "isValidating", "debounceMs", "isProcessingProps", "onValueChange"], SU = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["editInputCell"]
  }, rt, t);
}, xU = te(Xi, {
  name: "MuiDataGrid",
  slot: "EditInputCell",
  overridesResolver: (e, t) => t.editInputCell
})(({
  theme: e
}) => I({}, e.typography.body2, {
  padding: "1px 0",
  "& input": {
    padding: "0 16px",
    height: "100%"
  }
})), Sk = Ct((e, t) => {
  const n = Xe(), {
    id: o,
    value: s,
    field: i,
    colDef: a,
    hasFocus: l,
    debounceMs: c = 200,
    isProcessingProps: u,
    onValueChange: d
  } = e, f = ve(e, wU), p = lt(), m = h.useRef(null), [b, v] = h.useState(s), g = SU(n), y = h.useCallback(async (x) => {
    const S = x.target.value;
    d && await d(x, S);
    const T = p.current.getColumn(i);
    let E = S;
    T.valueParser && (E = T.valueParser(S, p.current.getRow(o), T, p)), v(E), p.current.setEditCellValue({
      id: o,
      field: i,
      value: E,
      debounceMs: c,
      unstable_skipValueParser: !0
    }, x);
  }, [p, c, i, o, d]), w = p.current.unstable_getEditCellMeta(o, i);
  return h.useEffect(() => {
    (w == null ? void 0 : w.changeReason) !== "debouncedSetEditCellValue" && v(s);
  }, [w, s]), yt(() => {
    l && m.current.focus();
  }, [l]), /* @__PURE__ */ C(xU, I({
    inputRef: m,
    className: g.root,
    ownerState: n,
    fullWidth: !0,
    type: a.type === "number" ? a.type : "text",
    value: b ?? "",
    onChange: y,
    endAdornment: u ? /* @__PURE__ */ C(n.slots.loadIcon, {
      fontSize: "small",
      color: "action"
    }) : void 0
  }, f, {
    ref: t
  }));
});
process.env.NODE_ENV !== "production" && (Sk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: r.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: r.oneOf(["edit", "view"]).isRequired,
  changeReason: r.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: r.object.isRequired,
  debounceMs: r.number,
  /**
   * The column field of the cell that triggered the event.
   */
  field: r.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: r.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: r.bool.isRequired,
  /**
   * The grid row id.
   */
  id: r.oneOfType([r.number, r.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: r.bool,
  isProcessingProps: r.bool,
  isValidating: r.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {Date | null} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: r.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: r.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: r.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: r.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: r.any
});
const TU = (e) => /* @__PURE__ */ C(Sk, I({}, e)), xk = (e, t) => t && e.length > 1 ? (process.env.NODE_ENV !== "production" && vo(["MUI X: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.", "If you are using the community version of the Data Grid, this prop is always `true`."], "error"), [e[0]]) : e, eT = (e, t) => (n) => I({}, n, {
  sorting: I({}, n.sorting, {
    sortModel: xk(e, t)
  })
}), RU = (e) => e === "desc", EU = (e, t) => {
  const n = t.current.getColumn(e.field);
  if (!n || e.sort === null)
    return null;
  let o;
  return n.getSortComparator ? o = n.getSortComparator(e.sort) : o = RU(e.sort) ? (...i) => -1 * n.sortComparator(...i) : n.sortComparator, o ? {
    getSortCellParams: (i) => ({
      id: i,
      field: n.field,
      rowNode: t.current.getRowNode(i),
      value: t.current.getCellValue(i, n.field),
      api: t.current
    }),
    comparator: o
  } : null;
}, IU = (e, t, n) => e.reduce((o, s, i) => {
  if (o !== 0)
    return o;
  const a = t.params[i], l = n.params[i];
  return o = s.comparator(a.value, l.value, a, l), o;
}, 0), OU = (e, t) => {
  const n = e.map((o) => EU(o, t)).filter((o) => !!o);
  return n.length === 0 ? null : (o) => o.map((s) => ({
    node: s,
    params: n.map((i) => i.getSortCellParams(s.id))
  })).sort((s, i) => IU(n, s, i)).map((s) => s.node.id);
}, tT = (e, t) => {
  const n = e.indexOf(t);
  return !t || n === -1 || n + 1 === e.length ? e[0] : e[n + 1];
}, jC = (e, t) => e == null && t != null ? -1 : t == null && e != null ? 1 : e == null && t == null ? 0 : null, PU = new Intl.Collator(), MU = (e, t) => {
  const n = jC(e, t);
  return n !== null ? n : typeof e == "string" ? PU.compare(e.toString(), t.toString()) : e - t;
}, Tk = (e, t) => {
  const n = jC(e, t);
  return n !== null ? n : Number(e) - Number(t);
}, Rk = (e, t) => {
  const n = jC(e, t);
  return n !== null ? n : e > t ? 1 : e < t ? -1 : 0;
}, kU = ["item", "applyValue", "type", "apiRef", "focusElementRef", "tabIndex", "disabled", "isFilterActive", "clearButton", "InputProps", "variant"];
function po(e) {
  var S;
  const {
    item: t,
    applyValue: n,
    type: o,
    apiRef: s,
    focusElementRef: i,
    tabIndex: a,
    disabled: l,
    clearButton: c,
    InputProps: u,
    variant: d = "standard"
  } = e, f = ve(e, kU), p = go(), [m, b] = h.useState(vg(t.value)), [v, g] = h.useState(!1), y = gt(), w = Xe(), x = h.useCallback((T) => {
    const E = vg(T.target.value);
    b(E), g(!0), p.start(w.filterDebounceMs, () => {
      const O = I({}, t, {
        value: o === "number" && !Number.isNaN(Number(E)) ? Number(E) : E,
        fromInput: y
      });
      n(O), g(!1);
    });
  }, [p, w.filterDebounceMs, t, o, y, n]);
  return h.useEffect(() => {
    (t.fromInput !== y || t.value == null) && b(vg(t.value));
  }, [y, t]), /* @__PURE__ */ C(w.slots.baseTextField, I({
    id: y,
    label: s.current.getLocaleText("filterPanelInputLabel"),
    placeholder: s.current.getLocaleText("filterPanelInputPlaceholder"),
    value: m ?? "",
    onChange: x,
    variant: d,
    type: o || "text",
    InputProps: I({}, v || c ? {
      endAdornment: v ? /* @__PURE__ */ C(w.slots.loadIcon, {
        fontSize: "small",
        color: "action"
      }) : c
    } : {}, {
      disabled: l
    }, u, {
      inputProps: I({
        tabIndex: a
      }, u == null ? void 0 : u.inputProps)
    }),
    InputLabelProps: {
      shrink: !0
    },
    inputRef: i
  }, f, (S = w.slotProps) == null ? void 0 : S.baseTextField));
}
function vg(e) {
  if (!(e == null || e === ""))
    return String(e);
}
process.env.NODE_ENV !== "production" && (po.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: r.shape({
    current: r.object.isRequired
  }).isRequired,
  applyValue: r.func.isRequired,
  clearButton: r.node,
  focusElementRef: r.oneOfType([r.func, r.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: r.bool,
  item: r.shape({
    field: r.string.isRequired,
    id: r.oneOfType([r.number, r.string]),
    operator: r.string.isRequired,
    value: r.any
  }).isRequired
});
function GC(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function Ek(e) {
  return typeof e == "function";
}
function qC(e) {
  return typeof e == "object" && e !== null;
}
function DU() {
  try {
    const e = "__some_random_key_you_are_not_going_to_use__";
    return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
  } catch {
    return !1;
  }
}
function Ff(e) {
  return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
const Uo = (e, t, n) => Math.max(t, Math.min(n, e));
function nT(e, t) {
  return Array.from({
    length: t - e
  }).map((n, o) => e + o);
}
function Xr(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    if (Array.isArray(e)) {
      const s = e.length;
      if (s !== t.length)
        return !1;
      for (let i = 0; i < s; i += 1)
        if (!Xr(e[i], t[i]))
          return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      const s = Array.from(e.entries());
      for (let i = 0; i < s.length; i += 1)
        if (!t.has(s[i][0]))
          return !1;
      for (let i = 0; i < s.length; i += 1) {
        const a = s[i];
        if (!Xr(a[1], t.get(a[0])))
          return !1;
      }
      return !0;
    }
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      const s = Array.from(e.entries());
      for (let i = 0; i < s.length; i += 1)
        if (!t.has(s[i][0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      const s = e.length;
      if (s !== t.length)
        return !1;
      for (let i = 0; i < s; i += 1)
        if (e[i] !== t[i])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    const n = Object.keys(e), o = n.length;
    if (o !== Object.keys(t).length)
      return !1;
    for (let s = 0; s < o; s += 1)
      if (!Object.prototype.hasOwnProperty.call(t, n[s]))
        return !1;
    for (let s = 0; s < o; s += 1) {
      const i = n[s];
      if (!Xr(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function NU(e) {
  return () => {
    let t = e += 1831565813;
    return t = Math.imul(t ^ t >>> 15, t | 1), t ^= t + Math.imul(t ^ t >>> 7, t | 61), ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}
function $U(e) {
  const t = NU(e);
  return (n, o) => n + (o - n) * t();
}
function Ik(e) {
  return typeof structuredClone == "function" ? structuredClone(e) : JSON.parse(JSON.stringify(e));
}
const ql = (e, t) => (n) => {
  e && t(n);
}, AU = ["item", "applyValue", "type", "apiRef", "focusElementRef", "color", "error", "helperText", "size", "variant"], FU = ["key"];
function WC(e) {
  const {
    item: t,
    applyValue: n,
    type: o,
    apiRef: s,
    focusElementRef: i,
    color: a,
    error: l,
    helperText: c,
    size: u,
    variant: d = "standard"
  } = e, f = ve(e, AU), p = {
    color: a,
    error: l,
    helperText: c,
    size: u,
    variant: d
  }, [m, b] = h.useState(t.value || []), v = gt(), g = Xe();
  h.useEffect(() => {
    const w = t.value ?? [];
    b(w.map(String));
  }, [t.value]);
  const y = h.useCallback((w, x) => {
    b(x.map(String)), n(I({}, t, {
      value: [...x.map((S) => o === "number" ? Number(S) : S)]
    }));
  }, [n, t, o]);
  return /* @__PURE__ */ C(Np, I({
    multiple: !0,
    freeSolo: !0,
    options: [],
    filterOptions: (w, x) => {
      const {
        inputValue: S
      } = x;
      return S == null || S === "" ? [] : [S];
    },
    id: v,
    value: m,
    onChange: y,
    renderTags: (w, x) => w.map((S, T) => {
      const E = x({
        index: T
      }), {
        key: O
      } = E, M = ve(E, FU);
      return /* @__PURE__ */ C(g.slots.baseChip, I({
        variant: "outlined",
        size: "small",
        label: S
      }, M), O);
    }),
    renderInput: (w) => {
      var x;
      return /* @__PURE__ */ C(g.slots.baseTextField, I({}, w, {
        label: s.current.getLocaleText("filterPanelInputLabel"),
        placeholder: s.current.getLocaleText("filterPanelInputPlaceholder"),
        InputLabelProps: I({}, w.InputLabelProps, {
          shrink: !0
        }),
        inputRef: i,
        type: o || "text"
      }, p, (x = g.slotProps) == null ? void 0 : x.baseTextField));
    }
  }, f));
}
process.env.NODE_ENV !== "production" && (WC.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: r.shape({
    current: r.object.isRequired
  }).isRequired,
  applyValue: r.func.isRequired,
  focusElementRef: r.oneOfType([r.func, r.object]),
  item: r.shape({
    field: r.string.isRequired,
    id: r.oneOfType([r.number, r.string]),
    operator: r.string.isRequired,
    value: r.any
  }).isRequired,
  type: r.oneOf(["date", "datetime-local", "number", "text"])
});
var ts = /* @__PURE__ */ function(e) {
  return e.Cell = "cell", e.Row = "row", e;
}(ts || {}), Bt = /* @__PURE__ */ function(e) {
  return e.Edit = "edit", e.View = "view", e;
}(Bt || {}), fn = /* @__PURE__ */ function(e) {
  return e.Edit = "edit", e.View = "view", e;
}(fn || {}), ho = /* @__PURE__ */ function(e) {
  return e.And = "and", e.Or = "or", e;
}(ho || {}), ps = /* @__PURE__ */ function(e) {
  return e.enterKeyDown = "enterKeyDown", e.cellDoubleClick = "cellDoubleClick", e.printableKeyDown = "printableKeyDown", e.deleteKeyDown = "deleteKeyDown", e.pasteKeyDown = "pasteKeyDown", e;
}(ps || {}), xr = /* @__PURE__ */ function(e) {
  return e.cellFocusOut = "cellFocusOut", e.escapeKeyDown = "escapeKeyDown", e.enterKeyDown = "enterKeyDown", e.tabKeyDown = "tabKeyDown", e.shiftTabKeyDown = "shiftTabKeyDown", e;
}(xr || {}), Ls = /* @__PURE__ */ function(e) {
  return e.enterKeyDown = "enterKeyDown", e.cellDoubleClick = "cellDoubleClick", e.printableKeyDown = "printableKeyDown", e.deleteKeyDown = "deleteKeyDown", e;
}(Ls || {}), Fr = /* @__PURE__ */ function(e) {
  return e.rowFocusOut = "rowFocusOut", e.escapeKeyDown = "escapeKeyDown", e.enterKeyDown = "enterKeyDown", e.tabKeyDown = "tabKeyDown", e.shiftTabKeyDown = "shiftTabKeyDown", e;
}(Fr || {});
function Ok(e) {
  return e.field !== void 0;
}
const UC = {
  filteredRowsLookup: {},
  filteredChildrenCountLookup: {},
  filteredDescendantCountLookup: {}
}, Yc = () => ({
  items: [],
  logicOperator: ho.And,
  quickFilterValues: [],
  quickFilterLogicOperator: ho.And
});
function Pk(e) {
  return {
    current: e.current.getPublicApi()
  };
}
let Ln = /* @__PURE__ */ function(e) {
  return e.LEFT = "left", e.RIGHT = "right", e;
}({});
const Lf = {
  left: [],
  right: []
}, LU = (e) => e.isRtl, Qr = (e) => e.columns, Or = Je(Qr, (e) => e.orderedFields), as = Je(Qr, (e) => e.lookup), Pr = Mt(Or, as, (e, t) => e.map((n) => t[n])), jo = Je(Qr, (e) => e.columnVisibilityModel), pn = Mt(Pr, jo, (e, t) => e.filter((n) => t[n.field] !== !1)), na = Mt(pn, (e) => e.map((t) => t.field)), fc = (e) => e.pinnedColumns, ws = Mt(Qr, fc, na, LU, (e, t, n, o) => {
  const s = _U(t, n, o);
  return {
    left: s.left.map((a) => e.lookup[a]),
    right: s.right.map((a) => e.lookup[a])
  };
});
function _U(e, t, n) {
  var l, c;
  if (!Array.isArray(e.left) && !Array.isArray(e.right) || ((l = e.left) == null ? void 0 : l.length) === 0 && ((c = e.right) == null ? void 0 : c.length) === 0)
    return Lf;
  const o = (u, d) => Array.isArray(u) ? u.filter((f) => d.includes(f)) : [], s = o(e.left, t), i = t.filter(
    // Filter out from the remaining columns those columns already pinned to the left
    (u) => !s.includes(u)
  ), a = o(e.right, i);
  return n ? {
    left: a,
    right: s
  } : {
    left: s,
    right: a
  };
}
const Os = Mt(pn, (e) => {
  const t = [];
  let n = 0;
  for (let o = 0; o < e.length; o += 1)
    t.push(n), n += e[o].computedWidth;
  return t;
}), Mk = Mt(Pr, (e) => e.filter((t) => t.filterable)), kk = Mt(Pr, (e) => e.reduce((t, n) => (n.filterable && (t[n.field] = n), t), {})), VU = Mt(Pr, (e) => e.some((t) => t.colSpan !== void 0));
let Wl;
function BU() {
  if (Wl !== void 0)
    return Wl;
  try {
    Wl = new Function("return true")();
  } catch {
    Wl = !1;
  }
  return Wl;
}
const Oy = (e, t) => {
  const n = I({}, e);
  if (n.id == null && (n.id = Math.round(Math.random() * 1e5)), n.operator == null) {
    const o = as(t)[n.field];
    n.operator = o && o.filterOperators[0].value;
  }
  return n;
}, KC = (e, t, n) => {
  const o = e.items.length > 1;
  let s;
  o && t ? (process.env.NODE_ENV !== "production" && vo(["MUI X: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.", "If you are using the community version of the Data Grid, this prop is always `true`."], "error"), s = [e.items[0]]) : s = e.items;
  const i = o && s.some((l) => l.id == null), a = s.some((l) => l.operator == null);
  return process.env.NODE_ENV !== "production" && i && vo("MUI X: The `id` field is required on `filterModel.items` when you use multiple filters.", "error"), process.env.NODE_ENV !== "production" && a && vo("MUI X: The `operator` field is required on `filterModel.items`, one or more of your filtering item has no `operator` provided.", "error"), a || i ? I({}, e, {
    items: s.map((l) => Oy(l, n))
  }) : e.items !== s ? I({}, e, {
    items: s
  }) : e;
}, oT = (e, t, n) => (o) => I({}, o, {
  filterModel: KC(e, t, n)
}), Xc = (e) => typeof e == "string" ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : e, Dk = (e, t) => {
  var d;
  if (!e.field || !e.operator)
    return null;
  const n = t.current.getColumn(e.field);
  if (!n)
    return null;
  let o;
  if (n.valueParser) {
    const f = n.valueParser;
    o = Array.isArray(e.value) ? (d = e.value) == null ? void 0 : d.map((p) => f(p, void 0, n, t)) : f(e.value, void 0, n, t);
  } else
    o = e.value;
  const {
    ignoreDiacritics: s
  } = t.current.rootProps;
  s && (o = Xc(o));
  const i = I({}, e, {
    value: o
  }), a = n.filterOperators;
  if (!(a != null && a.length))
    throw new Error(`MUI X: No filter operators found for column '${n.field}'.`);
  const l = a.find((f) => f.value === i.operator);
  if (!l)
    throw new Error(`MUI X: No filter operator found for column '${n.field}' and operator value '${i.operator}'.`);
  const c = Pk(t), u = l.getApplyFilterFn(i, n);
  return typeof u != "function" ? null : {
    item: i,
    fn: (f) => {
      let p = t.current.getRowValue(f, n);
      return s && (p = Xc(p)), u(p, f, n, c);
    }
  };
};
let rT = 1;
const zU = (e, t, n) => {
  const {
    items: o
  } = e, s = o.map((l) => Dk(l, t)).filter((l) => !!l);
  if (s.length === 0)
    return null;
  if (n || !BU())
    return (l, c) => {
      const u = {};
      for (let d = 0; d < s.length; d += 1) {
        const f = s[d];
        (!c || c(f.item.field)) && (u[f.item.id] = f.fn(l));
      }
      return u;
    };
  const i = new Function("appliers", "row", "shouldApplyFilter", `"use strict";
${s.map((l, c) => `const shouldApply${c} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(l.item.field)});`).join(`
`)}

const result$$ = {
${s.map((l, c) => `  ${JSON.stringify(String(l.item.id))}: !shouldApply${c} ? false : appliers[${c}].fn(row),`).join(`
`)}
};

return result$$;`.replaceAll("$$", String(rT)));
  return rT += 1, (l, c) => i(s, l, c);
}, Nk = (e) => e.quickFilterExcludeHiddenColumns ?? !0, HU = (e, t) => {
  var l;
  const n = ((l = e.quickFilterValues) == null ? void 0 : l.filter(Boolean)) ?? [];
  if (n.length === 0)
    return null;
  const o = Nk(e) ? na(t) : Or(t), s = [], {
    ignoreDiacritics: i
  } = t.current.rootProps, a = Pk(t);
  return o.forEach((c) => {
    const u = t.current.getColumn(c), d = u == null ? void 0 : u.getApplyQuickFilterFn;
    d && s.push({
      column: u,
      appliers: n.map((f) => {
        const p = i ? Xc(f) : f;
        return {
          fn: d(p, u, a)
        };
      })
    });
  }), function(u, d) {
    const f = {};
    e: for (let p = 0; p < n.length; p += 1) {
      const m = n[p];
      for (let b = 0; b < s.length; b += 1) {
        const {
          column: v,
          appliers: g
        } = s[b], {
          field: y
        } = v;
        if (d && !d(y))
          continue;
        const w = g[p];
        let x = t.current.getRowValue(u, v);
        if (w.fn === null)
          continue;
        if (i && (x = Xc(x)), w.fn(x, u, v, a)) {
          f[m] = !0;
          continue e;
        }
      }
      f[m] = !1;
    }
    return f;
  };
}, jU = (e, t, n) => {
  const o = zU(e, t, n), s = HU(e, t);
  return function(a, l, c) {
    c.passingFilterItems = (o == null ? void 0 : o(a, l)) ?? null, c.passingQuickFilterValues = (s == null ? void 0 : s(a, l)) ?? null;
  };
}, sT = (e) => e != null, GU = (e, t, n) => (e.cleanedFilterItems || (e.cleanedFilterItems = n.filter((o) => Dk(o, t) !== null)), e.cleanedFilterItems), $k = (e, t, n, o, s) => {
  const i = GU(s, o, n.items), a = e.filter(sT), l = t.filter(sT);
  if (a.length > 0) {
    const c = (d) => a.some((f) => f[d.id]);
    if ((n.logicOperator ?? Yc().logicOperator) === ho.And) {
      if (!i.every(c))
        return !1;
    } else if (!i.some(c))
      return !1;
  }
  if (l.length > 0 && n.quickFilterValues != null) {
    const c = (d) => l.some((f) => f[d]);
    if ((n.quickFilterLogicOperator ?? Yc().quickFilterLogicOperator) === ho.And) {
      if (!n.quickFilterValues.every(c))
        return !1;
    } else if (!n.quickFilterValues.some(c))
      return !1;
  }
  return !0;
}, qU = (e) => {
  if (!e)
    return null;
  const t = new RegExp(Ff(e), "i");
  return (n, o, s, i) => {
    let a = i.current.getRowFormattedValue(o, s);
    return i.current.ignoreDiacritics && (a = Xc(a)), a != null ? t.test(a.toString()) : !1;
  };
}, iT = (e, t) => (n) => {
  if (!n.value)
    return null;
  const o = e ? n.value : n.value.trim(), s = new RegExp(Ff(o), "i");
  return (i) => {
    if (i == null)
      return t;
    const a = s.test(String(i));
    return t ? !a : a;
  };
}, aT = (e, t) => (n) => {
  if (!n.value)
    return null;
  const o = e ? n.value : n.value.trim(), s = new Intl.Collator(void 0, {
    sensitivity: "base",
    usage: "search"
  });
  return (i) => {
    if (i == null)
      return t;
    const a = s.compare(o, i.toString()) === 0;
    return t ? !a : a;
  };
}, lT = (e) => () => (t) => {
  const n = t === "" || t == null;
  return e ? !n : n;
}, WU = (e = !1) => [{
  value: "contains",
  getApplyFilterFn: iT(e, !1),
  InputComponent: po
}, {
  value: "doesNotContain",
  getApplyFilterFn: iT(e, !0),
  InputComponent: po
}, {
  value: "equals",
  getApplyFilterFn: aT(e, !1),
  InputComponent: po
}, {
  value: "doesNotEqual",
  getApplyFilterFn: aT(e, !0),
  InputComponent: po
}, {
  value: "startsWith",
  getApplyFilterFn: (t) => {
    if (!t.value)
      return null;
    const n = e ? t.value : t.value.trim(), o = new RegExp(`^${Ff(n)}.*$`, "i");
    return (s) => s != null ? o.test(s.toString()) : !1;
  },
  InputComponent: po
}, {
  value: "endsWith",
  getApplyFilterFn: (t) => {
    if (!t.value)
      return null;
    const n = e ? t.value : t.value.trim(), o = new RegExp(`.*${Ff(n)}$`, "i");
    return (s) => s != null ? o.test(s.toString()) : !1;
  },
  InputComponent: po
}, {
  value: "isEmpty",
  getApplyFilterFn: lT(!1),
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFn: lT(!0),
  requiresFilterValue: !1
}, {
  value: "isAnyOf",
  getApplyFilterFn: (t) => {
    if (!Array.isArray(t.value) || t.value.length === 0)
      return null;
    const n = e ? t.value : t.value.map((s) => s.trim()), o = new Intl.Collator(void 0, {
      sensitivity: "base",
      usage: "search"
    });
    return (s) => s != null ? n.some((i) => o.compare(i, s.toString() || "") === 0) : !1;
  },
  InputComponent: WC
}], ko = {
  width: 100,
  minWidth: 50,
  maxWidth: 1 / 0,
  hideable: !0,
  sortable: !0,
  resizable: !0,
  filterable: !0,
  groupable: !0,
  pinnable: !0,
  // @ts-ignore
  aggregable: !0,
  editable: !1,
  sortComparator: MU,
  type: "string",
  align: "left",
  filterOperators: WU(),
  renderEditCell: TU,
  getApplyQuickFilterFn: qU
}, UU = ["open", "target", "onClose", "children", "position", "className", "onExited"], KU = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["menu"]
  }, rt, t);
}, YU = te(is, {
  name: "MuiDataGrid",
  slot: "Menu",
  overridesResolver: (e, t) => t.menu
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal,
  [`& .${K.menuList}`]: {
    outline: 0
  }
})), XU = {
  "bottom-start": "top left",
  "bottom-end": "top right"
};
function ku(e) {
  var v;
  const {
    open: t,
    target: n,
    onClose: o,
    children: s,
    position: i,
    className: a,
    onExited: l
  } = e, c = ve(e, UU), u = lt(), d = Xe(), f = KU(d), p = h.useRef(null);
  yt(() => {
    var g, y;
    t ? p.current = document.activeElement instanceof HTMLElement ? document.activeElement : null : ((y = (g = p.current) == null ? void 0 : g.focus) == null || y.call(g), p.current = null);
  }, [t]), h.useEffect(() => {
    const g = t ? "menuOpen" : "menuClose";
    u.current.publishEvent(g, {
      target: n
    });
  }, [u, t, n]);
  const m = (g) => (y) => {
    g && g(), l && l(y);
  }, b = (g) => {
    g.target && (n === g.target || n != null && n.contains(g.target)) || o(g);
  };
  return /* @__PURE__ */ C(YU, I({
    as: d.slots.basePopper,
    className: ae(f.root, a),
    ownerState: d,
    open: t,
    anchorEl: n,
    transition: !0,
    placement: i
  }, c, (v = d.slotProps) == null ? void 0 : v.basePopper, {
    children: ({
      TransitionProps: g,
      placement: y
    }) => /* @__PURE__ */ C(tl, {
      onClickAway: b,
      mouseEvent: "onMouseDown",
      children: /* @__PURE__ */ C(vs, I({}, g, {
        style: {
          transformOrigin: XU[y]
        },
        onExited: m(g == null ? void 0 : g.onExited),
        children: /* @__PURE__ */ C(ao, {
          children: s
        })
      }))
    })
  }));
}
process.env.NODE_ENV !== "production" && (ku.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: r.node,
  onClose: r.func.isRequired,
  onExited: r.func,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  position: r.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  target: Ko
});
const QU = ["api", "colDef", "id", "hasFocus", "isEditable", "field", "value", "formattedValue", "row", "rowNode", "cellMode", "tabIndex", "position", "focusElementRef"], ZU = (e) => typeof e.getActions == "function";
function Ak(e) {
  var k;
  const {
    colDef: t,
    id: n,
    hasFocus: o,
    tabIndex: s,
    position: i = "bottom-end",
    focusElementRef: a
  } = e, l = ve(e, QU), [c, u] = h.useState(-1), [d, f] = h.useState(!1), p = lt(), m = h.useRef(null), b = h.useRef(null), v = h.useRef(!1), g = h.useRef({}), y = _t(), w = gt(), x = gt(), S = Xe();
  if (!ZU(t))
    throw new Error("MUI X: Missing the `getActions` property in the `GridColDef`.");
  const T = t.getActions(p.current.getRowParams(n)), E = T.filter((L) => !L.props.showInMenu), O = T.filter((L) => L.props.showInMenu), M = E.length + (O.length ? 1 : 0);
  h.useLayoutEffect(() => {
    o || Object.entries(g.current).forEach(([L, B]) => {
      B == null || B.stop({}, () => {
        delete g.current[L];
      });
    });
  }, [o]), h.useEffect(() => {
    if (c < 0 || !m.current || c >= m.current.children.length)
      return;
    m.current.children[c].focus({
      preventScroll: !0
    });
  }, [c]), h.useEffect(() => {
    o || (u(-1), v.current = !1);
  }, [o]), h.useImperativeHandle(a, () => ({
    focus() {
      if (!v.current) {
        const L = T.findIndex((B) => !B.props.disabled);
        u(L);
      }
    }
  }), [T]), h.useEffect(() => {
    c >= M && u(M - 1);
  }, [c, M]);
  const D = () => {
    f(!0), u(M - 1), v.current = !0;
  }, R = () => {
    f(!1);
  }, P = () => {
    d ? R() : D();
  }, F = (L) => (B) => {
    g.current[L] = B;
  }, $ = (L, B) => (V) => {
    u(L), v.current = !0, B && B(V);
  }, N = (L) => {
    if (M <= 1)
      return;
    const B = (_, z) => {
      var J;
      if (_ < 0 || _ > T.length)
        return _;
      const W = (z === "left" ? -1 : 1) * (y ? -1 : 1);
      return (J = T[_ + W]) != null && J.props.disabled ? B(_ + W, z) : _ + W;
    };
    let V = c;
    L.key === "ArrowRight" ? V = B(c, "right") : L.key === "ArrowLeft" && (V = B(c, "left")), !(V < 0 || V >= M) && V !== c && (L.preventDefault(), L.stopPropagation(), u(V));
  }, A = (L) => {
    L.key === "Tab" && L.preventDefault(), ["Tab", "Escape"].includes(L.key) && R();
  };
  return /* @__PURE__ */ ie("div", I({
    role: "menu",
    ref: m,
    tabIndex: -1,
    className: K.actionsCell,
    onKeyDown: N
  }, l, {
    children: [E.map((L, B) => /* @__PURE__ */ h.cloneElement(L, {
      key: B,
      touchRippleRef: F(B),
      onClick: $(B, L.props.onClick),
      tabIndex: c === B ? s : -1
    })), O.length > 0 && x && /* @__PURE__ */ C(S.slots.baseIconButton, I({
      ref: b,
      id: x,
      "aria-label": p.current.getLocaleText("actionsCellMore"),
      "aria-haspopup": "menu",
      "aria-expanded": d,
      "aria-controls": d ? w : void 0,
      role: "menuitem",
      size: "small",
      onClick: P,
      touchRippleRef: F(x),
      tabIndex: c === E.length ? s : -1
    }, (k = S.slotProps) == null ? void 0 : k.baseIconButton, {
      children: /* @__PURE__ */ C(S.slots.moreActionsIcon, {
        fontSize: "small"
      })
    })), O.length > 0 && /* @__PURE__ */ C(ku, {
      open: d,
      target: b.current,
      position: i,
      onClose: R,
      children: /* @__PURE__ */ C(Zi, {
        id: w,
        className: K.menuList,
        onKeyDown: A,
        "aria-labelledby": x,
        variant: "menu",
        autoFocusItem: !0,
        children: O.map((L, B) => /* @__PURE__ */ h.cloneElement(L, {
          key: B,
          closeMenu: R
        }))
      })
    })]
  }));
}
process.env.NODE_ENV !== "production" && (Ak.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  api: r.object,
  /**
   * The mode of the cell.
   */
  cellMode: r.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: r.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: r.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      focus: r.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: r.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: r.bool.isRequired,
  /**
   * The grid row id.
   */
  id: r.oneOfType([r.number, r.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: r.bool,
  position: r.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: r.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: r.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: r.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: r.any
});
const JU = (e) => /* @__PURE__ */ C(Ak, I({}, e)), Gp = "actions", eK = I({}, ko, {
  sortable: !1,
  filterable: !1,
  // @ts-ignore
  aggregable: !1,
  width: 100,
  display: "flex",
  align: "center",
  headerAlign: "center",
  headerName: "",
  disableColumnMenu: !0,
  disableExport: !0,
  renderCell: JU,
  getApplyQuickFilterFn: void 0
}), Cr = (e) => e.rows, Du = Je(Cr, (e) => e.totalRowCount), Fk = Je(Cr, (e) => e.loading), tK = Je(Cr, (e) => e.totalTopLevelRowCount), fr = Je(Cr, (e) => e.dataRowIdToModelLookup), cT = Je(Cr, (e) => e.dataRowIdToIdLookup), Vn = Je(Cr, (e) => e.tree), Lk = Je(Cr, (e) => e.groupsToFetch), nK = Je(Cr, (e) => e.groupingName), uT = Je(Cr, (e) => e.treeDepths), Ps = Mt(Cr, (e) => {
  const t = Object.entries(e.treeDepths);
  return t.length === 0 ? 1 : (t.filter(([, n]) => n > 0).map(([n]) => Number(n)).sort((n, o) => o - n)[0] ?? 0) + 1;
}), Da = Je(Cr, (e) => e.dataRowIds), oK = Je(Cr, (e) => e == null ? void 0 : e.additionalRowGroups), oa = Mt(oK, (e) => {
  var n, o;
  const t = e == null ? void 0 : e.pinnedRows;
  return {
    bottom: ((n = t == null ? void 0 : t.bottom) == null ? void 0 : n.map((s) => ({
      id: s.id,
      model: s.model ?? {}
    }))) ?? [],
    top: ((o = t == null ? void 0 : t.top) == null ? void 0 : o.map((s) => ({
      id: s.id,
      model: s.model ?? {}
    }))) ?? []
  };
}), _k = Je(oa, (e) => {
  var t, n;
  return (((t = e == null ? void 0 : e.top) == null ? void 0 : t.length) || 0) + (((n = e == null ? void 0 : e.bottom) == null ? void 0 : n.length) || 0);
}), Dt = "auto-generated-group-node-root", za = Symbol("mui.id_autogenerated"), Vk = () => ({
  type: "group",
  id: Dt,
  depth: -1,
  groupingField: null,
  groupingKey: null,
  isAutoGenerated: !0,
  children: [],
  childrenFromPath: {},
  childrenExpanded: !0,
  parent: null
});
function rK(e, t, n = "A row was provided without id in the rows prop:") {
  if (e == null)
    throw new Error(["MUI X: The Data Grid component requires all rows to have a unique `id` property.", "Alternatively, you can use the `getRowId` prop to specify a custom id for each row.", n, JSON.stringify(t)].join(`
`));
}
const il = (e, t, n) => {
  const o = t ? t(e) : e.id;
  return rK(o, e, n), o;
}, ef = ({
  rows: e,
  getRowId: t,
  loading: n,
  rowCount: o
}) => {
  const s = {
    type: "full",
    rows: []
  }, i = {}, a = {};
  for (let l = 0; l < e.length; l += 1) {
    const c = e[l], u = il(c, t);
    i[u] = c, a[u] = u, s.rows.push(u);
  }
  return {
    rowsBeforePartialUpdates: e,
    loadingPropBeforePartialUpdates: n,
    rowCountPropBeforePartialUpdates: o,
    updates: s,
    dataRowIdToIdLookup: a,
    dataRowIdToModelLookup: i
  };
}, Bk = ({
  tree: e,
  rowCountProp: t = 0
}) => {
  const n = e[Dt];
  return Math.max(t, n.children.length + (n.footerId == null ? 0 : 1));
}, zk = ({
  apiRef: e,
  rowCountProp: t = 0,
  loadingProp: n,
  previousTree: o,
  previousTreeDepths: s,
  previousGroupsToFetch: i
}) => {
  const a = e.current.caches.rows, {
    tree: l,
    treeDepths: c,
    dataRowIds: u,
    groupingName: d,
    groupsToFetch: f = []
  } = e.current.applyStrategyProcessor("rowTreeCreation", {
    previousTree: o,
    previousTreeDepths: s,
    updates: a.updates,
    dataRowIdToIdLookup: a.dataRowIdToIdLookup,
    dataRowIdToModelLookup: a.dataRowIdToModelLookup,
    previousGroupsToFetch: i
  }), p = e.current.unstable_applyPipeProcessors("hydrateRows", {
    tree: l,
    treeDepths: c,
    dataRowIdToIdLookup: a.dataRowIdToIdLookup,
    dataRowIds: u,
    dataRowIdToModelLookup: a.dataRowIdToModelLookup
  });
  return e.current.caches.rows.updates = {
    type: "partial",
    actions: {
      insert: [],
      modify: [],
      remove: []
    },
    idToActionLookup: {}
  }, I({}, p, {
    totalRowCount: Math.max(t, p.dataRowIds.length),
    totalTopLevelRowCount: Bk({
      tree: p.tree,
      rowCountProp: t
    }),
    groupingName: d,
    loading: n,
    groupsToFetch: f
  });
}, al = (e) => e.type === "skeletonRow" || e.type === "footer" || e.type === "group" && e.isAutoGenerated || e.type === "pinnedRow" && e.isAutoGenerated, Nu = (e, t, n) => {
  const o = e[t];
  if (o.type !== "group")
    return [];
  const s = [];
  for (let i = 0; i < o.children.length; i += 1) {
    const a = o.children[i];
    (!n || !al(e[a])) && s.push(a);
    const l = Nu(e, a, n);
    for (let c = 0; c < l.length; c += 1)
      s.push(l[c]);
  }
  return !n && o.footerId != null && s.push(o.footerId), s;
}, dT = ({
  previousCache: e,
  getRowId: t,
  updates: n,
  groupKeys: o
}) => {
  if (e.updates.type === "full")
    throw new Error("MUI X: Unable to prepare a partial update if a full update is not applied yet.");
  const s = /* @__PURE__ */ new Map();
  n.forEach((d) => {
    const f = il(d, t, "A row was provided without id when calling updateRows():");
    s.has(f) ? s.set(f, I({}, s.get(f), d)) : s.set(f, d);
  });
  const i = {
    type: "partial",
    actions: {
      insert: [...e.updates.actions.insert ?? []],
      modify: [...e.updates.actions.modify ?? []],
      remove: [...e.updates.actions.remove ?? []]
    },
    idToActionLookup: I({}, e.updates.idToActionLookup),
    groupKeys: o
  }, a = I({}, e.dataRowIdToModelLookup), l = I({}, e.dataRowIdToIdLookup), c = {
    insert: {},
    modify: {},
    remove: {}
  };
  s.forEach((d, f) => {
    const p = i.idToActionLookup[f];
    if (d._action === "delete") {
      if (p === "remove" || !a[f])
        return;
      p != null && (c[p][f] = !0), i.actions.remove.push(f), delete a[f], delete l[f];
      return;
    }
    const m = a[f];
    if (m) {
      p === "remove" ? (c.remove[f] = !0, i.actions.modify.push(f)) : p == null && i.actions.modify.push(f), a[f] = I({}, m, d);
      return;
    }
    p === "remove" ? (c.remove[f] = !0, i.actions.insert.push(f)) : p == null && i.actions.insert.push(f), a[f] = d, l[f] = f;
  });
  const u = Object.keys(c);
  for (let d = 0; d < u.length; d += 1) {
    const f = u[d], p = c[f];
    Object.keys(p).length > 0 && (i.actions[f] = i.actions[f].filter((m) => !p[m]));
  }
  return {
    dataRowIdToModelLookup: a,
    dataRowIdToIdLookup: l,
    updates: i,
    rowsBeforePartialUpdates: e.rowsBeforePartialUpdates,
    loadingPropBeforePartialUpdates: e.loadingPropBeforePartialUpdates,
    rowCountPropBeforePartialUpdates: e.rowCountPropBeforePartialUpdates
  };
}, Hk = "var(--DataGrid-overlayHeight, calc(var(--height) * 2))";
function fT(e, t, n) {
  const o = [];
  return t.forEach((s) => {
    const i = il(s, n, "A row was provided without id when calling updateRows():"), a = e.current.getRowNode(i);
    if ((a == null ? void 0 : a.type) === "pinnedRow") {
      const l = e.current.caches.pinnedRows, c = l.idLookup[i];
      c && (l.idLookup[i] = I({}, c, s));
    } else
      o.push(s);
  }), o;
}
let pT = !1;
const jk = (e, t, n) => typeof e == "number" && e > 0 ? e : (process.env.NODE_ENV !== "production" && !pT && typeof e < "u" && e !== null && (console.warn(n), pT = !0), t), sK = ["MUI X: The `rowHeight` prop should be a number greater than 0.", "The default value will be used instead."].join(`
`), iK = ["MUI X: The `getRowHeight` prop should return a number greater than 0 or 'auto'.", "The default value will be used instead."].join(`
`), YC = "__tree_data_group__", Gk = "__row_group_by_columns_group__", Bo = "__detail_panel_toggle__";
let ut = /* @__PURE__ */ function(e) {
  return e[e.NONE = 0] = "NONE", e[e.LEFT = 1] = "LEFT", e[e.RIGHT = 2] = "RIGHT", e[e.VIRTUAL = 3] = "VIRTUAL", e;
}({});
const aK = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "hasFocus", "tabIndex", "hideDescendantCount"], lK = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["booleanCell"]
  }, rt, t);
};
function qk(e) {
  const {
    value: t,
    rowNode: n
  } = e, o = ve(e, aK), s = lt(), i = Xe(), a = {
    classes: i.classes
  }, l = lK(a), u = (
    // @ts-expect-error - Access tree data prop
    ge(s, Ps) > 0 && n.type === "group" && i.treeData === !1
  ), d = h.useMemo(() => t ? i.slots.booleanCellTrueIcon : i.slots.booleanCellFalseIcon, [i.slots.booleanCellFalseIcon, i.slots.booleanCellTrueIcon, t]);
  return u && t === void 0 ? null : /* @__PURE__ */ C(d, I({
    fontSize: "small",
    className: l.root,
    titleAccess: s.current.getLocaleText(t ? "booleanCellTrueLabel" : "booleanCellFalseLabel"),
    "data-value": !!t
  }, o));
}
process.env.NODE_ENV !== "production" && (qk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: r.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: r.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: r.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: r.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      focus: r.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: r.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: r.bool.isRequired,
  hideDescendantCount: r.bool,
  /**
   * The grid row id.
   */
  id: r.oneOfType([r.number, r.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: r.bool,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: r.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: r.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: r.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: r.any
});
const cK = /* @__PURE__ */ h.memo(qk), uK = (e) => e.field !== Gk && al(e.rowNode) ? "" : /* @__PURE__ */ C(cK, I({}, e)), dK = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "className", "hasFocus", "isValidating", "isProcessingProps", "error", "onValueChange"], fK = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["editBooleanCell"]
  }, rt, t);
};
function Wk(e) {
  var y;
  const {
    id: t,
    value: n,
    field: o,
    className: s,
    hasFocus: i,
    onValueChange: a
  } = e, l = ve(e, dK), c = lt(), u = h.useRef(null), d = gt(), [f, p] = h.useState(n), m = Xe(), b = {
    classes: m.classes
  }, v = fK(b), g = h.useCallback(async (w) => {
    const x = w.target.checked;
    a && await a(w, x), p(x), await c.current.setEditCellValue({
      id: t,
      field: o,
      value: x
    }, w);
  }, [c, o, t, a]);
  return h.useEffect(() => {
    p(n);
  }, [n]), yt(() => {
    i && u.current.focus();
  }, [i]), /* @__PURE__ */ C("label", I({
    htmlFor: d,
    className: ae(v.root, s)
  }, l, {
    children: /* @__PURE__ */ C(m.slots.baseCheckbox, I({
      id: d,
      inputRef: u,
      checked: !!f,
      onChange: g,
      size: "small"
    }, (y = m.slotProps) == null ? void 0 : y.baseCheckbox))
  }));
}
process.env.NODE_ENV !== "production" && (Wk.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: r.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: r.oneOf(["edit", "view"]).isRequired,
  changeReason: r.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: r.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: r.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: r.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: r.bool.isRequired,
  /**
   * The grid row id.
   */
  id: r.oneOfType([r.number, r.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: r.bool,
  isProcessingProps: r.bool,
  isValidating: r.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {boolean} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: r.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: r.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: r.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: r.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: r.any
});
const pK = (e) => /* @__PURE__ */ C(Wk, I({}, e)), hK = ["item", "applyValue", "apiRef", "focusElementRef", "isFilterActive", "clearButton", "tabIndex", "label", "variant", "InputLabelProps"], tf = (e) => {
  if (String(e).toLowerCase() === "true")
    return !0;
  if (String(e).toLowerCase() === "false")
    return !1;
}, gK = te("div")({
  display: "flex",
  alignItems: "center",
  width: "100%",
  "& button": {
    margin: "auto 0px 5px 5px"
  }
});
function XC(e) {
  var S, T, E;
  const {
    item: t,
    applyValue: n,
    apiRef: o,
    focusElementRef: s,
    clearButton: i,
    tabIndex: a,
    label: l,
    variant: c = "standard"
  } = e, u = ve(e, hK), [d, f] = h.useState(tf(t.value)), p = Xe(), m = gt(), b = gt(), v = ((S = p.slotProps) == null ? void 0 : S.baseSelect) || {}, g = v.native ?? !1, y = ((T = p.slotProps) == null ? void 0 : T.baseSelectOption) || {}, w = h.useCallback((O) => {
    const M = tf(O.target.value);
    f(M), n(I({}, t, {
      value: M
    }));
  }, [n, t]);
  h.useEffect(() => {
    f(tf(t.value));
  }, [t.value]);
  const x = l ?? o.current.getLocaleText("filterPanelInputLabel");
  return /* @__PURE__ */ ie(gK, {
    children: [/* @__PURE__ */ ie(p.slots.baseFormControl, {
      fullWidth: !0,
      children: [/* @__PURE__ */ C(p.slots.baseInputLabel, I({}, (E = p.slotProps) == null ? void 0 : E.baseInputLabel, {
        id: m,
        shrink: !0,
        variant: c,
        children: x
      })), /* @__PURE__ */ ie(p.slots.baseSelect, I({
        labelId: m,
        id: b,
        label: x,
        value: d === void 0 ? "" : String(d),
        onChange: w,
        variant: c,
        notched: c === "outlined" ? !0 : void 0,
        native: g,
        displayEmpty: !0,
        inputProps: {
          ref: s,
          tabIndex: a
        }
      }, u, v, {
        children: [/* @__PURE__ */ C(p.slots.baseSelectOption, I({}, y, {
          native: g,
          value: "",
          children: o.current.getLocaleText("filterValueAny")
        })), /* @__PURE__ */ C(p.slots.baseSelectOption, I({}, y, {
          native: g,
          value: "true",
          children: o.current.getLocaleText("filterValueTrue")
        })), /* @__PURE__ */ C(p.slots.baseSelectOption, I({}, y, {
          native: g,
          value: "false",
          children: o.current.getLocaleText("filterValueFalse")
        }))]
      }))]
    }), i]
  });
}
process.env.NODE_ENV !== "production" && (XC.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: r.shape({
    current: r.object.isRequired
  }).isRequired,
  applyValue: r.func.isRequired,
  clearButton: r.node,
  focusElementRef: Lt,
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: r.bool,
  item: r.shape({
    field: r.string.isRequired,
    id: r.oneOfType([r.number, r.string]),
    operator: r.string.isRequired,
    value: r.any
  }).isRequired
});
const mK = () => [{
  value: "is",
  getApplyFilterFn: (e) => {
    const t = tf(e.value);
    return t === void 0 ? null : (n) => !!n === t;
  },
  InputComponent: XC
}], bK = (e, t, n, o) => e ? o.current.getLocaleText("booleanCellTrueLabel") : o.current.getLocaleText("booleanCellFalseLabel"), yK = (e) => {
  switch (e.toLowerCase().trim()) {
    case "true":
    case "yes":
    case "1":
      return !0;
    case "false":
    case "no":
    case "0":
    case "null":
    case "undefined":
      return !1;
    default:
      return;
  }
}, Uk = I({}, ko, {
  type: "boolean",
  display: "flex",
  align: "center",
  headerAlign: "center",
  renderCell: uK,
  renderEditCell: pK,
  sortComparator: Tk,
  valueFormatter: bK,
  filterOperators: mK(),
  getApplyQuickFilterFn: void 0,
  // @ts-ignore
  aggregable: !1,
  // @ts-ignore
  pastedValueParser: (e) => yK(e)
}), Kk = (e) => e.sorting, Rl = Je(Kk, (e) => e.sortedRows), QC = Mt(Rl, fr, Vn, (e, t, n) => e.reduce((o, s) => {
  const i = t[s];
  if (i)
    o.push({
      id: s,
      model: i
    });
  else {
    const a = n[s];
    a && al(a) && o.push({
      id: s,
      model: {
        [za]: s
      }
    });
  }
  return o;
}, [])), uo = Je(Kk, (e) => e.sortModel), vK = Mt(uo, (e) => e.reduce((n, o, s) => (n[o.field] = {
  sortDirection: o.sort,
  sortIndex: e.length > 1 ? s + 1 : void 0
}, n), {})), CK = Mt(Rl, (e) => e.reduce((t, n, o) => (t[n] = o, t), /* @__PURE__ */ Object.create(null))), qp = (e) => e.filter, kn = Je(qp, (e) => e.filterModel), Yk = Je(kn, (e) => e.quickFilterValues), wK = (e) => e.visibleRowsLookup, El = Je(qp, (e) => e.filteredRowsLookup), SK = Je(qp, (e) => e.filteredChildrenCountLookup), xK = Je(qp, (e) => e.filteredDescendantCountLookup), oi = Mt(wK, QC, Ps, kn, Yk, (e, t, n, o, s) => n < 2 && !o.items.length && !(s != null && s.length) ? t : t.filter((i) => e[i.id] !== !1)), Ha = Mt(oi, (e) => e.map((t) => t.id)), Xk = Mt(El, QC, (e, t) => t.filter((n) => e[n.id] !== !1)), Qk = Mt(Xk, (e) => e.map((t) => t.id)), TK = Mt(Ha, Vn, (e, t) => {
  const n = {};
  let o = 0;
  return e.reduce((s, i) => {
    const a = t[i];
    return n[a.depth] || (n[a.depth] = 0), a.depth > o && (n[a.depth] = 0), o = a.depth, n[a.depth] += 1, s[i] = n[a.depth], s;
  }, {});
}), Zk = Mt(oi, Vn, Ps, (e, t, n) => n < 2 ? e : e.filter((o) => {
  var s;
  return ((s = t[o.id]) == null ? void 0 : s.depth) === 0;
})), ZC = Je(oi, (e) => e.length), Wp = Je(Zk, (e) => e.length), RK = Je(Xk, (e) => e.length);
Je(RK, Wp, (e, t) => e - t);
const EK = Mt(kn, as, (e, t) => {
  var n;
  return (n = e.items) == null ? void 0 : n.filter((o) => {
    var a, l;
    if (!o.field)
      return !1;
    const s = t[o.field];
    if (!(s != null && s.filterOperators) || ((a = s == null ? void 0 : s.filterOperators) == null ? void 0 : a.length) === 0)
      return !1;
    const i = s.filterOperators.find((c) => c.value === o.operator);
    return i ? !i.InputComponent || o.value != null && ((l = o.value) == null ? void 0 : l.toString()) !== "" : !1;
  });
}), IK = Mt(EK, (e) => e.reduce((n, o) => (n[o.field] ? n[o.field].push(o) : n[o.field] = [o], n), {})), sr = (e) => e.rowSelection, OK = Je(sr, (e) => e.length), PK = Mt(sr, fr, (e, t) => new Map(e.map((n) => [n, t[n]]))), ms = Mt(sr, (e) => e.reduce((t, n) => (t[n] = n, t), {})), MK = {
  parents: !1,
  descendants: !1
};
function Jk(e, t) {
  var c;
  const n = Vn(e), o = Rl(e), s = El(e), i = n[t];
  if (!i || i.type !== "group")
    return [];
  const a = [], l = o.findIndex((u) => u === t) + 1;
  for (let u = l; u < o.length && ((c = n[o[u]]) == null ? void 0 : c.depth) > i.depth; u += 1) {
    const d = o[u];
    s[d] !== !1 && e.current.isRowSelectable(d) && a.push(d);
  }
  return a;
}
function kK(e, t) {
  return Je(Vn, Rl, El, ms, (n, o, s, i) => {
    var d;
    const a = n[e];
    if (!a || a.type !== "group")
      return {
        isIndeterminate: !1,
        isChecked: i[e] === e
      };
    if (i[e] === e)
      return {
        isIndeterminate: !1,
        isChecked: !0
      };
    let l = 0, c = 0;
    const u = o.findIndex((f) => f === e) + 1;
    for (let f = u; f < o.length && ((d = n[o[f]]) == null ? void 0 : d.depth) > a.depth; f += 1) {
      const p = o[f];
      s[p] !== !1 && (l += 1, i[p] !== void 0 && (c += 1));
    }
    return {
      isIndeterminate: c > 0 && (c < l || i[e] === void 0),
      isChecked: t ? c > 0 : i[e] === e
    };
  });
}
function JC(e) {
  return e.signature === Mo.DataGrid ? e.checkboxSelection && e.disableMultipleRowSelection !== !0 : !e.disableMultipleRowSelection;
}
const DK = (e, t) => {
  const n = [];
  let o = t;
  for (; o != null && o !== Dt; ) {
    const s = e[o];
    if (!s)
      return n;
    n.push(o), o = s.parent;
  }
  return n;
}, NK = (e, t, n) => {
  const o = e[n];
  if (!o)
    return [];
  const s = o.parent;
  return s == null ? [] : e[s].children.filter((a) => a !== n && t[a] !== !1);
}, Id = (e, t, n, o, s, i) => {
  const a = El(e), l = ms(e), c = /* @__PURE__ */ new Set([]);
  if (!(!o && !s)) {
    if (o) {
      const u = t[n];
      (u == null ? void 0 : u.type) === "group" && Jk(e, n).forEach((f) => {
        i(f), c.add(f);
      });
    }
    if (s) {
      const u = (f) => {
        if (l[f] !== f && !c.has(f))
          return !1;
        const p = t[f];
        return (p == null ? void 0 : p.type) !== "group" ? !0 : p.children.every(u);
      }, d = (f) => {
        const p = NK(t, a, f);
        if (p.length === 0 || p.every(u)) {
          const b = t[f].parent;
          b != null && b !== Dt && e.current.isRowSelectable(b) && (i(b), c.add(b), d(b));
        }
      };
      d(n);
    }
  }
}, hT = (e, t, n, o, s, i) => {
  const a = ms(e);
  if (!(!s && !o) && (s && DK(t, n).forEach((c) => {
    a[c] === c && i(c);
  }), o)) {
    const l = t[n];
    (l == null ? void 0 : l.type) === "group" && Jk(e, n).forEach((u) => {
      i(u);
    });
  }
}, $K = ["field", "id", "formattedValue", "row", "rowNode", "colDef", "isEditable", "cellMode", "hasFocus", "tabIndex", "api"], AK = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["checkboxInput"]
  }, rt, t);
}, eD = Ct(function(t, n) {
  var M, D;
  const {
    field: o,
    id: s,
    rowNode: i,
    hasFocus: a,
    tabIndex: l
  } = t, c = ve(t, $K), u = lt(), d = Xe(), f = {
    classes: d.classes
  }, p = AK(f), m = h.useRef(null), b = h.useRef(null), v = tt(m, n), g = (R) => {
    const P = {
      value: R.target.checked,
      id: s
    };
    u.current.publishEvent("rowSelectionCheckboxChange", P, R);
  };
  h.useLayoutEffect(() => {
    if (l === 0) {
      const R = u.current.getCellElement(s, o);
      R && (R.tabIndex = -1);
    }
  }, [u, l, s, o]), h.useEffect(() => {
    var R;
    if (a) {
      const P = (R = m.current) == null ? void 0 : R.querySelector("input");
      P == null || P.focus({
        preventScroll: !0
      });
    } else b.current && b.current.stop({});
  }, [a]);
  const y = h.useCallback((R) => {
    R.key === " " && R.stopPropagation();
  }, []), w = u.current.isRowSelectable(s), x = kK(s, ((M = d.rowSelectionPropagation) == null ? void 0 : M.parents) ?? !1), {
    isIndeterminate: S,
    isChecked: T
  } = ge(u, x, LC);
  if (i.type === "footer" || i.type === "pinnedRow")
    return null;
  const E = d.indeterminateCheckboxAction === "select" ? T && !S : T, O = u.current.getLocaleText(E ? "checkboxSelectionUnselectRow" : "checkboxSelectionSelectRow");
  return /* @__PURE__ */ C(d.slots.baseCheckbox, I({
    tabIndex: l,
    checked: E,
    onChange: g,
    className: p.root,
    inputProps: {
      "aria-label": O,
      name: "select_row"
    },
    onKeyDown: y,
    indeterminate: S,
    disabled: !w,
    touchRippleRef: b
    /* FIXME: typing error */
  }, (D = d.slotProps) == null ? void 0 : D.baseCheckbox, c, {
    ref: v
  }));
});
process.env.NODE_ENV !== "production" && (eD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: r.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: r.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: r.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: r.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      focus: r.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: r.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: r.bool.isRequired,
  /**
   * The grid row id.
   */
  id: r.oneOfType([r.number, r.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: r.bool,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: r.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: r.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: r.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: r.any
});
const FK = eD, Up = (e) => e.focus, fo = Je(Up, (e) => e.cell), LK = Je(Up, (e) => e.columnHeader), _K = Je(Up, (e) => e.columnHeaderFilter), _f = Je(Up, (e) => e.columnGroupHeader), Kp = (e) => e.tabIndex, e0 = Je(Kp, (e) => e.cell), tD = Je(Kp, (e) => e.columnHeader), VK = Je(Kp, (e) => e.columnHeaderFilter), BK = Je(Kp, (e) => e.columnGroupHeader);
function ot(e, t, n) {
  const o = h.useRef(!0);
  yt(() => {
    o.current = !1, e.current.register(n, t);
  }, [e, n, t]), o.current && e.current.register(n, t);
}
function Mn(e, t) {
  const n = h.useRef(null);
  if (n.current)
    return n.current;
  const o = e.current.getLogger(t);
  return n.current = o, o;
}
const nD = (e, t, n, o, s) => {
  const i = Mn(e, "useNativeEventListener"), [a, l] = h.useState(!1), c = h.useRef(o), u = Ek(t) ? t() : (t == null ? void 0 : t.current) ?? null, d = h.useCallback((f) => c.current && c.current(f), []);
  h.useEffect(() => {
    c.current = o;
  }, [o]), h.useEffect(() => {
    if (u && n && !a) {
      i.debug(`Binding native ${n} event`), u.addEventListener(n, d, s), l(!0);
      const f = () => {
        i.debug(`Clearing native ${n} event`), u.removeEventListener(n, d, s);
      };
      e.current.subscribeEvent("unmount", f);
    }
  }, [u, d, n, a, i, s, e]);
}, ra = (e) => {
  const t = h.useRef(!0);
  t.current && (t.current = !1, e());
}, zK = () => {
}, HK = (e, t) => {
  const n = h.useRef(!1);
  yt(() => n.current || !e ? zK : (n.current = !0, t()), [n.current || e]);
}, jK = 100, GK = (e) => e ? 0 : 100, oD = (e, t, n) => t > 0 && e > 0 ? Math.ceil(e / t) : e === -1 ? n + 2 : 0, rD = (e) => ({
  page: 0,
  pageSize: e ? 0 : 100
}), qK = (e, t = 0) => t === 0 ? e : Math.max(Math.min(e, t - 1), 0), sD = (e, t) => {
  if (t === Mo.DataGrid && e > jK)
    throw new Error(["MUI X: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`));
}, WK = -1, $u = (e) => e.pagination, iD = Je($u, (e) => e.enabled && e.paginationMode === "client"), oo = Je($u, (e) => e.paginationModel), Na = Je($u, (e) => e.rowCount), pc = Je($u, (e) => e.meta), UK = Je(oo, (e) => e.page), aD = Je(oo, (e) => e.pageSize), lD = Je(oo, Na, (e, t) => oD(t, e.pageSize, e.page)), t0 = Mt(iD, oo, Vn, Ps, oi, Zk, (e, t, n, o, s, i) => {
  var b;
  if (!e)
    return null;
  const a = i.length, l = Math.min(t.pageSize * t.page, a - 1), c = t.pageSize === WK ? a - 1 : Math.min(l + t.pageSize - 1, a - 1);
  if (l === -1 || c === -1)
    return null;
  if (o < 2)
    return {
      firstRowIndex: l,
      lastRowIndex: c
    };
  const u = i[l], d = c - l + 1, f = s.findIndex((v) => v.id === u.id);
  let p = f, m = 0;
  for (; p < s.length && m <= d; ) {
    const v = s[p], g = (b = n[v.id]) == null ? void 0 : b.depth;
    g === void 0 ? p += 1 : ((m < d || g > 0) && (p += 1), g === 0 && (m += 1));
  }
  return {
    firstRowIndex: f,
    lastRowIndex: p - 1
  };
}), KK = Mt(oi, t0, (e, t) => t ? e.slice(t.firstRowIndex, t.lastRowIndex + 1) : []), cD = Mt(Ha, t0, (e, t) => t ? e.slice(t.firstRowIndex, t.lastRowIndex + 1) : []), Au = Mt(iD, t0, KK, oi, (e, t, n, o) => e ? {
  rows: n,
  range: t,
  rowToIndexMap: n.reduce((s, i, a) => (s.set(i.model, a), s), /* @__PURE__ */ new Map())
} : {
  rows: o,
  range: o.length === 0 ? null : {
    firstRowIndex: 0,
    lastRowIndex: o.length - 1
  },
  rowToIndexMap: o.reduce((s, i, a) => (s.set(i.model, a), s), /* @__PURE__ */ new Map())
}), YK = ["field", "colDef"], XK = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["checkboxInput"]
  }, rt, t);
}, uD = Ct(function(t, n) {
  var M;
  const o = ve(t, YK), [, s] = h.useState(!1), i = lt(), a = Xe(), l = {
    classes: a.classes
  }, c = XK(l), u = ge(i, tD), d = ge(i, sr), f = ge(i, Ha), p = ge(i, cD), m = h.useMemo(() => typeof a.isRowSelectable != "function" ? d : d.filter((D) => a.keepNonExistentRowsSelected ? !0 : i.current.getRow(D) ? a.isRowSelectable(i.current.getRowParams(D)) : !1), [i, a.isRowSelectable, d, a.keepNonExistentRowsSelected]), b = h.useMemo(() => (!a.pagination || !a.checkboxSelectionVisibleOnly ? f : p).reduce((R, P) => (R[P] = !0, R), {}), [a.pagination, a.checkboxSelectionVisibleOnly, p, f]), v = h.useMemo(() => m.filter((D) => b[D]).length, [m, b]), g = v > 0 && v < Object.keys(b).length, y = v > 0, w = (D) => {
    const R = {
      value: D.target.checked
    };
    i.current.publishEvent("headerSelectionCheckboxChange", R);
  }, x = u !== null && u.field === t.field ? 0 : -1;
  h.useLayoutEffect(() => {
    const D = i.current.getColumnHeaderElement(t.field);
    x === 0 && D && (D.tabIndex = -1);
  }, [x, i, t.field]);
  const S = h.useCallback((D) => {
    D.key === " " && i.current.publishEvent("headerSelectionCheckboxChange", {
      value: !y
    });
  }, [i, y]), T = h.useCallback(() => {
    s((D) => !D);
  }, []);
  h.useEffect(() => i.current.subscribeEvent("rowSelectionChange", T), [i, T]);
  const E = a.indeterminateCheckboxAction === "select" ? y && !g : y, O = i.current.getLocaleText(E ? "checkboxSelectionUnselectAllRows" : "checkboxSelectionSelectAllRows");
  return /* @__PURE__ */ C(a.slots.baseCheckbox, I({
    indeterminate: g,
    checked: E,
    onChange: w,
    className: c.root,
    inputProps: {
      "aria-label": O,
      name: "select_all_rows"
    },
    tabIndex: x,
    onKeyDown: S,
    disabled: !JC(a)
  }, (M = a.slotProps) == null ? void 0 : M.baseCheckbox, o, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (uD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The column of the current header component.
   */
  colDef: r.object.isRequired,
  /**
   * The column field of the column that triggered the event
   */
  field: r.string.isRequired
});
const Rr = "__check__", Il = I({}, Uk, {
  type: "custom",
  field: Rr,
  width: 50,
  resizable: !1,
  sortable: !1,
  filterable: !1,
  // @ts-ignore
  aggregable: !1,
  disableColumnMenu: !0,
  disableReorder: !0,
  disableExport: !0,
  getApplyQuickFilterFn: void 0,
  display: "flex",
  valueGetter: (e, t, n, o) => {
    const s = ms(o), i = o.current.getRowId(t);
    return s[i] !== void 0;
  },
  renderHeader: (e) => /* @__PURE__ */ C(uD, I({}, e)),
  renderCell: (e) => /* @__PURE__ */ C(FK, I({}, e))
}), QK = ["item", "applyValue", "type", "apiRef", "focusElementRef", "InputProps", "isFilterActive", "clearButton", "tabIndex", "disabled"];
function gT(e, t) {
  if (e == null)
    return "";
  const n = new Date(e);
  return Number.isNaN(n.getTime()) ? "" : t === "date" ? n.toISOString().substring(0, 10) : t === "datetime-local" ? (n.setMinutes(n.getMinutes() - n.getTimezoneOffset()), n.toISOString().substring(0, 19)) : n.toISOString().substring(0, 10);
}
function hs(e) {
  var x;
  const {
    item: t,
    applyValue: n,
    type: o,
    apiRef: s,
    focusElementRef: i,
    InputProps: a,
    clearButton: l,
    tabIndex: c,
    disabled: u
  } = e, d = ve(e, QK), f = go(), [p, m] = h.useState(() => gT(t.value, o)), [b, v] = h.useState(!1), g = gt(), y = Xe(), w = h.useCallback((S) => {
    f.clear();
    const T = S.target.value;
    m(T), v(!0), f.start(y.filterDebounceMs, () => {
      const E = new Date(T);
      n(I({}, t, {
        value: Number.isNaN(E.getTime()) ? void 0 : E
      })), v(!1);
    });
  }, [n, t, y.filterDebounceMs, f]);
  return h.useEffect(() => {
    const S = gT(t.value, o);
    m(S);
  }, [t.value, o]), /* @__PURE__ */ C(y.slots.baseTextField, I({
    fullWidth: !0,
    id: g,
    label: s.current.getLocaleText("filterPanelInputLabel"),
    placeholder: s.current.getLocaleText("filterPanelInputPlaceholder"),
    value: p,
    onChange: w,
    variant: "standard",
    type: o || "text",
    InputLabelProps: {
      shrink: !0
    },
    inputRef: i,
    InputProps: I({}, b || l ? {
      endAdornment: b ? /* @__PURE__ */ C(y.slots.loadIcon, {
        fontSize: "small",
        color: "action"
      }) : l
    } : {}, {
      disabled: u
    }, a, {
      inputProps: I({
        max: o === "datetime-local" ? "9999-12-31T23:59" : "9999-12-31",
        tabIndex: c
      }, a == null ? void 0 : a.inputProps)
    })
  }, d, (x = y.slotProps) == null ? void 0 : x.baseTextField));
}
process.env.NODE_ENV !== "production" && (hs.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: r.shape({
    current: r.object.isRequired
  }).isRequired,
  applyValue: r.func.isRequired,
  clearButton: r.node,
  focusElementRef: r.oneOfType([r.func, r.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: r.bool,
  item: r.shape({
    field: r.string.isRequired,
    id: r.oneOfType([r.number, r.string]),
    operator: r.string.isRequired,
    value: r.any
  }).isRequired
});
function fa(e, t, n, o) {
  if (!e.value)
    return null;
  const s = new Date(e.value);
  n ? s.setSeconds(0, 0) : (s.setMinutes(s.getMinutes() + s.getTimezoneOffset()), s.setHours(0, 0, 0, 0));
  const i = s.getTime();
  return (a) => {
    if (!a)
      return !1;
    if (o)
      return t(a.getTime(), i);
    const l = new Date(a);
    return n ? l.setSeconds(0, 0) : l.setHours(0, 0, 0, 0), t(l.getTime(), i);
  };
}
const dD = (e) => [{
  value: "is",
  getApplyFilterFn: (t) => fa(t, (n, o) => n === o, e),
  InputComponent: hs,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "not",
  getApplyFilterFn: (t) => fa(t, (n, o) => n !== o, e),
  InputComponent: hs,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "after",
  getApplyFilterFn: (t) => fa(t, (n, o) => n > o, e),
  InputComponent: hs,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "onOrAfter",
  getApplyFilterFn: (t) => fa(t, (n, o) => n >= o, e),
  InputComponent: hs,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "before",
  getApplyFilterFn: (t) => fa(t, (n, o) => n < o, e, !e),
  InputComponent: hs,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "onOrBefore",
  getApplyFilterFn: (t) => fa(t, (n, o) => n <= o, e),
  InputComponent: hs,
  InputComponentProps: {
    type: e ? "datetime-local" : "date"
  }
}, {
  value: "isEmpty",
  getApplyFilterFn: () => (t) => t == null,
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFn: () => (t) => t != null,
  requiresFilterValue: !1
}], ZK = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "inputProps", "isValidating", "isProcessingProps", "onValueChange"], JK = te(Xi)({
  fontSize: "inherit"
}), eY = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["editInputCell"]
  }, rt, t);
};
function fD(e) {
  const {
    id: t,
    value: n,
    field: o,
    colDef: s,
    hasFocus: i,
    inputProps: a,
    onValueChange: l
  } = e, c = ve(e, ZK), u = s.type === "dateTime", d = lt(), f = h.useRef(null), p = h.useMemo(() => {
    let S;
    n == null ? S = null : n instanceof Date ? S = n : S = new Date((n ?? "").toString());
    let T;
    return S == null || Number.isNaN(S.getTime()) ? T = "" : T = new Date(S.getTime() - S.getTimezoneOffset() * 60 * 1e3).toISOString().substr(0, u ? 16 : 10), {
      parsed: S,
      formatted: T
    };
  }, [n, u]), [m, b] = h.useState(p), g = {
    classes: Xe().classes
  }, y = eY(g), w = h.useCallback((S) => {
    if (S === "")
      return null;
    const [T, E] = S.split("T"), [O, M, D] = T.split("-"), R = /* @__PURE__ */ new Date();
    if (R.setFullYear(Number(O), Number(M) - 1, Number(D)), R.setHours(0, 0, 0, 0), E) {
      const [P, F] = E.split(":");
      R.setHours(Number(P), Number(F), 0, 0);
    }
    return R;
  }, []), x = h.useCallback(async (S) => {
    const T = S.target.value, E = w(T);
    l && await l(S, E), b({
      parsed: E,
      formatted: T
    }), d.current.setEditCellValue({
      id: t,
      field: o,
      value: E
    }, S);
  }, [d, o, t, l, w]);
  return h.useEffect(() => {
    b((S) => {
      var T, E;
      return p.parsed !== S.parsed && ((T = p.parsed) == null ? void 0 : T.getTime()) !== ((E = S.parsed) == null ? void 0 : E.getTime()) ? p : S;
    });
  }, [p]), yt(() => {
    i && f.current.focus();
  }, [i]), /* @__PURE__ */ C(JK, I({
    inputRef: f,
    fullWidth: !0,
    className: y.root,
    type: u ? "datetime-local" : "date",
    inputProps: I({
      max: u ? "9999-12-31T23:59" : "9999-12-31"
    }, a),
    value: m.formatted,
    onChange: x
  }, c));
}
process.env.NODE_ENV !== "production" && (fD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: r.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: r.oneOf(["edit", "view"]).isRequired,
  changeReason: r.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: r.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: r.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: r.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: r.bool.isRequired,
  /**
   * The grid row id.
   */
  id: r.oneOfType([r.number, r.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: r.bool,
  isProcessingProps: r.bool,
  isValidating: r.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {Date | null} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: r.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: r.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: r.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: r.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: r.any
});
const pD = (e) => /* @__PURE__ */ C(fD, I({}, e));
function hD({
  value: e,
  columnType: t,
  rowId: n,
  field: o
}) {
  if (!(e instanceof Date))
    throw new Error([`MUI X: \`${t}\` column type only accepts \`Date\` objects as values.`, "Use `valueGetter` to transform the value into a `Date` object.", `Row ID: ${n}, field: "${o}".`].join(`
`));
}
const tY = (e, t, n, o) => {
  if (!e)
    return "";
  const s = o.current.getRowId(t);
  return hD({
    value: e,
    columnType: "date",
    rowId: s,
    field: n.field
  }), e.toLocaleDateString();
}, nY = (e, t, n, o) => {
  if (!e)
    return "";
  const s = o.current.getRowId(t);
  return hD({
    value: e,
    columnType: "dateTime",
    rowId: s,
    field: n.field
  }), e.toLocaleString();
}, oY = I({}, ko, {
  type: "date",
  sortComparator: Rk,
  valueFormatter: tY,
  filterOperators: dD(),
  renderEditCell: pD,
  // @ts-ignore
  pastedValueParser: (e) => new Date(e)
}), rY = I({}, ko, {
  type: "dateTime",
  sortComparator: Rk,
  valueFormatter: nY,
  filterOperators: dD(!0),
  renderEditCell: pD,
  // @ts-ignore
  pastedValueParser: (e) => new Date(e)
}), Vs = (e) => e == null ? null : Number(e), sY = (e) => e == null || Number.isNaN(e) || e === "" ? null : (t) => Vs(t) === Vs(e), iY = () => [{
  value: "=",
  getApplyFilterFn: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => Vs(t) === e.value,
  InputComponent: po,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "!=",
  getApplyFilterFn: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => Vs(t) !== e.value,
  InputComponent: po,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: ">",
  getApplyFilterFn: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => t == null ? !1 : Vs(t) > e.value,
  InputComponent: po,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: ">=",
  getApplyFilterFn: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => t == null ? !1 : Vs(t) >= e.value,
  InputComponent: po,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "<",
  getApplyFilterFn: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => t == null ? !1 : Vs(t) < e.value,
  InputComponent: po,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "<=",
  getApplyFilterFn: (e) => e.value == null || Number.isNaN(e.value) ? null : (t) => t == null ? !1 : Vs(t) <= e.value,
  InputComponent: po,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "isEmpty",
  getApplyFilterFn: () => (e) => e == null,
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFn: () => (e) => e != null,
  requiresFilterValue: !1
}, {
  value: "isAnyOf",
  getApplyFilterFn: (e) => !Array.isArray(e.value) || e.value.length === 0 ? null : (t) => t != null && e.value.includes(Number(t)),
  InputComponent: WC,
  InputComponentProps: {
    type: "number"
  }
}], aY = I({}, ko, {
  type: "number",
  align: "right",
  headerAlign: "right",
  sortComparator: Tk,
  valueParser: (e) => e === "" ? null : Number(e),
  valueFormatter: (e) => GC(e) ? e.toLocaleString() : e || "",
  filterOperators: iY(),
  getApplyQuickFilterFn: sY
});
function ll(e) {
  return (e == null ? void 0 : e.type) === "singleSelect";
}
function Vi(e, t) {
  if (e)
    return typeof e.valueOptions == "function" ? e.valueOptions(I({
      field: e.field
    }, t)) : e.valueOptions;
}
function Vf(e, t, n) {
  if (t === void 0)
    return;
  const o = t.find((s) => {
    const i = n(s);
    return String(i) === String(e);
  });
  return n(o);
}
const lY = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "className", "hasFocus", "isValidating", "isProcessingProps", "error", "onValueChange", "initialOpen"], cY = ["MenuProps"];
function uY(e) {
  return !!e.key;
}
function gD(e) {
  var F, $;
  const t = Xe(), {
    id: n,
    value: o,
    field: s,
    row: i,
    colDef: a,
    hasFocus: l,
    error: c,
    onValueChange: u,
    initialOpen: d = t.editMode === ts.Cell
  } = e, f = ve(e, lY), p = lt(), m = h.useRef(null), b = h.useRef(null), [v, g] = h.useState(d), w = (((F = t.slotProps) == null ? void 0 : F.baseSelect) || {}).native ?? !1, x = (($ = t.slotProps) == null ? void 0 : $.baseSelect) || {}, {
    MenuProps: S
  } = x, T = ve(x, cY);
  if (yt(() => {
    var N;
    l && ((N = b.current) == null || N.focus());
  }, [l]), !ll(a))
    return null;
  const E = Vi(a, {
    id: n,
    row: i
  });
  if (!E)
    return null;
  const O = a.getOptionValue, M = a.getOptionLabel, D = async (N) => {
    if (!ll(a) || !E)
      return;
    g(!1);
    const A = N.target, k = Vf(A.value, E, O);
    u && await u(N, k), await p.current.setEditCellValue({
      id: n,
      field: s,
      value: k
    }, N);
  }, R = (N, A) => {
    if (t.editMode === ts.Row) {
      g(!1);
      return;
    }
    if (A === "backdropClick" || N.key === "Escape") {
      const k = p.current.getCellParams(n, s);
      p.current.publishEvent("cellEditStop", I({}, k, {
        reason: N.key === "Escape" ? xr.escapeKeyDown : xr.cellFocusOut
      }));
    }
  }, P = (N) => {
    uY(N) && N.key === "Enter" || g(!0);
  };
  return !E || !a ? null : /* @__PURE__ */ C(t.slots.baseSelect, I({
    ref: m,
    inputRef: b,
    value: o,
    onChange: D,
    open: v,
    onOpen: P,
    MenuProps: I({
      onClose: R
    }, S),
    error: c,
    native: w,
    fullWidth: !0
  }, f, T, {
    children: E.map((N) => {
      var k;
      const A = O(N);
      return /* @__PURE__ */ js(t.slots.baseSelectOption, I({}, ((k = t.slotProps) == null ? void 0 : k.baseSelectOption) || {}, {
        native: w,
        key: A,
        value: A
      }), M(N));
    })
  }));
}
process.env.NODE_ENV !== "production" && (gD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: r.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: r.oneOf(["edit", "view"]).isRequired,
  changeReason: r.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: r.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: r.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: r.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: r.bool.isRequired,
  /**
   * The grid row id.
   */
  id: r.oneOfType([r.number, r.string]).isRequired,
  /**
   * If true, the select opens by default.
   */
  initialOpen: r.bool,
  /**
   * If true, the cell is editable.
   */
  isEditable: r.bool,
  isProcessingProps: r.bool,
  isValidating: r.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {SelectChangeEvent<any>} event The event source of the callback.
   * @param {any} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: r.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: r.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: r.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: r.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: r.any
});
const dY = (e) => /* @__PURE__ */ C(gD, I({}, e)), fY = ["item", "applyValue", "type", "apiRef", "focusElementRef", "placeholder", "tabIndex", "label", "variant", "isFilterActive", "clearButton", "InputLabelProps"], pY = ({
  column: e,
  OptionComponent: t,
  getOptionLabel: n,
  getOptionValue: o,
  isSelectNative: s,
  baseSelectOptionProps: i
}) => ["", ...Vi(e) || []].map((l) => {
  const c = o(l);
  let u = n(l);
  return u === "" && (u = " "), /* @__PURE__ */ js(t, I({}, i, {
    native: s,
    key: c,
    value: c
  }), u);
}), hY = te("div")({
  display: "flex",
  alignItems: "flex-end",
  width: "100%",
  "& button": {
    margin: "auto 0px 5px 5px"
  }
});
function Bf(e) {
  var O, M, D, R, P;
  const {
    item: t,
    applyValue: n,
    type: o,
    apiRef: s,
    focusElementRef: i,
    placeholder: a,
    tabIndex: l,
    label: c,
    variant: u = "standard",
    clearButton: d
  } = e, f = ve(e, fY), p = t.value ?? "", m = gt(), b = gt(), v = Xe(), g = ((M = (O = v.slotProps) == null ? void 0 : O.baseSelect) == null ? void 0 : M.native) ?? !1;
  let y = null;
  if (t.field) {
    const F = s.current.getColumn(t.field);
    ll(F) && (y = F);
  }
  const w = y == null ? void 0 : y.getOptionValue, x = y == null ? void 0 : y.getOptionLabel, S = h.useMemo(() => Vi(y), [y]), T = h.useCallback((F) => {
    let $ = F.target.value;
    $ = Vf($, S, w), n(I({}, t, {
      value: $
    }));
  }, [S, w, n, t]);
  if (!ll(y))
    return null;
  const E = c ?? s.current.getLocaleText("filterPanelInputLabel");
  return /* @__PURE__ */ ie(hY, {
    children: [/* @__PURE__ */ ie(v.slots.baseFormControl, {
      fullWidth: !0,
      children: [/* @__PURE__ */ C(v.slots.baseInputLabel, I({}, (D = v.slotProps) == null ? void 0 : D.baseInputLabel, {
        id: b,
        htmlFor: m,
        shrink: !0,
        variant: u,
        children: E
      })), /* @__PURE__ */ C(v.slots.baseSelect, I({
        id: m,
        label: E,
        labelId: b,
        value: p,
        onChange: T,
        variant: u,
        type: o || "text",
        inputProps: {
          tabIndex: l,
          ref: i,
          placeholder: a ?? s.current.getLocaleText("filterPanelInputPlaceholder")
        },
        native: g,
        notched: u === "outlined" ? !0 : void 0
      }, f, (R = v.slotProps) == null ? void 0 : R.baseSelect, {
        children: pY({
          column: y,
          OptionComponent: v.slots.baseSelectOption,
          getOptionLabel: x,
          getOptionValue: w,
          isSelectNative: g,
          baseSelectOptionProps: (P = v.slotProps) == null ? void 0 : P.baseSelectOption
        })
      }))]
    }), d]
  });
}
process.env.NODE_ENV !== "production" && (Bf.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: r.shape({
    current: r.object.isRequired
  }).isRequired,
  applyValue: r.func.isRequired,
  clearButton: r.node,
  focusElementRef: r.oneOfType([r.func, r.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: r.bool,
  item: r.shape({
    field: r.string.isRequired,
    id: r.oneOfType([r.number, r.string]),
    operator: r.string.isRequired,
    value: r.any
  }).isRequired
});
const gY = ["item", "applyValue", "type", "apiRef", "focusElementRef", "color", "error", "helperText", "size", "variant"], mY = ["key"], bY = _P();
function mD(e) {
  const {
    item: t,
    applyValue: n,
    apiRef: o,
    focusElementRef: s,
    color: i,
    error: a,
    helperText: l,
    size: c,
    variant: u = "standard"
  } = e, d = ve(e, gY), f = {
    color: i,
    error: a,
    helperText: l,
    size: c,
    variant: u
  }, p = gt(), m = Xe();
  let b = null;
  if (t.field) {
    const T = o.current.getColumn(t.field);
    ll(T) && (b = T);
  }
  const v = b == null ? void 0 : b.getOptionValue, g = b == null ? void 0 : b.getOptionLabel, y = h.useCallback((T, E) => v(T) === v(E), [v]), w = h.useMemo(() => Vi(b) || [], [b]), x = h.useMemo(() => Array.isArray(t.value) ? t.value.reduce((T, E) => {
    const O = w.find((M) => v(M) === E);
    return O != null && T.push(O), T;
  }, []) : [], [v, t.value, w]), S = h.useCallback((T, E) => {
    n(I({}, t, {
      value: E.map(v)
    }));
  }, [n, t, v]);
  return /* @__PURE__ */ C(Np, I({
    multiple: !0,
    options: w,
    isOptionEqualToValue: y,
    filterOptions: bY,
    id: p,
    value: x,
    onChange: S,
    getOptionLabel: g,
    renderTags: (T, E) => T.map((O, M) => {
      const D = E({
        index: M
      }), {
        key: R
      } = D, P = ve(D, mY);
      return /* @__PURE__ */ C(m.slots.baseChip, I({
        variant: "outlined",
        size: "small",
        label: g(O)
      }, P), R);
    }),
    renderInput: (T) => {
      var E;
      return /* @__PURE__ */ C(m.slots.baseTextField, I({}, T, {
        label: o.current.getLocaleText("filterPanelInputLabel"),
        placeholder: o.current.getLocaleText("filterPanelInputPlaceholder"),
        InputLabelProps: I({}, T.InputLabelProps, {
          shrink: !0
        }),
        inputRef: s,
        type: "singleSelect"
      }, f, (E = m.slotProps) == null ? void 0 : E.baseTextField));
    }
  }, d));
}
process.env.NODE_ENV !== "production" && (mD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: r.shape({
    current: r.object.isRequired
  }).isRequired,
  applyValue: r.func.isRequired,
  focusElementRef: r.oneOfType([r.func, r.object]),
  item: r.shape({
    field: r.string.isRequired,
    id: r.oneOfType([r.number, r.string]),
    operator: r.string.isRequired,
    value: r.any
  }).isRequired,
  type: r.oneOf(["singleSelect"])
});
const pa = (e) => e == null || !qC(e) ? e : e.value, yY = () => [{
  value: "is",
  getApplyFilterFn: (e) => e.value == null || e.value === "" ? null : (t) => pa(t) === pa(e.value),
  InputComponent: Bf
}, {
  value: "not",
  getApplyFilterFn: (e) => e.value == null || e.value === "" ? null : (t) => pa(t) !== pa(e.value),
  InputComponent: Bf
}, {
  value: "isAnyOf",
  getApplyFilterFn: (e) => {
    if (!Array.isArray(e.value) || e.value.length === 0)
      return null;
    const t = e.value.map(pa);
    return (n) => t.includes(pa(n));
  },
  InputComponent: mD
}], vY = (e) => typeof e[0] == "object", CY = (e) => qC(e) ? e.value : e, wY = (e) => qC(e) ? e.label : String(e), SY = I({}, ko, {
  type: "singleSelect",
  getOptionLabel: wY,
  getOptionValue: CY,
  valueFormatter(e, t, n, o) {
    const s = o.current.getRowId(t);
    if (!ll(n))
      return "";
    const i = Vi(n, {
      id: s,
      row: t
    });
    if (e == null)
      return "";
    if (!i)
      return e;
    if (!vY(i))
      return n.getOptionLabel(e);
    const a = i.find((l) => n.getOptionValue(l) === e);
    return a ? n.getOptionLabel(a) : "";
  },
  renderEditCell: dY,
  filterOperators: yY(),
  // @ts-ignore
  pastedValueParser: (e, t, n) => {
    const o = n, s = Vi(o) || [], i = o.getOptionValue;
    if (s.find((l) => i(l) === e))
      return e;
  }
}), xY = "string", TY = () => ({
  string: ko,
  number: aY,
  date: oY,
  dateTime: rY,
  boolean: Uk,
  singleSelect: SY,
  [Gp]: eK,
  custom: ko
}), n0 = (e) => e.headerFiltering, RY = Je(
  n0,
  // No initialization in MIT, so we need to default to false to be used by `getTotalHeaderHeight`
  (e) => (e == null ? void 0 : e.enabled) ?? !1
), bD = Je(n0, (e) => e.editing), o0 = Je(n0, (e) => e.menuOpen), Yp = (e) => e.columnGrouping, yD = Mt(Yp, (e) => (e == null ? void 0 : e.unwrappedGroupingModel) ?? {}), vD = Mt(Yp, (e) => (e == null ? void 0 : e.lookup) ?? {}), EY = Mt(Yp, (e) => (e == null ? void 0 : e.headerStructure) ?? []), Fu = Je(Yp, (e) => (e == null ? void 0 : e.maxDepth) ?? 0), CD = ["maxWidth", "minWidth", "width", "flex"], Cg = TY();
function IY({
  initialFreeSpace: e,
  totalFlexUnits: t,
  flexColumns: n
}) {
  const o = new Set(n.map((a) => a.field)), s = {
    all: {},
    frozenFields: [],
    freeze: (a) => {
      const l = s.all[a];
      l && l.frozen !== !0 && (s.all[a].frozen = !0, s.frozenFields.push(a));
    }
  };
  function i() {
    if (s.frozenFields.length === o.size)
      return;
    const a = {
      min: {},
      max: {}
    };
    let l = e, c = t, u = 0;
    s.frozenFields.forEach((d) => {
      l -= s.all[d].computedWidth, c -= s.all[d].flex;
    });
    for (let d = 0; d < n.length; d += 1) {
      const f = n[d];
      if (s.all[f.field] && s.all[f.field].frozen === !0)
        continue;
      let m = l / c * f.flex;
      m < f.minWidth ? (u += f.minWidth - m, m = f.minWidth, a.min[f.field] = !0) : m > f.maxWidth && (u += f.maxWidth - m, m = f.maxWidth, a.max[f.field] = !0), s.all[f.field] = {
        frozen: !1,
        computedWidth: m,
        flex: f.flex
      };
    }
    u < 0 ? Object.keys(a.max).forEach((d) => {
      s.freeze(d);
    }) : u > 0 ? Object.keys(a.min).forEach((d) => {
      s.freeze(d);
    }) : n.forEach(({
      field: d
    }) => {
      s.freeze(d);
    }), i();
  }
  return i(), s.all;
}
const Py = (e, t) => {
  const n = {};
  let o = 0, s = 0;
  const i = [];
  e.orderedFields.forEach((c) => {
    let u = e.lookup[c], d = 0, f = !1;
    e.columnVisibilityModel[c] !== !1 && (u.flex && u.flex > 0 ? (o += u.flex, f = !0) : d = Uo(u.width || ko.width, u.minWidth || ko.minWidth, u.maxWidth || ko.maxWidth), s += d), u.computedWidth !== d && (u = I({}, u, {
      computedWidth: d
    })), f && i.push(u), n[c] = u;
  });
  const a = t === void 0 ? 0 : t.viewportOuterSize.width - (t.hasScrollY ? t.scrollbarSize : 0), l = Math.max(a - s, 0);
  if (o > 0 && a > 0) {
    const c = IY({
      initialFreeSpace: l,
      totalFlexUnits: o,
      flexColumns: i
    });
    Object.keys(c).forEach((u) => {
      n[u].computedWidth = c[u].computedWidth;
    });
  }
  return I({}, e, {
    lookup: n
  });
}, OY = (e, t) => {
  if (!t)
    return e;
  const {
    orderedFields: n = [],
    dimensions: o = {}
  } = t, s = Object.keys(o);
  if (s.length === 0 && n.length === 0)
    return e;
  const i = {}, a = [];
  for (let d = 0; d < n.length; d += 1) {
    const f = n[d];
    e.lookup[f] && (i[f] = !0, a.push(f));
  }
  const l = a.length === 0 ? e.orderedFields : [...a, ...e.orderedFields.filter((d) => !i[d])], c = I({}, e.lookup);
  for (let d = 0; d < s.length; d += 1) {
    const f = s[d], p = I({}, c[f], {
      hasBeenResized: !0
    });
    Object.entries(o[f]).forEach(([m, b]) => {
      p[m] = b === -1 ? 1 / 0 : b;
    }), c[f] = p;
  }
  return I({}, e, {
    orderedFields: l,
    lookup: c
  });
};
function mT(e) {
  let t = Cg[xY];
  return e && Cg[e] && (t = Cg[e]), t;
}
const Ra = ({
  apiRef: e,
  columnsToUpsert: t,
  initialState: n,
  columnVisibilityModel: o = jo(e),
  keepOnlyColumnsToUpsert: s = !1
}) => {
  var d, f;
  const i = !e.current.state.columns;
  let a;
  if (i)
    a = {
      orderedFields: [],
      lookup: {},
      columnVisibilityModel: o
    };
  else {
    const p = Qr(e.current.state);
    a = {
      orderedFields: s ? [] : [...p.orderedFields],
      lookup: I({}, p.lookup),
      // Will be cleaned later if keepOnlyColumnsToUpsert=true
      columnVisibilityModel: o
    };
  }
  let l = {};
  s && !i && (l = Object.keys(a.lookup).reduce((p, m) => I({}, p, {
    [m]: !1
  }), {})), t.forEach((p) => {
    const {
      field: m
    } = p;
    l[m] = !0;
    let b = a.lookup[m];
    b == null ? (b = I({}, mT(p.type), {
      field: m,
      hasBeenResized: !1
    }), a.orderedFields.push(m)) : s && a.orderedFields.push(m), b && b.type !== p.type && (b = I({}, mT(p.type), {
      field: m
    }));
    let v = b.hasBeenResized;
    CD.forEach((g) => {
      p[g] !== void 0 && (v = !0, p[g] === -1 && (p[g] = 1 / 0));
    }), a.lookup[m] = Fi(b, I({}, p, {
      hasBeenResized: v
    }));
  }), s && !i && Object.keys(a.lookup).forEach((p) => {
    l[p] || delete a.lookup[p];
  });
  const c = e.current.unstable_applyPipeProcessors("hydrateColumns", a), u = OY(c, n);
  return Py(u, ((f = (d = e.current).getRootDimensions) == null ? void 0 : f.call(d)) ?? void 0);
};
function PY({
  firstColumnToRender: e,
  apiRef: t,
  firstRowToRender: n,
  lastRowToRender: o,
  visibleRows: s
}) {
  let i = e;
  for (let a = n; a < o; a += 1)
    if (s[a]) {
      const c = s[a].id, u = t.current.unstable_getCellColSpanInfo(c, e);
      u && u.spannedByColSpan && (i = u.leftVisibleCellIndex);
    }
  return i;
}
function r0(e, t) {
  if (t.unstable_listView)
    return 0;
  const n = Tl(e), o = Fu(e), s = RY(e), i = Math.floor(t.columnHeaderHeight * n), a = Math.floor((t.columnGroupHeaderHeight ?? t.columnHeaderHeight) * n), l = s ? Math.floor((t.headerFilterHeight ?? t.columnHeaderHeight) * n) : 0;
  return i + a * o + l;
}
const bT = 1, MY = 1.5, kY = (e) => {
  const {
    scrollDirection: t,
    classes: n
  } = e, o = {
    root: ["scrollArea", `scrollArea--${t}`]
  };
  return fe(o, rt, n);
}, DY = tn("div", {
  name: "MuiDataGrid",
  slot: "ScrollArea",
  overridesResolver: (e, t) => [{
    [`&.${K["scrollArea--left"]}`]: t["scrollArea--left"]
  }, {
    [`&.${K["scrollArea--right"]}`]: t["scrollArea--right"]
  }, t.scrollArea]
})(() => ({
  position: "absolute",
  top: 0,
  zIndex: 101,
  width: 20,
  bottom: 0,
  [`&.${K["scrollArea--left"]}`]: {
    left: 0
  },
  [`&.${K["scrollArea--right"]}`]: {
    right: 0
  }
})), NY = ni(Kn, (e, t) => t === "left" ? e.leftPinnedWidth : t === "right" ? e.rightPinnedWidth + (e.hasScrollX ? e.scrollbarSize : 0) : 0);
function $Y(e) {
  const t = lt(), [n, o] = h.useState(!1);
  return Le(t, "columnHeaderDragStart", () => o(!0)), Le(t, "columnHeaderDragEnd", () => o(!1)), n ? /* @__PURE__ */ C(AY, I({}, e)) : null;
}
function AY(e) {
  const {
    scrollDirection: t,
    scrollPosition: n
  } = e, o = h.useRef(null), s = lt(), i = go(), a = ge(s, Tl), l = ge(s, xl), c = Ys(s, NY, t), u = () => {
    const S = Kn(s.current.state);
    if (t === "left")
      return n.current.left > 0;
    if (t === "right") {
      const T = l - S.viewportInnerSize.width;
      return n.current.left < T;
    }
    return !1;
  }, [d, f] = h.useState(u), p = Xe(), m = I({}, p, {
    scrollDirection: t
  }), b = kY(m), v = r0(s, p), g = Math.floor(p.columnHeaderHeight * a), y = {
    height: g,
    top: v - g
  };
  t === "left" ? y.left = c : t === "right" && (y.right = c);
  const w = () => {
    f(u);
  }, x = xe((S) => {
    let T;
    if (S.preventDefault(), t === "left")
      T = S.clientX - o.current.getBoundingClientRect().right;
    else if (t === "right")
      T = Math.max(1, S.clientX - o.current.getBoundingClientRect().left);
    else
      throw new Error("MUI X: Wrong drag direction");
    T = (T - bT) * MY + bT, i.start(0, () => {
      s.current.scroll({
        left: n.current.left + T,
        top: n.current.top
      });
    });
  });
  return Le(s, "scrollPositionChange", w), d ? /* @__PURE__ */ C(DY, {
    ref: o,
    className: ae(b.root),
    ownerState: m,
    onDragOver: x,
    style: y
  }) : null;
}
const yT = Dr($Y);
var Ul = {}, wg = { exports: {} }, Sg = { exports: {} }, vT;
function FY() {
  return vT || (vT = 1, function(e) {
    function t(n) {
      "@babel/helpers - typeof";
      return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
        return typeof o;
      } : function(o) {
        return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Sg)), Sg.exports;
}
var CT;
function LY() {
  return CT || (CT = 1, function(e) {
    var t = FY().default;
    function n(s) {
      if (typeof WeakMap != "function") return null;
      var i = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakMap();
      return (n = function(c) {
        return c ? a : i;
      })(s);
    }
    function o(s, i) {
      if (!i && s && s.__esModule) return s;
      if (s === null || t(s) != "object" && typeof s != "function") return {
        default: s
      };
      var a = n(i);
      if (a && a.has(s)) return a.get(s);
      var l = {
        __proto__: null
      }, c = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var u in s) if (u !== "default" && {}.hasOwnProperty.call(s, u)) {
        var d = c ? Object.getOwnPropertyDescriptor(s, u) : null;
        d && (d.get || d.set) ? Object.defineProperty(l, u, d) : l[u] = s[u];
      }
      return l.default = s, a && a.set(s, l), l;
    }
    e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(wg)), wg.exports;
}
var wT;
function _Y() {
  if (wT) return Ul;
  wT = 1;
  var e = LY().default;
  Object.defineProperty(Ul, "__esModule", {
    value: !0
  }), Ul.default = void 0;
  var t = e(en);
  return Ul.default = parseInt(t.version, 10), Ul;
}
var VY = /* @__PURE__ */ _Y();
const BY = /* @__PURE__ */ Zo(VY), s0 = /* @__PURE__ */ h.createContext(void 0);
process.env.NODE_ENV !== "production" && (s0.displayName = "GridPrivateApiContext");
function eo() {
  const e = h.useContext(s0);
  if (e === void 0)
    throw new Error(["MUI X: Could not find the Data Grid private context.", "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.", "This can also happen if you are bundling multiple versions of the Data Grid."].join(`
`));
  return e;
}
const bs = (e, t) => Au(e), Xp = (e, t) => ge(e, Au), zY = typeof navigator < "u" ? navigator.userAgent.toLowerCase() : "empty", HY = zY.includes("firefox"), Lu = (e) => e.rowsMeta, Qp = (e) => e.virtualization;
Je(Qp, (e) => e.enabled);
const wD = Je(Qp, (e) => e.enabledForColumns), jY = Je(Qp, (e) => e.enabledForRows), Bi = Je(Qp, (e) => e.renderContext), GY = Mt((e) => e.virtualization.renderContext.firstColumnIndex, (e) => e.virtualization.renderContext.lastColumnIndex, (e, t) => ({
  firstColumnIndex: e,
  lastColumnIndex: t
})), My = {
  firstRowIndex: 0,
  lastRowIndex: 0,
  firstColumnIndex: 0,
  lastColumnIndex: 0
}, qY = (e, t) => {
  const {
    disableVirtualization: n,
    autoHeight: o
  } = t;
  return I({}, e, {
    virtualization: {
      enabled: !n,
      enabledForColumns: !n,
      enabledForRows: !n && !o,
      renderContext: My
    }
  });
};
function WY(e, t) {
  const n = (i) => {
    e.current.setState((a) => I({}, a, {
      virtualization: I({}, a.virtualization, {
        enabled: i,
        enabledForColumns: i,
        enabledForRows: i && !t.autoHeight
      })
    }));
  };
  ot(e, {
    unstable_setVirtualization: n,
    unstable_setColumnVirtualization: (i) => {
      e.current.setState((a) => I({}, a, {
        virtualization: I({}, a.virtualization, {
          enabledForColumns: i
        })
      }));
    }
  }, "public"), h.useEffect(() => {
    n(!t.disableVirtualization);
  }, [t.disableVirtualization, t.autoHeight]);
}
const i0 = (e) => e.rowSpanning, SD = Je(i0, (e) => e.hiddenCells), UY = Je(i0, (e) => e.spannedCells), KY = Je(i0, (e) => e.hiddenCellOriginMap), cl = (e) => e.listViewColumn, YY = bk(fo, Bi, Au, pn, fr, (e, t, n, o, s) => {
  if (!e)
    return !1;
  const i = s[e.id];
  if (!i)
    return !1;
  const a = n.rowToIndexMap.get(i), l = o.slice(t.firstColumnIndex, t.lastColumnIndex).findIndex((u) => u.field === e.field);
  return !(a !== void 0 && l !== -1 && a >= t.firstRowIndex && a <= t.lastRowIndex);
}), XY = Mt(YY, pn, Au, fr, fo, (e, t, n, o, s) => {
  if (!e)
    return null;
  const i = o[s.id];
  if (!i)
    return null;
  const a = n.rowToIndexMap.get(i);
  if (a === void 0)
    return null;
  const l = t.findIndex((c) => c.field === s.field);
  return l === -1 ? null : I({}, s, {
    rowIndex: a,
    columnIndex: l
  });
});
function $a(e, t) {
  return Math.round(e * 10 ** t) / 10 ** t;
}
const zf = typeof window < "u" && /jsdom|HappyDOM/.test(window.navigator.userAgent), xg = 50;
var Dn = /* @__PURE__ */ function(e) {
  return e[e.NONE = 0] = "NONE", e[e.UP = 1] = "UP", e[e.DOWN = 2] = "DOWN", e[e.LEFT = 3] = "LEFT", e[e.RIGHT = 4] = "RIGHT", e;
}(Dn || {});
const ST = {
  top: 0,
  left: 0
}, xD = Object.freeze(/* @__PURE__ */ new Map()), QY = (e, t, n, o, s) => ({
  direction: Dn.NONE,
  buffer: RD(e, Dn.NONE, t, n, o, s)
}), ZY = () => {
  var H;
  const e = eo(), t = Xe(), {
    unstable_listView: n
  } = t, o = ge(e, () => n ? [cl(e.current.state)] : pn(e)), s = ge(e, jY) && !zf, i = ge(e, wD) && !zf, a = ge(e, oa), l = ws(e), c = n ? Lf : l, u = a.bottom.length > 0, [d, f] = h.useState(xD), p = _t(), m = ge(e, ms), b = Xp(e), v = e.current.mainElementRef, g = e.current.virtualScrollerRef, y = e.current.virtualScrollbarVerticalRef, w = e.current.virtualScrollbarHorizontalRef, x = ge(e, VU), S = h.useRef(!1), T = ge(e, _C), E = ge(e, nU), O = ge(e, xl), M = ge(e, JY), D = ge(e, BC), R = ge(e, VC), P = h.useRef(null), F = h.useCallback((U) => {
    if (v.current = U, !U)
      return;
    const X = U.getBoundingClientRect();
    let re = {
      width: $a(X.width, 1),
      height: $a(X.height, 1)
    };
    if ((!P.current || re.width !== P.current.width && re.height !== P.current.height) && (P.current = re, e.current.publishEvent("resize", re)), typeof ResizeObserver > "u")
      return;
    const oe = new ResizeObserver((le) => {
      const se = le[0];
      if (!se)
        return;
      const Ce = {
        width: $a(se.contentRect.width, 1),
        height: $a(se.contentRect.height, 1)
      };
      Ce.width === re.width && Ce.height === re.height || (e.current.publishEvent("resize", Ce), re = Ce);
    });
    if (oe.observe(U), BY >= 19)
      return () => {
        v.current = null, oe.disconnect();
      };
  }, [e, v]), $ = h.useRef(((H = t.initialState) == null ? void 0 : H.scroll) ?? ST), N = h.useRef(!1), A = h.useRef(ST), k = h.useRef(My), L = ge(e, Bi), B = ge(e, XY), V = go(), _ = h.useRef(void 0), z = Jo(() => QY(p, t.rowBufferPx, t.columnBufferPx, T * 15, xg * 6)).current, j = h.useCallback((U) => {
    if (nX(U, e.current.state.virtualization.renderContext))
      return;
    const X = U.firstRowIndex !== k.current.firstRowIndex || U.lastRowIndex !== k.current.lastRowIndex;
    e.current.setState((oe) => I({}, oe, {
      virtualization: I({}, oe.virtualization, {
        renderContext: U
      })
    })), Kn(e.current.state).isReady && X && (k.current = U, e.current.publishEvent("renderedRowsIntervalChange", U)), A.current = $.current;
  }, [e]), W = xe(() => {
    const U = g.current;
    if (!U)
      return;
    const X = Kn(e.current.state), re = Math.ceil(X.minimumSize.height - X.viewportOuterSize.height), oe = Math.ceil(X.minimumSize.width - X.viewportInnerSize.width), le = {
      top: Uo(U.scrollTop, 0, re),
      left: p ? Uo(U.scrollLeft, -oe, 0) : Uo(U.scrollLeft, 0, oe)
    }, se = le.left - $.current.left, Ce = le.top - $.current.top, $e = se !== 0 || Ce !== 0;
    $.current = le;
    const we = $e ? oX(se, Ce) : Dn.NONE, Te = Math.abs($.current.top - A.current.top), ue = Math.abs($.current.left - A.current.left), de = Te >= T || ue >= xg, Pe = z.direction !== we;
    if (!(de || Pe))
      return L;
    if (Pe)
      switch (we) {
        case Dn.NONE:
        case Dn.LEFT:
        case Dn.RIGHT:
          _.current = void 0;
          break;
        default:
          _.current = L;
          break;
      }
    z.direction = we, z.buffer = RD(p, we, t.rowBufferPx, t.columnBufferPx, T * 15, xg * 6);
    const Me = xT(e, t, s, i), be = TT(Me, $.current, z);
    return IO.flushSync(() => {
      j(be);
    }), V.start(1e3, W), be;
  }), J = () => {
    if (!Kn(e.current.state).isReady && (s || i))
      return;
    const U = xT(e, t, s, i), X = TT(U, $.current, z);
    _.current = void 0, j(X);
  }, G = xe(() => {
    if (N.current) {
      N.current = !1;
      return;
    }
    const U = W();
    e.current.publishEvent("scrollPositionChange", {
      top: $.current.top,
      left: $.current.left,
      renderContext: U
    });
  }), q = xe((U) => {
    e.current.publishEvent("virtualScrollerWheel", {}, U);
  }), Z = xe((U) => {
    e.current.publishEvent("virtualScrollerTouchMove", {}, U);
  }), Y = (U = {}) => {
    var ke;
    if (!U.rows && !b.range)
      return [];
    let X = L;
    U.renderContext && (X = U.renderContext, X.firstColumnIndex = L.firstColumnIndex, X.lastColumnIndex = L.lastColumnIndex);
    const re = !u && U.position === void 0 || u && U.position === "bottom", oe = U.position !== void 0;
    let le;
    switch (U.position) {
      case "top":
        le = 0;
        break;
      case "bottom":
        le = a.top.length + b.rows.length;
        break;
      case void 0:
        le = a.top.length;
        break;
    }
    const se = U.rows ?? b.rows, Ce = X.firstRowIndex, $e = Math.min(X.lastRowIndex, se.length), we = U.rows ? nT(0, U.rows.length) : nT(Ce, $e);
    let Te = -1;
    !oe && B && (B.rowIndex < Ce && (we.unshift(B.rowIndex), Te = B.rowIndex), B.rowIndex > $e && (we.push(B.rowIndex), Te = B.rowIndex));
    const ue = [], de = (ke = t.slotProps) == null ? void 0 : ke.row, Pe = Os(e);
    return we.forEach((Me) => {
      var ft, nn, St;
      const {
        id: be,
        model: me
      } = se[Me], Ae = (((ft = b == null ? void 0 : b.range) == null ? void 0 : ft.firstRowIndex) || 0) + le + Me;
      if (x) {
        const Ke = c.left.length, Ot = o.length - c.right.length;
        e.current.calculateColSpan({
          rowId: be,
          minFirstColumn: Ke,
          maxLastColumn: Ot,
          columns: o
        }), c.left.length > 0 && e.current.calculateColSpan({
          rowId: be,
          minFirstColumn: 0,
          maxLastColumn: c.left.length,
          columns: o
        }), c.right.length > 0 && e.current.calculateColSpan({
          rowId: be,
          minFirstColumn: o.length - c.right.length,
          maxLastColumn: o.length,
          columns: o
        });
      }
      const ye = e.current.rowHasAutoHeight(be) ? "auto" : e.current.unstable_getRowHeight(be);
      let We;
      m[be] == null ? We = !1 : We = e.current.isRowSelectable(be);
      let He = !1;
      U.position === void 0 && (He = Me === 0);
      let ze = !1;
      const pe = Me === se.length - 1;
      if (re)
        if (oe)
          ze = pe;
        else {
          const Ke = b.rows.length - 1;
          Me === Ke && (ze = !0);
        }
      let Re = X;
      _.current && Me >= _.current.firstRowIndex && Me < _.current.lastRowIndex && (Re = _.current);
      const Ge = Me === Te, Qe = (B == null ? void 0 : B.rowIndex) === Ae, qe = TD(Pe, Re, c.left.length), st = pe && U.position === "top", wt = Re.firstColumnIndex, Ue = Re.lastColumnIndex;
      if (ue.push(/* @__PURE__ */ C(t.slots.row, I({
        row: me,
        rowId: be,
        index: Ae,
        selected: We,
        offsetLeft: qe,
        columnsTotalWidth: O,
        rowHeight: ye,
        pinnedColumns: c,
        visibleColumns: o,
        firstColumnIndex: wt,
        lastColumnIndex: Ue,
        focusedColumnIndex: Qe ? B.columnIndex : void 0,
        isFirstVisible: He,
        isLastVisible: ze,
        isNotVisible: Ge,
        showBottomBorder: st,
        scrollbarWidth: D,
        gridHasFiller: R
      }, de), be)), Ge)
        return;
      const nt = d.get(be);
      nt && ue.push(nt), U.position === void 0 && pe && ue.push((St = (nn = e.current).getInfiniteLoadingTriggerElement) == null ? void 0 : St.call(nn, {
        lastRowId: be
      }));
    }), ue;
  }, Q = h.useMemo(() => ({
    overflowX: !M || n ? "hidden" : void 0,
    overflowY: t.autoHeight ? "hidden" : void 0
  }), [M, t.autoHeight, n]), ee = h.useMemo(() => {
    const U = {
      width: M ? O : "auto",
      flexBasis: E,
      flexShrink: 0
    };
    return U.flexBasis === 0 && (U.flexBasis = Hk), U;
  }, [O, E, M]), ne = h.useCallback((U) => {
    U && e.current.publishEvent("virtualScrollerContentSizeChange", {
      columnsTotalWidth: O,
      contentHeight: E
    });
  }, [e, O, E]);
  return yt(() => {
    var U, X;
    S.current && ((X = (U = e.current).updateRenderContext) == null || X.call(U));
  }, [e, i, s]), yt(() => {
    n && (g.current.scrollLeft = 0);
  }, [n, g]), HK(L !== My, () => {
    var U;
    if (e.current.publishEvent("scrollPositionChange", {
      top: $.current.top,
      left: $.current.left,
      renderContext: L
    }), S.current = !0, (U = t.initialState) != null && U.scroll && g.current) {
      const X = g.current, {
        top: re,
        left: oe
      } = t.initialState.scroll, le = {
        top: !(re > 0),
        left: !(oe > 0)
      };
      if (!le.left && O && (X.scrollLeft = oe, N.current = !0, le.left = !0), !le.top && E && (X.scrollTop = re, N.current = !0, le.top = !0), !le.top || !le.left) {
        const se = e.current.subscribeEvent("virtualScrollerContentSizeChange", (Ce) => {
          !le.left && Ce.columnsTotalWidth && (X.scrollLeft = oe, N.current = !0, le.left = !0), !le.top && Ce.contentHeight && (X.scrollTop = re, N.current = !0, le.top = !0), le.left && le.top && se();
        });
        return se;
      }
    }
  }), e.current.register("private", {
    updateRenderContext: J
  }), Pt(e, "sortedRowsSet", J), Pt(e, "paginationModelChange", J), Pt(e, "columnsChange", J), {
    renderContext: L,
    setPanels: f,
    getRows: Y,
    getContainerProps: () => ({
      ref: F
    }),
    getScrollerProps: () => ({
      ref: g,
      onScroll: G,
      onWheel: q,
      onTouchMove: Z,
      style: Q,
      role: "presentation",
      // `tabIndex` shouldn't be used along role=presentation, but it fixes a Firefox bug
      // https://github.com/mui/mui-x/pull/13891#discussion_r1683416024
      tabIndex: HY ? -1 : void 0
    }),
    getContentProps: () => ({
      style: ee,
      role: "presentation",
      ref: ne
    }),
    getRenderZoneProps: () => ({
      role: "rowgroup"
    }),
    getScrollbarVerticalProps: () => ({
      ref: y,
      role: "presentation",
      scrollPosition: $
    }),
    getScrollbarHorizontalProps: () => ({
      ref: w,
      role: "presentation",
      scrollPosition: $
    }),
    getScrollAreaProps: () => ({
      scrollPosition: $
    })
  };
};
function JY(e) {
  return e.dimensions.viewportOuterSize.width > 0 && e.dimensions.columnsTotalWidth > e.dimensions.viewportOuterSize.width;
}
function xT(e, t, n, o) {
  const s = Kn(e.current.state), i = bs(e), a = t.unstable_listView ? [cl(e.current.state)] : pn(e), l = KY(e), c = e.current.state.rows.dataRowIds.at(-1), u = a.at(-1);
  return {
    enabledForRows: n,
    enabledForColumns: o,
    apiRef: e,
    autoHeight: t.autoHeight,
    rowBufferPx: t.rowBufferPx,
    columnBufferPx: t.columnBufferPx,
    leftPinnedWidth: s.leftPinnedWidth,
    columnsTotalWidth: s.columnsTotalWidth,
    viewportInnerWidth: s.viewportInnerSize.width,
    viewportInnerHeight: s.viewportInnerSize.height,
    lastRowHeight: c !== void 0 ? e.current.unstable_getRowHeight(c) : 0,
    lastColumnWidth: (u == null ? void 0 : u.computedWidth) ?? 0,
    rowsMeta: Lu(e.current.state),
    columnPositions: Os(e),
    rows: i.rows,
    range: i.range,
    pinnedColumns: ws(e),
    visibleColumns: a,
    hiddenCellsOriginMap: l,
    listView: t.unstable_listView ?? !1,
    virtualizeColumnsWithAutoRowHeight: t.virtualizeColumnsWithAutoRowHeight
  };
}
function TT(e, t, n) {
  const o = {
    firstRowIndex: 0,
    lastRowIndex: e.rows.length,
    firstColumnIndex: 0,
    lastColumnIndex: e.visibleColumns.length
  };
  if (e.listView)
    return I({}, o, {
      lastColumnIndex: 1
    });
  const {
    top: s,
    left: i
  } = t, a = Math.abs(i) + e.leftPinnedWidth;
  if (e.enabledForRows) {
    let c = Math.min(RT(e, s, {
      atStart: !0,
      lastPosition: e.rowsMeta.positions[e.rowsMeta.positions.length - 1] + e.lastRowHeight
    }), e.rowsMeta.positions.length - 1);
    const u = e.hiddenCellsOriginMap[c];
    if (u) {
      const f = Math.min(...Object.values(u));
      c = Math.min(c, f);
    }
    const d = e.autoHeight ? c + e.rows.length : RT(e, s + e.viewportInnerHeight);
    o.firstRowIndex = c, o.lastRowIndex = d;
  }
  if (e.enabledForColumns) {
    let c = 0, u = e.columnPositions.length, d = !1;
    const [f, p] = ky({
      firstIndex: o.firstRowIndex,
      lastIndex: o.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: e.rows.length,
      bufferBefore: n.buffer.rowBefore,
      bufferAfter: n.buffer.rowAfter,
      positions: e.rowsMeta.positions,
      lastSize: e.lastRowHeight
    });
    if (!e.virtualizeColumnsWithAutoRowHeight)
      for (let m = f; m < p && !d; m += 1) {
        const b = e.rows[m];
        d = e.apiRef.current.rowHasAutoHeight(b.id);
      }
    (!d || e.virtualizeColumnsWithAutoRowHeight) && (c = Xs(a, e.columnPositions, {
      atStart: !0,
      lastPosition: e.columnsTotalWidth
    }), u = Xs(a + e.viewportInnerWidth, e.columnPositions)), o.firstColumnIndex = c, o.lastColumnIndex = u;
  }
  return eX(e, o, n);
}
function RT(e, t, n) {
  var a, l;
  const o = e.apiRef.current.getLastMeasuredRowIndex();
  let s = o === 1 / 0;
  (a = e.range) != null && a.lastRowIndex && !s && (s = o >= e.range.lastRowIndex);
  const i = Uo(o - (((l = e.range) == null ? void 0 : l.firstRowIndex) || 0), 0, e.rowsMeta.positions.length);
  return s || e.rowsMeta.positions[i] >= t ? Xs(t, e.rowsMeta.positions, n) : tX(t, e.rowsMeta.positions, i, n);
}
function eX(e, t, n) {
  const [o, s] = ky({
    firstIndex: t.firstRowIndex,
    lastIndex: t.lastRowIndex,
    minFirstIndex: 0,
    maxLastIndex: e.rows.length,
    bufferBefore: n.buffer.rowBefore,
    bufferAfter: n.buffer.rowAfter,
    positions: e.rowsMeta.positions,
    lastSize: e.lastRowHeight
  }), [i, a] = ky({
    firstIndex: t.firstColumnIndex,
    lastIndex: t.lastColumnIndex,
    minFirstIndex: e.pinnedColumns.left.length,
    maxLastIndex: e.visibleColumns.length - e.pinnedColumns.right.length,
    bufferBefore: n.buffer.columnBefore,
    bufferAfter: n.buffer.columnAfter,
    positions: e.columnPositions,
    lastSize: e.lastColumnWidth
  }), l = PY({
    firstColumnToRender: i,
    apiRef: e.apiRef,
    firstRowToRender: o,
    lastRowToRender: s,
    visibleRows: e.rows
  });
  return {
    firstRowIndex: o,
    lastRowIndex: s,
    firstColumnIndex: l,
    lastColumnIndex: a
  };
}
function Xs(e, t, n = void 0, o = 0, s = t.length) {
  if (t.length <= 0)
    return -1;
  if (o >= s)
    return o;
  const i = o + Math.floor((s - o) / 2), a = t[i];
  let l;
  if (n != null && n.atStart) {
    const c = (i === t.length - 1 ? n.lastPosition : t[i + 1]) - a;
    l = e - c < a;
  } else
    l = e <= a;
  return l ? Xs(e, t, n, o, i) : Xs(e, t, n, i + 1, s);
}
function tX(e, t, n, o = void 0) {
  let s = 1;
  for (; n < t.length && Math.abs(t[n]) < e; )
    n += s, s *= 2;
  return Xs(e, t, o, Math.floor(n / 2), Math.min(n, t.length));
}
function ky({
  firstIndex: e,
  lastIndex: t,
  bufferBefore: n,
  bufferAfter: o,
  minFirstIndex: s,
  maxLastIndex: i,
  positions: a,
  lastSize: l
}) {
  const c = a[e] - n, u = a[t] + o, d = Xs(c, a, {
    atStart: !0,
    lastPosition: a[a.length - 1] + l
  }), f = Xs(u, a);
  return [Uo(d, s, i), Uo(f, s, i)];
}
function nX(e, t) {
  return e === t ? !0 : e.firstRowIndex === t.firstRowIndex && e.lastRowIndex === t.lastRowIndex && e.firstColumnIndex === t.firstColumnIndex && e.lastColumnIndex === t.lastColumnIndex;
}
function TD(e, t, n) {
  const o = (e[t.firstColumnIndex] ?? 0) - (e[n] ?? 0);
  return Math.abs(o);
}
function oX(e, t) {
  return e === 0 && t === 0 ? Dn.NONE : Math.abs(t) >= Math.abs(e) ? t > 0 ? Dn.DOWN : Dn.UP : e > 0 ? Dn.RIGHT : Dn.LEFT;
}
function RD(e, t, n, o, s, i) {
  if (e)
    switch (t) {
      case Dn.LEFT:
        t = Dn.RIGHT;
        break;
      case Dn.RIGHT:
        t = Dn.LEFT;
        break;
    }
  switch (t) {
    case Dn.NONE:
      return {
        rowAfter: n,
        rowBefore: n,
        columnAfter: o,
        columnBefore: o
      };
    case Dn.LEFT:
      return {
        rowAfter: 0,
        rowBefore: 0,
        columnAfter: 0,
        columnBefore: i
      };
    case Dn.RIGHT:
      return {
        rowAfter: 0,
        rowBefore: 0,
        columnAfter: i,
        columnBefore: 0
      };
    case Dn.UP:
      return {
        rowAfter: 0,
        rowBefore: s,
        columnAfter: 0,
        columnBefore: 0
      };
    case Dn.DOWN:
      return {
        rowAfter: s,
        rowBefore: 0,
        columnAfter: 0,
        columnBefore: 0
      };
    default:
      throw new Error("unreachable");
  }
}
const rX = () => {
  var f, p;
  const e = lt(), t = Xe(), n = ge(e, Du), o = ge(e, ZC), s = ge(e, _k), i = n === 0 && s === 0, a = ge(e, Fk), l = !a && i, c = !a && n > 0 && o === 0;
  let u = null, d = null;
  return l && (u = "noRowsOverlay"), c && (u = "noResultsOverlay"), a && (u = "loadingOverlay", d = ((p = (f = t.slotProps) == null ? void 0 : f.loadingOverlay) == null ? void 0 : p[i ? "noRowsVariant" : "variant"]) || null), {
    overlayType: u,
    loadingOverlayVariant: d
  };
}, sX = tn("div", {
  name: "MuiDataGrid",
  slot: "OverlayWrapper",
  shouldForwardProp: (e) => e !== "overlayType" && e !== "loadingOverlayVariant",
  overridesResolver: (e, t) => t.overlayWrapper
})(({
  overlayType: e,
  loadingOverlayVariant: t
}) => (
  // Skeleton overlay should flow with the scroll container and not be sticky
  t !== "skeleton" ? {
    position: "sticky",
    // To stay in place while scrolling
    top: "var(--DataGrid-headersTotalHeight)",
    // TODO: take pinned rows into account
    left: 0,
    width: 0,
    // To stay above the content instead of shifting it down
    height: 0,
    // To stay above the content instead of shifting it down
    zIndex: e === "loadingOverlay" ? 5 : 4
    // Should be above pinned columns and detail panel
  } : {}
)), iX = tn("div", {
  name: "MuiDataGrid",
  slot: "OverlayWrapperInner",
  shouldForwardProp: (e) => e !== "overlayType" && e !== "loadingOverlayVariant",
  overridesResolver: (e, t) => t.overlayWrapperInner
})({}), aX = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["overlayWrapper"],
    inner: ["overlayWrapperInner"]
  }, rt, t);
};
function ED(e) {
  const t = lt(), n = Xe(), o = ge(t, Kn);
  let s = Math.max(o.viewportOuterSize.height - o.topContainerHeight - o.bottomContainerHeight - (o.hasScrollX ? o.scrollbarSize : 0), 0);
  s === 0 && (s = Hk);
  const i = aX(I({}, e, {
    classes: n.classes
  }));
  return /* @__PURE__ */ C(sX, I({
    className: ae(i.root)
  }, e, {
    children: /* @__PURE__ */ C(iX, I({
      className: ae(i.inner),
      style: {
        height: s,
        width: o.viewportOuterSize.width
      }
    }, e))
  }));
}
process.env.NODE_ENV !== "production" && (ED.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  loadingOverlayVariant: r.oneOf(["circular-progress", "linear-progress", "skeleton"]),
  overlayType: r.oneOf(["loadingOverlay", "noResultsOverlay", "noRowsOverlay"])
});
process.env.NODE_ENV !== "production" && (ID.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  loadingOverlayVariant: r.oneOf(["circular-progress", "linear-progress", "skeleton"]),
  overlayType: r.oneOf(["loadingOverlay", "noResultsOverlay", "noRowsOverlay"])
});
function ID(e) {
  var i, a;
  const {
    overlayType: t
  } = e, n = Xe();
  if (!t)
    return null;
  const o = (i = n.slots) == null ? void 0 : i[t], s = (a = n.slotProps) == null ? void 0 : a[t];
  return /* @__PURE__ */ C(ED, I({}, e, {
    children: /* @__PURE__ */ C(o, I({}, s))
  }));
}
const nf = (e) => e.columnMenu;
function lX() {
  var g;
  const e = eo(), t = Xe(), n = ge(e, pn), o = ge(e, IK), s = ge(e, vK), i = ge(e, tD), a = ge(e, () => e0(e) === null), l = ge(e, BK), c = ge(e, LK), u = ge(e, _f), d = ge(e, Fu), f = ge(e, nf), p = ge(e, jo), m = ge(e, EY), b = !(l === null && i === null && a), v = e.current.columnHeadersContainerRef;
  return /* @__PURE__ */ C(t.slots.columnHeaders, I({
    ref: v,
    visibleColumns: n,
    filterColumnLookup: o,
    sortColumnLookup: s,
    columnHeaderTabIndexState: i,
    columnGroupHeaderTabIndexState: l,
    columnHeaderFocus: c,
    columnGroupHeaderFocus: u,
    headerGroupingMaxDepth: d,
    columnMenuState: f,
    columnVisibility: p,
    columnGroupsHeaderStructure: m,
    hasOtherElementInTabSequence: b
  }, (g = t.slotProps) == null ? void 0 : g.columnHeaders));
}
const cX = Dr(lX), a0 = /* @__PURE__ */ h.createContext(void 0);
process.env.NODE_ENV !== "production" && (a0.displayName = "GridConfigurationContext");
const OD = () => {
  const e = h.useContext(a0);
  if (e === void 0)
    throw new Error(["MUI X: Could not find the Data Grid configuration context.", "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.", "This can also happen if you are bundling multiple versions of the Data Grid."].join(`
`));
  return e;
}, uX = tn("div")({
  position: "absolute",
  top: "var(--DataGrid-headersTotalHeight)",
  left: 0,
  width: "calc(100% - (var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize)))"
}), dX = tn("div", {
  name: "MuiDataGrid",
  slot: "Main",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.main, n.hasPinnedRight && t["main--hasPinnedRight"], n.loadingOverlayVariant === "skeleton" && t["main--hasSkeletonLoadingOverlay"]];
  }
})({
  flexGrow: 1,
  position: "relative",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column"
}), fX = Ct((e, t) => {
  var a;
  const {
    ownerState: n
  } = e, o = Xe(), i = OD().hooks.useGridAriaAttributes();
  return /* @__PURE__ */ ie(dX, I({
    ownerState: n,
    className: e.className,
    tabIndex: -1
  }, i, (a = o.slotProps) == null ? void 0 : a.main, {
    ref: t,
    children: [/* @__PURE__ */ C(uX, {
      role: "presentation",
      "data-id": "gridPanelAnchor"
    }), e.children]
  }));
}), pX = () => fe({
  root: ["topContainer"]
}, rt, {}), hX = tn("div")({
  position: "sticky",
  zIndex: 4,
  top: 0
});
function gX(e) {
  const t = pX();
  return /* @__PURE__ */ C(hX, I({}, e, {
    className: ae(t.root, K["container--top"]),
    role: "presentation"
  }));
}
const mX = () => fe({
  root: ["bottomContainer"]
}, rt, {}), bX = tn("div")({
  position: "sticky",
  zIndex: 4,
  bottom: "calc(var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize))"
});
function yX(e) {
  const t = mX();
  return /* @__PURE__ */ C(bX, I({}, e, {
    className: ae(t.root, K["container--bottom"]),
    role: "presentation"
  }));
}
const vX = (e, t) => {
  const {
    classes: n
  } = e;
  return fe({
    root: ["virtualScrollerContent", t && "virtualScrollerContent--overflowed"]
  }, rt, n);
}, CX = tn("div", {
  name: "MuiDataGrid",
  slot: "VirtualScrollerContent",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.virtualScrollerContent, n.overflowedContent && t["virtualScrollerContent--overflowed"]];
  }
})({}), wX = Ct(function(t, n) {
  var l;
  const o = Xe(), s = !o.autoHeight && ((l = t.style) == null ? void 0 : l.minHeight) === "auto", i = vX(o, s), a = {
    classes: o.classes,
    overflowedContent: s
  };
  return /* @__PURE__ */ C(CX, I({}, t, {
    ownerState: a,
    className: ae(i.root, t.className),
    ref: n
  }));
}), SX = tn("div")({
  display: "flex",
  flexDirection: "row",
  width: "var(--DataGrid-rowWidth)",
  boxSizing: "border-box"
}), PD = tn("div")({
  position: "sticky",
  height: "100%",
  boxSizing: "border-box",
  borderTop: "1px solid var(--rowBorderColor)",
  backgroundColor: "var(--DataGrid-pinnedBackground)"
}), xX = tn(PD)({
  left: 0,
  borderRight: "1px solid var(--rowBorderColor)"
}), TX = tn(PD)({
  right: 0,
  borderLeft: "1px solid var(--rowBorderColor)"
}), RX = tn("div")({
  flexGrow: 1,
  borderTop: "1px solid var(--rowBorderColor)"
});
function EX({
  rowsLength: e
}) {
  const t = lt(), {
    viewportOuterSize: n,
    minimumSize: o,
    hasScrollX: s,
    hasScrollY: i,
    scrollbarSize: a,
    leftPinnedWidth: l,
    rightPinnedWidth: c
  } = ge(t, Kn), u = s ? a : 0, d = n.height - o.height > 0;
  return u === 0 && !d ? null : /* @__PURE__ */ ie(SX, {
    className: K.filler,
    role: "presentation",
    style: {
      height: u,
      "--rowBorderColor": e === 0 ? "transparent" : "var(--DataGrid-rowBorderColor)"
    },
    children: [l > 0 && /* @__PURE__ */ C(xX, {
      className: K["filler--pinnedLeft"],
      style: {
        width: l
      }
    }), /* @__PURE__ */ C(RX, {}), c > 0 && /* @__PURE__ */ C(TX, {
      className: K["filler--pinnedRight"],
      style: {
        width: c + (i ? a : 0)
      }
    })]
  });
}
const IX = Dr(EX), OX = ["className"], PX = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["virtualScrollerRenderZone"]
  }, rt, t);
}, MX = tn("div", {
  name: "MuiDataGrid",
  slot: "VirtualScrollerRenderZone",
  overridesResolver: (e, t) => t.virtualScrollerRenderZone
})({
  position: "absolute",
  display: "flex",
  // Prevents margin collapsing when using `getRowSpacing`
  flexDirection: "column"
}), kX = Ct(function(t, n) {
  const {
    className: o
  } = t, s = ve(t, OX), i = lt(), a = Xe(), l = PX(a), c = ge(i, () => {
    const u = Bi(i);
    return Lu(i.current.state).positions[u.firstRowIndex] ?? 0;
  });
  return /* @__PURE__ */ C(MX, I({
    className: ae(l.root, o),
    ownerState: a,
    style: {
      transform: `translate3d(0, ${c}px, 0)`
    }
  }, s, {
    ref: n
  }));
}), DX = {
  includeHeaders: !0,
  includeOutliers: !1,
  outliersFactor: 1.5,
  expand: !1,
  disableColumnVirtualization: !0
}, Pn = (e) => e.editRows, MD = ni(Pn, (e, {
  rowId: t,
  editMode: n
}) => n === ts.Row && !!e[t]), NX = ni(Pn, (e, {
  rowId: t,
  field: n
}) => {
  var o;
  return ((o = e[t]) == null ? void 0 : o[n]) ?? null;
}), Qc = (e) => e.preferencePanel, $X = ni(Qc, (e, t) => !!(e.open && e.labelId === t));
var zi = /* @__PURE__ */ function(e) {
  return e.filters = "filters", e.columns = "columns", e;
}(zi || {});
const AX = (e, t) => {
  const {
    classes: n
  } = e, o = {
    root: ["scrollbar", `scrollbar--${t}`],
    content: ["scrollbarContent"]
  };
  return fe(o, rt, n);
}, kD = tn("div")({
  position: "absolute",
  display: "inline-block",
  zIndex: 6,
  "&:hover": {
    zIndex: 7
  },
  // In macOS Safari and Gnome Web, scrollbars are overlaid and don't affect the layout. So we consider
  // their size to be 0px throughout all the calculations, but the floating scrollbar container does need
  // to appear and have a real size. We set it to 14px because it seems like an acceptable value and we
  // don't have a method to find the required size for scrollbars on those platforms.
  "--size": "calc(max(var(--DataGrid-scrollbarSize), 14px))"
}), FX = tn(kD)({
  width: "var(--size)",
  height: "calc(var(--DataGrid-hasScrollY) * (100% - var(--DataGrid-topContainerHeight) - var(--DataGrid-bottomContainerHeight) - var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize)))",
  overflowY: "auto",
  overflowX: "hidden",
  // Disable focus-visible style, it's a scrollbar.
  outline: 0,
  "& > div": {
    width: "var(--size)"
  },
  top: "var(--DataGrid-topContainerHeight)",
  right: "0px"
}), LX = tn(kD)({
  width: "100%",
  height: "var(--size)",
  overflowY: "hidden",
  overflowX: "auto",
  // Disable focus-visible style, it's a scrollbar.
  outline: 0,
  "& > div": {
    height: "var(--size)"
  },
  bottom: "0px"
}), ET = Ct(function(t, n) {
  const o = eo(), s = Xe(), i = h.useRef(!1), a = h.useRef(0), l = h.useRef(null), c = h.useRef(null), u = AX(s, t.position), d = ge(o, Kn), f = t.position === "vertical" ? "height" : "width", p = t.position === "vertical" ? "scrollTop" : "scrollLeft", m = t.position === "vertical" ? "top" : "left", b = t.position === "vertical" ? d.hasScrollX : d.hasScrollY, v = d.minimumSize[f] + (b ? d.scrollbarSize : 0), y = (t.position === "vertical" ? d.viewportInnerSize.height : d.viewportOuterSize.width) * (v / d.viewportOuterSize[f]), w = xe(() => {
    const T = l.current, E = t.scrollPosition.current;
    if (!T || E[m] === a.current)
      return;
    if (a.current = E[m], i.current) {
      i.current = !1;
      return;
    }
    i.current = !0;
    const O = E[m] / v;
    T[p] = O * y;
  }), x = xe(() => {
    const T = o.current.virtualScrollerRef.current, E = l.current;
    if (!E)
      return;
    if (i.current) {
      i.current = !1;
      return;
    }
    i.current = !0;
    const O = E[p] / y;
    T[p] = O * v;
  });
  Iv(() => {
    const T = o.current.virtualScrollerRef.current, E = l.current, O = {
      passive: !0
    };
    return T.addEventListener("scroll", w, O), E.addEventListener("scroll", x, O), () => {
      T.removeEventListener("scroll", w, O), E.removeEventListener("scroll", x, O);
    };
  }), h.useEffect(() => {
    c.current.style.setProperty(f, `${y}px`);
  }, [y, f]);
  const S = t.position === "vertical" ? FX : LX;
  return /* @__PURE__ */ C(S, {
    ref: tt(n, l),
    className: u.root,
    style: t.position === "vertical" && s.unstable_listView ? {
      height: "100%",
      top: 0
    } : void 0,
    tabIndex: -1,
    "aria-hidden": "true",
    children: /* @__PURE__ */ C("div", {
      ref: c,
      className: u.content
    })
  });
}), _X = (e) => {
  const {
    classes: t,
    hasScrollX: n,
    hasPinnedRight: o,
    loadingOverlayVariant: s
  } = e;
  return fe({
    root: ["main", o && "main--hasPinnedRight", s === "skeleton" && "main--hasSkeletonLoadingOverlay"],
    scroller: ["virtualScroller", n && "virtualScroller--hasScrollX"]
  }, rt, t);
}, VX = tn("div", {
  name: "MuiDataGrid",
  slot: "VirtualScroller",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.virtualScroller, n.hasScrollX && t["virtualScroller--hasScrollX"]];
  }
})({
  position: "relative",
  height: "100%",
  flexGrow: 1,
  overflow: "scroll",
  scrollbarWidth: "none",
  display: "flex",
  flexDirection: "column",
  "&::-webkit-scrollbar": {
    display: "none"
    /* Safari and Chrome */
  },
  "@media print": {
    overflow: "hidden"
  },
  // See https://github.com/mui/mui-x/issues/10547
  zIndex: 0
}), BX = (e) => e.dimensions.rightPinnedWidth > 0;
function zX(e) {
  const t = lt(), n = Xe(), o = ge(t, rU), s = ge(t, oU), i = ge(t, BX), a = ge(t, cU), l = rX(), c = {
    classes: n.classes,
    hasScrollX: s,
    hasPinnedRight: i,
    loadingOverlayVariant: l.loadingOverlayVariant
  }, u = _X(c), d = ZY(), {
    getContainerProps: f,
    getScrollerProps: p,
    getContentProps: m,
    getRenderZoneProps: b,
    getScrollbarVerticalProps: v,
    getScrollbarHorizontalProps: g,
    getRows: y,
    getScrollAreaProps: w
  } = d, x = y();
  return /* @__PURE__ */ ie(fX, I({
    className: u.root
  }, f(), {
    ownerState: c,
    children: [/* @__PURE__ */ C(yT, I({
      scrollDirection: "left"
    }, w())), /* @__PURE__ */ C(yT, I({
      scrollDirection: "right"
    }, w())), /* @__PURE__ */ ie(VX, I({
      className: u.scroller
    }, p(), {
      ownerState: c,
      children: [/* @__PURE__ */ ie(gX, {
        children: [!n.unstable_listView && /* @__PURE__ */ C(cX, {}), /* @__PURE__ */ C(n.slots.pinnedRows, {
          position: "top",
          virtualScroller: d
        })]
      }), /* @__PURE__ */ C(ID, I({}, l)), /* @__PURE__ */ C(wX, I({}, m(), {
        children: /* @__PURE__ */ ie(kX, I({}, b(), {
          children: [x, /* @__PURE__ */ C(n.slots.detailPanels, {
            virtualScroller: d
          })]
        }))
      })), a && /* @__PURE__ */ C(IX, {
        rowsLength: x.length
      }), /* @__PURE__ */ C(yX, {
        children: /* @__PURE__ */ C(n.slots.pinnedRows, {
          position: "bottom",
          virtualScroller: d
        })
      })]
    })), s && !n.unstable_listView && /* @__PURE__ */ C(ET, I({
      position: "horizontal"
    }, g())), o && /* @__PURE__ */ C(ET, I({
      position: "vertical"
    }, v())), e.children]
  }));
}
function HX() {
  var t;
  const e = Xe();
  return e.hideFooter ? null : /* @__PURE__ */ C(e.slots.footer, I(
    {},
    (t = e.slotProps) == null ? void 0 : t.footer
    /* FIXME: typing error */
  ));
}
let Tg;
function jX() {
  return Tg === void 0 && document.createElement("div").focus({
    get preventScroll() {
      return Tg = !0, !1;
    }
  }), Tg;
}
function GX({
  defaultSlots: e,
  slots: t
}) {
  const n = t;
  if (!n || Object.keys(n).length === 0)
    return e;
  const o = I({}, e);
  return Object.keys(n).forEach((s) => {
    const i = s;
    n[i] !== void 0 && (o[i] = n[i]);
  }), o;
}
function qX(e) {
  var s;
  if ((s = e.slotProps) != null && s.root)
    return e;
  const t = Object.keys(e);
  if (!t.some((i) => i.startsWith("aria-") || i.startsWith("data-")))
    return e;
  const n = {}, o = e.forwardedProps ?? {};
  for (let i = 0; i < t.length; i += 1) {
    const a = t[i];
    a.startsWith("aria-") || a.startsWith("data-") ? o[a] = e[a] : n[a] = e[a];
  }
  return n.forwardedProps = o, n;
}
function WX(e) {
  return h.useMemo(() => qX(e), [e]);
}
const UX = [(e) => e.autoPageSize && e.autoHeight && ["MUI X: `<DataGrid autoPageSize={true} autoHeight={true} />` are not valid props.", "You cannot use both the `autoPageSize` and `autoHeight` props at the same time because `autoHeight` scales the height of the Data Grid according to the `pageSize`.", "", "Please remove one of these two props."].join(`
`) || void 0, (e) => e.paginationMode === "client" && e.paginationMeta != null && ['MUI X: Usage of the `paginationMeta` prop with client-side pagination (`paginationMode="client"`) has no effect.', '`paginationMeta` is only meant to be used with `paginationMode="server"`.'].join(`
`) || void 0, (e) => e.signature === Mo.DataGrid && e.paginationMode === "client" && GC(e.rowCount) && ['MUI X: Usage of the `rowCount` prop with client side pagination (`paginationMode="client"`) has no effect.', '`rowCount` is only meant to be used with `paginationMode="server"`.'].join(`
`) || void 0, (e) => e.paginationMode === "server" && e.rowCount == null && !e.unstable_dataSource && ["MUI X: The `rowCount` prop must be passed using `paginationMode='server'`", "For more detail, see http://mui.com/components/data-grid/pagination/#index-based-pagination"].join(`
`) || void 0];
function KX(e, t) {
  t.forEach((n) => {
    const o = n(e);
    o && vo(o, "error");
  });
}
const YX = (e) => {
  const t = e.match(/^__row_group_by_columns_group_(.*)__$/);
  return t ? t[1] : null;
}, XX = (e) => e === Gk || YX(e) !== null, DD = (e, t) => {
  if (e)
    if (t) {
      if (e === ut.LEFT)
        return "right";
      if (e === ut.RIGHT)
        return "left";
    } else {
      if (e === ut.LEFT)
        return "left";
      if (e === ut.RIGHT)
        return "right";
    }
};
function _u(e, t, n, o) {
  const s = DD(n, t);
  return !s || o === void 0 || (e[s] = o), e;
}
const QX = ["column", "row", "rowId", "rowNode", "align", "children", "colIndex", "width", "className", "style", "colSpan", "disableDragEvents", "isNotVisible", "pinnedOffset", "pinnedPosition", "showRightBorder", "showLeftBorder", "onClick", "onDoubleClick", "onMouseDown", "onMouseUp", "onMouseOver", "onKeyDown", "onKeyUp", "onDragEnter", "onDragOver"], ZX = ["changeReason", "unstable_updateValueOnRender"];
ut.LEFT + "", Ln.LEFT, ut.RIGHT + "", Ln.RIGHT, ut.NONE + "", ut.VIRTUAL + "";
const JX = (e) => {
  const {
    align: t,
    showLeftBorder: n,
    showRightBorder: o,
    pinnedPosition: s,
    isEditable: i,
    isSelected: a,
    isSelectionMode: l,
    classes: c
  } = e, u = {
    root: ["cell", `cell--text${ce(t)}`, a && "selected", i && "cell--editable", n && "cell--withLeftBorder", o && "cell--withRightBorder", s === ut.LEFT && "cell--pinnedLeft", s === ut.RIGHT && "cell--pinnedRight", l && !i && "cell--selectionMode"]
  };
  return fe(u, rt, c);
};
let IT = !1;
const ND = Ct(function(t, n) {
  var me, Ae, ye, We;
  const {
    column: o,
    row: s,
    rowId: i,
    rowNode: a,
    align: l,
    colIndex: c,
    width: u,
    className: d,
    style: f,
    colSpan: p,
    disableDragEvents: m,
    isNotVisible: b,
    pinnedOffset: v,
    pinnedPosition: g,
    showRightBorder: y,
    showLeftBorder: w,
    onClick: x,
    onDoubleClick: S,
    onMouseDown: T,
    onMouseUp: E,
    onMouseOver: O,
    onKeyDown: M,
    onKeyUp: D,
    onDragEnter: R,
    onDragOver: P
  } = t, F = ve(t, QX), $ = eo(), N = Xe(), A = _t(), k = o.field, L = Ys($, NX, {
    rowId: i,
    field: k
  }), B = L ? Bt.Edit : Bt.View, V = $.current.getCellParamsForRow(i, k, s, {
    colDef: o,
    cellMode: B,
    rowNode: a,
    tabIndex: ge($, () => {
      const He = e0($);
      return He && He.field === k && He.id === i ? 0 : -1;
    }),
    hasFocus: ge($, () => {
      const He = fo($);
      return (He == null ? void 0 : He.id) === i && He.field === k;
    })
  });
  V.api = $.current;
  const _ = ge($, () => $.current.unstable_applyPipeProcessors("isCellSelected", !1, {
    id: i,
    field: k
  })), z = ge($, SD), j = ge($, UY), {
    hasFocus: W,
    isEditable: J = !1,
    value: G
  } = V, q = o.type === "actions" && ((me = o.getActions) == null ? void 0 : me.call(o, $.current.getRowParams(i)).some((He) => !He.props.disabled)), Z = (B === "view" || !J) && !q ? V.tabIndex : -1, {
    classes: Y,
    getCellClassName: Q
  } = N, ne = [ge($, () => $.current.unstable_applyPipeProcessors("cellClassName", [], {
    id: i,
    field: k
  }).filter(Boolean).join(" "))];
  o.cellClassName && ne.push(typeof o.cellClassName == "function" ? o.cellClassName(V) : o.cellClassName), o.display === "flex" && ne.push(K["cell--flex"]), Q && ne.push(Q(V));
  const H = V.formattedValue ?? G, U = h.useRef(null), X = tt(n, U), re = h.useRef(null), oe = N.cellSelection ?? !1, le = {
    align: l,
    showLeftBorder: w,
    showRightBorder: y,
    isEditable: J,
    classes: N.classes,
    pinnedPosition: g,
    isSelected: _,
    isSelectionMode: oe
  }, se = JX(le), Ce = h.useCallback((He) => (ze) => {
    const pe = $.current.getCellParams(i, k || "");
    $.current.publishEvent(He, pe, ze), E && E(ze);
  }, [$, k, E, i]), $e = h.useCallback((He) => (ze) => {
    const pe = $.current.getCellParams(i, k || "");
    $.current.publishEvent(He, pe, ze), T && T(ze);
  }, [$, k, T, i]), we = h.useCallback((He, ze) => (pe) => {
    if (!$.current.getRow(i))
      return;
    const Re = $.current.getCellParams(i, k || "");
    $.current.publishEvent(He, Re, pe), ze && ze(pe);
  }, [$, k, i]), Te = ((Ae = z[i]) == null ? void 0 : Ae[k]) ?? !1, ue = ((ye = j[i]) == null ? void 0 : ye[k]) ?? 1, de = h.useMemo(() => {
    if (b)
      return {
        padding: 0,
        opacity: 0,
        width: 0,
        height: 0,
        border: 0
      };
    const He = _u(I({
      "--width": `${u}px`
    }, f), A, g, v), ze = g === ut.LEFT, pe = g === ut.RIGHT;
    return ue > 1 && (He.height = `calc(var(--height) * ${ue})`, He.zIndex = 5, (ze || pe) && (He.zIndex = 6)), He;
  }, [u, b, f, v, g, A, ue]);
  if (h.useEffect(() => {
    if (!W || B === Bt.Edit)
      return;
    const He = qt($.current.rootElementRef.current);
    if (U.current && !U.current.contains(He.activeElement)) {
      const ze = U.current.querySelector('[tabindex="0"]'), pe = re.current || ze || U.current;
      if (jX())
        pe.focus({
          preventScroll: !0
        });
      else {
        const Re = $.current.getScrollPosition();
        pe.focus(), $.current.scroll(Re);
      }
    }
  }, [W, B, $]), Te)
    return /* @__PURE__ */ C("div", {
      "data-colindex": c,
      role: "presentation",
      style: I({
        width: "var(--width)"
      }, de)
    });
  let Pe = F.onFocus;
  process.env.NODE_ENV === "test" && ((We = N.experimentalFeatures) != null && We.warnIfFocusStateIsNotSynced) && (Pe = (He) => {
    const ze = fo($);
    if ((ze == null ? void 0 : ze.id) === i && ze.field === k) {
      typeof F.onFocus == "function" && F.onFocus(He);
      return;
    }
    IT || (console.warn([`MUI X: The cell with id=${i} and field=${k} received focus.`, `According to the state, the focus should be at id=${ze == null ? void 0 : ze.id}, field=${ze == null ? void 0 : ze.field}.`, "Not syncing the state may cause unwanted behaviors since the `cellFocusIn` event won't be fired.", "Call `fireEvent.mouseUp` before the `fireEvent.click` to sync the focus with the state."].join(`
`)), IT = !0);
  });
  let ke, Me;
  if (L === null && o.renderCell && (ke = o.renderCell(V)), L !== null && o.renderEditCell) {
    const He = $.current.getRowWithUpdatedValues(i, o.field), ze = ve(L, ZX), pe = o.valueFormatter ? o.valueFormatter(L.value, He, o, $) : V.formattedValue, Re = I({}, V, {
      row: He,
      formattedValue: pe
    }, ze);
    ke = o.renderEditCell(Re), ne.push(K["cell--editing"]), ne.push(Y == null ? void 0 : Y["cell--editing"]);
  }
  if (ke === void 0) {
    const He = H == null ? void 0 : H.toString();
    ke = He, Me = He;
  }
  /* @__PURE__ */ h.isValidElement(ke) && q && (ke = /* @__PURE__ */ h.cloneElement(ke, {
    focusElementRef: re
  }));
  const be = m ? null : {
    onDragEnter: we("cellDragEnter", R),
    onDragOver: we("cellDragOver", P)
  };
  return /* @__PURE__ */ C("div", I({
    className: ae(se.root, ne, d),
    role: "gridcell",
    "data-field": k,
    "data-colindex": c,
    "aria-colindex": c + 1,
    "aria-colspan": p,
    "aria-rowspan": ue,
    style: de,
    title: Me,
    tabIndex: Z,
    onClick: we("cellClick", x),
    onDoubleClick: we("cellDoubleClick", S),
    onMouseOver: we("cellMouseOver", O),
    onMouseDown: $e("cellMouseDown"),
    onMouseUp: Ce("cellMouseUp"),
    onKeyDown: we("cellKeyDown", M),
    onKeyUp: we("cellKeyUp", D)
  }, be, F, {
    onFocus: Pe,
    ref: X,
    children: ke
  }));
});
process.env.NODE_ENV !== "production" && (ND.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  align: r.oneOf(["center", "left", "right"]).isRequired,
  colIndex: r.number.isRequired,
  colSpan: r.number,
  column: r.object.isRequired,
  disableDragEvents: r.bool,
  isNotVisible: r.bool.isRequired,
  pinnedOffset: r.number,
  pinnedPosition: r.oneOf([0, 1, 2, 3]).isRequired,
  row: r.object.isRequired,
  rowId: r.oneOfType([r.number, r.string]).isRequired,
  rowNode: r.object.isRequired,
  showLeftBorder: r.bool.isRequired,
  showRightBorder: r.bool.isRequired,
  width: r.number.isRequired
});
const eQ = Dr(ND), tQ = ["field", "type", "align", "width", "height", "empty", "style", "className"], OT = "1.3em", nQ = "1.2em", PT = [40, 80], oQ = {
  number: [40, 60],
  string: [40, 80],
  date: [40, 60],
  dateTime: [60, 80],
  singleSelect: [40, 80]
}, rQ = (e) => {
  const {
    align: t,
    classes: n,
    empty: o
  } = e, s = {
    root: ["cell", "cellSkeleton", `cell--text${t ? ce(t) : "Left"}`, o && "cellEmpty"]
  };
  return fe(s, rt, n);
}, sQ = $U(12345);
function $D(e) {
  const {
    field: t,
    type: n,
    align: o,
    width: s,
    height: i,
    empty: a = !1,
    style: l,
    className: c
  } = e, u = ve(e, tQ), f = {
    classes: Xe().classes,
    align: o,
    empty: a
  }, p = rQ(f), m = h.useMemo(() => {
    if (n === "boolean" || n === "actions")
      return {
        variant: "circular",
        width: OT,
        height: OT
      };
    const [v, g] = n ? oQ[n] ?? PT : PT;
    return {
      variant: "text",
      width: `${Math.round(sQ(v, g))}%`,
      height: nQ
    };
  }, [n]);
  return /* @__PURE__ */ C("div", I({
    "data-field": t,
    className: ae(p.root, c),
    style: I({
      height: i,
      maxWidth: s,
      minWidth: s
    }, l)
  }, u, {
    children: !a && /* @__PURE__ */ C(bC, I({}, m))
  }));
}
process.env.NODE_ENV !== "production" && ($D.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  align: r.string,
  /**
   * If `true`, the cell will not display the skeleton but still reserve the cell space.
   * @default false
   */
  empty: r.bool,
  field: r.string,
  height: r.oneOfType([r.oneOf(["auto"]), r.number]),
  type: r.oneOf(["actions", "boolean", "custom", "date", "dateTime", "number", "singleSelect", "string"]),
  width: r.oneOfType([r.number, r.string])
});
const iQ = Dr($D);
function aQ(e) {
  return e.vars ? e.vars.palette.TableCell.border : e.palette.mode === "light" ? wo(he(e.palette.divider, 1), 0.88) : $o(he(e.palette.divider, 1), 0.68);
}
const MT = {
  [`& .${K.iconButtonContainer}`]: {
    visibility: "visible",
    width: "auto"
  },
  [`& .${K.menuIcon}`]: {
    width: "auto",
    visibility: "visible"
  }
}, lQ = 10, Od = -5, ha = 1, kT = {
  width: 3,
  rx: 1.5,
  x: 10.5
}, cQ = "/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */", uQ = (e) => e.dimensions.hasScrollX && (!e.dimensions.hasScrollY || e.dimensions.scrollbarSize === 0), dQ = te("div", {
  name: "MuiDataGrid",
  slot: "Root",
  overridesResolver: (e, t) => [
    // Root overrides
    t.root,
    {
      [`&.${K.autoHeight}`]: t.autoHeight
    },
    {
      [`&.${K.autosizing}`]: t.autosizing
    },
    {
      [`&.${K["root--densityStandard"]}`]: t["root--densityStandard"]
    },
    {
      [`&.${K["root--densityComfortable"]}`]: t["root--densityComfortable"]
    },
    {
      [`&.${K["root--densityCompact"]}`]: t["root--densityCompact"]
    },
    {
      [`&.${K["root--disableUserSelection"]}`]: t["root--disableUserSelection"]
    },
    {
      [`&.${K["root--noToolbar"]}`]: t["root--noToolbar"]
    },
    {
      [`&.${K.withVerticalBorder}`]: t.withVerticalBorder
    },
    // Child element overrides
    // - Only declare overrides here for class names that are not applied to `styled` components.
    // - For `styled` components, declare overrides in the component itself.
    {
      [`& .${K.actionsCell}`]: t.actionsCell
    },
    {
      [`& .${K.booleanCell}`]: t.booleanCell
    },
    {
      [`& .${K.cell}`]: t.cell
    },
    {
      [`& .${K["cell--editable"]}`]: t["cell--editable"]
    },
    {
      [`& .${K["cell--editing"]}`]: t["cell--editing"]
    },
    {
      [`& .${K["cell--flex"]}`]: t["cell--flex"]
    },
    {
      [`& .${K["cell--pinnedLeft"]}`]: t["cell--pinnedLeft"]
    },
    {
      [`& .${K["cell--pinnedRight"]}`]: t["cell--pinnedRight"]
    },
    {
      [`& .${K["cell--rangeBottom"]}`]: t["cell--rangeBottom"]
    },
    {
      [`& .${K["cell--rangeLeft"]}`]: t["cell--rangeLeft"]
    },
    {
      [`& .${K["cell--rangeRight"]}`]: t["cell--rangeRight"]
    },
    {
      [`& .${K["cell--rangeTop"]}`]: t["cell--rangeTop"]
    },
    {
      [`& .${K["cell--selectionMode"]}`]: t["cell--selectionMode"]
    },
    {
      [`& .${K["cell--textCenter"]}`]: t["cell--textCenter"]
    },
    {
      [`& .${K["cell--textLeft"]}`]: t["cell--textLeft"]
    },
    {
      [`& .${K["cell--textRight"]}`]: t["cell--textRight"]
    },
    {
      [`& .${K["cell--withLeftBorder"]}`]: t["cell--withLeftBorder"]
    },
    {
      [`& .${K["cell--withRightBorder"]}`]: t["cell--withRightBorder"]
    },
    {
      [`& .${K.cellCheckbox}`]: t.cellCheckbox
    },
    {
      [`& .${K.cellEmpty}`]: t.cellEmpty
    },
    {
      [`& .${K.cellOffsetLeft}`]: t.cellOffsetLeft
    },
    {
      [`& .${K.cellSkeleton}`]: t.cellSkeleton
    },
    {
      [`& .${K.checkboxInput}`]: t.checkboxInput
    },
    {
      [`& .${K.columnHeader}`]: t.columnHeader
    },
    {
      [`& .${K["columnHeader--alignCenter"]}`]: t["columnHeader--alignCenter"]
    },
    {
      [`& .${K["columnHeader--alignLeft"]}`]: t["columnHeader--alignLeft"]
    },
    {
      [`& .${K["columnHeader--alignRight"]}`]: t["columnHeader--alignRight"]
    },
    {
      [`& .${K["columnHeader--dragging"]}`]: t["columnHeader--dragging"]
    },
    {
      [`& .${K["columnHeader--emptyGroup"]}`]: t["columnHeader--emptyGroup"]
    },
    {
      [`& .${K["columnHeader--filledGroup"]}`]: t["columnHeader--filledGroup"]
    },
    {
      [`& .${K["columnHeader--filtered"]}`]: t["columnHeader--filtered"]
    },
    {
      [`& .${K["columnHeader--last"]}`]: t["columnHeader--last"]
    },
    {
      [`& .${K["columnHeader--lastUnpinned"]}`]: t["columnHeader--lastUnpinned"]
    },
    {
      [`& .${K["columnHeader--moving"]}`]: t["columnHeader--moving"]
    },
    {
      [`& .${K["columnHeader--numeric"]}`]: t["columnHeader--numeric"]
    },
    {
      [`& .${K["columnHeader--pinnedLeft"]}`]: t["columnHeader--pinnedLeft"]
    },
    {
      [`& .${K["columnHeader--pinnedRight"]}`]: t["columnHeader--pinnedRight"]
    },
    {
      [`& .${K["columnHeader--siblingFocused"]}`]: t["columnHeader--siblingFocused"]
    },
    {
      [`& .${K["columnHeader--sortable"]}`]: t["columnHeader--sortable"]
    },
    {
      [`& .${K["columnHeader--sorted"]}`]: t["columnHeader--sorted"]
    },
    {
      [`& .${K["columnHeader--withLeftBorder"]}`]: t["columnHeader--withLeftBorder"]
    },
    {
      [`& .${K["columnHeader--withRightBorder"]}`]: t["columnHeader--withRightBorder"]
    },
    {
      [`& .${K.columnHeaderCheckbox}`]: t.columnHeaderCheckbox
    },
    {
      [`& .${K.columnHeaderDraggableContainer}`]: t.columnHeaderDraggableContainer
    },
    {
      [`& .${K.columnHeaderTitleContainer}`]: t.columnHeaderTitleContainer
    },
    {
      [`& .${K.columnHeaderTitleContainerContent}`]: t.columnHeaderTitleContainerContent
    },
    {
      [`& .${K.columnSeparator}`]: t.columnSeparator
    },
    {
      [`& .${K["columnSeparator--resizable"]}`]: t["columnSeparator--resizable"]
    },
    {
      [`& .${K["columnSeparator--resizing"]}`]: t["columnSeparator--resizing"]
    },
    {
      [`& .${K["columnSeparator--sideLeft"]}`]: t["columnSeparator--sideLeft"]
    },
    {
      [`& .${K["columnSeparator--sideRight"]}`]: t["columnSeparator--sideRight"]
    },
    {
      [`& .${K["container--bottom"]}`]: t["container--bottom"]
    },
    {
      [`& .${K["container--top"]}`]: t["container--top"]
    },
    {
      [`& .${K.detailPanelToggleCell}`]: t.detailPanelToggleCell
    },
    {
      [`& .${K["detailPanelToggleCell--expanded"]}`]: t["detailPanelToggleCell--expanded"]
    },
    {
      [`& .${K.editBooleanCell}`]: t.editBooleanCell
    },
    {
      [`& .${K.filterIcon}`]: t.filterIcon
    },
    {
      [`& .${K["filler--borderBottom"]}`]: t["filler--borderBottom"]
    },
    {
      [`& .${K["filler--pinnedLeft"]}`]: t["filler--pinnedLeft"]
    },
    {
      [`& .${K["filler--pinnedRight"]}`]: t["filler--pinnedRight"]
    },
    {
      [`& .${K.groupingCriteriaCell}`]: t.groupingCriteriaCell
    },
    {
      [`& .${K.groupingCriteriaCellLoadingContainer}`]: t.groupingCriteriaCellLoadingContainer
    },
    {
      [`& .${K.groupingCriteriaCellToggle}`]: t.groupingCriteriaCellToggle
    },
    {
      [`& .${K.headerFilterRow}`]: t.headerFilterRow
    },
    {
      [`& .${K.iconSeparator}`]: t.iconSeparator
    },
    {
      [`& .${K.menuIcon}`]: t.menuIcon
    },
    {
      [`& .${K.menuIconButton}`]: t.menuIconButton
    },
    {
      [`& .${K.menuList}`]: t.menuList
    },
    {
      [`& .${K.menuOpen}`]: t.menuOpen
    },
    {
      [`& .${K.overlayWrapperInner}`]: t.overlayWrapperInner
    },
    {
      [`& .${K.pinnedRows}`]: t.pinnedRows
    },
    {
      [`& .${K["pinnedRows--bottom"]}`]: t["pinnedRows--bottom"]
    },
    {
      [`& .${K["pinnedRows--top"]}`]: t["pinnedRows--top"]
    },
    {
      [`& .${K.row}`]: t.row
    },
    {
      [`& .${K["row--borderBottom"]}`]: t["row--borderBottom"]
    },
    {
      [`& .${K["row--detailPanelExpanded"]}`]: t["row--detailPanelExpanded"]
    },
    {
      [`& .${K["row--dragging"]}`]: t["row--dragging"]
    },
    {
      [`& .${K["row--dynamicHeight"]}`]: t["row--dynamicHeight"]
    },
    {
      [`& .${K["row--editable"]}`]: t["row--editable"]
    },
    {
      [`& .${K["row--editing"]}`]: t["row--editing"]
    },
    {
      [`& .${K["row--firstVisible"]}`]: t["row--firstVisible"]
    },
    {
      [`& .${K["row--lastVisible"]}`]: t["row--lastVisible"]
    },
    {
      [`& .${K.rowReorderCell}`]: t.rowReorderCell
    },
    {
      [`& .${K["rowReorderCell--draggable"]}`]: t["rowReorderCell--draggable"]
    },
    {
      [`& .${K.rowReorderCellContainer}`]: t.rowReorderCellContainer
    },
    {
      [`& .${K.rowReorderCellPlaceholder}`]: t.rowReorderCellPlaceholder
    },
    {
      [`& .${K.rowSkeleton}`]: t.rowSkeleton
    },
    {
      [`& .${K.scrollbar}`]: t.scrollbar
    },
    {
      [`& .${K["scrollbar--horizontal"]}`]: t["scrollbar--horizontal"]
    },
    {
      [`& .${K["scrollbar--vertical"]}`]: t["scrollbar--vertical"]
    },
    {
      [`& .${K.scrollbarFiller}`]: t.scrollbarFiller
    },
    {
      [`& .${K["scrollbarFiller--borderBottom"]}`]: t["scrollbarFiller--borderBottom"]
    },
    {
      [`& .${K["scrollbarFiller--borderTop"]}`]: t["scrollbarFiller--borderTop"]
    },
    {
      [`& .${K["scrollbarFiller--header"]}`]: t["scrollbarFiller--header"]
    },
    {
      [`& .${K["scrollbarFiller--pinnedRight"]}`]: t["scrollbarFiller--pinnedRight"]
    },
    {
      [`& .${K.sortIcon}`]: t.sortIcon
    },
    {
      [`& .${K.treeDataGroupingCell}`]: t.treeDataGroupingCell
    },
    {
      [`& .${K.treeDataGroupingCellLoadingContainer}`]: t.treeDataGroupingCellLoadingContainer
    },
    {
      [`& .${K.treeDataGroupingCellToggle}`]: t.treeDataGroupingCellToggle
    },
    {
      [`& .${K.withBorderColor}`]: t.withBorderColor
    }
  ]
})(({
  theme: e
}) => {
  var M, D;
  const t = eo(), n = ge(t, uQ), o = aQ(e), s = e.shape.borderRadius, i = e.vars ? e.vars.palette.background.default : ((M = e.mixins.MuiDataGrid) == null ? void 0 : M.containerBackground) ?? e.palette.background.default, a = ((D = e.mixins.MuiDataGrid) == null ? void 0 : D.pinnedBackground) ?? i, l = e.vars ? `rgba(${e.vars.palette.background.defaultChannel} / ${e.vars.palette.action.disabledOpacity})` : he(e.palette.background.default, e.palette.action.disabledOpacity), c = (e.vars || e).palette.action.hoverOpacity, u = (e.vars || e).palette.action.hover, d = (e.vars || e).palette.action.selectedOpacity, f = e.vars ? `calc(${c} + ${d})` : c + d, p = e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${d})` : he(e.palette.primary.main, d), m = e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${f})` : he(e.palette.primary.main, f), b = e.vars ? hQ : fQ, v = (R) => ({
    [`& .${K["cell--pinnedLeft"]}, & .${K["cell--pinnedRight"]}`]: {
      backgroundColor: R,
      "&.Mui-selected": {
        backgroundColor: b(R, p, d),
        "&:hover": {
          backgroundColor: b(R, p, f)
        }
      }
    }
  }), g = b(a, u, c), y = v(g), w = b(a, p, d), x = v(w), S = b(a, m, f), T = v(S), E = {
    backgroundColor: p,
    "&:hover": {
      backgroundColor: m,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: p
      }
    }
  };
  return I({
    "--unstable_DataGrid-radius": typeof s == "number" ? `${s}px` : s,
    "--unstable_DataGrid-headWeight": e.typography.fontWeightMedium,
    "--unstable_DataGrid-overlayBackground": l,
    "--DataGrid-containerBackground": i,
    "--DataGrid-pinnedBackground": a,
    "--DataGrid-rowBorderColor": o,
    "--DataGrid-cellOffsetMultiplier": 2,
    "--DataGrid-width": "0px",
    "--DataGrid-hasScrollX": "0",
    "--DataGrid-hasScrollY": "0",
    "--DataGrid-scrollbarSize": "10px",
    "--DataGrid-rowWidth": "0px",
    "--DataGrid-columnsTotalWidth": "0px",
    "--DataGrid-leftPinnedWidth": "0px",
    "--DataGrid-rightPinnedWidth": "0px",
    "--DataGrid-headerHeight": "0px",
    "--DataGrid-headersTotalHeight": "0px",
    "--DataGrid-topContainerHeight": "0px",
    "--DataGrid-bottomContainerHeight": "0px",
    flex: 1,
    boxSizing: "border-box",
    position: "relative",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: o,
    borderRadius: "var(--unstable_DataGrid-radius)",
    color: (e.vars || e).palette.text.primary
  }, e.typography.body2, {
    outline: "none",
    height: "100%",
    display: "flex",
    minWidth: 0,
    // See https://github.com/mui/mui-x/issues/8547
    minHeight: 0,
    flexDirection: "column",
    overflow: "hidden",
    overflowAnchor: "none",
    // Keep the same scrolling position
    [`.${K.main} > *:first-child${cQ}`]: {
      borderTopLeftRadius: "var(--unstable_DataGrid-radius)",
      borderTopRightRadius: "var(--unstable_DataGrid-radius)"
    },
    [`&.${K.autoHeight}`]: {
      height: "auto"
    },
    [`&.${K.autosizing}`]: {
      [`& .${K.columnHeaderTitleContainerContent} > *`]: {
        overflow: "visible !important"
      },
      "@media (hover: hover)": {
        [`& .${K.menuIcon}`]: {
          width: "0 !important",
          visibility: "hidden !important"
        }
      },
      [`& .${K.cell}`]: {
        overflow: "visible !important",
        whiteSpace: "nowrap",
        minWidth: "max-content !important",
        maxWidth: "max-content !important"
      },
      [`& .${K.groupingCriteriaCell}`]: {
        width: "unset"
      },
      [`& .${K.treeDataGroupingCell}`]: {
        width: "unset"
      }
    },
    [`& .${K.columnHeader}, & .${K.cell}`]: {
      WebkitTapHighlightColor: "transparent",
      padding: "0 10px",
      boxSizing: "border-box"
    },
    [`& .${K.columnHeader}:focus-within, & .${K.cell}:focus-within`]: {
      outline: `solid ${e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / 0.5)` : he(e.palette.primary.main, 0.5)} ${ha}px`,
      outlineOffset: ha * -1
    },
    [`& .${K.columnHeader}:focus, & .${K.cell}:focus`]: {
      outline: `solid ${e.palette.primary.main} ${ha}px`,
      outlineOffset: ha * -1
    },
    // Hide the column separator when:
    // - the column is focused and has an outline
    // - the next column is focused and has an outline
    // - the column has a left or right border
    // - the next column is pinned right and has a left border
    [`& .${K.columnHeader}:focus,
      & .${K["columnHeader--withLeftBorder"]},
      & .${K["columnHeader--withRightBorder"]},
      & .${K["columnHeader--siblingFocused"]},
      & .${K["virtualScroller--hasScrollX"]} .${K["columnHeader--lastUnpinned"]},
      & .${K["virtualScroller--hasScrollX"]} .${K["columnHeader--last"]}
      `]: {
      [`& .${K.columnSeparator}`]: {
        opacity: 0
      },
      // Show resizable separators at all times on touch devices
      "@media (hover: none)": {
        [`& .${K["columnSeparator--resizable"]}`]: {
          opacity: 1
        }
      },
      [`& .${K["columnSeparator--resizable"]}:hover`]: {
        opacity: 1
      }
    },
    [`&.${K["root--noToolbar"]} [aria-rowindex="1"] [aria-colindex="1"]`]: {
      borderTopLeftRadius: "calc(var(--unstable_DataGrid-radius) - 1px)"
    },
    [`&.${K["root--noToolbar"]} [aria-rowindex="1"] .${K["columnHeader--last"]}`]: {
      borderTopRightRadius: n ? "calc(var(--unstable_DataGrid-radius) - 1px)" : void 0
    },
    [`& .${K.columnHeaderCheckbox}, & .${K.cellCheckbox}`]: {
      padding: 0,
      justifyContent: "center",
      alignItems: "center"
    },
    [`& .${K.columnHeader}`]: {
      position: "relative",
      display: "flex",
      alignItems: "center"
    },
    [`& .${K["virtualScroller--hasScrollX"]} .${K["columnHeader--last"]}`]: {
      overflow: "hidden"
    },
    [`& .${K["columnHeader--sorted"]} .${K.iconButtonContainer}, & .${K["columnHeader--filtered"]} .${K.iconButtonContainer}`]: {
      visibility: "visible",
      width: "auto"
    },
    [`& .${K.columnHeader}:not(.${K["columnHeader--sorted"]}) .${K.sortIcon}`]: {
      opacity: 0,
      transition: e.transitions.create(["opacity"], {
        duration: e.transitions.duration.shorter
      })
    },
    [`& .${K.columnHeaderTitleContainer}`]: {
      display: "flex",
      alignItems: "center",
      gap: e.spacing(0.25),
      minWidth: 0,
      flex: 1,
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    [`& .${K.columnHeaderTitleContainerContent}`]: {
      overflow: "hidden",
      display: "flex",
      alignItems: "center"
    },
    [`& .${K["columnHeader--filledGroup"]} .${K.columnHeaderTitleContainer}`]: {
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      boxSizing: "border-box"
    },
    [`& .${K.sortIcon}, & .${K.filterIcon}`]: {
      fontSize: "inherit"
    },
    [`& .${K["columnHeader--sortable"]}`]: {
      cursor: "pointer"
    },
    [`& .${K["columnHeader--alignCenter"]} .${K.columnHeaderTitleContainer}`]: {
      justifyContent: "center"
    },
    [`& .${K["columnHeader--alignRight"]} .${K.columnHeaderDraggableContainer}, & .${K["columnHeader--alignRight"]} .${K.columnHeaderTitleContainer}`]: {
      flexDirection: "row-reverse"
    },
    [`& .${K["columnHeader--alignCenter"]} .${K.menuIcon}`]: {
      marginLeft: "auto"
    },
    [`& .${K["columnHeader--alignRight"]} .${K.menuIcon}`]: {
      marginRight: "auto",
      marginLeft: -5
    },
    [`& .${K["columnHeader--moving"]}`]: {
      backgroundColor: (e.vars || e).palette.action.hover
    },
    [`& .${K["columnHeader--pinnedLeft"]}, & .${K["columnHeader--pinnedRight"]}`]: {
      position: "sticky",
      zIndex: 4,
      // Should be above the column separator
      background: "var(--DataGrid-pinnedBackground)"
    },
    [`& .${K.columnSeparator}`]: {
      position: "absolute",
      overflow: "hidden",
      zIndex: 3,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      maxWidth: lQ,
      color: o
    },
    [`& .${K.columnHeaders}`]: {
      width: "var(--DataGrid-rowWidth)"
    },
    "@media (hover: hover)": {
      [`& .${K.columnHeader}:hover`]: MT,
      [`& .${K.columnHeader}:not(.${K["columnHeader--sorted"]}):hover .${K.sortIcon}`]: {
        opacity: 0.5
      }
    },
    "@media (hover: none)": {
      [`& .${K.columnHeader}`]: MT,
      [`& .${K.columnHeader}:focus,
        & .${K["columnHeader--siblingFocused"]}`]: {
        [`.${K["columnSeparator--resizable"]}`]: {
          color: (e.vars || e).palette.primary.main
        }
      }
    },
    [`& .${K["columnSeparator--sideLeft"]}`]: {
      left: Od
    },
    [`& .${K["columnSeparator--sideRight"]}`]: {
      right: Od
    },
    [`& .${K["columnHeader--withRightBorder"]} .${K["columnSeparator--sideLeft"]}`]: {
      left: Od - 0.5
    },
    [`& .${K["columnHeader--withRightBorder"]} .${K["columnSeparator--sideRight"]}`]: {
      right: Od - 0.5
    },
    [`& .${K["columnSeparator--resizable"]}`]: {
      cursor: "col-resize",
      touchAction: "none",
      [`&.${K["columnSeparator--resizing"]}`]: {
        color: (e.vars || e).palette.primary.main
      },
      // Always appear as draggable on touch devices
      "@media (hover: none)": {
        [`& .${K.iconSeparator} rect`]: kT
      },
      "@media (hover: hover)": {
        "&:hover": {
          color: (e.vars || e).palette.primary.main,
          [`& .${K.iconSeparator} rect`]: kT
        }
      },
      "& svg": {
        pointerEvents: "none"
      }
    },
    [`& .${K.iconSeparator}`]: {
      color: "inherit",
      transition: e.transitions.create(["color", "width"], {
        duration: e.transitions.duration.shortest
      })
    },
    [`& .${K.menuIcon}`]: {
      width: 0,
      visibility: "hidden",
      fontSize: 20,
      marginRight: -5,
      display: "flex",
      alignItems: "center"
    },
    [`.${K.menuOpen}`]: {
      visibility: "visible",
      width: "auto"
    },
    [`& .${K.headerFilterRow}`]: {
      [`& .${K.columnHeader}`]: {
        boxSizing: "border-box",
        borderBottom: "1px solid var(--DataGrid-rowBorderColor)"
      }
    },
    /* Bottom border of the top-container */
    [`& .${K["row--borderBottom"]} .${K.columnHeader},
      & .${K["row--borderBottom"]} .${K.filler},
      & .${K["row--borderBottom"]} .${K.scrollbarFiller}`]: {
      borderBottom: "1px solid var(--DataGrid-rowBorderColor)"
    },
    [`& .${K["row--borderBottom"]} .${K.cell}`]: {
      borderBottom: "1px solid var(--rowBorderColor)"
    },
    /* Row styles */
    [`.${K.row}`]: {
      display: "flex",
      width: "var(--DataGrid-rowWidth)",
      breakInside: "avoid",
      // Avoid the row to be broken in two different print pages.
      "--rowBorderColor": "var(--DataGrid-rowBorderColor)",
      [`&.${K["row--firstVisible"]}`]: {
        "--rowBorderColor": "transparent"
      },
      "&:hover": {
        backgroundColor: (e.vars || e).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      [`&.${K.rowSkeleton}:hover`]: {
        backgroundColor: "transparent"
      },
      "&.Mui-selected": E
    },
    [`& .${K["container--top"]}, & .${K["container--bottom"]}`]: {
      "[role=row]": {
        background: "var(--DataGrid-containerBackground)"
      }
    },
    /* Cell styles */
    [`& .${K.cell}`]: {
      flex: "0 0 auto",
      height: "var(--height)",
      width: "var(--width)",
      lineHeight: "calc(var(--height) - 1px)",
      // -1px for the border
      boxSizing: "border-box",
      borderTop: "1px solid var(--rowBorderColor)",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      "&.Mui-selected": E
    },
    [`& .${K["virtualScrollerContent--overflowed"]} .${K["row--lastVisible"]} .${K.cell}`]: {
      borderTopColor: "transparent"
    },
    [`& .${K["pinnedRows--top"]} :first-of-type`]: {
      [`& .${K.cell}, .${K.scrollbarFiller}`]: {
        borderTop: "none"
      }
    },
    [`&.${K["root--disableUserSelection"]} .${K.cell}`]: {
      userSelect: "none"
    },
    [`& .${K["row--dynamicHeight"]} > .${K.cell}`]: {
      whiteSpace: "initial",
      lineHeight: "inherit"
    },
    [`& .${K.cellEmpty}`]: {
      flex: 1,
      padding: 0,
      height: "unset"
    },
    [`& .${K.cell}.${K["cell--selectionMode"]}`]: {
      cursor: "default"
    },
    [`& .${K.cell}.${K["cell--editing"]}`]: {
      padding: 1,
      display: "flex",
      boxShadow: e.shadows[2],
      backgroundColor: (e.vars || e).palette.background.paper,
      "&:focus-within": {
        outline: `${ha}px solid ${(e.vars || e).palette.primary.main}`,
        outlineOffset: ha * -1
      }
    },
    [`& .${K["row--editing"]}`]: {
      boxShadow: e.shadows[2]
    },
    [`& .${K["row--editing"]} .${K.cell}`]: {
      boxShadow: e.shadows[0],
      backgroundColor: (e.vars || e).palette.background.paper
    },
    [`& .${K.editBooleanCell}`]: {
      display: "flex",
      height: "100%",
      width: "100%",
      alignItems: "center",
      justifyContent: "center"
    },
    [`& .${K.booleanCell}[data-value="true"]`]: {
      color: (e.vars || e).palette.text.secondary
    },
    [`& .${K.booleanCell}[data-value="false"]`]: {
      color: (e.vars || e).palette.text.disabled
    },
    [`& .${K.actionsCell}`]: {
      display: "inline-flex",
      alignItems: "center",
      gridGap: e.spacing(1)
    },
    [`& .${K.rowReorderCell}`]: {
      display: "inline-flex",
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`& .${K["rowReorderCell--draggable"]}`]: {
      cursor: "move",
      opacity: 1
    },
    [`& .${K.rowReorderCellContainer}`]: {
      padding: 0,
      display: "flex",
      alignItems: "stretch"
    },
    [`.${K.withBorderColor}`]: {
      borderColor: o
    },
    [`& .${K["cell--withLeftBorder"]}, & .${K["columnHeader--withLeftBorder"]}`]: {
      borderLeftColor: "var(--DataGrid-rowBorderColor)",
      borderLeftWidth: "1px",
      borderLeftStyle: "solid"
    },
    [`& .${K["cell--withRightBorder"]}, & .${K["columnHeader--withRightBorder"]}`]: {
      borderRightColor: "var(--DataGrid-rowBorderColor)",
      borderRightWidth: "1px",
      borderRightStyle: "solid"
    },
    [`& .${K["cell--flex"]}`]: {
      display: "flex",
      alignItems: "center",
      lineHeight: "inherit"
    },
    [`& .${K["cell--textLeft"]}`]: {
      textAlign: "left",
      justifyContent: "flex-start"
    },
    [`& .${K["cell--textRight"]}`]: {
      textAlign: "right",
      justifyContent: "flex-end"
    },
    [`& .${K["cell--textCenter"]}`]: {
      textAlign: "center",
      justifyContent: "center"
    },
    [`& .${K["cell--pinnedLeft"]}, & .${K["cell--pinnedRight"]}`]: {
      position: "sticky",
      zIndex: 3,
      background: "var(--DataGrid-pinnedBackground)",
      "&.Mui-selected": {
        backgroundColor: w
      }
    },
    [`& .${K.virtualScrollerContent} .${K.row}`]: {
      "&:hover": y,
      "&.Mui-selected": x,
      "&.Mui-selected:hover": T
    },
    [`& .${K.cellOffsetLeft}`]: {
      flex: "0 0 auto",
      display: "inline-block"
    },
    [`& .${K.cellSkeleton}`]: {
      flex: "0 0 auto",
      height: "100%",
      display: "inline-flex",
      alignItems: "center"
    },
    [`& .${K.columnHeaderDraggableContainer}`]: {
      display: "flex",
      width: "100%",
      height: "100%"
    },
    [`& .${K.rowReorderCellPlaceholder}`]: {
      display: "none"
    },
    [`& .${K["columnHeader--dragging"]}, & .${K["row--dragging"]}`]: {
      background: (e.vars || e).palette.background.paper,
      padding: "0 12px",
      borderRadius: "var(--unstable_DataGrid-radius)",
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`& .${K["row--dragging"]}`]: {
      background: (e.vars || e).palette.background.paper,
      padding: "0 12px",
      borderRadius: "var(--unstable_DataGrid-radius)",
      opacity: (e.vars || e).palette.action.disabledOpacity,
      [`& .${K.rowReorderCellPlaceholder}`]: {
        display: "flex"
      }
    },
    [`& .${K.treeDataGroupingCell}`]: {
      display: "flex",
      alignItems: "center",
      width: "100%"
    },
    [`& .${K.treeDataGroupingCellToggle}`]: {
      flex: "0 0 28px",
      alignSelf: "stretch",
      marginRight: e.spacing(2)
    },
    [`& .${K.treeDataGroupingCellLoadingContainer}, .${K.groupingCriteriaCellLoadingContainer}`]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%"
    },
    [`& .${K.groupingCriteriaCell}`]: {
      display: "flex",
      alignItems: "center",
      width: "100%"
    },
    [`& .${K.groupingCriteriaCellToggle}`]: {
      flex: "0 0 28px",
      alignSelf: "stretch",
      marginRight: e.spacing(2)
    },
    /* ScrollbarFiller styles */
    [`.${K.scrollbarFiller}`]: {
      minWidth: "calc(var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))",
      alignSelf: "stretch",
      [`&.${K["scrollbarFiller--borderTop"]}`]: {
        borderTop: "1px solid var(--DataGrid-rowBorderColor)"
      },
      [`&.${K["scrollbarFiller--borderBottom"]}`]: {
        borderBottom: "1px solid var(--DataGrid-rowBorderColor)"
      },
      [`&.${K["scrollbarFiller--pinnedRight"]}`]: {
        backgroundColor: "var(--DataGrid-pinnedBackground)",
        position: "sticky",
        right: 0
      }
    },
    [`& .${K.filler}`]: {
      flex: "1 0 auto"
    },
    [`& .${K["filler--borderBottom"]}`]: {
      borderBottom: "1px solid var(--DataGrid-rowBorderColor)"
    },
    /* Hide grid rows, row filler, and vertical scrollbar when skeleton overlay is visible */
    [`& .${K["main--hasSkeletonLoadingOverlay"]}`]: {
      [`& .${K.virtualScrollerContent}`]: {
        // We use visibility hidden so that the virtual scroller content retains its height.
        // Position fixed is used to remove the virtual scroller content from the flow.
        // https://github.com/mui/mui-x/issues/14061
        position: "fixed",
        visibility: "hidden"
      },
      [`& .${K["scrollbar--vertical"]}, & .${K.pinnedRows}, & .${K.virtualScroller} > .${K.filler}`]: {
        display: "none"
      }
    }
  });
});
function fQ(e, t, n, o = 1) {
  const s = (c, u) => Math.round((c ** (1 / o) * (1 - n) + u ** (1 / o) * n) ** o), i = Mr(e), a = Mr(t), l = [s(i.values[0], a.values[0]), s(i.values[1], a.values[1]), s(i.values[2], a.values[2])];
  return gu({
    type: "rgb",
    values: l
  });
}
const pQ = (e) => `rgb(from ${e} r g b / 1)`;
function hQ(e, t, n) {
  return `color-mix(in srgb,${e}, ${pQ(t)} calc(${n} * 100%))`;
}
const gQ = () => () => {
}, mQ = () => !1, bQ = () => !0, yQ = () => FC.useSyncExternalStore(gQ, mQ, bQ);
function vQ() {
  var i, a;
  const e = lt(), t = ge(e, Pr), n = Xe(), o = ge(e, Qc), s = e.current.unstable_applyPipeProcessors("preferencePanel", null, o.openedPanelValue ?? zi.filters);
  return /* @__PURE__ */ C(n.slots.panel, I({
    as: n.slots.basePopper,
    open: t.length > 0 && o.open,
    id: o.panelId,
    "aria-labelledby": o.labelId
  }, (i = n.slotProps) == null ? void 0 : i.panel, (a = n.slotProps) == null ? void 0 : a.basePopper, {
    children: s
  }));
}
function CQ() {
  var t;
  const e = Xe();
  return /* @__PURE__ */ ie(h.Fragment, {
    children: [/* @__PURE__ */ C(vQ, {}), e.slots.toolbar && /* @__PURE__ */ C(e.slots.toolbar, I({}, (t = e.slotProps) == null ? void 0 : t.toolbar))]
  });
}
const wQ = ["className", "children"], SQ = (e, t) => {
  const {
    autoHeight: n,
    classes: o,
    showCellVerticalBorder: s
  } = e, i = {
    root: ["root", n && "autoHeight", `root--density${ce(t)}`, e.slots.toolbar === null && "root--noToolbar", "withBorderColor", s && "withVerticalBorder"]
  };
  return fe(i, rt, o);
}, AD = Ct(function(t, n) {
  const o = Xe(), {
    className: s,
    children: i
  } = t, a = ve(t, wQ), l = eo(), c = ge(l, ka), u = l.current.rootElementRef, d = h.useCallback((v) => {
    v !== null && l.current.publishEvent("rootMount", v);
  }, [l]), f = tt(u, n, d), p = o, m = SQ(p, c);
  return yQ() ? null : /* @__PURE__ */ ie(dQ, I({
    className: ae(m.root, s),
    ownerState: p
  }, a, {
    ref: f,
    children: [/* @__PURE__ */ C(CQ, {}), /* @__PURE__ */ C(zX, {
      children: i
    }), /* @__PURE__ */ C(HX, {})]
  }));
});
process.env.NODE_ENV !== "production" && (AD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const xQ = Dr(AD), TQ = ["className"], RQ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["footerContainer", "withBorderColor"]
  }, rt, t);
}, EQ = tn("div", {
  name: "MuiDataGrid",
  slot: "FooterContainer",
  overridesResolver: (e, t) => t.footerContainer
})({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  minHeight: 52,
  borderTop: "1px solid"
}), FD = Ct(function(t, n) {
  const {
    className: o
  } = t, s = ve(t, TQ), i = Xe(), a = RQ(i);
  return /* @__PURE__ */ C(EQ, I({
    className: ae(a.root, o),
    ownerState: i
  }, s, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (FD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const IQ = ["className"], OQ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["overlay"]
  }, rt, t);
}, PQ = tn("div", {
  name: "MuiDataGrid",
  slot: "Overlay",
  overridesResolver: (e, t) => t.overlay
})({
  width: "100%",
  height: "100%",
  display: "flex",
  alignSelf: "center",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "var(--unstable_DataGrid-overlayBackground)"
}), Zp = Ct(function(t, n) {
  const {
    className: o
  } = t, s = ve(t, IQ), i = Xe(), a = OQ(i);
  return /* @__PURE__ */ C(PQ, I({
    className: ae(a.root, o),
    ownerState: i
  }, s, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (Zp.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const MQ = (e) => {
  const {
    classes: t,
    open: n
  } = e;
  return fe({
    root: ["menuIcon", n && "menuOpen"],
    button: ["menuIconButton"]
  }, rt, t);
}, kQ = /* @__PURE__ */ h.memo((e) => {
  var f, p;
  const {
    colDef: t,
    open: n,
    columnMenuId: o,
    columnMenuButtonId: s,
    iconButtonRef: i
  } = e, a = lt(), l = Xe(), c = I({}, e, {
    classes: l.classes
  }), u = MQ(c), d = h.useCallback((m) => {
    m.preventDefault(), m.stopPropagation(), a.current.toggleColumnMenu(t.field);
  }, [a, t.field]);
  return /* @__PURE__ */ C("div", {
    className: u.root,
    children: /* @__PURE__ */ C(l.slots.baseTooltip, I({
      title: a.current.getLocaleText("columnMenuLabel"),
      enterDelay: 1e3
    }, (f = l.slotProps) == null ? void 0 : f.baseTooltip, {
      children: /* @__PURE__ */ C(l.slots.baseIconButton, I({
        ref: i,
        tabIndex: -1,
        className: u.button,
        "aria-label": a.current.getLocaleText("columnMenuLabel"),
        size: "small",
        onClick: d,
        "aria-haspopup": "menu",
        "aria-expanded": n,
        "aria-controls": n ? o : void 0,
        id: s
      }, (p = l.slotProps) == null ? void 0 : p.baseIconButton, {
        children: /* @__PURE__ */ C(l.slots.columnMenuIcon, {
          fontSize: "inherit"
        })
      }))
    }))
  });
});
function LD({
  columnMenuId: e,
  columnMenuButtonId: t,
  ContentComponent: n,
  contentComponentProps: o,
  field: s,
  open: i,
  target: a,
  onExited: l
}) {
  const c = lt(), u = c.current.getColumn(s), d = xe((f) => {
    f && (f.stopPropagation(), a != null && a.contains(f.target)) || c.current.hideColumnMenu();
  });
  return !a || !u ? null : /* @__PURE__ */ C(ku, {
    placement: `bottom-${u.align === "right" ? "start" : "end"}`,
    open: i,
    target: a,
    onClose: d,
    onExited: l,
    children: /* @__PURE__ */ C(n, I({
      colDef: u,
      hideMenu: d,
      open: i,
      id: e,
      labelledby: t
    }, o))
  });
}
process.env.NODE_ENV !== "production" && (LD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  columnMenuButtonId: r.string,
  columnMenuId: r.string,
  ContentComponent: r.elementType.isRequired,
  contentComponentProps: r.any,
  field: r.string.isRequired,
  onExited: r.func,
  open: r.bool.isRequired,
  target: Ko
});
function DQ(e) {
  return e.scrollHeight > e.clientHeight || e.scrollWidth > e.clientWidth;
}
function Hf(e, t) {
  return e.closest(`.${t}`);
}
function Ms(e) {
  return e.replace(/["\\]/g, "\\$&");
}
function NQ(e, t) {
  return e.querySelector(`[role="columnheader"][data-field="${Ms(t)}"]`);
}
function _D(e) {
  return `.${K.row}[data-id="${Ms(String(e))}"]`;
}
function $Q(e, t) {
  return e.querySelector(_D(t));
}
function AQ(e, {
  id: t,
  field: n
}) {
  const o = _D(t), s = `.${K.cell}[data-field="${Ms(n)}"]`, i = `${o} ${s}`;
  return e.querySelector(i);
}
function Ol(e) {
  return (
    // The target is not an element when triggered by a Select inside the cell
    // See https://github.com/mui/material-ui/issues/10534
    e.target.nodeType === 1 && !e.currentTarget.contains(e.target)
  );
}
function FQ(e) {
  return e.getAttribute("data-field");
}
function LQ(e, t) {
  return e.querySelector(`[data-field="${Ms(t)}"]`);
}
function _Q(e) {
  return e.getAttribute("data-fields").slice(2, -2).split("-|-");
}
function VQ(e, t) {
  return Array.from(e.querySelectorAll(`[data-fields*="|-${Ms(t)}-|"]`) ?? []);
}
function BQ(e, t) {
  var a;
  if (!Hf(e, K.root))
    throw new Error("MUI X: The root element is not found.");
  const o = e.getAttribute("aria-colindex");
  if (!o)
    return [];
  const s = Number(o) - 1, i = [];
  return (a = t.virtualScrollerRef) != null && a.current ? (zD(t).forEach((l) => {
    const c = l.getAttribute("data-id");
    if (!c)
      return;
    let u = s;
    const d = t.unstable_getCellColSpanInfo(c, s);
    d && d.spannedByColSpan && (u = d.leftVisibleCellIndex);
    const f = l.querySelector(`[data-colindex="${u}"]`);
    f && i.push(f);
  }), i) : [];
}
function DT(e, t) {
  return e.rootElementRef.current.querySelector(`.${K[t]}`);
}
const VD = ({
  api: e,
  colIndex: t,
  position: n,
  filterFn: o
}) => {
  if (t === null)
    return [];
  const s = [];
  return zD(e).forEach((i) => {
    i.getAttribute("data-id") && i.querySelectorAll(`.${K[n === "left" ? "cell--pinnedLeft" : "cell--pinnedRight"]}`).forEach((l) => {
      const c = Pl(l);
      c !== null && o(c) && s.push(l);
    });
  }), s;
};
function zQ(e, t, n) {
  const o = Pl(t);
  return VD({
    api: e,
    colIndex: o,
    position: n ? "right" : "left",
    filterFn: (s) => n ? s < o : s > o
  });
}
function HQ(e, t, n) {
  const o = Pl(t);
  return VD({
    api: e,
    colIndex: o,
    position: n ? "left" : "right",
    filterFn: (s) => n ? s > o : s < o
  });
}
const BD = ({
  api: e,
  colIndex: t,
  position: n,
  filterFn: o
}) => {
  var i;
  if (!((i = e.columnHeadersContainerRef) != null && i.current))
    return [];
  if (t === null)
    return [];
  const s = [];
  return e.columnHeadersContainerRef.current.querySelectorAll(`.${K[n === "left" ? "columnHeader--pinnedLeft" : "columnHeader--pinnedRight"]}`).forEach((a) => {
    const l = Pl(a);
    l !== null && o(l, a) && s.push(a);
  }), s;
};
function jQ(e, t, n) {
  const o = Pl(t);
  return BD({
    api: e,
    position: n ? "right" : "left",
    colIndex: o,
    filterFn: (s) => n ? s < o : s > o
  });
}
function GQ(e, t, n) {
  const o = Pl(t);
  return BD({
    api: e,
    position: n ? "left" : "right",
    colIndex: o,
    filterFn: (s, i) => i.classList.contains(K["columnHeader--last"]) ? !1 : n ? s > o : s < o
  });
}
function qQ(e, t) {
  return e.columnHeadersContainerRef.current.querySelector(`:scope > div > [data-field="${Ms(t)}"][role="columnheader"]`);
}
function WQ(e, t) {
  const n = e.virtualScrollerRef.current;
  return Array.from(n.querySelectorAll(`:scope > div > div > div > [data-field="${Ms(t)}"][role="gridcell"]`));
}
function zD(e) {
  return e.virtualScrollerRef.current.querySelectorAll(
    // Use > to ignore rows from nested Data Grids (for example in detail panel)
    `:scope > div > div > .${K.row}`
  );
}
function Pl(e) {
  const t = e.getAttribute("aria-colindex");
  return t ? Number(t) - 1 : null;
}
const UQ = ["className", "aria-label"], KQ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["columnHeaderTitle"]
  }, rt, t);
}, YQ = tn("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaderTitle",
  overridesResolver: (e, t) => t.columnHeaderTitle
})({
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  fontWeight: "var(--unstable_DataGrid-headWeight)",
  lineHeight: "normal"
}), XQ = Ct(function(t, n) {
  const {
    className: o
  } = t, s = ve(t, UQ), i = Xe(), a = KQ(i);
  return /* @__PURE__ */ C(YQ, I({
    className: ae(a.root, o),
    ownerState: i
  }, s, {
    ref: n
  }));
});
function HD(e) {
  var c;
  const {
    label: t,
    description: n
  } = e, o = Xe(), s = h.useRef(null), [i, a] = h.useState(""), l = h.useCallback(() => {
    if (!n && (s != null && s.current)) {
      const u = DQ(s.current);
      a(u ? t : "");
    }
  }, [n, t]);
  return /* @__PURE__ */ C(o.slots.baseTooltip, I({
    title: n || i
  }, (c = o.slotProps) == null ? void 0 : c.baseTooltip, {
    children: /* @__PURE__ */ C(XQ, {
      onMouseOver: l,
      ref: s,
      children: t
    })
  }));
}
process.env.NODE_ENV !== "production" && (HD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  columnWidth: r.number.isRequired,
  description: r.node,
  label: r.string.isRequired
});
const QQ = ["resizable", "resizing", "height", "side"];
var l0 = /* @__PURE__ */ function(e) {
  return e.Left = "left", e.Right = "right", e;
}(l0 || {});
const ZQ = (e) => {
  const {
    resizable: t,
    resizing: n,
    classes: o,
    side: s
  } = e, i = {
    root: ["columnSeparator", t && "columnSeparator--resizable", n && "columnSeparator--resizing", s && `columnSeparator--side${ce(s)}`],
    icon: ["iconSeparator"]
  };
  return fe(i, rt, o);
};
function jD(e) {
  const {
    height: t,
    side: n = l0.Right
  } = e, o = ve(e, QQ), s = Xe(), i = I({}, e, {
    side: n,
    classes: s.classes
  }), a = ZQ(i), l = h.useCallback((c) => {
    c.preventDefault(), c.stopPropagation();
  }, []);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ C("div", I({
      className: a.root,
      style: {
        minHeight: t
      }
    }, o, {
      onClick: l,
      children: /* @__PURE__ */ C(s.slots.columnResizeIcon, {
        className: a.icon
      })
    }))
  );
}
const JQ = /* @__PURE__ */ h.memo(jD);
process.env.NODE_ENV !== "production" && (jD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  height: r.number.isRequired,
  resizable: r.bool.isRequired,
  resizing: r.bool.isRequired,
  side: r.oneOf(["left", "right"])
});
const eZ = ["classes", "columnMenuOpen", "colIndex", "height", "isResizing", "sortDirection", "hasFocus", "tabIndex", "separatorSide", "isDraggable", "headerComponent", "description", "elementId", "width", "columnMenuIconButton", "columnMenu", "columnTitleIconButtons", "headerClassName", "label", "resizable", "draggableContainerProps", "columnHeaderSeparatorProps", "style"], GD = Ct(function(t, n) {
  const {
    classes: o,
    colIndex: s,
    height: i,
    isResizing: a,
    sortDirection: l,
    hasFocus: c,
    tabIndex: u,
    separatorSide: d,
    isDraggable: f,
    headerComponent: p,
    description: m,
    width: b,
    columnMenuIconButton: v = null,
    columnMenu: g = null,
    columnTitleIconButtons: y = null,
    headerClassName: w,
    label: x,
    resizable: S,
    draggableContainerProps: T,
    columnHeaderSeparatorProps: E,
    style: O
  } = t, M = ve(t, eZ), D = eo(), R = Xe(), P = h.useRef(null), F = tt(P, n);
  let $ = "none";
  return l != null && ($ = l === "asc" ? "ascending" : "descending"), h.useLayoutEffect(() => {
    var A;
    const N = D.current.state.columnMenu;
    if (c && !N.open) {
      const L = P.current.querySelector('[tabindex="0"]') || P.current;
      L == null || L.focus(), (A = D.current.columnHeadersContainerRef) != null && A.current && (D.current.columnHeadersContainerRef.current.scrollLeft = 0);
    }
  }, [D, c]), /* @__PURE__ */ ie("div", I({
    className: ae(o.root, w),
    style: I({}, O, {
      height: i,
      width: b
    }),
    role: "columnheader",
    tabIndex: u,
    "aria-colindex": s + 1,
    "aria-sort": $
  }, M, {
    ref: F,
    children: [/* @__PURE__ */ ie("div", I({
      className: o.draggableContainer,
      draggable: f,
      role: "presentation"
    }, T, {
      children: [/* @__PURE__ */ ie("div", {
        className: o.titleContainer,
        role: "presentation",
        children: [/* @__PURE__ */ C("div", {
          className: o.titleContainerContent,
          children: p !== void 0 ? p : /* @__PURE__ */ C(HD, {
            label: x,
            description: m,
            columnWidth: b
          })
        }), y]
      }), v]
    })), /* @__PURE__ */ C(JQ, I({
      resizable: !R.disableColumnResize && !!S,
      resizing: a,
      height: i,
      side: d
    }, E)), g]
  }));
}), tZ = (e) => {
  const {
    colDef: t,
    classes: n,
    isDragging: o,
    sortDirection: s,
    showRightBorder: i,
    showLeftBorder: a,
    filterItemsCounter: l,
    pinnedPosition: c,
    isLastUnpinned: u,
    isSiblingFocused: d
  } = e, f = s != null, p = l != null && l > 0, m = t.type === "number", b = {
    root: [
      "columnHeader",
      t.headerAlign === "left" && "columnHeader--alignLeft",
      t.headerAlign === "center" && "columnHeader--alignCenter",
      t.headerAlign === "right" && "columnHeader--alignRight",
      t.sortable && "columnHeader--sortable",
      o && "columnHeader--moving",
      f && "columnHeader--sorted",
      p && "columnHeader--filtered",
      m && "columnHeader--numeric",
      "withBorderColor",
      i && "columnHeader--withRightBorder",
      a && "columnHeader--withLeftBorder",
      c === ut.LEFT && "columnHeader--pinnedLeft",
      c === ut.RIGHT && "columnHeader--pinnedRight",
      // TODO: Remove classes below and restore `:has` selectors when they are supported in jsdom
      // See https://github.com/mui/mui-x/pull/14559
      u && "columnHeader--lastUnpinned",
      d && "columnHeader--siblingFocused"
    ],
    draggableContainer: ["columnHeaderDraggableContainer"],
    titleContainer: ["columnHeaderTitleContainer"],
    titleContainerContent: ["columnHeaderTitleContainerContent"]
  };
  return fe(b, rt, n);
};
function qD(e) {
  var Y, Q, ee;
  const {
    colDef: t,
    columnMenuOpen: n,
    colIndex: o,
    headerHeight: s,
    isResizing: i,
    isLast: a,
    sortDirection: l,
    sortIndex: c,
    filterItemsCounter: u,
    hasFocus: d,
    tabIndex: f,
    disableReorder: p,
    separatorSide: m,
    showLeftBorder: b,
    showRightBorder: v,
    pinnedPosition: g,
    pinnedOffset: y
  } = e, w = eo(), x = Xe(), S = _t(), T = h.useRef(null), E = gt(), O = gt(), M = h.useRef(null), [D, R] = h.useState(n), P = h.useMemo(() => !x.disableColumnReorder && !p && !t.disableReorder, [x.disableColumnReorder, p, t.disableReorder]);
  let F;
  t.renderHeader && (F = t.renderHeader(w.current.getColumnHeaderParams(t.field)));
  const $ = I({}, e, {
    classes: x.classes,
    showRightBorder: v,
    showLeftBorder: b
  }), N = tZ($), A = h.useCallback((ne) => (H) => {
    Ol(H) || w.current.publishEvent(ne, w.current.getColumnHeaderParams(t.field), H);
  }, [w, t.field]), k = h.useMemo(() => ({
    onClick: A("columnHeaderClick"),
    onContextMenu: A("columnHeaderContextMenu"),
    onDoubleClick: A("columnHeaderDoubleClick"),
    onMouseOver: A("columnHeaderOver"),
    // TODO remove as it's not used
    onMouseOut: A("columnHeaderOut"),
    // TODO remove as it's not used
    onMouseEnter: A("columnHeaderEnter"),
    // TODO remove as it's not used
    onMouseLeave: A("columnHeaderLeave"),
    // TODO remove as it's not used
    onKeyDown: A("columnHeaderKeyDown"),
    onFocus: A("columnHeaderFocus"),
    onBlur: A("columnHeaderBlur")
  }), [A]), L = h.useMemo(() => P ? {
    onDragStart: A("columnHeaderDragStart"),
    onDragEnter: A("columnHeaderDragEnter"),
    onDragOver: A("columnHeaderDragOver"),
    onDragEnd: A("columnHeaderDragEnd")
  } : {}, [P, A]), B = h.useMemo(() => ({
    onMouseDown: A("columnSeparatorMouseDown"),
    onDoubleClick: A("columnSeparatorDoubleClick")
  }), [A]);
  h.useEffect(() => {
    D || R(n);
  }, [D, n]);
  const V = h.useCallback(() => {
    R(!1);
  }, []), _ = !x.disableColumnMenu && !t.disableColumnMenu && /* @__PURE__ */ C(kQ, {
    colDef: t,
    columnMenuId: E,
    columnMenuButtonId: O,
    open: D,
    iconButtonRef: M
  }), z = /* @__PURE__ */ C(LD, {
    columnMenuId: E,
    columnMenuButtonId: O,
    field: t.field,
    open: n,
    target: M.current,
    ContentComponent: x.slots.columnMenu,
    contentComponentProps: (Y = x.slotProps) == null ? void 0 : Y.columnMenu,
    onExited: V
  }), j = t.sortingOrder ?? x.sortingOrder, W = (t.sortable || l != null) && !t.hideSortIcons && !x.disableColumnSorting, J = /* @__PURE__ */ ie(h.Fragment, {
    children: [!x.disableColumnFilter && /* @__PURE__ */ C(x.slots.columnHeaderFilterIconButton, I({
      field: t.field,
      counter: u
    }, (Q = x.slotProps) == null ? void 0 : Q.columnHeaderFilterIconButton)), W && /* @__PURE__ */ C(x.slots.columnHeaderSortIcon, I({
      field: t.field,
      direction: l,
      index: c,
      sortingOrder: j,
      disabled: !t.sortable
    }, (ee = x.slotProps) == null ? void 0 : ee.columnHeaderSortIcon))]
  });
  h.useLayoutEffect(() => {
    var H;
    const ne = w.current.state.columnMenu;
    if (d && !ne.open) {
      const X = T.current.querySelector('[tabindex="0"]') || T.current;
      X == null || X.focus(), (H = w.current.columnHeadersContainerRef) != null && H.current && (w.current.columnHeadersContainerRef.current.scrollLeft = 0);
    }
  }, [w, d]);
  const G = typeof t.headerClassName == "function" ? t.headerClassName({
    field: t.field,
    colDef: t
  }) : t.headerClassName, q = t.headerName ?? t.field, Z = h.useMemo(() => _u(I({}, e.style), S, g, y), [g, y, e.style, S]);
  return /* @__PURE__ */ C(GD, I({
    ref: T,
    classes: N,
    columnMenuOpen: n,
    colIndex: o,
    height: s,
    isResizing: i,
    sortDirection: l,
    hasFocus: d,
    tabIndex: f,
    separatorSide: m,
    isDraggable: P,
    headerComponent: F,
    description: t.description,
    elementId: t.field,
    width: t.computedWidth,
    columnMenuIconButton: _,
    columnTitleIconButtons: J,
    headerClassName: ae(G, a && K["columnHeader--last"]),
    label: q,
    resizable: !x.disableColumnResize && !!t.resizable,
    "data-field": t.field,
    columnMenu: z,
    draggableContainerProps: L,
    columnHeaderSeparatorProps: B,
    style: Z
  }, k));
}
process.env.NODE_ENV !== "production" && (qD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: r.object.isRequired,
  colIndex: r.number.isRequired,
  columnMenuOpen: r.bool.isRequired,
  disableReorder: r.bool,
  filterItemsCounter: r.number,
  hasFocus: r.bool,
  headerHeight: r.number.isRequired,
  isDragging: r.bool.isRequired,
  isLast: r.bool.isRequired,
  isLastUnpinned: r.bool.isRequired,
  isResizing: r.bool.isRequired,
  isSiblingFocused: r.bool.isRequired,
  pinnedOffset: r.number,
  pinnedPosition: r.oneOf([0, 1, 2, 3]),
  separatorSide: r.oneOf(["left", "right"]),
  showLeftBorder: r.bool.isRequired,
  showRightBorder: r.bool.isRequired,
  sortDirection: r.oneOf(["asc", "desc"]),
  sortIndex: r.number,
  style: r.object,
  tabIndex: r.oneOf([-1, 0]).isRequired
});
const nZ = Dr(qD), oZ = ["className"], rZ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["iconButtonContainer"]
  }, rt, t);
}, sZ = tn("div", {
  name: "MuiDataGrid",
  slot: "IconButtonContainer",
  overridesResolver: (e, t) => t.iconButtonContainer
})(() => ({
  display: "flex",
  visibility: "hidden",
  width: 0
})), WD = Ct(function(t, n) {
  const {
    className: o
  } = t, s = ve(t, oZ), i = Xe(), a = rZ(i);
  return /* @__PURE__ */ C(sZ, I({
    className: ae(a.root, o),
    ownerState: i
  }, s, {
    ref: n
  }));
}), iZ = ["direction", "index", "sortingOrder", "disabled"], aZ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    icon: ["sortIcon"]
  }, rt, t);
};
function lZ(e, t, n, o) {
  let s;
  const i = {};
  return t === "asc" ? s = e.columnSortedAscendingIcon : t === "desc" ? s = e.columnSortedDescendingIcon : (s = e.columnUnsortedIcon, i.sortingOrder = o), s ? /* @__PURE__ */ C(s, I({
    fontSize: "small",
    className: n
  }, i)) : null;
}
function UD(e) {
  var p;
  const {
    direction: t,
    index: n,
    sortingOrder: o,
    disabled: s
  } = e, i = ve(e, iZ), a = lt(), l = Xe(), c = I({}, e, {
    classes: l.classes
  }), u = aZ(c), d = lZ(l.slots, t, u.icon, o);
  if (!d)
    return null;
  const f = /* @__PURE__ */ C(l.slots.baseIconButton, I({
    tabIndex: -1,
    "aria-label": a.current.getLocaleText("columnHeaderSortIconLabel"),
    title: a.current.getLocaleText("columnHeaderSortIconLabel"),
    size: "small",
    disabled: s
  }, (p = l.slotProps) == null ? void 0 : p.baseIconButton, i, {
    children: d
  }));
  return /* @__PURE__ */ ie(WD, {
    children: [n != null && /* @__PURE__ */ C(l.slots.baseBadge, {
      badgeContent: n,
      color: "default",
      overlap: "circular",
      children: f
    }), n == null && f]
  });
}
const cZ = /* @__PURE__ */ h.memo(UD);
process.env.NODE_ENV !== "production" && (UD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  direction: r.oneOf(["asc", "desc"]),
  disabled: r.bool,
  field: r.string.isRequired,
  index: r.number,
  sortingOrder: r.arrayOf(r.oneOf(["asc", "desc"])).isRequired
});
const uZ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    icon: ["filterIcon"]
  }, rt, t);
};
function KD(e) {
  return e.counter ? /* @__PURE__ */ C(YD, I({}, e)) : null;
}
process.env.NODE_ENV !== "production" && (KD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  counter: r.number,
  field: r.string.isRequired,
  onClick: r.func
});
function YD(e) {
  var m, b;
  const {
    counter: t,
    field: n,
    onClick: o
  } = e, s = lt(), i = Xe(), a = I({}, e, {
    classes: i.classes
  }), l = uZ(a), c = gt(), u = Ys(s, $X, c), d = gt(), f = h.useCallback((v) => {
    v.preventDefault(), v.stopPropagation();
    const {
      open: g,
      openedPanelValue: y
    } = Qc(s.current.state);
    g && y === zi.filters ? s.current.hideFilterPanel() : s.current.showFilterPanel(void 0, d, c), o && o(s.current.getColumnHeaderParams(n), v);
  }, [s, n, o, d, c]);
  if (!t)
    return null;
  const p = /* @__PURE__ */ C(i.slots.baseIconButton, I({
    id: c,
    onClick: f,
    color: "default",
    "aria-label": s.current.getLocaleText("columnHeaderFiltersLabel"),
    size: "small",
    tabIndex: -1,
    "aria-haspopup": "menu",
    "aria-expanded": u,
    "aria-controls": u ? d : void 0
  }, (m = i.slotProps) == null ? void 0 : m.baseIconButton, {
    children: /* @__PURE__ */ C(i.slots.columnFilteredIcon, {
      className: l.icon,
      fontSize: "small"
    })
  }));
  return /* @__PURE__ */ C(i.slots.baseTooltip, I({
    title: s.current.getLocaleText("columnHeaderFiltersTooltipActive")(t),
    enterDelay: 1e3
  }, (b = i.slotProps) == null ? void 0 : b.baseTooltip, {
    children: /* @__PURE__ */ ie(WD, {
      children: [t > 1 && /* @__PURE__ */ C(i.slots.baseBadge, {
        badgeContent: t,
        color: "default",
        children: p
      }), t === 1 && p]
    })
  }));
}
process.env.NODE_ENV !== "production" && (YD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  counter: r.number,
  field: r.string.isRequired,
  onClick: r.func
});
const NT = _e(/* @__PURE__ */ C("path", {
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), "ArrowUpward"), $T = _e(/* @__PURE__ */ C("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward"), AT = _e(/* @__PURE__ */ C("path", {
  d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "KeyboardArrowRight"), FT = _e(/* @__PURE__ */ C("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore"), dZ = _e(/* @__PURE__ */ C("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), "FilterList"), LT = _e(/* @__PURE__ */ C("path", {
  d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), "FilterAlt"), fZ = _e(/* @__PURE__ */ C("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
_e(/* @__PURE__ */ C("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");
_e(/* @__PURE__ */ C("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckCircle");
const pZ = _e(/* @__PURE__ */ C("path", {
  d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), "ColumnIcon"), hZ = _e(/* @__PURE__ */ C("rect", {
  width: "1",
  height: "24",
  x: "11.5",
  rx: "0.5"
}), "Separator"), gZ = _e(/* @__PURE__ */ C("path", {
  d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), "ViewHeadline"), mZ = _e(/* @__PURE__ */ C("path", {
  d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), "TableRows"), bZ = _e(/* @__PURE__ */ C("path", {
  d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), "ViewStream"), yZ = _e(/* @__PURE__ */ C("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "TripleDotsVertical"), Rg = _e(/* @__PURE__ */ C("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), _T = _e(/* @__PURE__ */ C("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add"), vZ = _e(/* @__PURE__ */ C("path", {
  d: "M19 13H5v-2h14v2z"
}), "Remove"), CZ = _e(/* @__PURE__ */ C("path", {
  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), "Load"), VT = _e(/* @__PURE__ */ C("path", {
  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "Drag"), wZ = _e(/* @__PURE__ */ C("path", {
  d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), "SaveAlt"), SZ = _e(/* @__PURE__ */ C("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check"), xZ = _e(/* @__PURE__ */ C("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreVert"), TZ = _e(/* @__PURE__ */ C("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), "VisibilityOff"), RZ = _e(/* @__PURE__ */ C("g", {
  children: /* @__PURE__ */ C("path", {
    d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
  })
}), "ViewColumn"), EZ = _e(/* @__PURE__ */ C("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
_e(/* @__PURE__ */ C("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
const IZ = _e(/* @__PURE__ */ C("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
function XD(e) {
  return e.key.length === 1 && !e.ctrlKey && !e.metaKey;
}
const Zc = (e) => e.indexOf("Arrow") === 0 || e.indexOf("Page") === 0 || e === " " || e === "Home" || e === "End", OZ = (e) => !!e.key, QD = (e) => e === "Tab" || e === "Escape";
function ZD(e) {
  return (e.ctrlKey || e.metaKey) && // We can't use event.code === 'KeyV' as event.code assumes a QWERTY keyboard layout,
  // for example, it would be another letter on a Dvorak physical keyboard.
  // We can't use event.key === 'v' as event.key is not stable with key modifiers and keyboard layouts,
  // for example, it would be ה on a Hebrew keyboard layout.
  // https://github.com/w3c/uievents/issues/377 could be a long-term solution
  String.fromCharCode(e.keyCode) === "V" && !e.shiftKey && !e.altKey;
}
function PZ(e) {
  return (e.ctrlKey || e.metaKey) && String.fromCharCode(e.keyCode) === "C" && !e.shiftKey && !e.altKey;
}
const MZ = ["hideMenu", "colDef", "id", "labelledby", "className", "children", "open"], kZ = te(Zi)(() => ({
  minWidth: 248
})), JD = Ct(function(t, n) {
  const {
    hideMenu: o,
    id: s,
    labelledby: i,
    className: a,
    children: l,
    open: c
  } = t, u = ve(t, MZ), d = h.useCallback((f) => {
    f.key === "Tab" && f.preventDefault(), QD(f.key) && o(f);
  }, [o]);
  return /* @__PURE__ */ C(kZ, I({
    id: s,
    className: ae(K.menuList, a),
    "aria-labelledby": i,
    onKeyDown: d,
    autoFocus: c
  }, u, {
    ref: n,
    children: l
  }));
});
process.env.NODE_ENV !== "production" && (JD.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: r.object.isRequired,
  hideMenu: r.func.isRequired,
  id: r.string,
  labelledby: r.string,
  open: r.bool.isRequired
});
const DZ = ["displayOrder"], NZ = (e) => {
  const t = eo(), n = Xe(), {
    defaultSlots: o,
    defaultSlotProps: s,
    slots: i = {},
    slotProps: a = {},
    hideMenu: l,
    colDef: c,
    addDividers: u = !0
  } = e, d = h.useMemo(() => I({}, o, i), [o, i]), f = h.useMemo(() => {
    if (!a || Object.keys(a).length === 0)
      return s;
    const b = I({}, a);
    return Object.entries(s).forEach(([v, g]) => {
      b[v] = I({}, g, a[v] || {});
    }), b;
  }, [s, a]), p = t.current.unstable_applyPipeProcessors("columnMenu", [], e.colDef), m = h.useMemo(() => {
    const b = Object.keys(o);
    return Object.keys(i).filter((v) => !b.includes(v));
  }, [i, o]);
  return h.useMemo(() => {
    const g = Array.from(/* @__PURE__ */ new Set([...p, ...m])).filter((y) => d[y] != null).sort((y, w) => {
      const x = f[y], S = f[w], T = Number.isFinite(x == null ? void 0 : x.displayOrder) ? x.displayOrder : 100, E = Number.isFinite(S == null ? void 0 : S.displayOrder) ? S.displayOrder : 100;
      return T - E;
    });
    return g.reduce((y, w, x) => {
      let S = {
        colDef: c,
        onClick: l
      };
      const T = f[w];
      if (T) {
        const E = ve(T, DZ);
        S = I({}, S, E);
      }
      return u && x !== g.length - 1 ? [...y, [d[w], S], [n.slots.baseDivider, {}]] : [...y, [d[w], S]];
    }, []);
  }, [u, c, p, l, d, f, m, n.slots.baseDivider]);
};
function e2(e) {
  const {
    colDef: t,
    onClick: n
  } = e, o = lt(), s = Xe(), l = pn(o).filter((u) => u.disableColumnMenu !== !0).length === 1, c = h.useCallback((u) => {
    l || (o.current.setColumnVisibility(t.field, !1), n(u));
  }, [o, t.field, n, l]);
  return s.disableColumnSelector || t.hideable === !1 ? null : /* @__PURE__ */ ie(Nn, {
    onClick: c,
    disabled: l,
    children: [/* @__PURE__ */ C(ur, {
      children: /* @__PURE__ */ C(s.slots.columnMenuHideIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ C(Ho, {
      children: o.current.getLocaleText("columnMenuHideColumn")
    })]
  });
}
process.env.NODE_ENV !== "production" && (e2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: r.object.isRequired,
  onClick: r.func.isRequired
});
function t2(e) {
  const {
    onClick: t
  } = e, n = lt(), o = Xe(), s = h.useCallback((i) => {
    t(i), n.current.showPreferences(zi.columns);
  }, [n, t]);
  return o.disableColumnSelector ? null : /* @__PURE__ */ ie(Nn, {
    onClick: s,
    children: [/* @__PURE__ */ C(ur, {
      children: /* @__PURE__ */ C(o.slots.columnMenuManageColumnsIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ C(Ho, {
      children: n.current.getLocaleText("columnMenuManageColumns")
    })]
  });
}
process.env.NODE_ENV !== "production" && (t2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: r.object.isRequired,
  onClick: r.func.isRequired
});
function n2(e) {
  return /* @__PURE__ */ ie(h.Fragment, {
    children: [/* @__PURE__ */ C(e2, I({}, e)), /* @__PURE__ */ C(t2, I({}, e))]
  });
}
process.env.NODE_ENV !== "production" && (n2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: r.object.isRequired,
  onClick: r.func.isRequired
});
function o2(e) {
  const {
    colDef: t,
    onClick: n
  } = e, o = lt(), s = Xe(), i = h.useCallback((a) => {
    n(a), o.current.showFilterPanel(t.field);
  }, [o, t.field, n]);
  return s.disableColumnFilter || !t.filterable ? null : /* @__PURE__ */ ie(Nn, {
    onClick: i,
    children: [/* @__PURE__ */ C(ur, {
      children: /* @__PURE__ */ C(s.slots.columnMenuFilterIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ C(Ho, {
      children: o.current.getLocaleText("columnMenuFilter")
    })]
  });
}
process.env.NODE_ENV !== "production" && (o2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: r.object.isRequired,
  onClick: r.func.isRequired
});
function r2(e) {
  const {
    colDef: t,
    onClick: n
  } = e, o = lt(), s = ge(o, uo), i = Xe(), a = h.useMemo(() => {
    if (!t)
      return null;
    const d = s.find((f) => f.field === t.field);
    return d == null ? void 0 : d.sort;
  }, [t, s]), l = t.sortingOrder ?? i.sortingOrder, c = h.useCallback((d) => {
    n(d);
    const f = d.currentTarget.getAttribute("data-value") || null;
    o.current.sortColumn(t.field, f === a ? null : f);
  }, [o, t, n, a]);
  if (i.disableColumnSorting || !t || !t.sortable || !l.some((d) => !!d))
    return null;
  const u = (d) => {
    const f = o.current.getLocaleText(d);
    return typeof f == "function" ? f(t) : f;
  };
  return /* @__PURE__ */ ie(h.Fragment, {
    children: [l.includes("asc") && a !== "asc" ? /* @__PURE__ */ ie(Nn, {
      onClick: c,
      "data-value": "asc",
      children: [/* @__PURE__ */ C(ur, {
        children: /* @__PURE__ */ C(i.slots.columnMenuSortAscendingIcon, {
          fontSize: "small"
        })
      }), /* @__PURE__ */ C(Ho, {
        children: u("columnMenuSortAsc")
      })]
    }) : null, l.includes("desc") && a !== "desc" ? /* @__PURE__ */ ie(Nn, {
      onClick: c,
      "data-value": "desc",
      children: [/* @__PURE__ */ C(ur, {
        children: /* @__PURE__ */ C(i.slots.columnMenuSortDescendingIcon, {
          fontSize: "small"
        })
      }), /* @__PURE__ */ C(Ho, {
        children: u("columnMenuSortDesc")
      })]
    }) : null, l.includes(null) && a != null ? /* @__PURE__ */ ie(Nn, {
      onClick: c,
      children: [/* @__PURE__ */ C(ur, {}), /* @__PURE__ */ C(Ho, {
        children: o.current.getLocaleText("columnMenuUnsort")
      })]
    }) : null]
  });
}
process.env.NODE_ENV !== "production" && (r2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: r.object.isRequired,
  onClick: r.func.isRequired
});
const $Z = ["defaultSlots", "defaultSlotProps", "slots", "slotProps"], s2 = {
  columnMenuSortItem: r2,
  columnMenuFilterItem: o2,
  columnMenuColumnsItem: n2
}, i2 = {
  columnMenuSortItem: {
    displayOrder: 10
  },
  columnMenuFilterItem: {
    displayOrder: 20
  },
  columnMenuColumnsItem: {
    displayOrder: 30
  }
}, c0 = Ct(function(t, n) {
  const {
    defaultSlots: o,
    defaultSlotProps: s,
    slots: i,
    slotProps: a
  } = t, l = ve(t, $Z), c = NZ(I({}, l, {
    defaultSlots: o,
    defaultSlotProps: s,
    slots: i,
    slotProps: a
  }));
  return /* @__PURE__ */ C(JD, I({}, l, {
    ref: n,
    children: c.map(([u, d], f) => /* @__PURE__ */ C(u, I({}, d), f))
  }));
});
process.env.NODE_ENV !== "production" && (c0.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: r.object.isRequired,
  /**
   * Initial `slotProps` - it is internal, to be overrriden by Pro or Premium packages
   * @ignore - do not document.
   */
  defaultSlotProps: r.object.isRequired,
  /**
   * Initial `slots` - it is internal, to be overrriden by Pro or Premium packages
   * @ignore - do not document.
   */
  defaultSlots: r.object.isRequired,
  hideMenu: r.func.isRequired,
  id: r.string,
  labelledby: r.string,
  open: r.bool.isRequired,
  /**
   * Could be used to pass new props or override props specific to a column menu component
   * e.g. `displayOrder`
   */
  slotProps: r.object,
  /**
   * `slots` could be used to add new and (or) override default column menu items
   * If you register a nee component you must pass it's `displayOrder` in `slotProps`
   * or it will be placed in the end of the list
   */
  slots: r.object
});
const a2 = Ct(function(t, n) {
  return /* @__PURE__ */ C(c0, I({}, t, {
    ref: n,
    defaultSlots: s2,
    defaultSlotProps: i2
  }));
});
process.env.NODE_ENV !== "production" && (a2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: r.object.isRequired,
  hideMenu: r.func.isRequired,
  id: r.string,
  labelledby: r.string,
  open: r.bool.isRequired,
  /**
   * Could be used to pass new props or override props specific to a column menu component
   * e.g. `displayOrder`
   */
  slotProps: r.object,
  /**
   * `slots` could be used to add new and (or) override default column menu items
   * If you register a nee component you must pass it's `displayOrder` in `slotProps`
   * or it will be placed in the end of the list
   */
  slots: r.object
});
const AZ = ["className", "slotProps"], FZ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["panelWrapper"]
  }, rt, t);
}, LZ = te("div", {
  name: "MuiDataGrid",
  slot: "PanelWrapper",
  overridesResolver: (e, t) => t.panelWrapper
})({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  "&:focus": {
    outline: 0
  }
}), _Z = () => !0, u0 = Ct(function(t, n) {
  const {
    className: o,
    slotProps: s = {}
  } = t, i = ve(t, AZ), a = Xe(), l = FZ(a);
  return /* @__PURE__ */ C(nl, I({
    open: !0,
    disableEnforceFocus: !0,
    isEnabled: _Z
  }, s.TrapFocus, {
    children: /* @__PURE__ */ C(LZ, I({
      tabIndex: -1,
      className: ae(l.root, o),
      ownerState: a
    }, i, {
      ref: n
    }))
  }));
});
process.env.NODE_ENV !== "production" && (u0.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  slotProps: r.object
});
function l2(e) {
  var n;
  const t = Xe();
  return /* @__PURE__ */ C(u0, I({}, e, {
    children: /* @__PURE__ */ C(t.slots.columnsManagement, I({}, (n = t.slotProps) == null ? void 0 : n.columnsManagement))
  }));
}
process.env.NODE_ENV !== "production" && (l2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  slotProps: r.object
});
const VZ = ["children", "className", "classes"], BZ = Ne("MuiDataGrid", ["panel", "paper"]), zZ = te(is, {
  name: "MuiDataGrid",
  slot: "Panel",
  overridesResolver: (e, t) => t.panel
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), HZ = te(ao, {
  name: "MuiDataGrid",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  minWidth: 300,
  maxHeight: 450,
  display: "flex",
  maxWidth: `calc(100vw - ${e.spacing(0.5)})`,
  overflow: "auto"
})), c2 = Ct((e, t) => {
  const {
    children: n,
    className: o
  } = e, s = ve(e, VZ), i = lt(), a = Xe(), l = BZ, [c, u] = h.useState(!1), d = h.useCallback(() => {
    i.current.hidePreferences();
  }, [i]), f = h.useCallback((v) => {
    v.key === "Escape" && i.current.hidePreferences();
  }, [i]), p = h.useMemo(() => [{
    name: "flip",
    enabled: !0,
    options: {
      rootBoundary: "document"
    }
  }, {
    name: "isPlaced",
    enabled: !0,
    phase: "main",
    fn: () => {
      u(!0);
    },
    effect: () => () => {
      u(!1);
    }
  }], []), [m, b] = h.useState(null);
  return h.useEffect(() => {
    var g, y;
    const v = (y = (g = i.current.rootElementRef) == null ? void 0 : g.current) == null ? void 0 : y.querySelector('[data-id="gridPanelAnchor"]');
    v && b(v);
  }, [i]), m ? /* @__PURE__ */ C(zZ, I({
    placement: "bottom-start",
    className: ae(l.panel, o),
    ownerState: a,
    anchorEl: m,
    modifiers: p
  }, s, {
    ref: t,
    children: /* @__PURE__ */ C(tl, {
      mouseEvent: "onPointerUp",
      touchEvent: !1,
      onClickAway: d,
      children: /* @__PURE__ */ C(HZ, {
        className: l.paper,
        ownerState: a,
        elevation: 8,
        onKeyDown: f,
        children: c && n
      })
    })
  })) : null;
});
process.env.NODE_ENV !== "production" && (c2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Popper render function or node.
   */
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * If `true`, the component is shown.
   */
  open: r.bool.isRequired,
  ownerState: r.object
});
const jZ = ["className"], GZ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["panelContent"]
  }, rt, t);
}, qZ = tn("div", {
  name: "MuiDataGrid",
  slot: "PanelContent",
  overridesResolver: (e, t) => t.panelContent
})({
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  flex: "1 1",
  maxHeight: 400
});
function u2(e) {
  const {
    className: t
  } = e, n = ve(e, jZ), o = Xe(), s = GZ(o);
  return /* @__PURE__ */ C(qZ, I({
    className: ae(s.root, t),
    ownerState: o
  }, n));
}
process.env.NODE_ENV !== "production" && (u2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const WZ = ["className"], UZ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["panelFooter"]
  }, rt, t);
}, KZ = tn("div", {
  name: "MuiDataGrid",
  slot: "PanelFooter",
  overridesResolver: (e, t) => t.panelFooter
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5),
  display: "flex",
  justifyContent: "space-between"
}));
function d2(e) {
  const {
    className: t
  } = e, n = ve(e, WZ), o = Xe(), s = UZ(o);
  return /* @__PURE__ */ C(KZ, I({
    className: ae(s.root, t),
    ownerState: o
  }, n));
}
process.env.NODE_ENV !== "production" && (d2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const YZ = ["item", "hasMultipleFilters", "deleteFilter", "applyFilterChanges", "showMultiFilterOperators", "disableMultiFilterOperator", "applyMultiFilterOperatorChanges", "focusElementRef", "logicOperators", "columnsSort", "filterColumns", "deleteIconProps", "logicOperatorInputProps", "operatorInputProps", "columnInputProps", "valueInputProps", "readOnly", "children"], XZ = ["InputComponentProps"], QZ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["filterForm"],
    deleteIcon: ["filterFormDeleteIcon"],
    logicOperatorInput: ["filterFormLogicOperatorInput"],
    columnInput: ["filterFormColumnInput"],
    operatorInput: ["filterFormOperatorInput"],
    valueInput: ["filterFormValueInput"]
  }, rt, t);
}, ZZ = te("div", {
  name: "MuiDataGrid",
  slot: "FilterForm",
  overridesResolver: (e, t) => t.filterForm
})(({
  theme: e
}) => ({
  display: "flex",
  padding: e.spacing(1)
})), JZ = te("div", {
  name: "MuiDataGrid",
  slot: "FilterFormDeleteIcon",
  overridesResolver: (e, t) => t.filterFormDeleteIcon
})(({
  theme: e
}) => ({
  flexShrink: 0,
  justifyContent: "flex-end",
  marginRight: e.spacing(0.5),
  marginBottom: e.spacing(0.2)
})), eJ = te("div", {
  name: "MuiDataGrid",
  slot: "FilterFormLogicOperatorInput",
  overridesResolver: (e, t) => t.filterFormLogicOperatorInput
})({
  minWidth: 55,
  marginRight: 5,
  justifyContent: "end"
}), tJ = te("div", {
  name: "MuiDataGrid",
  slot: "FilterFormColumnInput",
  overridesResolver: (e, t) => t.filterFormColumnInput
})({
  width: 150
}), nJ = te("div", {
  name: "MuiDataGrid",
  slot: "FilterFormOperatorInput",
  overridesResolver: (e, t) => t.filterFormOperatorInput
})({
  width: 150
}), oJ = te("div", {
  name: "MuiDataGrid",
  slot: "FilterFormValueInput",
  overridesResolver: (e, t) => t.filterFormValueInput
})({
  width: 190
}), rJ = (e) => {
  switch (e) {
    case ho.And:
      return "filterPanelOperatorAnd";
    case ho.Or:
      return "filterPanelOperatorOr";
    default:
      throw new Error("MUI X: Invalid `logicOperator` property in the `GridFilterPanel`.");
  }
}, Kl = (e) => e.headerName || e.field, BT = new Intl.Collator(), Dy = Ct(function(t, n) {
  var re, oe, le, se, Ce, $e, we, Te, ue;
  const {
    item: o,
    hasMultipleFilters: s,
    deleteFilter: i,
    applyFilterChanges: a,
    showMultiFilterOperators: l,
    disableMultiFilterOperator: c,
    applyMultiFilterOperatorChanges: u,
    focusElementRef: d,
    logicOperators: f = [ho.And, ho.Or],
    columnsSort: p,
    filterColumns: m,
    deleteIconProps: b = {},
    logicOperatorInputProps: v = {},
    operatorInputProps: g = {},
    columnInputProps: y = {},
    valueInputProps: w = {},
    readOnly: x
  } = t, S = ve(t, YZ), T = lt(), E = ge(T, as), O = ge(T, Mk), M = ge(T, kn), D = gt(), R = gt(), P = gt(), F = gt(), $ = Xe(), N = QZ($), A = h.useRef(null), k = h.useRef(null), L = M.logicOperator ?? ho.And, B = s && f.length > 0, V = ((re = $.slotProps) == null ? void 0 : re.baseFormControl) || {}, z = (((oe = $.slotProps) == null ? void 0 : oe.baseSelect) || {}).native ?? !1, j = ((le = $.slotProps) == null ? void 0 : le.baseInputLabel) || {}, W = ((se = $.slotProps) == null ? void 0 : se.baseSelectOption) || {}, {
    InputComponentProps: J
  } = w, G = ve(w, XZ), {
    filteredColumns: q,
    selectedField: Z
  } = h.useMemo(() => {
    let de = o.field;
    const Pe = E[o.field].filterable === !1 ? E[o.field] : null;
    if (Pe)
      return {
        filteredColumns: [Pe],
        selectedField: de
      };
    if (m === void 0 || typeof m != "function")
      return {
        filteredColumns: O,
        selectedField: de
      };
    const ke = m({
      field: o.field,
      columns: O,
      currentFilters: (M == null ? void 0 : M.items) || []
    });
    return {
      filteredColumns: O.filter((Me) => {
        const be = ke.includes(Me.field);
        return Me.field === o.field && !be && (de = void 0), be;
      }),
      selectedField: de
    };
  }, [m, M == null ? void 0 : M.items, O, o.field, E]), Y = h.useMemo(() => {
    switch (p) {
      case "asc":
        return q.sort((de, Pe) => BT.compare(Kl(de), Kl(Pe)));
      case "desc":
        return q.sort((de, Pe) => -BT.compare(Kl(de), Kl(Pe)));
      default:
        return q;
    }
  }, [q, p]), Q = o.field ? T.current.getColumn(o.field) : null, ee = h.useMemo(() => {
    var de;
    return !o.operator || !Q ? null : (de = Q.filterOperators) == null ? void 0 : de.find((Pe) => Pe.value === o.operator);
  }, [o, Q]), ne = h.useCallback((de) => {
    const Pe = de.target.value, ke = T.current.getColumn(Pe);
    if (ke.field === Q.field)
      return;
    const Me = ke.filterOperators.find((Ae) => Ae.value === o.operator) || ke.filterOperators[0];
    let me = !Me.InputComponent || Me.InputComponent !== (ee == null ? void 0 : ee.InputComponent) || ke.type !== Q.type ? void 0 : o.value;
    if (ke.type === "singleSelect" && me !== void 0) {
      const Ae = ke, ye = Vi(Ae);
      Array.isArray(me) ? me = me.filter((We) => (
        // Only keep values that are in the new value options
        Vf(We, ye, Ae == null ? void 0 : Ae.getOptionValue) !== void 0
      )) : Vf(o.value, ye, Ae == null ? void 0 : Ae.getOptionValue) === void 0 && (me = void 0);
    }
    a(I({}, o, {
      field: Pe,
      operator: Me.value,
      value: me
    }));
  }, [T, a, o, Q, ee]), H = h.useCallback((de) => {
    const Pe = de.target.value, ke = Q == null ? void 0 : Q.filterOperators.find((be) => be.value === Pe), Me = !(ke != null && ke.InputComponent) || (ke == null ? void 0 : ke.InputComponent) !== (ee == null ? void 0 : ee.InputComponent);
    a(I({}, o, {
      operator: Pe,
      value: Me ? void 0 : o.value
    }));
  }, [a, o, Q, ee]), U = h.useCallback((de) => {
    const Pe = de.target.value === ho.And.toString() ? ho.And : ho.Or;
    u(Pe);
  }, [u]), X = () => {
    i(o);
  };
  return h.useImperativeHandle(d, () => ({
    focus: () => {
      var de;
      ee != null && ee.InputComponent ? (de = A == null ? void 0 : A.current) == null || de.focus() : k.current.focus();
    }
  }), [ee]), /* @__PURE__ */ ie(ZZ, I({
    className: N.root,
    "data-id": o.id,
    ownerState: $
  }, S, {
    ref: n,
    children: [/* @__PURE__ */ C(JZ, I({
      variant: "standard",
      as: $.slots.baseFormControl
    }, V, b, {
      className: ae(N.deleteIcon, V.className, b.className),
      ownerState: $,
      children: /* @__PURE__ */ C($.slots.baseIconButton, I({
        "aria-label": T.current.getLocaleText("filterPanelDeleteIconLabel"),
        title: T.current.getLocaleText("filterPanelDeleteIconLabel"),
        onClick: X,
        size: "small",
        disabled: x
      }, (Ce = $.slotProps) == null ? void 0 : Ce.baseIconButton, {
        children: /* @__PURE__ */ C($.slots.filterPanelDeleteIcon, {
          fontSize: "small"
        })
      }))
    })), /* @__PURE__ */ C(eJ, I({
      variant: "standard",
      as: $.slots.baseFormControl
    }, V, v, {
      sx: [B ? {
        display: "flex"
      } : {
        display: "none"
      }, l ? {
        visibility: "visible"
      } : {
        visibility: "hidden"
      }, V.sx, v.sx],
      className: ae(N.logicOperatorInput, V.className, v.className),
      ownerState: $,
      children: /* @__PURE__ */ C($.slots.baseSelect, I({
        inputProps: {
          "aria-label": T.current.getLocaleText("filterPanelLogicOperator")
        },
        value: L ?? "",
        onChange: U,
        disabled: !!c || f.length === 1,
        native: z
      }, ($e = $.slotProps) == null ? void 0 : $e.baseSelect, {
        children: f.map((de) => /* @__PURE__ */ js($.slots.baseSelectOption, I({}, W, {
          native: z,
          key: de.toString(),
          value: de.toString()
        }), T.current.getLocaleText(rJ(de))))
      }))
    })), /* @__PURE__ */ ie(tJ, I({
      variant: "standard",
      as: $.slots.baseFormControl
    }, V, y, {
      className: ae(N.columnInput, V.className, y.className),
      ownerState: $,
      children: [/* @__PURE__ */ C($.slots.baseInputLabel, I({}, j, {
        htmlFor: D,
        id: R,
        children: T.current.getLocaleText("filterPanelColumns")
      })), /* @__PURE__ */ C($.slots.baseSelect, I({
        labelId: R,
        id: D,
        label: T.current.getLocaleText("filterPanelColumns"),
        value: Z ?? "",
        onChange: ne,
        native: z,
        disabled: x
      }, (we = $.slotProps) == null ? void 0 : we.baseSelect, {
        children: Y.map((de) => /* @__PURE__ */ js($.slots.baseSelectOption, I({}, W, {
          native: z,
          key: de.field,
          value: de.field
        }), Kl(de)))
      }))]
    })), /* @__PURE__ */ ie(nJ, I({
      variant: "standard",
      as: $.slots.baseFormControl
    }, V, g, {
      className: ae(N.operatorInput, V.className, g.className),
      ownerState: $,
      children: [/* @__PURE__ */ C($.slots.baseInputLabel, I({}, j, {
        htmlFor: P,
        id: F,
        children: T.current.getLocaleText("filterPanelOperator")
      })), /* @__PURE__ */ C($.slots.baseSelect, I({
        labelId: F,
        label: T.current.getLocaleText("filterPanelOperator"),
        id: P,
        value: o.operator,
        onChange: H,
        native: z,
        inputRef: k,
        disabled: x
      }, (Te = $.slotProps) == null ? void 0 : Te.baseSelect, {
        children: (ue = Q == null ? void 0 : Q.filterOperators) == null ? void 0 : ue.map((de) => /* @__PURE__ */ js($.slots.baseSelectOption, I({}, W, {
          native: z,
          key: de.value,
          value: de.value
        }), de.label || T.current.getLocaleText(`filterOperator${ce(de.value)}`)))
      }))]
    })), /* @__PURE__ */ C(oJ, I({
      variant: "standard",
      as: $.slots.baseFormControl
    }, V, G, {
      className: ae(N.valueInput, V.className, G.className),
      ownerState: $,
      children: ee != null && ee.InputComponent ? /* @__PURE__ */ C(ee.InputComponent, I({
        apiRef: T,
        item: o,
        applyValue: a,
        focusElementRef: A,
        disabled: x
      }, ee.InputComponentProps, J), o.field) : null
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (Dy.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Callback called when the operator, column field or value is changed.
   * @param {GridFilterItem} item The updated [[GridFilterItem]].
   */
  applyFilterChanges: r.func.isRequired,
  /**
   * Callback called when the logic operator is changed.
   * @param {GridLogicOperator} operator The new logic operator.
   */
  applyMultiFilterOperatorChanges: r.func.isRequired,
  /**
   * @ignore - do not document.
   */
  children: r.node,
  /**
   * Props passed to the column input component.
   * @default {}
   */
  columnInputProps: r.any,
  /**
   * Changes how the options in the columns selector should be ordered.
   * If not specified, the order is derived from the `columns` prop.
   */
  columnsSort: r.oneOf(["asc", "desc"]),
  /**
   * Callback called when the delete button is clicked.
   * @param {GridFilterItem} item The deleted [[GridFilterItem]].
   */
  deleteFilter: r.func.isRequired,
  /**
   * Props passed to the delete icon.
   * @default {}
   */
  deleteIconProps: r.any,
  /**
   * If `true`, disables the logic operator field but still renders it.
   */
  disableMultiFilterOperator: r.bool,
  /**
   * Allows to filter the columns displayed in the filter form.
   * @param {FilterColumnsArgs} args The columns of the grid and name of field.
   * @returns {GridColDef['field'][]} The filtered fields array.
   */
  filterColumns: r.func,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the el
   */
  focusElementRef: r.oneOfType([r.func, r.object]),
  /**
   * If `true`, the logic operator field is rendered.
   * The field will be invisible if `showMultiFilterOperators` is also `true`.
   */
  hasMultipleFilters: r.bool.isRequired,
  /**
   * The [[GridFilterItem]] representing this form.
   */
  item: r.shape({
    field: r.string.isRequired,
    id: r.oneOfType([r.number, r.string]),
    operator: r.string.isRequired,
    value: r.any
  }).isRequired,
  /**
   * Props passed to the logic operator input component.
   * @default {}
   */
  logicOperatorInputProps: r.any,
  /**
   * Sets the available logic operators.
   * @default [GridLogicOperator.And, GridLogicOperator.Or]
   */
  logicOperators: r.arrayOf(r.oneOf(["and", "or"]).isRequired),
  /**
   * Props passed to the operator input component.
   * @default {}
   */
  operatorInputProps: r.any,
  /**
   * `true` if the filter is disabled/read only.
   * i.e. `colDef.fiterable = false` but passed in `filterModel`
   * @default false
   */
  readOnly: r.bool,
  /**
   * If `true`, the logic operator field is visible.
   */
  showMultiFilterOperators: r.bool,
  /**
   * Props passed to the value input component.
   * @default {}
   */
  valueInputProps: r.any
});
const sJ = ["logicOperators", "columnsSort", "filterFormProps", "getColumnForNewFilter", "children", "disableAddFilterButton", "disableRemoveAllButton"], Ny = (e) => ({
  field: e.field,
  operator: e.filterOperators[0].value,
  id: Math.round(Math.random() * 1e5)
}), f2 = Ct(function(t, n) {
  var F, $;
  const o = lt(), s = Xe(), i = ge(o, kn), a = ge(o, Mk), l = ge(o, kk), c = h.useRef(null), u = h.useRef(null), {
    logicOperators: d = [ho.And, ho.Or],
    columnsSort: f,
    filterFormProps: p,
    getColumnForNewFilter: m,
    disableAddFilterButton: b = !1,
    disableRemoveAllButton: v = !1
  } = t, g = ve(t, sJ), y = o.current.upsertFilterItem, w = h.useCallback((N) => {
    o.current.setFilterLogicOperator(N);
  }, [o]), x = h.useCallback(() => {
    let N;
    if (m && typeof m == "function") {
      const A = m({
        currentFilters: (i == null ? void 0 : i.items) || [],
        columns: a
      });
      if (A === null)
        return null;
      N = a.find(({
        field: k
      }) => k === A);
    } else
      N = a.find((A) => {
        var k;
        return (k = A.filterOperators) == null ? void 0 : k.length;
      });
    return N ? Ny(N) : null;
  }, [i == null ? void 0 : i.items, a, m]), S = h.useCallback(() => {
    if (m === void 0 || typeof m != "function")
      return x();
    const N = i.items.length ? i.items : [x()].filter(Boolean), A = m({
      currentFilters: N,
      columns: a
    });
    if (A === null)
      return null;
    const k = a.find(({
      field: L
    }) => L === A);
    return k ? Ny(k) : null;
  }, [i.items, a, m, x]), T = h.useMemo(() => i.items.length ? i.items : (u.current || (u.current = x()), u.current ? [u.current] : []), [i.items, x]), E = T.length > 1, {
    readOnlyFilters: O,
    validFilters: M
  } = h.useMemo(() => T.reduce((N, A) => (l[A.field] ? N.validFilters.push(A) : N.readOnlyFilters.push(A), N), {
    readOnlyFilters: [],
    validFilters: []
  }), [T, l]), D = h.useCallback(() => {
    const N = S();
    N && o.current.upsertFilterItems([...T, N]);
  }, [o, S, T]), R = h.useCallback((N) => {
    const A = M.length === 1;
    o.current.deleteFilterItem(N), A && o.current.hideFilterPanel();
  }, [o, M.length]), P = h.useCallback(() => M.length === 1 && M[0].value === void 0 ? (o.current.deleteFilterItem(M[0]), o.current.hideFilterPanel()) : o.current.setFilterModel(I({}, i, {
    items: O
  }), "removeAllFilterItems"), [o, O, i, M]);
  return h.useEffect(() => {
    d.length > 0 && i.logicOperator && !d.includes(i.logicOperator) && w(d[0]);
  }, [d, w, i.logicOperator]), h.useEffect(() => {
    M.length > 0 && c.current.focus();
  }, [M.length]), /* @__PURE__ */ ie(u0, I({}, g, {
    ref: n,
    children: [/* @__PURE__ */ ie(u2, {
      children: [O.map((N, A) => /* @__PURE__ */ C(Dy, I({
        item: N,
        applyFilterChanges: y,
        deleteFilter: R,
        hasMultipleFilters: E,
        showMultiFilterOperators: A > 0,
        disableMultiFilterOperator: A !== 1,
        applyMultiFilterOperatorChanges: w,
        focusElementRef: null,
        readOnly: !0,
        logicOperators: d,
        columnsSort: f
      }, p), N.id == null ? A : N.id)), M.map((N, A) => /* @__PURE__ */ C(Dy, I({
        item: N,
        applyFilterChanges: y,
        deleteFilter: R,
        hasMultipleFilters: E,
        showMultiFilterOperators: O.length + A > 0,
        disableMultiFilterOperator: O.length + A !== 1,
        applyMultiFilterOperatorChanges: w,
        focusElementRef: A === M.length - 1 ? c : null,
        logicOperators: d,
        columnsSort: f
      }, p), N.id == null ? A + O.length : N.id))]
    }), !s.disableMultipleColumnsFiltering && !(b && v) ? /* @__PURE__ */ ie(d2, {
      children: [b ? /* @__PURE__ */ C("span", {}) : /* @__PURE__ */ C(s.slots.baseButton, I({
        onClick: D,
        startIcon: /* @__PURE__ */ C(s.slots.filterPanelAddIcon, {})
      }, (F = s.slotProps) == null ? void 0 : F.baseButton, {
        children: o.current.getLocaleText("filterPanelAddFilter")
      })), !v && M.length > 0 ? /* @__PURE__ */ C(s.slots.baseButton, I({
        onClick: P,
        startIcon: /* @__PURE__ */ C(s.slots.filterPanelRemoveAllIcon, {})
      }, ($ = s.slotProps) == null ? void 0 : $.baseButton, {
        children: o.current.getLocaleText("filterPanelRemoveAll")
      })) : null]
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (f2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore - do not document.
   */
  children: r.node,
  /**
   * Changes how the options in the columns selector should be ordered.
   * If not specified, the order is derived from the `columns` prop.
   */
  columnsSort: r.oneOf(["asc", "desc"]),
  /**
   * If `true`, the `Add filter` button will not be displayed.
   * @default false
   */
  disableAddFilterButton: r.bool,
  /**
   * If `true`, the `Remove all` button will be disabled
   * @default false
   */
  disableRemoveAllButton: r.bool,
  /**
   * Props passed to each filter form.
   */
  filterFormProps: r.shape({
    columnInputProps: r.any,
    columnsSort: r.oneOf(["asc", "desc"]),
    deleteIconProps: r.any,
    filterColumns: r.func,
    logicOperatorInputProps: r.any,
    operatorInputProps: r.any,
    valueInputProps: r.any
  }),
  /**
   * Function that returns the next filter item to be picked as default filter.
   * @param {GetColumnForNewFilterArgs} args Currently configured filters and columns.
   * @returns {GridColDef['field']} The field to be used for the next filter or `null` to prevent adding a filter.
   */
  getColumnForNewFilter: r.func,
  /**
   * Sets the available logic operators.
   * @default [GridLogicOperator.And, GridLogicOperator.Or]
   */
  logicOperators: r.arrayOf(r.oneOf(["and", "or"]).isRequired),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const iJ = (e, t) => {
  const n = new Set(Object.keys(e).filter((i) => e[i] === !1)), o = new Set(Object.keys(t).filter((i) => t[i] === !1));
  if (n.size !== o.size)
    return !1;
  let s = !0;
  return n.forEach((i) => {
    o.has(i) || (s = !1);
  }), s;
}, aJ = (e, t) => (e.headerName || e.field).toLowerCase().indexOf(t) > -1, lJ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["columnsManagement"],
    header: ["columnsManagementHeader"],
    searchInput: ["columnsManagementSearchInput"],
    footer: ["columnsManagementFooter"],
    row: ["columnsManagementRow"]
  }, rt, t);
}, zT = new Intl.Collator();
function p2(e) {
  var A, k, L, B;
  const t = lt(), n = h.useRef(null), o = ge(t, Pr), s = Jo(() => jo(t)).current, i = ge(t, jo), a = Xe(), [l, c] = h.useState(""), u = lJ(a), {
    sort: d,
    searchPredicate: f = aJ,
    autoFocusSearchField: p = !0,
    disableShowHideToggle: m = !1,
    disableResetButton: b = !1,
    toggleAllMode: v = "all",
    getTogglableColumns: g,
    searchInputProps: y
  } = e, w = h.useMemo(() => iJ(i, s), [i, s]), x = h.useMemo(() => {
    switch (d) {
      case "asc":
        return [...o].sort((V, _) => zT.compare(V.headerName || V.field, _.headerName || _.field));
      case "desc":
        return [...o].sort((V, _) => -zT.compare(V.headerName || V.field, _.headerName || _.field));
      default:
        return o;
    }
  }, [o, d]), S = (V) => {
    const {
      name: _
    } = V.target;
    t.current.setColumnVisibility(_, i[_] === !1);
  }, T = h.useMemo(() => {
    const V = g ? g(x) : null, _ = V ? x.filter(({
      field: z
    }) => V.includes(z)) : x;
    return l ? _.filter((z) => f(z, l.toLowerCase())) : _;
  }, [x, l, f, g]), E = h.useCallback((V) => {
    const _ = jo(t), z = I({}, _), j = g ? g(o) : null;
    return (v === "filteredOnly" ? T : o).forEach((W) => {
      W.hideable && (j == null || j.includes(W.field)) && (V ? delete z[W.field] : z[W.field] = !1);
    }), t.current.setColumnVisibilityModel(z);
  }, [t, o, g, v, T]), O = h.useCallback((V) => {
    c(V.target.value);
  }, []), M = h.useMemo(() => T.filter((V) => V.hideable), [T]), D = h.useMemo(() => M.every((V) => i[V.field] == null || i[V.field] !== !1), [i, M]), R = h.useMemo(() => M.every((V) => i[V.field] === !1), [i, M]), P = h.useRef(null);
  h.useEffect(() => {
    p ? n.current.focus() : P.current && typeof P.current.focus == "function" && P.current.focus();
  }, [p]);
  let F = !1;
  const $ = (V) => F === !1 && V.hideable !== !1 ? (F = !0, !0) : !1, N = h.useCallback(() => {
    c(""), n.current.focus();
  }, []);
  return /* @__PURE__ */ ie(h.Fragment, {
    children: [/* @__PURE__ */ C(uJ, {
      className: u.header,
      ownerState: a,
      children: /* @__PURE__ */ C(dJ, I({
        as: a.slots.baseTextField,
        ownerState: a,
        placeholder: t.current.getLocaleText("columnsManagementSearchTitle"),
        inputRef: n,
        className: u.searchInput,
        value: l,
        onChange: O,
        variant: "outlined",
        size: "small",
        type: "search",
        InputProps: {
          startAdornment: /* @__PURE__ */ C(a.slots.baseInputAdornment, {
            position: "start",
            children: /* @__PURE__ */ C(a.slots.quickFilterIcon, {})
          }),
          endAdornment: /* @__PURE__ */ C(a.slots.baseIconButton, I({
            "aria-label": t.current.getLocaleText("columnsManagementDeleteIconLabel"),
            size: "small",
            sx: [l ? {
              visibility: "visible"
            } : {
              visibility: "hidden"
            }],
            tabIndex: -1,
            onClick: N
          }, (A = a.slotProps) == null ? void 0 : A.baseIconButton, {
            children: /* @__PURE__ */ C(a.slots.quickFilterClearIcon, {
              fontSize: "small"
            })
          }))
        },
        inputProps: {
          "aria-label": t.current.getLocaleText("columnsManagementSearchTitle")
        },
        autoComplete: "off",
        fullWidth: !0
      }, (k = a.slotProps) == null ? void 0 : k.baseTextField, y))
    }), /* @__PURE__ */ ie(cJ, {
      className: u.root,
      ownerState: a,
      children: [T.map((V) => {
        var _;
        return /* @__PURE__ */ C(qc, {
          className: u.row,
          control: /* @__PURE__ */ C(a.slots.baseCheckbox, I({
            disabled: V.hideable === !1,
            checked: i[V.field] !== !1,
            onClick: S,
            name: V.field,
            sx: {
              p: 0.5
            },
            inputRef: $(V) ? P : void 0
          }, (_ = a.slotProps) == null ? void 0 : _.baseCheckbox)),
          label: V.headerName || V.field
        }, V.field);
      }), T.length === 0 && /* @__PURE__ */ C(pJ, {
        ownerState: a,
        children: t.current.getLocaleText("columnsManagementNoColumns")
      })]
    }), (!m || !b) && T.length > 0 ? /* @__PURE__ */ ie(fJ, {
      ownerState: a,
      className: u.footer,
      children: [m ? /* @__PURE__ */ C("span", {}) : /* @__PURE__ */ C(qc, {
        control: /* @__PURE__ */ C(a.slots.baseCheckbox, I({
          disabled: M.length === 0,
          checked: D,
          indeterminate: !D && !R,
          onClick: () => E(!D),
          name: t.current.getLocaleText("columnsManagementShowHideAllText"),
          sx: {
            p: 0.5
          }
        }, (L = a.slotProps) == null ? void 0 : L.baseCheckbox)),
        label: t.current.getLocaleText("columnsManagementShowHideAllText")
      }), b ? null : /* @__PURE__ */ C(a.slots.baseButton, I({
        onClick: () => t.current.setColumnVisibilityModel(s),
        disabled: w
      }, (B = a.slotProps) == null ? void 0 : B.baseButton, {
        children: t.current.getLocaleText("columnsManagementReset")
      }))]
    }) : null]
  });
}
process.env.NODE_ENV !== "production" && (p2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the column search field will be focused automatically.
   * If `false`, the first column switch input will be focused automatically.
   * This helps to avoid input keyboard panel to popup automatically on touch devices.
   * @default true
   */
  autoFocusSearchField: r.bool,
  /**
   * If `true`, the `Reset` button will not be disabled
   * @default false
   */
  disableResetButton: r.bool,
  /**
   * If `true`, the `Show/Hide all` toggle checkbox will not be displayed.
   * @default false
   */
  disableShowHideToggle: r.bool,
  /**
   * Returns the list of togglable columns.
   * If used, only those columns will be displayed in the panel
   * which are passed as the return value of the function.
   * @param {GridColDef[]} columns The `ColDef` list of all columns.
   * @returns {GridColDef['field'][]} The list of togglable columns' field names.
   */
  getTogglableColumns: r.func,
  searchInputProps: r.object,
  searchPredicate: r.func,
  sort: r.oneOf(["asc", "desc"]),
  /**
   * Changes the behavior of the `Show/Hide All` toggle when the search field is used:
   * - `all`: Will toggle all columns.
   * - `filteredOnly`: Will only toggle columns that match the search criteria.
   * @default 'all'
   */
  toggleAllMode: r.oneOf(["all", "filteredOnly"])
});
const cJ = te("div", {
  name: "MuiDataGrid",
  slot: "ColumnsManagement",
  overridesResolver: (e, t) => t.columnsManagement
})(({
  theme: e
}) => ({
  padding: e.spacing(0, 3, 1.5),
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  flex: "1 1",
  maxHeight: 400,
  alignItems: "flex-start"
})), uJ = te("div", {
  name: "MuiDataGrid",
  slot: "ColumnsManagementHeader",
  overridesResolver: (e, t) => t.columnsManagementHeader
})(({
  theme: e
}) => ({
  padding: e.spacing(1.5, 3)
})), dJ = te(Is, {
  name: "MuiDataGrid",
  slot: "ColumnsManagementSearchInput",
  overridesResolver: (e, t) => t.columnsManagementSearchInput
})(({
  theme: e
}) => ({
  [`& .${Un.root}`]: {
    padding: e.spacing(0, 1.5, 0, 1.5)
  },
  [`& .${Un.input}::-webkit-search-decoration,
  & .${Un.input}::-webkit-search-cancel-button,
  & .${Un.input}::-webkit-search-results-button,
  & .${Un.input}::-webkit-search-results-decoration`]: {
    /* clears the 'X' icon from Chrome */
    display: "none"
  }
})), fJ = te("div", {
  name: "MuiDataGrid",
  slot: "ColumnsManagementFooter",
  overridesResolver: (e, t) => t.columnsManagementFooter
})(({
  theme: e
}) => ({
  padding: e.spacing(0.5, 1, 0.5, 3),
  display: "flex",
  justifyContent: "space-between",
  borderTop: `1px solid ${e.palette.divider}`
})), pJ = te("div")(({
  theme: e
}) => ({
  padding: e.spacing(0.5, 0),
  color: e.palette.grey[500]
})), h2 = Ct(function(t, n) {
  var w, x;
  const {
    children: o,
    slotProps: s = {}
  } = t, i = s.button || {}, a = s.tooltip || {}, l = lt(), c = Xe(), u = gt(), d = gt(), [f, p] = h.useState(!1), m = h.useRef(null), b = tt(n, m), v = (S) => {
    var T;
    p((E) => !E), (T = i.onClick) == null || T.call(i, S);
  }, g = () => p(!1), y = (S) => {
    S.key === "Tab" && S.preventDefault(), QD(S.key) && g();
  };
  return o == null ? null : /* @__PURE__ */ ie(h.Fragment, {
    children: [/* @__PURE__ */ C(c.slots.baseTooltip, I({
      title: l.current.getLocaleText("toolbarExportLabel"),
      enterDelay: 1e3
    }, (w = c.slotProps) == null ? void 0 : w.baseTooltip, a, {
      children: /* @__PURE__ */ C(c.slots.baseButton, I({
        size: "small",
        startIcon: /* @__PURE__ */ C(c.slots.exportIcon, {}),
        "aria-expanded": f,
        "aria-label": l.current.getLocaleText("toolbarExportLabel"),
        "aria-haspopup": "menu",
        "aria-controls": f ? d : void 0,
        id: u
      }, (x = c.slotProps) == null ? void 0 : x.baseButton, i, {
        onClick: v,
        ref: b,
        children: l.current.getLocaleText("toolbarExport")
      }))
    })), /* @__PURE__ */ C(ku, {
      open: f,
      target: m.current,
      onClose: g,
      position: "bottom-start",
      children: /* @__PURE__ */ C(Zi, {
        id: d,
        className: K.menuList,
        "aria-labelledby": u,
        onKeyDown: y,
        autoFocusItem: f,
        children: h.Children.map(o, (S) => /* @__PURE__ */ h.isValidElement(S) ? /* @__PURE__ */ h.cloneElement(S, {
          hideMenu: g
        }) : S)
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (h2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.object
});
const hJ = ["hideMenu", "options"], gJ = ["hideMenu", "options"], mJ = ["csvOptions", "printOptions", "excelOptions"];
function g2(e) {
  const t = lt(), {
    hideMenu: n,
    options: o
  } = e, s = ve(e, hJ);
  return /* @__PURE__ */ C(Nn, I({
    onClick: () => {
      t.current.exportDataAsCsv(o), n == null || n();
    }
  }, s, {
    children: t.current.getLocaleText("toolbarExportCSV")
  }));
}
process.env.NODE_ENV !== "production" && (g2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  hideMenu: r.func,
  options: r.shape({
    allColumns: r.bool,
    delimiter: r.string,
    disableToolbarButton: r.bool,
    escapeFormulas: r.bool,
    fields: r.arrayOf(r.string),
    fileName: r.string,
    getRowsToExport: r.func,
    includeColumnGroupsHeaders: r.bool,
    includeHeaders: r.bool,
    shouldAppendQuotes: r.bool,
    utf8WithBom: r.bool
  })
});
function m2(e) {
  const t = lt(), {
    hideMenu: n,
    options: o
  } = e, s = ve(e, gJ);
  return /* @__PURE__ */ C(Nn, I({
    onClick: () => {
      t.current.exportDataAsPrint(o), n == null || n();
    }
  }, s, {
    children: t.current.getLocaleText("toolbarExportPrint")
  }));
}
process.env.NODE_ENV !== "production" && (m2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  hideMenu: r.func,
  options: r.shape({
    allColumns: r.bool,
    bodyClassName: r.string,
    copyStyles: r.bool,
    disableToolbarButton: r.bool,
    fields: r.arrayOf(r.string),
    fileName: r.string,
    getRowsToExport: r.func,
    hideFooter: r.bool,
    hideToolbar: r.bool,
    includeCheckboxes: r.bool,
    pageStyle: r.oneOfType([r.func, r.string])
  })
});
const bJ = Ct(function(t, n) {
  const o = t, {
    csvOptions: s = {},
    printOptions: i = {},
    excelOptions: a
  } = o, l = ve(o, mJ), u = lt().current.unstable_applyPipeProcessors("exportMenu", [], {
    excelOptions: a,
    csvOptions: s,
    printOptions: i
  }).sort((d, f) => d.componentName > f.componentName ? 1 : -1);
  return u.length === 0 ? null : /* @__PURE__ */ C(h2, I({}, l, {
    ref: n,
    children: u.map((d, f) => /* @__PURE__ */ h.cloneElement(d.component, {
      key: f
    }))
  }));
});
process.env.NODE_ENV !== "production" && (bJ.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  csvOptions: r.object,
  printOptions: r.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: r.object
});
const yJ = ["quickFilterParser", "quickFilterFormatter", "debounceMs", "className"], vJ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["toolbarQuickFilter"]
  }, rt, t);
}, CJ = te(Is, {
  name: "MuiDataGrid",
  slot: "ToolbarQuickFilter",
  overridesResolver: (e, t) => t.toolbarQuickFilter
})(({
  theme: e
}) => ({
  width: "auto",
  paddingBottom: e.spacing(0.5),
  "& input": {
    marginLeft: e.spacing(0.5)
  },
  "& .MuiInput-underline:before": {
    borderBottom: `1px solid ${(e.vars || e).palette.divider}`
  },
  '& input[type="search"]::-webkit-search-decoration,\n  & input[type="search"]::-webkit-search-cancel-button,\n  & input[type="search"]::-webkit-search-results-button,\n  & input[type="search"]::-webkit-search-results-decoration': {
    /* clears the 'X' icon from Chrome */
    display: "none"
  }
})), wJ = (e) => e.split(" ").filter((t) => t !== ""), SJ = (e) => e.join(" ");
function b2(e) {
  var y, w;
  const t = lt(), n = Xe(), o = vJ(n), s = ge(t, Yk), {
    quickFilterParser: i = wJ,
    quickFilterFormatter: a = SJ,
    debounceMs: l = n.filterDebounceMs,
    className: c
  } = e, u = ve(e, yJ), [d, f] = h.useState(() => a(s ?? [])), p = h.useRef(s);
  h.useEffect(() => {
    Xr(p.current, s) || (p.current = s, f((x) => Xr(i(x), s) ? x : a(s ?? [])));
  }, [s, a, i]);
  const m = h.useCallback((x) => {
    const S = i(x);
    p.current = S, t.current.setQuickFilterValues(S);
  }, [t, i]), b = h.useMemo(() => Yi(m, l), [m, l]);
  h.useEffect(() => b.clear, [b]);
  const v = h.useCallback((x) => {
    const S = x.target.value;
    f(S), b(S);
  }, [b]), g = h.useCallback(() => {
    f(""), m("");
  }, [m]);
  return /* @__PURE__ */ C(CJ, I({
    as: n.slots.baseTextField,
    ownerState: n,
    variant: "standard",
    value: d,
    onChange: v,
    className: ae(o.root, c),
    placeholder: t.current.getLocaleText("toolbarQuickFilterPlaceholder"),
    "aria-label": t.current.getLocaleText("toolbarQuickFilterLabel"),
    type: "search"
  }, u, {
    InputProps: I({
      startAdornment: /* @__PURE__ */ C(n.slots.quickFilterIcon, {
        fontSize: "small"
      }),
      endAdornment: /* @__PURE__ */ C(n.slots.baseIconButton, I({
        "aria-label": t.current.getLocaleText("toolbarQuickFilterDeleteIconLabel"),
        size: "small",
        sx: [d ? {
          visibility: "visible"
        } : {
          visibility: "hidden"
        }],
        onClick: g
      }, (y = n.slotProps) == null ? void 0 : y.baseIconButton, {
        children: /* @__PURE__ */ C(n.slots.quickFilterClearIcon, {
          fontSize: "small"
        })
      }))
    }, u.InputProps)
  }, (w = n.slotProps) == null ? void 0 : w.baseTextField));
}
process.env.NODE_ENV !== "production" && (b2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The debounce time in milliseconds.
   * @default 150
   */
  debounceMs: r.number,
  /**
   * Function responsible for formatting values of quick filter in a string when the model is modified
   * @param {any[]} values The new values passed to the quick filter model
   * @returns {string} The string to display in the text field
   * @default (values: string[]) => values.join(' ')
   */
  quickFilterFormatter: r.func,
  /**
   * Function responsible for parsing text input in an array of independent values for quick filtering.
   * @param {string} input The value entered by the user
   * @returns {any[]} The array of value on which quick filter is applied
   * @default (searchText: string) => searchText
   *   .split(' ')
   *   .filter((word) => word !== '')
   */
  quickFilterParser: r.func
});
const xJ = ["className", "selectedRowCount"], TJ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["selectedRowCount"]
  }, rt, t);
}, RJ = tn("div", {
  name: "MuiDataGrid",
  slot: "SelectedRowCount",
  overridesResolver: (e, t) => t.selectedRowCount
})(({
  theme: e
}) => ({
  alignItems: "center",
  display: "flex",
  margin: e.spacing(0, 2),
  visibility: "hidden",
  width: 0,
  height: 0,
  [e.breakpoints.up("sm")]: {
    visibility: "visible",
    width: "auto",
    height: "auto"
  }
})), y2 = Ct(function(t, n) {
  const {
    className: o,
    selectedRowCount: s
  } = t, i = ve(t, xJ), a = lt(), l = Xe(), c = TJ(l), u = a.current.getLocaleText("footerRowSelected")(s);
  return /* @__PURE__ */ C(RJ, I({
    className: ae(c.root, o),
    ownerState: l
  }, i, {
    ref: n,
    children: u
  }));
});
process.env.NODE_ENV !== "production" && (y2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  selectedRowCount: r.number.isRequired,
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const v2 = Ct(function(t, n) {
  var f, p;
  const o = lt(), s = Xe(), i = ge(o, tK), a = ge(o, OK), l = ge(o, Wp), c = !s.hideFooterSelectedRowCount && a > 0 ? /* @__PURE__ */ C(y2, {
    selectedRowCount: a
  }) : /* @__PURE__ */ C("div", {}), u = !s.hideFooterRowCount && !s.pagination ? /* @__PURE__ */ C(s.slots.footerRowCount, I({}, (f = s.slotProps) == null ? void 0 : f.footerRowCount, {
    rowCount: i,
    visibleRowCount: l
  })) : null, d = s.pagination && !s.hideFooterPagination && s.slots.pagination && /* @__PURE__ */ C(s.slots.pagination, I({}, (p = s.slotProps) == null ? void 0 : p.pagination));
  return /* @__PURE__ */ ie(FD, I({}, t, {
    ref: n,
    children: [c, u, d]
  }));
});
process.env.NODE_ENV !== "production" && (v2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const Mc = (e, t, n, o, s, i) => {
  let a;
  switch (e) {
    case ut.LEFT:
      a = o[n];
      break;
    case ut.RIGHT:
      a = s - o[n] - t + i;
      break;
    default:
      a = void 0;
      break;
  }
  return a;
}, Jc = (e, t, n, o, s) => {
  const i = t === n - 1;
  return e === ut.LEFT && i ? !0 : o ? e === ut.LEFT ? !0 : e === ut.RIGHT ? !i : !i || s : !1;
}, eu = (e, t) => e === ut.RIGHT && t === 0, Yl = {
  root: K.scrollbarFiller,
  header: K["scrollbarFiller--header"],
  borderTop: K["scrollbarFiller--borderTop"],
  borderBottom: K["scrollbarFiller--borderBottom"],
  pinnedRight: K["scrollbarFiller--pinnedRight"]
};
function d0({
  header: e,
  borderTop: t = !0,
  borderBottom: n,
  pinnedRight: o
}) {
  return /* @__PURE__ */ C("div", {
    role: "presentation",
    className: ae(Yl.root, e && Yl.header, t && Yl.borderTop, n && Yl.borderBottom, o && Yl.pinnedRight)
  });
}
const EJ = tn("div", {
  name: "MuiDataGrid",
  slot: "SkeletonLoadingOverlay",
  overridesResolver: (e, t) => t.skeletonLoadingOverlay
})({
  minWidth: "100%",
  width: "max-content",
  // prevents overflow: clip; cutting off the x axis
  height: "100%",
  overflow: "clip"
  // y axis is hidden while the x axis is allowed to overflow
}), IJ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["skeletonLoadingOverlay"]
  }, rt, t);
}, HT = (e) => parseInt(e.getAttribute("data-colindex"), 10), OJ = Ct(function(t, n) {
  const o = Xe(), {
    slots: s
  } = o, i = _t(), a = IJ({
    classes: o.classes
  }), l = h.useRef(null), c = tt(l, n), u = lt(), d = ge(u, Kn), f = (d == null ? void 0 : d.viewportInnerSize.height) ?? 0, p = Math.ceil(f / d.rowHeight), m = ge(u, xl), b = ge(u, Os), v = h.useMemo(() => b.filter((E) => E <= m).length, [m, b]), g = ge(u, pn), y = h.useMemo(() => g.slice(0, v), [g, v]), w = ge(u, ws), x = h.useCallback((E) => {
    if (w.left.findIndex((O) => O.field === E) !== -1)
      return ut.LEFT;
    if (w.right.findIndex((O) => O.field === E) !== -1)
      return ut.RIGHT;
  }, [w.left, w.right]), S = h.useMemo(() => {
    const E = [];
    for (let O = 0; O < p; O += 1) {
      const M = [];
      for (let D = 0; D < y.length; D += 1) {
        const R = y[D], P = x(R.field), F = P === ut.LEFT, $ = P === ut.RIGHT, N = DD(P, i), A = N ? w[N].length : y.length - w.left.length - w.right.length, k = N ? w[N].findIndex((ee) => ee.field === R.field) : D - w.left.length, L = d.hasScrollY ? d.scrollbarSize : 0, B = _u({}, i, P, Mc(P, R.computedWidth, D, b, d.columnsTotalWidth, L)), V = d.columnsTotalWidth < d.viewportOuterSize.width, _ = Jc(P, k, A, o.showCellVerticalBorder, V), z = eu(P, k), j = D === y.length - 1, W = $ && k === 0, J = W && V, G = j && !W && V, q = d.viewportOuterSize.width - d.columnsTotalWidth, Z = Math.max(0, q), Y = /* @__PURE__ */ C(s.skeletonCell, {
          width: Z,
          empty: !0
        }, `skeleton-filler-column-${O}`), Q = j && L !== 0;
        J && M.push(Y), M.push(/* @__PURE__ */ C(s.skeletonCell, {
          field: R.field,
          type: R.type,
          align: R.align,
          width: "var(--width)",
          height: d.rowHeight,
          "data-colindex": D,
          className: ae(F && K["cell--pinnedLeft"], $ && K["cell--pinnedRight"], _ && K["cell--withRightBorder"], z && K["cell--withLeftBorder"]),
          style: I({
            "--width": `${R.computedWidth}px`
          }, B)
        }, `skeleton-column-${O}-${R.field}`)), G && M.push(Y), Q && M.push(/* @__PURE__ */ C(d0, {
          pinnedRight: w.right.length > 0
        }, `skeleton-scrollbar-filler-${O}`));
      }
      E.push(/* @__PURE__ */ C("div", {
        className: ae(K.row, K.rowSkeleton, O === 0 && K["row--firstVisible"]),
        children: M
      }, `skeleton-row-${O}`));
    }
    return E;
  }, [s, y, w, p, o.showCellVerticalBorder, d, b, x, i]);
  return Le(u, "columnResize", (E) => {
    var k, L, B;
    const {
      colDef: O,
      width: M
    } = E, D = (k = l.current) == null ? void 0 : k.querySelectorAll(`[data-field="${Ms(O.field)}"]`);
    if (!D)
      throw new Error("MUI X: Expected skeleton cells to be defined with `data-field` attribute.");
    const R = y.findIndex((V) => V.field === O.field), P = x(O.field), F = P === ut.LEFT, $ = P === ut.RIGHT, N = getComputedStyle(D[0]).getPropertyValue("--width"), A = parseInt(N, 10) - M;
    if (D && D.forEach((V) => {
      V.style.setProperty("--width", `${M}px`);
    }), F) {
      const V = (L = l.current) == null ? void 0 : L.querySelectorAll(`.${K["cell--pinnedLeft"]}`);
      V == null || V.forEach((_) => {
        HT(_) > R && (_.style.left = `${parseInt(getComputedStyle(_).left, 10) - A}px`);
      });
    }
    if ($) {
      const V = (B = l.current) == null ? void 0 : B.querySelectorAll(`.${K["cell--pinnedRight"]}`);
      V == null || V.forEach((_) => {
        HT(_) < R && (_.style.right = `${parseInt(getComputedStyle(_).right, 10) + A}px`);
      });
    }
  }), /* @__PURE__ */ C(EJ, I({
    className: a.root
  }, t, {
    ref: c,
    children: S
  }));
}), PJ = ["variant", "noRowsVariant", "style"], MJ = {
  "circular-progress": {
    component: Fp,
    style: {}
  },
  "linear-progress": {
    component: oC,
    style: {
      display: "block"
    }
  },
  skeleton: {
    component: OJ,
    style: {
      display: "block"
    }
  }
}, C2 = Ct(function(t, n) {
  const {
    variant: o = "circular-progress",
    noRowsVariant: s = "circular-progress",
    style: i
  } = t, a = ve(t, PJ), l = lt(), c = ge(l, Du), u = MJ[c === 0 ? s : o];
  return /* @__PURE__ */ C(Zp, I({
    style: I({}, u.style, i)
  }, a, {
    ref: n,
    children: /* @__PURE__ */ C(u.component, {})
  }));
});
process.env.NODE_ENV !== "production" && (C2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The variant of the overlay when no rows are displayed.
   * @default 'circular-progress'
   */
  noRowsVariant: r.oneOf(["circular-progress", "linear-progress", "skeleton"]),
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * The variant of the overlay.
   * @default 'circular-progress'
   */
  variant: r.oneOf(["circular-progress", "linear-progress", "skeleton"])
});
const w2 = Ct(function(t, n) {
  const s = lt().current.getLocaleText("noRowsLabel");
  return /* @__PURE__ */ C(Zp, I({}, t, {
    ref: n,
    children: s
  }));
});
process.env.NODE_ENV !== "production" && (w2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const kJ = te(NM)(({
  theme: e
}) => ({
  maxHeight: "calc(100% + 1px)",
  // border width
  flexGrow: 1,
  [`& .${ki.selectLabel}`]: {
    display: "none",
    [e.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  [`& .${ki.input}`]: {
    display: "none",
    [e.breakpoints.up("sm")]: {
      display: "inline-flex"
    }
  }
})), DJ = (e, t) => ({
  from: n,
  to: o,
  count: s,
  page: i
}) => e({
  from: n,
  to: o,
  count: s,
  page: i,
  estimated: t
}), NJ = ({
  from: e,
  to: t,
  count: n,
  estimated: o
}) => o ? `${e}–${t} of ${n !== -1 ? n : `more than ${o > t ? o : t}`}` : `${e}–${t} of ${n !== -1 ? n : `more than ${t}`}`, S2 = Ct(function(t, n) {
  var S;
  const o = lt(), s = Xe(), i = ge(o, oo), a = ge(o, Na), l = ge(o, lD), {
    paginationMode: c,
    loading: u,
    estimatedRowCount: d
  } = s, f = h.useMemo(() => a === -1 && c === "server" && u ? {
    backIconButtonProps: {
      disabled: !0
    },
    nextIconButtonProps: {
      disabled: !0
    }
  } : {}, [u, c, a]), p = h.useMemo(() => Math.max(0, l - 1), [l]), m = h.useMemo(() => a === -1 || i.page <= p ? i.page : p, [p, i.page, a]), b = h.useCallback((T) => {
    const E = Number(T.target.value);
    o.current.setPageSize(E);
  }, [o]), v = h.useCallback((T, E) => {
    o.current.setPage(E);
  }, [o]), g = (T) => {
    for (let E = 0; E < s.pageSizeOptions.length; E += 1) {
      const O = s.pageSizeOptions[E];
      if (typeof O == "number") {
        if (O === T)
          return !0;
      } else if (O.value === T)
        return !0;
    }
    return !1;
  };
  if (process.env.NODE_ENV !== "production") {
    const T = h.useRef(!1), E = ((S = s.paginationModel) == null ? void 0 : S.pageSize) ?? i.pageSize;
    !T.current && !s.autoPageSize && !g(E) && (console.warn([`MUI X: The page size \`${i.pageSize}\` is not present in the \`pageSizeOptions\`.`, "Add it to show the pagination select."].join(`
`)), T.current = !0);
  }
  const y = g(i.pageSize) ? s.pageSizeOptions : [], w = o.current.getLocaleText("MuiTablePagination"), x = DJ(w.labelDisplayedRows || NJ, d);
  return /* @__PURE__ */ C(kJ, I({
    component: "div",
    count: a,
    page: m,
    rowsPerPageOptions: y,
    rowsPerPage: i.pageSize,
    onPageChange: v,
    onRowsPerPageChange: b
  }, f, w, {
    labelDisplayedRows: x
  }, t, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (S2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  component: r.elementType
});
const $J = ["className", "rowCount", "visibleRowCount"], AJ = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["rowCount"]
  }, rt, t);
}, FJ = tn("div", {
  name: "MuiDataGrid",
  slot: "RowCount",
  overridesResolver: (e, t) => t.rowCount
})(({
  theme: e
}) => ({
  alignItems: "center",
  display: "flex",
  margin: e.spacing(0, 2)
})), x2 = Ct(function(t, n) {
  const {
    className: o,
    rowCount: s,
    visibleRowCount: i
  } = t, a = ve(t, $J), l = lt(), c = Xe(), u = AJ(c);
  if (s === 0)
    return null;
  const d = i < s ? l.current.getLocaleText("footerTotalVisibleRows")(i, s) : s.toLocaleString();
  return /* @__PURE__ */ ie(FJ, I({
    className: ae(u.root, o),
    ownerState: c
  }, a, {
    ref: n,
    children: [l.current.getLocaleText("footerTotalRows"), " ", d]
  }));
});
process.env.NODE_ENV !== "production" && (x2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  rowCount: r.number.isRequired,
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  visibleRowCount: r.number.isRequired
});
function LJ(e) {
  for (const t in e)
    return !1;
  return !0;
}
function _J(e, t) {
  return fe(t, rt, e);
}
const VJ = ["selected", "rowId", "row", "index", "style", "rowHeight", "className", "visibleColumns", "pinnedColumns", "offsetLeft", "columnsTotalWidth", "firstColumnIndex", "lastColumnIndex", "focusedColumnIndex", "isFirstVisible", "isLastVisible", "isNotVisible", "showBottomBorder", "scrollbarWidth", "gridHasFiller", "onClick", "onDoubleClick", "onMouseEnter", "onMouseLeave", "onMouseOut", "onMouseOver"], BJ = ni(Pn, (e, t) => t ? !!LJ(e) : !1), T2 = Ct(function(t, n) {
  var be;
  const {
    selected: o,
    rowId: s,
    row: i,
    index: a,
    style: l,
    rowHeight: c,
    className: u,
    visibleColumns: d,
    pinnedColumns: f,
    offsetLeft: p,
    columnsTotalWidth: m,
    firstColumnIndex: b,
    lastColumnIndex: v,
    focusedColumnIndex: g,
    isFirstVisible: y,
    isLastVisible: w,
    isNotVisible: x,
    showBottomBorder: S,
    scrollbarWidth: T,
    gridHasFiller: E,
    onClick: O,
    onDoubleClick: M,
    onMouseEnter: D,
    onMouseLeave: R,
    onMouseOut: P,
    onMouseOver: F
  } = t, $ = ve(t, VJ), N = eo(), A = OD(), k = h.useRef(null), L = Xe(), B = Xp(N), V = ge(N, uo), _ = ge(N, Ps), z = ge(N, Os), j = L.rowReordering, W = Ys(N, BJ, j), J = tt(k, n), G = N.current.getRowNode(s), q = Ys(N, MD, {
    rowId: s,
    editMode: L.editMode
  }), Z = L.editMode === ts.Row, Y = g !== void 0, Q = Y && g >= f.left.length && g < b, ee = Y && g < d.length - f.right.length && g >= v, ne = _J(L.classes, {
    root: ["row", o && "selected", Z && "row--editable", q && "row--editing", y && "row--firstVisible", w && "row--lastVisible", S && "row--borderBottom", c === "auto" && "row--dynamicHeight"]
  }), H = A.hooks.useGridRowAriaAttributes();
  h.useLayoutEffect(() => {
    if (B.range) {
      const me = N.current.getRowIndexRelativeToVisibleRows(s);
      me !== void 0 && N.current.unstable_setLastMeasuredRowIndex(me);
    }
    if (k.current && c === "auto")
      return N.current.observeRowHeight(k.current, s);
  }, [N, B.range, c, s]);
  const U = h.useCallback((me, Ae) => (ye) => {
    Ol(ye) || N.current.getRow(s) && (N.current.publishEvent(me, N.current.getRowParams(s), ye), Ae && Ae(ye));
  }, [N, s]), X = h.useCallback((me) => {
    const Ae = Hf(me.target, K.cell), ye = Ae == null ? void 0 : Ae.getAttribute("data-field");
    if (ye) {
      if (ye === Il.field || ye === Bo || ye === "__reorder__" || N.current.getCellMode(s, ye) === Bt.Edit)
        return;
      const We = N.current.getColumn(ye);
      if ((We == null ? void 0 : We.type) === Gp)
        return;
    }
    U("rowClick", O)(me);
  }, [N, O, U, s]), {
    slots: re,
    slotProps: oe,
    disableColumnReorder: le
  } = L, se = ge(N, () => I({}, N.current.getRowHeightEntry(s)), LC), Ce = h.useMemo(() => {
    if (x)
      return {
        opacity: 0,
        width: 0,
        height: 0
      };
    const me = I({}, l, {
      maxHeight: c === "auto" ? "none" : c,
      // max-height doesn't support "auto"
      minHeight: c,
      "--height": typeof c == "number" ? `${c}px` : c
    });
    if (se.spacingTop) {
      const Ae = L.rowSpacingType === "border" ? "borderTopWidth" : "marginTop";
      me[Ae] = se.spacingTop;
    }
    if (se.spacingBottom) {
      const Ae = L.rowSpacingType === "border" ? "borderBottomWidth" : "marginBottom";
      let ye = me[Ae];
      typeof ye != "number" && (ye = parseInt(ye || "0", 10)), ye += se.spacingBottom, me[Ae] = ye;
    }
    return me;
  }, [x, c, l, se, L.rowSpacingType]), $e = N.current.unstable_applyPipeProcessors("rowClassName", [], s), we = G ? H(G, a) : void 0;
  if (typeof L.getRowClassName == "function") {
    const me = a - (((be = B.range) == null ? void 0 : be.firstRowIndex) || 0), Ae = I({}, N.current.getRowParams(s), {
      isFirstVisible: me === 0,
      isLastVisible: me === B.rows.length - 1,
      indexRelativeToCurrentPage: me
    });
    $e.push(L.getRowClassName(Ae));
  }
  if (!G)
    return null;
  const Te = (me, Ae, ye, We, He = ut.NONE) => {
    const ze = N.current.unstable_getCellColSpanInfo(s, ye);
    if (ze != null && ze.spannedByColSpan)
      return null;
    const pe = (ze == null ? void 0 : ze.cellProps.width) ?? me.computedWidth, Re = (ze == null ? void 0 : ze.cellProps.colSpan) ?? 1, Ge = Mc(He, me.computedWidth, ye, z, m, T);
    if ((G == null ? void 0 : G.type) === "skeletonRow")
      return /* @__PURE__ */ C(re.skeletonCell, {
        type: me.type,
        width: pe,
        height: c,
        field: me.field,
        align: me.align
      }, me.field);
    const Qe = me.field === "__reorder__", qe = !(le || me.disableReorder), st = W && !V.length && _ <= 1, wt = !(qe || Qe && st), Ue = He === ut.VIRTUAL, nt = eu(He, Ae), ft = Jc(He, Ae, We, L.showCellVerticalBorder, E);
    return /* @__PURE__ */ C(re.cell, I({
      column: me,
      width: pe,
      rowId: s,
      align: me.align || "left",
      colIndex: ye,
      colSpan: Re,
      disableDragEvents: wt,
      isNotVisible: Ue,
      pinnedOffset: Ge,
      pinnedPosition: He,
      showLeftBorder: nt,
      showRightBorder: ft,
      row: i,
      rowNode: G
    }, oe == null ? void 0 : oe.cell), me.field);
  }, ue = f.left.map((me, Ae) => Te(me, Ae, Ae, f.left.length, ut.LEFT)), de = f.right.map((me, Ae) => {
    const ye = d.length - f.right.length + Ae;
    return Te(me, Ae, ye, f.right.length, ut.RIGHT);
  }), Pe = d.length - f.left.length - f.right.length, ke = [];
  Q && ke.push(Te(d[g], g - f.left.length, g, Pe, ut.VIRTUAL));
  for (let me = b; me < v; me += 1) {
    const Ae = d[me], ye = me - f.left.length;
    Ae && ke.push(Te(Ae, ye, me, Pe));
  }
  ee && ke.push(Te(d[g], g - f.left.length, g, Pe, ut.VIRTUAL));
  const Me = i ? {
    onClick: X,
    onDoubleClick: U("rowDoubleClick", M),
    onMouseEnter: U("rowMouseEnter", D),
    onMouseLeave: U("rowMouseLeave", R),
    onMouseOut: U("rowMouseOut", P),
    onMouseOver: U("rowMouseOver", F)
  } : null;
  return /* @__PURE__ */ ie("div", I({
    "data-id": s,
    "data-rowindex": a,
    role: "row",
    className: ae(...$e, ne.root, u),
    style: Ce
  }, we, Me, $, {
    ref: J,
    children: [ue, /* @__PURE__ */ C("div", {
      role: "presentation",
      className: K.cellOffsetLeft,
      style: {
        width: p
      }
    }), ke, /* @__PURE__ */ C("div", {
      role: "presentation",
      className: ae(K.cell, K.cellEmpty)
    }), de, T !== 0 && /* @__PURE__ */ C(d0, {
      pinnedRight: f.right.length > 0,
      borderTop: !y
    })]
  }));
});
process.env.NODE_ENV !== "production" && (T2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  columnsTotalWidth: r.number.isRequired,
  firstColumnIndex: r.number.isRequired,
  /**
   * Determines which cell has focus.
   * If `null`, no cell in this row has focus.
   */
  focusedColumnIndex: r.number,
  gridHasFiller: r.bool.isRequired,
  /**
   * Index of the row in the whole sorted and filtered dataset.
   * If some rows above have expanded children, this index also take those children into account.
   */
  index: r.number.isRequired,
  isFirstVisible: r.bool.isRequired,
  isLastVisible: r.bool.isRequired,
  isNotVisible: r.bool.isRequired,
  lastColumnIndex: r.number.isRequired,
  offsetLeft: r.number.isRequired,
  onClick: r.func,
  onDoubleClick: r.func,
  onMouseEnter: r.func,
  onMouseLeave: r.func,
  pinnedColumns: r.object.isRequired,
  row: r.object.isRequired,
  rowHeight: r.oneOfType([r.oneOf(["auto"]), r.number]).isRequired,
  rowId: r.oneOfType([r.number, r.string]).isRequired,
  scrollbarWidth: r.number.isRequired,
  selected: r.bool.isRequired,
  showBottomBorder: r.bool.isRequired,
  visibleColumns: r.arrayOf(r.object).isRequired
});
const zJ = Dr(T2);
function HJ({
  privateApiRef: e,
  configuration: t,
  props: n,
  children: o
}) {
  const s = h.useRef(e.current.getPublicApi());
  return /* @__PURE__ */ C(a0.Provider, {
    value: t,
    children: /* @__PURE__ */ C(zC.Provider, {
      value: n,
      children: /* @__PURE__ */ C(s0.Provider, {
        value: e,
        children: /* @__PURE__ */ C(HC.Provider, {
          value: s,
          children: o
        })
      })
    })
  });
}
const jJ = () => (
  // TODO v8: initialize with null (see https://github.com/mui/mui-x/issues/16135#issuecomment-2589395230 and https://github.com/mui/mui-x/issues/16000#issuecomment-2567820735)
  h.useRef({})
), GJ = () => {
  const e = eo(), t = Xe(), n = ge(e, pn), o = ge(e, ZC), s = ge(e, Fu), i = ge(e, _k);
  return {
    role: "grid",
    "aria-colcount": n.length,
    "aria-rowcount": s + 1 + i + o,
    "aria-multiselectable": JC(t)
  };
}, qJ = () => {
  const e = eo(), t = ge(e, ms), n = ge(e, Fu);
  return h.useCallback((o, s) => {
    const i = {}, a = s + n + 2;
    return i["aria-rowindex"] = a, e.current.isRowSelectable(o.id) && (i["aria-selected"] = t[o.id] !== void 0), i;
  }, [e, t, n]);
}, WJ = (e) => {
  const t = h.useRef(null), n = h.useRef(null), o = h.useRef(null), s = h.useRef(null), i = h.useRef(null), a = h.useRef(null);
  e.current.register("public", {
    rootElementRef: t
  }), e.current.register("private", {
    mainElementRef: n,
    virtualScrollerRef: o,
    virtualScrollbarVerticalRef: s,
    virtualScrollbarHorizontalRef: i,
    columnHeadersContainerRef: a
  });
}, UJ = (e) => {
  const t = _t();
  e.current.state.isRtl === void 0 && (e.current.state.isRtl = t);
  const n = h.useRef(!0);
  h.useEffect(() => {
    n.current ? n.current = !1 : e.current.setState((o) => I({}, o, {
      isRtl: t
    }));
  }, [e, t]);
}, KJ = DU() && window.localStorage.getItem("DEBUG") != null, hc = () => {
}, YJ = {
  debug: hc,
  info: hc,
  warn: hc,
  error: hc
}, jT = ["debug", "info", "warn", "error"];
function GT(e, t, n = console) {
  const o = jT.indexOf(t);
  if (o === -1)
    throw new Error(`MUI X: Log level ${t} not recognized.`);
  return jT.reduce((i, a, l) => (l >= o ? i[a] = (...c) => {
    const [u, ...d] = c;
    n[a](`MUI X: ${e} - ${u}`, ...d);
  } : i[a] = hc, i), {});
}
const XJ = (e, t) => {
  const n = h.useCallback((o) => KJ ? GT(o, "debug", t.logger) : t.logLevel ? GT(o, t.logLevel.toString(), t.logger) : YJ, [t.logLevel, t.logger]);
  ot(e, {
    getLogger: n
  }, "private");
};
class QJ {
  constructor() {
    this.maxListeners = 20, this.warnOnce = !1, this.events = {};
  }
  on(t, n, o = {}) {
    let s = this.events[t];
    if (s || (s = {
      highPriority: /* @__PURE__ */ new Map(),
      regular: /* @__PURE__ */ new Map()
    }, this.events[t] = s), o.isFirst ? s.highPriority.set(n, !0) : s.regular.set(n, !0), process.env.NODE_ENV !== "production") {
      const i = s.highPriority.size + s.regular.size;
      i > this.maxListeners && !this.warnOnce && (this.warnOnce = !0, console.warn([`Possible EventEmitter memory leak detected. ${i} ${t} listeners added.`].join(`
`)));
    }
  }
  removeListener(t, n) {
    this.events[t] && (this.events[t].regular.delete(n), this.events[t].highPriority.delete(n));
  }
  removeAllListeners() {
    this.events = {};
  }
  emit(t, ...n) {
    const o = this.events[t];
    if (!o)
      return;
    const s = Array.from(o.highPriority.keys()), i = Array.from(o.regular.keys());
    for (let a = s.length - 1; a >= 0; a -= 1) {
      const l = s[a];
      o.highPriority.has(l) && l.apply(this, n);
    }
    for (let a = 0; a < i.length; a += 1) {
      const l = i[a];
      o.regular.has(l) && l.apply(this, n);
    }
  }
  once(t, n) {
    const o = this;
    this.on(t, function s(...i) {
      o.removeListener(t, s), n.apply(o, i);
    });
  }
}
class f0 {
  static create(t) {
    return new f0(t);
  }
  constructor(t) {
    this.value = void 0, this.listeners = void 0, this.subscribe = (n) => (this.listeners.add(n), () => {
      this.listeners.delete(n);
    }), this.getSnapshot = () => this.value, this.update = (n) => {
      this.value = n, this.listeners.forEach((o) => o(n));
    }, this.value = t, this.listeners = /* @__PURE__ */ new Set();
  }
}
const R2 = Symbol("mui.api_private"), ZJ = (e) => e.isPropagationStopped !== void 0;
let qT = 0;
function JJ(e) {
  var s;
  const t = (s = e.current) == null ? void 0 : s[R2];
  if (t)
    return t;
  const n = {}, o = {
    state: n,
    store: f0.create(n),
    instanceId: {
      id: qT
    }
  };
  return qT += 1, o.getPublicApi = () => e.current, o.register = (i, a) => {
    Object.keys(a).forEach((l) => {
      const c = a[l], u = o[l];
      if ((u == null ? void 0 : u.spying) === !0 ? u.target = c : o[l] = c, i === "public") {
        const d = e.current, f = d[l];
        (f == null ? void 0 : f.spying) === !0 ? f.target = c : d[l] = c;
      }
    });
  }, o.register("private", {
    caches: {},
    eventManager: new QJ()
  }), o;
}
function eee(e) {
  return {
    get state() {
      return e.current.state;
    },
    get store() {
      return e.current.store;
    },
    get instanceId() {
      return e.current.instanceId;
    },
    [R2]: e.current
  };
}
function tee(e, t) {
  var a;
  const n = h.useRef(null), o = h.useRef(null);
  o.current || (o.current = JJ(n)), n.current || (n.current = eee(o));
  const s = h.useCallback((...l) => {
    const [c, u, d = {}] = l;
    if (d.defaultMuiPrevented = !1, ZJ(d) && d.isPropagationStopped())
      return;
    const f = t.signature === Mo.DataGridPro || t.signature === Mo.DataGridPremium ? {
      api: o.current.getPublicApi()
    } : {};
    o.current.eventManager.emit(c, u, d, f);
  }, [o, t.signature]), i = h.useCallback((l, c, u) => {
    o.current.eventManager.on(l, c, u);
    const d = o.current;
    return () => {
      d.eventManager.removeListener(l, c);
    };
  }, [o]);
  return ot(o, {
    subscribeEvent: i,
    publishEvent: s
  }, "public"), e && !((a = e.current) != null && a.state) && (e.current = n.current), h.useImperativeHandle(e, () => n.current, [n]), h.useEffect(() => {
    const l = o.current;
    return () => {
      l.publishEvent("unmount");
    };
  }, [o]), o;
}
const nee = (e, t) => {
  const n = h.useCallback((o) => {
    if (t.localeText[o] == null)
      throw new Error(`Missing translation for key ${o}.`);
    return t.localeText[o];
  }, [t.localeText]);
  e.current.register("public", {
    getLocaleText: n
  });
}, oee = (e) => {
  const t = h.useRef({}), n = h.useRef(!1), o = h.useCallback((d) => {
    n.current || !d || (n.current = !0, Object.values(d.appliers).forEach((f) => {
      f();
    }), n.current = !1);
  }, []), s = h.useCallback((d, f, p) => {
    t.current[d] || (t.current[d] = {
      processors: /* @__PURE__ */ new Map(),
      processorsAsArray: [],
      appliers: {}
    });
    const m = t.current[d];
    return m.processors.get(f) !== p && (m.processors.set(f, p), m.processorsAsArray = Array.from(t.current[d].processors.values()), o(m)), () => {
      t.current[d].processors.delete(f), t.current[d].processorsAsArray = Array.from(t.current[d].processors.values());
    };
  }, [o]), i = h.useCallback((d, f, p) => (t.current[d] || (t.current[d] = {
    processors: /* @__PURE__ */ new Map(),
    processorsAsArray: [],
    appliers: {}
  }), t.current[d].appliers[f] = p, () => {
    const m = t.current[d].appliers, b = ve(m, [f].map(sl));
    t.current[d].appliers = b;
  }), []), a = h.useCallback((d) => {
    o(t.current[d]);
  }, [o]), l = h.useCallback((...d) => {
    const [f, p, m] = d;
    if (!t.current[f])
      return p;
    const b = t.current[f].processorsAsArray;
    let v = p;
    for (let g = 0; g < b.length; g += 1)
      v = b[g](v, m);
    return v;
  }, []), c = {
    registerPipeProcessor: s,
    registerPipeApplier: i,
    requestPipeProcessorsApplication: a
  }, u = {
    unstable_applyPipeProcessors: l
  };
  ot(e, c, "private"), ot(e, u, "public");
}, bt = (e, t, n, o = !0) => {
  const s = h.useRef(null), i = h.useRef(`mui-${Math.round(Math.random() * 1e9)}`), a = h.useCallback(() => {
    s.current = e.current.registerPipeProcessor(t, i.current, n);
  }, [e, n, t]);
  ra(() => {
    o && a();
  });
  const l = h.useRef(!0);
  h.useEffect(() => (l.current ? l.current = !1 : o && a(), () => {
    s.current && (s.current(), s.current = null);
  }), [a, o]);
}, p0 = (e, t, n) => {
  const o = h.useRef(null), s = h.useRef(`mui-${Math.round(Math.random() * 1e9)}`), i = h.useCallback(() => {
    o.current = e.current.registerPipeApplier(t, s.current, n);
  }, [e, n, t]);
  ra(() => {
    i();
  });
  const a = h.useRef(!0);
  h.useEffect(() => (a.current ? a.current = !1 : i(), () => {
    o.current && (o.current(), o.current = null);
  }), [i]);
}, pr = (e, t, n, o) => {
  const s = h.useCallback(() => {
    e.current.registerStrategyProcessor(t, n, o);
  }, [e, o, n, t]);
  ra(() => {
    s();
  });
  const i = h.useRef(!0);
  h.useEffect(() => {
    i.current ? i.current = !1 : s();
  }, [s]);
}, Hi = "none", WT = {
  rowTreeCreation: "rowTree",
  filtering: "rowTree",
  sorting: "rowTree",
  visibleRowsLookupCreation: "rowTree"
}, ree = (e) => {
  const t = h.useRef(/* @__PURE__ */ new Map()), n = h.useRef({}), o = h.useCallback((c, u, d) => {
    const f = () => {
      const b = n.current[u], v = ve(b, [c].map(sl));
      n.current[u] = v;
    };
    n.current[u] || (n.current[u] = {});
    const p = n.current[u], m = p[c];
    return p[c] = d, !m || m === d || c === e.current.getActiveStrategy(WT[u]) && e.current.publishEvent("activeStrategyProcessorChange", u), f;
  }, [e]), s = h.useCallback((c, u) => {
    const d = e.current.getActiveStrategy(WT[c]);
    if (d == null)
      throw new Error("Can't apply a strategy processor before defining an active strategy");
    const f = n.current[c];
    if (!f || !f[d])
      throw new Error(`No processor found for processor "${c}" on strategy "${d}"`);
    const p = f[d];
    return p(u);
  }, [e]), i = h.useCallback((c) => {
    const d = Array.from(t.current.entries()).find(([, f]) => f.group !== c ? !1 : f.isAvailable());
    return (d == null ? void 0 : d[0]) ?? Hi;
  }, []), a = h.useCallback((c, u, d) => {
    t.current.set(u, {
      group: c,
      isAvailable: d
    }), e.current.publishEvent("strategyAvailabilityChange");
  }, [e]);
  ot(e, {
    registerStrategyProcessor: o,
    applyStrategyProcessor: s,
    getActiveStrategy: i,
    setStrategyAvailability: a
  }, "private");
}, see = (e) => {
  const t = h.useRef({}), n = h.useCallback((c) => {
    t.current[c.stateId] = c;
  }, []), o = h.useCallback((c, u) => {
    let d;
    if (Ek(c) ? d = c(e.current.state) : d = c, e.current.state === d)
      return !1;
    let f = !1;
    const p = [];
    if (Object.keys(t.current).forEach((m) => {
      const b = t.current[m], v = b.stateSelector(e.current.state, e.current.instanceId), g = b.stateSelector(d, e.current.instanceId);
      g !== v && (p.push({
        stateId: b.stateId,
        hasPropChanged: g !== b.propModel
      }), b.propModel !== void 0 && g !== b.propModel && (f = !0));
    }), p.length > 1)
      throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${p[0].stateId}, therefore, you're not allowed to update ${p.map((m) => m.stateId).join(", ")} in the same transaction.`);
    if (f || (e.current.state = d, e.current.publishEvent("stateChange", d), e.current.store.update(d)), p.length === 1) {
      const {
        stateId: m,
        hasPropChanged: b
      } = p[0], v = t.current[m], g = v.stateSelector(d, e.current.instanceId);
      v.propOnChange && b && v.propOnChange(g, {
        reason: u,
        api: e.current
      }), f || e.current.publishEvent(v.changeEvent, g, {
        reason: u
      });
    }
    return !f;
  }, [e]), s = h.useCallback((c, u, d) => e.current.setState((f) => I({}, f, {
    [c]: u(f[c])
  }), d), [e]), i = h.useCallback(() => {
  }, []), a = {
    setState: o,
    forceUpdate: i
  }, l = {
    updateControlState: s,
    registerControlState: n
  };
  ot(e, a, "public"), ot(e, l, "private");
}, iee = (e, t) => {
  const n = tee(e, t);
  return WJ(n), UJ(n), XJ(n, t), see(n), oee(n), ree(n), nee(n, t), n.current.register("private", {
    rootProps: t
  }), n;
}, wn = (e, t, n) => {
  const o = h.useRef(!1);
  o.current || (t.current.state = e(t.current.state, n, t), o.current = !0);
};
function $y(e, t) {
  if (e == null)
    return "";
  const n = typeof e == "string" ? e : `${e}`;
  if (t.shouldAppendQuotes || t.escapeFormulas) {
    const o = n.replace(/"/g, '""');
    return t.escapeFormulas && ["=", "+", "-", "@", "	", "\r"].includes(o[0]) ? `"'${o}"` : [t.delimiter, `
`, "\r", '"'].some((s) => n.includes(s)) ? `"${o}"` : o;
  }
  return n;
}
const E2 = (e, t) => {
  var i, a;
  const {
    csvOptions: n,
    ignoreValueFormatter: o
  } = t;
  let s;
  if (o) {
    const l = e.colDef.type;
    l === "number" ? s = String(e.value) : l === "date" || l === "dateTime" ? s = (i = e.value) == null ? void 0 : i.toISOString() : typeof ((a = e.value) == null ? void 0 : a.toString) == "function" ? s = e.value.toString() : s = e.value;
  } else
    s = e.formattedValue;
  return $y(s, n);
};
class Ay {
  constructor(t) {
    this.options = void 0, this.rowString = "", this.isEmpty = !0, this.options = t;
  }
  addValue(t) {
    this.isEmpty || (this.rowString += this.options.csvOptions.delimiter), typeof this.options.sanitizeCellValue == "function" ? this.rowString += this.options.sanitizeCellValue(t, this.options.csvOptions) : this.rowString += t, this.isEmpty = !1;
  }
  getRowString() {
    return this.rowString;
  }
}
const aee = ({
  id: e,
  columns: t,
  getCellParams: n,
  csvOptions: o,
  ignoreValueFormatter: s
}) => {
  const i = new Ay({
    csvOptions: o
  });
  return t.forEach((a) => {
    const l = n(e, a.field);
    process.env.NODE_ENV !== "production" && String(l.formattedValue) === "[object Object]" && vo(["MUI X: When the value of a field is an object or a `renderCell` is provided, the CSV export might not display the value correctly.", "You can provide a `valueFormatter` with a string representation to be used."]), i.addValue(E2(l, {
      ignoreValueFormatter: s,
      csvOptions: o
    }));
  }), i.getRowString();
};
function lee(e) {
  const {
    columns: t,
    rowIds: n,
    csvOptions: o,
    ignoreValueFormatter: s,
    apiRef: i
  } = e, a = n.reduce((f, p) => `${f}${aee({
    id: p,
    columns: t,
    getCellParams: i.current.getCellParams,
    ignoreValueFormatter: s,
    csvOptions: o
  })}\r
`, "").trim();
  if (!o.includeHeaders)
    return a;
  const l = t.filter((f) => f.field !== Il.field), c = [];
  if (o.includeColumnGroupsHeaders) {
    const f = i.current.getAllGroupDetails();
    let p = 0;
    const m = l.reduce((b, v) => {
      const g = i.current.getColumnGroupPath(v.field);
      return b[v.field] = g, p = Math.max(p, g.length), b;
    }, {});
    for (let b = 0; b < p; b += 1) {
      const v = new Ay({
        csvOptions: o,
        sanitizeCellValue: $y
      });
      c.push(v), l.forEach((g) => {
        const y = (m[g.field] || [])[b], w = f[y];
        v.addValue(w ? w.headerName || w.groupId : "");
      });
    }
  }
  const u = new Ay({
    csvOptions: o,
    sanitizeCellValue: $y
  });
  return l.forEach((f) => {
    u.addValue(f.headerName || f.field);
  }), c.push(u), `${`${c.map((f) => f.getRowString()).join(`\r
`)}\r
`}${a}`.trim();
}
function UT(e) {
  const t = document.createElement("span");
  t.style.whiteSpace = "pre", t.style.userSelect = "all", t.style.opacity = "0px", t.textContent = e, document.body.appendChild(t);
  const n = document.createRange();
  n.selectNode(t);
  const o = window.getSelection();
  o.removeAllRanges(), o.addRange(n);
  try {
    document.execCommand("copy");
  } finally {
    document.body.removeChild(t);
  }
}
function cee(e) {
  navigator.clipboard ? navigator.clipboard.writeText(e).catch(() => {
    UT(e);
  }) : UT(e);
}
function uee(e) {
  var t;
  return !!((t = window.getSelection()) != null && t.toString() || e && (e.selectionEnd || 0) - (e.selectionStart || 0) > 0);
}
const dee = (e, t) => {
  const n = t.ignoreValueFormatterDuringExport, o = (typeof n == "object" ? n == null ? void 0 : n.clipboardExport : n) || !1, s = t.clipboardCopyCellDelimiter, i = h.useCallback((a) => {
    if (!PZ(a) || uee(a.target))
      return;
    let l = "";
    if (e.current.getSelectedRows().size > 0)
      l = e.current.getDataAsCsv({
        includeHeaders: !1,
        delimiter: s,
        shouldAppendQuotes: !1,
        escapeFormulas: !1
      });
    else {
      const u = fo(e);
      if (u) {
        const d = e.current.getCellParams(u.id, u.field);
        l = E2(d, {
          csvOptions: {
            delimiter: s,
            shouldAppendQuotes: !1,
            escapeFormulas: !1
          },
          ignoreValueFormatter: o
        });
      }
    }
    l = e.current.unstable_applyPipeProcessors("clipboardCopy", l), l && (cee(l), e.current.publishEvent("clipboardCopy", l));
  }, [e, o, s]);
  nD(e, e.current.rootElementRef, "keydown", i), Pt(e, "clipboardCopy", t.onClipboardCopy);
}, fee = (e) => I({}, e, {
  columnMenu: {
    open: !1
  }
}), pee = (e) => {
  const t = Mn(e, "useGridColumnMenu"), n = h.useCallback((a) => {
    const l = nf(e.current.state), c = {
      open: !0,
      field: a
    };
    (c.open !== l.open || c.field !== l.field) && (e.current.setState((d) => d.columnMenu.open && d.columnMenu.field === a ? d : (t.debug("Opening Column Menu"), I({}, d, {
      columnMenu: {
        open: !0,
        field: a
      }
    }))), e.current.hidePreferences());
  }, [e, t]), o = h.useCallback(() => {
    const a = nf(e.current.state);
    if (a.field) {
      const u = as(e), d = jo(e), f = Or(e);
      let p = a.field;
      if (u[p] || (p = f[0]), d[p] === !1) {
        const m = f.filter((v) => v === p ? !0 : d[v] !== !1), b = m.indexOf(p);
        p = m[b + 1] || m[b - 1];
      }
      e.current.setColumnHeaderFocus(p);
    }
    const l = {
      open: !1,
      field: void 0
    };
    (l.open !== a.open || l.field !== a.field) && e.current.setState((u) => (t.debug("Hiding Column Menu"), I({}, u, {
      columnMenu: l
    })));
  }, [e, t]), s = h.useCallback((a) => {
    t.debug("Toggle Column Menu");
    const l = nf(e.current.state);
    !l.open || l.field !== a ? n(a) : o();
  }, [e, t, n, o]);
  ot(e, {
    showColumnMenu: n,
    hideColumnMenu: o,
    toggleColumnMenu: s
  }, "public"), Le(e, "columnResizeStart", o), Le(e, "virtualScrollerWheel", e.current.hideColumnMenu), Le(e, "virtualScrollerTouchMove", e.current.hideColumnMenu);
}, hee = (e, t, n) => {
  var s, i, a;
  const o = Ra({
    apiRef: n,
    columnsToUpsert: t.columns,
    initialState: (s = t.initialState) == null ? void 0 : s.columns,
    columnVisibilityModel: t.columnVisibilityModel ?? ((a = (i = t.initialState) == null ? void 0 : i.columns) == null ? void 0 : a.columnVisibilityModel) ?? {},
    keepOnlyColumnsToUpsert: !0
  });
  return I({}, e, {
    columns: o,
    // In pro/premium, this part of the state is defined. We give it an empty but defined value
    // for the community version.
    pinnedColumns: e.pinnedColumns ?? Lf
  });
};
function gee(e, t) {
  var R, P;
  const n = Mn(e, "useGridColumns"), o = h.useRef(t.columns);
  e.current.registerControlState({
    stateId: "visibleColumns",
    propModel: t.columnVisibilityModel,
    propOnChange: t.onColumnVisibilityModelChange,
    stateSelector: jo,
    changeEvent: "columnVisibilityModelChange"
  });
  const s = h.useCallback((F) => {
    var $, N;
    n.debug("Updating columns state."), e.current.setState(KT(F)), e.current.publishEvent("columnsChange", F.orderedFields), (N = ($ = e.current).updateRenderContext) == null || N.call($), e.current.forceUpdate();
  }, [n, e]), i = h.useCallback((F) => as(e)[F], [e]), a = h.useCallback(() => Pr(e), [e]), l = h.useCallback(() => pn(e), [e]), c = h.useCallback((F, $ = !0) => ($ ? pn(e) : Pr(e)).findIndex((A) => A.field === F), [e]), u = h.useCallback((F) => {
    const $ = c(F);
    return Os(e)[$];
  }, [e, c]), d = h.useCallback((F) => {
    var N, A;
    jo(e) !== F && (e.current.setState((k) => I({}, k, {
      columns: Ra({
        apiRef: e,
        columnsToUpsert: [],
        initialState: void 0,
        columnVisibilityModel: F,
        keepOnlyColumnsToUpsert: !1
      })
    })), (A = (N = e.current).updateRenderContext) == null || A.call(N), e.current.forceUpdate());
  }, [e]), f = h.useCallback((F) => {
    const $ = Ra({
      apiRef: e,
      columnsToUpsert: F,
      initialState: void 0,
      keepOnlyColumnsToUpsert: !1
    });
    s($);
  }, [e, s]), p = h.useCallback((F, $) => {
    const N = jo(e), A = N[F] ?? !0;
    if ($ !== A) {
      const k = I({}, N, {
        [F]: $
      });
      e.current.setColumnVisibilityModel(k);
    }
  }, [e]), m = h.useCallback((F) => Or(e).findIndex((N) => N === F), [e]), b = h.useCallback((F, $) => {
    const N = Or(e), A = m(F);
    if (A === $)
      return;
    n.debug(`Moving column ${F} to index ${$}`);
    const k = [...N], L = k.splice(A, 1)[0];
    k.splice($, 0, L), s(I({}, Qr(e.current.state), {
      orderedFields: k
    }));
    const B = {
      column: e.current.getColumn(F),
      targetIndex: e.current.getColumnIndexRelativeToVisibleColumns(F),
      oldIndex: A
    };
    e.current.publishEvent("columnIndexChange", B);
  }, [e, n, s, m]), v = h.useCallback((F, $) => {
    n.debug(`Updating column ${F} width to ${$}`);
    const N = Qr(e.current.state), A = N.lookup[F], k = I({}, A, {
      width: $,
      hasBeenResized: !0
    });
    s(Py(I({}, N, {
      lookup: I({}, N.lookup, {
        [F]: k
      })
    }), e.current.getRootDimensions())), e.current.publishEvent("columnWidthChange", {
      element: e.current.getColumnHeaderElement(F),
      colDef: k,
      width: $
    });
  }, [e, n, s]), g = {
    getColumn: i,
    getAllColumns: a,
    getColumnIndex: c,
    getColumnPosition: u,
    getVisibleColumns: l,
    getColumnIndexRelativeToVisibleColumns: m,
    updateColumns: f,
    setColumnVisibilityModel: d,
    setColumnVisibility: p,
    setColumnWidth: v
  }, y = {
    setColumnIndex: b
  };
  ot(e, g, "public"), ot(e, y, t.signature === Mo.DataGrid ? "private" : "public");
  const w = h.useCallback((F, $) => {
    var V, _;
    const N = {}, A = jo(e);
    // Always export if the `exportOnlyDirtyModels` property is not activated
    (!$.exportOnlyDirtyModels || // Always export if the model is controlled
    t.columnVisibilityModel != null || // Always export if the model has been initialized
    // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
    Object.keys(((_ = (V = t.initialState) == null ? void 0 : V.columns) == null ? void 0 : _.columnVisibilityModel) ?? {}).length > 0 || // Always export if the model is not empty
    Object.keys(A).length > 0) && (N.columnVisibilityModel = A), N.orderedFields = Or(e);
    const L = Pr(e), B = {};
    return L.forEach((z) => {
      if (z.hasBeenResized) {
        const j = {};
        CD.forEach((W) => {
          let J = z[W];
          J === 1 / 0 && (J = -1), j[W] = J;
        }), B[z.field] = j;
      }
    }), Object.keys(B).length > 0 && (N.dimensions = B), I({}, F, {
      columns: N
    });
  }, [e, t.columnVisibilityModel, (R = t.initialState) == null ? void 0 : R.columns]), x = h.useCallback((F, $) => {
    var L;
    const N = (L = $.stateToRestore.columns) == null ? void 0 : L.columnVisibilityModel, A = $.stateToRestore.columns;
    if (N == null && A == null)
      return F;
    const k = Ra({
      apiRef: e,
      columnsToUpsert: [],
      initialState: A,
      columnVisibilityModel: N,
      keepOnlyColumnsToUpsert: !1
    });
    return e.current.setState(KT(k)), A != null && e.current.publishEvent("columnsChange", k.orderedFields), F;
  }, [e]), S = h.useCallback((F, $) => {
    var N;
    if ($ === zi.columns) {
      const A = t.slots.columnsPanel;
      return /* @__PURE__ */ C(A, I({}, (N = t.slotProps) == null ? void 0 : N.columnsPanel));
    }
    return F;
  }, [t.slots.columnsPanel, (P = t.slotProps) == null ? void 0 : P.columnsPanel]), T = h.useCallback((F) => t.disableColumnSelector ? F : [...F, "columnMenuColumnsItem"], [t.disableColumnSelector]);
  bt(e, "columnMenu", T), bt(e, "exportState", w), bt(e, "restoreState", x), bt(e, "preferencePanel", S);
  const E = h.useRef(null);
  Le(e, "viewportInnerSizeChange", (F) => {
    if (E.current !== F.width) {
      if (E.current = F.width, !pn(e).some((N) => N.flex && N.flex > 0))
        return;
      s(Py(Qr(e.current.state), e.current.getRootDimensions()));
    }
  });
  const M = h.useCallback(() => {
    n.info("Columns pipe processing have changed, regenerating the columns");
    const F = Ra({
      apiRef: e,
      columnsToUpsert: [],
      initialState: void 0,
      keepOnlyColumnsToUpsert: !1
    });
    s(F);
  }, [e, n, s]);
  p0(e, "hydrateColumns", M);
  const D = h.useRef(!0);
  h.useEffect(() => {
    if (D.current) {
      D.current = !1;
      return;
    }
    if (n.info(`GridColumns have changed, new length ${t.columns.length}`), o.current === t.columns)
      return;
    const F = Ra({
      apiRef: e,
      initialState: void 0,
      // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
      columnsToUpsert: t.columns,
      keepOnlyColumnsToUpsert: !0
    });
    o.current = t.columns, s(F);
  }, [n, e, s, t.columns]), h.useEffect(() => {
    t.columnVisibilityModel !== void 0 && e.current.setColumnVisibilityModel(t.columnVisibilityModel);
  }, [e, n, t.columnVisibilityModel]);
}
function KT(e) {
  return (t) => I({}, t, {
    columns: e
  });
}
const mee = (e, t) => {
  var n;
  return I({}, e, {
    density: ((n = t.initialState) == null ? void 0 : n.density) ?? t.density ?? "standard"
  });
}, bee = (e, t) => {
  var l;
  const n = Mn(e, "useDensity");
  e.current.registerControlState({
    stateId: "density",
    propModel: t.density,
    propOnChange: t.onDensityChange,
    stateSelector: ka,
    changeEvent: "densityChange"
  });
  const s = {
    setDensity: xe((c) => {
      ka(e.current.state) !== c && (n.debug(`Set grid density to ${c}`), e.current.setState((d) => I({}, d, {
        density: c
      })));
    })
  };
  ot(e, s, "public");
  const i = h.useCallback((c, u) => {
    var p;
    const d = ka(e.current.state);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !u.exportOnlyDirtyModels || // Always export if the `density` is controlled
      t.density != null || // Always export if the `density` has been initialized
      ((p = t.initialState) == null ? void 0 : p.density) != null ? I({}, c, {
        density: d
      }) : c
    );
  }, [e, t.density, (l = t.initialState) == null ? void 0 : l.density]), a = h.useCallback((c, u) => {
    var f;
    const d = (f = u.stateToRestore) != null && f.density ? u.stateToRestore.density : ka(e.current.state);
    return e.current.setState((p) => I({}, p, {
      density: d
    })), c;
  }, [e]);
  bt(e, "exportState", i), bt(e, "restoreState", a), h.useEffect(() => {
    t.density && e.current.setDensity(t.density);
  }, [e, t.density]);
};
function yee(e, t = "csv", n = document.title || "untitled") {
  const o = `${n}.${t}`;
  if ("download" in HTMLAnchorElement.prototype) {
    const s = URL.createObjectURL(e), i = document.createElement("a");
    i.href = s, i.download = o, i.click(), setTimeout(() => {
      URL.revokeObjectURL(s);
    });
    return;
  }
  throw new Error("MUI X: exportAs not supported.");
}
const I2 = ({
  apiRef: e,
  options: t
}) => {
  const n = Pr(e);
  return t.fields ? t.fields.reduce((s, i) => {
    const a = n.find((l) => l.field === i);
    return a && s.push(a), s;
  }, []) : (t.allColumns ? n : pn(e)).filter((s) => !s.disableExport);
}, O2 = ({
  apiRef: e
}) => {
  var c, u;
  const t = Qk(e), n = Vn(e), o = e.current.getSelectedRows(), s = t.filter((d) => n[d].type !== "footer"), i = oa(e), a = ((c = i == null ? void 0 : i.top) == null ? void 0 : c.map((d) => d.id)) || [], l = ((u = i == null ? void 0 : i.bottom) == null ? void 0 : u.map((d) => d.id)) || [];
  return s.unshift(...a), s.push(...l), o.size > 0 ? s.filter((d) => o.has(d)) : s;
}, vee = (e, t) => {
  const n = Mn(e, "useGridCsvExport"), o = t.ignoreValueFormatterDuringExport, s = (typeof o == "object" ? o == null ? void 0 : o.csvExport : o) || !1, i = h.useCallback((u = {}) => {
    n.debug("Get data as CSV");
    const d = I2({
      apiRef: e,
      options: u
    }), p = (u.getRowsToExport ?? O2)({
      apiRef: e
    });
    return lee({
      columns: d,
      rowIds: p,
      csvOptions: {
        delimiter: u.delimiter || ",",
        shouldAppendQuotes: u.shouldAppendQuotes ?? !0,
        includeHeaders: u.includeHeaders ?? !0,
        includeColumnGroupsHeaders: u.includeColumnGroupsHeaders ?? !0,
        escapeFormulas: u.escapeFormulas ?? !0
      },
      ignoreValueFormatter: s,
      apiRef: e
    });
  }, [n, e, s]), a = h.useCallback((u) => {
    n.debug("Export data as CSV");
    const d = i(u), f = new Blob([u != null && u.utf8WithBom ? new Uint8Array([239, 187, 191]) : "", d], {
      type: "text/csv"
    });
    yee(f, "csv", u == null ? void 0 : u.fileName);
  }, [n, i]);
  ot(e, {
    getDataAsCsv: i,
    exportDataAsCsv: a
  }, "public");
  const c = h.useCallback((u, d) => {
    var f;
    return (f = d.csvOptions) != null && f.disableToolbarButton ? u : [...u, {
      component: /* @__PURE__ */ C(g2, {
        options: d.csvOptions
      }),
      componentName: "csvExport"
    }];
  }, []);
  bt(e, "exportMenu", c);
}, of = (e, t, n) => {
  let o = e.paginationModel;
  const s = e.rowCount, i = (n == null ? void 0 : n.pageSize) ?? o.pageSize, a = (n == null ? void 0 : n.page) ?? o.page, l = oD(s, i, a);
  n && ((n == null ? void 0 : n.page) !== o.page || (n == null ? void 0 : n.pageSize) !== o.pageSize) && (o = n);
  const c = qK(o.page, l);
  return c !== o.page && (o = I({}, o, {
    page: c
  })), sD(o.pageSize, t), o;
}, Cee = (e, t) => {
  var v, g;
  const n = Mn(e, "useGridPaginationModel"), o = ge(e, Tl), s = Math.floor(t.rowHeight * o);
  e.current.registerControlState({
    stateId: "paginationModel",
    propModel: t.paginationModel,
    propOnChange: t.onPaginationModelChange,
    stateSelector: oo,
    changeEvent: "paginationModelChange"
  });
  const i = h.useCallback((y) => {
    const w = oo(e);
    y !== w.page && (n.debug(`Setting page to ${y}`), e.current.setPaginationModel({
      page: y,
      pageSize: w.pageSize
    }));
  }, [e, n]), a = h.useCallback((y) => {
    const w = oo(e);
    y !== w.pageSize && (n.debug(`Setting page size to ${y}`), e.current.setPaginationModel({
      pageSize: y,
      page: w.page
    }));
  }, [e, n]), l = h.useCallback((y) => {
    const w = oo(e);
    y !== w && (n.debug("Setting 'paginationModel' to", y), e.current.setState((x) => I({}, x, {
      pagination: I({}, x.pagination, {
        paginationModel: of(x.pagination, t.signature, y)
      })
    }), "setPaginationModel"));
  }, [e, n, t.signature]);
  ot(e, {
    setPage: i,
    setPageSize: a,
    setPaginationModel: l
  }, "public");
  const u = h.useCallback((y, w) => {
    var T, E;
    const x = oo(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !w.exportOnlyDirtyModels || // Always export if the `paginationModel` is controlled
      t.paginationModel != null || // Always export if the `paginationModel` has been initialized
      ((E = (T = t.initialState) == null ? void 0 : T.pagination) == null ? void 0 : E.paginationModel) != null || // Export if `page` or `pageSize` is not equal to the default value
      x.page !== 0 && x.pageSize !== GK(t.autoPageSize) ? I({}, y, {
        pagination: I({}, y.pagination, {
          paginationModel: x
        })
      }) : y
    );
  }, [e, t.paginationModel, (g = (v = t.initialState) == null ? void 0 : v.pagination) == null ? void 0 : g.paginationModel, t.autoPageSize]), d = h.useCallback((y, w) => {
    var S, T;
    const x = (S = w.stateToRestore.pagination) != null && S.paginationModel ? I({}, rD(t.autoPageSize), (T = w.stateToRestore.pagination) == null ? void 0 : T.paginationModel) : oo(e);
    return e.current.setState((E) => I({}, E, {
      pagination: I({}, E.pagination, {
        paginationModel: of(E.pagination, t.signature, x)
      })
    }), "stateRestorePreProcessing"), y;
  }, [e, t.autoPageSize, t.signature]);
  bt(e, "exportState", u), bt(e, "restoreState", d);
  const f = () => {
    var w;
    const y = oo(e);
    (w = e.current.virtualScrollerRef) != null && w.current && e.current.scrollToIndexes({
      rowIndex: y.page * y.pageSize
    });
  }, p = h.useCallback(() => {
    if (!t.autoPageSize)
      return;
    const y = e.current.getRootDimensions(), w = Math.floor(y.viewportInnerSize.height / s);
    e.current.setPageSize(w);
  }, [e, t.autoPageSize, s]), m = h.useCallback((y) => {
    if (y == null)
      return;
    const w = oo(e), x = lD(e);
    w.page > x - 1 && e.current.setPage(Math.max(0, x - 1));
  }, [e]);
  Le(e, "viewportInnerSizeChange", p), Le(e, "paginationModelChange", f), Le(e, "rowCountChange", m);
  const b = h.useRef(!0);
  h.useEffect(() => {
    if (b.current) {
      b.current = !1;
      return;
    }
    t.pagination && e.current.setState((y) => I({}, y, {
      pagination: I({}, y.pagination, {
        paginationModel: of(y.pagination, t.signature, t.paginationModel)
      })
    }));
  }, [e, t.paginationModel, t.signature, t.pagination]), h.useEffect(() => {
    e.current.setState((y) => {
      const w = t.pagination === !0;
      return y.pagination.paginationMode === t.paginationMode || y.pagination.enabled === w ? y : I({}, y, {
        pagination: I({}, y.pagination, {
          paginationMode: t.paginationMode,
          enabled: t.pagination === !0
        })
      });
    });
  }, [e, t.paginationMode, t.pagination]), h.useEffect(p, [p]);
};
function wee() {
  return new Promise((e) => {
    requestAnimationFrame(() => {
      e();
    });
  });
}
function See(e) {
  const t = document.createElement("iframe");
  return t.style.position = "absolute", t.style.width = "0px", t.style.height = "0px", t.title = e || document.title, t;
}
const xee = (e, t) => {
  const n = e.current.rootElementRef.current !== null, o = Mn(e, "useGridPrintExport"), s = h.useRef(null), i = h.useRef(null), a = h.useRef({}), l = h.useRef([]), c = h.useRef(null);
  h.useEffect(() => {
    s.current = qt(e.current.rootElementRef.current);
  }, [e, n]);
  const u = h.useCallback((g, y, w) => new Promise((x) => {
    const S = I2({
      apiRef: e,
      options: {
        fields: g,
        allColumns: y
      }
    }).map((O) => O.field), T = Pr(e), E = {};
    T.forEach((O) => {
      E[O.field] = S.includes(O.field);
    }), w && (E[Il.field] = !0), e.current.setColumnVisibilityModel(E), x();
  }), [e]), d = h.useCallback((g) => {
    const w = g({
      apiRef: e
    }).reduce((x, S) => {
      const T = e.current.getRow(S);
      return T[za] || x.push(T), x;
    }, []);
    e.current.setRows(w);
  }, [e]), f = h.useCallback((g, y) => {
    var N, A, k, L;
    const w = I({
      copyStyles: !0,
      hideToolbar: !1,
      hideFooter: !1,
      includeCheckboxes: !1
    }, y), x = g.contentDocument;
    if (!x)
      return;
    const S = Lu(e.current.state), T = e.current.rootElementRef.current, E = T.cloneNode(!0), O = E.querySelector(`.${K.main}`);
    O.style.overflow = "visible", E.style.contain = "size";
    let M = ((N = T.querySelector(`.${K.toolbarContainer}`)) == null ? void 0 : N.offsetHeight) || 0, D = ((A = T.querySelector(`.${K.footerContainer}`)) == null ? void 0 : A.offsetHeight) || 0;
    w.hideToolbar && ((k = E.querySelector(`.${K.toolbarContainer}`)) == null || k.remove(), M = 0), w.hideFooter && ((L = E.querySelector(`.${K.footerContainer}`)) == null || L.remove(), D = 0);
    const R = S.currentPageTotalHeight + r0(e, t) + M + D;
    if (E.style.height = `${R}px`, E.style.boxSizing = "content-box", !w.hideFooter) {
      const B = E.querySelector(`.${K.footerContainer}`);
      B.style.position = "absolute", B.style.width = "100%", B.style.top = `${R - D}px`;
    }
    const P = document.createElement("div");
    P.appendChild(E), x.body.style.marginTop = "0px", x.body.innerHTML = P.innerHTML;
    const F = typeof w.pageStyle == "function" ? w.pageStyle() : w.pageStyle;
    if (typeof F == "string") {
      const B = x.createElement("style");
      B.appendChild(x.createTextNode(F)), x.head.appendChild(B);
    }
    w.bodyClassName && x.body.classList.add(...w.bodyClassName.split(" "));
    const $ = [];
    if (w.copyStyles) {
      const B = T.getRootNode(), _ = (B.constructor.name === "ShadowRoot" ? B : s.current).querySelectorAll("style, link[rel='stylesheet']");
      for (let z = 0; z < _.length; z += 1) {
        const j = _[z];
        if (j.tagName === "STYLE") {
          const W = x.createElement(j.tagName), J = j.sheet;
          if (J) {
            let G = "";
            for (let q = 0; q < J.cssRules.length; q += 1)
              typeof J.cssRules[q].cssText == "string" && (G += `${J.cssRules[q].cssText}\r
`);
            W.appendChild(x.createTextNode(G)), x.head.appendChild(W);
          }
        } else if (j.getAttribute("href")) {
          const W = x.createElement(j.tagName);
          for (let J = 0; J < j.attributes.length; J += 1) {
            const G = j.attributes[J];
            G && W.setAttribute(G.nodeName, G.nodeValue || "");
          }
          $.push(new Promise((J) => {
            W.addEventListener("load", () => J());
          })), x.head.appendChild(W);
        }
      }
    }
    process.env.NODE_ENV !== "test" && Promise.all($).then(() => {
      g.contentWindow.print();
    });
  }, [e, s, t]), p = h.useCallback((g) => {
    var y, w;
    s.current.body.removeChild(g), e.current.restoreState(i.current || {}), (w = (y = i.current) == null ? void 0 : y.columns) != null && w.columnVisibilityModel || e.current.setColumnVisibilityModel(a.current), e.current.setState((x) => I({}, x, {
      virtualization: c.current
    })), e.current.setRows(l.current), i.current = null, a.current = {}, l.current = [];
  }, [e]), b = {
    exportDataAsPrint: h.useCallback(async (g) => {
      if (o.debug("Export data as Print"), !e.current.rootElementRef.current)
        throw new Error("MUI X: No grid root element available.");
      if (i.current = e.current.exportState(), a.current = jo(e), l.current = e.current.getSortedRows().filter((w) => !w[za]), t.pagination) {
        const x = {
          page: 0,
          pageSize: ZC(e)
        };
        e.current.setState((S) => I({}, S, {
          pagination: I({}, S.pagination, {
            paginationModel: of(
              S.pagination,
              // Using signature `DataGridPro` to allow more than 100 rows in the print export
              "DataGridPro",
              x
            )
          })
        }));
      }
      c.current = e.current.state.virtualization, e.current.setState((w) => I({}, w, {
        virtualization: I({}, w.virtualization, {
          enabled: !1,
          enabledForColumns: !1
        })
      })), await u(g == null ? void 0 : g.fields, g == null ? void 0 : g.allColumns, g == null ? void 0 : g.includeCheckboxes), d((g == null ? void 0 : g.getRowsToExport) ?? O2), await wee();
      const y = See(g == null ? void 0 : g.fileName);
      process.env.NODE_ENV === "test" ? (s.current.body.appendChild(y), f(y, g), p(y)) : (y.onload = () => {
        f(y, g), y.contentWindow.matchMedia("print").addEventListener("change", (x) => {
          x.matches === !1 && p(y);
        });
      }, s.current.body.appendChild(y));
    }, [t, o, e, f, p, u, d])
  };
  ot(e, b, "public");
  const v = h.useCallback((g, y) => {
    var w;
    return (w = y.printOptions) != null && w.disableToolbarButton ? g : [...g, {
      component: /* @__PURE__ */ C(m2, {
        options: y.printOptions
      }),
      componentName: "printExport"
    }];
  }, []);
  bt(e, "exportMenu", v);
}, Tee = (e, t, n) => {
  var s, i;
  const o = t.filterModel ?? ((i = (s = t.initialState) == null ? void 0 : s.filter) == null ? void 0 : i.filterModel) ?? Yc();
  return I({}, e, {
    filter: I({
      filterModel: KC(o, t.disableMultipleColumnsFiltering, n)
    }, UC),
    visibleRowsLookup: {}
  });
}, Ree = (e) => e.filteredRowsLookup;
function YT(e, t) {
  return e.current.applyStrategyProcessor("visibleRowsLookupCreation", {
    tree: t.rows.tree,
    filteredRowsLookup: t.filter.filteredRowsLookup
  });
}
function Eee() {
  return hk(Object.values);
}
const Iee = (e, t) => {
  var D, R, P;
  const n = Mn(e, "useGridFilter");
  e.current.registerControlState({
    stateId: "filter",
    propModel: t.filterModel,
    propOnChange: t.onFilterModelChange,
    stateSelector: kn,
    changeEvent: "filterModelChange"
  });
  const o = h.useCallback(() => {
    e.current.setState((F) => {
      const $ = kn(F, e.current.instanceId), N = e.current.getFilterState($), A = I({}, F, {
        filter: I({}, F.filter, N)
      }), k = YT(e, A);
      return I({}, A, {
        visibleRowsLookup: k
      });
    }), e.current.publishEvent("filteredRowsSet");
  }, [e]), s = h.useCallback((F, $) => $ == null || $.filterable === !1 || t.disableColumnFilter ? F : [...F, "columnMenuFilterItem"], [t.disableColumnFilter]), i = h.useCallback(() => {
    o(), e.current.forceUpdate();
  }, [e, o]), a = h.useCallback((F) => {
    const $ = kn(e), N = [...$.items], A = N.findIndex((k) => k.id === F.id);
    A === -1 ? N.push(F) : N[A] = F, e.current.setFilterModel(I({}, $, {
      items: N
    }), "upsertFilterItem");
  }, [e]), l = h.useCallback((F) => {
    const $ = kn(e), N = [...$.items];
    F.forEach((A) => {
      const k = N.findIndex((L) => L.id === A.id);
      k === -1 ? N.push(A) : N[k] = A;
    }), e.current.setFilterModel(I({}, $, {
      items: N
    }), "upsertFilterItems");
  }, [e]), c = h.useCallback((F) => {
    const $ = kn(e), N = $.items.filter((A) => A.id !== F.id);
    N.length !== $.items.length && e.current.setFilterModel(I({}, $, {
      items: N
    }), "deleteFilterItem");
  }, [e]), u = h.useCallback((F, $, N) => {
    if (n.debug("Displaying filter panel"), F) {
      const A = kn(e), k = A.items.filter((_) => {
        var J;
        if (_.value !== void 0)
          return !(Array.isArray(_.value) && _.value.length === 0);
        const j = (J = e.current.getColumn(_.field).filterOperators) == null ? void 0 : J.find((G) => G.value === _.operator);
        return !(typeof (j == null ? void 0 : j.requiresFilterValue) > "u" ? !0 : j == null ? void 0 : j.requiresFilterValue);
      });
      let L;
      const B = k.find((_) => _.field === F), V = e.current.getColumn(F);
      B ? L = k : t.disableMultipleColumnsFiltering ? L = [Oy({
        field: F,
        operator: V.filterOperators[0].value
      }, e)] : L = [...k, Oy({
        field: F,
        operator: V.filterOperators[0].value
      }, e)], e.current.setFilterModel(I({}, A, {
        items: L
      }));
    }
    e.current.showPreferences(zi.filters, $, N);
  }, [e, n, t.disableMultipleColumnsFiltering]), d = h.useCallback(() => {
    n.debug("Hiding filter panel"), e.current.hidePreferences();
  }, [e, n]), f = h.useCallback((F) => {
    const $ = kn(e);
    $.logicOperator !== F && e.current.setFilterModel(I({}, $, {
      logicOperator: F
    }), "changeLogicOperator");
  }, [e]), p = h.useCallback((F) => {
    const $ = kn(e);
    Xr($.quickFilterValues, F) || e.current.setFilterModel(I({}, $, {
      quickFilterValues: [...F]
    }));
  }, [e]), m = h.useCallback((F, $) => {
    kn(e) !== F && (n.debug("Setting filter model"), e.current.updateControlState("filter", oT(F, t.disableMultipleColumnsFiltering, e), $), e.current.unstable_applyFilters());
  }, [e, n, t.disableMultipleColumnsFiltering]), b = h.useCallback((F) => {
    const $ = KC(F, t.disableMultipleColumnsFiltering, e), N = t.filterMode === "client" ? jU($, e, t.disableEval) : null, A = e.current.applyStrategyProcessor("filtering", {
      isRowMatchingFilters: N,
      filterModel: $ ?? Yc()
    });
    return I({}, A, {
      filterModel: $
    });
  }, [t.disableMultipleColumnsFiltering, t.filterMode, t.disableEval, e]), v = {
    setFilterLogicOperator: f,
    unstable_applyFilters: i,
    deleteFilterItem: c,
    upsertFilterItem: a,
    upsertFilterItems: l,
    setFilterModel: m,
    showFilterPanel: u,
    hideFilterPanel: d,
    setQuickFilterValues: p,
    ignoreDiacritics: t.ignoreDiacritics,
    getFilterState: b
  };
  ot(e, v, "public");
  const g = h.useCallback((F, $) => {
    var k, L;
    const N = kn(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !$.exportOnlyDirtyModels || // Always export if the model is controlled
      t.filterModel != null || // Always export if the model has been initialized
      ((L = (k = t.initialState) == null ? void 0 : k.filter) == null ? void 0 : L.filterModel) != null || // Export if the model is not equal to the default value
      !Xr(N, Yc()) ? I({}, F, {
        filter: {
          filterModel: N
        }
      }) : F
    );
  }, [e, t.filterModel, (R = (D = t.initialState) == null ? void 0 : D.filter) == null ? void 0 : R.filterModel]), y = h.useCallback((F, $) => {
    var A;
    const N = (A = $.stateToRestore.filter) == null ? void 0 : A.filterModel;
    return N == null ? F : (e.current.updateControlState("filter", oT(N, t.disableMultipleColumnsFiltering, e), "restoreState"), I({}, F, {
      callbacks: [...F.callbacks, e.current.unstable_applyFilters]
    }));
  }, [e, t.disableMultipleColumnsFiltering]), w = h.useCallback((F, $) => {
    var N;
    if ($ === zi.filters) {
      const A = t.slots.filterPanel;
      return /* @__PURE__ */ C(A, I({}, (N = t.slotProps) == null ? void 0 : N.filterPanel));
    }
    return F;
  }, [t.slots.filterPanel, (P = t.slotProps) == null ? void 0 : P.filterPanel]), {
    getRowId: x
  } = t, S = Jo(Eee), T = h.useCallback((F) => {
    var z;
    if (t.filterMode !== "client" || !F.isRowMatchingFilters || !F.filterModel.items.length && !((z = F.filterModel.quickFilterValues) != null && z.length))
      return UC;
    const $ = fr(e), N = {}, {
      isRowMatchingFilters: A
    } = F, k = {}, L = {
      passingFilterItems: null,
      passingQuickFilterValues: null
    }, B = S.current(e.current.state.rows.dataRowIdToModelLookup);
    for (let j = 0; j < B.length; j += 1) {
      const W = B[j], J = x ? x(W) : W.id;
      A(W, void 0, L);
      const G = $k([L.passingFilterItems], [L.passingQuickFilterValues], F.filterModel, e, k);
      N[J] = G;
    }
    const V = "auto-generated-group-footer-root";
    return $[V] && (N[V] = !0), {
      filteredRowsLookup: N,
      filteredChildrenCountLookup: {},
      filteredDescendantCountLookup: {}
    };
  }, [e, t.filterMode, x, S]);
  bt(e, "columnMenu", s), bt(e, "exportState", g), bt(e, "restoreState", y), bt(e, "preferencePanel", w), pr(e, Hi, "filtering", T), pr(e, Hi, "visibleRowsLookupCreation", Ree);
  const E = h.useCallback(() => {
    n.debug("onColUpdated - GridColumns changed, applying filters");
    const F = kn(e), $ = as(e), N = F.items.filter((A) => A.field && $[A.field]);
    N.length < F.items.length && e.current.setFilterModel(I({}, F, {
      items: N
    }));
  }, [e, n]), O = h.useCallback((F) => {
    F === "filtering" && e.current.unstable_applyFilters();
  }, [e]), M = h.useCallback(() => {
    e.current.setState((F) => I({}, F, {
      visibleRowsLookup: YT(e, F)
    })), e.current.forceUpdate();
  }, [e]);
  Le(e, "rowsSet", o), Le(e, "columnsChange", E), Le(e, "activeStrategyProcessorChange", O), Le(e, "rowExpansionChange", M), Le(e, "columnVisibilityModelChange", () => {
    const F = kn(e);
    F.quickFilterValues && Nk(F) && e.current.unstable_applyFilters();
  }), ra(() => {
    e.current.unstable_applyFilters();
  }), yt(() => {
    t.filterModel !== void 0 && e.current.setFilterModel(t.filterModel);
  }, [e, n, t.filterModel]);
}, Oee = (e) => I({}, e, {
  focus: {
    cell: null,
    columnHeader: null,
    columnHeaderFilter: null,
    columnGroupHeader: null
  },
  tabIndex: {
    cell: null,
    columnHeader: null,
    columnHeaderFilter: null,
    columnGroupHeader: null
  }
}), Pee = (e, t) => {
  const n = Mn(e, "useGridFocus"), o = h.useRef(null), s = e.current.rootElementRef.current !== null, i = h.useCallback((M, D) => {
    M && e.current.getRow(M.id) && e.current.publishEvent("cellFocusOut", e.current.getCellParams(M.id, M.field), D);
  }, [e]), a = h.useCallback((M, D) => {
    const R = fo(e);
    (R == null ? void 0 : R.id) === M && (R == null ? void 0 : R.field) === D || (e.current.setState((P) => (n.debug(`Focusing on cell with id=${M} and field=${D}`), I({}, P, {
      tabIndex: {
        cell: {
          id: M,
          field: D
        },
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      },
      focus: {
        cell: {
          id: M,
          field: D
        },
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    }))), e.current.forceUpdate(), e.current.getRow(M) && (R && i(R, {}), e.current.publishEvent("cellFocusIn", e.current.getCellParams(M, D))));
  }, [e, n, i]), l = h.useCallback((M, D = {}) => {
    const R = fo(e);
    i(R, D), e.current.setState((P) => (n.debug(`Focusing on column header with colIndex=${M}`), I({}, P, {
      tabIndex: {
        columnHeader: {
          field: M
        },
        columnHeaderFilter: null,
        cell: null,
        columnGroupHeader: null
      },
      focus: {
        columnHeader: {
          field: M
        },
        columnHeaderFilter: null,
        cell: null,
        columnGroupHeader: null
      }
    }))), e.current.forceUpdate();
  }, [e, n, i]), c = h.useCallback((M, D = {}) => {
    const R = fo(e);
    i(R, D), e.current.setState((P) => (n.debug(`Focusing on column header filter with colIndex=${M}`), I({}, P, {
      tabIndex: {
        columnHeader: null,
        columnHeaderFilter: {
          field: M
        },
        cell: null,
        columnGroupHeader: null
      },
      focus: {
        columnHeader: null,
        columnHeaderFilter: {
          field: M
        },
        cell: null,
        columnGroupHeader: null
      }
    }))), e.current.forceUpdate();
  }, [e, n, i]), u = h.useCallback((M, D, R = {}) => {
    const P = fo(e);
    P && e.current.publishEvent("cellFocusOut", e.current.getCellParams(P.id, P.field), R), e.current.setState((F) => I({}, F, {
      tabIndex: {
        columnGroupHeader: {
          field: M,
          depth: D
        },
        columnHeader: null,
        columnHeaderFilter: null,
        cell: null
      },
      focus: {
        columnGroupHeader: {
          field: M,
          depth: D
        },
        columnHeader: null,
        columnHeaderFilter: null,
        cell: null
      }
    })), e.current.forceUpdate();
  }, [e]), d = h.useCallback(() => _f(e), [e]), f = h.useCallback((M, D, R) => {
    let P = e.current.getColumnIndex(D);
    const F = pn(e), $ = bs(e, {
      pagination: t.pagination,
      paginationMode: t.paginationMode
    }), N = oa(e), A = [].concat(N.top || [], $.rows, N.bottom || []);
    let k = A.findIndex((_) => _.id === M);
    R === "right" ? P += 1 : R === "left" ? P -= 1 : k += 1, P >= F.length ? (k += 1, k < A.length && (P = 0)) : P < 0 && (k -= 1, k >= 0 && (P = F.length - 1)), k = Uo(k, 0, A.length - 1);
    const L = A[k];
    if (!L)
      return;
    const B = e.current.unstable_getCellColSpanInfo(L.id, P);
    B && B.spannedByColSpan && (R === "left" || R === "below" ? P = B.leftVisibleCellIndex : R === "right" && (P = B.rightVisibleCellIndex)), P = Uo(P, 0, F.length - 1);
    const V = F[P];
    e.current.setCellFocus(L.id, V.field);
  }, [e, t.pagination, t.paginationMode]), p = h.useCallback(({
    id: M,
    field: D
  }) => {
    e.current.setCellFocus(M, D);
  }, [e]), m = h.useCallback((M, D) => {
    D.key === "Enter" || D.key === "Tab" || D.key === "Shift" || Zc(D.key) || e.current.setCellFocus(M.id, M.field);
  }, [e]), b = h.useCallback(({
    field: M
  }, D) => {
    D.target === D.currentTarget && e.current.setColumnHeaderFocus(M, D);
  }, [e]), v = h.useCallback(({
    fields: M,
    depth: D
  }, R) => {
    if (R.target !== R.currentTarget)
      return;
    const P = _f(e);
    P !== null && P.depth === D && M.includes(P.field) || e.current.setColumnGroupHeaderFocus(M[0], D, R);
  }, [e]), g = h.useCallback((M, D) => {
    var R, P;
    (P = (R = D.relatedTarget) == null ? void 0 : R.getAttribute("class")) != null && P.includes(K.columnHeader) || (n.debug("Clearing focus"), e.current.setState((F) => I({}, F, {
      focus: {
        cell: null,
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    })));
  }, [n, e]), y = h.useCallback((M) => {
    o.current = M;
  }, []), w = h.useCallback((M) => {
    const D = o.current;
    o.current = null;
    const R = fo(e);
    if (!e.current.unstable_applyPipeProcessors("canUpdateFocus", !0, {
      event: M,
      cell: D
    }))
      return;
    if (!R) {
      D && e.current.setCellFocus(D.id, D.field);
      return;
    }
    if ((D == null ? void 0 : D.id) === R.id && (D == null ? void 0 : D.field) === R.field)
      return;
    const F = e.current.getCellElement(R.id, R.field);
    F != null && F.contains(M.target) || (D ? e.current.setCellFocus(D.id, D.field) : (e.current.setState(($) => I({}, $, {
      focus: {
        cell: null,
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    })), e.current.forceUpdate(), i(R, M)));
  }, [e, i]), x = h.useCallback((M) => {
    if (M.cellMode === "view")
      return;
    const D = fo(e);
    ((D == null ? void 0 : D.id) !== M.id || (D == null ? void 0 : D.field) !== M.field) && e.current.setCellFocus(M.id, M.field);
  }, [e]), S = h.useCallback(() => {
    const M = fo(e);
    if (M && !e.current.getRow(M.id)) {
      const D = M.id;
      let R = null;
      if (typeof D < "u") {
        const P = e.current.getRowElement(D), F = P != null && P.dataset.rowindex ? Number(P == null ? void 0 : P.dataset.rowindex) : 0, $ = bs(e, {
          pagination: t.pagination,
          paginationMode: t.paginationMode
        }), N = $.rows[Uo(F, 0, $.rows.length - 1)];
        R = (N == null ? void 0 : N.id) ?? null;
      }
      e.current.setState((P) => I({}, P, {
        focus: {
          cell: R === null ? null : {
            id: R,
            field: M.field
          },
          columnHeader: null,
          columnHeaderFilter: null,
          columnGroupHeader: null
        }
      }));
    }
  }, [e, t.pagination, t.paginationMode]), T = xe(() => {
    const M = fo(e);
    if (!M)
      return;
    const D = bs(e, {
      pagination: t.pagination,
      paginationMode: t.paginationMode
    });
    if (D.rows.find((F) => F.id === M.id))
      return;
    const P = pn(e);
    e.current.setState((F) => I({}, F, {
      tabIndex: {
        cell: {
          id: D.rows[0].id,
          field: P[0].field
        },
        columnGroupHeader: null,
        columnHeader: null,
        columnHeaderFilter: null
      }
    }));
  }), E = {
    setCellFocus: a,
    setColumnHeaderFocus: l,
    setColumnHeaderFilterFocus: c
  }, O = {
    moveFocusToRelativeCell: f,
    setColumnGroupHeaderFocus: u,
    getColumnGroupHeaderFocus: d
  };
  ot(e, E, "public"), ot(e, O, "private"), h.useEffect(() => {
    const M = qt(e.current.rootElementRef.current);
    return M.addEventListener("mouseup", w), () => {
      M.removeEventListener("mouseup", w);
    };
  }, [e, s, w]), Le(e, "columnHeaderBlur", g), Le(e, "cellDoubleClick", p), Le(e, "cellMouseDown", y), Le(e, "cellKeyDown", m), Le(e, "cellModeChange", x), Le(e, "columnHeaderFocus", b), Le(e, "columnGroupHeaderFocus", v), Le(e, "rowsSet", S), Le(e, "paginationModelChange", T);
}, Eg = ({
  currentColIndex: e,
  firstColIndex: t,
  lastColIndex: n,
  isRtl: o
}) => {
  if (o) {
    if (e < n)
      return e + 1;
  } else if (!o && e > t)
    return e - 1;
  return null;
}, Ig = ({
  currentColIndex: e,
  firstColIndex: t,
  lastColIndex: n,
  isRtl: o
}) => {
  if (o) {
    if (e > t)
      return e - 1;
  } else if (!o && e < n)
    return e + 1;
  return null;
};
function Mee(e, t, n, o) {
  var l, c;
  const s = SD(e);
  if (!((l = s[t]) != null && l[n]))
    return t;
  const i = Qk(e);
  let a = i.indexOf(t) + (o === "down" ? 1 : -1);
  for (; a >= 0 && a < i.length; ) {
    const u = i[a];
    if (!((c = s[u]) != null && c[n]))
      return u;
    a += o === "down" ? 1 : -1;
  }
  return t;
}
const kee = Mt(Au, oa, (e, t) => (t.top || []).concat(e.rows, t.bottom || [])), Dee = (e, t) => {
  const n = Mn(e, "useGridKeyboardNavigation"), o = _t(), s = t.unstable_listView, i = h.useCallback(() => kee(e), [e]), a = t.signature !== "DataGrid" && t.headerFilters, l = h.useCallback((y, w, x = "left", S = "up") => {
    const T = oi(e), E = e.current.unstable_getCellColSpanInfo(w, y);
    E && E.spannedByColSpan && (x === "left" ? y = E.leftVisibleCellIndex : x === "right" && (y = E.rightVisibleCellIndex));
    const O = s ? cl(e.current.state).field : na(e)[y], M = Mee(e, w, O, S), D = T.findIndex((R) => R.id === M);
    n.debug(`Navigating to cell row ${D}, col ${y}`), e.current.scrollToIndexes({
      colIndex: y,
      rowIndex: D
    }), e.current.setCellFocus(M, O);
  }, [e, n, s]), c = h.useCallback((y, w) => {
    n.debug(`Navigating to header col ${y}`), e.current.scrollToIndexes({
      colIndex: y
    });
    const x = e.current.getVisibleColumns()[y].field;
    e.current.setColumnHeaderFocus(x, w);
  }, [e, n]), u = h.useCallback((y, w) => {
    n.debug(`Navigating to header filter col ${y}`), e.current.scrollToIndexes({
      colIndex: y
    });
    const x = e.current.getVisibleColumns()[y].field;
    e.current.setColumnHeaderFilterFocus(x, w);
  }, [e, n]), d = h.useCallback((y, w, x) => {
    n.debug(`Navigating to header col ${y}`), e.current.scrollToIndexes({
      colIndex: y
    });
    const {
      field: S
    } = e.current.getVisibleColumns()[y];
    e.current.setColumnGroupHeaderFocus(S, w, x);
  }, [e, n]), f = h.useCallback((y) => {
    var w;
    return (w = i()[y]) == null ? void 0 : w.id;
  }, [i]), p = h.useCallback((y, w) => {
    const x = w.currentTarget.querySelector(`.${K.columnHeaderTitleContainerContent}`);
    if (!!x && x.contains(w.target) && y.field !== Il.field)
      return;
    const T = i(), E = e.current.getViewportPageSize(), O = y.field ? e.current.getColumnIndex(y.field) : 0, M = T.length > 0 ? 0 : null, D = T.length - 1, R = 0, P = pn(e).length - 1, F = Fu(e);
    let $ = !0;
    switch (w.key) {
      case "ArrowDown": {
        a ? u(O, w) : M !== null && l(O, f(M));
        break;
      }
      case "ArrowRight": {
        const N = Ig({
          currentColIndex: O,
          firstColIndex: R,
          lastColIndex: P,
          isRtl: o
        });
        N !== null && c(N, w);
        break;
      }
      case "ArrowLeft": {
        const N = Eg({
          currentColIndex: O,
          firstColIndex: R,
          lastColIndex: P,
          isRtl: o
        });
        N !== null && c(N, w);
        break;
      }
      case "ArrowUp": {
        F > 0 && d(O, F - 1, w);
        break;
      }
      case "PageDown": {
        M !== null && D !== null && l(O, f(Math.min(M + E, D)));
        break;
      }
      case "Home": {
        c(R, w);
        break;
      }
      case "End": {
        c(P, w);
        break;
      }
      case "Enter": {
        (w.ctrlKey || w.metaKey) && e.current.toggleColumnMenu(y.field);
        break;
      }
      case " ":
        break;
      default:
        $ = !1;
    }
    $ && w.preventDefault();
  }, [e, i, a, u, l, f, o, c, d]), m = h.useCallback((y, w) => {
    const x = bD(e) === y.field, S = o0(e) === y.field;
    if (x || S || !Zc(w.key))
      return;
    const T = i(), E = e.current.getViewportPageSize(), O = y.field ? e.current.getColumnIndex(y.field) : 0, M = 0, D = T.length - 1, R = 0, P = pn(e).length - 1;
    let F = !0;
    switch (w.key) {
      case "ArrowDown": {
        const $ = f(M);
        $ != null && l(O, $);
        break;
      }
      case "ArrowRight": {
        const $ = Ig({
          currentColIndex: O,
          firstColIndex: R,
          lastColIndex: P,
          isRtl: o
        });
        $ !== null && u($, w);
        break;
      }
      case "ArrowLeft": {
        const $ = Eg({
          currentColIndex: O,
          firstColIndex: R,
          lastColIndex: P,
          isRtl: o
        });
        $ !== null ? u($, w) : e.current.setColumnHeaderFilterFocus(y.field, w);
        break;
      }
      case "ArrowUp": {
        c(O, w);
        break;
      }
      case "PageDown": {
        D !== null && l(O, f(Math.min(M + E, D)));
        break;
      }
      case "Home": {
        u(R, w);
        break;
      }
      case "End": {
        u(P, w);
        break;
      }
      case " ":
        break;
      default:
        F = !1;
    }
    F && w.preventDefault();
  }, [e, i, u, o, c, l, f]), b = h.useCallback((y, w) => {
    const x = _f(e);
    if (x === null)
      return;
    const {
      field: S,
      depth: T
    } = x, {
      fields: E,
      depth: O,
      maxDepth: M
    } = y, D = i(), R = e.current.getViewportPageSize(), P = e.current.getColumnIndex(S), F = S ? e.current.getColumnIndex(S) : 0, $ = 0, N = D.length - 1, A = 0, k = pn(e).length - 1;
    let L = !0;
    switch (w.key) {
      case "ArrowDown": {
        O === M - 1 ? c(P, w) : d(P, T + 1, w);
        break;
      }
      case "ArrowUp": {
        O > 0 && d(P, T - 1, w);
        break;
      }
      case "ArrowRight": {
        const B = E.length - E.indexOf(S) - 1;
        P + B + 1 <= k && d(P + B + 1, T, w);
        break;
      }
      case "ArrowLeft": {
        const B = E.indexOf(S);
        P - B - 1 >= A && d(P - B - 1, T, w);
        break;
      }
      case "PageDown": {
        N !== null && l(F, f(Math.min($ + R, N)));
        break;
      }
      case "Home": {
        d(A, T, w);
        break;
      }
      case "End": {
        d(k, T, w);
        break;
      }
      case " ":
        break;
      default:
        L = !1;
    }
    L && w.preventDefault();
  }, [e, i, c, d, l, f]), v = h.useCallback((y, w) => {
    if (Ol(w))
      return;
    const x = e.current.getCellParams(y.id, y.field);
    if (x.cellMode === Bt.Edit || !Zc(w.key) || !e.current.unstable_applyPipeProcessors("canUpdateFocus", !0, {
      event: w,
      cell: x
    }))
      return;
    const T = i();
    if (T.length === 0)
      return;
    const E = e.current.getViewportPageSize(), O = s ? () => 0 : e.current.getColumnIndex, M = y.field ? O(y.field) : 0, D = T.findIndex((k) => k.id === y.id), R = 0, P = T.length - 1, F = 0, N = (s ? [cl(e.current.state)] : pn(e)).length - 1;
    let A = !0;
    switch (w.key) {
      case "ArrowDown": {
        D < P && l(M, f(D + 1), o ? "right" : "left", "down");
        break;
      }
      case "ArrowUp": {
        D > R ? l(M, f(D - 1)) : a ? u(M, w) : c(M, w);
        break;
      }
      case "ArrowRight": {
        const k = Ig({
          currentColIndex: M,
          firstColIndex: F,
          lastColIndex: N,
          isRtl: o
        });
        k !== null && l(k, f(D), o ? "left" : "right");
        break;
      }
      case "ArrowLeft": {
        const k = Eg({
          currentColIndex: M,
          firstColIndex: F,
          lastColIndex: N,
          isRtl: o
        });
        k !== null && l(k, f(D), o ? "right" : "left");
        break;
      }
      case "Tab": {
        w.shiftKey && M > F ? l(M - 1, f(D), "left") : !w.shiftKey && M < N && l(M + 1, f(D), "right");
        break;
      }
      case " ": {
        if (y.field === Bo)
          break;
        const L = y.colDef;
        if (L && (L.field === YC || XX(L.field)))
          break;
        !w.shiftKey && D < P && l(M, f(Math.min(D + E, P)));
        break;
      }
      case "PageDown": {
        D < P && l(M, f(Math.min(D + E, P)));
        break;
      }
      case "PageUp": {
        const k = Math.max(D - E, R);
        k !== D && k >= R ? l(M, f(k)) : c(M, w);
        break;
      }
      case "Home": {
        w.ctrlKey || w.metaKey || w.shiftKey ? l(F, f(R)) : l(F, f(D));
        break;
      }
      case "End": {
        w.ctrlKey || w.metaKey || w.shiftKey ? l(N, f(P)) : l(N, f(D));
        break;
      }
      default:
        A = !1;
    }
    A && w.preventDefault();
  }, [e, i, o, l, f, a, u, c, s]), g = h.useCallback((y, {
    event: w
  }) => w.key === " " ? !1 : y, []);
  bt(e, "canStartEditing", g), Le(e, "columnHeaderKeyDown", p), Le(e, "headerFilterKeyDown", m), Le(e, "columnGroupHeaderKeyDown", b), Le(e, "cellKeyDown", v);
}, Nee = (e, t) => {
  var b, v;
  const n = Mn(e, "useGridRowCount"), o = ge(e, Wp), s = ge(e, Na), i = ge(e, pc), a = ge(e, oo), l = Jo(() => oo(e).pageSize);
  e.current.registerControlState({
    stateId: "paginationRowCount",
    propModel: t.rowCount,
    propOnChange: t.onRowCountChange,
    stateSelector: Na,
    changeEvent: "rowCountChange"
  });
  const u = {
    setRowCount: h.useCallback((g) => {
      s !== g && (n.debug("Setting 'rowCount' to", g), e.current.setState((y) => I({}, y, {
        pagination: I({}, y.pagination, {
          rowCount: g
        })
      })));
    }, [e, n, s])
  };
  ot(e, u, "public");
  const d = h.useCallback((g, y) => {
    var S, T;
    const w = Na(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !y.exportOnlyDirtyModels || // Always export if the `rowCount` is controlled
      t.rowCount != null || // Always export if the `rowCount` has been initialized
      ((T = (S = t.initialState) == null ? void 0 : S.pagination) == null ? void 0 : T.rowCount) != null ? I({}, g, {
        pagination: I({}, g.pagination, {
          rowCount: w
        })
      }) : g
    );
  }, [e, t.rowCount, (v = (b = t.initialState) == null ? void 0 : b.pagination) == null ? void 0 : v.rowCount]), f = h.useCallback((g, y) => {
    var x;
    const w = (x = y.stateToRestore.pagination) != null && x.rowCount ? y.stateToRestore.pagination.rowCount : Na(e);
    return e.current.setState((S) => I({}, S, {
      pagination: I({}, S.pagination, {
        rowCount: w
      })
    })), g;
  }, [e]);
  bt(e, "exportState", d), bt(e, "restoreState", f);
  const p = h.useCallback((g) => {
    t.paginationMode === "client" || !l.current || g.pageSize !== l.current && (l.current = g.pageSize, s === -1 && e.current.setPage(0));
  }, [t.paginationMode, l, s, e]);
  Le(e, "paginationModelChange", p), h.useEffect(() => {
    t.paginationMode === "client" ? e.current.setRowCount(o) : t.rowCount != null && e.current.setRowCount(t.rowCount);
  }, [e, t.paginationMode, o, t.rowCount]);
  const m = i.hasNextPage === !1;
  h.useEffect(() => {
    m && s === -1 && e.current.setRowCount(a.pageSize * a.page + o);
  }, [e, o, m, s, a]);
}, $ee = (e, t) => {
  var c, u;
  const n = Mn(e, "useGridPaginationMeta"), o = ge(e, pc);
  e.current.registerControlState({
    stateId: "paginationMeta",
    propModel: t.paginationMeta,
    propOnChange: t.onPaginationMetaChange,
    stateSelector: pc,
    changeEvent: "paginationMetaChange"
  });
  const i = {
    setPaginationMeta: h.useCallback((d) => {
      o !== d && (n.debug("Setting 'paginationMeta' to", d), e.current.setState((f) => I({}, f, {
        pagination: I({}, f.pagination, {
          meta: d
        })
      })));
    }, [e, n, o])
  };
  ot(e, i, "public");
  const a = h.useCallback((d, f) => {
    var b, v;
    const p = pc(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !f.exportOnlyDirtyModels || // Always export if the `paginationMeta` is controlled
      t.paginationMeta != null || // Always export if the `paginationMeta` has been initialized
      ((v = (b = t.initialState) == null ? void 0 : b.pagination) == null ? void 0 : v.meta) != null ? I({}, d, {
        pagination: I({}, d.pagination, {
          meta: p
        })
      }) : d
    );
  }, [e, t.paginationMeta, (u = (c = t.initialState) == null ? void 0 : c.pagination) == null ? void 0 : u.meta]), l = h.useCallback((d, f) => {
    var m;
    const p = (m = f.stateToRestore.pagination) != null && m.meta ? f.stateToRestore.pagination.meta : pc(e);
    return e.current.setState((b) => I({}, b, {
      pagination: I({}, b.pagination, {
        meta: p
      })
    })), d;
  }, [e]);
  bt(e, "exportState", a), bt(e, "restoreState", l), h.useEffect(() => {
    t.paginationMeta && e.current.setPaginationMeta(t.paginationMeta);
  }, [e, t.paginationMeta]);
}, Aee = (e, t) => {
  var i, a, l, c, u, d, f;
  const n = I({}, rD(t.autoPageSize), t.paginationModel ?? ((a = (i = t.initialState) == null ? void 0 : i.pagination) == null ? void 0 : a.paginationModel));
  sD(n.pageSize, t.signature);
  const o = t.rowCount ?? ((c = (l = t.initialState) == null ? void 0 : l.pagination) == null ? void 0 : c.rowCount) ?? (t.paginationMode === "client" ? (u = e.rows) == null ? void 0 : u.totalRowCount : void 0), s = t.paginationMeta ?? ((f = (d = t.initialState) == null ? void 0 : d.pagination) == null ? void 0 : f.meta) ?? {};
  return I({}, e, {
    pagination: I({}, e.pagination, {
      paginationModel: n,
      rowCount: o,
      meta: s,
      enabled: t.pagination === !0,
      paginationMode: t.paginationMode
    })
  });
}, Fee = (e, t) => {
  $ee(e, t), Cee(e, t), Nee(e, t);
}, Lee = (e, t) => {
  var n;
  return I({}, e, {
    preferencePanel: ((n = t.initialState) == null ? void 0 : n.preferencePanel) ?? {
      open: !1
    }
  });
}, _ee = (e, t) => {
  var l;
  const n = Mn(e, "useGridPreferencesPanel"), o = h.useCallback(() => {
    e.current.setState((c) => {
      if (!c.preferencePanel.open)
        return c;
      n.debug("Hiding Preferences Panel");
      const u = Qc(c);
      return e.current.publishEvent("preferencePanelClose", {
        openedPanelValue: u.openedPanelValue
      }), I({}, c, {
        preferencePanel: {
          open: !1
        }
      });
    });
  }, [e, n]), s = h.useCallback((c, u, d) => {
    n.debug("Opening Preferences Panel"), e.current.setState((f) => I({}, f, {
      preferencePanel: I({}, f.preferencePanel, {
        open: !0,
        openedPanelValue: c,
        panelId: u,
        labelId: d
      })
    })), e.current.publishEvent("preferencePanelOpen", {
      openedPanelValue: c
    });
  }, [n, e]);
  ot(e, {
    showPreferences: s,
    hidePreferences: o
  }, "public");
  const i = h.useCallback((c, u) => {
    var p;
    const d = Qc(e.current.state);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !u.exportOnlyDirtyModels || // Always export if the panel was initialized
      ((p = t.initialState) == null ? void 0 : p.preferencePanel) != null || // Always export if the panel is opened
      d.open ? I({}, c, {
        preferencePanel: d
      }) : c
    );
  }, [e, (l = t.initialState) == null ? void 0 : l.preferencePanel]), a = h.useCallback((c, u) => {
    const d = u.stateToRestore.preferencePanel;
    return d != null && e.current.setState((f) => I({}, f, {
      preferencePanel: d
    })), c;
  }, [e]);
  bt(e, "exportState", i), bt(e, "restoreState", a);
}, Fy = (e) => {
  switch (e.type) {
    case "boolean":
      return !1;
    case "date":
    case "dateTime":
    case "number":
      return;
    case "singleSelect":
      return null;
    case "string":
    default:
      return "";
  }
}, Vee = ["id", "field"], Bee = ["id", "field"], zee = (e, t) => {
  const [n, o] = h.useState({}), s = h.useRef(n), i = h.useRef({}), {
    processRowUpdate: a,
    onProcessRowUpdateError: l,
    cellModesModel: c,
    onCellModesModelChange: u
  } = t, d = (A) => (...k) => {
    t.editMode === ts.Cell && A(...k);
  }, f = h.useCallback((A, k) => {
    const L = e.current.getCellParams(A, k);
    if (!e.current.isCellEditable(L))
      throw new Error(`MUI X: The cell with id=${A} and field=${k} is not editable.`);
  }, [e]), p = h.useCallback((A, k, L) => {
    if (e.current.getCellMode(A, k) !== L)
      throw new Error(`MUI X: The cell with id=${A} and field=${k} is not in ${L} mode.`);
  }, [e]), m = h.useCallback((A, k) => {
    if (!A.isEditable || A.cellMode === Bt.Edit)
      return;
    const L = I({}, A, {
      reason: ps.cellDoubleClick
    });
    e.current.publishEvent("cellEditStart", L, k);
  }, [e]), b = h.useCallback((A, k) => {
    if (A.cellMode === Bt.View || e.current.getCellMode(A.id, A.field) === Bt.View)
      return;
    const L = I({}, A, {
      reason: xr.cellFocusOut
    });
    e.current.publishEvent("cellEditStop", L, k);
  }, [e]), v = h.useCallback((A, k) => {
    if (A.cellMode === Bt.Edit) {
      if (k.which === 229)
        return;
      let L;
      if (k.key === "Escape" ? L = xr.escapeKeyDown : k.key === "Enter" ? L = xr.enterKeyDown : k.key === "Tab" && (L = k.shiftKey ? xr.shiftTabKeyDown : xr.tabKeyDown, k.preventDefault()), L) {
        const B = I({}, A, {
          reason: L
        });
        e.current.publishEvent("cellEditStop", B, k);
      }
    } else if (A.isEditable) {
      let L;
      if (!e.current.unstable_applyPipeProcessors("canStartEditing", !0, {
        event: k,
        cellParams: A,
        editMode: "cell"
      }))
        return;
      if (XD(k) ? L = ps.printableKeyDown : ZD(k) ? L = ps.pasteKeyDown : k.key === "Enter" ? L = ps.enterKeyDown : (k.key === "Backspace" || k.key === "Delete") && (L = ps.deleteKeyDown), L) {
        const V = I({}, A, {
          reason: L,
          key: k.key
        });
        e.current.publishEvent("cellEditStart", V, k);
      }
    }
  }, [e]), g = h.useCallback((A) => {
    const {
      id: k,
      field: L,
      reason: B
    } = A, V = {
      id: k,
      field: L
    };
    (B === ps.printableKeyDown || B === ps.deleteKeyDown || B === ps.pasteKeyDown) && (V.deleteValue = !0), e.current.startCellEditMode(V);
  }, [e]), y = h.useCallback((A) => {
    const {
      id: k,
      field: L,
      reason: B
    } = A;
    e.current.runPendingEditCellValueMutation(k, L);
    let V;
    B === xr.enterKeyDown ? V = "below" : B === xr.tabKeyDown ? V = "right" : B === xr.shiftTabKeyDown && (V = "left");
    const _ = B === "escapeKeyDown";
    e.current.stopCellEditMode({
      id: k,
      field: L,
      ignoreModifications: _,
      cellToFocusAfter: V
    });
  }, [e]), w = (A) => async (...k) => {
    var L;
    if (A) {
      const {
        id: B,
        field: V
      } = k[0];
      ((L = e.current.state.editRows[B][V]) == null ? void 0 : L.error) || A(...k);
    }
  };
  Le(e, "cellDoubleClick", d(m)), Le(e, "cellFocusOut", d(b)), Le(e, "cellKeyDown", d(v)), Le(e, "cellEditStart", d(g)), Le(e, "cellEditStop", d(y)), Pt(e, "cellEditStart", t.onCellEditStart), Pt(e, "cellEditStop", w(t.onCellEditStop));
  const x = h.useCallback((A, k) => {
    const L = Pn(e.current.state);
    return L[A] && L[A][k] ? Bt.Edit : Bt.View;
  }, [e]), S = xe((A) => {
    const k = A !== t.cellModesModel;
    u && k && u(A, {
      api: e.current
    }), !(t.cellModesModel && k) && (o(A), s.current = A, e.current.publishEvent("cellModesModelChange", A));
  }), T = h.useCallback((A, k, L) => {
    const B = I({}, s.current);
    if (L !== null)
      B[A] = I({}, B[A], {
        [k]: I({}, L)
      });
    else {
      const V = B[A], _ = ve(V, [k].map(sl));
      B[A] = _, Object.keys(B[A]).length === 0 && delete B[A];
    }
    S(B);
  }, [S]), E = h.useCallback((A, k, L) => {
    e.current.setState((B) => {
      const V = I({}, B.editRows);
      return L !== null ? V[A] = I({}, V[A], {
        [k]: I({}, L)
      }) : (delete V[A][k], Object.keys(V[A]).length === 0 && delete V[A]), I({}, B, {
        editRows: V
      });
    }), e.current.forceUpdate();
  }, [e]), O = h.useCallback((A) => {
    const {
      id: k,
      field: L
    } = A, B = ve(A, Vee);
    f(k, L), p(k, L, Bt.View), T(k, L, I({
      mode: Bt.Edit
    }, B));
  }, [f, p, T]), M = xe(async (A) => {
    const {
      id: k,
      field: L,
      deleteValue: B,
      initialValue: V
    } = A, _ = e.current.getCellValue(k, L);
    let z = _;
    B ? z = Fy(e.current.getColumn(L)) : V && (z = V);
    const j = e.current.getColumn(L), W = !!j.preProcessEditCellProps && B;
    let J = {
      value: z,
      error: !1,
      isProcessingProps: W
    };
    if (E(k, L, J), e.current.setCellFocus(k, L), W && (J = await Promise.resolve(j.preProcessEditCellProps({
      id: k,
      row: e.current.getRow(k),
      props: J,
      hasChanged: z !== _
    })), e.current.getCellMode(k, L) === Bt.Edit)) {
      const G = Pn(e.current.state);
      E(k, L, I({}, J, {
        value: G[k][L].value,
        isProcessingProps: !1
      }));
    }
  }), D = h.useCallback((A) => {
    const {
      id: k,
      field: L
    } = A, B = ve(A, Bee);
    p(k, L, Bt.Edit), T(k, L, I({
      mode: Bt.View
    }, B));
  }, [p, T]), R = xe(async (A) => {
    const {
      id: k,
      field: L,
      ignoreModifications: B,
      cellToFocusAfter: V = "none"
    } = A;
    p(k, L, Bt.Edit), e.current.runPendingEditCellValueMutation(k, L);
    const _ = () => {
      E(k, L, null), T(k, L, null), V !== "none" && e.current.moveFocusToRelativeCell(k, L, V);
    };
    if (B) {
      _();
      return;
    }
    const z = Pn(e.current.state), {
      error: j,
      isProcessingProps: W
    } = z[k][L];
    if (j || W) {
      i.current[k][L].mode = Bt.Edit, T(k, L, {
        mode: Bt.Edit
      });
      return;
    }
    const J = e.current.getRowWithUpdatedValuesFromCellEditing(k, L);
    if (a) {
      const G = (q) => {
        i.current[k][L].mode = Bt.Edit, T(k, L, {
          mode: Bt.Edit
        }), l ? l(q) : process.env.NODE_ENV !== "production" && vo(["MUI X: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.", "To handle the error pass a callback to the `onProcessRowUpdateError` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.", "For more detail, see https://mui.com/x/react-data-grid/editing/#server-side-persistence."], "error");
      };
      try {
        const q = e.current.getRow(k);
        Promise.resolve(a(J, q, {
          rowId: k
        })).then((Z) => {
          e.current.updateRows([Z]), _();
        }).catch(G);
      } catch (q) {
        G(q);
      }
    } else
      e.current.updateRows([J]), _();
  }), P = h.useCallback(async (A) => {
    var q, Z;
    const {
      id: k,
      field: L,
      value: B,
      debounceMs: V,
      unstable_skipValueParser: _
    } = A;
    f(k, L), p(k, L, Bt.Edit);
    const z = e.current.getColumn(L), j = e.current.getRow(k);
    let W = B;
    z.valueParser && !_ && (W = z.valueParser(B, j, z, e));
    let J = Pn(e.current.state), G = I({}, J[k][L], {
      value: W,
      changeReason: V ? "debouncedSetEditCellValue" : "setEditCellValue"
    });
    if (z.preProcessEditCellProps) {
      const Y = B !== J[k][L].value;
      G = I({}, G, {
        isProcessingProps: !0
      }), E(k, L, G), G = await Promise.resolve(z.preProcessEditCellProps({
        id: k,
        row: j,
        props: G,
        hasChanged: Y
      }));
    }
    return e.current.getCellMode(k, L) === Bt.View ? !1 : (J = Pn(e.current.state), G = I({}, G, {
      isProcessingProps: !1
    }), G.value = z.preProcessEditCellProps ? J[k][L].value : W, E(k, L, G), J = Pn(e.current.state), !((Z = (q = J[k]) == null ? void 0 : q[L]) != null && Z.error));
  }, [e, f, p, E]), F = h.useCallback((A, k) => {
    const L = e.current.getColumn(k), B = Pn(e.current.state), V = e.current.getRow(A);
    if (!B[A] || !B[A][k])
      return e.current.getRow(A);
    const {
      value: _
    } = B[A][k];
    return L.valueSetter ? L.valueSetter(_, V, L, e) : I({}, V, {
      [k]: _
    });
  }, [e]), $ = {
    getCellMode: x,
    startCellEditMode: O,
    stopCellEditMode: D
  }, N = {
    setCellEditingEditCellValue: P,
    getRowWithUpdatedValuesFromCellEditing: F
  };
  ot(e, $, "public"), ot(e, N, "private"), h.useEffect(() => {
    c && S(c);
  }, [c, S]), yt(() => {
    const A = fr(e), k = i.current;
    i.current = Ik(n), Object.entries(n).forEach(([L, B]) => {
      Object.entries(B).forEach(([V, _]) => {
        var W, J;
        const z = ((J = (W = k[L]) == null ? void 0 : W[V]) == null ? void 0 : J.mode) || Bt.View, j = A[L] ? e.current.getRowId(A[L]) : L;
        _.mode === Bt.Edit && z === Bt.View ? M(I({
          id: j,
          field: V
        }, _)) : _.mode === Bt.View && z === Bt.Edit && R(I({
          id: j,
          field: V
        }, _));
      });
    });
  }, [e, n, M, R]);
}, Hee = ["id"], jee = ["id"], Gee = (e, t) => {
  const [n, o] = h.useState({}), s = h.useRef(n), i = h.useRef({}), a = h.useRef(void 0), l = h.useRef(null), {
    processRowUpdate: c,
    onProcessRowUpdateError: u,
    rowModesModel: d,
    onRowModesModelChange: f
  } = t, p = (V) => (..._) => {
    t.editMode === ts.Row && V(..._);
  }, m = h.useCallback((V, _) => {
    const z = e.current.getCellParams(V, _);
    if (!e.current.isCellEditable(z))
      throw new Error(`MUI X: The cell with id=${V} and field=${_} is not editable.`);
  }, [e]), b = h.useCallback((V, _) => {
    if (e.current.getRowMode(V) !== _)
      throw new Error(`MUI X: The row with id=${V} is not in ${_} mode.`);
  }, [e]), v = h.useCallback((V) => {
    const _ = Pn(e.current.state);
    return Object.values(_[V]).some((z) => z.error);
  }, [e]), g = h.useCallback((V, _) => {
    if (!V.isEditable || e.current.getRowMode(V.id) === fn.Edit)
      return;
    const z = e.current.getRowParams(V.id), j = I({}, z, {
      field: V.field,
      reason: Ls.cellDoubleClick
    });
    e.current.publishEvent("rowEditStart", j, _);
  }, [e]), y = h.useCallback((V) => {
    l.current = V;
  }, []), w = h.useCallback((V, _) => {
    V.isEditable && e.current.getRowMode(V.id) !== fn.View && (l.current = null, a.current = setTimeout(() => {
      var z;
      if (((z = l.current) == null ? void 0 : z.id) !== V.id) {
        if (!e.current.getRow(V.id) || e.current.getRowMode(V.id) === fn.View || v(V.id))
          return;
        const j = e.current.getRowParams(V.id), W = I({}, j, {
          field: V.field,
          reason: Fr.rowFocusOut
        });
        e.current.publishEvent("rowEditStop", W, _);
      }
    }));
  }, [e, v]);
  h.useEffect(() => () => {
    clearTimeout(a.current);
  }, []);
  const x = h.useCallback((V, _) => {
    if (V.cellMode === fn.Edit) {
      if (_.which === 229)
        return;
      let z;
      if (_.key === "Escape")
        z = Fr.escapeKeyDown;
      else if (_.key === "Enter")
        z = Fr.enterKeyDown;
      else if (_.key === "Tab") {
        const j = na(e).filter((W) => e.current.getColumn(W).type === Gp ? !0 : e.current.isCellEditable(e.current.getCellParams(V.id, W)));
        if (_.shiftKey ? V.field === j[0] && (z = Fr.shiftTabKeyDown) : V.field === j[j.length - 1] && (z = Fr.tabKeyDown), _.preventDefault(), !z) {
          const W = j.findIndex((G) => G === V.field), J = j[_.shiftKey ? W - 1 : W + 1];
          e.current.setCellFocus(V.id, J);
        }
      }
      if (z) {
        if (z !== Fr.escapeKeyDown && v(V.id))
          return;
        const j = I({}, e.current.getRowParams(V.id), {
          reason: z,
          field: V.field
        });
        e.current.publishEvent("rowEditStop", j, _);
      }
    } else if (V.isEditable) {
      let z;
      if (!e.current.unstable_applyPipeProcessors("canStartEditing", !0, {
        event: _,
        cellParams: V,
        editMode: "row"
      }))
        return;
      if (XD(_) || ZD(_) ? z = Ls.printableKeyDown : _.key === "Enter" ? z = Ls.enterKeyDown : (_.key === "Backspace" || _.key === "Delete") && (z = Ls.deleteKeyDown), z) {
        const W = e.current.getRowParams(V.id), J = I({}, W, {
          field: V.field,
          reason: z
        });
        e.current.publishEvent("rowEditStart", J, _);
      }
    }
  }, [e, v]), S = h.useCallback((V) => {
    const {
      id: _,
      field: z,
      reason: j
    } = V, W = {
      id: _,
      fieldToFocus: z
    };
    (j === Ls.printableKeyDown || j === Ls.deleteKeyDown) && (W.deleteValue = !!z), e.current.startRowEditMode(W);
  }, [e]), T = h.useCallback((V) => {
    const {
      id: _,
      reason: z,
      field: j
    } = V;
    e.current.runPendingEditCellValueMutation(_);
    let W;
    z === Fr.enterKeyDown ? W = "below" : z === Fr.tabKeyDown ? W = "right" : z === Fr.shiftTabKeyDown && (W = "left");
    const J = z === "escapeKeyDown";
    e.current.stopRowEditMode({
      id: _,
      ignoreModifications: J,
      field: j,
      cellToFocusAfter: W
    });
  }, [e]);
  Le(e, "cellDoubleClick", p(g)), Le(e, "cellFocusIn", p(y)), Le(e, "cellFocusOut", p(w)), Le(e, "cellKeyDown", p(x)), Le(e, "rowEditStart", p(S)), Le(e, "rowEditStop", p(T)), Pt(e, "rowEditStart", t.onRowEditStart), Pt(e, "rowEditStop", t.onRowEditStop);
  const E = h.useCallback((V) => MD(e, {
    rowId: V,
    editMode: t.editMode
  }) ? fn.Edit : fn.View, [e, t.editMode]), O = xe((V) => {
    const _ = V !== t.rowModesModel;
    f && _ && f(V, {
      api: e.current
    }), !(t.rowModesModel && _) && (o(V), s.current = V, e.current.publishEvent("rowModesModelChange", V));
  }), M = h.useCallback((V, _) => {
    const z = I({}, s.current);
    _ !== null ? z[V] = I({}, _) : delete z[V], O(z);
  }, [O]), D = h.useCallback((V, _) => {
    e.current.setState((z) => {
      const j = I({}, z.editRows);
      return _ !== null ? j[V] = _ : delete j[V], I({}, z, {
        editRows: j
      });
    }), e.current.forceUpdate();
  }, [e]), R = h.useCallback((V, _, z) => {
    e.current.setState((j) => {
      const W = I({}, j.editRows);
      return z !== null ? W[V] = I({}, W[V], {
        [_]: I({}, z)
      }) : (delete W[V][_], Object.keys(W[V]).length === 0 && delete W[V]), I({}, j, {
        editRows: W
      });
    }), e.current.forceUpdate();
  }, [e]), P = h.useCallback((V) => {
    const {
      id: _
    } = V, z = ve(V, Hee);
    b(_, fn.View), M(_, I({
      mode: fn.Edit
    }, z));
  }, [b, M]), F = xe((V) => {
    const {
      id: _,
      fieldToFocus: z,
      deleteValue: j,
      initialValue: W
    } = V, J = Or(e), G = J.reduce((q, Z) => {
      if (!e.current.getCellParams(_, Z).isEditable)
        return q;
      const Q = e.current.getColumn(Z);
      let ee = e.current.getCellValue(_, Z);
      return z === Z && (j || W) && (j ? ee = Fy(Q) : W && (ee = W)), q[Z] = {
        value: ee,
        error: !1,
        isProcessingProps: !!Q.preProcessEditCellProps && j
      }, q;
    }, {});
    D(_, G), z && e.current.setCellFocus(_, z), J.filter((q) => !!e.current.getColumn(q).preProcessEditCellProps && j).forEach((q) => {
      const Z = e.current.getColumn(q), Y = e.current.getCellValue(_, q), Q = j ? Fy(Z) : W ?? Y;
      Promise.resolve(Z.preProcessEditCellProps({
        id: _,
        row: e.current.getRow(_),
        props: G[q],
        hasChanged: Q !== Y
      })).then((ee) => {
        if (e.current.getRowMode(_) === fn.Edit) {
          const ne = Pn(e.current.state);
          R(_, q, I({}, ee, {
            value: ne[_][q].value,
            isProcessingProps: !1
          }));
        }
      });
    });
  }), $ = h.useCallback((V) => {
    const {
      id: _
    } = V, z = ve(V, jee);
    b(_, fn.Edit), M(_, I({
      mode: fn.View
    }, z));
  }, [b, M]), N = xe((V) => {
    const {
      id: _,
      ignoreModifications: z,
      field: j,
      cellToFocusAfter: W = "none"
    } = V;
    e.current.runPendingEditCellValueMutation(_);
    const J = () => {
      W !== "none" && j && e.current.moveFocusToRelativeCell(_, j, W), D(_, null), M(_, null);
    };
    if (z) {
      J();
      return;
    }
    const G = Pn(e.current.state), q = e.current.getRow(_);
    if (Object.values(G[_]).some((Q) => Q.isProcessingProps)) {
      i.current[_].mode = fn.Edit;
      return;
    }
    if (v(_)) {
      i.current[_].mode = fn.Edit, M(_, {
        mode: fn.Edit
      });
      return;
    }
    const Y = e.current.getRowWithUpdatedValuesFromRowEditing(_);
    if (c) {
      const Q = (ee) => {
        i.current[_].mode = fn.Edit, M(_, {
          mode: fn.Edit
        }), u ? u(ee) : process.env.NODE_ENV !== "production" && vo(["MUI X: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.", "To handle the error pass a callback to the `onProcessRowUpdateError` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.", "For more detail, see https://mui.com/x/react-data-grid/editing/#server-side-persistence."], "error");
      };
      try {
        Promise.resolve(c(Y, q, {
          rowId: _
        })).then((ee) => {
          e.current.updateRows([ee]), J();
        }).catch(Q);
      } catch (ee) {
        Q(ee);
      }
    } else
      e.current.updateRows([Y]), J();
  }), A = h.useCallback((V) => {
    const {
      id: _,
      field: z,
      value: j,
      debounceMs: W,
      unstable_skipValueParser: J
    } = V;
    m(_, z);
    const G = e.current.getColumn(z), q = e.current.getRow(_);
    let Z = j;
    G.valueParser && !J && (Z = G.valueParser(j, q, G, e));
    let Y = Pn(e.current.state), Q = I({}, Y[_][z], {
      value: Z,
      changeReason: W ? "debouncedSetEditCellValue" : "setEditCellValue"
    });
    return G.preProcessEditCellProps || R(_, z, Q), new Promise((ee) => {
      const ne = [];
      if (G.preProcessEditCellProps) {
        const H = Q.value !== Y[_][z].value;
        Q = I({}, Q, {
          isProcessingProps: !0
        }), R(_, z, Q);
        const U = Y[_], X = ve(U, [z].map(sl)), re = Promise.resolve(G.preProcessEditCellProps({
          id: _,
          row: q,
          props: Q,
          hasChanged: H,
          otherFieldsProps: X
        })).then((oe) => {
          if (e.current.getRowMode(_) === fn.View) {
            ee(!1);
            return;
          }
          Y = Pn(e.current.state), oe = I({}, oe, {
            isProcessingProps: !1
          }), oe.value = G.preProcessEditCellProps ? Y[_][z].value : Z, R(_, z, oe);
        });
        ne.push(re);
      }
      Object.entries(Y[_]).forEach(([H, U]) => {
        if (H === z)
          return;
        const X = e.current.getColumn(H);
        if (!X.preProcessEditCellProps)
          return;
        U = I({}, U, {
          isProcessingProps: !0
        }), R(_, H, U), Y = Pn(e.current.state);
        const re = Y[_], oe = ve(re, [H].map(sl)), le = Promise.resolve(X.preProcessEditCellProps({
          id: _,
          row: q,
          props: U,
          hasChanged: !1,
          otherFieldsProps: oe
        })).then((se) => {
          if (e.current.getRowMode(_) === fn.View) {
            ee(!1);
            return;
          }
          se = I({}, se, {
            isProcessingProps: !1
          }), R(_, H, se);
        });
        ne.push(le);
      }), Promise.all(ne).then(() => {
        e.current.getRowMode(_) === fn.Edit ? (Y = Pn(e.current.state), ee(!Y[_][z].error)) : ee(!1);
      });
    });
  }, [e, m, R]), k = h.useCallback((V) => {
    const _ = Pn(e.current.state), z = e.current.getRow(V);
    if (!_[V])
      return e.current.getRow(V);
    let j = I({}, z);
    return Object.entries(_[V]).forEach(([W, J]) => {
      const G = e.current.getColumn(W);
      G.valueSetter ? j = G.valueSetter(J.value, j, G, e) : j[W] = J.value;
    }), j;
  }, [e]), L = {
    getRowMode: E,
    startRowEditMode: P,
    stopRowEditMode: $
  }, B = {
    setRowEditingEditCellValue: A,
    getRowWithUpdatedValuesFromRowEditing: k
  };
  ot(e, L, "public"), ot(e, B, "private"), h.useEffect(() => {
    d && O(d);
  }, [d, O]), yt(() => {
    const V = fr(e), _ = i.current;
    i.current = Ik(n);
    const z = /* @__PURE__ */ new Set([...Object.keys(n), ...Object.keys(_)]);
    Array.from(z).forEach((j) => {
      var q;
      const W = n[j] ?? {
        mode: fn.View
      }, J = ((q = _[j]) == null ? void 0 : q.mode) || fn.View, G = V[j] ? e.current.getRowId(V[j]) : j;
      W.mode === fn.Edit && J === fn.View ? F(I({
        id: G
      }, W)) : W.mode === fn.View && J === fn.Edit && N(I({
        id: G
      }, W));
    });
  }, [e, n, F, N]);
}, qee = (e) => I({}, e, {
  editRows: {}
}), Wee = (e, t) => {
  zee(e, t), Gee(e, t);
  const n = h.useRef({}), {
    isCellEditable: o
  } = t, s = h.useCallback((p) => al(p.rowNode) || !p.colDef.editable || !p.colDef.renderEditCell ? !1 : o ? o(p) : !0, [o]), i = (p, m, b, v) => {
    if (!b) {
      v();
      return;
    }
    if (n.current[p] || (n.current[p] = {}), n.current[p][m]) {
      const [w] = n.current[p][m];
      clearTimeout(w);
    }
    const g = () => {
      const [w] = n.current[p][m];
      clearTimeout(w), v(), delete n.current[p][m];
    }, y = setTimeout(() => {
      v(), delete n.current[p][m];
    }, b);
    n.current[p][m] = [y, g];
  };
  h.useEffect(() => {
    const p = n.current;
    return () => {
      Object.entries(p).forEach(([m, b]) => {
        Object.keys(b).forEach((v) => {
          const [g] = p[m][v];
          clearTimeout(g), delete p[m][v];
        });
      });
    };
  }, []);
  const a = h.useCallback((p, m) => {
    if (n.current[p]) {
      if (!m)
        Object.keys(n.current[p]).forEach((b) => {
          const [, v] = n.current[p][b];
          v();
        });
      else if (n.current[p][m]) {
        const [, b] = n.current[p][m];
        b();
      }
    }
  }, []), l = h.useCallback((p) => {
    const {
      id: m,
      field: b,
      debounceMs: v
    } = p;
    return new Promise((g) => {
      i(m, b, v, async () => {
        const y = t.editMode === ts.Row ? e.current.setRowEditingEditCellValue : e.current.setCellEditingEditCellValue;
        if (e.current.getCellMode(m, b) === Bt.Edit) {
          const w = await y(p);
          g(w);
        }
      });
    });
  }, [e, t.editMode]), c = h.useCallback((p, m) => t.editMode === ts.Cell ? e.current.getRowWithUpdatedValuesFromCellEditing(p, m) : e.current.getRowWithUpdatedValuesFromRowEditing(p), [e, t.editMode]), u = h.useCallback((p, m) => {
    var v;
    return ((v = Pn(e.current.state)[p]) == null ? void 0 : v[m]) ?? null;
  }, [e]), d = {
    isCellEditable: s,
    setEditCellValue: l,
    getRowWithUpdatedValues: c,
    unstable_getEditCellMeta: u
  }, f = {
    runPendingEditCellValueMutation: a
  };
  ot(e, d, "public"), ot(e, f, "private");
}, Uee = (e, t, n) => {
  const o = !!t.unstable_dataSource;
  return n.current.caches.rows = ef({
    rows: o ? [] : t.rows,
    getRowId: t.getRowId,
    loading: t.loading,
    rowCount: t.rowCount
  }), I({}, e, {
    rows: zk({
      apiRef: n,
      rowCountProp: t.rowCount,
      loadingProp: o ? !0 : t.loading,
      previousTree: null,
      previousTreeDepths: null
    })
  });
}, Kee = (e, t) => {
  if (process.env.NODE_ENV !== "production")
    try {
      Object.freeze(t.rows);
    } catch {
    }
  const n = Mn(e, "useGridRows"), o = h.useRef(Date.now()), s = h.useRef(t.rowCount), i = go(), a = h.useCallback((k) => {
    const L = fr(e)[k];
    if (L)
      return L;
    const B = e.current.getRowNode(k);
    return B && al(B) ? {
      [za]: k
    } : null;
  }, [e]), l = t.getRowId, c = h.useCallback((k) => za in k ? k[za] : l ? l(k) : k.id, [l]), u = h.useCallback(({
    cache: k,
    throttle: L
  }) => {
    const B = () => {
      o.current = Date.now(), e.current.setState((_) => I({}, _, {
        rows: zk({
          apiRef: e,
          rowCountProp: t.rowCount,
          loadingProp: t.loading,
          previousTree: Vn(e),
          previousTreeDepths: uT(e),
          previousGroupsToFetch: Lk(e)
        })
      })), e.current.publishEvent("rowsSet"), e.current.forceUpdate();
    };
    if (i.clear(), e.current.caches.rows = k, !L) {
      B();
      return;
    }
    const V = t.throttleRowsMs - (Date.now() - o.current);
    if (V > 0) {
      i.start(V, B);
      return;
    }
    B();
  }, [t.throttleRowsMs, t.rowCount, t.loading, e, i]), d = h.useCallback((k) => {
    n.debug(`Updating all rows, new length ${k.length}`);
    const L = ef({
      rows: k,
      getRowId: t.getRowId,
      loading: t.loading,
      rowCount: t.rowCount
    }), B = e.current.caches.rows;
    L.rowsBeforePartialUpdates = B.rowsBeforePartialUpdates, u({
      cache: L,
      throttle: !0
    });
  }, [n, t.getRowId, t.loading, t.rowCount, u, e]), f = h.useCallback((k) => {
    if (t.signature === Mo.DataGrid && k.length > 1)
      throw new Error(["MUI X: You cannot update several rows at once in `apiRef.current.updateRows` on the DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`));
    const L = fT(e, k, t.getRowId), B = dT({
      updates: L,
      getRowId: t.getRowId,
      previousCache: e.current.caches.rows
    });
    u({
      cache: B,
      throttle: !0
    });
  }, [t.signature, t.getRowId, u, e]), p = h.useCallback((k, L) => {
    const B = fT(e, k, t.getRowId), V = dT({
      updates: B,
      getRowId: t.getRowId,
      previousCache: e.current.caches.rows,
      groupKeys: L ?? []
    });
    u({
      cache: V,
      throttle: !1
    });
  }, [t.getRowId, u, e]), m = h.useCallback((k) => {
    k !== t.loading && (n.debug(`Setting loading to ${k}`), e.current.setState((L) => I({}, L, {
      rows: I({}, L.rows, {
        loading: k
      })
    })), e.current.caches.rows.loadingPropBeforePartialUpdates = k);
  }, [t.loading, e, n]), b = h.useCallback(() => {
    const k = Da(e), L = fr(e);
    return new Map(k.map((B) => [B, L[B] ?? {}]));
  }, [e]), v = h.useCallback(() => Du(e), [e]), g = h.useCallback(() => Da(e), [e]), y = h.useCallback((k) => {
    const L = e.current.getRow(k), {
      rowToIndexMap: B
    } = bs(e);
    return B.get(L);
  }, [e]), w = h.useCallback((k, L) => {
    const B = e.current.getRowNode(k);
    if (!B)
      throw new Error(`MUI X: No row with id #${k} found.`);
    if (B.type !== "group")
      throw new Error("MUI X: Only group nodes can be expanded or collapsed.");
    const V = I({}, B, {
      childrenExpanded: L
    });
    e.current.setState((_) => I({}, _, {
      rows: I({}, _.rows, {
        tree: I({}, _.rows.tree, {
          [k]: V
        })
      })
    })), e.current.forceUpdate(), e.current.publishEvent("rowExpansionChange", V);
  }, [e]), x = h.useCallback((k) => Vn(e)[k] ?? null, [e]), S = h.useCallback(({
    skipAutoGeneratedRows: k = !0,
    groupId: L,
    applySorting: B,
    applyFiltering: V
  }) => {
    const _ = Vn(e);
    let z;
    if (B) {
      const j = _[L];
      if (!j)
        return [];
      const W = Rl(e);
      z = [];
      const J = W.findIndex((G) => G === L) + 1;
      for (let G = J; G < W.length && _[W[G]].depth > j.depth; G += 1) {
        const q = W[G];
        (!k || !al(_[q])) && z.push(q);
      }
    } else
      z = Nu(_, L, k);
    if (V) {
      const j = El(e);
      z = z.filter((W) => j[W] !== !1);
    }
    return z;
  }, [e]), T = h.useCallback((k, L) => {
    const B = e.current.getRowNode(k);
    if (!B)
      throw new Error(`MUI X: No row with id #${k} found.`);
    if (B.parent !== Dt)
      throw new Error("MUI X: The row reordering do not support reordering of grouped rows yet.");
    if (B.type !== "leaf")
      throw new Error("MUI X: The row reordering do not support reordering of footer or grouping rows.");
    e.current.setState((V) => {
      const _ = Vn(V, e.current.instanceId)[Dt], z = _.children, j = z.findIndex((J) => J === k);
      if (j === -1 || j === L)
        return V;
      n.debug(`Moving row ${k} to index ${L}`);
      const W = [...z];
      return W.splice(L, 0, W.splice(j, 1)[0]), I({}, V, {
        rows: I({}, V.rows, {
          tree: I({}, V.rows.tree, {
            [Dt]: I({}, _, {
              children: W
            })
          })
        })
      });
    }), e.current.publishEvent("rowsSet");
  }, [e, n]), E = h.useCallback((k, L) => {
    if (t.signature === Mo.DataGrid && L.length > 1)
      throw new Error(["MUI X: You cannot replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`));
    if (L.length === 0)
      return;
    if (Ps(e) > 1)
      throw new Error("`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping");
    const V = I({}, Vn(e)), _ = I({}, fr(e)), z = I({}, cT(e)), j = V[Dt], W = [...j.children], J = /* @__PURE__ */ new Set();
    for (let q = 0; q < L.length; q += 1) {
      const Z = L[q], Y = il(Z, t.getRowId, "A row was provided without id when calling replaceRows()."), [Q] = W.splice(k + q, 1, Y);
      J.has(Q) || (delete _[Q], delete z[Q], delete V[Q]);
      const ee = {
        id: Y,
        depth: 0,
        parent: Dt,
        type: "leaf",
        groupingKey: null
      };
      _[Y] = Z, z[Y] = Y, V[Y] = ee, J.add(Y);
    }
    V[Dt] = I({}, j, {
      children: W
    });
    const G = W.filter((q) => {
      var Z;
      return ((Z = V[q]) == null ? void 0 : Z.type) === "leaf";
    });
    e.current.caches.rows.dataRowIdToModelLookup = _, e.current.caches.rows.dataRowIdToIdLookup = z, e.current.setState((q) => I({}, q, {
      rows: I({}, q.rows, {
        dataRowIdToModelLookup: _,
        dataRowIdToIdLookup: z,
        dataRowIds: G,
        tree: V
      })
    })), e.current.publishEvent("rowsSet");
  }, [e, t.signature, t.getRowId]), O = {
    getRow: a,
    setLoading: m,
    getRowId: c,
    getRowModels: b,
    getRowsCount: v,
    getAllRowIds: g,
    setRows: d,
    updateRows: f,
    getRowNode: x,
    getRowIndexRelativeToVisibleRows: y,
    unstable_replaceRows: E
  }, M = {
    setRowIndex: T,
    setRowChildrenExpansion: w,
    getRowGroupChildren: S
  }, D = {
    updateServerRows: p
  }, R = h.useCallback(() => {
    n.info("Row grouping pre-processing have changed, regenerating the row tree");
    let k;
    e.current.caches.rows.rowsBeforePartialUpdates === t.rows ? k = I({}, e.current.caches.rows, {
      updates: {
        type: "full",
        rows: Da(e)
      }
    }) : k = ef({
      rows: t.rows,
      getRowId: t.getRowId,
      loading: t.loading,
      rowCount: t.rowCount
    }), u({
      cache: k,
      throttle: !1
    });
  }, [n, e, t.rows, t.getRowId, t.loading, t.rowCount, u]), P = Jo(() => t.unstable_dataSource), F = h.useCallback((k) => {
    if (t.unstable_dataSource && t.unstable_dataSource !== P.current) {
      P.current = t.unstable_dataSource;
      return;
    }
    k === "rowTreeCreation" && R();
  }, [R, P, t.unstable_dataSource]), $ = h.useCallback(() => {
    e.current.getActiveStrategy("rowTree") !== nK(e) && R();
  }, [e, R]);
  Le(e, "activeStrategyProcessorChange", F), Le(e, "strategyAvailabilityChange", $);
  const N = h.useCallback(() => {
    e.current.setState((k) => {
      const L = e.current.unstable_applyPipeProcessors("hydrateRows", {
        tree: Vn(k, e.current.instanceId),
        treeDepths: uT(k, e.current.instanceId),
        dataRowIds: Da(k, e.current.instanceId),
        dataRowIdToModelLookup: fr(k, e.current.instanceId),
        dataRowIdToIdLookup: cT(k, e.current.instanceId)
      });
      return I({}, k, {
        rows: I({}, k.rows, L, {
          totalTopLevelRowCount: Bk({
            tree: L.tree,
            rowCountProp: t.rowCount
          })
        })
      });
    }), e.current.publishEvent("rowsSet"), e.current.forceUpdate();
  }, [e, t.rowCount]);
  p0(e, "hydrateRows", N), ot(e, O, "public"), ot(e, M, t.signature === Mo.DataGrid ? "private" : "public"), ot(e, D, "private");
  const A = h.useRef(!0);
  h.useEffect(() => {
    var _;
    if (A.current) {
      A.current = !1;
      return;
    }
    let k = !1;
    t.rowCount !== s.current && (k = !0, s.current = t.rowCount);
    const L = e.current.caches.rows.rowsBeforePartialUpdates === t.rows, B = e.current.caches.rows.loadingPropBeforePartialUpdates === t.loading, V = e.current.caches.rows.rowCountPropBeforePartialUpdates === t.rowCount;
    L && (B || (e.current.setState((z) => I({}, z, {
      rows: I({}, z.rows, {
        loading: t.loading
      })
    })), e.current.caches.rows.loadingPropBeforePartialUpdates = t.loading, e.current.forceUpdate()), V || (e.current.setState((z) => I({}, z, {
      rows: I({}, z.rows, {
        totalRowCount: Math.max(t.rowCount || 0, z.rows.totalRowCount),
        totalTopLevelRowCount: Math.max(t.rowCount || 0, z.rows.totalTopLevelRowCount)
      })
    })), e.current.caches.rows.rowCountPropBeforePartialUpdates = t.rowCount, e.current.forceUpdate()), !k) || (n.debug(`Updating all rows, new length ${(_ = t.rows) == null ? void 0 : _.length}`), u({
      cache: ef({
        rows: t.rows,
        getRowId: t.getRowId,
        loading: t.loading,
        rowCount: t.rowCount
      }),
      throttle: !1
    }));
  }, [t.rows, t.rowCount, t.getRowId, t.loading, n, u, e]);
}, Yee = (e) => {
  const t = {
    [Dt]: I({}, Vk(), {
      children: e
    })
  };
  for (let n = 0; n < e.length; n += 1) {
    const o = e[n];
    t[o] = {
      id: o,
      depth: 0,
      parent: Dt,
      type: "leaf",
      groupingKey: null
    };
  }
  return {
    groupingName: Hi,
    tree: t,
    treeDepths: {
      0: e.length
    },
    dataRowIds: e
  };
}, Xee = ({
  previousTree: e,
  actions: t
}) => {
  const n = I({}, e), o = {};
  for (let a = 0; a < t.remove.length; a += 1) {
    const l = t.remove[a];
    o[l] = !0, delete n[l];
  }
  for (let a = 0; a < t.insert.length; a += 1) {
    const l = t.insert[a];
    n[l] = {
      id: l,
      depth: 0,
      parent: Dt,
      type: "leaf",
      groupingKey: null
    };
  }
  const s = n[Dt];
  let i = [...s.children, ...t.insert];
  return Object.values(o).length && (i = i.filter((a) => !o[a])), n[Dt] = I({}, s, {
    children: i
  }), {
    groupingName: Hi,
    tree: n,
    treeDepths: {
      0: i.length
    },
    dataRowIds: i
  };
}, Qee = (e) => e.updates.type === "full" ? Yee(e.updates.rows) : Xee({
  previousTree: e.previousTree,
  actions: e.updates.actions
}), Zee = (e) => {
  pr(e, Hi, "rowTreeCreation", Qee);
};
class Og extends Error {
}
function Jee(e, t) {
  var b;
  const n = h.useCallback((v) => ({
    field: v,
    colDef: e.current.getColumn(v)
  }), [e]), o = h.useCallback((v) => {
    const g = e.current.getRow(v);
    if (!g)
      throw new Og(`No row with id #${v} found`);
    return {
      id: v,
      columns: e.current.getAllColumns(),
      row: g
    };
  }, [e]), s = h.useCallback((v, g, y, {
    cellMode: w,
    colDef: x,
    hasFocus: S,
    rowNode: T,
    tabIndex: E
  }) => {
    const O = y[g], M = x != null && x.valueGetter ? x.valueGetter(O, y, x, e) : O, D = {
      id: v,
      field: g,
      row: y,
      rowNode: T,
      colDef: x,
      cellMode: w,
      hasFocus: S,
      tabIndex: E,
      value: M,
      formattedValue: M,
      isEditable: !1,
      api: null
    };
    return x && x.valueFormatter && (D.formattedValue = x.valueFormatter(M, y, x, e)), D.isEditable = x && e.current.isCellEditable(D), D;
  }, [e]), i = h.useCallback((v, g) => {
    var E;
    const y = e.current.getRow(v), w = e.current.getRowNode(v);
    if (!y || !w)
      throw new Og(`No row with id #${v} found`);
    const x = fo(e), S = e0(e), T = e.current.getCellMode(v, g);
    return e.current.getCellParamsForRow(v, g, y, {
      colDef: t.unstable_listView && ((E = t.unstable_listColumn) == null ? void 0 : E.field) === g ? cl(e.current.state) : e.current.getColumn(g),
      rowNode: w,
      hasFocus: x !== null && x.field === g && x.id === v,
      tabIndex: S && S.field === g && S.id === v ? 0 : -1,
      cellMode: T
    });
  }, [e, t.unstable_listView, (b = t.unstable_listColumn) == null ? void 0 : b.field]), a = h.useCallback((v, g) => {
    const y = e.current.getColumn(g), w = e.current.getRow(v);
    if (!w)
      throw new Og(`No row with id #${v} found`);
    return !y || !y.valueGetter ? w[g] : y.valueGetter(w[y.field], w, y, e);
  }, [e]), l = h.useCallback((v, g) => {
    const y = g.field;
    if (!g || !g.valueGetter)
      return v[y];
    const w = v[g.field];
    return g.valueGetter(w, v, g, e);
  }, [e]), c = h.useCallback((v, g) => {
    const y = l(v, g);
    return !g || !g.valueFormatter ? y : g.valueFormatter(y, v, g, e);
  }, [e, l]), u = h.useCallback((v) => e.current.rootElementRef.current ? NQ(e.current.rootElementRef.current, v) : null, [e]), d = h.useCallback((v) => e.current.rootElementRef.current ? $Q(e.current.rootElementRef.current, v) : null, [e]), f = h.useCallback((v, g) => e.current.rootElementRef.current ? AQ(e.current.rootElementRef.current, {
    id: v,
    field: g
  }) : null, [e]), p = {
    getCellValue: a,
    getCellParams: i,
    getCellElement: f,
    getRowValue: l,
    getRowFormattedValue: c,
    getRowParams: o,
    getRowElement: d,
    getColumnHeaderParams: n,
    getColumnHeaderElement: u
  }, m = {
    getCellParamsForRow: s
  };
  ot(e, p, "public"), ot(e, m, "private");
}
const P2 = (e, t) => e == null || Array.isArray(e) ? e : t && t[0] === e ? t : [e], ete = (e, t) => I({}, e, {
  rowSelection: t.rowSelection ? P2(t.rowSelectionModel) ?? [] : []
}), tte = (e, t) => {
  var A, k, L, B, V, _, z;
  const n = Mn(e, "useGridSelection"), o = h.useCallback((j) => (...W) => {
    t.rowSelection && j(...W);
  }, [t.rowSelection]), s = t.signature !== Mo.DataGrid && (((A = t.rowSelectionPropagation) == null ? void 0 : A.parents) || ((k = t.rowSelectionPropagation) == null ? void 0 : k.descendants)), i = h.useMemo(() => P2(t.rowSelectionModel, sr(e.current.state)), [e, t.rowSelectionModel]), a = h.useRef(null);
  e.current.registerControlState({
    stateId: "rowSelection",
    propModel: i,
    propOnChange: t.onRowSelectionModelChange,
    stateSelector: sr,
    changeEvent: "rowSelectionChange"
  });
  const {
    checkboxSelection: l,
    disableRowSelectionOnClick: c,
    isRowSelectable: u
  } = t, d = JC(t), f = ge(e, Vn), p = ge(e, Ps) > 1, m = h.useCallback((j) => {
    let W = j;
    const J = a.current ?? j, G = e.current.isRowSelected(j);
    if (G) {
      const q = Ha(e), Z = q.findIndex((Q) => Q === J), Y = q.findIndex((Q) => Q === W);
      if (Z === Y)
        return;
      Z > Y ? W = q[Y + 1] : W = q[Y - 1];
    }
    a.current = j, e.current.selectRowRange({
      startId: J,
      endId: W
    }, !G);
  }, [e]), b = h.useCallback((j) => {
    if (t.signature === Mo.DataGrid && !d && Array.isArray(j) && j.length > 1)
      throw new Error(["MUI X: `rowSelectionModel` can only contain 1 item in DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection."].join(`
`));
    sr(e.current.state) !== j && (n.debug("Setting selection model"), e.current.setState((J) => I({}, J, {
      rowSelection: t.rowSelection ? j : []
    })), e.current.forceUpdate());
  }, [e, n, t.rowSelection, t.signature, d]), v = h.useCallback((j) => sr(e.current.state).includes(j), [e]), g = h.useCallback((j) => {
    if (t.rowSelection === !1 || u && !u(e.current.getRowParams(j)))
      return !1;
    const W = e.current.getRowNode(j);
    return !((W == null ? void 0 : W.type) === "footer" || (W == null ? void 0 : W.type) === "pinnedRow");
  }, [e, t.rowSelection, u]), y = h.useCallback(() => PK(e), [e]), w = h.useCallback((j, W = !0, J = !1) => {
    var G, q, Z, Y, Q, ee;
    if (e.current.isRowSelectable(j))
      if (a.current = j, J) {
        n.debug(`Setting selection for row ${j}`);
        const ne = [], H = (U) => {
          ne.push(U);
        };
        W && (H(j), s && Id(e, f, j, ((G = t.rowSelectionPropagation) == null ? void 0 : G.descendants) ?? !1, ((q = t.rowSelectionPropagation) == null ? void 0 : q.parents) ?? !1, H)), e.current.setRowSelectionModel(ne);
      } else {
        n.debug(`Toggling selection for row ${j}`);
        const ne = sr(e.current.state), H = new Set(ne);
        H.delete(j);
        const U = (oe) => {
          H.add(oe);
        }, X = (oe) => {
          H.delete(oe);
        };
        W ? (U(j), s && Id(e, f, j, ((Z = t.rowSelectionPropagation) == null ? void 0 : Z.descendants) ?? !1, ((Y = t.rowSelectionPropagation) == null ? void 0 : Y.parents) ?? !1, U)) : s && hT(e, f, j, ((Q = t.rowSelectionPropagation) == null ? void 0 : Q.descendants) ?? !1, ((ee = t.rowSelectionPropagation) == null ? void 0 : ee.parents) ?? !1, X), (H.size < 2 || d) && e.current.setRowSelectionModel(Array.from(H));
      }
  }, [e, n, s, f, (L = t.rowSelectionPropagation) == null ? void 0 : L.descendants, (B = t.rowSelectionPropagation) == null ? void 0 : B.parents, d]), x = h.useCallback((j, W = !0, J = !1) => {
    n.debug("Setting selection for several rows");
    const G = j.filter((Y) => e.current.isRowSelectable(Y));
    let q;
    if (J) {
      if (W) {
        if (q = new Set(G), s) {
          const Q = (ee) => {
            q.add(ee);
          };
          G.forEach((ee) => {
            var ne, H;
            Id(e, f, ee, ((ne = t.rowSelectionPropagation) == null ? void 0 : ne.descendants) ?? !1, ((H = t.rowSelectionPropagation) == null ? void 0 : H.parents) ?? !1, Q);
          });
        }
      } else
        q = /* @__PURE__ */ new Set();
      const Y = ms(e);
      if (q.size === Object.keys(Y).length && Array.from(q).every((Q) => Y[Q] === Q))
        return;
    } else {
      q = new Set(Object.values(ms(e)));
      const Y = (ee) => {
        q.add(ee);
      }, Q = (ee) => {
        q.delete(ee);
      };
      G.forEach((ee) => {
        var ne, H, U, X;
        W ? (q.add(ee), s && Id(e, f, ee, ((ne = t.rowSelectionPropagation) == null ? void 0 : ne.descendants) ?? !1, ((H = t.rowSelectionPropagation) == null ? void 0 : H.parents) ?? !1, Y)) : (Q(ee), s && hT(e, f, ee, ((U = t.rowSelectionPropagation) == null ? void 0 : U.descendants) ?? !1, ((X = t.rowSelectionPropagation) == null ? void 0 : X.parents) ?? !1, Q));
      });
    }
    (q.size < 2 || d) && e.current.setRowSelectionModel(Array.from(q));
  }, [n, s, d, e, f, (V = t.rowSelectionPropagation) == null ? void 0 : V.descendants, (_ = t.rowSelectionPropagation) == null ? void 0 : _.parents]), S = h.useCallback(({
    startId: j,
    endId: W
  }, J = !0, G = !1) => {
    if (!e.current.getRow(j) || !e.current.getRow(W))
      return;
    n.debug(`Expanding selection from row ${j} to row ${W}`);
    const q = Ha(e), Z = q.indexOf(j), Y = q.indexOf(W), [Q, ee] = Z > Y ? [Y, Z] : [Z, Y], ne = q.slice(Q, ee + 1);
    e.current.selectRows(ne, J, G);
  }, [e, n]), T = {
    selectRow: w,
    setRowSelectionModel: b,
    getSelectedRows: y,
    isRowSelected: v,
    isRowSelectable: g
  }, E = {
    selectRows: x,
    selectRowRange: S
  };
  ot(e, T, "public"), ot(e, E, t.signature === Mo.DataGrid ? "private" : "public");
  const O = h.useCallback((j = !1) => {
    var ee;
    const W = sr(e.current.state), J = fr(e), G = El(e), q = I({}, ms(e)), Z = (ne) => t.filterMode === "server" ? !J[ne] : !J[ne] || G[ne] === !1;
    let Y = !1;
    W.forEach((ne) => {
      var U;
      if (Z(ne)) {
        if (t.keepNonExistentRowsSelected)
          return;
        delete q[ne], Y = !0;
        return;
      }
      if (!((U = t.rowSelectionPropagation) != null && U.parents))
        return;
      const H = f[ne];
      if (H.type === "group") {
        if (H.isAutoGenerated) {
          delete q[ne], Y = !0;
          return;
        }
        H.children.every((re) => G[re] === !1) || (delete q[ne], Y = !0);
      }
    });
    const Q = p && ((ee = t.rowSelectionPropagation) == null ? void 0 : ee.parents) && Object.keys(q).length > 0;
    if (Y || Q && !j) {
      const ne = Object.values(q);
      Q ? e.current.selectRows(ne, !0, !0) : e.current.setRowSelectionModel(ne);
    }
  }, [e, p, (z = t.rowSelectionPropagation) == null ? void 0 : z.parents, t.keepNonExistentRowsSelected, t.filterMode, f]), M = h.useCallback((j, W) => {
    const J = W.metaKey || W.ctrlKey, G = !l && !J && !OZ(W), q = !d || G, Z = e.current.isRowSelected(j);
    q ? e.current.selectRow(j, G ? !0 : !Z, !0) : e.current.selectRow(j, !Z, !1);
  }, [e, d, l]), D = h.useCallback((j, W) => {
    var q;
    if (c)
      return;
    const J = (q = W.target.closest(`.${K.cell}`)) == null ? void 0 : q.getAttribute("data-field");
    if (J === Il.field || J === Bo)
      return;
    if (J) {
      const Z = e.current.getColumn(J);
      if ((Z == null ? void 0 : Z.type) === Gp)
        return;
    }
    e.current.getRowNode(j.id).type !== "pinnedRow" && (W.shiftKey && d ? m(j.id) : M(j.id, W));
  }, [c, d, e, m, M]), R = h.useCallback((j, W) => {
    var J;
    d && W.shiftKey && ((J = window.getSelection()) == null || J.removeAllRanges());
  }, [d]), P = h.useCallback((j, W) => {
    d && W.nativeEvent.shiftKey ? m(j.id) : e.current.selectRow(j.id, j.value, !d);
  }, [e, m, d]), F = h.useCallback((j) => {
    const W = t.pagination && t.checkboxSelectionVisibleOnly && t.paginationMode === "client" ? cD(e) : Ha(e);
    e.current.selectRows(W, j.value);
  }, [e, t.checkboxSelectionVisibleOnly, t.pagination, t.paginationMode]), $ = h.useCallback((j, W) => {
    if (e.current.getCellMode(j.id, j.field) !== Bt.Edit && !Ol(W)) {
      if (Zc(W.key) && W.shiftKey) {
        const J = fo(e);
        if (J && J.id !== j.id) {
          W.preventDefault();
          const G = e.current.isRowSelected(J.id);
          if (!d) {
            e.current.selectRow(J.id, !G, !0);
            return;
          }
          const q = e.current.getRowIndexRelativeToVisibleRows(J.id), Z = e.current.getRowIndexRelativeToVisibleRows(j.id);
          let Y, Q;
          q > Z ? G ? (Y = Z, Q = q - 1) : (Y = Z, Q = q) : G ? (Y = q + 1, Q = Z) : (Y = q, Q = Z);
          const ne = bs(e).rows.slice(Y, Q + 1).map((H) => H.id);
          e.current.selectRows(ne, !G);
          return;
        }
      }
      if (W.key === " " && W.shiftKey) {
        W.preventDefault(), M(j.id, W);
        return;
      }
      String.fromCharCode(W.keyCode) === "A" && (W.ctrlKey || W.metaKey) && (W.preventDefault(), x(e.current.getAllRowIds(), !0));
    }
  }, [e, M, x, d]);
  Le(e, "sortedRowsSet", o(() => O(!0))), Le(e, "filteredRowsSet", o(O)), Le(e, "rowClick", o(D)), Le(e, "rowSelectionCheckboxChange", o(P)), Le(e, "headerSelectionCheckboxChange", F), Le(e, "cellMouseDown", o(R)), Le(e, "cellKeyDown", o($)), h.useEffect(() => {
    i !== void 0 && e.current.setRowSelectionModel(i);
  }, [e, i, t.rowSelection]), h.useEffect(() => {
    t.rowSelection || e.current.setRowSelectionModel([]);
  }, [e, t.rowSelection]);
  const N = i != null;
  h.useEffect(() => {
    if (N || !t.rowSelection)
      return;
    const j = sr(e.current.state);
    if (g) {
      const W = j.filter((J) => g(J));
      W.length < j.length && e.current.setRowSelectionModel(W);
    }
  }, [e, g, N, t.rowSelection]), h.useEffect(() => {
    if (!t.rowSelection || N)
      return;
    const j = sr(e.current.state);
    !d && j.length > 1 && e.current.setRowSelectionModel([]);
  }, [e, d, l, N, t.rowSelection]), h.useEffect(() => {
    o(O);
  }, [O, o]);
}, nte = (e) => {
  const {
    classes: t
  } = e;
  return h.useMemo(() => fe({
    cellCheckbox: ["cellCheckbox"],
    columnHeaderCheckbox: ["columnHeaderCheckbox"]
  }, rt, t), [t]);
}, ote = (e, t) => {
  const n = {
    classes: t.classes
  }, o = nte(n), s = h.useCallback((i) => {
    const a = I({}, Il, {
      cellClassName: o.cellCheckbox,
      headerClassName: o.columnHeaderCheckbox,
      headerName: e.current.getLocaleText("checkboxSelectionHeaderName")
    }), l = t.checkboxSelection, c = i.lookup[Rr] != null;
    return l && !c ? (i.lookup[Rr] = a, i.orderedFields = [Rr, ...i.orderedFields]) : !l && c ? (delete i.lookup[Rr], i.orderedFields = i.orderedFields.filter((u) => u !== Rr)) : l && c && (i.lookup[Rr] = I({}, a, i.lookup[Rr])), i;
  }, [e, o, t.checkboxSelection]);
  bt(e, "hydrateColumns", s);
}, rte = (e, t) => {
  var o, s;
  const n = t.sortModel ?? ((s = (o = t.initialState) == null ? void 0 : o.sorting) == null ? void 0 : s.sortModel) ?? [];
  return I({}, e, {
    sorting: {
      sortModel: xk(n, t.disableMultipleColumnsSorting),
      sortedRows: []
    }
  });
}, ste = (e, t) => {
  var T, E;
  const n = Mn(e, "useGridSorting");
  e.current.registerControlState({
    stateId: "sortModel",
    propModel: t.sortModel,
    propOnChange: t.onSortModelChange,
    stateSelector: uo,
    changeEvent: "sortModelChange"
  });
  const o = h.useCallback((O, M) => {
    const D = uo(e), R = D.findIndex((F) => F.field === O);
    let P = [...D];
    return R > -1 ? (M == null ? void 0 : M.sort) == null ? P.splice(R, 1) : P.splice(R, 1, M) : P = [...D, M], P;
  }, [e]), s = h.useCallback((O, M) => {
    const R = uo(e).find((P) => P.field === O.field);
    if (R) {
      const P = M === void 0 ? tT(O.sortingOrder ?? t.sortingOrder, R.sort) : M;
      return P === void 0 ? void 0 : I({}, R, {
        sort: P
      });
    }
    return {
      field: O.field,
      sort: M === void 0 ? tT(O.sortingOrder ?? t.sortingOrder) : M
    };
  }, [e, t.sortingOrder]), i = h.useCallback((O, M) => M == null || M.sortable === !1 || t.disableColumnSorting ? O : (M.sortingOrder || t.sortingOrder).some((R) => !!R) ? [...O, "columnMenuSortItem"] : O, [t.sortingOrder, t.disableColumnSorting]), a = h.useCallback(() => {
    e.current.setState((O) => {
      if (t.sortingMode === "server")
        return n.debug("Skipping sorting rows as sortingMode = server"), I({}, O, {
          sorting: I({}, O.sorting, {
            sortedRows: Nu(Vn(e), Dt, !1)
          })
        });
      const M = uo(O, e.current.instanceId), D = OU(M, e), R = e.current.applyStrategyProcessor("sorting", {
        sortRowList: D
      });
      return I({}, O, {
        sorting: I({}, O.sorting, {
          sortedRows: R
        })
      });
    }), e.current.publishEvent("sortedRowsSet"), e.current.forceUpdate();
  }, [e, n, t.sortingMode]), l = h.useCallback((O) => {
    uo(e) !== O && (n.debug("Setting sort model"), e.current.setState(eT(O, t.disableMultipleColumnsSorting)), e.current.forceUpdate(), e.current.applySorting());
  }, [e, n, t.disableMultipleColumnsSorting]), c = h.useCallback((O, M, D) => {
    const R = e.current.getColumn(O), P = s(R, M);
    let F;
    !D || t.disableMultipleColumnsSorting ? F = (P == null ? void 0 : P.sort) == null ? [] : [P] : F = o(R.field, P), e.current.setSortModel(F);
  }, [e, o, s, t.disableMultipleColumnsSorting]), u = h.useCallback(() => uo(e), [e]), d = h.useCallback(() => QC(e).map((M) => M.model), [e]), f = h.useCallback(() => Rl(e), [e]), p = h.useCallback((O) => e.current.getSortedRowIds()[O], [e]);
  ot(e, {
    getSortModel: u,
    getSortedRows: d,
    getSortedRowIds: f,
    getRowIdFromRowIndex: p,
    setSortModel: l,
    sortColumn: c,
    applySorting: a
  }, "public");
  const b = h.useCallback((O, M) => {
    var P, F;
    const D = uo(e);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !M.exportOnlyDirtyModels || // Always export if the model is controlled
      t.sortModel != null || // Always export if the model has been initialized
      ((F = (P = t.initialState) == null ? void 0 : P.sorting) == null ? void 0 : F.sortModel) != null || // Export if the model is not empty
      D.length > 0 ? I({}, O, {
        sorting: {
          sortModel: D
        }
      }) : O
    );
  }, [e, t.sortModel, (E = (T = t.initialState) == null ? void 0 : T.sorting) == null ? void 0 : E.sortModel]), v = h.useCallback((O, M) => {
    var R;
    const D = (R = M.stateToRestore.sorting) == null ? void 0 : R.sortModel;
    return D == null ? O : (e.current.setState(eT(D, t.disableMultipleColumnsSorting)), I({}, O, {
      callbacks: [...O.callbacks, e.current.applySorting]
    }));
  }, [e, t.disableMultipleColumnsSorting]), g = h.useCallback((O) => {
    const M = Vn(e), D = M[Dt], R = O.sortRowList ? O.sortRowList(D.children.map((P) => M[P])) : [...D.children];
    return D.footerId != null && R.push(D.footerId), R;
  }, [e]);
  bt(e, "exportState", b), bt(e, "restoreState", v), pr(e, Hi, "sorting", g);
  const y = h.useCallback(({
    field: O,
    colDef: M
  }, D) => {
    if (!M.sortable || t.disableColumnSorting)
      return;
    const R = D.shiftKey || D.metaKey || D.ctrlKey;
    c(O, void 0, R);
  }, [c, t.disableColumnSorting]), w = h.useCallback(({
    field: O,
    colDef: M
  }, D) => {
    !M.sortable || t.disableColumnSorting || D.key === "Enter" && !D.ctrlKey && !D.metaKey && c(O, void 0, D.shiftKey);
  }, [c, t.disableColumnSorting]), x = h.useCallback(() => {
    const O = uo(e), M = as(e);
    if (O.length > 0) {
      const D = O.filter((R) => M[R.field]);
      D.length < O.length && e.current.setSortModel(D);
    }
  }, [e]), S = h.useCallback((O) => {
    O === "sorting" && e.current.applySorting();
  }, [e]);
  bt(e, "columnMenu", i), Le(e, "columnHeaderClick", y), Le(e, "columnHeaderKeyDown", w), Le(e, "rowsSet", e.current.applySorting), Le(e, "columnsChange", x), Le(e, "activeStrategyProcessorChange", S), ra(() => {
    e.current.applySorting();
  }), yt(() => {
    t.sortModel !== void 0 && e.current.setSortModel(t.sortModel);
  }, [e, t.sortModel]);
};
function XT(e) {
  const {
    containerSize: t,
    scrollPosition: n,
    elementSize: o,
    elementOffset: s
  } = e, i = s + o;
  if (o > t)
    return s;
  if (i - t > n)
    return i - t;
  if (s < n)
    return s;
}
const ite = (e, t) => {
  const n = _t(), o = Mn(e, "useGridScroll"), s = e.current.columnHeadersContainerRef, i = e.current.virtualScrollerRef, a = ge(e, oi), l = h.useCallback((f) => {
    var y;
    const p = Kn(e.current.state), m = Du(e), b = t.unstable_listView ? [cl(e.current.state)] : pn(e);
    if (!(f.rowIndex == null) && m === 0 || b.length === 0)
      return !1;
    o.debug(`Scrolling to cell at row ${f.rowIndex}, col: ${f.colIndex} `);
    let g = {};
    if (f.colIndex !== void 0) {
      const w = Os(e);
      let x;
      if (typeof f.rowIndex < "u") {
        const S = (y = a[f.rowIndex]) == null ? void 0 : y.id, T = e.current.unstable_getCellColSpanInfo(S, f.colIndex);
        T && !T.spannedByColSpan && (x = T.cellProps.width);
      }
      typeof x > "u" && (x = b[f.colIndex].computedWidth), g.left = XT({
        containerSize: p.viewportOuterSize.width,
        scrollPosition: Math.abs(i.current.scrollLeft),
        elementSize: x,
        elementOffset: w[f.colIndex]
      });
    }
    if (f.rowIndex !== void 0) {
      const w = Lu(e.current.state), x = UK(e), S = aD(e), T = t.pagination ? f.rowIndex - x * S : f.rowIndex, E = w.positions[T + 1] ? w.positions[T + 1] - w.positions[T] : w.currentPageTotalHeight - w.positions[T];
      g.top = XT({
        containerSize: p.viewportInnerSize.height,
        scrollPosition: i.current.scrollTop,
        elementSize: E,
        elementOffset: w.positions[T]
      });
    }
    return g = e.current.unstable_applyPipeProcessors("scrollToIndexes", g, f), typeof g.left !== void 0 || typeof g.top !== void 0 ? (e.current.scroll(g), !0) : !1;
  }, [o, e, i, t.pagination, a, t.unstable_listView]), c = h.useCallback((f) => {
    if (i.current && f.left !== void 0 && s.current) {
      const p = n ? -1 : 1;
      s.current.scrollLeft = f.left, i.current.scrollLeft = p * f.left, o.debug(`Scrolling left: ${f.left}`);
    }
    i.current && f.top !== void 0 && (i.current.scrollTop = f.top, o.debug(`Scrolling top: ${f.top}`)), o.debug("Scrolling, updating container, and viewport");
  }, [i, n, s, o]), u = h.useCallback(() => i != null && i.current ? {
    top: i.current.scrollTop,
    left: i.current.scrollLeft
  } : {
    top: 0,
    left: 0
  }, [i]);
  ot(e, {
    scroll: c,
    scrollToIndexes: l,
    getScrollPosition: u
  }, "public");
};
function ate(e, t) {
  Pt(e, "columnHeaderClick", t.onColumnHeaderClick), Pt(e, "columnHeaderContextMenu", t.onColumnHeaderContextMenu), Pt(e, "columnHeaderDoubleClick", t.onColumnHeaderDoubleClick), Pt(e, "columnHeaderOver", t.onColumnHeaderOver), Pt(e, "columnHeaderOut", t.onColumnHeaderOut), Pt(e, "columnHeaderEnter", t.onColumnHeaderEnter), Pt(e, "columnHeaderLeave", t.onColumnHeaderLeave), Pt(e, "cellClick", t.onCellClick), Pt(e, "cellDoubleClick", t.onCellDoubleClick), Pt(e, "cellKeyDown", t.onCellKeyDown), Pt(e, "preferencePanelClose", t.onPreferencePanelClose), Pt(e, "preferencePanelOpen", t.onPreferencePanelOpen), Pt(e, "menuOpen", t.onMenuOpen), Pt(e, "menuClose", t.onMenuClose), Pt(e, "rowDoubleClick", t.onRowDoubleClick), Pt(e, "rowClick", t.onRowClick), Pt(e, "stateChange", t.onStateChange);
}
function lte(e, t = 166) {
  let n, o;
  const s = () => {
    n = void 0, e(...o);
  };
  function i(...a) {
    o = a, n === void 0 && (n = setTimeout(s, t));
  }
  return i.clear = () => {
    clearTimeout(n), n = void 0;
  }, i;
}
const M2 = {
  autoHeight: !1,
  autoPageSize: !1,
  autosizeOnMount: !1,
  checkboxSelection: !1,
  checkboxSelectionVisibleOnly: !1,
  clipboardCopyCellDelimiter: "	",
  columnBufferPx: 150,
  columnHeaderHeight: 56,
  disableAutosize: !1,
  disableColumnFilter: !1,
  disableColumnMenu: !1,
  disableColumnReorder: !1,
  disableColumnResize: !1,
  disableColumnSelector: !1,
  disableColumnSorting: !1,
  disableDensitySelector: !1,
  disableEval: !1,
  disableMultipleColumnsFiltering: !1,
  disableMultipleColumnsSorting: !1,
  disableMultipleRowSelection: !1,
  disableRowSelectionOnClick: !1,
  disableVirtualization: !1,
  editMode: ts.Cell,
  filterDebounceMs: 150,
  filterMode: "client",
  hideFooter: !1,
  hideFooterPagination: !1,
  hideFooterRowCount: !1,
  hideFooterSelectedRowCount: !1,
  ignoreDiacritics: !1,
  ignoreValueFormatterDuringExport: !1,
  // TODO v8: Update to 'select'
  indeterminateCheckboxAction: "deselect",
  keepColumnPositionIfDraggedOutside: !1,
  keepNonExistentRowsSelected: !1,
  loading: !1,
  logger: console,
  logLevel: process.env.NODE_ENV === "production" ? "error" : "warn",
  pageSizeOptions: [25, 50, 100],
  pagination: !1,
  paginationMode: "client",
  resizeThrottleMs: 60,
  rowBufferPx: 150,
  rowHeight: 52,
  rowPositionsDebounceMs: 166,
  rows: [],
  rowSelection: !0,
  rowSpacingType: "margin",
  showCellVerticalBorder: !1,
  showColumnVerticalBorder: !1,
  sortingMode: "client",
  sortingOrder: ["asc", "desc", null],
  throttleRowsMs: 0,
  unstable_rowSpanning: !1,
  virtualizeColumnsWithAutoRowHeight: !1
}, Ea = {
  width: 0,
  height: 0
}, cte = {
  isReady: !1,
  root: Ea,
  viewportOuterSize: Ea,
  viewportInnerSize: Ea,
  contentSize: Ea,
  minimumSize: Ea,
  hasScrollX: !1,
  hasScrollY: !1,
  scrollbarSize: 0,
  headerHeight: 0,
  groupHeaderHeight: 0,
  headerFilterHeight: 0,
  rowWidth: 0,
  rowHeight: 0,
  columnsTotalWidth: 0,
  leftPinnedWidth: 0,
  rightPinnedWidth: 0,
  headersTotalHeight: 0,
  topContainerHeight: 0,
  bottomContainerHeight: 0
}, ute = (e, t, n) => {
  const o = cte, s = Tl(n);
  return I({}, e, {
    dimensions: I({}, o, D2(t, n, s, ws(n)))
  });
}, k2 = Je(pn, Os, (e, t) => {
  const n = e.length;
  return n === 0 ? 0 : $a(t[n - 1] + e[n - 1].computedWidth, 1);
});
function dte(e, t) {
  const n = Mn(e, "useResizeContainer"), o = h.useRef(!1), s = h.useRef(Ea), i = ge(e, ws), a = ge(e, Tl), l = ge(e, k2), c = h.useRef(!0), {
    rowHeight: u,
    headerHeight: d,
    groupHeaderHeight: f,
    headerFilterHeight: p,
    headersTotalHeight: m,
    leftPinnedWidth: b,
    rightPinnedWidth: v
  } = D2(t, e, a, i), g = h.useRef(void 0), y = h.useCallback(() => Kn(e.current.state), [e]), w = h.useCallback((F) => {
    e.current.setState(($) => I({}, $, {
      dimensions: F
    })), e.current.rootElementRef.current && QT(e.current.rootElementRef.current, Kn(e.current.state));
  }, [e]), x = h.useCallback(() => {
    const F = e.current.mainElementRef.current;
    if (!F)
      return;
    const $ = Ao(F).getComputedStyle(F), N = {
      width: parseFloat($.width) || 0,
      height: parseFloat($.height) || 0
    };
    (!g.current || !JT(g.current, N)) && (e.current.publishEvent("resize", N), g.current = N);
  }, [e]), S = h.useCallback(() => {
    const F = Kn(e.current.state);
    if (!F.isReady)
      return 0;
    const $ = bs(e);
    if (t.getRowHeight) {
      const A = Bi(e), k = A.lastRowIndex - A.firstRowIndex;
      return Math.min(k - 1, $.rows.length);
    }
    const N = Math.floor(F.viewportInnerSize.height / u);
    return Math.min(N, $.rows.length);
  }, [e, t.getRowHeight, u]), T = h.useCallback(() => {
    var Z, Y;
    if (c.current)
      return;
    const F = e.current.rootElementRef.current, $ = fte(F, t.scrollbarSize), N = Lu(e.current.state), A = m + N.pinnedTopRowsTotalHeight, k = N.pinnedBottomRowsTotalHeight, B = {
      width: l - b - v,
      height: $a(N.currentPageTotalHeight, 1)
    };
    let V, _, z = !1, j = !1;
    if (t.autoHeight)
      j = !1, z = Math.round(l) > Math.round(s.current.width), V = {
        width: s.current.width,
        height: A + k + B.height
      }, _ = {
        width: Math.max(0, V.width - (j ? $ : 0)),
        height: Math.max(0, V.height - (z ? $ : 0))
      };
    else {
      V = {
        width: s.current.width,
        height: s.current.height
      }, _ = {
        width: Math.max(0, V.width - b - v),
        height: Math.max(0, V.height - A - k)
      };
      const Q = B, ee = _, ne = Q.width > ee.width, H = Q.height > ee.height;
      (ne || H) && (j = H, z = Q.width + (j ? $ : 0) > ee.width, z && (j = Q.height + $ > ee.height)), j && (_.width -= $), z && (_.height -= $);
    }
    const W = Math.max(V.width, l + (j ? $ : 0)), J = {
      width: l,
      height: A + B.height + k
    }, G = {
      isReady: !0,
      root: s.current,
      viewportOuterSize: V,
      viewportInnerSize: _,
      contentSize: B,
      minimumSize: J,
      hasScrollX: z,
      hasScrollY: j,
      scrollbarSize: $,
      headerHeight: d,
      groupHeaderHeight: f,
      headerFilterHeight: p,
      rowWidth: W,
      rowHeight: u,
      columnsTotalWidth: l,
      leftPinnedWidth: b,
      rightPinnedWidth: v,
      headersTotalHeight: m,
      topContainerHeight: A,
      bottomContainerHeight: k
    }, q = e.current.state.dimensions;
    Xr(q, G) || (w(G), JT(G.viewportInnerSize, q.viewportInnerSize) || e.current.publishEvent("viewportInnerSizeChange", G.viewportInnerSize), (Y = (Z = e.current).updateRenderContext) == null || Y.call(Z));
  }, [e, w, t.scrollbarSize, t.autoHeight, u, d, f, p, l, m, b, v]), E = xe(T), O = h.useMemo(() => t.resizeThrottleMs > 0 ? lte(() => {
    E(), e.current.publishEvent("debouncedResize", s.current);
  }, t.resizeThrottleMs) : void 0, [e, t.resizeThrottleMs, E]);
  h.useEffect(() => O == null ? void 0 : O.clear, [O]);
  const M = {
    resize: x,
    getRootDimensions: y
  }, D = {
    updateDimensions: T,
    getViewportPageSize: S
  };
  yt(T, [T]), ot(e, M, "public"), ot(e, D, "private");
  const R = h.useCallback((F) => {
    QT(F, Kn(e.current.state));
  }, [e]), P = h.useCallback((F) => {
    if (s.current = F, F.height === 0 && !o.current && !t.autoHeight && !zf && (n.error(["The parent DOM element of the Data Grid has an empty height.", "Please make sure that this element has an intrinsic height.", "The grid displays with a height of 0px.", "", "More details: https://mui.com/r/x-data-grid-no-dimensions."].join(`
`)), o.current = !0), F.width === 0 && !o.current && !zf && (n.error(["The parent DOM element of the Data Grid has an empty width.", "Please make sure that this element has an intrinsic width.", "The grid displays with a width of 0px.", "", "More details: https://mui.com/r/x-data-grid-no-dimensions."].join(`
`)), o.current = !0), c.current || !O) {
      c.current = !1, T();
      return;
    }
    O();
  }, [T, t.autoHeight, O, n]);
  Pt(e, "rootMount", R), Pt(e, "resize", P), Pt(e, "debouncedResize", t.onResize);
}
function QT(e, t) {
  const n = (o, s) => e.style.setProperty(o, s);
  n("--DataGrid-hasScrollX", `${Number(t.hasScrollX)}`), n("--DataGrid-hasScrollY", `${Number(t.hasScrollY)}`), n("--DataGrid-scrollbarSize", `${t.scrollbarSize}px`), n("--DataGrid-rowWidth", `${t.rowWidth}px`), n("--DataGrid-columnsTotalWidth", `${t.columnsTotalWidth}px`), n("--DataGrid-leftPinnedWidth", `${t.leftPinnedWidth}px`), n("--DataGrid-rightPinnedWidth", `${t.rightPinnedWidth}px`), n("--DataGrid-headerHeight", `${t.headerHeight}px`), n("--DataGrid-headersTotalHeight", `${t.headersTotalHeight}px`), n("--DataGrid-topContainerHeight", `${t.topContainerHeight}px`), n("--DataGrid-bottomContainerHeight", `${t.bottomContainerHeight}px`), n("--height", `${t.rowHeight}px`);
}
function D2(e, t, n, o) {
  const s = jk(e.rowHeight, M2.rowHeight, sK);
  return {
    rowHeight: Math.floor(s * n),
    headerHeight: Math.floor(e.columnHeaderHeight * n),
    groupHeaderHeight: Math.floor((e.columnGroupHeaderHeight ?? e.columnHeaderHeight) * n),
    headerFilterHeight: Math.floor((e.headerFilterHeight ?? e.columnHeaderHeight) * n),
    columnsTotalWidth: k2(t),
    headersTotalHeight: r0(t, e),
    leftPinnedWidth: o.left.reduce((i, a) => i + a.computedWidth, 0),
    rightPinnedWidth: o.right.reduce((i, a) => i + a.computedWidth, 0)
  };
}
const ZT = /* @__PURE__ */ new WeakMap();
function fte(e, t) {
  if (t !== void 0)
    return t;
  if (e === null)
    return 0;
  const n = ZT.get(e);
  if (n !== void 0)
    return n;
  const s = qt(e).createElement("div");
  s.style.width = "99px", s.style.height = "99px", s.style.position = "absolute", s.style.overflow = "scroll", s.className = "scrollDiv", e.appendChild(s);
  const i = s.offsetWidth - s.clientWidth;
  return e.removeChild(s), ZT.set(e, i), i;
}
function JT(e, t) {
  return e.width === t.width && e.height === t.height;
}
const pte = typeof globalThis.ResizeObserver < "u" ? globalThis.ResizeObserver : class {
  observe() {
  }
  unobserve() {
  }
  disconnect() {
  }
}, hte = (e, t, n) => {
  n.current.caches.rowsMeta = {
    heights: /* @__PURE__ */ new Map()
  };
  const o = _C(n.current.state), s = Du(n), i = $u(n.current.state), a = Math.min(i.enabled ? i.paginationModel.pageSize : s, s);
  return I({}, e, {
    rowsMeta: {
      currentPageTotalHeight: a * o,
      positions: Array.from({
        length: a
      }, (l, c) => c * o),
      pinnedTopRowsTotalHeight: 0,
      pinnedBottomRowsTotalHeight: 0
    }
  });
}, gte = (e, t) => {
  const {
    getRowHeight: n,
    getRowSpacing: o,
    getEstimatedRowHeight: s
  } = t, i = e.current.caches.rowsMeta.heights, a = h.useRef(-1), l = h.useRef(!1), c = h.useRef(!1), u = ge(e, Tl), d = Xp(e), f = ge(e, oa), p = ge(e, _C), m = (R) => {
    let P = i.get(R);
    return P === void 0 && (P = {
      content: p,
      spacingTop: 0,
      spacingBottom: 0,
      detail: 0,
      autoHeight: !1,
      needsFirstMeasurement: !0
    }, i.set(R, P)), P;
  }, b = h.useCallback((R) => {
    const P = Kn(e.current.state).rowHeight, F = e.current.getRowHeightEntry(R.id);
    if (!n)
      F.content = P, F.needsFirstMeasurement = !1;
    else {
      const $ = n(I({}, R, {
        densityFactor: u
      }));
      if ($ === "auto") {
        if (F.needsFirstMeasurement) {
          const N = s ? s(I({}, R, {
            densityFactor: u
          })) : P;
          F.content = N ?? P;
        }
        l.current = !0, F.autoHeight = !0;
      } else
        F.content = jk($, P, iK), F.needsFirstMeasurement = !1, F.autoHeight = !1;
    }
    if (o) {
      const $ = e.current.getRowIndexRelativeToVisibleRows(R.id), N = o(I({}, R, {
        isFirstVisible: $ === 0,
        isLastVisible: $ === d.rows.length - 1,
        indexRelativeToCurrentPage: $
      }));
      F.spacingTop = N.top ?? 0, F.spacingBottom = N.bottom ?? 0;
    } else
      F.spacingTop = 0, F.spacingBottom = 0;
    return e.current.unstable_applyPipeProcessors("rowHeight", F, R), F;
  }, [e, d.rows, n, s, p, o, u]), v = h.useCallback(() => {
    l.current = !1;
    const R = f.top.reduce((k, L) => {
      const B = b(L);
      return k + B.content + B.spacingTop + B.spacingBottom + B.detail;
    }, 0), P = f.bottom.reduce((k, L) => {
      const B = b(L);
      return k + B.content + B.spacingTop + B.spacingBottom + B.detail;
    }, 0), F = [], $ = d.rows.reduce((k, L) => {
      F.push(k);
      const B = b(L), V = B.content + B.spacingTop + B.spacingBottom + B.detail;
      return k + V;
    }, 0);
    l.current || (a.current = 1 / 0);
    const N = R !== e.current.state.rowsMeta.pinnedTopRowsTotalHeight || P !== e.current.state.rowsMeta.pinnedBottomRowsTotalHeight || $ !== e.current.state.rowsMeta.currentPageTotalHeight, A = {
      currentPageTotalHeight: $,
      positions: F,
      pinnedTopRowsTotalHeight: R,
      pinnedBottomRowsTotalHeight: P
    };
    e.current.setState((k) => I({}, k, {
      rowsMeta: A
    })), N && e.current.updateDimensions(), c.current = !0;
  }, [e, f, d.rows, b]), g = (R) => {
    var P;
    return ((P = i.get(R)) == null ? void 0 : P.content) ?? p;
  }, y = (R, P) => {
    const F = e.current.getRowHeightEntry(R), $ = F.content !== P;
    F.needsFirstMeasurement = !1, F.content = P, c.current && (c.current = !$);
  }, w = (R) => {
    var P;
    return ((P = i.get(R)) == null ? void 0 : P.autoHeight) ?? !1;
  }, x = () => a.current, S = (R) => {
    l.current && R > a.current && (a.current = R);
  }, T = () => {
    i.clear(), v();
  }, E = Jo(() => new pte((R) => {
    for (let P = 0; P < R.length; P += 1) {
      const F = R[P], $ = F.borderBoxSize && F.borderBoxSize.length > 0 ? F.borderBoxSize[0].blockSize : F.contentRect.height, N = F.target.__mui_id;
      e.current.unstable_storeRowHeightMeasurement(N, $);
    }
    c.current || e.current.requestPipeProcessorsApplication("rowHeight");
  })).current, O = (R, P) => (R.__mui_id = P, E.observe(R), () => E.unobserve(R));
  p0(e, "rowHeight", v), yt(() => {
    v();
  }, [v]);
  const M = {
    unstable_getRowHeight: g,
    unstable_setLastMeasuredRowIndex: S,
    unstable_storeRowHeightMeasurement: y,
    resetRowHeights: T
  }, D = {
    hydrateRowsMeta: v,
    observeRowHeight: O,
    rowHasAutoHeight: w,
    getRowHeightEntry: m,
    getLastMeasuredRowIndex: x
  };
  ot(e, M, "public"), ot(e, D, "private");
}, mte = (e) => {
  const t = h.useCallback((s = {}) => e.current.unstable_applyPipeProcessors("exportState", {}, s), [e]), n = h.useCallback((s) => {
    e.current.unstable_applyPipeProcessors("restoreState", {
      callbacks: []
    }, {
      stateToRestore: s
    }).callbacks.forEach((a) => {
      a();
    }), e.current.forceUpdate();
  }, [e]);
  ot(e, {
    exportState: t,
    restoreState: n
  }, "public");
}, bte = (e) => {
  const t = h.useRef({}), n = (l, c) => {
    var u;
    return (u = t.current[l]) == null ? void 0 : u[c];
  }, o = () => {
    t.current = {};
  }, s = h.useCallback(({
    rowId: l,
    minFirstColumn: c,
    maxLastColumn: u,
    columns: d
  }) => {
    for (let f = c; f < u; f += 1) {
      const p = yte({
        apiRef: e,
        lookup: t.current,
        columnIndex: f,
        rowId: l,
        minFirstColumnIndex: c,
        maxLastColumnIndex: u,
        columns: d
      });
      p.colSpan > 1 && (f += p.colSpan - 1);
    }
  }, [e]), i = {
    unstable_getCellColSpanInfo: n
  }, a = {
    resetColSpan: o,
    calculateColSpan: s
  };
  ot(e, i, "public"), ot(e, a, "private"), Le(e, "columnOrderChange", o);
};
function yte(e) {
  const {
    apiRef: t,
    lookup: n,
    columnIndex: o,
    rowId: s,
    minFirstColumnIndex: i,
    maxLastColumnIndex: a,
    columns: l
  } = e, c = l.length, u = l[o], d = t.current.getRow(s), f = t.current.getRowValue(d, u), p = typeof u.colSpan == "function" ? u.colSpan(f, d, u, t) : u.colSpan;
  if (!p || p === 1)
    return Pg(n, s, o, {
      spannedByColSpan: !1,
      cellProps: {
        colSpan: 1,
        width: u.computedWidth
      }
    }), {
      colSpan: 1
    };
  let m = u.computedWidth;
  for (let b = 1; b < p; b += 1) {
    const v = o + b;
    if (v >= i && v < a) {
      const g = l[v];
      m += g.computedWidth, Pg(n, s, o + b, {
        spannedByColSpan: !0,
        rightVisibleCellIndex: Math.min(o + p, c - 1),
        leftVisibleCellIndex: o
      });
    }
    Pg(n, s, o, {
      spannedByColSpan: !1,
      cellProps: {
        colSpan: p,
        width: m
      }
    });
  }
  return {
    colSpan: p
  };
}
function Pg(e, t, n, o) {
  e[t] || (e[t] = {}), e[t][n] = o;
}
const N2 = (e, t, n) => {
  if (Ok(e)) {
    if (n[e.field] !== void 0)
      throw new Error(["MUI X: columnGroupingModel contains duplicated field", `column field ${e.field} occurs two times in the grouping model:`, `- ${n[e.field].join(" > ")}`, `- ${t.join(" > ")}`].join(`
`));
    n[e.field] = t;
    return;
  }
  const {
    groupId: o,
    children: s
  } = e;
  s.forEach((i) => {
    N2(i, [...t, o], n);
  });
}, Ly = (e) => {
  if (!e)
    return {};
  const t = {};
  return e.forEach((n) => {
    N2(n, [], t);
  }), t;
}, _y = (e, t, n) => {
  const o = (c) => t[c] ?? [], s = [], i = Math.max(...e.map((c) => o(c).length)), a = (c, u, d) => Xr(o(c).slice(0, d + 1), o(u).slice(0, d + 1)), l = (c, u) => !!(n != null && n.left && n.left.includes(c) && !n.left.includes(u) || n != null && n.right && !n.right.includes(c) && n.right.includes(u));
  for (let c = 0; c < i; c += 1) {
    const u = e.reduce((d, f) => {
      const p = o(f)[c] ?? null;
      if (d.length === 0)
        return [{
          columnFields: [f],
          groupId: p
        }];
      const m = d[d.length - 1], b = m.columnFields[m.columnFields.length - 1];
      return m.groupId !== p || !a(b, f, c) || // Fix for https://github.com/mui/mui-x/issues/7041
      l(b, f) ? [...d, {
        columnFields: [f],
        groupId: p
      }] : [...d.slice(0, d.length - 1), {
        columnFields: [...m.columnFields, f],
        groupId: p
      }];
    }, []);
    s.push(u);
  }
  return s;
}, vte = ["groupId", "children"], h0 = (e) => {
  let t = {};
  return e.forEach((n) => {
    if (Ok(n))
      return;
    const {
      groupId: o,
      children: s
    } = n, i = ve(n, vte);
    if (!o)
      throw new Error("MUI X: An element of the columnGroupingModel does not have either `field` or `groupId`.");
    process.env.NODE_ENV !== "production" && (s || console.warn(`MUI X: group groupId=${o} has no children.`));
    const a = I({}, i, {
      groupId: o
    }), l = h0(s);
    if (l[o] !== void 0 || t[o] !== void 0)
      throw new Error(`MUI X: The groupId ${o} is used multiple times in the columnGroupingModel.`);
    t = I({}, t, l, {
      [o]: a
    });
  }), I({}, t);
}, Cte = (e, t, n) => {
  if (!t.columnGroupingModel)
    return e;
  const o = Or(n), s = na(n), i = h0(t.columnGroupingModel ?? []), a = Ly(t.columnGroupingModel ?? []), l = _y(o, a, n.current.state.pinnedColumns ?? {}), c = s.length === 0 ? 0 : Math.max(...s.map((u) => {
    var d;
    return ((d = a[u]) == null ? void 0 : d.length) ?? 0;
  }));
  return I({}, e, {
    columnGrouping: {
      lookup: i,
      unwrappedGroupingModel: a,
      headerStructure: l,
      maxDepth: c
    }
  });
}, wte = (e, t) => {
  const n = h.useCallback((l) => yD(e)[l] ?? [], [e]), o = h.useCallback(() => vD(e), [e]);
  ot(e, {
    getColumnGroupPath: n,
    getAllGroupDetails: o
  }, "public");
  const i = h.useCallback(() => {
    const l = Ly(t.columnGroupingModel ?? []);
    e.current.setState((c) => {
      var p;
      const u = ((p = c.columns) == null ? void 0 : p.orderedFields) ?? [], d = c.pinnedColumns ?? {}, f = _y(u, l, d);
      return I({}, c, {
        columnGrouping: I({}, c.columnGrouping, {
          headerStructure: f
        })
      });
    });
  }, [e, t.columnGroupingModel]), a = h.useCallback((l) => {
    var v, g;
    const c = ((g = (v = e.current).getPinnedColumns) == null ? void 0 : g.call(v)) ?? {}, u = Or(e), d = na(e), f = h0(l ?? []), p = Ly(l ?? []), m = _y(u, p, c), b = d.length === 0 ? 0 : Math.max(...d.map((y) => {
      var w;
      return ((w = p[y]) == null ? void 0 : w.length) ?? 0;
    }));
    e.current.setState((y) => I({}, y, {
      columnGrouping: {
        lookup: f,
        unwrappedGroupingModel: p,
        headerStructure: m,
        maxDepth: b
      }
    }));
  }, [e]);
  Le(e, "columnIndexChange", i), Le(e, "columnsChange", () => {
    a(t.columnGroupingModel);
  }), Le(e, "columnVisibilityModelChange", () => {
    a(t.columnGroupingModel);
  }), h.useEffect(() => {
    a(t.columnGroupingModel);
  }, [a, t.columnGroupingModel]);
};
function Ste() {
  let e, t;
  const n = new Promise((o, s) => {
    e = o, t = s;
  });
  return n.resolve = e, n.reject = t, n;
}
function eR(e, t) {
  if (t !== void 0 && e.changedTouches) {
    for (let n = 0; n < e.changedTouches.length; n += 1) {
      const o = e.changedTouches[n];
      if (o.identifier === t)
        return {
          x: o.clientX,
          y: o.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function tR(e, t, n, o) {
  let s = e;
  return o === "Right" ? s += t - n.left : s += n.right - t, s;
}
function xte(e, t, n) {
  return n === "Left" ? e - t.left : t.right - e;
}
function Tte(e) {
  return e === "Right" ? "Left" : "Right";
}
function Rte(e, t) {
  const n = e.classList.contains(K["columnSeparator--sideRight"]) ? "Right" : "Left";
  return t ? Tte(n) : n;
}
function nR(e) {
  e.preventDefault(), e.stopImmediatePropagation();
}
function Ete(e) {
  const t = h.useRef(void 0), n = () => wD(e), o = ge(e, n);
  return h.useEffect(() => {
    t.current && o === !1 && (t.current.resolve(), t.current = void 0);
  }), () => {
    if (!t.current) {
      if (n() === !1)
        return Promise.resolve();
      t.current = Ste();
    }
    return t.current;
  };
}
function Ite(e, t) {
  if (e.length < 4)
    return e;
  const n = e.slice();
  n.sort((l, c) => l - c);
  const o = n[Math.floor(n.length * 0.25)], s = n[Math.floor(n.length * 0.75) - 1], i = s - o, a = i < 5 ? 5 : i * t;
  return n.filter((l) => l > o - a && l < s + a);
}
function Ote(e, t, n) {
  const o = {}, s = e.current.rootElementRef.current;
  return s.classList.add(K.autosizing), n.forEach((i) => {
    const l = WQ(e.current, i.field).map((b) => b.getBoundingClientRect().width ?? 0), c = t.includeOutliers ? l : Ite(l, t.outliersFactor);
    if (t.includeHeaders) {
      const b = qQ(e.current, i.field);
      if (b) {
        const v = b.querySelector(`.${K.columnHeaderTitle}`), g = b.querySelector(`.${K.columnHeaderTitleContainerContent}`), y = b.querySelector(`.${K.iconButtonContainer}`), w = b.querySelector(`.${K.menuIcon}`), x = v ?? g, S = window.getComputedStyle(b, null), T = parseInt(S.paddingLeft, 10) + parseInt(S.paddingRight, 10), O = x.scrollWidth + 1 + T + ((y == null ? void 0 : y.clientWidth) ?? 0) + ((w == null ? void 0 : w.clientWidth) ?? 0);
        c.push(O);
      }
    }
    const u = i.minWidth !== -1 / 0 && i.minWidth !== void 0, d = i.maxWidth !== 1 / 0 && i.maxWidth !== void 0, f = u ? i.minWidth : 0, p = d ? i.maxWidth : 1 / 0, m = c.length === 0 ? 0 : Math.max(...c);
    o[i.field] = Uo(m, f, p);
  }), s.classList.remove(K.autosizing), o;
}
const Pte = (e) => I({}, e, {
  columnResize: {
    resizingColumnField: ""
  }
});
function Mte() {
  return {
    colDef: void 0,
    initialColWidth: 0,
    initialTotalWidth: 0,
    previousMouseClickEvent: void 0,
    columnHeaderElement: void 0,
    headerFilterElement: void 0,
    groupHeaderElements: [],
    cellElements: [],
    leftPinnedCellsAfter: [],
    rightPinnedCellsBefore: [],
    fillerLeft: void 0,
    fillerRight: void 0,
    leftPinnedHeadersAfter: [],
    rightPinnedHeadersBefore: []
  };
}
const kte = (e, t) => {
  const n = _t(), o = Mn(e, "useGridColumnResize"), s = Jo(Mte).current, i = h.useRef(null), a = h.useRef(null), l = go(), c = h.useRef(void 0), u = (D) => {
    var A, k;
    o.debug(`Updating width to ${D} for col ${s.colDef.field}`);
    const R = s.columnHeaderElement.offsetWidth, P = D - R, F = D - s.initialColWidth;
    if (F > 0) {
      const L = s.initialTotalWidth + F;
      (k = (A = e.current.rootElementRef) == null ? void 0 : A.current) == null || k.style.setProperty("--DataGrid-rowWidth", `${L}px`);
    }
    s.colDef.computedWidth = D, s.colDef.width = D, s.colDef.flex = 0, s.columnHeaderElement.style.width = `${D}px`;
    const $ = s.headerFilterElement;
    $ && ($.style.width = `${D}px`), s.groupHeaderElements.forEach((L) => {
      const B = L;
      let V;
      B.getAttribute("aria-colspan") === "1" ? V = `${D}px` : V = `${B.offsetWidth + P}px`, B.style.width = V;
    }), s.cellElements.forEach((L) => {
      const B = L;
      let V;
      B.getAttribute("aria-colspan") === "1" ? V = `${D}px` : V = `${B.offsetWidth + P}px`, B.style.setProperty("--width", V);
    });
    const N = e.current.unstable_applyPipeProcessors("isColumnPinned", !1, s.colDef.field);
    N === Ln.LEFT && (ga(s.fillerLeft, "width", P), s.leftPinnedCellsAfter.forEach((L) => {
      ga(L, "left", P);
    }), s.leftPinnedHeadersAfter.forEach((L) => {
      ga(L, "left", P);
    })), N === Ln.RIGHT && (ga(s.fillerRight, "width", P), s.rightPinnedCellsBefore.forEach((L) => {
      ga(L, "right", P);
    }), s.rightPinnedHeadersBefore.forEach((L) => {
      ga(L, "right", P);
    }));
  }, d = (D) => {
    if (y(), s.previousMouseClickEvent) {
      const R = s.previousMouseClickEvent, P = R.timeStamp, F = R.clientX, $ = R.clientY;
      if (D.timeStamp - P < 300 && D.clientX === F && D.clientY === $) {
        s.previousMouseClickEvent = void 0, e.current.publishEvent("columnResizeStop", null, D);
        return;
      }
    }
    if (s.colDef) {
      e.current.setColumnWidth(s.colDef.field, s.colDef.width), o.debug(`Updating col ${s.colDef.field} with new width: ${s.colDef.width}`);
      const R = Qr(e.current.state);
      s.groupHeaderElements.forEach((P) => {
        const F = _Q(P), $ = P, A = `${F.reduce((k, L) => R.columnVisibilityModel[L] !== !1 ? k + R.lookup[L].computedWidth : k, 0)}px`;
        $.style.width = A;
      });
    }
    l.start(0, () => {
      e.current.publishEvent("columnResizeStop", null, D);
    });
  }, f = (D, R, P) => {
    var A;
    const F = e.current.rootElementRef.current;
    s.initialColWidth = D.computedWidth, s.initialTotalWidth = e.current.getRootDimensions().rowWidth, s.colDef = D, s.columnHeaderElement = LQ(e.current.columnHeadersContainerRef.current, D.field);
    const $ = F.querySelector(`.${K.headerFilterRow} [data-field="${Ms(D.field)}"]`);
    $ && (s.headerFilterElement = $), s.groupHeaderElements = VQ((A = e.current.columnHeadersContainerRef) == null ? void 0 : A.current, D.field), s.cellElements = BQ(s.columnHeaderElement, e.current), s.fillerLeft = DT(e.current, n ? "filler--pinnedRight" : "filler--pinnedLeft"), s.fillerRight = DT(e.current, n ? "filler--pinnedLeft" : "filler--pinnedRight");
    const N = e.current.unstable_applyPipeProcessors("isColumnPinned", !1, s.colDef.field);
    s.leftPinnedCellsAfter = N !== Ln.LEFT ? [] : zQ(e.current, s.columnHeaderElement, n), s.rightPinnedCellsBefore = N !== Ln.RIGHT ? [] : HQ(e.current, s.columnHeaderElement, n), s.leftPinnedHeadersAfter = N !== Ln.LEFT ? [] : jQ(e.current, s.columnHeaderElement, n), s.rightPinnedHeadersBefore = N !== Ln.RIGHT ? [] : GQ(e.current, s.columnHeaderElement, n), a.current = Rte(R, n), i.current = xte(P, s.columnHeaderElement.getBoundingClientRect(), a.current);
  }, p = xe(d), m = xe((D) => {
    if (D.buttons === 0) {
      p(D);
      return;
    }
    let R = tR(i.current, D.clientX, s.columnHeaderElement.getBoundingClientRect(), a.current);
    R = Uo(R, s.colDef.minWidth, s.colDef.maxWidth), u(R);
    const P = {
      element: s.columnHeaderElement,
      colDef: s.colDef,
      width: R
    };
    e.current.publishEvent("columnResize", P, D);
  }), b = xe((D) => {
    eR(D, c.current) && d(D);
  }), v = xe((D) => {
    const R = eR(D, c.current);
    if (!R)
      return;
    if (D.type === "mousemove" && D.buttons === 0) {
      b(D);
      return;
    }
    let P = tR(i.current, R.x, s.columnHeaderElement.getBoundingClientRect(), a.current);
    P = Uo(P, s.colDef.minWidth, s.colDef.maxWidth), u(P);
    const F = {
      element: s.columnHeaderElement,
      colDef: s.colDef,
      width: P
    };
    e.current.publishEvent("columnResize", F, D);
  }), g = xe((D) => {
    const R = Hf(D.target, K["columnSeparator--resizable"]);
    if (!R)
      return;
    const P = D.changedTouches[0];
    P != null && (c.current = P.identifier);
    const F = Hf(D.target, K.columnHeader), $ = FQ(F), N = e.current.getColumn($);
    o.debug(`Start Resize on col ${N.field}`), e.current.publishEvent("columnResizeStart", {
      field: $
    }, D), f(N, R, P.clientX);
    const A = qt(D.currentTarget);
    A.addEventListener("touchmove", v), A.addEventListener("touchend", b);
  }), y = h.useCallback(() => {
    const D = qt(e.current.rootElementRef.current);
    D.body.style.removeProperty("cursor"), D.removeEventListener("mousemove", m), D.removeEventListener("mouseup", p), D.removeEventListener("touchmove", v), D.removeEventListener("touchend", b), setTimeout(() => {
      D.removeEventListener("click", nR, !0);
    }, 100), s.columnHeaderElement && (s.columnHeaderElement.style.pointerEvents = "unset");
  }, [e, s, m, p, v, b]), w = h.useCallback(({
    field: D
  }) => {
    e.current.setState((R) => I({}, R, {
      columnResize: I({}, R.columnResize, {
        resizingColumnField: D
      })
    })), e.current.forceUpdate();
  }, [e]), x = h.useCallback(() => {
    e.current.setState((D) => I({}, D, {
      columnResize: I({}, D.columnResize, {
        resizingColumnField: ""
      })
    })), e.current.forceUpdate();
  }, [e]), S = xe(({
    colDef: D
  }, R) => {
    if (R.button !== 0 || !R.currentTarget.classList.contains(K["columnSeparator--resizable"]))
      return;
    R.preventDefault(), o.debug(`Start Resize on col ${D.field}`), e.current.publishEvent("columnResizeStart", {
      field: D.field
    }, R), f(D, R.currentTarget, R.clientX);
    const P = qt(e.current.rootElementRef.current);
    P.body.style.cursor = "col-resize", s.previousMouseClickEvent = R.nativeEvent, P.addEventListener("mousemove", m), P.addEventListener("mouseup", p), P.addEventListener("click", nR, !0);
  }), T = xe((D, R) => {
    if (t.disableAutosize || R.button !== 0)
      return;
    const P = e.current.state.columns.lookup[D.field];
    P.resizable !== !1 && e.current.autosizeColumns(I({}, t.autosizeOptions, {
      disableColumnVirtualization: !1,
      columns: [P.field]
    }));
  }), E = Ete(e), O = h.useRef(!1), M = h.useCallback(async (D) => {
    var N;
    if (!((N = e.current.rootElementRef) == null ? void 0 : N.current) || O.current)
      return;
    O.current = !0;
    const P = Qr(e.current.state), F = I({}, DX, D, {
      columns: (D == null ? void 0 : D.columns) ?? P.orderedFields
    });
    F.columns = F.columns.filter((A) => P.columnVisibilityModel[A] !== !1);
    const $ = F.columns.map((A) => e.current.state.columns.lookup[A]);
    try {
      !t.disableVirtualization && F.disableColumnVirtualization && (e.current.unstable_setColumnVirtualization(!1), await E());
      const A = Ote(e, F, $), k = $.map((L) => I({}, L, {
        width: A[L.field],
        computedWidth: A[L.field],
        flex: 0
      }));
      if (F.expand) {
        const B = P.orderedFields.map((j) => P.lookup[j]).filter((j) => P.columnVisibilityModel[j.field] !== !1).reduce((j, W) => j + (A[W.field] ?? W.computedWidth ?? W.width), 0), z = e.current.getRootDimensions().viewportInnerSize.width - B;
        if (z > 0) {
          const j = z / (k.length || 1);
          k.forEach((W) => {
            W.width += j, W.computedWidth += j;
          });
        }
      }
      e.current.updateColumns(k), k.forEach((L, B) => {
        if (L.width !== $[B].width) {
          const V = L.width;
          e.current.publishEvent("columnWidthChange", {
            element: e.current.getColumnHeaderElement(L.field),
            colDef: L,
            width: V
          });
        }
      });
    } finally {
      t.disableVirtualization || e.current.unstable_setColumnVirtualization(!0), O.current = !1;
    }
  }, [e, E, t.disableVirtualization]);
  h.useEffect(() => y, [y]), Iv(() => {
    t.autosizeOnMount && Promise.resolve().then(() => {
      e.current.autosizeColumns(t.autosizeOptions);
    });
  }), nD(e, () => {
    var D;
    return (D = e.current.columnHeadersContainerRef) == null ? void 0 : D.current;
  }, "touchstart", g, {
    passive: !0
  }), ot(e, {
    autosizeColumns: M
  }, "public"), Le(e, "columnResizeStop", x), Le(e, "columnResizeStart", w), Le(e, "columnSeparatorMouseDown", S), Le(e, "columnSeparatorDoubleClick", T), Pt(e, "columnResize", t.onColumnResize), Pt(e, "columnWidthChange", t.onColumnWidthChange);
};
function ga(e, t, n) {
  e && (e.style[t] = `${parseInt(e.style[t], 10) + n}px`);
}
function Dte(e, t) {
  return e.firstRowIndex >= t.firstRowIndex && e.lastRowIndex <= t.lastRowIndex ? null : e.firstRowIndex >= t.firstRowIndex && e.lastRowIndex > t.lastRowIndex ? {
    firstRowIndex: t.lastRowIndex,
    lastRowIndex: e.lastRowIndex
  } : e.firstRowIndex < t.firstRowIndex && e.lastRowIndex <= t.lastRowIndex ? {
    firstRowIndex: e.firstRowIndex,
    lastRowIndex: t.firstRowIndex - 1
  } : e;
}
function oR(e) {
  return e.firstRowIndex !== 0 || e.lastRowIndex !== 0;
}
const Mg = (e, t, n) => {
  if (!e)
    return null;
  let o = e[t.field];
  const s = t.rowSpanValueGetter ?? t.valueGetter;
  return s && (o = s(o, e, t, n)), o;
}, Aa = {
  spannedCells: {},
  hiddenCells: {},
  hiddenCellOriginMap: {}
}, jf = {
  firstRowIndex: 0,
  lastRowIndex: 0
}, Nte = /* @__PURE__ */ new Set([Rr, "__reorder__", Bo]), rR = 20, $2 = (e, t, n, o, s, i, a) => {
  const l = i ? {} : I({}, e.current.state.rowSpanning.spannedCells), c = i ? {} : I({}, e.current.state.rowSpanning.hiddenCells), u = i ? {} : I({}, e.current.state.rowSpanning.hiddenCellOriginMap);
  return i && (a = jf), t.forEach((d) => {
    var f;
    if (!Nte.has(d.field)) {
      for (let p = s.firstRowIndex; p < s.lastRowIndex; p += 1) {
        const m = n[p];
        if ((f = c[m.id]) != null && f[d.field])
          continue;
        const b = Mg(m.model, d, e);
        if (b == null)
          continue;
        let v = m.id, g = p, y = 0;
        const w = [];
        if (p === s.firstRowIndex) {
          let S = p - 1, T = n[S];
          for (; S >= o.firstRowIndex && T && Mg(T.model, d, e) === b; ) {
            const E = n[S + 1];
            c[E.id] ? c[E.id][d.field] = !0 : c[E.id] = {
              [d.field]: !0
            }, w.push(p), y += 1, v = T.id, g = S, S -= 1, T = n[S];
          }
        }
        w.forEach((S) => {
          u[S] ? u[S][d.field] = g : u[S] = {
            [d.field]: g
          };
        });
        let x = p + 1;
        for (; x <= o.lastRowIndex && n[x] && Mg(n[x].model, d, e) === b; ) {
          const S = n[x];
          c[S.id] ? c[S.id][d.field] = !0 : c[S.id] = {
            [d.field]: !0
          }, u[x] ? u[x][d.field] = g : u[x] = {
            [d.field]: g
          }, x += 1, y += 1;
        }
        y > 0 && (l[v] ? l[v][d.field] = y + 1 : l[v] = {
          [d.field]: y + 1
        });
      }
      a = {
        firstRowIndex: Math.min(a.firstRowIndex, s.firstRowIndex),
        lastRowIndex: Math.max(a.lastRowIndex, s.lastRowIndex)
      };
    }
  }), {
    spannedCells: l,
    hiddenCells: c,
    hiddenCellOriginMap: u,
    processedRange: a
  };
}, A2 = (e, t) => {
  const n = Da(t).length;
  if (e.pagination) {
    const o = aD(t);
    let s = rR;
    return o > 0 && (s = o - 1), {
      firstRowIndex: 0,
      lastRowIndex: Math.min(s, n)
    };
  }
  return {
    firstRowIndex: 0,
    lastRowIndex: Math.min(rR, n)
  };
}, $te = (e, t, n) => {
  var b;
  if (!t.unstable_rowSpanning)
    return I({}, e, {
      rowSpanning: Aa
    });
  const o = e.rows.dataRowIds || [], s = e.columns.orderedFields || [], i = e.rows.dataRowIdToModelLookup, a = e.columns.lookup, l = !!e.filter.filterModel.items.length || !!((b = e.filter.filterModel.quickFilterValues) != null && b.length);
  if (!o.length || !s.length || !i || !a || l)
    return I({}, e, {
      rowSpanning: Aa
    });
  const c = A2(t, n), u = o.map((v) => ({
    id: v,
    model: i[v]
  })), d = s.map((v) => a[v]), {
    spannedCells: f,
    hiddenCells: p,
    hiddenCellOriginMap: m
  } = $2(n, d, u, c, c, !0, jf);
  return I({}, e, {
    rowSpanning: {
      spannedCells: f,
      hiddenCells: p,
      hiddenCellOriginMap: m
    }
  });
}, Ate = (e, t) => {
  const n = Jo(() => e.current.state.rowSpanning !== Aa ? A2(t, e) : jf), o = h.useCallback((i, a = !1) => {
    const {
      range: l,
      rows: c
    } = bs(e, {
      pagination: t.pagination,
      paginationMode: t.paginationMode
    });
    if (l === null || !oR(i))
      return;
    a && (n.current = jf);
    const u = Dte({
      firstRowIndex: i.firstRowIndex,
      lastRowIndex: Math.min(i.lastRowIndex, l.lastRowIndex + 1)
    }, n.current);
    if (u === null)
      return;
    const d = pn(e), {
      spannedCells: f,
      hiddenCells: p,
      hiddenCellOriginMap: m,
      processedRange: b
    } = $2(e, d, c, l, u, a, n.current);
    n.current = b;
    const v = Object.keys(f).length, g = Object.keys(p).length, y = Object.keys(e.current.state.rowSpanning.spannedCells).length, w = Object.keys(e.current.state.rowSpanning.hiddenCells).length;
    !(a || v !== y || g !== w) || v === 0 && y === 0 || e.current.setState((T) => I({}, T, {
      rowSpanning: {
        spannedCells: f,
        hiddenCells: p,
        hiddenCellOriginMap: m
      }
    }));
  }, [e, n, t.pagination, t.paginationMode]), s = h.useCallback(() => {
    const i = Bi(e);
    oR(i) && o(i, !0);
  }, [e, o]);
  Le(e, "renderedRowsIntervalChange", ql(t.unstable_rowSpanning, o)), Le(e, "sortedRowsSet", ql(t.unstable_rowSpanning, s)), Le(e, "paginationModelChange", ql(t.unstable_rowSpanning, s)), Le(e, "filteredRowsSet", ql(t.unstable_rowSpanning, s)), Le(e, "columnsChange", ql(t.unstable_rowSpanning, s)), h.useEffect(() => {
    t.unstable_rowSpanning ? e.current.state.rowSpanning === Aa && s() : e.current.state.rowSpanning !== Aa && e.current.setState((i) => I({}, i, {
      rowSpanning: Aa
    }));
  }, [e, s, t.unstable_rowSpanning]);
}, Fte = (e, t, n) => I({}, e, {
  listViewColumn: t.unstable_listColumn ? I({}, t.unstable_listColumn, {
    computedWidth: Vy(n)
  }) : void 0
});
function Lte(e, t) {
  const n = () => {
    e.current.setState((i) => i.listViewColumn ? I({}, i, {
      listViewColumn: I({}, i.listViewColumn, {
        computedWidth: Vy(e)
      })
    }) : i);
  }, o = h.useRef(null);
  Le(e, "viewportInnerSizeChange", (i) => {
    o.current !== i.width && (o.current = i.width, n());
  }), Le(e, "columnVisibilityModelChange", n), yt(() => {
    const i = t.unstable_listColumn;
    i && e.current.setState((a) => I({}, a, {
      listViewColumn: I({}, i, {
        computedWidth: Vy(e)
      })
    }));
  }, [e, t.unstable_listColumn]), h.useEffect(() => {
    t.unstable_listView && !t.unstable_listColumn && vo(["MUI X: The `unstable_listColumn` prop must be set if `unstable_listView` is enabled.", 'To fix, pass a column definition to the `unstable_listColumn` prop, e.g. `{ field: "example", renderCell: (params) => <div>{params.row.id}</div> }`.', "For more details, see https://mui.com/x/react-data-grid/list-view/"]);
  }, [t.unstable_listView, t.unstable_listColumn]);
}
function Vy(e) {
  return Kn(e.current.state).viewportInnerSize.width;
}
const _te = (e) => {
  const {
    classes: t,
    headerAlign: n,
    isDragging: o,
    isLastColumn: s,
    showLeftBorder: i,
    showRightBorder: a,
    groupId: l,
    pinnedPosition: c
  } = e, u = {
    root: ["columnHeader", n === "left" && "columnHeader--alignLeft", n === "center" && "columnHeader--alignCenter", n === "right" && "columnHeader--alignRight", o && "columnHeader--moving", a && "columnHeader--withRightBorder", i && "columnHeader--withLeftBorder", "withBorderColor", l === null ? "columnHeader--emptyGroup" : "columnHeader--filledGroup", c === ut.LEFT && "columnHeader--pinnedLeft", c === ut.RIGHT && "columnHeader--pinnedRight", s && "columnHeader--last"],
    draggableContainer: ["columnHeaderDraggableContainer"],
    titleContainer: ["columnHeaderTitleContainer", "withBorderColor"],
    titleContainerContent: ["columnHeaderTitleContainerContent"]
  };
  return fe(u, rt, t);
};
function Vte(e) {
  var B;
  const {
    groupId: t,
    width: n,
    depth: o,
    maxDepth: s,
    fields: i,
    height: a,
    colIndex: l,
    hasFocus: c,
    tabIndex: u,
    isLastColumn: d,
    pinnedPosition: f,
    pinnedOffset: p
  } = e, m = Xe(), b = _t(), v = h.useRef(null), g = lt(), y = ge(g, vD), w = t ? y[t] : {}, {
    headerName: x = t ?? "",
    description: S = "",
    headerAlign: T = void 0
  } = w;
  let E;
  const O = t && ((B = y[t]) == null ? void 0 : B.renderHeaderGroup), M = h.useMemo(() => ({
    groupId: t,
    headerName: x,
    description: S,
    depth: o,
    maxDepth: s,
    fields: i,
    colIndex: l,
    isLastColumn: d
  }), [t, x, S, o, s, i, l, d]);
  t && O && (E = O(M));
  const D = I({}, e, {
    classes: m.classes,
    headerAlign: T,
    depth: o,
    isDragging: !1
  }), R = x ?? t, P = gt(), F = t === null ? `empty-group-cell-${P}` : t, $ = _te(D);
  h.useLayoutEffect(() => {
    if (c) {
      const _ = v.current.querySelector('[tabindex="0"]') || v.current;
      _ == null || _.focus();
    }
  }, [g, c]);
  const N = h.useCallback(
    (V) => (_) => {
      Ol(_) || g.current.publishEvent(V, M, _);
    },
    // For now this is stupid, because renderParams change all the time.
    // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
    [g, M]
  ), A = h.useMemo(() => ({
    onKeyDown: N("columnGroupHeaderKeyDown"),
    onFocus: N("columnGroupHeaderFocus"),
    onBlur: N("columnGroupHeaderBlur")
  }), [N]), k = typeof w.headerClassName == "function" ? w.headerClassName(M) : w.headerClassName, L = h.useMemo(() => _u(I({}, e.style), b, f, p), [f, p, e.style, b]);
  return /* @__PURE__ */ C(GD, I({
    ref: v,
    classes: $,
    columnMenuOpen: !1,
    colIndex: l,
    height: a,
    isResizing: !1,
    sortDirection: null,
    hasFocus: !1,
    tabIndex: u,
    isDraggable: !1,
    headerComponent: E,
    headerClassName: k,
    description: S,
    elementId: F,
    width: n,
    columnMenuIconButton: null,
    columnTitleIconButtons: null,
    resizable: !1,
    label: R,
    "aria-colspan": i.length,
    "data-fields": `|-${i.join("-|-")}-|`,
    style: L
  }, A));
}
const By = te("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaderRow",
  overridesResolver: (e, t) => t.columnHeaderRow
})({
  display: "flex"
}), F2 = (e) => {
  const {
    visibleColumns: t,
    sortColumnLookup: n,
    filterColumnLookup: o,
    columnHeaderTabIndexState: s,
    columnGroupHeaderTabIndexState: i,
    columnHeaderFocus: a,
    columnGroupHeaderFocus: l,
    headerGroupingMaxDepth: c,
    columnMenuState: u,
    columnVisibility: d,
    columnGroupsHeaderStructure: f,
    hasOtherElementInTabSequence: p
  } = e, [m, b] = h.useState(""), [v, g] = h.useState(""), y = eo(), w = Xe(), x = ge(y, yD), S = ge(y, Os), T = ge(y, GY), E = ge(y, ws), O = ge(y, as), M = TD(S, T, E.left.length), D = ge(y, xl), R = ge(y, VC), P = ge(y, sU), F = ge(y, iU), $ = ge(y, BC), N = h.useCallback((q) => g(q.field), []), A = h.useCallback(() => g(""), []), k = h.useCallback((q) => b(q.field), []), L = h.useCallback(() => b(""), []), B = h.useMemo(() => E.left.length ? {
    firstColumnIndex: 0,
    lastColumnIndex: E.left.length
  } : null, [E.left.length]), V = h.useMemo(() => E.right.length ? {
    firstColumnIndex: t.length - E.right.length,
    lastColumnIndex: t.length
  } : null, [E.right.length, t.length]);
  Le(y, "columnResizeStart", N), Le(y, "columnResizeStop", A), Le(y, "columnHeaderDragStart", k), Le(y, "columnHeaderDragEnd", L);
  const _ = (q) => {
    const {
      renderContext: Z = T
    } = q || {}, Y = Z.firstColumnIndex, Q = Z.lastColumnIndex;
    return {
      renderedColumns: t.slice(Y, Q),
      firstColumnToRender: Y,
      lastColumnToRender: Q
    };
  }, z = (q, Z, Y, Q = !1) => {
    const ee = (q == null ? void 0 : q.position) === ut.RIGHT, ne = (q == null ? void 0 : q.position) === void 0, H = E.right.length > 0 && ee || E.right.length === 0 && ne, U = M - Y;
    return /* @__PURE__ */ ie(h.Fragment, {
      children: [ne && /* @__PURE__ */ C("div", {
        role: "presentation",
        style: {
          width: U
        }
      }), Z, ne && /* @__PURE__ */ C("div", {
        role: "presentation",
        className: ae(K.filler, Q && K["filler--borderBottom"])
      }), H && /* @__PURE__ */ C(d0, {
        header: !0,
        pinnedRight: ee,
        borderBottom: Q,
        borderTop: !1
      })]
    });
  }, j = (q, Z = {}) => {
    const {
      renderedColumns: Y,
      firstColumnToRender: Q
    } = _(q), ee = [];
    for (let ne = 0; ne < Y.length; ne += 1) {
      const H = Y[ne], U = Q + ne, X = U === 0, re = s !== null && s.field === H.field || X && !p ? 0 : -1, oe = a !== null && a.field === H.field, le = u.open && u.field === H.field, se = q == null ? void 0 : q.position, Ce = Mc(se, H.computedWidth, U, S, D, $), $e = se === ut.RIGHT ? Y[ne - 1] : Y[ne + 1], we = $e ? a !== null && a.field === $e.field : !1, Te = U + 1 === S.length - E.right.length, ue = ne, de = Y.length, Pe = eu(se, ue), ke = Jc(se, ue, de, w.showCellVerticalBorder, R);
      ee.push(/* @__PURE__ */ C(nZ, I({}, n[H.field], {
        columnMenuOpen: le,
        filterItemsCounter: o[H.field] && o[H.field].length,
        headerHeight: P,
        isDragging: H.field === m,
        colDef: H,
        colIndex: U,
        isResizing: v === H.field,
        isLast: U === S.length - 1,
        hasFocus: oe,
        tabIndex: re,
        pinnedPosition: se,
        pinnedOffset: Ce,
        isLastUnpinned: Te,
        isSiblingFocused: we,
        showLeftBorder: Pe,
        showRightBorder: ke
      }, Z), H.field));
    }
    return z(q, ee, 0);
  }, W = () => /* @__PURE__ */ ie(By, {
    role: "row",
    "aria-rowindex": c + 1,
    ownerState: w,
    className: K["row--borderBottom"],
    children: [B && j({
      position: ut.LEFT,
      renderContext: B
    }, {
      disableReorder: !0
    }), j({
      renderContext: T
    }), V && j({
      position: ut.RIGHT,
      renderContext: V
    }, {
      disableReorder: !0,
      separatorSide: l0.Left
    })]
  }), J = ({
    depth: q,
    params: Z
  }) => {
    var de, Pe;
    const Y = _(Z);
    if (Y.renderedColumns.length === 0)
      return null;
    const {
      firstColumnToRender: Q,
      lastColumnToRender: ee
    } = Y, ne = f[q], H = t[Q].field, U = ((de = x[H]) == null ? void 0 : de[q]) ?? null, X = ne.findIndex(({
      groupId: ke,
      columnFields: Me
    }) => ke === U && Me.includes(H)), re = t[ee - 1].field, oe = ((Pe = x[re]) == null ? void 0 : Pe[q]) ?? null, le = ne.findIndex(({
      groupId: ke,
      columnFields: Me
    }) => ke === oe && Me.includes(re)), se = ne.slice(X, le + 1).map((ke) => I({}, ke, {
      columnFields: ke.columnFields.filter((Me) => d[Me] !== !1)
    })).filter((ke) => ke.columnFields.length > 0), Ce = se[0].columnFields.indexOf(H), we = se[0].columnFields.slice(0, Ce).reduce((ke, Me) => {
      const be = O[Me];
      return ke + (be.computedWidth ?? 0);
    }, 0);
    let Te = Q;
    const ue = se.map(({
      groupId: ke,
      columnFields: Me
    }, be) => {
      const me = l !== null && l.depth === q && Me.includes(l.field), Ae = i !== null && i.depth === q && Me.includes(i.field) ? 0 : -1, ye = {
        width: Me.reduce((pe, Re) => pe + O[Re].computedWidth, 0),
        fields: Me,
        colIndex: Te
      }, We = Z.position, He = Mc(We, ye.width, Te, S, D, $);
      Te += Me.length;
      let ze = be;
      return We === ut.LEFT && (ze = Te - 1), /* @__PURE__ */ C(Vte, {
        groupId: ke,
        width: ye.width,
        fields: ye.fields,
        colIndex: ye.colIndex,
        depth: q,
        isLastColumn: be === se.length - 1,
        maxDepth: c,
        height: F,
        hasFocus: me,
        tabIndex: Ae,
        pinnedPosition: We,
        pinnedOffset: He,
        showLeftBorder: eu(We, ze),
        showRightBorder: Jc(We, ze, se.length, w.showCellVerticalBorder, R)
      }, be);
    });
    return z(Z, ue, we);
  };
  return {
    renderContext: T,
    leftRenderContext: B,
    rightRenderContext: V,
    pinnedColumns: E,
    visibleColumns: t,
    columnPositions: S,
    getFillers: z,
    getColumnHeadersRow: W,
    getColumnsToRender: _,
    getColumnGroupHeadersRows: () => {
      if (c === 0)
        return null;
      const q = [];
      for (let Z = 0; Z < c; Z += 1)
        q.push(/* @__PURE__ */ ie(By, {
          role: "row",
          "aria-rowindex": Z + 1,
          ownerState: w,
          children: [B && J({
            depth: Z,
            params: {
              position: ut.LEFT,
              renderContext: B,
              maxLastColumn: B.lastColumnIndex
            }
          }), J({
            depth: Z,
            params: {
              renderContext: T
            }
          }), V && J({
            depth: Z,
            params: {
              position: ut.RIGHT,
              renderContext: V,
              maxLastColumn: V.lastColumnIndex
            }
          })]
        }, Z));
      return q;
    },
    getPinnedCellOffset: Mc,
    isDragging: !!m,
    getInnerProps: () => ({
      role: "rowgroup"
    })
  };
}, Bte = ["className"], zte = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["columnHeaders"]
  }, rt, t);
}, Hte = tn("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaders",
  overridesResolver: (e, t) => t.columnHeaders
})({
  display: "flex",
  flexDirection: "column",
  borderTopLeftRadius: "var(--unstable_DataGrid-radius)",
  borderTopRightRadius: "var(--unstable_DataGrid-radius)"
}), L2 = Ct(function(t, n) {
  const {
    className: o
  } = t, s = ve(t, Bte), i = Xe(), a = zte(i);
  return /* @__PURE__ */ C(Hte, I({
    className: ae(a.root, o),
    ownerState: i
  }, s, {
    role: "presentation",
    ref: n
  }));
}), jte = ["className", "visibleColumns", "sortColumnLookup", "filterColumnLookup", "columnHeaderTabIndexState", "columnGroupHeaderTabIndexState", "columnHeaderFocus", "columnGroupHeaderFocus", "headerGroupingMaxDepth", "columnMenuState", "columnVisibility", "columnGroupsHeaderStructure", "hasOtherElementInTabSequence"], _2 = Ct(function(t, n) {
  const {
    visibleColumns: o,
    sortColumnLookup: s,
    filterColumnLookup: i,
    columnHeaderTabIndexState: a,
    columnGroupHeaderTabIndexState: l,
    columnHeaderFocus: c,
    columnGroupHeaderFocus: u,
    headerGroupingMaxDepth: d,
    columnMenuState: f,
    columnVisibility: p,
    columnGroupsHeaderStructure: m,
    hasOtherElementInTabSequence: b
  } = t, v = ve(t, jte), {
    getInnerProps: g,
    getColumnHeadersRow: y,
    getColumnGroupHeadersRows: w
  } = F2({
    visibleColumns: o,
    sortColumnLookup: s,
    filterColumnLookup: i,
    columnHeaderTabIndexState: a,
    columnGroupHeaderTabIndexState: l,
    columnHeaderFocus: c,
    columnGroupHeaderFocus: u,
    headerGroupingMaxDepth: d,
    columnMenuState: f,
    columnVisibility: p,
    columnGroupsHeaderStructure: m,
    hasOtherElementInTabSequence: b
  });
  return /* @__PURE__ */ ie(L2, I({}, v, g(), {
    ref: n,
    children: [w(), y()]
  }));
});
process.env.NODE_ENV !== "production" && (_2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  columnGroupHeaderFocus: r.shape({
    depth: r.number.isRequired,
    field: r.string.isRequired
  }),
  columnGroupHeaderTabIndexState: r.shape({
    depth: r.number.isRequired,
    field: r.string.isRequired
  }),
  columnGroupsHeaderStructure: r.arrayOf(r.arrayOf(r.shape({
    columnFields: r.arrayOf(r.string).isRequired,
    groupId: r.string
  }))).isRequired,
  columnHeaderFocus: r.shape({
    field: r.string.isRequired
  }),
  columnHeaderTabIndexState: r.shape({
    field: r.string.isRequired
  }),
  columnMenuState: r.shape({
    field: r.string,
    open: r.bool.isRequired
  }).isRequired,
  columnVisibility: r.object.isRequired,
  filterColumnLookup: r.object.isRequired,
  hasOtherElementInTabSequence: r.bool.isRequired,
  headerGroupingMaxDepth: r.number.isRequired,
  sortColumnLookup: r.object.isRequired,
  visibleColumns: r.arrayOf(r.object).isRequired
});
const Gte = Dr(_2);
function qte(e) {
  return null;
}
function Wte(e) {
  return null;
}
const Ute = Ct(function(t, n) {
  const s = lt().current.getLocaleText("noResultsOverlayLabel");
  return /* @__PURE__ */ C(Zp, I({}, t, {
    ref: n,
    children: s
  }));
}), Kte = ["sortingOrder"], Yte = /* @__PURE__ */ h.memo(function(t) {
  const {
    sortingOrder: n
  } = t, o = ve(t, Kte), s = Xe(), [i] = n, a = i === "asc" ? s.slots.columnSortedAscendingIcon : s.slots.columnSortedDescendingIcon;
  return a ? /* @__PURE__ */ C(a, I({}, o)) : null;
}), Xte = ["native"];
function Qte(e) {
  let {
    native: t
  } = e, n = ve(e, Xte);
  return t ? /* @__PURE__ */ C("option", I({}, n)) : /* @__PURE__ */ C(Nn, I({}, n));
}
const Zte = {
  booleanCellTrueIcon: SZ,
  booleanCellFalseIcon: Rg,
  columnMenuIcon: yZ,
  openFilterButtonIcon: dZ,
  filterPanelDeleteIcon: Rg,
  columnFilteredIcon: LT,
  columnSelectorIcon: pZ,
  columnUnsortedIcon: Yte,
  columnSortedAscendingIcon: NT,
  columnSortedDescendingIcon: $T,
  columnResizeIcon: hZ,
  densityCompactIcon: gZ,
  densityStandardIcon: mZ,
  densityComfortableIcon: bZ,
  exportIcon: wZ,
  moreActionsIcon: xZ,
  treeDataCollapseIcon: FT,
  treeDataExpandIcon: AT,
  groupingCriteriaCollapseIcon: FT,
  groupingCriteriaExpandIcon: AT,
  detailPanelExpandIcon: _T,
  detailPanelCollapseIcon: vZ,
  rowReorderIcon: VT,
  quickFilterIcon: fZ,
  quickFilterClearIcon: Rg,
  columnMenuHideIcon: TZ,
  columnMenuSortAscendingIcon: NT,
  columnMenuSortDescendingIcon: $T,
  columnMenuFilterIcon: LT,
  columnMenuManageColumnsIcon: RZ,
  columnMenuClearIcon: EZ,
  loadIcon: CZ,
  filterPanelAddIcon: _T,
  filterPanelRemoveAllIcon: IZ,
  columnReorderIcon: VT
}, Jte = I({}, Zte, {
  baseBadge: Qv,
  baseCheckbox: ml,
  baseDivider: jc,
  baseTextField: Is,
  baseFormControl: bl,
  baseSelect: Ji,
  baseButton: Io,
  baseIconButton: Eo,
  baseInputAdornment: yl,
  baseTooltip: Vp,
  basePopper: is,
  baseInputLabel: Ru,
  baseSelectOption: Qte,
  baseChip: Su
}), ene = I({}, Jte, {
  cell: eQ,
  skeletonCell: iQ,
  columnHeaderFilterIconButton: KD,
  columnHeaderSortIcon: cZ,
  columnMenu: a2,
  columnHeaders: Gte,
  detailPanels: qte,
  footer: v2,
  footerRowCount: x2,
  toolbar: null,
  pinnedRows: Wte,
  loadingOverlay: C2,
  noResultsOverlay: Ute,
  noRowsOverlay: w2,
  pagination: S2,
  filterPanel: f2,
  columnsPanel: l2,
  columnsManagement: p2,
  panel: c2,
  row: zJ
}), tne = (e, t) => I({}, e, {
  headerFiltering: {
    enabled: t.headerFilters ?? !1,
    editing: null,
    menuOpen: null
  }
}), nne = (e, t) => {
  const n = Mn(e, "useGridHeaderFiltering"), o = h.useCallback((f) => {
    e.current.setState((p) => t.signature === "DataGrid" ? p : I({}, p, {
      headerFiltering: {
        enabled: t.headerFilters ?? !1,
        editing: f.editing ?? null,
        menuOpen: f.menuOpen ?? null
      }
    })), e.current.forceUpdate();
  }, [e, t.signature, t.headerFilters]), s = h.useCallback((f) => {
    n.debug(`Starting edit mode on header filter for field: ${f}`), e.current.setHeaderFilterState({
      editing: f
    });
  }, [e, n]), i = h.useCallback(() => {
    n.debug("Stopping edit mode on header filter"), e.current.setHeaderFilterState({
      editing: null
    });
  }, [e, n]), a = h.useCallback((f) => {
    n.debug(`Opening header filter menu for field: ${f}`), e.current.setHeaderFilterState({
      menuOpen: f
    });
  }, [e, n]), l = h.useCallback(() => {
    n.debug("Hiding header filter menu for active field");
    let f = e.current.state.headerFiltering.menuOpen;
    if (f) {
      const p = as(e), m = jo(e), b = Or(e);
      if (p[f] || (f = b[0]), m[f] === !1) {
        const v = b.filter((y) => y === f ? !0 : m[y] !== !1), g = v.indexOf(f);
        f = v[g + 1] || v[g - 1];
      }
      e.current.setHeaderFilterState({
        menuOpen: null
      }), e.current.setColumnHeaderFilterFocus(f);
    }
  }, [e, n]), c = {
    setHeaderFilterState: o
  };
  ot(e, {
    startHeaderFilterEditMode: s,
    stopHeaderFilterEditMode: i,
    showHeaderFilterMenu: a,
    hideHeaderFilterMenu: l
  }, "public"), ot(e, c, "private");
  const d = h.useRef(!0);
  h.useEffect(() => {
    d.current ? d.current = !1 : e.current.setHeaderFilterState({
      enabled: t.headerFilters ?? !1
    });
  }, [e, t.headerFilters]);
}, one = tn("div")({
  position: "sticky",
  left: 0,
  width: 0,
  height: 0
}), rne = (e, t) => {
  const n = ge(e, pn), o = Xp(e), s = h.useRef(null), i = go(), a = h.useRef(null), l = t.rowsLoadingMode === "client" && !!t.onRowsScrollEnd, c = xe(([b]) => {
    var y;
    const v = b.intersectionRatio;
    if (b.isIntersecting && v === 1) {
      const w = e.current.getViewportPageSize(), x = {
        visibleColumns: n,
        viewportPageSize: w,
        visibleRowsCount: o.rows.length
      };
      e.current.publishEvent("rowsScrollEnd", x), (y = s.current) == null || y.disconnect(), a.current = null;
    }
  }), u = e.current.virtualScrollerRef.current;
  h.useEffect(() => {
    var g;
    if (!l || !u)
      return;
    (g = s.current) == null || g.disconnect();
    const b = lU(e.current.state), v = t.scrollEndThreshold - b;
    s.current = new IntersectionObserver(c, {
      threshold: 1,
      root: u,
      rootMargin: `0px 0px ${v}px 0px`
    }), a.current && s.current.observe(a.current);
  }, [e, u, c, l, t.scrollEndThreshold]);
  const d = (b) => {
    var v, g;
    a.current !== b && ((v = s.current) == null || v.disconnect(), a.current = b, a.current && ((g = s.current) == null || g.observe(a.current)));
  }, f = h.useCallback((b) => {
    l && i.start(0, () => d(b));
  }, [l, i]), m = {
    getInfiniteLoadingTriggerElement: h.useCallback(({
      lastRowId: b
    }) => l ? /* @__PURE__ */ C(one, {
      ref: f,
      role: "presentation"
    }, `trigger-${b}`) : null, [l, f])
  };
  ot(e, m, "private"), Pt(e, "rowsScrollEnd", t.onRowsScrollEnd);
}, sne = (e) => e.columnReorder, sR = Je(sne, (e) => e.dragCol), V2 = "left", B2 = "right", ine = (e, t) => e.x <= t.x ? B2 : V2, ane = (e, t) => e.x !== t.x || e.y !== t.y, lne = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    columnHeaderDragging: ["columnHeader--dragging"]
  }, rt, t);
}, cne = (e) => I({}, e, {
  columnReorder: {
    dragCol: ""
  }
}), une = (e, t) => {
  const n = Mn(e, "useGridColumnReorder"), o = h.useRef(null), s = h.useRef({
    x: 0,
    y: 0
  }), i = h.useRef(null), a = h.useRef({}), l = h.useRef(void 0), c = {
    classes: t.classes
  }, u = lne(c), d = _t();
  h.useEffect(() => () => {
    clearTimeout(l.current);
  }, []);
  const f = h.useCallback((v, g) => {
    if (t.disableColumnReorder || v.colDef.disableReorder)
      return;
    n.debug(`Start dragging col ${v.field}`), g.stopPropagation(), o.current = g.currentTarget, o.current.classList.add(u.columnHeaderDragging), g.dataTransfer && (g.dataTransfer.effectAllowed = "move"), e.current.setState((O) => I({}, O, {
      columnReorder: I({}, O.columnReorder, {
        dragCol: v.field
      })
    })), e.current.forceUpdate(), l.current = setTimeout(() => {
      o.current.classList.remove(u.columnHeaderDragging);
    }), i.current = e.current.getColumnIndex(v.field, !1);
    const y = e.current.getColumnGroupPath(v.field), w = i.current, x = e.current.getAllColumns(), S = e.current.getAllGroupDetails(), T = (O) => {
      const M = x[O].field;
      return e.current.getColumnGroupPath(M);
    };
    let E = null;
    y.forEach((O) => {
      var M;
      (M = S[O]) != null && M.freeReordering || (w > 0 && T(w - 1).includes(O) || w + 1 < x.length && T(w + 1).includes(O)) && (E = O);
    }), a.current = {};
    for (let O = 0; O < x.length; O += 1) {
      const M = O <= w ? O - 1 : O, D = O < w ? O : O + 1;
      if (E !== null) {
        let R = !1;
        (M >= 0 && T(M).includes(E) || D < x.length && T(D).includes(E)) && (R = !0), R || (a.current[O] = !0);
      }
      M >= 0 && D < x.length && T(D).forEach((R) => {
        var P;
        T(M).includes(R) && (y.includes(R) || (P = S[R]) != null && P.freeReordering || (a.current[O] = !0));
      });
    }
  }, [t.disableColumnReorder, u.columnHeaderDragging, n, e]), p = h.useCallback((v, g) => {
    g.preventDefault(), g.stopPropagation();
  }, []), m = h.useCallback((v, g) => {
    const y = sR(e);
    if (!y)
      return;
    n.debug(`Dragging over col ${v.field}`), g.preventDefault(), g.stopPropagation();
    const w = {
      x: g.clientX,
      y: g.clientY
    };
    if (v.field !== y && ane(s.current, w)) {
      const x = e.current.getColumnIndex(v.field, !1), S = e.current.getColumnIndex(v.field, !0), T = e.current.getColumn(v.field), E = e.current.getColumnIndex(y, !1), O = e.current.getVisibleColumns(), M = e.current.getAllColumns(), D = ine(s.current, w), R = D === V2 && (d ? E < x : x < E), P = D === B2 && (d ? x < E : E < x);
      if (R || P) {
        let F, $ = 0;
        if (T.disableReorder ? R ? F = S > 0 && !O[S - 1].disableReorder : F = S < O.length - 1 && !O[S + 1].disableReorder : F = !0, a.current[x]) {
          let A, k = x + $;
          if (R)
            for (A = S > 0 ? O[S - 1].field : null; k > 0 && M[k].field !== A && a.current[k]; )
              $ -= 1, k = x + $;
          else
            for (A = S + 1 < O.length ? O[S + 1].field : null; k < M.length - 1 && M[k].field !== A && a.current[k]; )
              $ += 1, k = x + $;
          (a.current[k] || M[k].field === A) && (F = !1);
        }
        e.current.unstable_applyPipeProcessors("canBeReordered", F, {
          targetIndex: S
        }) && e.current.setColumnIndex(y, x + $);
      }
      s.current = w;
    }
  }, [e, n, d]), b = h.useCallback((v, g) => {
    const y = sR(e);
    if (!(t.disableColumnReorder || !y)) {
      if (n.debug("End dragging col"), g.preventDefault(), g.stopPropagation(), clearTimeout(l.current), o.current.classList.contains(u.columnHeaderDragging) && o.current.classList.remove(u.columnHeaderDragging), o.current = null, g.dataTransfer.dropEffect === "none" && !t.keepColumnPositionIfDraggedOutside)
        e.current.setColumnIndex(y, i.current), i.current = null;
      else {
        const w = {
          column: e.current.getColumn(y),
          targetIndex: e.current.getColumnIndexRelativeToVisibleColumns(y),
          oldIndex: i.current
        };
        e.current.publishEvent("columnOrderChange", w);
      }
      e.current.setState((w) => I({}, w, {
        columnReorder: I({}, w.columnReorder, {
          dragCol: ""
        })
      })), e.current.forceUpdate();
    }
  }, [e, t.disableColumnReorder, t.keepColumnPositionIfDraggedOutside, n, u.columnHeaderDragging]);
  Le(e, "columnHeaderDragStart", f), Le(e, "columnHeaderDragEnter", p), Le(e, "columnHeaderDragOver", m), Le(e, "columnHeaderDragEnd", b), Le(e, "cellDragEnter", p), Le(e, "cellDragOver", m), Pt(e, "columnOrderChange", t.onColumnOrderChange);
}, z2 = I({}, ko, {
  type: "custom",
  sortable: !1,
  filterable: !1,
  disableColumnMenu: !0,
  disableReorder: !0,
  align: "left",
  width: 200,
  valueGetter: (e, t, n, o) => {
    const s = o.current.getRowId(t), i = o.current.getRowNode(s);
    return (i == null ? void 0 : i.type) === "group" || (i == null ? void 0 : i.type) === "leaf" ? i.groupingKey : void 0;
  }
}), Gf = {
  field: YC,
  editable: !1,
  groupable: !1
}, dne = (e, t) => {
  const n = h.useCallback((o, s) => {
    if (e.current.getCellParams(o.id, o.field).colDef.field === YC && (s.key === " " || s.key === "Enter") && !s.shiftKey) {
      if (o.rowNode.type !== "group")
        return;
      if (t.unstable_dataSource && !o.rowNode.childrenExpanded) {
        e.current.unstable_dataSource.fetchRows(o.id);
        return;
      }
      e.current.setRowChildrenExpansion(o.id, !o.rowNode.childrenExpanded);
    }
  }, [e, t.unstable_dataSource]);
  Le(e, "cellKeyDown", n);
};
let ro = /* @__PURE__ */ function(e) {
  return e.Default = "tree-data", e.DataSource = "tree-data-source", e;
}({});
const fne = (e) => {
  const {
    apiRef: t,
    rowTree: n,
    disableChildrenFiltering: o,
    isRowMatchingFilters: s
  } = e, i = {}, a = {}, l = {}, c = {}, u = {
    passingFilterItems: null,
    passingQuickFilterValues: null
  }, d = (p, m, b) => {
    const v = o && p.depth > 0;
    let g;
    if (v)
      g = null;
    else if (!s || p.type === "footer")
      g = !0;
    else {
      const S = t.current.getRow(p.id);
      s(S, void 0, u), g = $k([u.passingFilterItems], [u.passingQuickFilterValues], e.filterModel, e.apiRef, c);
    }
    let y = 0, w = 0;
    p.type === "group" && p.children.forEach((S) => {
      const T = n[S], E = d(T, g ?? m, b && !!p.childrenExpanded);
      w += E, E > 0 && (y += 1);
    });
    let x;
    switch (g) {
      case !0: {
        x = !0;
        break;
      }
      case !1: {
        x = w > 0;
        break;
      }
      default: {
        x = m;
        break;
      }
    }
    return i[p.id] = x, x ? (a[p.id] = y, l[p.id] = w, p.type === "footer" ? w : w + 1) : 0;
  }, f = Object.values(n);
  for (let p = 0; p < f.length; p += 1) {
    const m = f[p];
    m.depth === 0 && d(m, !0, !0);
  }
  return {
    filteredRowsLookup: i,
    filteredChildrenCountLookup: a,
    filteredDescendantCountLookup: l
  };
}, Fo = Xe, g0 = lt, pne = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["treeDataGroupingCell"],
    toggle: ["treeDataGroupingCellToggle"]
  }, rt, t);
};
function H2(e) {
  var b;
  const {
    id: t,
    field: n,
    formattedValue: o,
    rowNode: s,
    hideDescendantCount: i,
    offsetMultiplier: a = 2
  } = e, l = Fo(), c = g0(), u = pne(l), f = ge(c, xK)[s.id] ?? 0, p = s.childrenExpanded ? l.slots.treeDataCollapseIcon : l.slots.treeDataExpandIcon, m = (v) => {
    c.current.setRowChildrenExpansion(t, !s.childrenExpanded), c.current.setCellFocus(t, n), v.stopPropagation();
  };
  return /* @__PURE__ */ ie(vt, {
    className: u.root,
    sx: {
      ml: s.depth * a
    },
    children: [/* @__PURE__ */ C("div", {
      className: u.toggle,
      children: f > 0 && /* @__PURE__ */ C(l.slots.baseIconButton, I({
        size: "small",
        onClick: m,
        tabIndex: -1,
        "aria-label": s.childrenExpanded ? c.current.getLocaleText("treeDataCollapse") : c.current.getLocaleText("treeDataExpand")
      }, (b = l == null ? void 0 : l.slotProps) == null ? void 0 : b.baseIconButton, {
        children: /* @__PURE__ */ C(p, {
          fontSize: "inherit"
        })
      }))
    }), /* @__PURE__ */ ie("span", {
      children: [o === void 0 ? s.groupingKey : o, !i && f > 0 ? ` (${f})` : ""]
    })]
  });
}
process.env.NODE_ENV !== "production" && (H2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: r.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: r.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: r.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: r.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      focus: r.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: r.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: r.bool.isRequired,
  hideDescendantCount: r.bool,
  /**
   * The grid row id.
   */
  id: r.oneOfType([r.number, r.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: r.bool,
  /**
   * The cell offset multiplier used for calculating cell offset (`rowNode.depth * offsetMultiplier` px).
   * @default 2
   */
  offsetMultiplier: r.number,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: r.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: r.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: r.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: r.any
});
function j2(e) {
  const {
    colDef: t,
    onClick: n
  } = e, o = g0(), s = Fo(), i = _t(), a = h.useCallback((f) => (p) => {
    o.current.pinColumn(t.field, f), n(p);
  }, [o, t.field, n]), l = (f) => {
    o.current.unpinColumn(t.field), n(f);
  }, c = /* @__PURE__ */ ie(Nn, {
    onClick: a(Ln.LEFT),
    children: [/* @__PURE__ */ C(ur, {
      children: /* @__PURE__ */ C(s.slots.columnMenuPinLeftIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ C(Ho, {
      children: o.current.getLocaleText("pinToLeft")
    })]
  }), u = /* @__PURE__ */ ie(Nn, {
    onClick: a(Ln.RIGHT),
    children: [/* @__PURE__ */ C(ur, {
      children: /* @__PURE__ */ C(s.slots.columnMenuPinRightIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ C(Ho, {
      children: o.current.getLocaleText("pinToRight")
    })]
  });
  if (!t)
    return null;
  const d = o.current.isColumnPinned(t.field);
  if (d) {
    const f = d === Ln.RIGHT ? Ln.LEFT : Ln.RIGHT, p = f === Ln.RIGHT ? "pinToRight" : "pinToLeft", m = d === Ln.RIGHT ? s.slots.columnMenuPinLeftIcon : s.slots.columnMenuPinRightIcon;
    return /* @__PURE__ */ ie(h.Fragment, {
      children: [/* @__PURE__ */ ie(Nn, {
        onClick: a(f),
        children: [/* @__PURE__ */ C(ur, {
          children: /* @__PURE__ */ C(m, {
            fontSize: "small"
          })
        }), /* @__PURE__ */ C(Ho, {
          children: o.current.getLocaleText(p)
        })]
      }), /* @__PURE__ */ ie(Nn, {
        onClick: l,
        children: [/* @__PURE__ */ C(ur, {}), /* @__PURE__ */ C(Ho, {
          children: o.current.getLocaleText("unpin")
        })]
      })]
    });
  }
  return i ? /* @__PURE__ */ ie(h.Fragment, {
    children: [u, c]
  }) : /* @__PURE__ */ ie(h.Fragment, {
    children: [c, u]
  });
}
process.env.NODE_ENV !== "production" && (j2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: r.object.isRequired,
  onClick: r.func.isRequired
});
const Hs = (e) => e.detailPanel.expandedRowIds, m0 = (e) => e.detailPanel.contentCache, zy = (e) => e.detailPanel.heightCache, G2 = Mt(zy, (e) => Object.entries(e).reduce((t, [n, {
  height: o
}]) => (t[n] = o || 0, t), {})), hne = (e) => {
  const {
    classes: t,
    isExpanded: n
  } = e;
  return fe({
    root: ["detailPanelToggleCell", n && "detailPanelToggleCell--expanded"]
  }, rt, t);
}, gne = ni(Hs, (e, t) => e.includes(t));
function q2(e) {
  var m;
  const {
    id: t,
    row: n,
    api: o
  } = e, s = o.getRowId(n), i = Ys({
    current: o
  }, gne, s), a = Fo(), l = g0(), c = {
    classes: a.classes,
    isExpanded: i
  }, u = hne(c), d = ge(l, m0), f = /* @__PURE__ */ h.isValidElement(d[t]), p = i ? a.slots.detailPanelCollapseIcon : a.slots.detailPanelExpandIcon;
  return /* @__PURE__ */ C(a.slots.baseIconButton, I({
    size: "small",
    tabIndex: -1,
    disabled: !f,
    className: u.root,
    "aria-label": i ? l.current.getLocaleText("collapseDetailPanel") : l.current.getLocaleText("expandDetailPanel")
  }, (m = a.slotProps) == null ? void 0 : m.baseIconButton, {
    children: /* @__PURE__ */ C(p, {
      fontSize: "inherit"
    })
  }));
}
process.env.NODE_ENV !== "production" && (q2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: r.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: r.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: r.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: r.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      focus: r.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: r.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: r.bool.isRequired,
  /**
   * The grid row id.
   */
  id: r.oneOfType([r.number, r.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: r.bool,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: r.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: r.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: r.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: r.any
});
const mne = (e) => {
  const {
    isDraggable: t,
    classes: n
  } = e;
  return fe({
    root: ["rowReorderCell", t && "rowReorderCell--draggable"],
    placeholder: ["rowReorderCellPlaceholder"]
  }, rt, n);
};
function W2(e) {
  const t = lt(), n = Fo(), o = ge(t, uo), s = ge(t, Ps), i = ge(t, Pn), a = e.row.__reorder__ || e.id, l = h.useMemo(() => !!n.rowReordering && !o.length && s === 1 && Object.keys(i).length === 0, [n.rowReordering, o, s, i]), c = {
    isDraggable: l,
    classes: n.classes
  }, u = mne(c), d = h.useCallback((p, m) => (b) => {
    Ol(b) || t.current.getRow(e.id) && (t.current.publishEvent(p, t.current.getRowParams(e.id), b), m && m(b));
  }, [t, e.id]), f = l ? {
    onDragStart: d("rowDragStart"),
    onDragOver: d("rowDragOver"),
    onDragEnd: d("rowDragEnd")
  } : null;
  return e.rowNode.type === "footer" ? null : /* @__PURE__ */ ie("div", I({
    className: u.root,
    draggable: l
  }, f, {
    children: [/* @__PURE__ */ C(n.slots.rowReorderIcon, {}), /* @__PURE__ */ C("div", {
      className: u.placeholder,
      children: a
    })]
  }));
}
process.env.NODE_ENV !== "production" && (W2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: r.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: r.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: r.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: r.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      focus: r.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: r.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: r.bool.isRequired,
  /**
   * The grid row id.
   */
  id: r.oneOfType([r.number, r.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: r.bool,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: r.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: r.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: r.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: r.any
});
const bne = (e) => e.rowNode.type === "footer" || e.rowNode.type === "pinnedRow" ? null : /* @__PURE__ */ C(W2, I({}, e)), yne = _e(/* @__PURE__ */ C("g", {
  transform: "rotate(-30 15 10)",
  children: /* @__PURE__ */ C("path", {
    d: "M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z",
    fillRule: "evenodd"
  })
}), "PushPinRight"), vne = _e(/* @__PURE__ */ C("g", {
  transform: "rotate(30 8 12)",
  children: /* @__PURE__ */ C("path", {
    d: "M16,9V4l1,0c0.55,0,1-0.45,1-1v0c0-0.55-0.45-1-1-1H7C6.45,2,6,2.45,6,3v0 c0,0.55,0.45,1,1,1l1,0v5c0,1.66-1.34,3-3,3h0v2h5.97v7l1,1l1-1v-7H19v-2h0C17.34,12,16,10.66,16,9z",
    fillRule: "evenodd"
  })
}), "PushPinLeft"), Cne = ["operators", "item", "field", "buttonRef", "headerFilterMenuRef", "disabled"], wne = {
  width: 22,
  height: 22,
  margin: "auto 0 10px 5px"
};
function U2(e) {
  var y;
  const {
    operators: t,
    item: n,
    field: o,
    buttonRef: s,
    headerFilterMenuRef: i,
    disabled: a = !1
  } = e, l = ve(e, Cne), c = gt(), u = gt(), d = Fo(), f = lt(), m = !!(ge(f, o0) === o && i.current), b = (w) => {
    i.current = w.currentTarget, f.current.showHeaderFilterMenu(o);
  };
  if (!d.slots.headerFilterMenu)
    return null;
  const v = f.current.getLocaleText("filterPanelOperator"), g = v ? String(v) : void 0;
  return /* @__PURE__ */ ie(h.Fragment, {
    children: [/* @__PURE__ */ C(d.slots.baseIconButton, I({
      id: c,
      ref: s,
      "aria-label": g,
      title: g,
      "aria-controls": u,
      "aria-expanded": m ? "true" : void 0,
      "aria-haspopup": "true",
      tabIndex: -1,
      size: "small",
      onClick: b,
      sx: wne,
      disabled: a
    }, (y = d.slotProps) == null ? void 0 : y.baseIconButton, {
      children: /* @__PURE__ */ C(d.slots.openFilterButtonIcon, {
        fontSize: "small"
      })
    })), /* @__PURE__ */ C(d.slots.headerFilterMenu, I({
      field: o,
      open: m,
      item: n,
      target: i.current,
      operators: t,
      labelledBy: c,
      id: u
    }, l))]
  });
}
process.env.NODE_ENV !== "production" && (U2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  applyFilterChanges: r.func.isRequired,
  buttonRef: Lt,
  disabled: r.bool,
  field: r.string.isRequired,
  headerFilterMenuRef: r.shape({
    current: r.object
  }).isRequired,
  item: r.shape({
    field: r.string.isRequired,
    id: r.oneOfType([r.number, r.string]),
    operator: r.string.isRequired,
    value: r.any
  }).isRequired,
  operators: r.arrayOf(r.shape({
    getApplyFilterFn: r.func.isRequired,
    getValueAsString: r.func,
    headerLabel: r.string,
    InputComponent: r.elementType,
    InputComponentProps: r.object,
    label: r.string,
    requiresFilterValue: r.bool,
    value: r.string.isRequired
  })).isRequired
});
const Sne = {
  padding: "2px"
};
function xne(e) {
  var n;
  const t = Fo();
  return /* @__PURE__ */ C(t.slots.baseIconButton, I({
    tabIndex: -1,
    "aria-label": "Clear filter",
    size: "small",
    sx: Sne
  }, e, (n = t.slotProps) == null ? void 0 : n.baseIconButton, {
    children: /* @__PURE__ */ C(t.slots.columnMenuClearIcon, {
      fontSize: "inherit"
    })
  }));
}
const Tne = ["colIndex", "height", "hasFocus", "width", "headerClassName", "colDef", "item", "headerFilterMenuRef", "InputComponentProps", "showClearIcon", "pinnedPosition", "pinnedOffset", "style", "showLeftBorder", "showRightBorder"], Rne = (e) => {
  const {
    colDef: t,
    classes: n,
    showRightBorder: o,
    showLeftBorder: s,
    pinnedPosition: i
  } = e, a = {
    root: ["columnHeader", t.headerAlign === "left" && "columnHeader--alignLeft", t.headerAlign === "center" && "columnHeader--alignCenter", t.headerAlign === "right" && "columnHeader--alignRight", "withBorderColor", o && "columnHeader--withRightBorder", s && "columnHeader--withLeftBorder", i === ut.LEFT && "columnHeader--pinnedLeft", i === ut.RIGHT && "columnHeader--pinnedRight"]
  };
  return fe(a, rt, n);
}, Ene = {
  '& input[value=""]:not(:focus)': {
    color: "transparent"
  }
}, Ine = {
  string: po,
  number: po,
  date: hs,
  dateTime: hs,
  boolean: XC,
  singleSelect: Bf,
  actions: null,
  custom: null
}, K2 = Ct((e, t) => {
  const {
    colIndex: n,
    height: o,
    hasFocus: s,
    width: i,
    headerClassName: a,
    colDef: l,
    item: c,
    headerFilterMenuRef: u,
    InputComponentProps: d,
    showClearIcon: f = !0,
    pinnedPosition: p,
    pinnedOffset: m,
    style: b,
    showLeftBorder: v,
    showRightBorder: g
  } = e, y = ve(e, Tne), w = eo(), x = _t(), S = ge(w, na), T = Fo(), E = h.useRef(null), O = tt(t, E), M = h.useRef(null), D = h.useRef(null), P = ge(w, bD) === l.field, $ = ge(w, o0) === l.field, N = h.useMemo(() => l.filterOperators ? l.filterOperators.filter((H) => H.value !== "isAnyOf") : [], [l.filterOperators]), A = ge(w, kn), k = ge(w, kk), L = h.useMemo(() => {
    if (!(A != null && A.items.length))
      return !1;
    const H = A.items.find((U) => U.field === l.field);
    return H ? !k[H.field] : !1;
  }, [l.field, A, k]), B = h.useMemo(() => N.find((H) => H.value === c.operator) ?? N[0], [c.operator, N]), V = l.filterable || L ? B.InputComponent ?? Ine[l.type] : null, _ = h.useCallback(() => {
    w.current.deleteFilterItem(c);
  }, [w, c]);
  let z;
  l.renderHeaderFilter && (z = l.renderHeaderFilter(I({}, e, {
    inputRef: M
  }))), h.useLayoutEffect(() => {
    if (s && !$) {
      let H = E.current.querySelector('[tabindex="0"]');
      P && V && (H = M.current);
      const U = H || E.current;
      U == null || U.focus(), w.current.columnHeadersContainerRef.current && (w.current.columnHeadersContainerRef.current.scrollLeft = 0);
    }
  }, [V, w, s, P, $]);
  const j = h.useCallback((H) => {
    if (!($ || Zc(H.key) || L))
      switch (H.key) {
        case "Escape":
          P && w.current.stopHeaderFilterEditMode();
          break;
        case "Enter":
          if (P && !H.defaultPrevented) {
            w.current.stopHeaderFilterEditMode();
            break;
          }
          if (H.metaKey || H.ctrlKey) {
            u.current = D.current, w.current.showHeaderFilterMenu(l.field);
            break;
          }
          w.current.startHeaderFilterEditMode(l.field);
          break;
        case "Tab": {
          if (P) {
            const U = S[n + (H.shiftKey ? -1 : 1)] ?? null;
            U && (w.current.startHeaderFilterEditMode(U), w.current.setColumnHeaderFilterFocus(U, H));
          }
          break;
        }
        default:
          if (P || H.metaKey || H.ctrlKey || H.altKey || H.shiftKey)
            break;
          w.current.startHeaderFilterEditMode(l.field);
          break;
      }
  }, [w, l.field, n, S, u, P, L, $]), W = h.useCallback((H, U) => (X) => {
    w.current.publishEvent(H, w.current.getColumnHeaderParams(l.field), X), U && U(X);
  }, [w, l.field]), J = h.useCallback((H) => {
    var U, X;
    s || ((X = (U = M.current) == null ? void 0 : U.contains) != null && X.call(U, H.target) && M.current.focus(), w.current.setColumnHeaderFilterFocus(l.field, H));
  }, [w, l.field, s]), G = h.useMemo(() => ({
    onKeyDown: W("headerFilterKeyDown", j),
    onClick: W("headerFilterClick"),
    onMouseDown: W("headerFilterMouseDown", J),
    onBlur: W("headerFilterBlur")
  }), [J, j, W]), q = I({}, T, {
    pinnedPosition: p,
    colDef: l,
    showLeftBorder: v,
    showRightBorder: g
  }), Z = Rne(q), Y = B.requiresFilterValue === !1, Q = (c == null ? void 0 : c.value) !== void 0 || Y, ee = B.headerLabel ?? w.current.getLocaleText(`headerFilterOperator${ce(c.operator)}`), ne = Q || s;
  return /* @__PURE__ */ ie("div", I({
    className: ae(Z.root, a),
    style: _u(I({
      height: o,
      width: i
    }, b), x, p, m),
    role: "columnheader",
    "aria-colindex": n + 1,
    "aria-label": z == null ? l.headerName ?? l.field : void 0
  }, y, G, {
    ref: O,
    children: [z, V && z === void 0 ? /* @__PURE__ */ ie(h.Fragment, {
      children: [/* @__PURE__ */ C(V, I({
        apiRef: w,
        item: c,
        inputRef: M,
        applyValue: w.current.upsertFilterItem,
        onFocus: () => w.current.startHeaderFilterEditMode(l.field),
        onBlur: (H) => {
          var U;
          w.current.stopHeaderFilterEditMode(), (U = H.relatedTarget) != null && U.className.includes("columnHeader") || w.current.setState((X) => I({}, X, {
            focus: {
              cell: null,
              columnHeader: null,
              columnHeaderFilter: null,
              columnGroupHeader: null
            }
          }));
        },
        label: ce(ee),
        placeholder: "",
        isFilterActive: ne,
        clearButton: f && Q ? /* @__PURE__ */ C(xne, {
          onClick: _,
          disabled: L
        }) : null,
        disabled: L || Y,
        tabIndex: -1,
        InputLabelProps: null,
        sx: l.type === "date" || l.type === "dateTime" || l.type === "number" ? Ene : void 0
      }, Y ? {
        value: ""
      } : {}, B == null ? void 0 : B.InputComponentProps, d)), /* @__PURE__ */ C(U2, {
        operators: N,
        item: c,
        field: l.field,
        disabled: L,
        applyFilterChanges: w.current.upsertFilterItem,
        headerFilterMenuRef: u,
        buttonRef: D
      })]
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (K2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: r.object.isRequired,
  colIndex: r.number.isRequired,
  hasFocus: r.bool,
  /**
   * Class name added to the column header cell.
   */
  headerClassName: r.oneOfType([r.func, r.string]),
  headerFilterMenuRef: r.shape({
    current: r.object
  }).isRequired,
  height: r.number.isRequired,
  InputComponentProps: r.object,
  item: r.shape({
    field: r.string.isRequired,
    id: r.oneOfType([r.number, r.string]),
    operator: r.string.isRequired,
    value: r.any
  }).isRequired,
  pinnedOffset: r.number,
  pinnedPosition: r.oneOf([0, 1, 2, 3]),
  showClearIcon: r.bool,
  showLeftBorder: r.bool.isRequired,
  showRightBorder: r.bool.isRequired,
  sortIndex: r.number,
  style: r.object,
  tabIndex: r.oneOf([-1, 0]).isRequired,
  width: r.number.isRequired
});
const One = Dr(K2);
function Y2({
  open: e,
  field: t,
  target: n,
  applyFilterChanges: o,
  operators: s,
  item: i,
  id: a,
  labelledBy: l
}) {
  const c = lt(), u = h.useCallback(() => {
    c.current.hideHeaderFilterMenu();
  }, [c]), d = h.useCallback((f) => {
    f.key === "Tab" && f.preventDefault(), (f.key === "Escape" || f.key === "Tab") && u();
  }, [u]);
  return n ? /* @__PURE__ */ C(ku, {
    placement: "bottom-end",
    open: e,
    target: n,
    onClose: u,
    children: /* @__PURE__ */ C(Zi, {
      "aria-labelledby": l,
      id: a,
      onKeyDown: d,
      children: s.map((f, p) => {
        const m = (f == null ? void 0 : f.headerLabel) ?? c.current.getLocaleText(`headerFilterOperator${ce(f.value)}`);
        return /* @__PURE__ */ C(Nn, {
          onClick: () => {
            o(I({}, i, {
              operator: f.value
            })), u();
          },
          autoFocus: p === 0 ? e : !1,
          selected: f.value === i.operator,
          children: m
        }, `${t}-${f.value}`);
      })
    })
  }) : null;
}
process.env.NODE_ENV !== "production" && (Y2.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  applyFilterChanges: r.func.isRequired,
  field: r.string.isRequired,
  id: r.string.isRequired,
  item: r.shape({
    field: r.string.isRequired,
    id: r.oneOfType([r.number, r.string]),
    operator: r.string.isRequired,
    value: r.any
  }).isRequired,
  labelledBy: r.string.isRequired,
  open: r.bool.isRequired,
  operators: r.arrayOf(r.shape({
    getApplyFilterFn: r.func.isRequired,
    getValueAsString: r.func,
    headerLabel: r.string,
    InputComponent: r.elementType,
    InputComponentProps: r.object,
    label: r.string,
    requiresFilterValue: r.bool,
    value: r.string.isRequired
  })).isRequired,
  target: Ko
});
const X2 = (e) => `auto-generated-row-${e.map((n) => `${n.field}/${n.key}`).join("-")}`, Q2 = ({
  id: e,
  tree: t
}) => {
  const n = [];
  let o = t[e];
  for (; o.id !== Dt; )
    n.push({
      field: o.type === "leaf" ? null : o.groupingField,
      key: o.groupingKey
    }), o = t[o.parent];
  return n.reverse(), n;
}, Z2 = (e, t, n) => {
  let o;
  return e.id === Dt ? o = !0 : n ? o = n(e) : o = t === -1 || t > e.depth, o;
}, iR = (e, t, n) => {
  const o = Z2(e, t, n);
  return e.childrenExpanded = o, e;
}, qf = (e, t, n, o) => {
  var i;
  t[e.id] = e, n[e.depth] = (n[e.depth] ?? 0) + 1;
  const s = t[e.parent];
  if (e.type === "group" || e.type === "leaf") {
    const a = e.groupingField ?? "__no_field__", l = e.groupingKey ?? "__no_key__", c = (i = s.childrenFromPath) == null ? void 0 : i[a];
    o !== null && o[s.id] === t[s.id] ? s.children = [...s.children, e.id] : s.children.push(e.id), c == null ? s.childrenFromPath[a] = {
      [l.toString()]: e.id
    } : c[l.toString()] = e.id;
  } else e.type === "footer" && (s.footerId = e.id);
}, Hy = ({
  node: e,
  tree: t,
  treeDepths: n
}) => {
  delete t[e.id];
  const o = e.depth, s = n[o];
  s === 1 ? delete n[o] : n[o] = s - 1;
  const i = t[e.parent];
  if (e.type === "footer")
    t[i.id] = I({}, i, {
      footerId: null
    });
  else {
    const a = e.groupingField ?? "__no_field__", l = e.groupingKey ?? "__no_key__", c = i.children.filter((d) => d !== e.id), u = i.childrenFromPath;
    delete u[a][l.toString()], t[i.id] = I({}, i, {
      children: c,
      childrenFromPath: u
    });
  }
}, J2 = ({
  node: e,
  updatedNode: t,
  previousTree: n,
  tree: o,
  treeDepths: s
}) => {
  e.children.forEach((a) => {
    o[a] = I({}, o[a], {
      parent: t.id
    });
  }), Hy({
    node: e,
    tree: o,
    treeDepths: s
  });
  const i = I({}, e, t);
  qf(i, o, s, n);
}, Pne = () => ({
  value: {},
  addAction(e, t) {
    this.value[e] || (this.value[e] = {}), this.value[e][t] = !0;
  }
}), eN = ({
  tree: e,
  filteredRowsLookup: t
}) => {
  if (!t)
    return {};
  const n = {}, o = (i, a) => {
    const l = t[i.id] !== !1;
    i.type === "group" && i.children.forEach((c) => {
      const u = e[c];
      o(u, a && !!i.childrenExpanded);
    }), n[i.id] = l && a, i.type === "group" && i.footerId != null && (n[i.footerId] = l && a && !!i.childrenExpanded);
  }, s = Object.values(e);
  for (let i = 0; i < s.length; i += 1) {
    const a = s[i];
    a.depth === 0 && o(a, !0);
  }
  return n;
}, jy = ({
  id: e,
  path: t,
  updatedGroupsManager: n,
  previousTree: o,
  tree: s,
  treeDepths: i,
  onDuplicatePath: a,
  isGroupExpandedByDefault: l,
  defaultGroupingExpansionDepth: c,
  serverChildrenCount: u,
  groupsToFetch: d
}) => {
  var p, m;
  let f = Dt;
  for (let b = 0; b < t.length; b += 1) {
    const {
      key: v,
      field: g
    } = t[b], y = g ?? "__no_field__", w = v ?? "__no_key__", x = (m = (p = s[f].childrenFromPath) == null ? void 0 : p[y]) == null ? void 0 : m[w.toString()];
    if (b === t.length - 1)
      if (x == null) {
        let S;
        u !== void 0 && u !== 0 ? (S = {
          type: "group",
          id: e,
          parent: f,
          path: t.map((E) => E.key),
          depth: b,
          isAutoGenerated: !1,
          groupingKey: v,
          groupingField: g,
          children: [],
          childrenFromPath: {},
          childrenExpanded: !1,
          serverChildrenCount: u
        }, Z2(S, c, l) && (d == null || d.add(e))) : S = {
          type: "leaf",
          id: e,
          depth: b,
          parent: f,
          groupingKey: v
        }, n == null || n.addAction(f, "insertChildren"), qf(S, s, i, o);
      } else {
        const S = s[x];
        S.type === "group" && S.isAutoGenerated ? (n == null || n.addAction(f, "removeChildren"), n == null || n.addAction(f, "insertChildren"), J2({
          tree: s,
          previousTree: o,
          treeDepths: i,
          node: S,
          updatedNode: {
            id: e,
            isAutoGenerated: !1
          }
        })) : a == null || a(x, e, t);
      }
    else if (x == null) {
      const S = X2(t.slice(0, b + 1)), T = {
        type: "group",
        id: S,
        parent: f,
        depth: b,
        isAutoGenerated: !0,
        groupingKey: v,
        groupingField: g,
        children: [],
        childrenFromPath: {},
        childrenExpanded: !1
      };
      n == null || n.addAction(f, "insertChildren"), qf(iR(T, c, l), s, i, o), f = S;
    } else {
      const S = s[x];
      if (S.type !== "group") {
        const T = {
          type: "group",
          id: S.id,
          parent: S.parent,
          depth: S.depth,
          isAutoGenerated: !1,
          groupingKey: v,
          groupingField: g,
          children: [],
          childrenFromPath: {},
          childrenExpanded: !1
        };
        s[x] = iR(T, c, l);
      }
      f = S.id;
    }
  }
}, tN = (e) => {
  const t = [], n = {
    [Dt]: Vk()
  }, o = {}, s = /* @__PURE__ */ new Set();
  for (let i = 0; i < e.nodes.length; i += 1) {
    const a = e.nodes[i];
    t.push(a.id), jy({
      tree: n,
      previousTree: e.previousTree,
      id: a.id,
      path: a.path,
      serverChildrenCount: a.serverChildrenCount,
      onDuplicatePath: e.onDuplicatePath,
      treeDepths: o,
      isGroupExpandedByDefault: e.isGroupExpandedByDefault,
      defaultGroupingExpansionDepth: e.defaultGroupingExpansionDepth,
      groupsToFetch: s
    });
  }
  return {
    tree: n,
    treeDepths: o,
    groupingName: e.groupingName,
    dataRowIds: t,
    groupsToFetch: Array.from(s)
  };
};
class aR {
  constructor(t, n) {
    this.next = void 0, this.data = void 0, this.next = n, this.data = t;
  }
  insertAfter(t) {
    if (!t.first || !t.last)
      return;
    const n = this.next;
    this.next = t.first, t.last.next = n;
  }
}
class tu {
  constructor(t, n) {
    this.first = void 0, this.last = void 0, this.first = t, this.last = n;
  }
  data() {
    const t = [];
    return this.forEach((n) => {
      t.push(n.data);
    }), t;
  }
  forEach(t) {
    let n = this.first;
    for (; n !== null; )
      t(n), n = n.next;
  }
  static from(t) {
    if (t.length === 0)
      return new tu(null, null);
    let n = 0;
    const o = new aR(t[n], null);
    let s = o;
    for (; n + 1 < t.length; ) {
      n += 1;
      const i = new aR(t[n], null);
      s.next = i, s = i;
    }
    return new tu(o, s);
  }
}
const Mne = (e) => {
  const {
    rowTree: t,
    disableChildrenSorting: n,
    sortRowList: o
  } = e, s = /* @__PURE__ */ new Map(), i = (l) => {
    const c = !!o && (!n || l.depth === -1);
    let u;
    if (c) {
      for (let d = 0; d < l.children.length; d += 1) {
        const f = t[l.children[d]];
        f.type === "group" && i(f);
      }
      u = o(l.children.map((d) => t[d]));
    } else {
      for (let d = 0; d < l.children.length; d += 1) {
        const f = t[l.children[d]];
        f.type === "group" && i(f);
      }
      u = [...l.children];
    }
    l.footerId != null && u.push(l.footerId), s.set(l.id, u);
  };
  i(t[Dt]);
  const a = tu.from(s.get(Dt));
  return a.forEach((l) => {
    const c = s.get(l.data);
    c != null && c.length && l.insertAfter(tu.from(c));
  }), a.data();
}, nN = ({
  node: e,
  tree: t,
  treeDepths: n,
  updatedGroupsManager: o
}) => {
  Hy({
    node: e,
    tree: t,
    treeDepths: n
  }), e.type === "group" && e.footerId != null && Hy({
    node: t[e.footerId],
    tree: t,
    treeDepths: n
  });
  const s = t[e.parent];
  o == null || o.addAction(s.id, "removeChildren"), s.id !== Dt && s.children.length === 0 && (s.isAutoGenerated ? nN({
    node: s,
    tree: t,
    treeDepths: n
  }) : t[s.id] = {
    type: "leaf",
    id: s.id,
    depth: s.depth,
    parent: s.parent,
    groupingKey: s.groupingKey
  });
}, kne = ({
  node: e,
  tree: t,
  treeDepths: n,
  updatedGroupsManager: o
}) => {
  o == null || o.addAction(e.parent, "removeChildren"), o == null || o.addAction(e.parent, "insertChildren"), J2({
    previousTree: null,
    tree: t,
    treeDepths: n,
    node: e,
    updatedNode: {
      id: X2(Q2({
        id: e.id,
        tree: t
      })),
      isAutoGenerated: !0
    }
  });
}, lR = ({
  id: e,
  tree: t,
  treeDepths: n,
  updatedGroupsManager: o
}) => {
  const s = t[e];
  s.type === "group" && s.children.length > 0 ? kne({
    node: s,
    tree: t,
    treeDepths: n,
    updatedGroupsManager: o
  }) : nN({
    node: s,
    tree: t,
    treeDepths: n,
    updatedGroupsManager: o
  });
}, oN = (e) => {
  const t = I({}, e.previousTree), n = I({}, e.previousTreeDepth), o = Pne(), s = e.previousGroupsToFetch ? /* @__PURE__ */ new Set([...e.previousGroupsToFetch]) : /* @__PURE__ */ new Set([]);
  for (let a = 0; a < e.nodes.inserted.length; a += 1) {
    const {
      id: l,
      path: c,
      serverChildrenCount: u
    } = e.nodes.inserted[a];
    jy({
      previousTree: e.previousTree,
      tree: t,
      treeDepths: n,
      updatedGroupsManager: o,
      id: l,
      path: c,
      serverChildrenCount: u,
      onDuplicatePath: e.onDuplicatePath,
      isGroupExpandedByDefault: e.isGroupExpandedByDefault,
      defaultGroupingExpansionDepth: e.defaultGroupingExpansionDepth,
      groupsToFetch: s
    });
  }
  for (let a = 0; a < e.nodes.removed.length; a += 1) {
    const l = e.nodes.removed[a];
    lR({
      tree: t,
      treeDepths: n,
      updatedGroupsManager: o,
      id: l
    });
  }
  for (let a = 0; a < e.nodes.modified.length; a += 1) {
    const {
      id: l,
      path: c,
      serverChildrenCount: u
    } = e.nodes.modified[a], d = Q2({
      tree: t,
      id: l
    });
    Xr(d, c) ? o == null || o.addAction(t[l].parent, "modifyChildren") : (lR({
      tree: t,
      treeDepths: n,
      updatedGroupsManager: o,
      id: l
    }), jy({
      previousTree: e.previousTree,
      tree: t,
      treeDepths: n,
      updatedGroupsManager: o,
      id: l,
      path: c,
      serverChildrenCount: u,
      onDuplicatePath: e.onDuplicatePath,
      isGroupExpandedByDefault: e.isGroupExpandedByDefault,
      defaultGroupingExpansionDepth: e.defaultGroupingExpansionDepth,
      groupsToFetch: s
    }));
  }
  const i = Nu(t, Dt, !0);
  return {
    tree: t,
    treeDepths: n,
    groupingName: e.groupingName,
    dataRowIds: i,
    updatedGroupsManager: o,
    groupsToFetch: Array.from(s)
  };
}, Dne = ["hideDescendantCount"], Nne = (e, t) => {
  const n = h.useCallback(() => {
    e.current.setStrategyAvailability("rowTree", ro.Default, t.treeData && !t.unstable_dataSource ? () => !0 : () => !1);
  }, [e, t.treeData, t.unstable_dataSource]), o = h.useCallback(() => {
    const u = t.groupingColDef;
    let d;
    if (typeof u == "function") {
      const v = {
        groupingName: ro.Default,
        fields: []
      };
      d = u(v);
    } else
      d = u;
    const f = d ?? {}, {
      hideDescendantCount: p
    } = f, m = ve(f, Dne), b = I({}, z2, {
      renderCell: (v) => /* @__PURE__ */ C(H2, I({}, v, {
        hideDescendantCount: p
      })),
      headerName: e.current.getLocaleText("treeDataGroupingHeaderName")
    });
    return I({}, b, m, Gf);
  }, [e, t.groupingColDef]), s = h.useCallback((u) => {
    if (t.unstable_dataSource)
      return u;
    const d = Gf.field, f = t.treeData, p = u.lookup[d];
    if (f) {
      const m = o();
      if (p && (m.width = p.width, m.flex = p.flex), u.lookup[d] = m, p == null) {
        const b = u.orderedFields[0] === Rr ? 1 : 0;
        u.orderedFields = [...u.orderedFields.slice(0, b), d, ...u.orderedFields.slice(b)];
      }
    } else !f && p && (delete u.lookup[d], u.orderedFields = u.orderedFields.filter((m) => m !== d));
    return u;
  }, [t.treeData, t.unstable_dataSource, o]), i = h.useCallback((u) => {
    if (!t.getTreeDataPath)
      throw new Error("MUI X: No getTreeDataPath given.");
    const d = (p) => ({
      id: p,
      path: t.getTreeDataPath(u.dataRowIdToModelLookup[p]).map((m) => ({
        key: m,
        field: null
      }))
    }), f = (p, m, b) => {
      throw new Error(["MUI X: The path returned by `getTreeDataPath` should be unique.", `The rows with id #${p} and #${m} have the same.`, `Path: ${JSON.stringify(b.map((v) => v.key))}.`].join(`
`));
    };
    return u.updates.type === "full" ? tN({
      previousTree: u.previousTree,
      nodes: u.updates.rows.map(d),
      defaultGroupingExpansionDepth: t.defaultGroupingExpansionDepth,
      isGroupExpandedByDefault: t.isGroupExpandedByDefault,
      groupingName: ro.Default,
      onDuplicatePath: f
    }) : oN({
      nodes: {
        inserted: u.updates.actions.insert.map(d),
        modified: u.updates.actions.modify.map(d),
        removed: u.updates.actions.remove
      },
      previousTree: u.previousTree,
      previousTreeDepth: u.previousTreeDepths,
      defaultGroupingExpansionDepth: t.defaultGroupingExpansionDepth,
      isGroupExpandedByDefault: t.isGroupExpandedByDefault,
      groupingName: ro.Default
    });
  }, [t.getTreeDataPath, t.defaultGroupingExpansionDepth, t.isGroupExpandedByDefault]), a = h.useCallback((u) => {
    const d = Vn(e);
    return fne({
      rowTree: d,
      isRowMatchingFilters: u.isRowMatchingFilters,
      disableChildrenFiltering: t.disableChildrenFiltering,
      filterModel: u.filterModel,
      apiRef: e
    });
  }, [e, t.disableChildrenFiltering]), l = h.useCallback((u) => {
    const d = Vn(e);
    return Mne({
      rowTree: d,
      sortRowList: u.sortRowList,
      disableChildrenSorting: t.disableChildrenSorting
    });
  }, [e, t.disableChildrenSorting]);
  bt(e, "hydrateColumns", s), pr(e, ro.Default, "rowTreeCreation", i), pr(e, ro.Default, "filtering", a), pr(e, ro.Default, "sorting", l), pr(e, ro.Default, "visibleRowsLookupCreation", eN), ra(() => {
    n();
  });
  const c = h.useRef(!0);
  h.useEffect(() => {
    c.current ? c.current = !1 : n();
  }, [n]);
};
function $ne(e) {
  const t = {}, n = {}, o = Object.values(e);
  for (let s = 0; s < o.length; s += 1) {
    const i = o[s];
    t[i.id] = !0, n[i.id] = i.serverChildrenCount ?? 0;
  }
  return {
    filteredRowsLookup: t,
    filteredChildrenCountLookup: n,
    filteredDescendantCountLookup: UC.filteredDescendantCountLookup
  };
}
function Ane(e) {
  return Nu(e, Dt, !1);
}
const Vu = eo, Fne = (e) => {
  const t = e.page * e.pageSize, n = t + e.pageSize - 1;
  return {
    start: t,
    end: n
  };
}, cR = Je(kn, uo, oo, (e, t, n) => I({
  groupKeys: [],
  paginationModel: n,
  sortModel: t,
  filterModel: e
}, Fne(n))), Jp = (e) => e.dataSource;
Je(Jp, (e) => e.loading);
const Lne = ni(Jp, (e, t) => e.loading[t] ?? !1), _ne = Je(Jp, (e) => e.errors), Vne = ni(Jp, (e, t) => e.errors[t]), rN = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["treeDataGroupingCell"],
    toggle: ["treeDataGroupingCellToggle"],
    loadingContainer: ["treeDataGroupingCellLoadingContainer"]
  }, rt, t);
};
function Bne(e) {
  var p;
  const t = Vu(), n = Fo(), o = rN(n), {
    rowNode: s,
    id: i,
    field: a,
    descendantCount: l
  } = e, c = Ys(t, Lne, i), u = Ys(t, Vne, i), d = (m) => {
    s.childrenExpanded ? t.current.setRowChildrenExpansion(i, !s.childrenExpanded) : t.current.unstable_dataSource.fetchRows(i), t.current.setCellFocus(i, a), m.stopPropagation();
  }, f = s.childrenExpanded ? n.slots.treeDataCollapseIcon : n.slots.treeDataExpandIcon;
  return c ? /* @__PURE__ */ C("div", {
    className: o.loadingContainer,
    children: /* @__PURE__ */ C(Fp, {
      size: "1rem",
      color: "inherit"
    })
  }) : l > 0 ? /* @__PURE__ */ C(n.slots.baseIconButton, I({
    size: "small",
    onClick: d,
    tabIndex: -1,
    "aria-label": s.childrenExpanded ? t.current.getLocaleText("treeDataCollapse") : t.current.getLocaleText("treeDataExpand")
  }, (p = n == null ? void 0 : n.slotProps) == null ? void 0 : p.baseIconButton, {
    children: /* @__PURE__ */ C(n.slots.baseTooltip, {
      title: (u == null ? void 0 : u.message) ?? null,
      children: /* @__PURE__ */ C(n.slots.baseBadge, {
        variant: "dot",
        color: "error",
        invisible: !u,
        children: /* @__PURE__ */ C(f, {
          fontSize: "inherit"
        })
      })
    })
  })) : null;
}
function zne(e) {
  var m, b;
  const {
    id: t,
    field: n,
    formattedValue: o,
    rowNode: s,
    hideDescendantCount: i,
    offsetMultiplier: a = 2
  } = e, l = Fo(), c = Vu(), d = ge(c, (v) => v.rows.dataRowIdToModelLookup[t]), f = rN(l);
  let p = 0;
  return d && (p = Math.max(((b = (m = l.unstable_dataSource) == null ? void 0 : m.getChildrenCount) == null ? void 0 : b.call(m, d)) ?? 0, 0)), /* @__PURE__ */ ie(vt, {
    className: f.root,
    sx: {
      ml: s.depth * a
    },
    children: [/* @__PURE__ */ C("div", {
      className: f.toggle,
      children: /* @__PURE__ */ C(Bne, {
        id: t,
        field: n,
        rowNode: s,
        row: d,
        descendantCount: p
      })
    }), /* @__PURE__ */ ie("span", {
      children: [o === void 0 ? s.groupingKey : o, !i && p > 0 ? ` (${p})` : ""]
    })]
  });
}
const Hne = ["hideDescendantCount"], jne = (e, t) => {
  const n = h.useCallback(() => {
    e.current.setStrategyAvailability("rowTree", ro.DataSource, t.treeData && t.unstable_dataSource ? () => !0 : () => !1);
  }, [e, t.treeData, t.unstable_dataSource]), o = h.useCallback(() => {
    const u = t.groupingColDef;
    let d;
    if (typeof u == "function") {
      const v = {
        groupingName: ro.DataSource,
        fields: []
      };
      d = u(v);
    } else
      d = u;
    const f = d ?? {}, {
      hideDescendantCount: p
    } = f, m = ve(f, Hne), b = I({}, z2, {
      renderCell: (v) => /* @__PURE__ */ C(zne, I({}, v, {
        hideDescendantCount: p
      })),
      headerName: e.current.getLocaleText("treeDataGroupingHeaderName")
    });
    return I({}, b, m, Gf);
  }, [e, t.groupingColDef]), s = h.useCallback((u) => {
    if (!t.unstable_dataSource)
      return u;
    const d = Gf.field, f = t.treeData, p = u.lookup[d];
    if (f) {
      const m = o();
      if (p && (m.width = p.width, m.flex = p.flex), u.lookup[d] = m, p == null) {
        const b = u.orderedFields[0] === Rr ? 1 : 0;
        u.orderedFields = [...u.orderedFields.slice(0, b), d, ...u.orderedFields.slice(b)];
      }
    } else !f && p && (delete u.lookup[d], u.orderedFields = u.orderedFields.filter((m) => m !== d));
    return u;
  }, [t.treeData, t.unstable_dataSource, o]), i = h.useCallback((u) => {
    var v, g;
    const d = (v = t.unstable_dataSource) == null ? void 0 : v.getGroupKey;
    if (!d)
      throw new Error("MUI X: No `getGroupKey` method provided with the dataSource.");
    const f = (g = t.unstable_dataSource) == null ? void 0 : g.getChildrenCount;
    if (!f)
      throw new Error("MUI X: No `getChildrenCount` method provided with the dataSource.");
    const p = u.updates.groupKeys ?? [], m = (y) => {
      const w = f(u.dataRowIdToModelLookup[y]);
      return {
        id: y,
        path: [...p, d(u.dataRowIdToModelLookup[y])].map((x) => ({
          key: x,
          field: null
        })),
        serverChildrenCount: w
      };
    }, b = (y, w, x) => {
      throw new Error(["MUI X: The values returned by `getGroupKey` for all the sibling rows should be unique.", `The rows with id #${y} and #${w} have the same.`, `Path: ${JSON.stringify(x.map((S) => S.key))}.`].join(`
`));
    };
    return u.updates.type === "full" ? tN({
      previousTree: u.previousTree,
      nodes: u.updates.rows.map(m),
      defaultGroupingExpansionDepth: t.defaultGroupingExpansionDepth,
      isGroupExpandedByDefault: t.isGroupExpandedByDefault,
      groupingName: ro.DataSource,
      onDuplicatePath: b
    }) : oN({
      nodes: {
        inserted: u.updates.actions.insert.map(m),
        modified: u.updates.actions.modify.map(m),
        removed: u.updates.actions.remove
      },
      previousTree: u.previousTree,
      previousGroupsToFetch: u.previousGroupsToFetch,
      previousTreeDepth: u.previousTreeDepths,
      defaultGroupingExpansionDepth: t.defaultGroupingExpansionDepth,
      isGroupExpandedByDefault: t.isGroupExpandedByDefault,
      groupingName: ro.DataSource
    });
  }, [t.unstable_dataSource, t.defaultGroupingExpansionDepth, t.isGroupExpandedByDefault]), a = h.useCallback(() => {
    const u = Vn(e);
    return $ne(u);
  }, [e]), l = h.useCallback(() => {
    const u = Vn(e);
    return Ane(u);
  }, [e]);
  bt(e, "hydrateColumns", s), pr(e, ro.DataSource, "rowTreeCreation", i), pr(e, ro.DataSource, "filtering", a), pr(e, ro.DataSource, "sorting", l), pr(e, ro.DataSource, "visibleRowsLookupCreation", eN), ra(() => {
    n();
  });
  const c = h.useRef(!0);
  h.useEffect(() => {
    c.current ? c.current = !1 : n();
  }, [n]);
}, Gne = (e, t, n) => {
  var s;
  n.current.caches.columnPinning = {
    orderedFieldsBeforePinningColumns: null
  };
  let o;
  return t.pinnedColumns ? o = t.pinnedColumns : (s = t.initialState) != null && s.pinnedColumns ? o = t.initialState.pinnedColumns : o = {}, I({}, e, {
    pinnedColumns: o
  });
}, qne = (e, t) => {
  var v;
  const n = ge(e, fc), o = h.useCallback((g, y) => {
    const w = ws(e);
    if (!y.colIndex || w.left.length === 0 && w.right.length === 0)
      return g;
    const x = pn(e), S = xl(e), T = Os(e), E = e.current.virtualScrollerRef.current.clientWidth, O = Math.abs(e.current.virtualScrollerRef.current.scrollLeft), M = x[y.colIndex].computedWidth, D = T[y.colIndex], R = T[w.left.length], P = S - T[T.length - w.right.length], F = D + M;
    if (F - (E - P) > O) {
      const $ = F - (E - P);
      return I({}, g, {
        left: $
      });
    }
    if (D < O + R) {
      const $ = D - R;
      return I({}, g, {
        left: $
      });
    }
    return g;
  }, [e]), s = h.useCallback((g, y) => t.disableColumnPinning || y.pinnable === !1 ? g : [...g, "columnMenuPinningItem"], [t.disableColumnPinning]), i = h.useCallback((g, {
    targetIndex: y
  }) => {
    const w = ws(e);
    if (w.left.length === 0 && w.right.length === 0)
      return g;
    if (w.left.length > 0 && y < w.left.length)
      return !1;
    if (w.right.length > 0) {
      const S = pn(e).length - w.right.length;
      return y >= S ? !1 : g;
    }
    return g;
  }, [e]), a = h.useCallback((g, y) => {
    var S;
    const w = fc(e.current.state);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !y.exportOnlyDirtyModels || // Always export if the model is controlled
      t.pinnedColumns != null || // Always export if the model has been initialized
      ((S = t.initialState) == null ? void 0 : S.pinnedColumns) != null || // Export if the model is not empty
      (w.left ?? []).length > 0 || (w.right ?? []).length > 0 ? I({}, g, {
        pinnedColumns: w
      }) : g
    );
  }, [e, t.pinnedColumns, (v = t.initialState) == null ? void 0 : v.pinnedColumns]), l = h.useCallback((g, y) => {
    const w = y.stateToRestore.pinnedColumns;
    return w != null && uR(e, w), g;
  }, [e]);
  bt(e, "scrollToIndexes", o), bt(e, "columnMenu", s), bt(e, "canBeReordered", i), bt(e, "exportState", a), bt(e, "restoreState", l), e.current.registerControlState({
    stateId: "pinnedColumns",
    propModel: t.pinnedColumns,
    propOnChange: t.onPinnedColumnsChange,
    stateSelector: fc,
    changeEvent: "pinnedColumnsChange"
  });
  const c = h.useCallback((g, y) => {
    if (e.current.isColumnPinned(g) === y)
      return;
    const w = y === Ln.RIGHT ? Ln.LEFT : Ln.RIGHT, x = {
      [y]: [...n[y] || [], g],
      [w]: (n[w] || []).filter((S) => S !== g)
    };
    e.current.setPinnedColumns(x);
  }, [e, n]), u = h.useCallback((g) => {
    e.current.setPinnedColumns({
      left: (n.left || []).filter((y) => y !== g),
      right: (n.right || []).filter((y) => y !== g)
    });
  }, [e, n.left, n.right]), d = h.useCallback(() => fc(e.current.state), [e]), f = h.useCallback((g) => {
    uR(e, g), e.current.requestPipeProcessorsApplication("hydrateColumns");
  }, [e]), p = h.useCallback((g) => (n.left || []).includes(g) ? Ln.LEFT : (n.right || []).includes(g) ? Ln.RIGHT : !1, [n.left, n.right]);
  ot(e, {
    pinColumn: c,
    unpinColumn: u,
    getPinnedColumns: d,
    setPinnedColumns: f,
    isColumnPinned: p
  }, "public"), Le(e, "columnOrderChange", (g) => {
    if (!e.current.caches.columnPinning.orderedFieldsBeforePinningColumns)
      return;
    const {
      column: y,
      targetIndex: w,
      oldIndex: x
    } = g, S = w > x ? 1 : -1, E = Or(e)[w - S], O = [...e.current.caches.columnPinning.orderedFieldsBeforePinningColumns];
    let M = O.findIndex((P) => P === y.field), D = M + S;
    const R = O.findIndex((P) => P === E);
    for (; S > 0 ? M < R : M > R; ) {
      for (; e.current.isColumnPinned(O[D]); )
        D += S;
      const P = O[M];
      O[M] = O[D], O[D] = P, M = D, D = M + S;
    }
    e.current.caches.columnPinning.orderedFieldsBeforePinningColumns = O;
  }), h.useEffect(() => {
    t.pinnedColumns && e.current.setPinnedColumns(t.pinnedColumns);
  }, [e, t.pinnedColumns]);
};
function uR(e, t) {
  e.current.setState((n) => I({}, n, {
    pinnedColumns: t
  }));
}
const Wne = (e, t) => {
  const {
    disableColumnPinning: n
  } = t, o = h.useRef([]), s = h.useCallback((a) => {
    if (a.orderedFields.length === 0 || n)
      return a;
    const l = e.current.state;
    e.current.state = I({}, l, {
      columns: a
    });
    const c = ws(e);
    e.current.state = l;
    const u = c.left.map((v) => v.field), d = c.right.map((v) => v.field);
    let f;
    const p = [...u, ...d], {
      orderedFieldsBeforePinningColumns: m
    } = e.current.caches.columnPinning;
    if (m) {
      f = new Array(a.orderedFields.length).fill(null);
      const v = [...f], g = [...a.orderedFields];
      o.current.forEach((w) => {
        if (!p.includes(w) && a.lookup[w]) {
          const x = m.indexOf(w);
          f[x] = w, v[x] = w, g.splice(g.indexOf(w), 1);
        }
      }), p.forEach((w) => {
        let x = m.indexOf(w);
        if ((x === -1 || x >= v.length) && (x = a.orderedFields.indexOf(w)), v[x] !== null)
          for (x = 0; v[x] !== null; )
            x += 1;
        f[x] = w, v[x] = w, g.splice(g.indexOf(w), 1);
      });
      let y = 0;
      g.forEach((w) => {
        for (; v[y] !== null; )
          y += 1;
        v[y] = w, f[y] = w;
      }), e.current.caches.columnPinning.orderedFieldsBeforePinningColumns = v;
    } else
      f = [...a.orderedFields], e.current.caches.columnPinning.orderedFieldsBeforePinningColumns = [...a.orderedFields];
    o.current = p;
    const b = f.filter((v) => !u.includes(v) && !d.includes(v));
    return I({}, a, {
      orderedFields: [...u, ...b, ...d]
    });
  }, [e, n]);
  bt(e, "hydrateColumns", s);
  const i = h.useCallback((a, l) => e.current.isColumnPinned(l), [e]);
  bt(e, "isColumnPinned", i);
}, Une = I({}, ko, {
  type: "custom",
  field: Bo,
  editable: !1,
  sortable: !1,
  filterable: !1,
  resizable: !1,
  // @ts-ignore
  aggregable: !1,
  disableColumnMenu: !0,
  disableReorder: !0,
  disableExport: !0,
  align: "left",
  width: 40,
  valueGetter: (e, t, n, o) => {
    const s = o.current.getRowId(t);
    return Hs(o.current.state).includes(s);
  },
  renderCell: (e) => /* @__PURE__ */ C(q2, I({}, e)),
  renderHeader: ({
    colDef: e
  }) => /* @__PURE__ */ C("div", {
    "aria-label": e.headerName
  })
}), Kne = (e, t) => {
  var n, o;
  return I({}, e, {
    detailPanel: {
      heightCache: {},
      expandedRowIds: t.detailPanelExpandedRowIds ?? ((o = (n = t.initialState) == null ? void 0 : n.detailPanel) == null ? void 0 : o.expandedRowIds) ?? []
    }
  });
};
function dR(e, t, n, o) {
  if (typeof t != "function")
    return {};
  const s = Da(e), i = s.reduce((l, c) => {
    const u = e.current.getRowParams(c);
    return l[c] = t(u), l;
  }, {}), a = s.reduce((l, c) => {
    var p;
    if (i[c] == null)
      return l;
    const u = e.current.getRowParams(c), d = n(u), f = d === "auto";
    return l[c] = {
      autoHeight: f,
      height: f ? (p = o[c]) == null ? void 0 : p.height : d
    }, l;
  }, {});
  return {
    contentCache: i,
    heightCache: a
  };
}
const Yne = (e, t) => {
  const n = ge(e, Hs), o = ge(e, m0), s = h.useCallback((S, T) => {
    if (S.field !== Bo || t.getDetailPanelContent == null)
      return;
    const E = o[S.id];
    /* @__PURE__ */ h.isValidElement(E) && T.target !== T.currentTarget && e.current.toggleDetailPanel(S.id);
  }, [e, o, t.getDetailPanelContent]), i = h.useCallback((S, T) => {
    t.getDetailPanelContent != null && S.field === Bo && T.key === " " && e.current.toggleDetailPanel(S.id);
  }, [e, t.getDetailPanelContent]);
  Le(e, "cellClick", s), Le(e, "cellKeyDown", i), e.current.registerControlState({
    stateId: "detailPanels",
    propModel: t.detailPanelExpandedRowIds,
    propOnChange: t.onDetailPanelExpandedRowIdsChange,
    stateSelector: Hs,
    changeEvent: "detailPanelsExpandedRowIdsChange"
  });
  const a = h.useCallback((S) => {
    if (t.getDetailPanelContent == null)
      return;
    const T = o[S];
    if (!/* @__PURE__ */ h.isValidElement(T))
      return;
    const E = e.current.getExpandedDetailPanels();
    e.current.setExpandedDetailPanels(E.includes(S) ? E.filter((O) => O !== S) : [...E, S]);
  }, [e, o, t.getDetailPanelContent]), l = h.useCallback(() => Hs(e.current.state), [e]), c = h.useCallback((S) => {
    e.current.setState((T) => I({}, T, {
      detailPanel: I({}, T.detailPanel, {
        expandedRowIds: S
      })
    }));
  }, [e]), u = h.useCallback((S, T) => {
    const E = zy(e.current.state);
    !E[S] || E[S].height === T || (e.current.setState((O) => I({}, O, {
      detailPanel: I({}, O.detailPanel, {
        heightCache: I({}, E, {
          [S]: I({}, E[S], {
            height: T
          })
        })
      })
    })), e.current.requestPipeProcessorsApplication("rowHeight"));
  }, [e]), d = h.useCallback((S) => {
    const T = zy(e.current.state);
    return T[S] ? T[S].autoHeight : !1;
  }, [e]), f = {
    toggleDetailPanel: a,
    getExpandedDetailPanels: l,
    setExpandedDetailPanels: c
  }, p = {
    storeDetailPanelHeight: u,
    detailPanelHasAutoHeight: d
  };
  ot(e, f, "public"), ot(e, p, "private"), h.useEffect(() => {
    t.detailPanelExpandedRowIds && Hs(e.current.state) !== t.detailPanelExpandedRowIds && e.current.setExpandedDetailPanels(t.detailPanelExpandedRowIds);
  }, [e, t.detailPanelExpandedRowIds]);
  const m = h.useCallback(() => {
    t.getDetailPanelContent && (e.current.setState((S) => I({}, S, {
      detailPanel: I({}, S.detailPanel, dR(e, t.getDetailPanelContent, t.getDetailPanelHeight, S.detailPanel.heightCache))
    })), e.current.forceUpdate());
  }, [e, t.getDetailPanelContent, t.getDetailPanelHeight]);
  Le(e, "sortedRowsSet", m);
  const b = h.useRef(void 0), v = h.useRef(void 0), g = h.useCallback(() => {
    t.getDetailPanelContent === b.current && t.getDetailPanelHeight === v.current || (e.current.setState((S) => I({}, S, {
      detailPanel: I({}, S.detailPanel, dR(e, t.getDetailPanelContent, t.getDetailPanelHeight, S.detailPanel.heightCache))
    })), b.current = t.getDetailPanelContent, v.current = t.getDetailPanelHeight);
  }, [e, t.getDetailPanelContent, t.getDetailPanelHeight]), y = h.useCallback((S, T) => {
    if (!n || n.length === 0 || !n.includes(T.id))
      return S.detail = 0, S;
    g();
    const E = G2(e);
    return S.detail = E[T.id] ?? 0, S;
  }, [e, n, g]), w = t.getDetailPanelContent !== void 0;
  bt(e, "rowHeight", y, w);
  const x = h.useRef(!0);
  x.current && g(), h.useEffect(() => {
    x.current || g(), x.current = !1;
  }, [e, g]);
}, Xne = (e, t) => {
  const n = h.useCallback((s) => t.getDetailPanelContent == null ? (s.lookup[Bo] && (delete s.lookup[Bo], s.orderedFields = s.orderedFields.filter((i) => i !== Bo)), s) : (s.lookup[Bo] || (s.orderedFields = [Bo, ...s.orderedFields], s.lookup[Bo] = I({}, Une, {
    headerName: e.current.getLocaleText("detailPanelToggle")
  })), s), [e, t.getDetailPanelContent]), o = h.useCallback((s, i) => t.getDetailPanelContent == null || !Hs(e.current.state).includes(i) ? s : [...s, K["row--detailPanelExpanded"]], [e, t.getDetailPanelContent]);
  bt(e, "hydrateColumns", n), bt(e, "rowClassName", o);
}, sN = I({}, ko, {
  type: "custom",
  field: "__reorder__",
  sortable: !1,
  filterable: !1,
  width: 50,
  align: "center",
  headerAlign: "center",
  disableColumnMenu: !0,
  disableExport: !0,
  disableReorder: !0,
  resizable: !1,
  // @ts-ignore
  aggregable: !1,
  renderHeader: () => " ",
  renderCell: bne
});
var Gy = /* @__PURE__ */ function(e) {
  return e[e.UP = 0] = "UP", e[e.DOWN = 1] = "DOWN", e;
}(Gy || {});
let kg = null, Xl = {
  previousTargetId: null,
  dragDirection: null
};
const Qne = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    rowDragging: ["row--dragging"]
  }, rt, t);
}, Zne = (e, t) => {
  const n = Mn(e, "useGridRowReorder"), o = ge(e, uo), s = ge(e, Ps), i = h.useRef(null), a = h.useRef(null), l = h.useRef(void 0), c = {
    classes: t.classes
  }, u = Qne(c), [d, f] = h.useState(""), p = ge(e, CK);
  h.useEffect(() => () => {
    clearTimeout(l.current);
  }, []);
  const m = h.useMemo(() => !t.rowReordering || !!o.length || s !== 1, [t.rowReordering, o, s]), b = h.useCallback((y, w) => {
    const x = Pn(e.current.state);
    m || Object.keys(x).length !== 0 || (n.debug(`Start dragging row ${y.id}`), w.stopPropagation(), i.current = w.currentTarget, i.current.classList.add(u.rowDragging), f(y.id), l.current = setTimeout(() => {
      i.current.classList.remove(u.rowDragging);
    }), a.current = p[y.id], e.current.setCellFocus(y.id, sN.field));
  }, [e, m, n, u.rowDragging, p]), v = h.useCallback((y, w) => {
    if (d === "")
      return;
    const x = e.current.getRowNode(y.id);
    if (!x || x.type === "footer" || x.type === "pinnedRow")
      return;
    n.debug(`Dragging over row ${y.id}`), w.preventDefault(), w.stopPropagation();
    const S = kg ? kg.y - w.clientY : w.clientY;
    if (y.id !== d) {
      const T = p[y.id], O = {
        dragDirection: S > 0 ? Gy.DOWN : Gy.UP,
        previousTargetId: y.id
      }, M = O.dragDirection !== Xl.dragDirection || O.previousTargetId !== Xl.previousTargetId;
      (Xl.dragDirection === null || Math.abs(S) >= 1 && M) && (e.current.setRowIndex(d, T), Xl = O);
    }
    kg = {
      x: w.clientX,
      y: w.clientY
    };
  }, [d, e, n, p]), g = h.useCallback((y, w) => {
    const x = Pn(e.current.state);
    if (!(d === "" || m || Object.keys(x).length !== 0)) {
      if (n.debug("End dragging row"), w.preventDefault(), w.stopPropagation(), clearTimeout(l.current), i.current = null, Xl.dragDirection = null, w.dataTransfer.dropEffect === "none")
        e.current.setRowIndex(d, a.current), a.current = null;
      else {
        const S = {
          row: e.current.getRow(d),
          targetIndex: p[y.id],
          oldIndex: a.current
        };
        e.current.publishEvent("rowOrderChange", S);
      }
      f("");
    }
  }, [e, d, m, n, p]);
  Le(e, "rowDragStart", b), Le(e, "rowDragOver", v), Le(e, "rowDragEnd", g), Le(e, "cellDragOver", v), Pt(e, "rowOrderChange", t.onRowOrderChange);
}, Jne = (e) => {
  const {
    classes: t
  } = e;
  return h.useMemo(() => fe({
    rowReorderCellContainer: ["rowReorderCellContainer"],
    columnHeaderReorder: ["columnHeaderReorder"]
  }, rt, t), [t]);
}, eoe = (e, t) => {
  const n = {
    classes: t.classes
  }, o = Jne(n), s = h.useCallback((i) => {
    const a = I({}, sN, {
      cellClassName: o.rowReorderCellContainer,
      headerClassName: o.columnHeaderReorder,
      headerName: e.current.getLocaleText("rowReorderingHeaderName")
    }), l = t.rowReordering, c = i.lookup[a.field] != null;
    return l && c ? (i.lookup[a.field] = I({}, a, i.lookup[a.field]), i) : (l && !c ? (i.lookup[a.field] = a, i.orderedFields = [a.field, ...i.orderedFields]) : !l && c && (delete i.lookup[a.field], i.orderedFields = i.orderedFields.filter((u) => u !== a.field)), i);
  }, [e, o, t.rowReordering]);
  bt(e, "hydrateColumns", s);
};
function toe({
  apiRef: e,
  visibleRows: t,
  range: n
}) {
  var u, d;
  let {
    firstRowIndex: o,
    lastRowIndex: s
  } = n;
  const i = t.slice(n.firstRowIndex, n.lastRowIndex);
  let a = 0, l = i.length - 1, c = !1;
  for (; !c && o < s; ) {
    const f = ((u = e.current.getRowNode(i[a].id)) == null ? void 0 : u.type) === "skeletonRow", p = ((d = e.current.getRowNode(i[l].id)) == null ? void 0 : d.type) === "skeletonRow";
    f && p && (c = !0), f || (a += 1, o += 1), p || (l -= 1, s -= 1);
  }
  return c ? {
    firstRowIndex: o,
    lastRowIndex: s
  } : void 0;
}
const noe = (e, t) => {
  const n = ge(e, uo), o = ge(e, kn), s = h.useRef({
    firstRowToRender: 0,
    lastRowToRender: 0
  }), i = t.rowsLoadingMode !== "server", a = h.useCallback((u) => {
    if (i)
      return;
    const d = {
      firstRowToRender: u.firstRowIndex,
      lastRowToRender: u.lastRowIndex,
      sortModel: n,
      filterModel: o
    };
    if (!(s.current.firstRowToRender === u.firstRowIndex && s.current.lastRowToRender === u.lastRowIndex)) {
      if (s.current = {
        firstRowToRender: u.firstRowIndex,
        lastRowToRender: u.lastRowIndex
      }, n.length === 0 && o.items.length === 0) {
        const f = bs(e, {
          pagination: t.pagination,
          paginationMode: t.paginationMode
        }), p = toe({
          apiRef: e,
          visibleRows: f.rows,
          range: {
            firstRowIndex: u.firstRowIndex,
            lastRowIndex: u.lastRowIndex
          }
        });
        if (!p)
          return;
        d.firstRowToRender = p.firstRowIndex, d.lastRowToRender = p.lastRowIndex;
      }
      e.current.publishEvent("fetchRows", d);
    }
  }, [e, i, t.pagination, t.paginationMode, n, o]), l = h.useCallback((u) => {
    if (i)
      return;
    e.current.requestPipeProcessorsApplication("hydrateRows");
    const d = Bi(e), f = {
      firstRowToRender: d.firstRowIndex,
      lastRowToRender: d.lastRowIndex,
      sortModel: u,
      filterModel: o
    };
    e.current.publishEvent("fetchRows", f);
  }, [e, i, o]), c = h.useCallback((u) => {
    if (i)
      return;
    e.current.requestPipeProcessorsApplication("hydrateRows");
    const d = Bi(e), f = {
      firstRowToRender: d.firstRowIndex,
      lastRowToRender: d.lastRowIndex,
      sortModel: n,
      filterModel: u
    };
    e.current.publishEvent("fetchRows", f);
  }, [e, i, n]);
  Le(e, "renderedRowsIntervalChange", a), Le(e, "sortModelChange", l), Le(e, "filterModelChange", c), Pt(e, "fetchRows", t.onFetchRows);
}, ooe = "auto-generated-skeleton-row-root", roe = (e) => `${ooe}-${e}`, soe = (e, t) => {
  const n = h.useCallback((o) => {
    const s = o.tree[Dt];
    if (t.rowsLoadingMode !== "server" || !t.rowCount || s.children.length >= t.rowCount)
      return o;
    const i = I({}, o.tree), a = [...s.children];
    for (let l = 0; l < t.rowCount - s.children.length; l += 1) {
      const c = roe(l);
      a.push(c);
      const u = {
        type: "skeletonRow",
        id: c,
        parent: Dt,
        depth: 0
      };
      i[c] = u;
    }
    return i[Dt] = I({}, s, {
      children: a
    }), I({}, o, {
      tree: i
    });
  }, [t.rowCount, t.rowsLoadingMode]);
  bt(e, "hydrateRows", n);
};
function iN(e, t) {
  var o, s;
  const n = {
    topIds: [],
    bottomIds: [],
    idLookup: {}
  };
  return (o = e == null ? void 0 : e.top) == null || o.forEach((i) => {
    const a = il(i, t);
    n.topIds.push(a), n.idLookup[a] = i;
  }), (s = e == null ? void 0 : e.bottom) == null || s.forEach((i) => {
    const a = il(i, t);
    n.bottomIds.push(a), n.idLookup[a] = i;
  }), n;
}
const ioe = (e, t, n) => {
  var o;
  return n.current.caches.pinnedRows = iN(t.pinnedRows, t.getRowId), I({}, e, {
    rows: I({}, e.rows, {
      additionalRowGroups: I({}, (o = e.rows) == null ? void 0 : o.additionalRowGroups, {
        pinnedRows: {
          top: [],
          bottom: []
        }
      })
    })
  });
}, aoe = (e, t) => {
  const n = h.useCallback((s) => {
    e.current.caches.pinnedRows = iN(s, t.getRowId), e.current.requestPipeProcessorsApplication("hydrateRows");
  }, [e, t.getRowId]);
  ot(e, {
    unstable_setPinnedRows: n
  }, "public");
  const o = h.useRef(!0);
  h.useEffect(() => {
    if (o.current) {
      o.current = !1;
      return;
    }
    e.current.unstable_setPinnedRows(t.pinnedRows);
  }, [e, t.pinnedRows]);
};
function fR({
  groupingParams: e,
  rowModel: t,
  rowId: n,
  position: o,
  apiRef: s,
  isAutoGenerated: i
}) {
  var m, b, v, g;
  const a = I({}, e.dataRowIdToModelLookup), l = I({}, e.dataRowIdToIdLookup), c = I({}, e.tree), u = I({}, e.treeDepths);
  qf({
    type: "pinnedRow",
    id: n,
    depth: 0,
    parent: Dt,
    isAutoGenerated: i
  }, c, u, null), a[n] = t, l[n] = n, s.current.caches.rows.dataRowIdToModelLookup[n] = I({}, t), s.current.caches.rows.dataRowIdToIdLookup[n] = n;
  const f = ((m = e.additionalRowGroups) == null ? void 0 : m.pinnedRows) || {}, p = {
    id: n,
    model: t
  };
  return (g = (v = (b = e.additionalRowGroups) == null ? void 0 : b.pinnedRows) == null ? void 0 : v[o]) != null && g.includes(p) ? I({}, e, {
    dataRowIdToModelLookup: a,
    dataRowIdToIdLookup: l,
    tree: c,
    treeDepths: u
  }) : I({}, e, {
    dataRowIdToModelLookup: a,
    dataRowIdToIdLookup: l,
    tree: c,
    treeDepths: u,
    additionalRowGroups: I({}, e.additionalRowGroups, {
      pinnedRows: I({}, f, {
        [o]: [...f[o] || [], p]
      })
    })
  });
}
const loe = (e) => {
  const t = h.useRef(null), n = h.useCallback((o) => {
    var l, c, u, d, f, p;
    const s = e.current.caches.pinnedRows || {}, i = t.current;
    t.current = s;
    let a = I({}, o, {
      additionalRowGroups: I({}, o.additionalRowGroups, {
        // reset pinned rows state
        pinnedRows: {}
      })
    });
    if (i) {
      const m = (b) => {
        const v = a.tree[b];
        (v == null ? void 0 : v.type) === "pinnedRow" && (delete a.tree[b], delete a.dataRowIdToModelLookup[b], delete a.dataRowIdToIdLookup[b], delete e.current.caches.rows.dataRowIdToIdLookup[b], delete e.current.caches.rows.dataRowIdToModelLookup[b]);
      };
      (l = i.topIds) == null || l.forEach(m), (c = i.bottomIds) == null || c.forEach(m);
    }
    if ((u = s.topIds) == null || u.forEach((m) => {
      a = fR({
        groupingParams: a,
        rowModel: s.idLookup[m],
        rowId: m,
        position: "top",
        apiRef: e,
        isAutoGenerated: !1
      });
    }), (d = s.bottomIds) == null || d.forEach((m) => {
      a = fR({
        groupingParams: a,
        rowModel: s.idLookup[m],
        rowId: m,
        position: "bottom",
        apiRef: e,
        isAutoGenerated: !1
      });
    }), (f = s.bottomIds) != null && f.length || (p = s.topIds) != null && p.length) {
      const m = (v) => !(a.tree[v] && a.tree[v].type === "pinnedRow"), b = a.tree[Dt];
      a.tree[Dt] = I({}, b, {
        children: b.children.filter(m)
      }), a.dataRowIds = a.dataRowIds.filter(m);
    }
    return a;
  }, [e]);
  bt(e, "hydrateRows", n);
}, coe = 1 / 0, Dg = (e, t) => () => {
  e === "server" && t();
};
let gc = /* @__PURE__ */ function(e) {
  return e[e.QUEUED = 0] = "QUEUED", e[e.PENDING = 1] = "PENDING", e[e.SETTLED = 2] = "SETTLED", e[e.UNKNOWN = 3] = "UNKNOWN", e;
}({});
class uoe {
  constructor(t, n = coe) {
    this.pendingRequests = /* @__PURE__ */ new Set(), this.queuedRequests = /* @__PURE__ */ new Set(), this.settledRequests = /* @__PURE__ */ new Set(), this.api = void 0, this.maxConcurrentRequests = void 0, this.processQueue = async () => {
      if (this.queuedRequests.size === 0 || this.pendingRequests.size >= this.maxConcurrentRequests)
        return;
      const o = Math.min(this.maxConcurrentRequests - this.pendingRequests.size, this.queuedRequests.size);
      if (o === 0)
        return;
      const s = Array.from(this.queuedRequests);
      for (let i = 0; i < o; i += 1) {
        const a = s[i];
        this.queuedRequests.delete(a), this.pendingRequests.add(a), this.api.fetchRowChildren(a);
      }
    }, this.queue = async (o) => {
      const s = {};
      o.forEach((i) => {
        this.queuedRequests.add(i), s[i] = !0;
      }), this.api.setState((i) => I({}, i, {
        dataSource: I({}, i.dataSource, {
          loading: I({}, i.dataSource.loading, s)
        })
      })), this.processQueue();
    }, this.setRequestSettled = (o) => {
      this.pendingRequests.delete(o), this.settledRequests.add(o), this.processQueue();
    }, this.clear = () => {
      this.queuedRequests.clear(), Array.from(this.pendingRequests).forEach((o) => this.clearPendingRequest(o));
    }, this.clearPendingRequest = (o) => {
      this.api.unstable_dataSource.setChildrenLoading(o, !1), this.pendingRequests.delete(o), this.processQueue();
    }, this.getRequestStatus = (o) => this.pendingRequests.has(o) ? gc.PENDING : this.queuedRequests.has(o) ? gc.QUEUED : this.settledRequests.has(o) ? gc.SETTLED : gc.UNKNOWN, this.getActiveRequestsCount = () => this.pendingRequests.size + this.queuedRequests.size, this.api = t.current, this.maxConcurrentRequests = n;
  }
}
function pR(e) {
  return JSON.stringify([e.paginationModel, e.filterModel, e.sortModel, e.groupKeys, e.groupFields]);
}
class doe {
  constructor({
    ttl: t = 3e5
  }) {
    this.cache = void 0, this.ttl = void 0, this.cache = {}, this.ttl = t;
  }
  set(t, n) {
    const o = pR(t), s = Date.now() + this.ttl;
    this.cache[o] = {
      value: n,
      expiry: s
    };
  }
  get(t) {
    const n = pR(t), o = this.cache[n];
    if (o) {
      if (Date.now() > o.expiry) {
        delete this.cache[n];
        return;
      }
      return o.value;
    }
  }
  clear() {
    this.cache = {};
  }
}
const qy = {
  loading: {},
  errors: {}
}, foe = {
  clear: () => {
  },
  get: () => {
  },
  set: () => {
  }
};
function hR(e) {
  return e === null ? foe : e ?? new doe({});
}
const poe = (e) => I({}, e, {
  dataSource: qy
}), hoe = (e, t) => {
  var y, w;
  const n = Jo(() => new uoe(e)).current, o = ge(e, Lk), s = h.useRef(0), i = t.unstable_onDataSourceError, [a, l] = h.useState(() => hR(t.unstable_dataSourceCache)), c = h.useCallback(async (x) => {
    var D;
    const S = (D = t.unstable_dataSource) == null ? void 0 : D.getRows;
    if (!S)
      return;
    if (x) {
      n.queue([x]);
      return;
    }
    n.clear(), s.current = 0, e.current.state.dataSource !== qy && e.current.resetDataSourceState();
    const E = I({}, cR(e), e.current.unstable_applyPipeProcessors("getRowsParams", {})), O = e.current.unstable_dataSource.cache.get(E);
    if (O !== void 0) {
      const R = O.rows;
      e.current.setRows(R), O.rowCount !== void 0 && e.current.setRowCount(O.rowCount);
      return;
    }
    Fk(e) || e.current.setLoading(!0);
    try {
      const R = await S(E);
      e.current.unstable_dataSource.cache.set(E, R), R.rowCount !== void 0 && e.current.setRowCount(R.rowCount), e.current.setRows(R.rows), e.current.setLoading(!1);
    } catch (R) {
      e.current.setRows([]), e.current.setLoading(!1), i == null || i(R, E);
    }
  }, [n, e, (y = t.unstable_dataSource) == null ? void 0 : y.getRows, i]), u = h.useCallback(async (x) => {
    var R, P;
    const S = e.current.unstable_applyPipeProcessors("getRowsParams", {});
    if (!t.treeData && (((R = S.groupFields) == null ? void 0 : R.length) ?? 0) === 0) {
      n.clearPendingRequest(x);
      return;
    }
    const T = (P = t.unstable_dataSource) == null ? void 0 : P.getRows;
    if (!T) {
      n.clearPendingRequest(x);
      return;
    }
    const E = e.current.getRowNode(x);
    if (!E) {
      n.clearPendingRequest(x);
      return;
    }
    const O = I({}, cR(e), S, {
      groupKeys: E.path
    }), M = e.current.unstable_dataSource.cache.get(O);
    if (M !== void 0) {
      const F = M.rows;
      n.setRequestSettled(x), e.current.updateServerRows(F, E.path), M.rowCount && e.current.setRowCount(M.rowCount), e.current.setRowChildrenExpansion(x, !0), e.current.unstable_dataSource.setChildrenLoading(x, !1);
      return;
    }
    (_ne(e)[x] ?? null) && e.current.unstable_dataSource.setChildrenFetchError(x, null);
    try {
      const F = await T(O);
      if (!e.current.getRowNode(x)) {
        n.clearPendingRequest(x);
        return;
      }
      if (n.getRequestStatus(x) === gc.UNKNOWN) {
        e.current.unstable_dataSource.setChildrenLoading(x, !1);
        return;
      }
      n.setRequestSettled(x), e.current.unstable_dataSource.cache.set(O, F), F.rowCount && e.current.setRowCount(F.rowCount), e.current.updateServerRows(F.rows, E.path), e.current.setRowChildrenExpansion(x, !0);
    } catch (F) {
      const $ = F;
      e.current.unstable_dataSource.setChildrenFetchError(x, $), i == null || i($, O);
    } finally {
      e.current.unstable_dataSource.setChildrenLoading(x, !1), n.setRequestSettled(x);
    }
  }, [n, i, e, t.treeData, (w = t.unstable_dataSource) == null ? void 0 : w.getRows]), d = h.useCallback((x, S) => {
    e.current.setState((T) => {
      if (!T.dataSource.loading[x] && S === !1)
        return T;
      const E = I({}, T.dataSource.loading);
      return S === !1 ? delete E[x] : E[x] = S, I({}, T, {
        dataSource: I({}, T.dataSource, {
          loading: E
        })
      });
    });
  }, [e]), f = h.useCallback((x, S) => {
    e.current.setState((T) => {
      const E = I({}, T.dataSource.errors);
      return S === null && E[x] !== void 0 ? delete E[x] : E[x] = S, I({}, T, {
        dataSource: I({}, T.dataSource, {
          errors: E
        })
      });
    });
  }, [e]), p = h.useCallback(() => {
    e.current.setState((x) => I({}, x, {
      dataSource: qy
    }));
  }, [e]), m = h.useMemo(() => Yi(c, 0), [c]), b = {
    unstable_dataSource: {
      setChildrenLoading: d,
      setChildrenFetchError: f,
      fetchRows: c,
      cache: a
    }
  }, v = {
    fetchRowChildren: u,
    resetDataSourceState: p
  };
  ot(e, b, "public"), ot(e, v, "private"), Le(e, "sortModelChange", Dg(t.sortingMode, m)), Le(e, "filterModelChange", Dg(t.filterMode, m)), Le(e, "paginationModelChange", Dg(t.paginationMode, m));
  const g = h.useRef(!0);
  h.useEffect(() => {
    if (g.current) {
      g.current = !1;
      return;
    }
    const x = hR(t.unstable_dataSourceCache);
    l((S) => S !== x ? x : S);
  }, [t.unstable_dataSourceCache]), h.useEffect(() => {
    t.unstable_dataSource && (e.current.unstable_dataSource.cache.clear(), e.current.unstable_dataSource.fetchRows());
  }, [e, t.unstable_dataSource]), h.useEffect(() => {
    if (o && o.length && s.current < o.length) {
      const x = o.slice(s.current);
      n.queue(x), s.current = o.length;
    }
  }, [e, n, o]);
}, goe = (e, t) => {
  const n = iee(e, t);
  return ote(n, t), eoe(n, t), Nne(n, t), jne(n, t), soe(n, t), loe(n), Xne(n, t), Wne(n, t), Zee(n), wn(tne, n, t), wn(ete, n, t), wn(Kne, n, t), wn(Gne, n, t), wn(hee, n, t), wn(ioe, n, t), wn(Aee, n, t), wn(Uee, n, t), wn(qee, n, t), wn(Oee, n, t), wn(rte, n, t), wn(Lee, n, t), wn(Tee, n, t), wn($te, n, t), wn(mee, n, t), wn(cne, n, t), wn(Pte, n, t), wn(fee, n, t), wn(Cte, n, t), wn(qY, n, t), wn(poe, n, t), wn(ute, n, t), wn(hte, n, t), wn(Fte, n, t), nne(n, t), dne(n, t), Dee(n, t), tte(n, t), qne(n, t), aoe(n, t), gee(n, t), Kee(n, t), Ate(n, t), Jee(n, t), Yne(n, t), bte(n), wte(n, t), Wee(n, t), Pee(n, t), _ee(n, t), Iee(n, t), ste(n, t), bee(n, t), une(n, t), kte(n, t), Fee(n, t), gte(n, t), Zne(n, t), ite(n, t), rne(n, t), noe(n, t), pee(n), vee(n, t), xee(n, t), dee(n, t), dte(n, t), ate(n, t), mte(n), WY(n, t), hoe(n, t), Lte(n, t), n;
}, moe = I({}, s2, {
  columnMenuPinningItem: j2
}), boe = I({}, i2, {
  columnMenuPinningItem: {
    displayOrder: 15
  }
}), yoe = Ct(function(t, n) {
  return /* @__PURE__ */ C(c0, I({}, t, {
    defaultSlots: moe,
    defaultSlotProps: boe,
    ref: n
  }));
}), voe = ["getColumnsToRender", "getPinnedCellOffset", "renderContext", "leftRenderContext", "rightRenderContext", "pinnedColumns", "visibleColumns", "columnPositions"], Coe = (e) => {
  const {
    classes: t
  } = e;
  return h.useMemo(() => fe({
    headerFilterRow: ["headerFilterRow"]
  }, rt, t), [t]);
}, gR = /* @__PURE__ */ Object.create(null), woe = (e) => {
  const t = eo(), {
    headerGroupingMaxDepth: n,
    hasOtherElementInTabSequence: o
  } = e, s = ge(t, VK), i = F2(I({}, e, {
    hasOtherElementInTabSequence: o || s !== null
  })), {
    getColumnsToRender: a,
    getPinnedCellOffset: l,
    renderContext: c,
    leftRenderContext: u,
    rightRenderContext: d,
    pinnedColumns: f,
    visibleColumns: p,
    columnPositions: m
  } = i, b = ve(i, voe), v = h.useRef(null);
  t.current.register("private", {
    headerFiltersElementRef: v
  });
  const g = h.useRef(null), y = Fo(), w = Coe(y), x = !y.headerFilters, S = ge(t, kn), T = ge(t, xl), E = ge(t, VC), O = ge(t, aU), M = ge(t, BC), D = ge(t, _K), R = h.useCallback(($) => {
    const N = S == null ? void 0 : S.items.find((L) => L.field === $.field && L.operator !== "isAnyOf");
    if (N != null)
      return N;
    const A = gR[$.field];
    if (A != null)
      return A;
    const k = Ny($);
    return gR[$.field] = k, k;
  }, [S]), P = ($) => {
    var L;
    const {
      renderedColumns: N,
      firstColumnToRender: A
    } = a($), k = [];
    for (let B = 0; B < N.length; B += 1) {
      const V = N[B], _ = A + B, z = (D == null ? void 0 : D.field) === V.field, j = _ === 0, J = (s == null ? void 0 : s.field) === V.field || j && !e.hasOtherElementInTabSequence ? 0 : -1, G = typeof V.headerClassName == "function" ? V.headerClassName({
        field: V.field,
        colDef: V
      }) : V.headerClassName, q = R(V), Z = $ == null ? void 0 : $.position, Y = l(Z, V.computedWidth, _, m, T, M), Q = B, ee = N.length, ne = eu(Z, Q), H = Jc(Z, Q, ee, y.showCellVerticalBorder, E);
      k.push(/* @__PURE__ */ C(y.slots.headerFilterCell, I({
        colIndex: _,
        height: O,
        width: V.computedWidth,
        colDef: V,
        hasFocus: z,
        tabIndex: J,
        headerFilterMenuRef: g,
        headerClassName: G,
        "data-field": V.field,
        item: q,
        pinnedPosition: Z,
        pinnedOffset: Y,
        showLeftBorder: ne,
        showRightBorder: H
      }, (L = y.slotProps) == null ? void 0 : L.headerFilterCell), `${V.field}-filter`));
    }
    return b.getFillers($, k, 0, !0);
  };
  return I({}, b, {
    getColumnFiltersRow: () => x ? null : /* @__PURE__ */ ie(By, {
      ref: v,
      className: w.headerFilterRow,
      role: "row",
      "aria-rowindex": n + 2,
      ownerState: y,
      children: [u && P({
        position: ut.LEFT,
        renderContext: u,
        maxLastColumn: u.lastColumnIndex
      }), P({
        renderContext: c,
        maxLastColumn: p.length - f.right.length
      }), d && P({
        position: ut.RIGHT,
        renderContext: d,
        maxLastColumn: d.lastColumnIndex
      })]
    })
  });
}, Soe = ["style", "className", "visibleColumns", "sortColumnLookup", "filterColumnLookup", "columnHeaderTabIndexState", "columnGroupHeaderTabIndexState", "columnHeaderFocus", "columnGroupHeaderFocus", "headerGroupingMaxDepth", "columnMenuState", "columnVisibility", "columnGroupsHeaderStructure", "hasOtherElementInTabSequence"], xoe = te("div")({
  flex: 1,
  backgroundColor: "var(--DataGrid-containerBackground)"
}), aN = Ct(function(t, n) {
  const {
    className: o,
    visibleColumns: s,
    sortColumnLookup: i,
    filterColumnLookup: a,
    columnHeaderTabIndexState: l,
    columnGroupHeaderTabIndexState: c,
    columnHeaderFocus: u,
    columnGroupHeaderFocus: d,
    headerGroupingMaxDepth: f,
    columnMenuState: p,
    columnVisibility: m,
    columnGroupsHeaderStructure: b,
    hasOtherElementInTabSequence: v
  } = t, g = ve(t, Soe), {
    getInnerProps: y,
    getColumnHeadersRow: w,
    getColumnFiltersRow: x,
    getColumnGroupHeadersRows: S
  } = woe({
    visibleColumns: s,
    sortColumnLookup: i,
    filterColumnLookup: a,
    columnHeaderTabIndexState: l,
    hasOtherElementInTabSequence: v,
    columnGroupHeaderTabIndexState: c,
    columnHeaderFocus: u,
    columnGroupHeaderFocus: d,
    headerGroupingMaxDepth: f,
    columnMenuState: p,
    columnVisibility: m,
    columnGroupsHeaderStructure: b
  });
  return /* @__PURE__ */ ie(L2, I({
    className: o
  }, g, y(), {
    ref: n,
    children: [S(), w(), x(), /* @__PURE__ */ C(xoe, {})]
  }));
});
process.env.NODE_ENV !== "production" && (aN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  columnGroupHeaderFocus: r.shape({
    depth: r.number.isRequired,
    field: r.string.isRequired
  }),
  columnGroupHeaderTabIndexState: r.shape({
    depth: r.number.isRequired,
    field: r.string.isRequired
  }),
  columnGroupsHeaderStructure: r.arrayOf(r.arrayOf(r.shape({
    columnFields: r.arrayOf(r.string).isRequired,
    groupId: r.string
  }))).isRequired,
  columnHeaderFocus: r.shape({
    field: r.string.isRequired
  }),
  columnHeaderTabIndexState: r.shape({
    field: r.string.isRequired
  }),
  columnMenuState: r.shape({
    field: r.string,
    open: r.bool.isRequired
  }).isRequired,
  columnVisibility: r.object.isRequired,
  filterColumnLookup: r.object.isRequired,
  hasOtherElementInTabSequence: r.bool.isRequired,
  headerGroupingMaxDepth: r.number.isRequired,
  sortColumnLookup: r.object.isRequired,
  visibleColumns: r.arrayOf(r.object).isRequired
});
const Toe = process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test", Roe = () => {
};
function Eoe(e, t, n) {
  const o = h.useRef(null);
  o.current = t, yt(() => {
    if (n === !1 || typeof ResizeObserver > "u")
      return Roe;
    let s = 0;
    const i = e.current, a = new ResizeObserver((l) => {
      Toe ? s = requestAnimationFrame(() => {
        o.current(l);
      }) : o.current(l);
    });
    return i && a.observe(i), () => {
      s && cancelAnimationFrame(s), a.disconnect();
    };
  }, [e, n]);
}
const Ioe = te("div", {
  name: "MuiDataGrid",
  slot: "DetailPanel",
  overridesResolver: (e, t) => t.detailPanel
})(({
  theme: e
}) => ({
  width: "calc(var(--DataGrid-rowWidth) - var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))",
  backgroundColor: (e.vars || e).palette.background.default,
  overflow: "auto"
}));
function Ooe(e) {
  const {
    rowId: t,
    height: n,
    className: o,
    children: s
  } = e, i = Vu(), a = h.useRef(null), c = Fo(), u = n === "auto";
  return h.useLayoutEffect(() => {
    u && typeof ResizeObserver > "u" && i.current.storeDetailPanelHeight(t, a.current.clientHeight);
  }, [i, u, t]), Eoe(a, (d) => {
    const [f] = d, p = f.borderBoxSize && f.borderBoxSize.length > 0 ? f.borderBoxSize[0].blockSize : f.contentRect.height;
    i.current.storeDetailPanelHeight(t, p);
  }, u), /* @__PURE__ */ C(Ioe, {
    ref: a,
    ownerState: c,
    role: "presentation",
    style: {
      height: n
    },
    className: o,
    children: s
  });
}
const Poe = () => fe({
  detailPanel: ["detailPanel"]
}, rt, {});
function Moe(e) {
  return Fo().getDetailPanelContent ? /* @__PURE__ */ h.createElement(koe, e) : null;
}
function koe({
  virtualScroller: e
}) {
  const t = Vu(), n = Poe(), {
    setPanels: o
  } = e, s = ge(t, Hs), i = ge(t, m0), a = ge(t, G2), l = h.useCallback((c) => {
    const u = i[c], f = t.current.getRowIndexRelativeToVisibleRows(c) !== void 0;
    if (!/* @__PURE__ */ h.isValidElement(u) || !f)
      return null;
    const m = t.current.detailPanelHasAutoHeight(c) ? "auto" : a[c];
    return /* @__PURE__ */ C(Ooe, {
      rowId: c,
      height: m,
      className: n.detailPanel,
      children: u
    }, `panel-${c}`);
  }, [t, n.detailPanel, a, i]);
  return h.useEffect(() => {
    s.length === 0 ? o(xD) : o(new Map(s.map((c) => [c, l(c)])));
  }, [s, o, l]), null;
}
const Doe = () => fe({
  root: ["pinnedRows"]
}, rt, {});
function Noe({
  position: e,
  virtualScroller: t
}) {
  const n = Doe(), o = eo(), i = ge(o, oa)[e], a = h.useMemo(() => ({
    firstRowIndex: 0,
    lastRowIndex: i.length,
    firstColumnIndex: -1,
    lastColumnIndex: -1
  }), [i]);
  if (i.length === 0)
    return null;
  const l = t.getRows({
    position: e,
    rows: i,
    renderContext: a
  });
  return /* @__PURE__ */ C("div", {
    className: ae(n.root, K[`pinnedRows--${e}`]),
    role: "presentation",
    children: l
  });
}
const $oe = {
  columnMenuPinRightIcon: yne,
  columnMenuPinLeftIcon: vne
}, Aoe = I({}, $oe), Foe = I({}, ene, Aoe, {
  columnMenu: yoe,
  columnHeaders: aN,
  detailPanels: Moe,
  headerFilterCell: One,
  headerFilterMenu: Y2,
  pinnedRows: Noe
}), Loe = (e) => I({
  signature: "DataGridPro"
}, e.unstable_dataSource ? {
  filterMode: "server",
  sortingMode: "server",
  paginationMode: "server"
} : {}), _oe = I({}, M2, {
  autosizeOnMount: !1,
  defaultGroupingExpansionDepth: 0,
  disableAutosize: !1,
  disableChildrenFiltering: !1,
  disableChildrenSorting: !1,
  disableColumnPinning: !1,
  getDetailPanelHeight: () => 500,
  headerFilters: !1,
  keepColumnPositionIfDraggedOutside: !1,
  rowSelectionPropagation: MK,
  rowReordering: !1,
  rowsLoadingMode: "client",
  scrollEndThreshold: 80,
  treeData: !1,
  unstable_listView: !1
}), Voe = Foe, Boe = (e) => {
  const t = WX(
    // eslint-disable-next-line material-ui/mui-name-matches-component-name
    Et({
      props: e,
      name: "MuiDataGrid"
    })
  ), n = h.useMemo(() => I({}, uU, t.localeText), [t.localeText]), o = h.useMemo(() => GX({
    defaultSlots: Voe,
    slots: t.slots
  }), [t.slots]);
  return h.useMemo(() => I({}, _oe, t, {
    localeText: n,
    slots: o
  }, Loe(t)), [t, n, o]);
}, zoe = () => {
  const e = "MTczODg4MjgwMDAwMA==";
  return process.env.NODE_ENV, e;
}, Hoe = [...UX, (e) => e.pagination && e.hideFooterRowCount && "MUI X: The `hideFooterRowCount` prop has no effect when the pagination is enabled." || void 0, (e) => e.treeData && e.filterMode === "server" && !e.unstable_dataSource && 'MUI X: The `filterMode="server"` prop is not available when the `treeData` is enabled.' || void 0, (e) => !e.pagination && e.checkboxSelectionVisibleOnly && "MUI X: The `checkboxSelectionVisibleOnly` prop has no effect when the pagination is not enabled." || void 0, (e) => e.signature !== Mo.DataGrid && e.paginationMode === "client" && e.rowsLoadingMode !== "server" && GC(e.rowCount) && 'MUI X: Usage of the `rowCount` prop with client side pagination (`paginationMode="client"`) has no effect. `rowCount` is only meant to be used with `paginationMode="server"`.' || void 0], joe = () => {
  const e = GJ(), n = Fo().treeData ? {
    role: "treegrid"
  } : {};
  return I({}, e, n);
}, Goe = (e) => {
  const t = Vu(), n = Fo(), o = qJ(), s = ge(t, Wp), i = ge(t, SK), a = ge(t, TK);
  return h.useCallback((l, c) => {
    const u = o(l, c);
    if (l === null || !(n.treeData || e) || l.type === "footer" || l.type === "pinnedRow")
      return u;
    u["aria-level"] = l.depth + 1;
    const d = i[l.id] ?? 0;
    return l.type === "group" && d > 0 && (u["aria-expanded"] = !!l.childrenExpanded), l.parent !== null && (u["aria-setsize"] = l.parent === Dt ? s : i[l.parent], u["aria-posinset"] = a[l.id]), u;
  }, [n.treeData, e, s, i, a, o]);
}, qoe = {
  hooks: {
    useGridAriaAttributes: joe,
    useGridRowAriaAttributes: Goe
  }
}, lN = zoe(), Woe = /* @__PURE__ */ C(pk, {
  packageName: "x-data-grid-pro",
  releaseInfo: lN
}), cN = Ct(function(t, n) {
  var i;
  const o = Boe(t), s = goe(o.apiRef, o);
  return Mu("x-data-grid-pro", lN), process.env.NODE_ENV !== "production" && KX(o, Hoe), /* @__PURE__ */ C(HJ, {
    privateApiRef: s,
    configuration: qoe,
    props: o,
    children: /* @__PURE__ */ C(xQ, I({
      className: o.className,
      style: o.style,
      sx: o.sx
    }, o.forwardedProps, (i = o.slotProps) == null ? void 0 : i.root, {
      ref: n,
      children: Woe
    }))
  });
}), Uoe = /* @__PURE__ */ h.memo(cN);
cN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The ref object that allows grid manipulation. Can be instantiated with `useGridApiRef()`.
   */
  apiRef: r.shape({
    current: r.object.isRequired
  }),
  /**
   * The label of the Data Grid.
   */
  "aria-label": r.string,
  /**
   * The id of the element containing a label for the Data Grid.
   */
  "aria-labelledby": r.string,
  /**
   * If `true`, the Data Grid height is dynamic and follows the number of rows in the Data Grid.
   * @default false
   * @deprecated Use flex parent container instead: https://mui.com/x/react-data-grid/layout/#flex-parent-container
   * @example
   * <div style={{ display: 'flex', flexDirection: 'column' }}>
   *   <DataGrid />
   * </div>
   */
  autoHeight: r.bool,
  /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */
  autoPageSize: r.bool,
  /**
   * If `true`, columns are autosized after the datagrid is mounted.
   * @default false
   */
  autosizeOnMount: r.bool,
  /**
   * The options for autosize when user-initiated.
   */
  autosizeOptions: r.shape({
    columns: r.arrayOf(r.string),
    disableColumnVirtualization: r.bool,
    expand: r.bool,
    includeHeaders: r.bool,
    includeOutliers: r.bool,
    outliersFactor: r.number
  }),
  /**
   * Controls the modes of the cells.
   */
  cellModesModel: r.object,
  /**
   * If `true`, the Data Grid will display an extra column with checkboxes for selecting rows.
   * @default false
   */
  checkboxSelection: r.bool,
  /**
   * If `true`, the "Select All" header checkbox selects only the rows on the current page. To be used in combination with `checkboxSelection`.
   * It only works if the pagination is enabled.
   * @default false
   */
  checkboxSelectionVisibleOnly: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */
  clipboardCopyCellDelimiter: r.string,
  /**
   * Column region in pixels to render before/after the viewport
   * @default 150
   */
  columnBufferPx: r.number,
  /**
   * Sets the height in pixels of the column group headers in the Data Grid.
   * Inherits the `columnHeaderHeight` value if not set.
   */
  columnGroupHeaderHeight: r.number,
  columnGroupingModel: r.arrayOf(r.object),
  /**
   * Sets the height in pixel of the column headers in the Data Grid.
   * @default 56
   */
  columnHeaderHeight: r.number,
  /**
   * Set of columns of type [[GridColDef]][].
   */
  columns: r.arrayOf(r.object).isRequired,
  /**
   * Set the column visibility model of the Data Grid.
   * If defined, the Data Grid will ignore the `hide` property in [[GridColDef]].
   */
  columnVisibilityModel: r.object,
  /**
   * If above 0, the row children will be expanded up to this depth.
   * If equal to -1, all the row children will be expanded.
   * @default 0
   */
  defaultGroupingExpansionDepth: r.number,
  /**
   * Set the density of the Data Grid.
   * @default "standard"
   */
  density: r.oneOf(["comfortable", "compact", "standard"]),
  /**
   * The row ids to show the detail panel.
   */
  detailPanelExpandedRowIds: r.arrayOf(r.oneOfType([r.number, r.string]).isRequired),
  /**
   * If `true`, column autosizing on header separator double-click is disabled.
   * @default false
   */
  disableAutosize: r.bool,
  /**
   * If `true`, the filtering will only be applied to the top level rows when grouping rows with the `treeData` prop.
   * @default false
   */
  disableChildrenFiltering: r.bool,
  /**
   * If `true`, the sorting will only be applied to the top level rows when grouping rows with the `treeData` prop.
   * @default false
   */
  disableChildrenSorting: r.bool,
  /**
   * If `true`, column filters are disabled.
   * @default false
   */
  disableColumnFilter: r.bool,
  /**
   * If `true`, the column menu is disabled.
   * @default false
   */
  disableColumnMenu: r.bool,
  /**
   * If `true`, the column pinning is disabled.
   * @default false
   */
  disableColumnPinning: r.bool,
  /**
   * If `true`, reordering columns is disabled.
   * @default false
   */
  disableColumnReorder: r.bool,
  /**
   * If `true`, resizing columns is disabled.
   * @default false
   */
  disableColumnResize: r.bool,
  /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */
  disableColumnSelector: r.bool,
  /**
   * If `true`, the column sorting feature will be disabled.
   * @default false
   */
  disableColumnSorting: r.bool,
  /**
   * If `true`, the density selector is disabled.
   * @default false
   */
  disableDensitySelector: r.bool,
  /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   */
  disableEval: r.bool,
  /**
   * If `true`, filtering with multiple columns is disabled.
   * @default false
   */
  disableMultipleColumnsFiltering: r.bool,
  /**
   * If `true`, the sorting with multiple columns is disabled.
   * @default false
   */
  disableMultipleColumnsSorting: r.bool,
  /**
   * If `true`, multiple selection using the Ctrl/CMD or Shift key is disabled.
   * The MIT DataGrid will ignore this prop, unless `checkboxSelection` is enabled.
   * @default false (`!props.checkboxSelection` for MIT Data Grid)
   */
  disableMultipleRowSelection: r.bool,
  /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */
  disableRowSelectionOnClick: r.bool,
  /**
   * If `true`, the virtualization is disabled.
   * @default false
   */
  disableVirtualization: r.bool,
  /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */
  editMode: r.oneOf(["cell", "row"]),
  /**
   * Use if the actual rowCount is not known upfront, but an estimation is available.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Applicable only with `paginationMode="server"` and when `rowCount="-1"`
   */
  estimatedRowCount: r.number,
  /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */
  experimentalFeatures: r.shape({
    warnIfFocusStateIsNotSynced: r.bool
  }),
  /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */
  filterDebounceMs: r.number,
  /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */
  filterMode: r.oneOf(["client", "server"]),
  /**
   * Set the filter model of the Data Grid.
   */
  filterModel: r.shape({
    items: r.arrayOf(r.shape({
      field: r.string.isRequired,
      id: r.oneOfType([r.number, r.string]),
      operator: r.string.isRequired,
      value: r.any
    })).isRequired,
    logicOperator: r.oneOf(["and", "or"]),
    quickFilterExcludeHiddenColumns: r.bool,
    quickFilterLogicOperator: r.oneOf(["and", "or"]),
    quickFilterValues: r.array
  }),
  /**
   * Forwarded props for the Data Grid root element.
   * @ignore - do not document.
   */
  forwardedProps: r.object,
  /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */
  getCellClassName: r.func,
  /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */
  getDetailPanelContent: r.func,
  /**
   * Function that returns the height of the row detail panel.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {number | string} The height in pixels or "auto" to use the content height.
   * @default "() => 500"
   */
  getDetailPanelHeight: r.func,
  /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */
  getEstimatedRowHeight: r.func,
  /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */
  getRowClassName: r.func,
  /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */
  getRowHeight: r.func,
  /**
   * Return the id of a given [[GridRowModel]].
   */
  getRowId: r.func,
  /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */
  getRowSpacing: r.func,
  /**
   * Determines the path of a row in the tree data.
   * For instance, a row with the path ["A", "B"] is the child of the row with the path ["A"].
   * Note that all paths must contain at least one element.
   * @template R
   * @param {R} row The row from which we want the path.
   * @returns {string[]} The path to the row.
   */
  getTreeDataPath: r.func,
  /**
   * The grouping column used by the tree data.
   */
  groupingColDef: r.oneOfType([r.func, r.object]),
  /**
   * Override the height of the header filters.
   */
  headerFilterHeight: r.number,
  /**
   * If `true`, the header filters feature is enabled.
   * @default false
   */
  headerFilters: r.bool,
  /**
   * If `true`, the footer component is hidden.
   * @default false
   */
  hideFooter: r.bool,
  /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */
  hideFooterPagination: r.bool,
  /**
   * If `true`, the row count in the footer is hidden.
   * It has no effect if the pagination is enabled.
   * @default false
   */
  hideFooterRowCount: r.bool,
  /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */
  hideFooterSelectedRowCount: r.bool,
  /**
   * If `true`, the diacritics (accents) are ignored when filtering or quick filtering.
   * E.g. when filter value is `cafe`, the rows with `café` will be visible.
   * @default false
   */
  ignoreDiacritics: r.bool,
  /**
   * If `true`, the Data Grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default false
   */
  ignoreValueFormatterDuringExport: r.oneOfType([r.shape({
    clipboardExport: r.bool,
    csvExport: r.bool
  }), r.bool]),
  /**
   * If `select`, a group header checkbox in indeterminate state (like "Select All" checkbox)
   * will select all the rows under it.
   * If `deselect`, it will deselect all the rows under it.
   * Works only if `checkboxSelection` is enabled.
   * @default "deselect"
   * @deprecated `select` will be the default behavior from v8 onwards
   */
  indeterminateCheckboxAction: r.oneOf(["deselect", "select"]),
  /**
   * The initial state of the DataGridPro.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */
  initialState: r.object,
  /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */
  isCellEditable: r.func,
  /**
   * Determines if a group should be expanded after its creation.
   * This prop takes priority over the `defaultGroupingExpansionDepth` prop.
   * @param {GridGroupNode} node The node of the group to test.
   * @returns {boolean} A boolean indicating if the group is expanded.
   */
  isGroupExpandedByDefault: r.func,
  /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the row is selectable.
   */
  isRowSelectable: r.func,
  /**
   * If `true`, moving the mouse pointer outside the grid before releasing the mouse button
   * in a column re-order action will not cause the column to jump back to its original position.
   * @default false
   */
  keepColumnPositionIfDraggedOutside: r.bool,
  /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */
  keepNonExistentRowsSelected: r.bool,
  /**
   * If `true`, a loading overlay is displayed.
   * @default false
   */
  loading: r.bool,
  /**
   * Set the locale text of the Data Grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */
  localeText: r.object,
  /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */
  logger: r.shape({
    debug: r.func.isRequired,
    error: r.func.isRequired,
    info: r.func.isRequired,
    warn: r.func.isRequired
  }),
  /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */
  logLevel: r.oneOf(["debug", "error", "info", "warn", !1]),
  /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */
  nonce: r.string,
  /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellClick: r.func,
  /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellDoubleClick: r.func,
  /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */
  onCellEditStart: r.func,
  /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */
  onCellEditStop: r.func,
  /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellKeyDown: r.func,
  /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellModesModelChange: r.func,
  /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */
  onClipboardCopy: r.func,
  /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderClick: r.func,
  /**
   * Callback fired when a contextmenu event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   */
  onColumnHeaderContextMenu: r.func,
  /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderDoubleClick: r.func,
  /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderEnter: r.func,
  /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderLeave: r.func,
  /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderOut: r.func,
  /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderOver: r.func,
  /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnOrderChange: r.func,
  /**
   * Callback fired while a column is being resized.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnResize: r.func,
  /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnVisibilityModelChange: r.func,
  /**
   * Callback fired when the width of a column is changed.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnWidthChange: r.func,
  /**
   * Callback fired when the density changes.
   * @param {GridDensity} density New density value.
   */
  onDensityChange: r.func,
  /**
   * Callback fired when the detail panel of a row is opened or closed.
   * @param {GridRowId[]} ids The ids of the rows which have the detail panel open.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onDetailPanelExpandedRowIdsChange: r.func,
  /**
   * Callback fired when rowCount is set and the next batch of virtualized rows is rendered.
   * @param {GridFetchRowsParams} params With all properties from [[GridFetchRowsParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onFetchRows: r.func,
  /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onFilterModelChange: r.func,
  /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onMenuClose: r.func,
  /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onMenuOpen: r.func,
  /**
   * Callback fired when the pagination meta has changed.
   * @param {GridPaginationMeta} paginationMeta Updated pagination meta.
   */
  onPaginationMetaChange: r.func,
  /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPaginationModelChange: r.func,
  /**
   * Callback fired when the pinned columns have changed.
   * @param {GridPinnedColumnFields} pinnedColumns The changed pinned columns.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPinnedColumnsChange: r.func,
  /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPreferencePanelClose: r.func,
  /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPreferencePanelOpen: r.func,
  /**
   * Callback called when `processRowUpdate` throws an error or rejects.
   * @param {any} error The error thrown.
   */
  onProcessRowUpdateError: r.func,
  /**
   * Callback fired when the Data Grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onResize: r.func,
  /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowClick: r.func,
  /**
   * Callback fired when the row count has changed.
   * @param {number} count Updated row count.
   */
  onRowCountChange: r.func,
  /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowDoubleClick: r.func,
  /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */
  onRowEditStart: r.func,
  /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */
  onRowEditStop: r.func,
  /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowModesModelChange: r.func,
  /**
   * Callback fired when a row is being reordered.
   * @param {GridRowOrderChangeParams} params With all properties from [[GridRowOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowOrderChange: r.func,
  /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowSelectionModelChange: r.func,
  /**
   * Callback fired when scrolling to the bottom of the grid viewport.
   * @param {GridRowScrollEndParams} params With all properties from [[GridRowScrollEndParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowsScrollEnd: r.func,
  /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onSortModelChange: r.func,
  /**
   * Callback fired when the state of the Data Grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */
  onStateChange: r.func,
  /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */
  pageSizeOptions: r.arrayOf(r.oneOfType([r.number, r.shape({
    label: r.string.isRequired,
    value: r.number.isRequired
  })]).isRequired),
  /**
   * If `true`, pagination is enabled.
   * @default false
   */
  pagination: r.bool,
  /**
   * The extra information about the pagination state of the Data Grid.
   * Only applicable with `paginationMode="server"`.
   */
  paginationMeta: r.shape({
    hasNextPage: r.bool
  }),
  /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */
  paginationMode: r.oneOf(["client", "server"]),
  /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */
  paginationModel: r.shape({
    page: r.number.isRequired,
    pageSize: r.number.isRequired
  }),
  /**
   * The column fields to display pinned to left or right.
   */
  pinnedColumns: r.object,
  /**
   * Rows data to pin on top or bottom.
   */
  pinnedRows: r.shape({
    bottom: r.arrayOf(r.object),
    top: r.arrayOf(r.object)
  }),
  /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @param {{ rowId: GridRowId }} params Additional parameters.
   * @returns {Promise<R> | R} The final values to update the row.
   */
  processRowUpdate: r.func,
  /**
   * The milliseconds throttle delay for resizing the grid.
   * @default 60
   */
  resizeThrottleMs: r.number,
  /**
   * Row region in pixels to render before/after the viewport
   * @default 150
   */
  rowBufferPx: r.number,
  /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Only works with `paginationMode="server"`, ignored when `paginationMode="client"`.
   */
  rowCount: r.number,
  /**
   * Sets the height in pixel of a row in the Data Grid.
   * @default 52
   */
  rowHeight: r.number,
  /**
   * Controls the modes of the rows.
   */
  rowModesModel: r.object,
  /**
   * The milliseconds delay to wait after measuring the row height before recalculating row positions.
   * Setting it to a lower value could be useful when using dynamic row height,
   * but might reduce performance when displaying a large number of rows.
   * @default 166
   * @deprecated
   */
  rowPositionsDebounceMs: r.number,
  /**
   * If `true`, the reordering of rows is enabled.
   * @default false
   */
  rowReordering: r.bool,
  /**
   * Set of rows of type [[GridRowsProp]].
   * @default []
   */
  rows: r.arrayOf(r.object),
  /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */
  rowSelection: r.bool,
  /**
   * Sets the row selection model of the Data Grid.
   */
  rowSelectionModel: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string]).isRequired), r.number, r.string]),
  /**
   * When `rowSelectionPropagation.descendants` is set to `true`.
   * - Selecting a parent selects all its filtered descendants automatically.
   * - Deselecting a parent row deselects all its filtered descendants automatically.
   *
   * When `rowSelectionPropagation.parents` is set to `true`
   * - Selecting all the filtered descendants of a parent selects the parent automatically.
   * - Deselecting a descendant of a selected parent deselects the parent automatically.
   *
   * Works with tree data and row grouping on the client-side only.
   * @default { parents: false, descendants: false }
   */
  rowSelectionPropagation: r.shape({
    descendants: r.bool,
    parents: r.bool
  }),
  /**
   * Loading rows can be processed on the server or client-side.
   * Set it to 'client' if you would like enable infnite loading.
   * Set it to 'server' if you would like to enable lazy loading.
   * * @default "client"
   */
  rowsLoadingMode: r.oneOf(["client", "server"]),
  /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */
  rowSpacingType: r.oneOf(["border", "margin"]),
  /**
   * Override the height/width of the Data Grid inner scrollbar.
   */
  scrollbarSize: r.number,
  /**
   * Set the area in `px` at the bottom of the grid viewport where onRowsScrollEnd is called.
   * @default 80
   */
  scrollEndThreshold: r.number,
  /**
   * If `true`, vertical borders will be displayed between cells.
   * @default false
   */
  showCellVerticalBorder: r.bool,
  /**
   * If `true`, vertical borders will be displayed between column header items.
   * @default false
   */
  showColumnVerticalBorder: r.bool,
  /**
   * Overridable components props dynamically passed to the component at rendering.
   */
  slotProps: r.object,
  /**
   * Overridable components.
   */
  slots: r.object,
  /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */
  sortingMode: r.oneOf(["client", "server"]),
  /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */
  sortingOrder: r.arrayOf(r.oneOf(["asc", "desc"])),
  /**
   * Set the sort model of the Data Grid.
   */
  sortModel: r.arrayOf(r.shape({
    field: r.string.isRequired,
    sort: r.oneOf(["asc", "desc"])
  })),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * If positive, the Data Grid will throttle updates coming from `apiRef.current.updateRows` and `apiRef.current.setRows`.
   * It can be useful if you have a high update rate but do not want to do heavy work like filtering / sorting or rendering on each  individual update.
   * @default 0
   */
  throttleRowsMs: r.number,
  /**
   * If `true`, the rows will be gathered in a tree structure according to the `getTreeDataPath` prop.
   * @default false
   */
  treeData: r.bool,
  unstable_dataSource: r.shape({
    getChildrenCount: r.func,
    getGroupKey: r.func,
    getRows: r.func.isRequired,
    updateRow: r.func
  }),
  unstable_dataSourceCache: r.shape({
    clear: r.func.isRequired,
    get: r.func.isRequired,
    set: r.func.isRequired
  }),
  /**
   * Definition of the column rendered when the `unstable_listView` prop is enabled.
   */
  unstable_listColumn: r.shape({
    align: r.oneOf(["center", "left", "right"]),
    cellClassName: r.oneOfType([r.func, r.string]),
    display: r.oneOf(["flex", "text"]),
    field: r.string.isRequired,
    renderCell: r.func
  }),
  /**
   * If `true`, displays the data in a list view.
   * Use in combination with `unstable_listColumn`.
   */
  unstable_listView: r.bool,
  unstable_onDataSourceError: r.func,
  /**
   * If `true`, the Data Grid will auto span the cells over the rows having the same value.
   * @default false
   */
  unstable_rowSpanning: r.bool,
  /**
   * If `true`, the Data Grid enables column virtualization when `getRowHeight` is set to `() => 'auto'`.
   * By default, column virtualization is disabled when dynamic row height is enabled to measure the row height correctly.
   * For datasets with a large number of columns, this can cause performance issues.
   * The downside of enabling this prop is that the row height will be estimated based the cells that are currently rendered, which can cause row height change when scrolling horizontally.
   * @default false
   */
  virtualizeColumnsWithAutoRowHeight: r.bool
};
const Koe = jJ, Yoe = (e, t) => {
  const n = (o) => {
    e.current && !e.current.contains(o.target) && t();
  };
  Nt(() => (document.addEventListener("click", n), () => {
    document.removeEventListener("click", n);
  }));
}, Ng = (e, t = 255) => Math.min(t, Math.max(0, parseInt(e, 10))), $g = (e, t) => parseInt(e.slice(t * 2, t * 2 + 2), 16) || 0, Ag = (e, t, n) => Math.round(n * e + (1 - n) * t), Fg = (e) => e.toString(16).padStart(2, "0"), Xoe = (e) => e.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/), Qoe = (e, t) => {
  const n = Xoe(e);
  if (!n) return e;
  const o = Ng(n[1]), s = Ng(n[2]), i = Ng(n[3]), a = n[4] ? Math.min(1, Math.max(0, parseFloat(n[4]))) : 1, l = t.replace("#", ""), c = $g(l, 0), u = $g(l, 1), d = $g(l, 2), f = Ag(o, c, a), p = Ag(s, u, a), m = Ag(i, d, a);
  return `#${Fg(f)}${Fg(p)}${Fg(m)}`;
}, Zoe = [
  "primary",
  "secondary",
  "error",
  "warning",
  "info",
  "success",
  "report",
  "numa",
  "customer",
  "user",
  "appointment",
  "order",
  "note",
  "task",
  "phonecall",
  "payment",
  "highlight",
  "fiveScale1",
  "fiveScale2",
  "fiveScale3",
  "fiveScale4",
  "fiveScale5",
  "tenScale1",
  "tenScale2",
  "tenScale3",
  "tenScale4",
  "tenScale5",
  "tenScale6",
  "tenScale7",
  "tenScale8",
  "tenScale9",
  "tenScale10",
  "good",
  "concern",
  "bad",
  "inherit"
], Joe = (e) => Zoe.includes(e || ""), Lve = (e) => Joe(e) && !["inherit"].includes(e || ""), ere = 150, _ve = ({
  height: e = 500,
  title: t,
  withQuickFilter: n,
  columns: o,
  pageSizeOptions: s,
  pageSize: i = 50,
  noRowsOverlay: a,
  apiRef: l,
  disableColumnMenu: c,
  slots: u = {},
  disableFooterPaging: d,
  ...f
}) => {
  const [p, m] = jt(!1), b = Ft(null), v = Ft(null), g = Koe(), y = l || g;
  Yoe(b, () => {
    var E;
    v.current && (v.current.value = "", (E = y.current) == null || E.setQuickFilterValues([])), m(!1);
  });
  const w = Ye(() => n ? p ? /* @__PURE__ */ C("div", { ref: b, children: /* @__PURE__ */ C(
    b2,
    {
      debounceMs: 0,
      inputProps: { ref: v }
    }
  ) }) : /* @__PURE__ */ C(
    zp,
    {
      onClick: (E) => {
        E.stopPropagation(), m(!0);
      },
      icon: /* @__PURE__ */ C(O8, {})
    }
  ) : null, [p, n, b, v]), x = pt(
    () => t || n ? /* @__PURE__ */ ie(
      Gt,
      {
        sx: (E) => ({
          backgroundColor: E.palette.primary.background,
          padding: 1,
          paddingBottom: 0,
          display: "flex",
          justifyContent: "space-between"
        }),
        children: [
          typeof t == "string" ? /* @__PURE__ */ C(yn, { variant: "body1", sx: { fontWeight: "bold" }, children: t }) : t,
          n && w
        ]
      }
    ) : null,
    [t, w, n]
  ), S = Ye(() => o.map((E) => ({
    ...E,
    width: E.width || ere
  })), [o]), T = Ye(() => {
    if (i || s) {
      let E = i;
      return s && (E = typeof (s == null ? void 0 : s[0]) == "number" ? s == null ? void 0 : s[0] : s == null ? void 0 : s[0].value), {
        pagination: {
          paginationModel: {
            pageSize: E
          }
        }
      };
    }
    return {};
  }, [i, s]);
  return /* @__PURE__ */ C(Gt, { sx: { width: "100%", height: e }, children: /* @__PURE__ */ C(
    Uoe,
    {
      apiRef: y,
      disableColumnMenu: c,
      slots: {
        toolbar: x,
        noRowsOverlay: a,
        ...u
      },
      slotProps: {
        pagination: {
          disabled: d
        }
      },
      columns: S,
      sx: (E) => {
        const O = E.palette.mode === "dark" ? E.palette.divider : void 0;
        return {
          // We have to override MUI's workaround for table border alpha
          // See MuiTableCell.tsx (in core theme components) for more details
          "--DataGrid-rowBorderColor": O,
          borderColor: O,
          [`& .${K.cell}:focus, & .${K.cell}:focus-within`]: {
            outline: "none"
          },
          [`& .${K.columnHeader}:focus, & .${K.columnHeader}:focus-within`]: {
            outline: "none"
          },
          [`& .${K.columnHeaders}`]: {
            backgroundColor: Qoe(
              E.palette.primary.background,
              E.palette.background.default
            )
          },
          [`& .${K["container--top"]} [role=row]`]: {
            background: "transparent"
          },
          // hide the column separator if they're not resizable
          [`& .${K.columnSeparator}`]: {
            [`&:not(.${K["columnSeparator--resizable"]})`]: {
              display: "none"
            }
          },
          [`& .${K.row}`]: {
            cursor: f.onRowClick ? "pointer" : "default"
          }
        };
      },
      disableRowSelectionOnClick: !0,
      hideFooterSelectedRowCount: !0,
      pagination: !0,
      pageSizeOptions: s || [i],
      initialState: T,
      ...f
    }
  ) });
}, Lg = (e, t, n = !0) => {
  e(
    (o) => {
      const s = new URLSearchParams(o);
      return t.page !== void 0 && s.set("page", t.page.toString()), t.pageSize !== void 0 && s.set("pageSize", t.pageSize.toString()), s;
    },
    { replace: n }
  );
}, tre = (e) => {
  const t = () => {
    const i = { 0: null }, a = localStorage.getItem(e);
    return a ? { ...i, ...JSON.parse(a) } : i;
  }, n = (i) => {
    const a = localStorage.getItem(e);
    return i === null || !a ? null : JSON.parse(a)[i] || null;
  }, o = (i) => {
    localStorage.setItem(e, JSON.stringify(i));
  };
  return {
    getInitialCursorHistory: t,
    getCursorForPage: n,
    saveCursorHistory: o,
    clearCursorHistory: () => {
      o({ 0: null });
    }
  };
}, Vve = (e, t = 10, n, o) => {
  const {
    getInitialCursorHistory: s,
    getCursorForPage: i,
    saveCursorHistory: a,
    clearCursorHistory: l
  } = tre(e), [c, u] = jt(
    () => {
      const g = n.get("page"), y = n.get("pageSize");
      return {
        page: g ? parseInt(g) : 0,
        pageSize: y ? parseInt(y) : t
      };
    }
  ), [d, f] = jt(() => {
    const g = n.get("page");
    return g ? i(g) : null;
  }), p = Ft(s()), m = (g) => {
    const y = p.current[g.page];
    u(g), f(y), Lg(o, {
      page: g.page,
      pageSize: g.pageSize
    });
  }, b = pt(
    (g, y) => {
      if (g && !y) {
        const w = {
          ...p.current,
          [c.page + 1]: g
        };
        p.current = w, a(w);
      }
    },
    [c.page, a]
  ), v = pt(
    (g) => {
      u((y) => ({
        page: 0,
        pageSize: g ?? y.pageSize
      })), f(null), p.current = { 0: null }, l(), Lg(o, { page: 0 });
    },
    [l, o]
  );
  return Nt(() => {
    const g = c.page;
    g > 0 && !p.current[g] && (u((y) => ({ ...y, page: 0 })), f(null), Lg(o, { page: 0 }));
  }, [c.page, o]), {
    paginationModel: c,
    cursor: d,
    cursorHistoryRef: p,
    handlePaginationModelChange: m,
    updateCursorHistory: b,
    resetPagination: v
  };
}, nre = ["localeText"], Wf = /* @__PURE__ */ h.createContext(null);
process.env.NODE_ENV !== "production" && (Wf.displayName = "MuiPickersAdapterContext");
const eh = function(t) {
  const {
    localeText: n
  } = t, o = ve(t, nre), {
    utils: s,
    localeText: i
  } = h.useContext(Wf) ?? {
    utils: void 0,
    localeText: void 0
  }, a = Et({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: o,
    name: "MuiLocalizationProvider"
  }), {
    children: l,
    dateAdapter: c,
    dateFormats: u,
    dateLibInstance: d,
    adapterLocale: f,
    localeText: p
  } = a, m = h.useMemo(() => I({}, p, i, n), [p, i, n]), b = h.useMemo(() => {
    if (!c)
      return s || null;
    const y = new c({
      locale: f,
      formats: u,
      instance: d
    });
    if (!y.isMUIAdapter)
      throw new Error(["MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return y;
  }, [c, f, u, d, s]), v = h.useMemo(() => b ? {
    minDate: b.date("1900-01-01T00:00:00.000"),
    maxDate: b.date("2099-12-31T00:00:00.000")
  } : null, [b]), g = h.useMemo(() => ({
    utils: b,
    defaultDates: v,
    localeText: m
  }), [v, b, m]);
  return /* @__PURE__ */ C(Wf.Provider, {
    value: g,
    children: l
  });
};
process.env.NODE_ENV !== "production" && (eh.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: r.any,
  children: r.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: r.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: r.shape({
    dayOfMonth: r.string,
    dayOfMonthFull: r.string,
    fullDate: r.string,
    fullTime: r.string,
    fullTime12h: r.string,
    fullTime24h: r.string,
    hours12h: r.string,
    hours24h: r.string,
    keyboardDate: r.string,
    keyboardDateTime: r.string,
    keyboardDateTime12h: r.string,
    keyboardDateTime24h: r.string,
    meridiem: r.string,
    minutes: r.string,
    month: r.string,
    monthShort: r.string,
    normalDate: r.string,
    normalDateWithWeekday: r.string,
    seconds: r.string,
    shortDate: r.string,
    weekday: r.string,
    weekdayShort: r.string,
    year: r.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: r.any,
  /**
   * Locale for components texts
   */
  localeText: r.object
});
const ore = (e) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: I({}, e)
      }
    }
  }
}), uN = (e) => {
  const {
    utils: t,
    formatKey: n,
    contextTranslation: o,
    propsTranslation: s
  } = e;
  return (i) => {
    const a = i !== null && t.isValid(i) ? t.format(i, n) : null;
    return (s ?? o)(i, t, a);
  };
}, dN = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "Open previous view",
  openNextView: "Open next view",
  calendarViewSwitchingButtonAriaLabel: (e) => e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange labels
  start: "Start",
  end: "End",
  startDate: "Start date",
  startTime: "Start time",
  endDate: "End date",
  endTime: "End time",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (e, t, n, o) => `Select ${e}. ${!o && (t === null || !n.isValid(t)) ? "No time selected" : `Selected time is ${o ?? n.format(t, "fullTime")}`}`,
  hoursClockNumberText: (e) => `${e} hours`,
  minutesClockNumberText: (e) => `${e} minutes`,
  secondsClockNumberText: (e) => `${e} seconds`,
  // Digital clock labels
  selectViewText: (e) => `Select ${e}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (e) => `Week ${e}`,
  calendarWeekNumberText: (e) => `${e}`,
  // Open picker labels
  openDatePickerDialogue: (e, t, n) => n || e !== null && t.isValid(e) ? `Choose date, selected date is ${n ?? t.format(e, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (e, t, n) => n || e !== null && t.isValid(e) ? `Choose time, selected time is ${n ?? t.format(e, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (e) => "Y".repeat(e.digitAmount),
  fieldMonthPlaceholder: (e) => e.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (e) => e.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa",
  // View names
  year: "Year",
  month: "Month",
  day: "Day",
  weekDay: "Week day",
  hours: "Hours",
  minutes: "Minutes",
  seconds: "Seconds",
  meridiem: "Meridiem",
  // Common
  empty: "Empty"
}, rre = dN;
ore(dN);
const sa = () => {
  const e = h.useContext(Wf);
  if (e === null)
    throw new Error(["MUI X: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (e.utils === null)
    throw new Error(["MUI X: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const t = h.useMemo(() => I({}, rre, e.localeText), [e.localeText]);
  return h.useMemo(() => I({}, e, {
    localeText: t
  }), [e, t]);
}, Wt = () => sa().utils, ia = () => sa().defaultDates, Bu = (e) => {
  const t = Wt(), n = h.useRef(void 0);
  return n.current === void 0 && (n.current = t.date(void 0, e)), n.current;
}, er = () => sa().localeText, sre = _e(/* @__PURE__ */ C("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), ire = _e(/* @__PURE__ */ C("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), are = _e(/* @__PURE__ */ C("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), lre = _e(/* @__PURE__ */ C("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar");
_e(/* @__PURE__ */ ie(h.Fragment, {
  children: [/* @__PURE__ */ C("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ C("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock");
_e(/* @__PURE__ */ C("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange");
_e(/* @__PURE__ */ ie(h.Fragment, {
  children: [/* @__PURE__ */ C("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ C("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time");
const cre = _e(/* @__PURE__ */ C("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function ure(e) {
  return De("MuiPickersArrowSwitcher", e);
}
Ne("MuiPickersArrowSwitcher", ["root", "spacer", "button", "previousIconButton", "nextIconButton", "leftArrowIcon", "rightArrowIcon"]);
const dre = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel", "labelId"], fre = ["ownerState"], pre = ["ownerState"], hre = te("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex"
}), gre = te("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})(({
  theme: e
}) => ({
  width: e.spacing(3)
})), mR = te(Eo, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (e, t) => t.button
})({
  variants: [{
    props: {
      hidden: !0
    },
    style: {
      visibility: "hidden"
    }
  }]
}), mre = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"],
    previousIconButton: ["previousIconButton"],
    nextIconButton: ["nextIconButton"],
    leftArrowIcon: ["leftArrowIcon"],
    rightArrowIcon: ["rightArrowIcon"]
  }, ure, t);
}, fN = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = _t(), s = Et({
    props: t,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: i,
    className: a,
    slots: l,
    slotProps: c,
    isNextDisabled: u,
    isNextHidden: d,
    onGoToNext: f,
    nextLabel: p,
    isPreviousDisabled: m,
    isPreviousHidden: b,
    onGoToPrevious: v,
    previousLabel: g,
    labelId: y
  } = s, w = ve(s, dre), x = s, S = mre(x), T = {
    isDisabled: u,
    isHidden: d,
    goTo: f,
    label: p
  }, E = {
    isDisabled: m,
    isHidden: b,
    goTo: v,
    label: g
  }, O = (l == null ? void 0 : l.previousIconButton) ?? mR, M = et({
    elementType: O,
    externalSlotProps: c == null ? void 0 : c.previousIconButton,
    additionalProps: {
      size: "medium",
      title: E.label,
      "aria-label": E.label,
      disabled: E.isDisabled,
      edge: "end",
      onClick: E.goTo
    },
    ownerState: I({}, x, {
      hidden: E.isHidden
    }),
    className: ae(S.button, S.previousIconButton)
  }), D = (l == null ? void 0 : l.nextIconButton) ?? mR, R = et({
    elementType: D,
    externalSlotProps: c == null ? void 0 : c.nextIconButton,
    additionalProps: {
      size: "medium",
      title: T.label,
      "aria-label": T.label,
      disabled: T.isDisabled,
      edge: "start",
      onClick: T.goTo
    },
    ownerState: I({}, x, {
      hidden: T.isHidden
    }),
    className: ae(S.button, S.nextIconButton)
  }), P = (l == null ? void 0 : l.leftArrowIcon) ?? ire, F = et({
    elementType: P,
    externalSlotProps: c == null ? void 0 : c.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: x,
    className: S.leftArrowIcon
  }), $ = ve(F, fre), N = (l == null ? void 0 : l.rightArrowIcon) ?? are, A = et({
    elementType: N,
    externalSlotProps: c == null ? void 0 : c.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: x,
    className: S.rightArrowIcon
  }), k = ve(A, pre);
  return /* @__PURE__ */ ie(hre, I({
    ref: n,
    className: ae(S.root, a),
    ownerState: x
  }, w, {
    children: [/* @__PURE__ */ C(O, I({}, M, {
      children: o ? /* @__PURE__ */ C(N, I({}, k)) : /* @__PURE__ */ C(P, I({}, $))
    })), i ? /* @__PURE__ */ C(yn, {
      variant: "subtitle1",
      component: "span",
      id: y,
      children: i
    }) : /* @__PURE__ */ C(gre, {
      className: S.spacer,
      ownerState: x
    }), /* @__PURE__ */ C(D, I({}, R, {
      children: o ? /* @__PURE__ */ C(P, I({}, $)) : /* @__PURE__ */ C(N, I({}, k))
    }))]
  }));
}), Ql = (e, t) => e.length !== t.length ? !1 : t.every((n) => e.includes(n)), bre = ({
  openTo: e,
  defaultOpenTo: t,
  views: n,
  defaultViews: o
}) => {
  const s = n ?? o;
  let i;
  if (e != null)
    i = e;
  else if (s.includes(t))
    i = t;
  else if (s.length > 0)
    i = s[0];
  else
    throw new Error("MUI X: The `views` prop must contain at least one view.");
  return {
    views: s,
    openTo: i
  };
}, yre = ["hours", "minutes", "seconds"], vre = (e) => yre.includes(e), bR = (e, t) => t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e), Cre = (e, t) => (n, o) => e ? t.isAfter(n, o) : bR(n, t) > bR(o, t);
let _g = !1;
function b0({
  onChange: e,
  onViewChange: t,
  openTo: n,
  view: o,
  views: s,
  autoFocus: i,
  focusedView: a,
  onFocusedViewChange: l
}) {
  process.env.NODE_ENV !== "production" && (_g || (o != null && !s.includes(o) && (console.warn(`MUI X: \`view="${o}"\` is not a valid prop.`, `It must be an element of \`views=["${s.join('", "')}"]\`.`), _g = !0), o == null && n != null && !s.includes(n) && (console.warn(`MUI X: \`openTo="${n}"\` is not a valid prop.`, `It must be an element of \`views=["${s.join('", "')}"]\`.`), _g = !0)));
  const c = h.useRef(n), u = h.useRef(s), d = h.useRef(s.includes(n) ? n : s[0]), [f, p] = jn({
    name: "useViews",
    state: "view",
    controlled: o,
    default: d.current
  }), m = h.useRef(i ? f : null), [b, v] = jn({
    name: "useViews",
    state: "focusedView",
    controlled: a,
    default: m.current
  });
  h.useEffect(() => {
    (c.current && c.current !== n || u.current && u.current.some((O) => !s.includes(O))) && (p(s.includes(n) ? n : s[0]), u.current = s, c.current = n);
  }, [n, p, f, s]);
  const g = s.indexOf(f), y = s[g - 1] ?? null, w = s[g + 1] ?? null, x = xe((O, M) => {
    v(M ? O : (D) => O === D ? null : D), l == null || l(O, M);
  }), S = xe((O) => {
    x(O, !0), O !== f && (p(O), t && t(O));
  }), T = xe(() => {
    w && S(w);
  }), E = xe((O, M, D) => {
    const R = M === "finish", P = D ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but when it's not the final view given all `views` -> overall selection state should be `partial`.
      s.indexOf(D) < s.length - 1
    ) : !!w;
    if (e(O, R && P ? "partial" : M, D), D && D !== f) {
      const $ = s[s.indexOf(D) + 1];
      $ && S($);
    } else R && T();
  });
  return {
    view: f,
    setView: S,
    focusedView: b,
    setFocusedView: x,
    nextView: w,
    previousView: y,
    // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
    defaultView: s.includes(n) ? n : s[0],
    goToNextView: T,
    setValueAndGoToNextView: E
  };
}
function pN(e, {
  disableFuture: t,
  maxDate: n,
  timezone: o
}) {
  const s = Wt();
  return h.useMemo(() => {
    const i = s.date(void 0, o), a = s.startOfMonth(t && s.isBefore(i, n) ? i : n);
    return !s.isAfter(a, e);
  }, [t, n, e, s, o]);
}
function hN(e, {
  disablePast: t,
  minDate: n,
  timezone: o
}) {
  const s = Wt();
  return h.useMemo(() => {
    const i = s.date(void 0, o), a = s.startOfMonth(t && s.isAfter(i, n) ? i : n);
    return !s.isBefore(a, e);
  }, [t, n, e, s, o]);
}
const nu = 36, zu = 2, th = 320, wre = 280, y0 = 336, Sre = te("div")({
  overflow: "hidden",
  width: th,
  maxHeight: y0,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
}), Ni = (e, t, n) => {
  let o = t;
  return o = e.setHours(o, e.getHours(n)), o = e.setMinutes(o, e.getMinutes(n)), o = e.setSeconds(o, e.getSeconds(n)), o = e.setMilliseconds(o, e.getMilliseconds(n)), o;
}, kc = ({
  date: e,
  disableFuture: t,
  disablePast: n,
  maxDate: o,
  minDate: s,
  isDateDisabled: i,
  utils: a,
  timezone: l
}) => {
  const c = Ni(a, a.date(void 0, l), e);
  n && a.isBefore(s, c) && (s = c), t && a.isAfter(o, c) && (o = c);
  let u = e, d = e;
  for (a.isBefore(e, s) && (u = s, d = null), a.isAfter(e, o) && (d && (d = o), u = null); u || d; ) {
    if (u && a.isAfter(u, o) && (u = null), d && a.isBefore(d, s) && (d = null), u) {
      if (!i(u))
        return u;
      u = a.addDays(u, 1);
    }
    if (d) {
      if (!i(d))
        return d;
      d = a.addDays(d, -1);
    }
  }
  return null;
}, gN = (e, t) => t == null || !e.isValid(t) ? null : t, io = (e, t, n) => t == null || !e.isValid(t) ? n : t, Wy = (e, t, n) => !e.isValid(t) && t != null && !e.isValid(n) && n != null ? !0 : e.isEqual(t, n), v0 = (e, t) => {
  const o = [e.startOfYear(t)];
  for (; o.length < 12; ) {
    const s = o[o.length - 1];
    o.push(e.addMonths(s, 1));
  }
  return o;
}, Uf = (e, t, n) => n === "date" ? e.startOfDay(e.date(void 0, t)) : e.date(void 0, t), xre = ["year", "month", "day"], yR = (e) => xre.includes(e), C0 = (e, {
  format: t,
  views: n
}, o) => {
  if (t != null)
    return t;
  const s = e.formats;
  return Ql(n, ["year"]) ? s.year : Ql(n, ["month"]) ? s.month : Ql(n, ["day"]) ? s.dayOfMonth : Ql(n, ["month", "year"]) ? `${s.month} ${s.year}` : Ql(n, ["day", "month"]) ? `${s.month} ${s.dayOfMonth}` : o ? /en/.test(e.getCurrentLocaleCode()) ? s.normalDateWithWeekday : s.normalDate : s.keyboardDate;
}, Tre = (e, t) => {
  const n = e.startOfWeek(t);
  return [0, 1, 2, 3, 4, 5, 6].map((o) => e.addDays(n, o));
}, w0 = ({
  timezone: e,
  value: t,
  defaultValue: n,
  referenceDate: o,
  onChange: s,
  valueManager: i
}) => {
  const a = Wt(), l = h.useRef(n), c = t ?? l.current ?? i.emptyValue, u = h.useMemo(() => i.getTimezone(a, c), [a, i, c]), d = xe((b) => u == null ? b : i.setTimezone(a, u, b));
  let f;
  e ? f = e : u ? f = u : o ? f = a.getTimezone(o) : f = "default";
  const p = h.useMemo(() => i.setTimezone(a, f, c), [i, a, f, c]), m = xe((b, ...v) => {
    const g = d(b);
    s == null || s(g, ...v);
  });
  return {
    value: p,
    handleValueChange: m,
    timezone: f
  };
}, Hu = ({
  name: e,
  timezone: t,
  value: n,
  defaultValue: o,
  referenceDate: s,
  onChange: i,
  valueManager: a
}) => {
  const [l, c] = jn({
    name: e,
    state: "value",
    controlled: n,
    default: o ?? a.emptyValue
  }), u = xe((d, ...f) => {
    c(d), i == null || i(d, ...f);
  });
  return w0({
    timezone: t,
    value: l,
    defaultValue: void 0,
    referenceDate: s,
    onChange: u,
    valueManager: a
  });
}, zr = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, Rre = (e) => Math.max(...e.map((t) => zr[t.type] ?? 1)), Zl = (e, t, n) => {
  if (t === zr.year)
    return e.startOfYear(n);
  if (t === zr.month)
    return e.startOfMonth(n);
  if (t === zr.day)
    return e.startOfDay(n);
  let o = n;
  return t < zr.minutes && (o = e.setMinutes(o, 0)), t < zr.seconds && (o = e.setSeconds(o, 0)), t < zr.milliseconds && (o = e.setMilliseconds(o, 0)), o;
}, mN = ({
  props: e,
  utils: t,
  granularity: n,
  timezone: o,
  getTodayDate: s
}) => {
  let i = s ? s() : Zl(t, n, Uf(t, o));
  e.minDate != null && t.isAfterDay(e.minDate, i) && (i = Zl(t, n, e.minDate)), e.maxDate != null && t.isBeforeDay(e.maxDate, i) && (i = Zl(t, n, e.maxDate));
  const a = Cre(e.disableIgnoringDatePartForTimeValidation ?? !1, t);
  return e.minTime != null && a(e.minTime, i) && (i = Zl(t, n, e.disableIgnoringDatePartForTimeValidation ? e.minTime : Ni(t, i, e.minTime))), e.maxTime != null && a(i, e.maxTime) && (i = Zl(t, n, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : Ni(t, i, e.maxTime))), i;
}, S0 = (e, t) => {
  const n = e.formatTokenMap[t];
  if (n == null)
    throw new Error([`MUI X: The token "${t}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof n == "string" ? {
    type: n,
    contentType: n === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: n.sectionType,
    contentType: n.contentType,
    maxLength: n.maxLength
  };
}, Ere = (e) => {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, nh = (e, t) => {
  const n = [], o = e.date(void 0, "default"), s = e.startOfWeek(o), i = e.endOfWeek(o);
  let a = s;
  for (; e.isBefore(a, i); )
    n.push(a), a = e.addDays(a, 1);
  return n.map((l) => e.formatByString(l, t));
}, bN = (e, t, n, o) => {
  switch (n) {
    case "month":
      return v0(e, e.date(void 0, t)).map((s) => e.formatByString(s, o));
    case "weekDay":
      return nh(e, o);
    case "meridiem": {
      const s = e.date(void 0, t);
      return [e.startOfDay(s), e.endOfDay(s)].map((i) => e.formatByString(i, o));
    }
    default:
      return [];
  }
}, vR = "s", Ire = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"], Ore = (e) => {
  const t = e.date(void 0);
  return e.formatByString(e.setSeconds(t, 0), vR) === "0" ? Ire : Array.from({
    length: 10
  }).map((o, s) => e.formatByString(e.setSeconds(t, s), vR));
}, ji = (e, t) => {
  if (t[0] === "0")
    return e;
  const n = [];
  let o = "";
  for (let s = 0; s < e.length; s += 1) {
    o += e[s];
    const i = t.indexOf(o);
    i > -1 && (n.push(i.toString()), o = "");
  }
  return n.join("");
}, x0 = (e, t) => t[0] === "0" ? e : e.split("").map((n) => t[Number(n)]).join(""), CR = (e, t) => {
  const n = ji(e, t);
  return n !== " " && !Number.isNaN(Number(n));
}, yN = (e, t) => {
  let n = e;
  for (n = Number(n).toString(); n.length < t; )
    n = `0${n}`;
  return n;
}, vN = (e, t, n, o, s) => {
  if (process.env.NODE_ENV !== "production" && s.type !== "day" && s.contentType === "digit-with-letter")
    throw new Error([`MUI X: The token "${s.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (s.type === "day" && s.contentType === "digit-with-letter") {
    const a = e.setDate(n.longestMonth, t);
    return e.formatByString(a, s.format);
  }
  let i = t.toString();
  return s.hasLeadingZerosInInput && (i = yN(i, s.maxLength)), x0(i, o);
}, Pre = (e, t, n, o, s, i, a, l) => {
  const c = Ere(o), u = o === "Home", d = o === "End", f = n.value === "" || u || d, p = () => {
    const b = s[n.type]({
      currentDate: a,
      format: n.format,
      contentType: n.contentType
    }), v = (x) => vN(e, x, b, i, n), g = n.type === "minutes" && (l != null && l.minutesStep) ? l.minutesStep : 1;
    let w = parseInt(ji(n.value, i), 10) + c * g;
    if (f) {
      if (n.type === "year" && !d && !u)
        return e.formatByString(e.date(void 0, t), n.format);
      c > 0 || u ? w = b.minimum : w = b.maximum;
    }
    return w % g !== 0 && ((c < 0 || u) && (w += g - (g + w) % g), (c > 0 || d) && (w -= w % g)), w > b.maximum ? v(b.minimum + (w - b.maximum - 1) % (b.maximum - b.minimum + 1)) : w < b.minimum ? v(b.maximum - (b.minimum - w - 1) % (b.maximum - b.minimum + 1)) : v(w);
  }, m = () => {
    const b = bN(e, t, n.type, n.format);
    if (b.length === 0)
      return n.value;
    if (f)
      return c > 0 || u ? b[0] : b[b.length - 1];
    const y = ((b.indexOf(n.value) + c) % b.length + b.length) % b.length;
    return b[y];
  };
  return n.contentType === "digit" || n.contentType === "digit-with-letter" ? p() : m();
}, T0 = (e, t, n) => {
  let o = e.value || e.placeholder;
  const s = t === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return t === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (o = Number(ji(o, n)).toString()), ["input-rtl", "input-ltr"].includes(t) && e.contentType === "digit" && !s && o.length === 1 && (o = `${o}‎`), t === "input-rtl" && (o = `⁨${o}⁩`), o;
}, wR = (e, t, n, o) => {
  if (process.env.NODE_ENV !== "production" && S0(e, n).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return e.formatByString(e.parse(t, n), o);
}, CN = (e, t) => e.formatByString(e.date(void 0, "system"), t).length === 4, wN = (e, t, n, o) => {
  if (t !== "digit")
    return !1;
  const s = e.date(void 0, "default");
  switch (n) {
    // We can't use `changeSectionValueFormat`, because  `utils.parse('1', 'YYYY')` returns `1971` instead of `1`.
    case "year":
      return CN(e, o) ? e.formatByString(e.setYear(s, 1), o) === "0001" : e.formatByString(e.setYear(s, 2001), o) === "01";
    case "month":
      return e.formatByString(e.startOfYear(s), o).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(s), o).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(s), o).length > 1;
    case "hours":
      return e.formatByString(e.setHours(s, 1), o).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(s, 1), o).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(s, 1), o).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, Mre = (e, t, n) => {
  const o = t.some((c) => c.type === "day"), s = [], i = [];
  for (let c = 0; c < t.length; c += 1) {
    const u = t[c];
    o && u.type === "weekDay" || (s.push(u.format), i.push(T0(u, "non-input", n)));
  }
  const a = s.join(" "), l = i.join(" ");
  return e.parse(l, a);
}, SN = (e) => e.map((t) => `${t.startSeparator}${t.value || t.placeholder}${t.endSeparator}`).join(""), xN = (e, t, n) => {
  const s = e.map((i) => {
    const a = T0(i, n ? "input-rtl" : "input-ltr", t);
    return `${i.startSeparator}${a}${i.endSeparator}`;
  }).join("");
  return n ? `⁦${s}⁩` : s;
}, kre = (e, t, n) => {
  const o = e.date(void 0, n), s = e.endOfYear(o), i = e.endOfDay(o), {
    maxDaysInMonth: a,
    longestMonth: l
  } = v0(e, o).reduce((c, u) => {
    const d = e.getDaysInMonth(u);
    return d > c.maxDaysInMonth ? {
      maxDaysInMonth: d,
      longestMonth: u
    } : c;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: c
    }) => ({
      minimum: 0,
      maximum: CN(e, c) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(s) + 1
    }),
    day: ({
      currentDate: c
    }) => ({
      minimum: 1,
      maximum: c != null && e.isValid(c) ? e.getDaysInMonth(c) : a,
      longestMonth: l
    }),
    weekDay: ({
      format: c,
      contentType: u
    }) => {
      if (u === "digit") {
        const d = nh(e, c).map(Number);
        return {
          minimum: Math.min(...d),
          maximum: Math.max(...d)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: c
    }) => {
      const u = e.getHours(i);
      return ji(e.formatByString(e.endOfDay(o), c), t) !== u.toString() ? {
        minimum: 1,
        maximum: Number(ji(e.formatByString(e.startOfDay(o), c), t))
      } : {
        minimum: 0,
        maximum: u
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(i)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(i)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 1
    }),
    empty: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let SR = !1;
const xR = (e, t) => {
  if (process.env.NODE_ENV !== "production" && !SR) {
    const n = ["empty"];
    ["date", "date-time"].includes(t) && n.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(t) && n.push("hours", "minutes", "seconds", "meridiem");
    const o = e.find((s) => !n.includes(s.type));
    o && (console.warn(`MUI X: The field component you are using is not compatible with the "${o.type}" date section.`, `The supported date sections are ["${n.join('", "')}"]\`.`), SR = !0);
  }
}, Dre = (e, t, n, o) => {
  switch (t.type) {
    case "year":
      return e.setYear(o, e.getYear(n));
    case "month":
      return e.setMonth(o, e.getMonth(n));
    case "weekDay": {
      const s = nh(e, t.format), i = e.formatByString(n, t.format), a = s.indexOf(i), c = s.indexOf(t.value) - a;
      return e.addDays(n, c);
    }
    case "day":
      return e.setDate(o, e.getDate(n));
    case "meridiem": {
      const s = e.getHours(n) < 12, i = e.getHours(o);
      return s && i >= 12 ? e.addHours(o, -12) : !s && i < 12 ? e.addHours(o, 12) : o;
    }
    case "hours":
      return e.setHours(o, e.getHours(n));
    case "minutes":
      return e.setMinutes(o, e.getMinutes(n));
    case "seconds":
      return e.setSeconds(o, e.getSeconds(n));
    default:
      return o;
  }
}, TR = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8,
  empty: 9
}, RR = (e, t, n, o, s) => (
  // cloning sections before sort to avoid mutating it
  [...n].sort((i, a) => TR[i.type] - TR[a.type]).reduce((i, a) => !s || a.modified ? Dre(e, a, t, i) : i, o)
), Nre = () => navigator.userAgent.toLowerCase().includes("android"), $re = (e, t) => {
  const n = {};
  if (!t)
    return e.forEach((c, u) => {
      const d = u === 0 ? null : u - 1, f = u === e.length - 1 ? null : u + 1;
      n[u] = {
        leftIndex: d,
        rightIndex: f
      };
    }), {
      neighbors: n,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const o = {}, s = {};
  let i = 0, a = 0, l = e.length - 1;
  for (; l >= 0; ) {
    a = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (c, u) => {
        var d;
        return u >= i && ((d = c.endSeparator) == null ? void 0 : d.includes(" ")) && // Special case where the spaces were not there in the initial input
        c.endSeparator !== " / ";
      }
    ), a === -1 && (a = e.length - 1);
    for (let c = a; c >= i; c -= 1)
      s[c] = l, o[l] = c, l -= 1;
    i = a + 1;
  }
  return e.forEach((c, u) => {
    const d = s[u], f = d === 0 ? null : o[d - 1], p = d === e.length - 1 ? null : o[d + 1];
    n[u] = {
      leftIndex: f,
      rightIndex: p
    };
  }), {
    neighbors: n,
    startIndex: o[0],
    endIndex: o[e.length - 1]
  };
}, Uy = (e, t) => {
  if (e == null)
    return null;
  if (e === "all")
    return "all";
  if (typeof e == "string") {
    const n = t.findIndex((o) => o.type === e);
    return n === -1 ? null : n;
  }
  return e;
}, Are = (e, t) => {
  if (e.value)
    switch (e.type) {
      case "month": {
        if (e.contentType === "digit")
          return t.format(t.setMonth(t.date(), Number(e.value) - 1), "month");
        const n = t.parse(e.value, e.format);
        return n ? t.format(n, "month") : void 0;
      }
      case "day":
        return e.contentType === "digit" ? t.format(t.setDate(t.startOfYear(t.date()), Number(e.value)), "dayOfMonthFull") : e.value;
      case "weekDay":
        return;
      default:
        return;
    }
}, Fre = (e, t) => {
  if (e.value)
    switch (e.type) {
      case "weekDay":
        return e.contentType === "letter" ? void 0 : Number(e.value);
      case "meridiem": {
        const n = t.parse(`01:00 ${e.value}`, `${t.formats.hours12h}:${t.formats.minutes} ${e.format}`);
        return n ? t.getHours(n) >= 12 ? 1 : 0 : void 0;
      }
      case "day":
        return e.contentType === "digit-with-letter" ? parseInt(e.value, 10) : Number(e.value);
      case "month": {
        if (e.contentType === "digit")
          return Number(e.value);
        const n = t.parse(e.value, e.format);
        return n ? t.getMonth(n) + 1 : void 0;
      }
      default:
        return e.contentType !== "letter" ? Number(e.value) : void 0;
    }
}, Lre = ["value", "referenceDate"], ns = {
  emptyValue: null,
  getTodayValue: Uf,
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: n
    } = e, o = ve(e, Lre);
    return t != null && o.utils.isValid(t) ? t : n ?? mN(o);
  },
  cleanValue: gN,
  areValuesEqual: Wy,
  isSameError: (e, t) => e === t,
  hasError: (e) => e != null,
  defaultErrorState: null,
  getTimezone: (e, t) => t == null || !e.isValid(t) ? null : e.getTimezone(t),
  setTimezone: (e, t, n) => n == null ? null : e.setTimezone(n, t)
}, _re = {
  updateReferenceValue: (e, t, n) => t == null || !e.isValid(t) ? n : t,
  getSectionsFromValue: (e, t, n, o) => !e.isValid(t) && !!n ? n : o(t),
  getV7HiddenInputValueFromSections: SN,
  getV6InputValueFromSections: xN,
  getActiveDateManager: (e, t) => ({
    date: t.value,
    referenceDate: t.referenceValue,
    getSections: (n) => n,
    getNewValuesFromNewActiveDate: (n) => ({
      value: n,
      referenceValue: n == null || !e.isValid(n) ? t.referenceValue : n
    })
  }),
  parseValueStr: (e, t, n) => n(e.trim(), t)
};
function Vre(e, t) {
  return Array.isArray(t) ? t.every((n) => e.indexOf(n) !== -1) : e.indexOf(t) !== -1;
}
const Kf = (e, t) => (n) => {
  (n.key === "Enter" || n.key === " ") && (e(n), n.preventDefault(), n.stopPropagation()), t && t(n);
}, Bre = (e) => {
  setTimeout(e, 0);
}, so = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? so(t.shadowRoot) : t : null;
}, TN = "@media (pointer: fine)";
function zre(e) {
  return De("MuiPickersDay", e);
}
const li = Ne("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]), Hre = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"], jre = (e) => {
  const {
    selected: t,
    disableMargin: n,
    disableHighlightToday: o,
    today: s,
    disabled: i,
    outsideCurrentMonth: a,
    showDaysOutsideCurrentMonth: l,
    classes: c
  } = e, u = a && !l;
  return fe({
    root: ["root", t && !u && "selected", i && "disabled", !n && "dayWithMargin", !o && s && "today", a && l && "dayOutsideMonth", u && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, zre, c);
}, RN = ({
  theme: e
}) => I({}, e.typography.caption, {
  width: nu,
  height: nu,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.short
  }),
  color: (e.vars || e).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette.primary.main, e.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : he(e.palette.primary.main, e.palette.action.focusOpacity),
    [`&.${li.selected}`]: {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${li.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    fontWeight: e.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${li.disabled}:not(.${li.selected})`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${li.disabled}&.${li.selected}`]: {
    opacity: 0.6
  },
  variants: [{
    props: {
      disableMargin: !1
    },
    style: {
      margin: `0 ${zu}px`
    }
  }, {
    props: {
      outsideCurrentMonth: !0,
      showDaysOutsideCurrentMonth: !0
    },
    style: {
      color: (e.vars || e).palette.text.secondary
    }
  }, {
    props: {
      disableHighlightToday: !1,
      today: !0
    },
    style: {
      [`&:not(.${li.selected})`]: {
        border: `1px solid ${(e.vars || e).palette.text.secondary}`
      }
    }
  }]
}), EN = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, !n.disableMargin && t.dayWithMargin, !n.disableHighlightToday && n.today && t.today, !n.outsideCurrentMonth && n.showDaysOutsideCurrentMonth && t.dayOutsideMonth, n.outsideCurrentMonth && !n.showDaysOutsideCurrentMonth && t.hiddenDaySpacingFiller];
}, Gre = te(Yn, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: EN
})(RN), qre = te("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: EN
})(({
  theme: e
}) => I({}, RN({
  theme: e
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
})), Jl = () => {
}, IN = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiPickersDay"
  }), {
    autoFocus: s = !1,
    className: i,
    day: a,
    disabled: l = !1,
    disableHighlightToday: c = !1,
    disableMargin: u = !1,
    isAnimating: d,
    onClick: f,
    onDaySelect: p,
    onFocus: m = Jl,
    onBlur: b = Jl,
    onKeyDown: v = Jl,
    onMouseDown: g = Jl,
    onMouseEnter: y = Jl,
    outsideCurrentMonth: w,
    selected: x = !1,
    showDaysOutsideCurrentMonth: S = !1,
    children: T,
    today: E = !1
  } = o, O = ve(o, Hre), M = I({}, o, {
    autoFocus: s,
    disabled: l,
    disableHighlightToday: c,
    disableMargin: u,
    selected: x,
    showDaysOutsideCurrentMonth: S,
    today: E
  }), D = jre(M), R = Wt(), P = h.useRef(null), F = tt(P, n);
  yt(() => {
    s && !l && !d && !w && P.current.focus();
  }, [s, l, d, w]);
  const $ = (A) => {
    g(A), w && A.preventDefault();
  }, N = (A) => {
    l || p(a), w && A.currentTarget.focus(), f && f(A);
  };
  return w && !S ? /* @__PURE__ */ C(qre, {
    className: ae(D.root, D.hiddenDaySpacingFiller, i),
    ownerState: M,
    role: O.role
  }) : /* @__PURE__ */ C(Gre, I({
    className: ae(D.root, i),
    ref: F,
    centerRipple: !0,
    disabled: l,
    tabIndex: x ? 0 : -1,
    onKeyDown: (A) => v(A, a),
    onFocus: (A) => m(A, a),
    onBlur: (A) => b(A, a),
    onMouseEnter: (A) => y(A, a),
    onClick: N,
    onMouseDown: $
  }, O, {
    ownerState: M,
    children: T || R.format(a, "dayOfMonth")
  }));
});
process.env.NODE_ENV !== "production" && (IN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: r.oneOfType([r.func, r.shape({
    current: r.shape({
      focusVisible: r.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  component: r.elementType,
  /**
   * The date to show.
   */
  day: r.object.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: r.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: r.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: r.string,
  isAnimating: r.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: r.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: r.bool.isRequired,
  onBlur: r.func,
  onDaySelect: r.func.isRequired,
  onFocus: r.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: r.func,
  onKeyDown: r.func,
  onMouseEnter: r.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: r.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: r.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * @default 0
   */
  tabIndex: r.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: r.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: r.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      pulsate: r.func.isRequired,
      start: r.func.isRequired,
      stop: r.func.isRequired
    })
  })])
});
const ON = /* @__PURE__ */ h.memo(IN), Gi = ({
  props: e,
  value: t,
  timezone: n,
  adapter: o
}) => {
  if (t === null)
    return null;
  const {
    shouldDisableDate: s,
    shouldDisableMonth: i,
    shouldDisableYear: a,
    disablePast: l,
    disableFuture: c
  } = e, u = o.utils.date(void 0, n), d = io(o.utils, e.minDate, o.defaultDates.minDate), f = io(o.utils, e.maxDate, o.defaultDates.maxDate);
  switch (!0) {
    case !o.utils.isValid(t):
      return "invalidDate";
    case !!(s && s(t)):
      return "shouldDisableDate";
    case !!(i && i(t)):
      return "shouldDisableMonth";
    case !!(a && a(t)):
      return "shouldDisableYear";
    case !!(c && o.utils.isAfterDay(t, u)):
      return "disableFuture";
    case !!(l && o.utils.isBeforeDay(t, u)):
      return "disablePast";
    case !!(d && o.utils.isBeforeDay(t, d)):
      return "minDate";
    case !!(f && o.utils.isAfterDay(t, f)):
      return "maxDate";
    default:
      return null;
  }
};
Gi.valueManager = ns;
const PN = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], Wre = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], Ure = ["minDateTime", "maxDateTime"], Kre = [...PN, ...Wre, ...Ure], oh = (e) => Kre.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {});
function R0(e) {
  const {
    props: t,
    validator: n,
    value: o,
    timezone: s,
    onError: i
  } = e, a = sa(), l = h.useRef(n.valueManager.defaultErrorState), c = n({
    adapter: a,
    value: o,
    timezone: s,
    props: t
  }), u = n.valueManager.hasError(c);
  h.useEffect(() => {
    i && !n.valueManager.isSameError(c, l.current) && i(c, o), l.current = c;
  }, [n, i, c, o]);
  const d = xe((f) => n({
    adapter: a,
    value: f,
    timezone: s,
    props: t
  }));
  return {
    validationError: c,
    hasValidationError: u,
    getValidationErrorForNewValue: d
  };
}
const Yre = ({
  utils: e,
  format: t
}) => {
  let n = 10, o = t, s = e.expandFormat(t);
  for (; s !== o; )
    if (o = s, s = e.expandFormat(o), n -= 1, n < 0)
      throw new Error("MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the picker component.");
  return s;
}, Xre = ({
  utils: e,
  expandedFormat: t
}) => {
  const n = [], {
    start: o,
    end: s
  } = e.escapedCharacters, i = new RegExp(`(\\${o}[^\\${s}]*\\${s})+`, "g");
  let a = null;
  for (; a = i.exec(t); )
    n.push({
      start: a.index,
      end: i.lastIndex - 1
    });
  return n;
}, Qre = (e, t, n, o) => {
  switch (n.type) {
    case "year":
      return t.fieldYearPlaceholder({
        digitAmount: e.formatByString(e.date(void 0, "default"), o).length,
        format: o
      });
    case "month":
      return t.fieldMonthPlaceholder({
        contentType: n.contentType,
        format: o
      });
    case "day":
      return t.fieldDayPlaceholder({
        format: o
      });
    case "weekDay":
      return t.fieldWeekDayPlaceholder({
        contentType: n.contentType,
        format: o
      });
    case "hours":
      return t.fieldHoursPlaceholder({
        format: o
      });
    case "minutes":
      return t.fieldMinutesPlaceholder({
        format: o
      });
    case "seconds":
      return t.fieldSecondsPlaceholder({
        format: o
      });
    case "meridiem":
      return t.fieldMeridiemPlaceholder({
        format: o
      });
    default:
      return o;
  }
}, Zre = ({
  utils: e,
  date: t,
  shouldRespectLeadingZeros: n,
  localeText: o,
  localizedDigits: s,
  now: i,
  token: a,
  startSeparator: l
}) => {
  if (a === "")
    throw new Error("MUI X: Should not call `commitToken` with an empty token");
  const c = S0(e, a), u = wN(e, c.contentType, c.type, a), d = n ? u : c.contentType === "digit", f = t != null && e.isValid(t);
  let p = f ? e.formatByString(t, a) : "", m = null;
  if (d)
    if (u)
      m = p === "" ? e.formatByString(i, a).length : p.length;
    else {
      if (c.maxLength == null)
        throw new Error(`MUI X: The token ${a} should have a 'maxDigitNumber' property on it's adapter`);
      m = c.maxLength, f && (p = x0(yN(ji(p, s), m), s));
    }
  return I({}, c, {
    format: a,
    maxLength: m,
    value: p,
    placeholder: Qre(e, o, c, a),
    hasLeadingZerosInFormat: u,
    hasLeadingZerosInInput: d,
    startSeparator: l,
    endSeparator: "",
    modified: !1
  });
}, Jre = (e) => {
  var m;
  const {
    utils: t,
    expandedFormat: n,
    escapedParts: o
  } = e, s = t.date(void 0), i = [];
  let a = "";
  const l = Object.keys(t.formatTokenMap).sort((b, v) => v.length - b.length), c = /^([a-zA-Z]+)/, u = new RegExp(`^(${l.join("|")})*$`), d = new RegExp(`^(${l.join("|")})`), f = (b) => o.find((v) => v.start <= b && v.end >= b);
  let p = 0;
  for (; p < n.length; ) {
    const b = f(p), v = b != null, g = (m = c.exec(n.slice(p))) == null ? void 0 : m[1];
    if (!v && g != null && u.test(g)) {
      let y = g;
      for (; y.length > 0; ) {
        const w = d.exec(y)[1];
        y = y.slice(w.length), i.push(Zre(I({}, e, {
          now: s,
          token: w,
          startSeparator: a
        }))), a = "";
      }
      p += g.length;
    } else {
      const y = n[p];
      v && (b == null ? void 0 : b.start) === p || (b == null ? void 0 : b.end) === p || (i.length === 0 ? a += y : i[i.length - 1].endSeparator += y), p += 1;
    }
  }
  return i.length === 0 && a.length > 0 && i.push({
    type: "empty",
    contentType: "letter",
    maxLength: null,
    format: "",
    value: "",
    placeholder: "",
    hasLeadingZerosInFormat: !1,
    hasLeadingZerosInInput: !1,
    startSeparator: a,
    endSeparator: "",
    modified: !1
  }), i;
}, ese = ({
  isRtl: e,
  formatDensity: t,
  sections: n
}) => n.map((o) => {
  const s = (i) => {
    let a = i;
    return e && a !== null && a.includes(" ") && (a = `⁩${a}⁦`), t === "spacious" && ["/", ".", "-"].includes(a) && (a = ` ${a} `), a;
  };
  return o.startSeparator = s(o.startSeparator), o.endSeparator = s(o.endSeparator), o;
}), ER = (e) => {
  let t = Yre(e);
  e.isRtl && e.enableAccessibleFieldDOMStructure && (t = t.split(" ").reverse().join(" "));
  const n = Xre(I({}, e, {
    expandedFormat: t
  })), o = Jre(I({}, e, {
    expandedFormat: t,
    escapedParts: n
  }));
  return ese(I({}, e, {
    sections: o
  }));
}, tse = (e) => {
  const t = Wt(), n = er(), o = sa(), s = _t(), {
    valueManager: i,
    fieldValueManager: a,
    valueType: l,
    validator: c,
    internalProps: u,
    internalProps: {
      value: d,
      defaultValue: f,
      referenceDate: p,
      onChange: m,
      format: b,
      formatDensity: v = "dense",
      selectedSections: g,
      onSelectedSectionsChange: y,
      shouldRespectLeadingZeros: w = !1,
      timezone: x,
      enableAccessibleFieldDOMStructure: S = !1
    }
  } = e, {
    timezone: T,
    value: E,
    handleValueChange: O
  } = w0({
    timezone: x,
    value: d,
    defaultValue: f,
    referenceDate: p,
    onChange: m,
    valueManager: i
  }), M = h.useMemo(() => Ore(t), [t]), D = h.useMemo(() => kre(t, M, T), [t, M, T]), R = h.useCallback((G, q = null) => a.getSectionsFromValue(t, G, q, (Z) => ER({
    utils: t,
    localeText: n,
    localizedDigits: M,
    format: b,
    date: Z,
    formatDensity: v,
    shouldRespectLeadingZeros: w,
    enableAccessibleFieldDOMStructure: S,
    isRtl: s
  })), [a, b, n, M, s, w, t, v, S]), [P, F] = h.useState(() => {
    const G = R(E);
    xR(G, l);
    const q = {
      sections: G,
      value: E,
      referenceValue: i.emptyValue,
      tempValueStrAndroid: null
    }, Z = Rre(G), Y = i.getInitialReferenceValue({
      referenceDate: p,
      value: E,
      utils: t,
      props: u,
      granularity: Z,
      timezone: T
    });
    return I({}, q, {
      referenceValue: Y
    });
  }), [$, N] = jn({
    controlled: g,
    default: null,
    name: "useField",
    state: "selectedSections"
  }), A = (G) => {
    N(G), y == null || y(G);
  }, k = h.useMemo(() => Uy($, P.sections), [$, P.sections]), L = k === "all" ? 0 : k, B = ({
    value: G,
    referenceValue: q,
    sections: Z
  }) => {
    if (F((Q) => I({}, Q, {
      sections: Z,
      value: G,
      referenceValue: q,
      tempValueStrAndroid: null
    })), i.areValuesEqual(t, P.value, G))
      return;
    const Y = {
      validationError: c({
        adapter: o,
        value: G,
        timezone: T,
        props: u
      })
    };
    O(G, Y);
  }, V = (G, q) => {
    const Z = [...P.sections];
    return Z[G] = I({}, Z[G], {
      value: q,
      modified: !0
    }), Z;
  }, _ = () => {
    B({
      value: i.emptyValue,
      referenceValue: P.referenceValue,
      sections: R(i.emptyValue)
    });
  }, z = () => {
    if (L == null)
      return;
    const G = P.sections[L], q = a.getActiveDateManager(t, P, G), Y = q.getSections(P.sections).filter((H) => H.value !== "").length === (G.value === "" ? 0 : 1), Q = V(L, ""), ee = Y ? null : t.getInvalidDate(), ne = q.getNewValuesFromNewActiveDate(ee);
    B(I({}, ne, {
      sections: Q
    }));
  }, j = (G) => {
    const q = (Q, ee) => {
      const ne = t.parse(Q, b);
      if (ne == null || !t.isValid(ne))
        return null;
      const H = ER({
        utils: t,
        localeText: n,
        localizedDigits: M,
        format: b,
        date: ne,
        formatDensity: v,
        shouldRespectLeadingZeros: w,
        enableAccessibleFieldDOMStructure: S,
        isRtl: s
      });
      return RR(t, ne, H, ee, !1);
    }, Z = a.parseValueStr(G, P.referenceValue, q), Y = a.updateReferenceValue(t, Z, P.referenceValue);
    B({
      value: Z,
      referenceValue: Y,
      sections: R(Z, P.sections)
    });
  }, W = ({
    activeSection: G,
    newSectionValue: q,
    shouldGoToNextSection: Z
  }) => {
    Z && L < P.sections.length - 1 && A(L + 1);
    const Y = a.getActiveDateManager(t, P, G), Q = V(L, q), ee = Y.getSections(Q), ne = Mre(t, ee, M);
    let H, U;
    if (ne != null && t.isValid(ne)) {
      const X = RR(t, ne, ee, Y.referenceDate, !0);
      H = Y.getNewValuesFromNewActiveDate(X), U = !0;
    } else
      H = Y.getNewValuesFromNewActiveDate(ne), U = (ne != null && !t.isValid(ne)) != (Y.date != null && !t.isValid(Y.date));
    return U ? B(I({}, H, {
      sections: Q
    })) : F((X) => I({}, X, H, {
      sections: Q,
      tempValueStrAndroid: null
    }));
  }, J = (G) => F((q) => I({}, q, {
    tempValueStrAndroid: G
  }));
  return h.useEffect(() => {
    const G = R(P.value);
    xR(G, l), F((q) => I({}, q, {
      sections: G
    }));
  }, [b, t.locale, s]), h.useEffect(() => {
    let G;
    i.areValuesEqual(t, P.value, E) ? G = i.getTimezone(t, P.value) !== i.getTimezone(t, E) : G = !0, G && F((q) => I({}, q, {
      value: E,
      referenceValue: a.updateReferenceValue(t, E, q.referenceValue),
      sections: R(E)
    }));
  }, [E]), {
    state: P,
    activeSectionIndex: L,
    parsedSelectedSections: k,
    setSelectedSections: A,
    clearValue: _,
    clearActiveSection: z,
    updateSectionValue: W,
    updateValueFromValueStr: j,
    setTempAndroidValueStr: J,
    getSectionsFromValue: R,
    sectionsValueBoundaries: D,
    localizedDigits: M,
    timezone: T
  };
}, nse = 5e3, ma = (e) => e.saveQuery != null, ose = ({
  sections: e,
  updateSectionValue: t,
  sectionsValueBoundaries: n,
  localizedDigits: o,
  setTempAndroidValueStr: s,
  timezone: i
}) => {
  const a = Wt(), [l, c] = h.useState(null), u = xe(() => c(null));
  h.useEffect(() => {
    var b;
    l != null && ((b = e[l.sectionIndex]) == null ? void 0 : b.type) !== l.sectionType && u();
  }, [e, l, u]), h.useEffect(() => {
    if (l != null) {
      const b = setTimeout(() => u(), nse);
      return () => {
        clearTimeout(b);
      };
    }
    return () => {
    };
  }, [l, u]);
  const d = ({
    keyPressed: b,
    sectionIndex: v
  }, g, y) => {
    const w = b.toLowerCase(), x = e[v];
    if (l != null && (!y || y(l.value)) && l.sectionIndex === v) {
      const T = `${l.value}${w}`, E = g(T, x);
      if (!ma(E))
        return c({
          sectionIndex: v,
          value: T,
          sectionType: x.type
        }), E;
    }
    const S = g(w, x);
    return ma(S) && !S.saveQuery ? (u(), null) : (c({
      sectionIndex: v,
      value: w,
      sectionType: x.type
    }), ma(S) ? null : S);
  }, f = (b) => {
    const v = (w, x, S) => {
      const T = x.filter((E) => E.toLowerCase().startsWith(S));
      return T.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: T[0],
        shouldGoToNextSection: T.length === 1
      };
    }, g = (w, x, S, T) => {
      const E = (O) => bN(a, i, x.type, O);
      if (x.contentType === "letter")
        return v(x.format, E(x.format), w);
      if (S && T != null && S0(a, S).contentType === "letter") {
        const O = E(S), M = v(S, O, w);
        return ma(M) ? {
          saveQuery: !1
        } : I({}, M, {
          sectionValue: T(M.sectionValue, O)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return d(b, (w, x) => {
      switch (x.type) {
        case "month": {
          const S = (T) => wR(a, T, a.formats.month, x.format);
          return g(w, x, a.formats.month, S);
        }
        case "weekDay": {
          const S = (T, E) => E.indexOf(T).toString();
          return g(w, x, a.formats.weekday, S);
        }
        case "meridiem":
          return g(w, x);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, p = (b) => {
    const v = (y, w) => {
      const x = ji(y, o), S = Number(x), T = n[w.type]({
        currentDate: null,
        format: w.format,
        contentType: w.contentType
      });
      if (S > T.maximum)
        return {
          saveQuery: !1
        };
      if (S < T.minimum)
        return {
          saveQuery: !0
        };
      const E = S * 10 > T.maximum || x.length === T.maximum.toString().length;
      return {
        sectionValue: vN(a, S, T, o, w),
        shouldGoToNextSection: E
      };
    };
    return d(b, (y, w) => {
      if (w.contentType === "digit" || w.contentType === "digit-with-letter")
        return v(y, w);
      if (w.type === "month") {
        wN(a, "digit", "month", "MM");
        const x = v(y, {
          type: w.type,
          format: "MM",
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (ma(x))
          return x;
        const S = wR(a, x.sectionValue, "MM", w.format);
        return I({}, x, {
          sectionValue: S
        });
      }
      if (w.type === "weekDay") {
        const x = v(y, w);
        if (ma(x))
          return x;
        const S = nh(a, w.format)[Number(x.sectionValue) - 1];
        return I({}, x, {
          sectionValue: S
        });
      }
      return {
        saveQuery: !1
      };
    }, (y) => CR(y, o));
  };
  return {
    applyCharacterEditing: xe((b) => {
      const v = e[b.sectionIndex], y = CR(b.keyPressed, o) ? p(I({}, b, {
        keyPressed: x0(b.keyPressed, o)
      })) : f(b);
      if (y == null) {
        s(null);
        return;
      }
      t({
        activeSection: v,
        newSectionValue: y.sectionValue,
        shouldGoToNextSection: y.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: u
  };
}, rse = (e) => {
  const {
    internalProps: {
      disabled: t,
      readOnly: n = !1
    },
    forwardedProps: {
      sectionListRef: o,
      onBlur: s,
      onClick: i,
      onFocus: a,
      onInput: l,
      onPaste: c,
      focused: u,
      autoFocus: d = !1
    },
    fieldValueManager: f,
    applyCharacterEditing: p,
    resetCharacterQuery: m,
    setSelectedSections: b,
    parsedSelectedSections: v,
    state: g,
    clearActiveSection: y,
    clearValue: w,
    updateSectionValue: x,
    updateValueFromValueStr: S,
    sectionOrder: T,
    areAllSectionsEmpty: E,
    sectionsValueBoundaries: O
  } = e, M = h.useRef(null), D = tt(o, M), R = er(), P = Wt(), F = gt(), [$, N] = h.useState(!1), A = h.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!M.current)
        return;
      const U = document.getSelection();
      if (!U)
        return;
      if (v == null) {
        U.rangeCount > 0 && M.current.getRoot().contains(U.getRangeAt(0).startContainer) && U.removeAllRanges(), $ && M.current.getRoot().blur();
        return;
      }
      if (!M.current.getRoot().contains(so(document)))
        return;
      const X = new window.Range();
      let re;
      v === "all" ? re = M.current.getRoot() : g.sections[v].type === "empty" ? re = M.current.getSectionContainer(v) : re = M.current.getSectionContent(v), X.selectNodeContents(re), re.focus(), U.removeAllRanges(), U.addRange(X);
    },
    getActiveSectionIndexFromDOM: () => {
      const U = so(document);
      return !U || !M.current || !M.current.getRoot().contains(U) ? null : M.current.getSectionIndexFromDOMElement(U);
    },
    focusField: (U = 0) => {
      if (!M.current || // if the field is already focused, we don't need to focus it again
      A.getActiveSectionIndexFromDOM() != null)
        return;
      const X = Uy(U, g.sections);
      N(!0), M.current.getSectionContent(X).focus();
    },
    setSelectedSections: (U) => {
      if (!M.current)
        return;
      const X = Uy(U, g.sections);
      N((X === "all" ? 0 : X) !== null), b(U);
    },
    isFieldFocused: () => {
      const U = so(document);
      return !!M.current && M.current.getRoot().contains(U);
    }
  }), [v, b, g.sections, $]), k = xe((U) => {
    if (!M.current)
      return;
    const X = g.sections[U];
    M.current.getSectionContent(U).innerHTML = X.value || X.placeholder, A.syncSelectionToDOM();
  }), L = xe((U, ...X) => {
    U.isDefaultPrevented() || !M.current || (N(!0), i == null || i(U, ...X), v === "all" ? setTimeout(() => {
      const re = document.getSelection().getRangeAt(0).startOffset;
      if (re === 0) {
        b(T.startIndex);
        return;
      }
      let oe = 0, le = 0;
      for (; le < re && oe < g.sections.length; ) {
        const se = g.sections[oe];
        oe += 1, le += `${se.startSeparator}${se.value || se.placeholder}${se.endSeparator}`.length;
      }
      b(oe - 1);
    }) : $ ? M.current.getRoot().contains(U.target) || b(T.startIndex) : (N(!0), b(T.startIndex)));
  }), B = xe((U) => {
    if (l == null || l(U), !M.current || v !== "all")
      return;
    const re = U.target.textContent ?? "";
    M.current.getRoot().innerHTML = g.sections.map((oe) => `${oe.startSeparator}${oe.value || oe.placeholder}${oe.endSeparator}`).join(""), A.syncSelectionToDOM(), re.length === 0 || re.charCodeAt(0) === 10 ? (m(), w(), b("all")) : re.length > 1 ? S(re) : (v === "all" && b(0), p({
      keyPressed: re,
      sectionIndex: 0
    }));
  }), V = xe((U) => {
    if (c == null || c(U), n || v !== "all") {
      U.preventDefault();
      return;
    }
    const X = U.clipboardData.getData("text");
    U.preventDefault(), m(), S(X);
  }), _ = xe((...U) => {
    if (a == null || a(...U), $ || !M.current)
      return;
    N(!0), M.current.getSectionIndexFromDOMElement(so(document)) != null || b(T.startIndex);
  }), z = xe((...U) => {
    s == null || s(...U), setTimeout(() => {
      if (!M.current)
        return;
      const X = so(document);
      !M.current.getRoot().contains(X) && (N(!1), b(null));
    });
  }), j = xe((U) => (X) => {
    X.isDefaultPrevented() || b(U);
  }), W = xe((U) => {
    U.preventDefault();
  }), J = xe((U) => () => {
    b(U);
  }), G = xe((U) => {
    if (U.preventDefault(), n || t || typeof v != "number")
      return;
    const X = g.sections[v], re = U.clipboardData.getData("text"), oe = /^[a-zA-Z]+$/.test(re), le = /^[0-9]+$/.test(re), se = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(re);
    X.contentType === "letter" && oe || X.contentType === "digit" && le || X.contentType === "digit-with-letter" && se ? (m(), x({
      activeSection: X,
      newSectionValue: re,
      shouldGoToNextSection: !0
    })) : !oe && !le && (m(), S(re));
  }), q = xe((U) => {
    U.preventDefault(), U.dataTransfer.dropEffect = "none";
  }), Z = xe((U) => {
    if (!M.current)
      return;
    const X = U.target, re = X.textContent ?? "", oe = M.current.getSectionIndexFromDOMElement(X), le = g.sections[oe];
    if (n || !M.current) {
      k(oe);
      return;
    }
    if (re.length === 0) {
      if (le.value === "") {
        k(oe);
        return;
      }
      const se = U.nativeEvent.inputType;
      if (se === "insertParagraph" || se === "insertLineBreak") {
        k(oe);
        return;
      }
      m(), y();
      return;
    }
    p({
      keyPressed: re,
      sectionIndex: oe
    }), k(oe);
  });
  yt(() => {
    if (!(!$ || !M.current)) {
      if (v === "all")
        M.current.getRoot().focus();
      else if (typeof v == "number") {
        const U = M.current.getSectionContent(v);
        U && U.focus();
      }
    }
  }, [v, $]);
  const Y = h.useMemo(() => g.sections.reduce((U, X) => (U[X.type] = O[X.type]({
    currentDate: null,
    contentType: X.contentType,
    format: X.format
  }), U), {}), [O, g.sections]), Q = v === "all", ee = h.useMemo(() => g.sections.map((U, X) => {
    const re = !Q && !t && !n;
    return {
      container: {
        "data-sectionindex": X,
        onClick: j(X)
      },
      content: {
        tabIndex: Q || X > 0 ? -1 : 0,
        contentEditable: !Q && !t && !n,
        role: "spinbutton",
        id: `${F}-${U.type}`,
        "aria-labelledby": `${F}-${U.type}`,
        "aria-readonly": n,
        "aria-valuenow": Fre(U, P),
        "aria-valuemin": Y[U.type].minimum,
        "aria-valuemax": Y[U.type].maximum,
        "aria-valuetext": U.value ? Are(U, P) : R.empty,
        "aria-label": R[U.type],
        "aria-disabled": t,
        spellCheck: re ? !1 : void 0,
        autoCapitalize: re ? "off" : void 0,
        autoCorrect: re ? "off" : void 0,
        [parseInt(h.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: re ? "next" : void 0,
        children: U.value || U.placeholder,
        onInput: Z,
        onPaste: G,
        onFocus: J(X),
        onDragOver: q,
        onMouseUp: W,
        inputMode: U.contentType === "letter" ? "text" : "numeric"
      },
      before: {
        children: U.startSeparator
      },
      after: {
        children: U.endSeparator
      }
    };
  }), [g.sections, J, G, q, Z, j, W, t, n, Q, R, P, Y, F]), ne = xe((U) => {
    S(U.target.value);
  }), H = h.useMemo(() => E ? "" : f.getV7HiddenInputValueFromSections(g.sections), [E, g.sections, f]);
  return h.useEffect(() => {
    if (M.current == null)
      throw new Error(["MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`", "You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.", "", "If you want to keep using an `<input />` HTML element for the editing, please remove the `enableAccessibleFieldDOMStructure` prop from your picker or field component:", "", "<DatePicker slots={{ textField: MyCustomTextField }} />", "", "Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element"].join(`
`));
    d && M.current && M.current.getSectionContent(T.startIndex).focus();
  }, []), {
    interactions: A,
    returnedValue: {
      // Forwarded
      autoFocus: d,
      readOnly: n,
      focused: u ?? $,
      sectionListRef: D,
      onBlur: z,
      onClick: L,
      onFocus: _,
      onInput: B,
      onPaste: V,
      // Additional
      enableAccessibleFieldDOMStructure: !0,
      elements: ee,
      // TODO v7: Try to set to undefined when there is a section selected.
      tabIndex: v === 0 ? -1 : 0,
      contentEditable: Q,
      value: H,
      onChange: ne,
      areAllSectionsEmpty: E
    }
  };
}, Fa = (e) => e.replace(/[\u2066\u2067\u2068\u2069]/g, ""), sse = (e, t, n) => {
  let o = 0, s = n ? 1 : 0;
  const i = [];
  for (let a = 0; a < e.length; a += 1) {
    const l = e[a], c = T0(l, n ? "input-rtl" : "input-ltr", t), u = `${l.startSeparator}${c}${l.endSeparator}`, d = Fa(u).length, f = u.length, p = Fa(c), m = s + (p === "" ? 0 : c.indexOf(p[0])) + l.startSeparator.length, b = m + p.length;
    i.push(I({}, l, {
      start: o,
      end: o + d,
      startInInput: m,
      endInInput: b
    })), o += d, s += f;
  }
  return i;
}, ise = (e) => {
  const t = _t(), n = h.useRef(void 0), o = h.useRef(void 0), {
    forwardedProps: {
      onFocus: s,
      onClick: i,
      onPaste: a,
      onBlur: l,
      inputRef: c,
      placeholder: u
    },
    internalProps: {
      readOnly: d = !1,
      disabled: f = !1
    },
    parsedSelectedSections: p,
    activeSectionIndex: m,
    state: b,
    fieldValueManager: v,
    valueManager: g,
    applyCharacterEditing: y,
    resetCharacterQuery: w,
    updateSectionValue: x,
    updateValueFromValueStr: S,
    clearActiveSection: T,
    clearValue: E,
    setTempAndroidValueStr: O,
    setSelectedSections: M,
    getSectionsFromValue: D,
    areAllSectionsEmpty: R,
    localizedDigits: P
  } = e, F = h.useRef(null), $ = tt(c, F), N = h.useMemo(() => sse(b.sections, P, t), [b.sections, P, t]), A = h.useMemo(() => ({
    syncSelectionToDOM: () => {
      if (!F.current)
        return;
      if (p == null) {
        F.current.scrollLeft && (F.current.scrollLeft = 0);
        return;
      }
      if (F.current !== so(document))
        return;
      const Z = F.current.scrollTop;
      if (p === "all")
        F.current.select();
      else {
        const Y = N[p], Q = Y.type === "empty" ? Y.startInInput - Y.startSeparator.length : Y.startInInput, ee = Y.type === "empty" ? Y.endInInput + Y.endSeparator.length : Y.endInInput;
        (Q !== F.current.selectionStart || ee !== F.current.selectionEnd) && F.current === so(document) && F.current.setSelectionRange(Q, ee), clearTimeout(o.current), o.current = setTimeout(() => {
          F.current && F.current === so(document) && // The section might loose all selection, where `selectionStart === selectionEnd`
          // https://github.com/mui/mui-x/pull/13652
          F.current.selectionStart === F.current.selectionEnd && (F.current.selectionStart !== Q || F.current.selectionEnd !== ee) && A.syncSelectionToDOM();
        });
      }
      F.current.scrollTop = Z;
    },
    getActiveSectionIndexFromDOM: () => {
      const Z = F.current.selectionStart ?? 0, Y = F.current.selectionEnd ?? 0;
      if (Z === 0 && Y === 0)
        return null;
      const Q = Z <= N[0].startInInput ? 1 : N.findIndex((ee) => ee.startInInput - ee.startSeparator.length > Z);
      return Q === -1 ? N.length - 1 : Q - 1;
    },
    focusField: (Z = 0) => {
      var Y;
      so(document) !== F.current && ((Y = F.current) == null || Y.focus(), M(Z));
    },
    setSelectedSections: (Z) => M(Z),
    isFieldFocused: () => F.current === so(document)
  }), [F, p, N, M]), k = () => {
    const Z = F.current.selectionStart ?? 0;
    let Y;
    Z <= N[0].startInInput || Z >= N[N.length - 1].endInInput ? Y = 1 : Y = N.findIndex((ee) => ee.startInInput - ee.startSeparator.length > Z);
    const Q = Y === -1 ? N.length - 1 : Y - 1;
    M(Q);
  }, L = xe((...Z) => {
    s == null || s(...Z);
    const Y = F.current;
    clearTimeout(n.current), n.current = setTimeout(() => {
      !Y || Y !== F.current || m == null && (// avoid selecting all sections when focusing empty field without value
      Y.value.length && Number(Y.selectionEnd) - Number(Y.selectionStart) === Y.value.length ? M("all") : k());
    });
  }), B = xe((Z, ...Y) => {
    Z.isDefaultPrevented() || (i == null || i(Z, ...Y), k());
  }), V = xe((Z) => {
    if (a == null || a(Z), Z.preventDefault(), d || f)
      return;
    const Y = Z.clipboardData.getData("text");
    if (typeof p == "number") {
      const Q = b.sections[p], ee = /^[a-zA-Z]+$/.test(Y), ne = /^[0-9]+$/.test(Y), H = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(Y);
      if (Q.contentType === "letter" && ee || Q.contentType === "digit" && ne || Q.contentType === "digit-with-letter" && H) {
        w(), x({
          activeSection: Q,
          newSectionValue: Y,
          shouldGoToNextSection: !0
        });
        return;
      }
      if (ee || ne)
        return;
    }
    w(), S(Y);
  }), _ = xe((...Z) => {
    l == null || l(...Z), M(null);
  }), z = xe((Z) => {
    if (d)
      return;
    const Y = Z.target.value;
    if (Y === "") {
      w(), E();
      return;
    }
    const Q = Z.nativeEvent.data, ee = Q && Q.length > 1, ne = ee ? Q : Y, H = Fa(ne);
    if (p === "all" && M(m), m == null || ee) {
      S(ee ? Q : H);
      return;
    }
    let U;
    if (p === "all" && H.length === 1)
      U = H;
    else {
      const X = Fa(v.getV6InputValueFromSections(N, P, t));
      let re = -1, oe = -1;
      for (let $e = 0; $e < X.length; $e += 1)
        re === -1 && X[$e] !== H[$e] && (re = $e), oe === -1 && X[X.length - $e - 1] !== H[H.length - $e - 1] && (oe = $e);
      const le = N[m];
      if (re < le.start || X.length - oe - 1 > le.end)
        return;
      const Ce = H.length - X.length + le.end - Fa(le.endSeparator || "").length;
      U = H.slice(le.start + Fa(le.startSeparator || "").length, Ce);
    }
    if (U.length === 0) {
      Nre() && O(ne), w(), T();
      return;
    }
    y({
      keyPressed: U,
      sectionIndex: m
    });
  }), j = h.useMemo(() => u !== void 0 ? u : v.getV6InputValueFromSections(D(g.emptyValue), P, t), [u, v, D, g.emptyValue, P, t]), W = h.useMemo(() => b.tempValueStrAndroid ?? v.getV6InputValueFromSections(b.sections, P, t), [b.sections, v, b.tempValueStrAndroid, P, t]);
  h.useEffect(() => (F.current && F.current === so(document) && M("all"), () => {
    clearTimeout(n.current), clearTimeout(o.current);
  }), []);
  const J = h.useMemo(() => m == null || b.sections[m].contentType === "letter" ? "text" : "numeric", [m, b.sections]), q = !(F.current && F.current === so(document)) && R;
  return {
    interactions: A,
    returnedValue: {
      // Forwarded
      readOnly: d,
      onBlur: _,
      onClick: B,
      onFocus: L,
      onPaste: V,
      inputRef: $,
      // Additional
      enableAccessibleFieldDOMStructure: !1,
      placeholder: j,
      inputMode: J,
      autoComplete: "off",
      value: q ? "" : W,
      onChange: z
    }
  };
}, MN = (e) => {
  const t = Wt(), {
    internalProps: n,
    internalProps: {
      unstableFieldRef: o,
      minutesStep: s,
      enableAccessibleFieldDOMStructure: i = !1,
      disabled: a = !1,
      readOnly: l = !1
    },
    forwardedProps: {
      onKeyDown: c,
      error: u,
      clearable: d,
      onClear: f
    },
    fieldValueManager: p,
    valueManager: m,
    validator: b
  } = e, v = _t(), g = tse(e), {
    state: y,
    activeSectionIndex: w,
    parsedSelectedSections: x,
    setSelectedSections: S,
    clearValue: T,
    clearActiveSection: E,
    updateSectionValue: O,
    setTempAndroidValueStr: M,
    sectionsValueBoundaries: D,
    localizedDigits: R,
    timezone: P
  } = g, F = ose({
    sections: y.sections,
    updateSectionValue: O,
    sectionsValueBoundaries: D,
    localizedDigits: R,
    setTempAndroidValueStr: M,
    timezone: P
  }), {
    resetCharacterQuery: $
  } = F, N = m.areValuesEqual(t, y.value, m.emptyValue), A = i ? rse : ise, k = h.useMemo(() => $re(y.sections, v && !i), [y.sections, v, i]), {
    returnedValue: L,
    interactions: B
  } = A(I({}, e, g, F, {
    areAllSectionsEmpty: N,
    sectionOrder: k
  })), V = xe((G) => {
    if (c == null || c(G), !a)
      switch (!0) {
        // Select all
        case ((G.ctrlKey || G.metaKey) && String.fromCharCode(G.keyCode) === "A" && !G.shiftKey && !G.altKey): {
          G.preventDefault(), S("all");
          break;
        }
        // Move selection to next section
        case G.key === "ArrowRight": {
          if (G.preventDefault(), x == null)
            S(k.startIndex);
          else if (x === "all")
            S(k.endIndex);
          else {
            const q = k.neighbors[x].rightIndex;
            q !== null && S(q);
          }
          break;
        }
        // Move selection to previous section
        case G.key === "ArrowLeft": {
          if (G.preventDefault(), x == null)
            S(k.endIndex);
          else if (x === "all")
            S(k.startIndex);
          else {
            const q = k.neighbors[x].leftIndex;
            q !== null && S(q);
          }
          break;
        }
        // Reset the value of the selected section
        case G.key === "Delete": {
          if (G.preventDefault(), l)
            break;
          x == null || x === "all" ? T() : E(), $();
          break;
        }
        // Increment / decrement the selected section value
        case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(G.key): {
          if (G.preventDefault(), l || w == null)
            break;
          x === "all" && S(w);
          const q = y.sections[w], Z = p.getActiveDateManager(t, y, q), Y = Pre(t, P, q, G.key, D, R, Z.date, {
            minutesStep: s
          });
          O({
            activeSection: q,
            newSectionValue: Y,
            shouldGoToNextSection: !1
          });
          break;
        }
      }
  });
  yt(() => {
    B.syncSelectionToDOM();
  });
  const {
    hasValidationError: _
  } = R0({
    props: n,
    validator: b,
    timezone: P,
    value: y.value,
    onError: n.onError
  }), z = h.useMemo(() => u !== void 0 ? u : _, [_, u]);
  h.useEffect(() => {
    !z && w == null && $();
  }, [y.referenceValue, w, z]), h.useEffect(() => {
    y.tempValueStrAndroid != null && w != null && ($(), E());
  }, [y.sections]), h.useImperativeHandle(o, () => ({
    getSections: () => y.sections,
    getActiveSectionIndex: B.getActiveSectionIndexFromDOM,
    setSelectedSections: B.setSelectedSections,
    focusField: B.focusField,
    isFieldFocused: B.isFieldFocused
  }));
  const j = xe((G, ...q) => {
    G.preventDefault(), f == null || f(G, ...q), T(), B.isFieldFocused() ? S(k.startIndex) : B.focusField(0);
  }), W = {
    onKeyDown: V,
    onClear: j,
    error: z,
    clearable: !!(d && !N && !l && !a)
  }, J = {
    disabled: a,
    readOnly: l
  };
  return I({}, e.forwardedProps, W, J, L);
}, ase = ["clearable", "onClear", "InputProps", "sx", "slots", "slotProps"], lse = ["ownerState"], kN = (e) => {
  const t = er(), {
    clearable: n,
    onClear: o,
    InputProps: s,
    sx: i,
    slots: a,
    slotProps: l
  } = e, c = ve(e, ase), u = (a == null ? void 0 : a.clearButton) ?? Eo, d = et({
    elementType: u,
    externalSlotProps: l == null ? void 0 : l.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: t.fieldClearLabel
    }
  }), f = ve(d, lse), p = (a == null ? void 0 : a.clearIcon) ?? cre, m = et({
    elementType: p,
    externalSlotProps: l == null ? void 0 : l.clearIcon,
    ownerState: {}
  });
  return I({}, c, {
    InputProps: I({}, s, {
      endAdornment: /* @__PURE__ */ ie(h.Fragment, {
        children: [n && /* @__PURE__ */ C(yl, {
          position: "end",
          sx: {
            marginRight: s != null && s.endAdornment ? -1 : -1.5
          },
          children: /* @__PURE__ */ C(u, I({}, f, {
            onClick: o,
            children: /* @__PURE__ */ C(p, I({
              fontSize: "small"
            }, m))
          }))
        }), s == null ? void 0 : s.endAdornment]
      })
    }),
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(i) ? i : [i]]
  });
}, cse = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef", "enableAccessibleFieldDOMStructure", "disabled", "readOnly", "dateSeparator"], E0 = (e, t) => h.useMemo(() => {
  const n = I({}, e), o = {}, s = (i) => {
    n.hasOwnProperty(i) && (o[i] = n[i], delete n[i]);
  };
  return cse.forEach(s), PN.forEach(s), {
    forwardedProps: n,
    internalProps: o
  };
}, [e, t]), use = /* @__PURE__ */ h.createContext(null);
function rh(e) {
  const {
    contextValue: t,
    localeText: n,
    children: o
  } = e;
  return /* @__PURE__ */ C(use.Provider, {
    value: t,
    children: /* @__PURE__ */ C(eh, {
      localeText: n,
      children: o
    })
  });
}
const I0 = (e) => {
  const t = Wt(), n = ia();
  return I({}, e, {
    disablePast: e.disablePast ?? !1,
    disableFuture: e.disableFuture ?? !1,
    format: e.format ?? t.formats.keyboardDate,
    minDate: io(t, e.minDate, n.minDate),
    maxDate: io(t, e.maxDate, n.maxDate)
  });
}, Ky = (e) => {
  const t = I0(e), {
    forwardedProps: n,
    internalProps: o
  } = E0(t, "date");
  return MN({
    forwardedProps: n,
    internalProps: o,
    valueManager: ns,
    fieldValueManager: _re,
    validator: Gi,
    valueType: "date"
  });
};
function dse(e) {
  return De("MuiPickersTextField", e);
}
Ne("MuiPickersTextField", ["root", "focused", "disabled", "error", "required"]);
function fse(e) {
  return De("MuiPickersInputBase", e);
}
const ja = Ne("MuiPickersInputBase", ["root", "focused", "disabled", "error", "notchedOutline", "sectionContent", "sectionBefore", "sectionAfter", "adornedStart", "adornedEnd", "input"]);
function pse(e) {
  return De("MuiPickersSectionList", e);
}
const ec = Ne("MuiPickersSectionList", ["root", "section", "sectionContent"]), hse = ["slots", "slotProps", "elements", "sectionListRef"], DN = te("div", {
  name: "MuiPickersSectionList",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  direction: "ltr /*! @noflip */",
  outline: "none"
}), NN = te("span", {
  name: "MuiPickersSectionList",
  slot: "Section",
  overridesResolver: (e, t) => t.section
})({}), $N = te("span", {
  name: "MuiPickersSectionList",
  slot: "SectionSeparator",
  overridesResolver: (e, t) => t.sectionSeparator
})({
  whiteSpace: "pre"
}), AN = te("span", {
  name: "MuiPickersSectionList",
  slot: "SectionContent",
  overridesResolver: (e, t) => t.sectionContent
})({
  outline: "none"
}), gse = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    section: ["section"],
    sectionContent: ["sectionContent"]
  }, pse, t);
};
function FN(e) {
  const {
    slots: t,
    slotProps: n,
    element: o,
    classes: s
  } = e, i = (t == null ? void 0 : t.section) ?? NN, a = et({
    elementType: i,
    externalSlotProps: n == null ? void 0 : n.section,
    externalForwardedProps: o.container,
    className: s.section,
    ownerState: {}
  }), l = (t == null ? void 0 : t.sectionContent) ?? AN, c = et({
    elementType: l,
    externalSlotProps: n == null ? void 0 : n.sectionContent,
    externalForwardedProps: o.content,
    additionalProps: {
      suppressContentEditableWarning: !0
    },
    className: s.sectionContent,
    ownerState: {}
  }), u = (t == null ? void 0 : t.sectionSeparator) ?? $N, d = et({
    elementType: u,
    externalSlotProps: n == null ? void 0 : n.sectionSeparator,
    externalForwardedProps: o.before,
    ownerState: {
      position: "before"
    }
  }), f = et({
    elementType: u,
    externalSlotProps: n == null ? void 0 : n.sectionSeparator,
    externalForwardedProps: o.after,
    ownerState: {
      position: "after"
    }
  });
  return /* @__PURE__ */ ie(i, I({}, a, {
    children: [/* @__PURE__ */ C(u, I({}, d)), /* @__PURE__ */ C(l, I({}, c)), /* @__PURE__ */ C(u, I({}, f))]
  }));
}
process.env.NODE_ENV !== "production" && (FN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: r.object.isRequired,
  element: r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  }).isRequired,
  /**
   * The props used for each component slot.
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   */
  slots: r.object
});
const LN = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiPickersSectionList"
  }), {
    slots: s,
    slotProps: i,
    elements: a,
    sectionListRef: l
  } = o, c = ve(o, hse), u = gse(o), d = h.useRef(null), f = tt(n, d), p = (v) => {
    if (!d.current)
      throw new Error(`MUI X: Cannot call sectionListRef.${v} before the mount of the component.`);
    return d.current;
  };
  h.useImperativeHandle(l, () => ({
    getRoot() {
      return p("getRoot");
    },
    getSectionContainer(v) {
      return p("getSectionContainer").querySelector(`.${ec.section}[data-sectionindex="${v}"]`);
    },
    getSectionContent(v) {
      return p("getSectionContent").querySelector(`.${ec.section}[data-sectionindex="${v}"] .${ec.sectionContent}`);
    },
    getSectionIndexFromDOMElement(v) {
      const g = p("getSectionIndexFromDOMElement");
      if (v == null || !g.contains(v))
        return null;
      let y = null;
      return v.classList.contains(ec.section) ? y = v : v.classList.contains(ec.sectionContent) && (y = v.parentElement), y == null ? null : Number(y.dataset.sectionindex);
    }
  }));
  const m = (s == null ? void 0 : s.root) ?? DN, b = et({
    elementType: m,
    externalSlotProps: i == null ? void 0 : i.root,
    externalForwardedProps: c,
    additionalProps: {
      ref: f,
      suppressContentEditableWarning: !0
    },
    className: u.root,
    ownerState: {}
  });
  return /* @__PURE__ */ C(m, I({}, b, {
    children: b.contentEditable ? a.map(({
      content: v,
      before: g,
      after: y
    }) => `${g.children}${v.children}${y.children}`).join("") : /* @__PURE__ */ C(h.Fragment, {
      children: a.map((v, g) => /* @__PURE__ */ C(FN, {
        slots: s,
        slotProps: i,
        element: v,
        classes: u
      }, g))
    })
  }));
});
process.env.NODE_ENV !== "production" && (LN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: r.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: r.arrayOf(r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  })).isRequired,
  sectionListRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      getRoot: r.func.isRequired,
      getSectionContainer: r.func.isRequired,
      getSectionContent: r.func.isRequired,
      getSectionIndexFromDOMElement: r.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   */
  slots: r.object
});
const mse = ["elements", "areAllSectionsEmpty", "defaultValue", "label", "value", "onChange", "id", "autoFocus", "endAdornment", "startAdornment", "renderSuffix", "slots", "slotProps", "contentEditable", "tabIndex", "onInput", "onPaste", "onKeyDown", "fullWidth", "name", "readOnly", "inputProps", "inputRef", "sectionListRef"], bse = (e) => Math.round(e * 1e5) / 1e5, sh = te("div", {
  name: "MuiPickersInputBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => I({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  cursor: "text",
  padding: 0,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  letterSpacing: `${bse(0.15 / 16)}em`,
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
})), O0 = te(DN, {
  name: "MuiPickersInputBase",
  slot: "SectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})(({
  theme: e
}) => ({
  padding: "4px 0 5px",
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit",
  lineHeight: "1.4375em",
  // 23px
  flexGrow: 1,
  outline: "none",
  display: "flex",
  flexWrap: "nowrap",
  overflow: "hidden",
  letterSpacing: "inherit",
  // Baseline behavior
  width: "182px",
  variants: [{
    props: {
      isRtl: !0
    },
    style: {
      textAlign: "right /*! @noflip */"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingTop: 1
    }
  }, {
    props: {
      adornedStart: !1,
      focused: !1,
      filled: !1
    },
    style: {
      color: "currentColor",
      opacity: 0
    }
  }, {
    // Can't use the object notation because label can be null or undefined
    props: ({
      adornedStart: t,
      focused: n,
      filled: o,
      label: s
    }) => !t && !n && !o && s == null,
    style: e.vars ? {
      opacity: e.vars.opacity.inputPlaceholder
    } : {
      opacity: e.palette.mode === "light" ? 0.42 : 0.5
    }
  }]
})), yse = te(NN, {
  name: "MuiPickersInputBase",
  slot: "Section",
  overridesResolver: (e, t) => t.section
})(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit",
  letterSpacing: "inherit",
  lineHeight: "1.4375em",
  // 23px
  display: "inline-block",
  whiteSpace: "nowrap"
})), vse = te(AN, {
  name: "MuiPickersInputBase",
  slot: "SectionContent",
  overridesResolver: (e, t) => t.content
})(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  lineHeight: "1.4375em",
  // 23px
  letterSpacing: "inherit",
  width: "fit-content",
  outline: "none"
})), Cse = te($N, {
  name: "MuiPickersInputBase",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})(() => ({
  whiteSpace: "pre",
  letterSpacing: "inherit"
})), wse = te("input", {
  name: "MuiPickersInputBase",
  slot: "Input",
  overridesResolver: (e, t) => t.hiddenInput
})(I({}, Pv)), Sse = (e) => {
  const {
    focused: t,
    disabled: n,
    error: o,
    classes: s,
    fullWidth: i,
    readOnly: a,
    color: l,
    size: c,
    endAdornment: u,
    startAdornment: d
  } = e, f = {
    root: ["root", t && !n && "focused", n && "disabled", a && "readOnly", o && "error", i && "fullWidth", `color${ce(l)}`, c === "small" && "inputSizeSmall", !!d && "adornedStart", !!u && "adornedEnd"],
    notchedOutline: ["notchedOutline"],
    input: ["input"],
    sectionsContainer: ["sectionsContainer"],
    sectionContent: ["sectionContent"],
    sectionBefore: ["sectionBefore"],
    sectionAfter: ["sectionAfter"]
  };
  return fe(f, fse, s);
}, ih = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiPickersInputBase"
  }), {
    elements: s,
    areAllSectionsEmpty: i,
    value: a,
    onChange: l,
    id: c,
    endAdornment: u,
    startAdornment: d,
    renderSuffix: f,
    slots: p,
    slotProps: m,
    contentEditable: b,
    tabIndex: v,
    onInput: g,
    onPaste: y,
    onKeyDown: w,
    name: x,
    readOnly: S,
    inputProps: T,
    inputRef: E,
    sectionListRef: O
  } = o, M = ve(o, mse), D = h.useRef(null), R = tt(n, D), P = tt(T == null ? void 0 : T.ref, E), F = _t(), $ = lo();
  if (!$)
    throw new Error("MUI X: PickersInputBase should always be used inside a PickersTextField component");
  const N = (_) => {
    var z;
    if ($.disabled) {
      _.stopPropagation();
      return;
    }
    (z = $.onFocus) == null || z.call($, _);
  };
  h.useEffect(() => {
    $ && $.setAdornedStart(!!d);
  }, [$, d]), h.useEffect(() => {
    $ && (i ? $.onEmpty() : $.onFilled());
  }, [$, i]);
  const A = I({}, o, $, {
    isRtl: F
  }), k = Sse(A), L = (p == null ? void 0 : p.root) || sh, B = et({
    elementType: L,
    externalSlotProps: m == null ? void 0 : m.root,
    externalForwardedProps: M,
    additionalProps: {
      "aria-invalid": $.error,
      ref: R
    },
    className: k.root,
    ownerState: A
  }), V = (p == null ? void 0 : p.input) || O0;
  return /* @__PURE__ */ ie(L, I({}, B, {
    children: [d, /* @__PURE__ */ C(LN, {
      sectionListRef: O,
      elements: s,
      contentEditable: b,
      tabIndex: v,
      className: k.sectionsContainer,
      onFocus: N,
      onBlur: $.onBlur,
      onInput: g,
      onPaste: y,
      onKeyDown: w,
      slots: {
        root: V,
        section: yse,
        sectionContent: vse,
        sectionSeparator: Cse
      },
      slotProps: {
        root: {
          ownerState: A
        },
        sectionContent: {
          className: ja.sectionContent
        },
        sectionSeparator: ({
          position: _
        }) => ({
          className: _ === "before" ? ja.sectionBefore : ja.sectionAfter
        })
      }
    }), u, f ? f(I({}, $)) : null, /* @__PURE__ */ C(wse, I({
      name: x,
      className: k.input,
      value: a,
      onChange: l,
      id: c,
      "aria-hidden": "true",
      tabIndex: -1,
      readOnly: S,
      required: $.required,
      disabled: $.disabled
    }, T, {
      ref: P
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (ih.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: r.bool.isRequired,
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: r.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: r.arrayOf(r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  })).isRequired,
  endAdornment: r.node,
  fullWidth: r.bool,
  id: r.string,
  inputProps: r.object,
  inputRef: Lt,
  label: r.node,
  margin: r.oneOf(["dense", "none", "normal"]),
  name: r.string,
  onChange: r.func.isRequired,
  onClick: r.func.isRequired,
  onInput: r.func.isRequired,
  onKeyDown: r.func.isRequired,
  onPaste: r.func.isRequired,
  ownerState: r.any,
  readOnly: r.bool,
  renderSuffix: r.func,
  sectionListRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      getRoot: r.func.isRequired,
      getSectionContainer: r.func.isRequired,
      getSectionContent: r.func.isRequired,
      getSectionIndexFromDOMElement: r.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: r.object,
  startAdornment: r.node,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.string.isRequired
});
function xse(e) {
  return De("MuiPickersOutlinedInput", e);
}
const Sr = I({}, ja, Ne("MuiPickersOutlinedInput", ["root", "notchedOutline", "input"])), Tse = ["children", "className", "label", "notched", "shrink"], Rse = te("fieldset", {
  name: "MuiPickersOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    textAlign: "left",
    position: "absolute",
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: "0 8px",
    pointerEvents: "none",
    borderRadius: "inherit",
    borderStyle: "solid",
    borderWidth: 1,
    overflow: "hidden",
    minWidth: "0%",
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), IR = te("span")(({
  theme: e
}) => ({
  fontFamily: e.typography.fontFamily,
  fontSize: "inherit"
})), Ese = te("legend")(({
  theme: e
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: {
      withLabel: !1
    },
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: e.transitions.create("width", {
        duration: 150,
        easing: e.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      withLabel: !0
    },
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: e.transitions.create("max-width", {
        duration: 50,
        easing: e.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: {
      withLabel: !0,
      notched: !0
    },
    style: {
      maxWidth: "100%",
      transition: e.transitions.create("max-width", {
        duration: 100,
        easing: e.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
}));
function Ise(e) {
  const {
    className: t,
    label: n
  } = e, o = ve(e, Tse), s = n != null && n !== "", i = I({}, e, {
    withLabel: s
  });
  return /* @__PURE__ */ C(Rse, I({
    "aria-hidden": !0,
    className: t
  }, o, {
    ownerState: i,
    children: /* @__PURE__ */ C(Ese, {
      ownerState: i,
      children: s ? /* @__PURE__ */ C(IR, {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        /* @__PURE__ */ C(IR, {
          className: "notranslate",
          children: "​"
        })
      )
    })
  }));
}
const Ose = ["label", "autoFocus", "ownerState", "notched"], Pse = te(sh, {
  name: "MuiPickersOutlinedInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    padding: "0 14px",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${Sr.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Sr.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
      }
    },
    [`&.${Sr.focused} .${Sr.notchedOutline}`]: {
      borderStyle: "solid",
      borderWidth: 2
    },
    [`&.${Sr.disabled}`]: {
      [`& .${Sr.notchedOutline}`]: {
        borderColor: (e.vars || e).palette.action.disabled
      },
      "*": {
        color: (e.vars || e).palette.action.disabled
      }
    },
    [`&.${Sr.error} .${Sr.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    variants: Object.keys((e.vars ?? e).palette).filter((n) => {
      var o;
      return ((o = (e.vars ?? e).palette[n]) == null ? void 0 : o.main) ?? !1;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        [`&.${Sr.focused}:not(.${Sr.error}) .${Sr.notchedOutline}`]: {
          // @ts-ignore
          borderColor: (e.vars || e).palette[n].main
        }
      }
    }))
  };
}), Mse = te(O0, {
  name: "MuiPickersOutlinedInput",
  slot: "SectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})({
  padding: "16.5px 0",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 0"
    }
  }]
}), kse = (e) => {
  const {
    classes: t
  } = e, o = fe({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, xse, t);
  return I({}, t, o);
}, P0 = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiPickersOutlinedInput"
  }), {
    label: s,
    ownerState: i,
    notched: a
  } = o, l = ve(o, Ose), c = lo(), u = I({}, o, i, c, {
    color: (c == null ? void 0 : c.color) || "primary"
  }), d = kse(u);
  return /* @__PURE__ */ C(ih, I({
    slots: {
      root: Pse,
      input: Mse
    },
    renderSuffix: (f) => /* @__PURE__ */ C(Ise, {
      shrink: !!(a || f.adornedStart || f.focused || f.filled),
      notched: !!(a || f.adornedStart || f.focused || f.filled),
      className: d.notchedOutline,
      label: s != null && s !== "" && (c != null && c.required) ? /* @__PURE__ */ ie(h.Fragment, {
        children: [s, " ", "*"]
      }) : s,
      ownerState: u
    })
  }, l, {
    label: s,
    classes: d,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (P0.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: r.bool.isRequired,
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: r.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: r.arrayOf(r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  })).isRequired,
  endAdornment: r.node,
  fullWidth: r.bool,
  id: r.string,
  inputProps: r.object,
  inputRef: Lt,
  label: r.node,
  margin: r.oneOf(["dense", "none", "normal"]),
  name: r.string,
  notched: r.bool,
  onChange: r.func.isRequired,
  onClick: r.func.isRequired,
  onInput: r.func.isRequired,
  onKeyDown: r.func.isRequired,
  onPaste: r.func.isRequired,
  ownerState: r.any,
  readOnly: r.bool,
  renderSuffix: r.func,
  sectionListRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      getRoot: r.func.isRequired,
      getSectionContainer: r.func.isRequired,
      getSectionContent: r.func.isRequired,
      getSectionIndexFromDOMElement: r.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: r.object,
  startAdornment: r.node,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.string.isRequired
});
P0.muiName = "Input";
function Dse(e) {
  return De("MuiPickersFilledInput", e);
}
const ci = I({}, ja, Ne("MuiPickersFilledInput", ["root", "underline", "input"])), Nse = ["label", "autoFocus", "disableUnderline", "ownerState"], $se = te(sh, {
  name: "MuiPickersFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => Xd(e) && e !== "disableUnderline"
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light", n = t ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", o = t ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", s = t ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", i = t ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : s,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o
      }
    },
    [`&.${ci.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o
    },
    [`&.${ci.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : i
    },
    variants: [...Object.keys((e.vars ?? e).palette).filter((a) => (e.vars ?? e).palette[a].main).map((a) => {
      var l;
      return {
        props: {
          color: a,
          disableUnderline: !1
        },
        style: {
          "&::after": {
            // @ts-ignore
            borderBottom: `2px solid ${(l = (e.vars || e).palette[a]) == null ? void 0 : l.main}`
          }
        }
      };
    }), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${ci.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${ci.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : n}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${ci.disabled}, .${ci.error}):before`]: {
          borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
        },
        [`&.${ci.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, {
      props: ({
        startAdornment: a
      }) => !!a,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        endAdornment: a
      }) => !!a,
      style: {
        paddingRight: 12
      }
    }]
  };
}), Ase = te(O0, {
  name: "MuiPickersFilledInput",
  slot: "sectionsContainer",
  overridesResolver: (e, t) => t.sectionsContainer
})({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      startAdornment: e
    }) => !!e,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      endAdornment: e
    }) => !!e,
    style: {
      paddingRight: 0
    }
  }, {
    props: {
      hiddenLabel: !0
    },
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: {
      hiddenLabel: !0,
      size: "small"
    },
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }]
}), Fse = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, s = fe({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, Dse, t);
  return I({}, t, s);
}, M0 = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiPickersFilledInput"
  }), {
    label: s,
    disableUnderline: i = !1,
    ownerState: a
  } = o, l = ve(o, Nse), c = lo(), u = I({}, o, a, c, {
    color: (c == null ? void 0 : c.color) || "primary"
  }), d = Fse(u);
  return /* @__PURE__ */ C(ih, I({
    slots: {
      root: $se,
      input: Ase
    },
    slotProps: {
      root: {
        disableUnderline: i
      }
    }
  }, l, {
    label: s,
    classes: d,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (M0.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: r.bool.isRequired,
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: r.bool.isRequired,
  disableUnderline: r.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: r.arrayOf(r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  })).isRequired,
  endAdornment: r.node,
  fullWidth: r.bool,
  hiddenLabel: r.bool,
  id: r.string,
  inputProps: r.object,
  inputRef: Lt,
  label: r.node,
  margin: r.oneOf(["dense", "none", "normal"]),
  name: r.string,
  onChange: r.func.isRequired,
  onClick: r.func.isRequired,
  onInput: r.func.isRequired,
  onKeyDown: r.func.isRequired,
  onPaste: r.func.isRequired,
  ownerState: r.any,
  readOnly: r.bool,
  renderSuffix: r.func,
  sectionListRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      getRoot: r.func.isRequired,
      getSectionContainer: r.func.isRequired,
      getSectionContent: r.func.isRequired,
      getSectionIndexFromDOMElement: r.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: r.object,
  startAdornment: r.node,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.string.isRequired
});
M0.muiName = "Input";
function Lse(e) {
  return De("MuiPickersFilledInput", e);
}
const tc = I({}, ja, Ne("MuiPickersInput", ["root", "input"])), _se = ["label", "autoFocus", "disableUnderline", "ownerState"], Vse = te(sh, {
  name: "MuiPickersInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  let n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), {
    "label + &": {
      marginTop: 16
    },
    variants: [...Object.keys((e.vars ?? e).palette).filter((o) => (e.vars ?? e).palette[o].main).map((o) => ({
      props: {
        color: o
      },
      style: {
        "&::after": {
          // @ts-ignore
          borderBottom: `2px solid ${(e.vars || e).palette[o].main}`
        }
      }
    })), {
      props: {
        disableUnderline: !1
      },
      style: {
        "&::after": {
          background: "red",
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: e.transitions.create("transform", {
            duration: e.transitions.duration.shorter,
            easing: e.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${tc.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${tc.error}`]: {
          "&:before, &:after": {
            borderBottomColor: (e.vars || e).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${n}`,
          left: 0,
          bottom: 0,
          // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: e.transitions.create("border-bottom-color", {
            duration: e.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${tc.disabled}, .${tc.error}):before`]: {
          borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${n}`
          }
        },
        [`&.${tc.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }]
  };
}), Bse = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, s = fe({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, Lse, t);
  return I({}, t, s);
}, k0 = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiPickersInput"
  }), {
    label: s,
    disableUnderline: i = !1,
    ownerState: a
  } = o, l = ve(o, _se), c = lo(), u = I({}, o, a, c, {
    disableUnderline: i,
    color: (c == null ? void 0 : c.color) || "primary"
  }), d = Bse(u);
  return /* @__PURE__ */ C(ih, I({
    slots: {
      root: Vse
    }
  }, l, {
    label: s,
    classes: d,
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (k0.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: r.bool.isRequired,
  className: r.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: r.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: r.bool.isRequired,
  disableUnderline: r.bool,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: r.arrayOf(r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  })).isRequired,
  endAdornment: r.node,
  fullWidth: r.bool,
  id: r.string,
  inputProps: r.object,
  inputRef: Lt,
  label: r.node,
  margin: r.oneOf(["dense", "none", "normal"]),
  name: r.string,
  onChange: r.func.isRequired,
  onClick: r.func.isRequired,
  onInput: r.func.isRequired,
  onKeyDown: r.func.isRequired,
  onPaste: r.func.isRequired,
  ownerState: r.any,
  readOnly: r.bool,
  renderSuffix: r.func,
  sectionListRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      getRoot: r.func.isRequired,
      getSectionContainer: r.func.isRequired,
      getSectionContent: r.func.isRequired,
      getSectionIndexFromDOMElement: r.func.isRequired
    })
  })]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: r.object,
  startAdornment: r.node,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.string.isRequired
});
k0.muiName = "Input";
const zse = ["onFocus", "onBlur", "className", "color", "disabled", "error", "variant", "required", "InputProps", "inputProps", "inputRef", "sectionListRef", "elements", "areAllSectionsEmpty", "onClick", "onKeyDown", "onKeyUp", "onPaste", "onInput", "endAdornment", "startAdornment", "tabIndex", "contentEditable", "focused", "value", "onChange", "fullWidth", "id", "name", "helperText", "FormHelperTextProps", "label", "InputLabelProps"], Hse = {
  standard: k0,
  filled: M0,
  outlined: P0
}, jse = te(bl, {
  name: "MuiPickersTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Gse = (e) => {
  const {
    focused: t,
    disabled: n,
    classes: o,
    required: s
  } = e;
  return fe({
    root: ["root", t && !n && "focused", n && "disabled", s && "required"]
  }, dse, o);
}, ah = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiPickersTextField"
  }), {
    // Props used by FormControl
    onFocus: s,
    onBlur: i,
    className: a,
    color: l = "primary",
    disabled: c = !1,
    error: u = !1,
    variant: d = "outlined",
    required: f = !1,
    // Props used by PickersInput
    InputProps: p,
    inputProps: m,
    inputRef: b,
    sectionListRef: v,
    elements: g,
    areAllSectionsEmpty: y,
    onClick: w,
    onKeyDown: x,
    onKeyUp: S,
    onPaste: T,
    onInput: E,
    endAdornment: O,
    startAdornment: M,
    tabIndex: D,
    contentEditable: R,
    focused: P,
    value: F,
    onChange: $,
    fullWidth: N,
    id: A,
    name: k,
    // Props used by FormHelperText
    helperText: L,
    FormHelperTextProps: B,
    // Props used by InputLabel
    label: V,
    InputLabelProps: _
  } = o, z = ve(o, zse), j = h.useRef(null), W = tt(n, j), J = gt(A), G = L && J ? `${J}-helper-text` : void 0, q = V && J ? `${J}-label` : void 0, Z = I({}, o, {
    color: l,
    disabled: c,
    error: u,
    focused: P,
    required: f,
    variant: d
  }), Y = Gse(Z), Q = Hse[d];
  return /* @__PURE__ */ ie(jse, I({
    className: ae(Y.root, a),
    ref: W,
    focused: P,
    onFocus: s,
    onBlur: i,
    disabled: c,
    variant: d,
    error: u,
    color: l,
    fullWidth: N,
    required: f,
    ownerState: Z
  }, z, {
    children: [/* @__PURE__ */ C(Ru, I({
      htmlFor: J,
      id: q
    }, _, {
      children: V
    })), /* @__PURE__ */ C(Q, I({
      elements: g,
      areAllSectionsEmpty: y,
      onClick: w,
      onKeyDown: x,
      onKeyUp: S,
      onInput: E,
      onPaste: T,
      endAdornment: O,
      startAdornment: M,
      tabIndex: D,
      contentEditable: R,
      value: F,
      onChange: $,
      id: J,
      fullWidth: N,
      inputProps: m,
      inputRef: b,
      sectionListRef: v,
      label: V,
      name: k,
      role: "group",
      "aria-labelledby": q
    }, p)), L && /* @__PURE__ */ C(_p, I({
      id: G
    }, B, {
      children: L
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (ah.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Is `true` if the current values equals the empty value.
   * For a single item value, it means that `value === null`
   * For a range value, it means that `value === [null, null]`
   */
  areAllSectionsEmpty: r.bool.isRequired,
  className: r.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: r.elementType,
  /**
   * If true, the whole element is editable.
   * Useful when all the sections are selected.
   */
  contentEditable: r.bool.isRequired,
  disabled: r.bool.isRequired,
  /**
   * The elements to render.
   * Each element contains the prop to edit a section of the value.
   */
  elements: r.arrayOf(r.shape({
    after: r.object.isRequired,
    before: r.object.isRequired,
    container: r.object.isRequired,
    content: r.object.isRequired
  })).isRequired,
  endAdornment: r.node,
  error: r.bool.isRequired,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: r.bool,
  FormHelperTextProps: r.object,
  fullWidth: r.bool,
  /**
   * The helper text content.
   */
  helperText: r.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: r.bool,
  id: r.string,
  InputLabelProps: r.object,
  inputProps: r.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: r.object,
  inputRef: Lt,
  label: r.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: r.oneOf(["dense", "none", "normal"]),
  name: r.string,
  onBlur: r.func.isRequired,
  onChange: r.func.isRequired,
  onClick: r.func.isRequired,
  onFocus: r.func.isRequired,
  onInput: r.func.isRequired,
  onKeyDown: r.func.isRequired,
  onPaste: r.func.isRequired,
  readOnly: r.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: r.bool,
  sectionListRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      getRoot: r.func.isRequired,
      getSectionContainer: r.func.isRequired,
      getSectionContent: r.func.isRequired,
      getSectionIndexFromDOMElement: r.func.isRequired
    })
  })]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: r.oneOf(["medium", "small"]),
  startAdornment: r.node,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.string.isRequired,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
const qse = ["enableAccessibleFieldDOMStructure"], Wse = ["InputProps", "readOnly"], Use = ["onPaste", "onKeyDown", "inputMode", "readOnly", "InputProps", "inputProps", "inputRef"], Yf = (e) => {
  let {
    enableAccessibleFieldDOMStructure: t
  } = e, n = ve(e, qse);
  if (t) {
    const {
      InputProps: f,
      readOnly: p
    } = n, m = ve(n, Wse);
    return I({}, m, {
      InputProps: I({}, f ?? {}, {
        readOnly: p
      })
    });
  }
  const {
    onPaste: o,
    onKeyDown: s,
    inputMode: i,
    readOnly: a,
    InputProps: l,
    inputProps: c,
    inputRef: u
  } = n, d = ve(n, Use);
  return I({}, d, {
    InputProps: I({}, l ?? {}, {
      readOnly: a
    }),
    inputProps: I({}, c ?? {}, {
      inputMode: i,
      onPaste: o,
      onKeyDown: s,
      ref: u
    })
  });
}, Kse = ["slots", "slotProps", "InputProps", "inputProps"], D0 = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiDateField"
  }), {
    slots: s,
    slotProps: i,
    InputProps: a,
    inputProps: l
  } = o, c = ve(o, Kse), u = o, d = (s == null ? void 0 : s.textField) ?? (t.enableAccessibleFieldDOMStructure ? ah : Is), f = et({
    elementType: d,
    externalSlotProps: i == null ? void 0 : i.textField,
    externalForwardedProps: c,
    additionalProps: {
      ref: n
    },
    ownerState: u
  });
  f.inputProps = I({}, l, f.inputProps), f.InputProps = I({}, a, f.InputProps);
  const p = Ky(f), m = Yf(p), b = kN(I({}, m, {
    slots: s,
    slotProps: i
  }));
  return /* @__PURE__ */ C(d, I({}, b));
});
process.env.NODE_ENV !== "production" && (D0.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: r.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: r.elementType,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: r.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: r.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The helper text content.
   */
  helperText: r.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: r.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: r.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: r.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: r.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  onBlur: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: r.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: r.func,
  onFocus: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: r.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: r.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: r.bool,
  /**
   * The size of the component.
   */
  size: r.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: r.oneOfType([r.func, r.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
const _N = ({
  shouldDisableDate: e,
  shouldDisableMonth: t,
  shouldDisableYear: n,
  minDate: o,
  maxDate: s,
  disableFuture: i,
  disablePast: a,
  timezone: l
}) => {
  const c = sa();
  return h.useCallback((u) => Gi({
    adapter: c,
    value: u,
    timezone: l,
    props: {
      shouldDisableDate: e,
      shouldDisableMonth: t,
      shouldDisableYear: n,
      minDate: o,
      maxDate: s,
      disableFuture: i,
      disablePast: a
    }
  }) !== null, [c, e, t, n, o, s, i, a, l]);
}, Yse = (e, t, n) => (o, s) => {
  switch (s.type) {
    case "changeMonth":
      return I({}, o, {
        slideDirection: s.direction,
        currentMonth: s.newMonth,
        isMonthSwitchingAnimating: !e
      });
    case "changeMonthTimezone": {
      const i = s.newTimezone;
      if (n.getTimezone(o.currentMonth) === i)
        return o;
      let a = n.setTimezone(o.currentMonth, i);
      return n.getMonth(a) !== n.getMonth(o.currentMonth) && (a = n.setMonth(a, n.getMonth(o.currentMonth))), I({}, o, {
        currentMonth: a
      });
    }
    case "finishMonthSwitchingAnimation":
      return I({}, o, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (o.focusedDay != null && s.focusedDay != null && n.isSameDay(s.focusedDay, o.focusedDay))
        return o;
      const i = s.focusedDay != null && !t && !n.isSameMonth(o.currentMonth, s.focusedDay);
      return I({}, o, {
        focusedDay: s.focusedDay,
        isMonthSwitchingAnimating: i && !e && !s.withoutMonthSwitchingAnimation,
        currentMonth: i ? n.startOfMonth(s.focusedDay) : o.currentMonth,
        slideDirection: s.focusedDay != null && n.isAfterDay(s.focusedDay, o.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
}, VN = (e) => {
  const {
    value: t,
    referenceDate: n,
    disableFuture: o,
    disablePast: s,
    disableSwitchToMonthOnDayFocus: i = !1,
    maxDate: a,
    minDate: l,
    onMonthChange: c,
    reduceAnimations: u,
    shouldDisableDate: d,
    timezone: f
  } = e, p = Wt(), m = h.useRef(Yse(!!u, i, p)).current, b = h.useMemo(
    () => ns.getInitialReferenceValue({
      value: t,
      utils: p,
      timezone: f,
      props: e,
      referenceDate: n,
      granularity: zr.day
    }),
    // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, f]
  ), [v, g] = h.useReducer(m, {
    isMonthSwitchingAnimating: !1,
    focusedDay: b,
    currentMonth: p.startOfMonth(b),
    slideDirection: "left"
  });
  h.useEffect(() => {
    g({
      type: "changeMonthTimezone",
      newTimezone: p.getTimezone(b)
    });
  }, [b, p]);
  const y = h.useCallback((E) => {
    g(I({
      type: "changeMonth"
    }, E)), c && c(E.newMonth);
  }, [c]), w = h.useCallback((E) => {
    const O = E;
    p.isSameMonth(O, v.currentMonth) || y({
      newMonth: p.startOfMonth(O),
      direction: p.isAfterDay(O, v.currentMonth) ? "left" : "right"
    });
  }, [v.currentMonth, y, p]), x = _N({
    shouldDisableDate: d,
    minDate: l,
    maxDate: a,
    disableFuture: o,
    disablePast: s,
    timezone: f
  }), S = h.useCallback(() => {
    g({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), T = xe((E, O) => {
    x(E) || g({
      type: "changeFocusedDay",
      focusedDay: E,
      withoutMonthSwitchingAnimation: O
    });
  });
  return {
    referenceDate: b,
    calendarState: v,
    changeMonth: w,
    changeFocusedDay: T,
    isDateDisabled: x,
    onMonthSwitchingAnimationEnd: S,
    handleChangeMonth: y
  };
}, Xse = (e) => De("MuiPickersFadeTransitionGroup", e);
Ne("MuiPickersFadeTransitionGroup", ["root"]);
const Qse = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, Xse, t);
}, Zse = te(vu, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "block",
  position: "relative"
});
function BN(e) {
  const t = Et({
    props: e,
    name: "MuiPickersFadeTransitionGroup"
  }), {
    children: n,
    className: o,
    reduceAnimations: s,
    transKey: i
  } = t, a = Qse(t), l = sn();
  return s ? n : /* @__PURE__ */ C(Zse, {
    className: ae(a.root, o),
    children: /* @__PURE__ */ C(ti, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: l.transitions.duration.enteringScreen,
        enter: l.transitions.duration.enteringScreen,
        exit: 0
      },
      children: n
    }, i)
  });
}
const Jse = (e) => De("MuiPickersSlideTransition", e), or = Ne("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), eie = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"], tie = (e) => {
  const {
    classes: t,
    slideDirection: n
  } = e, o = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${n}`],
    exitActive: [`slideExitActiveLeft-${n}`]
  };
  return fe(o, Jse, t);
}, nie = te(vu, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`.${or["slideEnter-left"]}`]: t["slideEnter-left"]
  }, {
    [`.${or["slideEnter-right"]}`]: t["slideEnter-right"]
  }, {
    [`.${or.slideEnterActive}`]: t.slideEnterActive
  }, {
    [`.${or.slideExit}`]: t.slideExit
  }, {
    [`.${or["slideExitActiveLeft-left"]}`]: t["slideExitActiveLeft-left"]
  }, {
    [`.${or["slideExitActiveLeft-right"]}`]: t["slideExitActiveLeft-right"]
  }]
})(({
  theme: e
}) => {
  const t = e.transitions.create("transform", {
    duration: e.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${or["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${or["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${or.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: t
    },
    [`& .${or.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${or["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: t,
      zIndex: 0
    },
    [`& .${or["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: t,
      zIndex: 0
    }
  };
});
function oie(e) {
  const t = Et({
    props: e,
    name: "MuiPickersSlideTransition"
  }), {
    children: n,
    className: o,
    reduceAnimations: s,
    transKey: i
    // extracting `classes` from `other`
  } = t, a = ve(t, eie), l = tie(t), c = sn();
  if (s)
    return /* @__PURE__ */ C("div", {
      className: ae(l.root, o),
      children: n
    });
  const u = {
    exit: l.exit,
    enterActive: l.enterActive,
    enter: l.enter,
    exitActive: l.exitActive
  };
  return /* @__PURE__ */ C(nie, {
    className: ae(l.root, o),
    childFactory: (d) => /* @__PURE__ */ h.cloneElement(d, {
      classNames: u
    }),
    role: "presentation",
    children: /* @__PURE__ */ C(Av, I({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: c.transitions.duration.complex,
      classNames: u
    }, a, {
      children: n
    }), i)
  });
}
const rie = (e) => De("MuiDayCalendar", e);
Ne("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
const sie = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], iie = ["ownerState"], aie = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  }, rie, t);
}, zN = (nu + zu * 2) * 6, lie = te("div", {
  name: "MuiDayCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), cie = te("div", {
  name: "MuiDayCalendar",
  slot: "Header",
  overridesResolver: (e, t) => t.header
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), uie = te(yn, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel",
  overridesResolver: (e, t) => t.weekDayLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (e.vars || e).palette.text.secondary
})), die = te(yn, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel",
  overridesResolver: (e, t) => t.weekNumberLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: e.palette.text.disabled
})), fie = te(yn, {
  name: "MuiDayCalendar",
  slot: "WeekNumber",
  overridesResolver: (e, t) => t.weekNumber
})(({
  theme: e
}) => I({}, e.typography.caption, {
  width: nu,
  height: nu,
  padding: 0,
  margin: `0 ${zu}px`,
  color: e.palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
})), pie = te("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer",
  overridesResolver: (e, t) => t.loadingContainer
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: zN
}), hie = te(oie, {
  name: "MuiDayCalendar",
  slot: "SlideTransition",
  overridesResolver: (e, t) => t.slideTransition
})({
  minHeight: zN
}), gie = te("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer",
  overridesResolver: (e, t) => t.monthContainer
})({
  overflow: "hidden"
}), mie = te("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer",
  overridesResolver: (e, t) => t.weekContainer
})({
  margin: `${zu}px 0`,
  display: "flex",
  justifyContent: "center"
});
function bie(e) {
  let {
    parentProps: t,
    day: n,
    focusableDay: o,
    selectedDays: s,
    isDateDisabled: i,
    currentMonthNumber: a,
    isViewFocused: l
  } = e, c = ve(e, sie);
  const {
    disabled: u,
    disableHighlightToday: d,
    isMonthSwitchingAnimating: f,
    showDaysOutsideCurrentMonth: p,
    slots: m,
    slotProps: b,
    timezone: v
  } = t, g = Wt(), y = Bu(v), w = o !== null && g.isSameDay(n, o), x = s.some((F) => g.isSameDay(F, n)), S = g.isSameDay(n, y), T = (m == null ? void 0 : m.day) ?? ON, E = et({
    elementType: T,
    externalSlotProps: b == null ? void 0 : b.day,
    additionalProps: I({
      disableHighlightToday: d,
      showDaysOutsideCurrentMonth: p,
      role: "gridcell",
      isAnimating: f,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": g.toJsDate(n).valueOf()
    }, c),
    ownerState: I({}, t, {
      day: n,
      selected: x
    })
  }), O = ve(E, iie), M = h.useMemo(() => u || i(n), [u, i, n]), D = h.useMemo(() => g.getMonth(n) !== a, [g, n, a]), R = h.useMemo(() => {
    const F = g.startOfMonth(g.setMonth(n, a));
    return p ? g.isSameDay(n, g.startOfWeek(F)) : g.isSameDay(n, F);
  }, [a, n, p, g]), P = h.useMemo(() => {
    const F = g.endOfMonth(g.setMonth(n, a));
    return p ? g.isSameDay(n, g.endOfWeek(F)) : g.isSameDay(n, F);
  }, [a, n, p, g]);
  return /* @__PURE__ */ C(T, I({}, O, {
    day: n,
    disabled: M,
    autoFocus: l && w,
    today: S,
    outsideCurrentMonth: D,
    isFirstVisibleCell: R,
    isLastVisibleCell: P,
    selected: x,
    tabIndex: w ? 0 : -1,
    "aria-selected": x,
    "aria-current": S ? "date" : void 0
  }));
}
function HN(e) {
  const t = Et({
    props: e,
    name: "MuiDayCalendar"
  }), n = Wt(), {
    onFocusedDayChange: o,
    className: s,
    currentMonth: i,
    selectedDays: a,
    focusedDay: l,
    loading: c,
    onSelectedDaysChange: u,
    onMonthSwitchingAnimationEnd: d,
    readOnly: f,
    reduceAnimations: p,
    renderLoading: m = () => /* @__PURE__ */ C("span", {
      children: "..."
    }),
    slideDirection: b,
    TransitionProps: v,
    disablePast: g,
    disableFuture: y,
    minDate: w,
    maxDate: x,
    shouldDisableDate: S,
    shouldDisableMonth: T,
    shouldDisableYear: E,
    dayOfWeekFormatter: O = (oe) => n.format(oe, "weekdayShort").charAt(0).toUpperCase(),
    hasFocus: M,
    onFocusedViewChange: D,
    gridLabelId: R,
    displayWeekNumber: P,
    fixedWeekNumber: F,
    autoFocus: $,
    timezone: N
  } = t, A = Bu(N), k = aie(t), L = _t(), B = _N({
    shouldDisableDate: S,
    shouldDisableMonth: T,
    shouldDisableYear: E,
    minDate: w,
    maxDate: x,
    disablePast: g,
    disableFuture: y,
    timezone: N
  }), V = er(), [_, z] = jn({
    name: "DayCalendar",
    state: "hasFocus",
    controlled: M,
    default: $ ?? !1
  }), [j, W] = h.useState(() => l || A), J = xe((oe) => {
    f || u(oe);
  }), G = (oe) => {
    B(oe) || (o(oe), W(oe), D == null || D(!0), z(!0));
  }, q = xe((oe, le) => {
    switch (oe.key) {
      case "ArrowUp":
        G(n.addDays(le, -7)), oe.preventDefault();
        break;
      case "ArrowDown":
        G(n.addDays(le, 7)), oe.preventDefault();
        break;
      case "ArrowLeft": {
        const se = n.addDays(le, L ? 1 : -1), Ce = n.addMonths(le, L ? 1 : -1), $e = kc({
          utils: n,
          date: se,
          minDate: L ? se : n.startOfMonth(Ce),
          maxDate: L ? n.endOfMonth(Ce) : se,
          isDateDisabled: B,
          timezone: N
        });
        G($e || se), oe.preventDefault();
        break;
      }
      case "ArrowRight": {
        const se = n.addDays(le, L ? -1 : 1), Ce = n.addMonths(le, L ? -1 : 1), $e = kc({
          utils: n,
          date: se,
          minDate: L ? n.startOfMonth(Ce) : se,
          maxDate: L ? se : n.endOfMonth(Ce),
          isDateDisabled: B,
          timezone: N
        });
        G($e || se), oe.preventDefault();
        break;
      }
      case "Home":
        G(n.startOfWeek(le)), oe.preventDefault();
        break;
      case "End":
        G(n.endOfWeek(le)), oe.preventDefault();
        break;
      case "PageUp":
        G(n.addMonths(le, 1)), oe.preventDefault();
        break;
      case "PageDown":
        G(n.addMonths(le, -1)), oe.preventDefault();
        break;
    }
  }), Z = xe((oe, le) => G(le)), Y = xe((oe, le) => {
    _ && n.isSameDay(j, le) && (D == null || D(!1));
  }), Q = n.getMonth(i), ee = n.getYear(i), ne = h.useMemo(() => a.filter((oe) => !!oe).map((oe) => n.startOfDay(oe)), [n, a]), H = `${ee}-${Q}`, U = h.useMemo(() => /* @__PURE__ */ h.createRef(), [H]), X = h.useMemo(() => {
    const oe = n.startOfMonth(i), le = n.endOfMonth(i);
    return B(j) || n.isAfterDay(j, le) || n.isBeforeDay(j, oe) ? kc({
      utils: n,
      date: j,
      minDate: oe,
      maxDate: le,
      disablePast: g,
      disableFuture: y,
      isDateDisabled: B,
      timezone: N
    }) : j;
  }, [i, y, g, j, B, n, N]), re = h.useMemo(() => {
    const oe = n.getWeekArray(i);
    let le = n.addMonths(i, 1);
    for (; F && oe.length < F; ) {
      const se = n.getWeekArray(le), Ce = n.isSameDay(oe[oe.length - 1][0], se[0][0]);
      se.slice(Ce ? 1 : 0).forEach(($e) => {
        oe.length < F && oe.push($e);
      }), le = n.addMonths(le, 1);
    }
    return oe;
  }, [i, F, n]);
  return /* @__PURE__ */ ie(lie, {
    role: "grid",
    "aria-labelledby": R,
    className: k.root,
    children: [/* @__PURE__ */ ie(cie, {
      role: "row",
      className: k.header,
      children: [P && /* @__PURE__ */ C(die, {
        variant: "caption",
        role: "columnheader",
        "aria-label": V.calendarWeekNumberHeaderLabel,
        className: k.weekNumberLabel,
        children: V.calendarWeekNumberHeaderText
      }), Tre(n, A).map((oe, le) => /* @__PURE__ */ C(uie, {
        variant: "caption",
        role: "columnheader",
        "aria-label": n.format(oe, "weekday"),
        className: k.weekDayLabel,
        children: O(oe)
      }, le.toString()))]
    }), c ? /* @__PURE__ */ C(pie, {
      className: k.loadingContainer,
      children: m()
    }) : /* @__PURE__ */ C(hie, I({
      transKey: H,
      onExited: d,
      reduceAnimations: p,
      slideDirection: b,
      className: ae(s, k.slideTransition)
    }, v, {
      nodeRef: U,
      children: /* @__PURE__ */ C(gie, {
        ref: U,
        role: "rowgroup",
        className: k.monthContainer,
        children: re.map((oe, le) => /* @__PURE__ */ ie(mie, {
          role: "row",
          className: k.weekContainer,
          "aria-rowindex": le + 1,
          children: [P && /* @__PURE__ */ C(fie, {
            className: k.weekNumber,
            role: "rowheader",
            "aria-label": V.calendarWeekNumberAriaLabelText(n.getWeekNumber(oe[0])),
            children: V.calendarWeekNumberText(n.getWeekNumber(oe[0]))
          }), oe.map((se, Ce) => /* @__PURE__ */ C(bie, {
            parentProps: t,
            day: se,
            selectedDays: ne,
            focusableDay: X,
            onKeyDown: q,
            onFocus: Z,
            onBlur: Y,
            onDaySelect: J,
            isDateDisabled: B,
            currentMonthNumber: Q,
            isViewFocused: _,
            "aria-colindex": Ce + 1
          }, se.toString()))]
        }, `week-${oe[0]}`))
      })
    }))]
  });
}
function yie(e) {
  return De("MuiPickersMonth", e);
}
const Pd = Ne("MuiPickersMonth", ["root", "monthButton", "disabled", "selected"]), vie = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow", "slots", "slotProps"], Cie = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: o
  } = e;
  return fe({
    root: ["root"],
    monthButton: ["monthButton", t && "disabled", n && "selected"]
  }, yie, o);
}, wie = te("div", {
  name: "MuiPickersMonth",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      monthsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), Sie = te("button", {
  name: "MuiPickersMonth",
  slot: "MonthButton",
  overridesResolver: (e, t) => [t.monthButton, {
    [`&.${Pd.disabled}`]: t.disabled
  }, {
    [`&.${Pd.selected}`]: t.selected
  }]
})(({
  theme: e
}) => I({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${Pd.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${Pd.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), xie = /* @__PURE__ */ h.memo(function(t) {
  const n = Et({
    props: t,
    name: "MuiPickersMonth"
  }), {
    autoFocus: o,
    className: s,
    children: i,
    disabled: a,
    selected: l,
    value: c,
    tabIndex: u,
    onClick: d,
    onKeyDown: f,
    onFocus: p,
    onBlur: m,
    "aria-current": b,
    "aria-label": v,
    slots: g,
    slotProps: y
  } = n, w = ve(n, vie), x = h.useRef(null), S = Cie(n);
  yt(() => {
    var O;
    o && ((O = x.current) == null || O.focus());
  }, [o]);
  const T = (g == null ? void 0 : g.monthButton) ?? Sie, E = et({
    elementType: T,
    externalSlotProps: y == null ? void 0 : y.monthButton,
    additionalProps: {
      children: i,
      disabled: a,
      tabIndex: u,
      ref: x,
      type: "button",
      role: "radio",
      "aria-current": b,
      "aria-checked": l,
      "aria-label": v,
      onClick: (O) => d(O, c),
      onKeyDown: (O) => f(O, c),
      onFocus: (O) => p(O, c),
      onBlur: (O) => m(O, c)
    },
    ownerState: n,
    className: S.monthButton
  });
  return /* @__PURE__ */ C(wie, I({
    className: ae(S.root, s),
    ownerState: n
  }, w, {
    children: /* @__PURE__ */ C(T, I({}, E))
  }));
});
function Tie(e) {
  return De("MuiMonthCalendar", e);
}
Ne("MuiMonthCalendar", ["root"]);
const Rie = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], Eie = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, Tie, t);
};
function Iie(e, t) {
  const n = Wt(), o = ia(), s = Et({
    props: e,
    name: t
  });
  return I({
    disableFuture: !1,
    disablePast: !1
  }, s, {
    minDate: io(n, s.minDate, o.minDate),
    maxDate: io(n, s.maxDate, o.maxDate)
  });
}
const Oie = te("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  padding: "0 4px",
  width: th,
  // avoid padding increasing width over defined
  boxSizing: "border-box"
}), jN = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Iie(t, "MuiMonthCalendar"), {
    className: s,
    value: i,
    defaultValue: a,
    referenceDate: l,
    disabled: c,
    disableFuture: u,
    disablePast: d,
    maxDate: f,
    minDate: p,
    onChange: m,
    shouldDisableMonth: b,
    readOnly: v,
    autoFocus: g = !1,
    onMonthFocus: y,
    hasFocus: w,
    onFocusedViewChange: x,
    monthsPerRow: S = 3,
    timezone: T,
    gridLabelId: E,
    slots: O,
    slotProps: M
  } = o, D = ve(o, Rie), {
    value: R,
    handleValueChange: P,
    timezone: F
  } = Hu({
    name: "MonthCalendar",
    timezone: T,
    value: i,
    defaultValue: a,
    referenceDate: l,
    onChange: m,
    valueManager: ns
  }), $ = Bu(F), N = _t(), A = Wt(), k = h.useMemo(
    () => ns.getInitialReferenceValue({
      value: R,
      utils: A,
      props: o,
      timezone: F,
      referenceDate: l,
      granularity: zr.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), L = o, B = Eie(L), V = h.useMemo(() => A.getMonth($), [A, $]), _ = h.useMemo(() => R != null ? A.getMonth(R) : null, [R, A]), [z, j] = h.useState(() => _ || A.getMonth(k)), [W, J] = jn({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: w,
    default: g ?? !1
  }), G = xe((H) => {
    J(H), x && x(H);
  }), q = h.useCallback((H) => {
    const U = A.startOfMonth(d && A.isAfter($, p) ? $ : p), X = A.startOfMonth(u && A.isBefore($, f) ? $ : f), re = A.startOfMonth(H);
    return A.isBefore(re, U) || A.isAfter(re, X) ? !0 : b ? b(re) : !1;
  }, [u, d, f, p, $, b, A]), Z = xe((H, U) => {
    if (v)
      return;
    const X = A.setMonth(R ?? k, U);
    P(X);
  }), Y = xe((H) => {
    q(A.setMonth(R ?? k, H)) || (j(H), G(!0), y && y(H));
  });
  h.useEffect(() => {
    j((H) => _ !== null && H !== _ ? _ : H);
  }, [_]);
  const Q = xe((H, U) => {
    switch (H.key) {
      case "ArrowUp":
        Y((12 + U - 3) % 12), H.preventDefault();
        break;
      case "ArrowDown":
        Y((12 + U + 3) % 12), H.preventDefault();
        break;
      case "ArrowLeft":
        Y((12 + U + (N ? 1 : -1)) % 12), H.preventDefault();
        break;
      case "ArrowRight":
        Y((12 + U + (N ? -1 : 1)) % 12), H.preventDefault();
        break;
    }
  }), ee = xe((H, U) => {
    Y(U);
  }), ne = xe((H, U) => {
    z === U && G(!1);
  });
  return /* @__PURE__ */ C(Oie, I({
    ref: n,
    className: ae(B.root, s),
    ownerState: L,
    role: "radiogroup",
    "aria-labelledby": E
  }, D, {
    children: v0(A, R ?? k).map((H) => {
      const U = A.getMonth(H), X = A.format(H, "monthShort"), re = A.format(H, "month"), oe = U === _, le = c || q(H);
      return /* @__PURE__ */ C(xie, {
        selected: oe,
        value: U,
        onClick: Z,
        onKeyDown: Q,
        autoFocus: W && U === z,
        disabled: le,
        tabIndex: U === z && !le ? 0 : -1,
        onFocus: ee,
        onBlur: ne,
        "aria-current": V === U ? "date" : void 0,
        "aria-label": re,
        monthsPerRow: S,
        slots: O,
        slotProps: M,
        children: X
      }, X);
    })
  }));
});
process.env.NODE_ENV !== "production" && (jN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true` picker is disabled
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  gridLabelId: r.string,
  hasFocus: r.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: r.func,
  onFocusedViewChange: r.func,
  onMonthFocus: r.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: r.object,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object
});
function Pie(e) {
  return De("MuiPickersYear", e);
}
const Md = Ne("MuiPickersYear", ["root", "yearButton", "selected", "disabled"]), Mie = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow", "slots", "slotProps"], kie = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: o
  } = e;
  return fe({
    root: ["root"],
    yearButton: ["yearButton", t && "disabled", n && "selected"]
  }, Pie, o);
}, Die = te("div", {
  name: "MuiPickersYear",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexBasis: "33.3%",
  variants: [{
    props: {
      yearsPerRow: 4
    },
    style: {
      flexBasis: "25%"
    }
  }]
}), Nie = te("button", {
  name: "MuiPickersYear",
  slot: "YearButton",
  overridesResolver: (e, t) => [t.yearButton, {
    [`&.${Md.disabled}`]: t.disabled
  }, {
    [`&.${Md.selected}`]: t.selected
  }]
})(({
  theme: e
}) => I({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "6px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.focusOpacity})` : he(e.palette.action.active, e.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : he(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${Md.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${Md.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), $ie = /* @__PURE__ */ h.memo(function(t) {
  const n = Et({
    props: t,
    name: "MuiPickersYear"
  }), {
    autoFocus: o,
    className: s,
    children: i,
    disabled: a,
    selected: l,
    value: c,
    tabIndex: u,
    onClick: d,
    onKeyDown: f,
    onFocus: p,
    onBlur: m,
    "aria-current": b,
    slots: v,
    slotProps: g
  } = n, y = ve(n, Mie), w = h.useRef(null), x = kie(n);
  yt(() => {
    var E;
    o && ((E = w.current) == null || E.focus());
  }, [o]);
  const S = (v == null ? void 0 : v.yearButton) ?? Nie, T = et({
    elementType: S,
    externalSlotProps: g == null ? void 0 : g.yearButton,
    additionalProps: {
      children: i,
      disabled: a,
      tabIndex: u,
      ref: w,
      type: "button",
      role: "radio",
      "aria-current": b,
      "aria-checked": l,
      onClick: (E) => d(E, c),
      onKeyDown: (E) => f(E, c),
      onFocus: (E) => p(E, c),
      onBlur: (E) => m(E, c)
    },
    ownerState: n,
    className: x.yearButton
  });
  return /* @__PURE__ */ C(Die, I({
    className: ae(x.root, s),
    ownerState: n
  }, y, {
    children: /* @__PURE__ */ C(S, I({}, T))
  }));
});
function Aie(e) {
  return De("MuiYearCalendar", e);
}
Ne("MuiYearCalendar", ["root"]);
const Fie = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsOrder", "yearsPerRow", "timezone", "gridLabelId", "slots", "slotProps"], Lie = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, Aie, t);
};
function _ie(e, t) {
  const n = Wt(), o = ia(), s = Et({
    props: e,
    name: t
  });
  return I({
    disablePast: !1,
    disableFuture: !1
  }, s, {
    yearsPerRow: s.yearsPerRow ?? 3,
    minDate: io(n, s.minDate, o.minDate),
    maxDate: io(n, s.maxDate, o.maxDate)
  });
}
const Vie = te("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  padding: "0 4px",
  width: th,
  maxHeight: wre,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative"
}), GN = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = _ie(t, "MuiYearCalendar"), {
    autoFocus: s,
    className: i,
    value: a,
    defaultValue: l,
    referenceDate: c,
    disabled: u,
    disableFuture: d,
    disablePast: f,
    maxDate: p,
    minDate: m,
    onChange: b,
    readOnly: v,
    shouldDisableYear: g,
    onYearFocus: y,
    hasFocus: w,
    onFocusedViewChange: x,
    yearsOrder: S = "asc",
    yearsPerRow: T,
    timezone: E,
    gridLabelId: O,
    slots: M,
    slotProps: D
  } = o, R = ve(o, Fie), {
    value: P,
    handleValueChange: F,
    timezone: $
  } = Hu({
    name: "YearCalendar",
    timezone: E,
    value: a,
    defaultValue: l,
    referenceDate: c,
    onChange: b,
    valueManager: ns
  }), N = Bu($), A = _t(), k = Wt(), L = h.useMemo(
    () => ns.getInitialReferenceValue({
      value: P,
      utils: k,
      props: o,
      timezone: $,
      referenceDate: c,
      granularity: zr.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), B = o, V = Lie(B), _ = h.useMemo(() => k.getYear(N), [k, N]), z = h.useMemo(() => P != null ? k.getYear(P) : null, [P, k]), [j, W] = h.useState(() => z || k.getYear(L)), [J, G] = jn({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: w,
    default: s ?? !1
  }), q = xe((se) => {
    G(se), x && x(se);
  }), Z = h.useCallback((se) => {
    if (f && k.isBeforeYear(se, N) || d && k.isAfterYear(se, N) || m && k.isBeforeYear(se, m) || p && k.isAfterYear(se, p))
      return !0;
    if (!g)
      return !1;
    const Ce = k.startOfYear(se);
    return g(Ce);
  }, [d, f, p, m, N, g, k]), Y = xe((se, Ce) => {
    if (v)
      return;
    const $e = k.setYear(P ?? L, Ce);
    F($e);
  }), Q = xe((se) => {
    Z(k.setYear(P ?? L, se)) || (W(se), q(!0), y == null || y(se));
  });
  h.useEffect(() => {
    W((se) => z !== null && se !== z ? z : se);
  }, [z]);
  const ee = S !== "desc" ? T * 1 : T * -1, ne = A && S === "asc" || !A && S === "desc" ? -1 : 1, H = xe((se, Ce) => {
    switch (se.key) {
      case "ArrowUp":
        Q(Ce - ee), se.preventDefault();
        break;
      case "ArrowDown":
        Q(Ce + ee), se.preventDefault();
        break;
      case "ArrowLeft":
        Q(Ce - ne), se.preventDefault();
        break;
      case "ArrowRight":
        Q(Ce + ne), se.preventDefault();
        break;
    }
  }), U = xe((se, Ce) => {
    Q(Ce);
  }), X = xe((se, Ce) => {
    j === Ce && q(!1);
  }), re = h.useRef(null), oe = tt(n, re);
  h.useEffect(() => {
    if (s || re.current === null)
      return;
    const se = re.current.querySelector('[tabindex="0"]');
    if (!se)
      return;
    const Ce = se.offsetHeight, $e = se.offsetTop, we = re.current.clientHeight, Te = re.current.scrollTop, ue = $e + Ce;
    Ce > we || $e < Te || (re.current.scrollTop = ue - we / 2 - Ce / 2);
  }, [s]);
  const le = k.getYearRange([m, p]);
  return S === "desc" && le.reverse(), /* @__PURE__ */ C(Vie, I({
    ref: oe,
    className: ae(V.root, i),
    ownerState: B,
    role: "radiogroup",
    "aria-labelledby": O
  }, R, {
    children: le.map((se) => {
      const Ce = k.getYear(se), $e = Ce === z, we = u || Z(se);
      return /* @__PURE__ */ C($ie, {
        selected: $e,
        value: Ce,
        onClick: Y,
        onKeyDown: H,
        autoFocus: J && Ce === j,
        disabled: we,
        tabIndex: Ce === j && !we ? 0 : -1,
        onFocus: U,
        onBlur: X,
        "aria-current": _ === Ce ? "date" : void 0,
        yearsPerRow: T,
        slots: M,
        slotProps: D,
        children: k.format(se, "year")
      }, k.format(se, "year"));
    })
  }));
});
process.env.NODE_ENV !== "production" && (GN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true` picker is disabled
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  gridLabelId: r.string,
  hasFocus: r.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: r.func,
  onFocusedViewChange: r.func,
  onYearFocus: r.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: r.object,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: r.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: r.oneOf([3, 4])
});
const Bie = (e) => De("MuiPickersCalendarHeader", e), zie = Ne("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]), Hie = ["slots", "slotProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone", "format"], jie = ["ownerState"], Gie = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  }, Bie, t);
}, qie = te("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  alignItems: "center",
  marginTop: 12,
  marginBottom: 4,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 40,
  minHeight: 40
}), Wie = te("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(({
  theme: e
}) => I({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, e.typography.body1, {
  fontWeight: e.typography.fontWeightMedium
})), Uie = te("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})({
  marginRight: 6
}), Kie = te(Eo, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton",
  overridesResolver: (e, t) => t.switchViewButton
})({
  marginRight: "auto",
  variants: [{
    props: {
      view: "year"
    },
    style: {
      [`.${zie.switchViewIcon}`]: {
        transform: "rotate(180deg)"
      }
    }
  }]
}), Yie = te(sre, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon",
  overridesResolver: (e, t) => t.switchViewIcon
})(({
  theme: e
}) => ({
  willChange: "transform",
  transition: e.transitions.create("transform"),
  transform: "rotate(0deg)"
})), N0 = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = er(), s = Wt(), i = Et({
    props: t,
    name: "MuiPickersCalendarHeader"
  }), {
    slots: a,
    slotProps: l,
    currentMonth: c,
    disabled: u,
    disableFuture: d,
    disablePast: f,
    maxDate: p,
    minDate: m,
    onMonthChange: b,
    onViewChange: v,
    view: g,
    reduceAnimations: y,
    views: w,
    labelId: x,
    className: S,
    timezone: T,
    format: E = `${s.formats.month} ${s.formats.year}`
  } = i, O = ve(i, Hie), M = i, D = Gie(i), R = (a == null ? void 0 : a.switchViewButton) ?? Kie, P = et({
    elementType: R,
    externalSlotProps: l == null ? void 0 : l.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": o.calendarViewSwitchingButtonAriaLabel(g)
    },
    ownerState: M,
    className: D.switchViewButton
  }), F = (a == null ? void 0 : a.switchViewIcon) ?? Yie, $ = et({
    elementType: F,
    externalSlotProps: l == null ? void 0 : l.switchViewIcon,
    ownerState: M,
    className: D.switchViewIcon
  }), N = ve($, jie), A = () => b(s.addMonths(c, 1), "left"), k = () => b(s.addMonths(c, -1), "right"), L = pN(c, {
    disableFuture: d,
    maxDate: p,
    timezone: T
  }), B = hN(c, {
    disablePast: f,
    minDate: m,
    timezone: T
  }), V = () => {
    if (!(w.length === 1 || !v || u))
      if (w.length === 2)
        v(w.find((z) => z !== g) || w[0]);
      else {
        const z = w.indexOf(g) !== 0 ? 0 : 1;
        v(w[z]);
      }
  };
  if (w.length === 1 && w[0] === "year")
    return null;
  const _ = s.formatByString(c, E);
  return /* @__PURE__ */ ie(qie, I({}, O, {
    ownerState: M,
    className: ae(D.root, S),
    ref: n,
    children: [/* @__PURE__ */ ie(Wie, {
      role: "presentation",
      onClick: V,
      ownerState: M,
      "aria-live": "polite",
      className: D.labelContainer,
      children: [/* @__PURE__ */ C(BN, {
        reduceAnimations: y,
        transKey: _,
        children: /* @__PURE__ */ C(Uie, {
          id: x,
          ownerState: M,
          className: D.label,
          children: _
        })
      }), w.length > 1 && !u && /* @__PURE__ */ C(R, I({}, P, {
        children: /* @__PURE__ */ C(F, I({}, N))
      }))]
    }), /* @__PURE__ */ C(ti, {
      in: g === "day",
      appear: !y,
      enter: !y,
      children: /* @__PURE__ */ C(fN, {
        slots: a,
        slotProps: l,
        onGoToPrevious: k,
        isPreviousDisabled: B,
        previousLabel: o.previousMonth,
        onGoToNext: A,
        isNextDisabled: L,
        nextLabel: o.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (N0.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  currentMonth: r.object.isRequired,
  disabled: r.bool,
  disableFuture: r.bool,
  disablePast: r.bool,
  /**
   * Format used to display the date.
   * @default `${adapter.formats.month} ${adapter.formats.year}`
   */
  format: r.string,
  /**
   * Id of the calendar text element.
   * It is used to establish an `aria-labelledby` relationship with the calendar `grid` element.
   */
  labelId: r.string,
  maxDate: r.object.isRequired,
  minDate: r.object.isRequired,
  onMonthChange: r.func.isRequired,
  onViewChange: r.func,
  reduceAnimations: r.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  timezone: r.string.isRequired,
  view: r.oneOf(["day", "month", "year"]).isRequired,
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const Xie = "@media (prefers-reduced-motion: reduce)", Ga = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), OR = Ga && Ga[1] ? parseInt(Ga[1], 10) : null, PR = Ga && Ga[2] ? parseInt(Ga[2], 10) : null, Qie = OR && OR < 10 || PR && PR < 13 || !1, $0 = () => Qi(Xie, {
  defaultMatches: !1
}) || Qie, Zie = (e) => De("MuiDateCalendar", e);
Ne("MuiDateCalendar", ["root", "viewTransitionContainer"]);
const Jie = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsOrder", "yearsPerRow", "monthsPerRow", "timezone"], eae = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, Zie, t);
};
function tae(e, t) {
  const n = Wt(), o = ia(), s = $0(), i = Et({
    props: e,
    name: t
  });
  return I({}, i, {
    loading: i.loading ?? !1,
    disablePast: i.disablePast ?? !1,
    disableFuture: i.disableFuture ?? !1,
    openTo: i.openTo ?? "day",
    views: i.views ?? ["year", "day"],
    reduceAnimations: i.reduceAnimations ?? s,
    renderLoading: i.renderLoading ?? (() => /* @__PURE__ */ C("span", {
      children: "..."
    })),
    minDate: io(n, i.minDate, o.minDate),
    maxDate: io(n, i.maxDate, o.maxDate)
  });
}
const nae = te(Sre, {
  name: "MuiDateCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  height: y0
}), oae = te(BN, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer",
  overridesResolver: (e, t) => t.viewTransitionContainer
})({}), qN = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Wt(), s = gt(), i = tae(t, "MuiDateCalendar"), {
    autoFocus: a,
    onViewChange: l,
    value: c,
    defaultValue: u,
    referenceDate: d,
    disableFuture: f,
    disablePast: p,
    onChange: m,
    onYearChange: b,
    onMonthChange: v,
    reduceAnimations: g,
    shouldDisableDate: y,
    shouldDisableMonth: w,
    shouldDisableYear: x,
    view: S,
    views: T,
    openTo: E,
    className: O,
    disabled: M,
    readOnly: D,
    minDate: R,
    maxDate: P,
    disableHighlightToday: F,
    focusedView: $,
    onFocusedViewChange: N,
    showDaysOutsideCurrentMonth: A,
    fixedWeekNumber: k,
    dayOfWeekFormatter: L,
    slots: B,
    slotProps: V,
    loading: _,
    renderLoading: z,
    displayWeekNumber: j,
    yearsOrder: W,
    yearsPerRow: J,
    monthsPerRow: G,
    timezone: q
  } = i, Z = ve(i, Jie), {
    value: Y,
    handleValueChange: Q,
    timezone: ee
  } = Hu({
    name: "DateCalendar",
    timezone: q,
    value: c,
    defaultValue: u,
    referenceDate: d,
    onChange: m,
    valueManager: ns
  }), {
    view: ne,
    setView: H,
    focusedView: U,
    setFocusedView: X,
    goToNextView: re,
    setValueAndGoToNextView: oe
  } = b0({
    view: S,
    views: T,
    openTo: E,
    onChange: Q,
    onViewChange: l,
    autoFocus: a,
    focusedView: $,
    onFocusedViewChange: N
  }), {
    referenceDate: le,
    calendarState: se,
    changeFocusedDay: Ce,
    changeMonth: $e,
    handleChangeMonth: we,
    isDateDisabled: Te,
    onMonthSwitchingAnimationEnd: ue
  } = VN({
    value: Y,
    referenceDate: d,
    reduceAnimations: g,
    onMonthChange: v,
    minDate: R,
    maxDate: P,
    shouldDisableDate: y,
    disablePast: p,
    disableFuture: f,
    timezone: ee
  }), de = M && Y || R, Pe = M && Y || P, ke = `${s}-grid-label`, Me = U !== null, be = (B == null ? void 0 : B.calendarHeader) ?? N0, me = et({
    elementType: be,
    externalSlotProps: V == null ? void 0 : V.calendarHeader,
    additionalProps: {
      views: T,
      view: ne,
      currentMonth: se.currentMonth,
      onViewChange: H,
      onMonthChange: (qe, st) => we({
        newMonth: qe,
        direction: st
      }),
      minDate: de,
      maxDate: Pe,
      disabled: M,
      disablePast: p,
      disableFuture: f,
      reduceAnimations: g,
      timezone: ee,
      labelId: ke
    },
    ownerState: i
  }), Ae = xe((qe) => {
    const st = o.startOfMonth(qe), wt = o.endOfMonth(qe), Ue = Te(qe) ? kc({
      utils: o,
      date: qe,
      minDate: o.isBefore(R, st) ? st : R,
      maxDate: o.isAfter(P, wt) ? wt : P,
      disablePast: p,
      disableFuture: f,
      isDateDisabled: Te,
      timezone: ee
    }) : qe;
    Ue ? (oe(Ue, "finish"), v == null || v(st)) : (re(), $e(st)), Ce(Ue, !0);
  }), ye = xe((qe) => {
    const st = o.startOfYear(qe), wt = o.endOfYear(qe), Ue = Te(qe) ? kc({
      utils: o,
      date: qe,
      minDate: o.isBefore(R, st) ? st : R,
      maxDate: o.isAfter(P, wt) ? wt : P,
      disablePast: p,
      disableFuture: f,
      isDateDisabled: Te,
      timezone: ee
    }) : qe;
    Ue ? (oe(Ue, "finish"), b == null || b(Ue)) : (re(), $e(st)), Ce(Ue, !0);
  }), We = xe((qe) => Q(qe && Ni(o, qe, Y ?? le), "finish", ne));
  h.useEffect(() => {
    Y != null && o.isValid(Y) && $e(Y);
  }, [Y]);
  const He = i, ze = eae(He), pe = {
    disablePast: p,
    disableFuture: f,
    maxDate: P,
    minDate: R
  }, Re = {
    disableHighlightToday: F,
    readOnly: D,
    disabled: M,
    timezone: ee,
    gridLabelId: ke,
    slots: B,
    slotProps: V
  }, Ge = h.useRef(ne);
  h.useEffect(() => {
    Ge.current !== ne && (U === Ge.current && X(ne, !0), Ge.current = ne);
  }, [U, X, ne]);
  const Qe = h.useMemo(() => [Y], [Y]);
  return /* @__PURE__ */ ie(nae, I({
    ref: n,
    className: ae(ze.root, O),
    ownerState: He
  }, Z, {
    children: [/* @__PURE__ */ C(be, I({}, me, {
      slots: B,
      slotProps: V
    })), /* @__PURE__ */ C(oae, {
      reduceAnimations: g,
      className: ze.viewTransitionContainer,
      transKey: ne,
      ownerState: He,
      children: /* @__PURE__ */ ie("div", {
        children: [ne === "year" && /* @__PURE__ */ C(GN, I({}, pe, Re, {
          value: Y,
          onChange: ye,
          shouldDisableYear: x,
          hasFocus: Me,
          onFocusedViewChange: (qe) => X("year", qe),
          yearsOrder: W,
          yearsPerRow: J,
          referenceDate: le
        })), ne === "month" && /* @__PURE__ */ C(jN, I({}, pe, Re, {
          hasFocus: Me,
          className: O,
          value: Y,
          onChange: Ae,
          shouldDisableMonth: w,
          onFocusedViewChange: (qe) => X("month", qe),
          monthsPerRow: G,
          referenceDate: le
        })), ne === "day" && /* @__PURE__ */ C(HN, I({}, se, pe, Re, {
          onMonthSwitchingAnimationEnd: ue,
          onFocusedDayChange: Ce,
          reduceAnimations: g,
          selectedDays: Qe,
          onSelectedDaysChange: We,
          shouldDisableDate: y,
          shouldDisableMonth: w,
          shouldDisableYear: x,
          hasFocus: Me,
          onFocusedViewChange: (qe) => X("day", qe),
          showDaysOutsideCurrentMonth: A,
          fixedWeekNumber: k,
          dayOfWeekFormatter: L,
          displayWeekNumber: j,
          loading: _,
          renderLoading: z
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (qN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Controlled focused view.
   */
  focusedView: r.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: r.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: r.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["day", "month", "year"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: r.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: r.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: r.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: r.oneOf([3, 4])
});
function WN(e) {
  return De("MuiPickersToolbar", e);
}
Ne("MuiPickersToolbar", ["root", "content"]);
const rae = ["children", "className", "toolbarTitle", "hidden", "titleId", "isLandscape", "classes", "landscapeDirection"], sae = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    content: ["content"]
  }, WN, t);
}, iae = te("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3),
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      height: "auto",
      maxWidth: 160,
      padding: 16,
      justifyContent: "flex-start",
      flexWrap: "wrap"
    }
  }]
})), aae = te("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})({
  display: "flex",
  flexWrap: "wrap",
  width: "100%",
  flex: 1,
  justifyContent: "space-between",
  alignItems: "center",
  flexDirection: "row",
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      justifyContent: "flex-start",
      alignItems: "flex-start",
      flexDirection: "column"
    }
  }, {
    props: {
      isLandscape: !0,
      landscapeDirection: "row"
    },
    style: {
      flexDirection: "row"
    }
  }]
}), UN = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiPickersToolbar"
  }), {
    children: s,
    className: i,
    toolbarTitle: a,
    hidden: l,
    titleId: c
  } = o, u = ve(o, rae), d = o, f = sae(d);
  return l ? null : /* @__PURE__ */ ie(iae, I({
    ref: n,
    className: ae(f.root, i),
    ownerState: d
  }, u, {
    children: [/* @__PURE__ */ C(yn, {
      color: "text.secondary",
      variant: "overline",
      id: c,
      children: a
    }), /* @__PURE__ */ C(aae, {
      className: f.content,
      ownerState: d,
      children: s
    })]
  }));
});
function lae(e) {
  return De("MuiDatePickerToolbar", e);
}
Ne("MuiDatePickerToolbar", ["root", "title"]);
const cae = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views", "className", "onViewChange", "view"], uae = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    title: ["title"]
  }, lae, t);
}, dae = te(UN, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), fae = te(yn, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (e, t) => t.title
})({
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      margin: "auto 16px auto auto"
    }
  }]
}), KN = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiDatePickerToolbar"
  }), {
    value: s,
    isLandscape: i,
    toolbarFormat: a,
    toolbarPlaceholder: l = "––",
    views: c,
    className: u
  } = o, d = ve(o, cae), f = Wt(), p = er(), m = uae(o), b = h.useMemo(() => {
    if (!s)
      return l;
    const g = C0(f, {
      format: a,
      views: c
    }, !0);
    return f.formatByString(s, g);
  }, [s, a, l, f, c]), v = o;
  return /* @__PURE__ */ C(dae, I({
    ref: n,
    toolbarTitle: p.datePickerToolbarTitle,
    isLandscape: i,
    className: ae(m.root, u)
  }, d, {
    children: /* @__PURE__ */ C(fae, {
      variant: "h4",
      align: i ? "left" : "center",
      ownerState: v,
      className: m.title,
      children: b
    })
  }));
});
process.env.NODE_ENV !== "production" && (KN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  disabled: r.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: r.bool,
  isLandscape: r.bool.isRequired,
  onChange: r.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: r.func.isRequired,
  readOnly: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  titleId: r.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: r.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: r.node,
  value: r.object,
  /**
   * Currently visible picker view.
   */
  view: r.oneOf(["day", "month", "year"]).isRequired,
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired).isRequired
});
function YN(e, t) {
  const n = Wt(), o = ia(), s = Et({
    props: e,
    name: t
  }), i = h.useMemo(() => {
    var a;
    return ((a = s.localeText) == null ? void 0 : a.toolbarTitle) == null ? s.localeText : I({}, s.localeText, {
      datePickerToolbarTitle: s.localeText.toolbarTitle
    });
  }, [s.localeText]);
  return I({}, s, {
    localeText: i
  }, bre({
    views: s.views,
    openTo: s.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: s.disableFuture ?? !1,
    disablePast: s.disablePast ?? !1,
    minDate: io(n, s.minDate, o.minDate),
    maxDate: io(n, s.maxDate, o.maxDate),
    slots: I({
      toolbar: KN
    }, s.slots)
  });
}
function pae(e) {
  return De("MuiPickersPopper", e);
}
Ne("MuiPickersPopper", ["root", "paper"]);
const hae = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], gae = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    paper: ["paper"]
  }, pae, t);
}, mae = te(is, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), bae = te(ao, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  outline: 0,
  transformOrigin: "top center",
  variants: [{
    props: ({
      placement: e
    }) => ["top", "top-start", "top-end"].includes(e),
    style: {
      transformOrigin: "bottom center"
    }
  }]
});
function yae(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function vae(e, t) {
  const n = h.useRef(!1), o = h.useRef(!1), s = h.useRef(null), i = h.useRef(!1);
  h.useEffect(() => {
    if (!e)
      return;
    function c() {
      i.current = !0;
    }
    return document.addEventListener("mousedown", c, !0), document.addEventListener("touchstart", c, !0), () => {
      document.removeEventListener("mousedown", c, !0), document.removeEventListener("touchstart", c, !0), i.current = !1;
    };
  }, [e]);
  const a = xe((c) => {
    if (!i.current)
      return;
    const u = o.current;
    o.current = !1;
    const d = qt(s.current);
    if (!s.current || // is a TouchEvent?
    "clientX" in c && yae(c, d))
      return;
    if (n.current) {
      n.current = !1;
      return;
    }
    let f;
    c.composedPath ? f = c.composedPath().indexOf(s.current) > -1 : f = !d.documentElement.contains(c.target) || s.current.contains(c.target), !f && !u && t(c);
  }), l = () => {
    o.current = !0;
  };
  return h.useEffect(() => {
    if (e) {
      const c = qt(s.current), u = () => {
        n.current = !0;
      };
      return c.addEventListener("touchstart", a), c.addEventListener("touchmove", u), () => {
        c.removeEventListener("touchstart", a), c.removeEventListener("touchmove", u);
      };
    }
  }, [e, a]), h.useEffect(() => {
    if (e) {
      const c = qt(s.current);
      return c.addEventListener("click", a), () => {
        c.removeEventListener("click", a), o.current = !1;
      };
    }
  }, [e, a]), [s, l, l];
}
const Cae = /* @__PURE__ */ h.forwardRef((e, t) => {
  const {
    PaperComponent: n,
    popperPlacement: o,
    ownerState: s,
    children: i,
    paperSlotProps: a,
    paperClasses: l,
    onPaperClick: c,
    onPaperTouchStart: u
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = e, d = ve(e, hae), f = I({}, s, {
    placement: o
  }), p = et({
    elementType: n,
    externalSlotProps: a,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: t
    },
    className: l,
    ownerState: f
  });
  return /* @__PURE__ */ C(n, I({}, d, p, {
    onClick: (m) => {
      var b;
      c(m), (b = p.onClick) == null || b.call(p, m);
    },
    onTouchStart: (m) => {
      var b;
      u(m), (b = p.onTouchStart) == null || b.call(p, m);
    },
    ownerState: f,
    children: i
  }));
});
function XN(e) {
  const t = Et({
    props: e,
    name: "MuiPickersPopper"
  }), {
    anchorEl: n,
    children: o,
    containerRef: s = null,
    shouldRestoreFocus: i,
    onBlur: a,
    onDismiss: l,
    open: c,
    role: u,
    placement: d,
    slots: f,
    slotProps: p,
    reduceAnimations: m
  } = t;
  h.useEffect(() => {
    function A(k) {
      c && k.key === "Escape" && l();
    }
    return document.addEventListener("keydown", A), () => {
      document.removeEventListener("keydown", A);
    };
  }, [l, c]);
  const b = h.useRef(null);
  h.useEffect(() => {
    u === "tooltip" || i && !i() || (c ? b.current = so(document) : b.current && b.current instanceof HTMLElement && setTimeout(() => {
      b.current instanceof HTMLElement && b.current.focus();
    }));
  }, [c, u, i]);
  const [v, g, y] = vae(c, a ?? l), w = h.useRef(null), x = tt(w, s), S = tt(x, v), T = t, E = gae(T), O = $0(), M = m ?? O, D = (A) => {
    A.key === "Escape" && (A.stopPropagation(), l());
  }, R = (f == null ? void 0 : f.desktopTransition) ?? M ? ti : vs, P = (f == null ? void 0 : f.desktopTrapFocus) ?? nl, F = (f == null ? void 0 : f.desktopPaper) ?? bae, $ = (f == null ? void 0 : f.popper) ?? mae, N = et({
    elementType: $,
    externalSlotProps: p == null ? void 0 : p.popper,
    additionalProps: {
      transition: !0,
      role: u,
      open: c,
      anchorEl: n,
      placement: d,
      onKeyDown: D
    },
    className: E.root,
    ownerState: t
  });
  return /* @__PURE__ */ C($, I({}, N, {
    children: ({
      TransitionProps: A,
      placement: k
    }) => /* @__PURE__ */ C(P, I({
      open: c,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: u === "tooltip",
      isEnabled: () => !0
    }, p == null ? void 0 : p.desktopTrapFocus, {
      children: /* @__PURE__ */ C(R, I({}, A, p == null ? void 0 : p.desktopTransition, {
        children: /* @__PURE__ */ C(Cae, {
          PaperComponent: F,
          ownerState: T,
          popperPlacement: k,
          ref: S,
          onPaperClick: g,
          onPaperTouchStart: y,
          paperClasses: E.paper,
          paperSlotProps: p == null ? void 0 : p.desktopPaper,
          children: o
        })
      }))
    }))
  }));
}
const wae = ({
  open: e,
  onOpen: t,
  onClose: n
}) => {
  const o = h.useRef(typeof e == "boolean").current, [s, i] = h.useState(!1);
  h.useEffect(() => {
    if (o) {
      if (typeof e != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      i(e);
    }
  }, [o, e]);
  const a = h.useCallback((l) => {
    o || i(l), l && t && t(), !l && n && n();
  }, [o, t, n]);
  return {
    isOpen: s,
    setIsOpen: a
  };
}, Sae = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: o,
    isControlled: s
  } = e, i = !s && !o.hasBeenModifiedSinceMount;
  return t.name === "setValueFromField" ? !0 : t.name === "setValueFromAction" ? i && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(o.lastPublishedValue) : t.name === "setValueFromView" && t.selectionState !== "shallow" || t.name === "setValueFromShortcut" ? i ? !0 : n(o.lastPublishedValue) : !1;
}, xae = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: o,
    isControlled: s,
    closeOnSelect: i
  } = e, a = !s && !o.hasBeenModifiedSinceMount;
  return t.name === "setValueFromAction" ? a && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(o.lastCommittedValue) : t.name === "setValueFromView" && t.selectionState === "finish" && i ? a ? !0 : n(o.lastCommittedValue) : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" && n(o.lastCommittedValue) : !1;
}, Tae = (e) => {
  const {
    action: t,
    closeOnSelect: n
  } = e;
  return t.name === "setValueFromAction" ? !0 : t.name === "setValueFromView" ? t.selectionState === "finish" && n : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" : !1;
}, Rae = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: o,
  validator: s
}) => {
  const {
    onAccept: i,
    onChange: a,
    value: l,
    defaultValue: c,
    closeOnSelect: u = o === "desktop",
    timezone: d,
    referenceDate: f
  } = e, {
    current: p
  } = h.useRef(c), {
    current: m
  } = h.useRef(l !== void 0), [b, v] = h.useState(d);
  process.env.NODE_ENV !== "production" && (h.useEffect(() => {
    m !== (l !== void 0) && console.error([`MUI X: A component is changing the ${m ? "" : "un"}controlled value of a picker to be ${m ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [l]), h.useEffect(() => {
    !m && p !== c && console.error(["MUI X: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(p)]));
  const g = Wt(), y = sa(), {
    isOpen: w,
    setIsOpen: x
  } = wae(e), {
    timezone: S,
    value: T,
    handleValueChange: E
  } = w0({
    timezone: d,
    value: l,
    defaultValue: p,
    referenceDate: f,
    onChange: a,
    valueManager: t
  }), [O, M] = h.useState(() => {
    let Q;
    return T !== void 0 ? Q = T : p !== void 0 ? Q = p : Q = t.emptyValue, {
      draft: Q,
      lastPublishedValue: Q,
      lastCommittedValue: Q,
      lastControlledValue: l,
      hasBeenModifiedSinceMount: !1
    };
  }), D = t.getTimezone(g, O.draft);
  b !== d && (v(d), d && D && d !== D && M((Q) => I({}, Q, {
    draft: t.setTimezone(g, d, Q.draft)
  })));
  const {
    getValidationErrorForNewValue: R
  } = R0({
    props: e,
    validator: s,
    timezone: S,
    value: O.draft,
    onError: e.onError
  }), P = xe((Q) => {
    const ee = {
      action: Q,
      dateState: O,
      hasChanged: (oe) => !t.areValuesEqual(g, Q.value, oe),
      isControlled: m,
      closeOnSelect: u
    }, ne = Sae(ee), H = xae(ee), U = Tae(ee);
    M((oe) => I({}, oe, {
      draft: Q.value,
      lastPublishedValue: ne ? Q.value : oe.lastPublishedValue,
      lastCommittedValue: H ? Q.value : oe.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    }));
    let X = null;
    const re = () => (X || (X = {
      validationError: Q.name === "setValueFromField" ? Q.context.validationError : R(Q.value)
    }, Q.name === "setValueFromShortcut" && (X.shortcut = Q.shortcut)), X);
    ne && E(Q.value, re()), H && i && i(Q.value, re()), U && x(!1);
  });
  if (O.lastControlledValue !== l) {
    const Q = t.areValuesEqual(g, O.draft, T);
    M((ee) => I({}, ee, {
      lastControlledValue: l
    }, Q ? {} : {
      lastCommittedValue: T,
      lastPublishedValue: T,
      draft: T,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const F = xe(() => {
    P({
      value: t.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), $ = xe(() => {
    P({
      value: O.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), N = xe(() => {
    P({
      value: O.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), A = xe(() => {
    P({
      value: O.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), k = xe(() => {
    P({
      value: t.getTodayValue(g, S, n),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), L = xe((Q) => {
    Q.preventDefault(), x(!0);
  }), B = xe((Q) => {
    Q == null || Q.preventDefault(), x(!1);
  }), V = xe((Q, ee = "partial") => P({
    name: "setValueFromView",
    value: Q,
    selectionState: ee
  })), _ = xe((Q, ee, ne) => P({
    name: "setValueFromShortcut",
    value: Q,
    changeImportance: ee,
    shortcut: ne
  })), z = xe((Q, ee) => P({
    name: "setValueFromField",
    value: Q,
    context: ee
  })), j = {
    onClear: F,
    onAccept: $,
    onDismiss: N,
    onCancel: A,
    onSetToday: k,
    onOpen: L,
    onClose: B
  }, W = {
    value: O.draft,
    onChange: z
  }, J = h.useMemo(() => t.cleanValue(g, O.draft), [g, t, O.draft]), G = {
    value: J,
    onChange: V,
    onClose: B,
    open: w
  }, Z = I({}, j, {
    value: J,
    onChange: V,
    onSelectShortcut: _,
    isValid: (Q) => {
      const ee = s({
        adapter: y,
        value: Q,
        timezone: S,
        props: e
      });
      return !t.hasError(ee);
    }
  }), Y = h.useMemo(() => ({
    onOpen: L,
    onClose: B,
    open: w
  }), [w, B, L]);
  return {
    open: w,
    fieldProps: W,
    viewProps: G,
    layoutProps: Z,
    actions: j,
    contextValue: Y
  };
}, Eae = ["className", "sx"], Iae = ({
  props: e,
  propsFromPickerValue: t,
  additionalViewProps: n,
  autoFocusView: o,
  rendererInterceptor: s,
  fieldRef: i
}) => {
  const {
    onChange: a,
    open: l,
    onClose: c
  } = t, {
    view: u,
    views: d,
    openTo: f,
    onViewChange: p,
    viewRenderers: m,
    timezone: b
  } = e, v = ve(e, Eae), {
    view: g,
    setView: y,
    defaultView: w,
    focusedView: x,
    setFocusedView: S,
    setValueAndGoToNextView: T
  } = b0({
    view: u,
    views: d,
    openTo: f,
    onChange: a,
    onViewChange: p,
    autoFocus: o
  }), {
    hasUIView: E,
    viewModeLookup: O
  } = h.useMemo(() => d.reduce((N, A) => {
    let k;
    return m[A] != null ? k = "UI" : k = "field", N.viewModeLookup[A] = k, k === "UI" && (N.hasUIView = !0), N;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [m, d]), M = h.useMemo(() => d.reduce((N, A) => m[A] != null && vre(A) ? N + 1 : N, 0), [m, d]), D = O[g], R = xe(() => D === "UI"), [P, F] = h.useState(D === "UI" ? g : null);
  return P !== g && O[g] === "UI" && F(g), yt(() => {
    D === "field" && l && (c(), setTimeout(() => {
      var N, A;
      (N = i == null ? void 0 : i.current) == null || N.setSelectedSections(g), (A = i == null ? void 0 : i.current) == null || A.focusField(g);
    }));
  }, [g]), yt(() => {
    if (!l)
      return;
    let N = g;
    D === "field" && P != null && (N = P), N !== w && O[N] === "UI" && O[w] === "UI" && (N = w), N !== g && y(N), S(N, !0);
  }, [l]), {
    hasUIView: E,
    shouldRestoreFocus: R,
    layoutProps: {
      views: d,
      view: P,
      onViewChange: y
    },
    renderCurrentView: () => {
      if (P == null)
        return null;
      const N = m[P];
      if (N == null)
        return null;
      const A = I({}, v, n, t, {
        views: d,
        timezone: b,
        onChange: T,
        view: P,
        onViewChange: y,
        focusedView: x,
        onFocusedViewChange: S,
        showViewSwitcher: M > 1,
        timeViewsCount: M
      });
      return s ? s(m, P, A) : N(A);
    }
  };
};
function MR() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
const Oae = (e, t) => {
  const [n, o] = h.useState(MR);
  return yt(() => {
    const i = () => {
      o(MR());
    };
    return window.addEventListener("orientationchange", i), () => {
      window.removeEventListener("orientationchange", i);
    };
  }, []), Vre(e, ["hours", "minutes", "seconds"]) ? !1 : (t || n) === "landscape";
}, Pae = ({
  props: e,
  propsFromPickerValue: t,
  propsFromPickerViews: n,
  wrapperVariant: o
}) => {
  const {
    orientation: s
  } = e, i = Oae(n.views, s), a = _t();
  return {
    layoutProps: I({}, n, t, {
      isLandscape: i,
      isRtl: a,
      wrapperVariant: o,
      disabled: e.disabled,
      readOnly: e.readOnly
    })
  };
};
function Mae(e) {
  const {
    props: t,
    pickerValueResponse: n
  } = e;
  return h.useMemo(() => ({
    value: n.viewProps.value,
    open: n.open,
    disabled: t.disabled ?? !1,
    readOnly: t.readOnly ?? !1
  }), [n.viewProps.value, n.open, t.disabled, t.readOnly]);
}
const lh = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: o,
  additionalViewProps: s,
  validator: i,
  autoFocusView: a,
  rendererInterceptor: l,
  fieldRef: c
}) => {
  process.env.NODE_ENV !== "production" && e.renderInput != null && vo(["MUI X: The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]);
  const u = Rae({
    props: e,
    valueManager: t,
    valueType: n,
    wrapperVariant: o,
    validator: i
  }), d = Iae({
    props: e,
    additionalViewProps: s,
    autoFocusView: a,
    fieldRef: c,
    propsFromPickerValue: u.viewProps,
    rendererInterceptor: l
  }), f = Pae({
    props: e,
    wrapperVariant: o,
    propsFromPickerValue: u.layoutProps,
    propsFromPickerViews: d.layoutProps
  }), p = Mae({
    props: e,
    pickerValueResponse: u
  });
  return {
    // Picker value
    open: u.open,
    actions: u.actions,
    fieldProps: u.fieldProps,
    // Picker views
    renderCurrentView: d.renderCurrentView,
    hasUIView: d.hasUIView,
    shouldRestoreFocus: d.shouldRestoreFocus,
    // Picker layout
    layoutProps: f.layoutProps,
    // Picker context
    contextValue: u.contextValue,
    // Picker owner state
    ownerState: p
  };
};
function QN(e) {
  return De("MuiPickersLayout", e);
}
const ui = Ne("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]), kae = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function ZN(e) {
  const {
    onAccept: t,
    onClear: n,
    onCancel: o,
    onSetToday: s,
    actions: i
  } = e, a = ve(e, kae), l = er();
  if (i == null || i.length === 0)
    return null;
  const c = i == null ? void 0 : i.map((u) => {
    switch (u) {
      case "clear":
        return /* @__PURE__ */ C(Io, {
          onClick: n,
          children: l.clearButtonLabel
        }, u);
      case "cancel":
        return /* @__PURE__ */ C(Io, {
          onClick: o,
          children: l.cancelButtonLabel
        }, u);
      case "accept":
        return /* @__PURE__ */ C(Io, {
          onClick: t,
          children: l.okButtonLabel
        }, u);
      case "today":
        return /* @__PURE__ */ C(Io, {
          onClick: s,
          children: l.todayButtonLabel
        }, u);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ C(oM, I({}, a, {
    children: c
  }));
}
process.env.NODE_ENV !== "production" && (ZN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: r.arrayOf(r.oneOf(["accept", "cancel", "clear", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: r.bool,
  onAccept: r.func.isRequired,
  onCancel: r.func.isRequired,
  onClear: r.func.isRequired,
  onSetToday: r.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
const Dae = ["items", "changeImportance", "isLandscape", "onChange", "isValid"], Nae = ["getValue"];
function JN(e) {
  const {
    items: t,
    changeImportance: n = "accept",
    onChange: o,
    isValid: s
  } = e, i = ve(e, Dae);
  if (t == null || t.length === 0)
    return null;
  const a = t.map((l) => {
    let {
      getValue: c
    } = l, u = ve(l, Nae);
    const d = c({
      isValid: s
    });
    return I({}, u, {
      label: u.label,
      onClick: () => {
        o(d, n, u);
      },
      disabled: !s(d)
    });
  });
  return /* @__PURE__ */ C(rC, I({
    dense: !0,
    sx: [{
      maxHeight: y0,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(i.sx) ? i.sx : [i.sx]]
  }, i, {
    children: a.map((l) => /* @__PURE__ */ C(aC, {
      children: /* @__PURE__ */ C(Su, I({}, l))
    }, l.id ?? l.label))
  }));
}
process.env.NODE_ENV !== "production" && (JN.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: r.oneOf(["accept", "set"]),
  className: r.string,
  component: r.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: r.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: r.bool,
  isLandscape: r.bool.isRequired,
  isValid: r.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default []
   */
  items: r.arrayOf(r.shape({
    getValue: r.func.isRequired,
    id: r.string,
    label: r.string.isRequired
  })),
  onChange: r.func.isRequired,
  style: r.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: r.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object])
});
function $ae(e) {
  return e.view !== null;
}
const Aae = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return fe({
    root: ["root", n && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, QN, t);
}, Fae = (e) => {
  const {
    wrapperVariant: t,
    onAccept: n,
    onClear: o,
    onCancel: s,
    onSetToday: i,
    view: a,
    views: l,
    onViewChange: c,
    value: u,
    onChange: d,
    onSelectShortcut: f,
    isValid: p,
    isLandscape: m,
    disabled: b,
    readOnly: v,
    children: g,
    slots: y,
    slotProps: w
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = e, x = Aae(e), S = (y == null ? void 0 : y.actionBar) ?? ZN, T = et({
    elementType: S,
    externalSlotProps: w == null ? void 0 : w.actionBar,
    additionalProps: {
      onAccept: n,
      onClear: o,
      onCancel: s,
      onSetToday: i,
      actions: t === "desktop" ? [] : ["cancel", "accept"]
    },
    className: x.actionBar,
    ownerState: I({}, e, {
      wrapperVariant: t
    })
  }), E = /* @__PURE__ */ C(S, I({}, T)), O = y == null ? void 0 : y.toolbar, M = et({
    elementType: O,
    externalSlotProps: w == null ? void 0 : w.toolbar,
    additionalProps: {
      isLandscape: m,
      onChange: d,
      value: u,
      view: a,
      onViewChange: c,
      views: l,
      disabled: b,
      readOnly: v
    },
    className: x.toolbar,
    ownerState: I({}, e, {
      wrapperVariant: t
    })
  }), D = $ae(M) && O ? /* @__PURE__ */ C(O, I({}, M)) : null, R = g, P = y == null ? void 0 : y.tabs, F = a && P ? /* @__PURE__ */ C(P, I({
    view: a,
    onViewChange: c,
    className: x.tabs
  }, w == null ? void 0 : w.tabs)) : null, $ = (y == null ? void 0 : y.shortcuts) ?? JN, N = et({
    elementType: $,
    externalSlotProps: w == null ? void 0 : w.shortcuts,
    additionalProps: {
      isValid: p,
      isLandscape: m,
      onChange: f
    },
    className: x.shortcuts,
    ownerState: {
      isValid: p,
      isLandscape: m,
      onChange: f,
      wrapperVariant: t
    }
  }), A = a && $ ? /* @__PURE__ */ C($, I({}, N)) : null;
  return {
    toolbar: D,
    content: R,
    tabs: F,
    actionBar: E,
    shortcuts: A
  };
}, Lae = (e) => {
  const {
    isLandscape: t,
    classes: n
  } = e;
  return fe({
    root: ["root", t && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, QN, n);
}, _ae = te("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${ui.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  },
  variants: [{
    props: {
      isLandscape: !0
    },
    style: {
      [`& .${ui.toolbar}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      },
      [`.${ui.shortcuts}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      }
    }
  }, {
    props: {
      isLandscape: !0,
      isRtl: !0
    },
    style: {
      [`& .${ui.toolbar}`]: {
        gridColumn: 3
      }
    }
  }, {
    props: {
      isLandscape: !1
    },
    style: {
      [`& .${ui.toolbar}`]: {
        gridColumn: "2 / 4",
        gridRow: 1
      },
      [`& .${ui.shortcuts}`]: {
        gridColumn: 1,
        gridRow: "2 / 3"
      }
    }
  }, {
    props: {
      isLandscape: !1,
      isRtl: !0
    },
    style: {
      [`& .${ui.shortcuts}`]: {
        gridColumn: 3
      }
    }
  }]
}), Vae = te("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (e, t) => t.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), ju = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiPickersLayout"
  }), {
    toolbar: s,
    content: i,
    tabs: a,
    actionBar: l,
    shortcuts: c
  } = Fae(o), {
    sx: u,
    className: d,
    isLandscape: f,
    wrapperVariant: p
  } = o, m = Lae(o);
  return /* @__PURE__ */ ie(_ae, {
    ref: n,
    sx: u,
    className: ae(m.root, d),
    ownerState: o,
    children: [f ? c : s, f ? s : c, /* @__PURE__ */ C(Vae, {
      className: m.contentWrapper,
      children: p === "desktop" ? /* @__PURE__ */ ie(h.Fragment, {
        children: [i, a]
      }) : /* @__PURE__ */ ie(h.Fragment, {
        children: [a, i]
      })
    }), l]
  });
});
process.env.NODE_ENV !== "production" && (ju.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: r.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  disabled: r.bool,
  isLandscape: r.bool.isRequired,
  /**
   * `true` if the application is in right-to-left direction.
   */
  isRtl: r.bool.isRequired,
  isValid: r.func.isRequired,
  onAccept: r.func.isRequired,
  onCancel: r.func.isRequired,
  onChange: r.func.isRequired,
  onClear: r.func.isRequired,
  onClose: r.func.isRequired,
  onDismiss: r.func.isRequired,
  onOpen: r.func.isRequired,
  onSelectShortcut: r.func.isRequired,
  onSetToday: r.func.isRequired,
  onViewChange: r.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  value: r.any,
  view: r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: r.arrayOf(r.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: r.oneOf(["desktop", "mobile"])
});
const Bae = ["props", "getOpenDialogAriaText"], zae = ["ownerState"], Hae = ["ownerState"], jae = (e) => {
  var re;
  let {
    props: t,
    getOpenDialogAriaText: n
  } = e, o = ve(e, Bae);
  const {
    slots: s,
    slotProps: i,
    className: a,
    sx: l,
    format: c,
    formatDensity: u,
    enableAccessibleFieldDOMStructure: d,
    selectedSections: f,
    onSelectedSectionsChange: p,
    timezone: m,
    name: b,
    label: v,
    inputRef: g,
    readOnly: y,
    disabled: w,
    autoFocus: x,
    localeText: S,
    reduceAnimations: T
  } = t, E = h.useRef(null), O = h.useRef(null), M = gt(), D = ((re = i == null ? void 0 : i.toolbar) == null ? void 0 : re.hidden) ?? !1, {
    open: R,
    actions: P,
    hasUIView: F,
    layoutProps: $,
    renderCurrentView: N,
    shouldRestoreFocus: A,
    fieldProps: k,
    contextValue: L,
    ownerState: B
  } = lh(I({}, o, {
    props: t,
    fieldRef: O,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), V = s.inputAdornment ?? yl, _ = et({
    elementType: V,
    externalSlotProps: i == null ? void 0 : i.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: t
  }), z = ve(_, zae), j = s.openPickerButton ?? Eo, W = et({
    elementType: j,
    externalSlotProps: i == null ? void 0 : i.openPickerButton,
    additionalProps: {
      disabled: w || y,
      onClick: R ? P.onClose : P.onOpen,
      "aria-label": n(k.value),
      edge: z.position
    },
    ownerState: t
  }), J = ve(W, Hae), G = s.openPickerIcon, q = et({
    elementType: G,
    externalSlotProps: i == null ? void 0 : i.openPickerIcon,
    ownerState: B
  }), Z = s.field, Y = et({
    elementType: Z,
    externalSlotProps: i == null ? void 0 : i.field,
    additionalProps: I({}, k, D && {
      id: M
    }, {
      readOnly: y,
      disabled: w,
      className: a,
      sx: l,
      format: c,
      formatDensity: u,
      enableAccessibleFieldDOMStructure: d,
      selectedSections: f,
      onSelectedSectionsChange: p,
      timezone: m,
      label: v,
      name: b,
      autoFocus: x && !t.open,
      focused: R ? !0 : void 0
    }, g ? {
      inputRef: g
    } : {}),
    ownerState: t
  });
  F && (Y.InputProps = I({}, Y.InputProps, {
    ref: E
  }, !t.disableOpenPicker && {
    [`${z.position}Adornment`]: /* @__PURE__ */ C(V, I({}, z, {
      children: /* @__PURE__ */ C(j, I({}, J, {
        children: /* @__PURE__ */ C(G, I({}, q))
      }))
    }))
  }));
  const Q = I({
    textField: s.textField,
    clearIcon: s.clearIcon,
    clearButton: s.clearButton
  }, Y.slots), ee = s.layout ?? ju;
  let ne = M;
  D && (v ? ne = `${M}-label` : ne = void 0);
  const H = I({}, i, {
    toolbar: I({}, i == null ? void 0 : i.toolbar, {
      titleId: M
    }),
    popper: I({
      "aria-labelledby": ne
    }, i == null ? void 0 : i.popper)
  }), U = tt(O, Y.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ ie(rh, {
      contextValue: L,
      localeText: S,
      children: [/* @__PURE__ */ C(Z, I({}, Y, {
        slots: Q,
        slotProps: H,
        unstableFieldRef: U
      })), /* @__PURE__ */ C(XN, I({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: E.current
      }, P, {
        open: R,
        slots: s,
        slotProps: H,
        shouldRestoreFocus: A,
        reduceAnimations: T,
        children: /* @__PURE__ */ C(ee, I({}, $, H == null ? void 0 : H.layout, {
          slots: s,
          slotProps: H,
          children: N()
        }))
      }))]
    })
  };
}, qa = ({
  view: e,
  onViewChange: t,
  views: n,
  focusedView: o,
  onFocusedViewChange: s,
  value: i,
  defaultValue: a,
  referenceDate: l,
  onChange: c,
  className: u,
  classes: d,
  disableFuture: f,
  disablePast: p,
  minDate: m,
  maxDate: b,
  shouldDisableDate: v,
  shouldDisableMonth: g,
  shouldDisableYear: y,
  reduceAnimations: w,
  onMonthChange: x,
  monthsPerRow: S,
  onYearChange: T,
  yearsOrder: E,
  yearsPerRow: O,
  slots: M,
  slotProps: D,
  loading: R,
  renderLoading: P,
  disableHighlightToday: F,
  readOnly: $,
  disabled: N,
  showDaysOutsideCurrentMonth: A,
  dayOfWeekFormatter: k,
  sx: L,
  autoFocus: B,
  fixedWeekNumber: V,
  displayWeekNumber: _,
  timezone: z
}) => /* @__PURE__ */ C(qN, {
  view: e,
  onViewChange: t,
  views: n.filter(yR),
  focusedView: o && yR(o) ? o : null,
  onFocusedViewChange: s,
  value: i,
  defaultValue: a,
  referenceDate: l,
  onChange: c,
  className: u,
  classes: d,
  disableFuture: f,
  disablePast: p,
  minDate: m,
  maxDate: b,
  shouldDisableDate: v,
  shouldDisableMonth: g,
  shouldDisableYear: y,
  reduceAnimations: w,
  onMonthChange: x,
  monthsPerRow: S,
  onYearChange: T,
  yearsOrder: E,
  yearsPerRow: O,
  slots: M,
  slotProps: D,
  loading: R,
  renderLoading: P,
  disableHighlightToday: F,
  readOnly: $,
  disabled: N,
  showDaysOutsideCurrentMonth: A,
  dayOfWeekFormatter: k,
  sx: L,
  autoFocus: B,
  fixedWeekNumber: V,
  displayWeekNumber: _,
  timezone: z
}), e$ = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var u, d;
  const o = er(), s = Wt(), i = YN(t, "MuiDesktopDatePicker"), a = I({
    day: qa,
    month: qa,
    year: qa
  }, i.viewRenderers), l = I({}, i, {
    viewRenderers: a,
    format: C0(s, i, !1),
    yearsPerRow: i.yearsPerRow ?? 4,
    slots: I({
      openPickerIcon: lre,
      field: D0
    }, i.slots),
    slotProps: I({}, i.slotProps, {
      field: (f) => {
        var p;
        return I({}, Ur((p = i.slotProps) == null ? void 0 : p.field, f), oh(i), {
          ref: n
        });
      },
      toolbar: I({
        hidden: !0
      }, (u = i.slotProps) == null ? void 0 : u.toolbar)
    })
  }), {
    renderPicker: c
  } = jae({
    props: l,
    valueManager: ns,
    valueType: "date",
    getOpenDialogAriaText: uN({
      utils: s,
      formatKey: "fullDate",
      contextTranslation: o.openDatePickerDialogue,
      propsTranslation: (d = l.localeText) == null ? void 0 : d.openDatePickerDialogue
    }),
    validator: Gi
  });
  return c();
});
e$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: r.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    day: r.func,
    month: r.func,
    year: r.func
  }),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: r.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: r.oneOf([3, 4])
};
const Gae = te(Jv)({
  [`& .${Ec.container}`]: {
    outline: 0
  },
  [`& .${Ec.paper}`]: {
    outline: 0,
    minWidth: th
  }
}), qae = te(eC)({
  "&:first-of-type": {
    padding: 0
  }
});
function t$(e) {
  const {
    children: t,
    onDismiss: n,
    open: o,
    slots: s,
    slotProps: i
  } = e, a = (s == null ? void 0 : s.dialog) ?? Gae, l = (s == null ? void 0 : s.mobileTransition) ?? ti;
  return /* @__PURE__ */ C(a, I({
    open: o,
    onClose: n
  }, i == null ? void 0 : i.dialog, {
    TransitionComponent: l,
    TransitionProps: i == null ? void 0 : i.mobileTransition,
    PaperComponent: s == null ? void 0 : s.mobilePaper,
    PaperProps: i == null ? void 0 : i.mobilePaper,
    children: /* @__PURE__ */ C(qae, {
      children: t
    })
  }));
}
const Wae = ["props", "getOpenDialogAriaText"], Uae = (e) => {
  var z;
  let {
    props: t,
    getOpenDialogAriaText: n
  } = e, o = ve(e, Wae);
  const {
    slots: s,
    slotProps: i,
    className: a,
    sx: l,
    format: c,
    formatDensity: u,
    enableAccessibleFieldDOMStructure: d,
    selectedSections: f,
    onSelectedSectionsChange: p,
    timezone: m,
    name: b,
    label: v,
    inputRef: g,
    readOnly: y,
    disabled: w,
    localeText: x
  } = t, S = h.useRef(null), T = gt(), E = ((z = i == null ? void 0 : i.toolbar) == null ? void 0 : z.hidden) ?? !1, {
    open: O,
    actions: M,
    layoutProps: D,
    renderCurrentView: R,
    fieldProps: P,
    contextValue: F
  } = lh(I({}, o, {
    props: t,
    fieldRef: S,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), $ = s.field, N = et({
    elementType: $,
    externalSlotProps: i == null ? void 0 : i.field,
    additionalProps: I({}, P, E && {
      id: T
    }, !(w || y) && {
      onClick: M.onOpen,
      onKeyDown: Kf(M.onOpen)
    }, {
      readOnly: y ?? !0,
      disabled: w,
      className: a,
      sx: l,
      format: c,
      formatDensity: u,
      enableAccessibleFieldDOMStructure: d,
      selectedSections: f,
      onSelectedSectionsChange: p,
      timezone: m,
      label: v,
      name: b
    }, g ? {
      inputRef: g
    } : {}),
    ownerState: t
  });
  N.inputProps = I({}, N.inputProps, {
    "aria-label": n(P.value)
  });
  const A = I({
    textField: s.textField
  }, N.slots), k = s.layout ?? ju;
  let L = T;
  E && (v ? L = `${T}-label` : L = void 0);
  const B = I({}, i, {
    toolbar: I({}, i == null ? void 0 : i.toolbar, {
      titleId: T
    }),
    mobilePaper: I({
      "aria-labelledby": L
    }, i == null ? void 0 : i.mobilePaper)
  }), V = tt(S, N.unstableFieldRef);
  return {
    renderPicker: () => /* @__PURE__ */ ie(rh, {
      contextValue: F,
      localeText: x,
      children: [/* @__PURE__ */ C($, I({}, N, {
        slots: A,
        slotProps: B,
        unstableFieldRef: V
      })), /* @__PURE__ */ C(t$, I({}, M, {
        open: O,
        slots: s,
        slotProps: B,
        children: /* @__PURE__ */ C(k, I({}, D, B == null ? void 0 : B.layout, {
          slots: s,
          slotProps: B,
          children: R()
        }))
      }))]
    })
  };
}, n$ = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var u, d;
  const o = er(), s = Wt(), i = YN(t, "MuiMobileDatePicker"), a = I({
    day: qa,
    month: qa,
    year: qa
  }, i.viewRenderers), l = I({}, i, {
    viewRenderers: a,
    format: C0(s, i, !1),
    slots: I({
      field: D0
    }, i.slots),
    slotProps: I({}, i.slotProps, {
      field: (f) => {
        var p;
        return I({}, Ur((p = i.slotProps) == null ? void 0 : p.field, f), oh(i), {
          ref: n
        });
      },
      toolbar: I({
        hidden: !1
      }, (u = i.slotProps) == null ? void 0 : u.toolbar)
    })
  }), {
    renderPicker: c
  } = Uae({
    props: l,
    valueManager: ns,
    valueType: "date",
    getOpenDialogAriaText: uN({
      utils: s,
      formatKey: "fullDate",
      contextTranslation: o.openDatePickerDialogue,
      propsTranslation: (d = l.localeText) == null ? void 0 : d.openDatePickerDialogue
    }),
    validator: Gi
  });
  return c();
});
n$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: r.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    day: r.func,
    month: r.func,
    year: r.func
  }),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: r.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: r.oneOf([3, 4])
};
const Kae = ["desktopModeMediaQuery"], o$ = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiDatePicker"
  }), {
    desktopModeMediaQuery: s = TN
  } = o, i = ve(o, Kae);
  return Qi(s, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ C(e$, I({
    ref: n
  }, i)) : /* @__PURE__ */ C(n$, I({
    ref: n
  }, i));
});
process.env.NODE_ENV !== "production" && (o$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.object,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: r.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: r.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: r.oneOf(["landscape", "portrait"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */
  renderLoading: r.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: r.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.object,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    day: r.func,
    month: r.func,
    year: r.func
  }),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */
  yearsOrder: r.oneOf(["asc", "desc"]),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: r.oneOf([3, 4])
});
function Yae(e) {
  return De("MuiPickersToolbarText", e);
}
const kR = Ne("MuiPickersToolbarText", ["root", "selected"]), Xae = ["className", "selected", "value"], Qae = (e) => {
  const {
    classes: t,
    selected: n
  } = e;
  return fe({
    root: ["root", n && "selected"]
  }, Yae, t);
}, Zae = te(yn, {
  name: "MuiPickersToolbarText",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`&.${kR.selected}`]: t.selected
  }]
})(({
  theme: e
}) => ({
  transition: e.transitions.create("color"),
  color: (e.vars || e).palette.text.secondary,
  [`&.${kR.selected}`]: {
    color: (e.vars || e).palette.text.primary
  }
})), Jae = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiPickersToolbarText"
  }), {
    className: s,
    value: i
  } = o, a = ve(o, Xae), l = Qae(o);
  return /* @__PURE__ */ C(Zae, I({
    ref: n,
    className: ae(l.root, s),
    component: "span"
  }, a, {
    children: i
  }));
}), ele = ["align", "className", "selected", "typographyClassName", "value", "variant", "width"], tle = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"]
  }, WN, t);
}, nle = te(Io, {
  name: "MuiPickersToolbarButton",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 0,
  minWidth: 16,
  textTransform: "none"
}), DR = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiPickersToolbarButton"
  }), {
    align: s,
    className: i,
    selected: a,
    typographyClassName: l,
    value: c,
    variant: u,
    width: d
  } = o, f = ve(o, ele), p = tle(o);
  return /* @__PURE__ */ C(nle, I({
    variant: "text",
    ref: n,
    className: ae(p.root, i)
  }, d ? {
    sx: {
      width: d
    }
  } : {}, f, {
    children: /* @__PURE__ */ C(Jae, {
      align: s,
      className: l,
      variant: u,
      value: c,
      selected: a
    })
  }));
});
function ole(e) {
  return De("MuiDateRangePickerDay", e);
}
const Sn = Ne("MuiDateRangePickerDay", ["root", "rangeIntervalDayHighlight", "rangeIntervalDayHighlightStart", "rangeIntervalDayHighlightEnd", "rangeIntervalPreview", "rangeIntervalDayPreview", "rangeIntervalDayPreviewStart", "rangeIntervalDayPreviewEnd", "outsideCurrentMonth", "startOfMonth", "endOfMonth", "firstVisibleCell", "lastVisibleCell", "hiddenDayFiller", "day", "dayOutsideRangeInterval", "dayInsideRangeInterval", "notSelectedDate"]), ch = () => {
  const e = "MTczOTc0NjgwMDAwMA==";
  return process.env.NODE_ENV, e;
}, rle = ["className", "day", "outsideCurrentMonth", "isEndOfHighlighting", "isEndOfPreviewing", "isHighlighting", "isPreviewing", "isStartOfHighlighting", "isStartOfPreviewing", "selected", "isVisuallySelected", "sx", "draggable", "isFirstVisibleCell", "isLastVisibleCell"], sle = ch(), ile = (e) => {
  const {
    isHighlighting: t,
    outsideCurrentMonth: n,
    isStartOfHighlighting: o,
    isStartOfMonth: s,
    isEndOfHighlighting: i,
    isEndOfMonth: a,
    isPreviewing: l,
    isStartOfPreviewing: c,
    isEndOfPreviewing: u,
    isFirstVisibleCell: d,
    isLastVisibleCell: f,
    isHiddenDayFiller: p,
    selected: m,
    classes: b
  } = e;
  return fe({
    root: ["root", t && "rangeIntervalDayHighlight", o && "rangeIntervalDayHighlightStart", i && "rangeIntervalDayHighlightEnd", n && "outsideCurrentMonth", s && "startOfMonth", a && "endOfMonth", d && "firstVisibleCell", f && "lastVisibleCell", p && "hiddenDayFiller"],
    rangeIntervalPreview: ["rangeIntervalPreview", l && "rangeIntervalDayPreview", (c || s) && "rangeIntervalDayPreviewStart", (u || a) && "rangeIntervalDayPreviewEnd"],
    day: ["day", !m && "notSelectedDate", !t && "dayOutsideRangeInterval", !m && t && "dayInsideRangeInterval"]
  }, ole, b);
}, rf = {
  borderTopRightRadius: "50%",
  borderBottomRightRadius: "50%"
}, sf = {
  borderTopLeftRadius: "50%",
  borderBottomLeftRadius: "50%"
}, ale = te("div", {
  name: "MuiDateRangePickerDay",
  slot: "Root",
  overridesResolver: (e, t) => [{
    [`&.${Sn.rangeIntervalDayHighlight}`]: t.rangeIntervalDayHighlight
  }, {
    [`&.${Sn.rangeIntervalDayHighlightStart}`]: t.rangeIntervalDayHighlightStart
  }, {
    [`&.${Sn.rangeIntervalDayHighlightEnd}`]: t.rangeIntervalDayHighlightEnd
  }, {
    [`&.${Sn.firstVisibleCell}`]: t.firstVisibleCell
  }, {
    [`&.${Sn.lastVisibleCell}`]: t.lastVisibleCell
  }, {
    [`&.${Sn.startOfMonth}`]: t.startOfMonth
  }, {
    [`&.${Sn.endOfMonth}`]: t.endOfMonth
  }, {
    [`&.${Sn.outsideCurrentMonth}`]: t.outsideCurrentMonth
  }, {
    [`&.${Sn.hiddenDayFiller}`]: t.hiddenDayFiller
  }, t.root]
})(({
  theme: e
}) => ({
  variants: [{
    props: {
      isHiddenDayFiller: !1
    },
    style: {
      [`&:first-of-type .${Sn.rangeIntervalDayPreview}`]: I({}, sf, {
        borderLeftColor: (e.vars || e).palette.divider
      }),
      [`&:last-of-type .${Sn.rangeIntervalDayPreview}`]: I({}, rf, {
        borderRightColor: (e.vars || e).palette.divider
      })
    }
  }, {
    props: {
      isHiddenDayFiller: !1,
      isHighlighting: !0
    },
    style: {
      borderRadius: 0,
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : he(e.palette.primary.main, e.palette.action.focusOpacity),
      "&:first-of-type": sf,
      "&:last-of-type": rf
    }
  }, {
    props: ({
      ownerState: {
        isHiddenDayFiller: t,
        isStartOfHighlighting: n,
        isFirstVisibleCell: o
      }
    }) => !t && (n || o),
    style: I({}, sf, {
      paddingLeft: 0
    })
  }, {
    props: ({
      ownerState: {
        isHiddenDayFiller: t,
        isEndOfHighlighting: n,
        isLastVisibleCell: o
      }
    }) => !t && (n || o),
    style: I({}, rf, {
      paddingRight: 0
    })
  }]
})), lle = te("div", {
  name: "MuiDateRangePickerDay",
  slot: "RangeIntervalPreview",
  overridesResolver: (e, t) => [{
    [`&.${Sn.rangeIntervalDayPreview}`]: t.rangeIntervalDayPreview
  }, {
    [`&.${Sn.rangeIntervalDayPreviewStart}`]: t.rangeIntervalDayPreviewStart
  }, {
    [`&.${Sn.rangeIntervalDayPreviewEnd}`]: t.rangeIntervalDayPreviewEnd
  }, t.rangeIntervalPreview]
})(({
  theme: e
}) => ({
  // replace default day component margin with transparent border to avoid jumping on preview
  border: "2px solid transparent",
  variants: [{
    props: {
      isPreviewing: !0,
      isHiddenDayFiller: !1
    },
    style: {
      borderRadius: 0,
      border: `2px dashed ${(e.vars || e).palette.divider}`,
      borderLeftColor: "transparent",
      borderRightColor: "transparent"
    }
  }, {
    props: ({
      ownerState: {
        isPreviewing: t,
        isHiddenDayFiller: n,
        isStartOfPreviewing: o,
        isFirstVisibleCell: s
      }
    }) => t && !n && (o || s),
    style: I({
      borderLeftColor: (e.vars || e).palette.divider
    }, sf)
  }, {
    props: ({
      ownerState: {
        isPreviewing: t,
        isHiddenDayFiller: n,
        isEndOfPreviewing: o,
        isLastVisibleCell: s
      }
    }) => t && !n && (o || s),
    style: I({
      borderRightColor: (e.vars || e).palette.divider
    }, rf)
  }]
})), cle = te(ON, {
  name: "MuiDateRangePickerDay",
  slot: "Day",
  overridesResolver: (e, t) => [{
    [`&.${Sn.dayInsideRangeInterval}`]: t.dayInsideRangeInterval
  }, {
    [`&.${Sn.dayOutsideRangeInterval}`]: t.dayOutsideRangeInterval
  }, {
    [`&.${Sn.notSelectedDate}`]: t.notSelectedDate
  }, t.day]
})({
  // Required to overlap preview border
  transform: "scale(1.1)",
  "& > *": {
    transform: "scale(0.9)"
  },
  variants: [{
    props: {
      draggable: !0
    },
    style: {
      cursor: "grab",
      touchAction: "none"
    }
  }]
}), r$ = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiDateRangePickerDay"
  }), {
    className: s,
    day: i,
    outsideCurrentMonth: a,
    isHighlighting: l,
    isPreviewing: c,
    selected: u = !1,
    isVisuallySelected: d,
    sx: f,
    draggable: p,
    isFirstVisibleCell: m,
    isLastVisibleCell: b
  } = o, v = ve(o, rle);
  Mu("x-date-pickers-pro", sle);
  const g = Wt(), y = g.isSameDay(i, g.endOfMonth(i)), w = g.isSameDay(i, g.startOfMonth(i)), x = I({}, o, {
    selected: u,
    isStartOfMonth: w,
    isEndOfMonth: y,
    draggable: p,
    isFirstVisibleCell: m,
    isLastVisibleCell: b,
    isHiddenDayFiller: a && !v.showDaysOutsideCurrentMonth
  }), S = ile(x);
  return /* @__PURE__ */ C(ale, {
    className: ae(S.root, s),
    ownerState: x,
    sx: f,
    children: /* @__PURE__ */ C(lle, {
      className: S.rangeIntervalPreview,
      ownerState: x,
      children: /* @__PURE__ */ C(cle, I({}, v, {
        ref: n,
        disableMargin: !0,
        day: i,
        selected: d,
        outsideCurrentMonth: a,
        className: S.day,
        ownerState: x,
        draggable: p,
        isFirstVisibleCell: m,
        isLastVisibleCell: b
      }))
    })
  });
});
process.env.NODE_ENV !== "production" && (r$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: r.oneOfType([r.func, r.shape({
    current: r.shape({
      focusVisible: r.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  component: r.elementType,
  /**
   * The date to show.
   */
  day: r.object.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: r.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: r.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: r.bool,
  /**
   * If `true`, the day can be dragged to change the current date range.
   * @default false
   */
  draggable: r.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: r.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: r.string,
  isAnimating: r.bool,
  /**
   * Set to `true` if the `day` is the end of a highlighted date range.
   */
  isEndOfHighlighting: r.bool.isRequired,
  /**
   * Set to `true` if the `day` is the end of a previewing date range.
   */
  isEndOfPreviewing: r.bool.isRequired,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: r.bool.isRequired,
  /**
   * Set to `true` if the `day` is in a highlighted date range.
   */
  isHighlighting: r.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: r.bool.isRequired,
  /**
   * Set to `true` if the `day` is in a preview date range.
   */
  isPreviewing: r.bool.isRequired,
  /**
   * Set to `true` if the `day` is the start of a highlighted date range.
   */
  isStartOfHighlighting: r.bool.isRequired,
  /**
   * Set to `true` if the `day` is the start of a previewing date range.
   */
  isStartOfPreviewing: r.bool.isRequired,
  /**
   * Indicates if the day should be visually selected.
   */
  isVisuallySelected: r.bool,
  onDaySelect: r.func.isRequired,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: r.func,
  onMouseEnter: r.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: r.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: r.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * @default 0
   */
  tabIndex: r.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: r.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: r.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: r.oneOfType([r.func, r.shape({
    current: r.shape({
      pulsate: r.func.isRequired,
      start: r.func.isRequired,
      stop: r.func.isRequired
    })
  })])
});
const ule = /* @__PURE__ */ h.memo(r$), Gu = (e, t) => !!(t && t[0] && t[1] && !e.isBefore(t[1], t[0])), Vg = (e, t, n) => Gu(e, n) && e.isWithinRange(t, n), af = (e, t, n) => Gu(e, n) && e.isSameDay(t, n[0]), mc = (e, t, n) => Gu(e, n) && e.isSameDay(t, n[1]), kd = (e) => {
  const t = [], n = [];
  return e.forEach((o) => {
    o.dateName === "start" ? t.push(o) : n.push(o);
  }), {
    startDate: t,
    endDate: n
  };
}, dle = (e) => e.map((t, n) => n === e.length - 1 ? I({}, t, {
  separator: null
}) : t), fle = ["value", "referenceDate"], Ml = {
  emptyValue: [null, null],
  getTodayValue: (e, t, n) => [Uf(e, t, n), Uf(e, t, n)],
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: n
    } = e, o = ve(e, fle);
    const s = t[0] != null && o.utils.isValid(t[0]), i = t[1] != null && o.utils.isValid(t[1]);
    if (s && i)
      return t;
    const a = n ?? mN(o);
    return [s ? t[0] : a, i ? t[1] : a];
  },
  cleanValue: (e, t) => t.map((n) => gN(e, n)),
  areValuesEqual: (e, t, n) => Wy(e, t[0], n[0]) && Wy(e, t[1], n[1]),
  isSameError: (e, t) => t !== null && e[1] === t[1] && e[0] === t[0],
  hasError: (e) => e[0] != null || e[1] != null,
  defaultErrorState: [null, null],
  getTimezone: (e, t) => {
    const n = t[0] == null || !e.isValid(t[0]) ? null : e.getTimezone(t[0]), o = t[1] == null || !e.isValid(t[1]) ? null : e.getTimezone(t[1]);
    if (n != null && o != null && n !== o)
      throw new Error("MUI X: The timezone of the start and the end date should be the same.");
    return n ?? o;
  },
  setTimezone: (e, t, n) => [n[0] == null ? null : e.setTimezone(n[0], t), n[1] == null ? null : e.setTimezone(n[1], t)]
}, ple = ({
  dateSeparator: e = "–"
}) => ({
  updateReferenceValue: (t, n, o) => {
    const s = n[0] != null && t.isValid(n[0]), i = n[1] != null && t.isValid(n[1]);
    return !s && !i ? o : s && i ? n : s ? [n[0], o[0]] : [o[1], n[1]];
  },
  getSectionsFromValue: (t, [n, o], s, i) => {
    const a = s == null ? {
      startDate: null,
      endDate: null
    } : kd(s), l = (c, u, d) => {
      if (!t.isValid(c) && !!u)
        return u;
      const p = i(c);
      return p.map((m, b) => b === p.length - 1 && d === "start" ? I({}, m, {
        dateName: d,
        // TODO: Check if RTL still works
        endSeparator: `${m.endSeparator} ${e} `
      }) : I({}, m, {
        dateName: d
      }));
    };
    return [...l(n, a.startDate, "start"), ...l(o, a.endDate, "end")];
  },
  getV7HiddenInputValueFromSections: (t) => {
    const n = kd(t);
    return SN([...n.startDate, ...n.endDate]);
  },
  getV6InputValueFromSections: (t, n, o) => {
    const s = kd(t);
    return xN([...s.startDate, ...s.endDate], n, o);
  },
  parseValueStr: (t, n, o) => {
    const [s, i] = t.split(e);
    return [s, i].map((a, l) => a == null ? null : o(a.trim(), n[l]));
  },
  getActiveDateManager: (t, n, o) => {
    const s = o.dateName === "start" ? 0 : 1, i = (a, l) => s === 0 ? [a, l[1]] : [l[0], a];
    return {
      date: n.value[s],
      referenceDate: n.referenceValue[s],
      getSections: (a) => {
        const l = kd(a);
        return s === 0 ? dle(l.startDate) : l.endDate;
      },
      getNewValuesFromNewActiveDate: (a) => ({
        value: i(a, n.value),
        referenceValue: a == null || !t.isValid(a) ? n.referenceValue : i(a, n.referenceValue)
      })
    };
  }
}), hle = ["shouldDisableDate"], qu = ({
  adapter: e,
  value: t,
  timezone: n,
  props: o
}) => {
  const [s, i] = t, {
    shouldDisableDate: a
  } = o, l = ve(o, hle), c = [Gi({
    adapter: e,
    value: s,
    timezone: n,
    props: I({}, l, {
      shouldDisableDate: (u) => !!(a != null && a(u, "start"))
    })
  }), Gi({
    adapter: e,
    value: i,
    timezone: n,
    props: I({}, l, {
      shouldDisableDate: (u) => !!(a != null && a(u, "end"))
    })
  })];
  return c[0] || c[1] ? c : s === null || i === null ? [null, null] : Gu(e.utils, t) ? [null, null] : ["invalidRange", "invalidRange"];
};
qu.valueManager = Ml;
const NR = (e, t) => Object.keys(e).reduce((n, o) => (t.includes(o) || (n[o] = e[o]), n), {}), gle = (e) => {
  const t = h.useRef(null), n = tt(e.unstableEndFieldRef, t), [o, s] = h.useState(e.selectedSections ?? null), [i, a] = h.useState(null), l = () => t.current && t.current.isFieldFocused() ? "end" : "start", c = xe((f) => {
    var p;
    s(f), l() === "start" && ((p = e.onSelectedSectionsChange) == null || p.call(e, f));
  }), u = xe((f) => {
    var p;
    a(f), l() === "end" && ((p = e.onSelectedSectionsChange) == null || p.call(e, f));
  }), d = l();
  return {
    start: {
      unstableFieldRef: e.unstableStartFieldRef,
      selectedSections: d === "start" && e.selectedSections !== void 0 ? e.selectedSections : o,
      onSelectedSectionsChange: c
    },
    end: {
      unstableFieldRef: n,
      selectedSections: d === "end" && e.selectedSections !== void 0 ? e.selectedSections : i,
      onSelectedSectionsChange: u
    }
  };
}, mle = ({
  sharedProps: e,
  startTextFieldProps: t,
  unstableStartFieldRef: n,
  endTextFieldProps: o,
  unstableEndFieldRef: s
}) => {
  const i = I0(e), {
    value: a,
    defaultValue: l,
    referenceDate: c,
    format: u,
    formatDensity: d,
    shouldRespectLeadingZeros: f,
    onChange: p,
    disabled: m,
    readOnly: b,
    selectedSections: v,
    onSelectedSectionsChange: g,
    timezone: y,
    enableAccessibleFieldDOMStructure: w,
    autoFocus: x
  } = i, {
    value: S,
    handleValueChange: T,
    timezone: E
  } = Hu({
    name: "useMultiInputDateRangeField",
    timezone: y,
    value: a,
    defaultValue: l,
    referenceDate: c,
    onChange: p,
    valueManager: Ml
  }), {
    validationError: O,
    getValidationErrorForNewValue: M
  } = R0({
    props: i,
    value: S,
    timezone: E,
    validator: qu,
    onError: i.onError
  }), D = (L) => (B, V) => {
    const _ = L === 0 ? [B, S[1]] : [S[0], B], z = I({}, V, {
      validationError: M(_)
    });
    T(_, z);
  }, R = xe(D(0)), P = xe(D(1)), F = gle({
    selectedSections: v,
    onSelectedSectionsChange: g,
    unstableStartFieldRef: n,
    unstableEndFieldRef: s
  }), $ = I({
    error: !!O[0]
  }, t, F.start, {
    disabled: m,
    readOnly: b,
    format: u,
    formatDensity: d,
    shouldRespectLeadingZeros: f,
    timezone: E,
    value: a === void 0 ? void 0 : a[0],
    defaultValue: l === void 0 ? void 0 : l[0],
    onChange: R,
    enableAccessibleFieldDOMStructure: w,
    autoFocus: x
    // Do not add on end field.
  }), N = I({
    error: !!O[1]
  }, o, F.end, {
    format: u,
    formatDensity: d,
    shouldRespectLeadingZeros: f,
    disabled: m,
    readOnly: b,
    timezone: E,
    value: a === void 0 ? void 0 : a[1],
    defaultValue: l === void 0 ? void 0 : l[1],
    onChange: P,
    enableAccessibleFieldDOMStructure: w
  }), A = Ky($), k = Ky(N);
  return {
    startDate: NR(A, ["clearable", "onClear"]),
    endDate: NR(k, ["clearable", "onClear"])
  };
}, ble = ["slots", "slotProps", "unstableStartFieldRef", "unstableEndFieldRef", "className"];
Ne("MuiMultiInputDateRangeField", ["root", "separator"]);
const yle = (e) => De("MuiMultiInputDateRangeField", e), vle = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    separator: ["separator"]
  }, yle, t);
}, Cle = te(/* @__PURE__ */ h.forwardRef((e, t) => /* @__PURE__ */ C(yC, I({
  ref: t,
  spacing: 2,
  direction: "row",
  alignItems: "baseline"
}, e))), {
  name: "MuiMultiInputDateRangeField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), wle = te(yn, {
  name: "MuiMultiInputDateRangeField",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  lineHeight: "1.4375em"
  // 23px
}), A0 = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiMultiInputDateRangeField"
  }), {
    internalProps: s,
    forwardedProps: i
  } = E0(o, "date"), {
    slots: a,
    slotProps: l,
    unstableStartFieldRef: c,
    unstableEndFieldRef: u,
    className: d
  } = i, f = ve(i, ble), p = o, m = vle(p), b = (a == null ? void 0 : a.root) ?? Cle, v = et({
    elementType: b,
    externalSlotProps: l == null ? void 0 : l.root,
    externalForwardedProps: f,
    additionalProps: {
      ref: n
    },
    ownerState: p,
    className: ae(d, m.root)
  }), g = (a == null ? void 0 : a.textField) ?? (t.enableAccessibleFieldDOMStructure ? ah : Is), y = et({
    elementType: g,
    externalSlotProps: l == null ? void 0 : l.textField,
    ownerState: I({}, p, {
      position: "start"
    })
  }), w = et({
    elementType: g,
    externalSlotProps: l == null ? void 0 : l.textField,
    ownerState: I({}, p, {
      position: "end"
    })
  }), x = (a == null ? void 0 : a.separator) ?? wle, S = et({
    elementType: x,
    externalSlotProps: l == null ? void 0 : l.separator,
    additionalProps: {
      children: ` ${s.dateSeparator ?? "–"} `
    },
    ownerState: p,
    className: m.separator
  }), T = mle({
    sharedProps: s,
    startTextFieldProps: y,
    endTextFieldProps: w,
    unstableStartFieldRef: c,
    unstableEndFieldRef: u
  }), E = Yf(T.startDate), O = Yf(T.endDate);
  return /* @__PURE__ */ ie(b, I({}, v, {
    children: [/* @__PURE__ */ C(g, I({
      fullWidth: !0
    }, E)), /* @__PURE__ */ C(x, I({}, S)), /* @__PURE__ */ C(g, I({
      fullWidth: !0
    }, O))]
  }));
});
process.env.NODE_ENV !== "production" && (A0.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: r.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  component: r.elementType,
  /**
   * String displayed between the start and the end dates.
   * @default "–"
   */
  dateSeparator: r.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.arrayOf(r.object),
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: r.oneOfType([r.oneOf(["column-reverse", "column", "row-reverse", "row"]), r.arrayOf(r.oneOf(["column-reverse", "column", "row-reverse", "row"])), r.object]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * Add an element between each child.
   */
  divider: r.node,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: r.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: r.object,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @param {string} position The date to test, 'start' or 'end'.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: r.oneOfType([r.arrayOf(r.oneOfType([r.number, r.string])), r.number, r.object, r.string]),
  style: r.object,
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  unstableEndFieldRef: r.oneOfType([r.func, r.object]),
  unstableStartFieldRef: r.oneOfType([r.func, r.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: r.bool,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.arrayOf(r.object)
});
const Sle = (e) => {
  const t = I0(e), {
    forwardedProps: n,
    internalProps: o
  } = E0(t, "date"), s = h.useMemo(() => ple({
    dateSeparator: o.dateSeparator
  }), [o.dateSeparator]);
  return MN({
    forwardedProps: n,
    internalProps: o,
    valueManager: Ml,
    fieldValueManager: s,
    validator: qu,
    valueType: "date"
  });
}, xle = ["slots", "slotProps", "InputProps", "inputProps"], F0 = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiSingleInputDateRangeField"
  }), {
    slots: s,
    slotProps: i,
    InputProps: a,
    inputProps: l
  } = o, c = ve(o, xle), u = o, d = (s == null ? void 0 : s.textField) ?? (t.enableAccessibleFieldDOMStructure ? ah : Is), f = et({
    elementType: d,
    externalSlotProps: i == null ? void 0 : i.textField,
    externalForwardedProps: c,
    ownerState: u,
    additionalProps: {
      ref: n
    }
  });
  f.inputProps = I({}, l, f.inputProps), f.InputProps = I({}, a, f.InputProps);
  const p = Sle(f), m = Yf(p), b = kN(I({}, m, {
    slots: s,
    slotProps: i
  }));
  return /* @__PURE__ */ C(d, I({}, b));
});
F0.fieldType = "single-input";
process.env.NODE_ENV !== "production" && (F0.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: r.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: r.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: r.elementType,
  /**
   * String displayed between the start and the end dates.
   * @default "–"
   */
  dateSeparator: r.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: r.arrayOf(r.object),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: r.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: r.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: r.bool,
  /**
   * The helper text content.
   */
  helperText: r.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: r.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: r.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: r.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: r.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: r.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: Lt,
  /**
   * The label content.
   */
  label: r.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: r.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Name attribute of the `input` element.
   */
  name: r.string,
  onBlur: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: r.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: r.func,
  onFocus: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: r.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: r.object,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: r.bool,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @param {string} position The date to test, 'start' or 'end'.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default false
   */
  shouldRespectLeadingZeros: r.bool,
  /**
   * The size of the component.
   */
  size: r.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  style: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: r.oneOfType([r.func, r.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.arrayOf(r.object),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: r.oneOf(["filled", "outlined", "standard"])
});
const Tle = (e) => De("MuiDateRangeCalendar", e), $R = Ne("MuiDateRangeCalendar", ["root", "monthContainer", "dayDragging"]);
function Yy({
  utils: e,
  range: t,
  newDate: n,
  rangePosition: o,
  allowRangeFlip: s = !1,
  shouldMergeDateAndTime: i = !1,
  referenceDate: a
}) {
  const [l, c] = t;
  i && n && (l && o === "start" && (n = Ni(e, n, l)), c && o === "end" && (n = Ni(e, n, c)));
  const u = a && n && i ? Ni(e, n, a) : n;
  if (o === "start") {
    const f = s ? {
      nextSelection: "start",
      newRange: [c, u]
    } : {
      nextSelection: "end",
      newRange: [u, null]
    };
    return c && e.isAfter(u, c) ? f : {
      nextSelection: "end",
      newRange: [u, c]
    };
  }
  const d = s ? {
    nextSelection: "end",
    newRange: [u, l]
  } : {
    nextSelection: "end",
    newRange: [u, null]
  };
  return l && e.isBeforeDay(u, l) ? d : {
    nextSelection: "start",
    newRange: [l, u]
  };
}
function Rle(e) {
  if (e.newDate == null)
    return [null, null];
  const [t, n] = e.range, {
    newRange: o
  } = Yy(e);
  if (!t || !n)
    return o;
  const [s, i] = o;
  return e.rangePosition === "end" ? [n, i] : [s, t];
}
const ba = (e, t, n) => {
  const o = e.dataset.timestamp;
  if (!o)
    return null;
  const s = +o;
  return t.date(new Date(s).toISOString(), n);
}, Ele = (e) => e.target.dataset.timestamp === e.dataTransfer.getData("draggingDate"), s$ = (e) => e && (e instanceof HTMLButtonElement && !e.disabled ? e : e.children.length ? s$(e.children[0]) : null), Bg = (e, t) => {
  var n;
  if (((n = e.changedTouches) == null ? void 0 : n.length) === 1 && e.touches.length <= 1) {
    const o = document.elementFromPoint(e.changedTouches[0].clientX, e.changedTouches[0].clientY), s = s$(o);
    return t && s === e.changedTouches[0].target ? null : s;
  }
  return null;
}, Ile = ({
  utils: e,
  setRangeDragDay: t,
  setIsDragging: n,
  isDragging: o,
  onDatePositionChange: s,
  onDrop: i,
  disableDragEditing: a,
  dateRange: l,
  timezone: c
}) => {
  const u = h.useRef(null);
  h.useEffect(() => {
    u.current = document.createElement("img"), u.current.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
  }, []);
  const d = (S) => {
    if (S == null)
      return !1;
    const T = !a && !!l[0] && !!l[1], E = af(e, S, l), O = mc(e, S, l);
    return T && (E || O);
  }, f = xe((S) => {
    const T = ba(S.target, e, c);
    if (!d(T))
      return;
    S.stopPropagation(), u.current && S.dataTransfer.setDragImage(u.current, 0, 0), t(T), S.dataTransfer.effectAllowed = "move", n(!0);
    const E = S.target.dataset;
    E.timestamp && S.dataTransfer.setData("draggingDate", E.timestamp), E.position && s(E.position);
  }), p = xe((S) => {
    const T = Bg(S);
    if (!T)
      return;
    const E = ba(T, e, c);
    d(E) && t(E);
  }), m = xe((S) => {
    o && (S.preventDefault(), S.stopPropagation(), S.dataTransfer.dropEffect = "move", t(ba(S.target, e, c)));
  }), b = xe((S) => {
    const T = Bg(S);
    if (!T)
      return;
    const E = ba(T, e, c);
    if (E && t(E), !(T === S.changedTouches[0].target) || !d(E))
      return;
    n(!0);
    const D = S.target.dataset;
    D.position && s(D.position);
  }), v = xe((S) => {
    o && (S.preventDefault(), S.stopPropagation());
  }), g = xe((S) => {
    o && (S.preventDefault(), S.stopPropagation(), S.dataTransfer.dropEffect = "move");
  }), y = xe((S) => {
    if (!o)
      return;
    t(null), n(!1);
    const T = Bg(S, !0);
    if (!T)
      return;
    T.focus();
    const E = ba(T, e, c);
    E && i(E);
  }), w = xe((S) => {
    o && (S.preventDefault(), S.stopPropagation(), n(!1), t(null));
  }), x = xe((S) => {
    if (!o || (S.preventDefault(), S.stopPropagation(), n(!1), t(null), S.currentTarget.focus(), Ele(S)))
      return;
    const T = ba(S.target, e, c);
    T && i(T);
  });
  return {
    onDragStart: f,
    onDragEnter: m,
    onDragLeave: v,
    onDragOver: g,
    onDragEnd: w,
    onDrop: x,
    onTouchStart: p,
    onTouchMove: b,
    onTouchEnd: y
  };
}, Ole = ({
  disableDragEditing: e,
  utils: t,
  onDatePositionChange: n,
  onDrop: o,
  dateRange: s,
  timezone: i
}) => {
  const [a, l] = h.useState(!1), [c, u] = h.useState(null), d = xe((m) => {
    t.isEqual(m, c) || u(m);
  }), f = h.useMemo(() => {
    const [m, b] = s;
    if (c) {
      if (m && t.isBefore(c, m))
        return "start";
      if (b && t.isAfter(c, b))
        return "end";
    }
    return null;
  }, [s, c, t]), p = Ile({
    utils: t,
    onDatePositionChange: n,
    onDrop: o,
    setIsDragging: l,
    isDragging: a,
    setRangeDragDay: d,
    disableDragEditing: e,
    dateRange: s,
    timezone: i
  });
  return h.useMemo(() => I({
    isDragging: a,
    rangeDragDay: c,
    draggingDatePosition: f
  }, e ? {} : p), [a, c, f, e, p]);
}, L0 = (e, t) => {
  const [n, o] = jn({
    name: "useRangePosition",
    state: "rangePosition",
    controlled: e.rangePosition,
    default: e.defaultRangePosition ?? "start"
  }), s = (a) => {
    if ((t == null ? void 0 : t.current) == null)
      return;
    const l = t.current.getSections(), c = a === "start" ? 0 : l.length / 2, u = t.current.getActiveSectionIndex();
    u && u >= c && u < c + l.length / 2 || t.current.setSelectedSections(c);
  }, i = xe((a) => {
    var l;
    o(a), (l = e.onRangePositionChange) == null || l.call(e, a), s(a);
  });
  return {
    rangePosition: n,
    onRangePositionChange: i
  };
}, Ple = 40, Mle = ["calendars", "month", "monthIndex", "labelId"], kle = ["format", "slots", "slotProps", "currentMonth", "onMonthChange", "disableFuture", "disablePast", "minDate", "maxDate", "timezone", "reduceAnimations", "views", "view"], Dle = te(fN)({
  padding: "12px 16px 4px 16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
}), i$ = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Wt(), s = er(), {
    calendars: i,
    month: a,
    monthIndex: l,
    labelId: c
  } = t, u = ve(t, Mle), {
    format: d,
    slots: f,
    slotProps: p,
    currentMonth: m,
    onMonthChange: b,
    disableFuture: v,
    disablePast: g,
    minDate: y,
    maxDate: w,
    timezone: x
    // omit props that are not used in the PickersArrowSwitcher
  } = u, S = ve(u, kle), T = pN(m, {
    disableFuture: v,
    maxDate: w,
    timezone: x
  }), E = hN(m, {
    disablePast: g,
    minDate: y,
    timezone: x
  });
  return i === 1 ? /* @__PURE__ */ C(N0, I({}, u, {
    labelId: c,
    ref: n
  })) : /* @__PURE__ */ C(Dle, I({}, S, {
    ref: n,
    onGoToPrevious: () => b(o.addMonths(m, -1), "right"),
    onGoToNext: () => b(o.addMonths(m, 1), "left"),
    isPreviousHidden: l !== 0,
    isPreviousDisabled: E,
    previousLabel: s.previousMonth,
    isNextHidden: l !== i - 1,
    isNextDisabled: T,
    nextLabel: s.nextMonth,
    slots: f,
    slotProps: p,
    labelId: c,
    children: o.formatByString(a, d ?? `${o.formats.month} ${o.formats.year}`)
  }));
});
process.env.NODE_ENV !== "production" && (i$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The number of calendars rendered.
   */
  calendars: r.oneOf([1, 2, 3]).isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  currentMonth: r.object.isRequired,
  disabled: r.bool,
  disableFuture: r.bool,
  disablePast: r.bool,
  /**
   * Format used to display the date.
   * @default `${adapter.formats.month} ${adapter.formats.year}`
   */
  format: r.string,
  /**
   * Id of the calendar text element.
   * It is used to establish an `aria-labelledby` relationship with the calendar `grid` element.
   */
  labelId: r.string,
  maxDate: r.object.isRequired,
  minDate: r.object.isRequired,
  /**
   * Month used for this header.
   */
  month: r.object.isRequired,
  /**
   * Index of the month used for this header.
   */
  monthIndex: r.number.isRequired,
  onMonthChange: r.func.isRequired,
  onViewChange: r.func,
  reduceAnimations: r.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  timezone: r.string.isRequired,
  view: r.oneOf(["day", "month", "year"]).isRequired,
  views: r.arrayOf(r.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const Nle = ["value", "defaultValue", "referenceDate", "onChange", "className", "disableFuture", "disablePast", "minDate", "maxDate", "shouldDisableDate", "reduceAnimations", "onMonthChange", "rangePosition", "defaultRangePosition", "onRangePositionChange", "calendars", "currentMonthCalendarPosition", "slots", "slotProps", "loading", "renderLoading", "disableHighlightToday", "readOnly", "disabled", "showDaysOutsideCurrentMonth", "dayOfWeekFormatter", "disableAutoMonthSwitching", "autoFocus", "fixedWeekNumber", "disableDragEditing", "displayWeekNumber", "timezone", "availableRangePositions", "views", "view", "openTo", "onViewChange"], $le = ["isDragging", "rangeDragDay", "draggingDatePosition"], Ale = ch(), Fle = te("div", {
  name: "MuiDateRangeCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "row"
}), Lle = te("div", {
  name: "MuiDateRangeCalendar",
  slot: "Container",
  overridesResolver: (e, t) => t.monthContainer
})(({
  theme: e
}) => ({
  "&:not(:last-of-type)": {
    borderRight: `1px solid ${(e.vars || e).palette.divider}`
  }
})), _le = (Ple + zu * 2) * 6, Vle = te(HN)(({
  theme: e
}) => ({
  minWidth: 312,
  minHeight: _le,
  [`&.${$R.dayDragging}`]: {
    [`& .${Sn.day}`]: {
      cursor: "grabbing"
    },
    [`& .${Sn.root}:not(.${Sn.rangeIntervalDayHighlightStart}):not(.${Sn.rangeIntervalDayHighlightEnd}) .${Sn.day}:not(.${Sn.notSelectedDate})`]: {
      // we can't override `PickersDay` background color here, because it's styles take precedence
      opacity: 0.6
    }
  },
  [`&:not(.${$R.dayDragging}) .${Sn.dayOutsideRangeInterval}`]: {
    "@media (pointer: fine)": {
      "&:hover": {
        border: `1px solid ${(e.vars || e).palette.grey[500]}`
      }
    }
  }
})), Ble = Vle;
function zle(e, t) {
  const n = Wt(), o = ia(), s = $0(), i = Et({
    props: e,
    name: t
  });
  return I({}, i, {
    renderLoading: i.renderLoading ?? (() => /* @__PURE__ */ C("span", {
      children: "..."
    })),
    reduceAnimations: i.reduceAnimations ?? s,
    loading: e.loading ?? !1,
    disablePast: e.disablePast ?? !1,
    disableFuture: e.disableFuture ?? !1,
    openTo: i.openTo ?? "day",
    views: i.views ?? ["day"],
    minDate: io(n, i.minDate, o.minDate),
    maxDate: io(n, i.maxDate, o.maxDate),
    calendars: i.calendars ?? 2,
    disableDragEditing: i.disableDragEditing ?? !1,
    availableRangePositions: i.availableRangePositions ?? ["start", "end"]
  });
}
const Hle = (e) => {
  const {
    classes: t,
    isDragging: n
  } = e;
  return fe({
    root: ["root"],
    monthContainer: ["monthContainer"],
    dayCalendar: [n && "dayDragging"]
  }, Tle, t);
}, a$ = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = zle(t, "MuiDateRangeCalendar"), s = Qi(TN, {
    defaultMatches: !1
  }), {
    value: i,
    defaultValue: a,
    referenceDate: l,
    onChange: c,
    className: u,
    disableFuture: d,
    disablePast: f,
    minDate: p,
    maxDate: m,
    shouldDisableDate: b,
    reduceAnimations: v,
    onMonthChange: g,
    rangePosition: y,
    defaultRangePosition: w,
    onRangePositionChange: x,
    calendars: S,
    currentMonthCalendarPosition: T = 1,
    slots: E,
    slotProps: O,
    loading: M,
    renderLoading: D,
    disableHighlightToday: R,
    readOnly: P,
    disabled: F,
    showDaysOutsideCurrentMonth: $,
    dayOfWeekFormatter: N,
    disableAutoMonthSwitching: A,
    autoFocus: k,
    fixedWeekNumber: L,
    disableDragEditing: B,
    displayWeekNumber: V,
    timezone: _,
    availableRangePositions: z,
    views: j,
    view: W,
    openTo: J,
    onViewChange: G
  } = o, q = ve(o, Nle), {
    value: Z,
    handleValueChange: Y,
    timezone: Q
  } = Hu({
    name: "DateRangeCalendar",
    timezone: _,
    value: i,
    referenceDate: l,
    defaultValue: a,
    onChange: c,
    valueManager: Ml
  }), {
    setValueAndGoToNextView: ee,
    view: ne
  } = b0({
    view: W,
    views: j,
    openTo: J,
    onChange: Y,
    onViewChange: G,
    autoFocus: k
  }), H = Wt(), U = Bu(Q), X = gt(), {
    rangePosition: re,
    onRangePositionChange: oe
  } = L0({
    rangePosition: y,
    defaultRangePosition: w,
    onRangePositionChange: x
  }), le = xe((Ze) => {
    re !== Ze && oe(Ze);
  }), se = xe((Ze, ct, Ut = !1) => {
    const {
      nextSelection: xn,
      newRange: Fn
    } = Yy({
      newDate: Ze,
      utils: H,
      range: Z,
      rangePosition: re,
      allowRangeFlip: Ut,
      shouldMergeDateAndTime: !0,
      referenceDate: l
    }), Rn = z.includes(xn);
    Rn && oe(xn);
    const Tn = re === "end" && Gu(H, Fn);
    ee(Fn, Tn || !Rn ? "finish" : "partial", ne);
  }), Ce = xe((Ze) => {
    se(Ze, void 0, !0);
  }), $e = B || F || P, we = h.useMemo(() => [Z[0] == null || !H.isValid(Z[0]) ? Z[0] : H.startOfDay(Z[0]), Z[1] == null || !H.isValid(Z[1]) ? Z[1] : H.endOfDay(Z[1])], [Z, H]), Te = Ole({
    disableDragEditing: $e,
    onDrop: Ce,
    onDatePositionChange: le,
    utils: H,
    dateRange: we,
    timezone: Q
  }), {
    isDragging: ue,
    rangeDragDay: de,
    draggingDatePosition: Pe
  } = Te, ke = ve(Te, $le), Me = I({}, o, {
    isDragging: ue
  }), be = Hle(Me), me = h.useMemo(() => {
    if (!we[0] || !we[1] || !de)
      return [null, null];
    const Ze = Yy({
      utils: H,
      range: we,
      newDate: de,
      rangePosition: re,
      allowRangeFlip: !0
    }).newRange;
    return Ze[0] !== null && Ze[1] !== null ? [H.startOfDay(Ze[0]), H.endOfDay(Ze[1])] : Ze;
  }, [re, de, H, we]), Ae = h.useMemo(() => {
    if (b)
      return (Ze) => b(Ze, Pe || re);
  }, [b, re, Pe]), {
    calendarState: ye,
    changeFocusedDay: We,
    changeMonth: He,
    handleChangeMonth: ze,
    onMonthSwitchingAnimationEnd: pe
  } = VN({
    value: Z[0] || Z[1],
    referenceDate: l,
    disableFuture: d,
    disablePast: f,
    disableSwitchToMonthOnDayFocus: !0,
    maxDate: m,
    minDate: p,
    onMonthChange: g,
    reduceAnimations: v,
    shouldDisableDate: Ae,
    timezone: Q
  }), Re = (E == null ? void 0 : E.calendarHeader) ?? i$, Ge = et({
    elementType: Re,
    externalSlotProps: O == null ? void 0 : O.calendarHeader,
    additionalProps: {
      calendars: S,
      views: ["day"],
      view: "day",
      currentMonth: ye.currentMonth,
      onMonthChange: (Ze, ct) => ze({
        newMonth: Ze,
        direction: ct
      }),
      minDate: p,
      maxDate: m,
      disabled: F,
      disablePast: f,
      disableFuture: d,
      reduceAnimations: v,
      timezone: Q,
      slots: E,
      slotProps: O
    },
    ownerState: o
  }), Qe = h.useRef(null);
  h.useEffect(() => {
    var Rn, Tn;
    const Ze = re === "start" ? Z[0] : Z[1];
    if (!Ze || !H.isValid(Ze))
      return;
    const ct = re === "start" ? (Rn = Qe.current) == null ? void 0 : Rn[0] : (Tn = Qe.current) == null ? void 0 : Tn[1];
    if (Qe.current = Z, A && ct && H.isEqual(ct, Ze))
      return;
    const Ut = S - T, xn = H.getMonth(ye.currentMonth), Fn = H.getMonth(Ze);
    if (!H.isSameYear(ye.currentMonth, Ze) || Fn < xn || Fn > xn + Ut) {
      const an = re === "start" ? Ze : (
        // If need to focus end, scroll to the state when "end" is displaying in the last calendar
        H.addMonths(Ze, -Ut)
      );
      He(an);
    }
  }, [re, Z]);
  const qe = {
    disablePast: f,
    disableFuture: d,
    maxDate: m,
    minDate: p
  }, st = {
    disableHighlightToday: R,
    readOnly: P,
    disabled: F
  }, [wt, Ue] = h.useState(null), nt = h.useMemo(() => ({
    onMouseLeave: () => Ue(null)
  }), []), ft = Rle({
    utils: H,
    range: we,
    newDate: wt,
    rangePosition: re
  }), nn = xe((Ze, ct) => {
    Vg(H, ct, we) ? Ue(null) : Ue(ct);
  }), St = I({
    day: ule
  }, E), Ke = I({}, O, {
    day: (Ze) => {
      const {
        day: ct
      } = Ze, Ut = af(H, ct, we), xn = mc(H, ct, we), Rn = !$e && we[0] && we[1] && (Ut || xn);
      let Tn;
      Ut ? Tn = "start" : xn && (Tn = "end");
      const an = ue ? af(H, ct, me) : Ut, hn = ue ? mc(H, ct, me) : xn;
      return I({
        isPreviewing: s ? Vg(H, ct, ft) : !1,
        isStartOfPreviewing: s ? af(H, ct, ft) : !1,
        isEndOfPreviewing: s ? mc(H, ct, ft) : !1,
        isHighlighting: Vg(H, ct, ue ? me : we),
        isStartOfHighlighting: an,
        isEndOfHighlighting: ue ? mc(H, ct, me) : xn,
        onMouseEnter: s ? nn : void 0,
        // apply selected styling to the dragging start or end day
        isVisuallySelected: Ze.selected || ue && (an || hn),
        "data-position": Tn
      }, ke, {
        draggable: Rn ? !0 : void 0
      }, Ur(O == null ? void 0 : O.day, Ze) ?? {});
    }
  }), Ot = h.useMemo(() => Array.from({
    length: S
  }).map((Ze, ct) => ct), [S]), vn = h.useMemo(() => {
    process.env.NODE_ENV !== "production" && (T > S || T < 1) && vo(["MUI X: The `currentMonthCalendarPosition` prop must be an integer between `1` and the amount of calendars rendered.", "For example if you have 2 calendars rendered, it should be equal to either 1 or 2."]);
    const Ze = H.addMonths(ye.currentMonth, 1 - T);
    return Array.from({
      length: S
    }).map((ct, Ut) => H.addMonths(Ze, Ut));
  }, [H, ye.currentMonth, S, T]), on = h.useMemo(() => k ? Z[0] != null ? vn.find((Ze) => H.isSameMonth(Ze, Z[0])) : Z[1] != null ? vn.find((Ze) => H.isSameMonth(Ze, Z[1])) : vn.find((Ze) => H.isSameMonth(Ze, U)) ?? vn[0] : null, [H, Z, vn, k, U]);
  return /* @__PURE__ */ ie(Fle, I({
    ref: n,
    className: ae(be.root, u),
    ownerState: Me
  }, q, {
    children: [/* @__PURE__ */ C(pk, {
      packageName: "x-date-pickers-pro",
      releaseInfo: Ale
    }), Ot.map((Ze) => {
      const ct = vn[Ze], Ut = `${X}-grid-${Ze}-label`;
      return /* @__PURE__ */ ie(Lle, {
        className: be.monthContainer,
        children: [/* @__PURE__ */ C(Re, I({}, Ge, {
          month: ct,
          monthIndex: Ze,
          labelId: Ut
        })), /* @__PURE__ */ C(Ble, I({
          className: be.dayCalendar
        }, ye, qe, st, {
          onMonthSwitchingAnimationEnd: pe,
          onFocusedDayChange: We,
          reduceAnimations: v,
          selectedDays: Z,
          onSelectedDaysChange: se,
          currentMonth: ct,
          TransitionProps: nt,
          shouldDisableDate: Ae,
          showDaysOutsideCurrentMonth: S === 1 && $,
          dayOfWeekFormatter: N,
          loading: M,
          renderLoading: D,
          slots: St,
          slotProps: Ke,
          autoFocus: ct === on,
          fixedWeekNumber: L,
          displayWeekNumber: V,
          timezone: Q,
          gridLabelId: Ut
        }))]
      }, Ze);
    })]
  }));
});
process.env.NODE_ENV !== "production" && (a$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  /**
   * Range positions available for selection.
   * This list is checked against when checking if a next range position can be selected.
   *
   * Used on Date Time Range pickers with current `rangePosition` to force a `finish` selection after just one range position selection.
   * @default ['start', 'end']
   */
  availableRangePositions: r.arrayOf(r.oneOf(["end", "start"]).isRequired),
  /**
   * The number of calendars to render.
   * @default 2
   */
  calendars: r.oneOf([1, 2, 3]),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  /**
   * Position the current month is rendered in.
   * @default 1
   */
  currentMonthCalendarPosition: r.oneOf([1, 2, 3]),
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The initial position in the edited date range.
   * Used when the component is not controlled.
   * @default 'start'
   */
  defaultRangePosition: r.oneOf(["end", "start"]),
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: r.arrayOf(r.object),
  /**
   * If `true`, after selecting `start` date calendar will not automatically switch to the month of `end` date.
   * @default false
   */
  disableAutoMonthSwitching: r.bool,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, editing dates by dragging is disabled.
   * @default false
   */
  disableDragEditing: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Controlled focused view.
   */
  focusedView: r.oneOf(["day"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: r.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the range position changes.
   * @param {RangePosition} rangePosition The new range position.
   */
  onRangePositionChange: r.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: r.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: r.oneOf(["day"]),
  /**
   * The position in the currently edited date range.
   * Used when the component position is controlled.
   */
  rangePosition: r.oneOf(["end", "start"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: r.object,
  /**
   * Component rendered on the "day" view when `props.loading` is true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => "..."
   */
  renderLoading: r.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @param {string} position The date to test, 'start' or 'end'.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.arrayOf(r.object),
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: r.oneOf(["day"]),
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day"]))
});
function jle(e) {
  return De("MuiDateRangePickerToolbar", e);
}
Ne("MuiDateRangePickerToolbar", ["root", "container"]);
const Gle = ["value", "rangePosition", "onRangePositionChange", "toolbarFormat", "className", "onViewChange", "view", "views"], qle = (e) => {
  const {
    classes: t
  } = e;
  return fe({
    root: ["root"],
    container: ["container"]
  }, jle, t);
}, Wle = te(UN, {
  name: "MuiDateRangePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Ule = te("div", {
  name: "MuiDateRangePickerToolbar",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  display: "flex"
}), l$ = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Wt(), s = Et({
    props: t,
    name: "MuiDateRangePickerToolbar"
  }), {
    value: [i, a],
    rangePosition: l,
    onRangePositionChange: c,
    toolbarFormat: u,
    className: d
  } = s, f = ve(s, Gle), p = er(), m = i ? o.formatByString(i, u || o.formats.shortDate) : p.start, b = a ? o.formatByString(a, u || o.formats.shortDate) : p.end, v = s, g = qle(v);
  return /* @__PURE__ */ C(Wle, I({}, f, {
    toolbarTitle: p.dateRangePickerToolbarTitle,
    isLandscape: !1,
    className: ae(g.root, d),
    ownerState: v,
    ref: n,
    children: /* @__PURE__ */ ie(Ule, {
      className: g.container,
      children: [/* @__PURE__ */ C(DR, {
        variant: i !== null ? "h5" : "h6",
        value: m,
        selected: l === "start",
        onClick: () => c("start")
      }), /* @__PURE__ */ ie(yn, {
        variant: "h5",
        children: [" ", "–", " "]
      }), /* @__PURE__ */ C(DR, {
        variant: a !== null ? "h5" : "h6",
        value: b,
        selected: l === "end",
        onClick: () => c("end")
      })]
    })
  }));
});
process.env.NODE_ENV !== "production" && (l$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: r.object,
  className: r.string,
  disabled: r.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: r.bool,
  onRangePositionChange: r.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: r.func.isRequired,
  rangePosition: r.oneOf(["end", "start"]).isRequired,
  readOnly: r.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  titleId: r.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: r.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: r.node,
  value: r.arrayOf(r.object).isRequired,
  /**
   * Currently visible picker view.
   */
  view: r.oneOf(["day"]).isRequired,
  /**
   * Available views.
   */
  views: r.arrayOf(r.oneOf(["day"])).isRequired
});
function c$(e, t) {
  const n = Wt(), o = ia(), s = Et({
    props: e,
    name: t
  }), i = h.useMemo(() => {
    var a;
    return ((a = s.localeText) == null ? void 0 : a.toolbarTitle) == null ? s.localeText : I({}, s.localeText, {
      dateRangePickerToolbarTitle: s.localeText.toolbarTitle
    });
  }, [s.localeText]);
  return I({}, s, {
    localeText: i,
    disableFuture: s.disableFuture ?? !1,
    disablePast: s.disablePast ?? !1,
    minDate: io(n, s.minDate, o.minDate),
    maxDate: io(n, s.maxDate, o.maxDate),
    slots: I({
      toolbar: l$
    }, s.slots)
  });
}
const u$ = ({
  value: e,
  defaultValue: t,
  referenceDate: n,
  onChange: o,
  className: s,
  classes: i,
  disableFuture: a,
  disablePast: l,
  minDate: c,
  maxDate: u,
  shouldDisableDate: d,
  reduceAnimations: f,
  onMonthChange: p,
  rangePosition: m,
  defaultRangePosition: b,
  onRangePositionChange: v,
  calendars: g,
  currentMonthCalendarPosition: y,
  slots: w,
  slotProps: x,
  loading: S,
  renderLoading: T,
  disableHighlightToday: E,
  readOnly: O,
  disabled: M,
  showDaysOutsideCurrentMonth: D,
  dayOfWeekFormatter: R,
  disableAutoMonthSwitching: P,
  sx: F,
  autoFocus: $,
  fixedWeekNumber: N,
  disableDragEditing: A,
  displayWeekNumber: k,
  timezone: L,
  availableRangePositions: B,
  views: V,
  view: _,
  onViewChange: z
}) => /* @__PURE__ */ C(a$, {
  value: e,
  defaultValue: t,
  referenceDate: n,
  onChange: o,
  className: s,
  classes: i,
  disableFuture: a,
  disablePast: l,
  minDate: c,
  maxDate: u,
  shouldDisableDate: d,
  reduceAnimations: f,
  onMonthChange: p,
  rangePosition: m,
  defaultRangePosition: b,
  onRangePositionChange: v,
  calendars: g,
  currentMonthCalendarPosition: y,
  slots: w,
  slotProps: x,
  loading: S,
  renderLoading: T,
  disableHighlightToday: E,
  readOnly: O,
  disabled: M,
  showDaysOutsideCurrentMonth: D,
  dayOfWeekFormatter: R,
  disableAutoMonthSwitching: P,
  sx: F,
  autoFocus: $,
  fixedWeekNumber: N,
  disableDragEditing: A,
  displayWeekNumber: k,
  timezone: L,
  availableRangePositions: B,
  view: _,
  views: V,
  onViewChange: z
}), Kle = ["clearable", "onClear"], Yle = ({
  wrapperVariant: e,
  open: t,
  actions: n,
  readOnly: o,
  labelId: s,
  disableOpenPicker: i,
  onBlur: a,
  rangePosition: l,
  onRangePositionChange: c,
  localeText: u,
  pickerSlotProps: d,
  pickerSlots: f,
  fieldProps: p,
  anchorRef: m,
  currentView: b,
  initialView: v,
  onViewChange: g,
  startFieldRef: y,
  endFieldRef: w
}) => {
  const x = er(), S = tt(p.unstableStartFieldRef, y), T = tt(p.unstableEndFieldRef, w), E = h.useRef(l);
  h.useEffect(() => {
    var L;
    if (!t || e === "mobile")
      return;
    const k = l === "start" ? y : w;
    if ((L = k.current) == null || L.focusField(), !k.current || !b) {
      E.current = l;
      return;
    }
    k.current.setSelectedSections(
      // use the current view or `0` when the range position has just been swapped
      E.current === l ? b : 0
    ), E.current = l;
  }, [l, t, b, y, w, e]);
  const O = (k) => {
    k.stopPropagation(), c("start"), !o && !i && n.onOpen(k);
  }, M = (k) => {
    k.stopPropagation(), c("end"), !o && !i && n.onOpen(k);
  }, D = () => {
    t && (c("start"), E.current !== "start" && v && (g == null || g(v)));
  }, R = () => {
    t && (c("end"), E.current !== "end" && v && (g == null || g(v)));
  }, P = I({
    textField: f == null ? void 0 : f.textField,
    root: f == null ? void 0 : f.fieldRoot,
    separator: f == null ? void 0 : f.fieldSeparator
  }, p.slots), F = I({}, p.slotProps, {
    textField: (k) => {
      const L = Ur(d == null ? void 0 : d.textField, k);
      let B, V;
      return k.position === "start" ? (B = I({
        label: (u == null ? void 0 : u.start) ?? x.start,
        onKeyDown: Kf(O),
        onFocus: D,
        focused: t ? l === "start" : void 0
      }, !o && !p.disabled && {
        onClick: O
      }, e === "mobile" && {
        readOnly: !0
      }), m && (V = I({}, L == null ? void 0 : L.InputProps, {
        ref: m
      }))) : (B = I({
        label: (u == null ? void 0 : u.end) ?? x.end,
        onKeyDown: Kf(M),
        onFocus: R,
        focused: t ? l === "end" : void 0
      }, !o && !p.disabled && {
        onClick: M
      }, e === "mobile" && {
        readOnly: !0
      }), V = L == null ? void 0 : L.InputProps), I({}, s != null && {
        id: `${s}-${k.position}`
      }, B, Ur(d == null ? void 0 : d.textField, k), {
        InputProps: V
      });
    },
    root: (k) => I({}, {
      onBlur: a
    }, Ur(d == null ? void 0 : d.fieldRoot, k)),
    separator: d == null ? void 0 : d.fieldSeparator
  }), $ = p, N = ve($, Kle);
  return I({}, N, {
    unstableStartFieldRef: S,
    unstableEndFieldRef: T,
    slots: P,
    slotProps: F
  });
}, Xle = ({
  wrapperVariant: e,
  open: t,
  actions: n,
  readOnly: o,
  labelId: s,
  disableOpenPicker: i,
  label: a,
  onBlur: l,
  rangePosition: c,
  onRangePositionChange: u,
  startFieldRef: d,
  endFieldRef: f,
  pickerSlots: p,
  pickerSlotProps: m,
  fieldProps: b,
  anchorRef: v,
  currentView: g
}) => {
  const y = tt(b.unstableFieldRef, d, f);
  h.useEffect(() => {
    var M;
    if (!(!t || !d.current || e === "mobile") && !d.current.isFieldFocused() && g) {
      const D = d.current.getSections().map((P) => P.type), R = c === "start" ? D.indexOf(g) : D.lastIndexOf(g);
      (M = d.current) == null || M.focusField(R);
    }
  }, [c, t, g, d, e]);
  const w = () => {
    var P, F;
    if (!((P = d.current) != null && P.isFieldFocused()))
      return;
    const M = d.current.getSections(), D = (F = d.current) == null ? void 0 : F.getActiveSectionIndex(), R = D == null || D < M.length / 2 ? "start" : "end";
    R != null && R !== c && u(R);
  }, x = xe((M) => {
    var D;
    setTimeout(w), (D = b.onSelectedSectionsChange) == null || D.call(b, M);
  }), S = (M) => {
    M.stopPropagation(), !o && !i && n.onOpen(M);
  }, T = I({}, b.slots, {
    textField: p == null ? void 0 : p.textField,
    clearButton: p == null ? void 0 : p.clearButton,
    clearIcon: p == null ? void 0 : p.clearIcon
  }), E = I({}, b.slotProps, {
    textField: m == null ? void 0 : m.textField,
    clearButton: p == null ? void 0 : p.clearButton,
    clearIcon: p == null ? void 0 : p.clearIcon
  });
  return I({}, b, {
    slots: T,
    slotProps: E,
    label: a,
    unstableFieldRef: y,
    onKeyDown: Kf(S, b.onKeyDown),
    onSelectedSectionsChange: x,
    onBlur: l,
    InputProps: I({
      ref: v
    }, b == null ? void 0 : b.InputProps),
    focused: t ? !0 : void 0
  }, s != null && {
    id: s
  }, e === "mobile" && {
    readOnly: !0
  }, !o && !b.disabled && {
    onClick: S
  });
}, d$ = (e) => {
  if (process.env.NODE_ENV !== "production") {
    const t = h.useRef(e.fieldType);
    e.fieldType !== t.current && console.error("Should not switch between a multi input field and a single input field on a range picker.");
  }
  return e.fieldType === "multi-input" ? Yle(e) : Xle(e);
}, Qle = ["props"], Zle = ch(), Jle = (e) => {
  let {
    props: t
  } = e, n = ve(e, Qle);
  Mu("x-date-pickers-pro", Zle);
  const {
    slots: o,
    slotProps: s,
    className: i,
    sx: a,
    format: l,
    formatDensity: c,
    enableAccessibleFieldDOMStructure: u,
    selectedSections: d,
    onSelectedSectionsChange: f,
    timezone: p,
    label: m,
    inputRef: b,
    name: v,
    readOnly: g,
    disabled: y,
    autoFocus: w,
    disableOpenPicker: x,
    localeText: S,
    reduceAnimations: T
  } = t, E = h.useRef(null), O = h.useRef(null), M = h.useRef(null), D = h.useRef(null), R = h.useRef(null), P = h.useRef(t.openTo ?? null), F = o.field.fieldType ?? "multi-input", {
    rangePosition: $,
    onRangePositionChange: N
  } = L0(t, F === "single-input" ? D : void 0), {
    open: A,
    actions: k,
    layoutProps: L,
    renderCurrentView: B,
    shouldRestoreFocus: V,
    fieldProps: _,
    contextValue: z
  } = lh(I({}, n, {
    props: t,
    wrapperVariant: "desktop",
    autoFocusView: !1,
    fieldRef: $ === "start" ? D : R,
    additionalViewProps: {
      rangePosition: $,
      onRangePositionChange: N
    }
  }));
  h.useEffect(() => {
    L.view && (P.current = L.view);
  }, []);
  const j = () => {
    Bre(() => {
      var Q, ee;
      (Q = E.current) != null && Q.contains(so(document)) || (ee = M.current) != null && ee.contains(so(document)) || k.onDismiss();
    });
  }, W = o.field, J = et({
    elementType: W,
    externalSlotProps: s == null ? void 0 : s.field,
    additionalProps: I({}, _, {
      readOnly: g,
      disabled: y,
      className: i,
      sx: a,
      format: l,
      formatDensity: c,
      enableAccessibleFieldDOMStructure: u,
      selectedSections: d,
      onSelectedSectionsChange: f,
      timezone: p,
      autoFocus: w && !t.open,
      ref: E
    }, F === "single-input" ? {
      inputRef: b,
      name: v
    } : {}),
    ownerState: t
  }), G = d$({
    wrapperVariant: "desktop",
    fieldType: F,
    open: A,
    actions: k,
    readOnly: g,
    disableOpenPicker: x,
    label: m,
    localeText: S,
    onBlur: j,
    rangePosition: $,
    onRangePositionChange: N,
    pickerSlotProps: s,
    pickerSlots: o,
    fieldProps: J,
    anchorRef: O,
    startFieldRef: D,
    endFieldRef: R,
    currentView: L.view !== t.openTo ? L.view : void 0,
    initialView: P.current ?? void 0,
    onViewChange: L.onViewChange
  }), q = I({}, s, {
    tabs: I({}, s == null ? void 0 : s.tabs, {
      rangePosition: $,
      onRangePositionChange: N
    }),
    toolbar: I({}, s == null ? void 0 : s.toolbar, {
      rangePosition: $,
      onRangePositionChange: N
    })
  }), Z = (o == null ? void 0 : o.layout) ?? ju;
  return {
    renderPicker: () => /* @__PURE__ */ ie(rh, {
      contextValue: z,
      localeText: S,
      children: [/* @__PURE__ */ C(W, I({}, G)), /* @__PURE__ */ C(XN, I({
        role: "tooltip",
        placement: "bottom-start",
        containerRef: M,
        anchorEl: O.current,
        onBlur: j
      }, k, {
        open: A,
        slots: o,
        slotProps: s,
        shouldRestoreFocus: V,
        reduceAnimations: T,
        children: /* @__PURE__ */ C(Z, I({}, L, s == null ? void 0 : s.layout, {
          slots: o,
          slotProps: q,
          children: B()
        }))
      }))]
    })
  };
}, f$ = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var l;
  const o = c$(t, "MuiDesktopDateRangePicker"), s = I({
    day: u$
  }, o.viewRenderers), i = I({}, o, {
    viewRenderers: s,
    calendars: o.calendars ?? 2,
    views: ["day"],
    openTo: "day",
    slots: I({
      field: A0
    }, o.slots),
    slotProps: I({}, o.slotProps, {
      field: (c) => {
        var u;
        return I({}, Ur((u = o.slotProps) == null ? void 0 : u.field, c), oh(o), {
          ref: n
        });
      },
      toolbar: I({
        hidden: !0
      }, (l = o.slotProps) == null ? void 0 : l.toolbar)
    })
  }), {
    renderPicker: a
  } = Jle({
    props: i,
    valueManager: Ml,
    valueType: "date",
    validator: qu
  });
  return a();
});
f$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  /**
   * The number of calendars to render on **desktop**.
   * @default 2
   */
  calendars: r.oneOf([1, 2, 3]),
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * Position the current month is rendered in.
   * @default 1
   */
  currentMonthCalendarPosition: r.oneOf([1, 2, 3]),
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The initial position in the edited date range.
   * Used when the component is not controlled.
   * @default 'start'
   */
  defaultRangePosition: r.oneOf(["end", "start"]),
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.arrayOf(r.object),
  /**
   * If `true`, after selecting `start` date calendar will not automatically switch to the month of `end` date.
   * @default false
   */
  disableAutoMonthSwitching: r.bool,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, editing dates by dragging is disabled.
   * @default false
   */
  disableDragEditing: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   * Ignored if the field has several inputs.
   */
  inputRef: Lt,
  /**
   * The label content.
   * Ignored if the field has several inputs.
   */
  label: r.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Name attribute used by the `input` element in the Field.
   * Ignored if the field has several inputs.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the range position changes.
   * @param {RangePosition} rangePosition The new range position.
   */
  onRangePositionChange: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The position in the currently edited date range.
   * Used when the component position is controlled.
   */
  rangePosition: r.oneOf(["end", "start"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * Component rendered on the "day" view when `props.loading` is true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => "..."
   */
  renderLoading: r.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @param {string} position The date to test, 'start' or 'end'.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.arrayOf(r.object),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    day: r.func
  })
};
const ece = ["props"], tce = ch(), nce = (e) => {
  var Z;
  let {
    props: t
  } = e, n = ve(e, ece);
  Mu("x-date-pickers-pro", tce);
  const {
    slots: o,
    slotProps: s,
    className: i,
    sx: a,
    format: l,
    formatDensity: c,
    enableAccessibleFieldDOMStructure: u,
    selectedSections: d,
    onSelectedSectionsChange: f,
    timezone: p,
    label: m,
    inputRef: b,
    name: v,
    readOnly: g,
    disabled: y,
    disableOpenPicker: w,
    localeText: x
  } = t, S = h.useRef(null), T = h.useRef(null), E = o.field.fieldType ?? "multi-input", {
    rangePosition: O,
    onRangePositionChange: M
  } = L0(t, E === "single-input" ? S : void 0), D = gt(), R = er(), {
    open: P,
    actions: F,
    layoutProps: $,
    renderCurrentView: N,
    fieldProps: A,
    contextValue: k
  } = lh(I({}, n, {
    props: t,
    wrapperVariant: "mobile",
    autoFocusView: !0,
    fieldRef: O === "start" ? S : T,
    additionalViewProps: {
      rangePosition: O,
      onRangePositionChange: M
    }
  })), L = o.field, B = et({
    elementType: L,
    externalSlotProps: s == null ? void 0 : s.field,
    additionalProps: I({}, A, {
      readOnly: g ?? !0,
      disabled: y,
      className: i,
      sx: a,
      format: l,
      formatDensity: c,
      enableAccessibleFieldDOMStructure: u,
      selectedSections: d,
      onSelectedSectionsChange: f,
      timezone: p
    }, E === "single-input" ? {
      inputRef: b,
      name: v
    } : {}),
    ownerState: t
  }), V = ((Z = s == null ? void 0 : s.toolbar) == null ? void 0 : Z.hidden) ?? !1, _ = d$({
    wrapperVariant: "mobile",
    fieldType: E,
    open: P,
    actions: F,
    readOnly: g,
    labelId: D,
    disableOpenPicker: w,
    label: m,
    localeText: x,
    rangePosition: O,
    onRangePositionChange: M,
    pickerSlots: o,
    pickerSlotProps: s,
    fieldProps: B,
    startFieldRef: S,
    endFieldRef: T
  }), z = I({}, s, {
    tabs: I({}, s == null ? void 0 : s.tabs, {
      rangePosition: O,
      onRangePositionChange: M
    }),
    toolbar: I({}, s == null ? void 0 : s.toolbar, {
      titleId: D,
      rangePosition: O,
      onRangePositionChange: M
    })
  }), j = (o == null ? void 0 : o.layout) ?? ju, W = I({}, R, x);
  let J = n.valueType === "date-time" ? `${D}-start-toolbar ${D}-end-toolbar` : D;
  if (V) {
    const Y = [];
    E === "multi-input" ? (W.start && Y.push(`${D}-start-label`), W.end && Y.push(`${D}-end-label`)) : m != null && Y.push(`${D}-label`), J = Y.length > 0 ? Y.join(" ") : void 0;
  }
  const G = I({}, s, {
    mobilePaper: I({
      "aria-labelledby": J
    }, s == null ? void 0 : s.mobilePaper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ ie(rh, {
      contextValue: k,
      localeText: x,
      children: [/* @__PURE__ */ C(L, I({}, _)), /* @__PURE__ */ C(t$, I({}, F, {
        open: P,
        slots: o,
        slotProps: G,
        children: /* @__PURE__ */ C(j, I({}, $, G == null ? void 0 : G.layout, {
          slots: o,
          slotProps: z,
          children: N()
        }))
      }))]
    })
  };
}, p$ = /* @__PURE__ */ h.forwardRef(function(t, n) {
  var l;
  const o = c$(t, "MuiMobileDateRangePicker"), s = I({
    day: u$
  }, o.viewRenderers), i = I({}, o, {
    viewRenderers: s,
    // Force one calendar on mobile to avoid layout issues
    calendars: 1,
    // force current calendar position, since we only have one calendar
    currentMonthCalendarPosition: 1,
    views: ["day"],
    openTo: "day",
    slots: I({
      field: A0
    }, o.slots),
    slotProps: I({}, o.slotProps, {
      field: (c) => {
        var u;
        return I({}, Ur((u = o.slotProps) == null ? void 0 : u.field, c), oh(o), {
          ref: n
        });
      },
      toolbar: I({
        hidden: !1
      }, (l = o.slotProps) == null ? void 0 : l.toolbar)
    })
  }), {
    renderPicker: a
  } = nce({
    props: i,
    valueManager: Ml,
    valueType: "date",
    validator: qu
  });
  return a();
});
p$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * Position the current month is rendered in.
   * @default 1
   */
  currentMonthCalendarPosition: r.oneOf([1, 2, 3]),
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The initial position in the edited date range.
   * Used when the component is not controlled.
   * @default 'start'
   */
  defaultRangePosition: r.oneOf(["end", "start"]),
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.arrayOf(r.object),
  /**
   * If `true`, after selecting `start` date calendar will not automatically switch to the month of `end` date.
   * @default false
   */
  disableAutoMonthSwitching: r.bool,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, editing dates by dragging is disabled.
   * @default false
   */
  disableDragEditing: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   * Ignored if the field has several inputs.
   */
  inputRef: Lt,
  /**
   * The label content.
   * Ignored if the field has several inputs.
   */
  label: r.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Name attribute used by the `input` element in the Field.
   * Ignored if the field has several inputs.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the range position changes.
   * @param {RangePosition} rangePosition The new range position.
   */
  onRangePositionChange: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The position in the currently edited date range.
   * Used when the component position is controlled.
   */
  rangePosition: r.oneOf(["end", "start"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * Component rendered on the "day" view when `props.loading` is true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => "..."
   */
  renderLoading: r.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @param {string} position The date to test, 'start' or 'end'.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.arrayOf(r.object),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    day: r.func
  })
};
const oce = ["desktopModeMediaQuery"], h$ = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiDateRangePicker"
  }), {
    desktopModeMediaQuery: s = "@media (pointer: fine)"
  } = o, i = ve(o, oce);
  return Qi(s, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ C(f$, I({
    ref: n
  }, i)) : /* @__PURE__ */ C(p$, I({
    ref: n
  }, i));
});
process.env.NODE_ENV !== "production" && (h$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: r.bool,
  /**
   * The number of calendars to render on **desktop**.
   * @default 2
   */
  calendars: r.oneOf([1, 2, 3]),
  className: r.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: r.bool,
  /**
   * Position the current month is rendered in.
   * @default 1
   */
  currentMonthCalendarPosition: r.oneOf([1, 2, 3]),
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: r.func,
  /**
   * The initial position in the edited date range.
   * Used when the component is not controlled.
   * @default 'start'
   */
  defaultRangePosition: r.oneOf(["end", "start"]),
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: r.arrayOf(r.object),
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: r.string,
  /**
   * If `true`, after selecting `start` date calendar will not automatically switch to the month of `end` date.
   * @default false
   */
  disableAutoMonthSwitching: r.bool,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: r.bool,
  /**
   * If `true`, editing dates by dragging is disabled.
   * @default false
   */
  disableDragEditing: r.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: r.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: r.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: r.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: r.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: r.bool,
  /**
   * @default false
   */
  enableAccessibleFieldDOMStructure: r.any,
  /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */
  fixedWeekNumber: r.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: r.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: r.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   * Ignored if the field has several inputs.
   */
  inputRef: Lt,
  /**
   * The label content.
   * Ignored if the field has several inputs.
   */
  label: r.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: r.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: r.object,
  /**
   * Maximal selectable date.
   * @default 2099-12-31
   */
  maxDate: r.object,
  /**
   * Minimal selectable date.
   * @default 1900-01-01
   */
  minDate: r.object,
  /**
   * Name attribute used by the `input` element in the Field.
   * Ignored if the field has several inputs.
   */
  name: r.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onAccept: r.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: r.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: r.func,
  /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */
  onError: r.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: r.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: r.func,
  /**
   * Callback fired when the range position changes.
   * @param {RangePosition} rangePosition The new range position.
   */
  onRangePositionChange: r.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: r.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: r.bool,
  /**
   * The position in the currently edited date range.
   * Used when the component position is controlled.
   */
  rangePosition: r.oneOf(["end", "start"]),
  readOnly: r.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: r.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: r.object,
  /**
   * Component rendered on the "day" view when `props.loading` is true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => "..."
   */
  renderLoading: r.func,
  /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: r.oneOfType([r.oneOf(["all", "day", "empty", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), r.number]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @param {string} position The date to test, 'start' or 'end'.
   * @returns {boolean} Returns `true` if the date should be disabled.
   */
  shouldDisableDate: r.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: r.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: r.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: r.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: r.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: r.arrayOf(r.object),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */
  viewRenderers: r.shape({
    day: r.func
  })
});
var lf = { exports: {} }, rce = lf.exports, AR;
function sce() {
  return AR || (AR = 1, function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(rce, function() {
      var n = 1e3, o = 6e4, s = 36e5, i = "millisecond", a = "second", l = "minute", c = "hour", u = "day", d = "week", f = "month", p = "quarter", m = "year", b = "date", v = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, w = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(N) {
        var A = ["th", "st", "nd", "rd"], k = N % 100;
        return "[" + N + (A[(k - 20) % 10] || A[k] || A[0]) + "]";
      } }, x = function(N, A, k) {
        var L = String(N);
        return !L || L.length >= A ? N : "" + Array(A + 1 - L.length).join(k) + N;
      }, S = { s: x, z: function(N) {
        var A = -N.utcOffset(), k = Math.abs(A), L = Math.floor(k / 60), B = k % 60;
        return (A <= 0 ? "+" : "-") + x(L, 2, "0") + ":" + x(B, 2, "0");
      }, m: function N(A, k) {
        if (A.date() < k.date()) return -N(k, A);
        var L = 12 * (k.year() - A.year()) + (k.month() - A.month()), B = A.clone().add(L, f), V = k - B < 0, _ = A.clone().add(L + (V ? -1 : 1), f);
        return +(-(L + (k - B) / (V ? B - _ : _ - B)) || 0);
      }, a: function(N) {
        return N < 0 ? Math.ceil(N) || 0 : Math.floor(N);
      }, p: function(N) {
        return { M: f, y: m, w: d, d: u, D: b, h: c, m: l, s: a, ms: i, Q: p }[N] || String(N || "").toLowerCase().replace(/s$/, "");
      }, u: function(N) {
        return N === void 0;
      } }, T = "en", E = {};
      E[T] = w;
      var O = "$isDayjsObject", M = function(N) {
        return N instanceof F || !(!N || !N[O]);
      }, D = function N(A, k, L) {
        var B;
        if (!A) return T;
        if (typeof A == "string") {
          var V = A.toLowerCase();
          E[V] && (B = V), k && (E[V] = k, B = V);
          var _ = A.split("-");
          if (!B && _.length > 1) return N(_[0]);
        } else {
          var z = A.name;
          E[z] = A, B = z;
        }
        return !L && B && (T = B), B || !L && T;
      }, R = function(N, A) {
        if (M(N)) return N.clone();
        var k = typeof A == "object" ? A : {};
        return k.date = N, k.args = arguments, new F(k);
      }, P = S;
      P.l = D, P.i = M, P.w = function(N, A) {
        return R(N, { locale: A.$L, utc: A.$u, x: A.$x, $offset: A.$offset });
      };
      var F = function() {
        function N(k) {
          this.$L = D(k.locale, null, !0), this.parse(k), this.$x = this.$x || k.x || {}, this[O] = !0;
        }
        var A = N.prototype;
        return A.parse = function(k) {
          this.$d = function(L) {
            var B = L.date, V = L.utc;
            if (B === null) return /* @__PURE__ */ new Date(NaN);
            if (P.u(B)) return /* @__PURE__ */ new Date();
            if (B instanceof Date) return new Date(B);
            if (typeof B == "string" && !/Z$/i.test(B)) {
              var _ = B.match(g);
              if (_) {
                var z = _[2] - 1 || 0, j = (_[7] || "0").substring(0, 3);
                return V ? new Date(Date.UTC(_[1], z, _[3] || 1, _[4] || 0, _[5] || 0, _[6] || 0, j)) : new Date(_[1], z, _[3] || 1, _[4] || 0, _[5] || 0, _[6] || 0, j);
              }
            }
            return new Date(B);
          }(k), this.init();
        }, A.init = function() {
          var k = this.$d;
          this.$y = k.getFullYear(), this.$M = k.getMonth(), this.$D = k.getDate(), this.$W = k.getDay(), this.$H = k.getHours(), this.$m = k.getMinutes(), this.$s = k.getSeconds(), this.$ms = k.getMilliseconds();
        }, A.$utils = function() {
          return P;
        }, A.isValid = function() {
          return this.$d.toString() !== v;
        }, A.isSame = function(k, L) {
          var B = R(k);
          return this.startOf(L) <= B && B <= this.endOf(L);
        }, A.isAfter = function(k, L) {
          return R(k) < this.startOf(L);
        }, A.isBefore = function(k, L) {
          return this.endOf(L) < R(k);
        }, A.$g = function(k, L, B) {
          return P.u(k) ? this[L] : this.set(B, k);
        }, A.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, A.valueOf = function() {
          return this.$d.getTime();
        }, A.startOf = function(k, L) {
          var B = this, V = !!P.u(L) || L, _ = P.p(k), z = function(Q, ee) {
            var ne = P.w(B.$u ? Date.UTC(B.$y, ee, Q) : new Date(B.$y, ee, Q), B);
            return V ? ne : ne.endOf(u);
          }, j = function(Q, ee) {
            return P.w(B.toDate()[Q].apply(B.toDate("s"), (V ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ee)), B);
          }, W = this.$W, J = this.$M, G = this.$D, q = "set" + (this.$u ? "UTC" : "");
          switch (_) {
            case m:
              return V ? z(1, 0) : z(31, 11);
            case f:
              return V ? z(1, J) : z(0, J + 1);
            case d:
              var Z = this.$locale().weekStart || 0, Y = (W < Z ? W + 7 : W) - Z;
              return z(V ? G - Y : G + (6 - Y), J);
            case u:
            case b:
              return j(q + "Hours", 0);
            case c:
              return j(q + "Minutes", 1);
            case l:
              return j(q + "Seconds", 2);
            case a:
              return j(q + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, A.endOf = function(k) {
          return this.startOf(k, !1);
        }, A.$set = function(k, L) {
          var B, V = P.p(k), _ = "set" + (this.$u ? "UTC" : ""), z = (B = {}, B[u] = _ + "Date", B[b] = _ + "Date", B[f] = _ + "Month", B[m] = _ + "FullYear", B[c] = _ + "Hours", B[l] = _ + "Minutes", B[a] = _ + "Seconds", B[i] = _ + "Milliseconds", B)[V], j = V === u ? this.$D + (L - this.$W) : L;
          if (V === f || V === m) {
            var W = this.clone().set(b, 1);
            W.$d[z](j), W.init(), this.$d = W.set(b, Math.min(this.$D, W.daysInMonth())).$d;
          } else z && this.$d[z](j);
          return this.init(), this;
        }, A.set = function(k, L) {
          return this.clone().$set(k, L);
        }, A.get = function(k) {
          return this[P.p(k)]();
        }, A.add = function(k, L) {
          var B, V = this;
          k = Number(k);
          var _ = P.p(L), z = function(J) {
            var G = R(V);
            return P.w(G.date(G.date() + Math.round(J * k)), V);
          };
          if (_ === f) return this.set(f, this.$M + k);
          if (_ === m) return this.set(m, this.$y + k);
          if (_ === u) return z(1);
          if (_ === d) return z(7);
          var j = (B = {}, B[l] = o, B[c] = s, B[a] = n, B)[_] || 1, W = this.$d.getTime() + k * j;
          return P.w(W, this);
        }, A.subtract = function(k, L) {
          return this.add(-1 * k, L);
        }, A.format = function(k) {
          var L = this, B = this.$locale();
          if (!this.isValid()) return B.invalidDate || v;
          var V = k || "YYYY-MM-DDTHH:mm:ssZ", _ = P.z(this), z = this.$H, j = this.$m, W = this.$M, J = B.weekdays, G = B.months, q = B.meridiem, Z = function(ee, ne, H, U) {
            return ee && (ee[ne] || ee(L, V)) || H[ne].slice(0, U);
          }, Y = function(ee) {
            return P.s(z % 12 || 12, ee, "0");
          }, Q = q || function(ee, ne, H) {
            var U = ee < 12 ? "AM" : "PM";
            return H ? U.toLowerCase() : U;
          };
          return V.replace(y, function(ee, ne) {
            return ne || function(H) {
              switch (H) {
                case "YY":
                  return String(L.$y).slice(-2);
                case "YYYY":
                  return P.s(L.$y, 4, "0");
                case "M":
                  return W + 1;
                case "MM":
                  return P.s(W + 1, 2, "0");
                case "MMM":
                  return Z(B.monthsShort, W, G, 3);
                case "MMMM":
                  return Z(G, W);
                case "D":
                  return L.$D;
                case "DD":
                  return P.s(L.$D, 2, "0");
                case "d":
                  return String(L.$W);
                case "dd":
                  return Z(B.weekdaysMin, L.$W, J, 2);
                case "ddd":
                  return Z(B.weekdaysShort, L.$W, J, 3);
                case "dddd":
                  return J[L.$W];
                case "H":
                  return String(z);
                case "HH":
                  return P.s(z, 2, "0");
                case "h":
                  return Y(1);
                case "hh":
                  return Y(2);
                case "a":
                  return Q(z, j, !0);
                case "A":
                  return Q(z, j, !1);
                case "m":
                  return String(j);
                case "mm":
                  return P.s(j, 2, "0");
                case "s":
                  return String(L.$s);
                case "ss":
                  return P.s(L.$s, 2, "0");
                case "SSS":
                  return P.s(L.$ms, 3, "0");
                case "Z":
                  return _;
              }
              return null;
            }(ee) || _.replace(":", "");
          });
        }, A.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, A.diff = function(k, L, B) {
          var V, _ = this, z = P.p(L), j = R(k), W = (j.utcOffset() - this.utcOffset()) * o, J = this - j, G = function() {
            return P.m(_, j);
          };
          switch (z) {
            case m:
              V = G() / 12;
              break;
            case f:
              V = G();
              break;
            case p:
              V = G() / 3;
              break;
            case d:
              V = (J - W) / 6048e5;
              break;
            case u:
              V = (J - W) / 864e5;
              break;
            case c:
              V = J / s;
              break;
            case l:
              V = J / o;
              break;
            case a:
              V = J / n;
              break;
            default:
              V = J;
          }
          return B ? V : P.a(V);
        }, A.daysInMonth = function() {
          return this.endOf(f).$D;
        }, A.$locale = function() {
          return E[this.$L];
        }, A.locale = function(k, L) {
          if (!k) return this.$L;
          var B = this.clone(), V = D(k, L, !0);
          return V && (B.$L = V), B;
        }, A.clone = function() {
          return P.w(this.$d, this);
        }, A.toDate = function() {
          return new Date(this.valueOf());
        }, A.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, A.toISOString = function() {
          return this.$d.toISOString();
        }, A.toString = function() {
          return this.$d.toUTCString();
        }, N;
      }(), $ = F.prototype;
      return R.prototype = $, [["$ms", i], ["$s", a], ["$m", l], ["$H", c], ["$W", u], ["$M", f], ["$y", m], ["$D", b]].forEach(function(N) {
        $[N[1]] = function(A) {
          return this.$g(A, N[0], N[1]);
        };
      }), R.extend = function(N, A) {
        return N.$i || (N(A, F, R), N.$i = !0), R;
      }, R.locale = D, R.isDayjs = M, R.unix = function(N) {
        return R(1e3 * N);
      }, R.en = E[T], R.Ls = E, R.p = {}, R;
    });
  }(lf)), lf.exports;
}
var ice = sce();
const qn = /* @__PURE__ */ Zo(ice);
var cf = { exports: {} }, ace = cf.exports, FR;
function lce() {
  return FR || (FR = 1, function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(ace, function() {
      var n = "week", o = "year";
      return function(s, i, a) {
        var l = i.prototype;
        l.week = function(c) {
          if (c === void 0 && (c = null), c !== null) return this.add(7 * (c - this.week()), "day");
          var u = this.$locale().yearStart || 1;
          if (this.month() === 11 && this.date() > 25) {
            var d = a(this).startOf(o).add(1, o).date(u), f = a(this).endOf(n);
            if (d.isBefore(f)) return 1;
          }
          var p = a(this).startOf(o).date(u).startOf(n).subtract(1, "millisecond"), m = this.diff(p, n, !0);
          return m < 0 ? a(this).startOf("week").week() : Math.ceil(m);
        }, l.weeks = function(c) {
          return c === void 0 && (c = null), this.week(c);
        };
      };
    });
  }(cf)), cf.exports;
}
var cce = lce();
const uce = /* @__PURE__ */ Zo(cce);
var uf = { exports: {} }, dce = uf.exports, LR;
function fce() {
  return LR || (LR = 1, function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(dce, function() {
      var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, o = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, s = /\d/, i = /\d\d/, a = /\d\d?/, l = /\d*[^-_:/,()\s\d]+/, c = {}, u = function(g) {
        return (g = +g) + (g > 68 ? 1900 : 2e3);
      }, d = function(g) {
        return function(y) {
          this[g] = +y;
        };
      }, f = [/[+-]\d\d:?(\d\d)?|Z/, function(g) {
        (this.zone || (this.zone = {})).offset = function(y) {
          if (!y || y === "Z") return 0;
          var w = y.match(/([+-]|\d\d)/g), x = 60 * w[1] + (+w[2] || 0);
          return x === 0 ? 0 : w[0] === "+" ? -x : x;
        }(g);
      }], p = function(g) {
        var y = c[g];
        return y && (y.indexOf ? y : y.s.concat(y.f));
      }, m = function(g, y) {
        var w, x = c.meridiem;
        if (x) {
          for (var S = 1; S <= 24; S += 1) if (g.indexOf(x(S, 0, y)) > -1) {
            w = S > 12;
            break;
          }
        } else w = g === (y ? "pm" : "PM");
        return w;
      }, b = { A: [l, function(g) {
        this.afternoon = m(g, !1);
      }], a: [l, function(g) {
        this.afternoon = m(g, !0);
      }], Q: [s, function(g) {
        this.month = 3 * (g - 1) + 1;
      }], S: [s, function(g) {
        this.milliseconds = 100 * +g;
      }], SS: [i, function(g) {
        this.milliseconds = 10 * +g;
      }], SSS: [/\d{3}/, function(g) {
        this.milliseconds = +g;
      }], s: [a, d("seconds")], ss: [a, d("seconds")], m: [a, d("minutes")], mm: [a, d("minutes")], H: [a, d("hours")], h: [a, d("hours")], HH: [a, d("hours")], hh: [a, d("hours")], D: [a, d("day")], DD: [i, d("day")], Do: [l, function(g) {
        var y = c.ordinal, w = g.match(/\d+/);
        if (this.day = w[0], y) for (var x = 1; x <= 31; x += 1) y(x).replace(/\[|\]/g, "") === g && (this.day = x);
      }], w: [a, d("week")], ww: [i, d("week")], M: [a, d("month")], MM: [i, d("month")], MMM: [l, function(g) {
        var y = p("months"), w = (p("monthsShort") || y.map(function(x) {
          return x.slice(0, 3);
        })).indexOf(g) + 1;
        if (w < 1) throw new Error();
        this.month = w % 12 || w;
      }], MMMM: [l, function(g) {
        var y = p("months").indexOf(g) + 1;
        if (y < 1) throw new Error();
        this.month = y % 12 || y;
      }], Y: [/[+-]?\d+/, d("year")], YY: [i, function(g) {
        this.year = u(g);
      }], YYYY: [/\d{4}/, d("year")], Z: f, ZZ: f };
      function v(g) {
        var y, w;
        y = g, w = c && c.formats;
        for (var x = (g = y.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(R, P, F) {
          var $ = F && F.toUpperCase();
          return P || w[F] || n[F] || w[$].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(N, A, k) {
            return A || k.slice(1);
          });
        })).match(o), S = x.length, T = 0; T < S; T += 1) {
          var E = x[T], O = b[E], M = O && O[0], D = O && O[1];
          x[T] = D ? { regex: M, parser: D } : E.replace(/^\[|\]$/g, "");
        }
        return function(R) {
          for (var P = {}, F = 0, $ = 0; F < S; F += 1) {
            var N = x[F];
            if (typeof N == "string") $ += N.length;
            else {
              var A = N.regex, k = N.parser, L = R.slice($), B = A.exec(L)[0];
              k.call(P, B), R = R.replace(B, "");
            }
          }
          return function(V) {
            var _ = V.afternoon;
            if (_ !== void 0) {
              var z = V.hours;
              _ ? z < 12 && (V.hours += 12) : z === 12 && (V.hours = 0), delete V.afternoon;
            }
          }(P), P;
        };
      }
      return function(g, y, w) {
        w.p.customParseFormat = !0, g && g.parseTwoDigitYear && (u = g.parseTwoDigitYear);
        var x = y.prototype, S = x.parse;
        x.parse = function(T) {
          var E = T.date, O = T.utc, M = T.args;
          this.$u = O;
          var D = M[1];
          if (typeof D == "string") {
            var R = M[2] === !0, P = M[3] === !0, F = R || P, $ = M[2];
            P && ($ = M[2]), c = this.$locale(), !R && $ && (c = w.Ls[$]), this.$d = function(L, B, V, _) {
              try {
                if (["x", "X"].indexOf(B) > -1) return new Date((B === "X" ? 1e3 : 1) * L);
                var z = v(B)(L), j = z.year, W = z.month, J = z.day, G = z.hours, q = z.minutes, Z = z.seconds, Y = z.milliseconds, Q = z.zone, ee = z.week, ne = /* @__PURE__ */ new Date(), H = J || (j || W ? 1 : ne.getDate()), U = j || ne.getFullYear(), X = 0;
                j && !W || (X = W > 0 ? W - 1 : ne.getMonth());
                var re, oe = G || 0, le = q || 0, se = Z || 0, Ce = Y || 0;
                return Q ? new Date(Date.UTC(U, X, H, oe, le, se, Ce + 60 * Q.offset * 1e3)) : V ? new Date(Date.UTC(U, X, H, oe, le, se, Ce)) : (re = new Date(U, X, H, oe, le, se, Ce), ee && (re = _(re).week(ee).toDate()), re);
              } catch {
                return /* @__PURE__ */ new Date("");
              }
            }(E, D, O, w), this.init(), $ && $ !== !0 && (this.$L = this.locale($).$L), F && E != this.format(D) && (this.$d = /* @__PURE__ */ new Date("")), c = {};
          } else if (D instanceof Array) for (var N = D.length, A = 1; A <= N; A += 1) {
            M[1] = D[A - 1];
            var k = w.apply(this, M);
            if (k.isValid()) {
              this.$d = k.$d, this.$L = k.$L, this.init();
              break;
            }
            A === N && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else S.call(this, T);
        };
      };
    });
  }(uf)), uf.exports;
}
var pce = fce();
const hce = /* @__PURE__ */ Zo(pce);
var df = { exports: {} }, gce = df.exports, _R;
function mce() {
  return _R || (_R = 1, function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(gce, function() {
      var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
      return function(o, s, i) {
        var a = s.prototype, l = a.format;
        i.en.formats = n, a.format = function(c) {
          c === void 0 && (c = "YYYY-MM-DDTHH:mm:ssZ");
          var u = this.$locale().formats, d = function(f, p) {
            return f.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(m, b, v) {
              var g = v && v.toUpperCase();
              return b || p[v] || n[v] || p[g].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(y, w, x) {
                return w || x.slice(1);
              });
            });
          }(c, u === void 0 ? {} : u);
          return l.call(this, d);
        };
      };
    });
  }(df)), df.exports;
}
var bce = mce();
const yce = /* @__PURE__ */ Zo(bce);
var ff = { exports: {} }, vce = ff.exports, VR;
function Cce() {
  return VR || (VR = 1, function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(vce, function() {
      return function(n, o, s) {
        o.prototype.isBetween = function(i, a, l, c) {
          var u = s(i), d = s(a), f = (c = c || "()")[0] === "(", p = c[1] === ")";
          return (f ? this.isAfter(u, l) : !this.isBefore(u, l)) && (p ? this.isBefore(d, l) : !this.isAfter(d, l)) || (f ? this.isBefore(u, l) : !this.isAfter(u, l)) && (p ? this.isAfter(d, l) : !this.isBefore(d, l));
        };
      };
    });
  }(ff)), ff.exports;
}
var wce = Cce();
const Sce = /* @__PURE__ */ Zo(wce);
var pf = { exports: {} }, xce = pf.exports, BR;
function Tce() {
  return BR || (BR = 1, function(e, t) {
    (function(n, o) {
      e.exports = o();
    })(xce, function() {
      return function(n, o) {
        var s = o.prototype, i = s.format;
        s.format = function(a) {
          var l = this, c = this.$locale();
          if (!this.isValid()) return i.bind(this)(a);
          var u = this.$utils(), d = (a || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(f) {
            switch (f) {
              case "Q":
                return Math.ceil((l.$M + 1) / 3);
              case "Do":
                return c.ordinal(l.$D);
              case "gggg":
                return l.weekYear();
              case "GGGG":
                return l.isoWeekYear();
              case "wo":
                return c.ordinal(l.week(), "W");
              case "w":
              case "ww":
                return u.s(l.week(), f === "w" ? 1 : 2, "0");
              case "W":
              case "WW":
                return u.s(l.isoWeek(), f === "W" ? 1 : 2, "0");
              case "k":
              case "kk":
                return u.s(String(l.$H === 0 ? 24 : l.$H), f === "k" ? 1 : 2, "0");
              case "X":
                return Math.floor(l.$d.getTime() / 1e3);
              case "x":
                return l.$d.getTime();
              case "z":
                return "[" + l.offsetName() + "]";
              case "zzz":
                return "[" + l.offsetName("long") + "]";
              default:
                return f;
            }
          });
          return i.bind(this)(d);
        };
      };
    });
  }(pf)), pf.exports;
}
var Rce = Tce();
const Ece = /* @__PURE__ */ Zo(Rce);
qn.extend(yce);
qn.extend(uce);
qn.extend(Sce);
qn.extend(Ece);
const Ice = {
  // Year
  YY: "year",
  YYYY: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  D: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  DD: "day",
  Do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  d: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 2
  },
  dd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ddd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  dddd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  A: "meridiem",
  a: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, Oce = {
  year: "YYYY",
  month: "MMMM",
  monthShort: "MMM",
  dayOfMonth: "D",
  dayOfMonthFull: "Do",
  weekday: "dddd",
  weekdayShort: "dd",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "A",
  minutes: "mm",
  seconds: "ss",
  fullDate: "ll",
  keyboardDate: "L",
  shortDate: "MMM D",
  normalDate: "D MMMM",
  normalDateWithWeekday: "ddd, MMM D",
  fullTime: "LT",
  fullTime12h: "hh:mm A",
  fullTime24h: "HH:mm",
  keyboardDateTime: "L LT",
  keyboardDateTime12h: "L hh:mm A",
  keyboardDateTime24h: "L HH:mm"
}, zg = ["Missing UTC plugin", "To be able to use UTC or timezones, you have to enable the `utc` plugin", "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc"].join(`
`), zR = ["Missing timezone plugin", "To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin", "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone"].join(`
`), Pce = (e, t) => t ? (...n) => e(...n).locale(t) : e;
class uh {
  constructor({
    locale: t,
    formats: n
  } = {}) {
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !0, this.lib = "dayjs", this.dayjs = void 0, this.locale = void 0, this.formats = void 0, this.escapedCharacters = {
      start: "[",
      end: "]"
    }, this.formatTokenMap = Ice, this.setLocaleToValue = (o) => {
      const s = this.getCurrentLocaleCode();
      return s === o.locale() ? o : o.locale(s);
    }, this.hasUTCPlugin = () => typeof qn.utc < "u", this.hasTimezonePlugin = () => typeof qn.tz < "u", this.isSame = (o, s, i) => {
      const a = this.setTimezone(s, this.getTimezone(o));
      return o.format(i) === a.format(i);
    }, this.cleanTimezone = (o) => {
      switch (o) {
        case "default":
          return;
        case "system":
          return qn.tz.guess();
        default:
          return o;
      }
    }, this.createSystemDate = (o) => {
      if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
        const s = qn.tz.guess();
        return s !== "UTC" ? qn.tz(o, s) : qn(o);
      }
      return qn(o);
    }, this.createUTCDate = (o) => {
      if (!this.hasUTCPlugin())
        throw new Error(zg);
      return qn.utc(o);
    }, this.createTZDate = (o, s) => {
      if (!this.hasUTCPlugin())
        throw new Error(zg);
      if (!this.hasTimezonePlugin())
        throw new Error(zR);
      const i = o !== void 0 && !o.endsWith("Z");
      return qn(o).tz(this.cleanTimezone(s), i);
    }, this.getLocaleFormats = () => {
      const o = qn.Ls, s = this.locale || "en";
      let i = o[s];
      return i === void 0 && (process.env.NODE_ENV !== "production" && vo(["MUI X: Your locale has not been found.", "Either the locale key is not a supported one. Locales supported by dayjs are available here: https://github.com/iamkun/dayjs/tree/dev/src/locale.", "Or you forget to import the locale from 'dayjs/locale/{localeUsed}'", "fallback on English locale."]), i = o.en), i.formats;
    }, this.adjustOffset = (o) => {
      if (!this.hasTimezonePlugin())
        return o;
      const s = this.getTimezone(o);
      if (s !== "UTC") {
        const i = o.tz(this.cleanTimezone(s), !0);
        if (i.$offset === (o.$offset ?? 0))
          return o;
        o.$offset = i.$offset;
      }
      return o;
    }, this.date = (o, s = "default") => {
      if (o === null)
        return null;
      let i;
      return s === "UTC" ? i = this.createUTCDate(o) : s === "system" || s === "default" && !this.hasTimezonePlugin() ? i = this.createSystemDate(o) : i = this.createTZDate(o, s), this.locale === void 0 ? i : i.locale(this.locale);
    }, this.getInvalidDate = () => qn(/* @__PURE__ */ new Date("Invalid date")), this.getTimezone = (o) => {
      var s;
      if (this.hasTimezonePlugin()) {
        const i = (s = o.$x) == null ? void 0 : s.$timezone;
        if (i)
          return i;
      }
      return this.hasUTCPlugin() && o.isUTC() ? "UTC" : "system";
    }, this.setTimezone = (o, s) => {
      if (this.getTimezone(o) === s)
        return o;
      if (s === "UTC") {
        if (!this.hasUTCPlugin())
          throw new Error(zg);
        return o.utc();
      }
      if (s === "system")
        return o.local();
      if (!this.hasTimezonePlugin()) {
        if (s === "default")
          return o;
        throw new Error(zR);
      }
      return qn.tz(o, this.cleanTimezone(s));
    }, this.toJsDate = (o) => o.toDate(), this.parse = (o, s) => o === "" ? null : this.dayjs(o, s, this.locale, !0), this.getCurrentLocaleCode = () => this.locale || "en", this.is12HourCycleInCurrentLocale = () => /A|a/.test(this.getLocaleFormats().LT || ""), this.expandFormat = (o) => {
      const s = this.getLocaleFormats(), i = (a) => a.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (l, c, u) => c || u.slice(1));
      return o.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (a, l, c) => {
        const u = c && c.toUpperCase();
        return l || s[c] || i(s[u]);
      });
    }, this.isValid = (o) => o == null ? !1 : o.isValid(), this.format = (o, s) => this.formatByString(o, this.formats[s]), this.formatByString = (o, s) => this.dayjs(o).format(s), this.formatNumber = (o) => o, this.isEqual = (o, s) => o === null && s === null ? !0 : o === null || s === null ? !1 : o.toDate().getTime() === s.toDate().getTime(), this.isSameYear = (o, s) => this.isSame(o, s, "YYYY"), this.isSameMonth = (o, s) => this.isSame(o, s, "YYYY-MM"), this.isSameDay = (o, s) => this.isSame(o, s, "YYYY-MM-DD"), this.isSameHour = (o, s) => o.isSame(s, "hour"), this.isAfter = (o, s) => o > s, this.isAfterYear = (o, s) => this.hasUTCPlugin() ? !this.isSameYear(o, s) && o.utc() > s.utc() : o.isAfter(s, "year"), this.isAfterDay = (o, s) => this.hasUTCPlugin() ? !this.isSameDay(o, s) && o.utc() > s.utc() : o.isAfter(s, "day"), this.isBefore = (o, s) => o < s, this.isBeforeYear = (o, s) => this.hasUTCPlugin() ? !this.isSameYear(o, s) && o.utc() < s.utc() : o.isBefore(s, "year"), this.isBeforeDay = (o, s) => this.hasUTCPlugin() ? !this.isSameDay(o, s) && o.utc() < s.utc() : o.isBefore(s, "day"), this.isWithinRange = (o, [s, i]) => o >= s && o <= i, this.startOfYear = (o) => this.adjustOffset(o.startOf("year")), this.startOfMonth = (o) => this.adjustOffset(o.startOf("month")), this.startOfWeek = (o) => this.adjustOffset(this.setLocaleToValue(o).startOf("week")), this.startOfDay = (o) => this.adjustOffset(o.startOf("day")), this.endOfYear = (o) => this.adjustOffset(o.endOf("year")), this.endOfMonth = (o) => this.adjustOffset(o.endOf("month")), this.endOfWeek = (o) => this.adjustOffset(this.setLocaleToValue(o).endOf("week")), this.endOfDay = (o) => this.adjustOffset(o.endOf("day")), this.addYears = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "year") : o.add(s, "year")), this.addMonths = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "month") : o.add(s, "month")), this.addWeeks = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "week") : o.add(s, "week")), this.addDays = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "day") : o.add(s, "day")), this.addHours = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "hour") : o.add(s, "hour")), this.addMinutes = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "minute") : o.add(s, "minute")), this.addSeconds = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "second") : o.add(s, "second")), this.getYear = (o) => o.year(), this.getMonth = (o) => o.month(), this.getDate = (o) => o.date(), this.getHours = (o) => o.hour(), this.getMinutes = (o) => o.minute(), this.getSeconds = (o) => o.second(), this.getMilliseconds = (o) => o.millisecond(), this.setYear = (o, s) => this.adjustOffset(o.set("year", s)), this.setMonth = (o, s) => this.adjustOffset(o.set("month", s)), this.setDate = (o, s) => this.adjustOffset(o.set("date", s)), this.setHours = (o, s) => this.adjustOffset(o.set("hour", s)), this.setMinutes = (o, s) => this.adjustOffset(o.set("minute", s)), this.setSeconds = (o, s) => this.adjustOffset(o.set("second", s)), this.setMilliseconds = (o, s) => this.adjustOffset(o.set("millisecond", s)), this.getDaysInMonth = (o) => o.daysInMonth(), this.getWeekArray = (o) => {
      const s = this.startOfWeek(this.startOfMonth(o)), i = this.endOfWeek(this.endOfMonth(o));
      let a = 0, l = s;
      const c = [];
      for (; l < i; ) {
        const u = Math.floor(a / 7);
        c[u] = c[u] || [], c[u].push(l), l = this.addDays(l, 1), a += 1;
      }
      return c;
    }, this.getWeekNumber = (o) => o.week(), this.getYearRange = ([o, s]) => {
      const i = this.startOfYear(o), a = this.endOfYear(s), l = [];
      let c = i;
      for (; this.isBefore(c, a); )
        l.push(c), c = this.addYears(c, 1);
      return l;
    }, this.dayjs = Pce(qn, t), this.locale = t, this.formats = I({}, Oce, n), qn.extend(hce);
  }
  getDayOfWeek(t) {
    return t.day() + 1;
  }
}
const nc = new uh(), Bve = ({
  disabled: e = !1,
  format: t = "MM/DD/YYYY",
  value: n,
  onChange: o,
  defaultValue: s,
  minDate: i,
  maxDate: a,
  ...l
}) => /* @__PURE__ */ C(eh, { dateAdapter: uh, children: /* @__PURE__ */ C(
  o$,
  {
    disabled: e,
    format: t,
    value: n ? nc.date(n.toISOString()) : null,
    onChange: (c) => {
      o == null || o(
        c ? nc.toJsDate(c.startOf("day")) : null
      );
    },
    defaultValue: s ? nc.date(s.toISOString()) : null,
    minDate: i ? nc.date(i.toISOString()) ?? void 0 : void 0,
    maxDate: a ? nc.date(a.toISOString()) ?? void 0 : void 0,
    ...l
  }
) }), g$ = rs(
  (e, t) => /* @__PURE__ */ C(F0, { size: "small", ...e, ref: t })
);
g$.fieldType = "single-input";
const ya = new uh(), zve = ({
  disabled: e = !1,
  format: t = "MM/DD/YYYY",
  value: n,
  onChange: o,
  onClear: s,
  defaultValue: i,
  minDate: a,
  maxDate: l,
  ...c
}) => {
  const u = (p) => [
    p[0] ? ya.toJsDate(p[0].startOf("day")) : null,
    p[1] ? ya.toJsDate(p[1].startOf("day")) : null
  ], d = (p = [null, null]) => [
    p[0] ? ya.date(
      p[0] instanceof Date ? p[0].toISOString() : p[0]
    ) : null,
    p[1] ? ya.date(
      p[1] instanceof Date ? p[1].toISOString() : p[1]
    ) : null
  ], f = (p) => {
    p[0] && p[1] && (o == null || o(u(p)));
  };
  return /* @__PURE__ */ C(eh, { dateAdapter: uh, children: /* @__PURE__ */ C(
    h$,
    {
      sx: { minWidth: "300px" },
      disabled: e,
      format: t,
      value: n ? d(n) : [null, null],
      onChange: f,
      defaultValue: i ? d(i) : [null, null],
      minDate: a ? ya.date(a.toISOString()) : void 0,
      maxDate: l ? ya.date(l.toISOString()) : void 0,
      closeOnSelect: !1,
      slots: {
        field: g$
      },
      slotProps: {
        textField: {
          InputProps: {
            endAdornment: /* @__PURE__ */ C(Ve, { children: "event" })
          }
        },
        field: {
          clearable: !!s,
          onClear: s
        }
      },
      ...c
    }
  ) });
}, Hve = ({
  id: e,
  steps: t,
  open: n,
  onClose: o,
  onNextStep: s,
  onBack: i,
  dialogRef: a
}) => {
  const [l, c] = jt(0);
  hF(a, () => ({
    goToStep(y) {
      c(y);
    }
  }), []);
  const { validate: u, title: d, content: f } = t[l], p = () => {
    u() && (c(l + 1), s == null || s(l));
  }, m = () => {
    c(l - 1), i == null || i(l);
  }, b = () => {
    c(0), o == null || o(l);
  }, v = l === t.length - 1, g = {
    onClick: v ? b : p,
    children: v ? "Done" : "Continue",
    variant: "contained",
    disabled: !u(),
    ...t[l].button
  };
  return /* @__PURE__ */ C(
    Y7,
    {
      open: n,
      id: e,
      title: d,
      noPadding: !0,
      fixedWidth: !0,
      onClose: b,
      children: /* @__PURE__ */ ie(
        Gt,
        {
          sx: {
            height: "100%",
            position: "relative",
            display: "flex",
            flexDirection: "column"
          },
          children: [
            /* @__PURE__ */ C(Gt, { sx: { padding: 2, paddingBottom: 6, flexGrow: 1 }, children: f }),
            /* @__PURE__ */ ie(
              Gt,
              {
                sx: (y) => ({
                  padding: 2,
                  borderTop: `1px solid ${y.palette.divider}`,
                  display: "flex",
                  justifyContent: "space-between",
                  position: "sticky",
                  bottom: 0,
                  width: "100%",
                  boxSizing: "border-box",
                  backgroundColor: y.palette.background.paper
                }),
                children: [
                  l !== 0 && !t[l].hideBackButton && /* @__PURE__ */ C(Of, { onClick: m, children: "Back" }) || /* @__PURE__ */ C(Gt, {}),
                  /* @__PURE__ */ C(Of, { ...g })
                ]
              }
            )
          ]
        }
      )
    }
  );
}, jve = _e(/* @__PURE__ */ C("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), "ArrowBack"), Mce = _e(/* @__PURE__ */ C("path", {
  d: "m7 10 5 5 5-5z"
}), "ArrowDropDown"), kce = _e(/* @__PURE__ */ C("path", {
  d: "m7 14 5-5 5 5z"
}), "ArrowDropUp"), Gve = _e(/* @__PURE__ */ C("path", {
  d: "M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2m-6 0h-4V5h4z"
}), "BusinessCenter"), qve = _e(/* @__PURE__ */ C("path", {
  d: "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2M6 9h12v2H6zm8 5H6v-2h8zm4-6H6V6h12z"
}), "Chat"), Dce = _e(/* @__PURE__ */ C("path", {
  d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check"), Wve = _e(/* @__PURE__ */ C("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2m-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckBox"), Uve = _e(/* @__PURE__ */ C("path", {
  d: "M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
}), "CheckBoxOutlineBlank"), Kve = _e(/* @__PURE__ */ C("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckCircle"), Yve = _e(/* @__PURE__ */ C("path", {
  d: "M16.59 7.58 10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "CheckCircleOutline"), Nce = _e(/* @__PURE__ */ C("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), $ce = _e(/* @__PURE__ */ C("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z"
}), "ContentCopy"), Xve = _e(/* @__PURE__ */ C("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM8 9h8v10H8zm7.5-5-1-1h-5l-1 1H5v2h14V4z"
}), "DeleteOutline"), Ace = _e(/* @__PURE__ */ C("path", {
  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2m-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2"
}), "DragIndicator"), Qve = _e(/* @__PURE__ */ C("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M8.5 8c.83 0 1.5.67 1.5 1.5S9.33 11 8.5 11 7 10.33 7 9.5 7.67 8 8.5 8M12 18c-2.28 0-4.22-1.66-5-4h10c-.78 2.34-2.72 4-5 4m3.5-7c-.83 0-1.5-.67-1.5-1.5S14.67 8 15.5 8s1.5.67 1.5 1.5-.67 1.5-1.5 1.5"
}), "EmojiEmotions"), Zve = _e(/* @__PURE__ */ C("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), "Error"), Jve = _e(/* @__PURE__ */ C("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore"), eCe = _e(/* @__PURE__ */ C("path", {
  d: "m12 21.35-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z"
}), "Favorite"), tCe = _e(/* @__PURE__ */ C("path", {
  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), "Home"), Fce = _e(/* @__PURE__ */ C("path", {
  d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), "KeyboardArrowDown"), Lce = _e(/* @__PURE__ */ C("path", {
  d: "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), "KeyboardArrowUp"), nCe = _e(/* @__PURE__ */ C("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2m6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56M12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96M4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56m2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8M12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96M14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2m.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56M16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2z"
}), "Language"), oCe = _e([/* @__PURE__ */ C("path", {
  d: "m12 12.9-2.13 2.09c-.56.56-.87 1.29-.87 2.07C9 18.68 10.35 20 12 20s3-1.32 3-2.94c0-.78-.31-1.52-.87-2.07z"
}, "0"), /* @__PURE__ */ C("path", {
  d: "m16 6-.44.55C14.38 8.02 12 7.19 12 5.3V2S4 6 4 13c0 2.92 1.56 5.47 3.89 6.86-.56-.79-.89-1.76-.89-2.8 0-1.32.52-2.56 1.47-3.5L12 10.1l3.53 3.47c.95.93 1.47 2.17 1.47 3.5 0 1.02-.31 1.96-.85 2.75 1.89-1.15 3.29-3.06 3.71-5.3.66-3.55-1.07-6.9-3.86-8.52"
}, "1")], "LocalFireDepartment"), _ce = _e(/* @__PURE__ */ C("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1z"
}), "Lock"), Vce = _e(/* @__PURE__ */ C("path", {
  d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m0 12H6V10h12z"
}), "LockOpen"), rCe = _e(/* @__PURE__ */ C("path", {
  d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3z"
}), "OpenInNew"), sCe = _e(/* @__PURE__ */ C("path", {
  d: "M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1m-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m4.5-4H7V4h9z"
}), "PhoneIphone"), iCe = _e(/* @__PURE__ */ C("path", {
  d: "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1m-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1"
}), "QuestionAnswer"), aCe = _e(/* @__PURE__ */ C("path", {
  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
}), "Refresh"), lCe = _e(/* @__PURE__ */ C("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11H7v-2h10z"
}), "RemoveCircle"), cCe = _e(/* @__PURE__ */ C("path", {
  d: "M12 5V2L8 6l4 4V7c3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93 0-4.42-3.58-8-8-8m-6 8c0-1.65.67-3.15 1.76-4.24L6.34 7.34C4.9 8.79 4 10.79 4 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91"
}), "RestartAlt"), uCe = _e(/* @__PURE__ */ C("path", {
  d: "M15 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V9zM8 17c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m0-4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m0-4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m6 1V4.5l5.5 5.5z"
}), "Summarize"), Bce = _e(/* @__PURE__ */ C("path", {
  d: "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2m4 0v12h4V3z"
}), "ThumbDown"), zce = _e(/* @__PURE__ */ C("path", {
  d: "m10.89 18.28.57-2.89c.12-.59-.04-1.2-.42-1.66S10.1 13 9.5 13H4v-1.08L6.57 6h8.09c.18 0 .34.16.34.34v7.84zM10 22l6.41-6.41c.38-.38.59-.89.59-1.42V6.34C17 5.05 15.95 4 14.66 4h-8.1c-.71 0-1.36.37-1.72.97l-2.67 6.15c-.11.25-.17.52-.17.8V13c0 1.1.9 2 2 2h5.5l-.92 4.65c-.05.22-.02.46.08.66.23.45.52.86.88 1.22zm10-7h2V4h-2c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1"
}), "ThumbDownOffAlt"), Hce = _e(/* @__PURE__ */ C("path", {
  d: "M1 21h4V9H1zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73z"
}), "ThumbUp"), jce = _e(/* @__PURE__ */ C("path", {
  d: "m13.11 5.72-.57 2.89c-.12.59.04 1.2.42 1.66s.94.73 1.54.73H20v1.08L17.43 18H9.34c-.18 0-.34-.16-.34-.34V9.82zM14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.83C7 18.95 8.05 20 9.34 20h8.1c.71 0 1.36-.37 1.72-.97l2.67-6.15c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66-.23-.45-.52-.86-.88-1.22zM4 9H2v11h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1"
}), "ThumbUpOffAlt"), dCe = _e(/* @__PURE__ */ C("path", {
  d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), "Warning"), fCe = ({
  primaryTitle: e,
  options: t,
  value: n,
  optionsHeader: o,
  optionRenderer: s,
  selectedValueRenderer: i,
  onChange: a,
  disabled: l = !1
}) => {
  const c = sn(), [u, d] = jt(null), [f, p] = jt(n), m = !!u, b = (w) => {
    d(w.currentTarget);
  }, v = (w) => {
    p(w), d(null), a({ index: w, value: t[w] });
  }, g = () => {
    d(null);
  };
  Nt(() => {
    p(n);
  }, [n]);
  let y = "";
  return f !== null && (y = i ? i(t[f]) : t[f]), /* @__PURE__ */ ie(mo, { children: [
    /* @__PURE__ */ ie(
      sC,
      {
        sx: {
          position: "relative",
          padding: c.spacing(1),
          borderLeft: `3px solid ${c.palette.primary.main}`,
          backgroundColor: c.palette.primary.background,
          maxHeight: "80px"
        },
        onClick: b,
        disabled: l,
        children: [
          /* @__PURE__ */ C(
            Ho,
            {
              sx: {
                fontSize: c.typography.body1.fontSize,
                fontWeight: c.typography.fontWeightBold,
                color: c.palette.text.primary
              },
              primaryTypographyProps: {
                sx: {
                  fontSize: c.typography.body1.fontSize,
                  fontWeight: c.typography.fontWeightBold,
                  color: c.palette.text.primary
                }
              },
              primary: e,
              secondary: y,
              secondaryTypographyProps: {
                sx: {
                  fontSize: c.typography.body2.fontSize,
                  color: c.palette.text.secondary
                }
              }
            }
          ),
          m ? /* @__PURE__ */ C(
            kce,
            {
              sx: {
                color: c.palette.primary.main
              }
            }
          ) : /* @__PURE__ */ C(
            Mce,
            {
              sx: {
                color: c.palette.primary.main
              }
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ ie(Eu, { anchorEl: u, open: m, onClose: g, children: [
      o && /* @__PURE__ */ C(mo, { children: o }),
      t.map((w, x) => /* @__PURE__ */ ie(
        Nn,
        {
          selected: x === f,
          onClick: () => v(x),
          sx: {
            display: "flex",
            justifyContent: "space-between",
            padding: c.spacing(1, 2),
            gap: c.spacing(1),
            "&.Mui-selected": {
              backgroundColor: "inherit"
            }
          },
          children: [
            /* @__PURE__ */ C(
              vt,
              {
                sx: {
                  whiteSpace: "break-spaces"
                },
                children: s ? s(w) : w
              }
            ),
            x === f ? /* @__PURE__ */ C(
              Dce,
              {
                sx: {
                  color: c.palette.primary.main
                }
              }
            ) : null
          ]
        },
        w
      ))
    ] })
  ] });
};
function Gce() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Ye(
    () => (o) => {
      t.forEach((s) => s(o));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
const dh = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
function kl(e) {
  const t = Object.prototype.toString.call(e);
  return t === "[object Window]" || // In Electron context the Window object serializes to [object global]
  t === "[object global]";
}
function _0(e) {
  return "nodeType" in e;
}
function Lo(e) {
  var t, n;
  return e ? kl(e) ? e : _0(e) && (t = (n = e.ownerDocument) == null ? void 0 : n.defaultView) != null ? t : window : window;
}
function V0(e) {
  const {
    Document: t
  } = Lo(e);
  return e instanceof t;
}
function Wu(e) {
  return kl(e) ? !1 : e instanceof Lo(e).HTMLElement;
}
function m$(e) {
  return e instanceof Lo(e).SVGElement;
}
function Dl(e) {
  return e ? kl(e) ? e.document : _0(e) ? V0(e) ? e : Wu(e) || m$(e) ? e.ownerDocument : document : document : document;
}
const os = dh ? gF : Nt;
function B0(e) {
  const t = Ft(e);
  return os(() => {
    t.current = e;
  }), pt(function() {
    for (var n = arguments.length, o = new Array(n), s = 0; s < n; s++)
      o[s] = arguments[s];
    return t.current == null ? void 0 : t.current(...o);
  }, []);
}
function qce() {
  const e = Ft(null), t = pt((o, s) => {
    e.current = setInterval(o, s);
  }, []), n = pt(() => {
    e.current !== null && (clearInterval(e.current), e.current = null);
  }, []);
  return [t, n];
}
function ou(e, t) {
  t === void 0 && (t = [e]);
  const n = Ft(e);
  return os(() => {
    n.current !== e && (n.current = e);
  }, t), n;
}
function Uu(e, t) {
  const n = Ft();
  return Ye(
    () => {
      const o = e(n.current);
      return n.current = o, o;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
function Xf(e) {
  const t = B0(e), n = Ft(null), o = pt(
    (s) => {
      s !== n.current && (t == null || t(s, n.current)), n.current = s;
    },
    //eslint-disable-next-line
    []
  );
  return [n, o];
}
function Xy(e) {
  const t = Ft();
  return Nt(() => {
    t.current = e;
  }, [e]), t.current;
}
let Hg = {};
function Ku(e, t) {
  return Ye(() => {
    if (t)
      return t;
    const n = Hg[e] == null ? 0 : Hg[e] + 1;
    return Hg[e] = n, e + "-" + n;
  }, [e, t]);
}
function b$(e) {
  return function(t) {
    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
      o[s - 1] = arguments[s];
    return o.reduce((i, a) => {
      const l = Object.entries(a);
      for (const [c, u] of l) {
        const d = i[c];
        d != null && (i[c] = d + e * u);
      }
      return i;
    }, {
      ...t
    });
  };
}
const Wa = /* @__PURE__ */ b$(1), Qf = /* @__PURE__ */ b$(-1);
function Wce(e) {
  return "clientX" in e && "clientY" in e;
}
function z0(e) {
  if (!e)
    return !1;
  const {
    KeyboardEvent: t
  } = Lo(e.target);
  return t && e instanceof t;
}
function Uce(e) {
  if (!e)
    return !1;
  const {
    TouchEvent: t
  } = Lo(e.target);
  return t && e instanceof t;
}
function Qy(e) {
  if (Uce(e)) {
    if (e.touches && e.touches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.touches[0];
      return {
        x: t,
        y: n
      };
    } else if (e.changedTouches && e.changedTouches.length) {
      const {
        clientX: t,
        clientY: n
      } = e.changedTouches[0];
      return {
        x: t,
        y: n
      };
    }
  }
  return Wce(e) ? {
    x: e.clientX,
    y: e.clientY
  } : null;
}
const ul = /* @__PURE__ */ Object.freeze({
  Translate: {
    toString(e) {
      if (!e)
        return;
      const {
        x: t,
        y: n
      } = e;
      return "translate3d(" + (t ? Math.round(t) : 0) + "px, " + (n ? Math.round(n) : 0) + "px, 0)";
    }
  },
  Scale: {
    toString(e) {
      if (!e)
        return;
      const {
        scaleX: t,
        scaleY: n
      } = e;
      return "scaleX(" + t + ") scaleY(" + n + ")";
    }
  },
  Transform: {
    toString(e) {
      if (e)
        return [ul.Translate.toString(e), ul.Scale.toString(e)].join(" ");
    }
  },
  Transition: {
    toString(e) {
      let {
        property: t,
        duration: n,
        easing: o
      } = e;
      return t + " " + n + "ms " + o;
    }
  }
}), HR = "a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]";
function Kce(e) {
  return e.matches(HR) ? e : e.querySelector(HR);
}
const Yce = {
  display: "none"
};
function Xce(e) {
  let {
    id: t,
    value: n
  } = e;
  return en.createElement("div", {
    id: t,
    style: Yce
  }, n);
}
function Qce(e) {
  let {
    id: t,
    announcement: n,
    ariaLiveType: o = "assertive"
  } = e;
  const s = {
    position: "fixed",
    top: 0,
    left: 0,
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: "hidden",
    clip: "rect(0 0 0 0)",
    clipPath: "inset(100%)",
    whiteSpace: "nowrap"
  };
  return en.createElement("div", {
    id: t,
    style: s,
    role: "status",
    "aria-live": o,
    "aria-atomic": !0
  }, n);
}
function Zce() {
  const [e, t] = jt("");
  return {
    announce: pt((o) => {
      o != null && t(o);
    }, []),
    announcement: e
  };
}
const y$ = /* @__PURE__ */ Ki(null);
function Jce(e) {
  const t = Co(y$);
  Nt(() => {
    if (!t)
      throw new Error("useDndMonitor must be used within a children of <DndContext>");
    return t(e);
  }, [e, t]);
}
function eue() {
  const [e] = jt(() => /* @__PURE__ */ new Set()), t = pt((o) => (e.add(o), () => e.delete(o)), [e]);
  return [pt((o) => {
    let {
      type: s,
      event: i
    } = o;
    e.forEach((a) => {
      var l;
      return (l = a[s]) == null ? void 0 : l.call(a, i);
    });
  }, [e]), t];
}
const tue = {
  draggable: `
    To pick up a draggable item, press the space bar.
    While dragging, use the arrow keys to move the item.
    Press space again to drop the item in its new position, or press escape to cancel.
  `
}, nue = {
  onDragStart(e) {
    let {
      active: t
    } = e;
    return "Picked up draggable item " + t.id + ".";
  },
  onDragOver(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was moved over droppable area " + n.id + "." : "Draggable item " + t.id + " is no longer over a droppable area.";
  },
  onDragEnd(e) {
    let {
      active: t,
      over: n
    } = e;
    return n ? "Draggable item " + t.id + " was dropped over droppable area " + n.id : "Draggable item " + t.id + " was dropped.";
  },
  onDragCancel(e) {
    let {
      active: t
    } = e;
    return "Dragging was cancelled. Draggable item " + t.id + " was dropped.";
  }
};
function oue(e) {
  let {
    announcements: t = nue,
    container: n,
    hiddenTextDescribedById: o,
    screenReaderInstructions: s = tue
  } = e;
  const {
    announce: i,
    announcement: a
  } = Zce(), l = Ku("DndLiveRegion"), [c, u] = jt(!1);
  if (Nt(() => {
    u(!0);
  }, []), Jce(Ye(() => ({
    onDragStart(f) {
      let {
        active: p
      } = f;
      i(t.onDragStart({
        active: p
      }));
    },
    onDragMove(f) {
      let {
        active: p,
        over: m
      } = f;
      t.onDragMove && i(t.onDragMove({
        active: p,
        over: m
      }));
    },
    onDragOver(f) {
      let {
        active: p,
        over: m
      } = f;
      i(t.onDragOver({
        active: p,
        over: m
      }));
    },
    onDragEnd(f) {
      let {
        active: p,
        over: m
      } = f;
      i(t.onDragEnd({
        active: p,
        over: m
      }));
    },
    onDragCancel(f) {
      let {
        active: p,
        over: m
      } = f;
      i(t.onDragCancel({
        active: p,
        over: m
      }));
    }
  }), [i, t])), !c)
    return null;
  const d = en.createElement(en.Fragment, null, en.createElement(Xce, {
    id: o,
    value: s.draggable
  }), en.createElement(Qce, {
    id: l,
    announcement: a
  }));
  return n ? vF(d, n) : d;
}
var Hn;
(function(e) {
  e.DragStart = "dragStart", e.DragMove = "dragMove", e.DragEnd = "dragEnd", e.DragCancel = "dragCancel", e.DragOver = "dragOver", e.RegisterDroppable = "registerDroppable", e.SetDroppableDisabled = "setDroppableDisabled", e.UnregisterDroppable = "unregisterDroppable";
})(Hn || (Hn = {}));
function Zf() {
}
function Jf(e, t) {
  return Ye(
    () => ({
      sensor: e,
      options: {}
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, t]
  );
}
function v$() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return Ye(
    () => [...t].filter((o) => o != null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [...t]
  );
}
const kr = /* @__PURE__ */ Object.freeze({
  x: 0,
  y: 0
});
function rue(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function sue(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: o
    }
  } = t;
  return n - o;
}
function iue(e, t) {
  let {
    data: {
      value: n
    }
  } = e, {
    data: {
      value: o
    }
  } = t;
  return o - n;
}
function aue(e, t) {
  if (!e || e.length === 0)
    return null;
  const [n] = e;
  return n[t];
}
function jR(e, t, n) {
  return t === void 0 && (t = e.left), n === void 0 && (n = e.top), {
    x: t + e.width * 0.5,
    y: n + e.height * 0.5
  };
}
const lue = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: o
  } = e;
  const s = jR(t, t.left, t.top), i = [];
  for (const a of o) {
    const {
      id: l
    } = a, c = n.get(l);
    if (c) {
      const u = rue(jR(c), s);
      i.push({
        id: l,
        data: {
          droppableContainer: a,
          value: u
        }
      });
    }
  }
  return i.sort(sue);
};
function cue(e, t) {
  const n = Math.max(t.top, e.top), o = Math.max(t.left, e.left), s = Math.min(t.left + t.width, e.left + e.width), i = Math.min(t.top + t.height, e.top + e.height), a = s - o, l = i - n;
  if (o < s && n < i) {
    const c = t.width * t.height, u = e.width * e.height, d = a * l, f = d / (c + u - d);
    return Number(f.toFixed(4));
  }
  return 0;
}
const uue = (e) => {
  let {
    collisionRect: t,
    droppableRects: n,
    droppableContainers: o
  } = e;
  const s = [];
  for (const i of o) {
    const {
      id: a
    } = i, l = n.get(a);
    if (l) {
      const c = cue(l, t);
      c > 0 && s.push({
        id: a,
        data: {
          droppableContainer: i,
          value: c
        }
      });
    }
  }
  return s.sort(iue);
};
function due(e, t, n) {
  return {
    ...e,
    scaleX: t && n ? t.width / n.width : 1,
    scaleY: t && n ? t.height / n.height : 1
  };
}
function C$(e, t) {
  return e && t ? {
    x: e.left - t.left,
    y: e.top - t.top
  } : kr;
}
function fue(e) {
  return function(n) {
    for (var o = arguments.length, s = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
      s[i - 1] = arguments[i];
    return s.reduce((a, l) => ({
      ...a,
      top: a.top + e * l.y,
      bottom: a.bottom + e * l.y,
      left: a.left + e * l.x,
      right: a.right + e * l.x
    }), {
      ...n
    });
  };
}
const pue = /* @__PURE__ */ fue(1);
function hue(e) {
  if (e.startsWith("matrix3d(")) {
    const t = e.slice(9, -1).split(/, /);
    return {
      x: +t[12],
      y: +t[13],
      scaleX: +t[0],
      scaleY: +t[5]
    };
  } else if (e.startsWith("matrix(")) {
    const t = e.slice(7, -1).split(/, /);
    return {
      x: +t[4],
      y: +t[5],
      scaleX: +t[0],
      scaleY: +t[3]
    };
  }
  return null;
}
function gue(e, t, n) {
  const o = hue(t);
  if (!o)
    return e;
  const {
    scaleX: s,
    scaleY: i,
    x: a,
    y: l
  } = o, c = e.left - a - (1 - s) * parseFloat(n), u = e.top - l - (1 - i) * parseFloat(n.slice(n.indexOf(" ") + 1)), d = s ? e.width / s : e.width, f = i ? e.height / i : e.height;
  return {
    width: d,
    height: f,
    top: u,
    right: c + d,
    bottom: u + f,
    left: c
  };
}
const mue = {
  ignoreTransform: !1
};
function Nl(e, t) {
  t === void 0 && (t = mue);
  let n = e.getBoundingClientRect();
  if (t.ignoreTransform) {
    const {
      transform: u,
      transformOrigin: d
    } = Lo(e).getComputedStyle(e);
    u && (n = gue(n, u, d));
  }
  const {
    top: o,
    left: s,
    width: i,
    height: a,
    bottom: l,
    right: c
  } = n;
  return {
    top: o,
    left: s,
    width: i,
    height: a,
    bottom: l,
    right: c
  };
}
function GR(e) {
  return Nl(e, {
    ignoreTransform: !0
  });
}
function bue(e) {
  const t = e.innerWidth, n = e.innerHeight;
  return {
    top: 0,
    left: 0,
    right: t,
    bottom: n,
    width: t,
    height: n
  };
}
function yue(e, t) {
  return t === void 0 && (t = Lo(e).getComputedStyle(e)), t.position === "fixed";
}
function vue(e, t) {
  t === void 0 && (t = Lo(e).getComputedStyle(e));
  const n = /(auto|scroll|overlay)/;
  return ["overflow", "overflowX", "overflowY"].some((s) => {
    const i = t[s];
    return typeof i == "string" ? n.test(i) : !1;
  });
}
function H0(e, t) {
  const n = [];
  function o(s) {
    if (t != null && n.length >= t || !s)
      return n;
    if (V0(s) && s.scrollingElement != null && !n.includes(s.scrollingElement))
      return n.push(s.scrollingElement), n;
    if (!Wu(s) || m$(s) || n.includes(s))
      return n;
    const i = Lo(e).getComputedStyle(s);
    return s !== e && vue(s, i) && n.push(s), yue(s, i) ? n : o(s.parentNode);
  }
  return e ? o(e) : n;
}
function w$(e) {
  const [t] = H0(e, 1);
  return t ?? null;
}
function jg(e) {
  return !dh || !e ? null : kl(e) ? e : _0(e) ? V0(e) || e === Dl(e).scrollingElement ? window : Wu(e) ? e : null : null;
}
function S$(e) {
  return kl(e) ? e.scrollX : e.scrollLeft;
}
function x$(e) {
  return kl(e) ? e.scrollY : e.scrollTop;
}
function Zy(e) {
  return {
    x: S$(e),
    y: x$(e)
  };
}
var Wn;
(function(e) {
  e[e.Forward = 1] = "Forward", e[e.Backward = -1] = "Backward";
})(Wn || (Wn = {}));
function T$(e) {
  return !dh || !e ? !1 : e === document.scrollingElement;
}
function R$(e) {
  const t = {
    x: 0,
    y: 0
  }, n = T$(e) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: e.clientHeight,
    width: e.clientWidth
  }, o = {
    x: e.scrollWidth - n.width,
    y: e.scrollHeight - n.height
  }, s = e.scrollTop <= t.y, i = e.scrollLeft <= t.x, a = e.scrollTop >= o.y, l = e.scrollLeft >= o.x;
  return {
    isTop: s,
    isLeft: i,
    isBottom: a,
    isRight: l,
    maxScroll: o,
    minScroll: t
  };
}
const Cue = {
  x: 0.2,
  y: 0.2
};
function wue(e, t, n, o, s) {
  let {
    top: i,
    left: a,
    right: l,
    bottom: c
  } = n;
  o === void 0 && (o = 10), s === void 0 && (s = Cue);
  const {
    isTop: u,
    isBottom: d,
    isLeft: f,
    isRight: p
  } = R$(e), m = {
    x: 0,
    y: 0
  }, b = {
    x: 0,
    y: 0
  }, v = {
    height: t.height * s.y,
    width: t.width * s.x
  };
  return !u && i <= t.top + v.height ? (m.y = Wn.Backward, b.y = o * Math.abs((t.top + v.height - i) / v.height)) : !d && c >= t.bottom - v.height && (m.y = Wn.Forward, b.y = o * Math.abs((t.bottom - v.height - c) / v.height)), !p && l >= t.right - v.width ? (m.x = Wn.Forward, b.x = o * Math.abs((t.right - v.width - l) / v.width)) : !f && a <= t.left + v.width && (m.x = Wn.Backward, b.x = o * Math.abs((t.left + v.width - a) / v.width)), {
    direction: m,
    speed: b
  };
}
function Sue(e) {
  if (e === document.scrollingElement) {
    const {
      innerWidth: i,
      innerHeight: a
    } = window;
    return {
      top: 0,
      left: 0,
      right: i,
      bottom: a,
      width: i,
      height: a
    };
  }
  const {
    top: t,
    left: n,
    right: o,
    bottom: s
  } = e.getBoundingClientRect();
  return {
    top: t,
    left: n,
    right: o,
    bottom: s,
    width: e.clientWidth,
    height: e.clientHeight
  };
}
function E$(e) {
  return e.reduce((t, n) => Wa(t, Zy(n)), kr);
}
function xue(e) {
  return e.reduce((t, n) => t + S$(n), 0);
}
function Tue(e) {
  return e.reduce((t, n) => t + x$(n), 0);
}
function Rue(e, t) {
  if (t === void 0 && (t = Nl), !e)
    return;
  const {
    top: n,
    left: o,
    bottom: s,
    right: i
  } = t(e);
  w$(e) && (s <= 0 || i <= 0 || n >= window.innerHeight || o >= window.innerWidth) && e.scrollIntoView({
    block: "center",
    inline: "center"
  });
}
const Eue = [["x", ["left", "right"], xue], ["y", ["top", "bottom"], Tue]];
class j0 {
  constructor(t, n) {
    this.rect = void 0, this.width = void 0, this.height = void 0, this.top = void 0, this.bottom = void 0, this.right = void 0, this.left = void 0;
    const o = H0(n), s = E$(o);
    this.rect = {
      ...t
    }, this.width = t.width, this.height = t.height;
    for (const [i, a, l] of Eue)
      for (const c of a)
        Object.defineProperty(this, c, {
          get: () => {
            const u = l(o), d = s[i] - u;
            return this.rect[c] + d;
          },
          enumerable: !0
        });
    Object.defineProperty(this, "rect", {
      enumerable: !1
    });
  }
}
class Dc {
  constructor(t) {
    this.target = void 0, this.listeners = [], this.removeAll = () => {
      this.listeners.forEach((n) => {
        var o;
        return (o = this.target) == null ? void 0 : o.removeEventListener(...n);
      });
    }, this.target = t;
  }
  add(t, n, o) {
    var s;
    (s = this.target) == null || s.addEventListener(t, n, o), this.listeners.push([t, n, o]);
  }
}
function Iue(e) {
  const {
    EventTarget: t
  } = Lo(e);
  return e instanceof t ? e : Dl(e);
}
function Gg(e, t) {
  const n = Math.abs(e.x), o = Math.abs(e.y);
  return typeof t == "number" ? Math.sqrt(n ** 2 + o ** 2) > t : "x" in t && "y" in t ? n > t.x && o > t.y : "x" in t ? n > t.x : "y" in t ? o > t.y : !1;
}
var ar;
(function(e) {
  e.Click = "click", e.DragStart = "dragstart", e.Keydown = "keydown", e.ContextMenu = "contextmenu", e.Resize = "resize", e.SelectionChange = "selectionchange", e.VisibilityChange = "visibilitychange";
})(ar || (ar = {}));
function qR(e) {
  e.preventDefault();
}
function Oue(e) {
  e.stopPropagation();
}
var Ht;
(function(e) {
  e.Space = "Space", e.Down = "ArrowDown", e.Right = "ArrowRight", e.Left = "ArrowLeft", e.Up = "ArrowUp", e.Esc = "Escape", e.Enter = "Enter", e.Tab = "Tab";
})(Ht || (Ht = {}));
const I$ = {
  start: [Ht.Space, Ht.Enter],
  cancel: [Ht.Esc],
  end: [Ht.Space, Ht.Enter, Ht.Tab]
}, Pue = (e, t) => {
  let {
    currentCoordinates: n
  } = t;
  switch (e.code) {
    case Ht.Right:
      return {
        ...n,
        x: n.x + 25
      };
    case Ht.Left:
      return {
        ...n,
        x: n.x - 25
      };
    case Ht.Down:
      return {
        ...n,
        y: n.y + 25
      };
    case Ht.Up:
      return {
        ...n,
        y: n.y - 25
      };
  }
};
class O$ {
  constructor(t) {
    this.props = void 0, this.autoScrollEnabled = !1, this.referenceCoordinates = void 0, this.listeners = void 0, this.windowListeners = void 0, this.props = t;
    const {
      event: {
        target: n
      }
    } = t;
    this.props = t, this.listeners = new Dc(Dl(n)), this.windowListeners = new Dc(Lo(n)), this.handleKeyDown = this.handleKeyDown.bind(this), this.handleCancel = this.handleCancel.bind(this), this.attach();
  }
  attach() {
    this.handleStart(), this.windowListeners.add(ar.Resize, this.handleCancel), this.windowListeners.add(ar.VisibilityChange, this.handleCancel), setTimeout(() => this.listeners.add(ar.Keydown, this.handleKeyDown));
  }
  handleStart() {
    const {
      activeNode: t,
      onStart: n
    } = this.props, o = t.node.current;
    o && Rue(o), n(kr);
  }
  handleKeyDown(t) {
    if (z0(t)) {
      const {
        active: n,
        context: o,
        options: s
      } = this.props, {
        keyboardCodes: i = I$,
        coordinateGetter: a = Pue,
        scrollBehavior: l = "smooth"
      } = s, {
        code: c
      } = t;
      if (i.end.includes(c)) {
        this.handleEnd(t);
        return;
      }
      if (i.cancel.includes(c)) {
        this.handleCancel(t);
        return;
      }
      const {
        collisionRect: u
      } = o.current, d = u ? {
        x: u.left,
        y: u.top
      } : kr;
      this.referenceCoordinates || (this.referenceCoordinates = d);
      const f = a(t, {
        active: n,
        context: o.current,
        currentCoordinates: d
      });
      if (f) {
        const p = Qf(f, d), m = {
          x: 0,
          y: 0
        }, {
          scrollableAncestors: b
        } = o.current;
        for (const v of b) {
          const g = t.code, {
            isTop: y,
            isRight: w,
            isLeft: x,
            isBottom: S,
            maxScroll: T,
            minScroll: E
          } = R$(v), O = Sue(v), M = {
            x: Math.min(g === Ht.Right ? O.right - O.width / 2 : O.right, Math.max(g === Ht.Right ? O.left : O.left + O.width / 2, f.x)),
            y: Math.min(g === Ht.Down ? O.bottom - O.height / 2 : O.bottom, Math.max(g === Ht.Down ? O.top : O.top + O.height / 2, f.y))
          }, D = g === Ht.Right && !w || g === Ht.Left && !x, R = g === Ht.Down && !S || g === Ht.Up && !y;
          if (D && M.x !== f.x) {
            const P = v.scrollLeft + p.x, F = g === Ht.Right && P <= T.x || g === Ht.Left && P >= E.x;
            if (F && !p.y) {
              v.scrollTo({
                left: P,
                behavior: l
              });
              return;
            }
            F ? m.x = v.scrollLeft - P : m.x = g === Ht.Right ? v.scrollLeft - T.x : v.scrollLeft - E.x, m.x && v.scrollBy({
              left: -m.x,
              behavior: l
            });
            break;
          } else if (R && M.y !== f.y) {
            const P = v.scrollTop + p.y, F = g === Ht.Down && P <= T.y || g === Ht.Up && P >= E.y;
            if (F && !p.x) {
              v.scrollTo({
                top: P,
                behavior: l
              });
              return;
            }
            F ? m.y = v.scrollTop - P : m.y = g === Ht.Down ? v.scrollTop - T.y : v.scrollTop - E.y, m.y && v.scrollBy({
              top: -m.y,
              behavior: l
            });
            break;
          }
        }
        this.handleMove(t, Wa(Qf(f, this.referenceCoordinates), m));
      }
    }
  }
  handleMove(t, n) {
    const {
      onMove: o
    } = this.props;
    t.preventDefault(), o(n);
  }
  handleEnd(t) {
    const {
      onEnd: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  handleCancel(t) {
    const {
      onCancel: n
    } = this.props;
    t.preventDefault(), this.detach(), n();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll();
  }
}
O$.activators = [{
  eventName: "onKeyDown",
  handler: (e, t, n) => {
    let {
      keyboardCodes: o = I$,
      onActivation: s
    } = t, {
      active: i
    } = n;
    const {
      code: a
    } = e.nativeEvent;
    if (o.start.includes(a)) {
      const l = i.activatorNode.current;
      return l && e.target !== l ? !1 : (e.preventDefault(), s == null || s({
        event: e.nativeEvent
      }), !0);
    }
    return !1;
  }
}];
function WR(e) {
  return !!(e && "distance" in e);
}
function UR(e) {
  return !!(e && "delay" in e);
}
class G0 {
  constructor(t, n, o) {
    var s;
    o === void 0 && (o = Iue(t.event.target)), this.props = void 0, this.events = void 0, this.autoScrollEnabled = !0, this.document = void 0, this.activated = !1, this.initialCoordinates = void 0, this.timeoutId = null, this.listeners = void 0, this.documentListeners = void 0, this.windowListeners = void 0, this.props = t, this.events = n;
    const {
      event: i
    } = t, {
      target: a
    } = i;
    this.props = t, this.events = n, this.document = Dl(a), this.documentListeners = new Dc(this.document), this.listeners = new Dc(o), this.windowListeners = new Dc(Lo(a)), this.initialCoordinates = (s = Qy(i)) != null ? s : kr, this.handleStart = this.handleStart.bind(this), this.handleMove = this.handleMove.bind(this), this.handleEnd = this.handleEnd.bind(this), this.handleCancel = this.handleCancel.bind(this), this.handleKeydown = this.handleKeydown.bind(this), this.removeTextSelection = this.removeTextSelection.bind(this), this.attach();
  }
  attach() {
    const {
      events: t,
      props: {
        options: {
          activationConstraint: n,
          bypassActivationConstraint: o
        }
      }
    } = this;
    if (this.listeners.add(t.move.name, this.handleMove, {
      passive: !1
    }), this.listeners.add(t.end.name, this.handleEnd), t.cancel && this.listeners.add(t.cancel.name, this.handleCancel), this.windowListeners.add(ar.Resize, this.handleCancel), this.windowListeners.add(ar.DragStart, qR), this.windowListeners.add(ar.VisibilityChange, this.handleCancel), this.windowListeners.add(ar.ContextMenu, qR), this.documentListeners.add(ar.Keydown, this.handleKeydown), n) {
      if (o != null && o({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      }))
        return this.handleStart();
      if (UR(n)) {
        this.timeoutId = setTimeout(this.handleStart, n.delay), this.handlePending(n);
        return;
      }
      if (WR(n)) {
        this.handlePending(n);
        return;
      }
    }
    this.handleStart();
  }
  detach() {
    this.listeners.removeAll(), this.windowListeners.removeAll(), setTimeout(this.documentListeners.removeAll, 50), this.timeoutId !== null && (clearTimeout(this.timeoutId), this.timeoutId = null);
  }
  handlePending(t, n) {
    const {
      active: o,
      onPending: s
    } = this.props;
    s(o, t, this.initialCoordinates, n);
  }
  handleStart() {
    const {
      initialCoordinates: t
    } = this, {
      onStart: n
    } = this.props;
    t && (this.activated = !0, this.documentListeners.add(ar.Click, Oue, {
      capture: !0
    }), this.removeTextSelection(), this.documentListeners.add(ar.SelectionChange, this.removeTextSelection), n(t));
  }
  handleMove(t) {
    var n;
    const {
      activated: o,
      initialCoordinates: s,
      props: i
    } = this, {
      onMove: a,
      options: {
        activationConstraint: l
      }
    } = i;
    if (!s)
      return;
    const c = (n = Qy(t)) != null ? n : kr, u = Qf(s, c);
    if (!o && l) {
      if (WR(l)) {
        if (l.tolerance != null && Gg(u, l.tolerance))
          return this.handleCancel();
        if (Gg(u, l.distance))
          return this.handleStart();
      }
      if (UR(l) && Gg(u, l.tolerance))
        return this.handleCancel();
      this.handlePending(l, u);
      return;
    }
    t.cancelable && t.preventDefault(), a(c);
  }
  handleEnd() {
    const {
      onAbort: t,
      onEnd: n
    } = this.props;
    this.detach(), this.activated || t(this.props.active), n();
  }
  handleCancel() {
    const {
      onAbort: t,
      onCancel: n
    } = this.props;
    this.detach(), this.activated || t(this.props.active), n();
  }
  handleKeydown(t) {
    t.code === Ht.Esc && this.handleCancel();
  }
  removeTextSelection() {
    var t;
    (t = this.document.getSelection()) == null || t.removeAllRanges();
  }
}
const Mue = {
  cancel: {
    name: "pointercancel"
  },
  move: {
    name: "pointermove"
  },
  end: {
    name: "pointerup"
  }
};
class P$ extends G0 {
  constructor(t) {
    const {
      event: n
    } = t, o = Dl(n.target);
    super(t, Mue, o);
  }
}
P$.activators = [{
  eventName: "onPointerDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: o
    } = t;
    return !n.isPrimary || n.button !== 0 ? !1 : (o == null || o({
      event: n
    }), !0);
  }
}];
const kue = {
  move: {
    name: "mousemove"
  },
  end: {
    name: "mouseup"
  }
};
var Jy;
(function(e) {
  e[e.RightClick = 2] = "RightClick";
})(Jy || (Jy = {}));
class q0 extends G0 {
  constructor(t) {
    super(t, kue, Dl(t.event.target));
  }
}
q0.activators = [{
  eventName: "onMouseDown",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: o
    } = t;
    return n.button === Jy.RightClick ? !1 : (o == null || o({
      event: n
    }), !0);
  }
}];
const qg = {
  cancel: {
    name: "touchcancel"
  },
  move: {
    name: "touchmove"
  },
  end: {
    name: "touchend"
  }
};
class W0 extends G0 {
  constructor(t) {
    super(t, qg);
  }
  static setup() {
    return window.addEventListener(qg.move.name, t, {
      capture: !1,
      passive: !1
    }), function() {
      window.removeEventListener(qg.move.name, t);
    };
    function t() {
    }
  }
}
W0.activators = [{
  eventName: "onTouchStart",
  handler: (e, t) => {
    let {
      nativeEvent: n
    } = e, {
      onActivation: o
    } = t;
    const {
      touches: s
    } = n;
    return s.length > 1 ? !1 : (o == null || o({
      event: n
    }), !0);
  }
}];
var Nc;
(function(e) {
  e[e.Pointer = 0] = "Pointer", e[e.DraggableRect = 1] = "DraggableRect";
})(Nc || (Nc = {}));
var ep;
(function(e) {
  e[e.TreeOrder = 0] = "TreeOrder", e[e.ReversedTreeOrder = 1] = "ReversedTreeOrder";
})(ep || (ep = {}));
function Due(e) {
  let {
    acceleration: t,
    activator: n = Nc.Pointer,
    canScroll: o,
    draggingRect: s,
    enabled: i,
    interval: a = 5,
    order: l = ep.TreeOrder,
    pointerCoordinates: c,
    scrollableAncestors: u,
    scrollableAncestorRects: d,
    delta: f,
    threshold: p
  } = e;
  const m = $ue({
    delta: f,
    disabled: !i
  }), [b, v] = qce(), g = Ft({
    x: 0,
    y: 0
  }), y = Ft({
    x: 0,
    y: 0
  }), w = Ye(() => {
    switch (n) {
      case Nc.Pointer:
        return c ? {
          top: c.y,
          bottom: c.y,
          left: c.x,
          right: c.x
        } : null;
      case Nc.DraggableRect:
        return s;
    }
  }, [n, s, c]), x = Ft(null), S = pt(() => {
    const E = x.current;
    if (!E)
      return;
    const O = g.current.x * y.current.x, M = g.current.y * y.current.y;
    E.scrollBy(O, M);
  }, []), T = Ye(() => l === ep.TreeOrder ? [...u].reverse() : u, [l, u]);
  Nt(
    () => {
      if (!i || !u.length || !w) {
        v();
        return;
      }
      for (const E of T) {
        if ((o == null ? void 0 : o(E)) === !1)
          continue;
        const O = u.indexOf(E), M = d[O];
        if (!M)
          continue;
        const {
          direction: D,
          speed: R
        } = wue(E, M, w, t, p);
        for (const P of ["x", "y"])
          m[P][D[P]] || (R[P] = 0, D[P] = 0);
        if (R.x > 0 || R.y > 0) {
          v(), x.current = E, b(S, a), g.current = R, y.current = D;
          return;
        }
      }
      g.current = {
        x: 0,
        y: 0
      }, y.current = {
        x: 0,
        y: 0
      }, v();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t,
      S,
      o,
      v,
      i,
      a,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(w),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(m),
      b,
      u,
      T,
      d,
      // eslint-disable-next-line react-hooks/exhaustive-deps
      JSON.stringify(p)
    ]
  );
}
const Nue = {
  x: {
    [Wn.Backward]: !1,
    [Wn.Forward]: !1
  },
  y: {
    [Wn.Backward]: !1,
    [Wn.Forward]: !1
  }
};
function $ue(e) {
  let {
    delta: t,
    disabled: n
  } = e;
  const o = Xy(t);
  return Uu((s) => {
    if (n || !o || !s)
      return Nue;
    const i = {
      x: Math.sign(t.x - o.x),
      y: Math.sign(t.y - o.y)
    };
    return {
      x: {
        [Wn.Backward]: s.x[Wn.Backward] || i.x === -1,
        [Wn.Forward]: s.x[Wn.Forward] || i.x === 1
      },
      y: {
        [Wn.Backward]: s.y[Wn.Backward] || i.y === -1,
        [Wn.Forward]: s.y[Wn.Forward] || i.y === 1
      }
    };
  }, [n, t, o]);
}
function Aue(e, t) {
  const n = t != null ? e.get(t) : void 0, o = n ? n.node.current : null;
  return Uu((s) => {
    var i;
    return t == null ? null : (i = o ?? s) != null ? i : null;
  }, [o, t]);
}
function Fue(e, t) {
  return Ye(() => e.reduce((n, o) => {
    const {
      sensor: s
    } = o, i = s.activators.map((a) => ({
      eventName: a.eventName,
      handler: t(a.handler, o)
    }));
    return [...n, ...i];
  }, []), [e, t]);
}
var ru;
(function(e) {
  e[e.Always = 0] = "Always", e[e.BeforeDragging = 1] = "BeforeDragging", e[e.WhileDragging = 2] = "WhileDragging";
})(ru || (ru = {}));
var ev;
(function(e) {
  e.Optimized = "optimized";
})(ev || (ev = {}));
const KR = /* @__PURE__ */ new Map();
function Lue(e, t) {
  let {
    dragging: n,
    dependencies: o,
    config: s
  } = t;
  const [i, a] = jt(null), {
    frequency: l,
    measure: c,
    strategy: u
  } = s, d = Ft(e), f = g(), p = ou(f), m = pt(function(y) {
    y === void 0 && (y = []), !p.current && a((w) => w === null ? y : w.concat(y.filter((x) => !w.includes(x))));
  }, [p]), b = Ft(null), v = Uu((y) => {
    if (f && !n)
      return KR;
    if (!y || y === KR || d.current !== e || i != null) {
      const w = /* @__PURE__ */ new Map();
      for (let x of e) {
        if (!x)
          continue;
        if (i && i.length > 0 && !i.includes(x.id) && x.rect.current) {
          w.set(x.id, x.rect.current);
          continue;
        }
        const S = x.node.current, T = S ? new j0(c(S), S) : null;
        x.rect.current = T, T && w.set(x.id, T);
      }
      return w;
    }
    return y;
  }, [e, i, n, f, c]);
  return Nt(() => {
    d.current = e;
  }, [e]), Nt(
    () => {
      f || m();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n, f]
  ), Nt(
    () => {
      i && i.length > 0 && a(null);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(i)]
  ), Nt(
    () => {
      f || typeof l != "number" || b.current !== null || (b.current = setTimeout(() => {
        m(), b.current = null;
      }, l));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [l, f, m, ...o]
  ), {
    droppableRects: v,
    measureDroppableContainers: m,
    measuringScheduled: i != null
  };
  function g() {
    switch (u) {
      case ru.Always:
        return !1;
      case ru.BeforeDragging:
        return n;
      default:
        return !n;
    }
  }
}
function M$(e, t) {
  return Uu((n) => e ? n || (typeof t == "function" ? t(e) : e) : null, [t, e]);
}
function _ue(e, t) {
  return M$(e, t);
}
function Vue(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const o = B0(t), s = Ye(() => {
    if (n || typeof window > "u" || typeof window.MutationObserver > "u")
      return;
    const {
      MutationObserver: i
    } = window;
    return new i(o);
  }, [o, n]);
  return Nt(() => () => s == null ? void 0 : s.disconnect(), [s]), s;
}
function fh(e) {
  let {
    callback: t,
    disabled: n
  } = e;
  const o = B0(t), s = Ye(
    () => {
      if (n || typeof window > "u" || typeof window.ResizeObserver > "u")
        return;
      const {
        ResizeObserver: i
      } = window;
      return new i(o);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [n]
  );
  return Nt(() => () => s == null ? void 0 : s.disconnect(), [s]), s;
}
function Bue(e) {
  return new j0(Nl(e), e);
}
function YR(e, t, n) {
  t === void 0 && (t = Bue);
  const [o, s] = jt(null);
  function i() {
    s((c) => {
      if (!e)
        return null;
      if (e.isConnected === !1) {
        var u;
        return (u = c ?? n) != null ? u : null;
      }
      const d = t(e);
      return JSON.stringify(c) === JSON.stringify(d) ? c : d;
    });
  }
  const a = Vue({
    callback(c) {
      if (e)
        for (const u of c) {
          const {
            type: d,
            target: f
          } = u;
          if (d === "childList" && f instanceof HTMLElement && f.contains(e)) {
            i();
            break;
          }
        }
    }
  }), l = fh({
    callback: i
  });
  return os(() => {
    i(), e ? (l == null || l.observe(e), a == null || a.observe(document.body, {
      childList: !0,
      subtree: !0
    })) : (l == null || l.disconnect(), a == null || a.disconnect());
  }, [e]), o;
}
function zue(e) {
  const t = M$(e);
  return C$(e, t);
}
const XR = [];
function Hue(e) {
  const t = Ft(e), n = Uu((o) => e ? o && o !== XR && e && t.current && e.parentNode === t.current.parentNode ? o : H0(e) : XR, [e]);
  return Nt(() => {
    t.current = e;
  }, [e]), n;
}
function jue(e) {
  const [t, n] = jt(null), o = Ft(e), s = pt((i) => {
    const a = jg(i.target);
    a && n((l) => l ? (l.set(a, Zy(a)), new Map(l)) : null);
  }, []);
  return Nt(() => {
    const i = o.current;
    if (e !== i) {
      a(i);
      const l = e.map((c) => {
        const u = jg(c);
        return u ? (u.addEventListener("scroll", s, {
          passive: !0
        }), [u, Zy(u)]) : null;
      }).filter((c) => c != null);
      n(l.length ? new Map(l) : null), o.current = e;
    }
    return () => {
      a(e), a(i);
    };
    function a(l) {
      l.forEach((c) => {
        const u = jg(c);
        u == null || u.removeEventListener("scroll", s);
      });
    }
  }, [s, e]), Ye(() => e.length ? t ? Array.from(t.values()).reduce((i, a) => Wa(i, a), kr) : E$(e) : kr, [e, t]);
}
function QR(e, t) {
  t === void 0 && (t = []);
  const n = Ft(null);
  return Nt(
    () => {
      n.current = null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), Nt(() => {
    const o = e !== kr;
    o && !n.current && (n.current = e), !o && n.current && (n.current = null);
  }, [e]), n.current ? Qf(e, n.current) : kr;
}
function Gue(e) {
  Nt(
    () => {
      if (!dh)
        return;
      const t = e.map((n) => {
        let {
          sensor: o
        } = n;
        return o.setup == null ? void 0 : o.setup();
      });
      return () => {
        for (const n of t)
          n == null || n();
      };
    },
    // TO-DO: Sensors length could theoretically change which would not be a valid dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((t) => {
      let {
        sensor: n
      } = t;
      return n;
    })
  );
}
function que(e, t) {
  return Ye(() => e.reduce((n, o) => {
    let {
      eventName: s,
      handler: i
    } = o;
    return n[s] = (a) => {
      i(a, t);
    }, n;
  }, {}), [e, t]);
}
function k$(e) {
  return Ye(() => e ? bue(e) : null, [e]);
}
const ZR = [];
function Wue(e, t) {
  t === void 0 && (t = Nl);
  const [n] = e, o = k$(n ? Lo(n) : null), [s, i] = jt(ZR);
  function a() {
    i(() => e.length ? e.map((c) => T$(c) ? o : new j0(t(c), c)) : ZR);
  }
  const l = fh({
    callback: a
  });
  return os(() => {
    l == null || l.disconnect(), a(), e.forEach((c) => l == null ? void 0 : l.observe(c));
  }, [e]), s;
}
function Uue(e) {
  if (!e)
    return null;
  if (e.children.length > 1)
    return e;
  const t = e.children[0];
  return Wu(t) ? t : e;
}
function Kue(e) {
  let {
    measure: t
  } = e;
  const [n, o] = jt(null), s = pt((u) => {
    for (const {
      target: d
    } of u)
      if (Wu(d)) {
        o((f) => {
          const p = t(d);
          return f ? {
            ...f,
            width: p.width,
            height: p.height
          } : p;
        });
        break;
      }
  }, [t]), i = fh({
    callback: s
  }), a = pt((u) => {
    const d = Uue(u);
    i == null || i.disconnect(), d && (i == null || i.observe(d)), o(d ? t(d) : null);
  }, [t, i]), [l, c] = Xf(a);
  return Ye(() => ({
    nodeRef: l,
    rect: n,
    setRef: c
  }), [n, l, c]);
}
const Yue = [{
  sensor: P$,
  options: {}
}, {
  sensor: O$,
  options: {}
}], Xue = {
  current: {}
}, hf = {
  draggable: {
    measure: GR
  },
  droppable: {
    measure: GR,
    strategy: ru.WhileDragging,
    frequency: ev.Optimized
  },
  dragOverlay: {
    measure: Nl
  }
};
class $c extends Map {
  get(t) {
    var n;
    return t != null && (n = super.get(t)) != null ? n : void 0;
  }
  toArray() {
    return Array.from(this.values());
  }
  getEnabled() {
    return this.toArray().filter((t) => {
      let {
        disabled: n
      } = t;
      return !n;
    });
  }
  getNodeFor(t) {
    var n, o;
    return (n = (o = this.get(t)) == null ? void 0 : o.node.current) != null ? n : void 0;
  }
}
const Que = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /* @__PURE__ */ new Map(),
  droppableRects: /* @__PURE__ */ new Map(),
  droppableContainers: /* @__PURE__ */ new $c(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: Zf
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: hf,
  measureDroppableContainers: Zf,
  windowRect: null,
  measuringScheduled: !1
}, Zue = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ""
  },
  dispatch: Zf,
  draggableNodes: /* @__PURE__ */ new Map(),
  over: null,
  measureDroppableContainers: Zf
}, ph = /* @__PURE__ */ Ki(Zue), D$ = /* @__PURE__ */ Ki(Que);
function Jue() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: /* @__PURE__ */ new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new $c()
    }
  };
}
function ede(e, t) {
  switch (t.type) {
    case Hn.DragStart:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          initialCoordinates: t.initialCoordinates,
          active: t.active
        }
      };
    case Hn.DragMove:
      return e.draggable.active == null ? e : {
        ...e,
        draggable: {
          ...e.draggable,
          translate: {
            x: t.coordinates.x - e.draggable.initialCoordinates.x,
            y: t.coordinates.y - e.draggable.initialCoordinates.y
          }
        }
      };
    case Hn.DragEnd:
    case Hn.DragCancel:
      return {
        ...e,
        draggable: {
          ...e.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };
    case Hn.RegisterDroppable: {
      const {
        element: n
      } = t, {
        id: o
      } = n, s = new $c(e.droppable.containers);
      return s.set(o, n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: s
        }
      };
    }
    case Hn.SetDroppableDisabled: {
      const {
        id: n,
        key: o,
        disabled: s
      } = t, i = e.droppable.containers.get(n);
      if (!i || o !== i.key)
        return e;
      const a = new $c(e.droppable.containers);
      return a.set(n, {
        ...i,
        disabled: s
      }), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: a
        }
      };
    }
    case Hn.UnregisterDroppable: {
      const {
        id: n,
        key: o
      } = t, s = e.droppable.containers.get(n);
      if (!s || o !== s.key)
        return e;
      const i = new $c(e.droppable.containers);
      return i.delete(n), {
        ...e,
        droppable: {
          ...e.droppable,
          containers: i
        }
      };
    }
    default:
      return e;
  }
}
function tde(e) {
  let {
    disabled: t
  } = e;
  const {
    active: n,
    activatorEvent: o,
    draggableNodes: s
  } = Co(ph), i = Xy(o), a = Xy(n == null ? void 0 : n.id);
  return Nt(() => {
    if (!t && !o && i && a != null) {
      if (!z0(i) || document.activeElement === i.target)
        return;
      const l = s.get(a);
      if (!l)
        return;
      const {
        activatorNode: c,
        node: u
      } = l;
      if (!c.current && !u.current)
        return;
      requestAnimationFrame(() => {
        for (const d of [c.current, u.current]) {
          if (!d)
            continue;
          const f = Kce(d);
          if (f) {
            f.focus();
            break;
          }
        }
      });
    }
  }, [o, t, s, a, i]), null;
}
function nde(e, t) {
  let {
    transform: n,
    ...o
  } = t;
  return e != null && e.length ? e.reduce((s, i) => i({
    transform: s,
    ...o
  }), n) : n;
}
function ode(e) {
  return Ye(
    () => ({
      draggable: {
        ...hf.draggable,
        ...e == null ? void 0 : e.draggable
      },
      droppable: {
        ...hf.droppable,
        ...e == null ? void 0 : e.droppable
      },
      dragOverlay: {
        ...hf.dragOverlay,
        ...e == null ? void 0 : e.dragOverlay
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e == null ? void 0 : e.draggable, e == null ? void 0 : e.droppable, e == null ? void 0 : e.dragOverlay]
  );
}
function rde(e) {
  let {
    activeNode: t,
    measure: n,
    initialRect: o,
    config: s = !0
  } = e;
  const i = Ft(!1), {
    x: a,
    y: l
  } = typeof s == "boolean" ? {
    x: s,
    y: s
  } : s;
  os(() => {
    if (!a && !l || !t) {
      i.current = !1;
      return;
    }
    if (i.current || !o)
      return;
    const u = t == null ? void 0 : t.node.current;
    if (!u || u.isConnected === !1)
      return;
    const d = n(u), f = C$(d, o);
    if (a || (f.x = 0), l || (f.y = 0), i.current = !0, Math.abs(f.x) > 0 || Math.abs(f.y) > 0) {
      const p = w$(u);
      p && p.scrollBy({
        top: f.y,
        left: f.x
      });
    }
  }, [t, a, l, o, n]);
}
const N$ = /* @__PURE__ */ Ki({
  ...kr,
  scaleX: 1,
  scaleY: 1
});
var Bs;
(function(e) {
  e[e.Uninitialized = 0] = "Uninitialized", e[e.Initializing = 1] = "Initializing", e[e.Initialized = 2] = "Initialized";
})(Bs || (Bs = {}));
const $$ = /* @__PURE__ */ mF(function(t) {
  var n, o, s, i;
  let {
    id: a,
    accessibility: l,
    autoScroll: c = !0,
    children: u,
    sensors: d = Yue,
    collisionDetection: f = uue,
    measuring: p,
    modifiers: m,
    ...b
  } = t;
  const v = bF(ede, void 0, Jue), [g, y] = v, [w, x] = eue(), [S, T] = jt(Bs.Uninitialized), E = S === Bs.Initialized, {
    draggable: {
      active: O,
      nodes: M,
      translate: D
    },
    droppable: {
      containers: R
    }
  } = g, P = O != null ? M.get(O) : null, F = Ft({
    initial: null,
    translated: null
  }), $ = Ye(() => {
    var Ue;
    return O != null ? {
      id: O,
      // It's possible for the active node to unmount while dragging
      data: (Ue = P == null ? void 0 : P.data) != null ? Ue : Xue,
      rect: F
    } : null;
  }, [O, P]), N = Ft(null), [A, k] = jt(null), [L, B] = jt(null), V = ou(b, Object.values(b)), _ = Ku("DndDescribedBy", a), z = Ye(() => R.getEnabled(), [R]), j = ode(p), {
    droppableRects: W,
    measureDroppableContainers: J,
    measuringScheduled: G
  } = Lue(z, {
    dragging: E,
    dependencies: [D.x, D.y],
    config: j.droppable
  }), q = Aue(M, O), Z = Ye(() => L ? Qy(L) : null, [L]), Y = wt(), Q = _ue(q, j.draggable.measure);
  rde({
    activeNode: O != null ? M.get(O) : null,
    config: Y.layoutShiftCompensation,
    initialRect: Q,
    measure: j.draggable.measure
  });
  const ee = YR(q, j.draggable.measure, Q), ne = YR(q ? q.parentElement : null), H = Ft({
    activatorEvent: null,
    active: null,
    activeNode: q,
    collisionRect: null,
    collisions: null,
    droppableRects: W,
    draggableNodes: M,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers: R,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  }), U = R.getNodeFor((n = H.current.over) == null ? void 0 : n.id), X = Kue({
    measure: j.dragOverlay.measure
  }), re = (o = X.nodeRef.current) != null ? o : q, oe = E ? (s = X.rect) != null ? s : ee : null, le = !!(X.nodeRef.current && X.rect), se = zue(le ? null : ee), Ce = k$(re ? Lo(re) : null), $e = Hue(E ? U ?? q : null), we = Wue($e), Te = nde(m, {
    transform: {
      x: D.x - se.x,
      y: D.y - se.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent: L,
    active: $,
    activeNodeRect: ee,
    containerNodeRect: ne,
    draggingNodeRect: oe,
    over: H.current.over,
    overlayNodeRect: X.rect,
    scrollableAncestors: $e,
    scrollableAncestorRects: we,
    windowRect: Ce
  }), ue = Z ? Wa(Z, D) : null, de = jue($e), Pe = QR(de), ke = QR(de, [ee]), Me = Wa(Te, Pe), be = oe ? pue(oe, Te) : null, me = $ && be ? f({
    active: $,
    collisionRect: be,
    droppableRects: W,
    droppableContainers: z,
    pointerCoordinates: ue
  }) : null, Ae = aue(me, "id"), [ye, We] = jt(null), He = le ? Te : Wa(Te, ke), ze = due(He, (i = ye == null ? void 0 : ye.rect) != null ? i : null, ee), pe = Ft(null), Re = pt(
    (Ue, nt) => {
      let {
        sensor: ft,
        options: nn
      } = nt;
      if (N.current == null)
        return;
      const St = M.get(N.current);
      if (!St)
        return;
      const Ke = Ue.nativeEvent, Ot = new ft({
        active: N.current,
        activeNode: St,
        event: Ke,
        options: nn,
        // Sensors need to be instantiated with refs for arguments that change over time
        // otherwise they are frozen in time with the stale arguments
        context: H,
        onAbort(on) {
          if (!M.get(on))
            return;
          const {
            onDragAbort: ct
          } = V.current, Ut = {
            id: on
          };
          ct == null || ct(Ut), w({
            type: "onDragAbort",
            event: Ut
          });
        },
        onPending(on, Ze, ct, Ut) {
          if (!M.get(on))
            return;
          const {
            onDragPending: Fn
          } = V.current, Rn = {
            id: on,
            constraint: Ze,
            initialCoordinates: ct,
            offset: Ut
          };
          Fn == null || Fn(Rn), w({
            type: "onDragPending",
            event: Rn
          });
        },
        onStart(on) {
          const Ze = N.current;
          if (Ze == null)
            return;
          const ct = M.get(Ze);
          if (!ct)
            return;
          const {
            onDragStart: Ut
          } = V.current, xn = {
            activatorEvent: Ke,
            active: {
              id: Ze,
              data: ct.data,
              rect: F
            }
          };
          Ju(() => {
            Ut == null || Ut(xn), T(Bs.Initializing), y({
              type: Hn.DragStart,
              initialCoordinates: on,
              active: Ze
            }), w({
              type: "onDragStart",
              event: xn
            }), k(pe.current), B(Ke);
          });
        },
        onMove(on) {
          y({
            type: Hn.DragMove,
            coordinates: on
          });
        },
        onEnd: vn(Hn.DragEnd),
        onCancel: vn(Hn.DragCancel)
      });
      pe.current = Ot;
      function vn(on) {
        return async function() {
          const {
            active: ct,
            collisions: Ut,
            over: xn,
            scrollAdjustedTranslate: Fn
          } = H.current;
          let Rn = null;
          if (ct && Fn) {
            const {
              cancelDrop: Tn
            } = V.current;
            Rn = {
              activatorEvent: Ke,
              active: ct,
              collisions: Ut,
              delta: Fn,
              over: xn
            }, on === Hn.DragEnd && typeof Tn == "function" && await Promise.resolve(Tn(Rn)) && (on = Hn.DragCancel);
          }
          N.current = null, Ju(() => {
            y({
              type: on
            }), T(Bs.Uninitialized), We(null), k(null), B(null), pe.current = null;
            const Tn = on === Hn.DragEnd ? "onDragEnd" : "onDragCancel";
            if (Rn) {
              const an = V.current[Tn];
              an == null || an(Rn), w({
                type: Tn,
                event: Rn
              });
            }
          });
        };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [M]
  ), Ge = pt((Ue, nt) => (ft, nn) => {
    const St = ft.nativeEvent, Ke = M.get(nn);
    if (
      // Another sensor is already instantiating
      N.current !== null || // No active draggable
      !Ke || // Event has already been captured
      St.dndKit || St.defaultPrevented
    )
      return;
    const Ot = {
      active: Ke
    };
    Ue(ft, nt.options, Ot) === !0 && (St.dndKit = {
      capturedBy: nt.sensor
    }, N.current = nn, Re(ft, nt));
  }, [M, Re]), Qe = Fue(d, Ge);
  Gue(d), os(() => {
    ee && S === Bs.Initializing && T(Bs.Initialized);
  }, [ee, S]), Nt(
    () => {
      const {
        onDragMove: Ue
      } = V.current, {
        active: nt,
        activatorEvent: ft,
        collisions: nn,
        over: St
      } = H.current;
      if (!nt || !ft)
        return;
      const Ke = {
        active: nt,
        activatorEvent: ft,
        collisions: nn,
        delta: {
          x: Me.x,
          y: Me.y
        },
        over: St
      };
      Ju(() => {
        Ue == null || Ue(Ke), w({
          type: "onDragMove",
          event: Ke
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Me.x, Me.y]
  ), Nt(
    () => {
      const {
        active: Ue,
        activatorEvent: nt,
        collisions: ft,
        droppableContainers: nn,
        scrollAdjustedTranslate: St
      } = H.current;
      if (!Ue || N.current == null || !nt || !St)
        return;
      const {
        onDragOver: Ke
      } = V.current, Ot = nn.get(Ae), vn = Ot && Ot.rect.current ? {
        id: Ot.id,
        rect: Ot.rect.current,
        data: Ot.data,
        disabled: Ot.disabled
      } : null, on = {
        active: Ue,
        activatorEvent: nt,
        collisions: ft,
        delta: {
          x: St.x,
          y: St.y
        },
        over: vn
      };
      Ju(() => {
        We(vn), Ke == null || Ke(on), w({
          type: "onDragOver",
          event: on
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Ae]
  ), os(() => {
    H.current = {
      activatorEvent: L,
      active: $,
      activeNode: q,
      collisionRect: be,
      collisions: me,
      droppableRects: W,
      draggableNodes: M,
      draggingNode: re,
      draggingNodeRect: oe,
      droppableContainers: R,
      over: ye,
      scrollableAncestors: $e,
      scrollAdjustedTranslate: Me
    }, F.current = {
      initial: oe,
      translated: be
    };
  }, [$, q, me, be, M, re, oe, W, R, ye, $e, Me]), Due({
    ...Y,
    delta: D,
    draggingRect: be,
    pointerCoordinates: ue,
    scrollableAncestors: $e,
    scrollableAncestorRects: we
  });
  const qe = Ye(() => ({
    active: $,
    activeNode: q,
    activeNodeRect: ee,
    activatorEvent: L,
    collisions: me,
    containerNodeRect: ne,
    dragOverlay: X,
    draggableNodes: M,
    droppableContainers: R,
    droppableRects: W,
    over: ye,
    measureDroppableContainers: J,
    scrollableAncestors: $e,
    scrollableAncestorRects: we,
    measuringConfiguration: j,
    measuringScheduled: G,
    windowRect: Ce
  }), [$, q, ee, L, me, ne, X, M, R, W, ye, J, $e, we, j, G, Ce]), st = Ye(() => ({
    activatorEvent: L,
    activators: Qe,
    active: $,
    activeNodeRect: ee,
    ariaDescribedById: {
      draggable: _
    },
    dispatch: y,
    draggableNodes: M,
    over: ye,
    measureDroppableContainers: J
  }), [L, Qe, $, ee, y, _, M, ye, J]);
  return en.createElement(y$.Provider, {
    value: x
  }, en.createElement(ph.Provider, {
    value: st
  }, en.createElement(D$.Provider, {
    value: qe
  }, en.createElement(N$.Provider, {
    value: ze
  }, u)), en.createElement(tde, {
    disabled: (l == null ? void 0 : l.restoreFocus) === !1
  })), en.createElement(oue, {
    ...l,
    hiddenTextDescribedById: _
  }));
  function wt() {
    const Ue = (A == null ? void 0 : A.autoScrollEnabled) === !1, nt = typeof c == "object" ? c.enabled === !1 : c === !1, ft = E && !Ue && !nt;
    return typeof c == "object" ? {
      ...c,
      enabled: ft
    } : {
      enabled: ft
    };
  }
}), sde = /* @__PURE__ */ Ki(null), JR = "button", ide = "Draggable";
function A$(e) {
  let {
    id: t,
    data: n,
    disabled: o = !1,
    attributes: s
  } = e;
  const i = Ku(ide), {
    activators: a,
    activatorEvent: l,
    active: c,
    activeNodeRect: u,
    ariaDescribedById: d,
    draggableNodes: f,
    over: p
  } = Co(ph), {
    role: m = JR,
    roleDescription: b = "draggable",
    tabIndex: v = 0
  } = s ?? {}, g = (c == null ? void 0 : c.id) === t, y = Co(g ? N$ : sde), [w, x] = Xf(), [S, T] = Xf(), E = que(a, t), O = ou(n);
  os(
    () => (f.set(t, {
      id: t,
      key: i,
      node: w,
      activatorNode: S,
      data: O
    }), () => {
      const D = f.get(t);
      D && D.key === i && f.delete(t);
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [f, t]
  );
  const M = Ye(() => ({
    role: m,
    tabIndex: v,
    "aria-disabled": o,
    "aria-pressed": g && m === JR ? !0 : void 0,
    "aria-roledescription": b,
    "aria-describedby": d.draggable
  }), [o, m, v, g, b, d.draggable]);
  return {
    active: c,
    activatorEvent: l,
    activeNodeRect: u,
    attributes: M,
    isDragging: g,
    listeners: o ? void 0 : E,
    node: w,
    over: p,
    setNodeRef: x,
    setActivatorNodeRef: T,
    transform: y
  };
}
function ade() {
  return Co(D$);
}
const lde = "Droppable", cde = {
  timeout: 25
};
function ude(e) {
  let {
    data: t,
    disabled: n = !1,
    id: o,
    resizeObserverConfig: s
  } = e;
  const i = Ku(lde), {
    active: a,
    dispatch: l,
    over: c,
    measureDroppableContainers: u
  } = Co(ph), d = Ft({
    disabled: n
  }), f = Ft(!1), p = Ft(null), m = Ft(null), {
    disabled: b,
    updateMeasurementsFor: v,
    timeout: g
  } = {
    ...cde,
    ...s
  }, y = ou(v ?? o), w = pt(
    () => {
      if (!f.current) {
        f.current = !0;
        return;
      }
      m.current != null && clearTimeout(m.current), m.current = setTimeout(() => {
        u(Array.isArray(y.current) ? y.current : [y.current]), m.current = null;
      }, g);
    },
    //eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  ), x = fh({
    callback: w,
    disabled: b || !a
  }), S = pt((M, D) => {
    x && (D && (x.unobserve(D), f.current = !1), M && x.observe(M));
  }, [x]), [T, E] = Xf(S), O = ou(t);
  return Nt(() => {
    !x || !T.current || (x.disconnect(), f.current = !1, x.observe(T.current));
  }, [T, x]), Nt(
    () => (l({
      type: Hn.RegisterDroppable,
      element: {
        id: o,
        key: i,
        disabled: n,
        node: T,
        rect: p,
        data: O
      }
    }), () => l({
      type: Hn.UnregisterDroppable,
      key: i,
      id: o
    })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [o]
  ), Nt(() => {
    n !== d.current.disabled && (l({
      type: Hn.SetDroppableDisabled,
      id: o,
      key: i,
      disabled: n
    }), d.current.disabled = n);
  }, [o, i, n, l]), {
    active: a,
    rect: p,
    isOver: (c == null ? void 0 : c.id) === o,
    node: T,
    over: c,
    setNodeRef: E
  };
}
function dde(e, t, n) {
  const o = {
    ...e
  };
  return t.top + e.y <= n.top ? o.y = n.top - t.top : t.bottom + e.y >= n.top + n.height && (o.y = n.top + n.height - t.bottom), t.left + e.x <= n.left ? o.x = n.left - t.left : t.right + e.x >= n.left + n.width && (o.x = n.left + n.width - t.right), o;
}
const fde = (e) => {
  let {
    transform: t
  } = e;
  return {
    ...t,
    x: 0
  };
}, pde = (e) => {
  let {
    transform: t,
    draggingNodeRect: n,
    windowRect: o
  } = e;
  return !n || !o ? t : dde(t, n, o);
};
var Wg, eE;
function hde() {
  if (eE) return Wg;
  eE = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Wg = e, Wg;
}
var Ug, tE;
function hh() {
  if (tE) return Ug;
  tE = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return Ug = e, Ug;
}
var Kg, nE;
function gh() {
  if (nE) return Kg;
  nE = 1;
  var e = hh();
  function t(n, o) {
    for (var s = n.length; s--; )
      if (e(n[s][0], o))
        return s;
    return -1;
  }
  return Kg = t, Kg;
}
var Yg, oE;
function gde() {
  if (oE) return Yg;
  oE = 1;
  var e = gh(), t = Array.prototype, n = t.splice;
  function o(s) {
    var i = this.__data__, a = e(i, s);
    if (a < 0)
      return !1;
    var l = i.length - 1;
    return a == l ? i.pop() : n.call(i, a, 1), --this.size, !0;
  }
  return Yg = o, Yg;
}
var Xg, rE;
function mde() {
  if (rE) return Xg;
  rE = 1;
  var e = gh();
  function t(n) {
    var o = this.__data__, s = e(o, n);
    return s < 0 ? void 0 : o[s][1];
  }
  return Xg = t, Xg;
}
var Qg, sE;
function bde() {
  if (sE) return Qg;
  sE = 1;
  var e = gh();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return Qg = t, Qg;
}
var Zg, iE;
function yde() {
  if (iE) return Zg;
  iE = 1;
  var e = gh();
  function t(n, o) {
    var s = this.__data__, i = e(s, n);
    return i < 0 ? (++this.size, s.push([n, o])) : s[i][1] = o, this;
  }
  return Zg = t, Zg;
}
var Jg, aE;
function mh() {
  if (aE) return Jg;
  aE = 1;
  var e = hde(), t = gde(), n = mde(), o = bde(), s = yde();
  function i(a) {
    var l = -1, c = a == null ? 0 : a.length;
    for (this.clear(); ++l < c; ) {
      var u = a[l];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = o, i.prototype.set = s, Jg = i, Jg;
}
var em, lE;
function vde() {
  if (lE) return em;
  lE = 1;
  var e = mh();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return em = t, em;
}
var tm, cE;
function Cde() {
  if (cE) return tm;
  cE = 1;
  function e(t) {
    var n = this.__data__, o = n.delete(t);
    return this.size = n.size, o;
  }
  return tm = e, tm;
}
var nm, uE;
function wde() {
  if (uE) return nm;
  uE = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return nm = e, nm;
}
var om, dE;
function Sde() {
  if (dE) return om;
  dE = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return om = e, om;
}
var rm, fE;
function ks() {
  if (fE) return rm;
  fE = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return rm = e, rm;
}
var sm, pE;
function U0() {
  if (pE) return sm;
  pE = 1;
  var e = Cl(), t = ks(), n = "[object AsyncFunction]", o = "[object Function]", s = "[object GeneratorFunction]", i = "[object Proxy]";
  function a(l) {
    if (!t(l))
      return !1;
    var c = e(l);
    return c == o || c == s || c == n || c == i;
  }
  return sm = a, sm;
}
var im, hE;
function xde() {
  if (hE) return im;
  hE = 1;
  var e = ea(), t = e["__core-js_shared__"];
  return im = t, im;
}
var am, gE;
function Tde() {
  if (gE) return am;
  gE = 1;
  var e = xde(), t = function() {
    var o = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return o ? "Symbol(src)_1." + o : "";
  }();
  function n(o) {
    return !!t && t in o;
  }
  return am = n, am;
}
var lm, mE;
function Rde() {
  if (mE) return lm;
  mE = 1;
  var e = Function.prototype, t = e.toString;
  function n(o) {
    if (o != null) {
      try {
        return t.call(o);
      } catch {
      }
      try {
        return o + "";
      } catch {
      }
    }
    return "";
  }
  return lm = n, lm;
}
var cm, bE;
function Ede() {
  if (bE) return cm;
  bE = 1;
  var e = U0(), t = Tde(), n = ks(), o = Rde(), s = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, a = Function.prototype, l = Object.prototype, c = a.toString, u = l.hasOwnProperty, d = RegExp(
    "^" + c.call(u).replace(s, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(p) {
    if (!n(p) || t(p))
      return !1;
    var m = e(p) ? d : i;
    return m.test(o(p));
  }
  return cm = f, cm;
}
var um, yE;
function Ide() {
  if (yE) return um;
  yE = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return um = e, um;
}
var dm, vE;
function K0() {
  if (vE) return dm;
  vE = 1;
  var e = Ede(), t = Ide();
  function n(o, s) {
    var i = t(o, s);
    return e(i) ? i : void 0;
  }
  return dm = n, dm;
}
var fm, CE;
function F$() {
  if (CE) return fm;
  CE = 1;
  var e = K0(), t = ea(), n = e(t, "Map");
  return fm = n, fm;
}
var pm, wE;
function bh() {
  if (wE) return pm;
  wE = 1;
  var e = K0(), t = e(Object, "create");
  return pm = t, pm;
}
var hm, SE;
function Ode() {
  if (SE) return hm;
  SE = 1;
  var e = bh();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return hm = t, hm;
}
var gm, xE;
function Pde() {
  if (xE) return gm;
  xE = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return gm = e, gm;
}
var mm, TE;
function Mde() {
  if (TE) return mm;
  TE = 1;
  var e = bh(), t = "__lodash_hash_undefined__", n = Object.prototype, o = n.hasOwnProperty;
  function s(i) {
    var a = this.__data__;
    if (e) {
      var l = a[i];
      return l === t ? void 0 : l;
    }
    return o.call(a, i) ? a[i] : void 0;
  }
  return mm = s, mm;
}
var bm, RE;
function kde() {
  if (RE) return bm;
  RE = 1;
  var e = bh(), t = Object.prototype, n = t.hasOwnProperty;
  function o(s) {
    var i = this.__data__;
    return e ? i[s] !== void 0 : n.call(i, s);
  }
  return bm = o, bm;
}
var ym, EE;
function Dde() {
  if (EE) return ym;
  EE = 1;
  var e = bh(), t = "__lodash_hash_undefined__";
  function n(o, s) {
    var i = this.__data__;
    return this.size += this.has(o) ? 0 : 1, i[o] = e && s === void 0 ? t : s, this;
  }
  return ym = n, ym;
}
var vm, IE;
function Nde() {
  if (IE) return vm;
  IE = 1;
  var e = Ode(), t = Pde(), n = Mde(), o = kde(), s = Dde();
  function i(a) {
    var l = -1, c = a == null ? 0 : a.length;
    for (this.clear(); ++l < c; ) {
      var u = a[l];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = o, i.prototype.set = s, vm = i, vm;
}
var Cm, OE;
function $de() {
  if (OE) return Cm;
  OE = 1;
  var e = Nde(), t = mh(), n = F$();
  function o() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return Cm = o, Cm;
}
var wm, PE;
function Ade() {
  if (PE) return wm;
  PE = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return wm = e, wm;
}
var Sm, ME;
function yh() {
  if (ME) return Sm;
  ME = 1;
  var e = Ade();
  function t(n, o) {
    var s = n.__data__;
    return e(o) ? s[typeof o == "string" ? "string" : "hash"] : s.map;
  }
  return Sm = t, Sm;
}
var xm, kE;
function Fde() {
  if (kE) return xm;
  kE = 1;
  var e = yh();
  function t(n) {
    var o = e(this, n).delete(n);
    return this.size -= o ? 1 : 0, o;
  }
  return xm = t, xm;
}
var Tm, DE;
function Lde() {
  if (DE) return Tm;
  DE = 1;
  var e = yh();
  function t(n) {
    return e(this, n).get(n);
  }
  return Tm = t, Tm;
}
var Rm, NE;
function _de() {
  if (NE) return Rm;
  NE = 1;
  var e = yh();
  function t(n) {
    return e(this, n).has(n);
  }
  return Rm = t, Rm;
}
var Em, $E;
function Vde() {
  if ($E) return Em;
  $E = 1;
  var e = yh();
  function t(n, o) {
    var s = e(this, n), i = s.size;
    return s.set(n, o), this.size += s.size == i ? 0 : 1, this;
  }
  return Em = t, Em;
}
var Im, AE;
function Bde() {
  if (AE) return Im;
  AE = 1;
  var e = $de(), t = Fde(), n = Lde(), o = _de(), s = Vde();
  function i(a) {
    var l = -1, c = a == null ? 0 : a.length;
    for (this.clear(); ++l < c; ) {
      var u = a[l];
      this.set(u[0], u[1]);
    }
  }
  return i.prototype.clear = e, i.prototype.delete = t, i.prototype.get = n, i.prototype.has = o, i.prototype.set = s, Im = i, Im;
}
var Om, FE;
function zde() {
  if (FE) return Om;
  FE = 1;
  var e = mh(), t = F$(), n = Bde(), o = 200;
  function s(i, a) {
    var l = this.__data__;
    if (l instanceof e) {
      var c = l.__data__;
      if (!t || c.length < o - 1)
        return c.push([i, a]), this.size = ++l.size, this;
      l = this.__data__ = new n(c);
    }
    return l.set(i, a), this.size = l.size, this;
  }
  return Om = s, Om;
}
var Pm, LE;
function Hde() {
  if (LE) return Pm;
  LE = 1;
  var e = mh(), t = vde(), n = Cde(), o = wde(), s = Sde(), i = zde();
  function a(l) {
    var c = this.__data__ = new e(l);
    this.size = c.size;
  }
  return a.prototype.clear = t, a.prototype.delete = n, a.prototype.get = o, a.prototype.has = s, a.prototype.set = i, Pm = a, Pm;
}
var Mm, _E;
function L$() {
  if (_E) return Mm;
  _E = 1;
  var e = K0(), t = function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  }();
  return Mm = t, Mm;
}
var km, VE;
function Y0() {
  if (VE) return km;
  VE = 1;
  var e = L$();
  function t(n, o, s) {
    o == "__proto__" && e ? e(n, o, {
      configurable: !0,
      enumerable: !0,
      value: s,
      writable: !0
    }) : n[o] = s;
  }
  return km = t, km;
}
var Dm, BE;
function _$() {
  if (BE) return Dm;
  BE = 1;
  var e = Y0(), t = hh();
  function n(o, s, i) {
    (i !== void 0 && !t(o[s], i) || i === void 0 && !(s in o)) && e(o, s, i);
  }
  return Dm = n, Dm;
}
var Nm, zE;
function jde() {
  if (zE) return Nm;
  zE = 1;
  function e(t) {
    return function(n, o, s) {
      for (var i = -1, a = Object(n), l = s(n), c = l.length; c--; ) {
        var u = l[t ? c : ++i];
        if (o(a[u], u, a) === !1)
          break;
      }
      return n;
    };
  }
  return Nm = e, Nm;
}
var $m, HE;
function Gde() {
  if (HE) return $m;
  HE = 1;
  var e = jde(), t = e();
  return $m = t, $m;
}
var bc = { exports: {} };
bc.exports;
var jE;
function qde() {
  return jE || (jE = 1, function(e, t) {
    var n = ea(), o = t && !t.nodeType && t, s = o && !0 && e && !e.nodeType && e, i = s && s.exports === o, a = i ? n.Buffer : void 0, l = a ? a.allocUnsafe : void 0;
    function c(u, d) {
      if (d)
        return u.slice();
      var f = u.length, p = l ? l(f) : new u.constructor(f);
      return u.copy(p), p;
    }
    e.exports = c;
  }(bc, bc.exports)), bc.exports;
}
var Am, GE;
function Wde() {
  if (GE) return Am;
  GE = 1;
  var e = ea(), t = e.Uint8Array;
  return Am = t, Am;
}
var Fm, qE;
function Ude() {
  if (qE) return Fm;
  qE = 1;
  var e = Wde();
  function t(n) {
    var o = new n.constructor(n.byteLength);
    return new e(o).set(new e(n)), o;
  }
  return Fm = t, Fm;
}
var Lm, WE;
function Kde() {
  if (WE) return Lm;
  WE = 1;
  var e = Ude();
  function t(n, o) {
    var s = o ? e(n.buffer) : n.buffer;
    return new n.constructor(s, n.byteOffset, n.length);
  }
  return Lm = t, Lm;
}
var _m, UE;
function Yde() {
  if (UE) return _m;
  UE = 1;
  function e(t, n) {
    var o = -1, s = t.length;
    for (n || (n = Array(s)); ++o < s; )
      n[o] = t[o];
    return n;
  }
  return _m = e, _m;
}
var Vm, KE;
function Xde() {
  if (KE) return Vm;
  KE = 1;
  var e = ks(), t = Object.create, n = /* @__PURE__ */ function() {
    function o() {
    }
    return function(s) {
      if (!e(s))
        return {};
      if (t)
        return t(s);
      o.prototype = s;
      var i = new o();
      return o.prototype = void 0, i;
    };
  }();
  return Vm = n, Vm;
}
var Bm, YE;
function Qde() {
  if (YE) return Bm;
  YE = 1;
  function e(t, n) {
    return function(o) {
      return t(n(o));
    };
  }
  return Bm = e, Bm;
}
var zm, XE;
function V$() {
  if (XE) return zm;
  XE = 1;
  var e = Qde(), t = e(Object.getPrototypeOf, Object);
  return zm = t, zm;
}
var Hm, QE;
function B$() {
  if (QE) return Hm;
  QE = 1;
  var e = Object.prototype;
  function t(n) {
    var o = n && n.constructor, s = typeof o == "function" && o.prototype || e;
    return n === s;
  }
  return Hm = t, Hm;
}
var jm, ZE;
function Zde() {
  if (ZE) return jm;
  ZE = 1;
  var e = Xde(), t = V$(), n = B$();
  function o(s) {
    return typeof s.constructor == "function" && !n(s) ? e(t(s)) : {};
  }
  return jm = o, jm;
}
var Gm, JE;
function Jde() {
  if (JE) return Gm;
  JE = 1;
  var e = Cl(), t = ta(), n = "[object Arguments]";
  function o(s) {
    return t(s) && e(s) == n;
  }
  return Gm = o, Gm;
}
var qm, eI;
function z$() {
  if (eI) return qm;
  eI = 1;
  var e = Jde(), t = ta(), n = Object.prototype, o = n.hasOwnProperty, s = n.propertyIsEnumerable, i = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(a) {
    return t(a) && o.call(a, "callee") && !s.call(a, "callee");
  };
  return qm = i, qm;
}
var Wm, tI;
function H$() {
  if (tI) return Wm;
  tI = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return Wm = t, Wm;
}
var Um, nI;
function X0() {
  if (nI) return Um;
  nI = 1;
  var e = U0(), t = H$();
  function n(o) {
    return o != null && t(o.length) && !e(o);
  }
  return Um = n, Um;
}
var Km, oI;
function efe() {
  if (oI) return Km;
  oI = 1;
  var e = X0(), t = ta();
  function n(o) {
    return t(o) && e(o);
  }
  return Km = n, Km;
}
var yc = { exports: {} }, Ym, rI;
function tfe() {
  if (rI) return Ym;
  rI = 1;
  function e() {
    return !1;
  }
  return Ym = e, Ym;
}
yc.exports;
var sI;
function j$() {
  return sI || (sI = 1, function(e, t) {
    var n = ea(), o = tfe(), s = t && !t.nodeType && t, i = s && !0 && e && !e.nodeType && e, a = i && i.exports === s, l = a ? n.Buffer : void 0, c = l ? l.isBuffer : void 0, u = c || o;
    e.exports = u;
  }(yc, yc.exports)), yc.exports;
}
var Xm, iI;
function nfe() {
  if (iI) return Xm;
  iI = 1;
  var e = Cl(), t = V$(), n = ta(), o = "[object Object]", s = Function.prototype, i = Object.prototype, a = s.toString, l = i.hasOwnProperty, c = a.call(Object);
  function u(d) {
    if (!n(d) || e(d) != o)
      return !1;
    var f = t(d);
    if (f === null)
      return !0;
    var p = l.call(f, "constructor") && f.constructor;
    return typeof p == "function" && p instanceof p && a.call(p) == c;
  }
  return Xm = u, Xm;
}
var Qm, aI;
function ofe() {
  if (aI) return Qm;
  aI = 1;
  var e = Cl(), t = H$(), n = ta(), o = "[object Arguments]", s = "[object Array]", i = "[object Boolean]", a = "[object Date]", l = "[object Error]", c = "[object Function]", u = "[object Map]", d = "[object Number]", f = "[object Object]", p = "[object RegExp]", m = "[object Set]", b = "[object String]", v = "[object WeakMap]", g = "[object ArrayBuffer]", y = "[object DataView]", w = "[object Float32Array]", x = "[object Float64Array]", S = "[object Int8Array]", T = "[object Int16Array]", E = "[object Int32Array]", O = "[object Uint8Array]", M = "[object Uint8ClampedArray]", D = "[object Uint16Array]", R = "[object Uint32Array]", P = {};
  P[w] = P[x] = P[S] = P[T] = P[E] = P[O] = P[M] = P[D] = P[R] = !0, P[o] = P[s] = P[g] = P[i] = P[y] = P[a] = P[l] = P[c] = P[u] = P[d] = P[f] = P[p] = P[m] = P[b] = P[v] = !1;
  function F($) {
    return n($) && t($.length) && !!P[e($)];
  }
  return Qm = F, Qm;
}
var Zm, lI;
function rfe() {
  if (lI) return Zm;
  lI = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return Zm = e, Zm;
}
var vc = { exports: {} };
vc.exports;
var cI;
function sfe() {
  return cI || (cI = 1, function(e, t) {
    var n = zM(), o = t && !t.nodeType && t, s = o && !0 && e && !e.nodeType && e, i = s && s.exports === o, a = i && n.process, l = function() {
      try {
        var c = s && s.require && s.require("util").types;
        return c || a && a.binding && a.binding("util");
      } catch {
      }
    }();
    e.exports = l;
  }(vc, vc.exports)), vc.exports;
}
var Jm, uI;
function G$() {
  if (uI) return Jm;
  uI = 1;
  var e = ofe(), t = rfe(), n = sfe(), o = n && n.isTypedArray, s = o ? t(o) : e;
  return Jm = s, Jm;
}
var eb, dI;
function q$() {
  if (dI) return eb;
  dI = 1;
  function e(t, n) {
    if (!(n === "constructor" && typeof t[n] == "function") && n != "__proto__")
      return t[n];
  }
  return eb = e, eb;
}
var tb, fI;
function ife() {
  if (fI) return tb;
  fI = 1;
  var e = Y0(), t = hh(), n = Object.prototype, o = n.hasOwnProperty;
  function s(i, a, l) {
    var c = i[a];
    (!(o.call(i, a) && t(c, l)) || l === void 0 && !(a in i)) && e(i, a, l);
  }
  return tb = s, tb;
}
var nb, pI;
function afe() {
  if (pI) return nb;
  pI = 1;
  var e = ife(), t = Y0();
  function n(o, s, i, a) {
    var l = !i;
    i || (i = {});
    for (var c = -1, u = s.length; ++c < u; ) {
      var d = s[c], f = a ? a(i[d], o[d], d, i, o) : void 0;
      f === void 0 && (f = o[d]), l ? t(i, d, f) : e(i, d, f);
    }
    return i;
  }
  return nb = n, nb;
}
var ob, hI;
function lfe() {
  if (hI) return ob;
  hI = 1;
  function e(t, n) {
    for (var o = -1, s = Array(t); ++o < t; )
      s[o] = n(o);
    return s;
  }
  return ob = e, ob;
}
var rb, gI;
function W$() {
  if (gI) return rb;
  gI = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(o, s) {
    var i = typeof o;
    return s = s ?? e, !!s && (i == "number" || i != "symbol" && t.test(o)) && o > -1 && o % 1 == 0 && o < s;
  }
  return rb = n, rb;
}
var sb, mI;
function cfe() {
  if (mI) return sb;
  mI = 1;
  var e = lfe(), t = z$(), n = EC(), o = j$(), s = W$(), i = G$(), a = Object.prototype, l = a.hasOwnProperty;
  function c(u, d) {
    var f = n(u), p = !f && t(u), m = !f && !p && o(u), b = !f && !p && !m && i(u), v = f || p || m || b, g = v ? e(u.length, String) : [], y = g.length;
    for (var w in u)
      (d || l.call(u, w)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
      (w == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      m && (w == "offset" || w == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      b && (w == "buffer" || w == "byteLength" || w == "byteOffset") || // Skip index properties.
      s(w, y))) && g.push(w);
    return g;
  }
  return sb = c, sb;
}
var ib, bI;
function ufe() {
  if (bI) return ib;
  bI = 1;
  function e(t) {
    var n = [];
    if (t != null)
      for (var o in Object(t))
        n.push(o);
    return n;
  }
  return ib = e, ib;
}
var ab, yI;
function dfe() {
  if (yI) return ab;
  yI = 1;
  var e = ks(), t = B$(), n = ufe(), o = Object.prototype, s = o.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return n(a);
    var l = t(a), c = [];
    for (var u in a)
      u == "constructor" && (l || !s.call(a, u)) || c.push(u);
    return c;
  }
  return ab = i, ab;
}
var lb, vI;
function U$() {
  if (vI) return lb;
  vI = 1;
  var e = cfe(), t = dfe(), n = X0();
  function o(s) {
    return n(s) ? e(s, !0) : t(s);
  }
  return lb = o, lb;
}
var cb, CI;
function ffe() {
  if (CI) return cb;
  CI = 1;
  var e = afe(), t = U$();
  function n(o) {
    return e(o, t(o));
  }
  return cb = n, cb;
}
var ub, wI;
function pfe() {
  if (wI) return ub;
  wI = 1;
  var e = _$(), t = qde(), n = Kde(), o = Yde(), s = Zde(), i = z$(), a = EC(), l = efe(), c = j$(), u = U0(), d = ks(), f = nfe(), p = G$(), m = q$(), b = ffe();
  function v(g, y, w, x, S, T, E) {
    var O = m(g, w), M = m(y, w), D = E.get(M);
    if (D) {
      e(g, w, D);
      return;
    }
    var R = T ? T(O, M, w + "", g, y, E) : void 0, P = R === void 0;
    if (P) {
      var F = a(M), $ = !F && c(M), N = !F && !$ && p(M);
      R = M, F || $ || N ? a(O) ? R = O : l(O) ? R = o(O) : $ ? (P = !1, R = t(M, !0)) : N ? (P = !1, R = n(M, !0)) : R = [] : f(M) || i(M) ? (R = O, i(O) ? R = b(O) : (!d(O) || u(O)) && (R = s(M))) : P = !1;
    }
    P && (E.set(M, R), S(R, M, x, T, E), E.delete(M)), e(g, w, R);
  }
  return ub = v, ub;
}
var db, SI;
function hfe() {
  if (SI) return db;
  SI = 1;
  var e = Hde(), t = _$(), n = Gde(), o = pfe(), s = ks(), i = U$(), a = q$();
  function l(c, u, d, f, p) {
    c !== u && n(u, function(m, b) {
      if (p || (p = new e()), s(m))
        o(c, u, b, d, l, f, p);
      else {
        var v = f ? f(a(c, b), m, b + "", c, u, p) : void 0;
        v === void 0 && (v = m), t(c, b, v);
      }
    }, i);
  }
  return db = l, db;
}
var fb, xI;
function K$() {
  if (xI) return fb;
  xI = 1;
  function e(t) {
    return t;
  }
  return fb = e, fb;
}
var pb, TI;
function gfe() {
  if (TI) return pb;
  TI = 1;
  function e(t, n, o) {
    switch (o.length) {
      case 0:
        return t.call(n);
      case 1:
        return t.call(n, o[0]);
      case 2:
        return t.call(n, o[0], o[1]);
      case 3:
        return t.call(n, o[0], o[1], o[2]);
    }
    return t.apply(n, o);
  }
  return pb = e, pb;
}
var hb, RI;
function mfe() {
  if (RI) return hb;
  RI = 1;
  var e = gfe(), t = Math.max;
  function n(o, s, i) {
    return s = t(s === void 0 ? o.length - 1 : s, 0), function() {
      for (var a = arguments, l = -1, c = t(a.length - s, 0), u = Array(c); ++l < c; )
        u[l] = a[s + l];
      l = -1;
      for (var d = Array(s + 1); ++l < s; )
        d[l] = a[l];
      return d[s] = i(u), e(o, this, d);
    };
  }
  return hb = n, hb;
}
var gb, EI;
function bfe() {
  if (EI) return gb;
  EI = 1;
  function e(t) {
    return function() {
      return t;
    };
  }
  return gb = e, gb;
}
var mb, II;
function yfe() {
  if (II) return mb;
  II = 1;
  var e = bfe(), t = L$(), n = K$(), o = t ? function(s, i) {
    return t(s, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(i),
      writable: !0
    });
  } : n;
  return mb = o, mb;
}
var bb, OI;
function vfe() {
  if (OI) return bb;
  OI = 1;
  var e = 800, t = 16, n = Date.now;
  function o(s) {
    var i = 0, a = 0;
    return function() {
      var l = n(), c = t - (l - a);
      if (a = l, c > 0) {
        if (++i >= e)
          return arguments[0];
      } else
        i = 0;
      return s.apply(void 0, arguments);
    };
  }
  return bb = o, bb;
}
var yb, PI;
function Cfe() {
  if (PI) return yb;
  PI = 1;
  var e = yfe(), t = vfe(), n = t(e);
  return yb = n, yb;
}
var vb, MI;
function wfe() {
  if (MI) return vb;
  MI = 1;
  var e = K$(), t = mfe(), n = Cfe();
  function o(s, i) {
    return n(t(s, i, e), s + "");
  }
  return vb = o, vb;
}
var Cb, kI;
function Sfe() {
  if (kI) return Cb;
  kI = 1;
  var e = hh(), t = X0(), n = W$(), o = ks();
  function s(i, a, l) {
    if (!o(l))
      return !1;
    var c = typeof a;
    return (c == "number" ? t(l) && n(a, l.length) : c == "string" && a in l) ? e(l[a], i) : !1;
  }
  return Cb = s, Cb;
}
var wb, DI;
function xfe() {
  if (DI) return wb;
  DI = 1;
  var e = wfe(), t = Sfe();
  function n(o) {
    return e(function(s, i) {
      var a = -1, l = i.length, c = l > 1 ? i[l - 1] : void 0, u = l > 2 ? i[2] : void 0;
      for (c = o.length > 3 && typeof c == "function" ? (l--, c) : void 0, u && t(i[0], i[1], u) && (c = l < 3 ? void 0 : c, l = 1), s = Object(s); ++a < l; ) {
        var d = i[a];
        d && o(s, d, a, c);
      }
      return s;
    });
  }
  return wb = n, wb;
}
var Sb, NI;
function Tfe() {
  if (NI) return Sb;
  NI = 1;
  var e = hfe(), t = xfe(), n = t(function(o, s, i) {
    e(o, s, i);
  });
  return Sb = n, Sb;
}
var Rfe = Tfe();
const Efe = /* @__PURE__ */ Zo(Rfe), Ife = {
  defaultProps: {
    elevation: 0
  }
}, Ofe = {
  defaultProps: {},
  styleOverrides: {
    root: {
      // Removes the focus visible background added to the summary when focusing on an input
      // inside the summary
      backgroundColor: "transparent !important",
      padding: 0,
      width: "100%",
      position: "relative",
      "& .MuiAccordionSummary-expandIconWrapper": {
        position: "absolute",
        right: 10
      },
      "& .MuiAccordionSummary-content": {
        margin: 0
      }
    }
  }
}, Pfe = {
  defaultProps: {
    color: "default"
  },
  styleOverrides: {
    root: ({ theme: e }) => {
      var t;
      return {
        boxShadow: "none",
        borderBottom: `1px solid ${e.palette.divider}`,
        padding: e.spacing(0, 2),
        zIndex: e.zIndex.drawer + 1,
        height: (t = e.util) == null ? void 0 : t.customValues.navBarHeight,
        width: "100%"
      };
    }
  }
}, Mfe = {
  styleOverrides: {
    groupLabel: ({ theme: e }) => ({
      // don't add padding for "empty" group labels
      ":not(:empty)": {
        paddingTop: e.spacing(1),
        paddingBottom: e.spacing(1)
      }
    })
  }
}, kfe = {
  defaultProps: {
    variant: "outlined",
    disableElevation: !0
  },
  variants: [
    {
      props: { variant: "link" },
      style: {
        padding: 0,
        margin: 0,
        textDecoration: "underline",
        fontSize: "inherit",
        fontWeight: "inherit",
        lineHeight: "inherit",
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    },
    {
      props: { size: "xsmall" },
      style: ({ theme: e }) => ({
        padding: e.spacing(0.5)
      })
    },
    {
      props: { size: "xxsmall" },
      style: () => ({
        paddingTop: 0,
        paddingBottom: 0
      })
    }
  ],
  styleOverrides: {
    root: ({ theme: e, ownerState: t }) => ({
      textTransform: "inherit",
      fontSize: t.size === "large" ? e.typography.body1.fontSize : e.typography.body2.fontSize,
      padding: t.size === "large" ? e.spacing(1.25) : e.spacing(1)
    }),
    text: {
      textTransform: "inherit"
    },
    contained: ({ theme: e, ownerState: t }) => ({
      padding: `calc(${t.size === "large" ? e.spacing(1.25) : e.spacing(1)} + 1px)`
    })
  }
}, Dfe = {
  defaultProps: {
    color: "secondary"
  },
  styleOverrides: {}
}, Nfe = {
  defaultProps: {
    elevation: 0
  },
  styleOverrides: {
    root: ({ theme: e }) => ({
      boxSizing: "border-box",
      backgroundColor: e.palette.primary.background,
      width: "100%",
      borderRadius: e.shape.borderRadius,
      border: `1px solid ${e.palette.divider}`
    })
  }
}, $fe = {
  variants: [
    {
      props: { size: "small" },
      style: ({ theme: e }) => ({
        fontSize: e.typography.caption.fontSize,
        padding: 0
      })
    }
  ],
  styleOverrides: {
    root: ({ theme: e }) => ({
      borderRadius: e.shape.borderRadius,
      boxShadow: "none"
    })
  }
}, Afe = {
  defaultProps: {},
  styleOverrides: {
    paper: ({ theme: e }) => ({
      borderRadius: e.shape.borderRadius,
      // Remove background-image: var(--Paper-overlay) that dilutes colors
      // which is a problem in dark mode as paper is not white
      backgroundImage: "none"
    })
  }
}, Ffe = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme: e }) => ({
      paddingBottom: e.spacing(3),
      paddingRight: e.spacing(3),
      margin: 0
    })
  }
}, Lfe = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme: e }) => ({
      marginTop: e.spacing(2)
    })
  }
}, _fe = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme: e }) => ({
      color: e.palette.primary.contrastText,
      backgroundColor: e.palette.primary.main,
      borderColor: e.palette.divider
    })
  }
}, Vfe = {
  defaultProps: {
    variant: "outlined"
  },
  styleOverrides: {}
}, Bfe = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme: e }) => ({
      color: e.palette.text.secondary
    })
  }
}, zfe = {
  variants: [
    {
      props: { fontSize: "xxsmall" },
      style: ({ theme: e }) => ({
        fontSize: `${e.typography.body2.fontSize} !important`
      })
    },
    {
      props: { fontSize: "xsmall" },
      style: ({ theme: e }) => ({
        fontSize: `${e.typography.subtitle1.fontSize} !important`
      })
    },
    {
      props: { fontSize: "xlarge" },
      style: ({ theme: e }) => ({
        fontSize: `${e.typography.h1.fontSize} !important`
      })
    },
    {
      props: { fontSize: "xxlarge" },
      style: {
        fontSize: "100px !important"
      }
    }
  ],
  styleOverrides: {
    fontSizeInherit: () => ({
      fontSize: "inherit !important"
    }),
    fontSizeSmall: ({ theme: e }) => ({
      fontSize: `${e.typography.h6.fontSize} !important`
    })
  }
}, Hfe = {
  defaultProps: {
    variant: "outlined"
  },
  styleOverrides: {
    root: ({ theme: e, ownerState: t }) => {
      if (t.disabled || t.variant !== "filled")
        return !1;
      const n = {
        backgroundColor: Df(e, t.color),
        color: ik(e, t.color)
      };
      return {
        ...n,
        "&:hover": {
          ...n
        }
      };
    }
  }
}, jfe = {
  defaultProps: {
    dense: !1,
    disablePadding: !0
  },
  styleOverrides: {
    root: {
      padding: 0,
      paddingTop: 0,
      paddingBottom: 0,
      margin: 0,
      width: "100%"
    },
    padding: {
      padding: 0,
      margin: 0,
      paddingTop: 0,
      paddingBottom: 0
    }
  }
}, Gfe = {
  defaultProps: {},
  styleOverrides: {
    root: {
      color: "inherit"
    }
  }
}, qfe = {
  defaultProps: {},
  styleOverrides: {
    root: {},
    primary: ({ theme: e }) => ({
      fontSize: e.typography.body1.fontSize
    }),
    secondary: ({ theme: e }) => ({
      fontSize: e.typography.body2.fontSize
    })
  }
}, Wfe = {
  defaultProps: {},
  styleOverrides: {
    root: () => ({
      lineHeight: "1em"
    })
  }
}, Ufe = {
  defaultProps: {}
}, Kfe = {
  defaultProps: {},
  styleOverrides: {}
}, Yfe = {
  styleOverrides: {
    root: ({ theme: e, ownerState: t }) => {
      const n = t.color && e.palette[t.color] || void 0;
      return {
        backgroundColor: n == null ? void 0 : n.background,
        color: n == null ? void 0 : n.main,
        border: "none"
      };
    }
  }
}, Xfe = {
  defaultProps: {}
}, Qfe = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme: e, ownerState: t }) => ({
      color: t.color && Df(e, t.color) || e.palette.primary.main,
      gap: e.spacing(0.5)
    }),
    iconEmpty: ({ theme: e, ownerState: t }) => ({
      color: t.color && Df(e, t.color) || e.palette.primary.main
    })
  }
}, Zfe = {
  defaultProps: {
    MenuProps: {
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "left"
      }
    }
  },
  styleOverrides: {}
}, Jfe = {
  defaultProps: {},
  styleOverrides: {
    // This reverts a workaround from Mui which works well if the color has some alpha
    // but not if it's solid. Then again it works only with certain colors.
    // In dark mode, the divider is set to a solid color, so we do not need their workaround
    // which makes the border almost invisible. The undefined value is used to get the default
    // behavior.
    //
    // eslint-disable-next-line max-len
    // (https://github.com/mui/material-ui/blob/24e561c3156875fa3f7aca85e17a91c05a5fd28d/packages/material-ui/src/TableCell/TableCell.js#L17-L24)
    root: ({ theme: e }) => ({
      borderBottom: e.palette.mode === "dark" ? `1px solid ${e.palette.divider}` : void 0
    })
  }
}, epe = {
  defaultProps: {},
  styleOverrides: {
    root: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center"
    }
  }
}, tpe = {
  styleOverrides: {
    tooltip: ({ ownerState: e, theme: t }) => ({
      ...e.flipped === !0 && {
        backgroundColor: t.palette.background.paper,
        boxShadow: t.shadows[1],
        color: t.palette.text.primary
      }
    })
  }
}, npe = {
  defaultProps: {},
  styleOverrides: {}
}, ope = {
  MuiAutocomplete: Mfe,
  MuiButton: kfe,
  MuiButtonBase: Dfe,
  MuiDialog: Afe,
  MuiDialogActions: Ffe,
  MuiDialogContent: Lfe,
  MuiDialogTitle: _fe,
  MuiFormControl: Vfe,
  MuiIconButton: Hfe,
  MuiList: jfe,
  MuiListItem: Gfe,
  MuiListItemText: qfe,
  MuiListSubheader: Wfe,
  MuiOutlinedInput: Kfe,
  MuiSelect: Zfe,
  MuiToggleButton: lk,
  MuiTooltip: tpe,
  MuiFormHelperText: Bfe,
  MuiAppBar: Pfe,
  MuiToolbar: epe,
  MuiRating: Qfe,
  MuiPaper: Yfe,
  MuiIcon: zfe,
  MuiAccordion: Ife,
  MuiAccordionSummary: Ofe,
  MuiCard: Nfe,
  MuiPopper: Xfe,
  MuiModal: Ufe,
  MuiTypography: npe,
  MuiTableCell: Jfe,
  MuiChip: $fe
};
var $I = function(e, t, n) {
  if (n || arguments.length === 2) for (var o = 0, s = t.length, i; o < s; o++)
    (i || !(o in t)) && (i || (i = Array.prototype.slice.call(t, 0, o)), i[o] = t[o]);
  return e.concat(i || Array.prototype.slice.call(t));
}, rpe = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n, o) {
      this.name = t, this.version = n, this.os = o, this.type = "browser";
    }
    return e;
  }()
), spe = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t) {
      this.version = t, this.type = "node", this.name = "node", this.os = process.platform;
    }
    return e;
  }()
), ipe = (
  /** @class */
  /* @__PURE__ */ function() {
    function e(t, n, o, s) {
      this.name = t, this.version = n, this.os = o, this.bot = s, this.type = "bot-device";
    }
    return e;
  }()
), ape = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.type = "bot", this.bot = !0, this.name = "bot", this.version = null, this.os = null;
    }
    return e;
  }()
), lpe = (
  /** @class */
  /* @__PURE__ */ function() {
    function e() {
      this.type = "react-native", this.name = "react-native", this.version = null, this.os = null;
    }
    return e;
  }()
), cpe = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/, upe = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/, AI = 3, dpe = [
  ["aol", /AOLShield\/([0-9\._]+)/],
  ["edge", /Edge\/([0-9\._]+)/],
  ["edge-ios", /EdgiOS\/([0-9\._]+)/],
  ["yandexbrowser", /YaBrowser\/([0-9\._]+)/],
  ["kakaotalk", /KAKAOTALK\s([0-9\.]+)/],
  ["samsung", /SamsungBrowser\/([0-9\.]+)/],
  ["silk", /\bSilk\/([0-9._-]+)\b/],
  ["miui", /MiuiBrowser\/([0-9\.]+)$/],
  ["beaker", /BeakerBrowser\/([0-9\.]+)/],
  ["edge-chromium", /EdgA?\/([0-9\.]+)/],
  [
    "chromium-webview",
    /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
  ],
  ["chrome", /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
  ["phantomjs", /PhantomJS\/([0-9\.]+)(:?\s|$)/],
  ["crios", /CriOS\/([0-9\.]+)(:?\s|$)/],
  ["firefox", /Firefox\/([0-9\.]+)(?:\s|$)/],
  ["fxios", /FxiOS\/([0-9\.]+)/],
  ["opera-mini", /Opera Mini.*Version\/([0-9\.]+)/],
  ["opera", /Opera\/([0-9\.]+)(?:\s|$)/],
  ["opera", /OPR\/([0-9\.]+)(:?\s|$)/],
  ["pie", /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/],
  ["pie", /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/],
  ["netfront", /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/],
  ["ie", /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
  ["ie", /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
  ["ie", /MSIE\s(7\.0)/],
  ["bb10", /BB10;\sTouch.*Version\/([0-9\.]+)/],
  ["android", /Android\s([0-9\.]+)/],
  ["ios", /Version\/([0-9\._]+).*Mobile.*Safari.*/],
  ["safari", /Version\/([0-9\._]+).*Safari/],
  ["facebook", /FB[AS]V\/([0-9\.]+)/],
  ["instagram", /Instagram\s([0-9\.]+)/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Mobile/],
  ["ios-webview", /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
  ["curl", /^curl\/([0-9\.]+)$/],
  ["searchbot", cpe]
], FI = [
  ["iOS", /iP(hone|od|ad)/],
  ["Android OS", /Android/],
  ["BlackBerry OS", /BlackBerry|BB10/],
  ["Windows Mobile", /IEMobile/],
  ["Amazon OS", /Kindle/],
  ["Windows 3.11", /Win16/],
  ["Windows 95", /(Windows 95)|(Win95)|(Windows_95)/],
  ["Windows 98", /(Windows 98)|(Win98)/],
  ["Windows 2000", /(Windows NT 5.0)|(Windows 2000)/],
  ["Windows XP", /(Windows NT 5.1)|(Windows XP)/],
  ["Windows Server 2003", /(Windows NT 5.2)/],
  ["Windows Vista", /(Windows NT 6.0)/],
  ["Windows 7", /(Windows NT 6.1)/],
  ["Windows 8", /(Windows NT 6.2)/],
  ["Windows 8.1", /(Windows NT 6.3)/],
  ["Windows 10", /(Windows NT 10.0)/],
  ["Windows ME", /Windows ME/],
  ["Windows CE", /Windows CE|WinCE|Microsoft Pocket Internet Explorer/],
  ["Open BSD", /OpenBSD/],
  ["Sun OS", /SunOS/],
  ["Chrome OS", /CrOS/],
  ["Linux", /(Linux)|(X11)/],
  ["Mac OS", /(Mac_PowerPC)|(Macintosh)/],
  ["QNX", /QNX/],
  ["BeOS", /BeOS/],
  ["OS/2", /OS\/2/]
];
function fpe(e) {
  return typeof document > "u" && typeof navigator < "u" && navigator.product === "ReactNative" ? new lpe() : typeof navigator < "u" ? hpe(navigator.userAgent) : mpe();
}
function ppe(e) {
  return e !== "" && dpe.reduce(function(t, n) {
    var o = n[0], s = n[1];
    if (t)
      return t;
    var i = s.exec(e);
    return !!i && [o, i];
  }, !1);
}
function hpe(e) {
  var t = ppe(e);
  if (!t)
    return null;
  var n = t[0], o = t[1];
  if (n === "searchbot")
    return new ape();
  var s = o[1] && o[1].split(".").join("_").split("_").slice(0, 3);
  s ? s.length < AI && (s = $I($I([], s, !0), bpe(AI - s.length), !0)) : s = [];
  var i = s.join("."), a = gpe(e), l = upe.exec(e);
  return l && l[1] ? new ipe(n, i, a, l[1]) : new rpe(n, i, a);
}
function gpe(e) {
  for (var t = 0, n = FI.length; t < n; t++) {
    var o = FI[t], s = o[0], i = o[1], a = i.exec(e);
    if (a)
      return s;
  }
  return null;
}
function mpe() {
  var e = typeof process < "u" && process.version;
  return e ? new spe(process.version.slice(1)) : null;
}
function bpe(e) {
  for (var t = [], n = 0; n < e; n++)
    t.push("0");
  return t;
}
const $n = fpe(), ype = ($n == null ? void 0 : $n.name) === "ie", pCe = ($n == null ? void 0 : $n.name) === "edge", hCe = ($n == null ? void 0 : $n.name) === "safari", gCe = ($n == null ? void 0 : $n.name) === "firefox", mCe = ($n == null ? void 0 : $n.name) === "ios", vpe = ype, Cpe = ($n == null ? void 0 : $n.os) === "iOS", wpe = ($n == null ? void 0 : $n.os) === "Android OS", bCe = Cpe || wpe, yCe = () => ({
  innerWidth: window.innerWidth,
  innerHeight: window.innerHeight,
  screenWidth: window.screen.width,
  screenHeight: window.screen.height,
  screenAvailHeight: window.screen.availHeight,
  screenAvailWidth: window.screen.availWidth
}), Spe = {
  elements: {
    messagesHeader: "64pt",
    messagesFooter: "48pt",
    headerSizeSmall: 48,
    headerSizeLarge: 64,
    bannerHeight: 50,
    appTop: vpe ? 114 : 64,
    navigationSizeSmall: 48,
    navigationSizeLarge: 64
  }
}, $r = 0.07, xpe = 0.2, rn = "#FFFFFF", Lr = "#000000", La = "#3DA137", ds = "#63B35F", Dd = "#BAA432", Nd = "#C7B65B", fs = "#C27B55", Hr = "#B3332B", oc = "#C25B55", rc = "#7D231E", $d = {
  main: La,
  light: he(La, 0.15),
  dark: he(La, 0.2),
  contrastText: he(rn, 0.9),
  background: he(La, 0.07)
}, xb = {
  main: Dd,
  light: he(Dd, 0.15),
  dark: he(Dd, 0.2),
  contrastText: he(rn, 0.9),
  background: he(Dd, 0.07)
}, Ad = {
  main: Hr,
  light: he(Hr, 0.18),
  dark: he(Hr, 0.23),
  contrastText: he(rn, 0.9),
  background: he(Hr, 0.07)
}, Tb = {
  global: Lr,
  globalText: "#989DA3",
  local: "#101827",
  text: "#c6cad0",
  selectedText: "#E9EAEC",
  hover: "#273241"
}, Tpe = (e = "light") => {
  const t = e === "light", n = t ? $r : xpe, o = t ? rn : Lr;
  return {
    mode: e,
    primary: {
      main: "#4240D1",
      light: "#6766DA",
      dark: "#2E2C92",
      contrastText: he(rn, 0.9),
      background: he("#4240D1", t ? $r : 0.35)
    },
    secondary: t ? {
      main: "#050712",
      light: "#33343C",
      dark: "#000",
      contrastText: he(rn, 0.9),
      background: he("#050712", $r)
    } : {
      main: "#faf8ed",
      light: "#fff",
      dark: "#cccbc3",
      contrastText: he(Lr, 0.9),
      background: he("#faf8ed", 0.07)
    },
    error: {
      main: Hr,
      light: oc,
      dark: rc,
      contrastText: he(o, 0.9),
      background: he(Hr, n)
    },
    warning: {
      main: "#B35A2B",
      light: fs,
      dark: "#7D3E1E",
      contrastText: he(o, 0.9),
      background: he("#B35A2B", n)
    },
    success: {
      main: La,
      light: ds,
      dark: "#2A7026",
      contrastText: he(o, 0.9),
      background: he(La, n)
    },
    info: {
      main: "#2B7EB3",
      light: "#5597C2",
      dark: "#1E587D",
      contrastText: he(o, 0.9),
      background: he("#2B7EB3", n)
    },
    numa: {
      main: "#4536A1",
      light: "#6A5EB3",
      dark: "#302570",
      contrastText: he(rn, 0.9),
      background: he("#4536A1", t ? $r : 0.4)
    },
    highlight: {
      main: "#FD12D7",
      light: "#FA34DA",
      dark: "#D404B2",
      contrastText: he(rn, 0.9),
      background: he("#FD12D7", n)
    },
    customer: e === "light" ? {
      main: "#000000",
      light: "#333333",
      dark: "#000000",
      contrastText: he(rn, 0.9),
      background: he("#000000", $r)
    } : {
      main: "#FFFFFF",
      light: "#CCCCCC",
      dark: "#666666",
      contrastText: he(Lr, 0.9),
      background: he("#FFFFFF", 0.15)
    },
    user: {
      main: "#226CB3",
      light: "#4E89C2",
      dark: "#174B7D",
      contrastText: he(rn, 0.9),
      background: he(rn, t ? $r : 0.25)
    },
    appointment: {
      main: "#32BAB9",
      light: "#5BC7C7",
      dark: "#238281",
      contrastText: he(o, 0.9),
      background: he("#32BAB9", t ? $r : 0.4)
    },
    order: {
      main: "#7875C9",
      light: "#6A5EB3",
      dark: "#302570",
      contrastText: he(rn, 0.9),
      background: he("#7875C9", t ? $r : 0.25)
    },
    note: {
      main: "#E5BA1C",
      light: "#FFDD60",
      dark: "#B18D0B",
      contrastText: he(o, 0.9),
      background: he("#E5BA1C", 0.2)
    },
    task: {
      main: "#2B53B3",
      light: "#5575C2",
      dark: "#1E3A7D",
      contrastText: he(rn, 0.9),
      background: he("#2B53B3", t ? $r : 0.3)
    },
    phonecall: {
      main: "#2B70B3",
      light: "#558CC2",
      dark: "#1E4E7D",
      contrastText: he(rn, 0.9),
      background: he("#2B70B3", n)
    },
    payment: {
      main: "#064A22",
      light: "#376E4E",
      dark: "#043317",
      contrastText: he(rn, 0.9),
      background: he("#064A22", t ? $r : 0.3)
    },
    report: {
      main: "#B35A2B",
      light: "#C27B55",
      dark: "#7D3E1E",
      contrastText: he(o, 0.9),
      background: he("#B35A2B", n)
    },
    // Scale 0-10
    tenScale10: $d,
    tenScale9: $d,
    tenScale8: {
      main: ds,
      light: he(ds, 0.15),
      dark: he(ds, 0.2),
      contrastText: he(rn, 0.9),
      background: he(ds, n)
    },
    tenScale7: {
      main: Nd,
      light: he(Nd, 0.15),
      dark: he(Nd, 0.2),
      contrastText: he(rn, 0.9),
      background: he(Nd, n)
    },
    tenScale6: xb,
    tenScale5: {
      main: "#C29555",
      light: he("#C29555", 0.17),
      dark: he("#C29555", 0.22),
      contrastText: he(rn, 0.9),
      background: he("#C29555", n)
    },
    tenScale4: {
      main: fs,
      light: he(fs, 0.18),
      dark: he(fs, 0.23),
      contrastText: he(rn, 0.9),
      background: he(fs, n)
    },
    tenScale3: {
      main: oc,
      light: he(oc, 0.18),
      dark: he(oc, 0.23),
      contrastText: he(rn, 0.9),
      background: he(oc, n)
    },
    tenScale2: {
      main: Hr,
      light: he(Hr, 0.18),
      dark: he(Hr, 0.23),
      contrastText: he(rn, 0.9),
      background: he(Hr, n)
    },
    tenScale1: {
      ...Ad,
      light: he(rc, 0.22),
      dark: he(rc, 0.27)
    },
    tenScale0: {
      ...Ad,
      light: he(rc, 0.22),
      dark: he(rc, 0.27)
    },
    // Scale 1.0-5.0
    fiveScale5: $d,
    fiveScale4: {
      main: ds,
      light: he(ds, 0.15),
      dark: he(ds, 0.2),
      contrastText: he(rn, 0.9),
      background: he(ds, n)
    },
    fiveScale3: xb,
    fiveScale2: {
      main: fs,
      light: he(fs, 0.18),
      dark: he(fs, 0.23),
      contrastText: he(rn, 0.9),
      background: he(fs, n)
    },
    fiveScale1: Ad,
    // Scale
    good: $d,
    concern: xb,
    bad: Ad,
    divider: t ? he(Lr, 0.1) : "#27282D",
    background: {
      default: t ? rn : "#131219",
      paper: t ? rn : "#0E0E0F",
      brand: "#2D2BB3",
      dark: Lr
    },
    text: {
      primary: t ? wo(Lr, 0.1) : rn,
      secondary: he(t ? Lr : rn, 0.7),
      disabled: he(t ? Lr : rn, 0.25),
      hint: he(t ? Lr : rn, 0.5)
    },
    nav: t ? Tb : {
      ...Tb,
      local: "#0E0E0F",
      text: Tb.text,
      hover: "#1E1F23"
    }
  };
}, Rpe = {
  fontFamily: ["Inter", "sans-serif"].join(","),
  fontSize: 16,
  basefontSize: 16,
  // Base
  button: { fontSize: "1rem" },
  body1: { fontSize: "1rem" },
  // Smaller
  body2: { fontSize: "0.9rem" },
  caption: { fontSize: "0.85rem" },
  overline: { fontSize: "0.8rem" },
  // Larger
  subtitle1: { fontSize: "1.2rem" },
  subtitle2: { fontSize: "1.1rem" },
  // Headings
  h1: { fontSize: "2.5rem" },
  h2: { fontSize: "2rem" },
  h3: { fontSize: "1.75rem" },
  h4: { fontSize: "1.5rem" },
  h5: { fontSize: "1.25rem" },
  h6: { fontSize: "1.1rem" }
}, Epe = {
  narrow: 0.5,
  mid: 0.75,
  normal: 1.25,
  thick: 1.75,
  xThick: 2
}, Ipe = (e, t = 16) => `${e / t}rem`, Ope = (e) => {
  const t = Epe[e];
  return t ? `${t * 10}px` : void 0;
}, Ppe = {
  navBarHeight: "64px"
}, Mpe = {
  getSpacingByName: Ope,
  ptToRem: Ipe,
  customValues: Ppe
}, kpe = (e) => {
  const t = { ...e }, n = e.mode === "light" ? $o : wo, o = e.mode === "light" ? wo : $o;
  for (const [s, i] of Object.entries(e))
    if (i.main) {
      const a = s;
      t[a] = {
        main: i.contrastText,
        light: o(i.contrastText, 0.2),
        dark: n(i.contrastText, 0.2),
        background: he(i.contrastText, 0.07),
        contrastText: i.main
      };
    }
  return t;
}, Y$ = (e, t) => {
  const n = Tpe(e);
  return {
    palette: t ? kpe(n) : n,
    components: ope,
    typography: Rpe,
    spacing: 10,
    shape: {
      borderRadius: 3,
      borderRadiusBig: 10,
      borderRadiusHuge: 20,
      borderRadiusFull: "50%",
      borderRadiusNone: 0
    },
    layout: Spe,
    util: Mpe
  };
}, Dpe = (e, t, n = {}) => gl({
  ...Y$(e, t),
  ...n
}), Npe = (e, t, n = "light") => gl(Efe(Y$(n, t), e)), $pe = ({
  children: e,
  options: t,
  flipped: n,
  mode: o = "light"
}) => {
  const s = Ye(() => Dpe(o, !!n, t), [o, n, t]);
  return /* @__PURE__ */ C(Sv, { injectFirst: !0, children: /* @__PURE__ */ C($v, { theme: s, children: e }) });
}, Ape = ({ children: e }) => {
  const t = sn();
  return /* @__PURE__ */ C($pe, { mode: t.palette.mode === "light" ? "dark" : "light", children: e });
}, Fpe = ({
  id: e,
  isDraggable: t,
  children: n
}) => {
  const o = sn(), { attributes: s, listeners: i, setNodeRef: a, transform: l } = A$({
    id: `floater-${e}`
  });
  return /* @__PURE__ */ C(
    vt,
    {
      sx: {
        backgroundColor: he(o.palette.background.default, 0.93),
        borderRadius: 1,
        boxSizing: "border-box",
        boxShadow: o.shadows[3],
        backdropFilter: "blur(7px)",
        color: o.palette.text.primary,
        transform: t ? ul.Translate.toString(l) : void 0
      },
      ref: a,
      ...t ? i : {},
      ...t ? s : {},
      children: n
    }
  );
}, vCe = ({
  id: e,
  children: t,
  isDraggable: n = !0,
  placement: o = "top-left"
}) => {
  const s = v$(Jf(q0), Jf(W0)), i = sn(), [a, l] = jt({
    x: 0,
    y: 0
  });
  return /* @__PURE__ */ C(
    $$,
    {
      sensors: s,
      modifiers: [pde],
      onDragEnd: ({ delta: c }) => {
        n && l(({ x: u, y: d }) => ({
          x: u + c.x,
          y: d + c.y
        }));
      },
      children: /* @__PURE__ */ C(Ape, { children: /* @__PURE__ */ C(
        vt,
        {
          sx: {
            position: "absolute",
            zIndex: i.zIndex.drawer + 1,
            top: o.includes("top") ? 50 + a.y : "unset",
            left: o.includes("left") ? 50 + a.x : "unset",
            right: o.includes("right") ? 50 - a.x : "unset",
            bottom: o.includes("bottom") ? 50 - a.y : "unset"
          },
          children: /* @__PURE__ */ C(Fpe, { id: e, isDraggable: n, children: t })
        }
      ) })
    }
  );
}, CCe = (e) => /* @__PURE__ */ C(ml, { ...e }), wCe = ({ children: e, ...t }) => /* @__PURE__ */ C(bl, { ...t, children: e }), SCe = (e) => /* @__PURE__ */ C(qc, { ...e }), xCe = ({ children: e, ...t }) => /* @__PURE__ */ C(tC, { ...t, children: e }), TCe = ({ children: e, ...t }) => /* @__PURE__ */ C(_p, { ...t, children: e }), Lpe = {
  top: 50,
  bottom: 50,
  left: 50,
  right: 50
};
function As(e) {
  return function() {
    return e;
  };
}
const LI = Math.abs, to = Math.atan2, di = Math.cos, _pe = Math.max, Rb = Math.min, Ar = Math.sin, _a = Math.sqrt, To = 1e-12, su = Math.PI, tp = su / 2, Vpe = 2 * su;
function Bpe(e) {
  return e > 1 ? 0 : e < -1 ? su : Math.acos(e);
}
function _I(e) {
  return e >= 1 ? tp : e <= -1 ? -tp : Math.asin(e);
}
const tv = Math.PI, nv = 2 * tv, Ci = 1e-6, zpe = nv - Ci;
function X$(e) {
  this._ += e[0];
  for (let t = 1, n = e.length; t < n; ++t)
    this._ += arguments[t] + e[t];
}
function Hpe(e) {
  let t = Math.floor(e);
  if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
  if (t > 15) return X$;
  const n = 10 ** t;
  return function(o) {
    this._ += o[0];
    for (let s = 1, i = o.length; s < i; ++s)
      this._ += Math.round(arguments[s] * n) / n + o[s];
  };
}
class jpe {
  constructor(t) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = t == null ? X$ : Hpe(t);
  }
  moveTo(t, n) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(t, n) {
    this._append`L${this._x1 = +t},${this._y1 = +n}`;
  }
  quadraticCurveTo(t, n, o, s) {
    this._append`Q${+t},${+n},${this._x1 = +o},${this._y1 = +s}`;
  }
  bezierCurveTo(t, n, o, s, i, a) {
    this._append`C${+t},${+n},${+o},${+s},${this._x1 = +i},${this._y1 = +a}`;
  }
  arcTo(t, n, o, s, i) {
    if (t = +t, n = +n, o = +o, s = +s, i = +i, i < 0) throw new Error(`negative radius: ${i}`);
    let a = this._x1, l = this._y1, c = o - t, u = s - n, d = a - t, f = l - n, p = d * d + f * f;
    if (this._x1 === null)
      this._append`M${this._x1 = t},${this._y1 = n}`;
    else if (p > Ci) if (!(Math.abs(f * c - u * d) > Ci) || !i)
      this._append`L${this._x1 = t},${this._y1 = n}`;
    else {
      let m = o - a, b = s - l, v = c * c + u * u, g = m * m + b * b, y = Math.sqrt(v), w = Math.sqrt(p), x = i * Math.tan((tv - Math.acos((v + p - g) / (2 * y * w))) / 2), S = x / w, T = x / y;
      Math.abs(S - 1) > Ci && this._append`L${t + S * d},${n + S * f}`, this._append`A${i},${i},0,0,${+(f * m > d * b)},${this._x1 = t + T * c},${this._y1 = n + T * u}`;
    }
  }
  arc(t, n, o, s, i, a) {
    if (t = +t, n = +n, o = +o, a = !!a, o < 0) throw new Error(`negative radius: ${o}`);
    let l = o * Math.cos(s), c = o * Math.sin(s), u = t + l, d = n + c, f = 1 ^ a, p = a ? s - i : i - s;
    this._x1 === null ? this._append`M${u},${d}` : (Math.abs(this._x1 - u) > Ci || Math.abs(this._y1 - d) > Ci) && this._append`L${u},${d}`, o && (p < 0 && (p = p % nv + nv), p > zpe ? this._append`A${o},${o},0,1,${f},${t - l},${n - c}A${o},${o},0,1,${f},${this._x1 = u},${this._y1 = d}` : p > Ci && this._append`A${o},${o},0,${+(p >= tv)},${f},${this._x1 = t + o * Math.cos(i)},${this._y1 = n + o * Math.sin(i)}`);
  }
  rect(t, n, o, s) {
    this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +n}h${o = +o}v${+s}h${-o}Z`;
  }
  toString() {
    return this._;
  }
}
function Gpe(e) {
  let t = 3;
  return e.digits = function(n) {
    if (!arguments.length) return t;
    if (n == null)
      t = null;
    else {
      const o = Math.floor(n);
      if (!(o >= 0)) throw new RangeError(`invalid digits: ${n}`);
      t = o;
    }
    return e;
  }, () => new jpe(t);
}
function qpe(e) {
  return e.innerRadius;
}
function Wpe(e) {
  return e.outerRadius;
}
function Upe(e) {
  return e.startAngle;
}
function Kpe(e) {
  return e.endAngle;
}
function Ype(e) {
  return e && e.padAngle;
}
function Xpe(e, t, n, o, s, i, a, l) {
  var c = n - e, u = o - t, d = a - s, f = l - i, p = f * c - d * u;
  if (!(p * p < To))
    return p = (d * (t - i) - f * (e - s)) / p, [e + p * c, t + p * u];
}
function Fd(e, t, n, o, s, i, a) {
  var l = e - n, c = t - o, u = (a ? i : -i) / _a(l * l + c * c), d = u * c, f = -u * l, p = e + d, m = t + f, b = n + d, v = o + f, g = (p + b) / 2, y = (m + v) / 2, w = b - p, x = v - m, S = w * w + x * x, T = s - i, E = p * v - b * m, O = (x < 0 ? -1 : 1) * _a(_pe(0, T * T * S - E * E)), M = (E * x - w * O) / S, D = (-E * w - x * O) / S, R = (E * x + w * O) / S, P = (-E * w + x * O) / S, F = M - g, $ = D - y, N = R - g, A = P - y;
  return F * F + $ * $ > N * N + A * A && (M = R, D = P), {
    cx: M,
    cy: D,
    x01: -d,
    y01: -f,
    x11: M * (s / T - 1),
    y11: D * (s / T - 1)
  };
}
function Q$() {
  var e = qpe, t = Wpe, n = As(0), o = null, s = Upe, i = Kpe, a = Ype, l = null, c = Gpe(u);
  function u() {
    var d, f, p = +e.apply(this, arguments), m = +t.apply(this, arguments), b = s.apply(this, arguments) - tp, v = i.apply(this, arguments) - tp, g = LI(v - b), y = v > b;
    if (l || (l = d = c()), m < p && (f = m, m = p, p = f), !(m > To)) l.moveTo(0, 0);
    else if (g > Vpe - To)
      l.moveTo(m * di(b), m * Ar(b)), l.arc(0, 0, m, b, v, !y), p > To && (l.moveTo(p * di(v), p * Ar(v)), l.arc(0, 0, p, v, b, y));
    else {
      var w = b, x = v, S = b, T = v, E = g, O = g, M = a.apply(this, arguments) / 2, D = M > To && (o ? +o.apply(this, arguments) : _a(p * p + m * m)), R = Rb(LI(m - p) / 2, +n.apply(this, arguments)), P = R, F = R, $, N;
      if (D > To) {
        var A = _I(D / p * Ar(M)), k = _I(D / m * Ar(M));
        (E -= A * 2) > To ? (A *= y ? 1 : -1, S += A, T -= A) : (E = 0, S = T = (b + v) / 2), (O -= k * 2) > To ? (k *= y ? 1 : -1, w += k, x -= k) : (O = 0, w = x = (b + v) / 2);
      }
      var L = m * di(w), B = m * Ar(w), V = p * di(T), _ = p * Ar(T);
      if (R > To) {
        var z = m * di(x), j = m * Ar(x), W = p * di(S), J = p * Ar(S), G;
        if (g < su)
          if (G = Xpe(L, B, W, J, z, j, V, _)) {
            var q = L - G[0], Z = B - G[1], Y = z - G[0], Q = j - G[1], ee = 1 / Ar(Bpe((q * Y + Z * Q) / (_a(q * q + Z * Z) * _a(Y * Y + Q * Q))) / 2), ne = _a(G[0] * G[0] + G[1] * G[1]);
            P = Rb(R, (p - ne) / (ee - 1)), F = Rb(R, (m - ne) / (ee + 1));
          } else
            P = F = 0;
      }
      O > To ? F > To ? ($ = Fd(W, J, L, B, m, F, y), N = Fd(z, j, V, _, m, F, y), l.moveTo($.cx + $.x01, $.cy + $.y01), F < R ? l.arc($.cx, $.cy, F, to($.y01, $.x01), to(N.y01, N.x01), !y) : (l.arc($.cx, $.cy, F, to($.y01, $.x01), to($.y11, $.x11), !y), l.arc(0, 0, m, to($.cy + $.y11, $.cx + $.x11), to(N.cy + N.y11, N.cx + N.x11), !y), l.arc(N.cx, N.cy, F, to(N.y11, N.x11), to(N.y01, N.x01), !y))) : (l.moveTo(L, B), l.arc(0, 0, m, w, x, !y)) : l.moveTo(L, B), !(p > To) || !(E > To) ? l.lineTo(V, _) : P > To ? ($ = Fd(V, _, z, j, p, -P, y), N = Fd(L, B, W, J, p, -P, y), l.lineTo($.cx + $.x01, $.cy + $.y01), P < R ? l.arc($.cx, $.cy, P, to($.y01, $.x01), to(N.y01, N.x01), !y) : (l.arc($.cx, $.cy, P, to($.y01, $.x01), to($.y11, $.x11), !y), l.arc(0, 0, p, to($.cy + $.y11, $.cx + $.x11), to(N.cy + N.y11, N.cx + N.x11), y), l.arc(N.cx, N.cy, P, to(N.y11, N.x11), to(N.y01, N.x01), !y))) : l.arc(0, 0, p, T, S, y);
    }
    if (l.closePath(), d) return l = null, d + "" || null;
  }
  return u.centroid = function() {
    var d = (+e.apply(this, arguments) + +t.apply(this, arguments)) / 2, f = (+s.apply(this, arguments) + +i.apply(this, arguments)) / 2 - su / 2;
    return [di(f) * d, Ar(f) * d];
  }, u.innerRadius = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : As(+d), u) : e;
  }, u.outerRadius = function(d) {
    return arguments.length ? (t = typeof d == "function" ? d : As(+d), u) : t;
  }, u.cornerRadius = function(d) {
    return arguments.length ? (n = typeof d == "function" ? d : As(+d), u) : n;
  }, u.padRadius = function(d) {
    return arguments.length ? (o = d == null ? null : typeof d == "function" ? d : As(+d), u) : o;
  }, u.startAngle = function(d) {
    return arguments.length ? (s = typeof d == "function" ? d : As(+d), u) : s;
  }, u.endAngle = function(d) {
    return arguments.length ? (i = typeof d == "function" ? d : As(+d), u) : i;
  }, u.padAngle = function(d) {
    return arguments.length ? (a = typeof d == "function" ? d : As(+d), u) : a;
  }, u.context = function(d) {
    return arguments.length ? (l = d ?? null, u) : l;
  }, u;
}
let VI = 0;
function Qpe(e) {
  const [t, n] = h.useState(e), o = t;
  return h.useEffect(() => {
    t == null && (VI += 1, n(`mui-${VI}`));
  }, [t]), o;
}
const Zpe = {
  ...h
}, BI = Zpe.useId;
function Jpe(e) {
  return BI !== void 0 ? BI() : Qpe(e);
}
const ehe = (e, t, n) => {
  const o = I({}, Lpe, n);
  return h.useMemo(() => ({
    left: o.left,
    top: o.top,
    right: o.right,
    bottom: o.bottom,
    width: Math.max(0, e - o.left - o.right),
    height: Math.max(0, t - o.top - o.bottom)
  }), [e, t, o.top, o.bottom, o.left, o.right]);
}, Q0 = /* @__PURE__ */ h.createContext({
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  height: 300,
  width: 400,
  chartId: "",
  isPointInside: () => !1
});
process.env.NODE_ENV !== "production" && (Q0.displayName = "DrawingContext");
const Z0 = /* @__PURE__ */ h.createContext({
  isInitialized: !1,
  data: {
    current: null
  }
});
process.env.NODE_ENV !== "production" && (Z0.displayName = "SvgContext");
function the(e) {
  const {
    width: t,
    height: n,
    margin: o,
    svgRef: s,
    children: i
  } = e, a = ehe(t, n, o), l = Jpe(), c = h.useCallback(({
    x: f,
    y: p
  }, m) => {
    if (m != null && m.targetElement && (m != null && m.targetElement.closest("[data-drawing-container]")))
      return !0;
    const b = f >= a.left - 1 && f <= a.left + a.width, v = p >= a.top - 1 && p <= a.top + a.height;
    return (m == null ? void 0 : m.direction) === "x" ? b : ((m == null ? void 0 : m.direction) === "y" || b) && v;
  }, [a]), u = h.useMemo(() => I({
    chartId: l ?? ""
  }, a, {
    isPointInside: c
  }), [l, a, c]), d = h.useMemo(() => ({
    isInitialized: !0,
    data: s
  }), [s]);
  return /* @__PURE__ */ C(Z0.Provider, {
    value: d,
    children: /* @__PURE__ */ C(Q0.Provider, {
      value: u,
      children: i
    })
  });
}
function Z$() {
  const {
    left: e,
    top: t,
    width: n,
    height: o,
    bottom: s,
    right: i,
    isPointInside: a
  } = h.useContext(Q0);
  return h.useMemo(() => ({
    left: e,
    top: t,
    width: n,
    height: o,
    bottom: s,
    right: i,
    isPointInside: a
  }), [o, e, t, n, s, i, a]);
}
function nhe(e) {
  return e.bandwidth !== void 0;
}
const J$ = /* @__PURE__ */ h.createContext({
  isInitialized: !1,
  data: {
    xAxis: {},
    yAxis: {},
    xAxisIds: [],
    yAxisIds: []
  }
});
process.env.NODE_ENV !== "production" && (J$.displayName = "CartesianContext");
const ohe = () => {
  const {
    data: e
  } = h.useContext(J$);
  return e;
};
function rhe() {
  const {
    isInitialized: e,
    data: t
  } = h.useContext(Z0);
  if (!e)
    throw new Error(["MUI X: Could not find the svg ref context.", "It looks like you rendered your component outside of a ChartsContainer parent component."].join(`
`));
  return t;
}
function she(e, t, n = void 0) {
  const o = {};
  for (const s in e) {
    const i = e[s];
    let a = "", l = !0;
    for (let c = 0; c < i.length; c += 1) {
      const u = i[c];
      u && (a += (l === !0 ? "" : " ") + t(u), l = !1, n && n[u] && (a += " " + n[u]));
    }
    o[s] = a;
  }
  return o;
}
const zI = (e) => e, ihe = () => {
  let e = zI;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = zI;
    }
  };
}, ahe = ihe(), lhe = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function eA(e, t, n = "Mui") {
  const o = lhe[t];
  return o ? `${n}-${o}` : `${ahe.generate(e)}-${t}`;
}
function che(e, t, n = "Mui") {
  const o = {};
  return t.forEach((s) => {
    o[s] = eA(e, s, n);
  }), o;
}
function uhe() {
  return typeof window > "u";
}
const fi = {
  widthCache: {},
  cacheCount: 0
}, dhe = 2e3, fhe = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, phe = ["minWidth", "maxWidth", "width", "minHeight", "maxHeight", "height", "top", "left", "fontSize", "padding", "margin", "paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom"], HI = "mui_measurement_span";
function tA(e, t) {
  return phe.indexOf(e) >= 0 && t === +t ? `${t}px` : t;
}
function nA(e) {
  return e.split("").reduce((o, s) => s === s.toUpperCase() ? [...o, "-", s.toLowerCase()] : [...o, s], []).join("");
}
const hhe = (e) => Object.keys(e).sort().reduce((t, n) => `${t}${nA(n)}:${tA(n, e[n])};`, "");
let Eb;
const ghe = (e, t = {}) => {
  if (e == null || uhe())
    return {
      width: 0,
      height: 0
    };
  const n = `${e}`, o = hhe(t), s = `${n}-${o}`;
  if (fi.widthCache[s])
    return fi.widthCache[s];
  try {
    let i = document.getElementById(HI);
    i === null && (i = document.createElement("span"), i.setAttribute("id", HI), i.setAttribute("aria-hidden", "true"), document.body.appendChild(i));
    const a = I({}, fhe, t);
    Object.keys(a).map((u) => (i.style[nA(u)] = tA(u, a[u]), u)), i.textContent = n;
    const l = i.getBoundingClientRect(), c = {
      width: l.width,
      height: l.height
    };
    return fi.widthCache[s] = c, fi.cacheCount + 1 > dhe ? (fi.cacheCount = 0, fi.widthCache = {}) : fi.cacheCount += 1, Eb && clearTimeout(Eb), Eb = setTimeout(() => {
      i.textContent = "";
    }, 0), c;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
};
function mhe({
  style: e,
  needsComputation: t,
  text: n
}) {
  return n.split(`
`).map((o) => I({
    text: o
  }, t ? ghe(o, e) : {
    width: 0,
    height: 0
  }));
}
const bhe = ["x", "y", "style", "text", "ownerState"], yhe = ["angle", "textAnchor", "dominantBaseline"];
function oA(e) {
  const {
    x: t,
    y: n,
    style: o,
    text: s
  } = e, i = ve(e, bhe), a = o ?? {}, {
    angle: l,
    textAnchor: c,
    dominantBaseline: u
  } = a, d = ve(a, yhe), f = h.useMemo(() => mhe({
    style: d,
    needsComputation: s.includes(`
`),
    text: s
  }), [d, s]);
  let p;
  switch (u) {
    case "hanging":
      p = 0;
      break;
    case "central":
      p = (f.length - 1) / 2 * -f[0].height;
      break;
    default:
      p = (f.length - 1) * -f[0].height;
      break;
  }
  const m = [];
  return l && m.push(`rotate(${l}, ${t}, ${n})`), /* @__PURE__ */ C("text", I({}, i, {
    transform: m.length > 0 ? m.join(" ") : void 0,
    x: t,
    y: n,
    textAnchor: c,
    dominantBaseline: u,
    style: d,
    children: f.map((b, v) => /* @__PURE__ */ C("tspan", {
      x: t,
      dy: `${v === 0 ? p : f[0].height}px`,
      dominantBaseline: u,
      children: b.text
    }, v))
  }));
}
process.env.NODE_ENV !== "production" && (oA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Height of a text line (in `em`).
   */
  lineHeight: r.number,
  /**
   * If `true`, the line width is computed.
   * @default false
   */
  needsComputation: r.bool,
  ownerState: r.any,
  /**
   * Style applied to text elements.
   */
  style: r.object,
  /**
   * Text displayed.
   */
  text: r.string.isRequired
});
function vhe(...e) {
  const t = h.useRef(void 0), n = h.useCallback((o) => {
    const s = e.map((i) => {
      if (i == null)
        return null;
      if (typeof i == "function") {
        const a = i, l = a(o);
        return typeof l == "function" ? l : () => {
          a(null);
        };
      }
      return i.current = o, () => {
        i.current = null;
      };
    });
    return () => {
      s.forEach((i) => i == null ? void 0 : i());
    };
  }, e);
  return h.useMemo(() => e.every((o) => o == null) ? null : (o) => {
    t.current && (t.current(), t.current = void 0), o != null && (t.current = n(o));
  }, e);
}
function Che(e) {
  return e && e.ownerDocument || document;
}
function whe(e) {
  return Che(e).defaultView || window;
}
const jI = typeof window < "u" ? h.useLayoutEffect : h.useEffect, rA = /* @__PURE__ */ h.createContext({
  item: null,
  axis: {
    x: null,
    y: null
  },
  useVoronoiInteraction: !1,
  dispatch: () => null
});
process.env.NODE_ENV !== "production" && (rA.displayName = "InteractionContext");
function sc(e, t) {
  if (typeof e == "number")
    return e;
  if (e === "100%")
    return t;
  if (e.endsWith("%")) {
    const n = Number.parseFloat(e.slice(0, e.length - 1));
    if (!Number.isNaN(n))
      return n * t / 100;
  }
  if (e.endsWith("px")) {
    const n = Number.parseFloat(e.slice(0, e.length - 2));
    if (!Number.isNaN(n))
      return n;
  }
  throw new Error(`MUI X: Received an unknown value "${e}". It should be a number, or a string with a percentage value.`);
}
function She(e, t) {
  const n = e.createSVGPoint();
  return n.x = t.clientX, n.y = t.clientY, n.matrixTransform(e.getScreenCTM().inverse());
}
function va(e) {
  return e instanceof Date ? e.getTime() : e;
}
const xhe = (e) => {
  const t = rhe(), n = Z$(), {
    xAxis: o,
    yAxis: s,
    xAxisIds: i,
    yAxisIds: a
  } = ohe(), {
    dispatch: l
  } = h.useContext(rA), c = i[0], u = a[0], d = h.useRef({
    isInChart: !1,
    x: -1,
    y: -1
  });
  h.useEffect(() => {
    const f = t.current;
    if (f === null || e)
      return () => {
      };
    function p(g, y) {
      const {
        scale: w,
        data: x,
        reverse: S
      } = g;
      if (!nhe(w)) {
        const E = w.invert(y);
        if (x === void 0)
          return {
            value: E,
            index: -1
          };
        const O = va(E), M = x == null ? void 0 : x.findIndex((D, R) => {
          const P = va(D);
          return P > O && (R === 0 || Math.abs(O - P) <= Math.abs(O - va(x[R - 1]))) || P <= O && (R === x.length - 1 || Math.abs(va(E) - P) < Math.abs(va(E) - va(x[R + 1])));
        });
        return {
          value: M !== void 0 && M >= 0 ? x[M] : E,
          index: M
        };
      }
      const T = w.bandwidth() === 0 ? Math.floor((y - Math.min(...w.range()) + w.step() / 2) / w.step()) : Math.floor((y - Math.min(...w.range())) / w.step());
      if (T < 0 || T >= x.length)
        return null;
      if (S) {
        const E = x.length - 1 - T;
        return {
          index: E,
          value: x[E]
        };
      }
      return {
        index: T,
        value: x[T]
      };
    }
    const m = () => {
      d.current = {
        isInChart: !1,
        x: -1,
        y: -1
      }, l({
        type: "exitChart"
      });
    }, b = (g) => {
      const y = "targetTouches" in g ? g.targetTouches[0] : g, w = She(f, y);
      if (d.current.x = w.x, d.current.y = w.y, !n.isPointInside(w, {
        targetElement: g.target
      })) {
        d.current.isInChart && (l({
          type: "exitChart"
        }), d.current.isInChart = !1);
        return;
      }
      d.current.isInChart = !0;
      const x = p(o[c], w.x), S = p(s[u], w.y);
      l({
        type: "updateAxis",
        data: {
          x,
          y: S
        }
      });
    }, v = (g) => {
      const y = g.currentTarget;
      y && y.hasPointerCapture(g.pointerId) && y.releasePointerCapture(g.pointerId);
    };
    return f.addEventListener("pointerdown", v), f.addEventListener("pointermove", b), f.addEventListener("pointerout", m), f.addEventListener("pointercancel", m), f.addEventListener("pointerleave", m), () => {
      f.removeEventListener("pointerdown", v), f.removeEventListener("pointermove", b), f.removeEventListener("pointerout", m), f.removeEventListener("pointercancel", m), f.removeEventListener("pointerleave", m);
    };
  }, [t, l, u, s, c, o, e, n]);
}, The = ["children", "width", "height", "viewBox", "disableAxisListener", "className", "title", "desc"], Rhe = te("svg", {
  name: "MuiChartsSurface",
  slot: "Root"
})(() => ({
  // This prevents default touch actions when using the svg on mobile devices.
  // For example, prevent page scroll & zoom.
  touchAction: "none"
})), sA = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const o = Et({
    props: t,
    name: "MuiChartsSurface"
  }), {
    children: s,
    width: i,
    height: a,
    viewBox: l,
    disableAxisListener: c = !1,
    className: u,
    title: d,
    desc: f
  } = o, p = ve(o, The), m = I({
    width: i,
    height: a,
    x: 0,
    y: 0
  }, l);
  return xhe(c), /* @__PURE__ */ ie(Rhe, I({
    width: i,
    height: a,
    viewBox: `${m.x} ${m.y} ${m.width} ${m.height}`,
    ref: n,
    className: u
  }, p, {
    children: [/* @__PURE__ */ C("title", {
      children: d
    }), /* @__PURE__ */ C("desc", {
      children: f
    }), s]
  }));
});
process.env.NODE_ENV !== "production" && (sA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: r.node,
  className: r.string,
  desc: r.string,
  /**
   * If `true`, the charts will not listen to the mouse move event.
   * It might break interactive features, but will improve performance.
   * @default false
   */
  disableAxisListener: r.bool,
  /**
   * The height of the chart in px.
   */
  height: r.number.isRequired,
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  title: r.string,
  viewBox: r.shape({
    height: r.number,
    width: r.number,
    x: r.number,
    y: r.number
  }),
  /**
   * The width of the chart in px.
   */
  width: r.number.isRequired
});
const Ehe = (e, t, n) => {
  const o = h.useRef({
    displayError: !1,
    initialCompute: !0,
    computeRun: 0
  }), s = h.useRef(null), [i, a] = h.useState(0), [l, c] = h.useState(0), u = h.useCallback(() => {
    const d = s == null ? void 0 : s.current;
    if (!d)
      return {};
    const p = whe(d).getComputedStyle(d), m = Math.floor(parseFloat(p.height)) || 0, b = Math.floor(parseFloat(p.width)) || 0;
    return a(b), c(m), {
      width: b,
      height: m
    };
  }, []);
  return h.useEffect(() => {
    o.current.displayError = !0;
  }, []), jI(() => {
  }, [i, l, u, n]), jI(() => {
    if (e !== void 0 && t !== void 0)
      return () => {
      };
    u();
    const d = s.current;
    if (typeof ResizeObserver > "u")
      return () => {
      };
    let f;
    const p = new ResizeObserver(() => {
      f = requestAnimationFrame(() => {
        u();
      });
    });
    return d && p.observe(d), () => {
      f && cancelAnimationFrame(f), d && p.unobserve(d);
    };
  }, [u, t, e]), process.env.NODE_ENV !== "production" && (o.current.displayError && e === void 0 && i === 0 && (console.error("MUI X: ChartContainer does not have `width` prop, and its container has no `width` defined."), o.current.displayError = !1), o.current.displayError && t === void 0 && l === 0 && (console.error("MUI X: ChartContainer does not have `height` prop, and its container has no `height` defined."), o.current.displayError = !1)), {
    containerRef: s,
    width: e ?? i,
    height: t ?? l
  };
};
function Ihe(e) {
  return Math.PI * e / 180;
}
function Ib(e) {
  const t = Ihe(e);
  return [Math.sin(t), -Math.cos(t)];
}
function Ohe(e, t) {
  const n = [[0, 0], Ib(e), Ib(t)], o = Math.min(e, t), s = Math.max(e, t), i = Math.floor(o / 90) * 90;
  for (let d = 1; d <= 4; d += 1) {
    const f = i + d * 90;
    f < s && n.push(Ib(f));
  }
  const a = Math.min(...n.map(([d]) => d)), l = Math.max(...n.map(([d]) => d)), c = Math.min(...n.map(([, d]) => d)), u = Math.max(...n.map(([, d]) => d));
  return {
    cx: -a / (l - a),
    cy: -c / (u - c),
    minX: a,
    maxX: l,
    minY: c,
    maxY: u
  };
}
function Phe(e, t, n, o, {
  minX: s,
  maxX: i,
  minY: a,
  maxY: l
}) {
  return Math.min(...[{
    ratio: Math.abs(s),
    space: e
  }, {
    ratio: Math.abs(i),
    space: n - e
  }, {
    ratio: Math.abs(a),
    space: t
  }, {
    ratio: Math.abs(l),
    space: o - t
  }].map(({
    ratio: c,
    space: u
  }) => c < 1e-5 ? 1 / 0 : u / c));
}
const J0 = /* @__PURE__ */ h.createContext({
  value: null,
  valueMin: 0,
  valueMax: 0,
  startAngle: 0,
  endAngle: 0,
  innerRadius: 0,
  outerRadius: 0,
  cornerRadius: 0,
  cx: 0,
  cy: 0,
  maxRadius: 0,
  valueAngle: null
});
process.env.NODE_ENV !== "production" && (J0.displayName = "GaugeContext");
function Mhe(e) {
  const {
    value: t = null,
    valueMin: n = 0,
    valueMax: o = 100,
    startAngle: s = 0,
    endAngle: i = 360,
    outerRadius: a,
    innerRadius: l,
    cornerRadius: c,
    cx: u,
    cy: d,
    children: f
  } = e, {
    left: p,
    top: m,
    width: b,
    height: v
  } = Z$(), g = Ohe(s, i), y = u ? sc(u, b) : g.cx * b, w = d ? sc(d, v) : g.cy * v;
  let x = p + y, S = m + w;
  const T = Phe(y, w, b, v, g);
  if (u === void 0) {
    const R = T * (g.maxX - g.minX);
    x = p + (b - R) / 2 + g.cx * R;
  }
  if (d === void 0) {
    const R = T * (g.maxY - g.minY);
    S = m + (v - R) / 2 + g.cy * R;
  }
  const E = sc(a ?? T, T), O = sc(l ?? "80%", T), M = sc(c ?? 0, E - O), D = h.useMemo(() => {
    const R = Math.PI * s / 180, P = Math.PI * i / 180;
    return {
      value: t,
      valueMin: n,
      valueMax: o,
      startAngle: R,
      endAngle: P,
      outerRadius: E,
      innerRadius: O,
      cornerRadius: M,
      cx: x,
      cy: S,
      maxRadius: T,
      valueAngle: t === null ? null : R + (P - R) * (t - n) / (o - n)
    };
  }, [t, n, o, s, i, E, O, M, x, S, T]);
  return /* @__PURE__ */ C(J0.Provider, {
    value: D,
    children: f
  });
}
function ew() {
  return h.useContext(J0);
}
const khe = ["width", "height", "margin", "title", "desc", "value", "valueMin", "valueMax", "startAngle", "endAngle", "outerRadius", "innerRadius", "cornerRadius", "cx", "cy", "children"], Dhe = te("div", {
  name: "MuiGauge",
  slot: "Container"
})(({
  ownerState: e,
  theme: t
}) => ({
  width: e.width ?? "100%",
  height: e.height ?? "100%",
  display: "flex",
  position: "relative",
  flexGrow: 1,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  "&>svg": {
    width: "100%",
    height: "100%"
  },
  "& text": {
    fill: (t.vars || t).palette.text.primary
  }
})), iA = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    width: o,
    height: s,
    margin: i,
    title: a,
    desc: l,
    value: c,
    valueMin: u = 0,
    valueMax: d = 100,
    startAngle: f,
    endAngle: p,
    outerRadius: m,
    innerRadius: b,
    cornerRadius: v,
    cx: g,
    cy: y,
    children: w
  } = t, x = ve(t, khe), {
    containerRef: S,
    width: T,
    height: E
  } = Ehe(o, s), O = h.useRef(null), M = vhe(n, O);
  return /* @__PURE__ */ C(Dhe, I({
    ref: S,
    ownerState: {
      width: o,
      height: s
    },
    role: "meter",
    "aria-valuenow": c === null ? void 0 : c,
    "aria-valuemin": u,
    "aria-valuemax": d
  }, x, {
    children: T && E ? /* @__PURE__ */ C(the, {
      width: T,
      height: E,
      margin: I({
        left: 10,
        right: 10,
        top: 10,
        bottom: 10
      }, i),
      svgRef: O,
      children: /* @__PURE__ */ C(Mhe, {
        value: c,
        valueMin: u,
        valueMax: d,
        startAngle: f,
        endAngle: p,
        outerRadius: m,
        innerRadius: b,
        cornerRadius: v,
        cx: g,
        cy: y,
        children: /* @__PURE__ */ C(sA, {
          width: T,
          height: E,
          ref: M,
          title: a,
          desc: l,
          disableAxisListener: !0,
          "aria-hidden": "true",
          children: w
        })
      })
    }) : null
  }));
});
process.env.NODE_ENV !== "production" && (iA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: r.node,
  className: r.string,
  /**
   * The radius applied to arc corners (similar to border radius).
   * Set it to '50%' to get rounded arc.
   * @default 0
   */
  cornerRadius: r.oneOfType([r.number, r.string]),
  /**
   * The x coordinate of the arc center.
   * Can be a number (in px) or a string with a percentage such as '50%'.
   * The '100%' is the width the drawing area.
   */
  cx: r.oneOfType([r.number, r.string]),
  /**
   * The y coordinate of the arc center.
   * Can be a number (in px) or a string with a percentage such as '50%'.
   * The '100%' is the height the drawing area.
   */
  cy: r.oneOfType([r.number, r.string]),
  desc: r.string,
  /**
   * If `true`, the charts will not listen to the mouse move event.
   * It might break interactive features, but will improve performance.
   * @default false
   */
  disableAxisListener: r.bool,
  /**
   * The end angle (deg).
   * @default 360
   */
  endAngle: r.number,
  /**
   * The height of the chart in px. If not defined, it takes the height of the parent element.
   */
  height: r.number,
  /**
   * The radius between circle center and the beginning of the arc.
   * Can be a number (in px) or a string with a percentage such as '50%'.
   * The '100%' is the maximal radius that fit into the drawing area.
   * @default '80%'
   */
  innerRadius: r.oneOfType([r.number, r.string]),
  /**
   * The margin between the SVG and the drawing area.
   * It's used for leaving some space for extra information such as the x- and y-axis or legend.
   * Accepts an object with the optional properties: `top`, `bottom`, `left`, and `right`.
   * @default object Depends on the charts type.
   */
  margin: r.shape({
    bottom: r.number,
    left: r.number,
    right: r.number,
    top: r.number
  }),
  /**
   * The radius between circle center and the end of the arc.
   * Can be a number (in px) or a string with a percentage such as '50%'.
   * The '100%' is the maximal radius that fit into the drawing area.
   * @default '100%'
   */
  outerRadius: r.oneOfType([r.number, r.string]),
  /**
   * The start angle (deg).
   * @default 0
   */
  startAngle: r.number,
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  title: r.string,
  /**
   * The value of the gauge.
   * Set to `null` to not display a value.
   */
  value: r.number,
  /**
   * The maximal value of the gauge.
   * @default 100
   */
  valueMax: r.number,
  /**
   * The minimal value of the gauge.
   * @default 0
   */
  valueMin: r.number,
  viewBox: r.shape({
    height: r.number,
    width: r.number,
    x: r.number,
    y: r.number
  }),
  /**
   * The width of the chart in px. If not defined, it takes the width of the parent element.
   */
  width: r.number
});
const Nhe = te("path", {
  name: "MuiGauge",
  slot: "ReferenceArc",
  overridesResolver: (e, t) => t.referenceArc
})(({
  theme: e
}) => ({
  fill: (e.vars || e).palette.primary.main
}));
function $he(e) {
  const {
    value: t,
    valueMin: n,
    valueMax: o,
    startAngle: s,
    endAngle: i,
    outerRadius: a,
    innerRadius: l,
    cornerRadius: c,
    cx: u,
    cy: d
  } = ew();
  if (t === null)
    return null;
  const f = s + (t - n) / (o - n) * (i - s);
  return /* @__PURE__ */ C(Nhe, I({
    transform: `translate(${u}, ${d})`,
    d: Q$().cornerRadius(c)({
      startAngle: s,
      endAngle: f,
      innerRadius: l,
      outerRadius: a
    })
  }, e));
}
const Ahe = te("path", {
  name: "MuiGauge",
  slot: "ReferenceArc",
  overridesResolver: (e, t) => t.referenceArc
})(({
  theme: e
}) => ({
  fill: (e.vars || e).palette.divider
}));
function Fhe(e) {
  const {
    startAngle: t,
    endAngle: n,
    outerRadius: o,
    innerRadius: s,
    cornerRadius: i,
    cx: a,
    cy: l
  } = ew();
  return /* @__PURE__ */ C(Ahe, I({
    transform: `translate(${a}, ${l})`,
    d: Q$().cornerRadius(i)({
      startAngle: t,
      endAngle: n,
      innerRadius: s,
      outerRadius: o
    })
  }, e));
}
function Lhe(e) {
  return eA("MuiGauge", e);
}
che("MuiGauge", ["root", "valueArc", "referenceArc", "valueText"]);
const _he = ["text", "className"];
function Vhe({
  value: e
}) {
  return e === null ? null : e.toLocaleString();
}
function aA(e) {
  const {
    text: t = Vhe,
    className: n
  } = e, o = ve(e, _he), {
    value: s,
    valueMin: i,
    valueMax: a,
    cx: l,
    cy: c
  } = ew(), u = typeof t == "function" ? t({
    value: s,
    valueMin: i,
    valueMax: a
  }) : t;
  return u === null ? null : /* @__PURE__ */ C("g", {
    className: n,
    children: /* @__PURE__ */ C(oA, I({
      x: l,
      y: c,
      text: u,
      style: {
        textAnchor: "middle",
        dominantBaseline: "central"
      }
    }, o))
  });
}
process.env.NODE_ENV !== "production" && (aA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Height of a text line (in `em`).
   */
  lineHeight: r.number,
  /**
   * If `true`, the line width is computed.
   * @default false
   */
  needsComputation: r.bool,
  ownerState: r.any,
  /**
   * Style applied to text elements.
   */
  style: r.object,
  text: r.oneOfType([r.func, r.string])
});
const Bhe = ["text", "children", "classes", "className"], zhe = (e) => {
  const {
    classes: t
  } = e;
  return she({
    root: ["root"],
    valueArc: ["valueArc"],
    referenceArc: ["referenceArc"],
    valueText: ["valueText"]
  }, Lhe, t);
}, lA = /* @__PURE__ */ h.forwardRef(function(t, n) {
  const {
    text: o,
    children: s,
    className: i
  } = t, a = ve(t, Bhe), l = zhe(t);
  return /* @__PURE__ */ ie(iA, I({}, a, {
    className: ae(l.root, i),
    ref: n,
    children: [/* @__PURE__ */ C(Fhe, {
      className: l.referenceArc
    }), /* @__PURE__ */ C($he, {
      className: l.valueArc
    }), /* @__PURE__ */ C(aA, {
      className: l.valueText,
      text: o
    }), s]
  }));
});
process.env.NODE_ENV !== "production" && (lA.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: r.node,
  classes: r.object,
  className: r.string,
  /**
   * The radius applied to arc corners (similar to border radius).
   * Set it to '50%' to get rounded arc.
   * @default 0
   */
  cornerRadius: r.oneOfType([r.number, r.string]),
  /**
   * The x coordinate of the arc center.
   * Can be a number (in px) or a string with a percentage such as '50%'.
   * The '100%' is the width the drawing area.
   */
  cx: r.oneOfType([r.number, r.string]),
  /**
   * The y coordinate of the arc center.
   * Can be a number (in px) or a string with a percentage such as '50%'.
   * The '100%' is the height the drawing area.
   */
  cy: r.oneOfType([r.number, r.string]),
  desc: r.string,
  /**
   * If `true`, the charts will not listen to the mouse move event.
   * It might break interactive features, but will improve performance.
   * @default false
   */
  disableAxisListener: r.bool,
  /**
   * The end angle (deg).
   * @default 360
   */
  endAngle: r.number,
  /**
   * The height of the chart in px. If not defined, it takes the height of the parent element.
   */
  height: r.number,
  /**
   * The radius between circle center and the beginning of the arc.
   * Can be a number (in px) or a string with a percentage such as '50%'.
   * The '100%' is the maximal radius that fit into the drawing area.
   * @default '80%'
   */
  innerRadius: r.oneOfType([r.number, r.string]),
  /**
   * The margin between the SVG and the drawing area.
   * It's used for leaving some space for extra information such as the x- and y-axis or legend.
   * Accepts an object with the optional properties: `top`, `bottom`, `left`, and `right`.
   * @default object Depends on the charts type.
   */
  margin: r.shape({
    bottom: r.number,
    left: r.number,
    right: r.number,
    top: r.number
  }),
  /**
   * The radius between circle center and the end of the arc.
   * Can be a number (in px) or a string with a percentage such as '50%'.
   * The '100%' is the maximal radius that fit into the drawing area.
   * @default '100%'
   */
  outerRadius: r.oneOfType([r.number, r.string]),
  /**
   * The start angle (deg).
   * @default 0
   */
  startAngle: r.number,
  sx: r.oneOfType([r.arrayOf(r.oneOfType([r.func, r.object, r.bool])), r.func, r.object]),
  text: r.oneOfType([r.func, r.string]),
  title: r.string,
  /**
   * The value of the gauge.
   * Set to `null` to not display a value.
   */
  value: r.number,
  /**
   * The maximal value of the gauge.
   * @default 100
   */
  valueMax: r.number,
  /**
   * The minimal value of the gauge.
   * @default 0
   */
  valueMin: r.number,
  viewBox: r.shape({
    height: r.number,
    width: r.number,
    x: r.number,
    y: r.number
  }),
  /**
   * The width of the chart in px. If not defined, it takes the width of the parent element.
   */
  width: r.number
});
const RCe = ({
  variant: e = "primary",
  size: t = 50,
  children: n,
  margin: o,
  ...s
}) => {
  const i = sn(), {
    innerRadius: a,
    outerRadius: l,
    stroke: c,
    fill: u,
    backgroundColor: d,
    strokeWidth: f
  } = Ye(() => e === "disabled" ? {
    innerRadius: "25%",
    outerRadius: "100%",
    stroke: i.palette.action.disabled,
    fill: i.palette.action.disabled,
    backgroundColor: i.palette.action.disabled,
    strokeWidth: 0
  } : {
    innerRadius: "0%",
    outerRadius: "100%",
    stroke: i.palette[e].main,
    fill: i.palette[e].main,
    backgroundColor: null,
    strokeWidth: 2
  }, [e, i]);
  return /* @__PURE__ */ C(
    lA,
    {
      text: "",
      width: t,
      height: t,
      innerRadius: a,
      outerRadius: l,
      margin: typeof o == "number" ? { top: o, bottom: o, left: o, right: o } : o,
      sx: {
        ".MuiGauge-referenceArc": {
          fill: d,
          stroke: c,
          strokeWidth: f
        },
        ".MuiGauge-valueArc": {
          fill: u,
          stroke: c,
          strokeWidth: f
        }
      },
      ...s,
      children: /* @__PURE__ */ C(
        "foreignObject",
        {
          width: "100%",
          height: "100%",
          x: "0",
          y: "0",
          style: { pointerEvents: "none" },
          children: /* @__PURE__ */ C(
            Gt,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                height: "100%"
              },
              children: n
            }
          )
        }
      )
    }
  );
}, cA = (e) => {
  let t = 0;
  return e.forEach((n) => {
    t += Number(n.value);
  }), t;
}, Hhe = (e) => e.length > 0 ? cA(e) * 1 / e.length : 0, jhe = (e, t) => {
  switch (t) {
    case "decimal":
    case "dollar":
      return (n) => `$${Number(n).toFixed(e)}`;
    case "percentage":
      return (n) => `${Number(n).toFixed(e)}%`;
    default:
      return (n) => Number(n).toFixed(0).toString();
  }
}, GI = ({
  value: e,
  precision: t,
  format: n,
  key: o
}) => {
  const s = jhe(t, n);
  return /* @__PURE__ */ C(Gt, { sx: { flex: 1, textAlign: "center" }, children: /* @__PURE__ */ C(Gt, { children: s(e) }) }, o);
}, Ghe = ({ aggregates: e, row: t }) => {
  var l, c, u;
  if (!e) return null;
  const n = cA(t.columns), o = Hhe(t.columns), { format: s } = t.columns[0], a = { precision: ((l = t.columns[0].options) == null ? void 0 : l.precision) || 2, format: s };
  return /* @__PURE__ */ ie(Gt, { sx: { display: "flex", gap: 1 }, children: [
    ((c = e.average) == null ? void 0 : c.enabled) && /* @__PURE__ */ js(GI, { ...a, key: "_average", value: o }),
    ((u = e.total) == null ? void 0 : u.enabled) && /* @__PURE__ */ js(GI, { ...a, key: "_total", value: n })
  ] });
}, uA = (e) => {
  var c, u, d;
  const { cell: t, column: n, row: o } = e;
  if ((c = n.options) != null && c.isHidden) return null;
  const s = t.format || n.cellFormat;
  let i = t.onRender || n.onRenderCell;
  if (!i && s)
    switch (s) {
      case "icon":
        i = () => /* @__PURE__ */ C(Ve, { children: t.value });
        break;
      case "progress":
        i = () => {
          var p, m;
          const f = ((p = t.options) == null ? void 0 : p.progress) || ((m = n.options) == null ? void 0 : m.progress);
          return /* @__PURE__ */ C(
            D8,
            {
              value: t.value ? t.value * ((f == null ? void 0 : f.base) || 100) * 1 : 0,
              variant: (f == null ? void 0 : f.variant) || "determinate"
            }
          );
        };
        break;
      case "color":
        i = () => /* @__PURE__ */ C(Gt, { sx: { backgroundColor: t.value } });
        break;
    }
  let a = t.onFormat || n.onFormatCell;
  if (!a && s) {
    s === "decimal" && (a = () => `${Number(t.value).toFixed(0)}`);
    const f = ((u = t.options) == null ? void 0 : u.precision) || ((d = n.options) == null ? void 0 : d.precision) || 2, p = Number(t.value).toFixed(f);
    switch (s) {
      case "decimal":
        a = () => `${p}`;
        break;
      case "dollar":
        a = () => `$${p}`;
        break;
      case "percentage":
        a = () => `${p}%`;
        break;
    }
  }
  const l = a ? a({ value: t.value, cell: t, column: n, row: o }) : t.value;
  return i ? i({ value: l, cell: t, column: n, row: o }) : l;
}, dA = ({ column: e, sortOrder: t, sortBy: n, onClick: o }) => {
  const { label: s, value: i, options: a, onRender: l, onFormat: c } = e;
  if (a != null && a.isHidden) return null;
  const u = s || i;
  return l ? l({ value: s || i, column: e, sortBy: n, sortOrder: t }) : /* @__PURE__ */ C(Gt, { onClick: () => o && o(e), children: /* @__PURE__ */ C(
    $M,
    {
      active: (n == null ? void 0 : n.key) === e.key,
      direction: t,
      hideSortIcon: a == null ? void 0 : a.hideSortIcon,
      sx: (d) => ({
        fontWeight: "bold",
        fontSize: d.typography.caption.fontSize
      }),
      children: c ? c({ value: u, column: e }) : u
    }
  ) });
}, qhe = ({ cells: e, columns: t, row: n }) => /* @__PURE__ */ C(Gt, { sx: { display: "flex", textAlign: "left" }, children: e.map((o, s) => {
  const i = t[s];
  return /* @__PURE__ */ C(Gt, { sx: { flex: 1 }, children: /* @__PURE__ */ C(uA, { cell: o, column: i, row: n }) }, i.key);
}) }), qI = ({
  columns: e,
  sortBy: t,
  sortOrder: n,
  onClickColumn: o
}) => /* @__PURE__ */ C(Gt, { sx: { display: "flex" }, children: e.map((s) => /* @__PURE__ */ C(Gt, { sx: { flex: 1 }, children: /* @__PURE__ */ C(
  dA,
  {
    sortBy: t,
    sortOrder: n,
    column: s,
    onClick: o
  }
) }, s.key)) }), ECe = ({
  fields: e,
  columns: t,
  rows: n,
  aggregates: o,
  withBorder: s,
  ...i
}) => {
  var v, g;
  const [a, l] = jt("asc"), [c, u] = jt(void 0), d = sn(), f = (y) => {
    var w;
    (w = y.options) != null && w.blockSorting || ((c == null ? void 0 : c.key) !== y.key ? u({ key: y.key, type: y.type }) : l(a === "asc" ? "desc" : "asc"));
  };
  let p;
  c && (c.type === "column" ? p = t.findIndex(
    (y) => y.key === c.key
  ) : c.type === "field" && (p = e.findIndex((y) => y.key === c.key)));
  const m = [];
  (v = o == null ? void 0 : o.average) != null && v.enabled && m.push({
    type: "column",
    key: "_average",
    label: "Average"
  }), (g = o == null ? void 0 : o.total) != null && g.enabled && m.push({
    type: "column",
    key: "_total",
    label: "Total"
  });
  const b = m.length > 0;
  return /* @__PURE__ */ C(
    SC,
    {
      sx: {
        boxSizing: "border-box",
        border: s ? `1px solid ${d.palette.divider}` : 0,
        backgroundColor: s ? d.palette.background.default : void 0,
        flex: s ? 1 : void 0
      },
      children: /* @__PURE__ */ ie(Iu, { sx: { border: 0 }, ...i, children: [
        /* @__PURE__ */ C(Ou, { children: /* @__PURE__ */ ie(Us, { children: [
          e && /* @__PURE__ */ C(
            Ca,
            {
              sx: {
                position: "sticky",
                top: 0,
                zIndex: 250,
                left: 0,
                textAlign: "left",
                borderRight: `1px dotted ${d.palette.divider}`,
                backgroundColor: d.palette.background.paper
              },
              children: /* @__PURE__ */ C(
                qI,
                {
                  columns: e,
                  sortBy: c,
                  sortOrder: a,
                  onClickColumn: f
                }
              )
            }
          ),
          t.map((y) => /* @__PURE__ */ C(
            Ca,
            {
              sx: {
                zIndex: 200,
                top: 0
              },
              children: /* @__PURE__ */ C(
                dA,
                {
                  column: y,
                  sortBy: c,
                  sortOrder: a,
                  onClick: f
                }
              )
            },
            y.key
          )),
          b && /* @__PURE__ */ C(
            Ca,
            {
              sx: {
                position: "sticky",
                top: 0,
                zIndex: 250,
                right: 0,
                borderLeft: `1px dotted ${d.palette.divider}`,
                backgroundColor: d.palette.background.paper
              },
              children: /* @__PURE__ */ C(
                qI,
                {
                  columns: m,
                  sortBy: c,
                  sortOrder: a,
                  onClickColumn: f
                }
              )
            }
          )
        ] }) }),
        /* @__PURE__ */ C(rl, { children: [...n].sort((y, w) => {
          let x = 0, S = 0;
          if (c && ["_average", "_total"].includes(c == null ? void 0 : c.key))
            y.columns.forEach((E) => {
              x += Number(E.value);
            }), w.columns.forEach((E) => {
              S += Number(E.value);
            }), c.key === "_average" && (x = x * 1 / y.columns.length, S = S * 1 / w.columns.length);
          else {
            if (!c || p === void 0 || p < 0)
              return 1;
            c.type === "column" ? (x = y.columns[p].value || 0, S = w.columns[p].value || 0) : c.type === "field" && (x = y.fields[p].value || 0, S = w.fields[p].value || 0);
          }
          const T = x >= S ? 1 : -1;
          return a === "asc" ? T : T * -1;
        }).map((y, w) => {
          const x = `row-${w}`;
          return /* @__PURE__ */ ie(Us, { children: [
            y.fields && /* @__PURE__ */ C(
              Ca,
              {
                sx: {
                  position: "sticky",
                  zIndex: 10,
                  left: 0,
                  textAlign: "left",
                  borderRight: `1px dotted ${d.palette.divider}`,
                  backgroundColor: d.palette.background.paper
                },
                children: /* @__PURE__ */ C(
                  qhe,
                  {
                    cells: y.fields,
                    columns: e,
                    row: y
                  }
                )
              }
            ),
            y.columns.map((S, T) => {
              const E = `${w}-${t[T].key}`;
              return /* @__PURE__ */ C(Ca, { children: /* @__PURE__ */ C(
                uA,
                {
                  cell: S,
                  column: t[T],
                  row: y
                }
              ) }, E);
            }),
            b && /* @__PURE__ */ C(
              Ca,
              {
                sx: {
                  position: "sticky",
                  zIndex: 10,
                  right: 0,
                  borderLeft: `1px dotted ${d.palette.divider}`,
                  backgroundColor: d.palette.background.paper
                },
                children: /* @__PURE__ */ C(Ghe, { aggregates: o, row: y })
              }
            )
          ] }, x);
        }) })
      ] })
    }
  );
}, Ca = (e) => {
  const { children: t, sx: n = {}, ...o } = e;
  return /* @__PURE__ */ C(
    Wo,
    {
      ...o,
      sx: {
        ...n,
        height: "100%",
        padding: 1,
        textAlign: "center",
        textOverflow: "elipsis",
        boxSizing: "border-box"
      },
      children: t
    }
  );
}, WI = (e, t, n) => cu.toArray(e).findIndex((o) => bo(o) ? o.props[t] === n : !1), ICe = ({
  children: e,
  primary: t,
  cancel: n,
  noPrimary: o = !1,
  noCancel: s = !1,
  fullWidth: i = !1,
  responsive: a = !0,
  noPadding: l = !1
}) => {
  const c = NC(), u = i || a && c;
  if (!e && !t && !n) return null;
  const d = cu.toArray(e);
  let f = t;
  if (!f && !o) {
    const v = WI(e, "isPrimary", !0);
    v > -1 && (f = d.splice(v, 1));
  }
  let p = n;
  if (!p && !s) {
    const v = WI(e, "isCancel", !0);
    v > -1 && (p = d.splice(v, 1));
  }
  const m = [];
  d.forEach((v) => {
    if (!f && !o) {
      f = v;
      return;
    }
    if (!p && !s) {
      p = v;
      return;
    }
    m.push(v);
  });
  const b = {
    display: "flex",
    flex: u ? 1 : void 0,
    gap: 1,
    "& > *": u ? {
      flex: 1
    } : void 0
  };
  return /* @__PURE__ */ ie(
    BM,
    {
      paddingTop: l ? 0 : 1,
      spacing: 1,
      justifyContent: u ? "stretch" : "space-between",
      children: [
        (f || p) && /* @__PURE__ */ ie(
          vt,
          {
            sx: {
              ...b,
              flexDirection: "row",
              marginLeft: u ? void 0 : "auto",
              order: 99
            },
            children: [
              p && (bo(p) ? Gr(p, {
                isPrimary: !1,
                isCancel: !0,
                fullWidth: u
              }) : p),
              f && (bo(f) ? Gr(f, {
                isPrimary: !0,
                isCancel: !1,
                fullWidth: u
              }) : f)
            ]
          }
        ),
        m.length > 0 && /* @__PURE__ */ C(
          vt,
          {
            sx: {
              ...b,
              flexDirection: "row"
            },
            children: m.map(
              (v) => bo(v) ? Gr(v, {
                isPrimary: !1,
                isCancel: !1,
                fullWidth: u
              }) : v
            )
          }
        )
      ]
    }
  );
};
function OCe({
  title: e,
  description: t,
  actionNode: n,
  orientation: o = "vertical",
  maxWidth: s = "100%"
}) {
  return /* @__PURE__ */ C(vt, { sx: { maxWidth: s, margin: "auto", width: "100%" }, children: /* @__PURE__ */ ie(
    gs,
    {
      container: !0,
      spacing: o === "vertical" ? 2 : 1,
      alignItems: "center",
      justifyContent: o === "horizontal" ? "space-between" : "",
      children: [
        /* @__PURE__ */ C(gs, { item: !0, sx: { height: "100%" }, children: /* @__PURE__ */ ie(
          gs,
          {
            textAlign: o === "horizontal" ? "left" : "center",
            height: "100%",
            gap: 0.5,
            children: [
              e && /* @__PURE__ */ C(yn, { variant: "h6", sx: { fontWeight: "bold" }, children: e }),
              t && /* @__PURE__ */ C(
                yn,
                {
                  sx: { marginTop: o === "vertical" ? 1 : 0 },
                  children: t
                }
              )
            ]
          }
        ) }),
        n && /* @__PURE__ */ C(
          gs,
          {
            item: !0,
            sx: { width: o === "horizontal" ? "auto" : "100%" },
            children: /* @__PURE__ */ C(
              vt,
              {
                display: "flex",
                justifyContent: o === "horizontal" ? "flex-end" : "center",
                children: n
              }
            )
          }
        )
      ]
    }
  ) });
}
const PCe = ({
  centered: e,
  backgroundColor: t = "background.default",
  color: n = "text.primary",
  layout: o = "vertical",
  disableScroll: s = !0,
  children: i,
  sx: a
}) => /* @__PURE__ */ C(
  vt,
  {
    color: n,
    bgcolor: t,
    sx: {
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: s ? "hidden" : "auto",
      display: "flex",
      flexDirection: o === "vertical" ? "column" : "row",
      alignItems: e ? "center" : void 0,
      justifyContent: e ? "center" : void 0,
      ...a
    },
    children: i
  }
), UI = ({
  children: e,
  top: t,
  topSx: n,
  topFlex: o,
  bottom: s,
  bottomFlex: i,
  bottomSx: a,
  left: l,
  leftFlex: c,
  leftSx: u,
  right: d,
  rightFlex: f,
  rightSx: p,
  flexDirection: m = "row",
  overflow: b = "hidden",
  fill: v = !0,
  backgroundColor: g,
  ...y
}) => {
  const {
    border: w,
    borderLeft: x,
    borderRight: S,
    borderTop: T,
    borderBottom: E,
    padding: O,
    paddingX: M,
    paddingY: D,
    paddingTop: R,
    paddingBottom: P,
    paddingLeft: F,
    paddingRight: $,
    ...N
  } = y;
  return /* @__PURE__ */ ie(
    vt,
    {
      height: v ? "100%" : void 0,
      display: "flex",
      flexDirection: "column",
      flex: v ? 1 : void 0,
      overflow: "hidden",
      sx: {
        boxSizing: "border-box",
        overflow: "hidden",
        fontSize: "body1.fontSize",
        ...z8({
          border: w,
          borderLeft: x,
          borderRight: S,
          borderTop: T,
          borderBottom: E
        }),
        ...N
      },
      children: [
        /* @__PURE__ */ C(Ld, { placement: "top", ...n, flex: o, children: t }),
        /* @__PURE__ */ ie(
          vt,
          {
            flex: 1,
            display: "flex",
            flexDirection: m,
            overflow: b,
            children: [
              /* @__PURE__ */ C(Ld, { placement: "left", ...u, flex: c, children: l }),
              /* @__PURE__ */ C(
                Whe,
                {
                  layout: "rows",
                  padding: O,
                  paddingX: M,
                  paddingY: D,
                  paddingTop: R,
                  paddingBottom: P,
                  paddingLeft: F,
                  paddingRight: $,
                  backgroundColor: g,
                  children: e
                }
              ),
              /* @__PURE__ */ C(Ld, { placement: "right", ...p, flex: f, children: d })
            ]
          }
        ),
        /* @__PURE__ */ C(Ld, { placement: "bottom", ...a, flex: i, children: s })
      ]
    }
  );
}, Whe = ({ children: e, layout: t, ...n }) => {
  const o = cu.toArray(e).find(
    // @ts-expect-error Name isn't expected on JSX elements
    (s) => bo(s) && s.type.name === "Layout"
  );
  return /* @__PURE__ */ C(
    vt,
    {
      flex: 1,
      order: 0,
      overflow: o ? "hidden" : "auto",
      display: o ? "flex" : "block",
      sx: {
        boxSizing: "border-box",
        ...n
      },
      children: e
    }
  );
}, Ld = ({
  children: e,
  placement: t,
  border: n = !0,
  borderColor: o = "divider",
  borderStyle: s = "solid",
  borderWidth: i = 1,
  flex: a,
  ...l
}) => e ? /* @__PURE__ */ C(
  vt,
  {
    sx: {
      display: "flex",
      boxSizing: "border-box",
      overflow: t === "top" || t === "bottom" ? void 0 : "auto",
      order: t === "bottom" || t === "right" ? 1 : -1,
      borderTop: n && t === "bottom" ? `${i}px ${s}` : void 0,
      borderBottom: n && t === "top" ? `${i}px ${s}` : void 0,
      borderLeft: n && t === "right" ? `${i}px ${s}` : void 0,
      borderRight: n && t === "left" ? `${i}px ${s}` : void 0,
      borderColor: n ? o : void 0,
      ...l
    },
    children: /* @__PURE__ */ C(vt, { display: a ? "flex" : "block", flex: 1, children: e })
  }
) : null, MCe = ({
  children: e,
  color: t,
  align: n,
  noPadding: o,
  variant: s = "text",
  RouterLink: i,
  to: a,
  target: l,
  onClick: c
}) => /* @__PURE__ */ C(
  Io,
  {
    color: t,
    sx: [s === "text" ? { py: 0 } : {}, o ? { px: 0 } : {}],
    variant: s,
    onClick: c,
    children: /* @__PURE__ */ C(
      i,
      {
        to: a,
        target: l,
        style: {
          textDecoration: "none",
          color: "inherit",
          textAlign: n
        },
        children: e
      }
    )
  }
), kCe = rs(({ children: e, button: t, onClick: n, onMouseEnter: o, onMouseLeave: s, ...i }, a) => t ? /* @__PURE__ */ C(
  sC,
  {
    ref: a,
    onClick: n,
    ...i,
    children: e
  }
) : /* @__PURE__ */ C(
  aC,
  {
    onMouseEnter: o,
    onMouseLeave: s,
    ref: a,
    ...i,
    children: e
  }
)), DCe = ({
  children: e,
  ...t
}) => /* @__PURE__ */ C(el, { ...t, children: e }), NCe = ({ map: e, value: t, ...n }) => {
  const o = e.find((s) => s.value === t);
  return o ? /* @__PURE__ */ C(fW, { ...o, ...n }) : (console.error("Chip value not found in map", t), null);
}, $Ce = ({ children: e, ...t }) => /* @__PURE__ */ C(Eu, { ...t, children: e }), ACe = rs(
  ({ children: e, ...t }, n) => /* @__PURE__ */ C(Nn, { ...t, ref: n, children: e })
), FCe = ({ children: e, ...t }) => /* @__PURE__ */ C(Zi, { ...t, children: e }), LCe = ({ children: e }) => /* @__PURE__ */ C(UI, { fill: !0, children: /* @__PURE__ */ C(UI, { fill: !0, topSx: { borderWidth: 0 }, children: e }) }), _Ce = ({ title: e, children: t }) => /* @__PURE__ */ ie(
  _v,
  {
    disableGutters: !0,
    elevation: 0,
    defaultExpanded: !0,
    square: !0,
    sx: (n) => ({
      borderTop: `1px solid ${n.palette.divider}`,
      "&:first-child": {
        borderTop: 0
      },
      "&:not(:last-child)": {
        borderBottom: 0
      },
      "&::before": {
        display: "none"
      }
    }),
    children: [
      /* @__PURE__ */ C(
        Bv,
        {
          id: e.toString(),
          expandIcon: /* @__PURE__ */ C(Ve, { children: "expand_less" }),
          sx: {
            px: 2
          },
          children: /* @__PURE__ */ C(Gt, { sx: { display: "flex", flexDirection: "column", gap: 0.5 }, children: /* @__PURE__ */ C(
            yn,
            {
              variant: "caption",
              color: "text.secondary",
              sx: { letterSpacing: 0.5 },
              children: e
            }
          ) })
        }
      ),
      /* @__PURE__ */ C(
        Vv,
        {
          sx: (n) => ({
            p: 2,
            paddingTop: 0,
            fontSize: n.typography.body2.fontSize
          }),
          children: t
        }
      )
    ]
  }
), VCe = ({
  variant: e = "outlined",
  children: t,
  saveVerticalSpace: n,
  saveHorizontalSpace: o,
  noPadding: s,
  ...i
}) => /* @__PURE__ */ C(
  ao,
  {
    variant: e,
    sx: {
      ...!s && {
        padding: o || n ? 0 : 2,
        paddingY: n ? 1 : 2
      }
    },
    ...i,
    children: t
  }
), BCe = ({ layout: e = "vertical", ...t }) => e === "horizontal" ? /* @__PURE__ */ C(Uhe, { ...t }) : /* @__PURE__ */ C(Khe, { ...t }), fA = ({ icon: e, iconProps: t, layout: n }) => /* @__PURE__ */ C(
  vt,
  {
    sx: {
      color: "text.secondary",
      ...n === "horizontal" ? {
        flex: 1,
        maxWidth: "32px"
      } : {
        width: "32px",
        marginRight: "5px"
      }
    },
    children: /* @__PURE__ */ C(Ve, { ...t, children: e })
  }
), pA = ({
  label: e,
  labelProps: t,
  layout: n
}) => /* @__PURE__ */ C(
  vt,
  {
    sx: {
      color: (t == null ? void 0 : t.color) || "text.secondary",
      ...n === "horizontal" ? {
        flex: 1,
        maxWidth: "30%"
      } : {}
    },
    children: e
  }
), hA = ({
  children: e,
  layout: t
}) => /* @__PURE__ */ C(vt, { sx: { ...t === "horizontal" ? { flex: 1 } : {} }, children: e }), gA = ({
  action: e,
  actionProps: t,
  children: n
}) => {
  let o;
  if (bo(e))
    o = e;
  else
    switch (e && e.type) {
      case "clipboard":
        typeof n == "string" && (o = /* @__PURE__ */ C(V8, { toCopy: n }));
        break;
    }
  return /* @__PURE__ */ C(vt, { ...t, children: o });
}, Uhe = ({
  hideIcon: e,
  icon: t,
  iconProps: n,
  label: o,
  labelProps: s,
  action: i,
  actionProps: a,
  children: l
}) => /* @__PURE__ */ ie(
  vt,
  {
    sx: {
      display: "flex",
      flexDirection: "row",
      gap: 0.5
    },
    children: [
      !e && t && /* @__PURE__ */ C(fA, { icon: t, iconProps: n, layout: "horizontal" }),
      /* @__PURE__ */ C(pA, { label: o, labelProps: s, layout: "horizontal" }),
      /* @__PURE__ */ C(hA, { layout: "horizontal", children: l }),
      /* @__PURE__ */ C(vt, { children: /* @__PURE__ */ C(gA, { action: i, ...a, children: l }) })
    ]
  }
), Khe = ({
  hideIcon: e,
  icon: t,
  iconProps: n,
  label: o,
  children: s,
  action: i,
  actionProps: a
}) => /* @__PURE__ */ ie(
  vt,
  {
    sx: {
      display: "flex",
      flexDirection: "row"
    },
    children: [
      !e && t && /* @__PURE__ */ C(fA, { icon: t, iconProps: n, layout: "vertical" }),
      /* @__PURE__ */ ie(
        vt,
        {
          sx: {
            flex: 1,
            display: "flex",
            flexDirection: "row",
            gap: 1
          },
          children: [
            /* @__PURE__ */ ie(
              vt,
              {
                sx: {
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  gap: 0.5
                },
                children: [
                  /* @__PURE__ */ C(pA, { label: o, layout: "vertical" }),
                  /* @__PURE__ */ C(hA, { layout: "vertical", children: s })
                ]
              }
            ),
            i && /* @__PURE__ */ C(vt, { children: /* @__PURE__ */ C(gA, { action: i, ...a, children: s }) })
          ]
        }
      )
    ]
  }
), zCe = ({
  children: e,
  fullWidth: t = !1,
  dense: n = !0,
  size: o = "inherit"
}) => /* @__PURE__ */ C(
  vt,
  {
    sx: (s) => ({
      display: "flex",
      flexDirection: "column",
      alignContent: "flex-start",
      width: t ? "100%" : void 0,
      gap: n ? 1 : 2,
      fontSize: o === "small" ? s.typography.body2.fontSize : "inherit"
    }),
    children: cu.map(
      e,
      (s) => bo(s) && Gr(
        s,
        {
          layout: "horizontal",
          dense: n
        }
      )
    )
  }
), Yhe = [0, 1, -1], _d = {
  fontSize: "small"
}, Ob = {
  1: {
    icon: /* @__PURE__ */ C(jce, { ..._d }),
    iconSelected: /* @__PURE__ */ C(Hce, { ..._d }),
    label: "Good"
  },
  2: {
    icon: /* @__PURE__ */ C(zce, { ..._d }),
    iconSelected: /* @__PURE__ */ C(Bce, { ..._d }),
    label: "Bad"
  }
}, HCe = ({
  onChange: e,
  defaultValue: t,
  text: n,
  size: o = "small",
  color: s = "primary"
}) => {
  const [i, a] = jt(null), l = sn(), c = [
    2,
    0,
    1
    /* GOOD */
  ][(t ?? 0) + 1], [u, d] = jt(
    c || null
  ), f = (p) => {
    var g, y;
    const { value: m, ...b } = p, v = [i, u].includes(m) ? (g = Ob[m]) == null ? void 0 : g.iconSelected : (y = Ob[m]) == null ? void 0 : y.icon;
    return /* @__PURE__ */ C("span", { ...b, children: v });
  };
  return /* @__PURE__ */ ie(
    vt,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        whiteSpace: "nowrap"
      },
      children: [
        n && /* @__PURE__ */ C(
          Cs,
          {
            variant: o === "small" ? "caption" : "body1",
            sx: {
              fontStyle: o === "small" ? "italic" : "normal",
              color: l.palette.text.secondary
            },
            children: n
          }
        ),
        /* @__PURE__ */ C(
          vM,
          {
            color: s,
            IconContainerComponent: f,
            getLabelText: (p) => {
              var m;
              return ((m = Ob[p]) == null ? void 0 : m.label) || "";
            },
            highlightSelectedOnly: !0,
            max: 2,
            onChangeActive: (p, m) => {
              a(m);
            },
            onChange: (p, m) => {
              d(m), e == null || e(p, Yhe[m ?? 0]);
            },
            defaultValue: c,
            size: "small"
          }
        )
      ]
    }
  );
}, jCe = ({
  options: e,
  value: t,
  onChange: n,
  color: o = "primary",
  disabled: s = !1
}) => {
  const i = sn(), [a, l] = jt(t), c = (u) => {
    l(u), n(u);
  };
  return Nt(() => {
    l(t);
  }, [t]), /* @__PURE__ */ C(
    vt,
    {
      sx: {
        display: "flex",
        border: `1px solid ${i.palette.divider}`
      },
      children: e.map((u, d) => /* @__PURE__ */ ie(
        Io,
        {
          sx: {
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            gap: i.spacing(1),
            padding: i.spacing(2),
            border: "1px solid transparent",
            borderRadius: 0,
            backgroundColor: u.id === a ? i.palette[o].background : i.palette.background.default,
            borderBottom: u.id === a ? `3px solid ${i.palette[o].main}` : "3px solid transparent",
            flex: 1,
            cursor: "pointer",
            borderRight: d < e.length - 1 ? `1px solid ${i.palette.divider}` : "1px solid transparent",
            transition: "none",
            "&:hover": {
              border: "1px solid transparent",
              borderRight: d < e.length - 1 ? `1px solid ${i.palette.divider}` : "1px solid transparent",
              borderBottom: u.id === a ? `3px solid ${i.palette[o].main}` : "3px solid transparent"
            }
          },
          onClick: () => c(u.id),
          disabled: s,
          children: [
            u.icon && /* @__PURE__ */ C(
              yo,
              {
                sx: {
                  color: i.palette[o].main,
                  opacity: s ? 0.38 : 1,
                  alignSelf: "center"
                },
                children: u.icon
              }
            ),
            /* @__PURE__ */ ie(
              vt,
              {
                sx: {
                  display: "flex",
                  flexDirection: "column",
                  gap: i.spacing(0.5),
                  textAlign: "left"
                },
                children: [
                  /* @__PURE__ */ C(
                    Cs,
                    {
                      variant: "body2",
                      color: "text.primary",
                      sx: { fontWeight: "bold" },
                      children: u.title
                    }
                  ),
                  /* @__PURE__ */ C(Cs, { variant: "caption", color: "text.secondary", children: u.description })
                ]
              }
            )
          ]
        },
        u.id
      ))
    }
  );
}, GCe = ({
  value: e,
  defaultValue: t,
  step: n,
  marks: o,
  min: s,
  max: i,
  onChangeCommitted: a,
  onChange: l,
  ...c
}) => /* @__PURE__ */ C(
  RM,
  {
    value: e,
    defaultValue: t,
    step: n,
    marks: o,
    min: s,
    max: i,
    onChangeCommitted: a,
    onChange: l,
    ...c
  }
), qCe = ({
  edge: e = "end",
  color: t = "success",
  ...n
}) => /* @__PURE__ */ C(vC, { edge: e, color: t, ...n }), WCe = ({ children: e, ...t }) => /* @__PURE__ */ C(Iu, { ...t, children: e }), UCe = ({
  children: e,
  ...t
}) => /* @__PURE__ */ C(SC, { ...t, children: e }), KCe = ({ children: e, ...t }) => /* @__PURE__ */ C(Ou, { ...t, children: e }), YCe = ({ children: e, ...t }) => /* @__PURE__ */ C(rl, { ...t, children: e }), XCe = ({ children: e, ...t }) => /* @__PURE__ */ C(PM, { ...t, children: e }), QCe = ({ children: e, ...t }) => /* @__PURE__ */ C(Us, { ...t, children: e }), ZCe = ({ children: e, ...t }) => /* @__PURE__ */ C(Wo, { ...t, children: e });
function mA(e, t, n) {
  const o = e.slice();
  return o.splice(n < 0 ? o.length + n : n, 0, o.splice(t, 1)[0]), o;
}
function Xhe(e, t) {
  return e.reduce((n, o, s) => {
    const i = t.get(o);
    return i && (n[s] = i), n;
  }, Array(e.length));
}
function Vd(e) {
  return e !== null && e >= 0;
}
function Qhe(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
function Zhe(e) {
  return typeof e == "boolean" ? {
    draggable: e,
    droppable: e
  } : e;
}
const bA = (e) => {
  let {
    rects: t,
    activeIndex: n,
    overIndex: o,
    index: s
  } = e;
  const i = mA(t, o, n), a = t[s], l = i[s];
  return !l || !a ? null : {
    x: l.left - a.left,
    y: l.top - a.top,
    scaleX: l.width / a.width,
    scaleY: l.height / a.height
  };
}, Bd = {
  scaleX: 1,
  scaleY: 1
}, Jhe = (e) => {
  var t;
  let {
    activeIndex: n,
    activeNodeRect: o,
    index: s,
    rects: i,
    overIndex: a
  } = e;
  const l = (t = i[n]) != null ? t : o;
  if (!l)
    return null;
  if (s === n) {
    const u = i[a];
    return u ? {
      x: 0,
      y: n < a ? u.top + u.height - (l.top + l.height) : u.top - l.top,
      ...Bd
    } : null;
  }
  const c = ege(i, s, n);
  return s > n && s <= a ? {
    x: 0,
    y: -l.height - c,
    ...Bd
  } : s < n && s >= a ? {
    x: 0,
    y: l.height + c,
    ...Bd
  } : {
    x: 0,
    y: 0,
    ...Bd
  };
};
function ege(e, t, n) {
  const o = e[t], s = e[t - 1], i = e[t + 1];
  return o ? n < t ? s ? o.top - (s.top + s.height) : i ? i.top - (o.top + o.height) : 0 : i ? i.top - (o.top + o.height) : s ? o.top - (s.top + s.height) : 0 : 0;
}
const yA = "Sortable", vA = /* @__PURE__ */ en.createContext({
  activeIndex: -1,
  containerId: yA,
  disableTransforms: !1,
  items: [],
  overIndex: -1,
  useDragOverlay: !1,
  sortedRects: [],
  strategy: bA,
  disabled: {
    draggable: !1,
    droppable: !1
  }
});
function tge(e) {
  let {
    children: t,
    id: n,
    items: o,
    strategy: s = bA,
    disabled: i = !1
  } = e;
  const {
    active: a,
    dragOverlay: l,
    droppableRects: c,
    over: u,
    measureDroppableContainers: d
  } = ade(), f = Ku(yA, n), p = l.rect !== null, m = Ye(() => o.map((E) => typeof E == "object" && "id" in E ? E.id : E), [o]), b = a != null, v = a ? m.indexOf(a.id) : -1, g = u ? m.indexOf(u.id) : -1, y = Ft(m), w = !Qhe(m, y.current), x = g !== -1 && v === -1 || w, S = Zhe(i);
  os(() => {
    w && b && d(m);
  }, [w, m, b, d]), Nt(() => {
    y.current = m;
  }, [m]);
  const T = Ye(
    () => ({
      activeIndex: v,
      containerId: f,
      disabled: S,
      disableTransforms: x,
      items: m,
      overIndex: g,
      useDragOverlay: p,
      sortedRects: Xhe(m, c),
      strategy: s
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [v, f, S.draggable, S.droppable, x, m, g, c, p, s]
  );
  return en.createElement(vA.Provider, {
    value: T
  }, t);
}
const nge = (e) => {
  let {
    id: t,
    items: n,
    activeIndex: o,
    overIndex: s
  } = e;
  return mA(n, o, s).indexOf(t);
}, oge = (e) => {
  let {
    containerId: t,
    isSorting: n,
    wasDragging: o,
    index: s,
    items: i,
    newIndex: a,
    previousItems: l,
    previousContainerId: c,
    transition: u
  } = e;
  return !u || !o || l !== i && s === a ? !1 : n ? !0 : a !== s && t === c;
}, rge = {
  duration: 200,
  easing: "ease"
}, CA = "transform", sge = /* @__PURE__ */ ul.Transition.toString({
  property: CA,
  duration: 0,
  easing: "linear"
}), ige = {
  roleDescription: "sortable"
};
function age(e) {
  let {
    disabled: t,
    index: n,
    node: o,
    rect: s
  } = e;
  const [i, a] = jt(null), l = Ft(n);
  return os(() => {
    if (!t && n !== l.current && o.current) {
      const c = s.current;
      if (c) {
        const u = Nl(o.current, {
          ignoreTransform: !0
        }), d = {
          x: c.left - u.left,
          y: c.top - u.top,
          scaleX: c.width / u.width,
          scaleY: c.height / u.height
        };
        (d.x || d.y) && a(d);
      }
    }
    n !== l.current && (l.current = n);
  }, [t, n, o, s]), Nt(() => {
    i && a(null);
  }, [i]), i;
}
function lge(e) {
  let {
    animateLayoutChanges: t = oge,
    attributes: n,
    disabled: o,
    data: s,
    getNewIndex: i = nge,
    id: a,
    strategy: l,
    resizeObserverConfig: c,
    transition: u = rge
  } = e;
  const {
    items: d,
    containerId: f,
    activeIndex: p,
    disabled: m,
    disableTransforms: b,
    sortedRects: v,
    overIndex: g,
    useDragOverlay: y,
    strategy: w
  } = Co(vA), x = cge(o, m), S = d.indexOf(a), T = Ye(() => ({
    sortable: {
      containerId: f,
      index: S,
      items: d
    },
    ...s
  }), [f, s, S, d]), E = Ye(() => d.slice(d.indexOf(a)), [d, a]), {
    rect: O,
    node: M,
    isOver: D,
    setNodeRef: R
  } = ude({
    id: a,
    data: T,
    disabled: x.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: E,
      ...c
    }
  }), {
    active: P,
    activatorEvent: F,
    activeNodeRect: $,
    attributes: N,
    setNodeRef: A,
    listeners: k,
    isDragging: L,
    over: B,
    setActivatorNodeRef: V,
    transform: _
  } = A$({
    id: a,
    data: T,
    attributes: {
      ...ige,
      ...n
    },
    disabled: x.draggable
  }), z = Gce(R, A), j = !!P, W = j && !b && Vd(p) && Vd(g), J = !y && L, G = J && W ? _ : null, Z = W ? G ?? (l ?? w)({
    rects: v,
    activeNodeRect: $,
    activeIndex: p,
    overIndex: g,
    index: S
  }) : null, Y = Vd(p) && Vd(g) ? i({
    id: a,
    items: d,
    activeIndex: p,
    overIndex: g
  }) : S, Q = P == null ? void 0 : P.id, ee = Ft({
    activeId: Q,
    items: d,
    newIndex: Y,
    containerId: f
  }), ne = d !== ee.current.items, H = t({
    active: P,
    containerId: f,
    isDragging: L,
    isSorting: j,
    id: a,
    index: S,
    items: d,
    newIndex: ee.current.newIndex,
    previousItems: ee.current.items,
    previousContainerId: ee.current.containerId,
    transition: u,
    wasDragging: ee.current.activeId != null
  }), U = age({
    disabled: !H,
    index: S,
    node: M,
    rect: O
  });
  return Nt(() => {
    j && ee.current.newIndex !== Y && (ee.current.newIndex = Y), f !== ee.current.containerId && (ee.current.containerId = f), d !== ee.current.items && (ee.current.items = d);
  }, [j, Y, f, d]), Nt(() => {
    if (Q === ee.current.activeId)
      return;
    if (Q != null && ee.current.activeId == null) {
      ee.current.activeId = Q;
      return;
    }
    const re = setTimeout(() => {
      ee.current.activeId = Q;
    }, 50);
    return () => clearTimeout(re);
  }, [Q]), {
    active: P,
    activeIndex: p,
    attributes: N,
    data: T,
    rect: O,
    index: S,
    newIndex: Y,
    items: d,
    isOver: D,
    isSorting: j,
    isDragging: L,
    listeners: k,
    node: M,
    overIndex: g,
    over: B,
    setNodeRef: z,
    setActivatorNodeRef: V,
    setDroppableNodeRef: R,
    setDraggableNodeRef: A,
    transform: U ?? Z,
    transition: X()
  };
  function X() {
    if (
      // Temporarily disable transitions for a single frame to set up derived transforms
      U || // Or to prevent items jumping to back to their "new" position when items change
      ne && ee.current.newIndex === S
    )
      return sge;
    if (!(J && !z0(F) || !u) && (j || H))
      return ul.Transition.toString({
        ...u,
        property: CA
      });
  }
}
function cge(e, t) {
  var n, o;
  return typeof e == "boolean" ? {
    draggable: e,
    // Backwards compatibility
    droppable: !1
  } : {
    draggable: (n = e == null ? void 0 : e.draggable) != null ? n : t.draggable,
    droppable: (o = e == null ? void 0 : e.droppable) != null ? o : t.droppable
  };
}
Ht.Down, Ht.Right, Ht.Up, Ht.Left;
var Pb, KI;
function uge() {
  if (KI) return Pb;
  KI = 1;
  var e = ea(), t = function() {
    return e.Date.now();
  };
  return Pb = t, Pb;
}
var Mb, YI;
function dge() {
  if (YI) return Mb;
  YI = 1;
  var e = /\s/;
  function t(n) {
    for (var o = n.length; o-- && e.test(n.charAt(o)); )
      ;
    return o;
  }
  return Mb = t, Mb;
}
var kb, XI;
function fge() {
  if (XI) return kb;
  XI = 1;
  var e = dge(), t = /^\s+/;
  function n(o) {
    return o && o.slice(0, e(o) + 1).replace(t, "");
  }
  return kb = n, kb;
}
var Db, QI;
function pge() {
  if (QI) return Db;
  QI = 1;
  var e = Cl(), t = ta(), n = "[object Symbol]";
  function o(s) {
    return typeof s == "symbol" || t(s) && e(s) == n;
  }
  return Db = o, Db;
}
var Nb, ZI;
function hge() {
  if (ZI) return Nb;
  ZI = 1;
  var e = fge(), t = ks(), n = pge(), o = NaN, s = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, a = /^0o[0-7]+$/i, l = parseInt;
  function c(u) {
    if (typeof u == "number")
      return u;
    if (n(u))
      return o;
    if (t(u)) {
      var d = typeof u.valueOf == "function" ? u.valueOf() : u;
      u = t(d) ? d + "" : d;
    }
    if (typeof u != "string")
      return u === 0 ? u : +u;
    u = e(u);
    var f = i.test(u);
    return f || a.test(u) ? l(u.slice(2), f ? 2 : 8) : s.test(u) ? o : +u;
  }
  return Nb = c, Nb;
}
var $b, JI;
function gge() {
  if (JI) return $b;
  JI = 1;
  var e = ks(), t = uge(), n = hge(), o = "Expected a function", s = Math.max, i = Math.min;
  function a(l, c, u) {
    var d, f, p, m, b, v, g = 0, y = !1, w = !1, x = !0;
    if (typeof l != "function")
      throw new TypeError(o);
    c = n(c) || 0, e(u) && (y = !!u.leading, w = "maxWait" in u, p = w ? s(n(u.maxWait) || 0, c) : p, x = "trailing" in u ? !!u.trailing : x);
    function S($) {
      var N = d, A = f;
      return d = f = void 0, g = $, m = l.apply(A, N), m;
    }
    function T($) {
      return g = $, b = setTimeout(M, c), y ? S($) : m;
    }
    function E($) {
      var N = $ - v, A = $ - g, k = c - N;
      return w ? i(k, p - A) : k;
    }
    function O($) {
      var N = $ - v, A = $ - g;
      return v === void 0 || N >= c || N < 0 || w && A >= p;
    }
    function M() {
      var $ = t();
      if (O($))
        return D($);
      b = setTimeout(M, E($));
    }
    function D($) {
      return b = void 0, x && d ? S($) : (d = f = void 0, m);
    }
    function R() {
      b !== void 0 && clearTimeout(b), g = 0, d = v = f = b = void 0;
    }
    function P() {
      return b === void 0 ? m : D(t());
    }
    function F() {
      var $ = t(), N = O($);
      if (d = arguments, f = this, v = $, N) {
        if (b === void 0)
          return T(v);
        if (w)
          return clearTimeout(b), b = setTimeout(M, c), S(v);
      }
      return b === void 0 && (b = setTimeout(M, c)), m;
    }
    return F.cancel = R, F.flush = P, F;
  }
  return $b = a, $b;
}
var mge = gge();
const bge = /* @__PURE__ */ Zo(mge), yge = jp(() => ({
  centered: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }
})), vge = ({
  centered: e,
  size: t = 40,
  minSeconds: n = 1,
  maxSeconds: o = 3,
  placeholderElement: s = null
}) => {
  const i = yge(), [a, l] = jt(!1);
  return Nt(() => {
    const c = setTimeout(
      () => {
        l(!0);
      },
      ((o - n) * Math.random() + n) * 1e3
    );
    return () => {
      c && clearTimeout(c);
    };
  }), a ? e ? /* @__PURE__ */ C("div", { className: i.centered, children: /* @__PURE__ */ C(my, { size: t }) }) : /* @__PURE__ */ C(my, { size: t }) : /* @__PURE__ */ C(mo, { children: s });
}, Cge = ({
  variant: e = "outlined",
  color: t = "primary",
  autoFocus: n = !0,
  fullWidth: o = !0,
  size: s,
  endAdornment: i,
  ...a
}) => /* @__PURE__ */ C(
  Is,
  {
    InputProps: {
      startAdornment: /* @__PURE__ */ C(yl, { position: "start", children: /* @__PURE__ */ C(yo, { style: { alignSelf: "center" }, children: "search" }) }),
      endAdornment: i
    },
    color: t,
    size: s,
    variant: e,
    autoFocus: n,
    fullWidth: o,
    ...a
  }
), wge = 95, Sge = jp((e) => ({
  searchContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px"
  },
  tableContainer: {
    maxHeight: (t) => t.maxHeight,
    minHeight: (t) => t.minHeight,
    overflowY: "auto"
  },
  table: {
    backgroundColor: e.palette.background.default,
    borderRadius: e.shape.borderRadius,
    overflowY: "auto",
    height: "100%"
  },
  tableHead: {
    borderRadius: e.shape.borderRadius,
    boxShadow: `0px 0px 0px 1px ${e.palette.divider} inset`,
    backgroundColor: e.palette.secondary.background,
    position: "sticky",
    top: 0,
    zIndex: 1
  },
  tableHeadCell: {
    fontWeight: 700,
    width: "200px"
  },
  tableRow: {
    backgroundColor: e.palette.background.default,
    boxShadow: `-1px 0px 0px 0px ${e.palette.divider} inset,1px 0px 0px 0px ${e.palette.divider} inset`,
    "&:hover": {
      backgroundColor: e.palette.action.hover,
      cursor: "pointer"
    }
  },
  tableRowSelected: {
    transition: "0.2s",
    backgroundColor: e.palette.action.selected,
    "&:hover": {
      backgroundColor: e.palette.action.selectedOpacity
    }
  },
  button: {
    height: "56px",
    marginLeft: "10px",
    backgroundColor: e.palette.error.main,
    color: e.palette.error.contrastText,
    "&:hover": {
      backgroundColor: e.palette.error.main,
      transform: "scale(1.02)"
    }
  },
  buttonIcon: { marginRight: "10px" }
})), xge = ({
  onClick: e,
  className: t,
  row: n,
  columns: o,
  drag: s,
  rowRef: i,
  onFocus: a,
  onBlur: l,
  onKeyDown: c,
  onSelectRow: u,
  selectedRows: d
}) => {
  const { attributes: f, listeners: p, setNodeRef: m, transform: b, transition: v } = lge({
    id: n.id,
    disabled: !s || s && s.isRowDisabled && (s == null ? void 0 : s.isRowDisabled(n))
  }), g = u !== void 0, y = {
    transform: ul.Transform.toString(b),
    transition: v || void 0
  }, w = { ...f, ...p }, x = s && !s.useHandle ? w : {};
  return /* @__PURE__ */ ie(
    Us,
    {
      ...x,
      onClick: e,
      className: t,
      style: y,
      ref: (S) => {
        i(S), m(S);
      },
      tabIndex: 0,
      onFocus: a,
      onBlur: l,
      onKeyDown: c,
      children: [
        g && /* @__PURE__ */ C(
          Wo,
          {
            style: { width: "3rem", textAlign: "center" },
            children: /* @__PURE__ */ C(
              ml,
              {
                checked: d == null ? void 0 : d.some(
                  (S) => S.id === n.id
                ),
                onChange: (S) => {
                  S.preventDefault(), S.stopPropagation(), u && u(n);
                }
              }
            )
          },
          "checkbox"
        ),
        o.map((S, T) => /* @__PURE__ */ C(Wo, { children: /* @__PURE__ */ ie("div", { style: { display: "flex", alignItems: "center" }, children: [
          T === 0 && s && s.useHandle ? /* @__PURE__ */ C(
            yo,
            {
              ...w,
              style: { cursor: "grab", marginRight: "10px" },
              onClick: (E) => E.stopPropagation(),
              children: "drag_indicator"
            }
          ) : null,
          typeof S.accessor == "string" ? n[S.accessor] : S.accessor(n)
        ] }) }, n.id + S.title))
      ]
    }
  );
}, JCe = ({
  onScrollEnd: e = () => {
  },
  onSearch: t,
  isSelected: n,
  columns: o,
  rows: s,
  onRowClick: i = () => {
  },
  onRowFocus: a = () => {
  },
  searchFilter: l,
  searchFilterPlaceholder: c,
  drag: u,
  noMatchPlaceholder: d = "No matches found, try clearing your filter",
  maxHeight: f = "525px",
  style: p,
  selectedRows: m,
  onSelectRows: b,
  withoutHeader: v = !1,
  isLoading: g = !1,
  minHeight: y = "auto"
}) => {
  const w = Sge({ maxHeight: f, minHeight: y }), x = Ft(null), S = sn(), T = v$(Jf(q0), Jf(W0)), E = b !== void 0, O = Ye(() => m ?? [], [m]), [M, D] = jt(null), R = Ye(() => s == null ? void 0 : s.map(({ id: G }) => G), [s]), [P, F] = jt(""), $ = Ft([]), N = (G, q) => {
    G && ($.current[q] = G);
  }, A = l && !t ? s.filter((G) => l(G, P)) : s, k = pt(() => {
    D(null);
  }, []), L = pt(
    (G) => {
      u && D(G.active.id);
    },
    [u]
  ), B = pt(
    (G) => {
      const q = s.findIndex((ee) => {
        var ne;
        return ee.id === ((ne = G.over) == null ? void 0 : ne.id);
      }), Z = s.findIndex((ee) => ee.id === M), Y = s[q], Q = s[Z];
      !Y || !Q || (u == null || u.onSortEnd(Z, q, Q, Y), D(null));
    },
    [M, u, s]
  );
  Nt(() => {
    if (u) {
      const G = s.map((Z) => Z.id);
      new Set(G).size !== G.length && console.warn(
        "Duplicate row IDs found, drag and drop will not work correctly."
      );
    }
  }, [u, s]);
  const V = pt(
    (G) => {
      if (E) {
        const q = O.some(
          (Z) => Z.id === G.id
        );
        b(
          q ? O.filter(
            (Z) => Z.id !== G.id
          ) : [...O, G]
        );
      }
    },
    [E, O, b]
  ), _ = pt(
    bge((G) => {
      var q;
      t && ((q = x.current) == null || q.scrollTo({
        top: 0,
        behavior: "smooth"
      }), t(G));
    }, 300),
    [t]
  ), z = pt(
    (G) => {
      _(G), F(G);
    },
    [_]
  ), j = () => /* @__PURE__ */ ie(Iu, { className: w.table, children: [
    !v && /* @__PURE__ */ ie(Ou, { className: w.tableHead, children: [
      E && /* @__PURE__ */ C(
        Wo,
        {
          className: w.tableHeadCell,
          style: { width: "3rem", textAlign: "center" },
          children: /* @__PURE__ */ C(
            ml,
            {
              checked: (O == null ? void 0 : O.length) === s.length && !!(s != null && s.length),
              indeterminate: (O == null ? void 0 : O.length) > 0 && (O == null ? void 0 : O.length) < s.length,
              onChange: () => {
                (O == null ? void 0 : O.length) === s.length ? b([]) : b(A);
              }
            }
          )
        },
        "checkbox"
      ),
      o.map((G) => /* @__PURE__ */ C(
        Wo,
        {
          className: w.tableHeadCell,
          style: { width: G.width, textAlign: G.align },
          children: G.titleComponent || G.title
        },
        G.title
      ))
    ] }),
    g ? /* @__PURE__ */ C(rl, { children: /* @__PURE__ */ C(vge, {}) }) : /* @__PURE__ */ C(
      rl,
      {
        sx: {
          borderTop: v ? `1px solid ${S.palette.divider}` : void 0
        },
        children: A.length === 0 ? /* @__PURE__ */ C(Us, { className: w.tableRow, children: /* @__PURE__ */ C(Wo, { colSpan: o.length + 1, children: /* @__PURE__ */ C(yn, { color: "grey", children: d }) }) }) : A.map((G, q) => /* @__PURE__ */ C(
          xge,
          {
            row: G,
            columns: o,
            drag: u,
            rowRef: (Z) => N(Z, q),
            selectedRows: O,
            onSelectRow: E ? V : void 0,
            className: n && n(G) ? `${w.tableRow} ${w.tableRowSelected}` : w.tableRow,
            onClick: (Z) => {
              if (Z.ctrlKey || Z.metaKey) {
                V(G);
                return;
              }
              if (Z.shiftKey && O.length > 0 && E) {
                Z.preventDefault(), Z.stopPropagation();
                const Y = A.findIndex(
                  (U) => U.id === O[0].id
                ), Q = A.findIndex(
                  (U) => U.id === G.id
                ), ee = Math.min(
                  Y,
                  Q
                ), ne = Math.max(
                  Y,
                  Q
                ), H = A.slice(
                  ee,
                  ne + 1
                );
                b(H);
                return;
              }
              i && i(G);
            },
            onFocus: () => {
              a && a(G);
            },
            onKeyDown: W
          },
          G.id
        ))
      }
    )
  ] }), W = (G) => {
    if (G.preventDefault(), !n) return;
    const q = A.findIndex((Z) => n(Z));
    G.key === "ArrowDown" && q < A.length - 1 ? i && i(A[q + 1]) : G.key === "ArrowUp" && q > 0 && i && i(A[q - 1]);
  }, J = (G) => {
    const q = G.target;
    q.scrollTop / (q.scrollHeight - q.clientHeight) * 100 >= wge && e();
  };
  return /* @__PURE__ */ ie("div", { style: p, children: [
    (l || t) && /* @__PURE__ */ ie("div", { className: w.searchContainer, children: [
      /* @__PURE__ */ C(
        Cge,
        {
          id: "search-input",
          value: P,
          size: "medium",
          fullWidth: !1,
          placeholder: c,
          onChange: (G) => z(G.target.value)
        }
      ),
      P && /* @__PURE__ */ ie(Io, { onClick: () => z(""), className: w.button, children: [
        /* @__PURE__ */ C(yo, { fontSize: "small", className: w.buttonIcon, children: "cancel" }),
        "Clear filter"
      ] })
    ] }),
    /* @__PURE__ */ C(
      "div",
      {
        className: w.tableContainer,
        onScroll: J,
        ref: x,
        children: u ? /* @__PURE__ */ C(
          $$,
          {
            sensors: T,
            onDragStart: L,
            onDragCancel: k,
            onDragEnd: B,
            collisionDetection: lue,
            modifiers: [fde],
            children: /* @__PURE__ */ C(
              tge,
              {
                items: R,
                strategy: Jhe,
                children: j()
              }
            )
          }
        ) : j()
      }
    )
  ] });
}, e0e = ({ headers: e, rows: t }) => /* @__PURE__ */ ie(Iu, { children: [
  e && /* @__PURE__ */ C(Ou, { children: /* @__PURE__ */ C(Us, { children: e.map(({ children: n, ...o }) => /* @__PURE__ */ C(Wo, { ...o, children: n }, n == null ? void 0 : n.toString())) }) }),
  /* @__PURE__ */ C(rl, { children: t.map((n) => /* @__PURE__ */ C(Us, { children: n.cells.map(({ children: o, ...s }) => /* @__PURE__ */ C(Wo, { ...s, children: o }, o == null ? void 0 : o.toString())) }, n.key)) })
] }), t0e = ({
  children: e,
  color: t = "primary",
  inText: n
}) => /* @__PURE__ */ C(Gt, { sx: { display: n ? "inline" : void 0 }, children: /* @__PURE__ */ C(
  Cs,
  {
    sx: (o) => ({
      backgroundColor: o.palette[t].background,
      color: o.palette.text.primary
    }),
    component: "span",
    children: e
  }
) });
var wA = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e))(wA || {});
const Tge = {
  small: "caption",
  medium: "body1",
  large: "h6"
}, Rge = ({
  label: e,
  value: t,
  icon: n,
  buttonColor: o,
  size: s = "small",
  ...i
}) => {
  const { ...a } = i, l = Tge[s];
  return /* @__PURE__ */ C(
    CC,
    {
      disableRipple: !0,
      value: t,
      label: e,
      iconPosition: "start",
      icon: Pf(n) ? /* @__PURE__ */ C(yo, { children: n }) : n,
      sx: (c) => {
        var u;
        return {
          margin: 0,
          padding: 0,
          paddingBottom: 1,
          minWidth: "auto",
          minHeight: "auto",
          textTransform: "none",
          fontSize: c.typography[l].fontSize,
          color: c.palette.text.secondary,
          "&.Mui-selected": {
            color: o !== "inherit" && ((u = c.palette[o]) == null ? void 0 : u.main) || c.palette.primary.main
          },
          "& .MuiTab-icon": {
            marginRight: 0.5
          }
        };
      },
      ...a
    }
  );
}, Ege = ({
  value: e,
  onChange: t,
  items: n,
  color: o = "primary",
  size: s = "small",
  ...i
}) => /* @__PURE__ */ C(
  xC,
  {
    sx: (l) => {
      var c;
      return {
        margin: 0,
        marginTop: 2,
        marginBottom: 2,
        padding: 0,
        minHeight: "auto",
        "& .MuiTabs-indicator": {
          backgroundColor: o !== "inherit" && ((c = l.palette[o]) == null ? void 0 : c.main) || l.palette.primary.main
        },
        "& .MuiTabs-flexContainer": {
          gap: 2
        }
      };
    },
    value: e,
    onChange: (l, c) => {
      t(c);
    },
    "data-cy": i["data-cy"],
    children: n.map((l) => /* @__PURE__ */ C(
      Rge,
      {
        "data-cy": `${i["data-cy"]}-${l.value}`,
        buttonColor: o,
        size: s,
        ...l
      },
      l.value
    ))
  }
), Ige = ({
  value: e,
  onChange: t,
  items: n,
  ...o
}) => {
  const s = n.find((i) => i.value === e);
  return /* @__PURE__ */ C(
    $C,
    {
      "data-cy": o["data-cy"],
      variant: "text",
      label: (s == null ? void 0 : s.label) || "",
      icon: s == null ? void 0 : s.icon,
      value: (s == null ? void 0 : s.value) || "",
      handleChange: t,
      items: n
    }
  );
}, n0e = ({
  value: e,
  onChange: t,
  items: n,
  responsiveMenu: o,
  type: s = "tabs",
  size: i = wA.SMALL,
  color: a,
  ...l
}) => NC() && (o || s === "menu") ? /* @__PURE__ */ C(
  Ige,
  {
    onChange: t,
    value: e,
    items: n,
    "data-cy": l["data-cy"]
  }
) : /* @__PURE__ */ C(
  Ege,
  {
    onChange: t,
    value: e,
    items: n,
    "data-cy": l["data-cy"],
    color: a,
    size: i
  }
), o0e = ({ children: e, ...t }) => /* @__PURE__ */ C(QP, { ...t, children: e }), Oge = () => " ", r0e = ({
  prefix: e,
  variant: t = "body2"
}) => /* @__PURE__ */ C(Gt, { sx: { display: "flex", flexDirection: "row", alignItems: "baseline" }, children: /* @__PURE__ */ ie(mo, { children: [
  e && /* @__PURE__ */ ie(mo, { children: [
    /* @__PURE__ */ C(Cs, { variant: t, component: "span", children: e }),
    /* @__PURE__ */ C(Oge, {})
  ] }),
  /* @__PURE__ */ C(
    Cs,
    {
      variant: t,
      component: "span",
      sx: (n) => ({
        fontWeight: "bold",
        background: `linear-gradient(to top, ${n.palette.primary.main} 0%, ${n.palette.highlight.main} 100%)`,
        backgroundClip: "text",
        color: "transparent",
        textFillColor: "transparent"
      }),
      children: "Numa AI"
    }
  )
] }) }), s0e = ({ children: e, ...t }) => /* @__PURE__ */ C(nM, { ...t, children: e }), i0e = (e) => /* @__PURE__ */ C(jc, { ...e }), a0e = ({ children: e, ...t }) => /* @__PURE__ */ C(lM, { ...t, children: e }), l0e = ({ children: e, ...t }) => /* @__PURE__ */ C(gs, { ...t, children: e }), c0e = ({ children: e, ...t }) => /* @__PURE__ */ C(yl, { ...t, children: e }), u0e = ({ children: e, ...t }) => /* @__PURE__ */ C(Ru, { ...t, children: e }), Pge = "data:image/svg+xml,%3csvg%20width='148'%20height='148'%20viewBox='0%200%20148%20148'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M120.602%2078.997C119.993%2078.997%20119.491%2079.4515%20119.41%2080.0556C116.438%20102.465%2097.21%20119.815%2074.0009%20119.815C50.7918%20119.815%2031.5643%20102.465%2028.5914%2080.0556C28.5112%2079.4515%2028.0091%2078.997%2027.4%2078.997H1.51598C0.801688%2078.997%200.227994%2079.6123%200.288362%2080.3239C3.51009%20118.176%2035.3293%20148%2074.0009%20148C91.292%20148%20107.205%20142.022%20119.816%20132.047V144.82C135.383%20144.82%20148.002%20132.201%20148.002%20116.635V80.2153C148.002%2079.5422%20147.456%2078.997%20146.783%2078.997H120.602Z'%20fill='%23050712'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M27.3998%2069.003C28.009%2069.003%2028.5114%2068.5485%2028.5913%2067.9444C31.5633%2045.5353%2050.7912%2028.1854%2074.0007%2028.1854C97.2106%2028.1854%20116.438%2045.5353%20119.411%2067.9444C119.49%2068.5485%20119.993%2069.003%20120.602%2069.003H146.486C147.2%2069.003%20147.774%2068.3876%20147.713%2067.6761C144.493%2029.8232%20112.673%200%2074.0007%200C56.7101%200%2040.7974%205.97764%2028.1858%2015.9524V3.18005C12.6193%203.18005%200%2015.7994%200%2031.3655V67.7848C0%2068.4578%200.545652%2069.003%201.21827%2069.003H27.3998Z'%20fill='%23050712'/%3e%3c/svg%3e", Mge = "data:image/svg+xml,%3csvg%20width='148'%20height='148'%20viewBox='0%200%20148%20148'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M120.602%2078.997C119.993%2078.997%20119.491%2079.4515%20119.41%2080.0556C116.438%20102.465%2097.21%20119.815%2074.0009%20119.815C50.7918%20119.815%2031.5643%20102.465%2028.5914%2080.0556C28.5112%2079.4515%2028.0091%2078.997%2027.4%2078.997H1.51598C0.801688%2078.997%200.227994%2079.6124%200.288362%2080.3239C3.51009%20118.176%2035.3293%20148%2074.0009%20148C91.292%20148%20107.205%20142.022%20119.816%20132.047V144.82C135.383%20144.82%20148.002%20132.201%20148.002%20116.635V80.2153C148.002%2079.5422%20147.456%2078.997%20146.783%2078.997H120.602Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M27.3998%2069.003C28.009%2069.003%2028.5114%2068.5485%2028.5913%2067.9444C31.5633%2045.5353%2050.7912%2028.1854%2074.0007%2028.1854C97.2106%2028.1854%20116.438%2045.5353%20119.411%2067.9444C119.49%2068.5485%20119.993%2069.003%20120.602%2069.003H146.486C147.2%2069.003%20147.774%2068.3876%20147.713%2067.6761C144.493%2029.8232%20112.673%200%2074.0007%200C56.7101%200%2040.7974%205.97764%2028.1858%2015.9524V3.18005C12.6193%203.18005%200%2015.7994%200%2031.3655V67.7848C0%2068.4578%200.545652%2069.003%201.21827%2069.003H27.3998Z'%20fill='white'/%3e%3c/svg%3e", kge = "data:image/svg+xml,%3csvg%20width='718'%20height='148'%20viewBox='0%200%20718%20148'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%20144.303V32.0426C0%2016.5046%2012.596%203.9076%2028.134%203.9076V23.7056C36.467%209.1186%2052.616%200.261597%2072.672%200.261597C88.043%200.261597%20101.065%205.2106%20111.745%2015.3696C122.424%2025.5276%20127.893%2039.8536%20127.893%2058.8686V116.169C127.893%20131.707%20115.297%20144.303%2099.759%20144.303H98.982V66.9426C98.982%2041.1566%2085.438%2026.8306%2065.382%2026.8306C43.761%2026.8306%2028.652%2043.5006%2028.652%2067.4646V116.169C28.652%20131.707%2016.056%20144.303%200.518%20144.303H0Z'%20fill='%23050712'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M529.942%2016.412C540.362%2027.091%20545.572%2041.937%20545.572%2060.432V116.169C545.572%20131.707%20532.976%20144.303%20517.438%20144.303H516.92V65.12C516.92%2040.375%20504.417%2026.83%20484.882%2026.83C464.042%2026.83%20449.717%2042.198%20449.717%2065.901V116.169C449.717%20131.707%20437.121%20144.303%20421.583%20144.303H421.065V65.64C421.065%2041.417%20408.562%2026.83%20388.768%2026.83C367.927%2026.83%20353.34%2042.459%20353.34%2066.423V116.169C353.34%20131.707%20340.744%20144.303%20325.206%20144.303H324.688V32.042C324.688%2016.504%20337.284%203.908%20352.822%203.908V24.225C361.156%209.379%20376.786%200%20395.277%200C413.772%200.262%20430.963%209.379%20438.516%2025.788C448.156%2010.16%20467.69%200%20489.308%200C506.241%200%20519.784%205.472%20529.942%2016.412Z'%20fill='%23050712'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M690.903%2068.4613C690.484%2068.4613%20690.137%2068.1433%20690.091%2067.7273C688.927%2057.2583%20684.905%2048.2193%20677.97%2040.6343C669.638%2031.5193%20658.699%2026.8303%20645.415%2026.8303C632.13%2026.8303%20621.451%2031.5193%20612.855%2040.6343C605.669%2048.2553%20601.604%2057.3423%20600.456%2067.7233C600.409%2068.1423%20600.061%2068.4613%20599.64%2068.4613H573.417C572.955%2068.4613%20572.58%2068.0863%20572.58%2067.6253V31.5203C572.58%2016.2703%20584.943%203.90831%20600.194%203.90831V23.4443C612.956%208.07731%20629.105%200.522308%20648.117%200.522308C668.177%200.522308%20685.107%207.29431%20698.391%2021.1003C710.464%2033.6453%20716.873%2049.0313%20717.952%2067.5623C717.98%2068.0473%20717.59%2068.4613%20717.104%2068.4613H690.903Z'%20fill='%23050712'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M690.929%2079.7489C690.508%2079.7489%20690.16%2080.0679%20690.113%2080.4859C688.943%2090.9539%20684.887%2099.9939%20677.736%20107.577C669.139%20116.692%20658.461%20121.381%20645.176%20121.381C631.891%20121.381%20620.953%20116.954%20612.62%20107.838C605.626%20100.19%20601.589%2091.0659%20600.463%2080.4849C600.419%2080.0679%20600.072%2079.7489%20599.652%2079.7489H573.569C573.075%2079.7489%20572.679%2080.1739%20572.718%2080.6669C574.103%2098.4999%20580.509%20113.734%20592.189%20126.33C605.474%20140.656%20622.403%20147.688%20642.463%20147.688C661.475%20147.688%20677.625%20140.137%20690.387%20125.027V144.303C705.637%20144.303%20718%20131.94%20718%20116.691V80.5859C718%2080.1239%20717.625%2079.7489%20717.163%2079.7489H690.929Z'%20fill='%23050712'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M289.242%203.7045V115.921C289.242%20131.452%20276.651%20144.044%20261.119%20144.044V124.254C252.789%20138.835%20236.647%20147.688%20216.599%20147.688C201.234%20147.688%20188.217%20142.742%20177.542%20132.585C166.867%20122.432%20161.4%20108.113%20161.4%2089.1055V31.8275C161.4%2016.2955%20173.991%203.7045%20189.523%203.7045H190.3V81.0345C190.3%20106.811%20203.838%20121.131%20223.886%20121.131C245.498%20121.131%20260.601%20104.466%20260.601%2080.5125V31.8275C260.601%2016.2955%20273.192%203.7045%20288.724%203.7045H289.242Z'%20fill='%23050712'/%3e%3c/svg%3e", Dge = "data:image/svg+xml,%3csvg%20width='718'%20height='148'%20viewBox='0%200%20718%20148'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%20144.303V32.0426C0%2016.5046%2012.596%203.9076%2028.134%203.9076V23.7056C36.467%209.1186%2052.616%200.2616%2072.672%200.2616C88.043%200.2616%20101.065%205.2106%20111.745%2015.3696C122.424%2025.5276%20127.893%2039.8536%20127.893%2058.8686V116.169C127.893%20131.707%20115.297%20144.303%2099.759%20144.303H98.982V66.9426C98.982%2041.1566%2085.438%2026.8306%2065.382%2026.8306C43.761%2026.8306%2028.652%2043.5006%2028.652%2067.4646V116.169C28.652%20131.707%2016.056%20144.303%200.518%20144.303H0Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M529.942%2016.412C540.362%2027.091%20545.572%2041.937%20545.572%2060.432V116.169C545.572%20131.707%20532.976%20144.303%20517.438%20144.303H516.92V65.12C516.92%2040.375%20504.417%2026.83%20484.882%2026.83C464.042%2026.83%20449.717%2042.198%20449.717%2065.901V116.169C449.717%20131.707%20437.121%20144.303%20421.583%20144.303H421.065V65.64C421.065%2041.417%20408.562%2026.83%20388.768%2026.83C367.927%2026.83%20353.34%2042.459%20353.34%2066.423V116.169C353.34%20131.707%20340.744%20144.303%20325.206%20144.303H324.688V32.042C324.688%2016.504%20337.284%203.908%20352.822%203.908V24.225C361.156%209.379%20376.786%200%20395.277%200C413.772%200.262%20430.963%209.379%20438.516%2025.788C448.156%2010.16%20467.69%200%20489.308%200C506.241%200%20519.784%205.472%20529.942%2016.412Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M690.903%2068.4613C690.484%2068.4613%20690.137%2068.1433%20690.091%2067.7273C688.927%2057.2583%20684.905%2048.2193%20677.97%2040.6343C669.638%2031.5193%20658.699%2026.8303%20645.415%2026.8303C632.13%2026.8303%20621.451%2031.5193%20612.855%2040.6343C605.669%2048.2553%20601.604%2057.3423%20600.456%2067.7233C600.409%2068.1423%20600.061%2068.4613%20599.64%2068.4613H573.417C572.955%2068.4613%20572.58%2068.0863%20572.58%2067.6253V31.5203C572.58%2016.2703%20584.943%203.9083%20600.194%203.9083V23.4443C612.956%208.0773%20629.105%200.522301%20648.117%200.522301C668.177%200.522301%20685.107%207.2943%20698.391%2021.1003C710.464%2033.6453%20716.873%2049.0313%20717.952%2067.5623C717.98%2068.0473%20717.59%2068.4613%20717.104%2068.4613H690.903Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M690.929%2079.7489C690.508%2079.7489%20690.16%2080.0679%20690.113%2080.4859C688.943%2090.9539%20684.887%2099.9939%20677.736%20107.577C669.139%20116.692%20658.461%20121.381%20645.176%20121.381C631.891%20121.381%20620.953%20116.954%20612.62%20107.838C605.626%20100.19%20601.589%2091.0659%20600.463%2080.4849C600.419%2080.0679%20600.072%2079.7489%20599.652%2079.7489H573.569C573.075%2079.7489%20572.679%2080.1739%20572.718%2080.6669C574.103%2098.4999%20580.509%20113.734%20592.189%20126.33C605.474%20140.656%20622.403%20147.688%20642.463%20147.688C661.475%20147.688%20677.625%20140.137%20690.387%20125.027V144.303C705.637%20144.303%20718%20131.94%20718%20116.691V80.5859C718%2080.1239%20717.625%2079.7489%20717.163%2079.7489H690.929Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M289.242%203.7045V115.921C289.242%20131.453%20276.651%20144.044%20261.119%20144.044V124.254C252.789%20138.835%20236.647%20147.688%20216.599%20147.688C201.234%20147.688%20188.217%20142.742%20177.542%20132.585C166.867%20122.432%20161.4%20108.113%20161.4%2089.1055V31.8275C161.4%2016.2955%20173.991%203.7045%20189.523%203.7045H190.3V81.0345C190.3%20106.811%20203.838%20121.131%20223.886%20121.131C245.498%20121.131%20260.601%20104.467%20260.601%2080.5125V31.8275C260.601%2016.2955%20273.192%203.7045%20288.724%203.7045H289.242Z'%20fill='white'/%3e%3c/svg%3e", d0e = ({ type: e, color: t, ...n }) => {
  let o;
  return e === "icon" ? o = t === "primary" ? Pge : Mge : o = t === "primary" ? kge : Dge, /* @__PURE__ */ C("img", { src: o, alt: "Numa", ...n });
}, f0e = ({ children: e, ...t }) => /* @__PURE__ */ C(Tu, { ...t, children: e }), p0e = ({ children: e, ...t }) => /* @__PURE__ */ C(dC, { ...t, children: e }), h0e = (e) => /* @__PURE__ */ C(ol, { ...e }), g0e = ({ children: e, ...t }) => /* @__PURE__ */ C(is, { ...t, children: e }), m0e = (e) => /* @__PURE__ */ C(hC, { ...e }), b0e = ({ children: e, ...t }) => /* @__PURE__ */ C(gC, { ...t, children: e }), y0e = (e) => q7(
  e.smallScreenBreakpoint || "md"
) ? /* @__PURE__ */ C(Nge, { ...e }) : /* @__PURE__ */ C($ge, { ...e }), Nge = ({
  sections: e,
  value: t,
  onChange: n
}) => /* @__PURE__ */ C(
  $C,
  {
    label: t,
    fullWidth: !0,
    value: t,
    items: e.map((o) => ({
      label: o.label,
      value: o.id,
      selected: o.id === t
    })),
    handleChange: n
  }
), $ge = ({
  sections: e,
  value: t,
  onChange: n
}) => /* @__PURE__ */ C(Gt, { sx: { display: "flex", flexDirection: "column", gap: 1 }, children: e.map((o) => /* @__PURE__ */ C(
  Age,
  {
    isSelected: t === o.id,
    onClick: () => n(o.id),
    children: o.label
  },
  o.id
)) }), Age = ({ isSelected: e, children: t, ...n }) => {
  const o = sn(), s = e ? o.palette.success.main : o.palette.text.secondary, i = `${e ? "success" : "primary"}.main`, a = e ? o.palette.success.background : "transparent";
  return /* @__PURE__ */ C(
    Yn,
    {
      ...n,
      color: e ? "success" : "primary",
      sx: {
        borderLeft: "2px solid",
        color: s,
        borderColor: i,
        backgroundColor: a,
        padding: 1,
        justifyContent: "flex-start",
        textAlign: "left",
        borderTopRightRadius: 1,
        borderBottomRightRadius: 1,
        "&:hover": {
          color: i,
          backgroundColor: o.palette[`${e ? "success" : "primary"}`].background
        }
      },
      children: bo(t) ? t : /* @__PURE__ */ C(Cs, { variant: "body1", children: t })
    }
  );
}, v0e = rs(
  ({ children: e, ...t }, n) => /* @__PURE__ */ C(Ji, { ...t, ref: n, children: e })
), C0e = ({ onExit: e, children: t }) => /* @__PURE__ */ ie(
  Gt,
  {
    sx: (n) => ({
      height: 76,
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      px: 2,
      py: 1,
      color: n.palette.text.primary,
      backgroundColor: n.palette.background.default,
      borderBottom: `1px solid ${n.palette.divider}`
    }),
    children: [
      /* @__PURE__ */ C(Gt, { sx: { flexBasis: "33.33%" }, children: /* @__PURE__ */ C(Gt, { sx: { width: 120 }, children: /* @__PURE__ */ C(Of, { onClick: e, fullWidth: !0, children: "Exit" }) }) }),
      t
    ]
  }
);
function Fge(e) {
  return /* @__PURE__ */ C(Lp, { ...e, direction: "up" });
}
const w0e = ({
  children: e,
  open: t,
  ...n
}) => /* @__PURE__ */ C(
  IM,
  {
    open: t,
    anchorOrigin: { vertical: "bottom", horizontal: "center" },
    TransitionComponent: Fge,
    ...n,
    children: e
  }
), S0e = ({ children: e, ...t }) => /* @__PURE__ */ C(yC, { useFlexGap: !0, ...t, children: e }), x0e = (e) => /* @__PURE__ */ C(CC, { ...e }), T0e = (e) => /* @__PURE__ */ C(xC, { ...e }), R0e = ({
  variant: e = "outlined",
  backgroundColor: t = "transparent",
  startAdornment: n,
  endAdornment: o,
  min: s,
  max: i,
  maxLength: a,
  InputProps: l,
  inputProps: c,
  ...u
}) => /* @__PURE__ */ C(
  Is,
  {
    sx: { backgroundColor: t },
    variant: e,
    ...u,
    InputProps: {
      startAdornment: n,
      endAdornment: o,
      ...l
    },
    inputProps: {
      maxLength: a,
      min: s,
      max: i,
      ...c
    }
  }
), E0e = ({
  children: e,
  my: t = 2
}) => /* @__PURE__ */ C(vt, { sx: { my: t }, children: e }), Lge = () => ({
  palette: {
    primary: {
      main: "#2D2BB3",
      light: "#5755C2",
      dark: "#1F1E7D",
      contrastText: "#FFFFFF",
      background: he("#2D2BB3", 0.07)
    }
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: "large"
      }
    }
  },
  shape: {
    borderRadius: 3
  }
}), I0e = ({
  children: e,
  mode: t = "light"
}) => {
  const n = Qi("(prefers-color-scheme: dark)") ? "dark" : "light", o = t === "system" ? n : t;
  return /* @__PURE__ */ C($v, { theme: Npe(Lge(), !1, o), children: /* @__PURE__ */ C(CM, { children: e }) });
};
var zd = { exports: {} }, Ab = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var eO;
function _ge() {
  if (eO) return Ab;
  eO = 1;
  var e = en;
  function t(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var n = typeof Object.is == "function" ? Object.is : t, o = e.useSyncExternalStore, s = e.useRef, i = e.useEffect, a = e.useMemo, l = e.useDebugValue;
  return Ab.useSyncExternalStoreWithSelector = function(c, u, d, f, p) {
    var m = s(null);
    if (m.current === null) {
      var b = { hasValue: !1, value: null };
      m.current = b;
    } else b = m.current;
    m = a(
      function() {
        function g(T) {
          if (!y) {
            if (y = !0, w = T, T = f(T), p !== void 0 && b.hasValue) {
              var E = b.value;
              if (p(E, T))
                return x = E;
            }
            return x = T;
          }
          if (E = x, n(w, T)) return E;
          var O = f(T);
          return p !== void 0 && p(E, O) ? (w = T, E) : (w = T, x = O);
        }
        var y = !1, w, x, S = d === void 0 ? null : d;
        return [
          function() {
            return g(u());
          },
          S === null ? void 0 : function() {
            return g(S());
          }
        ];
      },
      [u, d, f, p]
    );
    var v = o(c, m[0], m[1]);
    return i(
      function() {
        b.hasValue = !0, b.value = v;
      },
      [v]
    ), l(v), v;
  }, Ab;
}
var Fb = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tO;
function Vge() {
  return tO || (tO = 1, process.env.NODE_ENV !== "production" && function() {
    function e(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = en, n = typeof Object.is == "function" ? Object.is : e, o = t.useSyncExternalStore, s = t.useRef, i = t.useEffect, a = t.useMemo, l = t.useDebugValue;
    Fb.useSyncExternalStoreWithSelector = function(c, u, d, f, p) {
      var m = s(null);
      if (m.current === null) {
        var b = { hasValue: !1, value: null };
        m.current = b;
      } else b = m.current;
      m = a(
        function() {
          function g(T) {
            if (!y) {
              if (y = !0, w = T, T = f(T), p !== void 0 && b.hasValue) {
                var E = b.value;
                if (p(E, T))
                  return x = E;
              }
              return x = T;
            }
            if (E = x, n(w, T))
              return E;
            var O = f(T);
            return p !== void 0 && p(E, O) ? (w = T, E) : (w = T, x = O);
          }
          var y = !1, w, x, S = d === void 0 ? null : d;
          return [
            function() {
              return g(u());
            },
            S === null ? void 0 : function() {
              return g(S());
            }
          ];
        },
        [u, d, f, p]
      );
      var v = o(c, m[0], m[1]);
      return i(
        function() {
          b.hasValue = !0, b.value = v;
        },
        [v]
      ), l(v), v;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Fb;
}
var nO;
function Bge() {
  return nO || (nO = 1, process.env.NODE_ENV === "production" ? zd.exports = _ge() : zd.exports = Vge()), zd.exports;
}
var zge = Bge(), Lb = /* @__PURE__ */ Symbol.for("react-redux-context"), _b = typeof globalThis < "u" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function Hge() {
  if (!h.createContext) return {};
  const e = _b[Lb] ?? (_b[Lb] = /* @__PURE__ */ new Map());
  let t = e.get(h.createContext);
  return t || (t = h.createContext(
    null
  ), process.env.NODE_ENV !== "production" && (t.displayName = "ReactRedux"), e.set(h.createContext, t)), t;
}
var qi = /* @__PURE__ */ Hge();
function tw(e = qi) {
  return function() {
    const n = h.useContext(e);
    if (process.env.NODE_ENV !== "production" && !n)
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    return n;
  };
}
var SA = /* @__PURE__ */ tw();
function nw(e = qi) {
  const t = e === qi ? SA : (
    // @ts-ignore
    tw(e)
  ), n = () => {
    const { store: o } = t();
    return o;
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var jge = /* @__PURE__ */ nw();
function Gge(e = qi) {
  const t = e === qi ? jge : nw(e), n = () => t().dispatch;
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var qge = (e, t) => e === t;
function Wge(e = qi) {
  const t = e === qi ? SA : tw(e), n = (o, s = {}) => {
    const { equalityFn: i = qge } = typeof s == "function" ? { equalityFn: s } : s;
    if (process.env.NODE_ENV !== "production") {
      if (!o)
        throw new Error("You must pass a selector to useSelector");
      if (typeof o != "function")
        throw new Error("You must pass a function as a selector to useSelector");
      if (typeof i != "function")
        throw new Error(
          "You must pass a function as an equality function to useSelector"
        );
    }
    const a = t(), { store: l, subscription: c, getServerState: u } = a, d = h.useRef(!0), f = h.useCallback(
      {
        [o.name](m) {
          const b = o(m);
          if (process.env.NODE_ENV !== "production") {
            const { devModeChecks: v = {} } = typeof s == "function" ? {} : s, { identityFunctionCheck: g, stabilityCheck: y } = a, {
              identityFunctionCheck: w,
              stabilityCheck: x
            } = {
              stabilityCheck: y,
              identityFunctionCheck: g,
              ...v
            };
            if (x === "always" || x === "once" && d.current) {
              const S = o(m);
              if (!i(b, S)) {
                let T;
                try {
                  throw new Error();
                } catch (E) {
                  ({ stack: T } = E);
                }
                console.warn(
                  "Selector " + (o.name || "unknown") + ` returned a different result when called with the same parameters. This can lead to unnecessary rerenders.
Selectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization`,
                  {
                    state: m,
                    selected: b,
                    selected2: S,
                    stack: T
                  }
                );
              }
            }
            if ((w === "always" || w === "once" && d.current) && b === m) {
              let S;
              try {
                throw new Error();
              } catch (T) {
                ({ stack: S } = T);
              }
              console.warn(
                "Selector " + (o.name || "unknown") + ` returned the root state when called. This can lead to unnecessary rerenders.
Selectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.`,
                { stack: S }
              );
            }
            d.current && (d.current = !1);
          }
          return b;
        }
      }[o.name],
      [o]
    ), p = zge.useSyncExternalStoreWithSelector(
      c.addNestedSub,
      l.getState,
      u || l.getState,
      f,
      i
    );
    return h.useDebugValue(p), p;
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
function Zn(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var Uge = typeof Symbol == "function" && Symbol.observable || "@@observable", oO = Uge, Vb = () => Math.random().toString(36).substring(7).split("").join("."), Kge = {
  INIT: `@@redux/INIT${/* @__PURE__ */ Vb()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ Vb()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${Vb()}`
}, $i = Kge;
function Yu(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function Yge(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (Zge(e))
    return "date";
  if (Qge(e))
    return "error";
  const n = Xge(e);
  switch (n) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return n;
  }
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function Xge(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function Qge(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function Zge(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function _s(e) {
  let t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = Yge(e)), t;
}
function xA(e, t, n) {
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? Zn(2) : `Expected the root reducer to be a function. Instead, received: '${_s(e)}'`);
  if (typeof t == "function" && typeof n == "function" || typeof n == "function" && typeof arguments[3] == "function")
    throw new Error(process.env.NODE_ENV === "production" ? Zn(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  if (typeof t == "function" && typeof n > "u" && (n = t, t = void 0), typeof n < "u") {
    if (typeof n != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Zn(1) : `Expected the enhancer to be a function. Instead, received: '${_s(n)}'`);
    return n(xA)(e, t);
  }
  let o = e, s = t, i = /* @__PURE__ */ new Map(), a = i, l = 0, c = !1;
  function u() {
    a === i && (a = /* @__PURE__ */ new Map(), i.forEach((g, y) => {
      a.set(y, g);
    }));
  }
  function d() {
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? Zn(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    return s;
  }
  function f(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Zn(4) : `Expected the listener to be a function. Instead, received: '${_s(g)}'`);
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? Zn(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    let y = !0;
    u();
    const w = l++;
    return a.set(w, g), function() {
      if (y) {
        if (c)
          throw new Error(process.env.NODE_ENV === "production" ? Zn(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
        y = !1, u(), a.delete(w), i = null;
      }
    };
  }
  function p(g) {
    if (!Yu(g))
      throw new Error(process.env.NODE_ENV === "production" ? Zn(7) : `Actions must be plain objects. Instead, the actual type was: '${_s(g)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    if (typeof g.type > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Zn(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    if (typeof g.type != "string")
      throw new Error(process.env.NODE_ENV === "production" ? Zn(17) : `Action "type" property must be a string. Instead, the actual type was: '${_s(g.type)}'. Value was: '${g.type}' (stringified)`);
    if (c)
      throw new Error(process.env.NODE_ENV === "production" ? Zn(9) : "Reducers may not dispatch actions.");
    try {
      c = !0, s = o(s, g);
    } finally {
      c = !1;
    }
    return (i = a).forEach((w) => {
      w();
    }), g;
  }
  function m(g) {
    if (typeof g != "function")
      throw new Error(process.env.NODE_ENV === "production" ? Zn(10) : `Expected the nextReducer to be a function. Instead, received: '${_s(g)}`);
    o = g, p({
      type: $i.REPLACE
    });
  }
  function b() {
    const g = f;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(y) {
        if (typeof y != "object" || y === null)
          throw new Error(process.env.NODE_ENV === "production" ? Zn(11) : `Expected the observer to be an object. Instead, received: '${_s(y)}'`);
        function w() {
          const S = y;
          S.next && S.next(d());
        }
        return w(), {
          unsubscribe: g(w)
        };
      },
      [oO]() {
        return this;
      }
    };
  }
  return p({
    type: $i.INIT
  }), {
    dispatch: p,
    subscribe: f,
    getState: d,
    replaceReducer: m,
    [oO]: b
  };
}
function rO(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function Jge(e, t, n, o) {
  const s = Object.keys(t), i = n && n.type === $i.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (s.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!Yu(e))
    return `The ${i} has unexpected type of "${_s(e)}". Expected argument to be an object with the following keys: "${s.join('", "')}"`;
  const a = Object.keys(e).filter((l) => !t.hasOwnProperty(l) && !o[l]);
  if (a.forEach((l) => {
    o[l] = !0;
  }), !(n && n.type === $i.REPLACE) && a.length > 0)
    return `Unexpected ${a.length > 1 ? "keys" : "key"} "${a.join('", "')}" found in ${i}. Expected to find one of the known reducer keys instead: "${s.join('", "')}". Unexpected keys will be ignored.`;
}
function eme(e) {
  Object.keys(e).forEach((t) => {
    const n = e[t];
    if (typeof n(void 0, {
      type: $i.INIT
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Zn(12) : `The slice reducer for key "${t}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof n(void 0, {
      type: $i.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? Zn(13) : `The slice reducer for key "${t}" returned undefined when probed with a random type. Don't try to handle '${$i.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function tme(e) {
  const t = Object.keys(e), n = {};
  for (let a = 0; a < t.length; a++) {
    const l = t[a];
    process.env.NODE_ENV !== "production" && typeof e[l] > "u" && rO(`No reducer provided for key "${l}"`), typeof e[l] == "function" && (n[l] = e[l]);
  }
  const o = Object.keys(n);
  let s;
  process.env.NODE_ENV !== "production" && (s = {});
  let i;
  try {
    eme(n);
  } catch (a) {
    i = a;
  }
  return function(l = {}, c) {
    if (i)
      throw i;
    if (process.env.NODE_ENV !== "production") {
      const f = Jge(l, n, c, s);
      f && rO(f);
    }
    let u = !1;
    const d = {};
    for (let f = 0; f < o.length; f++) {
      const p = o[f], m = n[p], b = l[p], v = m(b, c);
      if (typeof v > "u") {
        const g = c && c.type;
        throw new Error(process.env.NODE_ENV === "production" ? Zn(14) : `When called with an action of type ${g ? `"${String(g)}"` : "(unknown type)"}, the slice reducer for key "${p}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      d[p] = v, u = u || v !== b;
    }
    return u = u || o.length !== Object.keys(l).length, u ? d : l;
  };
}
function np(...e) {
  return e.length === 0 ? (t) => t : e.length === 1 ? e[0] : e.reduce((t, n) => (...o) => t(n(...o)));
}
function nme(...e) {
  return (t) => (n, o) => {
    const s = t(n, o);
    let i = () => {
      throw new Error(process.env.NODE_ENV === "production" ? Zn(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const a = {
      getState: s.getState,
      dispatch: (c, ...u) => i(c, ...u)
    }, l = e.map((c) => c(a));
    return i = np(...l)(s.dispatch), {
      ...s,
      dispatch: i
    };
  };
}
function TA(e) {
  return Yu(e) && "type" in e && typeof e.type == "string";
}
var RA = Symbol.for("immer-nothing"), sO = Symbol.for("immer-draftable"), Xo = Symbol.for("immer-state"), ome = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function Ro(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = ome[e], o = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${o}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var dl = Object.getPrototypeOf;
function Wi(e) {
  return !!e && !!e[Xo];
}
function Ss(e) {
  var t;
  return e ? EA(e) || Array.isArray(e) || !!e[sO] || !!((t = e.constructor) != null && t[sO]) || Ch(e) || wh(e) : !1;
}
var rme = Object.prototype.constructor.toString();
function EA(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = dl(e);
  if (t === null)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === rme;
}
function op(e, t) {
  vh(e) === 0 ? Reflect.ownKeys(e).forEach((n) => {
    t(n, e[n], e);
  }) : e.forEach((n, o) => t(o, n, e));
}
function vh(e) {
  const t = e[Xo];
  return t ? t.type_ : Array.isArray(e) ? 1 : Ch(e) ? 2 : wh(e) ? 3 : 0;
}
function ov(e, t) {
  return vh(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function IA(e, t, n) {
  const o = vh(e);
  o === 2 ? e.set(t, n) : o === 3 ? e.add(n) : e[t] = n;
}
function sme(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Ch(e) {
  return e instanceof Map;
}
function wh(e) {
  return e instanceof Set;
}
function wi(e) {
  return e.copy_ || e.base_;
}
function rv(e, t) {
  if (Ch(e))
    return new Map(e);
  if (wh(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const n = EA(e);
  if (t === !0 || t === "class_only" && !n) {
    const o = Object.getOwnPropertyDescriptors(e);
    delete o[Xo];
    let s = Reflect.ownKeys(o);
    for (let i = 0; i < s.length; i++) {
      const a = s[i], l = o[a];
      l.writable === !1 && (l.writable = !0, l.configurable = !0), (l.get || l.set) && (o[a] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: l.enumerable,
        value: e[a]
      });
    }
    return Object.create(dl(e), o);
  } else {
    const o = dl(e);
    if (o !== null && n)
      return { ...e };
    const s = Object.create(o);
    return Object.assign(s, e);
  }
}
function ow(e, t = !1) {
  return Sh(e) || Wi(e) || !Ss(e) || (vh(e) > 1 && (e.set = e.add = e.clear = e.delete = ime), Object.freeze(e), t && Object.entries(e).forEach(([n, o]) => ow(o, !0))), e;
}
function ime() {
  Ro(2);
}
function Sh(e) {
  return Object.isFrozen(e);
}
var ame = {};
function Ui(e) {
  const t = ame[e];
  return t || Ro(0, e), t;
}
var iu;
function OA() {
  return iu;
}
function lme(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function iO(e, t) {
  t && (Ui("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function sv(e) {
  iv(e), e.drafts_.forEach(cme), e.drafts_ = null;
}
function iv(e) {
  e === iu && (iu = e.parent_);
}
function aO(e) {
  return iu = lme(iu, e);
}
function cme(e) {
  const t = e[Xo];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function lO(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[Xo].modified_ && (sv(t), Ro(4)), Ss(e) && (e = rp(t, e), t.parent_ || sp(t, e)), t.patches_ && Ui("Patches").generateReplacementPatches_(
    n[Xo].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = rp(t, n, []), sv(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== RA ? e : void 0;
}
function rp(e, t, n) {
  if (Sh(t))
    return t;
  const o = t[Xo];
  if (!o)
    return op(
      t,
      (s, i) => cO(e, o, t, s, i, n)
    ), t;
  if (o.scope_ !== e)
    return t;
  if (!o.modified_)
    return sp(e, o.base_, !0), o.base_;
  if (!o.finalized_) {
    o.finalized_ = !0, o.scope_.unfinalizedDrafts_--;
    const s = o.copy_;
    let i = s, a = !1;
    o.type_ === 3 && (i = new Set(s), s.clear(), a = !0), op(
      i,
      (l, c) => cO(e, o, s, l, c, n, a)
    ), sp(e, s, !1), n && e.patches_ && Ui("Patches").generatePatches_(
      o,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return o.copy_;
}
function cO(e, t, n, o, s, i, a) {
  if (process.env.NODE_ENV !== "production" && s === n && Ro(5), Wi(s)) {
    const l = i && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !ov(t.assigned_, o) ? i.concat(o) : void 0, c = rp(e, s, l);
    if (IA(n, o, c), Wi(c))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else a && n.add(s);
  if (Ss(s) && !Sh(s)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    rp(e, s), (!t || !t.scope_.parent_) && typeof o != "symbol" && Object.prototype.propertyIsEnumerable.call(n, o) && sp(e, s);
  }
}
function sp(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && ow(t, n);
}
function ume(e, t) {
  const n = Array.isArray(e), o = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : OA(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let s = o, i = rw;
  n && (s = [o], i = au);
  const { revoke: a, proxy: l } = Proxy.revocable(s, i);
  return o.draft_ = l, o.revoke_ = a, l;
}
var rw = {
  get(e, t) {
    if (t === Xo)
      return e;
    const n = wi(e);
    if (!ov(n, t))
      return dme(e, n, t);
    const o = n[t];
    return e.finalized_ || !Ss(o) ? o : o === Bb(e.base_, t) ? (zb(e), e.copy_[t] = lv(o, e)) : o;
  },
  has(e, t) {
    return t in wi(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(wi(e));
  },
  set(e, t, n) {
    const o = PA(wi(e), t);
    if (o != null && o.set)
      return o.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const s = Bb(wi(e), t), i = s == null ? void 0 : s[Xo];
      if (i && i.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (sme(n, s) && (n !== void 0 || ov(e.base_, t)))
        return !0;
      zb(e), av(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return Bb(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, zb(e), av(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = wi(e), o = Reflect.getOwnPropertyDescriptor(n, t);
    return o && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: o.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    Ro(11);
  },
  getPrototypeOf(e) {
    return dl(e.base_);
  },
  setPrototypeOf() {
    Ro(12);
  }
}, au = {};
op(rw, (e, t) => {
  au[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
au.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Ro(13), au.set.call(this, e, t, void 0);
};
au.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Ro(14), rw.set.call(this, e[0], t, n, e[0]);
};
function Bb(e, t) {
  const n = e[Xo];
  return (n ? wi(n) : e)[t];
}
function dme(e, t, n) {
  var s;
  const o = PA(t, n);
  return o ? "value" in o ? o.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (s = o.get) == null ? void 0 : s.call(e.draft_)
  ) : void 0;
}
function PA(e, t) {
  if (!(t in e))
    return;
  let n = dl(e);
  for (; n; ) {
    const o = Object.getOwnPropertyDescriptor(n, t);
    if (o)
      return o;
    n = dl(n);
  }
}
function av(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && av(e.parent_));
}
function zb(e) {
  e.copy_ || (e.copy_ = rv(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var fme = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, n, o) => {
      if (typeof t == "function" && typeof n != "function") {
        const i = n;
        n = t;
        const a = this;
        return function(c = i, ...u) {
          return a.produce(c, (d) => n.call(this, d, ...u));
        };
      }
      typeof n != "function" && Ro(6), o !== void 0 && typeof o != "function" && Ro(7);
      let s;
      if (Ss(t)) {
        const i = aO(this), a = lv(t, void 0);
        let l = !0;
        try {
          s = n(a), l = !1;
        } finally {
          l ? sv(i) : iv(i);
        }
        return iO(i, o), lO(s, i);
      } else if (!t || typeof t != "object") {
        if (s = n(t), s === void 0 && (s = t), s === RA && (s = void 0), this.autoFreeze_ && ow(s, !0), o) {
          const i = [], a = [];
          Ui("Patches").generateReplacementPatches_(t, s, i, a), o(i, a);
        }
        return s;
      } else
        Ro(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (a, ...l) => this.produceWithPatches(a, (c) => t(c, ...l));
      let o, s;
      return [this.produce(t, n, (a, l) => {
        o = a, s = l;
      }), o, s];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    Ss(e) || Ro(8), Wi(e) && (e = pme(e));
    const t = aO(this), n = lv(e, void 0);
    return n[Xo].isManual_ = !0, iv(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[Xo];
    (!n || !n.isManual_) && Ro(9);
    const { scope_: o } = n;
    return iO(o, t), lO(void 0, o);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const s = t[n];
      if (s.path.length === 0 && s.op === "replace") {
        e = s.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const o = Ui("Patches").applyPatches_;
    return Wi(e) ? o(e, t) : this.produce(
      e,
      (s) => o(s, t)
    );
  }
};
function lv(e, t) {
  const n = Ch(e) ? Ui("MapSet").proxyMap_(e, t) : wh(e) ? Ui("MapSet").proxySet_(e, t) : ume(e, t);
  return (t ? t.scope_ : OA()).drafts_.push(n), n;
}
function pme(e) {
  return Wi(e) || Ro(10, e), MA(e);
}
function MA(e) {
  if (!Ss(e) || Sh(e))
    return e;
  const t = e[Xo];
  let n;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = rv(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    n = rv(e, !0);
  return op(n, (o, s) => {
    IA(n, o, MA(s));
  }), t && (t.finalized_ = !1), n;
}
var Qo = new fme(), xh = Qo.produce;
Qo.produceWithPatches.bind(
  Qo
);
Qo.setAutoFreeze.bind(Qo);
Qo.setUseStrictShallowCopy.bind(Qo);
Qo.applyPatches.bind(Qo);
Qo.createDraft.bind(Qo);
Qo.finishDraft.bind(Qo);
function kA(e) {
  return ({ dispatch: n, getState: o }) => (s) => (i) => typeof i == "function" ? i(n, o, e) : s(i);
}
var hme = kA(), gme = kA, mme = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length !== 0)
    return typeof arguments[0] == "object" ? np : np.apply(null, arguments);
}, bme = (e) => e && typeof e.match == "function";
function uO(e, t) {
  function n(...o) {
    if (t) {
      let s = t(...o);
      if (!s)
        throw new Error(process.env.NODE_ENV === "production" ? mn(0) : "prepareAction did not return an object");
      return {
        type: e,
        payload: s.payload,
        ..."meta" in s && {
          meta: s.meta
        },
        ..."error" in s && {
          error: s.error
        }
      };
    }
    return {
      type: e,
      payload: o[0]
    };
  }
  return n.toString = () => `${e}`, n.type = e, n.match = (o) => TA(o) && o.type === e, n;
}
function yme(e) {
  return typeof e == "function" && "type" in e && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  bme(e);
}
function vme(e) {
  const t = e ? `${e}`.split("/") : [], n = t[t.length - 1] || "actionCreator";
  return `Detected an action creator with type "${e || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${n}())\` instead of \`dispatch(${n})\`. This is necessary even if the action has no payload.`;
}
function Cme(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (n) => (o) => n(o);
  const {
    isActionCreator: t = yme
  } = e;
  return () => (n) => (o) => (t(o) && console.warn(vme(o.type)), n(o));
}
function DA(e, t) {
  let n = 0;
  return {
    measureTime(o) {
      const s = Date.now();
      try {
        return o();
      } finally {
        const i = Date.now();
        n += i - s;
      }
    },
    warnIfExceeded() {
      n > e && console.warn(`${t} took ${n}ms, which is more than the warning threshold of ${e}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
    }
  };
}
var NA = class Cc extends Array {
  constructor(...t) {
    super(...t), Object.setPrototypeOf(this, Cc.prototype);
  }
  static get [Symbol.species]() {
    return Cc;
  }
  concat(...t) {
    return super.concat.apply(this, t);
  }
  prepend(...t) {
    return t.length === 1 && Array.isArray(t[0]) ? new Cc(...t[0].concat(this)) : new Cc(...t.concat(this));
  }
};
function dO(e) {
  return Ss(e) ? xh(e, () => {
  }) : e;
}
function fO(e, t, n) {
  return e.has(t) ? e.get(t) : e.set(t, n(t)).get(t);
}
function wme(e) {
  return typeof e != "object" || e == null || Object.isFrozen(e);
}
function Sme(e, t, n) {
  const o = $A(e, t, n);
  return {
    detectMutations() {
      return AA(e, t, o, n);
    }
  };
}
function $A(e, t = [], n, o = "", s = /* @__PURE__ */ new Set()) {
  const i = {
    value: n
  };
  if (!e(n) && !s.has(n)) {
    s.add(n), i.children = {};
    for (const a in n) {
      const l = o ? o + "." + a : a;
      t.length && t.indexOf(l) !== -1 || (i.children[a] = $A(e, t, n[a], l));
    }
  }
  return i;
}
function AA(e, t = [], n, o, s = !1, i = "") {
  const a = n ? n.value : void 0, l = a === o;
  if (s && !l && !Number.isNaN(o))
    return {
      wasMutated: !0,
      path: i
    };
  if (e(a) || e(o))
    return {
      wasMutated: !1
    };
  const c = {};
  for (let d in n.children)
    c[d] = !0;
  for (let d in o)
    c[d] = !0;
  const u = t.length > 0;
  for (let d in c) {
    const f = i ? i + "." + d : d;
    if (u && t.some((b) => b instanceof RegExp ? b.test(f) : f === b))
      continue;
    const p = AA(e, t, n.children[d], o[d], l, f);
    if (p.wasMutated)
      return p;
  }
  return {
    wasMutated: !1
  };
}
function xme(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (t) => (n) => t(n);
  {
    let t = function(l, c, u, d) {
      return JSON.stringify(l, n(c, d), u);
    }, n = function(l, c) {
      let u = [], d = [];
      return c || (c = function(f, p) {
        return u[0] === p ? "[Circular ~]" : "[Circular ~." + d.slice(0, u.indexOf(p)).join(".") + "]";
      }), function(f, p) {
        if (u.length > 0) {
          var m = u.indexOf(this);
          ~m ? u.splice(m + 1) : u.push(this), ~m ? d.splice(m, 1 / 0, f) : d.push(f), ~u.indexOf(p) && (p = c.call(this, f, p));
        } else u.push(p);
        return l == null ? p : l.call(this, f, p);
      };
    }, {
      isImmutable: o = wme,
      ignoredPaths: s,
      warnAfter: i = 32
    } = e;
    const a = Sme.bind(null, o, s);
    return ({
      getState: l
    }) => {
      let c = l(), u = a(c), d;
      return (f) => (p) => {
        const m = DA(i, "ImmutableStateInvariantMiddleware");
        m.measureTime(() => {
          if (c = l(), d = u.detectMutations(), u = a(c), d.wasMutated)
            throw new Error(process.env.NODE_ENV === "production" ? mn(19) : `A state mutation was detected between dispatches, in the path '${d.path || ""}'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        });
        const b = f(p);
        return m.measureTime(() => {
          if (c = l(), d = u.detectMutations(), u = a(c), d.wasMutated)
            throw new Error(process.env.NODE_ENV === "production" ? mn(20) : `A state mutation was detected inside a dispatch, in the path: ${d.path || ""}. Take a look at the reducer(s) handling the action ${t(p)}. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
        }), m.warnIfExceeded(), b;
      };
    };
  }
}
function FA(e) {
  const t = typeof e;
  return e == null || t === "string" || t === "boolean" || t === "number" || Array.isArray(e) || Yu(e);
}
function cv(e, t = "", n = FA, o, s = [], i) {
  let a;
  if (!n(e))
    return {
      keyPath: t || "<root>",
      value: e
    };
  if (typeof e != "object" || e === null || i != null && i.has(e)) return !1;
  const l = o != null ? o(e) : Object.entries(e), c = s.length > 0;
  for (const [u, d] of l) {
    const f = t ? t + "." + u : u;
    if (!(c && s.some((m) => m instanceof RegExp ? m.test(f) : f === m))) {
      if (!n(d))
        return {
          keyPath: f,
          value: d
        };
      if (typeof d == "object" && (a = cv(d, f, n, o, s, i), a))
        return a;
    }
  }
  return i && LA(e) && i.add(e), !1;
}
function LA(e) {
  if (!Object.isFrozen(e)) return !1;
  for (const t of Object.values(e))
    if (!(typeof t != "object" || t === null) && !LA(t))
      return !1;
  return !0;
}
function Tme(e = {}) {
  if (process.env.NODE_ENV === "production")
    return () => (t) => (n) => t(n);
  {
    const {
      isSerializable: t = FA,
      getEntries: n,
      ignoredActions: o = [],
      ignoredActionPaths: s = ["meta.arg", "meta.baseQueryMeta"],
      ignoredPaths: i = [],
      warnAfter: a = 32,
      ignoreState: l = !1,
      ignoreActions: c = !1,
      disableCache: u = !1
    } = e, d = !u && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
    return (f) => (p) => (m) => {
      if (!TA(m))
        return p(m);
      const b = p(m), v = DA(a, "SerializableStateInvariantMiddleware");
      return !c && !(o.length && o.indexOf(m.type) !== -1) && v.measureTime(() => {
        const g = cv(m, "", t, n, s, d);
        if (g) {
          const {
            keyPath: y,
            value: w
          } = g;
          console.error(`A non-serializable value was detected in an action, in the path: \`${y}\`. Value:`, w, `
Take a look at the logic that dispatched this action: `, m, `
(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)`, `
(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)`);
        }
      }), l || (v.measureTime(() => {
        const g = f.getState(), y = cv(g, "", t, n, i, d);
        if (y) {
          const {
            keyPath: w,
            value: x
          } = y;
          console.error(`A non-serializable value was detected in the state, in the path: \`${w}\`. Value:`, x, `
Take a look at the reducer(s) handling this action type: ${m.type}.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
        }
      }), v.warnIfExceeded()), b;
    };
  }
}
function Hd(e) {
  return typeof e == "boolean";
}
var Rme = () => function(t) {
  const {
    thunk: n = !0,
    immutableCheck: o = !0,
    serializableCheck: s = !0,
    actionCreatorCheck: i = !0
  } = t ?? {};
  let a = new NA();
  if (n && (Hd(n) ? a.push(hme) : a.push(gme(n.extraArgument))), process.env.NODE_ENV !== "production") {
    if (o) {
      let l = {};
      Hd(o) || (l = o), a.unshift(xme(l));
    }
    if (s) {
      let l = {};
      Hd(s) || (l = s), a.push(Tme(l));
    }
    if (i) {
      let l = {};
      Hd(i) || (l = i), a.unshift(Cme(l));
    }
  }
  return a;
}, Eme = "RTK_autoBatch", pO = (e) => (t) => {
  setTimeout(t, e);
}, Ime = (e = {
  type: "raf"
}) => (t) => (...n) => {
  const o = t(...n);
  let s = !0, i = !1, a = !1;
  const l = /* @__PURE__ */ new Set(), c = e.type === "tick" ? queueMicrotask : e.type === "raf" ? (
    // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
    typeof window < "u" && window.requestAnimationFrame ? window.requestAnimationFrame : pO(10)
  ) : e.type === "callback" ? e.queueNotification : pO(e.timeout), u = () => {
    a = !1, i && (i = !1, l.forEach((d) => d()));
  };
  return Object.assign({}, o, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(d) {
      const f = () => s && d(), p = o.subscribe(f);
      return l.add(d), () => {
        p(), l.delete(d);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(d) {
      var f;
      try {
        return s = !((f = d == null ? void 0 : d.meta) != null && f[Eme]), i = !s, i && (a || (a = !0, c(u))), o.dispatch(d);
      } finally {
        s = !0;
      }
    }
  });
}, Ome = (e) => function(n) {
  const {
    autoBatch: o = !0
  } = n ?? {};
  let s = new NA(e);
  return o && s.push(Ime(typeof o == "object" ? o : void 0)), s;
};
function Pme(e) {
  const t = Rme(), {
    reducer: n = void 0,
    middleware: o,
    devTools: s = !0,
    preloadedState: i = void 0,
    enhancers: a = void 0
  } = e || {};
  let l;
  if (typeof n == "function")
    l = n;
  else if (Yu(n))
    l = tme(n);
  else
    throw new Error(process.env.NODE_ENV === "production" ? mn(1) : "`reducer` is a required argument, and must be a function or an object of functions that can be passed to combineReducers");
  if (process.env.NODE_ENV !== "production" && o && typeof o != "function")
    throw new Error(process.env.NODE_ENV === "production" ? mn(2) : "`middleware` field must be a callback");
  let c;
  if (typeof o == "function") {
    if (c = o(t), process.env.NODE_ENV !== "production" && !Array.isArray(c))
      throw new Error(process.env.NODE_ENV === "production" ? mn(3) : "when using a middleware builder function, an array of middleware must be returned");
  } else
    c = t();
  if (process.env.NODE_ENV !== "production" && c.some((b) => typeof b != "function"))
    throw new Error(process.env.NODE_ENV === "production" ? mn(4) : "each middleware provided to configureStore must be a function");
  let u = np;
  s && (u = mme({
    // Enable capture of stack traces for dispatched Redux actions
    trace: process.env.NODE_ENV !== "production",
    ...typeof s == "object" && s
  }));
  const d = nme(...c), f = Ome(d);
  if (process.env.NODE_ENV !== "production" && a && typeof a != "function")
    throw new Error(process.env.NODE_ENV === "production" ? mn(5) : "`enhancers` field must be a callback");
  let p = typeof a == "function" ? a(f) : f();
  if (process.env.NODE_ENV !== "production" && !Array.isArray(p))
    throw new Error(process.env.NODE_ENV === "production" ? mn(6) : "`enhancers` callback must return an array");
  if (process.env.NODE_ENV !== "production" && p.some((b) => typeof b != "function"))
    throw new Error(process.env.NODE_ENV === "production" ? mn(7) : "each enhancer provided to configureStore must be a function");
  process.env.NODE_ENV !== "production" && c.length && !p.includes(d) && console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
  const m = u(...p);
  return xA(l, i, m);
}
function _A(e) {
  const t = {}, n = [];
  let o;
  const s = {
    addCase(i, a) {
      if (process.env.NODE_ENV !== "production") {
        if (n.length > 0)
          throw new Error(process.env.NODE_ENV === "production" ? mn(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (o)
          throw new Error(process.env.NODE_ENV === "production" ? mn(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const l = typeof i == "string" ? i : i.type;
      if (!l)
        throw new Error(process.env.NODE_ENV === "production" ? mn(28) : "`builder.addCase` cannot be called with an empty action type");
      if (l in t)
        throw new Error(process.env.NODE_ENV === "production" ? mn(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${l}'`);
      return t[l] = a, s;
    },
    addMatcher(i, a) {
      if (process.env.NODE_ENV !== "production" && o)
        throw new Error(process.env.NODE_ENV === "production" ? mn(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return n.push({
        matcher: i,
        reducer: a
      }), s;
    },
    addDefaultCase(i) {
      if (process.env.NODE_ENV !== "production" && o)
        throw new Error(process.env.NODE_ENV === "production" ? mn(31) : "`builder.addDefaultCase` can only be called once");
      return o = i, s;
    }
  };
  return e(s), [t, n, o];
}
function Mme(e) {
  return typeof e == "function";
}
function kme(e, t) {
  if (process.env.NODE_ENV !== "production" && typeof t == "object")
    throw new Error(process.env.NODE_ENV === "production" ? mn(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [n, o, s] = _A(t), i;
  if (Mme(e))
    i = () => dO(e());
  else {
    const l = dO(e);
    i = () => l;
  }
  function a(l = i(), c) {
    let u = [n[c.type], ...o.filter(({
      matcher: d
    }) => d(c)).map(({
      reducer: d
    }) => d)];
    return u.filter((d) => !!d).length === 0 && (u = [s]), u.reduce((d, f) => {
      if (f)
        if (Wi(d)) {
          const m = f(d, c);
          return m === void 0 ? d : m;
        } else {
          if (Ss(d))
            return xh(d, (p) => f(p, c));
          {
            const p = f(d, c);
            if (p === void 0) {
              if (d === null)
                return d;
              throw Error("A case reducer on a non-draftable value must not return undefined");
            }
            return p;
          }
        }
      return d;
    }, l);
  }
  return a.getInitialState = i, a;
}
var Dme = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function Nme(e, t) {
  return `${e}/${t}`;
}
function $me({
  creators: e
} = {}) {
  var n;
  const t = (n = e == null ? void 0 : e.asyncThunk) == null ? void 0 : n[Dme];
  return function(s) {
    const {
      name: i,
      reducerPath: a = i
    } = s;
    if (!i)
      throw new Error(process.env.NODE_ENV === "production" ? mn(11) : "`name` is a required option for createSlice");
    typeof process < "u" && process.env.NODE_ENV === "development" && s.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const l = (typeof s.reducers == "function" ? s.reducers(Fme()) : s.reducers) || {}, c = Object.keys(l), u = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, d = {
      addCase(x, S) {
        const T = typeof x == "string" ? x : x.type;
        if (!T)
          throw new Error(process.env.NODE_ENV === "production" ? mn(12) : "`context.addCase` cannot be called with an empty action type");
        if (T in u.sliceCaseReducersByType)
          throw new Error(process.env.NODE_ENV === "production" ? mn(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + T);
        return u.sliceCaseReducersByType[T] = S, d;
      },
      addMatcher(x, S) {
        return u.sliceMatchers.push({
          matcher: x,
          reducer: S
        }), d;
      },
      exposeAction(x, S) {
        return u.actionCreators[x] = S, d;
      },
      exposeCaseReducer(x, S) {
        return u.sliceCaseReducersByName[x] = S, d;
      }
    };
    c.forEach((x) => {
      const S = l[x], T = {
        reducerName: x,
        type: Nme(i, x),
        createNotation: typeof s.reducers == "function"
      };
      _me(S) ? Bme(T, S, d, t) : Lme(T, S, d);
    });
    function f() {
      if (process.env.NODE_ENV !== "production" && typeof s.extraReducers == "object")
        throw new Error(process.env.NODE_ENV === "production" ? mn(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [x = {}, S = [], T = void 0] = typeof s.extraReducers == "function" ? _A(s.extraReducers) : [s.extraReducers], E = {
        ...x,
        ...u.sliceCaseReducersByType
      };
      return kme(s.initialState, (O) => {
        for (let M in E)
          O.addCase(M, E[M]);
        for (let M of u.sliceMatchers)
          O.addMatcher(M.matcher, M.reducer);
        for (let M of S)
          O.addMatcher(M.matcher, M.reducer);
        T && O.addDefaultCase(T);
      });
    }
    const p = (x) => x, m = /* @__PURE__ */ new Map();
    let b;
    function v(x, S) {
      return b || (b = f()), b(x, S);
    }
    function g() {
      return b || (b = f()), b.getInitialState();
    }
    function y(x, S = !1) {
      function T(O) {
        let M = O[x];
        if (typeof M > "u") {
          if (S)
            M = g();
          else if (process.env.NODE_ENV !== "production")
            throw new Error(process.env.NODE_ENV === "production" ? mn(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return M;
      }
      function E(O = p) {
        const M = fO(m, S, () => /* @__PURE__ */ new WeakMap());
        return fO(M, O, () => {
          const D = {};
          for (const [R, P] of Object.entries(s.selectors ?? {}))
            D[R] = Ame(P, O, g, S);
          return D;
        });
      }
      return {
        reducerPath: x,
        getSelectors: E,
        get selectors() {
          return E(T);
        },
        selectSlice: T
      };
    }
    const w = {
      name: i,
      reducer: v,
      actions: u.actionCreators,
      caseReducers: u.sliceCaseReducersByName,
      getInitialState: g,
      ...y(a),
      injectInto(x, {
        reducerPath: S,
        ...T
      } = {}) {
        const E = S ?? a;
        return x.inject({
          reducerPath: E,
          reducer: v
        }, T), {
          ...w,
          ...y(E, !0)
        };
      }
    };
    return w;
  };
}
function Ame(e, t, n, o) {
  function s(i, ...a) {
    let l = t(i);
    if (typeof l > "u") {
      if (o)
        l = n();
      else if (process.env.NODE_ENV !== "production")
        throw new Error(process.env.NODE_ENV === "production" ? mn(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return e(l, ...a);
  }
  return s.unwrapped = e, s;
}
var VA = /* @__PURE__ */ $me();
function Fme() {
  function e(t, n) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...n
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...n) {
          return t(...n);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, n) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: n
      };
    },
    asyncThunk: e
  };
}
function Lme({
  type: e,
  reducerName: t,
  createNotation: n
}, o, s) {
  let i, a;
  if ("reducer" in o) {
    if (n && !Vme(o))
      throw new Error(process.env.NODE_ENV === "production" ? mn(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    i = o.reducer, a = o.prepare;
  } else
    i = o;
  s.addCase(e, i).exposeCaseReducer(t, i).exposeAction(t, a ? uO(e, a) : uO(e));
}
function _me(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function Vme(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function Bme({
  type: e,
  reducerName: t
}, n, o, s) {
  if (!s)
    throw new Error(process.env.NODE_ENV === "production" ? mn(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: i,
    fulfilled: a,
    pending: l,
    rejected: c,
    settled: u,
    options: d
  } = n, f = s(e, i, d);
  o.exposeAction(t, f), a && o.addCase(f.fulfilled, a), l && o.addCase(f.pending, l), c && o.addCase(f.rejected, c), u && o.addMatcher(f.settled, u), o.exposeCaseReducer(t, {
    fulfilled: a || jd,
    pending: l || jd,
    rejected: c || jd,
    settled: u || jd
  });
}
function jd() {
}
function mn(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var BA = {
  "¼": "1/4",
  "½": "1/2",
  "¾": "3/4",
  "⅐": "1/7",
  "⅑": "1/9",
  "⅒": "1/10",
  "⅓": "1/3",
  "⅔": "2/3",
  "⅕": "1/5",
  "⅖": "2/5",
  "⅗": "3/5",
  "⅘": "4/5",
  "⅙": "1/6",
  "⅚": "5/6",
  "⅛": "1/8",
  "⅜": "3/8",
  "⅝": "5/8",
  "⅞": "7/8",
  "⅟": "1/"
}, sw = /^(?=-?\s*\.\d|-?\s*\d)(-)?\s*((?:\d(?:[\d,_]*\d)?)*)(([eE][+-]?\d(?:[\d,_]*\d)?)?|\.\d(?:[\d,_]*\d)?([eE][+-]?\d(?:[\d,_]*\d)?)?|(\s+\d(?:[\d,_]*\d)?\s*)?\s*\/\s*\d(?:[\d,_]*\d)?)?$/, zme = new RegExp(
  sw.source.replace(/\$$/, "(?:\\s*[^\\.\\d\\/].*)?")
), Hme = new RegExp(
  `(${Object.keys(BA).join("|")})`
), Gd = {
  MMM: 3e3,
  MM: 2e3,
  M: 1e3,
  CM: 900,
  DCCC: 800,
  DCC: 700,
  DC: 600,
  D: 500,
  CD: 400,
  CCC: 300,
  CC: 200,
  C: 100,
  XC: 90,
  LXXX: 80,
  LXX: 70,
  LX: 60,
  L: 50,
  XL: 40,
  XXX: 30,
  XX: 20,
  XII: 12,
  // only here for tests; not used in practice
  XI: 11,
  // only here for tests; not used in practice
  X: 10,
  IX: 9,
  VIII: 8,
  VII: 7,
  VI: 6,
  V: 5,
  IV: 4,
  III: 3,
  II: 2,
  I: 1
}, zA = {
  // Roman Numeral One (U+2160)
  "Ⅰ": "I",
  // Roman Numeral Two (U+2161)
  "Ⅱ": "II",
  // Roman Numeral Three (U+2162)
  "Ⅲ": "III",
  // Roman Numeral Four (U+2163)
  "Ⅳ": "IV",
  // Roman Numeral Five (U+2164)
  "Ⅴ": "V",
  // Roman Numeral Six (U+2165)
  "Ⅵ": "VI",
  // Roman Numeral Seven (U+2166)
  "Ⅶ": "VII",
  // Roman Numeral Eight (U+2167)
  "Ⅷ": "VIII",
  // Roman Numeral Nine (U+2168)
  "Ⅸ": "IX",
  // Roman Numeral Ten (U+2169)
  "Ⅹ": "X",
  // Roman Numeral Eleven (U+216A)
  "Ⅺ": "XI",
  // Roman Numeral Twelve (U+216B)
  "Ⅻ": "XII",
  // Roman Numeral Fifty (U+216C)
  "Ⅼ": "L",
  // Roman Numeral One Hundred (U+216D)
  "Ⅽ": "C",
  // Roman Numeral Five Hundred (U+216E)
  "Ⅾ": "D",
  // Roman Numeral One Thousand (U+216F)
  "Ⅿ": "M",
  // Small Roman Numeral One (U+2170)
  "ⅰ": "I",
  // Small Roman Numeral Two (U+2171)
  "ⅱ": "II",
  // Small Roman Numeral Three (U+2172)
  "ⅲ": "III",
  // Small Roman Numeral Four (U+2173)
  "ⅳ": "IV",
  // Small Roman Numeral Five (U+2174)
  "ⅴ": "V",
  // Small Roman Numeral Six (U+2175)
  "ⅵ": "VI",
  // Small Roman Numeral Seven (U+2176)
  "ⅶ": "VII",
  // Small Roman Numeral Eight (U+2177)
  "ⅷ": "VIII",
  // Small Roman Numeral Nine (U+2178)
  "ⅸ": "IX",
  // Small Roman Numeral Ten (U+2179)
  "ⅹ": "X",
  // Small Roman Numeral Eleven (U+217A)
  "ⅺ": "XI",
  // Small Roman Numeral Twelve (U+217B)
  "ⅻ": "XII",
  // Small Roman Numeral Fifty (U+217C)
  "ⅼ": "L",
  // Small Roman Numeral One Hundred (U+217D)
  "ⅽ": "C",
  // Small Roman Numeral Five Hundred (U+217E)
  "ⅾ": "D",
  // Small Roman Numeral One Thousand (U+217F)
  "ⅿ": "M"
}, jme = new RegExp(
  `(${Object.keys(zA).join("|")})`,
  "gi"
), Gme = /^(?=[MDCLXVI])(M{0,3})(C[MD]|D?C{0,3})(X[CL]|L?X{0,3})(I[XV]|V?I{0,3})$/i, hO = {
  round: 3,
  allowTrailingInvalid: !1,
  romanNumerals: !1
}, qme = (e) => {
  const t = `${e}`.replace(
    jme,
    (l, c) => zA[c]
  ).toUpperCase(), n = Gme.exec(t);
  if (!n)
    return NaN;
  const [, o, s, i, a] = n;
  return (Gd[o] ?? 0) + (Gd[s] ?? 0) + (Gd[i] ?? 0) + (Gd[a] ?? 0);
}, Wme = /^\s*\//, Ume = (e, t = hO) => {
  if (typeof e == "number" || typeof e == "bigint")
    return e;
  let n = NaN;
  const o = `${e}`.replace(
    Hme,
    (p, m) => ` ${BA[m]}`
  ).replace("⁄", "/").trim();
  if (o.length === 0)
    return NaN;
  const s = {
    ...hO,
    ...t
  }, i = (s.allowTrailingInvalid ? zme : sw).exec(o);
  if (!i)
    return s.romanNumerals ? qme(o) : NaN;
  const [, a, l, c] = i, u = l.replace(/[,_]/g, ""), d = c == null ? void 0 : c.replace(/[,_]/g, "");
  if (!u && d && d.startsWith(".") ? n = 0 : n = parseInt(u), !d)
    return a ? n * -1 : n;
  const f = s.round === !1 ? NaN : parseFloat(`1e${Math.floor(Math.max(0, s.round))}`);
  if (d.startsWith(".") || d.startsWith("e") || d.startsWith("E")) {
    const p = parseFloat(`${n}${d}`);
    n = isNaN(f) ? p : Math.round(p * f) / f;
  } else if (Wme.test(d)) {
    const p = parseInt(u), m = parseInt(d.replace("/", ""));
    n = isNaN(f) ? p / m : Math.round(p * f / m) / f;
  } else {
    const p = d.split("/"), [m, b] = p.map((v) => parseInt(v));
    n += isNaN(f) ? m / b : Math.round(m * f / b) / f;
  }
  return a ? n * -1 : n;
}, uv = /* @__PURE__ */ Ki({}), _r = (e) => /* @__PURE__ */ C("button", { type: "button", "data-testid": e.testID, disabled: e.disabled && !e.disabledTranslation, className: e.className, title: e.disabledTranslation && e.disabled ? e.disabledTranslation.title : e.title, onClick: (t) => e.handleOnClick(t), children: e.disabledTranslation && e.disabled ? e.disabledTranslation.label : e.label }), HA = /* @__PURE__ */ rs((e, t) => /* @__PURE__ */ C("span", { "data-testid": e.testID, ref: t, className: e.className, title: e.title, children: e.label })), jA = "~", Th = "------", Kme = jA, Yme = Th, Xme = Th, Qme = jA, Zme = Th, Jme = Th, iw = ",", ri = { fields: { title: "Fields", placeholderName: Kme, placeholderLabel: Yme, placeholderGroupLabel: Xme }, operators: { title: "Operators", placeholderName: Qme, placeholderLabel: Zme, placeholderGroupLabel: Jme }, value: { title: "Value" }, removeRule: { label: "⨯", title: "Remove rule" }, removeGroup: { label: "⨯", title: "Remove group" }, addRule: { label: "+ Rule", title: "Add rule" }, addGroup: { label: "+ Group", title: "Add group" }, combinators: { title: "Combinators" }, notToggle: { label: "Not", title: "Invert this group" }, cloneRule: { label: "⧉", title: "Clone rule" }, cloneRuleGroup: { label: "⧉", title: "Clone group" }, shiftActionUp: { label: "˄", title: "Shift up" }, shiftActionDown: { label: "˅", title: "Shift down" }, dragHandle: { label: "⁞⁞", title: "Drag handle" }, lockRule: { label: "🔓", title: "Lock rule" }, lockGroup: { label: "🔓", title: "Lock group" }, lockRuleDisabled: { label: "🔒", title: "Unlock rule" }, lockGroupDisabled: { label: "🔒", title: "Unlock group" }, valueSourceSelector: { title: "Value source" } }, Tt = { ruleGroup: "ruleGroup", header: "ruleGroup-header", body: "ruleGroup-body", combinators: "ruleGroup-combinators", addRule: "ruleGroup-addRule", addGroup: "ruleGroup-addGroup", cloneRule: "rule-cloneRule", cloneGroup: "ruleGroup-cloneGroup", removeGroup: "ruleGroup-remove", notToggle: "ruleGroup-notToggle", rule: "rule", fields: "rule-fields", operators: "rule-operators", value: "rule-value", removeRule: "rule-remove", betweenRules: "betweenRules", valid: "queryBuilder-valid", invalid: "queryBuilder-invalid", shiftActions: "shiftActions", dndDragging: "dndDragging", dndOver: "dndOver", dndCopy: "dndCopy", dragHandle: "queryBuilder-dragHandle", disabled: "queryBuilder-disabled", lockRule: "rule-lock", lockGroup: "ruleGroup-lock", valueSource: "rule-valueSource", valueListItem: "rule-value-list-item" }, ebe = { queryBuilder: "", ruleGroup: "", header: "", body: "", combinators: "", addRule: "", addGroup: "", cloneRule: "", cloneGroup: "", removeGroup: "", notToggle: "", rule: "", fields: "", operators: "", value: "", removeRule: "", shiftActions: "", dragHandle: "", lockRule: "", lockGroup: "", valueSource: "", actionElement: "", valueSelector: "", betweenRules: "", valid: "", invalid: "", dndDragging: "", dndOver: "", dndCopy: "", disabled: "", valueListItem: "", branches: "" }, dt = { rule: "rule", ruleGroup: "rule-group", inlineCombinator: "inline-combinator", addGroup: "add-group", removeGroup: "remove-group", cloneGroup: "clone-group", cloneRule: "clone-rule", addRule: "add-rule", removeRule: "remove-rule", combinators: "combinators", fields: "fields", operators: "operators", valueEditor: "value-editor", notToggle: "not-toggle", shiftActions: "shift-actions", dragHandle: "drag-handle", lockRule: "lock-rule", lockGroup: "lock-group", valueSourceSelector: "value-source-selector" };
function GA(e) {
  let t, n, o = "";
  if (typeof e == "string" || typeof e == "number")
    o += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      const s = e.length;
      for (t = 0; t < s; t++)
        e[t] && (n = GA(e[t])) && (o && (o += " "), o += n);
    } else
      for (n in e)
        e[n] && (o && (o += " "), o += n);
  return o;
}
function dn() {
  let e = 0, t, n, o = "";
  const s = arguments.length;
  for (; e < s; e++)
    (t = e < 0 || arguments.length <= e ? void 0 : arguments[e]) && (n = GA(t)) && (o && (o += " "), o += n);
  return o;
}
var tbe = dn, nbe = (e) => {
  const { component: t, ...n } = e, o = dn(n.schema.suppressStandardClassnames || Tt.betweenRules, n.schema.classNames.betweenRules);
  return /* @__PURE__ */ C("div", { className: o, "data-testid": dt.inlineCombinator, children: /* @__PURE__ */ C(t, { ...n, testID: dt.combinators }) });
}, qA = (e) => /* @__PURE__ */ ie("label", { "data-testid": e.testID, className: e.className, title: e.title, children: [/* @__PURE__ */ C("input", { type: "checkbox", onChange: (t) => e.handleOnChange(t.target.checked), checked: !!e.checked, disabled: e.disabled }), e.label] }), Tr = { errorInvalidIndependentCombinatorsProp: "QueryBuilder was rendered with a truthy independentCombinators prop. This prop is deprecated and unnecessary. Furthermore, the initial query/defaultQuery prop was of type RuleGroupType instead of type RuleGroupIC. More info: https://react-querybuilder.js.org/docs/components/querybuilder#independent-combinators", errorUnnecessaryIndependentCombinatorsProp: "QueryBuilder was rendered with the deprecated and unnecessary independentCombinators prop. To use independent combinators, make sure the query/defaultQuery prop is of type RuleGroupIC when the component mounts. More info: https://react-querybuilder.js.org/docs/components/querybuilder#independent-combinators", errorDeprecatedRuleGroupProps: "A custom RuleGroup component has rendered a standard RuleGroup component with deprecated props. The combinator, not, and rules props should not be used. Instead, the full group object should be passed as the ruleGroup prop.", errorDeprecatedRuleProps: "A custom RuleGroup component has rendered a standard Rule component with deprecated props. The field, operator, value, and valueSource props should not be used. Instead, the full rule object should be passed as the rule prop.", errorBothQueryDefaultQuery: "QueryBuilder was rendered with both query and defaultQuery props. QueryBuilder must be either controlled or uncontrolled (specify either the query prop, or the defaultQuery prop, but not both). Decide between using a controlled or uncontrolled query builder and remove one of these props. More info: https://reactjs.org/link/controlled-components", errorUncontrolledToControlled: "QueryBuilder is changing from an uncontrolled component to be controlled. This is likely caused by the query changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled query builder for the lifetime of the component. More info: https://reactjs.org/link/controlled-components", errorControlledToUncontrolled: "QueryBuilder is changing from a controlled component to be uncontrolled. This is likely caused by the query changing from defined to undefined, which should not happen. Decide between using a controlled or uncontrolled query builder for the lifetime of the component. More info: https://reactjs.org/link/controlled-components", errorEnabledDndWithoutReactDnD: "QueryBuilder was rendered with the enableDragAndDrop prop set to true, but either react-dnd or react-dnd-html5-backend (or both) was not installed. To enable drag-and-drop functionality, install both packages and wrap QueryBuilder in QueryBuilderDnD from @react-querybuilder/dnd." }, aw = /* @__PURE__ */ h.createContext(null), obe = {}, dv = VA({ name: "queries", initialState: obe, reducers: { setQueryState: (e, t) => {
  let { payload: { qbId: n, query: o } } = t;
  e[n] = o;
} }, selectors: { getQuerySelectorById: (e, t) => e[t] } }), rbe = { [Tr.errorInvalidIndependentCombinatorsProp]: !1, [Tr.errorUnnecessaryIndependentCombinatorsProp]: !1, [Tr.errorDeprecatedRuleGroupProps]: !1, [Tr.errorDeprecatedRuleProps]: !1, [Tr.errorBothQueryDefaultQuery]: !1, [Tr.errorUncontrolledToControlled]: !1, [Tr.errorControlledToUncontrolled]: !1, [Tr.errorEnabledDndWithoutReactDnD]: !1 }, lw = VA({ name: "warnings", initialState: rbe, reducers: { rqbWarn: (e, t) => {
  let { payload: n } = t;
  e[n] || (console.error(n), e[n] = !0);
} } }), sbe = Gge(aw);
nw(aw);
var { rqbWarn: ibe } = lw.actions, gO = (e) => (t) => {
  setTimeout(() => t(ibe(e)));
}, abe = { queries: dv.getInitialState(), warnings: lw.getInitialState() }, lbe = { reducer: { queries: dv.reducer, warnings: lw.reducer }, preloadedState: abe, middleware: (e) => e({
  // Ignore non-serializable values in setQueryState actions and rule `value`s
  // https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
  serializableCheck: { ignoredActions: [dv.actions.setQueryState.type], ignoredPaths: [/^queries\b.*\.rules\.\d+\.value$/] }
}) };
function WA(e, t, n) {
  const o = sbe();
  process.env.NODE_ENV !== "production" && t && (e === "rule" && o(gO(Tr.errorDeprecatedRuleProps)), e === "ruleGroup" && o(gO(Tr.errorDeprecatedRuleGroupProps)));
}
var mO = !1, UA = (e, t) => {
  process.env.NODE_ENV !== "production" && !mO && e && !t && (console.error(Tr.errorEnabledDndWithoutReactDnD), mO = !0);
}, bO = Symbol.for("react.memo_cache_sentinel");
function xs(e) {
  return h.useMemo(
    () => {
      const t = Array.from({ length: e });
      for (let n = 0; n < e; n++)
        t[n] = bO;
      return t[bO] = !0, t;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
}
var lr = (e) => {
  const t = xs(2);
  let n;
  return t[0] !== e ? (n = (o, s) => {
    o == null || o.preventDefault(), o == null || o.stopPropagation(), e(o, s);
  }, t[0] = e, t[1] = n) : n = t[1], n;
}, cbe = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : iw;
  return typeof e == "string" ? e.split(`\\${t}`).map((n) => n.split(t)).reduce((n, o, s) => s === 0 ? o : [...n.slice(0, -1), `${n.at(-1)}${t}${o[0]}`, ...o.slice(1)], []) : [];
}, KA = function(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : iw;
  return e.map((n) => `${n ?? ""}`.replaceAll(t[0], `\\${t[0]}`)).join(t);
}, ube = (e) => typeof e == "string" ? e.trim() : e, ip = function(e) {
  let { retainEmptyStrings: t } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Array.isArray(e) ? e.map((n) => ube(n)) : typeof e == "string" ? cbe(e, iw).filter(t ? () => !0 : (n) => !/^\s*$/.test(n)).map((n) => n.trim()) : typeof e == "number" ? [e] : [];
};
new RegExp(sw.source.replace(/^\^/, String.raw`^\s*`).replace(/\$$/, String.raw`\s*$`));
var fl = (e) => e === null || typeof e != "object" ? !1 : Object.getPrototypeOf(e) === Object.prototype, YA = (e) => fl(e) && Array.isArray(e.rules), XA = (e) => YA(e) && typeof e.combinator == "string", yO = (e) => fl(e) && "name" in e && typeof e.name == "string", vO = (e) => fl(e) && "value" in e && typeof e.value == "string";
function CO(e, t) {
  return xh((o) => {
    const s = {};
    let i = !1;
    if (yO(o) && !vO(o) ? (s.value = o.name, i = !0) : !yO(o) && vO(o) && (s.name = o.value, i = !0), i)
      return Object.assign({}, t, o, s);
  })(e);
}
var cw = (e) => Array.isArray(e) && e.length > 0 && fl(e[0]) && "options" in e[0] && Array.isArray(e[0].options), fv = (e) => {
  if (Array.isArray(e)) {
    for (const t of e)
      if (fl(t) && "options" in t)
        for (const n of t.options)
          return !!(fl(n) && ("name" in n || "value" in n));
  }
  return !1;
}, QA = (e, t) => (cw(e) ? e.flatMap((n) => n.options) : e).find((n) => n.value === t || n.name === t), lu = (e) => {
  if (!Array.isArray(e) || e.length === 0)
    return null;
  if (fv(e)) {
    for (const t of e)
      if (t.options.length > 0)
        return t.options[0].value ?? t.options[0].name;
    return null;
  }
  return e[0].value ?? e[0].name;
}, wO = (e, t, n) => {
  var i;
  const o = CO(e), s = CO(n);
  return o.value === s.value ? !1 : typeof o.comparator == "string" ? o[o.comparator] === s[o.comparator] : ((i = o.comparator) == null ? void 0 : i.call(o, s, t)) ?? /* istanbul ignore next */
  !1;
}, dbe = (e, t, n) => {
  if (!e.comparator) {
    const o = (s) => (s.value ?? /* istanbul ignore next */
    s.name) !== (e.value ?? /* istanbul ignore next */
    e.name);
    return fv(t) ? t.map((s) => ({ ...s, options: s.options.filter((i) => o(i)) })) : t.filter((s) => o(s));
  }
  return fv(t) ? t.map((o) => ({ ...o, options: o.options.filter((s) => wO(e, n, s)) })).filter((o) => o.options.length > 0) : t.filter((o) => wO(e, n, o));
}, ZA = function(e) {
  let { parseNumbers: t } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!t || typeof e == "bigint" || typeof e == "number")
    return e;
  if (t === "native")
    return parseFloat(e);
  const n = (
    // TODO: Should these options be configurable?
    Ume(e, { allowTrailingInvalid: t === "enhanced", romanNumerals: !1, round: !1 })
  );
  return isNaN(n) ? e : n;
}, JA = (e) => e.slice(0, -1), eF = (e, t) => e.length === t.length && e.every((n, o) => n === t[o]), fbe = (e, t) => e === !1 ? !1 : e ? !0 : t !== !1, pbe = (e, t) => e ? !0 : e === !1 ? !1 : !!t, hbe = (e, t, n) => e ? fbe(t, n) : pbe(t, n), Hb = (e, t, n) => hbe(e, t, n), gbe = (e) => {
  const t = (o) => {
    const s = xs(3), i = SO(e);
    let a;
    return s[0] !== i || s[1] !== o.children ? (a = C(uv.Provider, { value: i, children: o.children }), s[0] = i, s[1] = o.children, s[2] = a) : a = s[2], a;
  }, n = (o) => {
    const s = xs(3), i = SO(o);
    let a;
    return s[0] !== i || s[1] !== o.children ? (a = C(uv.Provider, { value: i, children: o.children }), s[0] = i, s[1] = o.children, s[2] = a) : a = s[2], a;
  };
  return (o) => /* @__PURE__ */ C(t, { children: /* @__PURE__ */ C(n, { ...o, children: o.children }) });
}, tF = (e) => {
  const t = typeof e == "boolean" ? e : typeof e == "object" && e !== null ? e.valid : null;
  return typeof t == "boolean" ? t ? Tt.valid : Tt.invalid : "";
}, At = (e, t) => dn(t.map((n) => dn(n == null ? void 0 : n[e]))), mbe = function() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return { queryBuilder: At("queryBuilder", t), ruleGroup: At("ruleGroup", t), header: At("header", t), body: At("body", t), combinators: At("combinators", t), addRule: At("addRule", t), addGroup: At("addGroup", t), cloneRule: At("cloneRule", t), cloneGroup: At("cloneGroup", t), removeGroup: At("removeGroup", t), rule: At("rule", t), fields: At("fields", t), operators: At("operators", t), value: At("value", t), removeRule: At("removeRule", t), notToggle: At("notToggle", t), shiftActions: At("shiftActions", t), dragHandle: At("dragHandle", t), lockRule: At("lockRule", t), lockGroup: At("lockGroup", t), valueSource: At("valueSource", t), actionElement: At("actionElement", t), valueSelector: At("valueSelector", t), betweenRules: At("betweenRules", t), valid: At("valid", t), invalid: At("invalid", t), dndDragging: At("dndDragging", t), dndOver: At("dndOver", t), dndCopy: At("dndCopy", t), disabled: At("disabled", t), valueListItem: At("valueListItem", t), branches: At("branches", t) };
}, bbe = Object.entries, zn = (e, t, n) => {
  const o = bbe(t).map((s) => {
    var c;
    let [i, [a, l]] = s;
    return [i, a ?? l ?? ((c = (n ? ri : {})[e]) == null ? void 0 : c[i])];
  }).filter((s) => !!s[1]);
  return o.length > 0 ? { [e]: Object.fromEntries(o) } : void 0;
}, ybe = (e) => cw(e) ? e.map((t) => /* @__PURE__ */ C("optgroup", { label: t.label, children: t.options.map((n) => /* @__PURE__ */ C("option", { value: n.name, disabled: n.disabled, children: n.label }, n.name)) }, t.label)) : Array.isArray(e) ? e.map((t) => /* @__PURE__ */ C("option", { value: t.name, disabled: t.disabled, children: t.label }, t.name)) : null, vbe = /* @__PURE__ */ h.memo(function(t) {
  const n = xs(7), o = wbe(t), s = lr(o.cloneRule), i = lr(o.toggleLockRule), a = lr(o.removeRule), l = lr(o.shiftRuleUp), c = lr(o.shiftRuleDown);
  let u;
  return n[0] !== o || n[1] !== s || n[2] !== i || n[3] !== a || n[4] !== l || n[5] !== c ? (u = C("div", { ref: o.dndRef, "data-testid": dt.rule, "data-dragmonitorid": o.dragMonitorId, "data-dropmonitorid": o.dropMonitorId, className: o.outerClassName, "data-rule-id": o.id, "data-level": o.path.length, "data-path": JSON.stringify(o.path), children: C(Cbe, { ...o, cloneRule: s, toggleLockRule: i, removeRule: a, shiftRuleUp: l, shiftRuleDown: c }) }), n[0] = o, n[1] = s, n[2] = i, n[3] = a, n[4] = l, n[5] = c, n[6] = u) : u = n[6], u;
}), Cbe = /* @__PURE__ */ h.memo(function(t) {
  const { schema: { controls: { shiftActions: n, dragHandle: o, fieldSelector: s, operatorSelector: i, valueSourceSelector: a, valueEditor: l, cloneRuleAction: c, lockRuleAction: u, removeRuleAction: d } } } = t;
  return /* @__PURE__ */ ie(mo, { children: [t.schema.showShiftActions && /* @__PURE__ */ C(n, { testID: dt.shiftActions, level: t.path.length, path: t.path, titles: { shiftUp: t.translations.shiftActionUp.title, shiftDown: t.translations.shiftActionDown.title }, labels: { shiftUp: t.translations.shiftActionUp.label, shiftDown: t.translations.shiftActionDown.label }, className: t.classNames.shiftActions, disabled: t.disabled, shiftUp: t.shiftRuleUp, shiftDown: t.shiftRuleDown, shiftUpDisabled: t.shiftUpDisabled, shiftDownDisabled: t.shiftDownDisabled, context: t.context, validation: t.validationResult, schema: t.schema, ruleOrGroup: t.rule }, dt.shiftActions), t.schema.enableDragAndDrop && /* @__PURE__ */ C(o, { testID: dt.dragHandle, ref: t.dragRef, level: t.path.length, path: t.path, title: t.translations.dragHandle.title, label: t.translations.dragHandle.label, className: t.classNames.dragHandle, disabled: t.disabled, context: t.context, validation: t.validationResult, schema: t.schema, ruleOrGroup: t.rule }, dt.dragHandle), /* @__PURE__ */ C(s, { testID: dt.fields, options: t.schema.fields, title: t.translations.fields.title, value: t.rule.field, operator: t.rule.operator, className: t.classNames.fields, handleOnChange: t.onChangeField, level: t.path.length, path: t.path, disabled: t.disabled, context: t.context, validation: t.validationResult, schema: t.schema, rule: t.rule }, dt.fields), (t.schema.autoSelectField || t.rule.field !== t.translations.fields.placeholderName) && /* @__PURE__ */ ie(mo, { children: [/* @__PURE__ */ C(i, { testID: dt.operators, field: t.rule.field, fieldData: t.fieldData, title: t.translations.operators.title, options: t.operators, value: t.rule.operator, className: t.classNames.operators, handleOnChange: t.onChangeOperator, level: t.path.length, path: t.path, disabled: t.disabled, context: t.context, validation: t.validationResult, schema: t.schema, rule: t.rule }, dt.operators), (t.schema.autoSelectOperator || t.rule.operator !== t.translations.operators.placeholderName) && !t.hideValueControls && /* @__PURE__ */ ie(mo, { children: [!["null", "notNull"].includes(t.rule.operator) && t.valueSources.length > 1 && /* @__PURE__ */ C(a, { testID: dt.valueSourceSelector, field: t.rule.field, fieldData: t.fieldData, title: t.translations.valueSourceSelector.title, options: t.valueSourceOptions, value: t.rule.valueSource ?? "value", className: t.classNames.valueSource, handleOnChange: t.onChangeValueSource, level: t.path.length, path: t.path, disabled: t.disabled, context: t.context, validation: t.validationResult, schema: t.schema, rule: t.rule }, dt.valueSourceSelector), /* @__PURE__ */ C(l, { testID: dt.valueEditor, field: t.rule.field, fieldData: t.fieldData, title: t.translations.value.title, operator: t.rule.operator, value: t.rule.value, valueSource: t.rule.valueSource ?? "value", type: t.valueEditorType, inputType: t.inputType, values: t.values, listsAsArrays: t.schema.listsAsArrays, parseNumbers: t.schema.parseNumbers, separator: t.valueEditorSeparator, className: t.classNames.value, handleOnChange: t.onChangeValue, level: t.path.length, path: t.path, disabled: t.disabled, context: t.context, validation: t.validationResult, schema: t.schema, rule: t.rule }, dt.valueEditor)] })] }), t.schema.showCloneButtons && /* @__PURE__ */ C(c, { testID: dt.cloneRule, label: t.translations.cloneRule.label, title: t.translations.cloneRule.title, className: t.classNames.cloneRule, handleOnClick: t.cloneRule, level: t.path.length, path: t.path, disabled: t.disabled, context: t.context, validation: t.validationResult, ruleOrGroup: t.rule, schema: t.schema }, dt.cloneRule), t.schema.showLockButtons && /* @__PURE__ */ C(u, { testID: dt.lockRule, label: t.translations.lockRule.label, title: t.translations.lockRule.title, className: t.classNames.lockRule, handleOnClick: t.toggleLockRule, level: t.path.length, path: t.path, disabled: t.disabled, disabledTranslation: t.parentDisabled ? void 0 : t.translations.lockRuleDisabled, context: t.context, validation: t.validationResult, ruleOrGroup: t.rule, schema: t.schema }, dt.lockRule), /* @__PURE__ */ C(d, { testID: dt.removeRule, label: t.translations.removeRule.label, title: t.translations.removeRule.title, className: t.classNames.removeRule, handleOnClick: t.removeRule, level: t.path.length, path: t.path, disabled: t.disabled, context: t.context, validation: t.validationResult, ruleOrGroup: t.rule, schema: t.schema }, dt.removeRule)] });
}), wbe = (e) => {
  const {
    id: t,
    path: n,
    rule: o,
    schema: { classNames: s, fields: i, fieldMap: a, getInputType: l, getOperators: c, getValueEditorType: u, getValueEditorSeparator: d, getValueSources: f, getValues: p, validationMap: m, enableDragAndDrop: b, getRuleClassname: v, suppressStandardClassnames: g },
    actions: { moveRule: y, onPropChange: w, onRuleRemove: x },
    disabled: S,
    parentDisabled: T,
    shiftUpDisabled: E,
    shiftDownDisabled: O,
    field: M,
    operator: D,
    value: R,
    valueSource: P,
    // Drag-and-drop
    dropEffect: F = "move",
    dragMonitorId: $ = "",
    dropMonitorId: N = "",
    dndRef: A = null,
    dragRef: k = null,
    isDragging: L = !1,
    isOver: B = !1
  } = e;
  WA("rule", !o), UA(b, !!($ || N || A || k));
  const V = !!T || !!S, _ = Ye(() => o ?? { id: t, field: M ?? /* istanbul ignore next */
  "", operator: D ?? /* istanbul ignore next */
  "", value: R, valueSource: P }, [M, t, D, o, R, P]), z = Ye(() => ({ shiftActions: dn(g || Tt.shiftActions, s.shiftActions), dragHandle: dn(g || Tt.dragHandle, s.dragHandle), fields: dn(g || Tt.fields, s.valueSelector, s.fields), operators: dn(g || Tt.operators, s.valueSelector, s.operators), valueSource: dn(g || Tt.valueSource, s.valueSelector, s.valueSource), value: dn(g || Tt.value, s.value), cloneRule: dn(g || Tt.cloneRule, s.actionElement, s.cloneRule), lockRule: dn(g || Tt.lockRule, s.actionElement, s.lockRule), removeRule: dn(g || Tt.removeRule, s.actionElement, s.removeRule), valueListItem: dn(g || Tt.valueListItem, s.valueListItem) }), [s.shiftActions, s.dragHandle, s.valueSelector, s.fields, s.operators, s.valueSource, s.value, s.actionElement, s.cloneRule, s.lockRule, s.removeRule, s.valueListItem, g]), j = pt(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (be) => (me, Ae) => {
      V || w(be, me, n, Ae);
    },
    [V, w, n]
  ), W = Ye(() => j("field"), [j]), J = Ye(() => j("operator"), [j]), G = Ye(() => j("valueSource"), [j]), q = Ye(() => j("value"), [j]), Z = pt((be, me) => {
    if (!V) {
      const Ae = [...JA(n), n.at(-1) + 1];
      y(n, Ae, !0, me);
    }
  }, [V, y, n]), Y = pt((be, me) => w("disabled", !V, n, me), [V, w, n]), Q = pt((be, me) => {
    V || x(n);
  }, [V, x, n]), ee = pt((be, me) => {
    !V && !E && y(n, "up", be == null ? void 0 : be.altKey, me);
  }, [V, y, n, E]), ne = pt((be, me) => {
    !V && !O && y(n, "down", be == null ? void 0 : be.altKey, me);
  }, [V, y, n, O]), H = Ye(() => (a == null ? void 0 : a[_.field]) ?? { name: _.field, value: _.field, label: _.field }, [a, _.field]), U = Ye(() => H.inputType ?? l(_.field, _.operator, { fieldData: H }), [H, l, _.field, _.operator]), X = Ye(() => c(_.field, { fieldData: H }), [H, c, _.field]), re = Ye(() => QA(X, _.operator), [X, _.operator]), oe = re == null ? void 0 : re.arity, le = typeof oe == "string" && oe === "unary" || typeof oe == "number" && oe < 2, se = Ye(() => typeof H.valueSources == "function" ? H.valueSources(_.operator) : H.valueSources ?? f(_.field, _.operator, { fieldData: H }), [H, f, _.field, _.operator]), Ce = Ye(() => _.valueSource === "field" ? "select" : u(_.field, _.operator, { fieldData: H }), [H, u, _.field, _.operator, _.valueSource]), $e = Ye(() => d(_.field, _.operator, { fieldData: H }), [H, d, _.field, _.operator]), we = Ye(() => _.valueSource === "field" ? dbe(H, i, _.operator) : H.values ?? p(_.field, _.operator, { fieldData: H }), [H, i, p, _.field, _.operator, _.valueSource]), Te = Ye(() => se.map((be) => ({ name: be, value: be, label: be })), [se]), ue = Ye(() => m[t ?? /* istanbul ignore next */
  ""] ?? (typeof H.validator == "function" ? H.validator(_) : null), [H, t, _, m]), de = Ye(() => tF(ue), [ue]), Pe = Ye(() => (H == null ? void 0 : H.className) ?? "", [H == null ? void 0 : H.className]), ke = Ye(() => (re == null ? void 0 : re.className) ?? "", [re == null ? void 0 : re.className]), Me = Ye(() => dn(
    v(_, { fieldData: H }),
    Pe,
    ke,
    g || Tt.rule,
    s.rule,
    // custom conditional classes
    V && s.disabled,
    L && s.dndDragging,
    B && s.dndOver,
    B && F === "copy" && s.dndCopy,
    // standard conditional classes
    g || { [Tt.disabled]: V, [Tt.dndDragging]: L, [Tt.dndOver]: B, [Tt.dndCopy]: B && F === "copy" },
    de
  ), [s.disabled, s.dndCopy, s.dndDragging, s.dndOver, s.rule, V, F, Pe, H, v, L, B, ke, _, g, de]);
  return { ...e, classNames: z, cloneRule: Z, disabled: V, dndRef: A, dragMonitorId: $, dragRef: k, dropMonitorId: N, fieldData: H, generateOnChangeHandler: j, onChangeField: W, onChangeOperator: J, onChangeValueSource: G, onChangeValue: q, hideValueControls: le, inputType: U, operators: X, outerClassName: Me, removeRule: Q, rule: _, shiftRuleUp: ee, shiftRuleDown: ne, toggleLockRule: Y, validationResult: ue, valueEditorSeparator: $e, valueEditorType: Ce, values: we, valueSourceOptions: Te, valueSources: se };
}, Sbe = /* @__PURE__ */ h.memo(function(t) {
  const n = xs(11), o = Rbe(t), { schema: s } = o, { controls: i } = s, { ruleGroupBodyElements: a, ruleGroupHeaderElements: l } = i, c = lr(o.addRule), u = lr(o.addGroup), d = lr(o.cloneGroup), f = lr(o.toggleLockGroup), p = lr(o.removeGroup), m = lr(o.shiftGroupUp), b = lr(o.shiftGroupDown);
  let v;
  return n[0] !== o || n[1] !== c || n[2] !== u || n[3] !== d || n[4] !== f || n[5] !== p || n[6] !== m || n[7] !== b || n[8] !== l || n[9] !== a ? (v = ie("div", { ref: o.previewRef, title: o.accessibleDescription, className: o.outerClassName, "data-testid": dt.ruleGroup, "data-dragmonitorid": o.dragMonitorId, "data-dropmonitorid": o.dropMonitorId, "data-rule-group-id": o.id, "data-level": o.path.length, "data-path": JSON.stringify(o.path), children: [C("div", { ref: o.dropRef, className: o.classNames.header, children: C(l, { ...o, addRule: c, addGroup: u, cloneGroup: d, toggleLockGroup: f, removeGroup: p, shiftGroupUp: m, shiftGroupDown: b }) }), C("div", { className: o.classNames.body, children: C(a, { ...o, addRule: c, addGroup: u, cloneGroup: d, toggleLockGroup: f, removeGroup: p, shiftGroupUp: m, shiftGroupDown: b }) })] }), n[0] = o, n[1] = c, n[2] = u, n[3] = d, n[4] = f, n[5] = p, n[6] = m, n[7] = b, n[8] = l, n[9] = a, n[10] = v) : v = n[10], v;
}), xbe = /* @__PURE__ */ h.memo(function(t) {
  const { schema: { controls: { shiftActions: n, dragHandle: o, combinatorSelector: s, notToggle: i, addRuleAction: a, addGroupAction: l, cloneGroupAction: c, lockGroupAction: u, removeGroupAction: d } } } = t;
  return /* @__PURE__ */ ie(mo, { children: [t.schema.showShiftActions && t.path.length > 0 && /* @__PURE__ */ C(n, { testID: dt.shiftActions, level: t.path.length, path: t.path, titles: { shiftUp: t.translations.shiftActionUp.title, shiftDown: t.translations.shiftActionDown.title }, labels: { shiftUp: t.translations.shiftActionUp.label, shiftDown: t.translations.shiftActionDown.label }, className: t.classNames.shiftActions, disabled: t.disabled, shiftUp: t.shiftGroupUp, shiftDown: t.shiftGroupDown, shiftUpDisabled: t.shiftUpDisabled, shiftDownDisabled: t.shiftDownDisabled, context: t.context, validation: t.validationResult, schema: t.schema, ruleOrGroup: t.ruleGroup }, dt.shiftActions), t.path.length > 0 && t.schema.enableDragAndDrop && /* @__PURE__ */ C(o, { testID: dt.dragHandle, ref: t.dragRef, level: t.path.length, path: t.path, title: t.translations.dragHandle.title, label: t.translations.dragHandle.label, className: t.classNames.dragHandle, disabled: t.disabled, context: t.context, validation: t.validationResult, schema: t.schema, ruleOrGroup: t.ruleGroup }, dt.dragHandle), !t.schema.showCombinatorsBetweenRules && !t.schema.independentCombinators && /* @__PURE__ */ C(s, { testID: dt.combinators, options: t.schema.combinators, value: t.combinator, title: t.translations.combinators.title, className: t.classNames.combinators, handleOnChange: t.onCombinatorChange, rules: t.ruleGroup.rules, level: t.path.length, path: t.path, disabled: t.disabled, context: t.context, validation: t.validationResult, schema: t.schema }, dt.combinators), t.schema.showNotToggle && /* @__PURE__ */ C(i, { testID: dt.notToggle, className: t.classNames.notToggle, title: t.translations.notToggle.title, label: t.translations.notToggle.label, checked: t.ruleGroup.not, handleOnChange: t.onNotToggleChange, level: t.path.length, disabled: t.disabled, path: t.path, context: t.context, validation: t.validationResult, schema: t.schema, ruleGroup: t.ruleGroup }, dt.notToggle), /* @__PURE__ */ C(a, { testID: dt.addRule, label: t.translations.addRule.label, title: t.translations.addRule.title, className: t.classNames.addRule, handleOnClick: t.addRule, rules: t.ruleGroup.rules, level: t.path.length, path: t.path, disabled: t.disabled, context: t.context, validation: t.validationResult, ruleOrGroup: t.ruleGroup, schema: t.schema }, dt.addRule), /* @__PURE__ */ C(l, { testID: dt.addGroup, label: t.translations.addGroup.label, title: t.translations.addGroup.title, className: t.classNames.addGroup, handleOnClick: t.addGroup, rules: t.ruleGroup.rules, level: t.path.length, path: t.path, disabled: t.disabled, context: t.context, validation: t.validationResult, ruleOrGroup: t.ruleGroup, schema: t.schema }, dt.addGroup), t.schema.showCloneButtons && t.path.length > 0 && /* @__PURE__ */ C(c, { testID: dt.cloneGroup, label: t.translations.cloneRuleGroup.label, title: t.translations.cloneRuleGroup.title, className: t.classNames.cloneGroup, handleOnClick: t.cloneGroup, rules: t.ruleGroup.rules, level: t.path.length, path: t.path, disabled: t.disabled, context: t.context, validation: t.validationResult, ruleOrGroup: t.ruleGroup, schema: t.schema }, dt.cloneGroup), t.schema.showLockButtons && /* @__PURE__ */ C(u, { testID: dt.lockGroup, label: t.translations.lockGroup.label, title: t.translations.lockGroup.title, className: t.classNames.lockGroup, handleOnClick: t.toggleLockGroup, rules: t.ruleGroup.rules, level: t.path.length, path: t.path, disabled: t.disabled, disabledTranslation: t.parentDisabled ? void 0 : t.translations.lockGroupDisabled, context: t.context, validation: t.validationResult, ruleOrGroup: t.ruleGroup, schema: t.schema }, dt.lockGroup), t.path.length > 0 && /* @__PURE__ */ C(d, { testID: dt.removeGroup, label: t.translations.removeGroup.label, title: t.translations.removeGroup.title, className: t.classNames.removeGroup, handleOnClick: t.removeGroup, rules: t.ruleGroup.rules, level: t.path.length, path: t.path, disabled: t.disabled, context: t.context, validation: t.validationResult, ruleOrGroup: t.ruleGroup, schema: t.schema }, dt.removeGroup)] });
}), Tbe = /* @__PURE__ */ h.memo(function(t) {
  const { schema: { controls: { combinatorSelector: n, inlineCombinator: o, ruleGroup: s, rule: i } } } = t;
  return /* @__PURE__ */ C(mo, { children: t.ruleGroup.rules.map((a, l, c) => {
    let { length: u } = c;
    const d = t.pathsMemo[l], f = d.path, p = d.disabled || typeof a != "string" && a.disabled, m = eF([0], f), b = t.path.length === 0 && l === u - 1, v = typeof a == "string" ? [...f, a].join("-") : a.id;
    return /* @__PURE__ */ ie(yF, { children: [l > 0 && !t.schema.independentCombinators && t.schema.showCombinatorsBetweenRules && /* @__PURE__ */ C(o, { options: t.schema.combinators, value: t.combinator, title: t.translations.combinators.title, className: t.classNames.combinators, handleOnChange: t.onCombinatorChange, rules: t.ruleGroup.rules, level: t.path.length, context: t.context, validation: t.validationResult, component: n, path: f, disabled: t.disabled, schema: t.schema }, dt.inlineCombinator), typeof a == "string" ? /* @__PURE__ */ C(o, { options: t.schema.combinators, value: a, title: t.translations.combinators.title, className: t.classNames.combinators, handleOnChange: (g) => t.onIndependentCombinatorChange(g, l), rules: t.ruleGroup.rules, level: t.path.length, context: t.context, validation: t.validationResult, component: n, path: f, disabled: p, schema: t.schema }, `${dt.inlineCombinator}-independent`) : YA(a) ? /* @__PURE__ */ C(s, { id: a.id, schema: t.schema, actions: t.actions, path: f, translations: t.translations, ruleGroup: a, rules: a.rules, combinator: XA(a) ? a.combinator : void 0, not: !!a.not, disabled: p, parentDisabled: t.parentDisabled || t.disabled, shiftUpDisabled: m, shiftDownDisabled: b, context: t.context }, dt.ruleGroup) : /* @__PURE__ */ C(i, { id: a.id, rule: a, field: a.field, operator: a.operator, value: a.value, valueSource: a.valueSource, schema: t.schema, actions: t.actions, path: f, disabled: p, parentDisabled: t.parentDisabled || t.disabled, translations: t.translations, shiftUpDisabled: m, shiftDownDisabled: b, context: t.context }, dt.rule)] }, v);
  }) });
}), Rbe = (e) => {
  const {
    id: t,
    path: n,
    ruleGroup: o,
    schema: { qbId: s, accessibleDescriptionGenerator: i, classNames: a, combinators: l, createRule: c, createRuleGroup: u, disabledPaths: d, independentCombinators: f, validationMap: p, enableDragAndDrop: m, getRuleGroupClassname: b, suppressStandardClassnames: v },
    actions: { onGroupAdd: g, onGroupRemove: y, onPropChange: w, onRuleAdd: x, moveRule: S },
    disabled: T,
    parentDisabled: E,
    shiftUpDisabled: O,
    shiftDownDisabled: M,
    combinator: D,
    rules: R,
    not: P,
    // Drag-and-drop
    dropEffect: F = "move",
    dragMonitorId: $ = "",
    dropMonitorId: N = "",
    previewRef: A = null,
    dragRef: k = null,
    dropRef: L = null,
    isDragging: B = !1,
    isOver: V = !1
  } = e;
  WA("ruleGroup", !o), UA(m, !!($ || N || A || k || L));
  const _ = !!E || !!T, z = Ye(() => o && XA(o) ? o.combinator : o ? lu(l) : D ?? lu(l), [D, l, o]), j = Ye(() => {
    if (o) {
      if (o.combinator === z || f)
        return o;
      const we = structuredClone(o);
      return we.combinator = z, we;
    }
    return { rules: R, not: P };
  }, [z, f, P, o, R]), W = Ye(() => ({
    header: dn(v || Tt.header, a.header, V && F === "copy" && a.dndCopy, v || { [Tt.dndOver]: V, [Tt.dndCopy]: V && F === "copy" }),
    shiftActions: dn(v || Tt.shiftActions, a.shiftActions),
    dragHandle: dn(v || Tt.dragHandle, a.dragHandle),
    combinators: dn(v || Tt.combinators, a.valueSelector, a.combinators),
    // betweenRules: clsx(
    //   suppressStandardClassnames || standardClassnames.betweenRules,
    //   classNamesProp.betweenRules
    // ),
    notToggle: dn(v || Tt.notToggle, a.notToggle),
    addRule: dn(v || Tt.addRule, a.actionElement, a.addRule),
    addGroup: dn(v || Tt.addGroup, a.actionElement, a.addGroup),
    cloneGroup: dn(v || Tt.cloneGroup, a.actionElement, a.cloneGroup),
    lockGroup: dn(v || Tt.lockGroup, a.actionElement, a.lockGroup),
    removeGroup: dn(v || Tt.removeGroup, a.actionElement, a.removeGroup),
    body: dn(v || Tt.body, a.body)
  }), [a.actionElement, a.addGroup, a.addRule, a.body, a.cloneGroup, a.combinators, a.dndCopy, a.dragHandle, a.header, a.lockGroup, a.notToggle, a.removeGroup, a.shiftActions, a.valueSelector, F, V, v]), J = pt((we) => {
    _ || w("combinator", we, n);
  }, [_, w, n]), G = pt(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (we, Te, ue) => {
      _ || w("combinator", we, [...n, Te]);
    },
    [_, w, n]
  ), q = pt(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (we, Te) => {
      _ || w("not", we, n);
    },
    [_, w, n]
  ), Z = pt((we, Te) => {
    if (!_) {
      const ue = c();
      x(ue, n, Te);
    }
  }, [c, _, x, n]), Y = pt((we, Te) => {
    if (!_) {
      const ue = u(f);
      g(ue, n, Te);
    }
  }, [u, _, f, g, n]), Q = pt(() => {
    if (!_) {
      const we = [...JA(n), n.at(-1) + 1];
      S(n, we, !0);
    }
  }, [_, S, n]), ee = pt(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (we, Te) => {
      !_ && !O && S(n, "up", we == null ? void 0 : we.altKey);
    },
    [_, S, n, O]
  ), ne = pt(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (we, Te) => {
      !_ && !M && S(n, "down", we == null ? void 0 : we.altKey);
    },
    [_, S, n, M]
  ), H = pt(() => {
    w("disabled", !_, n);
  }, [_, w, n]), U = pt(() => {
    _ || y(n);
  }, [_, y, n]), X = Ye(() => p[t ?? /* istanbul ignore next */
  ""], [t, p]), re = Ye(() => tF(X), [X]), oe = Ye(() => {
    var we;
    return f ? null : ((we = QA(l, z)) == null ? void 0 : we.className) ?? "";
  }, [z, l, f]), le = Ye(() => b(j), [b, j]), se = Ye(() => dn(le, oe, v || Tt.ruleGroup, a.ruleGroup, _ && a.disabled, B && a.dndDragging, v || { [Tt.disabled]: _, [Tt.dndDragging]: B }, re), [a.disabled, a.dndDragging, a.ruleGroup, oe, _, B, le, v, re]), Ce = Ye(() => {
    const we = [];
    for (let Te = 0; Te < j.rules.length; Te++) {
      const ue = [...n, Te];
      we[Te] = { path: ue, disabled: _ || d.some((de) => eF(ue, de)) };
    }
    return we;
  }, [_, n, j.rules.length, d]), $e = Ye(() => i({ path: n, qbId: s }), [i, n, s]);
  return { ...e, addGroup: Y, addRule: Z, accessibleDescription: $e, classNames: W, cloneGroup: Q, combinator: z, disabled: _, dragMonitorId: $, dragRef: k, dropMonitorId: N, dropRef: L, isDragging: B, isOver: V, onCombinatorChange: J, onGroupAdd: g, onIndependentCombinatorChange: G, onNotToggleChange: q, outerClassName: se, parentDisabled: E, pathsMemo: Ce, previewRef: A, removeGroup: U, ruleGroup: j, shiftGroupUp: ee, shiftGroupDown: ne, toggleLockGroup: H, validationClassName: re, validationResult: X };
}, nF = (e) => {
  var t, n, o, s;
  return /* @__PURE__ */ ie("div", { "data-testid": e.testID, className: e.className, children: [/* @__PURE__ */ C("button", { disabled: e.disabled || e.shiftUpDisabled, onClick: e.shiftUp, title: (t = e.titles) == null ? void 0 : t.shiftUp, children: (n = e.labels) == null ? void 0 : n.shiftUp }), /* @__PURE__ */ C("button", { disabled: e.disabled || e.shiftDownDisabled, onClick: e.shiftDown, title: (o = e.titles) == null ? void 0 : o.shiftDown, children: (s = e.labels) == null ? void 0 : s.shiftDown })] });
}, oF = (e) => {
  const {
    operator: t,
    value: n,
    handleOnChange: o,
    title: s,
    className: i,
    type: a = "text",
    inputType: l = "text",
    values: c = [],
    listsAsArrays: u,
    fieldData: d,
    disabled: f,
    separator: p = null,
    testID: m,
    selectorComponent: b = e.schema.controls.valueSelector,
    // Some value selectors spread all extra props to the rendered component, so
    // we cherry pick these out of `propsForValueSelector` to keep them from being
    // assigned to DOM elements. (The props with mixed case are the only ones that
    // really matter. Props in all lowercase don't emit warnings.)
    parseNumbers: v,
    skipHook: g,
    valueSource: y,
    ...w
  } = e, { valueAsArray: x, multiValueHandler: S, parseNumberMethod: T, valueListItemClassName: E } = rF(e);
  if (t === "null" || t === "notNull")
    return null;
  const O = (d == null ? void 0 : d.placeholder) ?? "", M = ["in", "notIn"].includes(t) ? "text" : l || "text";
  if ((t === "between" || t === "notBetween") && (a === "select" || a === "text")) {
    const D = ["from", "to"].map((R, P) => a === "text" ? /* @__PURE__ */ C("input", { type: M, placeholder: O, value: x[P] ?? "", className: E, disabled: f, onChange: (F) => S(F.target.value, P) }, R) : /* @__PURE__ */ C(b, { ...w, schema: e.schema, className: E, handleOnChange: (F) => S(F, P), disabled: f, value: x[P] ?? lu(c), options: c, listsAsArrays: u }, R));
    return /* @__PURE__ */ ie("span", { "data-testid": m, className: i, title: s, children: [D[0], p, D[1]] });
  }
  switch (a) {
    case "select":
    case "multiselect":
      return /* @__PURE__ */ C(b, { ...w, schema: e.schema, testID: m, className: i, title: s, handleOnChange: o, disabled: f, value: n, options: c, multiple: a === "multiselect", listsAsArrays: u });
    case "textarea":
      return /* @__PURE__ */ C("textarea", { "data-testid": m, placeholder: O, value: n, title: s, className: i, disabled: f, onChange: (D) => o(D.target.value) });
    case "switch":
    case "checkbox":
      return /* @__PURE__ */ C("input", { "data-testid": m, type: "checkbox", className: i, title: s, onChange: (D) => o(D.target.checked), checked: !!n, disabled: f });
    case "radio":
      return /* @__PURE__ */ C("span", { "data-testid": m, className: i, title: s, children: c.map((D) => /* @__PURE__ */ ie("label", { children: [/* @__PURE__ */ C("input", { type: "radio", value: D.name, disabled: f, checked: n === D.name, onChange: (R) => o(R.target.value) }), D.label] }, D.name)) });
  }
  return /* @__PURE__ */ C("input", { "data-testid": m, type: M, placeholder: O, value: n, title: s, className: i, disabled: f, onChange: (D) => o(ZA(D.target.value, { parseNumbers: T })) });
}, rF = (e) => {
  const t = xs(27), { handleOnChange: n, inputType: o, operator: s, value: i, listsAsArrays: a, parseNumbers: l, values: c, type: u, skipHook: d, schema: f } = e, { classNames: p, suppressStandardClassnames: m } = f;
  let b, v;
  t[0] !== d || t[1] !== u || t[2] !== s || t[3] !== i || t[4] !== o || t[5] !== n ? (b = () => {
    !d && u !== "multiselect" && !["between", "notBetween", "in", "notIn"].includes(s) && (Array.isArray(i) || o === "number" && typeof i == "string" && i.includes(",")) && n(ip(i, { retainEmptyStrings: !0 })[0] ?? "");
  }, v = [n, o, s, d, u, i], t[0] = d, t[1] = u, t[2] = s, t[3] = i, t[4] = o, t[5] = n, t[6] = b, t[7] = v) : (b = t[6], v = t[7]), Nt(b, v);
  let g, y;
  t[8] !== i ? (y = ip(i, { retainEmptyStrings: !0 }), t[8] = i, t[9] = y) : y = t[9], g = y;
  const w = g;
  let x;
  e: {
    if (typeof l == "string") {
      let F;
      t[10] !== l ? (F = l.split("-"), t[10] = l, t[11] = F) : F = t[11];
      const [$, N] = F;
      if (N === "limited") {
        x = o === "number" ? $ : !1;
        break e;
      }
      x = $;
      break e;
    }
    x = l ? "strict" : !1;
  }
  const S = x;
  let T;
  t[12] !== w || t[13] !== S || t[14] !== s || t[15] !== c || t[16] !== n || t[17] !== a ? (T = (F, $) => {
    const N = xh(w, (A) => {
      A[$] = ZA(F, { parseNumbers: S }), $ === 0 && (s === "between" || s === "notBetween") && (A.length < 2 || A[1] === void 0) && (A[1] = lu(c));
    });
    n(a ? N : KA(N, ","));
  }, t[12] = w, t[13] = S, t[14] = s, t[15] = c, t[16] = n, t[17] = a, t[18] = T) : T = t[18];
  const E = T, O = m || Tt.valueListItem, M = p == null ? void 0 : p.valueListItem;
  let D;
  t[19] !== O || t[20] !== M ? (D = tbe(O, M), t[19] = O, t[20] = M, t[21] = D) : D = t[21];
  const R = D;
  let P;
  return t[22] !== w || t[23] !== E || t[24] !== S || t[25] !== R ? (P = { valueAsArray: w, multiValueHandler: E, parseNumberMethod: S, valueListItemClassName: R }, t[22] = w, t[23] = E, t[24] = S, t[25] = R, t[26] = P) : P = t[26], P;
}, Ebe = (e) => {
  const t = xs(3), { multiple: n, onChange: o } = e;
  let s, i;
  return t[0] !== n || t[1] !== o ? (i = n ? (l) => o(Array.from(l.target.selectedOptions).map((c) => c.value)) : (l) => o(l.target.value), t[0] = n, t[1] = o, t[2] = i) : i = t[2], s = i, s;
}, Ia = (e) => {
  const t = xs(12), { onChange: n, val: o } = sF(e);
  let s;
  t[0] !== e.multiple || t[1] !== n ? (s = { multiple: e.multiple, onChange: n }, t[0] = e.multiple, t[1] = n, t[2] = s) : s = t[2];
  const i = Ebe(s), a = !!e.multiple;
  let l;
  return t[3] !== e.options || t[4] !== e.testID || t[5] !== e.className || t[6] !== e.title || t[7] !== e.disabled || t[8] !== o || t[9] !== a || t[10] !== i ? (l = C("select", { "data-testid": e.testID, className: e.className, value: o, title: e.title, disabled: e.disabled, multiple: a, onChange: i, children: ybe(e.options) }), t[3] = e.options, t[4] = e.testID, t[5] = e.className, t[6] = e.title, t[7] = e.disabled, t[8] = o, t[9] = a, t[10] = i, t[11] = l) : l = t[11], l;
}, sF = (e) => {
  const t = xs(10), { handleOnChange: n, listsAsArrays: o, multiple: s, value: i } = e, a = o === void 0 ? !1 : o, l = s === void 0 ? !1 : s;
  let c;
  t[0] !== l || t[1] !== n || t[2] !== a ? (c = (b) => {
    if (l) {
      const v = ip(b);
      n(a ? v : KA(v, ","));
    } else
      n(b);
  }, t[0] = l, t[1] = n, t[2] = a, t[3] = c) : c = t[3];
  const u = c;
  let d, f;
  t[4] !== l || t[5] !== i ? (f = l ? ip(i) : i, t[4] = l, t[5] = i, t[6] = f) : f = t[6], d = f;
  const p = d;
  let m;
  return t[7] !== u || t[8] !== p ? (m = { onChange: u, val: p }, t[7] = u, t[8] = p, t[9] = m) : m = t[9], m;
}, qd = { actionElement: _r, addGroupAction: _r, addRuleAction: _r, cloneGroupAction: _r, cloneRuleAction: _r, combinatorSelector: Ia, dragHandle: HA, fieldSelector: Ia, inlineCombinator: nbe, lockGroupAction: _r, lockRuleAction: _r, notToggle: qA, operatorSelector: Ia, removeGroupAction: _r, removeRuleAction: _r, rule: vbe, ruleGroup: Sbe, ruleGroupBodyElements: Tbe, ruleGroupHeaderElements: xbe, shiftActions: nF, valueEditor: oF, valueSelector: Ia, valueSourceSelector: Ia }, gf = () => null, Ibe = /* @__PURE__ */ rs(gf), wa = {}, SO = (e) => {
  var x, S, T, E, O, M, D, R, P, F, $, N, A, k, L, B, V, _, z, j, W, J, G, q, Z, Y, Q, ee, ne, H, U, X, re, oe, le, se, Ce, $e, we, Te, ue, de, Pe, ke, Me, be, me, Ae, ye, We, He, ze, pe, Re, Ge, Qe, qe, st, wt, Ue, nt, ft, nn, St, Ke, Ot, vn, on, Ze, ct, Ut, xn, Fn, Rn, Tn, an, hn, tr;
  let { finalize: t, ...n } = e;
  const o = Co(uv), s = Hb(!1, n.debugMode, o.debugMode), i = t ? s : n.debugMode ?? o.debugMode, a = Hb(!0, n.enableMountQueryChange, o.enableMountQueryChange), l = t ? a : n.enableMountQueryChange ?? o.enableMountQueryChange, c = Hb(!1, n.enableDragAndDrop, o.enableDragAndDrop) && o.enableDragAndDrop !== !1, u = t ? c : n.enableDragAndDrop ?? o.enableDragAndDrop, d = Ye(() => mbe(t ? Object.assign({}, ebe) : wa, o.controlClassnames, n.controlClassnames), [o.controlClassnames, n.controlClassnames, t]), f = Ye(() => ({ actionElement: d.actionElement, addGroup: d.addGroup, addRule: d.addRule, body: d.body, cloneGroup: d.cloneGroup, cloneRule: d.cloneRule, combinators: d.combinators, dragHandle: d.dragHandle, fields: d.fields, header: d.header, lockGroup: d.lockGroup, lockRule: d.lockRule, notToggle: d.notToggle, operators: d.operators, queryBuilder: d.queryBuilder, removeGroup: d.removeGroup, removeRule: d.removeRule, rule: d.rule, ruleGroup: d.ruleGroup, shiftActions: d.shiftActions, value: d.value, valueSelector: d.valueSelector, valueSource: d.valueSource, betweenRules: d.betweenRules, valid: d.valid, invalid: d.invalid, dndDragging: d.dndDragging, dndOver: d.dndOver, dndCopy: d.dndCopy, disabled: d.disabled, valueListItem: d.valueListItem, branches: d.branches }), [d.actionElement, d.addGroup, d.addRule, d.betweenRules, d.body, d.branches, d.cloneGroup, d.cloneRule, d.combinators, d.disabled, d.dndCopy, d.dndDragging, d.dndOver, d.dragHandle, d.fields, d.header, d.invalid, d.lockGroup, d.lockRule, d.notToggle, d.operators, d.queryBuilder, d.removeGroup, d.removeRule, d.rule, d.ruleGroup, d.shiftActions, d.valid, d.value, d.valueListItem, d.valueSelector, d.valueSource]), p = o.controlElements ?? wa, m = n.controlElements ?? wa, b = pt((Ie, Se, je) => {
    const it = Ie === "dragHandle" ? Ibe : gf, at = (Ie.endsWith("Action") && m.actionElement ? m.actionElement : void 0) ?? (Ie.endsWith("Selector") && m.valueSelector ? m.valueSelector : void 0), kt = (Ie.endsWith("Action") && p.actionElement ? p.actionElement : void 0) ?? (Ie.endsWith("Selector") && p.valueSelector ? p.valueSelector : void 0), It = Se === null ? it : Se ?? (t ? at : void 0) ?? (je === null ? it : je ?? (t ? kt : void 0));
    return It ? { [Ie]: It } : t ? { [Ie]: qd[Ie] } : wa;
  }, [p.actionElement, p.valueSelector, t, m.actionElement, m.valueSelector]), v = Ye(
    () => (
      // For some reason TypeScript doesn't like the object spread syntax here.
      // Something about a union type being too complex to represent.
      Object.assign(
        {},
        b("addGroupAction", m.addGroupAction, p.addGroupAction),
        b("addRuleAction", m.addRuleAction, p.addRuleAction),
        b("cloneGroupAction", m.cloneGroupAction, p.cloneGroupAction),
        b("cloneRuleAction", m.cloneRuleAction, p.cloneRuleAction),
        b("combinatorSelector", m.combinatorSelector, p.combinatorSelector),
        b("dragHandle", m.dragHandle, p.dragHandle),
        b("fieldSelector", m.fieldSelector, p.fieldSelector),
        b("inlineCombinator", m.inlineCombinator, p.inlineCombinator),
        b("lockGroupAction", m.lockGroupAction, p.lockGroupAction),
        b("lockRuleAction", m.lockRuleAction, p.lockRuleAction),
        b("notToggle", m.notToggle, p.notToggle),
        b("operatorSelector", m.operatorSelector, p.operatorSelector),
        b("removeGroupAction", m.removeGroupAction, p.removeGroupAction),
        b("removeRuleAction", m.removeRuleAction, p.removeRuleAction),
        b("shiftActions", m.shiftActions, p.shiftActions),
        { valueEditor: m.valueEditor === null ? gf : m.valueEditor ?? (p.valueEditor === null ? gf : p.valueEditor) ?? qd.valueEditor },
        b("valueSourceSelector", m.valueSourceSelector, p.valueSourceSelector),
        b("rule", m.rule, p.rule),
        b("ruleGroup", m.ruleGroup, p.ruleGroup),
        b("ruleGroupBodyElements", m.ruleGroupBodyElements, p.ruleGroupBodyElements),
        b("ruleGroupHeaderElements", m.ruleGroupHeaderElements, p.ruleGroupHeaderElements),
        { actionElement: m.actionElement ?? p.actionElement ?? (t ? qd.actionElement : void 0) },
        { valueSelector: m.valueSelector ?? p.valueSelector ?? (t ? qd.valueSelector : void 0) }
        // TODO: this type should probably depend on `finalize`
      )
    ),
    [p.actionElement, p.addGroupAction, p.addRuleAction, p.cloneGroupAction, p.cloneRuleAction, p.combinatorSelector, p.dragHandle, p.fieldSelector, p.inlineCombinator, p.lockGroupAction, p.lockRuleAction, p.notToggle, p.operatorSelector, p.removeGroupAction, p.removeRuleAction, p.rule, p.ruleGroup, p.ruleGroupBodyElements, p.ruleGroupHeaderElements, p.shiftActions, p.valueEditor, p.valueSelector, p.valueSourceSelector, b, t, m.actionElement, m.addGroupAction, m.addRuleAction, m.cloneGroupAction, m.cloneRuleAction, m.combinatorSelector, m.dragHandle, m.fieldSelector, m.inlineCombinator, m.lockGroupAction, m.lockRuleAction, m.notToggle, m.operatorSelector, m.removeGroupAction, m.removeRuleAction, m.rule, m.ruleGroup, m.ruleGroupBodyElements, m.ruleGroupHeaderElements, m.shiftActions, m.valueEditor, m.valueSelector, m.valueSourceSelector]
    // TODO: this type should probably depend on `finalize`
  ), g = n.translations ?? wa, y = o.translations ?? wa, w = Ye(
    () => {
      var Ie, Se, je, it, at, kt, It, Qn, ls, Rh, Xu, $l, si, ii, aa, ai, Rt, _o, wr, Ds, Qu, uw, dw, fw, pw, hw, gw, mw, bw, yw, vw, Cw, ww, Sw, xw, Tw, Rw, Ew, Iw, Ow, Pw, Mw, kw, Dw, Nw, $w, Aw, Fw, Lw, _w, Vw, Bw, zw, Hw, jw, Gw, qw, Ww, Uw, Kw, Yw, Xw, Qw, Zw, Jw, eS, tS, nS, oS, rS, sS, iS, aS, lS, cS, uS, dS, fS;
      return Object.assign(t ? Object.assign({}, ri) : {}, zn("addGroup", { label: [(Ie = g.addGroup) == null ? void 0 : Ie.label, (Se = y.addGroup) == null ? void 0 : Se.label], title: [(je = g.addGroup) == null ? void 0 : je.title, (it = y.addGroup) == null ? void 0 : it.title] }, t), zn("addRule", { label: [(at = g.addRule) == null ? void 0 : at.label, (kt = y.addRule) == null ? void 0 : kt.label], title: [(It = g.addRule) == null ? void 0 : It.title, (Qn = y.addRule) == null ? void 0 : Qn.title] }, t), zn("cloneRule", { label: [(ls = g.cloneRule) == null ? void 0 : ls.label, (Rh = y.cloneRule) == null ? void 0 : Rh.label], title: [(Xu = g.cloneRule) == null ? void 0 : Xu.title, ($l = y.cloneRule) == null ? void 0 : $l.title] }, t), zn("cloneRuleGroup", { label: [(si = g.cloneRuleGroup) == null ? void 0 : si.label, (ii = y.cloneRuleGroup) == null ? void 0 : ii.label], title: [(aa = g.cloneRuleGroup) == null ? void 0 : aa.title, (ai = y.cloneRuleGroup) == null ? void 0 : ai.title] }, t), zn("combinators", { title: [(Rt = g.combinators) == null ? void 0 : Rt.title, (_o = y.combinators) == null ? void 0 : _o.title] }, t), zn("dragHandle", { label: [(wr = g.dragHandle) == null ? void 0 : wr.label, (Ds = y.dragHandle) == null ? void 0 : Ds.label], title: [(Qu = g.dragHandle) == null ? void 0 : Qu.title, (uw = y.dragHandle) == null ? void 0 : uw.title] }, t), zn("fields", { placeholderGroupLabel: [(dw = g.fields) == null ? void 0 : dw.placeholderGroupLabel, (fw = y.fields) == null ? void 0 : fw.placeholderGroupLabel], placeholderLabel: [(pw = g.fields) == null ? void 0 : pw.placeholderLabel, (hw = y.fields) == null ? void 0 : hw.placeholderLabel], placeholderName: [(gw = g.fields) == null ? void 0 : gw.placeholderName, (mw = y.fields) == null ? void 0 : mw.placeholderName], title: [(bw = g.fields) == null ? void 0 : bw.title, (yw = y.fields) == null ? void 0 : yw.title] }, t), zn("lockGroup", { label: [(vw = g.lockGroup) == null ? void 0 : vw.label, (Cw = y.lockGroup) == null ? void 0 : Cw.label], title: [(ww = g.lockGroup) == null ? void 0 : ww.title, (Sw = y.lockGroup) == null ? void 0 : Sw.title] }, t), zn("lockGroupDisabled", { label: [(xw = g.lockGroupDisabled) == null ? void 0 : xw.label, (Tw = y.lockGroupDisabled) == null ? void 0 : Tw.label], title: [(Rw = g.lockGroupDisabled) == null ? void 0 : Rw.title, (Ew = y.lockGroupDisabled) == null ? void 0 : Ew.title] }, t), zn("lockRule", { label: [(Iw = g.lockRule) == null ? void 0 : Iw.label, (Ow = y.lockRule) == null ? void 0 : Ow.label], title: [(Pw = g.lockRule) == null ? void 0 : Pw.title, (Mw = y.lockRule) == null ? void 0 : Mw.title] }, t), zn("lockRuleDisabled", { label: [(kw = g.lockRuleDisabled) == null ? void 0 : kw.label, (Dw = y.lockRuleDisabled) == null ? void 0 : Dw.label], title: [(Nw = g.lockRuleDisabled) == null ? void 0 : Nw.title, ($w = y.lockRuleDisabled) == null ? void 0 : $w.title] }, t), zn("notToggle", { label: [(Aw = g.notToggle) == null ? void 0 : Aw.label, (Fw = y.notToggle) == null ? void 0 : Fw.label], title: [(Lw = g.notToggle) == null ? void 0 : Lw.title, (_w = y.notToggle) == null ? void 0 : _w.title] }, t), zn("operators", { placeholderGroupLabel: [(Vw = g.operators) == null ? void 0 : Vw.placeholderGroupLabel, (Bw = y.operators) == null ? void 0 : Bw.placeholderGroupLabel], placeholderLabel: [(zw = g.operators) == null ? void 0 : zw.placeholderLabel, (Hw = y.operators) == null ? void 0 : Hw.placeholderLabel], placeholderName: [(jw = g.operators) == null ? void 0 : jw.placeholderName, (Gw = y.operators) == null ? void 0 : Gw.placeholderName], title: [(qw = g.operators) == null ? void 0 : qw.title, (Ww = y.operators) == null ? void 0 : Ww.title] }, t), zn("removeGroup", { label: [(Uw = g.removeGroup) == null ? void 0 : Uw.label, (Kw = y.removeGroup) == null ? void 0 : Kw.label], title: [(Yw = g.removeGroup) == null ? void 0 : Yw.title, (Xw = y.removeGroup) == null ? void 0 : Xw.title] }, t), zn("removeRule", { label: [(Qw = g.removeRule) == null ? void 0 : Qw.label, (Zw = y.removeRule) == null ? void 0 : Zw.label], title: [(Jw = g.removeRule) == null ? void 0 : Jw.title, (eS = y.removeRule) == null ? void 0 : eS.title] }, t), zn("shiftActionDown", { label: [(tS = g.shiftActionDown) == null ? void 0 : tS.label, (nS = y.shiftActionDown) == null ? void 0 : nS.label], title: [(oS = g.shiftActionDown) == null ? void 0 : oS.title, (rS = y.shiftActionDown) == null ? void 0 : rS.title] }, t), zn("shiftActionUp", { label: [(sS = g.shiftActionUp) == null ? void 0 : sS.label, (iS = y.shiftActionUp) == null ? void 0 : iS.label], title: [(aS = g.shiftActionUp) == null ? void 0 : aS.title, (lS = y.shiftActionUp) == null ? void 0 : lS.title] }, t), zn("value", { title: [(cS = g.value) == null ? void 0 : cS.title, (uS = y.value) == null ? void 0 : uS.title] }, t), zn("valueSourceSelector", { title: [(dS = g.valueSourceSelector) == null ? void 0 : dS.title, (fS = y.valueSourceSelector) == null ? void 0 : fS.title] }, t));
    },
    [(x = g.addGroup) == null ? void 0 : x.label, (S = g.addGroup) == null ? void 0 : S.title, (T = g.addRule) == null ? void 0 : T.label, (E = g.addRule) == null ? void 0 : E.title, (O = g.cloneRule) == null ? void 0 : O.label, (M = g.cloneRule) == null ? void 0 : M.title, (D = g.cloneRuleGroup) == null ? void 0 : D.label, (R = g.cloneRuleGroup) == null ? void 0 : R.title, (P = g.combinators) == null ? void 0 : P.title, (F = g.dragHandle) == null ? void 0 : F.label, ($ = g.dragHandle) == null ? void 0 : $.title, (N = g.fields) == null ? void 0 : N.placeholderGroupLabel, (A = g.fields) == null ? void 0 : A.placeholderLabel, (k = g.fields) == null ? void 0 : k.placeholderName, (L = g.fields) == null ? void 0 : L.title, (B = g.lockGroup) == null ? void 0 : B.label, (V = g.lockGroup) == null ? void 0 : V.title, (_ = g.lockGroupDisabled) == null ? void 0 : _.label, (z = g.lockGroupDisabled) == null ? void 0 : z.title, (j = g.lockRule) == null ? void 0 : j.label, (W = g.lockRule) == null ? void 0 : W.title, (J = g.lockRuleDisabled) == null ? void 0 : J.label, (G = g.lockRuleDisabled) == null ? void 0 : G.title, (q = g.notToggle) == null ? void 0 : q.label, (Z = g.notToggle) == null ? void 0 : Z.title, (Y = g.operators) == null ? void 0 : Y.placeholderGroupLabel, (Q = g.operators) == null ? void 0 : Q.placeholderLabel, (ee = g.operators) == null ? void 0 : ee.placeholderName, (ne = g.operators) == null ? void 0 : ne.title, (H = g.removeGroup) == null ? void 0 : H.label, (U = g.removeGroup) == null ? void 0 : U.title, (X = g.removeRule) == null ? void 0 : X.label, (re = g.removeRule) == null ? void 0 : re.title, (oe = g.shiftActionDown) == null ? void 0 : oe.label, (le = g.shiftActionDown) == null ? void 0 : le.title, (se = g.shiftActionUp) == null ? void 0 : se.label, (Ce = g.shiftActionUp) == null ? void 0 : Ce.title, ($e = g.value) == null ? void 0 : $e.title, (we = g.valueSourceSelector) == null ? void 0 : we.title, t, (Te = y.addGroup) == null ? void 0 : Te.label, (ue = y.addGroup) == null ? void 0 : ue.title, (de = y.addRule) == null ? void 0 : de.label, (Pe = y.addRule) == null ? void 0 : Pe.title, (ke = y.cloneRule) == null ? void 0 : ke.label, (Me = y.cloneRule) == null ? void 0 : Me.title, (be = y.cloneRuleGroup) == null ? void 0 : be.label, (me = y.cloneRuleGroup) == null ? void 0 : me.title, (Ae = y.combinators) == null ? void 0 : Ae.title, (ye = y.dragHandle) == null ? void 0 : ye.label, (We = y.dragHandle) == null ? void 0 : We.title, (He = y.fields) == null ? void 0 : He.placeholderGroupLabel, (ze = y.fields) == null ? void 0 : ze.placeholderLabel, (pe = y.fields) == null ? void 0 : pe.placeholderName, (Re = y.fields) == null ? void 0 : Re.title, (Ge = y.lockGroup) == null ? void 0 : Ge.label, (Qe = y.lockGroup) == null ? void 0 : Qe.title, (qe = y.lockGroupDisabled) == null ? void 0 : qe.label, (st = y.lockGroupDisabled) == null ? void 0 : st.title, (wt = y.lockRule) == null ? void 0 : wt.label, (Ue = y.lockRule) == null ? void 0 : Ue.title, (nt = y.lockRuleDisabled) == null ? void 0 : nt.label, (ft = y.lockRuleDisabled) == null ? void 0 : ft.title, (nn = y.notToggle) == null ? void 0 : nn.label, (St = y.notToggle) == null ? void 0 : St.title, (Ke = y.operators) == null ? void 0 : Ke.placeholderGroupLabel, (Ot = y.operators) == null ? void 0 : Ot.placeholderLabel, (vn = y.operators) == null ? void 0 : vn.placeholderName, (on = y.operators) == null ? void 0 : on.title, (Ze = y.removeGroup) == null ? void 0 : Ze.label, (ct = y.removeGroup) == null ? void 0 : ct.title, (Ut = y.removeRule) == null ? void 0 : Ut.label, (xn = y.removeRule) == null ? void 0 : xn.title, (Fn = y.shiftActionDown) == null ? void 0 : Fn.label, (Rn = y.shiftActionDown) == null ? void 0 : Rn.title, (Tn = y.shiftActionUp) == null ? void 0 : Tn.label, (an = y.shiftActionUp) == null ? void 0 : an.title, (hn = y.value) == null ? void 0 : hn.title, (tr = y.valueSourceSelector) == null ? void 0 : tr.title]
    // TODO: this type should probably depend on `finalize`
  );
  return { controlClassnames: f, controlElements: v, debugMode: i, enableDragAndDrop: u, enableMountQueryChange: l, translations: w, initialQuery: n.initialQuery, qbId: n.qbId };
};
Wge(aw);
Pme({ ...lbe, devTools: !1 });
var xo = Ki(null);
xo.displayName = "RQBMaterialContext";
var iF = ({
  className: e,
  handleOnClick: t,
  label: n,
  title: o,
  disabled: s,
  disabledTranslation: i,
  testID: a,
  path: l,
  level: c,
  rules: u,
  context: d,
  validation: f,
  ruleOrGroup: p,
  schema: m,
  muiComponents: b,
  ...v
}) => {
  const g = Co(xo) ?? b, y = g ? "mui" : "no-mui";
  if (!g) {
    const x = _r;
    return /* @__PURE__ */ h.createElement(
      x,
      {
        key: y,
        className: e,
        handleOnClick: t,
        label: n,
        title: o,
        disabled: s,
        disabledTranslation: i,
        testID: a,
        path: l,
        level: c,
        rules: u,
        context: d,
        validation: f,
        ruleOrGroup: p,
        schema: m
      }
    );
  }
  const { Button: w } = g;
  return /* @__PURE__ */ h.createElement(
    w,
    {
      key: y,
      variant: "contained",
      color: "secondary",
      className: e,
      title: i && s ? i.title : o,
      size: "small",
      disabled: s && !i,
      onClick: (x) => t(x),
      ...v
    },
    i && s ? i.label : n
  );
};
iF.displayName = "MaterialActionElement";
var aF = rs(
  ({
    className: e,
    title: t,
    path: n,
    level: o,
    testID: s,
    label: i,
    disabled: a,
    context: l,
    validation: c,
    schema: u,
    ruleOrGroup: d,
    muiComponents: f,
    ...p
  }, m) => {
    const b = Co(xo) ?? f, v = b ? "mui" : "no-mui";
    if (!b)
      return /* @__PURE__ */ h.createElement(
        HA,
        {
          key: v,
          path: n,
          level: o,
          className: e,
          title: t,
          testID: s,
          label: i,
          disabled: a,
          context: l,
          validation: c,
          schema: u,
          ruleOrGroup: d
        }
      );
    const { DragIndicator: g } = b;
    return /* @__PURE__ */ h.createElement("span", { key: v, ref: m, className: e, title: t }, /* @__PURE__ */ h.createElement(g, { ...p }));
  }
);
aF.displayName = "MaterialDragHandle";
var lF = ({
  className: e,
  handleOnChange: t,
  label: n,
  checked: o,
  title: s,
  disabled: i,
  level: a,
  path: l,
  context: c,
  validation: u,
  testID: d,
  schema: f,
  ruleGroup: p,
  muiComponents: m,
  ...b
}) => {
  const v = Co(xo) ?? m, g = v ? "mui" : "no-mui";
  if (!v)
    return /* @__PURE__ */ h.createElement(
      qA,
      {
        key: g,
        className: e,
        handleOnChange: t,
        label: n,
        checked: o,
        title: s,
        disabled: i,
        path: l,
        level: a,
        context: c,
        validation: u,
        testID: d,
        schema: f,
        ruleGroup: p
      }
    );
  const { FormControlLabel: y, Switch: w } = v;
  return /* @__PURE__ */ h.createElement(
    y,
    {
      key: g,
      className: e,
      title: s,
      disabled: i,
      control: /* @__PURE__ */ h.createElement(
        w,
        {
          checked: !!o,
          onChange: (x) => t(x.target.checked),
          ...b
        }
      ),
      label: n ?? /* istanbul ignore next */
      ""
    }
  );
};
lF.displayName = "MaterialNotToggle";
var cF = ({
  path: e,
  shiftUp: t,
  shiftDown: n,
  shiftUpDisabled: o,
  shiftDownDisabled: s,
  disabled: i,
  className: a,
  labels: l,
  titles: c,
  testID: u,
  muiComponents: d,
  ...f
}) => {
  const p = h.useContext(xo) ?? d, m = p ? "mui" : "no-mui";
  if (!p)
    return /* @__PURE__ */ h.createElement(
      nF,
      {
        key: m,
        path: e,
        disabled: i,
        className: a,
        labels: l,
        titles: c,
        testID: u,
        shiftUp: t,
        shiftDown: n,
        shiftUpDisabled: o,
        shiftDownDisabled: s,
        ...f
      }
    );
  const { Button: b } = p;
  return /* @__PURE__ */ h.createElement("div", { key: m, "data-testid": u, className: a }, /* @__PURE__ */ h.createElement(
    b,
    {
      sx: { boxShadow: "none" },
      variant: "contained",
      color: "secondary",
      className: a,
      title: c == null ? void 0 : c.shiftUp,
      size: "small",
      disabled: i || o,
      onClick: t
    },
    l == null ? void 0 : l.shiftUp
  ), /* @__PURE__ */ h.createElement(
    b,
    {
      sx: { boxShadow: "none" },
      variant: "contained",
      color: "secondary",
      className: a,
      title: c == null ? void 0 : c.shiftDown,
      size: "small",
      disabled: i || s,
      onClick: n
    },
    l == null ? void 0 : l.shiftDown
  ));
};
cF.displayName = "MaterialShiftActions";
var uF = (e) => {
  const { muiComponents: t, ...n } = e, {
    field: o,
    fieldData: s,
    operator: i,
    value: a,
    handleOnChange: l,
    title: c,
    className: u,
    type: d,
    path: f,
    level: p,
    inputType: m,
    values: b = [],
    listsAsArrays: v,
    parseNumbers: g,
    separator: y,
    valueSource: w,
    disabled: x,
    testID: S,
    selectorComponent: T = e.schema.controls.valueSelector,
    extraProps: E,
    ...O
  } = n, M = Co(xo) ?? t, { valueAsArray: D, multiValueHandler: R } = rF({
    handleOnChange: l,
    inputType: m,
    operator: i,
    value: a,
    type: d,
    listsAsArrays: v,
    parseNumbers: g,
    values: b
  }), P = M ? "mui" : "no-mui";
  if (!M)
    return /* @__PURE__ */ h.createElement(oF, { skipHook: !0, key: P, ...n });
  const {
    Checkbox: F,
    FormControl: $,
    FormControlLabel: N,
    Input: A,
    Radio: k,
    RadioGroup: L,
    Switch: B,
    TextareaAutosize: V
  } = M;
  if (i === "null" || i === "notNull")
    return null;
  const _ = (s == null ? void 0 : s.placeholder) ?? "", z = ["in", "notIn"].includes(i) ? "text" : m || "text";
  if ((i === "between" || i === "notBetween") && (d === "select" || d === "text")) {
    const j = ["from", "to"].map((W, J) => d === "text" ? /* @__PURE__ */ h.createElement(
      A,
      {
        key: W,
        type: z,
        className: Tt.valueListItem,
        value: D[J] ?? "",
        disabled: x,
        placeholder: _,
        onChange: (G) => R(G.target.value, J),
        ...E
      }
    ) : /* @__PURE__ */ h.createElement(
      T,
      {
        ...O,
        key: W,
        path: f,
        level: p,
        className: Tt.valueListItem,
        handleOnChange: (G) => R(G, J),
        muiComponents: M,
        disabled: x,
        value: D[J] ?? lu(b),
        options: b,
        listsAsArrays: v
      }
    ));
    return /* @__PURE__ */ h.createElement("span", { key: P, "data-testid": S, className: u, title: c }, j[0], y, j[1]);
  }
  switch (d) {
    case "select":
    case "multiselect":
      return /* @__PURE__ */ h.createElement(
        T,
        {
          ...O,
          muiComponents: M,
          key: P,
          path: f,
          level: p,
          className: u,
          handleOnChange: l,
          options: b,
          value: a,
          disabled: x,
          title: c,
          multiple: d === "multiselect",
          listsAsArrays: v
        }
      );
    case "textarea":
      return /* @__PURE__ */ h.createElement(
        V,
        {
          key: P,
          value: a,
          title: c,
          disabled: x,
          className: u,
          placeholder: _,
          onChange: (j) => l(j.target.value),
          ...E
        }
      );
    case "switch":
      return /* @__PURE__ */ h.createElement(
        B,
        {
          key: P,
          checked: !!a,
          title: c,
          disabled: x,
          className: u,
          onChange: (j) => l(j.target.checked),
          ...E
        }
      );
    case "checkbox":
      return /* @__PURE__ */ h.createElement(
        F,
        {
          key: P,
          className: u,
          title: c,
          onChange: (j) => l(j.target.checked),
          checked: !!a,
          disabled: x,
          ...E
        }
      );
    case "radio":
      return /* @__PURE__ */ h.createElement(
        $,
        {
          key: P,
          className: u,
          title: c,
          component: "fieldset",
          disabled: x,
          ...E
        },
        /* @__PURE__ */ h.createElement(L, { value: a, onChange: (j) => l(j.target.value) }, b.map((j) => /* @__PURE__ */ h.createElement(
          N,
          {
            disabled: x,
            key: j.name,
            value: j.name,
            control: /* @__PURE__ */ h.createElement(k, null),
            label: j.label
          }
        )))
      );
  }
  return /* @__PURE__ */ h.createElement(
    A,
    {
      key: P,
      type: z,
      value: a,
      title: c,
      disabled: x,
      className: u,
      placeholder: _,
      onChange: (j) => l(j.target.value),
      ...E
    }
  );
};
uF.displayName = "MaterialValueEditor";
var Obe = (e, { ListSubheader: t, MenuItem: n }) => {
  if (cw(e)) {
    const o = [];
    for (const s of e)
      o.push(
        /* @__PURE__ */ h.createElement(t, { key: s.label }, s.label),
        ...s.options.map((i) => /* @__PURE__ */ h.createElement(n, { key: i.name, value: i.name }, i.label))
      );
    return o;
  }
  return Array.isArray(e) ? e.map((o) => /* @__PURE__ */ h.createElement(n, { key: o.name, value: o.name }, o.label)) : null;
}, dF = ({
  className: e,
  handleOnChange: t,
  options: n,
  value: o,
  disabled: s,
  title: i,
  multiple: a,
  listsAsArrays: l,
  testID: c,
  rule: u,
  rules: d,
  level: f,
  path: p,
  context: m,
  validation: b,
  operator: v,
  field: g,
  fieldData: y,
  schema: w,
  muiComponents: x,
  defaultValue: S,
  ...T
}) => {
  const E = Co(xo) ?? x, { onChange: O, val: M } = sF({ handleOnChange: t, listsAsArrays: l, multiple: a, value: o }), D = ({ target: { value: A } }) => O(A), R = E ? "mui" : "no-mui";
  if (!E) {
    const A = Ia;
    return /* @__PURE__ */ h.createElement(
      A,
      {
        key: R,
        className: e,
        handleOnChange: t,
        options: n,
        value: o,
        disabled: s,
        title: i,
        multiple: a,
        listsAsArrays: l,
        testID: c,
        rule: u,
        rules: d,
        level: f,
        path: p,
        context: m,
        validation: b,
        operator: v,
        field: g,
        fieldData: y,
        schema: w
      }
    );
  }
  const { FormControl: P, Select: F, ListSubheader: $, MenuItem: N } = E;
  return /* @__PURE__ */ h.createElement(
    P,
    {
      key: R,
      variant: "standard",
      className: e,
      title: i,
      disabled: s
    },
    /* @__PURE__ */ h.createElement(F, { value: M, onChange: D, multiple: a, ...T }, Obe(n ?? /* istanbul ignore next */
    [], {
      ListSubheader: $,
      MenuItem: N
    }))
  );
};
dF.displayName = "MaterialValueSelector";
var xO = () => {
  const e = h.useContext(xo);
  if (!e)
    return ri.removeRule.label;
  const { CloseIcon: t } = e;
  return /* @__PURE__ */ h.createElement(t, null);
}, TO = () => {
  const e = h.useContext(xo);
  if (!e)
    return ri.cloneRule.label;
  const { ContentCopyIcon: t } = e;
  return /* @__PURE__ */ h.createElement(t, null);
}, RO = () => {
  const e = h.useContext(xo);
  if (!e)
    return ri.lockRuleDisabled.label;
  const { LockIcon: t } = e;
  return /* @__PURE__ */ h.createElement(t, null);
}, EO = () => {
  const e = h.useContext(xo);
  if (!e)
    return ri.lockRule.label;
  const { LockOpenIcon: t } = e;
  return /* @__PURE__ */ h.createElement(t, null);
}, Pbe = () => {
  const e = h.useContext(xo);
  if (!e)
    return ri.shiftActionDown.label;
  const { KeyboardArrowDownIcon: t } = e;
  return /* @__PURE__ */ h.createElement(t, null);
}, Mbe = () => {
  const e = h.useContext(xo);
  if (!e)
    return ri.shiftActionUp.label;
  const { KeyboardArrowUpIcon: t } = e;
  return /* @__PURE__ */ h.createElement(t, null);
}, kbe = {
  removeGroup: { label: /* @__PURE__ */ h.createElement(xO, null) },
  removeRule: { label: /* @__PURE__ */ h.createElement(xO, null) },
  cloneRule: { label: /* @__PURE__ */ h.createElement(TO, null) },
  cloneRuleGroup: { label: /* @__PURE__ */ h.createElement(TO, null) },
  lockGroup: { label: /* @__PURE__ */ h.createElement(EO, null) },
  lockRule: { label: /* @__PURE__ */ h.createElement(EO, null) },
  lockGroupDisabled: { label: /* @__PURE__ */ h.createElement(RO, null) },
  lockRuleDisabled: { label: /* @__PURE__ */ h.createElement(RO, null) },
  shiftActionDown: { label: /* @__PURE__ */ h.createElement(Pbe, null) },
  shiftActionUp: { label: /* @__PURE__ */ h.createElement(Mbe, null) }
}, Wd = {
  DragIndicator: Ace,
  Button: Io,
  Checkbox: ml,
  CloseIcon: Nce,
  ContentCopyIcon: $ce,
  FormControl: bl,
  FormControlLabel: qc,
  Input: _i,
  KeyboardArrowDownIcon: Fce,
  KeyboardArrowUpIcon: Lce,
  ListSubheader: el,
  LockIcon: _ce,
  LockOpenIcon: Vce,
  MenuItem: Nn,
  Radio: hC,
  RadioGroup: gC,
  Select: Ji,
  Switch: vC,
  TextareaAutosize: Kv
}, Dbe = (e) => {
  const t = Co(xo);
  return Ye(
    () => e && t ? {
      ...Wd,
      ...t,
      ...e
    } : e ? { ...Wd, ...e } : t ? { ...Wd, ...t } : Wd,
    [t, e]
  );
}, Nbe = {
  actionElement: iF,
  dragHandle: aF,
  notToggle: lF,
  shiftActions: cF,
  valueEditor: uF,
  valueSelector: dF
}, $be = gbe({
  key: "material",
  controlElements: Nbe,
  translations: kbe
}), O0e = ({ muiComponents: e, ...t }) => {
  const n = Dbe(e), o = Ye(
    () => ({ ...n, ...e }),
    [n, e]
  );
  return /* @__PURE__ */ h.createElement(xo.Provider, { value: o }, /* @__PURE__ */ h.createElement($be, { ...t }));
};
export {
  gve as Accordion,
  uh as AdapterDayjs,
  Kye as AddIcon,
  tye as AddressIcon,
  lye as AlcoholIcon,
  mve as Alert,
  yve as AppBar,
  Qbe as AppIcon,
  wye as AppsViewIcon,
  jve as ArrowBack,
  fye as AssignIcon,
  Oye as AssistantFactIcon,
  Pye as AssistantQuestionIcon,
  Mye as AssistantReplyIcon,
  Sye as AttachIcon,
  iye as AttireIcon,
  vve as Autocomplete,
  Cve as Avatar,
  wve as AvatarGroup,
  uve as BackArrowIcon,
  Sve as Backdrop,
  xve as Badge,
  Tve as Banner,
  WCe as BasicTable,
  Gt as Box,
  o0e as Breadcrumbs,
  dye as BroadcastIcon,
  Ybe as BundleIcon,
  Gve as BusinessCenter,
  Of as Button,
  Rve as ButtonBase,
  Eve as ButtonGroup,
  ICe as ButtonRow,
  r0e as ByNumaAI,
  OCe as CallToAction,
  Ave as Card,
  s0e as CardActionArea,
  Iye as ChannelsIcon,
  qve as Chat,
  cye as ChatIcon,
  Wve as CheckBox,
  Zye as CheckBoxOffIcon,
  Qye as CheckBoxOnIcon,
  Uve as CheckBoxOutlineBlank,
  Kve as CheckCircle,
  Yve as CheckCircleOutline,
  Jye as CheckIcon,
  CCe as Checkbox,
  fW as Chip,
  my as CircularProgress,
  tl as ClickAwayListener,
  V8 as ClipboardButton,
  P8 as Collapse,
  Nye as CollapseIcon,
  Vbe as Colors,
  BM as Columns,
  JCe as ComplexTable,
  ave as ContactIcon,
  Cye as ContactsViewIcon,
  $ce as ContentCopy,
  $pe as CoreThemeProvider,
  _ve as DataGrid,
  Bve as DatePicker,
  zve as DateRangePicker,
  vge as DelayedLoadingIndicator,
  jye as DelegateIcon,
  eve as DeleteIcon,
  Xve as DeleteOutline,
  Y7 as Dialog,
  Pve as DialogButton,
  i0e as Divider,
  Lye as DoneIcon,
  Gbe as DownloadIcon,
  a0e as Drawer,
  fCe as Dropdown,
  tve as EditIcon,
  cve as EmailIcon,
  Qve as EmojiEmotions,
  Zve as Error,
  nve as ErrorIcon,
  ove as EventIcon,
  I8 as ExpandIcon,
  Jve as ExpandMore,
  dve as FaceIcon,
  M8 as Fade,
  eCe as Favorite,
  E8 as FileIcon,
  vCe as Floater,
  wCe as FormControl,
  SCe as FormControlLabel,
  xCe as FormGroup,
  TCe as FormHelperText,
  PCe as Fullscreen,
  RCe as Gauge,
  _ye as GoingIcon,
  l0e as Grid,
  zJ as GridRow,
  k8 as Grow,
  Vye as HappyFaceIcon,
  uW as HeaderText,
  tCe as Home,
  nye as HoursIcon,
  Ve as Icon,
  zp as IconButton,
  xye as ImageIcon,
  c0e as InputAdornment,
  u0e as InputLabel,
  ECe as InteractiveTable,
  Ape as InvertThemeProvider,
  aye as KidsIcon,
  nCe as Language,
  UI as Layout,
  $ye as LibraryIcon,
  D8 as LinearProgress,
  MCe as Link,
  rve as LinkIcon,
  rC as List,
  kCe as ListItem,
  e6 as ListItemAvatar,
  sC as ListItemButton,
  ur as ListItemIcon,
  iC as ListItemSecondaryAction,
  Ho as ListItemText,
  DCe as ListSubheader,
  oCe as LocalFireDepartment,
  d0e as Logo,
  Eye as LoyaltyIcon,
  NCe as MappedChip,
  hye as MarkSpamIcon,
  Np as MaterialAutocomplete,
  Io as MaterialButton,
  bl as MaterialFormControl,
  yo as MaterialIcon,
  Nn as MaterialMenuItem,
  ol as MaterialOutlinedInput,
  Ji as MaterialSelect,
  Is as MaterialTextField,
  $Ce as Menu,
  $C as MenuButton,
  ACe as MenuItem,
  FCe as MenuList,
  mye as MessagesViewIcon,
  Bye as MissedCallIcon,
  jbe as MissingIcon,
  f0e as Modal,
  Mve as MoreButton,
  Hve as MultiPagesDialog,
  kve as MultipleActionsButton,
  p0e as NativeSelect,
  gye as NewMessageIcon,
  Ube as NewStuffIcon,
  Oge as NonBreakingSpace,
  Zbe as NoteAlertIcon,
  Wye as NotificationsIcon,
  qye as OffersIcon,
  rCe as OpenInNew,
  h0e as OutlinedInput,
  LCe as Panel,
  _Ce as PanelSection,
  VCe as Paper,
  oye as ParkingIcon,
  fve as PhoneCallbackIcon,
  pve as PhoneIcon,
  sCe as PhoneIphone,
  Gye as PlatformIcon,
  Q7 as Popover,
  g0e as Popper,
  Kbe as PopularIcon,
  rye as PricingIcon,
  BCe as Property,
  zCe as PropertyList,
  I0e as PublicThemeProvider,
  Xbe as PurchasesIcon,
  O0e as QueryBuilderMaterial,
  iCe as QuestionAnswer,
  m0e as Radio,
  b0e as RadioGroup,
  Yye as RadioOffIcon,
  Xye as RadioOnIcon,
  HCe as Rating,
  aCe as Refresh,
  hve as RefreshIcon,
  pye as RemindIcon,
  lCe as RemoveCircle,
  Uye as RemoveIcon,
  Hye as ReportsIcon,
  yye as ReportsViewIcon,
  sye as ReservationsIcon,
  cCe as RestartAlt,
  Rye as ReviewIcon,
  lve as ReviewStarsIcon,
  K7 as Rows,
  Cge as SearchField,
  O8 as SearchIcon,
  y0e as SectionNav,
  jCe as SegmentedButton,
  v0e as Select,
  qbe as SendMessageIcon,
  C0e as SettingsBar,
  vye as SettingsViewIcon,
  bve as Skeleton,
  N8 as Slide,
  GCe as Slider,
  w0e as Snackbar,
  S0e as Stack,
  bye as StarIcon,
  uCe as Summarize,
  eye as SupportAggentIcon,
  Tye as SurveyIcon,
  qCe as Switch,
  x0e as Tab,
  e0e as Table,
  YCe as TableBody,
  ZCe as TableCell,
  UCe as TableContainer,
  XCe as TableFooter,
  KCe as TableHead,
  QCe as TableRow,
  T0e as Tabs,
  Wbe as TemplatesIcon,
  R0e as TextField,
  E0e as TextFieldWrapper,
  t0e as TextHighlight,
  sve as ThumbDownIcon,
  ive as ThumbUpIcon,
  zye as TimeIcon,
  n0e as Toggle,
  Z7 as ToggleButton,
  Dve as ToggleButtons,
  Ege as ToggleGroup,
  Aye as ToggleLeftIcon,
  Ige as ToggleMenuButton,
  Fye as ToggleRightIcon,
  wA as ToggleSize,
  Nve as Toolbar,
  sW as ToolbarThemeProvider,
  VM as Tooltip,
  zbe as TrainedIcon,
  Cs as Typography,
  Hbe as UntrainedIcon,
  $ve as UploadButton,
  R8 as UploadIcon,
  uye as UserIcon,
  kye as VoicemailIcon,
  dCe as Warning,
  Jbe as WarningAlertIcon,
  Dye as WelcomeMessageIcon,
  he as alpha,
  Dpe as createCoreTheme,
  Npe as createMergedTheme,
  rW as createToolbarTheme,
  $o as darken,
  Yi as debounce,
  WI as findChildIndexByProp,
  Qoe as flattenRgbaOverHex,
  ak as getBackgroundColor,
  z8 as getBorderStyles,
  dW as getChipBackgroundColor,
  AC as getColorTheme,
  ik as getContrastColor,
  yf as getLuminance,
  Df as getMainColor,
  U7 as getTransitionComponent,
  yCe as getWindowDimensions,
  K as gridClasses,
  uP as hslToRgb,
  wpe as isAndroid,
  Joe as isColorProp,
  pCe as isEdge,
  gCe as isFirefox,
  ype as isInternetExplorer,
  mCe as isIosSafari,
  hCe as isSafari,
  bCe as isSupportedMobileOS,
  Lve as isThemeColor,
  vpe as isUnsupportedBrowser,
  Cpe as isiOS,
  wo as lighten,
  jp as makeStyles,
  Bbe as rgbToHex,
  te as styled,
  B8 as textToClipboard,
  Y$ as themeOptions,
  Lg as updatePaginationParams,
  Yoe as useClickOutside,
  tre as useCursorManagement,
  Koe as useGridApiRef,
  q7 as useIsScreenSmallerThan,
  NC as useIsSmallScreen,
  Qi as useMediaQuery,
  Vve as usePaginationWithCursor,
  sn as useTheme,
  Ive as withStyles,
  Ove as withTheme
};
//# sourceMappingURL=index.js.map
